function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8632"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8632"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_createPortal", () => $0b2e6adb871a3b94$export$2577ef5d2565d52f, (v) => $0b2e6adb871a3b94$export$2577ef5d2565d52f = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$2577ef5d2565d52f;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error($0b2e6adb871a3b94$var$y(227));
var $0b2e6adb871a3b94$var$ba = new Set, $0b2e6adb871a3b94$var$ca = {};
function $0b2e6adb871a3b94$var$da(a, b) {
    $0b2e6adb871a3b94$var$ea(a, b);
    $0b2e6adb871a3b94$var$ea(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ea(a, b) {
    $0b2e6adb871a3b94$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$ba.add(b[a]);
}
var $0b2e6adb871a3b94$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$ia = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ja = {}, $0b2e6adb871a3b94$var$ka = {};
function $0b2e6adb871a3b94$var$la(a) {
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ka, a)) return !0;
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ja, a)) return !1;
    if ($0b2e6adb871a3b94$var$ha.test(a)) return $0b2e6adb871a3b94$var$ka[a] = !0;
    $0b2e6adb871a3b94$var$ja[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$oa = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$D.xlinkHref = new $0b2e6adb871a3b94$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$D.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($0b2e6adb871a3b94$var$na(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $0b2e6adb871a3b94$var$ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$sa = 60103, $0b2e6adb871a3b94$var$ta = 60106, $0b2e6adb871a3b94$var$ua = 60107, $0b2e6adb871a3b94$var$wa = 60108, $0b2e6adb871a3b94$var$xa = 60114, $0b2e6adb871a3b94$var$ya = 60109, $0b2e6adb871a3b94$var$za = 60110, $0b2e6adb871a3b94$var$Aa = 60112, $0b2e6adb871a3b94$var$Ba = 60113, $0b2e6adb871a3b94$var$Ca = 60120, $0b2e6adb871a3b94$var$Da = 60115, $0b2e6adb871a3b94$var$Ea = 60116, $0b2e6adb871a3b94$var$Fa = 60121, $0b2e6adb871a3b94$var$Ga = 60128, $0b2e6adb871a3b94$var$Ha = 60129, $0b2e6adb871a3b94$var$Ia = 60130, $0b2e6adb871a3b94$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $0b2e6adb871a3b94$var$E = Symbol.for;
    $0b2e6adb871a3b94$var$sa = $0b2e6adb871a3b94$var$E("react.element");
    $0b2e6adb871a3b94$var$ta = $0b2e6adb871a3b94$var$E("react.portal");
    $0b2e6adb871a3b94$var$ua = $0b2e6adb871a3b94$var$E("react.fragment");
    $0b2e6adb871a3b94$var$wa = $0b2e6adb871a3b94$var$E("react.strict_mode");
    $0b2e6adb871a3b94$var$xa = $0b2e6adb871a3b94$var$E("react.profiler");
    $0b2e6adb871a3b94$var$ya = $0b2e6adb871a3b94$var$E("react.provider");
    $0b2e6adb871a3b94$var$za = $0b2e6adb871a3b94$var$E("react.context");
    $0b2e6adb871a3b94$var$Aa = $0b2e6adb871a3b94$var$E("react.forward_ref");
    $0b2e6adb871a3b94$var$Ba = $0b2e6adb871a3b94$var$E("react.suspense");
    $0b2e6adb871a3b94$var$Ca = $0b2e6adb871a3b94$var$E("react.suspense_list");
    $0b2e6adb871a3b94$var$Da = $0b2e6adb871a3b94$var$E("react.memo");
    $0b2e6adb871a3b94$var$Ea = $0b2e6adb871a3b94$var$E("react.lazy");
    $0b2e6adb871a3b94$var$Fa = $0b2e6adb871a3b94$var$E("react.block");
    $0b2e6adb871a3b94$var$E("react.scope");
    $0b2e6adb871a3b94$var$Ga = $0b2e6adb871a3b94$var$E("react.opaque.id");
    $0b2e6adb871a3b94$var$Ha = $0b2e6adb871a3b94$var$E("react.debug_trace_mode");
    $0b2e6adb871a3b94$var$Ia = $0b2e6adb871a3b94$var$E("react.offscreen");
    $0b2e6adb871a3b94$var$Ja = $0b2e6adb871a3b94$var$E("react.legacy_hidden");
}
var $0b2e6adb871a3b94$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $0b2e6adb871a3b94$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ka && a[$0b2e6adb871a3b94$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$Ma;
function $0b2e6adb871a3b94$var$Na(a) {
    if (void 0 === $0b2e6adb871a3b94$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$Ma = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$Ma + a;
}
var $0b2e6adb871a3b94$var$Oa = !1;
function $0b2e6adb871a3b94$var$Pa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Oa) return "";
    $0b2e6adb871a3b94$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Na(a) : "";
}
function $0b2e6adb871a3b94$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Na(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Na("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Na("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $0b2e6adb871a3b94$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return "Fragment";
        case $0b2e6adb871a3b94$var$ta:
            return "Portal";
        case $0b2e6adb871a3b94$var$xa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$wa:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ba:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $0b2e6adb871a3b94$var$Da:
            return $0b2e6adb871a3b94$var$Ra(a.type);
        case $0b2e6adb871a3b94$var$Fa:
            return $0b2e6adb871a3b94$var$Ra(a._render);
        case $0b2e6adb871a3b94$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$$a(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$qa(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    $0b2e6adb871a3b94$var$$a(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$bb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$bb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $0b2e6adb871a3b94$var$db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $0b2e6adb871a3b94$var$eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = $0b2e6adb871a3b94$var$db(b.children)) a.children = b;
    return a;
}
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($0b2e6adb871a3b94$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $0b2e6adb871a3b94$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $0b2e6adb871a3b94$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$nb, $0b2e6adb871a3b94$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $0b2e6adb871a3b94$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$nb = $0b2e6adb871a3b94$var$nb || document.createElement("div");
        $0b2e6adb871a3b94$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$qb).forEach(function(a) {
    $0b2e6adb871a3b94$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$qb[b] = $0b2e6adb871a3b94$var$qb[a];
    });
});
function $0b2e6adb871a3b94$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$qb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$y(62));
    }
}
function $0b2e6adb871a3b94$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$y(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $0b2e6adb871a3b94$var$Ib() {}
var $0b2e6adb871a3b94$var$Jb = $0b2e6adb871a3b94$var$Gb, $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Lb = !1;
function $0b2e6adb871a3b94$var$Mb() {
    if (null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Ib(), $0b2e6adb871a3b94$var$Fb();
}
function $0b2e6adb871a3b94$var$Nb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Lb) return a(b, c);
    $0b2e6adb871a3b94$var$Lb = !0;
    try {
        return $0b2e6adb871a3b94$var$Jb(a, b, c);
    } finally{
        $0b2e6adb871a3b94$var$Lb = !1, $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$y(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Pb = !1;
if ($0b2e6adb871a3b94$var$fa) try {
    var $0b2e6adb871a3b94$var$Qb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Qb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Pb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
} catch (a) {
    $0b2e6adb871a3b94$var$Pb = !1;
}
function $0b2e6adb871a3b94$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $0b2e6adb871a3b94$var$Sb = !1, $0b2e6adb871a3b94$var$Tb = null, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, $0b2e6adb871a3b94$var$Wb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Sb = !0;
        $0b2e6adb871a3b94$var$Tb = a;
    }
};
function $0b2e6adb871a3b94$var$Xb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Sb = !1;
    $0b2e6adb871a3b94$var$Tb = null;
    $0b2e6adb871a3b94$var$Rb.apply($0b2e6adb871a3b94$var$Wb, arguments);
}
function $0b2e6adb871a3b94$var$Yb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Xb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Sb) {
        if ($0b2e6adb871a3b94$var$Sb) {
            var l = $0b2e6adb871a3b94$var$Tb;
            $0b2e6adb871a3b94$var$Sb = !1;
            $0b2e6adb871a3b94$var$Tb = null;
        } else throw Error($0b2e6adb871a3b94$var$y(198));
        $0b2e6adb871a3b94$var$Ub || ($0b2e6adb871a3b94$var$Ub = !0, $0b2e6adb871a3b94$var$Vb = l);
    }
}
function $0b2e6adb871a3b94$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$ac(a) {
    if ($0b2e6adb871a3b94$var$Zb(a) !== a) throw Error($0b2e6adb871a3b94$var$y(188));
}
function $0b2e6adb871a3b94$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Zb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$ac(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$y(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$cc(a) {
    a = $0b2e6adb871a3b94$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $0b2e6adb871a3b94$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $0b2e6adb871a3b94$var$ec, $0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$gc, $0b2e6adb871a3b94$var$hc, $0b2e6adb871a3b94$var$ic = !1, $0b2e6adb871a3b94$var$jc = [], $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null, $0b2e6adb871a3b94$var$mc = null, $0b2e6adb871a3b94$var$nc = new Map, $0b2e6adb871a3b94$var$oc = new Map, $0b2e6adb871a3b94$var$pc = [], $0b2e6adb871a3b94$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $0b2e6adb871a3b94$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$oc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $0b2e6adb871a3b94$var$rc(b, c, d, e, f), null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$mc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$nc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$oc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$vc(a) {
    var b = $0b2e6adb871a3b94$var$wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            $0b2e6adb871a3b94$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$zc(a, b, c) {
    $0b2e6adb871a3b94$var$xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$Ac() {
    for($0b2e6adb871a3b94$var$ic = !1; 0 < $0b2e6adb871a3b94$var$jc.length;){
        var a = $0b2e6adb871a3b94$var$jc[0];
        if (null !== a.blockedOn) {
            a = $0b2e6adb871a3b94$var$Cb(a.blockedOn);
            null !== a && $0b2e6adb871a3b94$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $0b2e6adb871a3b94$var$jc.shift();
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$kc) && ($0b2e6adb871a3b94$var$kc = null);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$lc) && ($0b2e6adb871a3b94$var$lc = null);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$mc) && ($0b2e6adb871a3b94$var$mc = null);
    $0b2e6adb871a3b94$var$nc.forEach($0b2e6adb871a3b94$var$zc);
    $0b2e6adb871a3b94$var$oc.forEach($0b2e6adb871a3b94$var$zc);
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$ic || ($0b2e6adb871a3b94$var$ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Ac)));
}
function $0b2e6adb871a3b94$var$Cc(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$Bc(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$jc.length) {
        $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$jc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$jc.length; c++){
            var d = $0b2e6adb871a3b94$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$kc, a);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$lc, a);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$mc, a);
    $0b2e6adb871a3b94$var$nc.forEach(b);
    $0b2e6adb871a3b94$var$oc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$pc.length; c++)d = $0b2e6adb871a3b94$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$pc.length && (c = $0b2e6adb871a3b94$var$pc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$pc.shift();
}
function $0b2e6adb871a3b94$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$Ec = {
    animationend: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Dc("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Fc = {}, $0b2e6adb871a3b94$var$Gc = {};
$0b2e6adb871a3b94$var$fa && ($0b2e6adb871a3b94$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$Ec.animationend.animation, delete $0b2e6adb871a3b94$var$Ec.animationiteration.animation, delete $0b2e6adb871a3b94$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$Ec.transitionend.transition);
function $0b2e6adb871a3b94$var$Hc(a) {
    if ($0b2e6adb871a3b94$var$Fc[a]) return $0b2e6adb871a3b94$var$Fc[a];
    if (!$0b2e6adb871a3b94$var$Ec[a]) return a;
    var b = $0b2e6adb871a3b94$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Gc) return $0b2e6adb871a3b94$var$Fc[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$Ic = $0b2e6adb871a3b94$var$Hc("animationend"), $0b2e6adb871a3b94$var$Jc = $0b2e6adb871a3b94$var$Hc("animationiteration"), $0b2e6adb871a3b94$var$Kc = $0b2e6adb871a3b94$var$Hc("animationstart"), $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Hc("transitionend"), $0b2e6adb871a3b94$var$Mc = new Map, $0b2e6adb871a3b94$var$Nc = new Map, $0b2e6adb871a3b94$var$Oc = [
    "abort",
    "abort",
    $0b2e6adb871a3b94$var$Ic,
    "animationEnd",
    $0b2e6adb871a3b94$var$Jc,
    "animationIteration",
    $0b2e6adb871a3b94$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $0b2e6adb871a3b94$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $0b2e6adb871a3b94$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $0b2e6adb871a3b94$var$Nc.set(d, b);
        $0b2e6adb871a3b94$var$Mc.set(d, e);
        $0b2e6adb871a3b94$var$da(e, [
            d
        ]);
    }
}
var $0b2e6adb871a3b94$var$Qc = $fO90s.unstable_now;
$0b2e6adb871a3b94$var$Qc();
var $0b2e6adb871a3b94$var$F = 8;
function $0b2e6adb871a3b94$var$Rc(a) {
    if (0 !== (1 & a)) return $0b2e6adb871a3b94$var$F = 15, 1;
    if (0 !== (2 & a)) return $0b2e6adb871a3b94$var$F = 14, 2;
    if (0 !== (4 & a)) return $0b2e6adb871a3b94$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 12, b;
    if (0 !== (a & 32)) return $0b2e6adb871a3b94$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 10, b;
    if (0 !== (a & 256)) return $0b2e6adb871a3b94$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 8, b;
    if (0 !== (a & 4096)) return $0b2e6adb871a3b94$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 5, b;
    if (a & 67108864) return $0b2e6adb871a3b94$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $0b2e6adb871a3b94$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $0b2e6adb871a3b94$var$F = 1, 1073741824;
    $0b2e6adb871a3b94$var$F = 8;
    return a;
}
function $0b2e6adb871a3b94$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $0b2e6adb871a3b94$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($0b2e6adb871a3b94$var$y(358, a));
    }
}
function $0b2e6adb871a3b94$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $0b2e6adb871a3b94$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $0b2e6adb871a3b94$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $0b2e6adb871a3b94$var$Rc(k), e = $0b2e6adb871a3b94$var$F) : (h &= f, 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F));
    } else f = c & ~g, 0 !== f ? (d = $0b2e6adb871a3b94$var$Rc(f), e = $0b2e6adb871a3b94$var$F) : 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F);
    if (0 === d) return 0;
    d = 31 - $0b2e6adb871a3b94$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $0b2e6adb871a3b94$var$Rc(b);
        if (e <= $0b2e6adb871a3b94$var$F) return b;
        $0b2e6adb871a3b94$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $0b2e6adb871a3b94$var$Yc(24 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(10, b) : a;
        case 10:
            return a = $0b2e6adb871a3b94$var$Yc(192 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(8, b) : a;
        case 8:
            return a = $0b2e6adb871a3b94$var$Yc(3584 & ~b), 0 === a && (a = $0b2e6adb871a3b94$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $0b2e6adb871a3b94$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($0b2e6adb871a3b94$var$y(358, a));
}
function $0b2e6adb871a3b94$var$Yc(a) {
    return a & -a;
}
function $0b2e6adb871a3b94$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$Vc(b);
    a[b] = c;
}
var $0b2e6adb871a3b94$var$Vc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$ad, $0b2e6adb871a3b94$var$bd = Math.log, $0b2e6adb871a3b94$var$cd = Math.LN2;
function $0b2e6adb871a3b94$var$ad(a) {
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$bd(a) / $0b2e6adb871a3b94$var$cd | 0) | 0;
}
var $0b2e6adb871a3b94$var$dd = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$ed = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$fd = !0;
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    $0b2e6adb871a3b94$var$Kb || $0b2e6adb871a3b94$var$Ib();
    var e = $0b2e6adb871a3b94$var$hd, f = $0b2e6adb871a3b94$var$Kb;
    $0b2e6adb871a3b94$var$Kb = !0;
    try {
        $0b2e6adb871a3b94$var$Hb(e, a, b, c, d);
    } finally{
        ($0b2e6adb871a3b94$var$Kb = f) || $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$id(a, b, c, d) {
    $0b2e6adb871a3b94$var$ed($0b2e6adb871a3b94$var$dd, $0b2e6adb871a3b94$var$hd.bind(null, a, b, c, d));
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $0b2e6adb871a3b94$var$jc.length && -1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) a = $0b2e6adb871a3b94$var$rc(null, a, b, c, d), $0b2e6adb871a3b94$var$jc.push(a);
        else {
            var f = $0b2e6adb871a3b94$var$yc(a, b, c, d);
            if (null === f) e && $0b2e6adb871a3b94$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) {
                        a = $0b2e6adb871a3b94$var$rc(f, a, b, c, d);
                        $0b2e6adb871a3b94$var$jc.push(a);
                        return;
                    }
                    if ($0b2e6adb871a3b94$var$uc(f, a, b, c, d)) return;
                    $0b2e6adb871a3b94$var$sc(a, d);
                }
                $0b2e6adb871a3b94$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $0b2e6adb871a3b94$var$yc(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$xb(d);
    e = $0b2e6adb871a3b94$var$wc(e);
    if (null !== e) {
        var f = $0b2e6adb871a3b94$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $0b2e6adb871a3b94$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $0b2e6adb871a3b94$var$jd(a, b, d, e, c);
    return null;
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$fa && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$fa && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$fa && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$fa && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$fa) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$fa) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        a = $0b2e6adb871a3b94$var$re;
        if ($0b2e6adb871a3b94$var$Kb) a(b);
        else {
            $0b2e6adb871a3b94$var$Kb = !0;
            try {
                $0b2e6adb871a3b94$var$Gb(a, b);
            } finally{
                $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Mb();
            }
        }
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge, $0b2e6adb871a3b94$var$Ie = Object.prototype.hasOwnProperty;
function $0b2e6adb871a3b94$var$Je(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$0b2e6adb871a3b94$var$Ie.call(b, c[d]) || !$0b2e6adb871a3b94$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    var c = $0b2e6adb871a3b94$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Ke(c);
    }
}
function $0b2e6adb871a3b94$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Ne() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$fa && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Je($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
$0b2e6adb871a3b94$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$0b2e6adb871a3b94$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$0b2e6adb871a3b94$var$Pc($0b2e6adb871a3b94$var$Oc, 2);
for(var $0b2e6adb871a3b94$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $0b2e6adb871a3b94$var$We = 0; $0b2e6adb871a3b94$var$We < $0b2e6adb871a3b94$var$Ve.length; $0b2e6adb871a3b94$var$We++)$0b2e6adb871a3b94$var$Nc.set($0b2e6adb871a3b94$var$Ve[$0b2e6adb871a3b94$var$We], 0);
$0b2e6adb871a3b94$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$Xe));
function $0b2e6adb871a3b94$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Ub) throw a = $0b2e6adb871a3b94$var$Vb, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, a;
}
function $0b2e6adb871a3b94$var$G(a, b) {
    var c = $0b2e6adb871a3b94$var$$e(b), d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$af(b, a, 2, !1), c.add(d));
}
var $0b2e6adb871a3b94$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$cf(a) {
    a[$0b2e6adb871a3b94$var$bf] || (a[$0b2e6adb871a3b94$var$bf] = !0, $0b2e6adb871a3b94$var$ba.forEach(function(b) {
        $0b2e6adb871a3b94$var$Ye.has(b) || $0b2e6adb871a3b94$var$df(b, !1, a, null);
        $0b2e6adb871a3b94$var$df(b, !0, a, null);
    }));
}
function $0b2e6adb871a3b94$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $0b2e6adb871a3b94$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $0b2e6adb871a3b94$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $0b2e6adb871a3b94$var$af(f, a, e, b), g.add(h));
}
function $0b2e6adb871a3b94$var$af(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        case 1:
            e = $0b2e6adb871a3b94$var$id;
            break;
        default:
            e = $0b2e6adb871a3b94$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Nb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$Ic:
                    case $0b2e6adb871a3b94$var$Jc:
                    case $0b2e6adb871a3b94$var$Kc:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$Lc:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $0b2e6adb871a3b94$var$Ob(t, u), null != v && w.push($0b2e6adb871a3b94$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$wc(x) || x[$0b2e6adb871a3b94$var$ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? $0b2e6adb871a3b94$var$wc(x) : null, null !== x && (z = $0b2e6adb871a3b94$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = $0b2e6adb871a3b94$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $0b2e6adb871a3b94$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        q = null == x ? h : $0b2e6adb871a3b94$var$ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $0b2e6adb871a3b94$var$wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $0b2e6adb871a3b94$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $0b2e6adb871a3b94$var$gf(v))q++;
                            for(; 0 < t - q;)w = $0b2e6adb871a3b94$var$gf(w), t--;
                            for(; 0 < q - t;)u = $0b2e6adb871a3b94$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $0b2e6adb871a3b94$var$gf(w);
                                u = $0b2e6adb871a3b94$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $0b2e6adb871a3b94$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $0b2e6adb871a3b94$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) J = $0b2e6adb871a3b94$var$Fe;
                    else {
                        J = $0b2e6adb871a3b94$var$De;
                        var K = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $0b2e6adb871a3b94$var$Ee);
                if (J && (J = J(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $0b2e6adb871a3b94$var$bb(h, "number", h.value);
            }
            K = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(K) || "true" === K.contentEditable) $0b2e6adb871a3b94$var$Qe = K, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var Q;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $0b2e6adb871a3b94$var$ie && (Q = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), K = $0b2e6adb871a3b94$var$oe(d, L), 0 < K.length && (L = new $0b2e6adb871a3b94$var$Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $0b2e6adb871a3b94$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Ob(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$ef(a, f, e)), f = $0b2e6adb871a3b94$var$Ob(a, b), null != f && d.push($0b2e6adb871a3b94$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$ef(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.push($0b2e6adb871a3b94$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $0b2e6adb871a3b94$var$jf() {}
var $0b2e6adb871a3b94$var$kf = null, $0b2e6adb871a3b94$var$lf = null;
function $0b2e6adb871a3b94$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $0b2e6adb871a3b94$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $0b2e6adb871a3b94$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $0b2e6adb871a3b94$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$tf = 0;
function $0b2e6adb871a3b94$var$uf(a) {
    return {
        $$typeof: $0b2e6adb871a3b94$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $0b2e6adb871a3b94$var$vf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$wf = "__reactFiber$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$xf = "__reactProps$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$ff = "__reactContainer$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$yf = "__reactEvents$" + $0b2e6adb871a3b94$var$vf;
function $0b2e6adb871a3b94$var$wc(a) {
    var b = a[$0b2e6adb871a3b94$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$ff] || c[$0b2e6adb871a3b94$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$sf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$wf]) return c;
                a = $0b2e6adb871a3b94$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$wf] || a[$0b2e6adb871a3b94$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$y(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$xf] || null;
}
function $0b2e6adb871a3b94$var$$e(a) {
    var b = a[$0b2e6adb871a3b94$var$yf];
    void 0 === b && (b = a[$0b2e6adb871a3b94$var$yf] = new Set);
    return b;
}
var $0b2e6adb871a3b94$var$zf = [], $0b2e6adb871a3b94$var$Af = -1;
function $0b2e6adb871a3b94$var$Bf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$H(a) {
    0 > $0b2e6adb871a3b94$var$Af || (a.current = $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af], $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = null, $0b2e6adb871a3b94$var$Af--);
}
function $0b2e6adb871a3b94$var$I(a, b) {
    $0b2e6adb871a3b94$var$Af++;
    $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Cf = {}, $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$Cf), $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$Bf(!1), $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$Gf() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
}
function $0b2e6adb871a3b94$var$Hf(a, b, c) {
    if ($0b2e6adb871a3b94$var$M.current !== $0b2e6adb871a3b94$var$Cf) throw Error($0b2e6adb871a3b94$var$y(168));
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
function $0b2e6adb871a3b94$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($0b2e6adb871a3b94$var$y(108, $0b2e6adb871a3b94$var$Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function $0b2e6adb871a3b94$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Cf;
    $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$M.current;
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, $0b2e6adb871a3b94$var$N.current);
    return !0;
}
function $0b2e6adb871a3b94$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$y(169));
    c ? (a = $0b2e6adb871a3b94$var$If(a, b, $0b2e6adb871a3b94$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a)) : $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
var $0b2e6adb871a3b94$var$Lf = null, $0b2e6adb871a3b94$var$Mf = null, $0b2e6adb871a3b94$var$Nf = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$Of = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$Pf = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$Qf = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$Rf = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$Sf = $fO90s.unstable_now, $0b2e6adb871a3b94$var$Tf = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$Uf = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$Vf = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$Wf = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Xf = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$Yf = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$Zf = {}, $0b2e6adb871a3b94$var$$f = void 0 !== $0b2e6adb871a3b94$var$Rf ? $0b2e6adb871a3b94$var$Rf : function() {}, $0b2e6adb871a3b94$var$ag = null, $0b2e6adb871a3b94$var$bg = null, $0b2e6adb871a3b94$var$cg = !1, $0b2e6adb871a3b94$var$dg = $0b2e6adb871a3b94$var$Sf(), $0b2e6adb871a3b94$var$O = 1E4 > $0b2e6adb871a3b94$var$dg ? $0b2e6adb871a3b94$var$Sf : function() {
    return $0b2e6adb871a3b94$var$Sf() - $0b2e6adb871a3b94$var$dg;
};
function $0b2e6adb871a3b94$var$eg() {
    switch($0b2e6adb871a3b94$var$Tf()){
        case $0b2e6adb871a3b94$var$Uf:
            return 99;
        case $0b2e6adb871a3b94$var$Vf:
            return 98;
        case $0b2e6adb871a3b94$var$Wf:
            return 97;
        case $0b2e6adb871a3b94$var$Xf:
            return 96;
        case $0b2e6adb871a3b94$var$Yf:
            return 95;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$fg(a) {
    switch(a){
        case 99:
            return $0b2e6adb871a3b94$var$Uf;
        case 98:
            return $0b2e6adb871a3b94$var$Vf;
        case 97:
            return $0b2e6adb871a3b94$var$Wf;
        case 96:
            return $0b2e6adb871a3b94$var$Xf;
        case 95:
            return $0b2e6adb871a3b94$var$Yf;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$gg(a, b) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Nf(a, b);
}
function $0b2e6adb871a3b94$var$hg(a, b, c) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Of(a, b, c);
}
function $0b2e6adb871a3b94$var$ig() {
    if (null !== $0b2e6adb871a3b94$var$bg) {
        var a = $0b2e6adb871a3b94$var$bg;
        $0b2e6adb871a3b94$var$bg = null;
        $0b2e6adb871a3b94$var$Pf(a);
    }
    $0b2e6adb871a3b94$var$jg();
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$cg && null !== $0b2e6adb871a3b94$var$ag) {
        $0b2e6adb871a3b94$var$cg = !0;
        var a = 0;
        try {
            var b = $0b2e6adb871a3b94$var$ag;
            $0b2e6adb871a3b94$var$gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $0b2e6adb871a3b94$var$ag = null;
        } catch (c) {
            throw null !== $0b2e6adb871a3b94$var$ag && ($0b2e6adb871a3b94$var$ag = $0b2e6adb871a3b94$var$ag.slice(a + 1)), $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$ig), c;
        } finally{
            $0b2e6adb871a3b94$var$cg = !1;
        }
    }
}
var $0b2e6adb871a3b94$var$kg = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$Bf(null), $0b2e6adb871a3b94$var$ng = null, $0b2e6adb871a3b94$var$og = null, $0b2e6adb871a3b94$var$pg = null;
function $0b2e6adb871a3b94$var$qg() {
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$ng = null;
}
function $0b2e6adb871a3b94$var$rg(a) {
    var b = $0b2e6adb871a3b94$var$mg.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$mg);
    a.type._context._currentValue = b;
}
function $0b2e6adb871a3b94$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$ng = a;
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$vg(a, b) {
    if ($0b2e6adb871a3b94$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $0b2e6adb871a3b94$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $0b2e6adb871a3b94$var$og) {
            if (null === $0b2e6adb871a3b94$var$ng) throw Error($0b2e6adb871a3b94$var$y(308));
            $0b2e6adb871a3b94$var$og = b;
            $0b2e6adb871a3b94$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$og.next = b;
    }
    return a._currentValue;
}
var $0b2e6adb871a3b94$var$wg = !1;
function $0b2e6adb871a3b94$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $0b2e6adb871a3b94$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $0b2e6adb871a3b94$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $0b2e6adb871a3b94$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$y(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$Fg = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$Hg(), d = $0b2e6adb871a3b94$var$Ig(a), e = $0b2e6adb871a3b94$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $0b2e6adb871a3b94$var$Ag(a, e);
        $0b2e6adb871a3b94$var$Jg(a, d, c);
    }
};
function $0b2e6adb871a3b94$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Je(c, d) || !$0b2e6adb871a3b94$var$Je(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Mg(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$vg(f) : (e = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Ef(a, e) : $0b2e6adb871a3b94$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$Fg;
    $0b2e6adb871a3b94$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$vg(f) : (f = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, e.context = $0b2e6adb871a3b94$var$Ef(a, f));
    $0b2e6adb871a3b94$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $0b2e6adb871a3b94$var$Pg = Array.isArray;
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $0b2e6adb871a3b94$var$Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$y(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$y(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($0b2e6adb871a3b94$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $0b2e6adb871a3b94$var$Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c = $0b2e6adb871a3b94$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Qg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$ta:
                    return b = $0b2e6adb871a3b94$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($0b2e6adb871a3b94$var$Pg(b) || $0b2e6adb871a3b94$var$La(b)) return b = $0b2e6adb871a3b94$var$Xg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c.key === e ? c.type === $0b2e6adb871a3b94$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($0b2e6adb871a3b94$var$Pg(c) || $0b2e6adb871a3b94$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $0b2e6adb871a3b94$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $0b2e6adb871a3b94$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($0b2e6adb871a3b94$var$Pg(d) || $0b2e6adb871a3b94$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$La(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $0b2e6adb871a3b94$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $0b2e6adb871a3b94$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $0b2e6adb871a3b94$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $0b2e6adb871a3b94$var$ua ? (d = $0b2e6adb871a3b94$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $0b2e6adb871a3b94$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $0b2e6adb871a3b94$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($0b2e6adb871a3b94$var$Pg(f)) return x(a, d, f, h);
        if ($0b2e6adb871a3b94$var$La(f)) return w(a, d, f, h);
        l && $0b2e6adb871a3b94$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($0b2e6adb871a3b94$var$y(152, $0b2e6adb871a3b94$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Sg(!0), $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Sg(!1), $0b2e6adb871a3b94$var$$g = {}, $0b2e6adb871a3b94$var$ah = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$bh = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$ch = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g);
function $0b2e6adb871a3b94$var$dh(a) {
    if (a === $0b2e6adb871a3b94$var$$g) throw Error($0b2e6adb871a3b94$var$y(174));
    return a;
}
function $0b2e6adb871a3b94$var$eh(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ch, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, $0b2e6adb871a3b94$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$mb(b, a);
    }
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, b);
}
function $0b2e6adb871a3b94$var$fh() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ch);
}
function $0b2e6adb871a3b94$var$gh(a) {
    $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
    var b = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
    var c = $0b2e6adb871a3b94$var$mb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, c));
}
function $0b2e6adb871a3b94$var$hh(a) {
    $0b2e6adb871a3b94$var$bh.current === a && ($0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh));
}
var $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$Bf(0);
function $0b2e6adb871a3b94$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$jh = null, $0b2e6adb871a3b94$var$kh = null, $0b2e6adb871a3b94$var$lh = !1;
function $0b2e6adb871a3b94$var$mh(a, b) {
    var c = $0b2e6adb871a3b94$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $0b2e6adb871a3b94$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$ph(a) {
    if ($0b2e6adb871a3b94$var$lh) {
        var b = $0b2e6adb871a3b94$var$kh;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$oh(a, b)) {
                b = $0b2e6adb871a3b94$var$rf(c.nextSibling);
                if (!b || !$0b2e6adb871a3b94$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $0b2e6adb871a3b94$var$lh = !1;
                    $0b2e6adb871a3b94$var$jh = a;
                    return;
                }
                $0b2e6adb871a3b94$var$mh($0b2e6adb871a3b94$var$jh, c);
            }
            $0b2e6adb871a3b94$var$jh = a;
            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $0b2e6adb871a3b94$var$lh = !1, $0b2e6adb871a3b94$var$jh = a;
    }
}
function $0b2e6adb871a3b94$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$jh = a;
}
function $0b2e6adb871a3b94$var$rh(a) {
    if (a !== $0b2e6adb871a3b94$var$jh) return !1;
    if (!$0b2e6adb871a3b94$var$lh) return $0b2e6adb871a3b94$var$qh(a), $0b2e6adb871a3b94$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$nf(b, a.memoizedProps)) for(b = $0b2e6adb871a3b94$var$kh; b;)$0b2e6adb871a3b94$var$mh(a, b), b = $0b2e6adb871a3b94$var$rf(b.nextSibling);
    $0b2e6adb871a3b94$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$kh = null;
        }
    } else $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh ? $0b2e6adb871a3b94$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$sh() {
    $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh = null;
    $0b2e6adb871a3b94$var$lh = !1;
}
var $0b2e6adb871a3b94$var$th = [];
function $0b2e6adb871a3b94$var$uh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$th.length; a++)$0b2e6adb871a3b94$var$th[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$th.length = 0;
}
var $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$xh = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$S = null, $0b2e6adb871a3b94$var$T = null, $0b2e6adb871a3b94$var$yh = !1, $0b2e6adb871a3b94$var$zh = !1;
function $0b2e6adb871a3b94$var$Ah() {
    throw Error($0b2e6adb871a3b94$var$y(321));
}
function $0b2e6adb871a3b94$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ch(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$xh = f;
    $0b2e6adb871a3b94$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$vh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Dh : $0b2e6adb871a3b94$var$Eh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$zh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$zh = !1;
            if (!(25 > f)) throw Error($0b2e6adb871a3b94$var$y(301));
            f += 1;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Fh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$zh);
    }
    $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
    b = null !== $0b2e6adb871a3b94$var$S && null !== $0b2e6adb871a3b94$var$S.next;
    $0b2e6adb871a3b94$var$xh = 0;
    $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$yh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$y(300));
    return a;
}
function $0b2e6adb871a3b94$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Ih() {
    if (null === $0b2e6adb871a3b94$var$S) {
        var a = $0b2e6adb871a3b94$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$S.next;
    var b = null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState : $0b2e6adb871a3b94$var$T.next;
    if (null !== b) $0b2e6adb871a3b94$var$T = b, $0b2e6adb871a3b94$var$S = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$y(310));
        $0b2e6adb871a3b94$var$S = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$S.memoizedState,
            baseState: $0b2e6adb871a3b94$var$S.baseState,
            baseQueue: $0b2e6adb871a3b94$var$S.baseQueue,
            queue: $0b2e6adb871a3b94$var$S.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    }
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Kh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($0b2e6adb871a3b94$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $0b2e6adb871a3b94$var$R.lanes |= l;
                $0b2e6adb871a3b94$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Lh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($0b2e6adb871a3b94$var$xh & a) === a) b._workInProgressVersionPrimary = d, $0b2e6adb871a3b94$var$th.push(b);
    if (a) return c(b._source);
    $0b2e6adb871a3b94$var$th.push(b);
    throw Error($0b2e6adb871a3b94$var$y(350));
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$U;
    if (null === e) throw Error($0b2e6adb871a3b94$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $0b2e6adb871a3b94$var$vh.current, k = h.useState(function() {
        return $0b2e6adb871a3b94$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $0b2e6adb871a3b94$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $0b2e6adb871a3b94$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!$0b2e6adb871a3b94$var$He(g, a)) {
            a = c(b._source);
            $0b2e6adb871a3b94$var$He(n, a) || (l(a), a = $0b2e6adb871a3b94$var$Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - $0b2e6adb871a3b94$var$Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = $0b2e6adb871a3b94$var$Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $0b2e6adb871a3b94$var$He(C, c) && $0b2e6adb871a3b94$var$He(x, b) && $0b2e6adb871a3b94$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a), k.queue = a, k.baseQueue = null, n = $0b2e6adb871a3b94$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $0b2e6adb871a3b94$var$Ph(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Ih();
    return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
}
function $0b2e6adb871a3b94$var$Qh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $0b2e6adb871a3b94$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$Sh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $0b2e6adb871a3b94$var$Th() {
    return $0b2e6adb871a3b94$var$Ih().memoizedState;
}
function $0b2e6adb871a3b94$var$Uh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Hh();
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$Vh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$S) {
        var g = $0b2e6adb871a3b94$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Bh(d, g.deps)) {
            $0b2e6adb871a3b94$var$Rh(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    return $0b2e6adb871a3b94$var$Uh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Xh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Yh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$Vh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ai() {}
function $0b2e6adb871a3b94$var$bi(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ci(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$di(a, b) {
    var c = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $0b2e6adb871a3b94$var$gg(97 < c ? 97 : c, function() {
        var c = $0b2e6adb871a3b94$var$wh.transition;
        $0b2e6adb871a3b94$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $0b2e6adb871a3b94$var$wh.transition = c;
        }
    });
}
function $0b2e6adb871a3b94$var$Oh(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $0b2e6adb871a3b94$var$R || null !== g && g === $0b2e6adb871a3b94$var$R) $0b2e6adb871a3b94$var$zh = $0b2e6adb871a3b94$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($0b2e6adb871a3b94$var$He(k, h)) return;
        } catch (l) {} finally{}
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    }
}
var $0b2e6adb871a3b94$var$Gh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$Ah,
    useContext: $0b2e6adb871a3b94$var$Ah,
    useEffect: $0b2e6adb871a3b94$var$Ah,
    useImperativeHandle: $0b2e6adb871a3b94$var$Ah,
    useLayoutEffect: $0b2e6adb871a3b94$var$Ah,
    useMemo: $0b2e6adb871a3b94$var$Ah,
    useReducer: $0b2e6adb871a3b94$var$Ah,
    useRef: $0b2e6adb871a3b94$var$Ah,
    useState: $0b2e6adb871a3b94$var$Ah,
    useDebugValue: $0b2e6adb871a3b94$var$Ah,
    useDeferredValue: $0b2e6adb871a3b94$var$Ah,
    useTransition: $0b2e6adb871a3b94$var$Ah,
    useMutableSource: $0b2e6adb871a3b94$var$Ah,
    useOpaqueIdentifier: $0b2e6adb871a3b94$var$Ah,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Dh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$Uh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $0b2e6adb871a3b94$var$Sh,
    useState: $0b2e6adb871a3b94$var$Qh,
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Qh(a), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Wh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Qh(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$di.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if ($0b2e6adb871a3b94$var$lh) {
            var a = !1, b = $0b2e6adb871a3b94$var$uf(function() {
                a || (a = !0, c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36)));
                throw Error($0b2e6adb871a3b94$var$y(355));
            }), c = $0b2e6adb871a3b94$var$Qh(b)[1];
            0 === ($0b2e6adb871a3b94$var$R.mode & 2) && ($0b2e6adb871a3b94$var$R.flags |= 516, $0b2e6adb871a3b94$var$Rh(5, function() {
                c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($0b2e6adb871a3b94$var$tf++).toString(36);
        $0b2e6adb871a3b94$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Eh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Kh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Fh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Lh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$ei = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$ug = !1;
function $0b2e6adb871a3b94$var$fi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Zg(b, null, c, d) : $0b2e6adb871a3b94$var$Yg(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$tg(b, e);
    d = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$0b2e6adb871a3b94$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $0b2e6adb871a3b94$var$ki(a, b, g, d, e, f);
        a = $0b2e6adb871a3b94$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $0b2e6adb871a3b94$var$Je, c(e, d) && a.ref === b.ref)) return $0b2e6adb871a3b94$var$hi(a, b, f);
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d, e, f) {
    if (null !== a && $0b2e6adb871a3b94$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($0b2e6adb871a3b94$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($0b2e6adb871a3b94$var$ug = !0);
        else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$hi(a, b, f);
    }
    return $0b2e6adb871a3b94$var$li(a, b, c, d, f);
}
function $0b2e6adb871a3b94$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $0b2e6adb871a3b94$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$ni(b, d);
    $0b2e6adb871a3b94$var$fi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $0b2e6adb871a3b94$var$li(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current;
    f = $0b2e6adb871a3b94$var$Ef(b, f);
    $0b2e6adb871a3b94$var$tg(b, e);
    c = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$pi(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Ff(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$Jf(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $0b2e6adb871a3b94$var$Mg(b, c, d), $0b2e6adb871a3b94$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$vg(l) : (l = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, l = $0b2e6adb871a3b94$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Ng(b, g, d, l);
        $0b2e6adb871a3b94$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof n && ($0b2e6adb871a3b94$var$Gg(b, c, n, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$vg(k) : (k = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, k = $0b2e6adb871a3b94$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $0b2e6adb871a3b94$var$Ng(b, g, d, k);
        $0b2e6adb871a3b94$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof C && ($0b2e6adb871a3b94$var$Gg(b, c, C, d), x = b.memoizedState), (l = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $0b2e6adb871a3b94$var$qi(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$qi(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$Kf(b, c, !1), $0b2e6adb871a3b94$var$hi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Yg(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Yg(b, null, h, f)) : $0b2e6adb871a3b94$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$Kf(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$Hf(a, b.context, !1);
    $0b2e6adb871a3b94$var$eh(a, b.containerInfo);
}
var $0b2e6adb871a3b94$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$ti(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $0b2e6adb871a3b94$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, b.lanes = 33554432, a;
        c = $0b2e6adb871a3b94$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
        c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
    c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $0b2e6adb871a3b94$var$vi(b, e, 0, null);
    c = $0b2e6adb871a3b94$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $0b2e6adb871a3b94$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $0b2e6adb871a3b94$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $0b2e6adb871a3b94$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $0b2e6adb871a3b94$var$Tg(g, h);
    null !== a ? d = $0b2e6adb871a3b94$var$Tg(a, d) : (d = $0b2e6adb871a3b94$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $0b2e6adb871a3b94$var$sg(a.return, b);
}
function $0b2e6adb871a3b94$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $0b2e6adb871a3b94$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$fi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$yi(a, c);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $0b2e6adb871a3b94$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Bi, $0b2e6adb871a3b94$var$Ci, $0b2e6adb871a3b94$var$Di, $0b2e6adb871a3b94$var$Ei;
$0b2e6adb871a3b94$var$Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Ci = function() {};
$0b2e6adb871a3b94$var$Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $0b2e6adb871a3b94$var$eb(a, e);
                d = $0b2e6adb871a3b94$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
        }
        $0b2e6adb871a3b94$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Fi(a, b) {
    if (!$0b2e6adb871a3b94$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $0b2e6adb871a3b94$var$Ci(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$hh(b);
            var e = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                    return null;
                }
                a = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                if ($0b2e6adb871a3b94$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$wf] = b;
                    d[$0b2e6adb871a3b94$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", d);
                            $0b2e6adb871a3b94$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $0b2e6adb871a3b94$var$Xe.length; a++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[a], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", d);
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$G("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $0b2e6adb871a3b94$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $0b2e6adb871a3b94$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $0b2e6adb871a3b94$var$kb.html && (a = $0b2e6adb871a3b94$var$lb(c));
                    a === $0b2e6adb871a3b94$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$wf] = b;
                    a[$0b2e6adb871a3b94$var$xf] = d;
                    $0b2e6adb871a3b94$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $0b2e6adb871a3b94$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", a);
                            $0b2e6adb871a3b94$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$Xe.length; e++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", a);
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(a, d);
                            e = $0b2e6adb871a3b94$var$Ya(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "option":
                            e = $0b2e6adb871a3b94$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(a, d);
                            e = $0b2e6adb871a3b94$var$gb(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $0b2e6adb871a3b94$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $0b2e6adb871a3b94$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$pb(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$G("scroll", a) : null != k && $0b2e6adb871a3b94$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    $0b2e6adb871a3b94$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                c = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
                $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                $0b2e6adb871a3b94$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$0b2e6adb871a3b94$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $0b2e6adb871a3b94$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($0b2e6adb871a3b94$var$P.current & 1)) 0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 3);
                else {
                    if (0 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V) $0b2e6adb871a3b94$var$V = 4;
                    null === $0b2e6adb871a3b94$var$U || 0 === ($0b2e6adb871a3b94$var$Dg & 134217727) && 0 === ($0b2e6adb871a3b94$var$Hi & 134217727) || $0b2e6adb871a3b94$var$Ii($0b2e6adb871a3b94$var$U, $0b2e6adb871a3b94$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), $0b2e6adb871a3b94$var$Ci(b), null === a && $0b2e6adb871a3b94$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 19:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $0b2e6adb871a3b94$var$Fi(d, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $0b2e6adb871a3b94$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $0b2e6adb871a3b94$var$O() > $0b2e6adb871a3b94$var$Ji && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $0b2e6adb871a3b94$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $0b2e6adb871a3b94$var$O() - d.renderingStartTime > $0b2e6adb871a3b94$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $0b2e6adb871a3b94$var$O(), c.sibling = null, b = $0b2e6adb871a3b94$var$P.current, $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
}
function $0b2e6adb871a3b94$var$Li(a) {
    switch(a.tag){
        case 1:
            $0b2e6adb871a3b94$var$Ff(a.type) && $0b2e6adb871a3b94$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($0b2e6adb871a3b94$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $0b2e6adb871a3b94$var$hh(a), null;
        case 13:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(a), null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $0b2e6adb871a3b94$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Pi(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Qi || ($0b2e6adb871a3b94$var$Qi = !0, $0b2e6adb871a3b94$var$Ri = d);
        $0b2e6adb871a3b94$var$Ni(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $0b2e6adb871a3b94$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ti ? $0b2e6adb871a3b94$var$Ti = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ti.add(this), $0b2e6adb871a3b94$var$Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $0b2e6adb871a3b94$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $0b2e6adb871a3b94$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $0b2e6adb871a3b94$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $0b2e6adb871a3b94$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $0b2e6adb871a3b94$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $0b2e6adb871a3b94$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($0b2e6adb871a3b94$var$Zi(c, a), $0b2e6adb871a3b94$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $0b2e6adb871a3b94$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $0b2e6adb871a3b94$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $0b2e6adb871a3b94$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $0b2e6adb871a3b94$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $0b2e6adb871a3b94$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $0b2e6adb871a3b94$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$bj(a, b) {
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount($0b2e6adb871a3b94$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $0b2e6adb871a3b94$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $0b2e6adb871a3b94$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $0b2e6adb871a3b94$var$Wi(b, f);
            }
            break;
        case 5:
            $0b2e6adb871a3b94$var$Vi(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$cj(a, b);
    }
}
function $0b2e6adb871a3b94$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($0b2e6adb871a3b94$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($0b2e6adb871a3b94$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$y(161));
    }
    c.flags & 16 && ($0b2e6adb871a3b94$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $0b2e6adb871a3b94$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $0b2e6adb871a3b94$var$gj(a, c, b) : $0b2e6adb871a3b94$var$hj(a, c, b);
}
function $0b2e6adb871a3b94$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($0b2e6adb871a3b94$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($0b2e6adb871a3b94$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($0b2e6adb871a3b94$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$0b2e6adb871a3b94$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $0b2e6adb871a3b94$var$$a(c, d);
                    $0b2e6adb871a3b94$var$wb(a, e);
                    b = $0b2e6adb871a3b94$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $0b2e6adb871a3b94$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $0b2e6adb871a3b94$var$ob(c, h) : "children" === g ? $0b2e6adb871a3b94$var$pb(c, h) : $0b2e6adb871a3b94$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $0b2e6adb871a3b94$var$ab(c, d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $0b2e6adb871a3b94$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($0b2e6adb871a3b94$var$jj = $0b2e6adb871a3b94$var$O(), $0b2e6adb871a3b94$var$aj(b.child, !0));
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 19:
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $0b2e6adb871a3b94$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Ui);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $0b2e6adb871a3b94$var$nj = Math.ceil, $0b2e6adb871a3b94$var$oj = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$pj = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$X = 0, $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$W = 0, $0b2e6adb871a3b94$var$qj = 0, $0b2e6adb871a3b94$var$rj = $0b2e6adb871a3b94$var$Bf(0), $0b2e6adb871a3b94$var$V = 0, $0b2e6adb871a3b94$var$sj = null, $0b2e6adb871a3b94$var$tj = 0, $0b2e6adb871a3b94$var$Dg = 0, $0b2e6adb871a3b94$var$Hi = 0, $0b2e6adb871a3b94$var$uj = 0, $0b2e6adb871a3b94$var$vj = null, $0b2e6adb871a3b94$var$jj = 0, $0b2e6adb871a3b94$var$Ji = Infinity;
function $0b2e6adb871a3b94$var$wj() {
    $0b2e6adb871a3b94$var$Ji = $0b2e6adb871a3b94$var$O() + 500;
}
var $0b2e6adb871a3b94$var$Z = null, $0b2e6adb871a3b94$var$Qi = !1, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$Ti = null, $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = null, $0b2e6adb871a3b94$var$zj = 90, $0b2e6adb871a3b94$var$Aj = [], $0b2e6adb871a3b94$var$Bj = [], $0b2e6adb871a3b94$var$Cj = null, $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, $0b2e6adb871a3b94$var$Fj = -1, $0b2e6adb871a3b94$var$Gj = 0, $0b2e6adb871a3b94$var$Hj = 0, $0b2e6adb871a3b94$var$Ij = null, $0b2e6adb871a3b94$var$Jj = !1;
function $0b2e6adb871a3b94$var$Hg() {
    return 0 !== ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$O() : -1 !== $0b2e6adb871a3b94$var$Fj ? $0b2e6adb871a3b94$var$Fj : $0b2e6adb871a3b94$var$Fj = $0b2e6adb871a3b94$var$O();
}
function $0b2e6adb871a3b94$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2;
    0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj);
    if (0 !== $0b2e6adb871a3b94$var$kg.transition) {
        0 !== $0b2e6adb871a3b94$var$Hj && ($0b2e6adb871a3b94$var$Hj = null !== $0b2e6adb871a3b94$var$vj ? $0b2e6adb871a3b94$var$vj.pendingLanes : 0);
        a = $0b2e6adb871a3b94$var$Gj;
        var b = 4186112 & ~$0b2e6adb871a3b94$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $0b2e6adb871a3b94$var$eg();
    0 !== ($0b2e6adb871a3b94$var$X & 4) && 98 === a ? a = $0b2e6adb871a3b94$var$Xc(12, $0b2e6adb871a3b94$var$Gj) : (a = $0b2e6adb871a3b94$var$Sc(a), a = $0b2e6adb871a3b94$var$Xc(a, $0b2e6adb871a3b94$var$Gj));
    return a;
}
function $0b2e6adb871a3b94$var$Jg(a, b, c) {
    if (50 < $0b2e6adb871a3b94$var$Dj) throw $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, Error($0b2e6adb871a3b94$var$y(185));
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    if (null === a) return null;
    $0b2e6adb871a3b94$var$$c(a, b, c);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Hi |= b, 4 === $0b2e6adb871a3b94$var$V && $0b2e6adb871a3b94$var$Ii(a, $0b2e6adb871a3b94$var$W));
    var d = $0b2e6adb871a3b94$var$eg();
    1 === b ? 0 !== ($0b2e6adb871a3b94$var$X & 8) && 0 === ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$Lj(a) : ($0b2e6adb871a3b94$var$Mj(a, c), 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig())) : (0 === ($0b2e6adb871a3b94$var$X & 4) || 98 !== d && 99 !== d || (null === $0b2e6adb871a3b94$var$Cj ? $0b2e6adb871a3b94$var$Cj = new Set([
        a
    ]) : $0b2e6adb871a3b94$var$Cj.add(a)), $0b2e6adb871a3b94$var$Mj(a, c));
    $0b2e6adb871a3b94$var$vj = a;
}
function $0b2e6adb871a3b94$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $0b2e6adb871a3b94$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $0b2e6adb871a3b94$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $0b2e6adb871a3b94$var$Rc(k);
                var n = $0b2e6adb871a3b94$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    b = $0b2e6adb871a3b94$var$F;
    if (0 === d) null !== c && (c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c);
        }
        15 === b ? (c = $0b2e6adb871a3b94$var$Lj.bind(null, a), null === $0b2e6adb871a3b94$var$ag ? ($0b2e6adb871a3b94$var$ag = [
            c
        ], $0b2e6adb871a3b94$var$bg = $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$jg)) : $0b2e6adb871a3b94$var$ag.push(c), c = $0b2e6adb871a3b94$var$Zf) : 14 === b ? c = $0b2e6adb871a3b94$var$hg(99, $0b2e6adb871a3b94$var$Lj.bind(null, a)) : (c = $0b2e6adb871a3b94$var$Tc(b), c = $0b2e6adb871a3b94$var$hg(c, $0b2e6adb871a3b94$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Nj(a) {
    $0b2e6adb871a3b94$var$Fj = -1;
    $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$Gj = 0;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var b = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Oj() && a.callbackNode !== b) return null;
    var c = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var f = $0b2e6adb871a3b94$var$Pj();
    if ($0b2e6adb871a3b94$var$U !== a || $0b2e6adb871a3b94$var$W !== d) $0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$Qj(a, d);
    for(;;)try {
        $0b2e6adb871a3b94$var$Rj();
        break;
    } catch (h) {
        $0b2e6adb871a3b94$var$Sj(a, h);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$oj.current = f;
    $0b2e6adb871a3b94$var$X = e;
    null !== $0b2e6adb871a3b94$var$Y ? d = 0 : ($0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0, d = $0b2e6adb871a3b94$var$V);
    if (0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi)) $0b2e6adb871a3b94$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), c = $0b2e6adb871a3b94$var$Wc(a), 0 !== c && (d = $0b2e6adb871a3b94$var$Tj(a, c)));
        if (1 === d) throw b = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, c), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($0b2e6adb871a3b94$var$y(345));
            case 2:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 3:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $0b2e6adb871a3b94$var$jj + 500 - $0b2e6adb871a3b94$var$O(), 10 < d)) {
                    if (0 !== $0b2e6adb871a3b94$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $0b2e6adb871a3b94$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), d);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $0b2e6adb871a3b94$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $0b2e6adb871a3b94$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $0b2e6adb871a3b94$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), c);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 5:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            default:
                throw Error($0b2e6adb871a3b94$var$y(329));
        }
    }
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return a.callbackNode === b ? $0b2e6adb871a3b94$var$Nj.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    b &= ~$0b2e6adb871a3b94$var$uj;
    b &= ~$0b2e6adb871a3b94$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Lj(a) {
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    $0b2e6adb871a3b94$var$Oj();
    if (a === $0b2e6adb871a3b94$var$U && 0 !== (a.expiredLanes & $0b2e6adb871a3b94$var$W)) {
        var b = $0b2e6adb871a3b94$var$W;
        var c = $0b2e6adb871a3b94$var$Tj(a, b);
        0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi) && (b = $0b2e6adb871a3b94$var$Uc(a, b), c = $0b2e6adb871a3b94$var$Tj(a, b));
    } else b = $0b2e6adb871a3b94$var$Uc(a, 0), c = $0b2e6adb871a3b94$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), b = $0b2e6adb871a3b94$var$Wc(a), 0 !== b && (c = $0b2e6adb871a3b94$var$Tj(a, b)));
    if (1 === c) throw c = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, b), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Uj(a);
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return null;
}
function $0b2e6adb871a3b94$var$Vj() {
    if (null !== $0b2e6adb871a3b94$var$Cj) {
        var a = $0b2e6adb871a3b94$var$Cj;
        $0b2e6adb871a3b94$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
        });
    }
    $0b2e6adb871a3b94$var$ig();
}
function $0b2e6adb871a3b94$var$Wj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$Xj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X &= -2;
    $0b2e6adb871a3b94$var$X |= 8;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$rj, $0b2e6adb871a3b94$var$qj);
    $0b2e6adb871a3b94$var$qj |= b;
    $0b2e6adb871a3b94$var$tj |= b;
}
function $0b2e6adb871a3b94$var$Ki() {
    $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$rj.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$rj);
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$pf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$Gf();
                break;
            case 3:
                $0b2e6adb871a3b94$var$fh();
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
                $0b2e6adb871a3b94$var$uh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$hh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$fh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 19:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 10:
                $0b2e6adb871a3b94$var$rg(d);
                break;
            case 23:
            case 24:
                $0b2e6adb871a3b94$var$Ki();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$U = a;
    $0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Tg(a.current, null);
    $0b2e6adb871a3b94$var$W = $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$tj = b;
    $0b2e6adb871a3b94$var$V = 0;
    $0b2e6adb871a3b94$var$sj = null;
    $0b2e6adb871a3b94$var$uj = $0b2e6adb871a3b94$var$Hi = $0b2e6adb871a3b94$var$Dg = 0;
}
function $0b2e6adb871a3b94$var$Sj(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$qg();
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
            if ($0b2e6adb871a3b94$var$yh) {
                for(var d = $0b2e6adb871a3b94$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$yh = !1;
            }
            $0b2e6adb871a3b94$var$xh = 0;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
            $0b2e6adb871a3b94$var$zh = !1;
            $0b2e6adb871a3b94$var$pj.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$V = 1;
                $0b2e6adb871a3b94$var$sj = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($0b2e6adb871a3b94$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $0b2e6adb871a3b94$var$zg(-1, 1);
                                        t.tag = 2;
                                        $0b2e6adb871a3b94$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $0b2e6adb871a3b94$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $0b2e6adb871a3b94$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($0b2e6adb871a3b94$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 2);
                k = $0b2e6adb871a3b94$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $0b2e6adb871a3b94$var$Pi(p, f, b);
                            $0b2e6adb871a3b94$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $0b2e6adb871a3b94$var$Si(p, f, b);
                                $0b2e6adb871a3b94$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $0b2e6adb871a3b94$var$Zj(c);
        } catch (va) {
            b = va;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Pj() {
    var a = $0b2e6adb871a3b94$var$oj.current;
    $0b2e6adb871a3b94$var$oj.current = $0b2e6adb871a3b94$var$Gh;
    return null === a ? $0b2e6adb871a3b94$var$Gh : a;
}
function $0b2e6adb871a3b94$var$Tj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var d = $0b2e6adb871a3b94$var$Pj();
    $0b2e6adb871a3b94$var$U === a && $0b2e6adb871a3b94$var$W === b || $0b2e6adb871a3b94$var$Qj(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$ak();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Sj(a, e);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$X = c;
    $0b2e6adb871a3b94$var$oj.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$y(261));
    $0b2e6adb871a3b94$var$U = null;
    $0b2e6adb871a3b94$var$W = 0;
    return $0b2e6adb871a3b94$var$V;
}
function $0b2e6adb871a3b94$var$ak() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Rj() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$Qf();)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = $0b2e6adb871a3b94$var$ck(a.alternate, a, $0b2e6adb871a3b94$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Zj(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$pj.current = null;
}
function $0b2e6adb871a3b94$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $0b2e6adb871a3b94$var$Gi(c, b, $0b2e6adb871a3b94$var$qj);
            if (null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($0b2e6adb871a3b94$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $0b2e6adb871a3b94$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 5);
}
function $0b2e6adb871a3b94$var$Uj(a) {
    var b = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(99, $0b2e6adb871a3b94$var$dk.bind(null, a, b));
    return null;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    do $0b2e6adb871a3b94$var$Oj();
    while (null !== $0b2e6adb871a3b94$var$yj);
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $0b2e6adb871a3b94$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $0b2e6adb871a3b94$var$Cj && 0 === (d & 24) && $0b2e6adb871a3b94$var$Cj.has(a) && $0b2e6adb871a3b94$var$Cj.delete(a);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $0b2e6adb871a3b94$var$X;
        $0b2e6adb871a3b94$var$X |= 32;
        $0b2e6adb871a3b94$var$pj.current = null;
        $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$fd;
        g = $0b2e6adb871a3b94$var$Ne();
        if ($0b2e6adb871a3b94$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $0b2e6adb871a3b94$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $0b2e6adb871a3b94$var$fd = !1;
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Jj = !1;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            $0b2e6adb871a3b94$var$ek();
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(g = a; null !== $0b2e6adb871a3b94$var$Z;){
                var t = $0b2e6adb871a3b94$var$Z.flags;
                t & 16 && $0b2e6adb871a3b94$var$pb($0b2e6adb871a3b94$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $0b2e6adb871a3b94$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        break;
                    case 6:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 1024:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 4:
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 8:
                        h = $0b2e6adb871a3b94$var$Z;
                        $0b2e6adb871a3b94$var$cj(g, h);
                        var J = h.alternate;
                        $0b2e6adb871a3b94$var$dj(h);
                        null !== J && $0b2e6adb871a3b94$var$dj(J);
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        v = $0b2e6adb871a3b94$var$lf;
        q = $0b2e6adb871a3b94$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $0b2e6adb871a3b94$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $0b2e6adb871a3b94$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $0b2e6adb871a3b94$var$Le(t, J), f = $0b2e6adb871a3b94$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $0b2e6adb871a3b94$var$fd = !!$0b2e6adb871a3b94$var$kf;
        $0b2e6adb871a3b94$var$lf = $0b2e6adb871a3b94$var$kf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(t = a; null !== $0b2e6adb871a3b94$var$Z;){
                var K = $0b2e6adb871a3b94$var$Z.flags;
                K & 36 && $0b2e6adb871a3b94$var$Yi(t, $0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $0b2e6adb871a3b94$var$Z.ref;
                    if (null !== Q) {
                        var L = $0b2e6adb871a3b94$var$Z.stateNode;
                        switch($0b2e6adb871a3b94$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Z = null;
        $0b2e6adb871a3b94$var$$f();
        $0b2e6adb871a3b94$var$X = e;
    } else a.current = c;
    if ($0b2e6adb871a3b94$var$xj) $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = a, $0b2e6adb871a3b94$var$zj = b;
    else for($0b2e6adb871a3b94$var$Z = d; null !== $0b2e6adb871a3b94$var$Z;)b = $0b2e6adb871a3b94$var$Z.nextEffect, $0b2e6adb871a3b94$var$Z.nextEffect = null, $0b2e6adb871a3b94$var$Z.flags & 8 && (K = $0b2e6adb871a3b94$var$Z, K.sibling = null, K.stateNode = null), $0b2e6adb871a3b94$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($0b2e6adb871a3b94$var$Ti = null);
    1 === d ? a === $0b2e6adb871a3b94$var$Ej ? $0b2e6adb871a3b94$var$Dj++ : ($0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = a) : $0b2e6adb871a3b94$var$Dj = 0;
    c = c.stateNode;
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot($0b2e6adb871a3b94$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    if ($0b2e6adb871a3b94$var$Qi) throw $0b2e6adb871a3b94$var$Qi = !1, a = $0b2e6adb871a3b94$var$Ri, $0b2e6adb871a3b94$var$Ri = null, a;
    if (0 !== ($0b2e6adb871a3b94$var$X & 8)) return null;
    $0b2e6adb871a3b94$var$ig();
    return null;
}
function $0b2e6adb871a3b94$var$ek() {
    for(; null !== $0b2e6adb871a3b94$var$Z;){
        var a = $0b2e6adb871a3b94$var$Z.alternate;
        $0b2e6adb871a3b94$var$Jj || null === $0b2e6adb871a3b94$var$Ij || (0 !== ($0b2e6adb871a3b94$var$Z.flags & 8) ? $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0) : 13 === $0b2e6adb871a3b94$var$Z.tag && $0b2e6adb871a3b94$var$mj(a, $0b2e6adb871a3b94$var$Z) && $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0));
        var b = $0b2e6adb871a3b94$var$Z.flags;
        0 !== (b & 256) && $0b2e6adb871a3b94$var$Xi(a, $0b2e6adb871a3b94$var$Z);
        0 === (b & 512) || $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
            $0b2e6adb871a3b94$var$Oj();
            return null;
        }));
        $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
    }
}
function $0b2e6adb871a3b94$var$Oj() {
    if (90 !== $0b2e6adb871a3b94$var$zj) {
        var a = 97 < $0b2e6adb871a3b94$var$zj ? 97 : $0b2e6adb871a3b94$var$zj;
        $0b2e6adb871a3b94$var$zj = 90;
        return $0b2e6adb871a3b94$var$gg(a, $0b2e6adb871a3b94$var$fk);
    }
    return !1;
}
function $0b2e6adb871a3b94$var$$i(a, b) {
    $0b2e6adb871a3b94$var$Aj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$Zi(a, b) {
    $0b2e6adb871a3b94$var$Bj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$fk() {
    if (null === $0b2e6adb871a3b94$var$yj) return !1;
    var a = $0b2e6adb871a3b94$var$yj;
    $0b2e6adb871a3b94$var$yj = null;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(331));
    var b = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 32;
    var c = $0b2e6adb871a3b94$var$Bj;
    $0b2e6adb871a3b94$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    c = $0b2e6adb871a3b94$var$Aj;
    $0b2e6adb871a3b94$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $0b2e6adb871a3b94$var$X = b;
    $0b2e6adb871a3b94$var$ig();
    return !0;
}
function $0b2e6adb871a3b94$var$gk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Mi(c, b);
    b = $0b2e6adb871a3b94$var$Pi(a, b, 1);
    $0b2e6adb871a3b94$var$Ag(a, b);
    b = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, 1);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, 1, b), $0b2e6adb871a3b94$var$Mj(a, b));
}
function $0b2e6adb871a3b94$var$Wi(a, b) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $0b2e6adb871a3b94$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) {
                a = $0b2e6adb871a3b94$var$Mi(b, a);
                var e = $0b2e6adb871a3b94$var$Si(c, a, 1);
                $0b2e6adb871a3b94$var$Ag(c, e);
                e = $0b2e6adb871a3b94$var$Hg();
                c = $0b2e6adb871a3b94$var$Kj(c, 1);
                if (null !== c) $0b2e6adb871a3b94$var$$c(c, 1, e), $0b2e6adb871a3b94$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$U === a && ($0b2e6adb871a3b94$var$W & c) === c && (4 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$W & 62914560) === $0b2e6adb871a3b94$var$W && 500 > $0b2e6adb871a3b94$var$O() - $0b2e6adb871a3b94$var$jj ? $0b2e6adb871a3b94$var$Qj(a, 0) : $0b2e6adb871a3b94$var$uj |= c);
    $0b2e6adb871a3b94$var$Mj(a, b);
}
function $0b2e6adb871a3b94$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2 : (0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj), b = $0b2e6adb871a3b94$var$Yc(62914560 & ~$0b2e6adb871a3b94$var$Gj), 0 === b && (b = 4194304)));
    c = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, b, c), $0b2e6adb871a3b94$var$Mj(a, c));
}
var $0b2e6adb871a3b94$var$ck;
$0b2e6adb871a3b94$var$ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$N.current) $0b2e6adb871a3b94$var$ug = !0;
        else if (0 !== (c & d)) $0b2e6adb871a3b94$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $0b2e6adb871a3b94$var$ug = !1;
            switch(b.tag){
                case 3:
                    $0b2e6adb871a3b94$var$ri(b);
                    $0b2e6adb871a3b94$var$sh();
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$gh(b);
                    break;
                case 1:
                    $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Jf(b);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$ti(a, b, c);
                        $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                        b = $0b2e6adb871a3b94$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $0b2e6adb871a3b94$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $0b2e6adb871a3b94$var$mi(a, b, c);
            }
            return $0b2e6adb871a3b94$var$hi(a, b, c);
        }
    } else $0b2e6adb871a3b94$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $0b2e6adb871a3b94$var$Ef(b, $0b2e6adb871a3b94$var$M.current);
            $0b2e6adb871a3b94$var$tg(b, c);
            e = $0b2e6adb871a3b94$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($0b2e6adb871a3b94$var$Ff(d)) {
                    var f = !0;
                    $0b2e6adb871a3b94$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $0b2e6adb871a3b94$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $0b2e6adb871a3b94$var$Gg(b, d, g, a);
                e.updater = $0b2e6adb871a3b94$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $0b2e6adb871a3b94$var$Og(b, d, a, c);
                b = $0b2e6adb871a3b94$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $0b2e6adb871a3b94$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $0b2e6adb871a3b94$var$hk(e);
                a = $0b2e6adb871a3b94$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $0b2e6adb871a3b94$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$ii(null, b, e, $0b2e6adb871a3b94$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$pi(a, b, d, e, c);
        case 3:
            $0b2e6adb871a3b94$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($0b2e6adb871a3b94$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $0b2e6adb871a3b94$var$yg(a, b);
            $0b2e6adb871a3b94$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $0b2e6adb871a3b94$var$sh(), b = $0b2e6adb871a3b94$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$jh = b, f = $0b2e6adb871a3b94$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $0b2e6adb871a3b94$var$th.push(f);
                    c = $0b2e6adb871a3b94$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $0b2e6adb871a3b94$var$fi(a, b, d, c), $0b2e6adb871a3b94$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$gh(b), null === a && $0b2e6adb871a3b94$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$nf(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$nf(d, f) && (b.flags |= 16), $0b2e6adb871a3b94$var$oi(a, b), $0b2e6adb871a3b94$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$ph(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$ti(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Yg(b, null, d, c) : $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$gi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $0b2e6adb871a3b94$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$0b2e6adb871a3b94$var$N.current) {
                            b = $0b2e6adb871a3b94$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $0b2e6adb871a3b94$var$zg(-1, c & -c), l.tag = 2, $0b2e6adb871a3b94$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $0b2e6adb871a3b94$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $0b2e6adb871a3b94$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $0b2e6adb871a3b94$var$tg(b, c), e = $0b2e6adb871a3b94$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $0b2e6adb871a3b94$var$lg(e, b.pendingProps), f = $0b2e6adb871a3b94$var$lg(e.type, f), $0b2e6adb871a3b94$var$ii(a, b, e, f, d, c);
        case 15:
            return $0b2e6adb871a3b94$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $0b2e6adb871a3b94$var$Ff(d) ? (a = !0, $0b2e6adb871a3b94$var$Jf(b)) : a = !1, $0b2e6adb871a3b94$var$tg(b, c), $0b2e6adb871a3b94$var$Mg(b, d, e), $0b2e6adb871a3b94$var$Og(b, d, e, c), $0b2e6adb871a3b94$var$qi(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$Ai(a, b, c);
        case 23:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
        case 24:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
};
function $0b2e6adb871a3b94$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$nh(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$ik(a, b, c, d);
}
function $0b2e6adb871a3b94$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$hk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Aa) return 11;
        if (a === $0b2e6adb871a3b94$var$Da) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return $0b2e6adb871a3b94$var$Xg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $0b2e6adb871a3b94$var$wa:
            g = 8;
            e |= 1;
            break;
        case $0b2e6adb871a3b94$var$xa:
            return a = $0b2e6adb871a3b94$var$nh(12, c, b, e | 8), a.elementType = $0b2e6adb871a3b94$var$xa, a.type = $0b2e6adb871a3b94$var$xa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ba:
            return a = $0b2e6adb871a3b94$var$nh(13, c, b, e), a.type = $0b2e6adb871a3b94$var$Ba, a.elementType = $0b2e6adb871a3b94$var$Ba, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ca:
            return a = $0b2e6adb871a3b94$var$nh(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ca, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$vi(c, e, f, b);
        case $0b2e6adb871a3b94$var$Ja:
            return a = $0b2e6adb871a3b94$var$nh(24, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$ya:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$za:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Aa:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $0b2e6adb871a3b94$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$y(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Xg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$vi(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(23, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Ug(a, b, c) {
    a = $0b2e6adb871a3b94$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Wg(a, b, c) {
    b = $0b2e6adb871a3b94$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$Zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$lk(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$Hg(), g = $0b2e6adb871a3b94$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($0b2e6adb871a3b94$var$Zb(c) !== c || 1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($0b2e6adb871a3b94$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($0b2e6adb871a3b94$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($0b2e6adb871a3b94$var$Ff(k)) {
                c = $0b2e6adb871a3b94$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $0b2e6adb871a3b94$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $0b2e6adb871a3b94$var$Ag(e, b);
    $0b2e6adb871a3b94$var$Jg(e, g, f);
    return g;
}
function $0b2e6adb871a3b94$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$ok(a, b) {
    $0b2e6adb871a3b94$var$nk(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$nk(a, b);
}
function $0b2e6adb871a3b94$var$pk() {
    return null;
}
function $0b2e6adb871a3b94$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $0b2e6adb871a3b94$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $0b2e6adb871a3b94$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $0b2e6adb871a3b94$var$xg(b);
    a[$0b2e6adb871a3b94$var$ff] = c.current;
    $0b2e6adb871a3b94$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$0b2e6adb871a3b94$var$qk.prototype.render = function(a) {
    $0b2e6adb871a3b94$var$lk(a, this._internalRoot, null, null);
};
$0b2e6adb871a3b94$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $0b2e6adb871a3b94$var$lk(null, a, null, function() {
        b[$0b2e6adb871a3b94$var$ff] = null;
    });
};
function $0b2e6adb871a3b94$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $0b2e6adb871a3b94$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $0b2e6adb871a3b94$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $0b2e6adb871a3b94$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                k.call(a);
            };
        }
        $0b2e6adb871a3b94$var$Xj(function() {
            $0b2e6adb871a3b94$var$lk(b, g, a, e);
        });
    }
    return $0b2e6adb871a3b94$var$mk(g);
}
$0b2e6adb871a3b94$var$ec = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 4, b);
        $0b2e6adb871a3b94$var$ok(a, 4);
    }
};
$0b2e6adb871a3b94$var$fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 67108864, b);
        $0b2e6adb871a3b94$var$ok(a, 67108864);
    }
};
$0b2e6adb871a3b94$var$gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg(), c = $0b2e6adb871a3b94$var$Ig(a);
        $0b2e6adb871a3b94$var$Jg(a, c, b);
        $0b2e6adb871a3b94$var$ok(a, c);
    }
};
$0b2e6adb871a3b94$var$hc = function(a, b) {
    return b();
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$y(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$var$Hb = function(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 4;
    try {
        return $0b2e6adb871a3b94$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $0b2e6adb871a3b94$var$X = f, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
$0b2e6adb871a3b94$var$Ib = function() {
    0 === ($0b2e6adb871a3b94$var$X & 49) && ($0b2e6adb871a3b94$var$Vj(), $0b2e6adb871a3b94$var$Oj());
};
$0b2e6adb871a3b94$var$Jb = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 2;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
function $0b2e6adb871a3b94$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$kk(a, b, null, c);
}
var $0b2e6adb871a3b94$var$vk = {
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Oj,
        {
            current: !1
        }
    ]
}, $0b2e6adb871a3b94$var$wk = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$xk = {
    bundleType: $0b2e6adb871a3b94$var$wk.bundleType,
    version: $0b2e6adb871a3b94$var$wk.version,
    rendererPackageName: $0b2e6adb871a3b94$var$wk.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wk.findFiberByHostInstance || $0b2e6adb871a3b94$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$yk.isDisabled && $0b2e6adb871a3b94$var$yk.supportsFiber) try {
        $0b2e6adb871a3b94$var$Lf = $0b2e6adb871a3b94$var$yk.inject($0b2e6adb871a3b94$var$xk), $0b2e6adb871a3b94$var$Mf = $0b2e6adb871a3b94$var$yk;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$vk;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = $0b2e6adb871a3b94$var$uk;
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$y(188));
        throw Error($0b2e6adb871a3b94$var$y(268, Object.keys(a)));
    }
    a = $0b2e6adb871a3b94$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    if (0 !== (c & 48)) return a(b);
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        if (a) return $0b2e6adb871a3b94$var$gg(99, a.bind(null, b));
    } finally{
        $0b2e6adb871a3b94$var$X = c, $0b2e6adb871a3b94$var$ig();
    }
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$rk(a)) throw Error($0b2e6adb871a3b94$var$y(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Xj(function() {
        $0b2e6adb871a3b94$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$ff] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$export$2577ef5d2565d52f = function(a, b) {
    return $0b2e6adb871a3b94$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$rk(c)) throw Error($0b2e6adb871a3b94$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$y(38));
    return $0b2e6adb871a3b94$var$tk(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRequire.register("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
"use strict";
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRequire.register("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance($lk5EI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($blSvA);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (parcelRequire("dIGMp"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));

$57966c7e0affc4cb$var$axios.VERSION = (parcelRequire("35BUy")).version;

$57966c7e0affc4cb$var$axios.toFormData = (parcelRequire("jOwpo"));

// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (parcelRequire("6HVMZ"));
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRequire.register("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $c319b2c832c2914a$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $c319b2c832c2914a$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $c319b2c832c2914a$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$toString.call(thing) === pattern || $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $c319b2c832c2914a$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $c319b2c832c2914a$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $c319b2c832c2914a$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($c319b2c832c2914a$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $c319b2c832c2914a$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList
};

});
parcelRequire.register("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    var fullPath = $7GD7a(config.baseURL, config.url);
    return $cbIsf(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($lk5EI(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRequire.register("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRequire.register("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $dIGMp();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $blSvA.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $blSvA;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("blSvA", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");
var $843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $843bf0209bc94df8$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $843bf0209bc94df8$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $843bf0209bc94df8$var$defaults = {
    transitional: $6YCMk,
    adapter: $843bf0209bc94df8$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $843bf0209bc94df8$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $gKvUL.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $gKvUL.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $jOwpo(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $843bf0209bc94df8$var$setContentTypeIfUnset(headers, "application/json");
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $6HVMZ.from(e, $6HVMZ.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("5vpyF"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = $gKvUL.merge($843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $843bf0209bc94df8$var$defaults;

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("6HVMZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$gKvUL.inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
var $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    $gKvUL.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $4e2395edb77acf3a$var$AxiosError;

});

parcelRequire.register("6YCMk", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("jOwpo", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $e6cbd383b18c9625$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($gKvUL.isDate(value)) return value.toISOString();
        if ($gKvUL.isArrayBuffer(value) || $gKvUL.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($gKvUL.isPlainObject(data) || $gKvUL.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $gKvUL.forEach(data, function each(value, key) {
                if ($gKvUL.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($gKvUL.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($gKvUL.endsWith(key, "[]") && (arr = $gKvUL.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$gKvUL.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $e6cbd383b18c9625$var$toFormData;

});
parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRequire.register("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($gKvUL.isFormData(requestData) && $gKvUL.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $6HVMZ("Request aborted", $6HVMZ.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $6HVMZ("Network Error", $6HVMZ.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $6YCMk;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $6HVMZ(timeoutErrorMessage, transitional.clarifyTimeoutError ? $6HVMZ.ETIMEDOUT : $6HVMZ.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $dIGMp() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $32jg5(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $6HVMZ("Unsupported protocol " + protocol + ":", $6HVMZ.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("kk0E9", function(module, exports) {
"use strict";

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $6HVMZ("Request failed with status code " + response.status, [
        $6HVMZ.ERR_BAD_REQUEST,
        $6HVMZ.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRequire.register("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("dIGMp", function(module, exports) {
"use strict";

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $9fd0919e266b4fda$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $6HVMZ.call(this, message == null ? "canceled" : message, $6HVMZ.ERR_CANCELED);
    this.name = "CanceledError";
}
$gKvUL.inherits($9fd0919e266b4fda$var$CanceledError, $6HVMZ, {
    __CANCEL__: true
});
module.exports = $9fd0919e266b4fda$var$CanceledError;

});

parcelRequire.register("32jg5", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRequire.register("5vpyF", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRequire.register("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $gKvUL.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $gKvUL.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRequire.register("bv3QM", function(module, exports) {
"use strict";

var $35BUy = parcelRequire("35BUy");
var $85f59389941e7907$require$VERSION = $35BUy.version;

var $6HVMZ = parcelRequire("6HVMZ");
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $85f59389941e7907$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $6HVMZ(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $6HVMZ.ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $6HVMZ("options must be an object", $6HVMZ.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $6HVMZ("option " + opt + " must be " + result, $6HVMZ.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $6HVMZ("Unknown option " + opt, $6HVMZ.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRequire.register("35BUy", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRequire.register("lAKPy", function(module, exports) {
"use strict";

var $dIGMp = parcelRequire("dIGMp");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $dIGMp(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRequire.register("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("dxy9O", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $gKvUL.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRequire.register("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = 60103, $6b3372b60d35b33f$var$c = 60106, $6b3372b60d35b33f$var$d = 60107, $6b3372b60d35b33f$var$e = 60108, $6b3372b60d35b33f$var$f = 60114, $6b3372b60d35b33f$var$g = 60109, $6b3372b60d35b33f$var$h = 60110, $6b3372b60d35b33f$var$k = 60112, $6b3372b60d35b33f$var$l = 60113, $6b3372b60d35b33f$var$m = 60120, $6b3372b60d35b33f$var$n = 60115, $6b3372b60d35b33f$var$p = 60116, $6b3372b60d35b33f$var$q = 60121, $6b3372b60d35b33f$var$r = 60122, $6b3372b60d35b33f$var$u = 60117, $6b3372b60d35b33f$var$v = 60129, $6b3372b60d35b33f$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $6b3372b60d35b33f$var$x = Symbol.for;
    $6b3372b60d35b33f$var$b = $6b3372b60d35b33f$var$x("react.element");
    $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$x("react.portal");
    $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$x("react.fragment");
    $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$x("react.strict_mode");
    $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$x("react.profiler");
    $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$x("react.provider");
    $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$x("react.context");
    $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$x("react.forward_ref");
    $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$x("react.suspense");
    $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$x("react.suspense_list");
    $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$x("react.memo");
    $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$x("react.lazy");
    $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$x("react.block");
    $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$x("react.server.block");
    $6b3372b60d35b33f$var$u = $6b3372b60d35b33f$var$x("react.fundamental");
    $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$x("react.debug_trace_mode");
    $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$x("react.legacy_hidden");
}
function $6b3372b60d35b33f$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return t;
        }
    }
}
var $6b3372b60d35b33f$var$z = $6b3372b60d35b33f$var$g, $6b3372b60d35b33f$var$A = $6b3372b60d35b33f$var$b, $6b3372b60d35b33f$var$B = $6b3372b60d35b33f$var$k, $6b3372b60d35b33f$var$C = $6b3372b60d35b33f$var$d, $6b3372b60d35b33f$var$D = $6b3372b60d35b33f$var$p, $6b3372b60d35b33f$var$E = $6b3372b60d35b33f$var$n, $6b3372b60d35b33f$var$F = $6b3372b60d35b33f$var$c, $6b3372b60d35b33f$var$G = $6b3372b60d35b33f$var$f, $6b3372b60d35b33f$var$H = $6b3372b60d35b33f$var$e, $6b3372b60d35b33f$var$I = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$z;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$B;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$C;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$D;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$E;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$F;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$G;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$H;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$I;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$v || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$l || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$w || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$u || a.$$typeof === $6b3372b60d35b33f$var$q || a[0] === $6b3372b60d35b33f$var$r) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$y;

});

parcelRequire.register("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRequire.register("7Ekty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $42zF9.default;
    }
});

var $42zF9 = parcelRequire("42zF9");

});
parcelRequire.register("42zF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f130330883526cb$export$2e2bcd8739ae039);

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");

var $ayMG0 = parcelRequire("ayMG0");
function $2f130330883526cb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), (0, $e8gS1.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $2VxZV.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRequire.register("e8gS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49ee629d5540020$export$2e2bcd8739ae039);
function $a49ee629d5540020$export$2e2bcd8739ae039() {
    $a49ee629d5540020$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a49ee629d5540020$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("2VxZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $221b46e996ce82df$export$2e2bcd8739ae039);

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $6LnsB = parcelRequire("6LnsB");

var $ayMG0 = parcelRequire("ayMG0");
const $221b46e996ce82df$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $221b46e996ce82df$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $3AM7p.default)(color)}`,
            `fontSize${(0, $3AM7p.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6LnsB.getSvgIconUtilityClass), classes);
};
const $221b46e996ce82df$var$SvgIconRoot = (0, $1Ikg4.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            styles[`fontSize${(0, $3AM7p.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $221b46e996ce82df$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $1sz44.default)(props, $221b46e996ce82df$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $221b46e996ce82df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($221b46e996ce82df$var$SvgIconRoot, (0, $e8gS1.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        ownerState: ownerState,
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$221b46e996ce82df$var$SvgIcon.muiName = "SvgIcon";
var $221b46e996ce82df$export$2e2bcd8739ae039 = $221b46e996ce82df$var$SvgIcon;

});
parcelRequire.register("1sz44", function(module, exports) {

$parcel$export(module.exports, "default", () => $11039b14ced2ab59$export$2e2bcd8739ae039);
function $11039b14ced2ab59$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("1SA7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;

});

parcelRequire.register("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                acc.push(getUtilityClass(key));
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("3AM7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $29da0f32997f4b8c$export$2e2bcd8739ae039);

var $6IaFk = parcelRequire("6IaFk");
var $29da0f32997f4b8c$export$2e2bcd8739ae039 = (0, $6IaFk.default);

});
parcelRequire.register("6IaFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2f201fa2fbf9f3$export$2e2bcd8739ae039);

var $bUPtf = parcelRequire("bUPtf");
function $4e2f201fa2fbf9f3$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $bUPtf.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("bUPtf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8accd9aba21f8e48$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $8accd9aba21f8e48$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("cpBQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $90952e82d066041a$export$2e2bcd8739ae039);

var $dFNG2 = parcelRequire("dFNG2");

var $e7sAA = parcelRequire("e7sAA");
function $90952e82d066041a$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $dFNG2.default)({
        props: props,
        name: name,
        defaultTheme: $e7sAA.default
    });
}

});
parcelRequire.register("dFNG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f45a3834bb6880f$export$2e2bcd8739ae039);

var $cfUWu = parcelRequire("cfUWu");

var $7HKeb = parcelRequire("7HKeb");
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme }) {
    const theme = (0, $7HKeb.default)(defaultTheme);
    const mergedProps = (0, $cfUWu.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("cfUWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec30e4d54713c84$export$2e2bcd8739ae039);

var $1vDzc = parcelRequire("1vDzc");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $1vDzc.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("1vDzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $119760d6b00d97d7$export$2e2bcd8739ae039);

var $by4kD = parcelRequire("by4kD");
function $119760d6b00d97d7$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $by4kD.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});
parcelRequire.register("by4kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $86863ae4c1c48a43$export$2e2bcd8739ae039);
function $86863ae4c1c48a43$export$2e2bcd8739ae039() {
    $86863ae4c1c48a43$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $86863ae4c1c48a43$export$2e2bcd8739ae039.apply(this, arguments);
}

});



parcelRequire.register("7HKeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c0686cf27fa016$export$2e2bcd8739ae039);

var $6o2lr = parcelRequire("6o2lr");

var $2HliV = parcelRequire("2HliV");
const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $2HliV.default)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;

});
parcelRequire.register("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $gUrmH = parcelRequire("gUrmH");

var $kEIch = parcelRequire("kEIch");

var $17r9Q = parcelRequire("17r9Q");

var $dLM8u = parcelRequire("dLM8u");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");
const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $kEIch.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $dLM8u.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $17r9Q.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $gUrmH.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $gUrmH.default)({}, (0, $bVuw0.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $17r9Q.default)(acc, argument), muiTheme);
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRequire.register("gUrmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4f71a78c28bad6f$export$2e2bcd8739ae039);
function $c4f71a78c28bad6f$export$2e2bcd8739ae039() {
    $c4f71a78c28bad6f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c4f71a78c28bad6f$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("kEIch", function(module, exports) {

$parcel$export(module.exports, "default", () => $f099d3adccf54e18$export$2e2bcd8739ae039);
function $f099d3adccf54e18$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("17r9Q", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $0d0b82dec42cae84$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $0d0b82dec42cae84$export$2e2bcd8739ae039);

var $by4kD = parcelRequire("by4kD");
function $0d0b82dec42cae84$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $0d0b82dec42cae84$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $by4kD.default)({}, target) : target;
    if ($0d0b82dec42cae84$export$53b83ca8eaab0383(target) && $0d0b82dec42cae84$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($0d0b82dec42cae84$export$53b83ca8eaab0383(source[key]) && key in target && $0d0b82dec42cae84$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $0d0b82dec42cae84$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("dLM8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06500f70819ed69$export$2e2bcd8739ae039);

var $kEIch = parcelRequire("kEIch");

var $gUrmH = parcelRequire("gUrmH");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $gUrmH.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $kEIch.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $gUrmH.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRequire.register("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $cKRCq = parcelRequire("cKRCq");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $cKRCq.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("cKRCq", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $94935f79a2c44a85$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $94935f79a2c44a85$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $94935f79a2c44a85$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "default", () => $94935f79a2c44a85$export$2e2bcd8739ae039);


var $3OJTQ = parcelRequire("3OJTQ");

var $k0igC = parcelRequire("k0igC");

var $aFh0N = parcelRequire("aFh0N");

var $hsAPr = parcelRequire("hsAPr");
const $94935f79a2c44a85$var$properties = {
    m: "margin",
    p: "padding"
};
const $94935f79a2c44a85$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $hsAPr.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$var$marginKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $94935f79a2c44a85$var$paddingKeys = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$var$marginKeys,
    ...$94935f79a2c44a85$var$paddingKeys
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $k0igC.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aFh0N.default), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$marginKeys);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = {};
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$var$marginKeys;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$paddingKeys);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = {};
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$var$paddingKeys;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = {};
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;

});
parcelRequire.register("3OJTQ", function(module, exports) {

$parcel$export(module.exports, "values", () => $2c79a5510dec9b08$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $2c79a5510dec9b08$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $2c79a5510dec9b08$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $2c79a5510dec9b08$export$8922c90b6e020726);
$parcel$export(module.exports, "resolveBreakpointValues", () => $2c79a5510dec9b08$export$980e6a259d807490);

var $gUrmH = parcelRequire("gUrmH");


var $17r9Q = parcelRequire("17r9Q");

var $aFh0N = parcelRequire("aFh0N");
const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $gUrmH.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aFh0N.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $17r9Q.default)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;

});
parcelRequire.register("aFh0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3aede628aa278f$export$2e2bcd8739ae039);

var $17r9Q = parcelRequire("17r9Q");
function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $17r9Q.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;

});


parcelRequire.register("k0igC", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $e901fa2f27580273$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "default", () => $e901fa2f27580273$export$2e2bcd8739ae039);

var $6IaFk = parcelRequire("6IaFk");


var $3OJTQ = parcelRequire("3OJTQ");
function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$var$getValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$var$getValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $e901fa2f27580273$var$getValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $6IaFk.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;

});

parcelRequire.register("hsAPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb619e97db430627$export$2e2bcd8739ae039);
function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRequire.register("2HliV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f701f7d1726bc9a$export$2e2bcd8739ae039);

var $lT1cX = parcelRequire("lT1cX");
function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = (0, $lT1cX.default)();
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;

});
parcelRequire.register("lT1cX", function(module, exports) {

$parcel$export(module.exports, "default", () => $feefabedf550ce3f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fHPaR = parcelRequire("fHPaR");
function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $fHPaR.default));
    return theme;
}

});
parcelRequire.register("fHPaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f2914bcc222460$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;

});





parcelRequire.register("e7sAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a477e5500cafdc51$export$2e2bcd8739ae039);

var $2rLZY = parcelRequire("2rLZY");
const $a477e5500cafdc51$var$defaultTheme = (0, $2rLZY.default)();
var $a477e5500cafdc51$export$2e2bcd8739ae039 = $a477e5500cafdc51$var$defaultTheme;

});
parcelRequire.register("2rLZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8355eadf532640$export$2e2bcd8739ae039);

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $17r9Q = parcelRequire("17r9Q");
var $bUPtf = parcelRequire("bUPtf");

var $6o2lr = parcelRequire("6o2lr");


var $4BnQk = parcelRequire("4BnQk");

var $7vaTq = parcelRequire("7vaTq");

var $b1ZjZ = parcelRequire("b1ZjZ");

var $86vDZ = parcelRequire("86vDZ");

var $frp52 = parcelRequire("frp52");

var $8YN2e = parcelRequire("8YN2e");
const $1c8355eadf532640$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $1c8355eadf532640$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1sz44.default)(options, $1c8355eadf532640$var$_excluded);
    if (options.vars) throw new Error((0, $bUPtf.default)(18));
    const palette = (0, $7vaTq.default)(paletteInput);
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $17r9Q.default)(systemTheme, {
        mixins: (0, $4BnQk.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $86vDZ.default).slice(),
        typography: (0, $b1ZjZ.default)(palette, typographyInput),
        transitions: (0, $frp52.default)(transitionsInput),
        zIndex: (0, $e8gS1.default)({}, (0, $8YN2e.default))
    });
    muiTheme = (0, $17r9Q.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $17r9Q.default)(acc, argument), muiTheme);
    var component;
    return muiTheme;
}
let $1c8355eadf532640$var$warnedOnce = false;
function $1c8355eadf532640$export$c469355549431d9b(...args) {
    return $1c8355eadf532640$var$createTheme(...args);
}
var $1c8355eadf532640$export$2e2bcd8739ae039 = $1c8355eadf532640$var$createTheme;

});
parcelRequire.register("4BnQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $359d1cd3c99dce0c$export$2e2bcd8739ae039);

var $e8gS1 = parcelRequire("e8gS1");
function $359d1cd3c99dce0c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $e8gS1.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("7vaTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5763e0c539a251df$export$2e2bcd8739ae039);

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $17r9Q = parcelRequire("17r9Q");
var $bUPtf = parcelRequire("bUPtf");

var $jgarO = parcelRequire("jgarO");

var $i9Iyg = parcelRequire("i9Iyg");

var $lbPfT = parcelRequire("lbPfT");

var $k3E08 = parcelRequire("k3E08");

var $7hly1 = parcelRequire("7hly1");

var $2XYar = parcelRequire("2XYar");

var $hxoZM = parcelRequire("hxoZM");

var $3Bwcf = parcelRequire("3Bwcf");

var $6TWA2 = parcelRequire("6TWA2");
const $5763e0c539a251df$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $5763e0c539a251df$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $i9Iyg.default).white,
        default: (0, $i9Iyg.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $5763e0c539a251df$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $i9Iyg.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $i9Iyg.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $5763e0c539a251df$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $jgarO.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $jgarO.darken)(intent.main, tonalOffsetDark);
    }
}
function $5763e0c539a251df$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hxoZM.default)[200],
        light: (0, $hxoZM.default)[50],
        dark: (0, $hxoZM.default)[400]
    };
    return {
        main: (0, $hxoZM.default)[700],
        light: (0, $hxoZM.default)[400],
        dark: (0, $hxoZM.default)[800]
    };
}
function $5763e0c539a251df$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $k3E08.default)[200],
        light: (0, $k3E08.default)[50],
        dark: (0, $k3E08.default)[400]
    };
    return {
        main: (0, $k3E08.default)[500],
        light: (0, $k3E08.default)[300],
        dark: (0, $k3E08.default)[700]
    };
}
function $5763e0c539a251df$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7hly1.default)[500],
        light: (0, $7hly1.default)[300],
        dark: (0, $7hly1.default)[700]
    };
    return {
        main: (0, $7hly1.default)[700],
        light: (0, $7hly1.default)[400],
        dark: (0, $7hly1.default)[800]
    };
}
function $5763e0c539a251df$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3Bwcf.default)[400],
        light: (0, $3Bwcf.default)[300],
        dark: (0, $3Bwcf.default)[700]
    };
    return {
        main: (0, $3Bwcf.default)[700],
        light: (0, $3Bwcf.default)[500],
        dark: (0, $3Bwcf.default)[900]
    };
}
function $5763e0c539a251df$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $6TWA2.default)[400],
        light: (0, $6TWA2.default)[300],
        dark: (0, $6TWA2.default)[700]
    };
    return {
        main: (0, $6TWA2.default)[800],
        light: (0, $6TWA2.default)[500],
        dark: (0, $6TWA2.default)[900]
    };
}
function $5763e0c539a251df$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2XYar.default)[400],
        light: (0, $2XYar.default)[300],
        dark: (0, $2XYar.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $2XYar.default)[500],
        dark: (0, $2XYar.default)[900]
    };
}
function $5763e0c539a251df$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1sz44.default)(palette, $5763e0c539a251df$var$_excluded);
    const primary = palette.primary || $5763e0c539a251df$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5763e0c539a251df$var$getDefaultSecondary(mode);
    const error = palette.error || $5763e0c539a251df$var$getDefaultError(mode);
    const info = palette.info || $5763e0c539a251df$var$getDefaultInfo(mode);
    const success = palette.success || $5763e0c539a251df$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5763e0c539a251df$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $jgarO.getContrastRatio)(background, $5763e0c539a251df$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5763e0c539a251df$export$55ce6f3a06c59543.text.primary : $5763e0c539a251df$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $e8gS1.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $bUPtf.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $bUPtf.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $5763e0c539a251df$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $5763e0c539a251df$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $5763e0c539a251df$export$55ce6f3a06c59543,
        light: $5763e0c539a251df$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $17r9Q.default)((0, $e8gS1.default)({
        // A collection of common colors.
        common: (0, $e8gS1.default)({}, (0, $i9Iyg.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $lbPfT.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("jgarO", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $e0579d99723e0dfe$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $e0579d99723e0dfe$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "darken", () => $e0579d99723e0dfe$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $e0579d99723e0dfe$export$c0816ed86df316af);
$parcel$export(module.exports, "emphasize", () => $e0579d99723e0dfe$export$e665714f76e581fd);

var $bUPtf = parcelRequire("bUPtf");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e0579d99723e0dfe$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $e0579d99723e0dfe$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $e0579d99723e0dfe$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e0579d99723e0dfe$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $bUPtf.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $bUPtf.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e0579d99723e0dfe$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e0579d99723e0dfe$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
function $e0579d99723e0dfe$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $e0579d99723e0dfe$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $e0579d99723e0dfe$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e0579d99723e0dfe$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $e0579d99723e0dfe$export$29fb7152bd3f781a(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e0579d99723e0dfe$export$c852d90bf7403b62(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e0579d99723e0dfe$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e0579d99723e0dfe$export$c852d90bf7403b62(foreground);
    const lumB = $e0579d99723e0dfe$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    value = $e0579d99723e0dfe$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e0579d99723e0dfe$export$c852d90bf7403b62(color) > 0.5 ? $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) : $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
}

});

parcelRequire.register("i9Iyg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37ba043b695a86b$export$2e2bcd8739ae039);
const $d37ba043b695a86b$var$common = {
    black: "#000",
    white: "#fff"
};
var $d37ba043b695a86b$export$2e2bcd8739ae039 = $d37ba043b695a86b$var$common;

});

parcelRequire.register("lbPfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d26248a242c674$export$2e2bcd8739ae039);
const $f6d26248a242c674$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $f6d26248a242c674$export$2e2bcd8739ae039 = $f6d26248a242c674$var$grey;

});

parcelRequire.register("k3E08", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9a31dd7cc73b986$export$2e2bcd8739ae039);
const $e9a31dd7cc73b986$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $e9a31dd7cc73b986$export$2e2bcd8739ae039 = $e9a31dd7cc73b986$var$purple;

});

parcelRequire.register("7hly1", function(module, exports) {

$parcel$export(module.exports, "default", () => $54cad5d9f2acbb0d$export$2e2bcd8739ae039);
const $54cad5d9f2acbb0d$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $54cad5d9f2acbb0d$export$2e2bcd8739ae039 = $54cad5d9f2acbb0d$var$red;

});

parcelRequire.register("2XYar", function(module, exports) {

$parcel$export(module.exports, "default", () => $228fc37206d3e0db$export$2e2bcd8739ae039);
const $228fc37206d3e0db$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $228fc37206d3e0db$export$2e2bcd8739ae039 = $228fc37206d3e0db$var$orange;

});

parcelRequire.register("hxoZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc48e8508d197286$export$2e2bcd8739ae039);
const $cc48e8508d197286$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $cc48e8508d197286$export$2e2bcd8739ae039 = $cc48e8508d197286$var$blue;

});

parcelRequire.register("3Bwcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $29fdcd59f703e693$export$2e2bcd8739ae039);
const $29fdcd59f703e693$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $29fdcd59f703e693$export$2e2bcd8739ae039 = $29fdcd59f703e693$var$lightBlue;

});

parcelRequire.register("6TWA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $506551f203a25923$export$2e2bcd8739ae039);
const $506551f203a25923$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $506551f203a25923$export$2e2bcd8739ae039 = $506551f203a25923$var$green;

});


parcelRequire.register("b1ZjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $807f5ad944800d5b$export$2e2bcd8739ae039);

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $17r9Q = parcelRequire("17r9Q");
const $807f5ad944800d5b$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $807f5ad944800d5b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $807f5ad944800d5b$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $807f5ad944800d5b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $807f5ad944800d5b$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $807f5ad944800d5b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1sz44.default)(_ref, $807f5ad944800d5b$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $e8gS1.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $807f5ad944800d5b$var$defaultFontFamily ? {
            letterSpacing: `${$807f5ad944800d5b$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $807f5ad944800d5b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $807f5ad944800d5b$var$caseAllCaps)
    };
    return (0, $17r9Q.default)((0, $e8gS1.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("86vDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e676e189e322653$export$2e2bcd8739ae039);
const $5e676e189e322653$var$shadowKeyUmbraOpacity = 0.2;
const $5e676e189e322653$var$shadowKeyPenumbraOpacity = 0.14;
const $5e676e189e322653$var$shadowAmbientShadowOpacity = 0.12;
function $5e676e189e322653$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$5e676e189e322653$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $5e676e189e322653$var$shadows = [
    "none",
    $5e676e189e322653$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $5e676e189e322653$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $5e676e189e322653$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $5e676e189e322653$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $5e676e189e322653$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $5e676e189e322653$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $5e676e189e322653$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $5e676e189e322653$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $5e676e189e322653$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $5e676e189e322653$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $5e676e189e322653$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $5e676e189e322653$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $5e676e189e322653$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $5e676e189e322653$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $5e676e189e322653$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $5e676e189e322653$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $5e676e189e322653$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $5e676e189e322653$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $5e676e189e322653$export$2e2bcd8739ae039 = $5e676e189e322653$var$shadows;

});

parcelRequire.register("frp52", function(module, exports) {

$parcel$export(module.exports, "duration", () => $b3dcd50dcf07bac9$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $b3dcd50dcf07bac9$export$2e2bcd8739ae039);

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");
const $b3dcd50dcf07bac9$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $b3dcd50dcf07bac9$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $b3dcd50dcf07bac9$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3dcd50dcf07bac9$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b3dcd50dcf07bac9$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $b3dcd50dcf07bac9$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $e8gS1.default)({}, $b3dcd50dcf07bac9$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $e8gS1.default)({}, $b3dcd50dcf07bac9$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1sz44.default)(options, $b3dcd50dcf07bac9$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $b3dcd50dcf07bac9$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $b3dcd50dcf07bac9$var$formatMs(delay)}`).join(",");
    };
    return (0, $e8gS1.default)({
        getAutoHeightDuration: $b3dcd50dcf07bac9$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("8YN2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $6899f6a23f8dea0a$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $6899f6a23f8dea0a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $6899f6a23f8dea0a$export$2e2bcd8739ae039 = $6899f6a23f8dea0a$var$zIndex;

});




parcelRequire.register("1Ikg4", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", () => $13f99d5fb06222df$export$effb20ecdbf4d6aa);
$parcel$export(module.exports, "slotShouldForwardProp", () => $13f99d5fb06222df$export$f10c5a10d27438e5);
$parcel$export(module.exports, "default", () => $13f99d5fb06222df$export$2e2bcd8739ae039);

var $dNfBQ = parcelRequire("dNfBQ");

var $e7sAA = parcelRequire("e7sAA");
const $13f99d5fb06222df$export$effb20ecdbf4d6aa = (prop)=>(0, $dNfBQ.shouldForwardProp)(prop) && prop !== "classes";
const $13f99d5fb06222df$export$f10c5a10d27438e5 = (0, $dNfBQ.shouldForwardProp);
const $13f99d5fb06222df$var$styled = (0, $dNfBQ.default)({
    defaultTheme: $e7sAA.default,
    rootShouldForwardProp: $13f99d5fb06222df$export$effb20ecdbf4d6aa
});
var $13f99d5fb06222df$export$2e2bcd8739ae039 = $13f99d5fb06222df$var$styled;

});
parcelRequire.register("dNfBQ", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $a0abf5ad226c4fb0$export$3ba67b570e26eea0);
$parcel$export(module.exports, "default", () => $a0abf5ad226c4fb0$export$2e2bcd8739ae039);

var $kEIch = parcelRequire("kEIch");

var $gUrmH = parcelRequire("gUrmH");

var $bOOlK = parcelRequire("bOOlK");


var $6o2lr = parcelRequire("6o2lr");

var $2OihT = parcelRequire("2OihT");

var $9dZwz = parcelRequire("9dZwz");
const $a0abf5ad226c4fb0$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
], $a0abf5ad226c4fb0$var$_excluded2 = [
    "theme"
], $a0abf5ad226c4fb0$var$_excluded3 = [
    "theme"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0abf5ad226c4fb0$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $a0abf5ad226c4fb0$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $a0abf5ad226c4fb0$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $2OihT.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $a0abf5ad226c4fb0$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $2OihT.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $6o2lr.default)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0, styleFunctionSx: styleFunctionSx = (0, $9dZwz.default) } = input;
    const systemSx = (props)=>{
        const theme = $a0abf5ad226c4fb0$var$isEmpty(props.theme) ? defaultTheme : props.theme;
        return styleFunctionSx((0, $gUrmH.default)({}, props, {
            theme: theme
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: overridesResolver } = inputOptions, options = (0, $kEIch.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0abf5ad226c4fb0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, (0, $gUrmH.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (_ref)=>{
                    let { theme: themeInput } = _ref, other = (0, $kEIch.default)(_ref, $a0abf5ad226c4fb0$var$_excluded2);
                    return stylesArg((0, $gUrmH.default)({
                        theme: $a0abf5ad226c4fb0$var$isEmpty(themeInput) ? defaultTheme : themeInput
                    }, other));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                const styleOverrides = $a0abf5ad226c4fb0$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $gUrmH.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$isEmpty(props.theme) ? defaultTheme : props.theme;
                return $a0abf5ad226c4fb0$var$variantsResolver(props, $a0abf5ad226c4fb0$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (_ref2)=>{
                let { theme: themeInput } = _ref2, other = (0, $kEIch.default)(_ref2, $a0abf5ad226c4fb0$var$_excluded3);
                return styleArg((0, $gUrmH.default)({
                    theme: $a0abf5ad226c4fb0$var$isEmpty(themeInput) ? defaultTheme : themeInput
                }, other));
            };
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("bOOlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $89ab6b9e702438b4$export$e00380445f2b9e0c);
/** @license MUI v5.10.14
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $1Bnx5 = parcelRequire("1Bnx5");
parcelRequire("8zogs");
var $1my5K = parcelRequire("1my5K");
var $8zogs = parcelRequire("8zogs");


var $bBbjn = parcelRequire("bBbjn");
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $1Bnx5.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $89ab6b9e702438b4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("1Bnx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ab803fa905d303$export$2e2bcd8739ae039);

var $8jRlF = parcelRequire("8jRlF");
parcelRequire("9tmpp");
parcelRequire("acw62");
parcelRequire("1wfXK");

parcelRequire("2Hahg");
parcelRequire("cqnxX");
parcelRequire("2cQcJ");
var $12ab803fa905d303$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $12ab803fa905d303$export$2e2bcd8739ae039 = (0, $8jRlF.default).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$export$2e2bcd8739ae039[tagName] = $12ab803fa905d303$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("8jRlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e97af874e8cdaa$export$2e2bcd8739ae039);

var $fsVeJ = parcelRequire("fsVeJ");

var $acw62 = parcelRequire("acw62");

var $1wfXK = parcelRequire("1wfXK");
parcelRequire("8zogs");
var $1my5K = parcelRequire("1my5K");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $1wfXK.default);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $1my5K.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $1my5K.T));
            }
            if (typeof props.className === "string") className = (0, $2Hahg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $cqnxX.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $fsVeJ.default)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("fsVeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b425de8cd413f5b0$export$2e2bcd8739ae039);
function $b425de8cd413f5b0$export$2e2bcd8739ae039() {
    $b425de8cd413f5b0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b425de8cd413f5b0$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("1wfXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $11b529730d83f0a6$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
var $11b529730d83f0a6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $11b529730d83f0a6$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $11b529730d83f0a6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRequire.register("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("8zogs", function(module, exports) {

$parcel$export(module.exports, "Global", () => $63d46a01db878c10$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $63d46a01db878c10$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $63d46a01db878c10$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("1my5K")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("1my5K")).w);

var $1my5K = parcelRequire("1my5K");

var $acw62 = parcelRequire("acw62");

var $2Hahg = parcelRequire("2Hahg");

var $2cQcJ = parcelRequire("2cQcJ");

var $cqnxX = parcelRequire("cqnxX");
parcelRequire("lDTld");
parcelRequire("7x827");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $1my5K.h).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $1my5K.E);
    createElementArgArray[1] = (0, $1my5K.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $1my5K.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cqnxX.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $1my5K.T)));
    if (!(0, $1my5K.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2Hahg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cqnxX.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $2Hahg.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $1my5K.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2Hahg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $1my5K.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;

});
parcelRequire.register("1my5K", function(module, exports) {

$parcel$export(module.exports, "i", () => $0fe24a6591b39473$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $0fe24a6591b39473$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $0fe24a6591b39473$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $0fe24a6591b39473$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $0fe24a6591b39473$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $0fe24a6591b39473$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $lDTld = parcelRequire("lDTld");

var $8sAjZ = parcelRequire("8sAjZ");

var $iq6RI = parcelRequire("iq6RI");

var $kKN31 = parcelRequire("kKN31");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $lDTld.default)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $lDTld.default)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8sAjZ.default)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8sAjZ.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kKN31.default)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $2Hahg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cqnxX.serializeStyles)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;

});
parcelRequire.register("lDTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc182b1f84212d3f$export$2e2bcd8739ae039);

var $jmsCu = parcelRequire("jmsCu");

var $fm8kz = parcelRequire("fm8kz");
parcelRequire("iq6RI");
parcelRequire("9ffXE");
var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($fc182b1f84212d3f$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fm8kz.stringify),
        (0, $fm8kz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jmsCu.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("jmsCu", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e18645ac1956fbe6$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRequire.register("8sAjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $628d1cf039ec98d7$export$2e2bcd8739ae039);
function $628d1cf039ec98d7$export$2e2bcd8739ae039() {
    $628d1cf039ec98d7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $628d1cf039ec98d7$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("kKN31", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1be2661c8fac766$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("9ORqK", function(module, exports) {
"use strict";

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRequire.register("2qzd6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dNL7g"));

});



parcelRequire.register("2Hahg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1f6791d0a193b918$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1f6791d0a193b918$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1f6791d0a193b918$export$6f077d94b33a01aa);
var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("cqnxX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $90ba2da1f62e5f1b$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $bojqG = parcelRequire("bojqG");

var $9ffXE = parcelRequire("9ffXE");
var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $bojqG.default)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};

});
parcelRequire.register("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("bojqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b101df16c1118f$export$2e2bcd8739ae039);
var $84b101df16c1118f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("2cQcJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $19b532704a3a90e7$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $19b532704a3a90e7$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRequire.register("7x827", function(module, exports) {
function $57c1d8b49932598a$var$_extends() {
    module.exports = $57c1d8b49932598a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $57c1d8b49932598a$var$_extends.apply(this, arguments);
}
module.exports = $57c1d8b49932598a$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("9tmpp", function(module, exports) {
function $6e583467edc27794$var$_extends() {
    module.exports = $6e583467edc27794$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $6e583467edc27794$var$_extends.apply(this, arguments);
}
module.exports = $6e583467edc27794$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $8zogs = parcelRequire("8zogs");

var $ayMG0 = parcelRequire("ayMG0");
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8zogs.Global), {
        styles: globalStyles
    });
}

});
parcelRequire.register("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});



parcelRequire.register("2OihT", function(module, exports) {

$parcel$export(module.exports, "default", () => $20be6fcb5f4e29cd$export$2e2bcd8739ae039);

var $kEIch = parcelRequire("kEIch");

var $6IaFk = parcelRequire("6IaFk");
const $20be6fcb5f4e29cd$var$_excluded = [
    "variant"
];
function $20be6fcb5f4e29cd$var$isEmpty(string) {
    return string.length === 0;
}
function $20be6fcb5f4e29cd$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $kEIch.default)(props, $20be6fcb5f4e29cd$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $20be6fcb5f4e29cd$var$isEmpty(classKey) ? props[key] : (0, $6IaFk.default)(props[key]);
        else classKey += `${$20be6fcb5f4e29cd$var$isEmpty(classKey) ? key : (0, $6IaFk.default)(key)}${(0, $6IaFk.default)(props[key].toString())}`;
    });
    return classKey;
}

});

parcelRequire.register("9dZwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $aFh0N = parcelRequire("aFh0N");

var $7XUPs = parcelRequire("7XUPs");

var $3OJTQ = parcelRequire("3OJTQ");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013(styleFunctionMapping = (0, $7XUPs.styleFunctionMapping)) {
    const propToStyleFunction = Object.keys(styleFunctionMapping).reduce((acc, styleFnName)=>{
        styleFunctionMapping[styleFnName].filterProps.forEach((propName)=>{
            acc[propName] = styleFunctionMapping[styleFnName];
        });
        return acc;
    }, {});
    function getThemeValue(prop, value, theme) {
        const inputProps = {
            [prop]: value,
            theme: theme
        };
        const styleFunction = propToStyleFunction[prop];
        return styleFunction ? styleFunction(inputProps) : {
            [prop]: value
        };
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3OJTQ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (propToStyleFunction[styleKey]) css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme));
                        else {
                            const breakpointsValues = (0, $3OJTQ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aFh0N.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aFh0N.default)(css, getThemeValue(styleKey, value, theme));
                }
            });
            return (0, $3OJTQ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    "sx"
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRequire.register("7XUPs", function(module, exports) {

$parcel$export(module.exports, "styleFunctionMapping", () => $5cca20270cff5ebe$export$40acc74e51be579a);
$parcel$export(module.exports, "propToStyleFunction", () => $5cca20270cff5ebe$export$2ec640062268c7c4);

var $jxD4j = parcelRequire("jxD4j");

var $4e7bk = parcelRequire("4e7bk");

var $kB0gT = parcelRequire("kB0gT");

var $nZvud = parcelRequire("nZvud");

var $6rF6G = parcelRequire("6rF6G");

var $8ru1G = parcelRequire("8ru1G");

var $kYQFo = parcelRequire("kYQFo");

var $imjyU = parcelRequire("imjyU");

var $cKRCq = parcelRequire("cKRCq");

var $hc92t = parcelRequire("hc92t");
const $5cca20270cff5ebe$var$filterPropsMapping = {
    borders: (0, $jxD4j.default).filterProps,
    display: (0, $4e7bk.default).filterProps,
    flexbox: (0, $kB0gT.default).filterProps,
    grid: (0, $nZvud.default).filterProps,
    positions: (0, $6rF6G.default).filterProps,
    palette: (0, $8ru1G.default).filterProps,
    shadows: (0, $kYQFo.default).filterProps,
    sizing: (0, $imjyU.default).filterProps,
    spacing: (0, $cKRCq.default).filterProps,
    typography: (0, $hc92t.default).filterProps
};
const $5cca20270cff5ebe$export$40acc74e51be579a = {
    borders: $jxD4j.default,
    display: $4e7bk.default,
    flexbox: $kB0gT.default,
    grid: $nZvud.default,
    positions: $6rF6G.default,
    palette: $8ru1G.default,
    shadows: $kYQFo.default,
    sizing: $imjyU.default,
    spacing: $cKRCq.default,
    typography: $hc92t.default
};
const $5cca20270cff5ebe$export$2ec640062268c7c4 = Object.keys($5cca20270cff5ebe$var$filterPropsMapping).reduce((acc, styleFnName)=>{
    $5cca20270cff5ebe$var$filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = $5cca20270cff5ebe$export$40acc74e51be579a[styleFnName];
    });
    return acc;
}, {});
function $5cca20270cff5ebe$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $5cca20270cff5ebe$export$2ec640062268c7c4[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $5cca20270cff5ebe$export$2e2bcd8739ae039 = $5cca20270cff5ebe$var$getThemeValue;

});
parcelRequire.register("jxD4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39f6794db8cf9ac$export$2e2bcd8739ae039);


var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");
function $e39f6794db8cf9ac$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = (0, $k0igC.default)({
    prop: "border",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = (0, $k0igC.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = (0, $k0igC.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = (0, $k0igC.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$47658cca1a909427 = (0, $k0igC.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$var$getBorder
});
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = (0, $k0igC.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$126a92c968acdb85 = (0, $k0igC.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = (0, $k0igC.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$340b0327727f6d1a = (0, $k0igC.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$60beef91a985b4bf = (0, $k0igC.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $e39f6794db8cf9ac$var$borders = (0, $gojsU.default)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;

});
parcelRequire.register("gojsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $beedfc9d7e65f133$export$2e2bcd8739ae039);

var $aFh0N = parcelRequire("aFh0N");
function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aFh0N.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;

});


parcelRequire.register("4e7bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $313e0a591bf5b524$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
const $313e0a591bf5b524$export$95a5c40fb210fe3e = (0, $k0igC.default)({
    prop: "displayPrint",
    cssProperty: false,
    transform: (value)=>({
            "@media print": {
                display: value
            }
        })
});
const $313e0a591bf5b524$export$e5efd59aba9975ad = (0, $k0igC.default)({
    prop: "display"
});
const $313e0a591bf5b524$export$f6530fb6e67e00bd = (0, $k0igC.default)({
    prop: "overflow"
});
const $313e0a591bf5b524$export$f00f69a6f0e8c5b6 = (0, $k0igC.default)({
    prop: "textOverflow"
});
const $313e0a591bf5b524$export$91fa9ac3f4021ce4 = (0, $k0igC.default)({
    prop: "visibility"
});
const $313e0a591bf5b524$export$9ef81298ca34ad41 = (0, $k0igC.default)({
    prop: "whiteSpace"
});
var $313e0a591bf5b524$export$2e2bcd8739ae039 = (0, $gojsU.default)($313e0a591bf5b524$export$95a5c40fb210fe3e, $313e0a591bf5b524$export$e5efd59aba9975ad, $313e0a591bf5b524$export$f6530fb6e67e00bd, $313e0a591bf5b524$export$f00f69a6f0e8c5b6, $313e0a591bf5b524$export$91fa9ac3f4021ce4, $313e0a591bf5b524$export$9ef81298ca34ad41);

});

parcelRequire.register("kB0gT", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe77942e9a45ffa$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
const $efe77942e9a45ffa$export$d2ad290394bbc49d = (0, $k0igC.default)({
    prop: "flexBasis"
});
const $efe77942e9a45ffa$export$84c3c16c9ed6c908 = (0, $k0igC.default)({
    prop: "flexDirection"
});
const $efe77942e9a45ffa$export$9a4bcd01f5c204bc = (0, $k0igC.default)({
    prop: "flexWrap"
});
const $efe77942e9a45ffa$export$8dea3061ba53bfd1 = (0, $k0igC.default)({
    prop: "justifyContent"
});
const $efe77942e9a45ffa$export$898d9006406726bd = (0, $k0igC.default)({
    prop: "alignItems"
});
const $efe77942e9a45ffa$export$38c32c6918694134 = (0, $k0igC.default)({
    prop: "alignContent"
});
const $efe77942e9a45ffa$export$aaaeab0fac9a3ccb = (0, $k0igC.default)({
    prop: "order"
});
const $efe77942e9a45ffa$export$97691fbb80847c19 = (0, $k0igC.default)({
    prop: "flex"
});
const $efe77942e9a45ffa$export$36c65c169152373d = (0, $k0igC.default)({
    prop: "flexGrow"
});
const $efe77942e9a45ffa$export$2670ac60b02109d2 = (0, $k0igC.default)({
    prop: "flexShrink"
});
const $efe77942e9a45ffa$export$4545dd3632cb520b = (0, $k0igC.default)({
    prop: "alignSelf"
});
const $efe77942e9a45ffa$export$55e6b7a7f0eaa3ff = (0, $k0igC.default)({
    prop: "justifyItems"
});
const $efe77942e9a45ffa$export$d012640ac9a6446f = (0, $k0igC.default)({
    prop: "justifySelf"
});
const $efe77942e9a45ffa$var$flexbox = (0, $gojsU.default)($efe77942e9a45ffa$export$d2ad290394bbc49d, $efe77942e9a45ffa$export$84c3c16c9ed6c908, $efe77942e9a45ffa$export$9a4bcd01f5c204bc, $efe77942e9a45ffa$export$8dea3061ba53bfd1, $efe77942e9a45ffa$export$898d9006406726bd, $efe77942e9a45ffa$export$38c32c6918694134, $efe77942e9a45ffa$export$aaaeab0fac9a3ccb, $efe77942e9a45ffa$export$97691fbb80847c19, $efe77942e9a45ffa$export$36c65c169152373d, $efe77942e9a45ffa$export$2670ac60b02109d2, $efe77942e9a45ffa$export$4545dd3632cb520b, $efe77942e9a45ffa$export$55e6b7a7f0eaa3ff, $efe77942e9a45ffa$export$d012640ac9a6446f);
var $efe77942e9a45ffa$export$2e2bcd8739ae039 = $efe77942e9a45ffa$var$flexbox;

});

parcelRequire.register("nZvud", function(module, exports) {

$parcel$export(module.exports, "default", () => $0481dc1348188242$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $cKRCq = parcelRequire("cKRCq");

var $3OJTQ = parcelRequire("3OJTQ");

const $0481dc1348188242$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$5df9adcb0db95e1e.propTypes = {};
$0481dc1348188242$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $0481dc1348188242$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$ec60d70ff941a580.propTypes = {};
$0481dc1348188242$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $0481dc1348188242$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $cKRCq.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $cKRCq.getValue)(transformer, propValue)
            });
        return (0, $3OJTQ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$8a833ffa5f5dbeda.propTypes = {};
$0481dc1348188242$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $0481dc1348188242$export$baf44164ca3a34e8 = (0, $k0igC.default)({
    prop: "gridColumn"
});
const $0481dc1348188242$export$8f7213a1cd01e832 = (0, $k0igC.default)({
    prop: "gridRow"
});
const $0481dc1348188242$export$b0e0abbc49ba668 = (0, $k0igC.default)({
    prop: "gridAutoFlow"
});
const $0481dc1348188242$export$bcd8b929d4b4142 = (0, $k0igC.default)({
    prop: "gridAutoColumns"
});
const $0481dc1348188242$export$e5039a674e14c828 = (0, $k0igC.default)({
    prop: "gridAutoRows"
});
const $0481dc1348188242$export$42bd9088661ffb03 = (0, $k0igC.default)({
    prop: "gridTemplateColumns"
});
const $0481dc1348188242$export$920682ae05b999bc = (0, $k0igC.default)({
    prop: "gridTemplateRows"
});
const $0481dc1348188242$export$1b88fbdd482fd33a = (0, $k0igC.default)({
    prop: "gridTemplateAreas"
});
const $0481dc1348188242$export$bdb486e40d52d26f = (0, $k0igC.default)({
    prop: "gridArea"
});
const $0481dc1348188242$var$grid = (0, $gojsU.default)($0481dc1348188242$export$5df9adcb0db95e1e, $0481dc1348188242$export$ec60d70ff941a580, $0481dc1348188242$export$8a833ffa5f5dbeda, $0481dc1348188242$export$baf44164ca3a34e8, $0481dc1348188242$export$8f7213a1cd01e832, $0481dc1348188242$export$b0e0abbc49ba668, $0481dc1348188242$export$bcd8b929d4b4142, $0481dc1348188242$export$e5039a674e14c828, $0481dc1348188242$export$42bd9088661ffb03, $0481dc1348188242$export$920682ae05b999bc, $0481dc1348188242$export$1b88fbdd482fd33a, $0481dc1348188242$export$bdb486e40d52d26f);
var $0481dc1348188242$export$2e2bcd8739ae039 = $0481dc1348188242$var$grid;

});

parcelRequire.register("6rF6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1526a666784d7b$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
const $4b1526a666784d7b$export$5880b8b5730aff45 = (0, $k0igC.default)({
    prop: "position"
});
const $4b1526a666784d7b$export$56446adcecbeec34 = (0, $k0igC.default)({
    prop: "zIndex",
    themeKey: "zIndex"
});
const $4b1526a666784d7b$export$1e95b668f3b82d = (0, $k0igC.default)({
    prop: "top"
});
const $4b1526a666784d7b$export$79ffe56a765070d2 = (0, $k0igC.default)({
    prop: "right"
});
const $4b1526a666784d7b$export$40e543e69a8b3fbb = (0, $k0igC.default)({
    prop: "bottom"
});
const $4b1526a666784d7b$export$eabcd2c8791e7bf4 = (0, $k0igC.default)({
    prop: "left"
});
var $4b1526a666784d7b$export$2e2bcd8739ae039 = (0, $gojsU.default)($4b1526a666784d7b$export$5880b8b5730aff45, $4b1526a666784d7b$export$56446adcecbeec34, $4b1526a666784d7b$export$1e95b668f3b82d, $4b1526a666784d7b$export$79ffe56a765070d2, $4b1526a666784d7b$export$40e543e69a8b3fbb, $4b1526a666784d7b$export$eabcd2c8791e7bf4);

});

parcelRequire.register("8ru1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $625822e5d7cce21a$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
function $625822e5d7cce21a$var$transform(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $625822e5d7cce21a$export$35e9368ef982300f = (0, $k0igC.default)({
    prop: "color",
    themeKey: "palette",
    transform: $625822e5d7cce21a$var$transform
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $k0igC.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $625822e5d7cce21a$var$transform
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $k0igC.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $625822e5d7cce21a$var$transform
});
const $625822e5d7cce21a$var$palette = (0, $gojsU.default)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;

});

parcelRequire.register("kYQFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f46243bac80ca856$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");
const $f46243bac80ca856$var$boxShadow = (0, $k0igC.default)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $f46243bac80ca856$export$2e2bcd8739ae039 = $f46243bac80ca856$var$boxShadow;

});

parcelRequire.register("imjyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d974b5976c38ad$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");

var $3OJTQ = parcelRequire("3OJTQ");
function $d5d974b5976c38ad$var$transform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $k0igC.default)({
    prop: "width",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $3OJTQ.values)[propValue];
            return {
                maxWidth: breakpoint || $d5d974b5976c38ad$var$transform(propValue)
            };
        };
        return (0, $3OJTQ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $k0igC.default)({
    prop: "minWidth",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $k0igC.default)({
    prop: "height",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $k0igC.default)({
    prop: "maxHeight",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $k0igC.default)({
    prop: "minHeight",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $k0igC.default)({
    prop: "size",
    cssProperty: "width",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $k0igC.default)({
    prop: "size",
    cssProperty: "height",
    transform: $d5d974b5976c38ad$var$transform
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $k0igC.default)({
    prop: "boxSizing"
});
const $d5d974b5976c38ad$var$sizing = (0, $gojsU.default)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;

});

parcelRequire.register("hc92t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84a9198f57b593d$export$2e2bcd8739ae039);

var $k0igC = parcelRequire("k0igC");

var $gojsU = parcelRequire("gojsU");
const $c84a9198f57b593d$export$a5975749f0374264 = (0, $k0igC.default)({
    prop: "fontFamily",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$85e3c3ca0c6fb93 = (0, $k0igC.default)({
    prop: "fontSize",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$a827189a08c5a3a3 = (0, $k0igC.default)({
    prop: "fontStyle",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$bc0b29e67df3229e = (0, $k0igC.default)({
    prop: "fontWeight",
    themeKey: "typography"
});
const $c84a9198f57b593d$export$3eb52878e4502ad1 = (0, $k0igC.default)({
    prop: "letterSpacing"
});
const $c84a9198f57b593d$export$d1b52fec4405b471 = (0, $k0igC.default)({
    prop: "textTransform"
});
const $c84a9198f57b593d$export$c9b91427b594e14 = (0, $k0igC.default)({
    prop: "lineHeight"
});
const $c84a9198f57b593d$export$a87999391cd10ae9 = (0, $k0igC.default)({
    prop: "textAlign"
});
const $c84a9198f57b593d$export$60b2982fc282cca6 = (0, $k0igC.default)({
    prop: "typography",
    cssProperty: false,
    themeKey: "typography"
});
const $c84a9198f57b593d$var$typography = (0, $gojsU.default)($c84a9198f57b593d$export$60b2982fc282cca6, $c84a9198f57b593d$export$a5975749f0374264, $c84a9198f57b593d$export$85e3c3ca0c6fb93, $c84a9198f57b593d$export$a827189a08c5a3a3, $c84a9198f57b593d$export$bc0b29e67df3229e, $c84a9198f57b593d$export$3eb52878e4502ad1, $c84a9198f57b593d$export$c9b91427b594e14, $c84a9198f57b593d$export$a87999391cd10ae9, $c84a9198f57b593d$export$d1b52fec4405b471);
var $c84a9198f57b593d$export$2e2bcd8739ae039 = $c84a9198f57b593d$var$typography;

});





parcelRequire.register("6LnsB", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $4ec9549e6ca0a145$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec9549e6ca0a145$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)("MuiSvgIcon", slot);
}
const $4ec9549e6ca0a145$var$svgIconClasses = (0, $beCSm.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $4ec9549e6ca0a145$export$2e2bcd8739ae039 = $4ec9549e6ca0a145$var$svgIconClasses;

});
parcelRequire.register("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $35cd7d64717698f7$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});







parcelRequire.register("cSJDD", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $960dedfd64f242ab$export$a7c73072b1a182ae, (v) => $960dedfd64f242ab$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $960dedfd64f242ab$export$9f27bc3417b4524d, (v) => $960dedfd64f242ab$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $960dedfd64f242ab$export$db77ccec0bb4ccac, (v) => $960dedfd64f242ab$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $960dedfd64f242ab$export$8392c0c9d3dcbd35, (v) => $960dedfd64f242ab$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $960dedfd64f242ab$export$ffb0004e005737fa, (v) => $960dedfd64f242ab$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $960dedfd64f242ab$export$b624eff549462981, (v) => $960dedfd64f242ab$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $960dedfd64f242ab$export$7897aa7841a5380c, (v) => $960dedfd64f242ab$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $960dedfd64f242ab$export$602eac185826482c, (v) => $960dedfd64f242ab$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $960dedfd64f242ab$export$e2c29f18771995cb, (v) => $960dedfd64f242ab$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $960dedfd64f242ab$export$5f8d39834fd61797, (v) => $960dedfd64f242ab$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $960dedfd64f242ab$export$74bf444e3cd11ea5, (v) => $960dedfd64f242ab$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $960dedfd64f242ab$export$998bcd577473dd93, (v) => $960dedfd64f242ab$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $960dedfd64f242ab$export$92387174baf9b227, (v) => $960dedfd64f242ab$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $960dedfd64f242ab$export$ec112efeb987d9c6, (v) => $960dedfd64f242ab$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $960dedfd64f242ab$export$b706b080d889d2c9, (v) => $960dedfd64f242ab$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $960dedfd64f242ab$export$5be5a87408f70ddc, (v) => $960dedfd64f242ab$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $960dedfd64f242ab$export$45a5e7f76e0caa8d, (v) => $960dedfd64f242ab$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $960dedfd64f242ab$export$455c2e768291efa6, (v) => $960dedfd64f242ab$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $960dedfd64f242ab$export$9522e17588c12572, (v) => $960dedfd64f242ab$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $960dedfd64f242ab$export$2110ac352bb060b9, (v) => $960dedfd64f242ab$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $960dedfd64f242ab$export$56885ab8b9c456ab, (v) => $960dedfd64f242ab$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $960dedfd64f242ab$export$d927fcb6adf8f9de, (v) => $960dedfd64f242ab$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $960dedfd64f242ab$export$b82d16f27459e05a, (v) => $960dedfd64f242ab$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $960dedfd64f242ab$export$522c17b4f5e123e8, (v) => $960dedfd64f242ab$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $960dedfd64f242ab$export$1aabd8a0274ecfd6, (v) => $960dedfd64f242ab$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $960dedfd64f242ab$export$3d6c20d97e46b957, (v) => $960dedfd64f242ab$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $960dedfd64f242ab$export$9b621391a187a31a, (v) => $960dedfd64f242ab$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $960dedfd64f242ab$export$f5bbd400c2f4426f, (v) => $960dedfd64f242ab$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $960dedfd64f242ab$export$a7c73072b1a182ae;
var $960dedfd64f242ab$export$9f27bc3417b4524d;
var $960dedfd64f242ab$export$db77ccec0bb4ccac;
var $960dedfd64f242ab$export$8392c0c9d3dcbd35;
var $960dedfd64f242ab$export$ffb0004e005737fa;
var $960dedfd64f242ab$export$b624eff549462981;
var $960dedfd64f242ab$export$7897aa7841a5380c;
var $960dedfd64f242ab$export$602eac185826482c;
var $960dedfd64f242ab$export$e2c29f18771995cb;
var $960dedfd64f242ab$export$5f8d39834fd61797;
var $960dedfd64f242ab$export$74bf444e3cd11ea5;
var $960dedfd64f242ab$export$998bcd577473dd93;
var $960dedfd64f242ab$export$92387174baf9b227;
var $960dedfd64f242ab$export$ec112efeb987d9c6;
var $960dedfd64f242ab$export$b706b080d889d2c9;
var $960dedfd64f242ab$export$5be5a87408f70ddc;
var $960dedfd64f242ab$export$45a5e7f76e0caa8d;
var $960dedfd64f242ab$export$455c2e768291efa6;
var $960dedfd64f242ab$export$9522e17588c12572;
var $960dedfd64f242ab$export$2110ac352bb060b9;
var $960dedfd64f242ab$export$56885ab8b9c456ab;
var $960dedfd64f242ab$export$d927fcb6adf8f9de;
var $960dedfd64f242ab$export$b82d16f27459e05a;
var $960dedfd64f242ab$export$522c17b4f5e123e8;
var $960dedfd64f242ab$export$1aabd8a0274ecfd6;
var $960dedfd64f242ab$export$3d6c20d97e46b957;
var $960dedfd64f242ab$export$9b621391a187a31a;
var $960dedfd64f242ab$export$f5bbd400c2f4426f;
"use strict";
var $960dedfd64f242ab$var$b = Symbol.for("react.element"), $960dedfd64f242ab$var$c = Symbol.for("react.portal"), $960dedfd64f242ab$var$d = Symbol.for("react.fragment"), $960dedfd64f242ab$var$e = Symbol.for("react.strict_mode"), $960dedfd64f242ab$var$f = Symbol.for("react.profiler"), $960dedfd64f242ab$var$g = Symbol.for("react.provider"), $960dedfd64f242ab$var$h = Symbol.for("react.context"), $960dedfd64f242ab$var$k = Symbol.for("react.server_context"), $960dedfd64f242ab$var$l = Symbol.for("react.forward_ref"), $960dedfd64f242ab$var$m = Symbol.for("react.suspense"), $960dedfd64f242ab$var$n = Symbol.for("react.suspense_list"), $960dedfd64f242ab$var$p = Symbol.for("react.memo"), $960dedfd64f242ab$var$q = Symbol.for("react.lazy"), $960dedfd64f242ab$var$t = Symbol.for("react.offscreen"), $960dedfd64f242ab$var$u;
$960dedfd64f242ab$var$u = Symbol.for("react.module.reference");
function $960dedfd64f242ab$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $960dedfd64f242ab$var$b:
                switch(a = a.type, a){
                    case $960dedfd64f242ab$var$d:
                    case $960dedfd64f242ab$var$f:
                    case $960dedfd64f242ab$var$e:
                    case $960dedfd64f242ab$var$m:
                    case $960dedfd64f242ab$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $960dedfd64f242ab$var$k:
                            case $960dedfd64f242ab$var$h:
                            case $960dedfd64f242ab$var$l:
                            case $960dedfd64f242ab$var$q:
                            case $960dedfd64f242ab$var$p:
                            case $960dedfd64f242ab$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $960dedfd64f242ab$var$c:
                return r;
        }
    }
}
$960dedfd64f242ab$export$a7c73072b1a182ae = $960dedfd64f242ab$var$h;
$960dedfd64f242ab$export$9f27bc3417b4524d = $960dedfd64f242ab$var$g;
$960dedfd64f242ab$export$db77ccec0bb4ccac = $960dedfd64f242ab$var$b;
$960dedfd64f242ab$export$8392c0c9d3dcbd35 = $960dedfd64f242ab$var$l;
$960dedfd64f242ab$export$ffb0004e005737fa = $960dedfd64f242ab$var$d;
$960dedfd64f242ab$export$b624eff549462981 = $960dedfd64f242ab$var$q;
$960dedfd64f242ab$export$7897aa7841a5380c = $960dedfd64f242ab$var$p;
$960dedfd64f242ab$export$602eac185826482c = $960dedfd64f242ab$var$c;
$960dedfd64f242ab$export$e2c29f18771995cb = $960dedfd64f242ab$var$f;
$960dedfd64f242ab$export$5f8d39834fd61797 = $960dedfd64f242ab$var$e;
$960dedfd64f242ab$export$74bf444e3cd11ea5 = $960dedfd64f242ab$var$m;
$960dedfd64f242ab$export$998bcd577473dd93 = $960dedfd64f242ab$var$n;
$960dedfd64f242ab$export$92387174baf9b227 = function() {
    return !1;
};
$960dedfd64f242ab$export$ec112efeb987d9c6 = function() {
    return !1;
};
$960dedfd64f242ab$export$b706b080d889d2c9 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$h;
};
$960dedfd64f242ab$export$5be5a87408f70ddc = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$g;
};
$960dedfd64f242ab$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $960dedfd64f242ab$var$b;
};
$960dedfd64f242ab$export$455c2e768291efa6 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$l;
};
$960dedfd64f242ab$export$9522e17588c12572 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$d;
};
$960dedfd64f242ab$export$2110ac352bb060b9 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$q;
};
$960dedfd64f242ab$export$56885ab8b9c456ab = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$p;
};
$960dedfd64f242ab$export$d927fcb6adf8f9de = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$c;
};
$960dedfd64f242ab$export$b82d16f27459e05a = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$f;
};
$960dedfd64f242ab$export$522c17b4f5e123e8 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$e;
};
$960dedfd64f242ab$export$1aabd8a0274ecfd6 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$m;
};
$960dedfd64f242ab$export$3d6c20d97e46b957 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$n;
};
$960dedfd64f242ab$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $960dedfd64f242ab$var$d || a === $960dedfd64f242ab$var$f || a === $960dedfd64f242ab$var$e || a === $960dedfd64f242ab$var$m || a === $960dedfd64f242ab$var$n || a === $960dedfd64f242ab$var$t || "object" === typeof a && null !== a && (a.$$typeof === $960dedfd64f242ab$var$q || a.$$typeof === $960dedfd64f242ab$var$p || a.$$typeof === $960dedfd64f242ab$var$g || a.$$typeof === $960dedfd64f242ab$var$h || a.$$typeof === $960dedfd64f242ab$var$l || a.$$typeof === $960dedfd64f242ab$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$960dedfd64f242ab$export$f5bbd400c2f4426f = $960dedfd64f242ab$var$v;

});

parcelRequire.register("7SR5F", function(module, exports) {

var $4QOjN = parcelRequire("4QOjN");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $4QOjN.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === "string") try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === "object") payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRequire.register("4QOjN", function(module, exports) {

$parcel$export(module.exports, "sign", () => $38830cf000cd4d7c$export$c5552dfdbc7cec71, (v) => $38830cf000cd4d7c$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "verify", () => $38830cf000cd4d7c$export$532244b5b8b0b4b6, (v) => $38830cf000cd4d7c$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "decode", () => $38830cf000cd4d7c$export$2f872c0f2117be69, (v) => $38830cf000cd4d7c$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "createSign", () => $38830cf000cd4d7c$export$45df7cae684751af, (v) => $38830cf000cd4d7c$export$45df7cae684751af = v);
/*global exports*/ var $38830cf000cd4d7c$export$6f6fa4628974a579;
var $38830cf000cd4d7c$export$c5552dfdbc7cec71;
var $38830cf000cd4d7c$export$532244b5b8b0b4b6;
var $38830cf000cd4d7c$export$2f872c0f2117be69;
var $38830cf000cd4d7c$export$1ea939691cdc45b8;
var $38830cf000cd4d7c$export$45df7cae684751af;
var $38830cf000cd4d7c$export$6f65485f87568e37;

var $1KBFA = parcelRequire("1KBFA");

var $jVVQU = parcelRequire("jVVQU");
var $38830cf000cd4d7c$var$ALGORITHMS = [
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
];
$38830cf000cd4d7c$export$6f6fa4628974a579 = $38830cf000cd4d7c$var$ALGORITHMS;
$38830cf000cd4d7c$export$c5552dfdbc7cec71 = $1KBFA.sign;
$38830cf000cd4d7c$export$532244b5b8b0b4b6 = $jVVQU.verify;
$38830cf000cd4d7c$export$2f872c0f2117be69 = $jVVQU.decode;
$38830cf000cd4d7c$export$1ea939691cdc45b8 = $jVVQU.isValid;
$38830cf000cd4d7c$export$45df7cae684751af = function createSign(opts) {
    return new $1KBFA(opts);
};
$38830cf000cd4d7c$export$6f65485f87568e37 = function createVerify(opts) {
    return new $jVVQU(opts);
};

});
parcelRequire.register("1KBFA", function(module, exports) {
/*global module*/ 
var $1U9GM = parcelRequire("1U9GM");
var $14674ebf784babdc$require$Buffer = $1U9GM.Buffer;

var $8prZJ = parcelRequire("8prZJ");

var $f2m41 = parcelRequire("f2m41");

var $ioRHp = parcelRequire("ioRHp");

var $1vKm0 = parcelRequire("1vKm0");

var $N7Lcz = parcelRequire("N7Lcz");
function $14674ebf784babdc$var$base64url(string, encoding) {
    return $14674ebf784babdc$require$Buffer.from(string, encoding).toString("base64").replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $14674ebf784babdc$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || "utf8";
    var encodedHeader = $14674ebf784babdc$var$base64url($1vKm0(header), "binary");
    var encodedPayload = $14674ebf784babdc$var$base64url($1vKm0(payload), encoding);
    return $N7Lcz.format("%s.%s", encodedHeader, encodedPayload);
}
function $14674ebf784babdc$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $f2m41(header.alg);
    var securedInput = $14674ebf784babdc$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $N7Lcz.format("%s.%s", securedInput, signature);
}
function $14674ebf784babdc$var$SignStream(opts) {
    var secret = opts.secret || opts.privateKey || opts.key;
    var secretStream = new $8prZJ(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $8prZJ(opts.payload);
    this.secret.once("close", (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once("close", (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$N7Lcz.inherits($14674ebf784babdc$var$SignStream, $ioRHp);
$14674ebf784babdc$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $14674ebf784babdc$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit("done", signature);
        this.emit("data", signature);
        this.emit("end");
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit("error", e);
        this.emit("close");
    }
};
$14674ebf784babdc$var$SignStream.sign = $14674ebf784babdc$var$jwsSign;
module.exports = $14674ebf784babdc$var$SignStream;

});
parcelRequire.register("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRequire.register("8prZJ", function(module, exports) {
/*global module, process*/ 
var $hPtJY = parcelRequire("hPtJY");

var $1U9GM = parcelRequire("1U9GM");
var $61f65fb5a1a8c380$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");

var $N7Lcz = parcelRequire("N7Lcz");
function $61f65fb5a1a8c380$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $61f65fb5a1a8c380$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === "function") {
        this.buffer = $61f65fb5a1a8c380$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === "object") {
        this.buffer = data;
        this.writable = false;
        $hPtJY.nextTick((function() {
            this.emit("end", data);
            this.readable = false;
            this.emit("close");
        }).bind(this));
        return this;
    }
    throw new TypeError("Unexpected data type (" + typeof data + ")");
}
$N7Lcz.inherits($61f65fb5a1a8c380$var$DataStream, $ioRHp);
$61f65fb5a1a8c380$var$DataStream.prototype.write = function write(data) {
    this.buffer = $61f65fb5a1a8c380$require$Buffer.concat([
        this.buffer,
        $61f65fb5a1a8c380$require$Buffer.from(data)
    ]);
    this.emit("data", data);
};
$61f65fb5a1a8c380$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit("end", data);
    this.emit("close");
    this.writable = false;
    this.readable = false;
};
module.exports = $61f65fb5a1a8c380$var$DataStream;

});
parcelRequire.register("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRequire.register("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRequire.register("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog("stream");
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug("ondata");
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, "error") === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug("on readable", state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self) {
    $7b84d2ca8f0d8afd$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $7b84d2ca8f0d8afd$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $7b84d2ca8f0d8afd$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});

parcelRequire.register("6aKSQ", function(module, exports) {
"use strict";
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $47e80b5d1f4ca857$var$ownKeys(Object(source), true).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || "inspect";
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRequire.register("5yyyA", function(module, exports) {
"use strict";

var $967Aq = parcelRequire("967Aq");
var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = $967Aq.codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRequire.register("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
"use strict";
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $69fa8f23fe6fc7e7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRequire.register("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, "buffer", {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jJj7p.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRequire.register("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol("lastResolve");
var $25a99ede456543b7$var$kLastReject = Symbol("lastReject");
var $25a99ede456543b7$var$kError = Symbol("error");
var $25a99ede456543b7$var$kEnded = Symbol("ended");
var $25a99ede456543b7$var$kLastPromise = Symbol("lastPromise");
var $25a99ede456543b7$var$kHandlePromise = Symbol("handlePromise");
var $25a99ede456543b7$var$kStream = Symbol("stream");
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$25a99ede456543b7$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on("readable", $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $967Aq = parcelRequire("967Aq");
var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = $967Aq.codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRequire.register("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});


parcelRequire.register("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += " " + x;
    else str += " " + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $hPtJY !== "undefined" && $hPtJY.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $hPtJY === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $093a98c17cb6b6b8$var$inspect.colors[style][1] + "m";
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = " " + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize("null", "null");
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRequire.register("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $iQb1G = parcelRequire("iQb1G");

var $24ePj = parcelRequire("24ePj");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== "undefined";
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== "undefined";
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $24ePj;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $24ePj(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $iQb1G(value) === "Uint8Array";
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $iQb1G(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $iQb1G(value) === "Uint16Array";
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $iQb1G(value) === "Uint32Array";
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $iQb1G(value) === "Int8Array";
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $iQb1G(value) === "Int16Array";
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $iQb1G(value) === "Int32Array";
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $iQb1G(value) === "Float32Array";
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $iQb1G(value) === "Float64Array";
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $iQb1G(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $iQb1G(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map]";
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== "undefined" && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set]";
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== "undefined" && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakMap]";
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WeakSet]";
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object DataView]";
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === "undefined") $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRequire.register("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRequire.register("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $1258b452ecf218a1$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $1258b452ecf218a1$var$undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $1258b452ecf218a1$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $1258b452ecf218a1$var$undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $1258b452ecf218a1$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $1258b452ecf218a1$var$undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : $1258b452ecf218a1$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $1258b452ecf218a1$var$undefined,
    "%Map%": typeof Map === "undefined" ? $1258b452ecf218a1$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $1258b452ecf218a1$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $1258b452ecf218a1$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $1258b452ecf218a1$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $1258b452ecf218a1$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : $1258b452ecf218a1$var$undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $1258b452ecf218a1$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $1258b452ecf218a1$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $1258b452ecf218a1$var$undefined : WeakSet
};
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $8aKn2 = parcelRequire("8aKn2");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8aKn2($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8aKn2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRequire.register("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRequire.register("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$slice = Array.prototype.slice;
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.call(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("8aKn2", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");
module.exports = $gvair.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    if ($9546dce5bd4976bd$var$$gOPD && $9546dce5bd4976bd$var$$defineProperty) {
        var desc = $9546dce5bd4976bd$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $9546dce5bd4976bd$var$$defineProperty(func, "length", {
            value: 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});



parcelRequire.register("5WnCa", function(module, exports) {
"use strict";
var $4534afe844d627e4$var$toStr = Object.prototype.toString;
var $4534afe844d627e4$var$fnToStr = Function.prototype.toString;
var $4534afe844d627e4$var$isFnRegex = /^\s*(?:function)?\*/;

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $4534afe844d627e4$var$getProto = Object.getPrototypeOf;
var $4534afe844d627e4$var$getGeneratorFunc = function() {
    if (!$4534afe844d627e4$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4534afe844d627e4$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4534afe844d627e4$var$isFnRegex.test($4534afe844d627e4$var$fnToStr.call(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4534afe844d627e4$var$getProto) return false;
    if (typeof $4534afe844d627e4$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4534afe844d627e4$var$getGeneratorFunc();
        $4534afe844d627e4$var$GeneratorFunction = generatorFunc ? $4534afe844d627e4$var$getProto(generatorFunc) : false;
    }
    return $4534afe844d627e4$var$getProto(fn) === $4534afe844d627e4$var$GeneratorFunction;
};

});

parcelRequire.register("iQb1G", function(module, exports) {
"use strict";

var $1n2vj = parcelRequire("1n2vj");

var $8yXCr = parcelRequire("8yXCr");

var $hXu6F = parcelRequire("hXu6F");
var $db75a2e6e011faed$var$$toString = $hXu6F("Object.prototype.toString");

var $db75a2e6e011faed$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $db75a2e6e011faed$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $db75a2e6e011faed$var$typedArrays = $8yXCr();
var $db75a2e6e011faed$var$$slice = $hXu6F("String.prototype.slice");
var $db75a2e6e011faed$var$toStrTags = {};

var $6SeTG = parcelRequire("6SeTG");
var $db75a2e6e011faed$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($db75a2e6e011faed$var$hasToStringTag && $6SeTG && $db75a2e6e011faed$var$getPrototypeOf) $1n2vj($db75a2e6e011faed$var$typedArrays, function(typedArray) {
    if (typeof $db75a2e6e011faed$var$g[typedArray] === "function") {
        var arr = new $db75a2e6e011faed$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $db75a2e6e011faed$var$getPrototypeOf(arr);
            var descriptor = $6SeTG(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $db75a2e6e011faed$var$getPrototypeOf(proto);
                descriptor = $6SeTG(superProto, Symbol.toStringTag);
            }
            $db75a2e6e011faed$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $db75a2e6e011faed$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $1n2vj($db75a2e6e011faed$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $24ePj = parcelRequire("24ePj");
module.exports = function whichTypedArray(value) {
    if (!$24ePj(value)) return false;
    if (!$db75a2e6e011faed$var$hasToStringTag || !(Symbol.toStringTag in value)) return $db75a2e6e011faed$var$$slice($db75a2e6e011faed$var$$toString(value), 8, -1);
    return $db75a2e6e011faed$var$tryTypedArrays(value);
};

});
parcelRequire.register("1n2vj", function(module, exports) {
var $0ff9e1aaf16a50e1$var$hasOwn = Object.prototype.hasOwnProperty;
var $0ff9e1aaf16a50e1$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($0ff9e1aaf16a50e1$var$toString.call(fn) !== "[object Function]") throw new TypeError("iterator must be a function");
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($0ff9e1aaf16a50e1$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});

parcelRequire.register("8yXCr", function(module, exports) {
"use strict";
var $63bfbecf41903c8f$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $63bfbecf41903c8f$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $63bfbecf41903c8f$var$possibleNames.length; i++)if (typeof $63bfbecf41903c8f$var$g[$63bfbecf41903c8f$var$possibleNames[i]] === "function") out[out.length] = $63bfbecf41903c8f$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("6SeTG", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $5013578038c7b048$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($5013578038c7b048$var$$gOPD) try {
    $5013578038c7b048$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $5013578038c7b048$var$$gOPD = null;
}
module.exports = $5013578038c7b048$var$$gOPD;

});

parcelRequire.register("24ePj", function(module, exports) {
"use strict";

var $1n2vj = parcelRequire("1n2vj");

var $8yXCr = parcelRequire("8yXCr");

var $hXu6F = parcelRequire("hXu6F");
var $181774c36689bc69$var$$toString = $hXu6F("Object.prototype.toString");

var $181774c36689bc69$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $181774c36689bc69$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $181774c36689bc69$var$typedArrays = $8yXCr();
var $181774c36689bc69$var$$indexOf = $hXu6F("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $181774c36689bc69$var$$slice = $hXu6F("String.prototype.slice");
var $181774c36689bc69$var$toStrTags = {};

var $6SeTG = parcelRequire("6SeTG");
var $181774c36689bc69$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($181774c36689bc69$var$hasToStringTag && $6SeTG && $181774c36689bc69$var$getPrototypeOf) $1n2vj($181774c36689bc69$var$typedArrays, function(typedArray) {
    var arr = new $181774c36689bc69$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $181774c36689bc69$var$getPrototypeOf(arr);
        var descriptor = $6SeTG(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $181774c36689bc69$var$getPrototypeOf(proto);
            descriptor = $6SeTG(superProto, Symbol.toStringTag);
        }
        $181774c36689bc69$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $181774c36689bc69$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $1n2vj($181774c36689bc69$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$181774c36689bc69$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $181774c36689bc69$var$$slice($181774c36689bc69$var$$toString(value), 8, -1);
        return $181774c36689bc69$var$$indexOf($181774c36689bc69$var$typedArrays, tag) > -1;
    }
    if (!$6SeTG) return false;
    return $181774c36689bc69$var$tryTypedArrays(value);
};

});



parcelRequire.register("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});



parcelRequire.register("f2m41", function(module, exports) {

var $2wwUJ = parcelRequire("2wwUJ");

var $1U9GM = parcelRequire("1U9GM");
var $af2828556be4bfdb$require$Buffer = $1U9GM.Buffer;

var $5UUfm = parcelRequire("5UUfm");

var $bpzVP = parcelRequire("bpzVP");

var $N7Lcz = parcelRequire("N7Lcz");
var $af2828556be4bfdb$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $af2828556be4bfdb$var$MSG_INVALID_SECRET = "secret must be a string or buffer";
var $af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY = "key must be a string or a buffer";
var $af2828556be4bfdb$var$MSG_INVALID_SIGNER_KEY = "key must be a string, a buffer or an object";
var $af2828556be4bfdb$var$supportsKeyObjects = typeof $5UUfm.createPublicKey === "function";
if ($af2828556be4bfdb$var$supportsKeyObjects) {
    $af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY += " or a KeyObject";
    $af2828556be4bfdb$var$MSG_INVALID_SECRET += "or a KeyObject";
}
function $af2828556be4bfdb$var$checkIsPublicKey(key) {
    if ($af2828556be4bfdb$require$Buffer.isBuffer(key)) return;
    if (typeof key === "string") return;
    if (!$af2828556be4bfdb$var$supportsKeyObjects) throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== "object") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== "string") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== "string") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== "function") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_VERIFIER_KEY);
}
function $af2828556be4bfdb$var$checkIsPrivateKey(key) {
    if ($af2828556be4bfdb$require$Buffer.isBuffer(key)) return;
    if (typeof key === "string") return;
    if (typeof key === "object") return;
    throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SIGNER_KEY);
}
function $af2828556be4bfdb$var$checkIsSecretKey(key) {
    if ($af2828556be4bfdb$require$Buffer.isBuffer(key)) return;
    if (typeof key === "string") return key;
    if (!$af2828556be4bfdb$var$supportsKeyObjects) throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
    if (typeof key !== "object") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
    if (key.type !== "secret") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
    if (typeof key.export !== "function") throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_SECRET);
}
function $af2828556be4bfdb$var$fromBase64(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $af2828556be4bfdb$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += "=";
    return base64url.replace(/\-/g, "+").replace(/_/g, "/");
}
function $af2828556be4bfdb$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $N7Lcz.format.bind($N7Lcz, template).apply(null, args);
    return new TypeError(errMsg);
}
function $af2828556be4bfdb$var$bufferOrString(obj) {
    return $af2828556be4bfdb$require$Buffer.isBuffer(obj) || typeof obj === "string";
}
function $af2828556be4bfdb$var$normalizeInput(thing) {
    if (!$af2828556be4bfdb$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $af2828556be4bfdb$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $af2828556be4bfdb$var$checkIsSecretKey(secret);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        var hmac = $5UUfm.createHmac("sha" + bits, secret);
        var sig = (hmac.update(thing), hmac.digest("base64"));
        return $af2828556be4bfdb$var$fromBase64(sig);
    };
}
function $af2828556be4bfdb$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $af2828556be4bfdb$var$createHmacSigner(bits)(thing, secret);
        return $2wwUJ($af2828556be4bfdb$require$Buffer.from(signature), $af2828556be4bfdb$require$Buffer.from(computedSig));
    };
}
function $af2828556be4bfdb$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $af2828556be4bfdb$var$checkIsPrivateKey(privateKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $5UUfm.createSign("RSA-SHA" + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, "base64"));
        return $af2828556be4bfdb$var$fromBase64(sig);
    };
}
function $af2828556be4bfdb$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $af2828556be4bfdb$var$checkIsPublicKey(publicKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        signature = $af2828556be4bfdb$var$toBase64(signature);
        var verifier = $5UUfm.createVerify("RSA-SHA" + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, "base64");
    };
}
function $af2828556be4bfdb$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $af2828556be4bfdb$var$checkIsPrivateKey(privateKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        var signer = $5UUfm.createSign("RSA-SHA" + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $5UUfm.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $5UUfm.constants.RSA_PSS_SALTLEN_DIGEST
        }, "base64"));
        return $af2828556be4bfdb$var$fromBase64(sig);
    };
}
function $af2828556be4bfdb$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $af2828556be4bfdb$var$checkIsPublicKey(publicKey);
        thing = $af2828556be4bfdb$var$normalizeInput(thing);
        signature = $af2828556be4bfdb$var$toBase64(signature);
        var verifier = $5UUfm.createVerify("RSA-SHA" + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $5UUfm.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $5UUfm.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, "base64");
    };
}
function $af2828556be4bfdb$var$createECDSASigner(bits) {
    var inner = $af2828556be4bfdb$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $bpzVP.derToJose(signature, "ES" + bits);
        return signature;
    };
}
function $af2828556be4bfdb$var$createECDSAVerifer(bits) {
    var inner = $af2828556be4bfdb$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $bpzVP.joseToDer(signature, "ES" + bits).toString("base64");
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $af2828556be4bfdb$var$createNoneSigner() {
    return function sign() {
        return "";
    };
}
function $af2828556be4bfdb$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === "";
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $af2828556be4bfdb$var$createHmacSigner,
        rs: $af2828556be4bfdb$var$createKeySigner,
        ps: $af2828556be4bfdb$var$createPSSKeySigner,
        es: $af2828556be4bfdb$var$createECDSASigner,
        none: $af2828556be4bfdb$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $af2828556be4bfdb$var$createHmacVerifier,
        rs: $af2828556be4bfdb$var$createKeyVerifier,
        ps: $af2828556be4bfdb$var$createPSSKeyVerifier,
        es: $af2828556be4bfdb$var$createECDSAVerifer,
        none: $af2828556be4bfdb$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
    if (!match) throw $af2828556be4bfdb$var$typeError($af2828556be4bfdb$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRequire.register("2wwUJ", function(module, exports) {
/*jshint node:true */ "use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $1d6819fc5f26d2dd$require$Buffer = $6ZWSX.Buffer;

var $6ZWSX = parcelRequire("6ZWSX");
var $1d6819fc5f26d2dd$require$SlowBuffer = $6ZWSX.SlowBuffer;
module.exports = $1d6819fc5f26d2dd$var$bufferEq;
function $1d6819fc5f26d2dd$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$1d6819fc5f26d2dd$require$Buffer.isBuffer(a) || !$1d6819fc5f26d2dd$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$1d6819fc5f26d2dd$var$bufferEq.install = function() {
    $1d6819fc5f26d2dd$require$Buffer.prototype.equal = $1d6819fc5f26d2dd$require$SlowBuffer.prototype.equal = function equal(that) {
        return $1d6819fc5f26d2dd$var$bufferEq(this, that);
    };
};
var $1d6819fc5f26d2dd$var$origBufEqual = $1d6819fc5f26d2dd$require$Buffer.prototype.equal;
var $1d6819fc5f26d2dd$var$origSlowBufEqual = $1d6819fc5f26d2dd$require$SlowBuffer.prototype.equal;
$1d6819fc5f26d2dd$var$bufferEq.restore = function() {
    $1d6819fc5f26d2dd$require$Buffer.prototype.equal = $1d6819fc5f26d2dd$var$origBufEqual;
    $1d6819fc5f26d2dd$require$SlowBuffer.prototype.equal = $1d6819fc5f26d2dd$var$origSlowBufEqual;
};

});

parcelRequire.register("5UUfm", function(module, exports) {

$parcel$export(module.exports, "createHmac", () => $44edd02a6be448cd$export$da39cf97e1eb7c91, (v) => $44edd02a6be448cd$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "createSign", () => $44edd02a6be448cd$export$45df7cae684751af, (v) => $44edd02a6be448cd$export$45df7cae684751af = v);
$parcel$export(module.exports, "createVerify", () => $44edd02a6be448cd$export$6f65485f87568e37, (v) => $44edd02a6be448cd$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "constants", () => $44edd02a6be448cd$export$1a988e7317c65621, (v) => $44edd02a6be448cd$export$1a988e7317c65621 = v);
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRequire.register("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRequire.register("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRequire.register("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRequire.register("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $imbnh = parcelRequire("imbnh");
var $abf00c68ae11d39d$require$Transform = $imbnh.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRequire.register("imbnh", function(module, exports) {

exports = module.exports = (parcelRequire("dKWUQ"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("c5jlB"));

exports.Duplex = (parcelRequire("3ov6Z"));

exports.Transform = (parcelRequire("crXmw"));

exports.PassThrough = (parcelRequire("di5wW"));

exports.finished = (parcelRequire("izVph"));

exports.pipeline = (parcelRequire("4HJZ1"));

});
parcelRequire.register("dKWUQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $a03d45b164266ddc$var$Readable;
/*<replacement>*/ var $a03d45b164266ddc$var$Duplex;
/*</replacement>*/ $a03d45b164266ddc$var$Readable.ReadableState = $a03d45b164266ddc$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $a03d45b164266ddc$require$EE = $7etJZ.EventEmitter;
var $a03d45b164266ddc$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $c6U6o = parcelRequire("c6U6o");

var $6ZWSX = parcelRequire("6ZWSX");
var $a03d45b164266ddc$require$Buffer = $6ZWSX.Buffer;
var $a03d45b164266ddc$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $a03d45b164266ddc$var$_uint8ArrayToBuffer(chunk) {
    return $a03d45b164266ddc$require$Buffer.from(chunk);
}
function $a03d45b164266ddc$var$_isUint8Array(obj) {
    return $a03d45b164266ddc$require$Buffer.isBuffer(obj) || obj instanceof $a03d45b164266ddc$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $a03d45b164266ddc$var$debug;
if ($kjyEk && $kjyEk.debuglog) $a03d45b164266ddc$var$debug = $kjyEk.debuglog("stream");
else $a03d45b164266ddc$var$debug = function debug() {};

var $67IS3 = parcelRequire("67IS3");

var $c0Uf7 = parcelRequire("c0Uf7");

var $2wssQ = parcelRequire("2wssQ");
var $a03d45b164266ddc$var$getHighWaterMark = $2wssQ.getHighWaterMark;

var $gid0T = parcelRequire("gid0T");
var $a03d45b164266ddc$require$_require$codes = $gid0T.codes;
var $a03d45b164266ddc$var$ERR_INVALID_ARG_TYPE = $a03d45b164266ddc$require$_require$codes.ERR_INVALID_ARG_TYPE, $a03d45b164266ddc$var$ERR_STREAM_PUSH_AFTER_EOF = $a03d45b164266ddc$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $a03d45b164266ddc$var$ERR_METHOD_NOT_IMPLEMENTED = $a03d45b164266ddc$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a03d45b164266ddc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $a03d45b164266ddc$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $a03d45b164266ddc$var$StringDecoder;
var $a03d45b164266ddc$var$createReadableStreamAsyncIterator;
var $a03d45b164266ddc$var$from;

(parcelRequire("dlqwk"))($a03d45b164266ddc$var$Readable, $c6U6o);
var $a03d45b164266ddc$var$errorOrDestroy = $c0Uf7.errorOrDestroy;
var $a03d45b164266ddc$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $a03d45b164266ddc$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $a03d45b164266ddc$var$ReadableState(options, stream, isDuplex) {
    $a03d45b164266ddc$var$Duplex = $a03d45b164266ddc$var$Duplex || (parcelRequire("3ov6Z"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $a03d45b164266ddc$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $a03d45b164266ddc$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $67IS3();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$a03d45b164266ddc$var$StringDecoder) $a03d45b164266ddc$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $a03d45b164266ddc$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $a03d45b164266ddc$var$Readable(options) {
    $a03d45b164266ddc$var$Duplex = $a03d45b164266ddc$var$Duplex || (parcelRequire("3ov6Z"));
    if (!(this instanceof $a03d45b164266ddc$var$Readable)) return new $a03d45b164266ddc$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $a03d45b164266ddc$var$Duplex;
    this._readableState = new $a03d45b164266ddc$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $c6U6o.call(this);
}
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$a03d45b164266ddc$var$Readable.prototype.destroy = $c0Uf7.destroy;
$a03d45b164266ddc$var$Readable.prototype._undestroy = $c0Uf7.undestroy;
$a03d45b164266ddc$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$a03d45b164266ddc$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $a03d45b164266ddc$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $a03d45b164266ddc$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$a03d45b164266ddc$var$Readable.prototype.unshift = function(chunk) {
    return $a03d45b164266ddc$var$readableAddChunk(this, chunk, null, true, false);
};
function $a03d45b164266ddc$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $a03d45b164266ddc$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $a03d45b164266ddc$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $a03d45b164266ddc$var$chunkInvalid(state, chunk);
        if (er) $a03d45b164266ddc$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $a03d45b164266ddc$require$Buffer.prototype) chunk = $a03d45b164266ddc$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $a03d45b164266ddc$var$errorOrDestroy(stream, new $a03d45b164266ddc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $a03d45b164266ddc$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $a03d45b164266ddc$var$errorOrDestroy(stream, new $a03d45b164266ddc$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $a03d45b164266ddc$var$addChunk(stream, state, chunk, false);
                    else $a03d45b164266ddc$var$maybeReadMore(stream, state);
                } else $a03d45b164266ddc$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $a03d45b164266ddc$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $a03d45b164266ddc$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $a03d45b164266ddc$var$emitReadable(stream);
    }
    $a03d45b164266ddc$var$maybeReadMore(stream, state);
}
function $a03d45b164266ddc$var$chunkInvalid(state, chunk) {
    var er;
    if (!$a03d45b164266ddc$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $a03d45b164266ddc$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$a03d45b164266ddc$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$a03d45b164266ddc$var$Readable.prototype.setEncoding = function(enc) {
    if (!$a03d45b164266ddc$var$StringDecoder) $a03d45b164266ddc$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $a03d45b164266ddc$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $a03d45b164266ddc$var$MAX_HWM = 0x40000000;
function $a03d45b164266ddc$var$computeNewHighWaterMark(n) {
    if (n >= $a03d45b164266ddc$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $a03d45b164266ddc$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a03d45b164266ddc$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $a03d45b164266ddc$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$a03d45b164266ddc$var$Readable.prototype.read = function(n) {
    $a03d45b164266ddc$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $a03d45b164266ddc$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $a03d45b164266ddc$var$endReadable(this);
        else $a03d45b164266ddc$var$emitReadable(this);
        return null;
    }
    n = $a03d45b164266ddc$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $a03d45b164266ddc$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $a03d45b164266ddc$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $a03d45b164266ddc$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $a03d45b164266ddc$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $a03d45b164266ddc$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $a03d45b164266ddc$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $a03d45b164266ddc$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $a03d45b164266ddc$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $a03d45b164266ddc$var$onEofChunk(stream, state) {
    $a03d45b164266ddc$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $a03d45b164266ddc$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $a03d45b164266ddc$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $a03d45b164266ddc$var$emitReadable(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $a03d45b164266ddc$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$emitReadable_, stream);
    }
}
function $a03d45b164266ddc$var$emitReadable_(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $a03d45b164266ddc$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $a03d45b164266ddc$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$maybeReadMore_, stream, state);
    }
}
function $a03d45b164266ddc$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $a03d45b164266ddc$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$a03d45b164266ddc$var$Readable.prototype._read = function(n) {
    $a03d45b164266ddc$var$errorOrDestroy(this, new $a03d45b164266ddc$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$a03d45b164266ddc$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $a03d45b164266ddc$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $a03d45b164266ddc$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $a03d45b164266ddc$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $a03d45b164266ddc$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $a03d45b164266ddc$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $a03d45b164266ddc$var$debug("ondata");
        var ret = dest.write(chunk);
        $a03d45b164266ddc$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $a03d45b164266ddc$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $a03d45b164266ddc$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $a03d45b164266ddc$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($a03d45b164266ddc$var$EElistenerCount(dest, "error") === 0) $a03d45b164266ddc$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $a03d45b164266ddc$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $a03d45b164266ddc$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $a03d45b164266ddc$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $a03d45b164266ddc$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $a03d45b164266ddc$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $a03d45b164266ddc$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $a03d45b164266ddc$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $a03d45b164266ddc$var$flow(src);
        }
    };
}
$a03d45b164266ddc$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $a03d45b164266ddc$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$a03d45b164266ddc$var$Readable.prototype.on = function(ev, fn) {
    var res = $c6U6o.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $a03d45b164266ddc$var$debug("on readable", state.length, state.reading);
            if (state.length) $a03d45b164266ddc$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($a03d45b164266ddc$var$nReadingNextTick, this);
        }
    }
    return res;
};
$a03d45b164266ddc$var$Readable.prototype.addListener = $a03d45b164266ddc$var$Readable.prototype.on;
$a03d45b164266ddc$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $c6U6o.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($a03d45b164266ddc$var$updateReadableListening, this);
    return res;
};
$a03d45b164266ddc$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $c6U6o.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($a03d45b164266ddc$var$updateReadableListening, this);
    return res;
};
function $a03d45b164266ddc$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $a03d45b164266ddc$var$nReadingNextTick(self) {
    $a03d45b164266ddc$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$a03d45b164266ddc$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $a03d45b164266ddc$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $a03d45b164266ddc$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $a03d45b164266ddc$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$resume_, stream, state);
    }
}
function $a03d45b164266ddc$var$resume_(stream, state) {
    $a03d45b164266ddc$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $a03d45b164266ddc$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$a03d45b164266ddc$var$Readable.prototype.pause = function() {
    $a03d45b164266ddc$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $a03d45b164266ddc$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $a03d45b164266ddc$var$flow(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$a03d45b164266ddc$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $a03d45b164266ddc$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $a03d45b164266ddc$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $a03d45b164266ddc$var$kProxyEvents.length; n++)stream.on($a03d45b164266ddc$var$kProxyEvents[n], this.emit.bind(this, $a03d45b164266ddc$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $a03d45b164266ddc$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $a03d45b164266ddc$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($a03d45b164266ddc$var$createReadableStreamAsyncIterator === undefined) $a03d45b164266ddc$var$createReadableStreamAsyncIterator = (parcelRequire("8NiiC"));
    return $a03d45b164266ddc$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$a03d45b164266ddc$var$Readable._fromList = $a03d45b164266ddc$var$fromList;
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a03d45b164266ddc$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $a03d45b164266ddc$var$endReadable(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$endReadableNT, state, stream);
    }
}
function $a03d45b164266ddc$var$endReadableNT(state, stream) {
    $a03d45b164266ddc$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $a03d45b164266ddc$var$Readable.from = function(iterable, opts) {
    if ($a03d45b164266ddc$var$from === undefined) $a03d45b164266ddc$var$from = (parcelRequire("2O9bI"));
    return $a03d45b164266ddc$var$from($a03d45b164266ddc$var$Readable, iterable, opts);
};
function $a03d45b164266ddc$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("c6U6o", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRequire.register("67IS3", function(module, exports) {
"use strict";
function $475633eec3441396$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $475633eec3441396$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $475633eec3441396$var$ownKeys(Object(source), true).forEach(function(key) {
            $475633eec3441396$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $475633eec3441396$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $475633eec3441396$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $475633eec3441396$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $475633eec3441396$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $475633eec3441396$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $475633eec3441396$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $475633eec3441396$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $6ZWSX = parcelRequire("6ZWSX");
var $475633eec3441396$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $475633eec3441396$var$inspect = $kjyEk.inspect;
var $475633eec3441396$var$custom = $475633eec3441396$var$inspect && $475633eec3441396$var$inspect.custom || "inspect";
function $475633eec3441396$var$copyBuffer(src, target, offset) {
    $475633eec3441396$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $475633eec3441396$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $475633eec3441396$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $475633eec3441396$var$Buffer.alloc(0);
                var ret = $475633eec3441396$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $475633eec3441396$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $475633eec3441396$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $475633eec3441396$var$custom,
            value: function value(_, options) {
                return $475633eec3441396$var$inspect(this, $475633eec3441396$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("c0Uf7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $8bf11cc7ac536710$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
    });
    return this;
}
function $8bf11cc7ac536710$var$emitErrorAndCloseNT(self, err) {
    $8bf11cc7ac536710$var$emitErrorNT(self, err);
    $8bf11cc7ac536710$var$emitCloseNT(self);
}
function $8bf11cc7ac536710$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $8bf11cc7ac536710$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $8bf11cc7ac536710$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $8bf11cc7ac536710$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $8bf11cc7ac536710$var$destroy,
    undestroy: $8bf11cc7ac536710$var$undestroy,
    errorOrDestroy: $8bf11cc7ac536710$var$errorOrDestroy
};

});

parcelRequire.register("2wssQ", function(module, exports) {
"use strict";

var $gid0T = parcelRequire("gid0T");
var $1d64a656ab2d4da3$var$ERR_INVALID_OPT_VALUE = $gid0T.codes.ERR_INVALID_OPT_VALUE;
function $1d64a656ab2d4da3$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1d64a656ab2d4da3$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $1d64a656ab2d4da3$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $1d64a656ab2d4da3$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $1d64a656ab2d4da3$var$getHighWaterMark
};

});
parcelRequire.register("gid0T", function(module, exports) {

$parcel$export(module.exports, "codes", () => $bdc86bf9ff1a2a6a$export$e45cb6485273080e, (v) => $bdc86bf9ff1a2a6a$export$e45cb6485273080e = v);
var $bdc86bf9ff1a2a6a$export$e45cb6485273080e;
"use strict";
function $bdc86bf9ff1a2a6a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bdc86bf9ff1a2a6a$var$codes = {};
function $bdc86bf9ff1a2a6a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $bdc86bf9ff1a2a6a$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $bdc86bf9ff1a2a6a$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $bdc86bf9ff1a2a6a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $bdc86bf9ff1a2a6a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $bdc86bf9ff1a2a6a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $bdc86bf9ff1a2a6a$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $bdc86bf9ff1a2a6a$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($bdc86bf9ff1a2a6a$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($bdc86bf9ff1a2a6a$var$oneOf(expected, "type"));
    else {
        var type = $bdc86bf9ff1a2a6a$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($bdc86bf9ff1a2a6a$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$bdc86bf9ff1a2a6a$export$e45cb6485273080e = $bdc86bf9ff1a2a6a$var$codes;

});


parcelRequire.register("3ov6Z", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $278bbf2162c434f2$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $278bbf2162c434f2$var$Duplex;

var $dKWUQ = parcelRequire("dKWUQ");

var $c5jlB = parcelRequire("c5jlB");

(parcelRequire("dlqwk"))($278bbf2162c434f2$var$Duplex, $dKWUQ);
// Allow the keys array to be GC'ed.
var $278bbf2162c434f2$var$keys = $278bbf2162c434f2$var$objectKeys($c5jlB.prototype);
for(var $278bbf2162c434f2$var$v = 0; $278bbf2162c434f2$var$v < $278bbf2162c434f2$var$keys.length; $278bbf2162c434f2$var$v++){
    var $278bbf2162c434f2$var$method = $278bbf2162c434f2$var$keys[$278bbf2162c434f2$var$v];
    if (!$278bbf2162c434f2$var$Duplex.prototype[$278bbf2162c434f2$var$method]) $278bbf2162c434f2$var$Duplex.prototype[$278bbf2162c434f2$var$method] = $c5jlB.prototype[$278bbf2162c434f2$var$method];
}
function $278bbf2162c434f2$var$Duplex(options) {
    if (!(this instanceof $278bbf2162c434f2$var$Duplex)) return new $278bbf2162c434f2$var$Duplex(options);
    $dKWUQ.call(this, options);
    $c5jlB.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $278bbf2162c434f2$var$onend);
        }
    }
}
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $278bbf2162c434f2$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($278bbf2162c434f2$var$onEndNT, this);
}
function $278bbf2162c434f2$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("c5jlB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $8cc4f5a98988b56b$var$Writable;
/* <replacement> */ function $8cc4f5a98988b56b$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8cc4f5a98988b56b$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8cc4f5a98988b56b$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8cc4f5a98988b56b$var$Duplex;
/*</replacement>*/ $8cc4f5a98988b56b$var$Writable.WritableState = $8cc4f5a98988b56b$var$WritableState;

/*<replacement>*/ var $8cc4f5a98988b56b$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $c6U6o = parcelRequire("c6U6o");

var $6ZWSX = parcelRequire("6ZWSX");
var $8cc4f5a98988b56b$require$Buffer = $6ZWSX.Buffer;
var $8cc4f5a98988b56b$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $8cc4f5a98988b56b$var$_uint8ArrayToBuffer(chunk) {
    return $8cc4f5a98988b56b$require$Buffer.from(chunk);
}
function $8cc4f5a98988b56b$var$_isUint8Array(obj) {
    return $8cc4f5a98988b56b$require$Buffer.isBuffer(obj) || obj instanceof $8cc4f5a98988b56b$var$OurUint8Array;
}

var $c0Uf7 = parcelRequire("c0Uf7");

var $2wssQ = parcelRequire("2wssQ");
var $8cc4f5a98988b56b$var$getHighWaterMark = $2wssQ.getHighWaterMark;

var $gid0T = parcelRequire("gid0T");
var $8cc4f5a98988b56b$require$_require$codes = $gid0T.codes;
var $8cc4f5a98988b56b$var$ERR_INVALID_ARG_TYPE = $8cc4f5a98988b56b$require$_require$codes.ERR_INVALID_ARG_TYPE, $8cc4f5a98988b56b$var$ERR_METHOD_NOT_IMPLEMENTED = $8cc4f5a98988b56b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8cc4f5a98988b56b$var$ERR_MULTIPLE_CALLBACK = $8cc4f5a98988b56b$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8cc4f5a98988b56b$var$ERR_STREAM_CANNOT_PIPE = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $8cc4f5a98988b56b$var$ERR_STREAM_DESTROYED = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_DESTROYED, $8cc4f5a98988b56b$var$ERR_STREAM_NULL_VALUES = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_NULL_VALUES, $8cc4f5a98988b56b$var$ERR_STREAM_WRITE_AFTER_END = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $8cc4f5a98988b56b$var$ERR_UNKNOWN_ENCODING = $8cc4f5a98988b56b$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $8cc4f5a98988b56b$var$errorOrDestroy = $c0Uf7.errorOrDestroy;

(parcelRequire("dlqwk"))($8cc4f5a98988b56b$var$Writable, $c6U6o);
function $8cc4f5a98988b56b$var$nop() {}

function $8cc4f5a98988b56b$var$WritableState(options, stream, isDuplex) {
    $8cc4f5a98988b56b$var$Duplex = $8cc4f5a98988b56b$var$Duplex || (parcelRequire("3ov6Z"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $8cc4f5a98988b56b$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $8cc4f5a98988b56b$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8cc4f5a98988b56b$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8cc4f5a98988b56b$var$CorkedRequest(this);
}
$8cc4f5a98988b56b$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8cc4f5a98988b56b$var$WritableState.prototype, "buffer", {
            get: $8cc4f5a98988b56b$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8cc4f5a98988b56b$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $8cc4f5a98988b56b$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8cc4f5a98988b56b$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($8cc4f5a98988b56b$var$realHasInstance.call(this, object)) return true;
            if (this !== $8cc4f5a98988b56b$var$Writable) return false;
            return object && object._writableState instanceof $8cc4f5a98988b56b$var$WritableState;
        }
    });
} else $8cc4f5a98988b56b$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $8cc4f5a98988b56b$var$Writable(options) {
    $8cc4f5a98988b56b$var$Duplex = $8cc4f5a98988b56b$var$Duplex || (parcelRequire("3ov6Z")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8cc4f5a98988b56b$var$Duplex;
    if (!isDuplex && !$8cc4f5a98988b56b$var$realHasInstance.call($8cc4f5a98988b56b$var$Writable, this)) return new $8cc4f5a98988b56b$var$Writable(options);
    this._writableState = new $8cc4f5a98988b56b$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $c6U6o.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$8cc4f5a98988b56b$var$Writable.prototype.pipe = function() {
    $8cc4f5a98988b56b$var$errorOrDestroy(this, new $8cc4f5a98988b56b$var$ERR_STREAM_CANNOT_PIPE());
};
function $8cc4f5a98988b56b$var$writeAfterEnd(stream, cb) {
    var er = new $8cc4f5a98988b56b$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8cc4f5a98988b56b$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $8cc4f5a98988b56b$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $8cc4f5a98988b56b$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$8cc4f5a98988b56b$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8cc4f5a98988b56b$var$_isUint8Array(chunk);
    if (isBuf && !$8cc4f5a98988b56b$require$Buffer.isBuffer(chunk)) chunk = $8cc4f5a98988b56b$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $8cc4f5a98988b56b$var$nop;
    if (state.ending) $8cc4f5a98988b56b$var$writeAfterEnd(this, cb);
    else if (isBuf || $8cc4f5a98988b56b$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8cc4f5a98988b56b$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8cc4f5a98988b56b$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$8cc4f5a98988b56b$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc4f5a98988b56b$var$clearBuffer(this, state);
    }
};
$8cc4f5a98988b56b$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $8cc4f5a98988b56b$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $8cc4f5a98988b56b$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $8cc4f5a98988b56b$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8cc4f5a98988b56b$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8cc4f5a98988b56b$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8cc4f5a98988b56b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8cc4f5a98988b56b$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $8cc4f5a98988b56b$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8cc4f5a98988b56b$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($8cc4f5a98988b56b$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    }
}
function $8cc4f5a98988b56b$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8cc4f5a98988b56b$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $8cc4f5a98988b56b$var$ERR_MULTIPLE_CALLBACK();
    $8cc4f5a98988b56b$var$onwriteStateUpdate(state);
    if (er) $8cc4f5a98988b56b$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8cc4f5a98988b56b$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc4f5a98988b56b$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($8cc4f5a98988b56b$var$afterWrite, stream, state, finished, cb);
        else $8cc4f5a98988b56b$var$afterWrite(stream, state, finished, cb);
    }
}
function $8cc4f5a98988b56b$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8cc4f5a98988b56b$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8cc4f5a98988b56b$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8cc4f5a98988b56b$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $8cc4f5a98988b56b$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8cc4f5a98988b56b$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8cc4f5a98988b56b$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8cc4f5a98988b56b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8cc4f5a98988b56b$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $8cc4f5a98988b56b$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$8cc4f5a98988b56b$var$Writable.prototype._writev = null;
$8cc4f5a98988b56b$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $8cc4f5a98988b56b$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $8cc4f5a98988b56b$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8cc4f5a98988b56b$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $8cc4f5a98988b56b$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    });
}
function $8cc4f5a98988b56b$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($8cc4f5a98988b56b$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $8cc4f5a98988b56b$var$finishMaybe(stream, state) {
    var need = $8cc4f5a98988b56b$var$needFinish(state);
    if (need) {
        $8cc4f5a98988b56b$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $8cc4f5a98988b56b$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8cc4f5a98988b56b$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8cc4f5a98988b56b$var$Writable.prototype.destroy = $c0Uf7.destroy;
$8cc4f5a98988b56b$var$Writable.prototype._undestroy = $c0Uf7.undestroy;
$8cc4f5a98988b56b$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRequire.register("8NiiC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $667118301431ed3f$var$_Object$setPrototypeO;
function $667118301431ed3f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $izVph = parcelRequire("izVph");
var $667118301431ed3f$var$kLastResolve = Symbol("lastResolve");
var $667118301431ed3f$var$kLastReject = Symbol("lastReject");
var $667118301431ed3f$var$kError = Symbol("error");
var $667118301431ed3f$var$kEnded = Symbol("ended");
var $667118301431ed3f$var$kLastPromise = Symbol("lastPromise");
var $667118301431ed3f$var$kHandlePromise = Symbol("handlePromise");
var $667118301431ed3f$var$kStream = Symbol("stream");
function $667118301431ed3f$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $667118301431ed3f$var$readAndResolve(iter) {
    var resolve = iter[$667118301431ed3f$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$667118301431ed3f$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$667118301431ed3f$var$kLastPromise] = null;
            iter[$667118301431ed3f$var$kLastResolve] = null;
            iter[$667118301431ed3f$var$kLastReject] = null;
            resolve($667118301431ed3f$var$createIterResult(data, false));
        }
    }
}
function $667118301431ed3f$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($667118301431ed3f$var$readAndResolve, iter);
}
function $667118301431ed3f$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$667118301431ed3f$var$kEnded]) {
                resolve($667118301431ed3f$var$createIterResult(undefined, true));
                return;
            }
            iter[$667118301431ed3f$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $667118301431ed3f$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $667118301431ed3f$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($667118301431ed3f$var$_Object$setPrototypeO = {
    get stream () {
        return this[$667118301431ed3f$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$667118301431ed3f$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$667118301431ed3f$var$kEnded]) return Promise.resolve($667118301431ed3f$var$createIterResult(undefined, true));
        if (this[$667118301431ed3f$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$667118301431ed3f$var$kError]) reject(_this[$667118301431ed3f$var$kError]);
                else resolve($667118301431ed3f$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$667118301431ed3f$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($667118301431ed3f$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$667118301431ed3f$var$kStream].read();
            if (data !== null) return Promise.resolve($667118301431ed3f$var$createIterResult(data, false));
            promise = new Promise(this[$667118301431ed3f$var$kHandlePromise]);
        }
        this[$667118301431ed3f$var$kLastPromise] = promise;
        return promise;
    }
}, $667118301431ed3f$var$_defineProperty($667118301431ed3f$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $667118301431ed3f$var$_defineProperty($667118301431ed3f$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$667118301431ed3f$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($667118301431ed3f$var$createIterResult(undefined, true));
        });
    });
}), $667118301431ed3f$var$_Object$setPrototypeO), $667118301431ed3f$var$AsyncIteratorPrototype);
var $667118301431ed3f$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($667118301431ed3f$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kStream, {
        value: stream,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kLastResolve, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kLastReject, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kError, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$667118301431ed3f$var$kStream].read();
            if (data) {
                iterator[$667118301431ed3f$var$kLastPromise] = null;
                iterator[$667118301431ed3f$var$kLastResolve] = null;
                iterator[$667118301431ed3f$var$kLastReject] = null;
                resolve($667118301431ed3f$var$createIterResult(data, false));
            } else {
                iterator[$667118301431ed3f$var$kLastResolve] = resolve;
                iterator[$667118301431ed3f$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$667118301431ed3f$var$kLastPromise] = null;
    $izVph(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$667118301431ed3f$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$667118301431ed3f$var$kLastPromise] = null;
                iterator[$667118301431ed3f$var$kLastResolve] = null;
                iterator[$667118301431ed3f$var$kLastReject] = null;
                reject(err);
            }
            iterator[$667118301431ed3f$var$kError] = err;
            return;
        }
        var resolve = iterator[$667118301431ed3f$var$kLastResolve];
        if (resolve !== null) {
            iterator[$667118301431ed3f$var$kLastPromise] = null;
            iterator[$667118301431ed3f$var$kLastResolve] = null;
            iterator[$667118301431ed3f$var$kLastReject] = null;
            resolve($667118301431ed3f$var$createIterResult(undefined, true));
        }
        iterator[$667118301431ed3f$var$kEnded] = true;
    });
    stream.on("readable", $667118301431ed3f$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $667118301431ed3f$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("izVph", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $gid0T = parcelRequire("gid0T");
var $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE = $gid0T.codes.ERR_STREAM_PREMATURE_CLOSE;
function $d86806abb7caca08$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d86806abb7caca08$var$noop() {}
function $d86806abb7caca08$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d86806abb7caca08$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d86806abb7caca08$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d86806abb7caca08$var$once(callback || $d86806abb7caca08$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d86806abb7caca08$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d86806abb7caca08$var$eos;

});


parcelRequire.register("2O9bI", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("crXmw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $91060dc4548a9b08$var$Transform;

var $gid0T = parcelRequire("gid0T");
var $91060dc4548a9b08$require$_require$codes = $gid0T.codes;
var $91060dc4548a9b08$var$ERR_METHOD_NOT_IMPLEMENTED = $91060dc4548a9b08$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $91060dc4548a9b08$var$ERR_MULTIPLE_CALLBACK = $91060dc4548a9b08$require$_require$codes.ERR_MULTIPLE_CALLBACK, $91060dc4548a9b08$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $91060dc4548a9b08$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $91060dc4548a9b08$var$ERR_TRANSFORM_WITH_LENGTH_0 = $91060dc4548a9b08$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $3ov6Z = parcelRequire("3ov6Z");

(parcelRequire("dlqwk"))($91060dc4548a9b08$var$Transform, $3ov6Z);
function $91060dc4548a9b08$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $91060dc4548a9b08$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $91060dc4548a9b08$var$Transform(options) {
    if (!(this instanceof $91060dc4548a9b08$var$Transform)) return new $91060dc4548a9b08$var$Transform(options);
    $3ov6Z.call(this, options);
    this._transformState = {
        afterTransform: $91060dc4548a9b08$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $91060dc4548a9b08$var$prefinish);
}
function $91060dc4548a9b08$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $91060dc4548a9b08$var$done(_this, er, data);
    });
    else $91060dc4548a9b08$var$done(this, null, null);
}
$91060dc4548a9b08$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $3ov6Z.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$91060dc4548a9b08$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $91060dc4548a9b08$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$91060dc4548a9b08$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$91060dc4548a9b08$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$91060dc4548a9b08$var$Transform.prototype._destroy = function(err, cb) {
    $3ov6Z.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $91060dc4548a9b08$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $91060dc4548a9b08$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $91060dc4548a9b08$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("di5wW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $9ad13f044dc43d7f$var$PassThrough;

var $crXmw = parcelRequire("crXmw");

(parcelRequire("dlqwk"))($9ad13f044dc43d7f$var$PassThrough, $crXmw);
function $9ad13f044dc43d7f$var$PassThrough(options) {
    if (!(this instanceof $9ad13f044dc43d7f$var$PassThrough)) return new $9ad13f044dc43d7f$var$PassThrough(options);
    $crXmw.call(this, options);
}
$9ad13f044dc43d7f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("4HJZ1", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $36ced8e7be5358d3$var$eos;
function $36ced8e7be5358d3$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $gid0T = parcelRequire("gid0T");
var $36ced8e7be5358d3$require$_require$codes = $gid0T.codes;
var $36ced8e7be5358d3$var$ERR_MISSING_ARGS = $36ced8e7be5358d3$require$_require$codes.ERR_MISSING_ARGS, $36ced8e7be5358d3$var$ERR_STREAM_DESTROYED = $36ced8e7be5358d3$require$_require$codes.ERR_STREAM_DESTROYED;
function $36ced8e7be5358d3$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $36ced8e7be5358d3$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $36ced8e7be5358d3$var$destroyer(stream, reading, writing, callback) {
    callback = $36ced8e7be5358d3$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($36ced8e7be5358d3$var$eos === undefined) $36ced8e7be5358d3$var$eos = (parcelRequire("izVph"));
    $36ced8e7be5358d3$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($36ced8e7be5358d3$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $36ced8e7be5358d3$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $36ced8e7be5358d3$var$call(fn) {
    fn();
}
function $36ced8e7be5358d3$var$pipe(from, to) {
    return from.pipe(to);
}
function $36ced8e7be5358d3$var$popCallback(streams) {
    if (!streams.length) return $36ced8e7be5358d3$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $36ced8e7be5358d3$var$noop;
    return streams.pop();
}
function $36ced8e7be5358d3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $36ced8e7be5358d3$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $36ced8e7be5358d3$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $36ced8e7be5358d3$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($36ced8e7be5358d3$var$call);
            if (reading) return;
            destroys.forEach($36ced8e7be5358d3$var$call);
            callback(error);
        });
    });
    return streams.reduce($36ced8e7be5358d3$var$pipe);
}
module.exports = $36ced8e7be5358d3$var$pipeline;

});




parcelRequire.register("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRequire.register("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRequire.register("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRequire.register("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRequire.register("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRequire.register("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRequire.register("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRequire.register("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRequire.register("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRequire.register("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRequire.register("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRequire.register("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRequire.register("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRequire.register("eFSIF", function(module, exports) {

module.exports = (parcelRequire("6swAi"));

});
parcelRequire.register("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRequire.register("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRequire.register("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRequire.register("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRequire.register("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRequire.register("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRequire.register("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRequire.register("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRequire.register("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede3": $8SeDJ.EDE,
    "des-ede-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede": $8SeDJ.EDE,
    "des-cbc": $8SeDJ.CBC.instantiate($8SeDJ.DES),
    "des-ecb": $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRequire.register("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRequire.register("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRequire.register("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRequire.register("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRequire.register("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRequire.register("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRequire.register("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRequire.register("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRequire.register("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRequire.register("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRequire.register("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRequire.register("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRequire.register("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRequire.register("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRequire.register("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRequire.register("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRequire.register("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRequire.register("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRequire.register("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRequire.register("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRequire.register("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRequire.register("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRequire.register("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRequire.register("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRequire.register("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRequire.register("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, "hex");
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRequire.register("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $dEXSZ = parcelRequire("dEXSZ");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $dEXSZ(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $dEXSZ(1);
var $7f34ba2fa9025258$var$TWO = new $dEXSZ(2);
var $7f34ba2fa9025258$var$FIVE = new $dEXSZ(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $dEXSZ(16);
var $7f34ba2fa9025258$var$EIGHT = new $dEXSZ(8);
var $7f34ba2fa9025258$var$TEN = new $dEXSZ(10);
var $7f34ba2fa9025258$var$THREE = new $dEXSZ(3);
var $7f34ba2fa9025258$var$SEVEN = new $dEXSZ(7);
var $7f34ba2fa9025258$var$ELEVEN = new $dEXSZ(11);
var $7f34ba2fa9025258$var$FOUR = new $dEXSZ(4);
var $7f34ba2fa9025258$var$TWELVE = new $dEXSZ(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $dEXSZ.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $dEXSZ([
            0x8c,
            0x7b
        ]);
        else return new $dEXSZ([
            0x8c,
            0x27
        ]);
    }
    gen = new $dEXSZ(gen);
    var num, n2;
    while(true){
        num = new $dEXSZ($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRequire.register("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("g2bJL", function(module, exports) {

var $dEXSZ = parcelRequire("dEXSZ");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $dEXSZ(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $dEXSZ.mont(n);
    var rone = new $dEXSZ(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $dEXSZ(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $dEXSZ.mont(n);
    var rone = new $dEXSZ(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $dEXSZ(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRequire.register("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRequire.register("kGErQ", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRequire.register("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $dEXSZ(24);
var $8911d62d5514749e$var$ELEVEN = new $dEXSZ(11);
var $8911d62d5514749e$var$TEN = new $dEXSZ(10);
var $8911d62d5514749e$var$THREE = new $dEXSZ(3);
var $8911d62d5514749e$var$SEVEN = new $dEXSZ(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $dEXSZ(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $dEXSZ(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $dEXSZ(prime);
    this._prime = $dEXSZ.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $dEXSZ($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $dEXSZ(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $dEXSZ(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRequire.register("4zMFU", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $62Mby = parcelRequire("62Mby");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $62Mby.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $3550302076d9e62e$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $62Mby.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $3550302076d9e62e$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $3550302076d9e62e$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sig, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRequire.register("62Mby", function(module, exports) {

exports = module.exports = (parcelRequire("ijRUb"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("77F6W"));

exports.Duplex = (parcelRequire("gymWQ"));

exports.Transform = (parcelRequire("8hRuT"));

exports.PassThrough = (parcelRequire("fbZXo"));

exports.finished = (parcelRequire("3mcid"));

exports.pipeline = (parcelRequire("etwQ4"));

});
parcelRequire.register("ijRUb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $d563d0cdbeba3673$var$Readable;
/*<replacement>*/ var $d563d0cdbeba3673$var$Duplex;
/*</replacement>*/ $d563d0cdbeba3673$var$Readable.ReadableState = $d563d0cdbeba3673$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $d563d0cdbeba3673$require$EE = $7etJZ.EventEmitter;
var $d563d0cdbeba3673$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $7TavY = parcelRequire("7TavY");

var $6ZWSX = parcelRequire("6ZWSX");
var $d563d0cdbeba3673$require$Buffer = $6ZWSX.Buffer;
var $d563d0cdbeba3673$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk) {
    return $d563d0cdbeba3673$require$Buffer.from(chunk);
}
function $d563d0cdbeba3673$var$_isUint8Array(obj) {
    return $d563d0cdbeba3673$require$Buffer.isBuffer(obj) || obj instanceof $d563d0cdbeba3673$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $d563d0cdbeba3673$var$debug;
if ($kjyEk && $kjyEk.debuglog) $d563d0cdbeba3673$var$debug = $kjyEk.debuglog("stream");
else $d563d0cdbeba3673$var$debug = function debug() {};

var $l520z = parcelRequire("l520z");

var $dMA3M = parcelRequire("dMA3M");

var $jjqfv = parcelRequire("jjqfv");
var $d563d0cdbeba3673$var$getHighWaterMark = $jjqfv.getHighWaterMark;

var $juU80 = parcelRequire("juU80");
var $d563d0cdbeba3673$require$_require$codes = $juU80.codes;
var $d563d0cdbeba3673$var$ERR_INVALID_ARG_TYPE = $d563d0cdbeba3673$require$_require$codes.ERR_INVALID_ARG_TYPE, $d563d0cdbeba3673$var$ERR_STREAM_PUSH_AFTER_EOF = $d563d0cdbeba3673$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $d563d0cdbeba3673$var$ERR_METHOD_NOT_IMPLEMENTED = $d563d0cdbeba3673$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d563d0cdbeba3673$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $d563d0cdbeba3673$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $d563d0cdbeba3673$var$StringDecoder;
var $d563d0cdbeba3673$var$createReadableStreamAsyncIterator;
var $d563d0cdbeba3673$var$from;

(parcelRequire("dlqwk"))($d563d0cdbeba3673$var$Readable, $7TavY);
var $d563d0cdbeba3673$var$errorOrDestroy = $dMA3M.errorOrDestroy;
var $d563d0cdbeba3673$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $d563d0cdbeba3673$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $d563d0cdbeba3673$var$ReadableState(options, stream, isDuplex) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $d563d0cdbeba3673$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $d563d0cdbeba3673$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $l520z();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $d563d0cdbeba3673$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d563d0cdbeba3673$var$Readable(options) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    if (!(this instanceof $d563d0cdbeba3673$var$Readable)) return new $d563d0cdbeba3673$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $d563d0cdbeba3673$var$Duplex;
    this._readableState = new $d563d0cdbeba3673$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $7TavY.call(this);
}
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$d563d0cdbeba3673$var$Readable.prototype.destroy = $dMA3M.destroy;
$d563d0cdbeba3673$var$Readable.prototype._undestroy = $dMA3M.undestroy;
$d563d0cdbeba3673$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d563d0cdbeba3673$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $d563d0cdbeba3673$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$d563d0cdbeba3673$var$Readable.prototype.unshift = function(chunk) {
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, null, true, false);
};
function $d563d0cdbeba3673$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $d563d0cdbeba3673$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $d563d0cdbeba3673$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $d563d0cdbeba3673$var$chunkInvalid(state, chunk);
        if (er) $d563d0cdbeba3673$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $d563d0cdbeba3673$require$Buffer.prototype) chunk = $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $d563d0cdbeba3673$var$errorOrDestroy(stream, new $d563d0cdbeba3673$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $d563d0cdbeba3673$var$errorOrDestroy(stream, new $d563d0cdbeba3673$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
                    else $d563d0cdbeba3673$var$maybeReadMore(stream, state);
                } else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $d563d0cdbeba3673$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d563d0cdbeba3673$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $d563d0cdbeba3673$var$emitReadable(stream);
    }
    $d563d0cdbeba3673$var$maybeReadMore(stream, state);
}
function $d563d0cdbeba3673$var$chunkInvalid(state, chunk) {
    var er;
    if (!$d563d0cdbeba3673$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $d563d0cdbeba3673$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$d563d0cdbeba3673$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$d563d0cdbeba3673$var$Readable.prototype.setEncoding = function(enc) {
    if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $d563d0cdbeba3673$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $d563d0cdbeba3673$var$MAX_HWM = 0x40000000;
function $d563d0cdbeba3673$var$computeNewHighWaterMark(n) {
    if (n >= $d563d0cdbeba3673$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $d563d0cdbeba3673$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d563d0cdbeba3673$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$d563d0cdbeba3673$var$Readable.prototype.read = function(n) {
    $d563d0cdbeba3673$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d563d0cdbeba3673$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $d563d0cdbeba3673$var$endReadable(this);
        else $d563d0cdbeba3673$var$emitReadable(this);
        return null;
    }
    n = $d563d0cdbeba3673$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d563d0cdbeba3673$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $d563d0cdbeba3673$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d563d0cdbeba3673$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $d563d0cdbeba3673$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $d563d0cdbeba3673$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d563d0cdbeba3673$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d563d0cdbeba3673$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d563d0cdbeba3673$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $d563d0cdbeba3673$var$onEofChunk(stream, state) {
    $d563d0cdbeba3673$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $d563d0cdbeba3673$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $d563d0cdbeba3673$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d563d0cdbeba3673$var$emitReadable(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d563d0cdbeba3673$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$emitReadable_, stream);
    }
}
function $d563d0cdbeba3673$var$emitReadable_(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d563d0cdbeba3673$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d563d0cdbeba3673$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$maybeReadMore_, stream, state);
    }
}
function $d563d0cdbeba3673$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $d563d0cdbeba3673$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d563d0cdbeba3673$var$Readable.prototype._read = function(n) {
    $d563d0cdbeba3673$var$errorOrDestroy(this, new $d563d0cdbeba3673$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$d563d0cdbeba3673$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $d563d0cdbeba3673$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d563d0cdbeba3673$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d563d0cdbeba3673$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $d563d0cdbeba3673$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $d563d0cdbeba3673$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $d563d0cdbeba3673$var$debug("ondata");
        var ret = dest.write(chunk);
        $d563d0cdbeba3673$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d563d0cdbeba3673$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $d563d0cdbeba3673$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d563d0cdbeba3673$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($d563d0cdbeba3673$var$EElistenerCount(dest, "error") === 0) $d563d0cdbeba3673$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $d563d0cdbeba3673$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $d563d0cdbeba3673$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $d563d0cdbeba3673$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $d563d0cdbeba3673$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $d563d0cdbeba3673$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $d563d0cdbeba3673$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $d563d0cdbeba3673$var$flow(src);
        }
    };
}
$d563d0cdbeba3673$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $d563d0cdbeba3673$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$d563d0cdbeba3673$var$Readable.prototype.on = function(ev, fn) {
    var res = $7TavY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d563d0cdbeba3673$var$debug("on readable", state.length, state.reading);
            if (state.length) $d563d0cdbeba3673$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($d563d0cdbeba3673$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.addListener = $d563d0cdbeba3673$var$Readable.prototype.on;
$d563d0cdbeba3673$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7TavY.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($d563d0cdbeba3673$var$updateReadableListening, this);
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7TavY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($d563d0cdbeba3673$var$updateReadableListening, this);
    return res;
};
function $d563d0cdbeba3673$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $d563d0cdbeba3673$var$nReadingNextTick(self) {
    $d563d0cdbeba3673$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d563d0cdbeba3673$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $d563d0cdbeba3673$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $d563d0cdbeba3673$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$resume_, stream, state);
    }
}
function $d563d0cdbeba3673$var$resume_(stream, state) {
    $d563d0cdbeba3673$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $d563d0cdbeba3673$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d563d0cdbeba3673$var$Readable.prototype.pause = function() {
    $d563d0cdbeba3673$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d563d0cdbeba3673$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $d563d0cdbeba3673$var$flow(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d563d0cdbeba3673$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $d563d0cdbeba3673$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $d563d0cdbeba3673$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $d563d0cdbeba3673$var$kProxyEvents.length; n++)stream.on($d563d0cdbeba3673$var$kProxyEvents[n], this.emit.bind(this, $d563d0cdbeba3673$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $d563d0cdbeba3673$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $d563d0cdbeba3673$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($d563d0cdbeba3673$var$createReadableStreamAsyncIterator === undefined) $d563d0cdbeba3673$var$createReadableStreamAsyncIterator = (parcelRequire("c6IHI"));
    return $d563d0cdbeba3673$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$d563d0cdbeba3673$var$Readable._fromList = $d563d0cdbeba3673$var$fromList;
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d563d0cdbeba3673$var$endReadable(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$endReadableNT, state, stream);
    }
}
function $d563d0cdbeba3673$var$endReadableNT(state, stream) {
    $d563d0cdbeba3673$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $d563d0cdbeba3673$var$Readable.from = function(iterable, opts) {
    if ($d563d0cdbeba3673$var$from === undefined) $d563d0cdbeba3673$var$from = (parcelRequire("gSI6Z"));
    return $d563d0cdbeba3673$var$from($d563d0cdbeba3673$var$Readable, iterable, opts);
};
function $d563d0cdbeba3673$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("7TavY", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRequire.register("l520z", function(module, exports) {
"use strict";
function $f58b9f61eb9af493$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f58b9f61eb9af493$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f58b9f61eb9af493$var$ownKeys(Object(source), true).forEach(function(key) {
            $f58b9f61eb9af493$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f58b9f61eb9af493$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f58b9f61eb9af493$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f58b9f61eb9af493$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f58b9f61eb9af493$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f58b9f61eb9af493$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f58b9f61eb9af493$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f58b9f61eb9af493$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $6ZWSX = parcelRequire("6ZWSX");
var $f58b9f61eb9af493$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $f58b9f61eb9af493$var$inspect = $kjyEk.inspect;
var $f58b9f61eb9af493$var$custom = $f58b9f61eb9af493$var$inspect && $f58b9f61eb9af493$var$inspect.custom || "inspect";
function $f58b9f61eb9af493$var$copyBuffer(src, target, offset) {
    $f58b9f61eb9af493$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $f58b9f61eb9af493$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $f58b9f61eb9af493$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $f58b9f61eb9af493$var$Buffer.alloc(0);
                var ret = $f58b9f61eb9af493$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $f58b9f61eb9af493$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $f58b9f61eb9af493$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $f58b9f61eb9af493$var$custom,
            value: function value(_, options) {
                return $f58b9f61eb9af493$var$inspect(this, $f58b9f61eb9af493$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("dMA3M", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $a08bbad2eabf9353$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
    });
    return this;
}
function $a08bbad2eabf9353$var$emitErrorAndCloseNT(self, err) {
    $a08bbad2eabf9353$var$emitErrorNT(self, err);
    $a08bbad2eabf9353$var$emitCloseNT(self);
}
function $a08bbad2eabf9353$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $a08bbad2eabf9353$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a08bbad2eabf9353$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $a08bbad2eabf9353$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $a08bbad2eabf9353$var$destroy,
    undestroy: $a08bbad2eabf9353$var$undestroy,
    errorOrDestroy: $a08bbad2eabf9353$var$errorOrDestroy
};

});

parcelRequire.register("jjqfv", function(module, exports) {
"use strict";

var $juU80 = parcelRequire("juU80");
var $e0f427330e62d0b4$var$ERR_INVALID_OPT_VALUE = $juU80.codes.ERR_INVALID_OPT_VALUE;
function $e0f427330e62d0b4$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $e0f427330e62d0b4$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $e0f427330e62d0b4$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $e0f427330e62d0b4$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $e0f427330e62d0b4$var$getHighWaterMark
};

});
parcelRequire.register("juU80", function(module, exports) {

$parcel$export(module.exports, "codes", () => $e31c5b8dd6d6ccf7$export$e45cb6485273080e, (v) => $e31c5b8dd6d6ccf7$export$e45cb6485273080e = v);
var $e31c5b8dd6d6ccf7$export$e45cb6485273080e;
"use strict";
function $e31c5b8dd6d6ccf7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e31c5b8dd6d6ccf7$var$codes = {};
function $e31c5b8dd6d6ccf7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $e31c5b8dd6d6ccf7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $e31c5b8dd6d6ccf7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $e31c5b8dd6d6ccf7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $e31c5b8dd6d6ccf7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e31c5b8dd6d6ccf7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $e31c5b8dd6d6ccf7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $e31c5b8dd6d6ccf7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($e31c5b8dd6d6ccf7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($e31c5b8dd6d6ccf7$var$oneOf(expected, "type"));
    else {
        var type = $e31c5b8dd6d6ccf7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($e31c5b8dd6d6ccf7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$e31c5b8dd6d6ccf7$export$e45cb6485273080e = $e31c5b8dd6d6ccf7$var$codes;

});


parcelRequire.register("gymWQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $c0d19f59fee501bd$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $c0d19f59fee501bd$var$Duplex;

var $ijRUb = parcelRequire("ijRUb");

var $77F6W = parcelRequire("77F6W");

(parcelRequire("dlqwk"))($c0d19f59fee501bd$var$Duplex, $ijRUb);
// Allow the keys array to be GC'ed.
var $c0d19f59fee501bd$var$keys = $c0d19f59fee501bd$var$objectKeys($77F6W.prototype);
for(var $c0d19f59fee501bd$var$v = 0; $c0d19f59fee501bd$var$v < $c0d19f59fee501bd$var$keys.length; $c0d19f59fee501bd$var$v++){
    var $c0d19f59fee501bd$var$method = $c0d19f59fee501bd$var$keys[$c0d19f59fee501bd$var$v];
    if (!$c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method]) $c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method] = $77F6W.prototype[$c0d19f59fee501bd$var$method];
}
function $c0d19f59fee501bd$var$Duplex(options) {
    if (!(this instanceof $c0d19f59fee501bd$var$Duplex)) return new $c0d19f59fee501bd$var$Duplex(options);
    $ijRUb.call(this, options);
    $77F6W.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $c0d19f59fee501bd$var$onend);
        }
    }
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $c0d19f59fee501bd$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($c0d19f59fee501bd$var$onEndNT, this);
}
function $c0d19f59fee501bd$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("77F6W", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $52f9139fc7db56d4$var$Writable;
/* <replacement> */ function $52f9139fc7db56d4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $52f9139fc7db56d4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $52f9139fc7db56d4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $52f9139fc7db56d4$var$Duplex;
/*</replacement>*/ $52f9139fc7db56d4$var$Writable.WritableState = $52f9139fc7db56d4$var$WritableState;

/*<replacement>*/ var $52f9139fc7db56d4$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $7TavY = parcelRequire("7TavY");

var $6ZWSX = parcelRequire("6ZWSX");
var $52f9139fc7db56d4$require$Buffer = $6ZWSX.Buffer;
var $52f9139fc7db56d4$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk) {
    return $52f9139fc7db56d4$require$Buffer.from(chunk);
}
function $52f9139fc7db56d4$var$_isUint8Array(obj) {
    return $52f9139fc7db56d4$require$Buffer.isBuffer(obj) || obj instanceof $52f9139fc7db56d4$var$OurUint8Array;
}

var $dMA3M = parcelRequire("dMA3M");

var $jjqfv = parcelRequire("jjqfv");
var $52f9139fc7db56d4$var$getHighWaterMark = $jjqfv.getHighWaterMark;

var $juU80 = parcelRequire("juU80");
var $52f9139fc7db56d4$require$_require$codes = $juU80.codes;
var $52f9139fc7db56d4$var$ERR_INVALID_ARG_TYPE = $52f9139fc7db56d4$require$_require$codes.ERR_INVALID_ARG_TYPE, $52f9139fc7db56d4$var$ERR_METHOD_NOT_IMPLEMENTED = $52f9139fc7db56d4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $52f9139fc7db56d4$var$ERR_MULTIPLE_CALLBACK = $52f9139fc7db56d4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $52f9139fc7db56d4$var$ERR_STREAM_CANNOT_PIPE = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $52f9139fc7db56d4$var$ERR_STREAM_DESTROYED = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_DESTROYED, $52f9139fc7db56d4$var$ERR_STREAM_NULL_VALUES = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_NULL_VALUES, $52f9139fc7db56d4$var$ERR_STREAM_WRITE_AFTER_END = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $52f9139fc7db56d4$var$ERR_UNKNOWN_ENCODING = $52f9139fc7db56d4$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $52f9139fc7db56d4$var$errorOrDestroy = $dMA3M.errorOrDestroy;

(parcelRequire("dlqwk"))($52f9139fc7db56d4$var$Writable, $7TavY);
function $52f9139fc7db56d4$var$nop() {}

function $52f9139fc7db56d4$var$WritableState(options, stream, isDuplex) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $52f9139fc7db56d4$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $52f9139fc7db56d4$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $52f9139fc7db56d4$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(this);
}
$52f9139fc7db56d4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($52f9139fc7db56d4$var$WritableState.prototype, "buffer", {
            get: $52f9139fc7db56d4$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $52f9139fc7db56d4$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $52f9139fc7db56d4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($52f9139fc7db56d4$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($52f9139fc7db56d4$var$realHasInstance.call(this, object)) return true;
            if (this !== $52f9139fc7db56d4$var$Writable) return false;
            return object && object._writableState instanceof $52f9139fc7db56d4$var$WritableState;
        }
    });
} else $52f9139fc7db56d4$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $52f9139fc7db56d4$var$Writable(options) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $52f9139fc7db56d4$var$Duplex;
    if (!isDuplex && !$52f9139fc7db56d4$var$realHasInstance.call($52f9139fc7db56d4$var$Writable, this)) return new $52f9139fc7db56d4$var$Writable(options);
    this._writableState = new $52f9139fc7db56d4$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $7TavY.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$52f9139fc7db56d4$var$Writable.prototype.pipe = function() {
    $52f9139fc7db56d4$var$errorOrDestroy(this, new $52f9139fc7db56d4$var$ERR_STREAM_CANNOT_PIPE());
};
function $52f9139fc7db56d4$var$writeAfterEnd(stream, cb) {
    var er = new $52f9139fc7db56d4$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $52f9139fc7db56d4$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $52f9139fc7db56d4$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $52f9139fc7db56d4$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$52f9139fc7db56d4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $52f9139fc7db56d4$var$_isUint8Array(chunk);
    if (isBuf && !$52f9139fc7db56d4$require$Buffer.isBuffer(chunk)) chunk = $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $52f9139fc7db56d4$var$nop;
    if (state.ending) $52f9139fc7db56d4$var$writeAfterEnd(this, cb);
    else if (isBuf || $52f9139fc7db56d4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $52f9139fc7db56d4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$52f9139fc7db56d4$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$52f9139fc7db56d4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(this, state);
    }
};
$52f9139fc7db56d4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $52f9139fc7db56d4$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $52f9139fc7db56d4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $52f9139fc7db56d4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $52f9139fc7db56d4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $52f9139fc7db56d4$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($52f9139fc7db56d4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    }
}
function $52f9139fc7db56d4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $52f9139fc7db56d4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $52f9139fc7db56d4$var$ERR_MULTIPLE_CALLBACK();
    $52f9139fc7db56d4$var$onwriteStateUpdate(state);
    if (er) $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $52f9139fc7db56d4$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($52f9139fc7db56d4$var$afterWrite, stream, state, finished, cb);
        else $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb);
    }
}
function $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $52f9139fc7db56d4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $52f9139fc7db56d4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $52f9139fc7db56d4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $52f9139fc7db56d4$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$52f9139fc7db56d4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $52f9139fc7db56d4$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$52f9139fc7db56d4$var$Writable.prototype._writev = null;
$52f9139fc7db56d4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $52f9139fc7db56d4$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $52f9139fc7db56d4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $52f9139fc7db56d4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $52f9139fc7db56d4$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    });
}
function $52f9139fc7db56d4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($52f9139fc7db56d4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $52f9139fc7db56d4$var$finishMaybe(stream, state) {
    var need = $52f9139fc7db56d4$var$needFinish(state);
    if (need) {
        $52f9139fc7db56d4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $52f9139fc7db56d4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $52f9139fc7db56d4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$52f9139fc7db56d4$var$Writable.prototype.destroy = $dMA3M.destroy;
$52f9139fc7db56d4$var$Writable.prototype._undestroy = $dMA3M.undestroy;
$52f9139fc7db56d4$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRequire.register("c6IHI", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $8d08b8e50a33e6d4$var$_Object$setPrototypeO;
function $8d08b8e50a33e6d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $3mcid = parcelRequire("3mcid");
var $8d08b8e50a33e6d4$var$kLastResolve = Symbol("lastResolve");
var $8d08b8e50a33e6d4$var$kLastReject = Symbol("lastReject");
var $8d08b8e50a33e6d4$var$kError = Symbol("error");
var $8d08b8e50a33e6d4$var$kEnded = Symbol("ended");
var $8d08b8e50a33e6d4$var$kLastPromise = Symbol("lastPromise");
var $8d08b8e50a33e6d4$var$kHandlePromise = Symbol("handlePromise");
var $8d08b8e50a33e6d4$var$kStream = Symbol("stream");
function $8d08b8e50a33e6d4$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $8d08b8e50a33e6d4$var$readAndResolve(iter) {
    var resolve = iter[$8d08b8e50a33e6d4$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$8d08b8e50a33e6d4$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$8d08b8e50a33e6d4$var$kLastPromise] = null;
            iter[$8d08b8e50a33e6d4$var$kLastResolve] = null;
            iter[$8d08b8e50a33e6d4$var$kLastReject] = null;
            resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
        }
    }
}
function $8d08b8e50a33e6d4$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($8d08b8e50a33e6d4$var$readAndResolve, iter);
}
function $8d08b8e50a33e6d4$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$8d08b8e50a33e6d4$var$kEnded]) {
                resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
                return;
            }
            iter[$8d08b8e50a33e6d4$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $8d08b8e50a33e6d4$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $8d08b8e50a33e6d4$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($8d08b8e50a33e6d4$var$_Object$setPrototypeO = {
    get stream () {
        return this[$8d08b8e50a33e6d4$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$8d08b8e50a33e6d4$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$8d08b8e50a33e6d4$var$kEnded]) return Promise.resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        if (this[$8d08b8e50a33e6d4$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$8d08b8e50a33e6d4$var$kError]) reject(_this[$8d08b8e50a33e6d4$var$kError]);
                else resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$8d08b8e50a33e6d4$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($8d08b8e50a33e6d4$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$8d08b8e50a33e6d4$var$kStream].read();
            if (data !== null) return Promise.resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
            promise = new Promise(this[$8d08b8e50a33e6d4$var$kHandlePromise]);
        }
        this[$8d08b8e50a33e6d4$var$kLastPromise] = promise;
        return promise;
    }
}, $8d08b8e50a33e6d4$var$_defineProperty($8d08b8e50a33e6d4$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $8d08b8e50a33e6d4$var$_defineProperty($8d08b8e50a33e6d4$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$8d08b8e50a33e6d4$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        });
    });
}), $8d08b8e50a33e6d4$var$_Object$setPrototypeO), $8d08b8e50a33e6d4$var$AsyncIteratorPrototype);
var $8d08b8e50a33e6d4$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($8d08b8e50a33e6d4$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kStream, {
        value: stream,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kLastResolve, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kLastReject, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kError, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$8d08b8e50a33e6d4$var$kStream].read();
            if (data) {
                iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
                resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
            } else {
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = resolve;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
    $3mcid(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$8d08b8e50a33e6d4$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
                reject(err);
            }
            iterator[$8d08b8e50a33e6d4$var$kError] = err;
            return;
        }
        var resolve = iterator[$8d08b8e50a33e6d4$var$kLastResolve];
        if (resolve !== null) {
            iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
            iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
            iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
            resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        }
        iterator[$8d08b8e50a33e6d4$var$kEnded] = true;
    });
    stream.on("readable", $8d08b8e50a33e6d4$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $8d08b8e50a33e6d4$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("3mcid", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $juU80 = parcelRequire("juU80");
var $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE = $juU80.codes.ERR_STREAM_PREMATURE_CLOSE;
function $271cf646c183c13f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $271cf646c183c13f$var$noop() {}
function $271cf646c183c13f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $271cf646c183c13f$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $271cf646c183c13f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $271cf646c183c13f$var$once(callback || $271cf646c183c13f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($271cf646c183c13f$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $271cf646c183c13f$var$eos;

});


parcelRequire.register("gSI6Z", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("8hRuT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $608968b8987d674a$var$Transform;

var $juU80 = parcelRequire("juU80");
var $608968b8987d674a$require$_require$codes = $juU80.codes;
var $608968b8987d674a$var$ERR_METHOD_NOT_IMPLEMENTED = $608968b8987d674a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $608968b8987d674a$var$ERR_MULTIPLE_CALLBACK = $608968b8987d674a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $608968b8987d674a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $608968b8987d674a$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $608968b8987d674a$var$ERR_TRANSFORM_WITH_LENGTH_0 = $608968b8987d674a$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $gymWQ = parcelRequire("gymWQ");

(parcelRequire("dlqwk"))($608968b8987d674a$var$Transform, $gymWQ);
function $608968b8987d674a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $608968b8987d674a$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $608968b8987d674a$var$Transform(options) {
    if (!(this instanceof $608968b8987d674a$var$Transform)) return new $608968b8987d674a$var$Transform(options);
    $gymWQ.call(this, options);
    this._transformState = {
        afterTransform: $608968b8987d674a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $608968b8987d674a$var$prefinish);
}
function $608968b8987d674a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $608968b8987d674a$var$done(_this, er, data);
    });
    else $608968b8987d674a$var$done(this, null, null);
}
$608968b8987d674a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gymWQ.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$608968b8987d674a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $608968b8987d674a$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$608968b8987d674a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$608968b8987d674a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$608968b8987d674a$var$Transform.prototype._destroy = function(err, cb) {
    $gymWQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $608968b8987d674a$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $608968b8987d674a$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $608968b8987d674a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("fbZXo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $b0f7f16f37d01e98$var$PassThrough;

var $8hRuT = parcelRequire("8hRuT");

(parcelRequire("dlqwk"))($b0f7f16f37d01e98$var$PassThrough, $8hRuT);
function $b0f7f16f37d01e98$var$PassThrough(options) {
    if (!(this instanceof $b0f7f16f37d01e98$var$PassThrough)) return new $b0f7f16f37d01e98$var$PassThrough(options);
    $8hRuT.call(this, options);
}
$b0f7f16f37d01e98$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("etwQ4", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $a89d3f3581dab9ef$var$eos;
function $a89d3f3581dab9ef$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $juU80 = parcelRequire("juU80");
var $a89d3f3581dab9ef$require$_require$codes = $juU80.codes;
var $a89d3f3581dab9ef$var$ERR_MISSING_ARGS = $a89d3f3581dab9ef$require$_require$codes.ERR_MISSING_ARGS, $a89d3f3581dab9ef$var$ERR_STREAM_DESTROYED = $a89d3f3581dab9ef$require$_require$codes.ERR_STREAM_DESTROYED;
function $a89d3f3581dab9ef$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a89d3f3581dab9ef$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $a89d3f3581dab9ef$var$destroyer(stream, reading, writing, callback) {
    callback = $a89d3f3581dab9ef$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($a89d3f3581dab9ef$var$eos === undefined) $a89d3f3581dab9ef$var$eos = (parcelRequire("3mcid"));
    $a89d3f3581dab9ef$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($a89d3f3581dab9ef$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $a89d3f3581dab9ef$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $a89d3f3581dab9ef$var$call(fn) {
    fn();
}
function $a89d3f3581dab9ef$var$pipe(from, to) {
    return from.pipe(to);
}
function $a89d3f3581dab9ef$var$popCallback(streams) {
    if (!streams.length) return $a89d3f3581dab9ef$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $a89d3f3581dab9ef$var$noop;
    return streams.pop();
}
function $a89d3f3581dab9ef$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a89d3f3581dab9ef$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a89d3f3581dab9ef$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a89d3f3581dab9ef$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a89d3f3581dab9ef$var$call);
            if (reading) return;
            destroys.forEach($a89d3f3581dab9ef$var$call);
            callback(error);
        });
    });
    return streams.reduce($a89d3f3581dab9ef$var$pipe);
}
module.exports = $a89d3f3581dab9ef$var$pipeline;

});


parcelRequire.register("6E9kG", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $jVUXf = parcelRequire("jVUXf");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $jVUXf(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $jVUXf(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $jVUXf(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($jVUXf.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRequire.register("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $5KK3w = parcelRequire("5KK3w");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($5KK3w.mont(priv.modulus)).redPow(new $5KK3w(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $5KK3w($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $5KK3w(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($5KK3w.mont(priv.prime1));
    var c2 = blinded.toRed($5KK3w.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});
parcelRequire.register("5KK3w", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRequire.register("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRequire.register("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $dEXSZ = parcelRequire("dEXSZ");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $dEXSZ(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRequire.register("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRequire.register("hSu7V", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $dEXSZ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $dEXSZ.red(conf.prime) : $dEXSZ.mont(this.p);
    // Useful for many curves
    this.zero = new $dEXSZ(0).toRed(this.red);
    this.one = new $dEXSZ(1).toRed(this.red);
    this.two = new $dEXSZ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $dEXSZ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $dEXSZ = parcelRequire("dEXSZ");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $dEXSZ(conf.a, 16).toRed(this.red);
    this.b = new $dEXSZ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $dEXSZ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $dEXSZ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $dEXSZ(vec.a, 16),
            b: new $dEXSZ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $dEXSZ.mont(num);
    var tinv = new $dEXSZ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $dEXSZ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $dEXSZ(1);
    var y1 = new $dEXSZ(0);
    var x2 = new $dEXSZ(0);
    var y2 = new $dEXSZ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $dEXSZ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $dEXSZ(x, 16);
        this.y = new $dEXSZ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $dEXSZ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $dEXSZ(0);
    } else {
        this.x = new $dEXSZ(x, 16);
        this.y = new $dEXSZ(y, 16);
        this.z = new $dEXSZ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $dEXSZ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("av2Yx", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $dEXSZ(conf.a, 16).toRed(this.red);
    this.b = new $dEXSZ(conf.b, 16).toRed(this.red);
    this.i4 = new $dEXSZ(4).toRed(this.red).redInvm();
    this.two = new $dEXSZ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $dEXSZ(x, 16);
        this.z = new $dEXSZ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $dEXSZ = parcelRequire("dEXSZ");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $dEXSZ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $dEXSZ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $dEXSZ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $dEXSZ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $dEXSZ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $dEXSZ(x, 16);
        this.y = new $dEXSZ(y, 16);
        this.z = z ? new $dEXSZ(z, 16) : this.curve.one;
        this.t = t && new $dEXSZ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRequire.register("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRequire.register("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRequire.register("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRequire.register("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRequire.register("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRequire.register("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRequire.register("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRequire.register("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("220Zx", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $dEXSZ(2));
    for(;;){
        var priv = new $dEXSZ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $dEXSZ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $dEXSZ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $dEXSZ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $dEXSZ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $dEXSZ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRequire.register("lPqzs", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $dEXSZ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("i46nc", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $dEXSZ(options.r, 16);
    this.s = new $dEXSZ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $dEXSZ(r);
    this.s = new $dEXSZ(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRequire.register("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRequire.register("7XcGE", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $dEXSZ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});



parcelRequire.register("jVUXf", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRequire.register("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRequire.register("10gXo", function(module, exports) {
"use strict";
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("dEXSZ"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRequire.register("8fBln", function(module, exports) {
"use strict";

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRequire.register("ljw8S", function(module, exports) {
"use strict";
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRequire.register("2j6ve", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRequire.register("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "SlowBuffer" || $45c80a3e8b7e5b65$var$key === "Buffer") continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "allocUnsafe" || $45c80a3e8b7e5b65$var$key === "allocUnsafeSlow") continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRequire.register("h4y6g", function(module, exports) {
"use strict";

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRequire.register("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
"use strict";

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRequire.register("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRequire.register("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
"use strict";
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRequire.register("bPffB", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRequire.register("89TTw", function(module, exports) {
"use strict";
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRequire.register("fkoHA", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $dEXSZ = parcelRequire("dEXSZ");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $dEXSZ(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRequire.register("9wGrq", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRequire.register("5JhaY", function(module, exports) {
"use strict";
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRequire.register("3TcQc", function(module, exports) {
"use strict";
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});


parcelRequire.register("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRequire.register("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRequire.register("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRequire.register("aYksR", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRequire.register("fQdau", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $jVUXf = parcelRequire("jVUXf");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $jVUXf.mont(pub.modulus);
    sig = new $jVUXf(sig).toRed(red);
    sig = sig.redPow(new $jVUXf(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $jVUXf.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $jVUXf(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRequire.register("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $dEXSZ = parcelRequire("dEXSZ");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $dEXSZ(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRequire.register("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRequire.register("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $dEXSZ = parcelRequire("dEXSZ");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $dEXSZ(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $dEXSZ($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $dEXSZ($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRequire.register("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRequire.register("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRequire.register("3pDg3", function(module, exports) {

var $dEXSZ = parcelRequire("dEXSZ");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($dEXSZ.mont(key.modulus)).redPow(new $dEXSZ(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRequire.register("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $dEXSZ = parcelRequire("dEXSZ");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $dEXSZ(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $dEXSZ(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRequire.register("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});


parcelRequire.register("bpzVP", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $84ede6cc3bc00614$require$Buffer = $1U9GM.Buffer;

var $1Awji = parcelRequire("1Awji");
var $84ede6cc3bc00614$var$MAX_OCTET = 0x80, $84ede6cc3bc00614$var$CLASS_UNIVERSAL = 0, $84ede6cc3bc00614$var$PRIMITIVE_BIT = 0x20, $84ede6cc3bc00614$var$TAG_SEQ = 0x10, $84ede6cc3bc00614$var$TAG_INT = 0x02, $84ede6cc3bc00614$var$ENCODED_TAG_SEQ = $84ede6cc3bc00614$var$TAG_SEQ | $84ede6cc3bc00614$var$PRIMITIVE_BIT | $84ede6cc3bc00614$var$CLASS_UNIVERSAL << 6, $84ede6cc3bc00614$var$ENCODED_TAG_INT = $84ede6cc3bc00614$var$TAG_INT | $84ede6cc3bc00614$var$CLASS_UNIVERSAL << 6;
function $84ede6cc3bc00614$var$base64Url(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $84ede6cc3bc00614$var$signatureAsBuffer(signature) {
    if ($84ede6cc3bc00614$require$Buffer.isBuffer(signature)) return signature;
    else if ("string" === typeof signature) return $84ede6cc3bc00614$require$Buffer.from(signature, "base64");
    throw new TypeError("ECDSA signature must be a Base64 string or a Buffer");
}
function $84ede6cc3bc00614$var$derToJose(signature, alg) {
    signature = $84ede6cc3bc00614$var$signatureAsBuffer(signature);
    var paramBytes = $1Awji(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $84ede6cc3bc00614$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($84ede6cc3bc00614$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $84ede6cc3bc00614$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $84ede6cc3bc00614$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $84ede6cc3bc00614$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString("base64");
    dst = $84ede6cc3bc00614$var$base64Url(dst);
    return dst;
}
function $84ede6cc3bc00614$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $84ede6cc3bc00614$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $84ede6cc3bc00614$var$joseToDer(signature, alg) {
    signature = $84ede6cc3bc00614$var$signatureAsBuffer(signature);
    var paramBytes = $1Awji(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $84ede6cc3bc00614$var$countPadding(signature, 0, paramBytes);
    var sPadding = $84ede6cc3bc00614$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $84ede6cc3bc00614$var$MAX_OCTET;
    var dst = $84ede6cc3bc00614$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $84ede6cc3bc00614$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $84ede6cc3bc00614$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $84ede6cc3bc00614$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $84ede6cc3bc00614$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $84ede6cc3bc00614$var$derToJose,
    joseToDer: $84ede6cc3bc00614$var$joseToDer
};

});
parcelRequire.register("1Awji", function(module, exports) {
"use strict";
function $12823763f46b367f$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $12823763f46b367f$var$paramBytesForAlg = {
    ES256: $12823763f46b367f$var$getParamSize(256),
    ES384: $12823763f46b367f$var$getParamSize(384),
    ES512: $12823763f46b367f$var$getParamSize(521)
};
function $12823763f46b367f$var$getParamBytesForAlg(alg) {
    var paramBytes = $12823763f46b367f$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $12823763f46b367f$var$getParamBytesForAlg;

});



parcelRequire.register("1vKm0", function(module, exports) {
/*global module*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $119ca4998a9d6e3f$require$Buffer = $6ZWSX.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === "string") return obj;
    if (typeof obj === "number" || $119ca4998a9d6e3f$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRequire.register("jVVQU", function(module, exports) {
/*global module*/ 
var $1U9GM = parcelRequire("1U9GM");
var $03beb692814012e4$require$Buffer = $1U9GM.Buffer;

var $8prZJ = parcelRequire("8prZJ");

var $f2m41 = parcelRequire("f2m41");

var $ioRHp = parcelRequire("ioRHp");

var $1vKm0 = parcelRequire("1vKm0");

var $N7Lcz = parcelRequire("N7Lcz");
var $03beb692814012e4$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $03beb692814012e4$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === "[object Object]";
}
function $03beb692814012e4$var$safeJsonParse(thing) {
    if ($03beb692814012e4$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $03beb692814012e4$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split(".", 1)[0];
    return $03beb692814012e4$var$safeJsonParse($03beb692814012e4$require$Buffer.from(encodedHeader, "base64").toString("binary"));
}
function $03beb692814012e4$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split(".", 2).join(".");
}
function $03beb692814012e4$var$signatureFromJWS(jwsSig) {
    return jwsSig.split(".")[2];
}
function $03beb692814012e4$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || "utf8";
    var payload = jwsSig.split(".")[1];
    return $03beb692814012e4$require$Buffer.from(payload, "base64").toString(encoding);
}
function $03beb692814012e4$var$isValidJws(string) {
    return $03beb692814012e4$var$JWS_REGEX.test(string) && !!$03beb692814012e4$var$headerFromJWS(string);
}
function $03beb692814012e4$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $1vKm0(jwsSig);
    var signature = $03beb692814012e4$var$signatureFromJWS(jwsSig);
    var securedInput = $03beb692814012e4$var$securedInputFromJWS(jwsSig);
    var algo = $f2m41(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $03beb692814012e4$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $1vKm0(jwsSig);
    if (!$03beb692814012e4$var$isValidJws(jwsSig)) return null;
    var header = $03beb692814012e4$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $03beb692814012e4$var$payloadFromJWS(jwsSig);
    if (header.typ === "JWT" || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $03beb692814012e4$var$signatureFromJWS(jwsSig)
    };
}
function $03beb692814012e4$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret || opts.publicKey || opts.key;
    var secretStream = new $8prZJ(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $8prZJ(opts.signature);
    this.secret.once("close", (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once("close", (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$N7Lcz.inherits($03beb692814012e4$var$VerifyStream, $ioRHp);
$03beb692814012e4$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $03beb692814012e4$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $03beb692814012e4$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit("done", valid, obj);
        this.emit("data", valid);
        this.emit("end");
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit("error", e);
        this.emit("close");
    }
};
$03beb692814012e4$var$VerifyStream.decode = $03beb692814012e4$var$jwsDecode;
$03beb692814012e4$var$VerifyStream.isValid = $03beb692814012e4$var$isValidJws;
$03beb692814012e4$var$VerifyStream.verify = $03beb692814012e4$var$jwsVerify;
module.exports = $03beb692814012e4$var$VerifyStream;

});



parcelRequire.register("1PSJS", function(module, exports) {

var $4r9pO = parcelRequire("4r9pO");

var $fUN9R = parcelRequire("fUN9R");

var $agX5Y = parcelRequire("agX5Y");

var $7SR5F = parcelRequire("7SR5F");

var $bkFw0 = parcelRequire("bkFw0");

var $jaMrC = parcelRequire("jaMrC");

var $4QOjN = parcelRequire("4QOjN");
var $156503e0affac391$var$PUB_KEY_ALGS = [
    "RS256",
    "RS384",
    "RS512",
    "ES256",
    "ES384",
    "ES512"
];
var $156503e0affac391$var$RSA_KEY_ALGS = [
    "RS256",
    "RS384",
    "RS512"
];
var $156503e0affac391$var$HS_ALGS = [
    "HS256",
    "HS384",
    "HS512"
];
if ($jaMrC) {
    $156503e0affac391$var$PUB_KEY_ALGS.splice(3, 0, "PS256", "PS384", "PS512");
    $156503e0affac391$var$RSA_KEY_ALGS.splice(3, 0, "PS256", "PS384", "PS512");
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === "function" && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    var done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== "number") return done(new $4r9pO("clockTimestamp must be a number"));
    if (options.nonce !== undefined && (typeof options.nonce !== "string" || options.nonce.trim() === "")) return done(new $4r9pO("nonce must be a non-empty string"));
    var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $4r9pO("jwt must be provided"));
    if (typeof jwtString !== "string") return done(new $4r9pO("jwt must be a string"));
    var parts = jwtString.split(".");
    if (parts.length !== 3) return done(new $4r9pO("jwt malformed"));
    var decodedToken;
    try {
        decodedToken = $7SR5F(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $4r9pO("invalid token"));
    var header = decodedToken.header;
    var getSecret;
    if (typeof secretOrPublicKey === "function") {
        if (!callback) return done(new $4r9pO("verify must be called asynchronous if secret or public key is provided as a callback"));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $4r9pO("error in secret or public key callback: " + err.message));
        var hasSignature = parts[2].trim() !== "";
        if (!hasSignature && secretOrPublicKey) return done(new $4r9pO("jwt signature is required"));
        if (hasSignature && !secretOrPublicKey) return done(new $4r9pO("secret or public key must be provided"));
        if (!hasSignature && !options.algorithms) options.algorithms = [
            "none"
        ];
        if (!options.algorithms) options.algorithms = ~secretOrPublicKey.toString().indexOf("BEGIN CERTIFICATE") || ~secretOrPublicKey.toString().indexOf("BEGIN PUBLIC KEY") ? $156503e0affac391$var$PUB_KEY_ALGS : ~secretOrPublicKey.toString().indexOf("BEGIN RSA PUBLIC KEY") ? $156503e0affac391$var$RSA_KEY_ALGS : $156503e0affac391$var$HS_ALGS;
        if (!~options.algorithms.indexOf(decodedToken.header.alg)) return done(new $4r9pO("invalid algorithm"));
        var valid;
        try {
            valid = $4QOjN.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $4r9pO("invalid signature"));
        var payload = decodedToken.payload;
        if (typeof payload.nbf !== "undefined" && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== "number") return done(new $4r9pO("invalid nbf value"));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $fUN9R("jwt not active", new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== "undefined" && !options.ignoreExpiration) {
            if (typeof payload.exp !== "number") return done(new $4r9pO("invalid exp value"));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $agX5Y("jwt expired", new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            var audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            var target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            var match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $4r9pO("jwt audience invalid. expected: " + audiences.join(" or ")));
        }
        if (options.issuer) {
            var invalid_issuer = typeof options.issuer === "string" && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $4r9pO("jwt issuer invalid. expected: " + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $4r9pO("jwt subject invalid. expected: " + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $4r9pO("jwt jwtid invalid. expected: " + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $4r9pO("jwt nonce invalid. expected: " + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== "number") return done(new $4r9pO("iat required when maxAge is specified"));
            var maxAgeTimestamp = $bkFw0(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === "undefined") return done(new $4r9pO('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $agX5Y("maxAge exceeded", new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            var signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRequire.register("4r9pO", function(module, exports) {
var $33b0fcc0293d21a5$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = "JsonWebTokenError";
    this.message = message;
    if (error) this.inner = error;
};
$33b0fcc0293d21a5$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$33b0fcc0293d21a5$var$JsonWebTokenError.prototype.constructor = $33b0fcc0293d21a5$var$JsonWebTokenError;
module.exports = $33b0fcc0293d21a5$var$JsonWebTokenError;

});

parcelRequire.register("fUN9R", function(module, exports) {

var $4r9pO = parcelRequire("4r9pO");
var $b96237c40ca813ad$var$NotBeforeError = function(message, date) {
    $4r9pO.call(this, message);
    this.name = "NotBeforeError";
    this.date = date;
};
$b96237c40ca813ad$var$NotBeforeError.prototype = Object.create($4r9pO.prototype);
$b96237c40ca813ad$var$NotBeforeError.prototype.constructor = $b96237c40ca813ad$var$NotBeforeError;
module.exports = $b96237c40ca813ad$var$NotBeforeError;

});

parcelRequire.register("agX5Y", function(module, exports) {

var $4r9pO = parcelRequire("4r9pO");
var $77a93d1635b1e624$var$TokenExpiredError = function(message, expiredAt) {
    $4r9pO.call(this, message);
    this.name = "TokenExpiredError";
    this.expiredAt = expiredAt;
};
$77a93d1635b1e624$var$TokenExpiredError.prototype = Object.create($4r9pO.prototype);
$77a93d1635b1e624$var$TokenExpiredError.prototype.constructor = $77a93d1635b1e624$var$TokenExpiredError;
module.exports = $77a93d1635b1e624$var$TokenExpiredError;

});

parcelRequire.register("bkFw0", function(module, exports) {

var $3pRq5 = parcelRequire("3pRq5");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === "string") {
        var milliseconds = $3pRq5(time);
        if (typeof milliseconds === "undefined") return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === "number") return timestamp + time;
    else return;
};

});
parcelRequire.register("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $27cd24efd2f930b8$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $27cd24efd2f930b8$var$w;
        case "days":
        case "day":
        case "d":
            return n * $27cd24efd2f930b8$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $27cd24efd2f930b8$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $27cd24efd2f930b8$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $27cd24efd2f930b8$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + "d";
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + "h";
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + "m";
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, "day");
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, "hour");
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, "minute");
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});


parcelRequire.register("jaMrC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $iHEx3 = parcelRequire("iHEx3");
module.exports = $iHEx3.satisfies($hPtJY.version, "^6.12.0 || >=8.0.0");

});
parcelRequire.register("iHEx3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
exports = module.exports = SemVer;
var debug;
/* istanbul ignore next */ typeof $hPtJY === "object" && $hPtJY.env && undefined;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = "2.0.0";
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = "0|[1-9]\\d*";
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = "[0-9]+";
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-][a-zA-Z0-9-]*";
// ## Main Version
// Three dot-separated numeric identifiers.
var MAINVERSION = R++;
src[MAINVERSION] = "(" + src[NUMERICIDENTIFIER] + ")\\." + "(" + src[NUMERICIDENTIFIER] + ")\\." + "(" + src[NUMERICIDENTIFIER] + ")";
var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = "(" + src[NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[NUMERICIDENTIFIERLOOSE] + ")\\." + "(" + src[NUMERICIDENTIFIERLOOSE] + ")";
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = "(?:" + src[NUMERICIDENTIFIER] + "|" + src[NONNUMERICIDENTIFIER] + ")";
var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = "(?:" + src[NUMERICIDENTIFIERLOOSE] + "|" + src[NONNUMERICIDENTIFIER] + ")";
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
var PRERELEASE = R++;
src[PRERELEASE] = "(?:-(" + src[PRERELEASEIDENTIFIER] + "(?:\\." + src[PRERELEASEIDENTIFIER] + ")*))";
var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = "(?:-?(" + src[PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + src[PRERELEASEIDENTIFIERLOOSE] + ")*))";
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = "[0-9A-Za-z-]+";
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
var BUILD = R++;
src[BUILD] = "(?:\\+(" + src[BUILDIDENTIFIER] + "(?:\\." + src[BUILDIDENTIFIER] + ")*))";
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
var FULL = R++;
var FULLPLAIN = "v?" + src[MAINVERSION] + src[PRERELEASE] + "?" + src[BUILD] + "?";
src[FULL] = "^" + FULLPLAIN + "$";
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = "[v=\\s]*" + src[MAINVERSIONLOOSE] + src[PRERELEASELOOSE] + "?" + src[BUILD] + "?";
var LOOSE = R++;
src[LOOSE] = "^" + LOOSEPLAIN + "$";
var GTLT = R++;
src[GTLT] = "((?:<|>)?=?)";
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + "|x|X|\\*";
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + "|x|X|\\*";
var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = "[v=\\s]*(" + src[XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIER] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIER] + ")" + "(?:" + src[PRERELEASE] + ")?" + src[BUILD] + "?" + ")?)?";
var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = "[v=\\s]*(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:\\.(" + src[XRANGEIDENTIFIERLOOSE] + ")" + "(?:" + src[PRERELEASELOOSE] + ")?" + src[BUILD] + "?" + ")?)?";
var XRANGE = R++;
src[XRANGE] = "^" + src[GTLT] + "\\s*" + src[XRANGEPLAIN] + "$";
var XRANGELOOSE = R++;
src[XRANGELOOSE] = "^" + src[GTLT] + "\\s*" + src[XRANGEPLAINLOOSE] + "$";
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = "(?:^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "})" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:\\.(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + "}))?" + "(?:$|[^\\d])";
// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = "(?:~>?)";
var TILDETRIM = R++;
src[TILDETRIM] = "(\\s*)" + src[LONETILDE] + "\\s+";
re[TILDETRIM] = new RegExp(src[TILDETRIM], "g");
var tildeTrimReplace = "$1~";
var TILDE = R++;
src[TILDE] = "^" + src[LONETILDE] + src[XRANGEPLAIN] + "$";
var TILDELOOSE = R++;
src[TILDELOOSE] = "^" + src[LONETILDE] + src[XRANGEPLAINLOOSE] + "$";
// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = "(?:\\^)";
var CARETTRIM = R++;
src[CARETTRIM] = "(\\s*)" + src[LONECARET] + "\\s+";
re[CARETTRIM] = new RegExp(src[CARETTRIM], "g");
var caretTrimReplace = "$1^";
var CARET = R++;
src[CARET] = "^" + src[LONECARET] + src[XRANGEPLAIN] + "$";
var CARETLOOSE = R++;
src[CARETLOOSE] = "^" + src[LONECARET] + src[XRANGEPLAINLOOSE] + "$";
// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = "^" + src[GTLT] + "\\s*(" + LOOSEPLAIN + ")$|^$";
var COMPARATOR = R++;
src[COMPARATOR] = "^" + src[GTLT] + "\\s*(" + FULLPLAIN + ")$|^$";
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = "(\\s*)" + src[GTLT] + "\\s*(" + LOOSEPLAIN + "|" + src[XRANGEPLAIN] + ")";
// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], "g");
var comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = "^\\s*(" + src[XRANGEPLAIN] + ")" + "\\s+-\\s+" + "(" + src[XRANGEPLAIN] + ")" + "\\s*$";
var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = "^\\s*(" + src[XRANGEPLAINLOOSE] + ")" + "\\s+-\\s+" + "(" + src[XRANGEPLAINLOOSE] + ")" + "\\s*$";
// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = "(<|>)?=?\\s*\\*";
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) re[i] = new RegExp(src[i]);
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? re[LOOSE] : re[FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== "string") throw new TypeError("Invalid Version: " + version);
    if (version.length > MAX_LENGTH) throw new TypeError("version is longer than " + MAX_LENGTH + " characters");
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug("SemVer", version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL]);
    if (!m) throw new TypeError("Invalid Version: " + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split(".").map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split(".") : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + "." + this.minor + "." + this.patch;
    if (this.prerelease.length) this.version += "-" + this.prerelease.join(".");
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug("prerelease compare", i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case "premajor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc("pre", identifier);
            break;
        case "preminor":
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc("pre", identifier);
            break;
        case "prepatch":
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
            if (this.prerelease.length === 0) this.inc("patch", identifier);
            this.inc("pre", identifier);
            break;
        case "major":
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "minor":
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case "patch":
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case "pre":
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error("invalid increment argument: " + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === "string") {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = "";
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = "pre";
            var defaultResult = "prerelease";
        }
        for(var key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compare(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.rcompare(a, b, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return eq(a, b, loose);
        case "!=":
            return neq(a, b, loose);
        case ">":
            return gt(a, b, loose);
        case ">=":
            return gte(a, b, loose);
        case "<":
            return lt(a, b, loose);
        case "<=":
            return lte(a, b, loose);
        default:
            throw new TypeError("Invalid operator: " + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    debug("comparator", comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = "";
    else this.value = this.operator + this.semver.version;
    debug("comp", this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError("Invalid comparator: " + comp);
    this.operator = m[1];
    if (this.operator === "=") this.operator = "";
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug("Comparator.test", version, this.options.loose);
    if (this.semver === ANY) return true;
    if (typeof version === "string") version = new SemVer(version, this.options);
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError("a Comparator is required");
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === "") {
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === "") {
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
    var sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
    var oppositeDirectionsLessThan = cmp(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
    var oppositeDirectionsGreaterThan = cmp(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== "object") options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First, split based on boolean or ||
    this.raw = range;
    this.set = range.split(/\s*\|\|\s*/).map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError("Invalid SemVer Range: " + range);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(" ").trim();
    }).join("||").trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    range = range.trim();
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug("hyphen replace", range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
    debug("comparator trim", range, re[COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(re[TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(re[CARETTRIM], caretTrimReplace);
    // normalize spaces
    range = range.split(/\s+/).join(" ");
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
    var set = range.split(" ").map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(" ").split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError("a Range is required");
    return this.set.some(function(thisComparators) {
        return thisComparators.every(function(thisComparator) {
            return range.set.some(function(rangeComparators) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(" ").trim().split(" ");
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug("comp", comp, options);
    comp = replaceCarets(comp, options);
    debug("caret", comp);
    comp = replaceTildes(comp, options);
    debug("tildes", comp);
    comp = replaceXRanges(comp, options);
    debug("xrange", comp);
    comp = replaceStars(comp, options);
    debug("stars", comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === "x" || id === "*";
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(" ");
}
function replaceTilde(comp, options) {
    var r = options.loose ? re[TILDELOOSE] : re[TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("tilde", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        else if (pr) {
            debug("replaceTilde pr", pr);
            ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
        debug("tilde return", ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(" ");
}
function replaceCaret(comp, options) {
    debug("caret", comp, options);
    var r = options.loose ? re[CARETLOOSE] : re[CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug("caret", comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = "";
        else if (isX(m)) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (isX(p)) {
            if (M === "0") ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
            else ret = ">=" + M + "." + m + ".0 <" + (+M + 1) + ".0.0";
        } else if (pr) {
            debug("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + "-" + pr + " <" + (+M + 1) + ".0.0";
        } else {
            debug("no pr");
            if (M === "0") {
                if (m === "0") ret = ">=" + M + "." + m + "." + p + " <" + M + "." + m + "." + (+p + 1);
                else ret = ">=" + M + "." + m + "." + p + " <" + M + "." + (+m + 1) + ".0";
            } else ret = ">=" + M + "." + m + "." + p + " <" + (+M + 1) + ".0.0";
        }
        debug("caret return", ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug("replaceXRanges", comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(" ");
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? re[XRANGELOOSE] : re[XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug("xRange", comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + "." + m + "." + p;
        } else if (xm) ret = ">=" + M + ".0.0 <" + (+M + 1) + ".0.0";
        else if (xp) ret = ">=" + M + "." + m + ".0 <" + M + "." + (+m + 1) + ".0";
        debug("xRange return", ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(re[STAR], "");
}
// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = "";
    else if (isX(fm)) from = ">=" + fM + ".0.0";
    else if (isX(fp)) from = ">=" + fM + "." + fm + ".0";
    else from = ">=" + from;
    if (isX(tM)) to = "";
    else if (isX(tm)) to = "<" + (+tM + 1) + ".0.0";
    else if (isX(tp)) to = "<" + tM + "." + (+tm + 1) + ".0";
    else if (tpr) to = "<=" + tM + "." + tm + "." + tp + "-" + tpr;
    else to = "<=" + to;
    return (from + " " + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === "string") version = new SemVer(version, this.options);
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer("0.0.0");
    if (range.test(minver)) return minver;
    minver = new SemVer("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error("Unexpected operation: " + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || "*";
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, "<", options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, ">", options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version) {
    if (version instanceof SemVer) return version;
    if (typeof version !== "string") return null;
    var match = version.match(re[COERCE]);
    if (match == null) return null;
    return parse(match[1] + "." + (match[2] || "0") + "." + (match[3] || "0"));
}

});



parcelRequire.register("8fWg9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $602cea95edb240cd$require$Buffer = $6ZWSX.Buffer;

var $bkFw0 = parcelRequire("bkFw0");

var $jaMrC = parcelRequire("jaMrC");

var $4QOjN = parcelRequire("4QOjN");

var $i96bT = parcelRequire("i96bT");

var $a0Xiz = parcelRequire("a0Xiz");

var $8fuXr = parcelRequire("8fuXr");

var $hzFRX = parcelRequire("hzFRX");

var $1hRv1 = parcelRequire("1hRv1");

var $eyfSd = parcelRequire("eyfSd");

var $eHmQe = parcelRequire("eHmQe");
var $602cea95edb240cd$var$SUPPORTED_ALGS = [
    "RS256",
    "RS384",
    "RS512",
    "ES256",
    "ES384",
    "ES512",
    "HS256",
    "HS384",
    "HS512",
    "none"
];
if ($jaMrC) $602cea95edb240cd$var$SUPPORTED_ALGS.splice(3, 0, "PS256", "PS384", "PS512");
var $602cea95edb240cd$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $8fuXr(value) || $eyfSd(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $8fuXr(value) || $eyfSd(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $eyfSd(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $i96bT.bind(null, $602cea95edb240cd$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $1hRv1,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $eyfSd,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $eyfSd,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $eyfSd,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $eyfSd,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $a0Xiz,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $eyfSd,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $a0Xiz,
        message: '"mutatePayload" must be a boolean'
    }
};
var $602cea95edb240cd$var$registered_claims_schema = {
    iat: {
        isValid: $hzFRX,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $hzFRX,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $hzFRX,
        message: '"nbf" should be a number of seconds'
    }
};
function $602cea95edb240cd$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$1hRv1(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        var validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $602cea95edb240cd$var$validateOptions(options) {
    return $602cea95edb240cd$var$validate($602cea95edb240cd$var$sign_options_schema, false, options, "options");
}
function $602cea95edb240cd$var$validatePayload(payload) {
    return $602cea95edb240cd$var$validate($602cea95edb240cd$var$registered_claims_schema, true, payload, "payload");
}
var $602cea95edb240cd$var$options_to_payload = {
    "audience": "aud",
    "issuer": "iss",
    "subject": "sub",
    "jwtid": "jti"
};
var $602cea95edb240cd$var$options_for_objects = [
    "expiresIn",
    "notBefore",
    "noTimestamp",
    "audience",
    "issuer",
    "subject",
    "jwtid"
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    } else options = options || {};
    var isObjectPayload = typeof payload === "object" && !$602cea95edb240cd$require$Buffer.isBuffer(payload);
    var header = Object.assign({
        alg: options.algorithm || "HS256",
        typ: isObjectPayload ? "JWT" : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== "none") return failure(new Error("secretOrPrivateKey must have a value"));
    if (typeof payload === "undefined") return failure(new Error("payload is required"));
    else if (isObjectPayload) {
        try {
            $602cea95edb240cd$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        var invalid_options = $602cea95edb240cd$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== "undefined";
        });
        if (invalid_options.length > 0) return failure(new Error("invalid " + invalid_options.join(",") + " option for " + typeof payload + " payload"));
    }
    if (typeof payload.exp !== "undefined" && typeof options.expiresIn !== "undefined") return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== "undefined" && typeof options.notBefore !== "undefined") return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $602cea95edb240cd$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    var timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== "undefined") {
        try {
            payload.nbf = $bkFw0(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === "undefined") return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== "undefined" && typeof payload === "object") {
        try {
            payload.exp = $bkFw0(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === "undefined") return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($602cea95edb240cd$var$options_to_payload).forEach(function(key) {
        var claim = $602cea95edb240cd$var$options_to_payload[key];
        if (typeof options[key] !== "undefined") {
            if (typeof payload[claim] !== "undefined") return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    var encoding = options.encoding || "utf8";
    if (typeof callback === "function") {
        callback = callback && $eHmQe(callback);
        $4QOjN.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once("error", callback).once("done", function(signature) {
            callback(null, signature);
        });
    } else return $4QOjN.sign({
        header: header,
        payload: payload,
        secret: secretOrPrivateKey,
        encoding: encoding
    });
};

});
parcelRequire.register("i96bT", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $d35ddea255759560$var$INFINITY = 1 / 0, $d35ddea255759560$var$MAX_SAFE_INTEGER = 9007199254740991, $d35ddea255759560$var$MAX_INTEGER = 1.7976931348623157e+308, $d35ddea255759560$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $d35ddea255759560$var$argsTag = "[object Arguments]", $d35ddea255759560$var$funcTag = "[object Function]", $d35ddea255759560$var$genTag = "[object GeneratorFunction]", $d35ddea255759560$var$stringTag = "[object String]", $d35ddea255759560$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $d35ddea255759560$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $d35ddea255759560$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $d35ddea255759560$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $d35ddea255759560$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $d35ddea255759560$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $d35ddea255759560$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d35ddea255759560$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d35ddea255759560$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d35ddea255759560$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $d35ddea255759560$var$baseFindIndex(array, $d35ddea255759560$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $d35ddea255759560$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d35ddea255759560$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $d35ddea255759560$var$baseValues(object, props) {
    return $d35ddea255759560$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $d35ddea255759560$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $d35ddea255759560$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d35ddea255759560$var$hasOwnProperty = $d35ddea255759560$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d35ddea255759560$var$objectToString = $d35ddea255759560$var$objectProto.toString;
/** Built-in value references. */ var $d35ddea255759560$var$propertyIsEnumerable = $d35ddea255759560$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d35ddea255759560$var$nativeKeys = $d35ddea255759560$var$overArg(Object.keys, Object), $d35ddea255759560$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $d35ddea255759560$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $d35ddea255759560$var$isArray(value) || $d35ddea255759560$var$isArguments(value) ? $d35ddea255759560$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $d35ddea255759560$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $d35ddea255759560$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d35ddea255759560$var$baseKeys(object) {
    if (!$d35ddea255759560$var$isPrototype(object)) return $d35ddea255759560$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($d35ddea255759560$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d35ddea255759560$var$isIndex(value, length) {
    length = length == null ? $d35ddea255759560$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $d35ddea255759560$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d35ddea255759560$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $d35ddea255759560$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $d35ddea255759560$var$includes(collection, value, fromIndex, guard) {
    collection = $d35ddea255759560$var$isArrayLike(collection) ? collection : $d35ddea255759560$var$values(collection);
    fromIndex = fromIndex && !guard ? $d35ddea255759560$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $d35ddea255759560$var$nativeMax(length + fromIndex, 0);
    return $d35ddea255759560$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $d35ddea255759560$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $d35ddea255759560$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $d35ddea255759560$var$isArrayLikeObject(value) && $d35ddea255759560$var$hasOwnProperty.call(value, "callee") && (!$d35ddea255759560$var$propertyIsEnumerable.call(value, "callee") || $d35ddea255759560$var$objectToString.call(value) == $d35ddea255759560$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d35ddea255759560$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d35ddea255759560$var$isArrayLike(value) {
    return value != null && $d35ddea255759560$var$isLength(value.length) && !$d35ddea255759560$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $d35ddea255759560$var$isArrayLikeObject(value) {
    return $d35ddea255759560$var$isObjectLike(value) && $d35ddea255759560$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d35ddea255759560$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $d35ddea255759560$var$isObject(value) ? $d35ddea255759560$var$objectToString.call(value) : "";
    return tag == $d35ddea255759560$var$funcTag || tag == $d35ddea255759560$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d35ddea255759560$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d35ddea255759560$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d35ddea255759560$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $d35ddea255759560$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $d35ddea255759560$var$isString(value) {
    return typeof value == "string" || !$d35ddea255759560$var$isArray(value) && $d35ddea255759560$var$isObjectLike(value) && $d35ddea255759560$var$objectToString.call(value) == $d35ddea255759560$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d35ddea255759560$var$isSymbol(value) {
    return typeof value == "symbol" || $d35ddea255759560$var$isObjectLike(value) && $d35ddea255759560$var$objectToString.call(value) == $d35ddea255759560$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $d35ddea255759560$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $d35ddea255759560$var$toNumber(value);
    if (value === $d35ddea255759560$var$INFINITY || value === -$d35ddea255759560$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $d35ddea255759560$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $d35ddea255759560$var$toInteger(value) {
    var result = $d35ddea255759560$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $d35ddea255759560$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($d35ddea255759560$var$isSymbol(value)) return $d35ddea255759560$var$NAN;
    if ($d35ddea255759560$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $d35ddea255759560$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($d35ddea255759560$var$reTrim, "");
    var isBinary = $d35ddea255759560$var$reIsBinary.test(value);
    return isBinary || $d35ddea255759560$var$reIsOctal.test(value) ? $d35ddea255759560$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $d35ddea255759560$var$reIsBadHex.test(value) ? $d35ddea255759560$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $d35ddea255759560$var$keys(object) {
    return $d35ddea255759560$var$isArrayLike(object) ? $d35ddea255759560$var$arrayLikeKeys(object) : $d35ddea255759560$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $d35ddea255759560$var$values(object) {
    return object ? $d35ddea255759560$var$baseValues(object, $d35ddea255759560$var$keys(object)) : [];
}
module.exports = $d35ddea255759560$var$includes;

});

parcelRequire.register("a0Xiz", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $74a7e6ed75c44e55$var$boolTag = "[object Boolean]";
/** Used for built-in method references. */ var $74a7e6ed75c44e55$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $74a7e6ed75c44e55$var$objectToString = $74a7e6ed75c44e55$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $74a7e6ed75c44e55$var$isBoolean(value) {
    return value === true || value === false || $74a7e6ed75c44e55$var$isObjectLike(value) && $74a7e6ed75c44e55$var$objectToString.call(value) == $74a7e6ed75c44e55$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $74a7e6ed75c44e55$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
module.exports = $74a7e6ed75c44e55$var$isBoolean;

});

parcelRequire.register("8fuXr", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $6017bd06bc3b7cba$var$INFINITY = 1 / 0, $6017bd06bc3b7cba$var$MAX_INTEGER = 1.7976931348623157e+308, $6017bd06bc3b7cba$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $6017bd06bc3b7cba$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $6017bd06bc3b7cba$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6017bd06bc3b7cba$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6017bd06bc3b7cba$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6017bd06bc3b7cba$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6017bd06bc3b7cba$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $6017bd06bc3b7cba$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6017bd06bc3b7cba$var$objectToString = $6017bd06bc3b7cba$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $6017bd06bc3b7cba$var$isInteger(value) {
    return typeof value == "number" && value == $6017bd06bc3b7cba$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6017bd06bc3b7cba$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6017bd06bc3b7cba$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6017bd06bc3b7cba$var$isSymbol(value) {
    return typeof value == "symbol" || $6017bd06bc3b7cba$var$isObjectLike(value) && $6017bd06bc3b7cba$var$objectToString.call(value) == $6017bd06bc3b7cba$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6017bd06bc3b7cba$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $6017bd06bc3b7cba$var$toNumber(value);
    if (value === $6017bd06bc3b7cba$var$INFINITY || value === -$6017bd06bc3b7cba$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6017bd06bc3b7cba$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6017bd06bc3b7cba$var$toInteger(value) {
    var result = $6017bd06bc3b7cba$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6017bd06bc3b7cba$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($6017bd06bc3b7cba$var$isSymbol(value)) return $6017bd06bc3b7cba$var$NAN;
    if ($6017bd06bc3b7cba$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $6017bd06bc3b7cba$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($6017bd06bc3b7cba$var$reTrim, "");
    var isBinary = $6017bd06bc3b7cba$var$reIsBinary.test(value);
    return isBinary || $6017bd06bc3b7cba$var$reIsOctal.test(value) ? $6017bd06bc3b7cba$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6017bd06bc3b7cba$var$reIsBadHex.test(value) ? $6017bd06bc3b7cba$var$NAN : +value;
}
module.exports = $6017bd06bc3b7cba$var$isInteger;

});

parcelRequire.register("hzFRX", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $ccb62ee8c326ddba$var$numberTag = "[object Number]";
/** Used for built-in method references. */ var $ccb62ee8c326ddba$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ccb62ee8c326ddba$var$objectToString = $ccb62ee8c326ddba$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ccb62ee8c326ddba$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $ccb62ee8c326ddba$var$isNumber(value) {
    return typeof value == "number" || $ccb62ee8c326ddba$var$isObjectLike(value) && $ccb62ee8c326ddba$var$objectToString.call(value) == $ccb62ee8c326ddba$var$numberTag;
}
module.exports = $ccb62ee8c326ddba$var$isNumber;

});

parcelRequire.register("1hRv1", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $0f00e0d907a420b6$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $0f00e0d907a420b6$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0f00e0d907a420b6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $0f00e0d907a420b6$var$funcProto = Function.prototype, $0f00e0d907a420b6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0f00e0d907a420b6$var$funcToString = $0f00e0d907a420b6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0f00e0d907a420b6$var$hasOwnProperty = $0f00e0d907a420b6$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0f00e0d907a420b6$var$objectCtorString = $0f00e0d907a420b6$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0f00e0d907a420b6$var$objectToString = $0f00e0d907a420b6$var$objectProto.toString;
/** Built-in value references. */ var $0f00e0d907a420b6$var$getPrototype = $0f00e0d907a420b6$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0f00e0d907a420b6$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0f00e0d907a420b6$var$isPlainObject(value) {
    if (!$0f00e0d907a420b6$var$isObjectLike(value) || $0f00e0d907a420b6$var$objectToString.call(value) != $0f00e0d907a420b6$var$objectTag || $0f00e0d907a420b6$var$isHostObject(value)) return false;
    var proto = $0f00e0d907a420b6$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $0f00e0d907a420b6$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0f00e0d907a420b6$var$funcToString.call(Ctor) == $0f00e0d907a420b6$var$objectCtorString;
}
module.exports = $0f00e0d907a420b6$var$isPlainObject;

});

parcelRequire.register("eyfSd", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $a9808dcc3ae59235$var$stringTag = "[object String]";
/** Used for built-in method references. */ var $a9808dcc3ae59235$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a9808dcc3ae59235$var$objectToString = $a9808dcc3ae59235$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $a9808dcc3ae59235$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a9808dcc3ae59235$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $a9808dcc3ae59235$var$isString(value) {
    return typeof value == "string" || !$a9808dcc3ae59235$var$isArray(value) && $a9808dcc3ae59235$var$isObjectLike(value) && $a9808dcc3ae59235$var$objectToString.call(value) == $a9808dcc3ae59235$var$stringTag;
}
module.exports = $a9808dcc3ae59235$var$isString;

});

parcelRequire.register("eHmQe", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ab36ccae1adcb107$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $ab36ccae1adcb107$var$INFINITY = 1 / 0, $ab36ccae1adcb107$var$MAX_INTEGER = 1.7976931348623157e+308, $ab36ccae1adcb107$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ab36ccae1adcb107$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $ab36ccae1adcb107$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ab36ccae1adcb107$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ab36ccae1adcb107$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ab36ccae1adcb107$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ab36ccae1adcb107$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $ab36ccae1adcb107$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ab36ccae1adcb107$var$objectToString = $ab36ccae1adcb107$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $ab36ccae1adcb107$var$before(n, func) {
    var result;
    if (typeof func != "function") throw new TypeError($ab36ccae1adcb107$var$FUNC_ERROR_TEXT);
    n = $ab36ccae1adcb107$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $ab36ccae1adcb107$var$once(func) {
    return $ab36ccae1adcb107$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ab36ccae1adcb107$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ab36ccae1adcb107$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ab36ccae1adcb107$var$isSymbol(value) {
    return typeof value == "symbol" || $ab36ccae1adcb107$var$isObjectLike(value) && $ab36ccae1adcb107$var$objectToString.call(value) == $ab36ccae1adcb107$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $ab36ccae1adcb107$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $ab36ccae1adcb107$var$toNumber(value);
    if (value === $ab36ccae1adcb107$var$INFINITY || value === -$ab36ccae1adcb107$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $ab36ccae1adcb107$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $ab36ccae1adcb107$var$toInteger(value) {
    var result = $ab36ccae1adcb107$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ab36ccae1adcb107$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ab36ccae1adcb107$var$isSymbol(value)) return $ab36ccae1adcb107$var$NAN;
    if ($ab36ccae1adcb107$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ab36ccae1adcb107$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($ab36ccae1adcb107$var$reTrim, "");
    var isBinary = $ab36ccae1adcb107$var$reIsBinary.test(value);
    return isBinary || $ab36ccae1adcb107$var$reIsOctal.test(value) ? $ab36ccae1adcb107$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ab36ccae1adcb107$var$reIsBadHex.test(value) ? $ab36ccae1adcb107$var$NAN : +value;
}
module.exports = $ab36ccae1adcb107$var$once;

});


parcelRequire.register("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRequire.register("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRequire.register("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRequire.register("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRequire.register("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRequire.register("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRequire.register("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


parcelRequire.register("36yar", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => reactAxe);
// index.ts

var $g7XQC = parcelRequire("g7XQC");

var $h8uFI = parcelRequire("h8uFI");
// after.ts
var restoreFunctions = [];
function after(host, name, cb) {
    const originalFn = host[name];
    let restoreFn;
    if (originalFn) {
        host[name] = function(...args) {
            originalFn.apply(this, args);
            cb(host);
        };
        restoreFn = function() {
            host[name] = originalFn;
        };
    } else {
        host[name] = function() {
            cb(host);
        };
        restoreFn = function() {
            delete host[name];
        };
    }
    restoreFunctions.push(restoreFn);
}
after.restorePatchedMethods = function() {
    restoreFunctions.forEach((restoreFn)=>restoreFn());
    restoreFunctions = [];
};
// cache.ts
var _cache = {};
var cache = {
    set (key, value) {
        _cache[key] = value;
    },
    get (key) {
        return _cache[key];
    },
    clear () {
        Object.keys(_cache).forEach((key)=>{
            delete _cache[key];
        });
    }
};
var cache_default = cache;
// index.ts
var requestIdleCallback = $h8uFI.request;
var cancelIdleCallback = $h8uFI.cancel;
var React;
var ReactDOM;
var logger;
var lightTheme = {
    serious: "#d93251",
    minor: "#d24700",
    text: "black"
};
var darkTheme = {
    serious: "#ffb3b3",
    minor: "#ffd500",
    text: "white"
};
var theme = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? darkTheme : lightTheme;
var boldCourier = "font-weight:bold;font-family:Courier;";
var critical = `color:${theme.serious};font-weight:bold;`;
var serious = `color:${theme.serious};font-weight:normal;`;
var moderate = `color:${theme.minor};font-weight:bold;`;
var minor = `color:${theme.minor};font-weight:normal;`;
var defaultReset = `font-color:${theme.text};font-weight:normal;`;
var idleId;
var timeout;
var context;
var conf;
var _createElement;
var components = {};
var nodes = [
    document.documentElement
];
function debounce(func, wait, immediate) {
    let _timeout;
    return function(...args) {
        const later = ()=>{
            _timeout = null;
            if (!immediate) func.apply(this, args);
        };
        const callNow = immediate && !_timeout;
        clearTimeout(_timeout);
        _timeout = setTimeout(later, wait);
        if (callNow) func.apply(this, args);
    };
}
function getPath(node) {
    const path = [
        node
    ];
    while(node && node.nodeName.toLowerCase() !== "html"){
        path.push(node.parentNode);
        node = node.parentNode;
    }
    if (!node || !node.parentNode) return null;
    return path.reverse();
}
function getCommonParent(nodes2) {
    let path;
    let nextPath;
    if (nodes2.length === 1) return nodes2.pop();
    while(!path && nodes2.length)path = getPath(nodes2.pop());
    while(nodes2.length){
        nextPath = getPath(nodes2.pop());
        if (nextPath) path = path.filter((node, index)=>{
            return nextPath.length > index && nextPath[index] === node;
        });
    }
    return path ? path[path.length - 1] : document;
}
function logElement(node, logFn) {
    const el = document.querySelector(node.target.toString());
    if (!el) logFn("Selector: %c%s", boldCourier, node.target.toString());
    else logFn("Element: %o", el);
}
function logHtml(node) {
    console.log("HTML: %c%s", boldCourier, node.html);
}
function logFailureMessage(node, key) {
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($g7XQC)))._audit.data.failureSummaries[key].failureMessage(node[key].map((check)=>check.message || ""));
    console.error(message);
}
function failureSummary(node, key) {
    if (node[key].length > 0) {
        logElement(node, console.groupCollapsed);
        logHtml(node);
        logFailureMessage(node, key);
        let relatedNodes = [];
        node[key].forEach((check)=>{
            relatedNodes = relatedNodes.concat(check.relatedNodes);
        });
        if (relatedNodes.length > 0) {
            console.groupCollapsed("Related nodes");
            relatedNodes.forEach((relatedNode)=>{
                logElement(relatedNode, console.log);
                logHtml(relatedNode);
            });
            console.groupEnd();
        }
        console.groupEnd();
    }
}
function checkAndReport(node, timeout2) {
    const disableDeduplicate = conf["disableDeduplicate"];
    if (idleId) {
        cancelIdleCallback(idleId);
        idleId = void 0;
    }
    return new Promise((resolve, reject)=>{
        nodes.push(node);
        idleId = requestIdleCallback(()=>{
            let n = context;
            if (n === void 0) {
                n = getCommonParent(nodes.filter((node2)=>node2.isConnected));
                if (n.nodeName.toLowerCase() === "html") n = document;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($g7XQC))).configure({
                allowedOrigins: [
                    "<unsafe_all_origins>"
                ]
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($g7XQC))).run(n, {
                reporter: "v2"
            }, function(error, results) {
                if (error) return reject(error);
                results.violations = results.violations.filter((result)=>{
                    result.nodes = result.nodes.filter((node2)=>{
                        const key = node2.target.toString() + result.id;
                        const retVal = !cache_default.get(key);
                        cache_default.set(key, key);
                        return disableDeduplicate || retVal;
                    });
                    return !!result.nodes.length;
                });
                if (results.violations.length) logger(results);
                resolve();
            });
        }, {
            timeout: timeout2
        });
    });
}
function checkNode(component) {
    let node;
    try {
        node = ReactDOM.findDOMNode(component);
    } catch (e) {
        console.group("%caxe error: could not check node", critical);
        console.group("%cComponent", serious);
        console.error(component);
        console.groupEnd();
        console.group("%cError", serious);
        console.error(e);
        console.groupEnd();
        console.groupEnd();
    }
    if (node) checkAndReport(node, timeout);
}
function componentAfterRender(component) {
    const debounceCheckNode = debounce(checkNode, timeout, true);
    after(component, "componentDidMount", debounceCheckNode);
    after(component, "componentDidUpdate", debounceCheckNode);
}
function addComponent(component) {
    const reactInstance = component._reactInternalInstance || {};
    const reactInstanceDebugID = reactInstance._debugID;
    const reactFiberInstance = component._reactInternalFiber || {};
    const reactFiberInstanceDebugID = reactFiberInstance._debugID;
    const reactInternals = component._reactInternals || {};
    const reactInternalsDebugID = reactInternals._debugID;
    if (reactInstanceDebugID && !components[reactInstanceDebugID]) {
        components[reactInstanceDebugID] = component;
        componentAfterRender(component);
    } else if (reactFiberInstanceDebugID && !components[reactFiberInstanceDebugID]) {
        components[reactFiberInstanceDebugID] = component;
        componentAfterRender(component);
    } else if (reactInternalsDebugID && !components[reactInternalsDebugID]) {
        components[reactInternalsDebugID] = component;
        componentAfterRender(component);
    }
}
function logToConsole(results) {
    console.group("%cNew axe issues", serious);
    results.violations.forEach((result)=>{
        let fmt;
        switch(result.impact){
            case "critical":
                fmt = critical;
                break;
            case "serious":
                fmt = serious;
                break;
            case "moderate":
                fmt = moderate;
                break;
            case "minor":
                fmt = minor;
                break;
            default:
                fmt = minor;
                break;
        }
        console.groupCollapsed("%c%s: %c%s %s", fmt, result.impact, defaultReset, result.help, result.helpUrl);
        result.nodes.forEach((node)=>{
            failureSummary(node, "any");
            failureSummary(node, "none");
        });
        console.groupEnd();
    });
    console.groupEnd();
}
function reactAxe(_React, _ReactDOM, _timeout, _conf = {}, _context, _logger) {
    React = _React;
    ReactDOM = _ReactDOM;
    timeout = _timeout;
    context = _context;
    conf = _conf;
    logger = _logger || logToConsole;
    const runOnly = conf["runOnly"];
    if (runOnly) {
        conf["rules"] = (0, (/*@__PURE__*/$parcel$interopDefault($g7XQC))).getRules(runOnly).map((rule)=>({
                ...rule,
                id: rule.ruleId,
                enabled: true
            }));
        conf["disableOtherRules"] = true;
    }
    if (Object.keys(conf).length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($g7XQC))).configure(conf);
    (0, (/*@__PURE__*/$parcel$interopDefault($g7XQC))).configure({
        allowedOrigins: [
            "<unsafe_all_origins>"
        ]
    });
    if (!_createElement) {
        _createElement = React.createElement;
        React.createElement = function(...args) {
            const reactEl = _createElement.apply(this, args);
            if (reactEl._owner && reactEl._owner._instance) addComponent(reactEl._owner._instance);
            else if (reactEl._owner && reactEl._owner.stateNode) addComponent(reactEl._owner.stateNode);
            return reactEl;
        };
    }
    return checkAndReport(document.body, timeout);
}
reactAxe.logToConsole = logToConsole;
exports = module.exports = reactAxe;

});
parcelRequire.register("g7XQC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/*! axe v4.8.2
 * Copyright (c) 2015 - 2023 Deque Systems, Inc.
 *
 * Your use of this Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 *
 * This entire copyright notice must appear in every copy of this file you
 * distribute or in any file that contains substantial portions of this source
 * code.
 */ (function axeFunction(window1) {
    var global = window1;
    var document = window1.document;
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    var axe = axe || {};
    axe.version = "4.8.2";
    if (typeof define === "function" && define.amd) define("axe-core", [], function() {
        return axe;
    });
    if (_typeof(module) === "object" && module.exports && typeof axeFunction.toString === "function") {
        axe.source = "(" + axeFunction.toString() + ')(typeof window === "object" ? window : this);';
        module.exports = axe;
    }
    if (typeof window1.getComputedStyle === "function") window1.axe = axe;
    var commons;
    function SupportError(error) {
        this.name = "SupportError";
        this.cause = error.cause;
        this.message = "`".concat(error.cause, "` - feature unsupported in your environment.");
        if (error.ruleId) {
            this.ruleId = error.ruleId;
            this.message += " Skipping ".concat(this.ruleId, " rule.");
        }
        this.stack = new Error().stack;
    }
    SupportError.prototype = Object.create(Error.prototype);
    SupportError.prototype.constructor = SupportError;
    "use strict";
    var _excluded = [
        "node"
    ], _excluded2 = [
        "relatedNodes"
    ], _excluded3 = [
        "node"
    ], _excluded4 = [
        "variant"
    ], _excluded5 = [
        "matches"
    ], _excluded6 = [
        "chromium"
    ], _excluded7 = [
        "noImplicit"
    ], _excluded8 = [
        "noPresentational"
    ], _excluded9 = [
        "precision",
        "format",
        "inGamut"
    ], _excluded10 = [
        "space"
    ], _excluded11 = [
        "algorithm"
    ], _excluded12 = [
        "method"
    ], _excluded13 = [
        "maxDeltaE",
        "deltaEMethod",
        "steps",
        "maxSteps"
    ], _excluded14 = [
        "node"
    ], _excluded15 = [
        "environmentData"
    ], _excluded16 = [
        "environmentData"
    ], _excluded17 = [
        "environmentData"
    ], _excluded18 = [
        "environmentData"
    ], _excluded19 = [
        "environmentData"
    ];
    function _toArray(arr) {
        return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(self1);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _classPrivateFieldInitSpec(obj, privateMap, value) {
        _checkPrivateRedeclaration(obj, privateMap);
        privateMap.set(obj, value);
    }
    function _classPrivateMethodInitSpec(obj, privateSet) {
        _checkPrivateRedeclaration(obj, privateSet);
        privateSet.add(obj);
    }
    function _checkPrivateRedeclaration(obj, privateCollection) {
        if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet(receiver, privateMap) {
        var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
        return _classApplyDescriptorGet(receiver, descriptor);
    }
    function _classApplyDescriptorGet(receiver, descriptor) {
        if (descriptor.get) return descriptor.get.call(receiver);
        return descriptor.value;
    }
    function _classPrivateMethodGet(receiver, privateSet, fn) {
        if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
        return fn;
    }
    function _classPrivateFieldSet(receiver, privateMap, value) {
        var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
        _classApplyDescriptorSet(receiver, descriptor, value);
        return value;
    }
    function _classExtractFieldDescriptor(receiver, privateMap, action) {
        if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
        return privateMap.get(receiver);
    }
    function _classApplyDescriptorSet(receiver, descriptor, value) {
        if (descriptor.set) descriptor.set.call(receiver, value);
        else {
            if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
            descriptor.value = value;
        }
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
        if (null != _i) {
            var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
            try {
                if (_x = (_i = _i.call(arr)).next, 0 === i) {
                    if (Object(_i) !== _i) return;
                    _n = !1;
                } else {
                    for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
                }
            } catch (err) {
                _d = !0, _e = err;
            } finally{
                try {
                    if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return _typeof(key) === "symbol" ? key : String(key);
    }
    function _toPrimitive(input, hint) {
        if (_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                var F = function F() {};
                return {
                    s: F,
                    n: function n() {
                        if (i >= o.length) return {
                            done: true
                        };
                        return {
                            done: false,
                            value: o[i++]
                        };
                    },
                    e: function e(_e2) {
                        throw _e2;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true, didErr = false, err;
        return {
            s: function s() {
                it = it.call(o);
            },
            n: function n() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
            },
            e: function e(_e3) {
                didErr = true;
                err = _e3;
            },
            f: function f() {
                try {
                    if (!normalCompletion && it["return"] != null) it["return"]();
                } finally{
                    if (didErr) throw err;
                }
            }
        };
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    (function() {
        var _processFormat, _path, _getPath, _space;
        var __create = Object.create;
        var __defProp = Object.defineProperty;
        var __getProtoOf = Object.getPrototypeOf;
        var __hasOwnProp = Object.prototype.hasOwnProperty;
        var __getOwnPropNames = Object.getOwnPropertyNames;
        var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
        var __defNormalProp = function __defNormalProp(obj, key, value) {
            return key in obj ? __defProp(obj, key, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: value
            }) : obj[key] = value;
        };
        var __markAsModule = function __markAsModule(target) {
            return __defProp(target, "__esModule", {
                value: true
            });
        };
        var __commonJS = function __commonJS(cb, mod) {
            return function() {
                return mod || cb((mod = {
                    exports: {}
                }).exports, mod), mod.exports;
            };
        };
        var __export = function __export(target, all) {
            for(var name in all)__defProp(target, name, {
                get: all[name],
                enumerable: true
            });
        };
        var __exportStar = function __exportStar(target, module1, desc) {
            if (module1 && _typeof(module1) === "object" || typeof module1 === "function") {
                var _iterator = _createForOfIteratorHelper(__getOwnPropNames(module1)), _step;
                try {
                    var _loop = function _loop() {
                        var key = _step.value;
                        if (!__hasOwnProp.call(target, key) && key !== "default") __defProp(target, key, {
                            get: function get() {
                                return module1[key];
                            },
                            enumerable: !(desc = __getOwnPropDesc(module1, key)) || desc.enumerable
                        });
                    };
                    for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
            return target;
        };
        var __toModule = function __toModule(module1) {
            return __exportStar(__markAsModule(__defProp(module1 != null ? __create(__getProtoOf(module1)) : {}, "default", module1 && module1.__esModule && "default" in module1 ? {
                get: function get() {
                    return module1["default"];
                },
                enumerable: true
            } : {
                value: module1,
                enumerable: true
            })), module1);
        };
        var __publicField = function __publicField(obj, key, value) {
            __defNormalProp(obj, _typeof(key) !== "symbol" ? key + "" : key, value);
            return value;
        };
        var require_noop = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {};
        });
        var require_is_value = __commonJS(function(exports, module1) {
            "use strict";
            var _undefined = require_noop()();
            module1.exports = function(val) {
                return val !== _undefined && val !== null;
            };
        });
        var require_normalize_options = __commonJS(function(exports, module1) {
            "use strict";
            var isValue = require_is_value();
            var forEach = Array.prototype.forEach;
            var create = Object.create;
            var process2 = function process2(src, obj) {
                var key;
                for(key in src)obj[key] = src[key];
            };
            module1.exports = function(opts1) {
                var result = create(null);
                forEach.call(arguments, function(options) {
                    if (!isValue(options)) return;
                    process2(Object(options), result);
                });
                return result;
            };
        });
        var require_is_implemented = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {
                var sign = Math.sign;
                if (typeof sign !== "function") return false;
                return sign(10) === 1 && sign(-20) === -1;
            };
        });
        var require_shim = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(value) {
                value = Number(value);
                if (isNaN(value) || value === 0) return value;
                return value > 0 ? 1 : -1;
            };
        });
        var require_sign = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented()() ? Math.sign : require_shim();
        });
        var require_to_integer = __commonJS(function(exports, module1) {
            "use strict";
            var sign = require_sign();
            var abs = Math.abs;
            var floor = Math.floor;
            module1.exports = function(value) {
                if (isNaN(value)) return 0;
                value = Number(value);
                if (value === 0 || !isFinite(value)) return value;
                return sign(value) * floor(abs(value));
            };
        });
        var require_to_pos_integer = __commonJS(function(exports, module1) {
            "use strict";
            var toInteger = require_to_integer();
            var max2 = Math.max;
            module1.exports = function(value) {
                return max2(0, toInteger(value));
            };
        });
        var require_resolve_length = __commonJS(function(exports, module1) {
            "use strict";
            var toPosInt = require_to_pos_integer();
            module1.exports = function(optsLength, fnLength, isAsync) {
                var length;
                if (isNaN(optsLength)) {
                    length = fnLength;
                    if (!(length >= 0)) return 1;
                    if (isAsync && length) return length - 1;
                    return length;
                }
                if (optsLength === false) return false;
                return toPosInt(optsLength);
            };
        });
        var require_valid_callable = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(fn) {
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                return fn;
            };
        });
        var require_valid_value = __commonJS(function(exports, module1) {
            "use strict";
            var isValue = require_is_value();
            module1.exports = function(value) {
                if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
                return value;
            };
        });
        var require_iterate = __commonJS(function(exports, module1) {
            "use strict";
            var callable = require_valid_callable();
            var value = require_valid_value();
            var bind = Function.prototype.bind;
            var call = Function.prototype.call;
            var keys = Object.keys;
            var objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;
            module1.exports = function(method, defVal) {
                return function(obj, cb) {
                    var list, thisArg = arguments[2], compareFn = arguments[3];
                    obj = Object(value(obj));
                    callable(cb);
                    list = keys(obj);
                    if (compareFn) list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : void 0);
                    if (typeof method !== "function") method = list[method];
                    return call.call(method, list, function(key, index) {
                        if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
                        return call.call(cb, thisArg, obj[key], key, obj, index);
                    });
                };
            };
        });
        var require_for_each = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_iterate()("forEach");
        });
        var require_registered_extensions = __commonJS(function() {
            "use strict";
        });
        var require_is_implemented2 = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {
                var assign = Object.assign, obj;
                if (typeof assign !== "function") return false;
                obj = {
                    foo: "raz"
                };
                assign(obj, {
                    bar: "dwa"
                }, {
                    trzy: "trzy"
                });
                return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
            };
        });
        var require_is_implemented3 = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {
                try {
                    Object.keys("primitive");
                    return true;
                } catch (e) {
                    return false;
                }
            };
        });
        var require_shim2 = __commonJS(function(exports, module1) {
            "use strict";
            var isValue = require_is_value();
            var keys = Object.keys;
            module1.exports = function(object) {
                return keys(isValue(object) ? Object(object) : object);
            };
        });
        var require_keys = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented3()() ? Object.keys : require_shim2();
        });
        var require_shim3 = __commonJS(function(exports, module1) {
            "use strict";
            var keys = require_keys();
            var value = require_valid_value();
            var max2 = Math.max;
            module1.exports = function(dest, src) {
                var error, i, length = max2(arguments.length, 2), assign;
                dest = Object(value(dest));
                assign = function assign(key) {
                    try {
                        dest[key] = src[key];
                    } catch (e) {
                        if (!error) error = e;
                    }
                };
                for(i = 1; i < length; ++i){
                    src = arguments[i];
                    keys(src).forEach(assign);
                }
                if (error !== void 0) throw error;
                return dest;
            };
        });
        var require_assign = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented2()() ? Object.assign : require_shim3();
        });
        var require_is_object = __commonJS(function(exports, module1) {
            "use strict";
            var isValue = require_is_value();
            var map = {
                function: true,
                object: true
            };
            module1.exports = function(value) {
                return isValue(value) && map[_typeof(value)] || false;
            };
        });
        var require_custom = __commonJS(function(exports, module1) {
            "use strict";
            var assign = require_assign();
            var isObject = require_is_object();
            var isValue = require_is_value();
            var captureStackTrace = Error.captureStackTrace;
            module1.exports = function(message) {
                var err2 = new Error(message), code = arguments[1], ext = arguments[2];
                if (!isValue(ext)) {
                    if (isObject(code)) {
                        ext = code;
                        code = null;
                    }
                }
                if (isValue(ext)) assign(err2, ext);
                if (isValue(code)) err2.code = code;
                if (captureStackTrace) captureStackTrace(err2, module1.exports);
                return err2;
            };
        });
        var require_mixin = __commonJS(function(exports, module1) {
            "use strict";
            var value = require_valid_value();
            var defineProperty = Object.defineProperty;
            var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            var getOwnPropertyNames = Object.getOwnPropertyNames;
            var getOwnPropertySymbols = Object.getOwnPropertySymbols;
            module1.exports = function(target, source) {
                var error, sourceObject = Object(value(source));
                target = Object(value(target));
                getOwnPropertyNames(sourceObject).forEach(function(name) {
                    try {
                        defineProperty(target, name, getOwnPropertyDescriptor(source, name));
                    } catch (e) {
                        error = e;
                    }
                });
                if (typeof getOwnPropertySymbols === "function") getOwnPropertySymbols(sourceObject).forEach(function(symbol) {
                    try {
                        defineProperty(target, symbol, getOwnPropertyDescriptor(source, symbol));
                    } catch (e) {
                        error = e;
                    }
                });
                if (error !== void 0) throw error;
                return target;
            };
        });
        var require_define_length = __commonJS(function(exports, module1) {
            "use strict";
            var toPosInt = require_to_pos_integer();
            var test = function test(arg1, arg2) {
                return arg2;
            };
            var desc;
            var defineProperty;
            var generate;
            var mixin;
            try {
                Object.defineProperty(test, "length", {
                    configurable: true,
                    writable: false,
                    enumerable: false,
                    value: 1
                });
            } catch (ignore) {}
            if (test.length === 1) {
                desc = {
                    configurable: true,
                    writable: false,
                    enumerable: false
                };
                defineProperty = Object.defineProperty;
                module1.exports = function(fn, length) {
                    length = toPosInt(length);
                    if (fn.length === length) return fn;
                    desc.value = length;
                    return defineProperty(fn, "length", desc);
                };
            } else {
                mixin = require_mixin();
                generate = function() {
                    var cache2 = [];
                    return function(length) {
                        var args, i = 0;
                        if (cache2[length]) return cache2[length];
                        args = [];
                        while(length--)args.push("a" + (++i).toString(36));
                        return new Function("fn", "return function (" + args.join(", ") + ") { return fn.apply(this, arguments); };");
                    };
                }();
                module1.exports = function(src, length) {
                    var target;
                    length = toPosInt(length);
                    if (src.length === length) return src;
                    target = generate(length)(src);
                    try {
                        mixin(target, src);
                    } catch (ignore) {}
                    return target;
                };
            }
        });
        var require_is = __commonJS(function(exports, module1) {
            "use strict";
            var _undefined = void 0;
            module1.exports = function(value) {
                return value !== _undefined && value !== null;
            };
        });
        var require_is2 = __commonJS(function(exports, module1) {
            "use strict";
            var isValue = require_is();
            var possibleTypes = {
                object: true,
                function: true,
                undefined: true
            };
            module1.exports = function(value) {
                if (!isValue(value)) return false;
                return hasOwnProperty.call(possibleTypes, _typeof(value));
            };
        });
        var require_is3 = __commonJS(function(exports, module1) {
            "use strict";
            var isObject = require_is2();
            module1.exports = function(value) {
                if (!isObject(value)) return false;
                try {
                    if (!value.constructor) return false;
                    return value.constructor.prototype === value;
                } catch (error) {
                    return false;
                }
            };
        });
        var require_is4 = __commonJS(function(exports, module1) {
            "use strict";
            var isPrototype = require_is3();
            module1.exports = function(value) {
                if (typeof value !== "function") return false;
                if (!hasOwnProperty.call(value, "length")) return false;
                try {
                    if (typeof value.length !== "number") return false;
                    if (typeof value.call !== "function") return false;
                    if (typeof value.apply !== "function") return false;
                } catch (error) {
                    return false;
                }
                return !isPrototype(value);
            };
        });
        var require_is5 = __commonJS(function(exports, module1) {
            "use strict";
            var isFunction = require_is4();
            var classRe = /^\s*class[\s{/}]/;
            var functionToString = Function.prototype.toString;
            module1.exports = function(value) {
                if (!isFunction(value)) return false;
                if (classRe.test(functionToString.call(value))) return false;
                return true;
            };
        });
        var require_is_implemented4 = __commonJS(function(exports, module1) {
            "use strict";
            var str = "razdwatrzy";
            module1.exports = function() {
                if (typeof str.contains !== "function") return false;
                return str.contains("dwa") === true && str.contains("foo") === false;
            };
        });
        var require_shim4 = __commonJS(function(exports, module1) {
            "use strict";
            var indexOf = String.prototype.indexOf;
            module1.exports = function(searchString) {
                return indexOf.call(this, searchString, arguments[1]) > -1;
            };
        });
        var require_contains = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented4()() ? String.prototype.contains : require_shim4();
        });
        var require_d = __commonJS(function(exports, module1) {
            "use strict";
            var isValue = require_is();
            var isPlainFunction = require_is5();
            var assign = require_assign();
            var normalizeOpts = require_normalize_options();
            var contains3 = require_contains();
            var d2 = module1.exports = function(dscr, value) {
                var c4, e, w, options, desc;
                if (arguments.length < 2 || typeof dscr !== "string") {
                    options = value;
                    value = dscr;
                    dscr = null;
                } else options = arguments[2];
                if (isValue(dscr)) {
                    c4 = contains3.call(dscr, "c");
                    e = contains3.call(dscr, "e");
                    w = contains3.call(dscr, "w");
                } else {
                    c4 = w = true;
                    e = false;
                }
                desc = {
                    value: value,
                    configurable: c4,
                    enumerable: e,
                    writable: w
                };
                return !options ? desc : assign(normalizeOpts(options), desc);
            };
            d2.gs = function(dscr, get2, set2) {
                var c4, e, options, desc;
                if (typeof dscr !== "string") {
                    options = set2;
                    set2 = get2;
                    get2 = dscr;
                    dscr = null;
                } else options = arguments[3];
                if (!isValue(get2)) get2 = void 0;
                else if (!isPlainFunction(get2)) {
                    options = get2;
                    get2 = set2 = void 0;
                } else if (!isValue(set2)) set2 = void 0;
                else if (!isPlainFunction(set2)) {
                    options = set2;
                    set2 = void 0;
                }
                if (isValue(dscr)) {
                    c4 = contains3.call(dscr, "c");
                    e = contains3.call(dscr, "e");
                } else {
                    c4 = true;
                    e = false;
                }
                desc = {
                    get: get2,
                    set: set2,
                    configurable: c4,
                    enumerable: e
                };
                return !options ? desc : assign(normalizeOpts(options), desc);
            };
        });
        var require_event_emitter = __commonJS(function(exports, module1) {
            "use strict";
            var d2 = require_d();
            var callable = require_valid_callable();
            var apply = Function.prototype.apply;
            var call = Function.prototype.call;
            var create = Object.create;
            var defineProperty = Object.defineProperty;
            var defineProperties = Object.defineProperties;
            var hasOwnProperty2 = Object.prototype.hasOwnProperty;
            var descriptor = {
                configurable: true,
                enumerable: false,
                writable: true
            };
            var on;
            var once;
            var off;
            var emit;
            var methods;
            var descriptors;
            var base;
            on = function on(type2, listener) {
                var data;
                callable(listener);
                if (!hasOwnProperty2.call(this, "__ee__")) {
                    data = descriptor.value = create(null);
                    defineProperty(this, "__ee__", descriptor);
                    descriptor.value = null;
                } else data = this.__ee__;
                if (!data[type2]) data[type2] = listener;
                else if (_typeof(data[type2]) === "object") data[type2].push(listener);
                else data[type2] = [
                    data[type2],
                    listener
                ];
                return this;
            };
            once = function once(type2, listener) {
                var _once, self2;
                callable(listener);
                self2 = this;
                on.call(this, type2, _once = function once2() {
                    off.call(self2, type2, _once);
                    apply.call(listener, this, arguments);
                });
                _once.__eeOnceListener__ = listener;
                return this;
            };
            off = function off(type2, listener) {
                var data, listeners, candidate, i;
                callable(listener);
                if (!hasOwnProperty2.call(this, "__ee__")) return this;
                data = this.__ee__;
                if (!data[type2]) return this;
                listeners = data[type2];
                if (_typeof(listeners) === "object") {
                    for(i = 0; candidate = listeners[i]; ++i)if (candidate === listener || candidate.__eeOnceListener__ === listener) {
                        if (listeners.length === 2) data[type2] = listeners[i ? 0 : 1];
                        else listeners.splice(i, 1);
                    }
                } else if (listeners === listener || listeners.__eeOnceListener__ === listener) delete data[type2];
                return this;
            };
            emit = function emit(type2) {
                var i, l, listener, listeners, args;
                if (!hasOwnProperty2.call(this, "__ee__")) return;
                listeners = this.__ee__[type2];
                if (!listeners) return;
                if (_typeof(listeners) === "object") {
                    l = arguments.length;
                    args = new Array(l - 1);
                    for(i = 1; i < l; ++i)args[i - 1] = arguments[i];
                    listeners = listeners.slice();
                    for(i = 0; listener = listeners[i]; ++i)apply.call(listener, this, args);
                } else switch(arguments.length){
                    case 1:
                        call.call(listeners, this);
                        break;
                    case 2:
                        call.call(listeners, this, arguments[1]);
                        break;
                    case 3:
                        call.call(listeners, this, arguments[1], arguments[2]);
                        break;
                    default:
                        l = arguments.length;
                        args = new Array(l - 1);
                        for(i = 1; i < l; ++i)args[i - 1] = arguments[i];
                        apply.call(listeners, this, args);
                }
            };
            methods = {
                on: on,
                once: once,
                off: off,
                emit: emit
            };
            descriptors = {
                on: d2(on),
                once: d2(once),
                off: d2(off),
                emit: d2(emit)
            };
            base = defineProperties({}, descriptors);
            module1.exports = exports = function exports(o) {
                return o == null ? create(base) : defineProperties(Object(o), descriptors);
            };
            exports.methods = methods;
        });
        var require_is_implemented5 = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {
                var from = Array.from, arr, result;
                if (typeof from !== "function") return false;
                arr = [
                    "raz",
                    "dwa"
                ];
                result = from(arr);
                return Boolean(result && result !== arr && result[1] === "dwa");
            };
        });
        var require_is_implemented6 = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {
                if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) !== "object") return false;
                if (!globalThis) return false;
                return globalThis.Array === Array;
            };
        });
        var require_implementation = __commonJS(function(exports, module1) {
            var naiveFallback = function naiveFallback() {
                if ((typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" && self) return self;
                if ((typeof window1 === "undefined" ? "undefined" : _typeof(window1)) === "object" && window1) return window1;
                throw new Error("Unable to resolve global `this`");
            };
            module1.exports = function() {
                if (this) return this;
                try {
                    Object.defineProperty(Object.prototype, "__global__", {
                        get: function get() {
                            return this;
                        },
                        configurable: true
                    });
                } catch (error) {
                    return naiveFallback();
                }
                try {
                    if (!__global__) return naiveFallback();
                    return __global__;
                } finally{
                    delete Object.prototype.__global__;
                }
            }();
        });
        var require_global_this = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented6()() ? globalThis : require_implementation();
        });
        var require_is_implemented7 = __commonJS(function(exports, module1) {
            "use strict";
            var global2 = require_global_this();
            var validTypes = {
                object: true,
                symbol: true
            };
            module1.exports = function() {
                var Symbol2 = global2.Symbol;
                var symbol;
                if (typeof Symbol2 !== "function") return false;
                symbol = Symbol2("test symbol");
                try {
                    String(symbol);
                } catch (e) {
                    return false;
                }
                if (!validTypes[_typeof(Symbol2.iterator)]) return false;
                if (!validTypes[_typeof(Symbol2.toPrimitive)]) return false;
                if (!validTypes[_typeof(Symbol2.toStringTag)]) return false;
                return true;
            };
        });
        var require_is_symbol = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(value) {
                if (!value) return false;
                if (_typeof(value) === "symbol") return true;
                if (!value.constructor) return false;
                if (value.constructor.name !== "Symbol") return false;
                return value[value.constructor.toStringTag] === "Symbol";
            };
        });
        var require_validate_symbol = __commonJS(function(exports, module1) {
            "use strict";
            var isSymbol = require_is_symbol();
            module1.exports = function(value) {
                if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
                return value;
            };
        });
        var require_generate_name = __commonJS(function(exports, module1) {
            "use strict";
            var d2 = require_d();
            var create = Object.create;
            var defineProperty = Object.defineProperty;
            var objPrototype = Object.prototype;
            var created = create(null);
            module1.exports = function(desc) {
                var postfix = 0, name, ie11BugWorkaround;
                while(created[desc + (postfix || "")])++postfix;
                desc += postfix || "";
                created[desc] = true;
                name = "@@" + desc;
                defineProperty(objPrototype, name, d2.gs(null, function(value) {
                    if (ie11BugWorkaround) return;
                    ie11BugWorkaround = true;
                    defineProperty(this, name, d2(value));
                    ie11BugWorkaround = false;
                }));
                return name;
            };
        });
        var require_standard_symbols = __commonJS(function(exports, module1) {
            "use strict";
            var d2 = require_d();
            var NativeSymbol = require_global_this().Symbol;
            module1.exports = function(SymbolPolyfill) {
                return Object.defineProperties(SymbolPolyfill, {
                    hasInstance: d2("", NativeSymbol && NativeSymbol.hasInstance || SymbolPolyfill("hasInstance")),
                    isConcatSpreadable: d2("", NativeSymbol && NativeSymbol.isConcatSpreadable || SymbolPolyfill("isConcatSpreadable")),
                    iterator: d2("", NativeSymbol && NativeSymbol.iterator || SymbolPolyfill("iterator")),
                    match: d2("", NativeSymbol && NativeSymbol.match || SymbolPolyfill("match")),
                    replace: d2("", NativeSymbol && NativeSymbol.replace || SymbolPolyfill("replace")),
                    search: d2("", NativeSymbol && NativeSymbol.search || SymbolPolyfill("search")),
                    species: d2("", NativeSymbol && NativeSymbol.species || SymbolPolyfill("species")),
                    split: d2("", NativeSymbol && NativeSymbol.split || SymbolPolyfill("split")),
                    toPrimitive: d2("", NativeSymbol && NativeSymbol.toPrimitive || SymbolPolyfill("toPrimitive")),
                    toStringTag: d2("", NativeSymbol && NativeSymbol.toStringTag || SymbolPolyfill("toStringTag")),
                    unscopables: d2("", NativeSymbol && NativeSymbol.unscopables || SymbolPolyfill("unscopables"))
                });
            };
        });
        var require_symbol_registry = __commonJS(function(exports, module1) {
            "use strict";
            var d2 = require_d();
            var validateSymbol = require_validate_symbol();
            var registry = Object.create(null);
            module1.exports = function(SymbolPolyfill) {
                return Object.defineProperties(SymbolPolyfill, {
                    for: d2(function(key) {
                        if (registry[key]) return registry[key];
                        return registry[key] = SymbolPolyfill(String(key));
                    }),
                    keyFor: d2(function(symbol) {
                        var key;
                        validateSymbol(symbol);
                        for(key in registry){
                            if (registry[key] === symbol) return key;
                        }
                        return void 0;
                    })
                });
            };
        });
        var require_polyfill = __commonJS(function(exports, module1) {
            "use strict";
            var d2 = require_d();
            var validateSymbol = require_validate_symbol();
            var NativeSymbol = require_global_this().Symbol;
            var generateName = require_generate_name();
            var setupStandardSymbols = require_standard_symbols();
            var setupSymbolRegistry = require_symbol_registry();
            var create = Object.create;
            var defineProperties = Object.defineProperties;
            var defineProperty = Object.defineProperty;
            var SymbolPolyfill;
            var HiddenSymbol;
            var isNativeSafe;
            if (typeof NativeSymbol === "function") try {
                String(NativeSymbol());
                isNativeSafe = true;
            } catch (ignore) {}
            else NativeSymbol = null;
            HiddenSymbol = function Symbol2(description) {
                if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
                return SymbolPolyfill(description);
            };
            module1.exports = SymbolPolyfill = function Symbol2(description) {
                var symbol;
                if (this instanceof Symbol2) throw new TypeError("Symbol is not a constructor");
                if (isNativeSafe) return NativeSymbol(description);
                symbol = create(HiddenSymbol.prototype);
                description = description === void 0 ? "" : String(description);
                return defineProperties(symbol, {
                    __description__: d2("", description),
                    __name__: d2("", generateName(description))
                });
            };
            setupStandardSymbols(SymbolPolyfill);
            setupSymbolRegistry(SymbolPolyfill);
            defineProperties(HiddenSymbol.prototype, {
                constructor: d2(SymbolPolyfill),
                toString: d2("", function() {
                    return this.__name__;
                })
            });
            defineProperties(SymbolPolyfill.prototype, {
                toString: d2(function() {
                    return "Symbol (" + validateSymbol(this).__description__ + ")";
                }),
                valueOf: d2(function() {
                    return validateSymbol(this);
                })
            });
            defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d2("", function() {
                var symbol = validateSymbol(this);
                if (_typeof(symbol) === "symbol") return symbol;
                return symbol.toString();
            }));
            defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d2("c", "Symbol"));
            defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag, d2("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));
            defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive, d2("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));
        });
        var require_es6_symbol = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented7()() ? require_global_this().Symbol : require_polyfill();
        });
        var require_is_arguments = __commonJS(function(exports, module1) {
            "use strict";
            var objToString = Object.prototype.toString;
            var id = objToString.call(function() {
                return arguments;
            }());
            module1.exports = function(value) {
                return objToString.call(value) === id;
            };
        });
        var require_is_function = __commonJS(function(exports, module1) {
            "use strict";
            var objToString = Object.prototype.toString;
            var isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
            module1.exports = function(value) {
                return typeof value === "function" && isFunctionStringTag(objToString.call(value));
            };
        });
        var require_is_string = __commonJS(function(exports, module1) {
            "use strict";
            var objToString = Object.prototype.toString;
            var id = objToString.call("");
            module1.exports = function(value) {
                return typeof value === "string" || value && _typeof(value) === "object" && (value instanceof String || objToString.call(value) === id) || false;
            };
        });
        var require_shim5 = __commonJS(function(exports, module1) {
            "use strict";
            var iteratorSymbol = require_es6_symbol().iterator;
            var isArguments = require_is_arguments();
            var isFunction = require_is_function();
            var toPosInt = require_to_pos_integer();
            var callable = require_valid_callable();
            var validValue = require_valid_value();
            var isValue = require_is_value();
            var isString2 = require_is_string();
            var isArray = Array.isArray;
            var call = Function.prototype.call;
            var desc = {
                configurable: true,
                enumerable: true,
                writable: true,
                value: null
            };
            var defineProperty = Object.defineProperty;
            module1.exports = function(arrayLike) {
                var mapFn = arguments[1], thisArg = arguments[2], Context2, i, j, arr, length, code, iterator, result, getIterator, value;
                arrayLike = Object(validValue(arrayLike));
                if (isValue(mapFn)) callable(mapFn);
                if (!this || this === Array || !isFunction(this)) {
                    if (!mapFn) {
                        if (isArguments(arrayLike)) {
                            length = arrayLike.length;
                            if (length !== 1) return Array.apply(null, arrayLike);
                            arr = new Array(1);
                            arr[0] = arrayLike[0];
                            return arr;
                        }
                        if (isArray(arrayLike)) {
                            arr = new Array(length = arrayLike.length);
                            for(i = 0; i < length; ++i)arr[i] = arrayLike[i];
                            return arr;
                        }
                    }
                    arr = [];
                } else Context2 = this;
                if (!isArray(arrayLike)) {
                    if ((getIterator = arrayLike[iteratorSymbol]) !== void 0) {
                        iterator = callable(getIterator).call(arrayLike);
                        if (Context2) arr = new Context2();
                        result = iterator.next();
                        i = 0;
                        while(!result.done){
                            value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
                            if (Context2) {
                                desc.value = value;
                                defineProperty(arr, i, desc);
                            } else arr[i] = value;
                            result = iterator.next();
                            ++i;
                        }
                        length = i;
                    } else if (isString2(arrayLike)) {
                        length = arrayLike.length;
                        if (Context2) arr = new Context2();
                        for(i = 0, j = 0; i < length; ++i){
                            value = arrayLike[i];
                            if (i + 1 < length) {
                                code = value.charCodeAt(0);
                                if (code >= 55296 && code <= 56319) value += arrayLike[++i];
                            }
                            value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
                            if (Context2) {
                                desc.value = value;
                                defineProperty(arr, j, desc);
                            } else arr[j] = value;
                            ++j;
                        }
                        length = j;
                    }
                }
                if (length === void 0) {
                    length = toPosInt(arrayLike.length);
                    if (Context2) arr = new Context2(length);
                    for(i = 0; i < length; ++i){
                        value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
                        if (Context2) {
                            desc.value = value;
                            defineProperty(arr, i, desc);
                        } else arr[i] = value;
                    }
                }
                if (Context2) {
                    desc.value = null;
                    arr.length = length;
                }
                return arr;
            };
        });
        var require_from = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented5()() ? Array.from : require_shim5();
        });
        var require_to_array = __commonJS(function(exports, module1) {
            "use strict";
            var from = require_from();
            var isArray = Array.isArray;
            module1.exports = function(arrayLike) {
                return isArray(arrayLike) ? arrayLike : from(arrayLike);
            };
        });
        var require_resolve_resolve = __commonJS(function(exports, module1) {
            "use strict";
            var toArray2 = require_to_array();
            var isValue = require_is_value();
            var callable = require_valid_callable();
            var slice = Array.prototype.slice;
            var resolveArgs;
            resolveArgs = function resolveArgs(args) {
                return this.map(function(resolve, i) {
                    return resolve ? resolve(args[i]) : args[i];
                }).concat(slice.call(args, this.length));
            };
            module1.exports = function(resolvers) {
                resolvers = toArray2(resolvers);
                resolvers.forEach(function(resolve) {
                    if (isValue(resolve)) callable(resolve);
                });
                return resolveArgs.bind(resolvers);
            };
        });
        var require_resolve_normalize = __commonJS(function(exports, module1) {
            "use strict";
            var callable = require_valid_callable();
            module1.exports = function(userNormalizer) {
                var normalizer;
                if (typeof userNormalizer === "function") return {
                    set: userNormalizer,
                    get: userNormalizer
                };
                normalizer = {
                    get: callable(userNormalizer.get)
                };
                if (userNormalizer.set !== void 0) {
                    normalizer.set = callable(userNormalizer.set);
                    if (userNormalizer["delete"]) normalizer["delete"] = callable(userNormalizer["delete"]);
                    if (userNormalizer.clear) normalizer.clear = callable(userNormalizer.clear);
                    return normalizer;
                }
                normalizer.set = normalizer.get;
                return normalizer;
            };
        });
        var require_configure_map = __commonJS(function(exports, module1) {
            "use strict";
            var customError = require_custom();
            var defineLength = require_define_length();
            var d2 = require_d();
            var ee = require_event_emitter().methods;
            var resolveResolve = require_resolve_resolve();
            var resolveNormalize = require_resolve_normalize();
            var apply = Function.prototype.apply;
            var call = Function.prototype.call;
            var create = Object.create;
            var defineProperties = Object.defineProperties;
            var _on = ee.on;
            var emit = ee.emit;
            module1.exports = function(original, length, options) {
                var cache2 = create(null), conf, memLength, get2, set2, del, _clear, extDel, extGet, extHas, normalizer, getListeners, setListeners, deleteListeners, memoized, resolve;
                if (length !== false) memLength = length;
                else if (isNaN(original.length)) memLength = 1;
                else memLength = original.length;
                if (options.normalizer) {
                    normalizer = resolveNormalize(options.normalizer);
                    get2 = normalizer.get;
                    set2 = normalizer.set;
                    del = normalizer["delete"];
                    _clear = normalizer.clear;
                }
                if (options.resolvers != null) resolve = resolveResolve(options.resolvers);
                if (get2) memoized = defineLength(function(arg) {
                    var id, result, args = arguments;
                    if (resolve) args = resolve(args);
                    id = get2(args);
                    if (id !== null) {
                        if (hasOwnProperty.call(cache2, id)) {
                            if (getListeners) conf.emit("get", id, args, this);
                            return cache2[id];
                        }
                    }
                    if (args.length === 1) result = call.call(original, this, args[0]);
                    else result = apply.call(original, this, args);
                    if (id === null) {
                        id = get2(args);
                        if (id !== null) throw customError("Circular invocation", "CIRCULAR_INVOCATION");
                        id = set2(args);
                    } else if (hasOwnProperty.call(cache2, id)) throw customError("Circular invocation", "CIRCULAR_INVOCATION");
                    cache2[id] = result;
                    if (setListeners) conf.emit("set", id, null, result);
                    return result;
                }, memLength);
                else if (length === 0) memoized = function memoized() {
                    var result;
                    if (hasOwnProperty.call(cache2, "data")) {
                        if (getListeners) conf.emit("get", "data", arguments, this);
                        return cache2.data;
                    }
                    if (arguments.length) result = apply.call(original, this, arguments);
                    else result = call.call(original, this);
                    if (hasOwnProperty.call(cache2, "data")) throw customError("Circular invocation", "CIRCULAR_INVOCATION");
                    cache2.data = result;
                    if (setListeners) conf.emit("set", "data", null, result);
                    return result;
                };
                else memoized = function memoized(arg) {
                    var result, args = arguments, id;
                    if (resolve) args = resolve(arguments);
                    id = String(args[0]);
                    if (hasOwnProperty.call(cache2, id)) {
                        if (getListeners) conf.emit("get", id, args, this);
                        return cache2[id];
                    }
                    if (args.length === 1) result = call.call(original, this, args[0]);
                    else result = apply.call(original, this, args);
                    if (hasOwnProperty.call(cache2, id)) throw customError("Circular invocation", "CIRCULAR_INVOCATION");
                    cache2[id] = result;
                    if (setListeners) conf.emit("set", id, null, result);
                    return result;
                };
                conf = {
                    original: original,
                    memoized: memoized,
                    profileName: options.profileName,
                    get: function get(args) {
                        if (resolve) args = resolve(args);
                        if (get2) return get2(args);
                        return String(args[0]);
                    },
                    has: function has(id) {
                        return hasOwnProperty.call(cache2, id);
                    },
                    delete: function _delete(id) {
                        var result;
                        if (!hasOwnProperty.call(cache2, id)) return;
                        if (del) del(id);
                        result = cache2[id];
                        delete cache2[id];
                        if (deleteListeners) conf.emit("delete", id, result);
                    },
                    clear: function clear() {
                        var oldCache = cache2;
                        if (_clear) _clear();
                        cache2 = create(null);
                        conf.emit("clear", oldCache);
                    },
                    on: function on(type2, listener) {
                        if (type2 === "get") getListeners = true;
                        else if (type2 === "set") setListeners = true;
                        else if (type2 === "delete") deleteListeners = true;
                        return _on.call(this, type2, listener);
                    },
                    emit: emit,
                    updateEnv: function updateEnv() {
                        original = conf.original;
                    }
                };
                if (get2) extDel = defineLength(function(arg) {
                    var id, args = arguments;
                    if (resolve) args = resolve(args);
                    id = get2(args);
                    if (id === null) return;
                    conf["delete"](id);
                }, memLength);
                else if (length === 0) extDel = function extDel() {
                    return conf["delete"]("data");
                };
                else extDel = function extDel(arg) {
                    if (resolve) arg = resolve(arguments)[0];
                    return conf["delete"](arg);
                };
                extGet = defineLength(function() {
                    var id, args = arguments;
                    if (length === 0) return cache2.data;
                    if (resolve) args = resolve(args);
                    if (get2) id = get2(args);
                    else id = String(args[0]);
                    return cache2[id];
                });
                extHas = defineLength(function() {
                    var id, args = arguments;
                    if (length === 0) return conf.has("data");
                    if (resolve) args = resolve(args);
                    if (get2) id = get2(args);
                    else id = String(args[0]);
                    if (id === null) return false;
                    return conf.has(id);
                });
                defineProperties(memoized, {
                    __memoized__: d2(true),
                    delete: d2(extDel),
                    clear: d2(conf.clear),
                    _get: d2(extGet),
                    _has: d2(extHas)
                });
                return conf;
            };
        });
        var require_plain = __commonJS(function(exports, module1) {
            "use strict";
            var callable = require_valid_callable();
            var forEach = require_for_each();
            var extensions = require_registered_extensions();
            var configure4 = require_configure_map();
            var resolveLength = require_resolve_length();
            module1.exports = function self2(fn) {
                var options, length, conf;
                callable(fn);
                options = Object(arguments[1]);
                if (options.async && options.promise) throw new Error("Options 'async' and 'promise' cannot be used together");
                if (hasOwnProperty.call(fn, "__memoized__") && !options.force) return fn;
                length = resolveLength(options.length, fn.length, options.async && extensions.async);
                conf = configure4(fn, length, options);
                forEach(extensions, function(extFn, name) {
                    if (options[name]) extFn(options[name], conf, options);
                });
                if (self2.__profiler__) self2.__profiler__(conf);
                conf.updateEnv();
                return conf.memoized;
            };
        });
        var require_primitive = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(args) {
                var id, i, length = args.length;
                if (!length) return "\x02";
                id = String(args[i = 0]);
                while(--length)id += "\x01" + args[++i];
                return id;
            };
        });
        var require_get_primitive_fixed = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(length) {
                if (!length) return function() {
                    return "";
                };
                return function(args) {
                    var id = String(args[0]), i = 0, currentLength = length;
                    while(--currentLength)id += "\x01" + args[++i];
                    return id;
                };
            };
        });
        var require_is_implemented8 = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function() {
                var numberIsNaN = Number.isNaN;
                if (typeof numberIsNaN !== "function") return false;
                return !numberIsNaN({}) && numberIsNaN(NaN) && !numberIsNaN(34);
            };
        });
        var require_shim6 = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(value) {
                return value !== value;
            };
        });
        var require_is_nan = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = require_is_implemented8()() ? Number.isNaN : require_shim6();
        });
        var require_e_index_of = __commonJS(function(exports, module1) {
            "use strict";
            var numberIsNaN = require_is_nan();
            var toPosInt = require_to_pos_integer();
            var value = require_valid_value();
            var indexOf = Array.prototype.indexOf;
            var objHasOwnProperty = Object.prototype.hasOwnProperty;
            var abs = Math.abs;
            var floor = Math.floor;
            module1.exports = function(searchElement) {
                var i, length, fromIndex, val;
                if (!numberIsNaN(searchElement)) return indexOf.apply(this, arguments);
                length = toPosInt(value(this).length);
                fromIndex = arguments[1];
                if (isNaN(fromIndex)) fromIndex = 0;
                else if (fromIndex >= 0) fromIndex = floor(fromIndex);
                else fromIndex = toPosInt(this.length) - floor(abs(fromIndex));
                for(i = fromIndex; i < length; ++i)if (objHasOwnProperty.call(this, i)) {
                    val = this[i];
                    if (numberIsNaN(val)) return i;
                }
                return -1;
            };
        });
        var require_get = __commonJS(function(exports, module1) {
            "use strict";
            var indexOf = require_e_index_of();
            var create = Object.create;
            module1.exports = function() {
                var lastId = 0, map = [], cache2 = create(null);
                return {
                    get: function get(args) {
                        var index = 0, set2 = map, i, length = args.length;
                        if (length === 0) return set2[length] || null;
                        if (set2 = set2[length]) {
                            while(index < length - 1){
                                i = indexOf.call(set2[0], args[index]);
                                if (i === -1) return null;
                                set2 = set2[1][i];
                                ++index;
                            }
                            i = indexOf.call(set2[0], args[index]);
                            if (i === -1) return null;
                            return set2[1][i] || null;
                        }
                        return null;
                    },
                    set: function set(args) {
                        var index = 0, set2 = map, i, length = args.length;
                        if (length === 0) set2[length] = ++lastId;
                        else {
                            if (!set2[length]) set2[length] = [
                                [],
                                []
                            ];
                            set2 = set2[length];
                            while(index < length - 1){
                                i = indexOf.call(set2[0], args[index]);
                                if (i === -1) {
                                    i = set2[0].push(args[index]) - 1;
                                    set2[1].push([
                                        [],
                                        []
                                    ]);
                                }
                                set2 = set2[1][i];
                                ++index;
                            }
                            i = indexOf.call(set2[0], args[index]);
                            if (i === -1) i = set2[0].push(args[index]) - 1;
                            set2[1][i] = ++lastId;
                        }
                        cache2[lastId] = args;
                        return lastId;
                    },
                    delete: function _delete(id) {
                        var index = 0, set2 = map, i, args = cache2[id], length = args.length, path = [];
                        if (length === 0) delete set2[length];
                        else if (set2 = set2[length]) {
                            while(index < length - 1){
                                i = indexOf.call(set2[0], args[index]);
                                if (i === -1) return;
                                path.push(set2, i);
                                set2 = set2[1][i];
                                ++index;
                            }
                            i = indexOf.call(set2[0], args[index]);
                            if (i === -1) return;
                            id = set2[1][i];
                            set2[0].splice(i, 1);
                            set2[1].splice(i, 1);
                            while(!set2[0].length && path.length){
                                i = path.pop();
                                set2 = path.pop();
                                set2[0].splice(i, 1);
                                set2[1].splice(i, 1);
                            }
                        }
                        delete cache2[id];
                    },
                    clear: function clear() {
                        map = [];
                        cache2 = create(null);
                    }
                };
            };
        });
        var require_get_1 = __commonJS(function(exports, module1) {
            "use strict";
            var indexOf = require_e_index_of();
            module1.exports = function() {
                var lastId = 0, argsMap = [], cache2 = [];
                return {
                    get: function get(args) {
                        var index = indexOf.call(argsMap, args[0]);
                        return index === -1 ? null : cache2[index];
                    },
                    set: function set(args) {
                        argsMap.push(args[0]);
                        cache2.push(++lastId);
                        return lastId;
                    },
                    delete: function _delete(id) {
                        var index = indexOf.call(cache2, id);
                        if (index !== -1) {
                            argsMap.splice(index, 1);
                            cache2.splice(index, 1);
                        }
                    },
                    clear: function clear() {
                        argsMap = [];
                        cache2 = [];
                    }
                };
            };
        });
        var require_get_fixed = __commonJS(function(exports, module1) {
            "use strict";
            var indexOf = require_e_index_of();
            var create = Object.create;
            module1.exports = function(length) {
                var lastId = 0, map = [
                    [],
                    []
                ], cache2 = create(null);
                return {
                    get: function get(args) {
                        var index = 0, set2 = map, i;
                        while(index < length - 1){
                            i = indexOf.call(set2[0], args[index]);
                            if (i === -1) return null;
                            set2 = set2[1][i];
                            ++index;
                        }
                        i = indexOf.call(set2[0], args[index]);
                        if (i === -1) return null;
                        return set2[1][i] || null;
                    },
                    set: function set(args) {
                        var index = 0, set2 = map, i;
                        while(index < length - 1){
                            i = indexOf.call(set2[0], args[index]);
                            if (i === -1) {
                                i = set2[0].push(args[index]) - 1;
                                set2[1].push([
                                    [],
                                    []
                                ]);
                            }
                            set2 = set2[1][i];
                            ++index;
                        }
                        i = indexOf.call(set2[0], args[index]);
                        if (i === -1) i = set2[0].push(args[index]) - 1;
                        set2[1][i] = ++lastId;
                        cache2[lastId] = args;
                        return lastId;
                    },
                    delete: function _delete(id) {
                        var index = 0, set2 = map, i, path = [], args = cache2[id];
                        while(index < length - 1){
                            i = indexOf.call(set2[0], args[index]);
                            if (i === -1) return;
                            path.push(set2, i);
                            set2 = set2[1][i];
                            ++index;
                        }
                        i = indexOf.call(set2[0], args[index]);
                        if (i === -1) return;
                        id = set2[1][i];
                        set2[0].splice(i, 1);
                        set2[1].splice(i, 1);
                        while(!set2[0].length && path.length){
                            i = path.pop();
                            set2 = path.pop();
                            set2[0].splice(i, 1);
                            set2[1].splice(i, 1);
                        }
                        delete cache2[id];
                    },
                    clear: function clear() {
                        map = [
                            [],
                            []
                        ];
                        cache2 = create(null);
                    }
                };
            };
        });
        var require_map = __commonJS(function(exports, module1) {
            "use strict";
            var callable = require_valid_callable();
            var forEach = require_for_each();
            var call = Function.prototype.call;
            module1.exports = function(obj, cb) {
                var result = {}, thisArg = arguments[2];
                callable(cb);
                forEach(obj, function(value, key, targetObj, index) {
                    result[key] = call.call(cb, thisArg, value, key, targetObj, index);
                });
                return result;
            };
        });
        var require_next_tick = __commonJS(function(exports, module1) {
            "use strict";
            var ensureCallable = function ensureCallable(fn) {
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                return fn;
            };
            var byObserver = function byObserver(Observer) {
                var node = document.createTextNode(""), queue2, currentQueue, i = 0;
                new Observer(function() {
                    var callback;
                    if (!queue2) {
                        if (!currentQueue) return;
                        queue2 = currentQueue;
                    } else if (currentQueue) queue2 = currentQueue.concat(queue2);
                    currentQueue = queue2;
                    queue2 = null;
                    if (typeof currentQueue === "function") {
                        callback = currentQueue;
                        currentQueue = null;
                        callback();
                        return;
                    }
                    node.data = i = ++i % 2;
                    while(currentQueue){
                        callback = currentQueue.shift();
                        if (!currentQueue.length) currentQueue = null;
                        callback();
                    }
                }).observe(node, {
                    characterData: true
                });
                return function(fn) {
                    ensureCallable(fn);
                    if (queue2) {
                        if (typeof queue2 === "function") queue2 = [
                            queue2,
                            fn
                        ];
                        else queue2.push(fn);
                        return;
                    }
                    queue2 = fn;
                    node.data = i = ++i % 2;
                };
            };
            module1.exports = function() {
                if ((typeof $hPtJY === "undefined" ? "undefined" : _typeof($hPtJY)) === "object" && $hPtJY && typeof $hPtJY.nextTick === "function") return $hPtJY.nextTick;
                if (typeof queueMicrotask === "function") return function(cb) {
                    queueMicrotask(ensureCallable(cb));
                };
                if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object" && document) {
                    if (typeof MutationObserver === "function") return byObserver(MutationObserver);
                    if (typeof WebKitMutationObserver === "function") return byObserver(WebKitMutationObserver);
                }
                if (typeof setImmediate === "function") return function(cb) {
                    setImmediate(ensureCallable(cb));
                };
                if (typeof setTimeout === "function" || (typeof setTimeout === "undefined" ? "undefined" : _typeof(setTimeout)) === "object") return function(cb) {
                    setTimeout(ensureCallable(cb), 0);
                };
                return null;
            }();
        });
        var require_async = __commonJS(function() {
            "use strict";
            var aFrom = require_from();
            var objectMap = require_map();
            var mixin = require_mixin();
            var defineLength = require_define_length();
            var nextTick = require_next_tick();
            var slice = Array.prototype.slice;
            var apply = Function.prototype.apply;
            var create = Object.create;
            require_registered_extensions().async = function(tbi, conf) {
                var waiting = create(null), cache2 = create(null), base = conf.memoized, original = conf.original, currentCallback, currentContext, currentArgs;
                conf.memoized = defineLength(function(arg) {
                    var args = arguments, last2 = args[args.length - 1];
                    if (typeof last2 === "function") {
                        currentCallback = last2;
                        args = slice.call(args, 0, -1);
                    }
                    return base.apply(currentContext = this, currentArgs = args);
                }, base);
                try {
                    mixin(conf.memoized, base);
                } catch (ignore) {}
                conf.on("get", function(id) {
                    var cb, context, args;
                    if (!currentCallback) return;
                    if (waiting[id]) {
                        if (typeof waiting[id] === "function") waiting[id] = [
                            waiting[id],
                            currentCallback
                        ];
                        else waiting[id].push(currentCallback);
                        currentCallback = null;
                        return;
                    }
                    cb = currentCallback;
                    context = currentContext;
                    args = currentArgs;
                    currentCallback = currentContext = currentArgs = null;
                    nextTick(function() {
                        var data;
                        if (hasOwnProperty.call(cache2, id)) {
                            data = cache2[id];
                            conf.emit("getasync", id, args, context);
                            apply.call(cb, data.context, data.args);
                        } else {
                            currentCallback = cb;
                            currentContext = context;
                            currentArgs = args;
                            base.apply(context, args);
                        }
                    });
                });
                conf.original = function() {
                    var args, cb, origCb, result;
                    if (!currentCallback) return apply.call(original, this, arguments);
                    args = aFrom(arguments);
                    cb = function self2(err2) {
                        var cb2, args2, id = self2.id;
                        if (id == null) {
                            nextTick(apply.bind(self2, this, arguments));
                            return void 0;
                        }
                        delete self2.id;
                        cb2 = waiting[id];
                        delete waiting[id];
                        if (!cb2) return void 0;
                        args2 = aFrom(arguments);
                        if (conf.has(id)) {
                            if (err2) conf["delete"](id);
                            else {
                                cache2[id] = {
                                    context: this,
                                    args: args2
                                };
                                conf.emit("setasync", id, typeof cb2 === "function" ? 1 : cb2.length);
                            }
                        }
                        if (typeof cb2 === "function") result = apply.call(cb2, this, args2);
                        else cb2.forEach(function(cb3) {
                            result = apply.call(cb3, this, args2);
                        }, this);
                        return result;
                    };
                    origCb = currentCallback;
                    currentCallback = currentContext = currentArgs = null;
                    args.push(cb);
                    result = apply.call(original, this, args);
                    cb.cb = origCb;
                    currentCallback = cb;
                    return result;
                };
                conf.on("set", function(id) {
                    if (!currentCallback) {
                        conf["delete"](id);
                        return;
                    }
                    if (waiting[id]) {
                        if (typeof waiting[id] === "function") waiting[id] = [
                            waiting[id],
                            currentCallback.cb
                        ];
                        else waiting[id].push(currentCallback.cb);
                    } else waiting[id] = currentCallback.cb;
                    delete currentCallback.cb;
                    currentCallback.id = id;
                    currentCallback = null;
                });
                conf.on("delete", function(id) {
                    var result;
                    if (hasOwnProperty.call(waiting, id)) return;
                    if (!cache2[id]) return;
                    result = cache2[id];
                    delete cache2[id];
                    conf.emit("deleteasync", id, slice.call(result.args, 1));
                });
                conf.on("clear", function() {
                    var oldCache = cache2;
                    cache2 = create(null);
                    conf.emit("clearasync", objectMap(oldCache, function(data) {
                        return slice.call(data.args, 1);
                    }));
                });
            };
        });
        var require_primitive_set = __commonJS(function(exports, module1) {
            "use strict";
            var forEach = Array.prototype.forEach;
            var create = Object.create;
            module1.exports = function(arg) {
                var set2 = create(null);
                forEach.call(arguments, function(name) {
                    set2[name] = true;
                });
                return set2;
            };
        });
        var require_is_callable = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = function(obj) {
                return typeof obj === "function";
            };
        });
        var require_validate_stringifiable = __commonJS(function(exports, module1) {
            "use strict";
            var isCallable = require_is_callable();
            module1.exports = function(stringifiable) {
                try {
                    if (stringifiable && isCallable(stringifiable.toString)) return stringifiable.toString();
                    return String(stringifiable);
                } catch (e) {
                    throw new TypeError("Passed argument cannot be stringifed");
                }
            };
        });
        var require_validate_stringifiable_value = __commonJS(function(exports, module1) {
            "use strict";
            var ensureValue = require_valid_value();
            var stringifiable = require_validate_stringifiable();
            module1.exports = function(value) {
                return stringifiable(ensureValue(value));
            };
        });
        var require_safe_to_string = __commonJS(function(exports, module1) {
            "use strict";
            var isCallable = require_is_callable();
            module1.exports = function(value) {
                try {
                    if (value && isCallable(value.toString)) return value.toString();
                    return String(value);
                } catch (e) {
                    return "<Non-coercible to string value>";
                }
            };
        });
        var require_to_short_string_representation = __commonJS(function(exports, module1) {
            "use strict";
            var safeToString = require_safe_to_string();
            var reNewLine = /[\n\r\u2028\u2029]/g;
            module1.exports = function(value) {
                var string = safeToString(value);
                if (string.length > 100) string = string.slice(0, 99) + "…";
                string = string.replace(reNewLine, function(_char) {
                    return JSON.stringify(_char).slice(1, -1);
                });
                return string;
            };
        });
        var require_is_promise = __commonJS(function(exports, module1) {
            module1.exports = isPromise;
            module1.exports["default"] = isPromise;
            function isPromise(obj) {
                return !!obj && (_typeof(obj) === "object" || typeof obj === "function") && typeof obj.then === "function";
            }
        });
        var require_promise = __commonJS(function() {
            "use strict";
            var objectMap = require_map();
            var primitiveSet = require_primitive_set();
            var ensureString = require_validate_stringifiable_value();
            var toShortString = require_to_short_string_representation();
            var isPromise = require_is_promise();
            var nextTick = require_next_tick();
            var create = Object.create;
            var supportedModes = primitiveSet("then", "then:finally", "done", "done:finally");
            require_registered_extensions().promise = function(mode, conf) {
                var waiting = create(null), cache2 = create(null), promises = create(null);
                if (mode === true) mode = null;
                else {
                    mode = ensureString(mode);
                    if (!supportedModes[mode]) throw new TypeError("'" + toShortString(mode) + "' is not valid promise mode");
                }
                conf.on("set", function(id, ignore, promise) {
                    var isFailed = false;
                    if (!isPromise(promise)) {
                        cache2[id] = promise;
                        conf.emit("setasync", id, 1);
                        return;
                    }
                    waiting[id] = 1;
                    promises[id] = promise;
                    var onSuccess = function onSuccess(result) {
                        var count = waiting[id];
                        if (isFailed) throw new Error("Memoizee error: Detected unordered then|done & finally resolution, which in turn makes proper detection of success/failure impossible (when in 'done:finally' mode)\nConsider to rely on 'then' or 'done' mode instead.");
                        if (!count) return;
                        delete waiting[id];
                        cache2[id] = result;
                        conf.emit("setasync", id, count);
                    };
                    var onFailure = function onFailure() {
                        isFailed = true;
                        if (!waiting[id]) return;
                        delete waiting[id];
                        delete promises[id];
                        conf["delete"](id);
                    };
                    var resolvedMode = mode;
                    if (!resolvedMode) resolvedMode = "then";
                    if (resolvedMode === "then") {
                        var nextTickFailure = function nextTickFailure() {
                            nextTick(onFailure);
                        };
                        promise = promise.then(function(result) {
                            nextTick(onSuccess.bind(this, result));
                        }, nextTickFailure);
                        if (typeof promise["finally"] === "function") promise["finally"](nextTickFailure);
                    } else if (resolvedMode === "done") {
                        if (typeof promise.done !== "function") throw new Error("Memoizee error: Retrieved promise does not implement 'done' in 'done' mode");
                        promise.done(onSuccess, onFailure);
                    } else if (resolvedMode === "done:finally") {
                        if (typeof promise.done !== "function") throw new Error("Memoizee error: Retrieved promise does not implement 'done' in 'done:finally' mode");
                        if (typeof promise["finally"] !== "function") throw new Error("Memoizee error: Retrieved promise does not implement 'finally' in 'done:finally' mode");
                        promise.done(onSuccess);
                        promise["finally"](onFailure);
                    }
                });
                conf.on("get", function(id, args, context) {
                    var promise;
                    if (waiting[id]) {
                        ++waiting[id];
                        return;
                    }
                    promise = promises[id];
                    var emit = function emit() {
                        conf.emit("getasync", id, args, context);
                    };
                    if (isPromise(promise)) {
                        if (typeof promise.done === "function") promise.done(emit);
                        else promise.then(function() {
                            nextTick(emit);
                        });
                    } else emit();
                });
                conf.on("delete", function(id) {
                    delete promises[id];
                    if (waiting[id]) {
                        delete waiting[id];
                        return;
                    }
                    if (!hasOwnProperty.call(cache2, id)) return;
                    var result = cache2[id];
                    delete cache2[id];
                    conf.emit("deleteasync", id, [
                        result
                    ]);
                });
                conf.on("clear", function() {
                    var oldCache = cache2;
                    cache2 = create(null);
                    waiting = create(null);
                    promises = create(null);
                    conf.emit("clearasync", objectMap(oldCache, function(data) {
                        return [
                            data
                        ];
                    }));
                });
            };
        });
        var require_dispose = __commonJS(function() {
            "use strict";
            var callable = require_valid_callable();
            var forEach = require_for_each();
            var extensions = require_registered_extensions();
            var apply = Function.prototype.apply;
            extensions.dispose = function(dispose, conf, options) {
                var del;
                callable(dispose);
                if (options.async && extensions.async || options.promise && extensions.promise) {
                    conf.on("deleteasync", del = function del(id, resultArray) {
                        apply.call(dispose, null, resultArray);
                    });
                    conf.on("clearasync", function(cache2) {
                        forEach(cache2, function(result, id) {
                            del(id, result);
                        });
                    });
                    return;
                }
                conf.on("delete", del = function del(id, result) {
                    dispose(result);
                });
                conf.on("clear", function(cache2) {
                    forEach(cache2, function(result, id) {
                        del(id, result);
                    });
                });
            };
        });
        var require_max_timeout = __commonJS(function(exports, module1) {
            "use strict";
            module1.exports = 2147483647;
        });
        var require_valid_timeout = __commonJS(function(exports, module1) {
            "use strict";
            var toPosInt = require_to_pos_integer();
            var maxTimeout = require_max_timeout();
            module1.exports = function(value) {
                value = toPosInt(value);
                if (value > maxTimeout) throw new TypeError(value + " exceeds maximum possible timeout");
                return value;
            };
        });
        var require_max_age = __commonJS(function() {
            "use strict";
            var aFrom = require_from();
            var forEach = require_for_each();
            var nextTick = require_next_tick();
            var isPromise = require_is_promise();
            var timeout = require_valid_timeout();
            var extensions = require_registered_extensions();
            var noop3 = Function.prototype;
            var max2 = Math.max;
            var min = Math.min;
            var create = Object.create;
            extensions.maxAge = function(maxAge, conf, options) {
                var timeouts, postfix, preFetchAge, preFetchTimeouts;
                maxAge = timeout(maxAge);
                if (!maxAge) return;
                timeouts = create(null);
                postfix = options.async && extensions.async || options.promise && extensions.promise ? "async" : "";
                conf.on("set" + postfix, function(id) {
                    timeouts[id] = setTimeout(function() {
                        conf["delete"](id);
                    }, maxAge);
                    if (typeof timeouts[id].unref === "function") timeouts[id].unref();
                    if (!preFetchTimeouts) return;
                    if (preFetchTimeouts[id]) {
                        if (preFetchTimeouts[id] !== "nextTick") clearTimeout(preFetchTimeouts[id]);
                    }
                    preFetchTimeouts[id] = setTimeout(function() {
                        delete preFetchTimeouts[id];
                    }, preFetchAge);
                    if (typeof preFetchTimeouts[id].unref === "function") preFetchTimeouts[id].unref();
                });
                conf.on("delete" + postfix, function(id) {
                    clearTimeout(timeouts[id]);
                    delete timeouts[id];
                    if (!preFetchTimeouts) return;
                    if (preFetchTimeouts[id] !== "nextTick") clearTimeout(preFetchTimeouts[id]);
                    delete preFetchTimeouts[id];
                });
                if (options.preFetch) {
                    if (options.preFetch === true || isNaN(options.preFetch)) preFetchAge = .333;
                    else preFetchAge = max2(min(Number(options.preFetch), 1), 0);
                    if (preFetchAge) {
                        preFetchTimeouts = {};
                        preFetchAge = (1 - preFetchAge) * maxAge;
                        conf.on("get" + postfix, function(id, args, context) {
                            if (!preFetchTimeouts[id]) {
                                preFetchTimeouts[id] = "nextTick";
                                nextTick(function() {
                                    var result;
                                    if (preFetchTimeouts[id] !== "nextTick") return;
                                    delete preFetchTimeouts[id];
                                    conf["delete"](id);
                                    if (options.async) {
                                        args = aFrom(args);
                                        args.push(noop3);
                                    }
                                    result = conf.memoized.apply(context, args);
                                    if (options.promise) {
                                        if (isPromise(result)) {
                                            if (typeof result.done === "function") result.done(noop3, noop3);
                                            else result.then(noop3, noop3);
                                        }
                                    }
                                });
                            }
                        });
                    }
                }
                conf.on("clear" + postfix, function() {
                    forEach(timeouts, function(id) {
                        clearTimeout(id);
                    });
                    timeouts = {};
                    if (preFetchTimeouts) {
                        forEach(preFetchTimeouts, function(id) {
                            if (id !== "nextTick") clearTimeout(id);
                        });
                        preFetchTimeouts = {};
                    }
                });
            };
        });
        var require_lru_queue = __commonJS(function(exports, module1) {
            "use strict";
            var toPosInt = require_to_pos_integer();
            var create = Object.create;
            var hasOwnProperty2 = Object.prototype.hasOwnProperty;
            module1.exports = function(limit) {
                var size = 0, base = 1, queue2 = create(null), map = create(null), index = 0, del;
                limit = toPosInt(limit);
                return {
                    hit: function hit(id) {
                        var oldIndex = map[id], nuIndex = ++index;
                        queue2[nuIndex] = id;
                        map[id] = nuIndex;
                        if (!oldIndex) {
                            ++size;
                            if (size <= limit) return;
                            id = queue2[base];
                            del(id);
                            return id;
                        }
                        delete queue2[oldIndex];
                        if (base !== oldIndex) return;
                        while(!hasOwnProperty2.call(queue2, ++base))continue;
                    },
                    delete: del = function del(id) {
                        var oldIndex = map[id];
                        if (!oldIndex) return;
                        delete queue2[oldIndex];
                        delete map[id];
                        --size;
                        if (base !== oldIndex) return;
                        if (!size) {
                            index = 0;
                            base = 1;
                            return;
                        }
                        while(!hasOwnProperty2.call(queue2, ++base))continue;
                    },
                    clear: function clear() {
                        size = 0;
                        base = 1;
                        queue2 = create(null);
                        map = create(null);
                        index = 0;
                    }
                };
            };
        });
        var require_max = __commonJS(function() {
            "use strict";
            var toPosInteger = require_to_pos_integer();
            var lruQueue = require_lru_queue();
            var extensions = require_registered_extensions();
            extensions.max = function(max2, conf, options) {
                var postfix, queue2, hit;
                max2 = toPosInteger(max2);
                if (!max2) return;
                queue2 = lruQueue(max2);
                postfix = options.async && extensions.async || options.promise && extensions.promise ? "async" : "";
                conf.on("set" + postfix, hit = function hit(id) {
                    id = queue2.hit(id);
                    if (id === void 0) return;
                    conf["delete"](id);
                });
                conf.on("get" + postfix, hit);
                conf.on("delete" + postfix, queue2["delete"]);
                conf.on("clear" + postfix, queue2.clear);
            };
        });
        var require_ref_counter = __commonJS(function() {
            "use strict";
            var d2 = require_d();
            var extensions = require_registered_extensions();
            var create = Object.create;
            var defineProperties = Object.defineProperties;
            extensions.refCounter = function(ignore, conf, options) {
                var cache2, postfix;
                cache2 = create(null);
                postfix = options.async && extensions.async || options.promise && extensions.promise ? "async" : "";
                conf.on("set" + postfix, function(id, length) {
                    cache2[id] = length || 1;
                });
                conf.on("get" + postfix, function(id) {
                    ++cache2[id];
                });
                conf.on("delete" + postfix, function(id) {
                    delete cache2[id];
                });
                conf.on("clear" + postfix, function() {
                    cache2 = {};
                });
                defineProperties(conf.memoized, {
                    deleteRef: d2(function() {
                        var id = conf.get(arguments);
                        if (id === null) return null;
                        if (!cache2[id]) return null;
                        if (!--cache2[id]) {
                            conf["delete"](id);
                            return true;
                        }
                        return false;
                    }),
                    getRefCount: d2(function() {
                        var id = conf.get(arguments);
                        if (id === null) return 0;
                        if (!cache2[id]) return 0;
                        return cache2[id];
                    })
                });
            };
        });
        var require_memoizee = __commonJS(function(exports, module1) {
            "use strict";
            var normalizeOpts = require_normalize_options();
            var resolveLength = require_resolve_length();
            var plain = require_plain();
            module1.exports = function(fn) {
                var options = normalizeOpts(arguments[1]), length;
                if (!options.normalizer) {
                    length = options.length = resolveLength(options.length, fn.length, options.async);
                    if (length !== 0) {
                        if (options.primitive) {
                            if (length === false) options.normalizer = require_primitive();
                            else if (length > 1) options.normalizer = require_get_primitive_fixed()(length);
                        } else if (length === false) options.normalizer = require_get()();
                        else if (length === 1) options.normalizer = require_get_1()();
                        else options.normalizer = require_get_fixed()(length);
                    }
                }
                if (options.async) require_async();
                if (options.promise) require_promise();
                if (options.dispose) require_dispose();
                if (options.maxAge) require_max_age();
                if (options.max) require_max();
                if (options.refCounter) require_ref_counter();
                return plain(fn, options);
            };
        });
        var require_utils = __commonJS(function(exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function isIdentStart(c4) {
                return c4 >= "a" && c4 <= "z" || c4 >= "A" && c4 <= "Z" || c4 === "-" || c4 === "_";
            }
            exports.isIdentStart = isIdentStart;
            function isIdent(c4) {
                return c4 >= "a" && c4 <= "z" || c4 >= "A" && c4 <= "Z" || c4 >= "0" && c4 <= "9" || c4 === "-" || c4 === "_";
            }
            exports.isIdent = isIdent;
            function isHex(c4) {
                return c4 >= "a" && c4 <= "f" || c4 >= "A" && c4 <= "F" || c4 >= "0" && c4 <= "9";
            }
            exports.isHex = isHex;
            function escapeIdentifier(s) {
                var len = s.length;
                var result = "";
                var i = 0;
                while(i < len){
                    var chr = s.charAt(i);
                    if (exports.identSpecialChars[chr]) result += "\\" + chr;
                    else if (!(chr === "_" || chr === "-" || chr >= "A" && chr <= "Z" || chr >= "a" && chr <= "z" || i !== 0 && chr >= "0" && chr <= "9")) {
                        var charCode = chr.charCodeAt(0);
                        if ((charCode & 63488) === 55296) {
                            var extraCharCode = s.charCodeAt(i++);
                            if ((charCode & 64512) !== 55296 || (extraCharCode & 64512) !== 56320) throw Error("UCS-2(decode): illegal sequence");
                            charCode = ((charCode & 1023) << 10) + (extraCharCode & 1023) + 65536;
                        }
                        result += "\\" + charCode.toString(16) + " ";
                    } else result += chr;
                    i++;
                }
                return result;
            }
            exports.escapeIdentifier = escapeIdentifier;
            function escapeStr(s) {
                var len = s.length;
                var result = "";
                var i = 0;
                var replacement;
                while(i < len){
                    var chr = s.charAt(i);
                    if (chr === '"') chr = '\\"';
                    else if (chr === "\\") chr = "\\\\";
                    else if ((replacement = exports.strReplacementsRev[chr]) !== void 0) chr = replacement;
                    result += chr;
                    i++;
                }
                return '"' + result + '"';
            }
            exports.escapeStr = escapeStr;
            exports.identSpecialChars = {
                "!": true,
                '"': true,
                "#": true,
                $: true,
                "%": true,
                "&": true,
                "'": true,
                "(": true,
                ")": true,
                "*": true,
                "+": true,
                ",": true,
                ".": true,
                "/": true,
                ";": true,
                "<": true,
                "=": true,
                ">": true,
                "?": true,
                "@": true,
                "[": true,
                "\\": true,
                "]": true,
                "^": true,
                "`": true,
                "{": true,
                "|": true,
                "}": true,
                "~": true
            };
            exports.strReplacementsRev = {
                "\n": "\\n",
                "\r": "\\r",
                "	": "\\t",
                "\f": "\\f",
                "\v": "\\v"
            };
            exports.singleQuoteEscapeChars = {
                n: "\n",
                r: "\r",
                t: "	",
                f: "\f",
                "\\": "\\",
                "'": "'"
            };
            exports.doubleQuotesEscapeChars = {
                n: "\n",
                r: "\r",
                t: "	",
                f: "\f",
                "\\": "\\",
                '"': '"'
            };
        });
        var require_parser_context = __commonJS(function(exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var utils_1 = require_utils();
            function parseCssSelector(str, pos, pseudos, attrEqualityMods, ruleNestingOperators, substitutesEnabled) {
                var l = str.length;
                var chr = "";
                function getStr(quote, escapeTable) {
                    var result = "";
                    pos++;
                    chr = str.charAt(pos);
                    while(pos < l){
                        if (chr === quote) {
                            pos++;
                            return result;
                        } else if (chr === "\\") {
                            pos++;
                            chr = str.charAt(pos);
                            var esc = void 0;
                            if (chr === quote) result += quote;
                            else if ((esc = escapeTable[chr]) !== void 0) result += esc;
                            else if (utils_1.isHex(chr)) {
                                var hex = chr;
                                pos++;
                                chr = str.charAt(pos);
                                while(utils_1.isHex(chr)){
                                    hex += chr;
                                    pos++;
                                    chr = str.charAt(pos);
                                }
                                if (chr === " ") {
                                    pos++;
                                    chr = str.charAt(pos);
                                }
                                result += String.fromCharCode(parseInt(hex, 16));
                                continue;
                            } else result += chr;
                        } else result += chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    return result;
                }
                function getIdent() {
                    var result = "";
                    chr = str.charAt(pos);
                    while(pos < l){
                        if (utils_1.isIdent(chr)) result += chr;
                        else if (chr === "\\") {
                            pos++;
                            if (pos >= l) throw Error("Expected symbol but end of file reached.");
                            chr = str.charAt(pos);
                            if (utils_1.identSpecialChars[chr]) result += chr;
                            else if (utils_1.isHex(chr)) {
                                var hex = chr;
                                pos++;
                                chr = str.charAt(pos);
                                while(utils_1.isHex(chr)){
                                    hex += chr;
                                    pos++;
                                    chr = str.charAt(pos);
                                }
                                if (chr === " ") {
                                    pos++;
                                    chr = str.charAt(pos);
                                }
                                result += String.fromCharCode(parseInt(hex, 16));
                                continue;
                            } else result += chr;
                        } else return result;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    return result;
                }
                function skipWhitespace() {
                    chr = str.charAt(pos);
                    var result = false;
                    while(chr === " " || chr === "	" || chr === "\n" || chr === "\r" || chr === "\f"){
                        result = true;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    return result;
                }
                function parse3() {
                    var res = parseSelector();
                    if (pos < l) throw Error('Rule expected but "' + str.charAt(pos) + '" found.');
                    return res;
                }
                function parseSelector() {
                    var selector = parseSingleSelector();
                    if (!selector) return null;
                    var res = selector;
                    chr = str.charAt(pos);
                    while(chr === ","){
                        pos++;
                        skipWhitespace();
                        if (res.type !== "selectors") res = {
                            type: "selectors",
                            selectors: [
                                selector
                            ]
                        };
                        selector = parseSingleSelector();
                        if (!selector) throw Error('Rule expected after ",".');
                        res.selectors.push(selector);
                    }
                    return res;
                }
                function parseSingleSelector() {
                    skipWhitespace();
                    var selector = {
                        type: "ruleSet"
                    };
                    var rule = parseRule();
                    if (!rule) return null;
                    var currentRule = selector;
                    while(rule){
                        rule.type = "rule";
                        currentRule.rule = rule;
                        currentRule = rule;
                        skipWhitespace();
                        chr = str.charAt(pos);
                        if (pos >= l || chr === "," || chr === ")") break;
                        if (ruleNestingOperators[chr]) {
                            var op = chr;
                            pos++;
                            skipWhitespace();
                            rule = parseRule();
                            if (!rule) throw Error('Rule expected after "' + op + '".');
                            rule.nestingOperator = op;
                        } else {
                            rule = parseRule();
                            if (rule) rule.nestingOperator = null;
                        }
                    }
                    return selector;
                }
                function parseRule() {
                    var rule = null;
                    while(pos < l){
                        chr = str.charAt(pos);
                        if (chr === "*") {
                            pos++;
                            (rule = rule || {}).tagName = "*";
                        } else if (utils_1.isIdentStart(chr) || chr === "\\") (rule = rule || {}).tagName = getIdent();
                        else if (chr === ".") {
                            pos++;
                            rule = rule || {};
                            (rule.classNames = rule.classNames || []).push(getIdent());
                        } else if (chr === "#") {
                            pos++;
                            (rule = rule || {}).id = getIdent();
                        } else if (chr === "[") {
                            pos++;
                            skipWhitespace();
                            var attr = {
                                name: getIdent()
                            };
                            skipWhitespace();
                            if (chr === "]") pos++;
                            else {
                                var operator = "";
                                if (attrEqualityMods[chr]) {
                                    operator = chr;
                                    pos++;
                                    chr = str.charAt(pos);
                                }
                                if (pos >= l) throw Error('Expected "=" but end of file reached.');
                                if (chr !== "=") throw Error('Expected "=" but "' + chr + '" found.');
                                attr.operator = operator + "=";
                                pos++;
                                skipWhitespace();
                                var attrValue = "";
                                attr.valueType = "string";
                                if (chr === '"') attrValue = getStr('"', utils_1.doubleQuotesEscapeChars);
                                else if (chr === "'") attrValue = getStr("'", utils_1.singleQuoteEscapeChars);
                                else if (substitutesEnabled && chr === "$") {
                                    pos++;
                                    attrValue = getIdent();
                                    attr.valueType = "substitute";
                                } else {
                                    while(pos < l){
                                        if (chr === "]") break;
                                        attrValue += chr;
                                        pos++;
                                        chr = str.charAt(pos);
                                    }
                                    attrValue = attrValue.trim();
                                }
                                skipWhitespace();
                                if (pos >= l) throw Error('Expected "]" but end of file reached.');
                                if (chr !== "]") throw Error('Expected "]" but "' + chr + '" found.');
                                pos++;
                                attr.value = attrValue;
                            }
                            rule = rule || {};
                            (rule.attrs = rule.attrs || []).push(attr);
                        } else if (chr === ":") {
                            pos++;
                            var pseudoName = getIdent();
                            var pseudo = {
                                name: pseudoName
                            };
                            if (chr === "(") {
                                pos++;
                                var value = "";
                                skipWhitespace();
                                if (pseudos[pseudoName] === "selector") {
                                    pseudo.valueType = "selector";
                                    value = parseSelector();
                                } else {
                                    pseudo.valueType = pseudos[pseudoName] || "string";
                                    if (chr === '"') value = getStr('"', utils_1.doubleQuotesEscapeChars);
                                    else if (chr === "'") value = getStr("'", utils_1.singleQuoteEscapeChars);
                                    else if (substitutesEnabled && chr === "$") {
                                        pos++;
                                        value = getIdent();
                                        pseudo.valueType = "substitute";
                                    } else {
                                        while(pos < l){
                                            if (chr === ")") break;
                                            value += chr;
                                            pos++;
                                            chr = str.charAt(pos);
                                        }
                                        value = value.trim();
                                    }
                                    skipWhitespace();
                                }
                                if (pos >= l) throw Error('Expected ")" but end of file reached.');
                                if (chr !== ")") throw Error('Expected ")" but "' + chr + '" found.');
                                pos++;
                                pseudo.value = value;
                            }
                            rule = rule || {};
                            (rule.pseudos = rule.pseudos || []).push(pseudo);
                        } else break;
                    }
                    return rule;
                }
                return parse3();
            }
            exports.parseCssSelector = parseCssSelector;
        });
        var require_render = __commonJS(function(exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var utils_1 = require_utils();
            function renderEntity(entity) {
                var res = "";
                switch(entity.type){
                    case "ruleSet":
                        var currentEntity = entity.rule;
                        var parts = [];
                        while(currentEntity){
                            if (currentEntity.nestingOperator) parts.push(currentEntity.nestingOperator);
                            parts.push(renderEntity(currentEntity));
                            currentEntity = currentEntity.rule;
                        }
                        res = parts.join(" ");
                        break;
                    case "selectors":
                        res = entity.selectors.map(renderEntity).join(", ");
                        break;
                    case "rule":
                        if (entity.tagName) {
                            if (entity.tagName === "*") res = "*";
                            else res = utils_1.escapeIdentifier(entity.tagName);
                        }
                        if (entity.id) res += "#" + utils_1.escapeIdentifier(entity.id);
                        if (entity.classNames) res += entity.classNames.map(function(cn) {
                            return "." + utils_1.escapeIdentifier(cn);
                        }).join("");
                        if (entity.attrs) res += entity.attrs.map(function(attr) {
                            if ("operator" in attr) {
                                if (attr.valueType === "substitute") return "[" + utils_1.escapeIdentifier(attr.name) + attr.operator + "$" + attr.value + "]";
                                else return "[" + utils_1.escapeIdentifier(attr.name) + attr.operator + utils_1.escapeStr(attr.value) + "]";
                            } else return "[" + utils_1.escapeIdentifier(attr.name) + "]";
                        }).join("");
                        if (entity.pseudos) res += entity.pseudos.map(function(pseudo) {
                            if (pseudo.valueType) {
                                if (pseudo.valueType === "selector") return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + renderEntity(pseudo.value) + ")";
                                else if (pseudo.valueType === "substitute") return ":" + utils_1.escapeIdentifier(pseudo.name) + "($" + pseudo.value + ")";
                                else if (pseudo.valueType === "numeric") return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + pseudo.value + ")";
                                else return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + utils_1.escapeIdentifier(pseudo.value) + ")";
                            } else return ":" + utils_1.escapeIdentifier(pseudo.name);
                        }).join("");
                        break;
                    default:
                        throw Error('Unknown entity type: "' + entity.type + '".');
                }
                return res;
            }
            exports.renderEntity = renderEntity;
        });
        var require_lib = __commonJS(function(exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var parser_context_1 = require_parser_context();
            var render_1 = require_render();
            var CssSelectorParser3 = function() {
                function CssSelectorParser4() {
                    this.pseudos = {};
                    this.attrEqualityMods = {};
                    this.ruleNestingOperators = {};
                    this.substitutesEnabled = false;
                }
                CssSelectorParser4.prototype.registerSelectorPseudos = function() {
                    var pseudos = [];
                    for(var _i = 0; _i < arguments.length; _i++)pseudos[_i] = arguments[_i];
                    for(var _a = 0, pseudos_1 = pseudos; _a < pseudos_1.length; _a++){
                        var pseudo = pseudos_1[_a];
                        this.pseudos[pseudo] = "selector";
                    }
                    return this;
                };
                CssSelectorParser4.prototype.unregisterSelectorPseudos = function() {
                    var pseudos = [];
                    for(var _i = 0; _i < arguments.length; _i++)pseudos[_i] = arguments[_i];
                    for(var _a = 0, pseudos_2 = pseudos; _a < pseudos_2.length; _a++){
                        var pseudo = pseudos_2[_a];
                        delete this.pseudos[pseudo];
                    }
                    return this;
                };
                CssSelectorParser4.prototype.registerNumericPseudos = function() {
                    var pseudos = [];
                    for(var _i = 0; _i < arguments.length; _i++)pseudos[_i] = arguments[_i];
                    for(var _a = 0, pseudos_3 = pseudos; _a < pseudos_3.length; _a++){
                        var pseudo = pseudos_3[_a];
                        this.pseudos[pseudo] = "numeric";
                    }
                    return this;
                };
                CssSelectorParser4.prototype.unregisterNumericPseudos = function() {
                    var pseudos = [];
                    for(var _i = 0; _i < arguments.length; _i++)pseudos[_i] = arguments[_i];
                    for(var _a = 0, pseudos_4 = pseudos; _a < pseudos_4.length; _a++){
                        var pseudo = pseudos_4[_a];
                        delete this.pseudos[pseudo];
                    }
                    return this;
                };
                CssSelectorParser4.prototype.registerNestingOperators = function() {
                    var operators = [];
                    for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
                    for(var _a = 0, operators_1 = operators; _a < operators_1.length; _a++){
                        var operator = operators_1[_a];
                        this.ruleNestingOperators[operator] = true;
                    }
                    return this;
                };
                CssSelectorParser4.prototype.unregisterNestingOperators = function() {
                    var operators = [];
                    for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
                    for(var _a = 0, operators_2 = operators; _a < operators_2.length; _a++){
                        var operator = operators_2[_a];
                        delete this.ruleNestingOperators[operator];
                    }
                    return this;
                };
                CssSelectorParser4.prototype.registerAttrEqualityMods = function() {
                    var mods = [];
                    for(var _i = 0; _i < arguments.length; _i++)mods[_i] = arguments[_i];
                    for(var _a = 0, mods_1 = mods; _a < mods_1.length; _a++){
                        var mod = mods_1[_a];
                        this.attrEqualityMods[mod] = true;
                    }
                    return this;
                };
                CssSelectorParser4.prototype.unregisterAttrEqualityMods = function() {
                    var mods = [];
                    for(var _i = 0; _i < arguments.length; _i++)mods[_i] = arguments[_i];
                    for(var _a = 0, mods_2 = mods; _a < mods_2.length; _a++){
                        var mod = mods_2[_a];
                        delete this.attrEqualityMods[mod];
                    }
                    return this;
                };
                CssSelectorParser4.prototype.enableSubstitutes = function() {
                    this.substitutesEnabled = true;
                    return this;
                };
                CssSelectorParser4.prototype.disableSubstitutes = function() {
                    this.substitutesEnabled = false;
                    return this;
                };
                CssSelectorParser4.prototype.parse = function(str) {
                    return parser_context_1.parseCssSelector(str, 0, this.pseudos, this.attrEqualityMods, this.ruleNestingOperators, this.substitutesEnabled);
                };
                CssSelectorParser4.prototype.render = function(path) {
                    return render_1.renderEntity(path).trim();
                };
                return CssSelectorParser4;
            }();
            exports.CssSelectorParser = CssSelectorParser3;
        });
        var require_doT = __commonJS(function(exports, module1) {
            (function() {
                "use strict";
                var doT3 = {
                    name: "doT",
                    version: "1.1.1",
                    templateSettings: {
                        evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g,
                        interpolate: /\{\{=([\s\S]+?)\}\}/g,
                        encode: /\{\{!([\s\S]+?)\}\}/g,
                        use: /\{\{#([\s\S]+?)\}\}/g,
                        useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
                        define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
                        defineParams: /^\s*([\w$]+):([\s\S]+)/,
                        conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
                        iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
                        varname: "it",
                        strip: true,
                        append: true,
                        selfcontained: false,
                        doNotSkipEncoded: false
                    },
                    template: void 0,
                    compile: void 0,
                    log: true
                };
                (function() {
                    if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") return;
                    try {
                        Object.defineProperty(Object.prototype, "__magic__", {
                            get: function get() {
                                return this;
                            },
                            configurable: true
                        });
                        __magic__.globalThis = __magic__;
                        delete Object.prototype.__magic__;
                    } catch (e) {
                        window1.globalThis = function() {
                            if (typeof self !== "undefined") return self;
                            if (typeof window1 !== "undefined") return window1;
                            if (typeof global !== "undefined") return global;
                            if (typeof this !== "undefined") return this;
                            throw new Error("Unable to locate global `this`");
                        }();
                    }
                })();
                doT3.encodeHTMLSource = function(doNotSkipEncoded) {
                    var encodeHTMLRules = {
                        "&": "&#38;",
                        "<": "&#60;",
                        ">": "&#62;",
                        '"': "&#34;",
                        "'": "&#39;",
                        "/": "&#47;"
                    }, matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
                    return function(code) {
                        return code ? code.toString().replace(matchHTML, function(m3) {
                            return encodeHTMLRules[m3] || m3;
                        }) : "";
                    };
                };
                if (typeof module1 !== "undefined" && module1.exports) module1.exports = doT3;
                else if (typeof define === "function" && define.amd) define(function() {
                    return doT3;
                });
                else globalThis.doT = doT3;
                var startend = {
                    append: {
                        start: "'+(",
                        end: ")+'",
                        startencode: "'+encodeHTML("
                    },
                    split: {
                        start: "';out+=(",
                        end: ");out+='",
                        startencode: "';out+=encodeHTML("
                    }
                }, skip = /$^/;
                function resolveDefs(c4, block, def) {
                    return (typeof block === "string" ? block : block.toString()).replace(c4.define || skip, function(m3, code, assign, value) {
                        if (code.indexOf("def.") === 0) code = code.substring(4);
                        if (!(code in def)) {
                            if (assign === ":") {
                                if (c4.defineParams) value.replace(c4.defineParams, function(m4, param, v) {
                                    def[code] = {
                                        arg: param,
                                        text: v
                                    };
                                });
                                if (!(code in def)) def[code] = value;
                            } else new Function("def", "def['" + code + "']=" + value)(def);
                        }
                        return "";
                    }).replace(c4.use || skip, function(m3, code) {
                        if (c4.useParams) code = code.replace(c4.useParams, function(m4, s, d2, param) {
                            if (def[d2] && def[d2].arg && param) {
                                var rw = (d2 + ":" + param).replace(/'|\\/g, "_");
                                def.__exp = def.__exp || {};
                                def.__exp[rw] = def[d2].text.replace(new RegExp("(^|[^\\w$])" + def[d2].arg + "([^\\w$])", "g"), "$1" + param + "$2");
                                return s + "def.__exp['" + rw + "']";
                            }
                        });
                        var v = new Function("def", "return " + code)(def);
                        return v ? resolveDefs(c4, v, def) : v;
                    });
                }
                function unescape(code) {
                    return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
                }
                doT3.template = function(tmpl, c4, def) {
                    c4 = c4 || doT3.templateSettings;
                    var cse = c4.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv, str = c4.use || c4.define ? resolveDefs(c4, tmpl, def || {}) : tmpl;
                    str = ("var out='" + (c4.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") : str).replace(/'|\\/g, "\\$&").replace(c4.interpolate || skip, function(m3, code) {
                        return cse.start + unescape(code) + cse.end;
                    }).replace(c4.encode || skip, function(m3, code) {
                        needhtmlencode = true;
                        return cse.startencode + unescape(code) + cse.end;
                    }).replace(c4.conditional || skip, function(m3, elsecase, code) {
                        return elsecase ? code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='" : code ? "';if(" + unescape(code) + "){out+='" : "';}out+='";
                    }).replace(c4.iterate || skip, function(m3, iterate, vname, iname) {
                        if (!iterate) return "';} } out+='";
                        sid += 1;
                        indv = iname || "i" + sid;
                        iterate = unescape(iterate);
                        return "';var arr" + sid + "=" + iterate + ";if(arr" + sid + "){var " + vname + "," + indv + "=-1,l" + sid + "=arr" + sid + ".length-1;while(" + indv + "<l" + sid + "){" + vname + "=arr" + sid + "[" + indv + "+=1];out+='";
                    }).replace(c4.evaluate || skip, function(m3, code) {
                        return "';" + unescape(code) + "out+='";
                    }) + "';return out;").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r").replace(/(\s|;|\}|^|\{)out\+='';/g, "$1").replace(/\+''/g, "");
                    if (needhtmlencode) {
                        if (!c4.selfcontained && globalThis && !globalThis._encodeHTML) globalThis._encodeHTML = doT3.encodeHTMLSource(c4.doNotSkipEncoded);
                        str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (" + doT3.encodeHTMLSource.toString() + "(" + (c4.doNotSkipEncoded || "") + "));" + str;
                    }
                    try {
                        return new Function(c4.varname, str);
                    } catch (e) {
                        if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
                        throw e;
                    }
                };
                doT3.compile = function(tmpl, def) {
                    return doT3.template(tmpl, null, def);
                };
            })();
        });
        var require_es6_promise = __commonJS(function(exports, module1) {
            (function(global2, factory) {
                _typeof(exports) === "object" && typeof module1 !== "undefined" ? module1.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global2.ES6Promise = factory();
            })(exports, function() {
                "use strict";
                function objectOrFunction(x) {
                    var type2 = _typeof(x);
                    return x !== null && (type2 === "object" || type2 === "function");
                }
                function isFunction(x) {
                    return typeof x === "function";
                }
                var _isArray = void 0;
                if (Array.isArray) _isArray = Array.isArray;
                else _isArray = function _isArray(x) {
                    return Object.prototype.toString.call(x) === "[object Array]";
                };
                var isArray = _isArray;
                var len = 0;
                var vertxNext = void 0;
                var customSchedulerFn = void 0;
                var asap = function asap2(callback, arg) {
                    queue2[len] = callback;
                    queue2[len + 1] = arg;
                    len += 2;
                    if (len === 2) {
                        if (customSchedulerFn) customSchedulerFn(flush);
                        else scheduleFlush();
                    }
                };
                function setScheduler(scheduleFn) {
                    customSchedulerFn = scheduleFn;
                }
                function setAsap(asapFn) {
                    asap = asapFn;
                }
                var browserWindow = typeof window1 !== "undefined" ? window1 : void 0;
                var browserGlobal = browserWindow || {};
                var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
                var isNode2 = typeof self === "undefined" && typeof $hPtJY !== "undefined" && ({}).toString.call($hPtJY) === "[object process]";
                var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
                function useNextTick() {
                    return function() {
                        return $hPtJY.nextTick(flush);
                    };
                }
                function useVertxTimer() {
                    if (typeof vertxNext !== "undefined") return function() {
                        vertxNext(flush);
                    };
                    return useSetTimeout();
                }
                function useMutationObserver() {
                    var iterations = 0;
                    var observer = new BrowserMutationObserver(flush);
                    var node = document.createTextNode("");
                    observer.observe(node, {
                        characterData: true
                    });
                    return function() {
                        node.data = iterations = ++iterations % 2;
                    };
                }
                function useMessageChannel() {
                    var channel = new MessageChannel();
                    channel.port1.onmessage = flush;
                    return function() {
                        return channel.port2.postMessage(0);
                    };
                }
                function useSetTimeout() {
                    var globalSetTimeout = setTimeout;
                    return function() {
                        return globalSetTimeout(flush, 1);
                    };
                }
                var queue2 = new Array(1e3);
                function flush() {
                    for(var i = 0; i < len; i += 2){
                        var callback = queue2[i];
                        var arg = queue2[i + 1];
                        callback(arg);
                        queue2[i] = void 0;
                        queue2[i + 1] = void 0;
                    }
                    len = 0;
                }
                function attemptVertx() {
                    try {
                        var vertx = Function("return this")().require("vertx");
                        vertxNext = vertx.runOnLoop || vertx.runOnContext;
                        return useVertxTimer();
                    } catch (e) {
                        return useSetTimeout();
                    }
                }
                var scheduleFlush = void 0;
                if (isNode2) scheduleFlush = useNextTick();
                else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
                else if (isWorker) scheduleFlush = useMessageChannel();
                else if (browserWindow === void 0 && true) scheduleFlush = attemptVertx();
                else scheduleFlush = useSetTimeout();
                function then(onFulfillment, onRejection) {
                    var parent = this;
                    var child = new this.constructor(noop3);
                    if (child[PROMISE_ID] === void 0) makePromise(child);
                    var _state = parent._state;
                    if (_state) {
                        var callback = arguments[_state - 1];
                        asap(function() {
                            return invokeCallback(_state, child, callback, parent._result);
                        });
                    } else subscribe2(parent, child, onFulfillment, onRejection);
                    return child;
                }
                function resolve$1(object) {
                    var Constructor = this;
                    if (object && _typeof(object) === "object" && object.constructor === Constructor) return object;
                    var promise = new Constructor(noop3);
                    resolve(promise, object);
                    return promise;
                }
                var PROMISE_ID = Math.random().toString(36).substring(2);
                function noop3() {}
                var PENDING = void 0;
                var FULFILLED = 1;
                var REJECTED = 2;
                function selfFulfillment() {
                    return new TypeError("You cannot resolve a promise with itself");
                }
                function cannotReturnOwn() {
                    return new TypeError("A promises callback cannot return that same promise.");
                }
                function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
                    try {
                        then$$1.call(value, fulfillmentHandler, rejectionHandler);
                    } catch (e) {
                        return e;
                    }
                }
                function handleForeignThenable(promise, thenable, then$$1) {
                    asap(function(promise2) {
                        var sealed = false;
                        var error = tryThen(then$$1, thenable, function(value) {
                            if (sealed) return;
                            sealed = true;
                            if (thenable !== value) resolve(promise2, value);
                            else fulfill(promise2, value);
                        }, function(reason) {
                            if (sealed) return;
                            sealed = true;
                            reject(promise2, reason);
                        }, "Settle: " + (promise2._label || " unknown promise"));
                        if (!sealed && error) {
                            sealed = true;
                            reject(promise2, error);
                        }
                    }, promise);
                }
                function handleOwnThenable(promise, thenable) {
                    if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
                    else if (thenable._state === REJECTED) reject(promise, thenable._result);
                    else subscribe2(thenable, void 0, function(value) {
                        return resolve(promise, value);
                    }, function(reason) {
                        return reject(promise, reason);
                    });
                }
                function handleMaybeThenable(promise, maybeThenable, then$$1) {
                    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
                    else {
                        if (then$$1 === void 0) fulfill(promise, maybeThenable);
                        else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
                        else fulfill(promise, maybeThenable);
                    }
                }
                function resolve(promise, value) {
                    if (promise === value) reject(promise, selfFulfillment());
                    else if (objectOrFunction(value)) {
                        var then$$1 = void 0;
                        try {
                            then$$1 = value.then;
                        } catch (error) {
                            reject(promise, error);
                            return;
                        }
                        handleMaybeThenable(promise, value, then$$1);
                    } else fulfill(promise, value);
                }
                function publishRejection(promise) {
                    if (promise._onerror) promise._onerror(promise._result);
                    publish(promise);
                }
                function fulfill(promise, value) {
                    if (promise._state !== PENDING) return;
                    promise._result = value;
                    promise._state = FULFILLED;
                    if (promise._subscribers.length !== 0) asap(publish, promise);
                }
                function reject(promise, reason) {
                    if (promise._state !== PENDING) return;
                    promise._state = REJECTED;
                    promise._result = reason;
                    asap(publishRejection, promise);
                }
                function subscribe2(parent, child, onFulfillment, onRejection) {
                    var _subscribers = parent._subscribers;
                    var length = _subscribers.length;
                    parent._onerror = null;
                    _subscribers[length] = child;
                    _subscribers[length + FULFILLED] = onFulfillment;
                    _subscribers[length + REJECTED] = onRejection;
                    if (length === 0 && parent._state) asap(publish, parent);
                }
                function publish(promise) {
                    var subscribers = promise._subscribers;
                    var settled = promise._state;
                    if (subscribers.length === 0) return;
                    var child = void 0, callback = void 0, detail = promise._result;
                    for(var i = 0; i < subscribers.length; i += 3){
                        child = subscribers[i];
                        callback = subscribers[i + settled];
                        if (child) invokeCallback(settled, child, callback, detail);
                        else callback(detail);
                    }
                    promise._subscribers.length = 0;
                }
                function invokeCallback(settled, promise, callback, detail) {
                    var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
                    if (hasCallback) {
                        try {
                            value = callback(detail);
                        } catch (e) {
                            succeeded = false;
                            error = e;
                        }
                        if (promise === value) {
                            reject(promise, cannotReturnOwn());
                            return;
                        }
                    } else value = detail;
                    if (promise._state !== PENDING) ;
                    else if (hasCallback && succeeded) resolve(promise, value);
                    else if (succeeded === false) reject(promise, error);
                    else if (settled === FULFILLED) fulfill(promise, value);
                    else if (settled === REJECTED) reject(promise, value);
                }
                function initializePromise(promise, resolver) {
                    try {
                        resolver(function resolvePromise(value) {
                            resolve(promise, value);
                        }, function rejectPromise(reason) {
                            reject(promise, reason);
                        });
                    } catch (e) {
                        reject(promise, e);
                    }
                }
                var id = 0;
                function nextId() {
                    return id++;
                }
                function makePromise(promise) {
                    promise[PROMISE_ID] = id++;
                    promise._state = void 0;
                    promise._result = void 0;
                    promise._subscribers = [];
                }
                function validationError() {
                    return new Error("Array Methods must be provided an Array");
                }
                var Enumerator = function() {
                    function Enumerator2(Constructor, input) {
                        this._instanceConstructor = Constructor;
                        this.promise = new Constructor(noop3);
                        if (!this.promise[PROMISE_ID]) makePromise(this.promise);
                        if (isArray(input)) {
                            this.length = input.length;
                            this._remaining = input.length;
                            this._result = new Array(this.length);
                            if (this.length === 0) fulfill(this.promise, this._result);
                            else {
                                this.length = this.length || 0;
                                this._enumerate(input);
                                if (this._remaining === 0) fulfill(this.promise, this._result);
                            }
                        } else reject(this.promise, validationError());
                    }
                    Enumerator2.prototype._enumerate = function _enumerate(input) {
                        for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
                    };
                    Enumerator2.prototype._eachEntry = function _eachEntry(entry, i) {
                        var c4 = this._instanceConstructor;
                        var resolve$$1 = c4.resolve;
                        if (resolve$$1 === resolve$1) {
                            var _then = void 0;
                            var error = void 0;
                            var didError = false;
                            try {
                                _then = entry.then;
                            } catch (e) {
                                didError = true;
                                error = e;
                            }
                            if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                            else if (typeof _then !== "function") {
                                this._remaining--;
                                this._result[i] = entry;
                            } else if (c4 === Promise$1) {
                                var promise = new c4(noop3);
                                if (didError) reject(promise, error);
                                else handleMaybeThenable(promise, entry, _then);
                                this._willSettleAt(promise, i);
                            } else this._willSettleAt(new c4(function(resolve$$12) {
                                return resolve$$12(entry);
                            }), i);
                        } else this._willSettleAt(resolve$$1(entry), i);
                    };
                    Enumerator2.prototype._settledAt = function _settledAt(state, i, value) {
                        var promise = this.promise;
                        if (promise._state === PENDING) {
                            this._remaining--;
                            if (state === REJECTED) reject(promise, value);
                            else this._result[i] = value;
                        }
                        if (this._remaining === 0) fulfill(promise, this._result);
                    };
                    Enumerator2.prototype._willSettleAt = function _willSettleAt(promise, i) {
                        var enumerator = this;
                        subscribe2(promise, void 0, function(value) {
                            return enumerator._settledAt(FULFILLED, i, value);
                        }, function(reason) {
                            return enumerator._settledAt(REJECTED, i, reason);
                        });
                    };
                    return Enumerator2;
                }();
                function all(entries) {
                    return new Enumerator(this, entries).promise;
                }
                function race(entries) {
                    var Constructor = this;
                    if (!isArray(entries)) return new Constructor(function(_, reject2) {
                        return reject2(new TypeError("You must pass an array to race."));
                    });
                    else return new Constructor(function(resolve2, reject2) {
                        var length = entries.length;
                        for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve2, reject2);
                    });
                }
                function reject$1(reason) {
                    var Constructor = this;
                    var promise = new Constructor(noop3);
                    reject(promise, reason);
                    return promise;
                }
                function needsResolver() {
                    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                }
                function needsNew() {
                    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                }
                var Promise$1 = function() {
                    function Promise2(resolver) {
                        this[PROMISE_ID] = nextId();
                        this._result = this._state = void 0;
                        this._subscribers = [];
                        if (noop3 !== resolver) {
                            typeof resolver !== "function" && needsResolver();
                            this instanceof Promise2 ? initializePromise(this, resolver) : needsNew();
                        }
                    }
                    Promise2.prototype["catch"] = function _catch(onRejection) {
                        return this.then(null, onRejection);
                    };
                    Promise2.prototype["finally"] = function _finally(callback) {
                        var promise = this;
                        var constructor = promise.constructor;
                        if (isFunction(callback)) return promise.then(function(value) {
                            return constructor.resolve(callback()).then(function() {
                                return value;
                            });
                        }, function(reason) {
                            return constructor.resolve(callback()).then(function() {
                                throw reason;
                            });
                        });
                        return promise.then(callback, callback);
                    };
                    return Promise2;
                }();
                Promise$1.prototype.then = then;
                Promise$1.all = all;
                Promise$1.race = race;
                Promise$1.resolve = resolve$1;
                Promise$1.reject = reject$1;
                Promise$1._setScheduler = setScheduler;
                Promise$1._setAsap = setAsap;
                Promise$1._asap = asap;
                function polyfill() {
                    var local = void 0;
                    if (typeof global !== "undefined") local = global;
                    else if (typeof self !== "undefined") local = self;
                    else try {
                        local = Function("return this")();
                    } catch (e) {
                        throw new Error("polyfill failed because global object is unavailable in this environment");
                    }
                    var P = local.Promise;
                    if (P) {
                        var promiseToString = null;
                        try {
                            promiseToString = Object.prototype.toString.call(P.resolve());
                        } catch (e) {}
                        if (promiseToString === "[object Promise]" && !P.cast) return;
                    }
                    local.Promise = Promise$1;
                }
                Promise$1.polyfill = polyfill;
                Promise$1.Promise = Promise$1;
                return Promise$1;
            });
        });
        var require_typedarray = __commonJS(function(exports) {
            var MAX_ARRAY_LENGTH = 1e5;
            var ECMAScript = function() {
                var opts = Object.prototype.toString;
                var ophop = Object.prototype.hasOwnProperty;
                return {
                    Class: function Class(v) {
                        return opts.call(v).replace(/^\[object *|\]$/g, "");
                    },
                    HasProperty: function HasProperty(o, p2) {
                        return p2 in o;
                    },
                    HasOwnProperty: function HasOwnProperty(o, p2) {
                        return ophop.call(o, p2);
                    },
                    IsCallable: function IsCallable(o) {
                        return typeof o === "function";
                    },
                    ToInt32: function ToInt32(v) {
                        return v >> 0;
                    },
                    ToUint32: function ToUint32(v) {
                        return v >>> 0;
                    }
                };
            }();
            var LN2 = Math.LN2;
            var abs = Math.abs;
            var floor = Math.floor;
            var log2 = Math.log;
            var min = Math.min;
            var pow = Math.pow;
            var round = Math.round;
            function clamp3(v, minimum, max2) {
                return v < minimum ? minimum : v > max2 ? max2 : v;
            }
            var getOwnPropNames = Object.getOwnPropertyNames || function(o) {
                if (o !== Object(o)) throw new TypeError("Object.getOwnPropertyNames called on non-object");
                var props = [], p2;
                for(p2 in o)if (ECMAScript.HasOwnProperty(o, p2)) props.push(p2);
                return props;
            };
            var defineProp;
            if (Object.defineProperty && function() {
                try {
                    Object.defineProperty({}, "x", {});
                    return true;
                } catch (e) {
                    return false;
                }
            }()) defineProp = Object.defineProperty;
            else defineProp = function defineProp(o, p2, desc) {
                if (!o === Object(o)) throw new TypeError("Object.defineProperty called on non-object");
                if (ECMAScript.HasProperty(desc, "get") && Object.prototype.__defineGetter__) Object.prototype.__defineGetter__.call(o, p2, desc.get);
                if (ECMAScript.HasProperty(desc, "set") && Object.prototype.__defineSetter__) Object.prototype.__defineSetter__.call(o, p2, desc.set);
                if (ECMAScript.HasProperty(desc, "value")) o[p2] = desc.value;
                return o;
            };
            function configureProperties(obj) {
                if (getOwnPropNames && defineProp) {
                    var props = getOwnPropNames(obj), i;
                    for(i = 0; i < props.length; i += 1)defineProp(obj, props[i], {
                        value: obj[props[i]],
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
            }
            function makeArrayAccessors(obj) {
                if (!defineProp) return;
                if (obj.length > MAX_ARRAY_LENGTH) throw new RangeError("Array too large for polyfill");
                function makeArrayAccessor(index) {
                    defineProp(obj, index, {
                        get: function get() {
                            return obj._getter(index);
                        },
                        set: function set(v) {
                            obj._setter(index, v);
                        },
                        enumerable: true,
                        configurable: false
                    });
                }
                var i;
                for(i = 0; i < obj.length; i += 1)makeArrayAccessor(i);
            }
            function as_signed(value, bits) {
                var s = 32 - bits;
                return value << s >> s;
            }
            function as_unsigned(value, bits) {
                var s = 32 - bits;
                return value << s >>> s;
            }
            function packI8(n2) {
                return [
                    n2 & 255
                ];
            }
            function unpackI8(bytes) {
                return as_signed(bytes[0], 8);
            }
            function packU8(n2) {
                return [
                    n2 & 255
                ];
            }
            function unpackU8(bytes) {
                return as_unsigned(bytes[0], 8);
            }
            function packU8Clamped(n2) {
                n2 = round(Number(n2));
                return [
                    n2 < 0 ? 0 : n2 > 255 ? 255 : n2 & 255
                ];
            }
            function packI16(n2) {
                return [
                    n2 >> 8 & 255,
                    n2 & 255
                ];
            }
            function unpackI16(bytes) {
                return as_signed(bytes[0] << 8 | bytes[1], 16);
            }
            function packU16(n2) {
                return [
                    n2 >> 8 & 255,
                    n2 & 255
                ];
            }
            function unpackU16(bytes) {
                return as_unsigned(bytes[0] << 8 | bytes[1], 16);
            }
            function packI32(n2) {
                return [
                    n2 >> 24 & 255,
                    n2 >> 16 & 255,
                    n2 >> 8 & 255,
                    n2 & 255
                ];
            }
            function unpackI32(bytes) {
                return as_signed(bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], 32);
            }
            function packU32(n2) {
                return [
                    n2 >> 24 & 255,
                    n2 >> 16 & 255,
                    n2 >> 8 & 255,
                    n2 & 255
                ];
            }
            function unpackU32(bytes) {
                return as_unsigned(bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], 32);
            }
            function packIEEE754(v, ebits, fbits) {
                var bias = (1 << ebits - 1) - 1;
                var s, e, f, i, bits, str, bytes;
                function roundToEven(n2) {
                    var w = floor(n2);
                    var fl = n2 - w;
                    if (fl < .5) return w;
                    if (fl > .5) return w + 1;
                    return w % 2 ? w + 1 : w;
                }
                if (v !== v) {
                    e = (1 << ebits) - 1;
                    f = pow(2, fbits - 1);
                    s = 0;
                } else if (v === Infinity || v === -Infinity) {
                    e = (1 << ebits) - 1;
                    f = 0;
                    s = v < 0 ? 1 : 0;
                } else if (v === 0) {
                    e = 0;
                    f = 0;
                    s = 1 / v === -Infinity ? 1 : 0;
                } else {
                    s = v < 0;
                    v = abs(v);
                    if (v >= pow(2, 1 - bias)) {
                        e = min(floor(log2(v) / LN2), 1023);
                        f = roundToEven(v / pow(2, e) * pow(2, fbits));
                        if (f / pow(2, fbits) >= 2) {
                            e = e + 1;
                            f = 1;
                        }
                        if (e > bias) {
                            e = (1 << ebits) - 1;
                            f = 0;
                        } else {
                            e = e + bias;
                            f = f - pow(2, fbits);
                        }
                    } else {
                        e = 0;
                        f = roundToEven(v / pow(2, 1 - bias - fbits));
                    }
                }
                bits = [];
                for(i = fbits; i; i -= 1){
                    bits.push(f % 2 ? 1 : 0);
                    f = floor(f / 2);
                }
                for(i = ebits; i; i -= 1){
                    bits.push(e % 2 ? 1 : 0);
                    e = floor(e / 2);
                }
                bits.push(s ? 1 : 0);
                bits.reverse();
                str = bits.join("");
                bytes = [];
                while(str.length){
                    bytes.push(parseInt(str.substring(0, 8), 2));
                    str = str.substring(8);
                }
                return bytes;
            }
            function unpackIEEE754(bytes, ebits, fbits) {
                var bits = [], i, j, b2, str, bias, s, e, f;
                for(i = bytes.length; i; i -= 1){
                    b2 = bytes[i - 1];
                    for(j = 8; j; j -= 1){
                        bits.push(b2 % 2 ? 1 : 0);
                        b2 = b2 >> 1;
                    }
                }
                bits.reverse();
                str = bits.join("");
                bias = (1 << ebits - 1) - 1;
                s = parseInt(str.substring(0, 1), 2) ? -1 : 1;
                e = parseInt(str.substring(1, 1 + ebits), 2);
                f = parseInt(str.substring(1 + ebits), 2);
                if (e === (1 << ebits) - 1) return f === 0 ? s * Infinity : NaN;
                else if (e > 0) return s * pow(2, e - bias) * (1 + f / pow(2, fbits));
                else if (f !== 0) return s * pow(2, -(bias - 1)) * (f / pow(2, fbits));
                return s < 0 ? -0 : 0;
            }
            function unpackF64(b2) {
                return unpackIEEE754(b2, 11, 52);
            }
            function packF64(v) {
                return packIEEE754(v, 11, 52);
            }
            function unpackF32(b2) {
                return unpackIEEE754(b2, 8, 23);
            }
            function packF32(v) {
                return packIEEE754(v, 8, 23);
            }
            (function() {
                function ArrayBuffer(length) {
                    length = ECMAScript.ToInt32(length);
                    if (length < 0) throw new RangeError("ArrayBuffer size is not a small enough positive integer");
                    this.byteLength = length;
                    this._bytes = [];
                    this._bytes.length = length;
                    var i;
                    for(i = 0; i < this.byteLength; i += 1)this._bytes[i] = 0;
                    configureProperties(this);
                }
                exports.ArrayBuffer = exports.ArrayBuffer || ArrayBuffer;
                function ArrayBufferView() {}
                function makeConstructor(bytesPerElement, pack, unpack) {
                    var _ctor;
                    _ctor = function ctor(buffer, byteOffset, length) {
                        var array, sequence, i, s;
                        if (!arguments.length || typeof arguments[0] === "number") {
                            this.length = ECMAScript.ToInt32(arguments[0]);
                            if (length < 0) throw new RangeError("ArrayBufferView size is not a small enough positive integer");
                            this.byteLength = this.length * this.BYTES_PER_ELEMENT;
                            this.buffer = new ArrayBuffer(this.byteLength);
                            this.byteOffset = 0;
                        } else if (_typeof(arguments[0]) === "object" && arguments[0].constructor === _ctor) {
                            array = arguments[0];
                            this.length = array.length;
                            this.byteLength = this.length * this.BYTES_PER_ELEMENT;
                            this.buffer = new ArrayBuffer(this.byteLength);
                            this.byteOffset = 0;
                            for(i = 0; i < this.length; i += 1)this._setter(i, array._getter(i));
                        } else if (_typeof(arguments[0]) === "object" && !(arguments[0] instanceof ArrayBuffer || ECMAScript.Class(arguments[0]) === "ArrayBuffer")) {
                            sequence = arguments[0];
                            this.length = ECMAScript.ToUint32(sequence.length);
                            this.byteLength = this.length * this.BYTES_PER_ELEMENT;
                            this.buffer = new ArrayBuffer(this.byteLength);
                            this.byteOffset = 0;
                            for(i = 0; i < this.length; i += 1){
                                s = sequence[i];
                                this._setter(i, Number(s));
                            }
                        } else if (_typeof(arguments[0]) === "object" && (arguments[0] instanceof ArrayBuffer || ECMAScript.Class(arguments[0]) === "ArrayBuffer")) {
                            this.buffer = buffer;
                            this.byteOffset = ECMAScript.ToUint32(byteOffset);
                            if (this.byteOffset > this.buffer.byteLength) throw new RangeError("byteOffset out of range");
                            if (this.byteOffset % this.BYTES_PER_ELEMENT) throw new RangeError("ArrayBuffer length minus the byteOffset is not a multiple of the element size.");
                            if (arguments.length < 3) {
                                this.byteLength = this.buffer.byteLength - this.byteOffset;
                                if (this.byteLength % this.BYTES_PER_ELEMENT) throw new RangeError("length of buffer minus byteOffset not a multiple of the element size");
                                this.length = this.byteLength / this.BYTES_PER_ELEMENT;
                            } else {
                                this.length = ECMAScript.ToUint32(length);
                                this.byteLength = this.length * this.BYTES_PER_ELEMENT;
                            }
                            if (this.byteOffset + this.byteLength > this.buffer.byteLength) throw new RangeError("byteOffset and length reference an area beyond the end of the buffer");
                        } else throw new TypeError("Unexpected argument type(s)");
                        this.constructor = _ctor;
                        configureProperties(this);
                        makeArrayAccessors(this);
                    };
                    _ctor.prototype = new ArrayBufferView();
                    _ctor.prototype.BYTES_PER_ELEMENT = bytesPerElement;
                    _ctor.prototype._pack = pack;
                    _ctor.prototype._unpack = unpack;
                    _ctor.BYTES_PER_ELEMENT = bytesPerElement;
                    _ctor.prototype._getter = function(index) {
                        if (arguments.length < 1) throw new SyntaxError("Not enough arguments");
                        index = ECMAScript.ToUint32(index);
                        if (index >= this.length) return void 0;
                        var bytes = [];
                        for(var i = 0, o = this.byteOffset + index * this.BYTES_PER_ELEMENT; i < this.BYTES_PER_ELEMENT; i += 1, o += 1)bytes.push(this.buffer._bytes[o]);
                        return this._unpack(bytes);
                    };
                    _ctor.prototype.get = _ctor.prototype._getter;
                    _ctor.prototype._setter = function(index, value) {
                        if (arguments.length < 2) throw new SyntaxError("Not enough arguments");
                        index = ECMAScript.ToUint32(index);
                        if (index < this.length) {
                            var bytes = this._pack(value);
                            var i;
                            var o;
                            for(i = 0, o = this.byteOffset + index * this.BYTES_PER_ELEMENT; i < this.BYTES_PER_ELEMENT; i += 1, o += 1)this.buffer._bytes[o] = bytes[i];
                        }
                    };
                    _ctor.prototype.set = function(index, value) {
                        if (arguments.length < 1) throw new SyntaxError("Not enough arguments");
                        var array, sequence, offset, len, i, s, d2, byteOffset, byteLength, tmp;
                        if (_typeof(arguments[0]) === "object" && arguments[0].constructor === this.constructor) {
                            array = arguments[0];
                            offset = ECMAScript.ToUint32(arguments[1]);
                            if (offset + array.length > this.length) throw new RangeError("Offset plus length of array is out of range");
                            byteOffset = this.byteOffset + offset * this.BYTES_PER_ELEMENT;
                            byteLength = array.length * this.BYTES_PER_ELEMENT;
                            if (array.buffer === this.buffer) {
                                tmp = [];
                                for(i = 0, s = array.byteOffset; i < byteLength; i += 1, s += 1)tmp[i] = array.buffer._bytes[s];
                                for(i = 0, d2 = byteOffset; i < byteLength; i += 1, d2 += 1)this.buffer._bytes[d2] = tmp[i];
                            } else for(i = 0, s = array.byteOffset, d2 = byteOffset; i < byteLength; i += 1, s += 1, d2 += 1)this.buffer._bytes[d2] = array.buffer._bytes[s];
                        } else if (_typeof(arguments[0]) === "object" && typeof arguments[0].length !== "undefined") {
                            sequence = arguments[0];
                            len = ECMAScript.ToUint32(sequence.length);
                            offset = ECMAScript.ToUint32(arguments[1]);
                            if (offset + len > this.length) throw new RangeError("Offset plus length of array is out of range");
                            for(i = 0; i < len; i += 1){
                                s = sequence[i];
                                this._setter(offset + i, Number(s));
                            }
                        } else throw new TypeError("Unexpected argument type(s)");
                    };
                    _ctor.prototype.subarray = function(start, end) {
                        start = ECMAScript.ToInt32(start);
                        end = ECMAScript.ToInt32(end);
                        if (arguments.length < 1) start = 0;
                        if (arguments.length < 2) end = this.length;
                        if (start < 0) start = this.length + start;
                        if (end < 0) end = this.length + end;
                        start = clamp3(start, 0, this.length);
                        end = clamp3(end, 0, this.length);
                        var len = end - start;
                        if (len < 0) len = 0;
                        return new this.constructor(this.buffer, this.byteOffset + start * this.BYTES_PER_ELEMENT, len);
                    };
                    return _ctor;
                }
                var Int8Array = makeConstructor(1, packI8, unpackI8);
                var Uint8Array2 = makeConstructor(1, packU8, unpackU8);
                var Uint8ClampedArray2 = makeConstructor(1, packU8Clamped, unpackU8);
                var Int16Array = makeConstructor(2, packI16, unpackI16);
                var Uint16Array = makeConstructor(2, packU16, unpackU16);
                var Int32Array = makeConstructor(4, packI32, unpackI32);
                var Uint32Array3 = makeConstructor(4, packU32, unpackU32);
                var Float32Array = makeConstructor(4, packF32, unpackF32);
                var Float64Array = makeConstructor(8, packF64, unpackF64);
                exports.Int8Array = exports.Int8Array || Int8Array;
                exports.Uint8Array = exports.Uint8Array || Uint8Array2;
                exports.Uint8ClampedArray = exports.Uint8ClampedArray || Uint8ClampedArray2;
                exports.Int16Array = exports.Int16Array || Int16Array;
                exports.Uint16Array = exports.Uint16Array || Uint16Array;
                exports.Int32Array = exports.Int32Array || Int32Array;
                exports.Uint32Array = exports.Uint32Array || Uint32Array3;
                exports.Float32Array = exports.Float32Array || Float32Array;
                exports.Float64Array = exports.Float64Array || Float64Array;
            })();
            (function() {
                function r(array, index) {
                    return ECMAScript.IsCallable(array.get) ? array.get(index) : array[index];
                }
                var IS_BIG_ENDIAN = function() {
                    var u16array = new exports.Uint16Array([
                        4660
                    ]), u8array = new exports.Uint8Array(u16array.buffer);
                    return r(u8array, 0) === 18;
                }();
                function DataView(buffer, byteOffset, byteLength) {
                    if (arguments.length === 0) buffer = new exports.ArrayBuffer(0);
                    else if (!(buffer instanceof exports.ArrayBuffer || ECMAScript.Class(buffer) === "ArrayBuffer")) throw new TypeError("TypeError");
                    this.buffer = buffer || new exports.ArrayBuffer(0);
                    this.byteOffset = ECMAScript.ToUint32(byteOffset);
                    if (this.byteOffset > this.buffer.byteLength) throw new RangeError("byteOffset out of range");
                    if (arguments.length < 3) this.byteLength = this.buffer.byteLength - this.byteOffset;
                    else this.byteLength = ECMAScript.ToUint32(byteLength);
                    if (this.byteOffset + this.byteLength > this.buffer.byteLength) throw new RangeError("byteOffset and length reference an area beyond the end of the buffer");
                    configureProperties(this);
                }
                function makeGetter(arrayType) {
                    return function(byteOffset, littleEndian) {
                        byteOffset = ECMAScript.ToUint32(byteOffset);
                        if (byteOffset + arrayType.BYTES_PER_ELEMENT > this.byteLength) throw new RangeError("Array index out of range");
                        byteOffset += this.byteOffset;
                        var uint8Array = new exports.Uint8Array(this.buffer, byteOffset, arrayType.BYTES_PER_ELEMENT), bytes = [], i;
                        for(i = 0; i < arrayType.BYTES_PER_ELEMENT; i += 1)bytes.push(r(uint8Array, i));
                        if (Boolean(littleEndian) === Boolean(IS_BIG_ENDIAN)) bytes.reverse();
                        return r(new arrayType(new exports.Uint8Array(bytes).buffer), 0);
                    };
                }
                DataView.prototype.getUint8 = makeGetter(exports.Uint8Array);
                DataView.prototype.getInt8 = makeGetter(exports.Int8Array);
                DataView.prototype.getUint16 = makeGetter(exports.Uint16Array);
                DataView.prototype.getInt16 = makeGetter(exports.Int16Array);
                DataView.prototype.getUint32 = makeGetter(exports.Uint32Array);
                DataView.prototype.getInt32 = makeGetter(exports.Int32Array);
                DataView.prototype.getFloat32 = makeGetter(exports.Float32Array);
                DataView.prototype.getFloat64 = makeGetter(exports.Float64Array);
                function makeSetter(arrayType) {
                    return function(byteOffset, value, littleEndian) {
                        byteOffset = ECMAScript.ToUint32(byteOffset);
                        if (byteOffset + arrayType.BYTES_PER_ELEMENT > this.byteLength) throw new RangeError("Array index out of range");
                        var typeArray = new arrayType([
                            value
                        ]), byteArray = new exports.Uint8Array(typeArray.buffer), bytes = [], i, byteView;
                        for(i = 0; i < arrayType.BYTES_PER_ELEMENT; i += 1)bytes.push(r(byteArray, i));
                        if (Boolean(littleEndian) === Boolean(IS_BIG_ENDIAN)) bytes.reverse();
                        byteView = new exports.Uint8Array(this.buffer, byteOffset, arrayType.BYTES_PER_ELEMENT);
                        byteView.set(bytes);
                    };
                }
                DataView.prototype.setUint8 = makeSetter(exports.Uint8Array);
                DataView.prototype.setInt8 = makeSetter(exports.Int8Array);
                DataView.prototype.setUint16 = makeSetter(exports.Uint16Array);
                DataView.prototype.setInt16 = makeSetter(exports.Int16Array);
                DataView.prototype.setUint32 = makeSetter(exports.Uint32Array);
                DataView.prototype.setInt32 = makeSetter(exports.Int32Array);
                DataView.prototype.setFloat32 = makeSetter(exports.Float32Array);
                DataView.prototype.setFloat64 = makeSetter(exports.Float64Array);
                exports.DataView = exports.DataView || DataView;
            })();
        });
        var require_weakmap_polyfill = __commonJS(function(exports) {
            (function(self2) {
                "use strict";
                if (self2.WeakMap) return;
                var hasOwnProperty2 = Object.prototype.hasOwnProperty;
                var hasDefine = Object.defineProperty && function() {
                    try {
                        return Object.defineProperty({}, "x", {
                            value: 1
                        }).x === 1;
                    } catch (e) {}
                }();
                var defineProperty = function defineProperty(object, name, value) {
                    if (hasDefine) Object.defineProperty(object, name, {
                        configurable: true,
                        writable: true,
                        value: value
                    });
                    else object[name] = value;
                };
                self2.WeakMap = function() {
                    function WeakMap2() {
                        if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
                        defineProperty(this, "_id", genId("_WeakMap"));
                        if (arguments.length > 0) throw new TypeError("WeakMap iterable is not supported");
                    }
                    defineProperty(WeakMap2.prototype, "delete", function(key) {
                        checkInstance(this, "delete");
                        if (!isObject(key)) return false;
                        var entry = key[this._id];
                        if (entry && entry[0] === key) {
                            delete key[this._id];
                            return true;
                        }
                        return false;
                    });
                    defineProperty(WeakMap2.prototype, "get", function(key) {
                        checkInstance(this, "get");
                        if (!isObject(key)) return void 0;
                        var entry = key[this._id];
                        if (entry && entry[0] === key) return entry[1];
                        return void 0;
                    });
                    defineProperty(WeakMap2.prototype, "has", function(key) {
                        checkInstance(this, "has");
                        if (!isObject(key)) return false;
                        var entry = key[this._id];
                        if (entry && entry[0] === key) return true;
                        return false;
                    });
                    defineProperty(WeakMap2.prototype, "set", function(key, value) {
                        checkInstance(this, "set");
                        if (!isObject(key)) throw new TypeError("Invalid value used as weak map key");
                        var entry = key[this._id];
                        if (entry && entry[0] === key) {
                            entry[1] = value;
                            return this;
                        }
                        defineProperty(key, this._id, [
                            key,
                            value
                        ]);
                        return this;
                    });
                    function checkInstance(x, methodName) {
                        if (!isObject(x) || !hasOwnProperty2.call(x, "_id")) throw new TypeError(methodName + " method called on incompatible receiver " + _typeof(x));
                    }
                    function genId(prefix) {
                        return prefix + "_" + rand() + "." + rand();
                    }
                    function rand() {
                        return Math.random().toString().substring(2);
                    }
                    defineProperty(WeakMap2, "_polyfill", true);
                    return WeakMap2;
                }();
                function isObject(x) {
                    return Object(x) === x;
                }
            })(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window1 !== "undefined" ? window1 : typeof global !== "undefined" ? global : exports);
        });
        var require_global = __commonJS(function(exports, module1) {
            var check = function check(it) {
                return it && it.Math == Math && it;
            };
            module1.exports = check((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) == "object" && globalThis) || check((typeof window1 === "undefined" ? "undefined" : _typeof(window1)) == "object" && window1) || check((typeof self === "undefined" ? "undefined" : _typeof(self)) == "object" && self) || check((typeof global === "undefined" ? "undefined" : _typeof(global)) == "object" && global) || function() {
                return this;
            }() || Function("return this")();
        });
        var require_fails = __commonJS(function(exports, module1) {
            module1.exports = function(exec) {
                try {
                    return !!exec();
                } catch (error) {
                    return true;
                }
            };
        });
        var require_function_bind_native = __commonJS(function(exports, module1) {
            var fails = require_fails();
            module1.exports = !fails(function() {
                var test = (function() {}).bind();
                return typeof test != "function" || test.hasOwnProperty("prototype");
            });
        });
        var require_function_apply = __commonJS(function(exports, module1) {
            var NATIVE_BIND = require_function_bind_native();
            var FunctionPrototype = Function.prototype;
            var apply = FunctionPrototype.apply;
            var call = FunctionPrototype.call;
            module1.exports = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) == "object" && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
                return call.apply(apply, arguments);
            });
        });
        var require_function_uncurry_this = __commonJS(function(exports, module1) {
            var NATIVE_BIND = require_function_bind_native();
            var FunctionPrototype = Function.prototype;
            var call = FunctionPrototype.call;
            var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
            module1.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
                return function() {
                    return call.apply(fn, arguments);
                };
            };
        });
        var require_classof_raw = __commonJS(function(exports, module1) {
            var uncurryThis = require_function_uncurry_this();
            var toString = uncurryThis({}.toString);
            var stringSlice = uncurryThis("".slice);
            module1.exports = function(it) {
                return stringSlice(toString(it), 8, -1);
            };
        });
        var require_function_uncurry_this_clause = __commonJS(function(exports, module1) {
            var classofRaw = require_classof_raw();
            var uncurryThis = require_function_uncurry_this();
            module1.exports = function(fn) {
                if (classofRaw(fn) === "Function") return uncurryThis(fn);
            };
        });
        var require_document_all = __commonJS(function(exports, module1) {
            var documentAll = (typeof document === "undefined" ? "undefined" : _typeof(document)) == "object" && document.all;
            var IS_HTMLDDA = typeof documentAll == "undefined" && documentAll !== void 0;
            module1.exports = {
                all: documentAll,
                IS_HTMLDDA: IS_HTMLDDA
            };
        });
        var require_is_callable2 = __commonJS(function(exports, module1) {
            var $documentAll = require_document_all();
            var documentAll = $documentAll.all;
            module1.exports = $documentAll.IS_HTMLDDA ? function(argument) {
                return typeof argument == "function" || argument === documentAll;
            } : function(argument) {
                return typeof argument == "function";
            };
        });
        var require_descriptors = __commonJS(function(exports, module1) {
            var fails = require_fails();
            module1.exports = !fails(function() {
                return Object.defineProperty({}, 1, {
                    get: function get() {
                        return 7;
                    }
                })[1] != 7;
            });
        });
        var require_function_call = __commonJS(function(exports, module1) {
            var NATIVE_BIND = require_function_bind_native();
            var call = Function.prototype.call;
            module1.exports = NATIVE_BIND ? call.bind(call) : function() {
                return call.apply(call, arguments);
            };
        });
        var require_object_property_is_enumerable = __commonJS(function(exports) {
            "use strict";
            var $propertyIsEnumerable = {}.propertyIsEnumerable;
            var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
                1: 2
            }, 1);
            exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
                var descriptor = getOwnPropertyDescriptor(this, V);
                return !!descriptor && descriptor.enumerable;
            } : $propertyIsEnumerable;
        });
        var require_create_property_descriptor = __commonJS(function(exports, module1) {
            module1.exports = function(bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };
        });
        var require_indexed_object = __commonJS(function(exports, module1) {
            var uncurryThis = require_function_uncurry_this();
            var fails = require_fails();
            var classof = require_classof_raw();
            var $Object = Object;
            var split = uncurryThis("".split);
            module1.exports = fails(function() {
                return !$Object("z").propertyIsEnumerable(0);
            }) ? function(it) {
                return classof(it) == "String" ? split(it, "") : $Object(it);
            } : $Object;
        });
        var require_is_null_or_undefined = __commonJS(function(exports, module1) {
            module1.exports = function(it) {
                return it === null || it === void 0;
            };
        });
        var require_require_object_coercible = __commonJS(function(exports, module1) {
            var isNullOrUndefined = require_is_null_or_undefined();
            var $TypeError = TypeError;
            module1.exports = function(it) {
                if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
                return it;
            };
        });
        var require_to_indexed_object = __commonJS(function(exports, module1) {
            var IndexedObject = require_indexed_object();
            var requireObjectCoercible = require_require_object_coercible();
            module1.exports = function(it) {
                return IndexedObject(requireObjectCoercible(it));
            };
        });
        var require_is_object2 = __commonJS(function(exports, module1) {
            var isCallable = require_is_callable2();
            var $documentAll = require_document_all();
            var documentAll = $documentAll.all;
            module1.exports = $documentAll.IS_HTMLDDA ? function(it) {
                return _typeof(it) == "object" ? it !== null : isCallable(it) || it === documentAll;
            } : function(it) {
                return _typeof(it) == "object" ? it !== null : isCallable(it);
            };
        });
        var require_path = __commonJS(function(exports, module1) {
            module1.exports = {};
        });
        var require_get_built_in = __commonJS(function(exports, module1) {
            var path = require_path();
            var global2 = require_global();
            var isCallable = require_is_callable2();
            var aFunction = function aFunction(variable) {
                return isCallable(variable) ? variable : void 0;
            };
            module1.exports = function(namespace, method) {
                return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global2[namespace]) : path[namespace] && path[namespace][method] || global2[namespace] && global2[namespace][method];
            };
        });
        var require_object_is_prototype_of = __commonJS(function(exports, module1) {
            var uncurryThis = require_function_uncurry_this();
            module1.exports = uncurryThis({}.isPrototypeOf);
        });
        var require_engine_user_agent = __commonJS(function(exports, module1) {
            var getBuiltIn = require_get_built_in();
            module1.exports = getBuiltIn("navigator", "userAgent") || "";
        });
        var require_engine_v8_version = __commonJS(function(exports, module1) {
            var global2 = require_global();
            var userAgent = require_engine_user_agent();
            var process2 = global2.process;
            var Deno = global2.Deno;
            var versions = process2 && process2.versions || Deno && Deno.version;
            var v8 = versions && versions.v8;
            var match;
            var version;
            if (v8) {
                match = v8.split(".");
                version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
            }
            if (!version && userAgent) {
                match = userAgent.match(/Edge\/(\d+)/);
                if (!match || match[1] >= 74) {
                    match = userAgent.match(/Chrome\/(\d+)/);
                    if (match) version = +match[1];
                }
            }
            module1.exports = version;
        });
        var require_symbol_constructor_detection = __commonJS(function(exports, module1) {
            var V8_VERSION = require_engine_v8_version();
            var fails = require_fails();
            module1.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                var symbol = Symbol();
                return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
            });
        });
        var require_use_symbol_as_uid = __commonJS(function(exports, module1) {
            var NATIVE_SYMBOL = require_symbol_constructor_detection();
            module1.exports = NATIVE_SYMBOL && !Symbol.sham && _typeof(Symbol.iterator) == "symbol";
        });
        var require_is_symbol2 = __commonJS(function(exports, module1) {
            var getBuiltIn = require_get_built_in();
            var isCallable = require_is_callable2();
            var isPrototypeOf = require_object_is_prototype_of();
            var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
            var $Object = Object;
            module1.exports = USE_SYMBOL_AS_UID ? function(it) {
                return _typeof(it) == "symbol";
            } : function(it) {
                var $Symbol = getBuiltIn("Symbol");
                return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
            };
        });
        var require_try_to_string = __commonJS(function(exports, module1) {
            var $String = String;
            module1.exports = function(argument) {
                try {
                    return $String(argument);
                } catch (error) {
                    return "Object";
                }
            };
        });
        var require_a_callable = __commonJS(function(exports, module1) {
            var isCallable = require_is_callable2();
            var tryToString = require_try_to_string();
            var $TypeError = TypeError;
            module1.exports = function(argument) {
                if (isCallable(argument)) return argument;
                throw $TypeError(tryToString(argument) + " is not a function");
            };
        });
        var require_get_method = __commonJS(function(exports, module1) {
            var aCallable = require_a_callable();
            var isNullOrUndefined = require_is_null_or_undefined();
            module1.exports = function(V, P) {
                var func = V[P];
                return isNullOrUndefined(func) ? void 0 : aCallable(func);
            };
        });
        var require_ordinary_to_primitive = __commonJS(function(exports, module1) {
            var call = require_function_call();
            var isCallable = require_is_callable2();
            var isObject = require_is_object2();
            var $TypeError = TypeError;
            module1.exports = function(input, pref) {
                var fn, val;
                if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
                if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
                throw $TypeError("Can't convert object to primitive value");
            };
        });
        var require_is_pure = __commonJS(function(exports, module1) {
            module1.exports = true;
        });
        var require_define_global_property = __commonJS(function(exports, module1) {
            var global2 = require_global();
            var defineProperty = Object.defineProperty;
            module1.exports = function(key, value) {
                try {
                    defineProperty(global2, key, {
                        value: value,
                        configurable: true,
                        writable: true
                    });
                } catch (error) {
                    global2[key] = value;
                }
                return value;
            };
        });
        var require_shared_store = __commonJS(function(exports, module1) {
            var global2 = require_global();
            var defineGlobalProperty = require_define_global_property();
            var SHARED = "__core-js_shared__";
            var store = global2[SHARED] || defineGlobalProperty(SHARED, {});
            module1.exports = store;
        });
        var require_shared = __commonJS(function(exports, module1) {
            var IS_PURE = require_is_pure();
            var store = require_shared_store();
            (module1.exports = function(key, value) {
                return store[key] || (store[key] = value !== void 0 ? value : {});
            })("versions", []).push({
                version: "3.26.1",
                mode: IS_PURE ? "pure" : "global",
                copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
                license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE",
                source: "https://github.com/zloirock/core-js"
            });
        });
        var require_to_object = __commonJS(function(exports, module1) {
            var requireObjectCoercible = require_require_object_coercible();
            var $Object = Object;
            module1.exports = function(argument) {
                return $Object(requireObjectCoercible(argument));
            };
        });
        var require_has_own_property = __commonJS(function(exports, module1) {
            var uncurryThis = require_function_uncurry_this();
            var toObject = require_to_object();
            var hasOwnProperty2 = uncurryThis({}.hasOwnProperty);
            module1.exports = Object.hasOwn || function hasOwn2(it, key) {
                return hasOwnProperty2(toObject(it), key);
            };
        });
        var require_uid = __commonJS(function(exports, module1) {
            var uncurryThis = require_function_uncurry_this();
            var id = 0;
            var postfix = Math.random();
            var toString = uncurryThis(1..toString);
            module1.exports = function(key) {
                return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString(++id + postfix, 36);
            };
        });
        var require_well_known_symbol = __commonJS(function(exports, module1) {
            var global2 = require_global();
            var shared = require_shared();
            var hasOwn2 = require_has_own_property();
            var uid = require_uid();
            var NATIVE_SYMBOL = require_symbol_constructor_detection();
            var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
            var WellKnownSymbolsStore = shared("wks");
            var Symbol2 = global2.Symbol;
            var symbolFor = Symbol2 && Symbol2["for"];
            var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol2 : Symbol2 && Symbol2.withoutSetter || uid;
            module1.exports = function(name) {
                if (!hasOwn2(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
                    var description = "Symbol." + name;
                    if (NATIVE_SYMBOL && hasOwn2(Symbol2, name)) WellKnownSymbolsStore[name] = Symbol2[name];
                    else if (USE_SYMBOL_AS_UID && symbolFor) WellKnownSymbolsStore[name] = symbolFor(description);
                    else WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
                }
                return WellKnownSymbolsStore[name];
            };
        });
        var require_to_primitive = __commonJS(function(exports, module1) {
            var call = require_function_call();
            var isObject = require_is_object2();
            var isSymbol = require_is_symbol2();
            var getMethod = require_get_method();
            var ordinaryToPrimitive = require_ordinary_to_primitive();
            var wellKnownSymbol = require_well_known_symbol();
            var $TypeError = TypeError;
            var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
            module1.exports = function(input, pref) {
                if (!isObject(input) || isSymbol(input)) return input;
                var exoticToPrim = getMethod(input, TO_PRIMITIVE);
                var result;
                if (exoticToPrim) {
                    if (pref === void 0) pref = "default";
                    result = call(exoticToPrim, input, pref);
                    if (!isObject(result) || isSymbol(result)) return result;
                    throw $TypeError("Can't convert object to primitive value");
                }
                if (pref === void 0) pref = "number";
                return ordinaryToPrimitive(input, pref);
            };
        });
        var require_to_property_key = __commonJS(function(exports, module1) {
            var toPrimitive = require_to_primitive();
            var isSymbol = require_is_symbol2();
            module1.exports = function(argument) {
                var key = toPrimitive(argument, "string");
                return isSymbol(key) ? key : key + "";
            };
        });
        var require_document_create_element = __commonJS(function(exports, module1) {
            var global2 = require_global();
            var isObject = require_is_object2();
            var document2 = global2.document;
            var EXISTS = isObject(document2) && isObject(document2.createElement);
            module1.exports = function(it) {
                return EXISTS ? document2.createElement(it) : {};
            };
        });
        var require_ie8_dom_define = __commonJS(function(exports, module1) {
            var DESCRIPTORS = require_descriptors();
            var fails = require_fails();
            var createElement = require_document_create_element();
            module1.exports = !DESCRIPTORS && !fails(function() {
                return Object.defineProperty(createElement("div"), "a", {
                    get: function get() {
                        return 7;
                    }
                }).a != 7;
            });
        });
        var require_object_get_own_property_descriptor = __commonJS(function(exports) {
            var DESCRIPTORS = require_descriptors();
            var call = require_function_call();
            var propertyIsEnumerableModule = require_object_property_is_enumerable();
            var createPropertyDescriptor = require_create_property_descriptor();
            var toIndexedObject = require_to_indexed_object();
            var toPropertyKey = require_to_property_key();
            var hasOwn2 = require_has_own_property();
            var IE8_DOM_DEFINE = require_ie8_dom_define();
            var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
                O = toIndexedObject(O);
                P = toPropertyKey(P);
                if (IE8_DOM_DEFINE) try {
                    return $getOwnPropertyDescriptor(O, P);
                } catch (error) {}
                if (hasOwn2(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
            };
        });
        var require_is_forced = __commonJS(function(exports, module1) {
            var fails = require_fails();
            var isCallable = require_is_callable2();
            var replacement = /#|\.prototype\./;
            var isForced = function isForced(feature, detection) {
                var value = data[normalize(feature)];
                return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
            };
            var normalize = isForced.normalize = function(string) {
                return String(string).replace(replacement, ".").toLowerCase();
            };
            var data = isForced.data = {};
            var NATIVE = isForced.NATIVE = "N";
            var POLYFILL = isForced.POLYFILL = "P";
            module1.exports = isForced;
        });
        var require_function_bind_context = __commonJS(function(exports, module1) {
            var uncurryThis = require_function_uncurry_this_clause();
            var aCallable = require_a_callable();
            var NATIVE_BIND = require_function_bind_native();
            var bind = uncurryThis(uncurryThis.bind);
            module1.exports = function(fn, that) {
                aCallable(fn);
                return that === void 0 ? fn : NATIVE_BIND ? bind(fn, that) : function() {
                    return fn.apply(that, arguments);
                };
            };
        });
        var require_v8_prototype_define_bug = __commonJS(function(exports, module1) {
            var DESCRIPTORS = require_descriptors();
            var fails = require_fails();
            module1.exports = DESCRIPTORS && fails(function() {
                return Object.defineProperty(function() {}, "prototype", {
                    value: 42,
                    writable: false
                }).prototype != 42;
            });
        });
        var require_an_object = __commonJS(function(exports, module1) {
            var isObject = require_is_object2();
            var $String = String;
            var $TypeError = TypeError;
            module1.exports = function(argument) {
                if (isObject(argument)) return argument;
                throw $TypeError($String(argument) + " is not an object");
            };
        });
        var require_object_define_property = __commonJS(function(exports) {
            var DESCRIPTORS = require_descriptors();
            var IE8_DOM_DEFINE = require_ie8_dom_define();
            var V8_PROTOTYPE_DEFINE_BUG = require_v8_prototype_define_bug();
            var anObject = require_an_object();
            var toPropertyKey = require_to_property_key();
            var $TypeError = TypeError;
            var $defineProperty = Object.defineProperty;
            var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            var ENUMERABLE = "enumerable";
            var CONFIGURABLE = "configurable";
            var WRITABLE = "writable";
            exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPropertyKey(P);
                anObject(Attributes);
                if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                    var current = $getOwnPropertyDescriptor(O, P);
                    if (current && current[WRITABLE]) {
                        O[P] = Attributes.value;
                        Attributes = {
                            configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                            enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                            writable: false
                        };
                    }
                }
                return $defineProperty(O, P, Attributes);
            } : $defineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPropertyKey(P);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return $defineProperty(O, P, Attributes);
                } catch (error) {}
                if ("get" in Attributes || "set" in Attributes) throw $TypeError("Accessors not supported");
                if ("value" in Attributes) O[P] = Attributes.value;
                return O;
            };
        });
        var require_create_non_enumerable_property = __commonJS(function(exports, module1) {
            var DESCRIPTORS = require_descriptors();
            var definePropertyModule = require_object_define_property();
            var createPropertyDescriptor = require_create_property_descriptor();
            module1.exports = DESCRIPTORS ? function(object, key, value) {
                return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
            } : function(object, key, value) {
                object[key] = value;
                return object;
            };
        });
        var require_export = __commonJS(function(exports, module1) {
            "use strict";
            var global2 = require_global();
            var apply = require_function_apply();
            var uncurryThis = require_function_uncurry_this_clause();
            var isCallable = require_is_callable2();
            var getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
            var isForced = require_is_forced();
            var path = require_path();
            var bind = require_function_bind_context();
            var createNonEnumerableProperty = require_create_non_enumerable_property();
            var hasOwn2 = require_has_own_property();
            var wrapConstructor = function wrapConstructor(NativeConstructor) {
                var Wrapper = function Wrapper(a2, b2, c4) {
                    if (this instanceof Wrapper) {
                        switch(arguments.length){
                            case 0:
                                return new NativeConstructor();
                            case 1:
                                return new NativeConstructor(a2);
                            case 2:
                                return new NativeConstructor(a2, b2);
                        }
                        return new NativeConstructor(a2, b2, c4);
                    }
                    return apply(NativeConstructor, this, arguments);
                };
                Wrapper.prototype = NativeConstructor.prototype;
                return Wrapper;
            };
            module1.exports = function(options, source) {
                var TARGET = options.target;
                var GLOBAL = options.global;
                var STATIC = options.stat;
                var PROTO = options.proto;
                var nativeSource = GLOBAL ? global2 : STATIC ? global2[TARGET] : (global2[TARGET] || {}).prototype;
                var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
                var targetPrototype = target.prototype;
                var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
                var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
                for(key in source){
                    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                    USE_NATIVE = !FORCED && nativeSource && hasOwn2(nativeSource, key);
                    targetProperty = target[key];
                    if (USE_NATIVE) {
                        if (options.dontCallGetSet) {
                            descriptor = getOwnPropertyDescriptor(nativeSource, key);
                            nativeProperty = descriptor && descriptor.value;
                        } else nativeProperty = nativeSource[key];
                    }
                    sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
                    if (USE_NATIVE && _typeof(targetProperty) == _typeof(sourceProperty)) continue;
                    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global2);
                    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
                    else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
                    else resultProperty = sourceProperty;
                    if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(resultProperty, "sham", true);
                    createNonEnumerableProperty(target, key, resultProperty);
                    if (PROTO) {
                        VIRTUAL_PROTOTYPE = TARGET + "Prototype";
                        if (!hasOwn2(path, VIRTUAL_PROTOTYPE)) createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
                        createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
                        if (options.real && targetPrototype && !targetPrototype[key]) createNonEnumerableProperty(targetPrototype, key, sourceProperty);
                    }
                }
            };
        });
        var require_es_object_has_own = __commonJS(function() {
            var $ = require_export();
            var hasOwn2 = require_has_own_property();
            $({
                target: "Object",
                stat: true
            }, {
                hasOwn: hasOwn2
            });
        });
        var require_has_own = __commonJS(function(exports, module1) {
            require_es_object_has_own();
            var path = require_path();
            module1.exports = path.Object.hasOwn;
        });
        var require_has_own2 = __commonJS(function(exports, module1) {
            var parent = require_has_own();
            module1.exports = parent;
        });
        var require_has_own3 = __commonJS(function(exports, module1) {
            var parent = require_has_own2();
            module1.exports = parent;
        });
        var definitions = [
            {
                name: "NA",
                value: "inapplicable",
                priority: 0,
                group: "inapplicable"
            },
            {
                name: "PASS",
                value: "passed",
                priority: 1,
                group: "passes"
            },
            {
                name: "CANTTELL",
                value: "cantTell",
                priority: 2,
                group: "incomplete"
            },
            {
                name: "FAIL",
                value: "failed",
                priority: 3,
                group: "violations"
            }
        ];
        var constants = {
            helpUrlBase: "https://dequeuniversity.com/rules/",
            gridSize: 200,
            results: [],
            resultGroups: [],
            resultGroupMap: {},
            impact: Object.freeze([
                "minor",
                "moderate",
                "serious",
                "critical"
            ]),
            preload: Object.freeze({
                assets: [
                    "cssom",
                    "media"
                ],
                timeout: 1e4
            }),
            allOrigins: "<unsafe_all_origins>",
            sameOrigin: "<same_origin>"
        };
        definitions.forEach(function(definition) {
            var name = definition.name;
            var value = definition.value;
            var priority = definition.priority;
            var group = definition.group;
            constants[name] = value;
            constants[name + "_PRIO"] = priority;
            constants[name + "_GROUP"] = group;
            constants.results[priority] = value;
            constants.resultGroups[priority] = group;
            constants.resultGroupMap[value] = group;
        });
        Object.freeze(constants.results);
        Object.freeze(constants.resultGroups);
        Object.freeze(constants.resultGroupMap);
        Object.freeze(constants);
        var constants_default = constants;
        function log() {
            if ((typeof console === "undefined" ? "undefined" : _typeof(console)) === "object" && console.log) Function.prototype.apply.call(console.log, console, arguments);
        }
        var log_default = log;
        var whitespaceRegex = /[\t\r\n\f]/g;
        var AbstractVirtualNode = function() {
            function AbstractVirtualNode() {
                _classCallCheck(this, AbstractVirtualNode);
                this.parent = void 0;
            }
            _createClass(AbstractVirtualNode, [
                {
                    key: "props",
                    get: function get() {
                        throw new Error('VirtualNode class must have a "props" object consisting of "nodeType" and "nodeName" properties');
                    }
                },
                {
                    key: "attrNames",
                    get: function get() {
                        throw new Error('VirtualNode class must have an "attrNames" property');
                    }
                },
                {
                    key: "attr",
                    value: function attr() {
                        throw new Error('VirtualNode class must have an "attr" function');
                    }
                },
                {
                    key: "hasAttr",
                    value: function hasAttr() {
                        throw new Error('VirtualNode class must have a "hasAttr" function');
                    }
                },
                {
                    key: "hasClass",
                    value: function hasClass(className) {
                        var classAttr = this.attr("class");
                        if (!classAttr) return false;
                        var selector = " " + className + " ";
                        return (" " + classAttr + " ").replace(whitespaceRegex, " ").indexOf(selector) >= 0;
                    }
                }
            ]);
            return AbstractVirtualNode;
        }();
        var abstract_virtual_node_default = AbstractVirtualNode;
        var utils_exports = {};
        __export(utils_exports, {
            DqElement: function DqElement() {
                return dq_element_default;
            },
            aggregate: function aggregate() {
                return aggregate_default;
            },
            aggregateChecks: function aggregateChecks() {
                return aggregate_checks_default;
            },
            aggregateNodeResults: function aggregateNodeResults() {
                return aggregate_node_results_default;
            },
            aggregateResult: function aggregateResult() {
                return aggregate_result_default;
            },
            areStylesSet: function areStylesSet() {
                return are_styles_set_default;
            },
            assert: function assert() {
                return assert_default;
            },
            checkHelper: function checkHelper() {
                return check_helper_default;
            },
            clone: function clone() {
                return _clone;
            },
            closest: function closest() {
                return closest_default;
            },
            collectResultsFromFrames: function collectResultsFromFrames() {
                return _collectResultsFromFrames;
            },
            contains: function contains() {
                return _contains;
            },
            convertSelector: function convertSelector() {
                return _convertSelector;
            },
            cssParser: function cssParser() {
                return css_parser_default;
            },
            deepMerge: function deepMerge() {
                return deep_merge_default;
            },
            escapeSelector: function escapeSelector() {
                return escape_selector_default;
            },
            extendMetaData: function extendMetaData() {
                return extend_meta_data_default;
            },
            filterHtmlAttrs: function filterHtmlAttrs() {
                return _filterHtmlAttrs;
            },
            finalizeRuleResult: function finalizeRuleResult() {
                return _finalizeRuleResult;
            },
            findBy: function findBy() {
                return find_by_default;
            },
            getAllChecks: function getAllChecks() {
                return get_all_checks_default;
            },
            getAncestry: function getAncestry() {
                return _getAncestry;
            },
            getBaseLang: function getBaseLang() {
                return get_base_lang_default;
            },
            getCheckMessage: function getCheckMessage() {
                return get_check_message_default;
            },
            getCheckOption: function getCheckOption() {
                return get_check_option_default;
            },
            getEnvironmentData: function getEnvironmentData() {
                return _getEnvironmentData;
            },
            getFlattenedTree: function getFlattenedTree() {
                return _getFlattenedTree;
            },
            getFrameContexts: function getFrameContexts() {
                return _getFrameContexts;
            },
            getFriendlyUriEnd: function getFriendlyUriEnd() {
                return get_friendly_uri_end_default;
            },
            getNodeAttributes: function getNodeAttributes() {
                return get_node_attributes_default;
            },
            getNodeFromTree: function getNodeFromTree() {
                return get_node_from_tree_default;
            },
            getPreloadConfig: function getPreloadConfig() {
                return _getPreloadConfig;
            },
            getRootNode: function getRootNode() {
                return get_root_node_default;
            },
            getRule: function getRule() {
                return _getRule;
            },
            getScroll: function getScroll() {
                return get_scroll_default;
            },
            getScrollState: function getScrollState() {
                return get_scroll_state_default;
            },
            getSelector: function getSelector() {
                return _getSelector;
            },
            getSelectorData: function getSelectorData() {
                return _getSelectorData;
            },
            getShadowSelector: function getShadowSelector() {
                return _getShadowSelector;
            },
            getStandards: function getStandards() {
                return _getStandards;
            },
            getStyleSheetFactory: function getStyleSheetFactory() {
                return get_stylesheet_factory_default;
            },
            getXpath: function getXpath() {
                return get_xpath_default;
            },
            injectStyle: function injectStyle() {
                return inject_style_default;
            },
            isHidden: function isHidden() {
                return is_hidden_default;
            },
            isHtmlElement: function isHtmlElement() {
                return is_html_element_default;
            },
            isNodeInContext: function isNodeInContext() {
                return _isNodeInContext;
            },
            isShadowRoot: function isShadowRoot() {
                return is_shadow_root_default;
            },
            isValidLang: function isValidLang() {
                return valid_langs_default;
            },
            isXHTML: function isXHTML() {
                return is_xhtml_default;
            },
            matchAncestry: function matchAncestry() {
                return _matchAncestry;
            },
            matches: function matches() {
                return _matches;
            },
            matchesExpression: function matchesExpression() {
                return _matchesExpression;
            },
            matchesSelector: function matchesSelector() {
                return element_matches_default;
            },
            memoize: function memoize() {
                return memoize_default;
            },
            mergeResults: function mergeResults() {
                return merge_results_default;
            },
            nodeLookup: function nodeLookup() {
                return _nodeLookup;
            },
            nodeSerializer: function nodeSerializer() {
                return node_serializer_default;
            },
            nodeSorter: function nodeSorter() {
                return node_sorter_default;
            },
            parseCrossOriginStylesheet: function parseCrossOriginStylesheet() {
                return parse_crossorigin_stylesheet_default;
            },
            parseSameOriginStylesheet: function parseSameOriginStylesheet() {
                return parse_sameorigin_stylesheet_default;
            },
            parseStylesheet: function parseStylesheet() {
                return parse_stylesheet_default;
            },
            performanceTimer: function performanceTimer() {
                return performance_timer_default;
            },
            pollyfillElementsFromPoint: function pollyfillElementsFromPoint() {
                return _pollyfillElementsFromPoint;
            },
            preload: function preload() {
                return _preload;
            },
            preloadCssom: function preloadCssom() {
                return preload_cssom_default;
            },
            preloadMedia: function preloadMedia() {
                return preload_media_default;
            },
            processMessage: function processMessage() {
                return process_message_default;
            },
            publishMetaData: function publishMetaData() {
                return _publishMetaData;
            },
            querySelectorAll: function querySelectorAll() {
                return query_selector_all_default;
            },
            querySelectorAllFilter: function querySelectorAllFilter() {
                return query_selector_all_filter_default;
            },
            queue: function queue() {
                return queue_default;
            },
            respondable: function respondable() {
                return _respondable;
            },
            ruleShouldRun: function ruleShouldRun() {
                return rule_should_run_default;
            },
            select: function select() {
                return _select;
            },
            sendCommandToFrame: function sendCommandToFrame() {
                return _sendCommandToFrame;
            },
            setScrollState: function setScrollState() {
                return set_scroll_state_default;
            },
            shadowSelect: function shadowSelect() {
                return _shadowSelect;
            },
            shadowSelectAll: function shadowSelectAll() {
                return _shadowSelectAll;
            },
            shouldPreload: function shouldPreload() {
                return _shouldPreload;
            },
            toArray: function toArray() {
                return to_array_default;
            },
            tokenList: function tokenList() {
                return token_list_default;
            },
            uniqueArray: function uniqueArray() {
                return unique_array_default;
            },
            uuid: function uuid() {
                return uuid_default;
            },
            validInputTypes: function validInputTypes() {
                return valid_input_type_default;
            },
            validLangs: function validLangs() {
                return _validLangs;
            }
        });
        function aggregate(map, values, initial) {
            values = values.slice();
            if (initial) values.push(initial);
            var sorting = values.map(function(val) {
                return map.indexOf(val);
            }).sort();
            return map[sorting.pop()];
        }
        var aggregate_default = aggregate;
        var CANTTELL_PRIO = constants_default.CANTTELL_PRIO, FAIL_PRIO = constants_default.FAIL_PRIO;
        var checkMap = [];
        checkMap[constants_default.PASS_PRIO] = true;
        checkMap[constants_default.CANTTELL_PRIO] = null;
        checkMap[constants_default.FAIL_PRIO] = false;
        var checkTypes = [
            "any",
            "all",
            "none"
        ];
        function anyAllNone(obj, functor) {
            return checkTypes.reduce(function(out, type2) {
                out[type2] = (obj[type2] || []).map(function(val) {
                    return functor(val, type2);
                });
                return out;
            }, {});
        }
        function aggregateChecks(nodeResOriginal) {
            var nodeResult = Object.assign({}, nodeResOriginal);
            anyAllNone(nodeResult, function(check, type2) {
                var i = typeof check.result === "undefined" ? -1 : checkMap.indexOf(check.result);
                check.priority = i !== -1 ? i : constants_default.CANTTELL_PRIO;
                if (type2 === "none") {
                    if (check.priority === constants_default.PASS_PRIO) check.priority = constants_default.FAIL_PRIO;
                    else if (check.priority === constants_default.FAIL_PRIO) check.priority = constants_default.PASS_PRIO;
                }
            });
            var priorities = {
                all: nodeResult.all.reduce(function(a2, b2) {
                    return Math.max(a2, b2.priority);
                }, 0),
                none: nodeResult.none.reduce(function(a2, b2) {
                    return Math.max(a2, b2.priority);
                }, 0),
                any: nodeResult.any.reduce(function(a2, b2) {
                    return Math.min(a2, b2.priority);
                }, 4) % 4
            };
            nodeResult.priority = Math.max(priorities.all, priorities.none, priorities.any);
            var impacts = [];
            checkTypes.forEach(function(type2) {
                nodeResult[type2] = nodeResult[type2].filter(function(check) {
                    return check.priority === nodeResult.priority && check.priority === priorities[type2];
                });
                nodeResult[type2].forEach(function(check) {
                    return impacts.push(check.impact);
                });
            });
            if ([
                CANTTELL_PRIO,
                FAIL_PRIO
            ].includes(nodeResult.priority)) nodeResult.impact = aggregate_default(constants_default.impact, impacts);
            else nodeResult.impact = null;
            anyAllNone(nodeResult, function(c4) {
                delete c4.result;
                delete c4.priority;
            });
            nodeResult.result = constants_default.results[nodeResult.priority];
            delete nodeResult.priority;
            return nodeResult;
        }
        var aggregate_checks_default = aggregateChecks;
        function _finalizeRuleResult(ruleResult) {
            var rule = axe._audit.rules.find(function(_ref) {
                var id = _ref.id;
                return id === ruleResult.id;
            });
            if (rule && rule.impact) ruleResult.nodes.forEach(function(node) {
                [
                    "any",
                    "all",
                    "none"
                ].forEach(function(checkType) {
                    (node[checkType] || []).forEach(function(checkResult) {
                        checkResult.impact = rule.impact;
                    });
                });
            });
            Object.assign(ruleResult, aggregate_node_results_default(ruleResult.nodes));
            delete ruleResult.nodes;
            return ruleResult;
        }
        function aggregateNodeResults(nodeResults) {
            var ruleResult = {};
            nodeResults = nodeResults.map(function(nodeResult) {
                if (nodeResult.any && nodeResult.all && nodeResult.none) return aggregate_checks_default(nodeResult);
                else if (Array.isArray(nodeResult.node)) return _finalizeRuleResult(nodeResult);
                else throw new TypeError("Invalid Result type");
            });
            if (nodeResults && nodeResults.length) {
                var resultList = nodeResults.map(function(node) {
                    return node.result;
                });
                ruleResult.result = aggregate_default(constants_default.results, resultList, ruleResult.result);
            } else ruleResult.result = "inapplicable";
            constants_default.resultGroups.forEach(function(group) {
                return ruleResult[group] = [];
            });
            nodeResults.forEach(function(nodeResult) {
                var groupName = constants_default.resultGroupMap[nodeResult.result];
                ruleResult[groupName].push(nodeResult);
            });
            var impactGroup = constants_default.FAIL_GROUP;
            if (ruleResult[impactGroup].length === 0) impactGroup = constants_default.CANTTELL_GROUP;
            if (ruleResult[impactGroup].length > 0) {
                var impactList = ruleResult[impactGroup].map(function(failure) {
                    return failure.impact;
                });
                ruleResult.impact = aggregate_default(constants_default.impact, impactList) || null;
            } else ruleResult.impact = null;
            return ruleResult;
        }
        var aggregate_node_results_default = aggregateNodeResults;
        function copyToGroup(resultObject, subResult, group) {
            var resultCopy = Object.assign({}, subResult);
            resultCopy.nodes = (resultCopy[group] || []).concat();
            constants_default.resultGroups.forEach(function(resultGroup) {
                delete resultCopy[resultGroup];
            });
            resultObject[group].push(resultCopy);
        }
        function aggregateResult(results) {
            var resultObject = {};
            constants_default.resultGroups.forEach(function(groupName) {
                return resultObject[groupName] = [];
            });
            results.forEach(function(subResult) {
                if (subResult.error) copyToGroup(resultObject, subResult, constants_default.CANTTELL_GROUP);
                else if (subResult.result === constants_default.NA) copyToGroup(resultObject, subResult, constants_default.NA_GROUP);
                else constants_default.resultGroups.forEach(function(group) {
                    if (Array.isArray(subResult[group]) && subResult[group].length > 0) copyToGroup(resultObject, subResult, group);
                });
            });
            return resultObject;
        }
        var aggregate_result_default = aggregateResult;
        function areStylesSet(el, styles, stopAt) {
            var styl = window1.getComputedStyle(el, null);
            if (!styl) return false;
            for(var i = 0; i < styles.length; ++i){
                var att = styles[i];
                if (styl.getPropertyValue(att.property) === att.value) return true;
            }
            if (!el.parentNode || el.nodeName.toUpperCase() === stopAt.toUpperCase()) return false;
            return areStylesSet(el.parentNode, styles, stopAt);
        }
        var are_styles_set_default = areStylesSet;
        function assert(bool, message) {
            if (!bool) throw new Error(message);
        }
        var assert_default = assert;
        function toArray(thing) {
            return Array.prototype.slice.call(thing);
        }
        var to_array_default = toArray;
        function escapeSelector(value) {
            var string = String(value);
            var length = string.length;
            var index = -1;
            var codeUnit;
            var result = "";
            var firstCodeUnit = string.charCodeAt(0);
            while(++index < length){
                codeUnit = string.charCodeAt(index);
                if (codeUnit == 0) {
                    result += "�";
                    continue;
                }
                if (codeUnit >= 1 && codeUnit <= 31 || codeUnit == 127 || index == 0 && codeUnit >= 48 && codeUnit <= 57 || index == 1 && codeUnit >= 48 && codeUnit <= 57 && firstCodeUnit == 45) {
                    result += "\\" + codeUnit.toString(16) + " ";
                    continue;
                }
                if (index == 0 && length == 1 && codeUnit == 45) {
                    result += "\\" + string.charAt(index);
                    continue;
                }
                if (codeUnit >= 128 || codeUnit == 45 || codeUnit == 95 || codeUnit >= 48 && codeUnit <= 57 || codeUnit >= 65 && codeUnit <= 90 || codeUnit >= 97 && codeUnit <= 122) {
                    result += string.charAt(index);
                    continue;
                }
                result += "\\" + string.charAt(index);
            }
            return result;
        }
        var escape_selector_default = escapeSelector;
        function isMostlyNumbers() {
            var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            return str.length !== 0 && (str.match(/[0-9]/g) || "").length >= str.length / 2;
        }
        function splitString(str, splitIndex) {
            return [
                str.substring(0, splitIndex),
                str.substring(splitIndex)
            ];
        }
        function trimRight(str) {
            return str.replace(/\s+$/, "");
        }
        function uriParser(url) {
            var original = url;
            var protocol = "", domain = "", port = "", path = "", query = "", hash = "";
            if (url.includes("#")) {
                var _splitString = splitString(url, url.indexOf("#"));
                var _splitString2 = _slicedToArray(_splitString, 2);
                url = _splitString2[0];
                hash = _splitString2[1];
            }
            if (url.includes("?")) {
                var _splitString3 = splitString(url, url.indexOf("?"));
                var _splitString4 = _slicedToArray(_splitString3, 2);
                url = _splitString4[0];
                query = _splitString4[1];
            }
            if (url.includes("://")) {
                var _url$split = url.split("://");
                var _url$split2 = _slicedToArray(_url$split, 2);
                protocol = _url$split2[0];
                url = _url$split2[1];
                var _splitString5 = splitString(url, url.indexOf("/"));
                var _splitString6 = _slicedToArray(_splitString5, 2);
                domain = _splitString6[0];
                url = _splitString6[1];
            } else if (url.substr(0, 2) === "//") {
                url = url.substr(2);
                var _splitString7 = splitString(url, url.indexOf("/"));
                var _splitString8 = _slicedToArray(_splitString7, 2);
                domain = _splitString8[0];
                url = _splitString8[1];
            }
            if (domain.substr(0, 4) === "www.") domain = domain.substr(4);
            if (domain && domain.includes(":")) {
                var _splitString9 = splitString(domain, domain.indexOf(":"));
                var _splitString10 = _slicedToArray(_splitString9, 2);
                domain = _splitString10[0];
                port = _splitString10[1];
            }
            path = url;
            return {
                original: original,
                protocol: protocol,
                domain: domain,
                port: port,
                path: path,
                query: query,
                hash: hash
            };
        }
        function getFriendlyUriEnd() {
            var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (uri.length <= 1 || uri.substr(0, 5) === "data:" || uri.substr(0, 11) === "javascript:" || uri.includes("?")) return;
            var currentDomain = options.currentDomain, _options$maxLength = options.maxLength, maxLength = _options$maxLength === void 0 ? 25 : _options$maxLength;
            var _uriParser = uriParser(uri), path = _uriParser.path, domain = _uriParser.domain, hash = _uriParser.hash;
            var pathEnd = path.substr(path.substr(0, path.length - 2).lastIndexOf("/") + 1);
            if (hash) {
                if (pathEnd && (pathEnd + hash).length <= maxLength) return trimRight(pathEnd + hash);
                else if (pathEnd.length < 2 && hash.length > 2 && hash.length <= maxLength) return trimRight(hash);
                else return;
            } else if (domain && domain.length < maxLength && path.length <= 1) return trimRight(domain + path);
            if (path === "/" + pathEnd && domain && currentDomain && domain !== currentDomain && (domain + path).length <= maxLength) return trimRight(domain + path);
            var lastDotIndex = pathEnd.lastIndexOf(".");
            if ((lastDotIndex === -1 || lastDotIndex > 1) && (lastDotIndex !== -1 || pathEnd.length > 2) && pathEnd.length <= maxLength && !pathEnd.match(/index(\.[a-zA-Z]{2-4})?/) && !isMostlyNumbers(pathEnd)) return trimRight(pathEnd);
        }
        var get_friendly_uri_end_default = getFriendlyUriEnd;
        function getNodeAttributes(node) {
            if (node.attributes instanceof window1.NamedNodeMap) return node.attributes;
            return node.cloneNode(false).attributes;
        }
        var get_node_attributes_default = getNodeAttributes;
        var matchesSelector = function() {
            var method;
            function getMethod(node) {
                var index, candidate, candidates = [
                    "matches",
                    "matchesSelector",
                    "mozMatchesSelector",
                    "webkitMatchesSelector",
                    "msMatchesSelector"
                ], length = candidates.length;
                for(index = 0; index < length; index++){
                    candidate = candidates[index];
                    if (node[candidate]) return candidate;
                }
            }
            return function(node, selector) {
                if (!method || !node[method]) method = getMethod(node);
                if (node[method]) return node[method](selector);
                return false;
            };
        }();
        var element_matches_default = matchesSelector;
        var import_memoizee = __toModule(require_memoizee());
        axe._memoizedFns = [];
        function memoizeImplementation(fn) {
            var memoized = (0, import_memoizee["default"])(fn);
            axe._memoizedFns.push(memoized);
            return memoized;
        }
        var memoize_default = memoizeImplementation;
        var isXHTML = memoize_default(function(doc) {
            if (!(doc !== null && doc !== void 0 && doc.createElement)) return false;
            return doc.createElement("A").localName === "A";
        });
        var is_xhtml_default = isXHTML;
        function _getShadowSelector(generateSelector2, elm) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (!elm) return "";
            var doc = elm.getRootNode && elm.getRootNode() || document;
            if (doc.nodeType !== 11) return generateSelector2(elm, options, doc);
            var stack = [];
            while(doc.nodeType === 11){
                if (!doc.host) return "";
                stack.unshift({
                    elm: elm,
                    doc: doc
                });
                elm = doc.host;
                doc = elm.getRootNode();
            }
            stack.unshift({
                elm: elm,
                doc: doc
            });
            return stack.map(function(item) {
                return generateSelector2(item.elm, options, item.doc);
            });
        }
        var ignoredAttributes = [
            "class",
            "style",
            "id",
            "selected",
            "checked",
            "disabled",
            "tabindex",
            "aria-checked",
            "aria-selected",
            "aria-invalid",
            "aria-activedescendant",
            "aria-busy",
            "aria-disabled",
            "aria-expanded",
            "aria-grabbed",
            "aria-pressed",
            "aria-valuenow"
        ];
        var MAXATTRIBUTELENGTH = 31;
        var attrCharsRegex = /([\\"])/g;
        var newlineChars = /(\r\n|\r|\n)/g;
        function escapeAttribute(str) {
            return str.replace(attrCharsRegex, "\\$1").replace(newlineChars, "\\a ");
        }
        function getAttributeNameValue(node, at) {
            var name = at.name;
            var atnv;
            if (name.indexOf("href") !== -1 || name.indexOf("src") !== -1) {
                var friendly = get_friendly_uri_end_default(node.getAttribute(name));
                if (friendly) atnv = escape_selector_default(at.name) + '$="' + escapeAttribute(friendly) + '"';
                else atnv = escape_selector_default(at.name) + '="' + escapeAttribute(node.getAttribute(name)) + '"';
            } else atnv = escape_selector_default(name) + '="' + escapeAttribute(at.value) + '"';
            return atnv;
        }
        function countSort(a2, b2) {
            return a2.count < b2.count ? -1 : a2.count === b2.count ? 0 : 1;
        }
        function filterAttributes(at) {
            return !ignoredAttributes.includes(at.name) && at.name.indexOf(":") === -1 && (!at.value || at.value.length < MAXATTRIBUTELENGTH);
        }
        function _getSelectorData(domTree) {
            var data = {
                classes: {},
                tags: {},
                attributes: {}
            };
            domTree = Array.isArray(domTree) ? domTree : [
                domTree
            ];
            var currentLevel = domTree.slice();
            var stack = [];
            var _loop2 = function _loop2() {
                var current = currentLevel.pop();
                var node = current.actualNode;
                if (!!node.querySelectorAll) {
                    var tag = node.nodeName;
                    if (data.tags[tag]) data.tags[tag]++;
                    else data.tags[tag] = 1;
                    if (node.classList) Array.from(node.classList).forEach(function(cl) {
                        var ind = escape_selector_default(cl);
                        if (data.classes[ind]) data.classes[ind]++;
                        else data.classes[ind] = 1;
                    });
                    if (node.hasAttributes()) Array.from(get_node_attributes_default(node)).filter(filterAttributes).forEach(function(at) {
                        var atnv = getAttributeNameValue(node, at);
                        if (atnv) {
                            if (data.attributes[atnv]) data.attributes[atnv]++;
                            else data.attributes[atnv] = 1;
                        }
                    });
                }
                if (current.children.length) {
                    stack.push(currentLevel);
                    currentLevel = current.children.slice();
                }
                while(!currentLevel.length && stack.length)currentLevel = stack.pop();
            };
            while(currentLevel.length)_loop2();
            return data;
        }
        function uncommonClasses(node, selectorData) {
            var retVal = [];
            var classData = selectorData.classes;
            var tagData = selectorData.tags;
            if (node.classList) Array.from(node.classList).forEach(function(cl) {
                var ind = escape_selector_default(cl);
                if (classData[ind] < tagData[node.nodeName]) retVal.push({
                    name: ind,
                    count: classData[ind],
                    species: "class"
                });
            });
            return retVal.sort(countSort);
        }
        function getNthChildString(elm, selector) {
            var siblings = elm.parentNode && Array.from(elm.parentNode.children || "") || [];
            var hasMatchingSiblings = siblings.find(function(sibling) {
                return sibling !== elm && element_matches_default(sibling, selector);
            });
            if (hasMatchingSiblings) {
                var nthChild = 1 + siblings.indexOf(elm);
                return ":nth-child(" + nthChild + ")";
            } else return "";
        }
        function getElmId(elm) {
            if (!elm.getAttribute("id")) return;
            var doc = elm.getRootNode && elm.getRootNode() || document;
            var id = "#" + escape_selector_default(elm.getAttribute("id") || "");
            if (!id.match(/player_uid_/) && doc.querySelectorAll(id).length === 1) return id;
        }
        function getBaseSelector(elm) {
            var xhtml = is_xhtml_default(document);
            return escape_selector_default(xhtml ? elm.localName : elm.nodeName.toLowerCase());
        }
        function uncommonAttributes(node, selectorData) {
            var retVal = [];
            var attData = selectorData.attributes;
            var tagData = selectorData.tags;
            if (node.hasAttributes()) Array.from(get_node_attributes_default(node)).filter(filterAttributes).forEach(function(at) {
                var atnv = getAttributeNameValue(node, at);
                if (atnv && attData[atnv] < tagData[node.nodeName]) retVal.push({
                    name: atnv,
                    count: attData[atnv],
                    species: "attribute"
                });
            });
            return retVal.sort(countSort);
        }
        function getThreeLeastCommonFeatures(elm, selectorData) {
            var selector = "";
            var features;
            var clss = uncommonClasses(elm, selectorData);
            var atts = uncommonAttributes(elm, selectorData);
            if (clss.length && clss[0].count === 1) features = [
                clss[0]
            ];
            else if (atts.length && atts[0].count === 1) {
                features = [
                    atts[0]
                ];
                selector = getBaseSelector(elm);
            } else {
                features = clss.concat(atts);
                features.sort(countSort);
                features = features.slice(0, 3);
                if (!features.some(function(feat) {
                    return feat.species === "class";
                })) selector = getBaseSelector(elm);
                else features.sort(function(a2, b2) {
                    return a2.species !== b2.species && a2.species === "class" ? -1 : a2.species === b2.species ? 0 : 1;
                });
            }
            return selector += features.reduce(function(val, feat) {
                switch(feat.species){
                    case "class":
                        return val + "." + feat.name;
                    case "attribute":
                        return val + "[" + feat.name + "]";
                }
                return val;
            }, "");
        }
        function generateSelector(elm, options, doc) {
            if (!axe._selectorData) throw new Error("Expect axe._selectorData to be set up");
            var _options$toRoot = options.toRoot, toRoot = _options$toRoot === void 0 ? false : _options$toRoot;
            var selector;
            var similar;
            do {
                var features = getElmId(elm);
                if (!features) {
                    features = getThreeLeastCommonFeatures(elm, axe._selectorData);
                    features += getNthChildString(elm, features);
                }
                if (selector) selector = features + " > " + selector;
                else selector = features;
                if (!similar) similar = Array.from(doc.querySelectorAll(selector));
                else similar = similar.filter(function(item) {
                    return element_matches_default(item, selector);
                });
                elm = elm.parentElement;
            }while ((similar.length > 1 || toRoot) && elm && elm.nodeType !== 11);
            if (similar.length === 1) return selector;
            else if (selector.indexOf(" > ") !== -1) return ":root" + selector.substring(selector.indexOf(" > "));
            return ":root";
        }
        function _getSelector(elm, options) {
            return _getShadowSelector(generateSelector, elm, options);
        }
        function generateAncestry(node) {
            var nodeName2 = node.nodeName.toLowerCase();
            var parent = node.parentElement;
            if (!parent) return nodeName2;
            var nthChild = "";
            if (nodeName2 !== "head" && nodeName2 !== "body" && parent.children.length > 1) {
                var index = Array.prototype.indexOf.call(parent.children, node) + 1;
                nthChild = ":nth-child(".concat(index, ")");
            }
            return generateAncestry(parent) + " > " + nodeName2 + nthChild;
        }
        function _getAncestry(elm, options) {
            return _getShadowSelector(generateAncestry, elm, options);
        }
        function getXPathArray(node, path) {
            var sibling, count;
            if (!node) return [];
            if (!path && node.nodeType === 9) {
                path = [
                    {
                        str: "html"
                    }
                ];
                return path;
            }
            path = path || [];
            if (node.parentNode && node.parentNode !== node) path = getXPathArray(node.parentNode, path);
            if (node.previousSibling) {
                count = 1;
                sibling = node.previousSibling;
                do {
                    if (sibling.nodeType === 1 && sibling.nodeName === node.nodeName) count++;
                    sibling = sibling.previousSibling;
                }while (sibling);
                if (count === 1) count = null;
            } else if (node.nextSibling) {
                sibling = node.nextSibling;
                do if (sibling.nodeType === 1 && sibling.nodeName === node.nodeName) {
                    count = 1;
                    sibling = null;
                } else {
                    count = null;
                    sibling = sibling.previousSibling;
                }
                while (sibling);
            }
            if (node.nodeType === 1) {
                var element = {};
                element.str = node.nodeName.toLowerCase();
                var id = node.getAttribute && escape_selector_default(node.getAttribute("id"));
                if (id && node.ownerDocument.querySelectorAll("#" + id).length === 1) element.id = node.getAttribute("id");
                if (count > 1) element.count = count;
                path.push(element);
            }
            return path;
        }
        function xpathToString(xpathArray) {
            return xpathArray.reduce(function(str, elm) {
                if (elm.id) return "/".concat(elm.str, "[@id='").concat(elm.id, "']");
                else return str + "/".concat(elm.str) + (elm.count > 0 ? "[".concat(elm.count, "]") : "");
            }, "");
        }
        function getXpath(node) {
            var xpathArray = getXPathArray(node);
            return xpathToString(xpathArray);
        }
        var get_xpath_default = getXpath;
        var _cache = {};
        var cache = {
            set: function set(key, value) {
                validateKey(key);
                _cache[key] = value;
            },
            get: function get(key, creator) {
                validateCreator(creator);
                if (key in _cache) return _cache[key];
                if (typeof creator === "function") {
                    var value = creator();
                    assert_default(value !== void 0, "Cache creator function should not return undefined");
                    this.set(key, value);
                    return _cache[key];
                }
            },
            clear: function clear() {
                _cache = {};
            }
        };
        function validateKey(key) {
            assert_default(typeof key === "string", "key must be a string, " + _typeof(key) + " given");
            assert_default(key !== "", "key must not be empty");
        }
        function validateCreator(creator) {
            assert_default(typeof creator === "function" || typeof creator === "undefined", "creator must be a function or undefined, " + _typeof(creator) + " given");
        }
        var cache_default = cache;
        function getNodeFromTree(vNode, node) {
            var el = node || vNode;
            return cache_default.get("nodeMap") ? cache_default.get("nodeMap").get(el) : null;
        }
        var get_node_from_tree_default = getNodeFromTree;
        var CACHE_KEY = "DqElm.RunOptions";
        function truncate(str, maxLength) {
            maxLength = maxLength || 300;
            if (str.length > maxLength) {
                var index = str.indexOf(">");
                str = str.substring(0, index + 1);
            }
            return str;
        }
        function getSource(element) {
            if (!(element !== null && element !== void 0 && element.outerHTML)) return "";
            var source = element.outerHTML;
            if (!source && typeof window1.XMLSerializer === "function") source = new window1.XMLSerializer().serializeToString(element);
            return truncate(source || "");
        }
        function DqElement(elm) {
            var _this$spec$selector, _this$_virtualNode;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var spec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (!options) {
                var _cache_default$get;
                options = (_cache_default$get = cache_default.get(CACHE_KEY)) !== null && _cache_default$get !== void 0 ? _cache_default$get : {};
            }
            this.spec = spec;
            if (elm instanceof abstract_virtual_node_default) {
                this._virtualNode = elm;
                this._element = elm.actualNode;
            } else {
                this._element = elm;
                this._virtualNode = get_node_from_tree_default(elm);
            }
            this.fromFrame = ((_this$spec$selector = this.spec.selector) === null || _this$spec$selector === void 0 ? void 0 : _this$spec$selector.length) > 1;
            this._includeElementInJson = options.elementRef;
            if (options.absolutePaths) this._options = {
                toRoot: true
            };
            this.nodeIndexes = [];
            if (Array.isArray(this.spec.nodeIndexes)) this.nodeIndexes = this.spec.nodeIndexes;
            else if (typeof ((_this$_virtualNode = this._virtualNode) === null || _this$_virtualNode === void 0 ? void 0 : _this$_virtualNode.nodeIndex) === "number") this.nodeIndexes = [
                this._virtualNode.nodeIndex
            ];
            this.source = null;
            if (!axe._audit.noHtml) {
                var _this$spec$source;
                this.source = (_this$spec$source = this.spec.source) !== null && _this$spec$source !== void 0 ? _this$spec$source : getSource(this._element);
            }
        }
        DqElement.prototype = {
            get selector () {
                return this.spec.selector || [
                    _getSelector(this.element, this._options)
                ];
            },
            get ancestry () {
                return this.spec.ancestry || [
                    _getAncestry(this.element)
                ];
            },
            get xpath () {
                return this.spec.xpath || [
                    get_xpath_default(this.element)
                ];
            },
            get element () {
                return this._element;
            },
            toJSON: function toJSON() {
                var spec = {
                    selector: this.selector,
                    source: this.source,
                    xpath: this.xpath,
                    ancestry: this.ancestry,
                    nodeIndexes: this.nodeIndexes,
                    fromFrame: this.fromFrame
                };
                if (this._includeElementInJson) spec.element = this._element;
                return spec;
            }
        };
        DqElement.fromFrame = function fromFrame(node, options, frame) {
            var spec = DqElement.mergeSpecs(node, frame);
            return new DqElement(frame.element, options, spec);
        };
        DqElement.mergeSpecs = function mergeSpecs(child, parentFrame) {
            return _extends({}, child, {
                selector: [].concat(_toConsumableArray(parentFrame.selector), _toConsumableArray(child.selector)),
                ancestry: [].concat(_toConsumableArray(parentFrame.ancestry), _toConsumableArray(child.ancestry)),
                xpath: [].concat(_toConsumableArray(parentFrame.xpath), _toConsumableArray(child.xpath)),
                nodeIndexes: [].concat(_toConsumableArray(parentFrame.nodeIndexes), _toConsumableArray(child.nodeIndexes)),
                fromFrame: true
            });
        };
        DqElement.setRunOptions = function setRunOptions(_ref2) {
            var elementRef = _ref2.elementRef, absolutePaths = _ref2.absolutePaths;
            cache_default.set(CACHE_KEY, {
                elementRef: elementRef,
                absolutePaths: absolutePaths
            });
        };
        var dq_element_default = DqElement;
        function checkHelper(checkResult, options, resolve, reject) {
            return {
                isAsync: false,
                async: function async() {
                    this.isAsync = true;
                    return function(result) {
                        if (result instanceof Error === false) {
                            checkResult.result = result;
                            resolve(checkResult);
                        } else reject(result);
                    };
                },
                data: function data(_data) {
                    checkResult.data = _data;
                },
                relatedNodes: function relatedNodes(nodes) {
                    if (!window1.Node) return;
                    if (nodes instanceof window1.Node || nodes instanceof abstract_virtual_node_default) nodes = [
                        nodes
                    ];
                    else nodes = to_array_default(nodes);
                    checkResult.relatedNodes = [];
                    nodes.forEach(function(node) {
                        if (node instanceof abstract_virtual_node_default) node = node.actualNode;
                        if (node instanceof window1.Node) {
                            var dqElm = new dq_element_default(node);
                            checkResult.relatedNodes.push(dqElm);
                        }
                    });
                }
            };
        }
        var check_helper_default = checkHelper;
        function _clone(obj) {
            return cloneRecused(obj, new Map());
        }
        function cloneRecused(obj, seen) {
            var _window, _window2;
            if (obj === null || _typeof(obj) !== "object") return obj;
            if ((_window = window1) !== null && _window !== void 0 && _window.Node && obj instanceof window1.Node || (_window2 = window1) !== null && _window2 !== void 0 && _window2.HTMLCollection && obj instanceof window1.HTMLCollection || "nodeName" in obj && "nodeType" in obj && "ownerDocument" in obj) return obj;
            if (seen.has(obj)) return seen.get(obj);
            if (Array.isArray(obj)) {
                var out2 = [];
                seen.set(obj, out2);
                obj.forEach(function(value) {
                    out2.push(cloneRecused(value, seen));
                });
                return out2;
            }
            var out = {};
            seen.set(obj, out);
            for(var key in obj)out[key] = cloneRecused(obj[key], seen);
            return out;
        }
        var import_css_selector_parser = __toModule(require_lib());
        var parser = new import_css_selector_parser.CssSelectorParser();
        parser.registerSelectorPseudos("not");
        parser.registerSelectorPseudos("is");
        parser.registerNestingOperators(">");
        parser.registerAttrEqualityMods("^", "$", "*", "~");
        var css_parser_default = parser;
        function _matches(vNode, selector) {
            var expressions = _convertSelector(selector);
            return expressions.some(function(expression) {
                return _matchesExpression(vNode, expression);
            });
        }
        function matchesTag(vNode, exp) {
            return vNode.props.nodeType === 1 && (exp.tag === "*" || vNode.props.nodeName === exp.tag);
        }
        function matchesClasses(vNode, exp) {
            return !exp.classes || exp.classes.every(function(cl) {
                return vNode.hasClass(cl.value);
            });
        }
        function matchesAttributes(vNode, exp) {
            return !exp.attributes || exp.attributes.every(function(att) {
                var nodeAtt = vNode.attr(att.key);
                return nodeAtt !== null && att.test(nodeAtt);
            });
        }
        function matchesId(vNode, exp) {
            return !exp.id || vNode.props.id === exp.id;
        }
        function matchesPseudos(target, exp) {
            if (!exp.pseudos || exp.pseudos.every(function(pseudo) {
                if (pseudo.name === "not") return !pseudo.expressions.some(function(expression) {
                    return _matchesExpression(target, expression);
                });
                else if (pseudo.name === "is") return pseudo.expressions.some(function(expression) {
                    return _matchesExpression(target, expression);
                });
                throw new Error("the pseudo selector " + pseudo.name + " has not yet been implemented");
            })) return true;
            return false;
        }
        function matchExpression(vNode, expression) {
            return matchesTag(vNode, expression) && matchesClasses(vNode, expression) && matchesAttributes(vNode, expression) && matchesId(vNode, expression) && matchesPseudos(vNode, expression);
        }
        var escapeRegExp = function() {
            var from = /(?=[\-\[\]{}()*+?.\\\^$|,#\s])/g;
            var to2 = "\\";
            return function(string) {
                return string.replace(from, to2);
            };
        }();
        var reUnescape = /\\/g;
        function convertAttributes(atts) {
            if (!atts) return;
            return atts.map(function(att) {
                var attributeKey = att.name.replace(reUnescape, "");
                var attributeValue = (att.value || "").replace(reUnescape, "");
                var test, regexp;
                switch(att.operator){
                    case "^=":
                        regexp = new RegExp("^" + escapeRegExp(attributeValue));
                        break;
                    case "$=":
                        regexp = new RegExp(escapeRegExp(attributeValue) + "$");
                        break;
                    case "~=":
                        regexp = new RegExp("(^|\\s)" + escapeRegExp(attributeValue) + "(\\s|$)");
                        break;
                    case "|=":
                        regexp = new RegExp("^" + escapeRegExp(attributeValue) + "(-|$)");
                        break;
                    case "=":
                        test = function test(value) {
                            return attributeValue === value;
                        };
                        break;
                    case "*=":
                        test = function test(value) {
                            return value && value.includes(attributeValue);
                        };
                        break;
                    case "!=":
                        test = function test(value) {
                            return attributeValue !== value;
                        };
                        break;
                    default:
                        test = function test(value) {
                            return value !== null;
                        };
                }
                if (attributeValue === "" && /^[*$^]=$/.test(att.operator)) test = function test() {
                    return false;
                };
                if (!test) test = function test(value) {
                    return value && regexp.test(value);
                };
                return {
                    key: attributeKey,
                    value: attributeValue,
                    type: typeof att.value === "undefined" ? "attrExist" : "attrValue",
                    test: test
                };
            });
        }
        function convertClasses(classes) {
            if (!classes) return;
            return classes.map(function(className) {
                className = className.replace(reUnescape, "");
                return {
                    value: className,
                    regexp: new RegExp("(^|\\s)" + escapeRegExp(className) + "(\\s|$)")
                };
            });
        }
        function convertPseudos(pseudos) {
            if (!pseudos) return;
            return pseudos.map(function(p2) {
                var expressions;
                if ([
                    "is",
                    "not"
                ].includes(p2.name)) {
                    expressions = p2.value;
                    expressions = expressions.selectors ? expressions.selectors : [
                        expressions
                    ];
                    expressions = convertExpressions(expressions);
                }
                return {
                    name: p2.name,
                    expressions: expressions,
                    value: p2.value
                };
            });
        }
        function convertExpressions(expressions) {
            return expressions.map(function(exp) {
                var newExp = [];
                var rule = exp.rule;
                while(rule){
                    newExp.push({
                        tag: rule.tagName ? rule.tagName.toLowerCase() : "*",
                        combinator: rule.nestingOperator ? rule.nestingOperator : " ",
                        id: rule.id,
                        attributes: convertAttributes(rule.attrs),
                        classes: convertClasses(rule.classNames),
                        pseudos: convertPseudos(rule.pseudos)
                    });
                    rule = rule.rule;
                }
                return newExp;
            });
        }
        function _convertSelector(selector) {
            var expressions = css_parser_default.parse(selector);
            expressions = expressions.selectors ? expressions.selectors : [
                expressions
            ];
            return convertExpressions(expressions);
        }
        function optimizedMatchesExpression(vNode, expressions, index, matchAnyParent) {
            if (!vNode) return false;
            var isArray = Array.isArray(expressions);
            var expression = isArray ? expressions[index] : expressions;
            var machedExpression = matchExpression(vNode, expression);
            while(!machedExpression && matchAnyParent && vNode.parent){
                vNode = vNode.parent;
                machedExpression = matchExpression(vNode, expression);
            }
            if (index > 0) {
                if ([
                    " ",
                    ">"
                ].includes(expression.combinator) === false) throw new Error("axe.utils.matchesExpression does not support the combinator: " + expression.combinator);
                machedExpression = machedExpression && optimizedMatchesExpression(vNode.parent, expressions, index - 1, expression.combinator === " ");
            }
            return machedExpression;
        }
        function _matchesExpression(vNode, expressions, matchAnyParent) {
            return optimizedMatchesExpression(vNode, expressions, expressions.length - 1, matchAnyParent);
        }
        function closest(vNode, selector) {
            while(vNode){
                if (_matches(vNode, selector)) return vNode;
                if (typeof vNode.parent === "undefined") throw new TypeError("Cannot resolve parent for non-DOM nodes");
                vNode = vNode.parent;
            }
            return null;
        }
        var closest_default = closest;
        function noop() {}
        function funcGuard(f) {
            if (typeof f !== "function") throw new TypeError("Queue methods require functions as arguments");
        }
        function queue() {
            var tasks = [];
            var started = 0;
            var remaining = 0;
            var completeQueue = noop;
            var complete = false;
            var err2;
            var defaultFail = function defaultFail(e) {
                err2 = e;
                setTimeout(function() {
                    if (err2 !== void 0 && err2 !== null) log_default("Uncaught error (of queue)", err2);
                }, 1);
            };
            var failed = defaultFail;
            function createResolve(i) {
                return function(r) {
                    tasks[i] = r;
                    remaining -= 1;
                    if (!remaining && completeQueue !== noop) {
                        complete = true;
                        completeQueue(tasks);
                    }
                };
            }
            function abort(msg) {
                completeQueue = noop;
                failed(msg);
                return tasks;
            }
            function pop() {
                var length = tasks.length;
                for(; started < length; started++){
                    var task = tasks[started];
                    try {
                        task.call(null, createResolve(started), abort);
                    } catch (e) {
                        abort(e);
                    }
                }
            }
            var q = {
                defer: function defer(fn) {
                    if (_typeof(fn) === "object" && fn.then && fn["catch"]) {
                        var defer = fn;
                        fn = function fn(resolve, reject) {
                            defer.then(resolve)["catch"](reject);
                        };
                    }
                    funcGuard(fn);
                    if (err2 !== void 0) return;
                    else if (complete) throw new Error("Queue already completed");
                    tasks.push(fn);
                    ++remaining;
                    pop();
                    return q;
                },
                then: function then(fn) {
                    funcGuard(fn);
                    if (completeQueue !== noop) throw new Error("queue `then` already set");
                    if (!err2) {
                        completeQueue = fn;
                        if (!remaining) {
                            complete = true;
                            completeQueue(tasks);
                        }
                    }
                    return q;
                },
                catch: function _catch(fn) {
                    funcGuard(fn);
                    if (failed !== defaultFail) throw new Error("queue `catch` already set");
                    if (!err2) failed = fn;
                    else {
                        fn(err2);
                        err2 = null;
                    }
                    return q;
                },
                abort: abort
            };
            return q;
        }
        var queue_default = queue;
        var uuid;
        var _rng;
        var _crypto = window1.crypto || window1.msCrypto;
        if (!_rng && _crypto && _crypto.getRandomValues) {
            _rnds8 = new Uint8Array(16);
            _rng = function whatwgRNG() {
                _crypto.getRandomValues(_rnds8);
                return _rnds8;
            };
        }
        var _rnds8;
        if (!_rng) {
            _rnds = new Array(16);
            _rng = function _rng() {
                for(var i = 0, r; i < 16; i++){
                    if ((i & 3) === 0) r = Math.random() * 4294967296;
                    _rnds[i] = r >>> ((i & 3) << 3) & 255;
                }
                return _rnds;
            };
        }
        var _rnds;
        var BufferClass = typeof window1.Buffer == "function" ? window1.Buffer : Array;
        var _byteToHex = [];
        var _hexToByte = {};
        for(var i = 0; i < 256; i++){
            _byteToHex[i] = (i + 256).toString(16).substr(1);
            _hexToByte[_byteToHex[i]] = i;
        }
        function parse(s, buf, offset) {
            var i = buf && offset || 0, ii = 0;
            buf = buf || [];
            s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
                if (ii < 16) buf[i + ii++] = _hexToByte[oct];
            });
            while(ii < 16)buf[i + ii++] = 0;
            return buf;
        }
        function unparse(buf, offset) {
            var i = offset || 0, bth = _byteToHex;
            return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
        }
        var _seedBytes = _rng();
        var _nodeId = [
            _seedBytes[0] | 1,
            _seedBytes[1],
            _seedBytes[2],
            _seedBytes[3],
            _seedBytes[4],
            _seedBytes[5]
        ];
        var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 16383;
        var _lastMSecs = 0;
        var _lastNSecs = 0;
        function v1(options, buf, offset) {
            var i = buf && offset || 0;
            var b2 = buf || [];
            options = options || {};
            var clockseq = options.clockseq != null ? options.clockseq : _clockseq;
            var msecs = options.msecs != null ? options.msecs : new Date().getTime();
            var nsecs = options.nsecs != null ? options.nsecs : _lastNSecs + 1;
            var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
            if (dt < 0 && options.clockseq == null) clockseq = clockseq + 1 & 16383;
            if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) nsecs = 0;
            if (nsecs >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
            _lastMSecs = msecs;
            _lastNSecs = nsecs;
            _clockseq = clockseq;
            msecs += 122192928e5;
            var tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
            b2[i++] = tl >>> 24 & 255;
            b2[i++] = tl >>> 16 & 255;
            b2[i++] = tl >>> 8 & 255;
            b2[i++] = tl & 255;
            var tmh = msecs / 4294967296 * 1e4 & 268435455;
            b2[i++] = tmh >>> 8 & 255;
            b2[i++] = tmh & 255;
            b2[i++] = tmh >>> 24 & 15 | 16;
            b2[i++] = tmh >>> 16 & 255;
            b2[i++] = clockseq >>> 8 | 128;
            b2[i++] = clockseq & 255;
            var node = options.node || _nodeId;
            for(var n2 = 0; n2 < 6; n2++)b2[i + n2] = node[n2];
            return buf ? buf : unparse(b2);
        }
        function v4(options, buf, offset) {
            var i = buf && offset || 0;
            if (typeof options == "string") {
                buf = options == "binary" ? new BufferClass(16) : null;
                options = null;
            }
            options = options || {};
            var rnds = options.random || (options.rng || _rng)();
            rnds[6] = rnds[6] & 15 | 64;
            rnds[8] = rnds[8] & 63 | 128;
            if (buf) for(var ii = 0; ii < 16; ii++)buf[i + ii] = rnds[ii];
            return buf || unparse(rnds);
        }
        uuid = v4;
        uuid.v1 = v1;
        uuid.v4 = v4;
        uuid.parse = parse;
        uuid.unparse = unparse;
        uuid.BufferClass = BufferClass;
        axe._uuid = v1();
        var uuid_default = v4;
        var errorTypes = Object.freeze([
            "EvalError",
            "RangeError",
            "ReferenceError",
            "SyntaxError",
            "TypeError",
            "URIError"
        ]);
        function stringifyMessage(_ref3) {
            var topic = _ref3.topic, channelId = _ref3.channelId, message = _ref3.message, messageId = _ref3.messageId, keepalive = _ref3.keepalive;
            var data = {
                channelId: channelId,
                topic: topic,
                messageId: messageId,
                keepalive: !!keepalive,
                source: getSource2()
            };
            if (message instanceof Error) data.error = {
                name: message.name,
                message: message.message,
                stack: message.stack
            };
            else data.payload = message;
            return JSON.stringify(data);
        }
        function parseMessage(dataString) {
            var data;
            try {
                data = JSON.parse(dataString);
            } catch (e) {
                return;
            }
            if (!isRespondableMessage(data)) return;
            var _data2 = data, topic = _data2.topic, channelId = _data2.channelId, messageId = _data2.messageId, keepalive = _data2.keepalive;
            var message = _typeof(data.error) === "object" ? buildErrorObject(data.error) : data.payload;
            return {
                topic: topic,
                message: message,
                messageId: messageId,
                channelId: channelId,
                keepalive: !!keepalive
            };
        }
        function isRespondableMessage(postedMessage) {
            return postedMessage !== null && _typeof(postedMessage) === "object" && typeof postedMessage.channelId === "string" && postedMessage.source === getSource2();
        }
        function buildErrorObject(error) {
            var msg = error.message || "Unknown error occurred";
            var errorName = errorTypes.includes(error.name) ? error.name : "Error";
            var ErrConstructor = window1[errorName] || Error;
            if (error.stack) msg += "\n" + error.stack.replace(error.message, "");
            return new ErrConstructor(msg);
        }
        function getSource2() {
            var application = "axeAPI";
            var version = "";
            if (typeof axe !== "undefined" && axe._audit && axe._audit.application) application = axe._audit.application;
            if (typeof axe !== "undefined") version = axe.version;
            return application + "." + version;
        }
        function assertIsParentWindow(win) {
            assetNotGlobalWindow(win);
            assert_default(window1.parent === win, "Source of the response must be the parent window.");
        }
        function assertIsFrameWindow(win) {
            assetNotGlobalWindow(win);
            assert_default(win.parent === window1, "Respondable target must be a frame in the current window");
        }
        function assetNotGlobalWindow(win) {
            assert_default(window1 !== win, "Messages can not be sent to the same window.");
        }
        var channels = {};
        function storeReplyHandler(channelId, replyHandler) {
            var sendToParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            assert_default(!channels[channelId], "A replyHandler already exists for this message channel.");
            channels[channelId] = {
                replyHandler: replyHandler,
                sendToParent: sendToParent
            };
        }
        function getReplyHandler(channelId) {
            return channels[channelId];
        }
        function deleteReplyHandler(channelId) {
            delete channels[channelId];
        }
        var messageIds = [];
        function createMessageId() {
            var uuid2 = "".concat(v4(), ":").concat(v4());
            if (messageIds.includes(uuid2)) return createMessageId();
            messageIds.push(uuid2);
            return uuid2;
        }
        function isNewMessage(uuid2) {
            if (messageIds.includes(uuid2)) return false;
            messageIds.push(uuid2);
            return true;
        }
        function postMessage(win, data, sendToParent, replyHandler) {
            sendToParent ? assertIsParentWindow(win) : assertIsFrameWindow(win);
            if (data.message instanceof Error && !sendToParent) {
                axe.log(data.message);
                return false;
            }
            var dataString = stringifyMessage(_extends({
                messageId: createMessageId()
            }, data));
            var allowedOrigins = axe._audit.allowedOrigins;
            if (!allowedOrigins || !allowedOrigins.length) return false;
            if (typeof replyHandler === "function") storeReplyHandler(data.channelId, replyHandler, sendToParent);
            allowedOrigins.forEach(function(origin) {
                try {
                    win.postMessage(dataString, origin);
                } catch (err2) {
                    if (err2 instanceof win.DOMException) throw new Error('allowedOrigins value "'.concat(origin, '" is not a valid origin'));
                    throw err2;
                }
            });
            return true;
        }
        function processError(win, error, channelId) {
            if (!win.parent !== window1) return axe.log(error);
            try {
                postMessage(win, {
                    topic: null,
                    channelId: channelId,
                    message: error,
                    messageId: createMessageId(),
                    keepalive: true
                }, true);
            } catch (err2) {
                return axe.log(err2);
            }
        }
        function createResponder(win, channelId) {
            var sendToParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            return function respond(message, keepalive, replyHandler) {
                var data = {
                    channelId: channelId,
                    message: message,
                    keepalive: keepalive
                };
                postMessage(win, data, sendToParent, replyHandler);
            };
        }
        function originIsAllowed(origin) {
            var allowedOrigins = axe._audit.allowedOrigins;
            return allowedOrigins && allowedOrigins.includes("*") || allowedOrigins.includes(origin);
        }
        function messageHandler(_ref4, topicHandler) {
            var origin = _ref4.origin, dataString = _ref4.data, win = _ref4.source;
            try {
                var data = parseMessage(dataString) || {};
                var channelId = data.channelId, message = data.message, messageId = data.messageId;
                if (!originIsAllowed(origin) || !isNewMessage(messageId)) return;
                if (message instanceof Error && win.parent !== window1) {
                    axe.log(message);
                    return false;
                }
                try {
                    if (data.topic) {
                        var responder = createResponder(win, channelId);
                        assertIsParentWindow(win);
                        topicHandler(data, responder);
                    } else callReplyHandler(win, data);
                } catch (error) {
                    processError(win, error, channelId);
                }
            } catch (error) {
                axe.log(error);
                return false;
            }
        }
        function callReplyHandler(win, data) {
            var channelId = data.channelId, message = data.message, keepalive = data.keepalive;
            var _ref5 = getReplyHandler(channelId) || {}, replyHandler = _ref5.replyHandler, sendToParent = _ref5.sendToParent;
            if (!replyHandler) return;
            sendToParent ? assertIsParentWindow(win) : assertIsFrameWindow(win);
            var responder = createResponder(win, channelId, sendToParent);
            if (!keepalive && channelId) deleteReplyHandler(channelId);
            try {
                replyHandler(message, keepalive, responder);
            } catch (error) {
                axe.log(error);
                responder(error, keepalive);
            }
        }
        var frameMessenger = {
            open: function open(topicHandler) {
                if (typeof window1.addEventListener !== "function") return;
                var handler = function handler(messageEvent) {
                    messageHandler(messageEvent, topicHandler);
                };
                window1.addEventListener("message", handler, false);
                return function() {
                    window1.removeEventListener("message", handler, false);
                };
            },
            post: function post(win, data, replyHandler) {
                if (typeof window1.addEventListener !== "function") return false;
                return postMessage(win, data, false, replyHandler);
            }
        };
        function setDefaultFrameMessenger(respondable2) {
            respondable2.updateMessenger(frameMessenger);
        }
        var closeHandler;
        var postMessage2;
        var topicHandlers = {};
        function _respondable(win, topic, message, keepalive, replyHandler) {
            var data = {
                topic: topic,
                message: message,
                channelId: "".concat(v4(), ":").concat(v4()),
                keepalive: keepalive
            };
            return postMessage2(win, data, replyHandler);
        }
        function messageListener(data, responder) {
            var topic = data.topic, message = data.message, keepalive = data.keepalive;
            var topicHandler = topicHandlers[topic];
            if (!topicHandler) return;
            try {
                topicHandler(message, keepalive, responder);
            } catch (error) {
                axe.log(error);
                responder(error, keepalive);
            }
        }
        _respondable.updateMessenger = function updateMessenger(_ref6) {
            var open = _ref6.open, post = _ref6.post;
            assert_default(typeof open === "function", "open callback must be a function");
            assert_default(typeof post === "function", "post callback must be a function");
            if (closeHandler) closeHandler();
            var close = open(messageListener);
            if (close) {
                assert_default(typeof close === "function", "open callback must return a cleanup function");
                closeHandler = close;
            } else closeHandler = null;
            postMessage2 = post;
        };
        _respondable.subscribe = function subscribe(topic, topicHandler) {
            assert_default(typeof topicHandler === "function", "Subscriber callback must be a function");
            assert_default(!topicHandlers[topic], "Topic ".concat(topic, " is already registered to."));
            topicHandlers[topic] = topicHandler;
        };
        _respondable.isInFrame = function isInFrame() {
            var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window1;
            return !!win.frameElement;
        };
        setDefaultFrameMessenger(_respondable);
        function _sendCommandToFrame(node, parameters, resolve, reject) {
            var _parameters$options$p, _parameters$options;
            var win = node.contentWindow;
            var pingWaitTime = (_parameters$options$p = (_parameters$options = parameters.options) === null || _parameters$options === void 0 ? void 0 : _parameters$options.pingWaitTime) !== null && _parameters$options$p !== void 0 ? _parameters$options$p : 500;
            if (!win) {
                log_default("Frame does not have a content window", node);
                resolve(null);
                return;
            }
            if (pingWaitTime === 0) {
                callAxeStart(node, parameters, resolve, reject);
                return;
            }
            var timeout = setTimeout(function() {
                timeout = setTimeout(function() {
                    if (!parameters.debug) resolve(null);
                    else reject(err("No response from frame", node));
                }, 0);
            }, pingWaitTime);
            _respondable(win, "axe.ping", null, void 0, function() {
                clearTimeout(timeout);
                callAxeStart(node, parameters, resolve, reject);
            });
        }
        function callAxeStart(node, parameters, resolve, reject) {
            var _parameters$options$f, _parameters$options2;
            var frameWaitTime = (_parameters$options$f = (_parameters$options2 = parameters.options) === null || _parameters$options2 === void 0 ? void 0 : _parameters$options2.frameWaitTime) !== null && _parameters$options$f !== void 0 ? _parameters$options$f : 6e4;
            var win = node.contentWindow;
            var timeout = setTimeout(function collectResultFramesTimeout() {
                reject(err("Axe in frame timed out", node));
            }, frameWaitTime);
            _respondable(win, "axe.start", parameters, void 0, function(data) {
                clearTimeout(timeout);
                if (data instanceof Error === false) resolve(data);
                else reject(data);
            });
        }
        function err(message, node) {
            var selector;
            if (axe._tree) selector = _getSelector(node);
            return new Error(message + ": " + (selector || node));
        }
        var customSerializer = null;
        var nodeSerializer = {
            update: function update(serializer) {
                assert_default(_typeof(serializer) === "object", "serializer must be an object");
                customSerializer = serializer;
            },
            toSpec: function toSpec(node) {
                return nodeSerializer.dqElmToSpec(new dq_element_default(node));
            },
            dqElmToSpec: function dqElmToSpec(dqElm, runOptions) {
                var _customSerializer;
                if (dqElm instanceof dq_element_default === false) return dqElm;
                if (runOptions) dqElm = cloneLimitedDqElement(dqElm, runOptions);
                if (typeof ((_customSerializer = customSerializer) === null || _customSerializer === void 0 ? void 0 : _customSerializer.toSpec) === "function") return customSerializer.toSpec(dqElm);
                return dqElm.toJSON();
            },
            mergeSpecs: function mergeSpecs(nodeSpec, parentFrameSpec) {
                var _customSerializer2;
                if (typeof ((_customSerializer2 = customSerializer) === null || _customSerializer2 === void 0 ? void 0 : _customSerializer2.mergeSpecs) === "function") return customSerializer.mergeSpecs(nodeSpec, parentFrameSpec);
                return dq_element_default.mergeSpecs(nodeSpec, parentFrameSpec);
            },
            mapRawResults: function mapRawResults(rawResults) {
                return rawResults.map(function(rawResult) {
                    return _extends({}, rawResult, {
                        nodes: nodeSerializer.mapRawNodeResults(rawResult.nodes)
                    });
                });
            },
            mapRawNodeResults: function mapRawNodeResults(nodeResults) {
                return nodeResults === null || nodeResults === void 0 ? void 0 : nodeResults.map(function(_ref7) {
                    var node = _ref7.node, nodeResult = _objectWithoutProperties(_ref7, _excluded);
                    nodeResult.node = nodeSerializer.dqElmToSpec(node);
                    for(var _i2 = 0, _arr2 = [
                        "any",
                        "all",
                        "none"
                    ]; _i2 < _arr2.length; _i2++){
                        var type2 = _arr2[_i2];
                        nodeResult[type2] = nodeResult[type2].map(function(_ref8) {
                            var relatedNodes = _ref8.relatedNodes, checkResult = _objectWithoutProperties(_ref8, _excluded2);
                            checkResult.relatedNodes = relatedNodes.map(nodeSerializer.dqElmToSpec);
                            return checkResult;
                        });
                    }
                    return nodeResult;
                });
            }
        };
        var node_serializer_default = nodeSerializer;
        function cloneLimitedDqElement(dqElm, runOptions) {
            var fromFrame2 = dqElm.fromFrame;
            var hasAncestry = runOptions.ancestry, hasXpath = runOptions.xpath;
            var hasSelectors = runOptions.selectors !== false || fromFrame2;
            dqElm = new dq_element_default(dqElm.element, runOptions, {
                source: dqElm.source,
                nodeIndexes: dqElm.nodeIndexes,
                selector: hasSelectors ? dqElm.selector : [
                    ":root"
                ],
                ancestry: hasAncestry ? dqElm.ancestry : [
                    ":root"
                ],
                xpath: hasXpath ? dqElm.xpath : "/"
            });
            dqElm.fromFrame = fromFrame2;
            return dqElm;
        }
        function getAllChecks(object) {
            var result = [];
            return result.concat(object.any || []).concat(object.all || []).concat(object.none || []);
        }
        var get_all_checks_default = getAllChecks;
        function findBy(array, key, value) {
            if (Array.isArray(array)) return array.find(function(obj) {
                return obj !== null && _typeof(obj) === "object" && Object.hasOwn(obj, key) && obj[key] === value;
            });
        }
        var find_by_default = findBy;
        function pushFrame(resultSet, options, frameSpec) {
            resultSet.forEach(function(res) {
                res.node = node_serializer_default.mergeSpecs(res.node, frameSpec);
                var checks = get_all_checks_default(res);
                checks.forEach(function(check) {
                    check.relatedNodes = check.relatedNodes.map(function(node) {
                        return node_serializer_default.mergeSpecs(node, frameSpec);
                    });
                });
            });
        }
        function spliceNodes(target, to2) {
            var firstFromFrame = to2[0].node;
            for(var _i3 = 0; _i3 < target.length; _i3++){
                var node = target[_i3].node;
                var resultSort = nodeIndexSort(node.nodeIndexes, firstFromFrame.nodeIndexes);
                if (resultSort > 0 || resultSort === 0 && firstFromFrame.selector.length < node.selector.length) {
                    target.splice.apply(target, [
                        _i3,
                        0
                    ].concat(_toConsumableArray(to2)));
                    return;
                }
            }
            target.push.apply(target, _toConsumableArray(to2));
        }
        function normalizeResult(result) {
            if (!result || !result.results) return null;
            if (!Array.isArray(result.results)) return [
                result.results
            ];
            if (!result.results.length) return null;
            return result.results;
        }
        function mergeResults(frameResults, options) {
            var mergedResult = [];
            frameResults.forEach(function(frameResult) {
                var results = normalizeResult(frameResult);
                if (!results || !results.length) return;
                var frameSpec = getFrameSpec(frameResult);
                results.forEach(function(ruleResult) {
                    if (ruleResult.nodes && frameSpec) pushFrame(ruleResult.nodes, options, frameSpec);
                    var res = find_by_default(mergedResult, "id", ruleResult.id);
                    if (!res) mergedResult.push(ruleResult);
                    else if (ruleResult.nodes.length) spliceNodes(res.nodes, ruleResult.nodes);
                });
            });
            mergedResult.forEach(function(result) {
                if (result.nodes) result.nodes.sort(function(nodeA, nodeB) {
                    return nodeIndexSort(nodeA.node.nodeIndexes, nodeB.node.nodeIndexes);
                });
            });
            return mergedResult;
        }
        function nodeIndexSort() {
            var nodeIndexesA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var nodeIndexesB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var length = Math.max(nodeIndexesA === null || nodeIndexesA === void 0 ? void 0 : nodeIndexesA.length, nodeIndexesB === null || nodeIndexesB === void 0 ? void 0 : nodeIndexesB.length);
            for(var _i4 = 0; _i4 < length; _i4++){
                var indexA = nodeIndexesA === null || nodeIndexesA === void 0 ? void 0 : nodeIndexesA[_i4];
                var indexB = nodeIndexesB === null || nodeIndexesB === void 0 ? void 0 : nodeIndexesB[_i4];
                if (typeof indexA !== "number" || isNaN(indexA)) return _i4 === 0 ? 1 : -1;
                if (typeof indexB !== "number" || isNaN(indexB)) return _i4 === 0 ? -1 : 1;
                if (indexA !== indexB) return indexA - indexB;
            }
            return 0;
        }
        var merge_results_default = mergeResults;
        function getFrameSpec(frameResult) {
            if (frameResult.frameElement) return node_serializer_default.toSpec(frameResult.frameElement);
            else if (frameResult.frameSpec) return frameResult.frameSpec;
            return null;
        }
        function _collectResultsFromFrames(parentContent, options, command, parameter, resolve, reject) {
            options = _extends({}, options, {
                elementRef: false
            });
            var q = queue_default();
            var frames = parentContent.frames;
            frames.forEach(function(_ref9) {
                var frameElement = _ref9.node, context = _objectWithoutProperties(_ref9, _excluded3);
                q.defer(function(res, rej) {
                    var params = {
                        options: options,
                        command: command,
                        parameter: parameter,
                        context: context
                    };
                    function callback(results) {
                        if (!results) return res(null);
                        return res({
                            results: results,
                            frameElement: frameElement
                        });
                    }
                    _sendCommandToFrame(frameElement, params, callback, rej);
                });
            });
            q.then(function(data) {
                resolve(merge_results_default(data, options));
            })["catch"](reject);
        }
        function _contains(vNode, otherVNode) {
            if (!vNode.shadowId && !otherVNode.shadowId && vNode.actualNode && typeof vNode.actualNode.contains === "function") return vNode.actualNode.contains(otherVNode.actualNode);
            do {
                if (vNode === otherVNode) return true;
                else if (otherVNode.nodeIndex < vNode.nodeIndex) return false;
                otherVNode = otherVNode.parent;
            }while (otherVNode);
            return false;
        }
        function deepMerge() {
            var target = {};
            for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
            sources.forEach(function(source) {
                if (!source || _typeof(source) !== "object" || Array.isArray(source)) return;
                for(var _i5 = 0, _Object$keys = Object.keys(source); _i5 < _Object$keys.length; _i5++){
                    var key = _Object$keys[_i5];
                    if (!target.hasOwnProperty(key) || _typeof(source[key]) !== "object" || Array.isArray(target[key])) target[key] = source[key];
                    else target[key] = deepMerge(target[key], source[key]);
                }
            });
            return target;
        }
        var deep_merge_default = deepMerge;
        function extendMetaData(to2, from) {
            Object.assign(to2, from);
            Object.keys(from).filter(function(prop) {
                return typeof from[prop] === "function";
            }).forEach(function(prop) {
                to2[prop] = null;
                try {
                    to2[prop] = from[prop](to2);
                } catch (e) {}
            });
        }
        var extend_meta_data_default = extendMetaData;
        var possibleShadowRoots = [
            "article",
            "aside",
            "blockquote",
            "body",
            "div",
            "footer",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "main",
            "nav",
            "p",
            "section",
            "span"
        ];
        function isShadowRoot(node) {
            if (node.shadowRoot) {
                var nodeName2 = node.nodeName.toLowerCase();
                if (possibleShadowRoots.includes(nodeName2) || /^[a-z][a-z0-9_.-]*-[a-z0-9_.-]*$/.test(nodeName2)) return true;
            }
            return false;
        }
        var is_shadow_root_default = isShadowRoot;
        var dom_exports = {};
        __export(dom_exports, {
            createGrid: function createGrid() {
                return _createGrid;
            },
            findElmsInContext: function findElmsInContext() {
                return find_elms_in_context_default;
            },
            findNearbyElms: function findNearbyElms() {
                return _findNearbyElms;
            },
            findUp: function findUp() {
                return find_up_default;
            },
            findUpVirtual: function findUpVirtual() {
                return find_up_virtual_default;
            },
            focusDisabled: function focusDisabled() {
                return focus_disabled_default;
            },
            getComposedParent: function getComposedParent() {
                return get_composed_parent_default;
            },
            getElementByReference: function getElementByReference() {
                return get_element_by_reference_default;
            },
            getElementCoordinates: function getElementCoordinates() {
                return get_element_coordinates_default;
            },
            getElementStack: function getElementStack() {
                return get_element_stack_default;
            },
            getModalDialog: function getModalDialog() {
                return get_modal_dialog_default;
            },
            getOverflowHiddenAncestors: function getOverflowHiddenAncestors() {
                return get_overflow_hidden_ancestors_default;
            },
            getRootNode: function getRootNode() {
                return get_root_node_default2;
            },
            getScrollOffset: function getScrollOffset() {
                return get_scroll_offset_default;
            },
            getTabbableElements: function getTabbableElements() {
                return get_tabbable_elements_default;
            },
            getTargetRects: function getTargetRects() {
                return get_target_rects_default;
            },
            getTargetSize: function getTargetSize() {
                return get_target_size_default;
            },
            getTextElementStack: function getTextElementStack() {
                return get_text_element_stack_default;
            },
            getViewportSize: function getViewportSize() {
                return get_viewport_size_default;
            },
            getVisibleChildTextRects: function getVisibleChildTextRects() {
                return get_visible_child_text_rects_default;
            },
            hasContent: function hasContent() {
                return has_content_default;
            },
            hasContentVirtual: function hasContentVirtual() {
                return has_content_virtual_default;
            },
            hasLangText: function hasLangText() {
                return _hasLangText;
            },
            idrefs: function idrefs() {
                return idrefs_default;
            },
            insertedIntoFocusOrder: function insertedIntoFocusOrder() {
                return inserted_into_focus_order_default;
            },
            isCurrentPageLink: function isCurrentPageLink() {
                return _isCurrentPageLink;
            },
            isFocusable: function isFocusable() {
                return _isFocusable;
            },
            isHTML5: function isHTML5() {
                return is_html5_default;
            },
            isHiddenForEveryone: function isHiddenForEveryone() {
                return _isHiddenForEveryone;
            },
            isHiddenWithCSS: function isHiddenWithCSS() {
                return is_hidden_with_css_default;
            },
            isInTabOrder: function isInTabOrder() {
                return _isInTabOrder;
            },
            isInTextBlock: function isInTextBlock() {
                return is_in_text_block_default;
            },
            isInert: function isInert() {
                return _isInert;
            },
            isModalOpen: function isModalOpen() {
                return is_modal_open_default;
            },
            isMultiline: function isMultiline() {
                return _isMultiline;
            },
            isNativelyFocusable: function isNativelyFocusable() {
                return is_natively_focusable_default;
            },
            isNode: function isNode() {
                return is_node_default;
            },
            isOffscreen: function isOffscreen() {
                return is_offscreen_default;
            },
            isOpaque: function isOpaque() {
                return is_opaque_default;
            },
            isSkipLink: function isSkipLink() {
                return _isSkipLink;
            },
            isVisible: function isVisible() {
                return is_visible_default;
            },
            isVisibleOnScreen: function isVisibleOnScreen() {
                return _isVisibleOnScreen;
            },
            isVisibleToScreenReaders: function isVisibleToScreenReaders() {
                return _isVisibleToScreenReaders;
            },
            isVisualContent: function isVisualContent() {
                return is_visual_content_default;
            },
            reduceToElementsBelowFloating: function reduceToElementsBelowFloating() {
                return reduce_to_elements_below_floating_default;
            },
            shadowElementsFromPoint: function shadowElementsFromPoint() {
                return shadow_elements_from_point_default;
            },
            urlPropsFromAttribute: function urlPropsFromAttribute() {
                return url_props_from_attribute_default;
            },
            visuallyContains: function visuallyContains() {
                return _visuallyContains;
            },
            visuallyOverlaps: function visuallyOverlaps() {
                return visually_overlaps_default;
            },
            visuallySort: function visuallySort() {
                return _visuallySort;
            }
        });
        function getRootNode(node) {
            var doc = node.getRootNode && node.getRootNode() || document;
            if (doc === node) doc = document;
            return doc;
        }
        var get_root_node_default = getRootNode;
        var get_root_node_default2 = get_root_node_default;
        function findElmsInContext(_ref10) {
            var context = _ref10.context, value = _ref10.value, attr = _ref10.attr, _ref10$elm = _ref10.elm, elm = _ref10$elm === void 0 ? "" : _ref10$elm;
            var root;
            var escapedValue = escape_selector_default(value);
            if (context.nodeType === 9 || context.nodeType === 11) root = context;
            else root = get_root_node_default2(context);
            return Array.from(root.querySelectorAll(elm + "[" + attr + "=" + escapedValue + "]"));
        }
        var find_elms_in_context_default = findElmsInContext;
        function findUpVirtual(element, target) {
            var parent;
            parent = element.actualNode;
            if (!element.shadowId && typeof element.actualNode.closest === "function") {
                var match = element.actualNode.closest(target);
                if (match) return match;
                return null;
            }
            do {
                parent = parent.assignedSlot ? parent.assignedSlot : parent.parentNode;
                if (parent && parent.nodeType === 11) parent = parent.host;
            }while (parent && !element_matches_default(parent, target) && parent !== document.documentElement);
            if (!parent) return null;
            if (!element_matches_default(parent, target)) return null;
            return parent;
        }
        var find_up_virtual_default = findUpVirtual;
        function findUp(element, target) {
            return find_up_virtual_default(get_node_from_tree_default(element), target);
        }
        var find_up_default = findUp;
        function _rectsOverlap(rect1, rect2) {
            return (rect1.left | 0) < (rect2.right | 0) && (rect1.right | 0) > (rect2.left | 0) && (rect1.top | 0) < (rect2.bottom | 0) && (rect1.bottom | 0) > (rect2.top | 0);
        }
        var getOverflowHiddenAncestors = memoize_default(function getOverflowHiddenAncestorsMemoized(vNode) {
            var ancestors = [];
            if (!vNode) return ancestors;
            var overflow = vNode.getComputedStylePropertyValue("overflow");
            if (overflow === "hidden") ancestors.push(vNode);
            return ancestors.concat(getOverflowHiddenAncestors(vNode.parent));
        });
        var get_overflow_hidden_ancestors_default = getOverflowHiddenAncestors;
        var clipRegex = /rect\s*\(([0-9]+)px,?\s*([0-9]+)px,?\s*([0-9]+)px,?\s*([0-9]+)px\s*\)/;
        var clipPathRegex = /(\w+)\((\d+)/;
        function nativelyHidden(vNode) {
            return [
                "style",
                "script",
                "noscript",
                "template"
            ].includes(vNode.props.nodeName);
        }
        function displayHidden(vNode) {
            if (vNode.props.nodeName === "area") return false;
            return vNode.getComputedStylePropertyValue("display") === "none";
        }
        function visibilityHidden(vNode) {
            var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, isAncestor = _ref11.isAncestor;
            return !isAncestor && [
                "hidden",
                "collapse"
            ].includes(vNode.getComputedStylePropertyValue("visibility"));
        }
        function contentVisibiltyHidden(vNode) {
            var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, isAncestor = _ref12.isAncestor;
            return !!isAncestor && vNode.getComputedStylePropertyValue("content-visibility") === "hidden";
        }
        function ariaHidden(vNode) {
            return vNode.attr("aria-hidden") === "true";
        }
        function opacityHidden(vNode) {
            return vNode.getComputedStylePropertyValue("opacity") === "0";
        }
        function scrollHidden(vNode) {
            var scroll = get_scroll_default(vNode.actualNode);
            var elHeight = parseInt(vNode.getComputedStylePropertyValue("height"));
            var elWidth = parseInt(vNode.getComputedStylePropertyValue("width"));
            return !!scroll && (elHeight === 0 || elWidth === 0);
        }
        function overflowHidden(vNode) {
            var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, isAncestor = _ref13.isAncestor;
            if (isAncestor) return false;
            var rect = vNode.boundingClientRect;
            var nodes = get_overflow_hidden_ancestors_default(vNode);
            if (!nodes.length) return false;
            return nodes.some(function(node) {
                var nodeRect = node.boundingClientRect;
                if (nodeRect.width < 2 || nodeRect.height < 2) return true;
                return !_rectsOverlap(rect, nodeRect);
            });
        }
        function clipHidden(vNode) {
            var matchesClip = vNode.getComputedStylePropertyValue("clip").match(clipRegex);
            var matchesClipPath = vNode.getComputedStylePropertyValue("clip-path").match(clipPathRegex);
            if (matchesClip && matchesClip.length === 5) {
                var position = vNode.getComputedStylePropertyValue("position");
                if ([
                    "fixed",
                    "absolute"
                ].includes(position)) return matchesClip[3] - matchesClip[1] <= 0 && matchesClip[2] - matchesClip[4] <= 0;
            }
            if (matchesClipPath) {
                var type2 = matchesClipPath[1];
                var value = parseInt(matchesClipPath[2], 10);
                switch(type2){
                    case "inset":
                        return value >= 50;
                    case "circle":
                        return value === 0;
                    default:
                }
            }
            return false;
        }
        function areaHidden(vNode, visibleFunction) {
            var mapEl = closest_default(vNode, "map");
            if (!mapEl) return true;
            var mapElName = mapEl.attr("name");
            if (!mapElName) return true;
            var mapElRootNode = get_root_node_default(vNode.actualNode);
            if (!mapElRootNode || mapElRootNode.nodeType !== 9) return true;
            var refs = query_selector_all_default(axe._tree, 'img[usemap="#'.concat(escape_selector_default(mapElName), '"]'));
            if (!refs || !refs.length) return true;
            return refs.some(function(ref) {
                return !visibleFunction(ref);
            });
        }
        function detailsHidden(vNode) {
            var _vNode$parent;
            if (((_vNode$parent = vNode.parent) === null || _vNode$parent === void 0 ? void 0 : _vNode$parent.props.nodeName) !== "details") return false;
            if (vNode.props.nodeName === "summary") {
                var firstSummary = vNode.parent.children.find(function(node) {
                    return node.props.nodeName === "summary";
                });
                if (firstSummary === vNode) return false;
            }
            return !vNode.parent.hasAttr("open");
        }
        var hiddenMethods = [
            displayHidden,
            visibilityHidden,
            contentVisibiltyHidden,
            detailsHidden
        ];
        function _isHiddenForEveryone(vNode) {
            var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, skipAncestors = _ref14.skipAncestors, _ref14$isAncestor = _ref14.isAncestor, isAncestor = _ref14$isAncestor === void 0 ? false : _ref14$isAncestor;
            vNode = _nodeLookup(vNode).vNode;
            if (skipAncestors) return isHiddenSelf(vNode, isAncestor);
            return isHiddenAncestors(vNode, isAncestor);
        }
        var isHiddenSelf = memoize_default(function isHiddenSelfMemoized(vNode, isAncestor) {
            if (nativelyHidden(vNode)) return true;
            if (!vNode.actualNode) return false;
            if (hiddenMethods.some(function(method) {
                return method(vNode, {
                    isAncestor: isAncestor
                });
            })) return true;
            if (!vNode.actualNode.isConnected) return true;
            return false;
        });
        var isHiddenAncestors = memoize_default(function isHiddenAncestorsMemoized(vNode, isAncestor) {
            if (isHiddenSelf(vNode, isAncestor)) return true;
            if (!vNode.parent) return false;
            return isHiddenAncestors(vNode.parent, true);
        });
        function getComposedParent(element) {
            if (element.assignedSlot) return getComposedParent(element.assignedSlot);
            else if (element.parentNode) {
                var parentNode = element.parentNode;
                if (parentNode.nodeType === 1) return parentNode;
                else if (parentNode.host) return parentNode.host;
            }
            return null;
        }
        var get_composed_parent_default = getComposedParent;
        function getScrollOffset(element) {
            if (!element.nodeType && element.document) element = element.document;
            if (element.nodeType === 9) {
                var docElement = element.documentElement, body = element.body;
                return {
                    left: docElement && docElement.scrollLeft || body && body.scrollLeft || 0,
                    top: docElement && docElement.scrollTop || body && body.scrollTop || 0
                };
            }
            return {
                left: element.scrollLeft,
                top: element.scrollTop
            };
        }
        var get_scroll_offset_default = getScrollOffset;
        function getElementCoordinates(element) {
            var scrollOffset = get_scroll_offset_default(document), xOffset = scrollOffset.left, yOffset = scrollOffset.top, coords = element.getBoundingClientRect();
            return {
                top: coords.top + yOffset,
                right: coords.right + xOffset,
                bottom: coords.bottom + yOffset,
                left: coords.left + xOffset,
                width: coords.right - coords.left,
                height: coords.bottom - coords.top
            };
        }
        var get_element_coordinates_default = getElementCoordinates;
        function getViewportSize(win) {
            var doc = win.document;
            var docElement = doc.documentElement;
            if (win.innerWidth) return {
                width: win.innerWidth,
                height: win.innerHeight
            };
            if (docElement) return {
                width: docElement.clientWidth,
                height: docElement.clientHeight
            };
            var body = doc.body;
            return {
                width: body.clientWidth,
                height: body.clientHeight
            };
        }
        var get_viewport_size_default = getViewportSize;
        function noParentScrolled(element, offset) {
            element = get_composed_parent_default(element);
            while(element && element.nodeName.toLowerCase() !== "html"){
                if (element.scrollTop) {
                    offset += element.scrollTop;
                    if (offset >= 0) return false;
                }
                element = get_composed_parent_default(element);
            }
            return true;
        }
        function isOffscreen(element) {
            var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, isAncestor = _ref15.isAncestor;
            if (isAncestor) return false;
            var _nodeLookup2 = _nodeLookup(element), domNode = _nodeLookup2.domNode;
            if (!domNode) return void 0;
            var leftBoundary;
            var docElement = document.documentElement;
            var styl = window1.getComputedStyle(domNode);
            var dir = window1.getComputedStyle(document.body || docElement).getPropertyValue("direction");
            var coords = get_element_coordinates_default(domNode);
            if (coords.bottom < 0 && (noParentScrolled(domNode, coords.bottom) || styl.position === "absolute")) return true;
            if (coords.left === 0 && coords.right === 0) return false;
            if (dir === "ltr") {
                if (coords.right <= 0) return true;
            } else {
                leftBoundary = Math.max(docElement.scrollWidth, get_viewport_size_default(window1).width);
                if (coords.left >= leftBoundary) return true;
            }
            return false;
        }
        var is_offscreen_default = isOffscreen;
        var hiddenMethods2 = [
            opacityHidden,
            scrollHidden,
            overflowHidden,
            clipHidden,
            is_offscreen_default
        ];
        function _isVisibleOnScreen(vNode) {
            vNode = _nodeLookup(vNode).vNode;
            return isVisibleOnScreenVirtual(vNode);
        }
        var isVisibleOnScreenVirtual = memoize_default(function isVisibleOnScreenMemoized(vNode, isAncestor) {
            if (vNode.actualNode && vNode.props.nodeName === "area") return !areaHidden(vNode, isVisibleOnScreenVirtual);
            if (_isHiddenForEveryone(vNode, {
                skipAncestors: true,
                isAncestor: isAncestor
            })) return false;
            if (vNode.actualNode && hiddenMethods2.some(function(method) {
                return method(vNode, {
                    isAncestor: isAncestor
                });
            })) return false;
            if (!vNode.parent) return true;
            return isVisibleOnScreenVirtual(vNode.parent, true);
        });
        function _getBoundingRect(rectA, rectB) {
            var top = Math.min(rectA.top, rectB.top);
            var right = Math.max(rectA.right, rectB.right);
            var bottom = Math.max(rectA.bottom, rectB.bottom);
            var left = Math.min(rectA.left, rectB.left);
            return new window1.DOMRect(left, top, right - left, bottom - top);
        }
        function _isPointInRect(_ref16, _ref17) {
            var x = _ref16.x, y = _ref16.y;
            var top = _ref17.top, right = _ref17.right, bottom = _ref17.bottom, left = _ref17.left;
            return y >= top && x <= right && y <= bottom && x >= left;
        }
        var math_exports = {};
        __export(math_exports, {
            getBoundingRect: function getBoundingRect() {
                return _getBoundingRect;
            },
            getIntersectionRect: function getIntersectionRect() {
                return _getIntersectionRect;
            },
            getOffset: function getOffset() {
                return _getOffset;
            },
            getRectCenter: function getRectCenter() {
                return _getRectCenter;
            },
            hasVisualOverlap: function hasVisualOverlap() {
                return _hasVisualOverlap;
            },
            isPointInRect: function isPointInRect() {
                return _isPointInRect;
            },
            rectHasMinimumSize: function rectHasMinimumSize() {
                return _rectHasMinimumSize;
            },
            rectsOverlap: function rectsOverlap() {
                return _rectsOverlap;
            },
            splitRects: function splitRects() {
                return _splitRects;
            }
        });
        function _getIntersectionRect(rect1, rect2) {
            var leftX = Math.max(rect1.left, rect2.left);
            var rightX = Math.min(rect1.right, rect2.right);
            var topY = Math.max(rect1.top, rect2.top);
            var bottomY = Math.min(rect1.bottom, rect2.bottom);
            if (leftX >= rightX || topY >= bottomY) return null;
            return new window1.DOMRect(leftX, topY, rightX - leftX, bottomY - topY);
        }
        function _getRectCenter(_ref18) {
            var left = _ref18.left, top = _ref18.top, width = _ref18.width, height = _ref18.height;
            return new window1.DOMPoint(left + width / 2, top + height / 2);
        }
        var roundingMargin = .05;
        function _rectHasMinimumSize(minSize, _ref19) {
            var width = _ref19.width, height = _ref19.height;
            return width + roundingMargin >= minSize && height + roundingMargin >= minSize;
        }
        function _getOffset(vTarget, vNeighbor) {
            var minRadiusNeighbour = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;
            var targetRects = get_target_rects_default(vTarget);
            var neighborRects = get_target_rects_default(vNeighbor);
            if (!targetRects.length || !neighborRects.length) return 0;
            var targetBoundingBox = targetRects.reduce(_getBoundingRect);
            var targetCenter = _getRectCenter(targetBoundingBox);
            var minDistance = Infinity;
            var _iterator2 = _createForOfIteratorHelper(neighborRects), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var rect = _step2.value;
                    if (_isPointInRect(targetCenter, rect)) return 0;
                    var closestPoint = getClosestPoint(targetCenter, rect);
                    var distance2 = pointDistance(targetCenter, closestPoint);
                    minDistance = Math.min(minDistance, distance2);
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var neighborTargetSize = get_target_size_default(vNeighbor);
            if (_rectHasMinimumSize(minRadiusNeighbour * 2, neighborTargetSize)) return minDistance;
            var neighborBoundingBox = neighborRects.reduce(_getBoundingRect);
            var neighborCenter = _getRectCenter(neighborBoundingBox);
            var centerDistance = pointDistance(targetCenter, neighborCenter) - minRadiusNeighbour;
            return Math.max(0, Math.min(minDistance, centerDistance));
        }
        function getClosestPoint(point, rect) {
            var x;
            var y;
            if (point.x < rect.left) x = rect.left;
            else if (point.x > rect.right) x = rect.right;
            else x = point.x;
            if (point.y < rect.top) y = rect.top;
            else if (point.y > rect.bottom) y = rect.bottom;
            else y = point.y;
            return {
                x: x,
                y: y
            };
        }
        function pointDistance(pointA, pointB) {
            return Math.hypot(pointA.x - pointB.x, pointA.y - pointB.y);
        }
        function _hasVisualOverlap(vNodeA, vNodeB) {
            var rectA = vNodeA.boundingClientRect;
            var rectB = vNodeB.boundingClientRect;
            if (rectA.left >= rectB.right || rectA.right <= rectB.left || rectA.top >= rectB.bottom || rectA.bottom <= rectB.top) return false;
            return _visuallySort(vNodeA, vNodeB) > 0;
        }
        function _splitRects(outerRect, overlapRects) {
            var uniqueRects = [
                outerRect
            ];
            var _iterator3 = _createForOfIteratorHelper(overlapRects), _step3;
            try {
                var _loop3 = function _loop3() {
                    var overlapRect = _step3.value;
                    uniqueRects = uniqueRects.reduce(function(rects, inputRect) {
                        return rects.concat(splitRect(inputRect, overlapRect));
                    }, []);
                };
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop3();
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            return uniqueRects;
        }
        function splitRect(inputRect, clipRect) {
            var top = inputRect.top, left = inputRect.left, bottom = inputRect.bottom, right = inputRect.right;
            var yAligned = top < clipRect.bottom && bottom > clipRect.top;
            var xAligned = left < clipRect.right && right > clipRect.left;
            var rects = [];
            if (between(clipRect.top, top, bottom) && xAligned) rects.push({
                top: top,
                left: left,
                bottom: clipRect.top,
                right: right
            });
            if (between(clipRect.right, left, right) && yAligned) rects.push({
                top: top,
                left: clipRect.right,
                bottom: bottom,
                right: right
            });
            if (between(clipRect.bottom, top, bottom) && xAligned) rects.push({
                top: clipRect.bottom,
                right: right,
                bottom: bottom,
                left: left
            });
            if (between(clipRect.left, left, right) && yAligned) rects.push({
                top: top,
                left: left,
                bottom: bottom,
                right: clipRect.left
            });
            if (rects.length === 0) {
                if (isEnclosedRect(inputRect, clipRect)) return [];
                rects.push(inputRect);
            }
            return rects.map(computeRect);
        }
        var between = function between(num, min, max2) {
            return num > min && num < max2;
        };
        function computeRect(baseRect) {
            return new window1.DOMRect(baseRect.left, baseRect.top, baseRect.right - baseRect.left, baseRect.bottom - baseRect.top);
        }
        function isEnclosedRect(rectA, rectB) {
            return rectA.top >= rectB.top && rectA.left >= rectB.left && rectA.bottom <= rectB.bottom && rectA.right <= rectB.right;
        }
        var ROOT_LEVEL = 0;
        var DEFAULT_LEVEL = .1;
        var FLOAT_LEVEL = .2;
        var POSITION_LEVEL = .3;
        var nodeIndex = 0;
        function _createGrid() {
            var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
            var rootGrid = arguments.length > 1 ? arguments[1] : undefined;
            var parentVNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (cache_default.get("gridCreated") && !parentVNode) return constants_default.gridSize;
            cache_default.set("gridCreated", true);
            if (!parentVNode) {
                var _rootGrid;
                var vNode = get_node_from_tree_default(document.documentElement);
                if (!vNode) vNode = new virtual_node_default(document.documentElement);
                nodeIndex = 0;
                vNode._stackingOrder = [
                    createStackingContext(ROOT_LEVEL, nodeIndex++, null)
                ];
                (_rootGrid = rootGrid) !== null && _rootGrid !== void 0 ? _rootGrid : rootGrid = new Grid();
                addNodeToGrid(rootGrid, vNode);
                if (get_scroll_default(vNode.actualNode)) {
                    var subGrid = new Grid(vNode);
                    vNode._subGrid = subGrid;
                }
            }
            var treeWalker = document.createTreeWalker(root, window1.NodeFilter.SHOW_ELEMENT, null, false);
            var node = parentVNode ? treeWalker.nextNode() : treeWalker.currentNode;
            while(node){
                var _vNode = get_node_from_tree_default(node);
                if (_vNode && _vNode.parent) parentVNode = _vNode.parent;
                else if (node.assignedSlot) parentVNode = get_node_from_tree_default(node.assignedSlot);
                else if (node.parentElement) parentVNode = get_node_from_tree_default(node.parentElement);
                else if (node.parentNode && get_node_from_tree_default(node.parentNode)) parentVNode = get_node_from_tree_default(node.parentNode);
                if (!_vNode) _vNode = new axe.VirtualNode(node, parentVNode);
                _vNode._stackingOrder = createStackingOrder(_vNode, parentVNode, nodeIndex++);
                var scrollRegionParent = findScrollRegionParent(_vNode, parentVNode);
                var grid = scrollRegionParent ? scrollRegionParent._subGrid : rootGrid;
                if (get_scroll_default(_vNode.actualNode)) {
                    var _subGrid = new Grid(_vNode);
                    _vNode._subGrid = _subGrid;
                }
                var rect = _vNode.boundingClientRect;
                if (rect.width !== 0 && rect.height !== 0 && _isVisibleOnScreen(node)) addNodeToGrid(grid, _vNode);
                if (is_shadow_root_default(node)) _createGrid(node.shadowRoot, grid, _vNode);
                node = treeWalker.nextNode();
            }
            return constants_default.gridSize;
        }
        function isStackingContext(vNode, parentVNode) {
            var position = vNode.getComputedStylePropertyValue("position");
            var zIndex = vNode.getComputedStylePropertyValue("z-index");
            if (position === "fixed" || position === "sticky") return true;
            if (zIndex !== "auto" && position !== "static") return true;
            if (vNode.getComputedStylePropertyValue("opacity") !== "1") return true;
            var transform = vNode.getComputedStylePropertyValue("-webkit-transform") || vNode.getComputedStylePropertyValue("-ms-transform") || vNode.getComputedStylePropertyValue("transform") || "none";
            if (transform !== "none") return true;
            var mixBlendMode = vNode.getComputedStylePropertyValue("mix-blend-mode");
            if (mixBlendMode && mixBlendMode !== "normal") return true;
            var filter = vNode.getComputedStylePropertyValue("filter");
            if (filter && filter !== "none") return true;
            var perspective = vNode.getComputedStylePropertyValue("perspective");
            if (perspective && perspective !== "none") return true;
            var clipPath = vNode.getComputedStylePropertyValue("clip-path");
            if (clipPath && clipPath !== "none") return true;
            var mask = vNode.getComputedStylePropertyValue("-webkit-mask") || vNode.getComputedStylePropertyValue("mask") || "none";
            if (mask !== "none") return true;
            var maskImage = vNode.getComputedStylePropertyValue("-webkit-mask-image") || vNode.getComputedStylePropertyValue("mask-image") || "none";
            if (maskImage !== "none") return true;
            var maskBorder = vNode.getComputedStylePropertyValue("-webkit-mask-border") || vNode.getComputedStylePropertyValue("mask-border") || "none";
            if (maskBorder !== "none") return true;
            if (vNode.getComputedStylePropertyValue("isolation") === "isolate") return true;
            var willChange = vNode.getComputedStylePropertyValue("will-change");
            if (willChange === "transform" || willChange === "opacity") return true;
            if (vNode.getComputedStylePropertyValue("-webkit-overflow-scrolling") === "touch") return true;
            var contain = vNode.getComputedStylePropertyValue("contain");
            if ([
                "layout",
                "paint",
                "strict",
                "content"
            ].includes(contain)) return true;
            if (zIndex !== "auto" && isFlexOrGridContainer(parentVNode)) return true;
            return false;
        }
        function isFlexOrGridContainer(vNode) {
            if (!vNode) return false;
            var display2 = vNode.getComputedStylePropertyValue("display");
            return [
                "flex",
                "inline-flex",
                "grid",
                "inline-grid"
            ].includes(display2);
        }
        function createStackingOrder(vNode, parentVNode, treeOrder) {
            var stackingOrder = parentVNode._stackingOrder.slice();
            if (isStackingContext(vNode, parentVNode)) {
                var index = stackingOrder.findIndex(function(_ref20) {
                    var stackLevel2 = _ref20.stackLevel;
                    return [
                        ROOT_LEVEL,
                        FLOAT_LEVEL,
                        POSITION_LEVEL
                    ].includes(stackLevel2);
                });
                if (index !== -1) stackingOrder.splice(index, stackingOrder.length - index);
            }
            var stackLevel = getStackLevel(vNode, parentVNode);
            if (stackLevel !== null) stackingOrder.push(createStackingContext(stackLevel, treeOrder, vNode));
            return stackingOrder;
        }
        function createStackingContext(stackLevel, treeOrder, vNode) {
            return {
                stackLevel: stackLevel,
                treeOrder: treeOrder,
                vNode: vNode
            };
        }
        function getStackLevel(vNode, parentVNode) {
            var zIndex = getRealZIndex(vNode, parentVNode);
            if (![
                "auto",
                "0"
            ].includes(zIndex)) return parseInt(zIndex);
            if (vNode.getComputedStylePropertyValue("position") !== "static") return POSITION_LEVEL;
            if (vNode.getComputedStylePropertyValue("float") !== "none") return FLOAT_LEVEL;
            if (isStackingContext(vNode, parentVNode)) return DEFAULT_LEVEL;
            return null;
        }
        function getRealZIndex(vNode, parentVNode) {
            var position = vNode.getComputedStylePropertyValue("position");
            if (position === "static" && !isFlexOrGridContainer(parentVNode)) return "auto";
            return vNode.getComputedStylePropertyValue("z-index");
        }
        function findScrollRegionParent(vNode, parentVNode) {
            var scrollRegionParent = null;
            var checkedNodes = [
                vNode
            ];
            while(parentVNode){
                if (get_scroll_default(parentVNode.actualNode)) {
                    scrollRegionParent = parentVNode;
                    break;
                }
                if (parentVNode._scrollRegionParent) {
                    scrollRegionParent = parentVNode._scrollRegionParent;
                    break;
                }
                checkedNodes.push(parentVNode);
                parentVNode = get_node_from_tree_default(parentVNode.actualNode.parentElement || parentVNode.actualNode.parentNode);
            }
            checkedNodes.forEach(function(virtualNode) {
                return virtualNode._scrollRegionParent = scrollRegionParent;
            });
            return scrollRegionParent;
        }
        function addNodeToGrid(grid, vNode) {
            var overflowHiddenNodes = get_overflow_hidden_ancestors_default(vNode);
            vNode.clientRects.forEach(function(clientRect) {
                var _vNode$_grid;
                var visibleRect = overflowHiddenNodes.reduce(function(rect, overflowNode) {
                    return rect && _getIntersectionRect(rect, overflowNode.boundingClientRect);
                }, clientRect);
                if (!visibleRect) return;
                (_vNode$_grid = vNode._grid) !== null && _vNode$_grid !== void 0 ? _vNode$_grid : vNode._grid = grid;
                var gridRect = grid.getGridPositionOfRect(visibleRect);
                grid.loopGridPosition(gridRect, function(gridCell) {
                    if (!gridCell.includes(vNode)) gridCell.push(vNode);
                });
            });
        }
        var Grid = function() {
            function Grid() {
                var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                _classCallCheck(this, Grid);
                this.container = container;
                this.cells = [];
            }
            _createClass(Grid, [
                {
                    key: "toGridIndex",
                    value: function toGridIndex(num) {
                        return Math.floor(num / constants_default.gridSize);
                    }
                },
                {
                    key: "getCellFromPoint",
                    value: function getCellFromPoint(_ref21) {
                        var _this$cells, _row;
                        var x = _ref21.x, y = _ref21.y;
                        assert_default(this.boundaries, "Grid does not have cells added");
                        var rowIndex = this.toGridIndex(y);
                        var colIndex = this.toGridIndex(x);
                        assert_default(_isPointInRect({
                            y: rowIndex,
                            x: colIndex
                        }, this.boundaries), "Element midpoint exceeds the grid bounds");
                        var row = (_this$cells = this.cells[rowIndex - this.cells._negativeIndex]) !== null && _this$cells !== void 0 ? _this$cells : [];
                        return (_row = row[colIndex - row._negativeIndex]) !== null && _row !== void 0 ? _row : [];
                    }
                },
                {
                    key: "loopGridPosition",
                    value: function loopGridPosition(gridPosition, callback) {
                        var _gridPosition = gridPosition, left = _gridPosition.left, right = _gridPosition.right, top = _gridPosition.top, bottom = _gridPosition.bottom;
                        if (this.boundaries) gridPosition = _getBoundingRect(this.boundaries, gridPosition);
                        this.boundaries = gridPosition;
                        loopNegativeIndexMatrix(this.cells, top, bottom, function(gridRow, row) {
                            loopNegativeIndexMatrix(gridRow, left, right, function(gridCell, col) {
                                callback(gridCell, {
                                    row: row,
                                    col: col
                                });
                            });
                        });
                    }
                },
                {
                    key: "getGridPositionOfRect",
                    value: function getGridPositionOfRect(_ref22) {
                        var top = _ref22.top, right = _ref22.right, bottom = _ref22.bottom, left = _ref22.left;
                        var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        top = this.toGridIndex(top - margin);
                        right = this.toGridIndex(right + margin - 1);
                        bottom = this.toGridIndex(bottom + margin - 1);
                        left = this.toGridIndex(left - margin);
                        return new window1.DOMRect(left, top, right - left, bottom - top);
                    }
                }
            ]);
            return Grid;
        }();
        function loopNegativeIndexMatrix(matrix, start, end, callback) {
            var _matrix$_negativeInde;
            (_matrix$_negativeInde = matrix._negativeIndex) !== null && _matrix$_negativeInde !== void 0 ? _matrix$_negativeInde : matrix._negativeIndex = 0;
            if (start < matrix._negativeIndex) {
                for(var _i6 = 0; _i6 < matrix._negativeIndex - start; _i6++)matrix.splice(0, 0, []);
                matrix._negativeIndex = start;
            }
            var startOffset = start - matrix._negativeIndex;
            var endOffset = end - matrix._negativeIndex;
            for(var index = startOffset; index <= endOffset; index++){
                var _index, _matrix$_index;
                (_matrix$_index = matrix[_index = index]) !== null && _matrix$_index !== void 0 ? _matrix$_index : matrix[_index] = [];
                callback(matrix[index], index + matrix._negativeIndex);
            }
        }
        function _findNearbyElms(vNode) {
            var _vNode$_grid2, _vNode$_grid2$cells;
            var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            _createGrid();
            if (!((_vNode$_grid2 = vNode._grid) !== null && _vNode$_grid2 !== void 0 && (_vNode$_grid2$cells = _vNode$_grid2.cells) !== null && _vNode$_grid2$cells !== void 0 && _vNode$_grid2$cells.length)) return [];
            var rect = vNode.boundingClientRect;
            var grid = vNode._grid;
            var selfIsFixed = hasFixedPosition(vNode);
            var gridPosition = grid.getGridPositionOfRect(rect, margin);
            var neighbors = [];
            grid.loopGridPosition(gridPosition, function(vNeighbors) {
                var _iterator4 = _createForOfIteratorHelper(vNeighbors), _step4;
                try {
                    for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                        var vNeighbor = _step4.value;
                        if (vNeighbor && vNeighbor !== vNode && !neighbors.includes(vNeighbor) && selfIsFixed === hasFixedPosition(vNeighbor)) neighbors.push(vNeighbor);
                    }
                } catch (err) {
                    _iterator4.e(err);
                } finally{
                    _iterator4.f();
                }
            });
            return neighbors;
        }
        var hasFixedPosition = memoize_default(function(vNode) {
            if (!vNode) return false;
            if (vNode.getComputedStylePropertyValue("position") === "fixed") return true;
            return hasFixedPosition(vNode.parent);
        });
        var getModalDialog = memoize_default(function getModalDialogMemoized() {
            var _dialogs$find;
            if (!axe._tree) return null;
            var dialogs = query_selector_all_filter_default(axe._tree[0], "dialog[open]", function(vNode) {
                var rect = vNode.boundingClientRect;
                var stack = document.elementsFromPoint(rect.left + 1, rect.top + 1);
                return stack.includes(vNode.actualNode) && _isVisibleOnScreen(vNode);
            });
            if (!dialogs.length) return null;
            var modalDialog = dialogs.find(function(dialog) {
                var rect = dialog.boundingClientRect;
                var stack = document.elementsFromPoint(rect.left - 10, rect.top - 10);
                return stack.includes(dialog.actualNode);
            });
            if (modalDialog) return modalDialog;
            return (_dialogs$find = dialogs.find(function(dialog) {
                var _getNodeFromGrid;
                var _ref23 = (_getNodeFromGrid = getNodeFromGrid(dialog)) !== null && _getNodeFromGrid !== void 0 ? _getNodeFromGrid : {}, vNode = _ref23.vNode, rect = _ref23.rect;
                if (!vNode) return false;
                var stack = document.elementsFromPoint(rect.left + 1, rect.top + 1);
                return !stack.includes(vNode.actualNode);
            })) !== null && _dialogs$find !== void 0 ? _dialogs$find : null;
        });
        var get_modal_dialog_default = getModalDialog;
        function getNodeFromGrid(dialog) {
            _createGrid();
            var grid = axe._tree[0]._grid;
            var viewRect = new window1.DOMRect(0, 0, window1.innerWidth, window1.innerHeight);
            if (!grid) return;
            for(var row = 0; row < grid.cells.length; row++){
                var cols = grid.cells[row];
                if (!cols) continue;
                for(var col = 0; col < cols.length; col++){
                    var cells = cols[col];
                    if (!cells) continue;
                    for(var _i7 = 0; _i7 < cells.length; _i7++){
                        var vNode = cells[_i7];
                        var rect = vNode.boundingClientRect;
                        var intersection = _getIntersectionRect(rect, viewRect);
                        if (vNode.props.nodeName !== "html" && vNode !== dialog && vNode.getComputedStylePropertyValue("pointer-events") !== "none" && intersection) return {
                            vNode: vNode,
                            rect: intersection
                        };
                    }
                }
            }
        }
        function _isInert(vNode) {
            var _ref24 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, skipAncestors = _ref24.skipAncestors, isAncestor = _ref24.isAncestor;
            if (skipAncestors) return isInertSelf(vNode, isAncestor);
            return isInertAncestors(vNode, isAncestor);
        }
        var isInertSelf = memoize_default(function isInertSelfMemoized(vNode, isAncestor) {
            if (vNode.hasAttr("inert")) return true;
            if (!isAncestor && vNode.actualNode) {
                var modalDialog = get_modal_dialog_default();
                if (modalDialog && !_contains(modalDialog, vNode)) return true;
            }
            return false;
        });
        var isInertAncestors = memoize_default(function isInertAncestorsMemoized(vNode, isAncestor) {
            if (isInertSelf(vNode, isAncestor)) return true;
            if (!vNode.parent) return false;
            return isInertAncestors(vNode.parent, true);
        });
        var allowedDisabledNodeNames = [
            "button",
            "command",
            "fieldset",
            "keygen",
            "optgroup",
            "option",
            "select",
            "textarea",
            "input"
        ];
        function isDisabledAttrAllowed(nodeName2) {
            return allowedDisabledNodeNames.includes(nodeName2);
        }
        function focusDisabled(el) {
            var _nodeLookup3 = _nodeLookup(el), vNode = _nodeLookup3.vNode;
            if (isDisabledAttrAllowed(vNode.props.nodeName) && vNode.hasAttr("disabled") || _isInert(vNode)) return true;
            var parentNode = vNode.parent;
            var ancestors = [];
            var fieldsetDisabled = false;
            while(parentNode && parentNode.shadowId === vNode.shadowId && !fieldsetDisabled){
                ancestors.push(parentNode);
                if (parentNode.props.nodeName === "legend") break;
                if (parentNode._inDisabledFieldset !== void 0) {
                    fieldsetDisabled = parentNode._inDisabledFieldset;
                    break;
                }
                if (parentNode.props.nodeName === "fieldset" && parentNode.hasAttr("disabled")) fieldsetDisabled = true;
                parentNode = parentNode.parent;
            }
            ancestors.forEach(function(ancestor) {
                return ancestor._inDisabledFieldset = fieldsetDisabled;
            });
            if (fieldsetDisabled) return true;
            if (vNode.props.nodeName !== "area") {
                if (!vNode.actualNode) return false;
                return _isHiddenForEveryone(vNode);
            }
            return false;
        }
        var focus_disabled_default = focusDisabled;
        var angularSkipLinkRegex = /^\/\#/;
        var angularRouterLinkRegex = /^#[!/]/;
        function _isCurrentPageLink(anchor) {
            var _window$location;
            var href = anchor.getAttribute("href");
            if (!href || href === "#") return false;
            if (angularSkipLinkRegex.test(href)) return true;
            var hash = anchor.hash, protocol = anchor.protocol, hostname = anchor.hostname, port = anchor.port, pathname = anchor.pathname;
            if (angularRouterLinkRegex.test(hash)) return false;
            if (href.charAt(0) === "#") return true;
            if (typeof ((_window$location = window1.location) === null || _window$location === void 0 ? void 0 : _window$location.origin) !== "string" || window1.location.origin.indexOf("://") === -1) return null;
            var currentPageUrl = window1.location.origin + window1.location.pathname;
            var url;
            if (!hostname) url = window1.location.origin;
            else url = "".concat(protocol, "//").concat(hostname).concat(port ? ":".concat(port) : "");
            if (!pathname) url += window1.location.pathname;
            else url += (pathname[0] !== "/" ? "/" : "") + pathname;
            return url === currentPageUrl;
        }
        function getElementByReference(node, attr) {
            var fragment = node.getAttribute(attr);
            if (!fragment) return null;
            if (attr === "href" && !_isCurrentPageLink(node)) return null;
            if (fragment.indexOf("#") !== -1) fragment = decodeURIComponent(fragment.substr(fragment.indexOf("#") + 1));
            var candidate = document.getElementById(fragment);
            if (candidate) return candidate;
            candidate = document.getElementsByName(fragment);
            if (candidate.length) return candidate[0];
            return null;
        }
        var get_element_by_reference_default = getElementByReference;
        function _visuallySort(a2, b2) {
            _createGrid();
            var length = Math.max(a2._stackingOrder.length, b2._stackingOrder.length);
            for(var _i8 = 0; _i8 < length; _i8++){
                if (typeof b2._stackingOrder[_i8] === "undefined") return -1;
                else if (typeof a2._stackingOrder[_i8] === "undefined") return 1;
                if (b2._stackingOrder[_i8].stackLevel > a2._stackingOrder[_i8].stackLevel) return 1;
                if (b2._stackingOrder[_i8].stackLevel < a2._stackingOrder[_i8].stackLevel) return -1;
                if (b2._stackingOrder[_i8].treeOrder !== a2._stackingOrder[_i8].treeOrder) return b2._stackingOrder[_i8].treeOrder - a2._stackingOrder[_i8].treeOrder;
            }
            var aNode = a2.actualNode;
            var bNode = b2.actualNode;
            if (aNode.getRootNode && aNode.getRootNode() !== bNode.getRootNode()) {
                var boundaries = [];
                while(aNode){
                    boundaries.push({
                        root: aNode.getRootNode(),
                        node: aNode
                    });
                    aNode = aNode.getRootNode().host;
                }
                while(bNode && !boundaries.find(function(boundary) {
                    return boundary.root === bNode.getRootNode();
                }))bNode = bNode.getRootNode().host;
                aNode = boundaries.find(function(boundary) {
                    return boundary.root === bNode.getRootNode();
                }).node;
                if (aNode === bNode) return a2.actualNode.getRootNode() !== aNode.getRootNode() ? -1 : 1;
            }
            var _window$Node = window1.Node, DOCUMENT_POSITION_FOLLOWING = _window$Node.DOCUMENT_POSITION_FOLLOWING, DOCUMENT_POSITION_CONTAINS = _window$Node.DOCUMENT_POSITION_CONTAINS, DOCUMENT_POSITION_CONTAINED_BY = _window$Node.DOCUMENT_POSITION_CONTAINED_BY;
            var docPosition = aNode.compareDocumentPosition(bNode);
            var DOMOrder = docPosition & DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
            var isDescendant = docPosition & DOCUMENT_POSITION_CONTAINS || docPosition & DOCUMENT_POSITION_CONTAINED_BY;
            var aPosition = getPositionOrder(a2);
            var bPosition = getPositionOrder(b2);
            if (aPosition === bPosition || isDescendant) return DOMOrder;
            return bPosition - aPosition;
        }
        function getPositionOrder(vNode) {
            if (vNode.getComputedStylePropertyValue("display").indexOf("inline") !== -1) return 2;
            if (isFloated(vNode)) return 1;
            return 0;
        }
        function isFloated(vNode) {
            if (!vNode) return false;
            if (vNode._isFloated !== void 0) return vNode._isFloated;
            var floatStyle = vNode.getComputedStylePropertyValue("float");
            if (floatStyle !== "none") {
                vNode._isFloated = true;
                return true;
            }
            var floated = isFloated(vNode.parent);
            vNode._isFloated = floated;
            return floated;
        }
        function getRectStack(grid, rect) {
            var recursed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var center = _getRectCenter(rect);
            var gridCell = grid.getCellFromPoint(center) || [];
            var floorX = Math.floor(center.x);
            var floorY = Math.floor(center.y);
            var stack = gridCell.filter(function(gridCellNode) {
                return gridCellNode.clientRects.some(function(clientRect) {
                    var rectX = clientRect.left;
                    var rectY = clientRect.top;
                    return floorX < Math.floor(rectX + clientRect.width) && floorX >= Math.floor(rectX) && floorY < Math.floor(rectY + clientRect.height) && floorY >= Math.floor(rectY);
                });
            });
            var gridContainer = grid.container;
            if (gridContainer) stack = getRectStack(gridContainer._grid, gridContainer.boundingClientRect, true).concat(stack);
            if (!recursed) stack = stack.sort(_visuallySort).map(function(vNode) {
                return vNode.actualNode;
            }).concat(document.documentElement).filter(function(node, index, array) {
                return array.indexOf(node) === index;
            });
            return stack;
        }
        function getElementStack(node) {
            _createGrid();
            var vNode = get_node_from_tree_default(node);
            var grid = vNode._grid;
            if (!grid) return [];
            return getRectStack(grid, vNode.boundingClientRect);
        }
        var get_element_stack_default = getElementStack;
        function getTabbableElements(virtualNode) {
            var nodeAndDescendents = query_selector_all_default(virtualNode, "*");
            var tabbableElements = nodeAndDescendents.filter(function(vNode) {
                var isFocusable2 = vNode.isFocusable;
                var tabIndex = vNode.actualNode.getAttribute("tabindex");
                tabIndex = tabIndex && !isNaN(parseInt(tabIndex, 10)) ? parseInt(tabIndex) : null;
                return tabIndex ? isFocusable2 && tabIndex >= 0 : isFocusable2;
            });
            return tabbableElements;
        }
        var get_tabbable_elements_default = getTabbableElements;
        function isNativelyFocusable(el) {
            var _nodeLookup4 = _nodeLookup(el), vNode = _nodeLookup4.vNode;
            if (!vNode || focus_disabled_default(vNode)) return false;
            switch(vNode.props.nodeName){
                case "a":
                case "area":
                    if (vNode.hasAttr("href")) return true;
                    break;
                case "input":
                    return vNode.props.type !== "hidden";
                case "textarea":
                case "select":
                case "summary":
                case "button":
                    return true;
                case "details":
                    return !query_selector_all_default(vNode, "summary").length;
            }
            return false;
        }
        var is_natively_focusable_default = isNativelyFocusable;
        function _isFocusable(el) {
            var _nodeLookup5 = _nodeLookup(el), vNode = _nodeLookup5.vNode;
            if (vNode.props.nodeType !== 1) return false;
            if (focus_disabled_default(vNode)) return false;
            else if (is_natively_focusable_default(vNode)) return true;
            var tabindex = vNode.attr("tabindex");
            if (tabindex && !isNaN(parseInt(tabindex, 10))) return true;
            return false;
        }
        function _isInTabOrder(el) {
            var _nodeLookup6 = _nodeLookup(el), vNode = _nodeLookup6.vNode;
            if (vNode.props.nodeType !== 1) return false;
            var tabindex = parseInt(vNode.attr("tabindex", 10));
            if (tabindex <= -1) return false;
            return _isFocusable(vNode);
        }
        var get_target_rects_default = memoize_default(getTargetRects);
        function getTargetRects(vNode) {
            var nodeRect = vNode.boundingClientRect;
            var overlappingVNodes = _findNearbyElms(vNode).filter(function(vNeighbor) {
                return _hasVisualOverlap(vNode, vNeighbor) && vNeighbor.getComputedStylePropertyValue("pointer-events") !== "none" && !isDescendantNotInTabOrder(vNode, vNeighbor);
            });
            if (!overlappingVNodes.length) return [
                nodeRect
            ];
            var obscuringRects = overlappingVNodes.map(function(_ref25) {
                var rect = _ref25.boundingClientRect;
                return rect;
            });
            return _splitRects(nodeRect, obscuringRects);
        }
        function isDescendantNotInTabOrder(vAncestor, vNode) {
            return vAncestor.actualNode.contains(vNode.actualNode) && !_isInTabOrder(vNode);
        }
        var get_target_size_default = memoize_default(getTargetSize);
        function getTargetSize(vNode, minSize) {
            var rects = get_target_rects_default(vNode);
            return getLargestRect(rects, minSize);
        }
        function getLargestRect(rects, minSize) {
            return rects.reduce(function(rectA, rectB) {
                var rectAisMinimum = _rectHasMinimumSize(minSize, rectA);
                var rectBisMinimum = _rectHasMinimumSize(minSize, rectB);
                if (rectAisMinimum !== rectBisMinimum) return rectAisMinimum ? rectA : rectB;
                var areaA = rectA.width * rectA.height;
                var areaB = rectB.width * rectB.height;
                return areaA > areaB ? rectA : rectB;
            });
        }
        var text_exports = {};
        __export(text_exports, {
            accessibleText: function accessibleText() {
                return accessible_text_default;
            },
            accessibleTextVirtual: function accessibleTextVirtual() {
                return _accessibleTextVirtual;
            },
            autocomplete: function autocomplete() {
                return _autocomplete;
            },
            formControlValue: function formControlValue() {
                return form_control_value_default;
            },
            formControlValueMethods: function formControlValueMethods() {
                return _formControlValueMethods;
            },
            hasUnicode: function hasUnicode() {
                return has_unicode_default;
            },
            isHumanInterpretable: function isHumanInterpretable() {
                return is_human_interpretable_default;
            },
            isIconLigature: function isIconLigature() {
                return _isIconLigature;
            },
            isValidAutocomplete: function isValidAutocomplete() {
                return is_valid_autocomplete_default;
            },
            label: function label() {
                return label_default;
            },
            labelText: function labelText() {
                return label_text_default;
            },
            labelVirtual: function labelVirtual() {
                return label_virtual_default2;
            },
            nativeElementType: function nativeElementType() {
                return native_element_type_default;
            },
            nativeTextAlternative: function nativeTextAlternative() {
                return _nativeTextAlternative;
            },
            nativeTextMethods: function nativeTextMethods() {
                return native_text_methods_default;
            },
            removeUnicode: function removeUnicode() {
                return remove_unicode_default;
            },
            sanitize: function sanitize() {
                return sanitize_default;
            },
            subtreeText: function subtreeText() {
                return subtree_text_default;
            },
            titleText: function titleText() {
                return title_text_default;
            },
            unsupported: function unsupported() {
                return unsupported_default;
            },
            visible: function visible() {
                return visible_default;
            },
            visibleTextNodes: function visibleTextNodes() {
                return visible_text_nodes_default;
            },
            visibleVirtual: function visibleVirtual() {
                return visible_virtual_default;
            }
        });
        function idrefs(node, attr) {
            node = node.actualNode || node;
            try {
                var doc = get_root_node_default2(node);
                var result = [];
                var attrValue = node.getAttribute(attr);
                if (attrValue) {
                    attrValue = token_list_default(attrValue);
                    for(var index = 0; index < attrValue.length; index++)result.push(doc.getElementById(attrValue[index]));
                }
                return result;
            } catch (e) {
                throw new TypeError("Cannot resolve id references for non-DOM nodes");
            }
        }
        var idrefs_default = idrefs;
        function accessibleText(element, context) {
            var virtualNode = get_node_from_tree_default(element);
            return _accessibleTextVirtual(virtualNode, context);
        }
        var accessible_text_default = accessibleText;
        function arialabelledbyText(element) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _nodeLookup7 = _nodeLookup(element), vNode = _nodeLookup7.vNode;
            if ((vNode === null || vNode === void 0 ? void 0 : vNode.props.nodeType) !== 1) return "";
            if (vNode.props.nodeType !== 1 || context.inLabelledByContext || context.inControlContext || !vNode.attr("aria-labelledby")) return "";
            var refs = idrefs_default(vNode, "aria-labelledby").filter(function(elm) {
                return elm;
            });
            return refs.reduce(function(accessibleName, elm) {
                var accessibleNameAdd = accessible_text_default(elm, _extends({
                    inLabelledByContext: true,
                    startNode: context.startNode || vNode
                }, context));
                if (!accessibleName) return accessibleNameAdd;
                else return "".concat(accessibleName, " ").concat(accessibleNameAdd);
            }, "");
        }
        var arialabelledby_text_default = arialabelledbyText;
        function _arialabelText(element) {
            var _nodeLookup8 = _nodeLookup(element), vNode = _nodeLookup8.vNode;
            if ((vNode === null || vNode === void 0 ? void 0 : vNode.props.nodeType) !== 1) return "";
            return vNode.attr("aria-label") || "";
        }
        var ariaAttrs = {
            "aria-activedescendant": {
                type: "idref",
                allowEmpty: true
            },
            "aria-atomic": {
                type: "boolean",
                global: true
            },
            "aria-autocomplete": {
                type: "nmtoken",
                values: [
                    "inline",
                    "list",
                    "both",
                    "none"
                ]
            },
            "aria-braillelabel": {
                type: "string",
                allowEmpty: true,
                global: true
            },
            "aria-brailleroledescription": {
                type: "string",
                allowEmpty: true,
                global: true
            },
            "aria-busy": {
                type: "boolean",
                global: true
            },
            "aria-checked": {
                type: "nmtoken",
                values: [
                    "false",
                    "mixed",
                    "true",
                    "undefined"
                ]
            },
            "aria-colcount": {
                type: "int",
                minValue: -1
            },
            "aria-colindex": {
                type: "int",
                minValue: 1
            },
            "aria-colspan": {
                type: "int",
                minValue: 1
            },
            "aria-controls": {
                type: "idrefs",
                allowEmpty: true,
                global: true
            },
            "aria-current": {
                type: "nmtoken",
                allowEmpty: true,
                values: [
                    "page",
                    "step",
                    "location",
                    "date",
                    "time",
                    "true",
                    "false"
                ],
                global: true
            },
            "aria-describedby": {
                type: "idrefs",
                allowEmpty: true,
                global: true
            },
            "aria-description": {
                type: "string",
                allowEmpty: true,
                global: true
            },
            "aria-details": {
                type: "idref",
                allowEmpty: true,
                global: true
            },
            "aria-disabled": {
                type: "boolean",
                global: true
            },
            "aria-dropeffect": {
                type: "nmtokens",
                values: [
                    "copy",
                    "execute",
                    "link",
                    "move",
                    "none",
                    "popup"
                ],
                global: true
            },
            "aria-errormessage": {
                type: "idref",
                allowEmpty: true,
                global: true
            },
            "aria-expanded": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "undefined"
                ]
            },
            "aria-flowto": {
                type: "idrefs",
                allowEmpty: true,
                global: true
            },
            "aria-grabbed": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "undefined"
                ],
                global: true
            },
            "aria-haspopup": {
                type: "nmtoken",
                allowEmpty: true,
                values: [
                    "true",
                    "false",
                    "menu",
                    "listbox",
                    "tree",
                    "grid",
                    "dialog"
                ],
                global: true
            },
            "aria-hidden": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "undefined"
                ],
                global: true
            },
            "aria-invalid": {
                type: "nmtoken",
                values: [
                    "grammar",
                    "false",
                    "spelling",
                    "true"
                ],
                global: true
            },
            "aria-keyshortcuts": {
                type: "string",
                allowEmpty: true,
                global: true
            },
            "aria-label": {
                type: "string",
                allowEmpty: true,
                global: true
            },
            "aria-labelledby": {
                type: "idrefs",
                allowEmpty: true,
                global: true
            },
            "aria-level": {
                type: "int",
                minValue: 1
            },
            "aria-live": {
                type: "nmtoken",
                values: [
                    "assertive",
                    "off",
                    "polite"
                ],
                global: true
            },
            "aria-modal": {
                type: "boolean"
            },
            "aria-multiline": {
                type: "boolean"
            },
            "aria-multiselectable": {
                type: "boolean"
            },
            "aria-orientation": {
                type: "nmtoken",
                values: [
                    "horizontal",
                    "undefined",
                    "vertical"
                ]
            },
            "aria-owns": {
                type: "idrefs",
                allowEmpty: true,
                global: true
            },
            "aria-placeholder": {
                type: "string",
                allowEmpty: true
            },
            "aria-posinset": {
                type: "int",
                minValue: 1
            },
            "aria-pressed": {
                type: "nmtoken",
                values: [
                    "false",
                    "mixed",
                    "true",
                    "undefined"
                ]
            },
            "aria-readonly": {
                type: "boolean"
            },
            "aria-relevant": {
                type: "nmtokens",
                values: [
                    "additions",
                    "all",
                    "removals",
                    "text"
                ],
                global: true
            },
            "aria-required": {
                type: "boolean"
            },
            "aria-roledescription": {
                type: "string",
                allowEmpty: true,
                global: true
            },
            "aria-rowcount": {
                type: "int",
                minValue: -1
            },
            "aria-rowindex": {
                type: "int",
                minValue: 1
            },
            "aria-rowspan": {
                type: "int",
                minValue: 0
            },
            "aria-selected": {
                type: "nmtoken",
                values: [
                    "false",
                    "true",
                    "undefined"
                ]
            },
            "aria-setsize": {
                type: "int",
                minValue: -1
            },
            "aria-sort": {
                type: "nmtoken",
                values: [
                    "ascending",
                    "descending",
                    "none",
                    "other"
                ]
            },
            "aria-valuemax": {
                type: "decimal"
            },
            "aria-valuemin": {
                type: "decimal"
            },
            "aria-valuenow": {
                type: "decimal"
            },
            "aria-valuetext": {
                type: "string",
                allowEmpty: true
            }
        };
        var aria_attrs_default = ariaAttrs;
        var ariaRoles = {
            alert: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            alertdialog: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-modal"
                ],
                superclassRole: [
                    "alert",
                    "dialog"
                ],
                accessibleNameRequired: true
            },
            application: {
                type: "landmark",
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-expanded"
                ],
                superclassRole: [
                    "structure"
                ],
                accessibleNameRequired: true
            },
            article: {
                type: "structure",
                allowedAttrs: [
                    "aria-posinset",
                    "aria-setsize",
                    "aria-expanded"
                ],
                superclassRole: [
                    "document"
                ]
            },
            banner: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            blockquote: {
                type: "structure",
                superclassRole: [
                    "section"
                ]
            },
            button: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-pressed"
                ],
                superclassRole: [
                    "command"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            caption: {
                type: "structure",
                requiredContext: [
                    "figure",
                    "table",
                    "grid",
                    "treegrid"
                ],
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            cell: {
                type: "structure",
                requiredContext: [
                    "row"
                ],
                allowedAttrs: [
                    "aria-colindex",
                    "aria-colspan",
                    "aria-rowindex",
                    "aria-rowspan",
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                nameFromContent: true
            },
            checkbox: {
                type: "widget",
                requiredAttrs: [
                    "aria-checked"
                ],
                allowedAttrs: [
                    "aria-readonly",
                    "aria-expanded",
                    "aria-required"
                ],
                superclassRole: [
                    "input"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            code: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            columnheader: {
                type: "structure",
                requiredContext: [
                    "row"
                ],
                allowedAttrs: [
                    "aria-sort",
                    "aria-colindex",
                    "aria-colspan",
                    "aria-expanded",
                    "aria-readonly",
                    "aria-required",
                    "aria-rowindex",
                    "aria-rowspan",
                    "aria-selected"
                ],
                superclassRole: [
                    "cell",
                    "gridcell",
                    "sectionhead"
                ],
                accessibleNameRequired: false,
                nameFromContent: true
            },
            combobox: {
                type: "widget",
                requiredAttrs: [
                    "aria-expanded",
                    "aria-controls"
                ],
                allowedAttrs: [
                    "aria-owns",
                    "aria-autocomplete",
                    "aria-readonly",
                    "aria-required",
                    "aria-activedescendant",
                    "aria-orientation"
                ],
                superclassRole: [
                    "select"
                ],
                accessibleNameRequired: true
            },
            command: {
                type: "abstract",
                superclassRole: [
                    "widget"
                ]
            },
            complementary: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            composite: {
                type: "abstract",
                superclassRole: [
                    "widget"
                ]
            },
            contentinfo: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            comment: {
                type: "structure",
                allowedAttrs: [
                    "aria-level",
                    "aria-posinset",
                    "aria-setsize"
                ],
                superclassRole: [
                    "article"
                ]
            },
            definition: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            deletion: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            dialog: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-modal"
                ],
                superclassRole: [
                    "window"
                ],
                accessibleNameRequired: true
            },
            directory: {
                type: "structure",
                deprecated: true,
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "list"
                ],
                nameFromContent: true
            },
            document: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "structure"
                ]
            },
            emphasis: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            feed: {
                type: "structure",
                requiredOwned: [
                    "article"
                ],
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "list"
                ]
            },
            figure: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                nameFromContent: true
            },
            form: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            grid: {
                type: "composite",
                requiredOwned: [
                    "rowgroup",
                    "row"
                ],
                allowedAttrs: [
                    "aria-level",
                    "aria-multiselectable",
                    "aria-readonly",
                    "aria-activedescendant",
                    "aria-colcount",
                    "aria-expanded",
                    "aria-rowcount"
                ],
                superclassRole: [
                    "composite",
                    "table"
                ],
                accessibleNameRequired: false
            },
            gridcell: {
                type: "widget",
                requiredContext: [
                    "row"
                ],
                allowedAttrs: [
                    "aria-readonly",
                    "aria-required",
                    "aria-selected",
                    "aria-colindex",
                    "aria-colspan",
                    "aria-expanded",
                    "aria-rowindex",
                    "aria-rowspan"
                ],
                superclassRole: [
                    "cell",
                    "widget"
                ],
                nameFromContent: true
            },
            group: {
                type: "structure",
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            heading: {
                type: "structure",
                requiredAttrs: [
                    "aria-level"
                ],
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "sectionhead"
                ],
                accessibleNameRequired: false,
                nameFromContent: true
            },
            img: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                accessibleNameRequired: true,
                childrenPresentational: true
            },
            input: {
                type: "abstract",
                superclassRole: [
                    "widget"
                ]
            },
            insertion: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            landmark: {
                type: "abstract",
                superclassRole: [
                    "section"
                ]
            },
            link: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "command"
                ],
                accessibleNameRequired: true,
                nameFromContent: true
            },
            list: {
                type: "structure",
                requiredOwned: [
                    "listitem"
                ],
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            listbox: {
                type: "widget",
                requiredOwned: [
                    "group",
                    "option"
                ],
                allowedAttrs: [
                    "aria-multiselectable",
                    "aria-readonly",
                    "aria-required",
                    "aria-activedescendant",
                    "aria-expanded",
                    "aria-orientation"
                ],
                superclassRole: [
                    "select"
                ],
                accessibleNameRequired: true
            },
            listitem: {
                type: "structure",
                requiredContext: [
                    "list"
                ],
                allowedAttrs: [
                    "aria-level",
                    "aria-posinset",
                    "aria-setsize",
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                nameFromContent: true
            },
            log: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            main: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            marquee: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            math: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                childrenPresentational: true
            },
            menu: {
                type: "composite",
                requiredOwned: [
                    "group",
                    "menuitemradio",
                    "menuitem",
                    "menuitemcheckbox",
                    "menu",
                    "separator"
                ],
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-expanded",
                    "aria-orientation"
                ],
                superclassRole: [
                    "select"
                ]
            },
            menubar: {
                type: "composite",
                requiredOwned: [
                    "group",
                    "menuitemradio",
                    "menuitem",
                    "menuitemcheckbox",
                    "menu",
                    "separator"
                ],
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-expanded",
                    "aria-orientation"
                ],
                superclassRole: [
                    "menu"
                ]
            },
            menuitem: {
                type: "widget",
                requiredContext: [
                    "menu",
                    "menubar",
                    "group"
                ],
                allowedAttrs: [
                    "aria-posinset",
                    "aria-setsize",
                    "aria-expanded"
                ],
                superclassRole: [
                    "command"
                ],
                accessibleNameRequired: true,
                nameFromContent: true
            },
            menuitemcheckbox: {
                type: "widget",
                requiredContext: [
                    "menu",
                    "menubar",
                    "group"
                ],
                requiredAttrs: [
                    "aria-checked"
                ],
                allowedAttrs: [
                    "aria-expanded",
                    "aria-posinset",
                    "aria-readonly",
                    "aria-setsize"
                ],
                superclassRole: [
                    "checkbox",
                    "menuitem"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            menuitemradio: {
                type: "widget",
                requiredContext: [
                    "menu",
                    "menubar",
                    "group"
                ],
                requiredAttrs: [
                    "aria-checked"
                ],
                allowedAttrs: [
                    "aria-expanded",
                    "aria-posinset",
                    "aria-readonly",
                    "aria-setsize"
                ],
                superclassRole: [
                    "menuitemcheckbox",
                    "radio"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            meter: {
                type: "structure",
                requiredAttrs: [
                    "aria-valuenow"
                ],
                allowedAttrs: [
                    "aria-valuemax",
                    "aria-valuemin",
                    "aria-valuetext"
                ],
                superclassRole: [
                    "range"
                ],
                accessibleNameRequired: true,
                childrenPresentational: true
            },
            mark: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            navigation: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            none: {
                type: "structure",
                superclassRole: [
                    "structure"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            note: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            option: {
                type: "widget",
                requiredContext: [
                    "group",
                    "listbox"
                ],
                allowedAttrs: [
                    "aria-selected",
                    "aria-checked",
                    "aria-posinset",
                    "aria-setsize"
                ],
                superclassRole: [
                    "input"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            paragraph: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            presentation: {
                type: "structure",
                superclassRole: [
                    "structure"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            progressbar: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-valuemax",
                    "aria-valuemin",
                    "aria-valuenow",
                    "aria-valuetext"
                ],
                superclassRole: [
                    "range"
                ],
                accessibleNameRequired: true,
                childrenPresentational: true
            },
            radio: {
                type: "widget",
                requiredAttrs: [
                    "aria-checked"
                ],
                allowedAttrs: [
                    "aria-posinset",
                    "aria-setsize",
                    "aria-required"
                ],
                superclassRole: [
                    "input"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            radiogroup: {
                type: "composite",
                allowedAttrs: [
                    "aria-readonly",
                    "aria-required",
                    "aria-activedescendant",
                    "aria-expanded",
                    "aria-orientation"
                ],
                superclassRole: [
                    "select"
                ],
                accessibleNameRequired: false
            },
            range: {
                type: "abstract",
                superclassRole: [
                    "widget"
                ]
            },
            region: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ],
                accessibleNameRequired: false
            },
            roletype: {
                type: "abstract",
                superclassRole: []
            },
            row: {
                type: "structure",
                requiredContext: [
                    "grid",
                    "rowgroup",
                    "table",
                    "treegrid"
                ],
                requiredOwned: [
                    "cell",
                    "columnheader",
                    "gridcell",
                    "rowheader"
                ],
                allowedAttrs: [
                    "aria-colindex",
                    "aria-level",
                    "aria-rowindex",
                    "aria-selected",
                    "aria-activedescendant",
                    "aria-expanded",
                    "aria-posinset",
                    "aria-setsize"
                ],
                superclassRole: [
                    "group",
                    "widget"
                ],
                nameFromContent: true
            },
            rowgroup: {
                type: "structure",
                requiredContext: [
                    "grid",
                    "table",
                    "treegrid"
                ],
                requiredOwned: [
                    "row"
                ],
                superclassRole: [
                    "structure"
                ],
                nameFromContent: true
            },
            rowheader: {
                type: "structure",
                requiredContext: [
                    "row"
                ],
                allowedAttrs: [
                    "aria-sort",
                    "aria-colindex",
                    "aria-colspan",
                    "aria-expanded",
                    "aria-readonly",
                    "aria-required",
                    "aria-rowindex",
                    "aria-rowspan",
                    "aria-selected"
                ],
                superclassRole: [
                    "cell",
                    "gridcell",
                    "sectionhead"
                ],
                accessibleNameRequired: false,
                nameFromContent: true
            },
            scrollbar: {
                type: "widget",
                requiredAttrs: [
                    "aria-valuenow"
                ],
                allowedAttrs: [
                    "aria-controls",
                    "aria-orientation",
                    "aria-valuemax",
                    "aria-valuemin",
                    "aria-valuetext"
                ],
                superclassRole: [
                    "range"
                ],
                childrenPresentational: true
            },
            search: {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            searchbox: {
                type: "widget",
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-autocomplete",
                    "aria-multiline",
                    "aria-placeholder",
                    "aria-readonly",
                    "aria-required"
                ],
                superclassRole: [
                    "textbox"
                ],
                accessibleNameRequired: true
            },
            section: {
                type: "abstract",
                superclassRole: [
                    "structure"
                ],
                nameFromContent: true
            },
            sectionhead: {
                type: "abstract",
                superclassRole: [
                    "structure"
                ],
                nameFromContent: true
            },
            select: {
                type: "abstract",
                superclassRole: [
                    "composite",
                    "group"
                ]
            },
            separator: {
                type: "structure",
                requiredAttrs: [
                    "aria-valuenow"
                ],
                allowedAttrs: [
                    "aria-valuemax",
                    "aria-valuemin",
                    "aria-orientation",
                    "aria-valuetext"
                ],
                superclassRole: [
                    "structure",
                    "widget"
                ],
                childrenPresentational: true
            },
            slider: {
                type: "widget",
                requiredAttrs: [
                    "aria-valuenow"
                ],
                allowedAttrs: [
                    "aria-valuemax",
                    "aria-valuemin",
                    "aria-orientation",
                    "aria-readonly",
                    "aria-required",
                    "aria-valuetext"
                ],
                superclassRole: [
                    "input",
                    "range"
                ],
                accessibleNameRequired: true,
                childrenPresentational: true
            },
            spinbutton: {
                type: "widget",
                allowedAttrs: [
                    "aria-valuemax",
                    "aria-valuemin",
                    "aria-readonly",
                    "aria-required",
                    "aria-activedescendant",
                    "aria-valuetext",
                    "aria-valuenow"
                ],
                superclassRole: [
                    "composite",
                    "input",
                    "range"
                ],
                accessibleNameRequired: true
            },
            status: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            strong: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            structure: {
                type: "abstract",
                superclassRole: [
                    "roletype"
                ]
            },
            subscript: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            superscript: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            switch: {
                type: "widget",
                requiredAttrs: [
                    "aria-checked"
                ],
                allowedAttrs: [
                    "aria-expanded",
                    "aria-readonly",
                    "aria-required"
                ],
                superclassRole: [
                    "checkbox"
                ],
                accessibleNameRequired: true,
                nameFromContent: true,
                childrenPresentational: true
            },
            suggestion: {
                type: "structure",
                requiredOwned: [
                    "insertion",
                    "deletion"
                ],
                superclassRole: [
                    "section"
                ],
                prohibitedAttrs: [
                    "aria-label",
                    "aria-labelledby"
                ]
            },
            tab: {
                type: "widget",
                requiredContext: [
                    "tablist"
                ],
                allowedAttrs: [
                    "aria-posinset",
                    "aria-selected",
                    "aria-setsize",
                    "aria-expanded"
                ],
                superclassRole: [
                    "sectionhead",
                    "widget"
                ],
                nameFromContent: true,
                childrenPresentational: true
            },
            table: {
                type: "structure",
                requiredOwned: [
                    "rowgroup",
                    "row"
                ],
                allowedAttrs: [
                    "aria-colcount",
                    "aria-rowcount",
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                accessibleNameRequired: false,
                nameFromContent: true
            },
            tablist: {
                type: "composite",
                requiredOwned: [
                    "tab"
                ],
                allowedAttrs: [
                    "aria-level",
                    "aria-multiselectable",
                    "aria-orientation",
                    "aria-activedescendant",
                    "aria-expanded"
                ],
                superclassRole: [
                    "composite"
                ]
            },
            tabpanel: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                accessibleNameRequired: false
            },
            term: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                nameFromContent: true
            },
            text: {
                type: "structure",
                superclassRole: [
                    "section"
                ],
                nameFromContent: true
            },
            textbox: {
                type: "widget",
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-autocomplete",
                    "aria-multiline",
                    "aria-placeholder",
                    "aria-readonly",
                    "aria-required"
                ],
                superclassRole: [
                    "input"
                ],
                accessibleNameRequired: true
            },
            time: {
                type: "structure",
                superclassRole: [
                    "section"
                ]
            },
            timer: {
                type: "widget",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "status"
                ]
            },
            toolbar: {
                type: "structure",
                allowedAttrs: [
                    "aria-orientation",
                    "aria-activedescendant",
                    "aria-expanded"
                ],
                superclassRole: [
                    "group"
                ],
                accessibleNameRequired: true
            },
            tooltip: {
                type: "structure",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ],
                nameFromContent: true
            },
            tree: {
                type: "composite",
                requiredOwned: [
                    "group",
                    "treeitem"
                ],
                allowedAttrs: [
                    "aria-multiselectable",
                    "aria-required",
                    "aria-activedescendant",
                    "aria-expanded",
                    "aria-orientation"
                ],
                superclassRole: [
                    "select"
                ],
                accessibleNameRequired: false
            },
            treegrid: {
                type: "composite",
                requiredOwned: [
                    "rowgroup",
                    "row"
                ],
                allowedAttrs: [
                    "aria-activedescendant",
                    "aria-colcount",
                    "aria-expanded",
                    "aria-level",
                    "aria-multiselectable",
                    "aria-orientation",
                    "aria-readonly",
                    "aria-required",
                    "aria-rowcount"
                ],
                superclassRole: [
                    "grid",
                    "tree"
                ],
                accessibleNameRequired: false
            },
            treeitem: {
                type: "widget",
                requiredContext: [
                    "group",
                    "tree"
                ],
                allowedAttrs: [
                    "aria-checked",
                    "aria-expanded",
                    "aria-level",
                    "aria-posinset",
                    "aria-selected",
                    "aria-setsize"
                ],
                superclassRole: [
                    "listitem",
                    "option"
                ],
                accessibleNameRequired: true,
                nameFromContent: true
            },
            widget: {
                type: "abstract",
                superclassRole: [
                    "roletype"
                ]
            },
            window: {
                type: "abstract",
                superclassRole: [
                    "roletype"
                ]
            }
        };
        var aria_roles_default = ariaRoles;
        var dpubRoles = {
            "doc-abstract": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-acknowledgments": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-afterword": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-appendix": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-backlink": {
                type: "link",
                allowedAttrs: [
                    "aria-expanded"
                ],
                nameFromContent: true,
                superclassRole: [
                    "link"
                ]
            },
            "doc-biblioentry": {
                type: "listitem",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-level",
                    "aria-posinset",
                    "aria-setsize"
                ],
                superclassRole: [
                    "listitem"
                ],
                deprecated: true
            },
            "doc-bibliography": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-biblioref": {
                type: "link",
                allowedAttrs: [
                    "aria-expanded"
                ],
                nameFromContent: true,
                superclassRole: [
                    "link"
                ]
            },
            "doc-chapter": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-colophon": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-conclusion": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-cover": {
                type: "img",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "img"
                ]
            },
            "doc-credit": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-credits": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-dedication": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-endnote": {
                type: "listitem",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-level",
                    "aria-posinset",
                    "aria-setsize"
                ],
                superclassRole: [
                    "listitem"
                ],
                deprecated: true
            },
            "doc-endnotes": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-epigraph": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-epilogue": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-errata": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-example": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-footnote": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-foreword": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-glossary": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-glossref": {
                type: "link",
                allowedAttrs: [
                    "aria-expanded"
                ],
                nameFromContent: true,
                superclassRole: [
                    "link"
                ]
            },
            "doc-index": {
                type: "navigation",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "navigation"
                ]
            },
            "doc-introduction": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-noteref": {
                type: "link",
                allowedAttrs: [
                    "aria-expanded"
                ],
                nameFromContent: true,
                superclassRole: [
                    "link"
                ]
            },
            "doc-notice": {
                type: "note",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "note"
                ]
            },
            "doc-pagebreak": {
                type: "separator",
                allowedAttrs: [
                    "aria-expanded",
                    "aria-orientation"
                ],
                superclassRole: [
                    "separator"
                ],
                childrenPresentational: true
            },
            "doc-pagelist": {
                type: "navigation",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "navigation"
                ]
            },
            "doc-part": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-preface": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-prologue": {
                type: "landmark",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "landmark"
                ]
            },
            "doc-pullquote": {
                type: "none",
                superclassRole: [
                    "none"
                ]
            },
            "doc-qna": {
                type: "section",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "section"
                ]
            },
            "doc-subtitle": {
                type: "sectionhead",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "sectionhead"
                ]
            },
            "doc-tip": {
                type: "note",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "note"
                ]
            },
            "doc-toc": {
                type: "navigation",
                allowedAttrs: [
                    "aria-expanded"
                ],
                superclassRole: [
                    "navigation"
                ]
            }
        };
        var dpub_roles_default = dpubRoles;
        var graphicsRoles = {
            "graphics-document": {
                type: "structure",
                superclassRole: [
                    "document"
                ],
                accessibleNameRequired: true
            },
            "graphics-object": {
                type: "structure",
                superclassRole: [
                    "group"
                ],
                nameFromContent: true
            },
            "graphics-symbol": {
                type: "structure",
                superclassRole: [
                    "img"
                ],
                accessibleNameRequired: true,
                childrenPresentational: true
            }
        };
        var graphics_roles_default = graphicsRoles;
        var htmlElms = {
            a: {
                variant: {
                    href: {
                        matches: "[href]",
                        contentTypes: [
                            "interactive",
                            "phrasing",
                            "flow"
                        ],
                        allowedRoles: [
                            "button",
                            "checkbox",
                            "menuitem",
                            "menuitemcheckbox",
                            "menuitemradio",
                            "option",
                            "radio",
                            "switch",
                            "tab",
                            "treeitem",
                            "doc-backlink",
                            "doc-biblioref",
                            "doc-glossref",
                            "doc-noteref"
                        ],
                        namingMethods: [
                            "subtreeText"
                        ]
                    },
                    default: {
                        contentTypes: [
                            "phrasing",
                            "flow"
                        ],
                        allowedRoles: true
                    }
                }
            },
            abbr: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            address: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true
            },
            area: {
                variant: {
                    href: {
                        matches: "[href]",
                        allowedRoles: false
                    },
                    default: {
                        allowedRoles: [
                            "button",
                            "link"
                        ]
                    }
                },
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                namingMethods: [
                    "altText"
                ]
            },
            article: {
                contentTypes: [
                    "sectioning",
                    "flow"
                ],
                allowedRoles: [
                    "feed",
                    "presentation",
                    "none",
                    "document",
                    "application",
                    "main",
                    "region"
                ],
                shadowRoot: true
            },
            aside: {
                contentTypes: [
                    "sectioning",
                    "flow"
                ],
                allowedRoles: [
                    "feed",
                    "note",
                    "presentation",
                    "none",
                    "region",
                    "search",
                    "doc-dedication",
                    "doc-example",
                    "doc-footnote",
                    "doc-glossary",
                    "doc-pullquote",
                    "doc-tip"
                ]
            },
            audio: {
                variant: {
                    controls: {
                        matches: "[controls]",
                        contentTypes: [
                            "interactive",
                            "embedded",
                            "phrasing",
                            "flow"
                        ]
                    },
                    default: {
                        contentTypes: [
                            "embedded",
                            "phrasing",
                            "flow"
                        ]
                    }
                },
                allowedRoles: [
                    "application"
                ],
                chromiumRole: "Audio"
            },
            b: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            base: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            bdi: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            bdo: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            blockquote: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true,
                shadowRoot: true
            },
            body: {
                allowedRoles: false,
                shadowRoot: true
            },
            br: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: [
                    "presentation",
                    "none"
                ],
                namingMethods: [
                    "titleText",
                    "singleSpace"
                ]
            },
            button: {
                contentTypes: [
                    "interactive",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: [
                    "checkbox",
                    "combobox",
                    "link",
                    "menuitem",
                    "menuitemcheckbox",
                    "menuitemradio",
                    "option",
                    "radio",
                    "switch",
                    "tab"
                ],
                namingMethods: [
                    "subtreeText"
                ]
            },
            canvas: {
                allowedRoles: true,
                contentTypes: [
                    "embedded",
                    "phrasing",
                    "flow"
                ],
                chromiumRole: "Canvas"
            },
            caption: {
                allowedRoles: false
            },
            cite: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            code: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            col: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            colgroup: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            data: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            datalist: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true,
                implicitAttrs: {
                    "aria-multiselectable": "false"
                }
            },
            dd: {
                allowedRoles: false
            },
            del: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            dfn: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            details: {
                contentTypes: [
                    "interactive",
                    "flow"
                ],
                allowedRoles: false
            },
            dialog: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "alertdialog"
                ]
            },
            div: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true,
                shadowRoot: true
            },
            dl: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "group",
                    "list",
                    "presentation",
                    "none"
                ],
                chromiumRole: "DescriptionList"
            },
            dt: {
                allowedRoles: [
                    "listitem"
                ]
            },
            em: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            embed: {
                contentTypes: [
                    "interactive",
                    "embedded",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: [
                    "application",
                    "document",
                    "img",
                    "presentation",
                    "none"
                ],
                chromiumRole: "EmbeddedObject"
            },
            fieldset: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "radiogroup"
                ],
                namingMethods: [
                    "fieldsetLegendText"
                ]
            },
            figcaption: {
                allowedRoles: [
                    "group",
                    "none",
                    "presentation"
                ]
            },
            figure: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true,
                namingMethods: [
                    "figureText",
                    "titleText"
                ]
            },
            footer: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "group",
                    "none",
                    "presentation",
                    "doc-footnote"
                ],
                shadowRoot: true
            },
            form: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "search",
                    "none",
                    "presentation"
                ]
            },
            h1: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "tab",
                    "doc-subtitle"
                ],
                shadowRoot: true,
                implicitAttrs: {
                    "aria-level": "1"
                }
            },
            h2: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "tab",
                    "doc-subtitle"
                ],
                shadowRoot: true,
                implicitAttrs: {
                    "aria-level": "2"
                }
            },
            h3: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "tab",
                    "doc-subtitle"
                ],
                shadowRoot: true,
                implicitAttrs: {
                    "aria-level": "3"
                }
            },
            h4: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "tab",
                    "doc-subtitle"
                ],
                shadowRoot: true,
                implicitAttrs: {
                    "aria-level": "4"
                }
            },
            h5: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "tab",
                    "doc-subtitle"
                ],
                shadowRoot: true,
                implicitAttrs: {
                    "aria-level": "5"
                }
            },
            h6: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "tab",
                    "doc-subtitle"
                ],
                shadowRoot: true,
                implicitAttrs: {
                    "aria-level": "6"
                }
            },
            head: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            header: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "group",
                    "none",
                    "presentation",
                    "doc-footnote"
                ],
                shadowRoot: true
            },
            hgroup: {
                contentTypes: [
                    "heading",
                    "flow"
                ],
                allowedRoles: true
            },
            hr: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "none",
                    "presentation",
                    "doc-pagebreak"
                ],
                namingMethods: [
                    "titleText",
                    "singleSpace"
                ]
            },
            html: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            i: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            iframe: {
                contentTypes: [
                    "interactive",
                    "embedded",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: [
                    "application",
                    "document",
                    "img",
                    "none",
                    "presentation"
                ],
                chromiumRole: "Iframe"
            },
            img: {
                variant: {
                    nonEmptyAlt: {
                        matches: [
                            {
                                attributes: {
                                    alt: "/.+/"
                                }
                            },
                            {
                                hasAccessibleName: true
                            }
                        ],
                        allowedRoles: [
                            "button",
                            "checkbox",
                            "link",
                            "menuitem",
                            "menuitemcheckbox",
                            "menuitemradio",
                            "meter",
                            "option",
                            "progressbar",
                            "radio",
                            "scrollbar",
                            "separator",
                            "slider",
                            "switch",
                            "tab",
                            "treeitem",
                            "doc-cover"
                        ]
                    },
                    usemap: {
                        matches: "[usemap]",
                        contentTypes: [
                            "interactive",
                            "embedded",
                            "flow"
                        ]
                    },
                    default: {
                        allowedRoles: [
                            "presentation",
                            "none"
                        ],
                        contentTypes: [
                            "embedded",
                            "flow"
                        ]
                    }
                },
                namingMethods: [
                    "altText"
                ]
            },
            input: {
                variant: {
                    button: {
                        matches: {
                            properties: {
                                type: "button"
                            }
                        },
                        allowedRoles: [
                            "checkbox",
                            "combobox",
                            "link",
                            "menuitem",
                            "menuitemcheckbox",
                            "menuitemradio",
                            "option",
                            "radio",
                            "switch",
                            "tab"
                        ]
                    },
                    buttonType: {
                        matches: {
                            properties: {
                                type: [
                                    "button",
                                    "submit",
                                    "reset"
                                ]
                            }
                        },
                        namingMethods: [
                            "valueText",
                            "titleText",
                            "buttonDefaultText"
                        ]
                    },
                    checkboxPressed: {
                        matches: {
                            properties: {
                                type: "checkbox"
                            },
                            attributes: {
                                "aria-pressed": "/.*/"
                            }
                        },
                        allowedRoles: [
                            "button",
                            "menuitemcheckbox",
                            "option",
                            "switch"
                        ],
                        implicitAttrs: {
                            "aria-checked": "false"
                        }
                    },
                    checkbox: {
                        matches: {
                            properties: {
                                type: "checkbox"
                            },
                            attributes: {
                                "aria-pressed": null
                            }
                        },
                        allowedRoles: [
                            "menuitemcheckbox",
                            "option",
                            "switch"
                        ],
                        implicitAttrs: {
                            "aria-checked": "false"
                        }
                    },
                    noRoles: {
                        matches: {
                            properties: {
                                type: [
                                    "color",
                                    "date",
                                    "datetime-local",
                                    "file",
                                    "month",
                                    "number",
                                    "password",
                                    "range",
                                    "reset",
                                    "submit",
                                    "time",
                                    "week"
                                ]
                            }
                        },
                        allowedRoles: false
                    },
                    hidden: {
                        matches: {
                            properties: {
                                type: "hidden"
                            }
                        },
                        contentTypes: [
                            "flow"
                        ],
                        allowedRoles: false,
                        noAriaAttrs: true
                    },
                    image: {
                        matches: {
                            properties: {
                                type: "image"
                            }
                        },
                        allowedRoles: [
                            "link",
                            "menuitem",
                            "menuitemcheckbox",
                            "menuitemradio",
                            "radio",
                            "switch"
                        ],
                        namingMethods: [
                            "altText",
                            "valueText",
                            "labelText",
                            "titleText",
                            "buttonDefaultText"
                        ]
                    },
                    radio: {
                        matches: {
                            properties: {
                                type: "radio"
                            }
                        },
                        allowedRoles: [
                            "menuitemradio"
                        ],
                        implicitAttrs: {
                            "aria-checked": "false"
                        }
                    },
                    textWithList: {
                        matches: {
                            properties: {
                                type: "text"
                            },
                            attributes: {
                                list: "/.*/"
                            }
                        },
                        allowedRoles: false
                    },
                    default: {
                        contentTypes: [
                            "interactive",
                            "flow"
                        ],
                        allowedRoles: [
                            "combobox",
                            "searchbox",
                            "spinbutton"
                        ],
                        implicitAttrs: {
                            "aria-valuenow": ""
                        },
                        namingMethods: [
                            "labelText",
                            "placeholderText"
                        ]
                    }
                }
            },
            ins: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            kbd: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            label: {
                contentTypes: [
                    "interactive",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                chromiumRole: "Label"
            },
            legend: {
                allowedRoles: false
            },
            li: {
                allowedRoles: [
                    "menuitem",
                    "menuitemcheckbox",
                    "menuitemradio",
                    "option",
                    "none",
                    "presentation",
                    "radio",
                    "separator",
                    "tab",
                    "treeitem",
                    "doc-biblioentry",
                    "doc-endnote"
                ],
                implicitAttrs: {
                    "aria-setsize": "1",
                    "aria-posinset": "1"
                }
            },
            link: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            main: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: false,
                shadowRoot: true
            },
            map: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            math: {
                contentTypes: [
                    "embedded",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false
            },
            mark: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            menu: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "directory",
                    "group",
                    "listbox",
                    "menu",
                    "menubar",
                    "none",
                    "presentation",
                    "radiogroup",
                    "tablist",
                    "toolbar",
                    "tree"
                ]
            },
            meta: {
                variant: {
                    itemprop: {
                        matches: "[itemprop]",
                        contentTypes: [
                            "phrasing",
                            "flow"
                        ]
                    }
                },
                allowedRoles: false,
                noAriaAttrs: true
            },
            meter: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                chromiumRole: "progressbar"
            },
            nav: {
                contentTypes: [
                    "sectioning",
                    "flow"
                ],
                allowedRoles: [
                    "doc-index",
                    "doc-pagelist",
                    "doc-toc",
                    "menu",
                    "menubar",
                    "none",
                    "presentation",
                    "tablist"
                ],
                shadowRoot: true
            },
            noscript: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            object: {
                variant: {
                    usemap: {
                        matches: "[usemap]",
                        contentTypes: [
                            "interactive",
                            "embedded",
                            "phrasing",
                            "flow"
                        ]
                    },
                    default: {
                        contentTypes: [
                            "embedded",
                            "phrasing",
                            "flow"
                        ]
                    }
                },
                allowedRoles: [
                    "application",
                    "document",
                    "img"
                ],
                chromiumRole: "PluginObject"
            },
            ol: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "directory",
                    "group",
                    "listbox",
                    "menu",
                    "menubar",
                    "none",
                    "presentation",
                    "radiogroup",
                    "tablist",
                    "toolbar",
                    "tree"
                ]
            },
            optgroup: {
                allowedRoles: false
            },
            option: {
                allowedRoles: false,
                implicitAttrs: {
                    "aria-selected": "false"
                }
            },
            output: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true,
                namingMethods: [
                    "subtreeText"
                ]
            },
            p: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true,
                shadowRoot: true
            },
            param: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            picture: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            pre: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true
            },
            progress: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                implicitAttrs: {
                    "aria-valuemax": "100",
                    "aria-valuemin": "0",
                    "aria-valuenow": "0"
                }
            },
            q: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            rp: {
                allowedRoles: true
            },
            rt: {
                allowedRoles: true
            },
            ruby: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            s: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            samp: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            script: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            search: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "form",
                    "group",
                    "none",
                    "presentation",
                    "region",
                    "search"
                ]
            },
            section: {
                contentTypes: [
                    "sectioning",
                    "flow"
                ],
                allowedRoles: [
                    "alert",
                    "alertdialog",
                    "application",
                    "banner",
                    "complementary",
                    "contentinfo",
                    "dialog",
                    "document",
                    "feed",
                    "group",
                    "log",
                    "main",
                    "marquee",
                    "navigation",
                    "none",
                    "note",
                    "presentation",
                    "search",
                    "status",
                    "tabpanel",
                    "doc-abstract",
                    "doc-acknowledgments",
                    "doc-afterword",
                    "doc-appendix",
                    "doc-bibliography",
                    "doc-chapter",
                    "doc-colophon",
                    "doc-conclusion",
                    "doc-credit",
                    "doc-credits",
                    "doc-dedication",
                    "doc-endnotes",
                    "doc-epigraph",
                    "doc-epilogue",
                    "doc-errata",
                    "doc-example",
                    "doc-foreword",
                    "doc-glossary",
                    "doc-index",
                    "doc-introduction",
                    "doc-notice",
                    "doc-pagelist",
                    "doc-part",
                    "doc-preface",
                    "doc-prologue",
                    "doc-pullquote",
                    "doc-qna",
                    "doc-toc"
                ],
                shadowRoot: true
            },
            select: {
                variant: {
                    combobox: {
                        matches: {
                            attributes: {
                                multiple: null,
                                size: [
                                    null,
                                    "1"
                                ]
                            }
                        },
                        allowedRoles: [
                            "menu"
                        ]
                    },
                    default: {
                        allowedRoles: false
                    }
                },
                contentTypes: [
                    "interactive",
                    "phrasing",
                    "flow"
                ],
                implicitAttrs: {
                    "aria-valuenow": ""
                },
                namingMethods: [
                    "labelText"
                ]
            },
            slot: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            small: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            source: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            span: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true,
                shadowRoot: true
            },
            strong: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            style: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            svg: {
                contentTypes: [
                    "embedded",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true,
                chromiumRole: "SVGRoot",
                namingMethods: [
                    "svgTitleText"
                ]
            },
            sub: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            summary: {
                allowedRoles: false,
                namingMethods: [
                    "subtreeText"
                ]
            },
            sup: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            table: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: true,
                namingMethods: [
                    "tableCaptionText",
                    "tableSummaryText"
                ]
            },
            tbody: {
                allowedRoles: true
            },
            template: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                noAriaAttrs: true
            },
            textarea: {
                contentTypes: [
                    "interactive",
                    "phrasing",
                    "flow"
                ],
                allowedRoles: false,
                implicitAttrs: {
                    "aria-valuenow": "",
                    "aria-multiline": "true"
                },
                namingMethods: [
                    "labelText",
                    "placeholderText"
                ]
            },
            tfoot: {
                allowedRoles: true
            },
            thead: {
                allowedRoles: true
            },
            time: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            title: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            td: {
                allowedRoles: true
            },
            th: {
                allowedRoles: true
            },
            tr: {
                allowedRoles: true
            },
            track: {
                allowedRoles: false,
                noAriaAttrs: true
            },
            u: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            ul: {
                contentTypes: [
                    "flow"
                ],
                allowedRoles: [
                    "directory",
                    "group",
                    "listbox",
                    "menu",
                    "menubar",
                    "none",
                    "presentation",
                    "radiogroup",
                    "tablist",
                    "toolbar",
                    "tree"
                ]
            },
            var: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: true
            },
            video: {
                variant: {
                    controls: {
                        matches: "[controls]",
                        contentTypes: [
                            "interactive",
                            "embedded",
                            "phrasing",
                            "flow"
                        ]
                    },
                    default: {
                        contentTypes: [
                            "embedded",
                            "phrasing",
                            "flow"
                        ]
                    }
                },
                allowedRoles: [
                    "application"
                ],
                chromiumRole: "video"
            },
            wbr: {
                contentTypes: [
                    "phrasing",
                    "flow"
                ],
                allowedRoles: [
                    "presentation",
                    "none"
                ]
            }
        };
        var html_elms_default = htmlElms;
        var cssColors = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        var css_colors_default = cssColors;
        var originals = {
            ariaAttrs: aria_attrs_default,
            ariaRoles: _extends({}, aria_roles_default, dpub_roles_default, graphics_roles_default),
            htmlElms: html_elms_default,
            cssColors: css_colors_default
        };
        var standards = _extends({}, originals);
        function configureStandards(config) {
            Object.keys(standards).forEach(function(propName) {
                if (config[propName]) standards[propName] = deep_merge_default(standards[propName], config[propName]);
            });
        }
        function resetStandards() {
            Object.keys(standards).forEach(function(propName) {
                standards[propName] = originals[propName];
            });
        }
        var standards_default = standards;
        function isUnsupportedRole(role) {
            var roleDefinition = standards_default.ariaRoles[role];
            return roleDefinition ? !!roleDefinition.unsupported : false;
        }
        var is_unsupported_role_default = isUnsupportedRole;
        function isValidRole(role) {
            var _ref26 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowAbstract = _ref26.allowAbstract, _ref26$flagUnsupporte = _ref26.flagUnsupported, flagUnsupported = _ref26$flagUnsupporte === void 0 ? false : _ref26$flagUnsupporte;
            var roleDefinition = standards_default.ariaRoles[role];
            var isRoleUnsupported = is_unsupported_role_default(role);
            if (!roleDefinition || flagUnsupported && isRoleUnsupported) return false;
            return allowAbstract ? true : roleDefinition.type !== "abstract";
        }
        var is_valid_role_default = isValidRole;
        function getExplicitRole(vNode) {
            var _ref27 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fallback = _ref27.fallback, abstracts = _ref27.abstracts, dpub = _ref27.dpub;
            vNode = vNode instanceof abstract_virtual_node_default ? vNode : get_node_from_tree_default(vNode);
            if (vNode.props.nodeType !== 1) return null;
            var roleAttr = (vNode.attr("role") || "").trim().toLowerCase();
            var roleList = fallback ? token_list_default(roleAttr) : [
                roleAttr
            ];
            var firstValidRole = roleList.find(function(role) {
                if (!dpub && role.substr(0, 4) === "doc-") return false;
                return is_valid_role_default(role, {
                    allowAbstract: abstracts
                });
            });
            return firstValidRole || null;
        }
        var get_explicit_role_default = getExplicitRole;
        function getElementsByContentType(type2) {
            return Object.keys(standards_default.htmlElms).filter(function(nodeName2) {
                var elm = standards_default.htmlElms[nodeName2];
                if (elm.contentTypes) return elm.contentTypes.includes(type2);
                if (!elm.variant) return false;
                if (elm.variant["default"] && elm.variant["default"].contentTypes) return elm.variant["default"].contentTypes.includes(type2);
                return false;
            });
        }
        var get_elements_by_content_type_default = getElementsByContentType;
        function getGlobalAriaAttrs() {
            return cache_default.get("globalAriaAttrs", function() {
                return Object.keys(standards_default.ariaAttrs).filter(function(attrName) {
                    return standards_default.ariaAttrs[attrName].global;
                });
            });
        }
        var get_global_aria_attrs_default = getGlobalAriaAttrs;
        function toGrid(node) {
            var table = [];
            var rows = node.rows;
            for(var i = 0, rowLength = rows.length; i < rowLength; i++){
                var cells = rows[i].cells;
                table[i] = table[i] || [];
                var columnIndex = 0;
                for(var j = 0, cellLength = cells.length; j < cellLength; j++)for(var colSpan = 0; colSpan < cells[j].colSpan; colSpan++){
                    var rowspanAttr = cells[j].getAttribute("rowspan");
                    var rowspanValue = parseInt(rowspanAttr) === 0 || cells[j].rowspan === 0 ? rows.length : cells[j].rowSpan;
                    for(var rowSpan = 0; rowSpan < rowspanValue; rowSpan++){
                        table[i + rowSpan] = table[i + rowSpan] || [];
                        while(table[i + rowSpan][columnIndex])columnIndex++;
                        table[i + rowSpan][columnIndex] = cells[j];
                    }
                    columnIndex++;
                }
            }
            return table;
        }
        var to_grid_default = memoize_default(toGrid);
        function getCellPosition(cell, tableGrid) {
            var rowIndex, index;
            if (!tableGrid) tableGrid = to_grid_default(find_up_default(cell, "table"));
            for(rowIndex = 0; rowIndex < tableGrid.length; rowIndex++)if (tableGrid[rowIndex]) {
                index = tableGrid[rowIndex].indexOf(cell);
                if (index !== -1) return {
                    x: index,
                    y: rowIndex
                };
            }
        }
        var get_cell_position_default = memoize_default(getCellPosition);
        function _getScope(el) {
            var _nodeLookup9 = _nodeLookup(el), vNode = _nodeLookup9.vNode, cell = _nodeLookup9.domNode;
            var scope = vNode.attr("scope");
            var role = vNode.attr("role");
            if (![
                "td",
                "th"
            ].includes(vNode.props.nodeName)) throw new TypeError("Expected TD or TH element");
            if (role === "columnheader") return "col";
            else if (role === "rowheader") return "row";
            else if (scope === "col" || scope === "row") return scope;
            else if (vNode.props.nodeName !== "th") return false;
            else if (!vNode.actualNode) return "auto";
            var tableGrid = to_grid_default(find_up_default(cell, "table"));
            var pos = get_cell_position_default(cell, tableGrid);
            var headerRow = tableGrid[pos.y].every(function(node) {
                return node.nodeName.toUpperCase() === "TH";
            });
            if (headerRow) return "col";
            var headerCol = tableGrid.map(function(col) {
                return col[pos.x];
            }).every(function(node) {
                return node && node.nodeName.toUpperCase() === "TH";
            });
            if (headerCol) return "row";
            return "auto";
        }
        function isColumnHeader(element) {
            return [
                "col",
                "auto"
            ].indexOf(_getScope(element)) !== -1;
        }
        var is_column_header_default = isColumnHeader;
        function isRowHeader(cell) {
            return [
                "row",
                "auto"
            ].includes(_getScope(cell));
        }
        var is_row_header_default = isRowHeader;
        function sanitize(str) {
            if (!str) return "";
            return str.replace(/\r\n/g, "\n").replace(/\u00A0/g, " ").replace(/[\s]{2,}/g, " ").trim();
        }
        var sanitize_default = sanitize;
        var getSectioningElementSelector = function getSectioningElementSelector() {
            return cache_default.get("sectioningElementSelector", function() {
                return get_elements_by_content_type_default("sectioning").map(function(nodeName2) {
                    return "".concat(nodeName2, ":not([role])");
                }).join(", ") + " , main:not([role]), [role=article], [role=complementary], [role=main], [role=navigation], [role=region]";
            });
        };
        function hasAccessibleName(vNode) {
            var ariaLabelledby = sanitize_default(arialabelledby_text_default(vNode));
            var ariaLabel = sanitize_default(_arialabelText(vNode));
            return !!(ariaLabelledby || ariaLabel);
        }
        var implicitHtmlRoles = {
            a: function a(vNode) {
                return vNode.hasAttr("href") ? "link" : null;
            },
            area: function area(vNode) {
                return vNode.hasAttr("href") ? "link" : null;
            },
            article: "article",
            aside: "complementary",
            body: "document",
            button: "button",
            datalist: "listbox",
            dd: "definition",
            dfn: "term",
            details: "group",
            dialog: "dialog",
            dt: "term",
            fieldset: "group",
            figure: "figure",
            footer: function footer(vNode) {
                var sectioningElement = closest_default(vNode, getSectioningElementSelector());
                return !sectioningElement ? "contentinfo" : null;
            },
            form: function form(vNode) {
                return hasAccessibleName(vNode) ? "form" : null;
            },
            h1: "heading",
            h2: "heading",
            h3: "heading",
            h4: "heading",
            h5: "heading",
            h6: "heading",
            header: function header(vNode) {
                var sectioningElement = closest_default(vNode, getSectioningElementSelector());
                return !sectioningElement ? "banner" : null;
            },
            hr: "separator",
            img: function img(vNode) {
                var emptyAlt = vNode.hasAttr("alt") && !vNode.attr("alt");
                var hasGlobalAria = get_global_aria_attrs_default().find(function(attr) {
                    return vNode.hasAttr(attr);
                });
                return emptyAlt && !hasGlobalAria && !_isFocusable(vNode) ? "presentation" : "img";
            },
            input: function input(vNode) {
                var suggestionsSourceElement;
                if (vNode.hasAttr("list")) {
                    var listElement = idrefs_default(vNode.actualNode, "list").filter(function(node) {
                        return !!node;
                    })[0];
                    suggestionsSourceElement = listElement && listElement.nodeName.toLowerCase() === "datalist";
                }
                switch(vNode.props.type){
                    case "checkbox":
                        return "checkbox";
                    case "number":
                        return "spinbutton";
                    case "radio":
                        return "radio";
                    case "range":
                        return "slider";
                    case "search":
                        return !suggestionsSourceElement ? "searchbox" : "combobox";
                    case "button":
                    case "image":
                    case "reset":
                    case "submit":
                        return "button";
                    case "text":
                    case "tel":
                    case "url":
                    case "email":
                    case "":
                        return !suggestionsSourceElement ? "textbox" : "combobox";
                    default:
                        return "textbox";
                }
            },
            li: "listitem",
            main: "main",
            math: "math",
            menu: "list",
            nav: "navigation",
            ol: "list",
            optgroup: "group",
            option: "option",
            output: "status",
            progress: "progressbar",
            search: "search",
            section: function section(vNode) {
                return hasAccessibleName(vNode) ? "region" : null;
            },
            select: function select(vNode) {
                return vNode.hasAttr("multiple") || parseInt(vNode.attr("size")) > 1 ? "listbox" : "combobox";
            },
            summary: "button",
            table: "table",
            tbody: "rowgroup",
            td: function td(vNode) {
                var table = closest_default(vNode, "table");
                var role = get_explicit_role_default(table);
                return [
                    "grid",
                    "treegrid"
                ].includes(role) ? "gridcell" : "cell";
            },
            textarea: "textbox",
            tfoot: "rowgroup",
            th: function th(vNode) {
                if (is_column_header_default(vNode)) return "columnheader";
                if (is_row_header_default(vNode)) return "rowheader";
            },
            thead: "rowgroup",
            tr: "row",
            ul: "list"
        };
        var implicit_html_roles_default = implicitHtmlRoles;
        function fromPrimative(someString, matcher) {
            var matcherType = _typeof(matcher);
            if (Array.isArray(matcher) && typeof someString !== "undefined") return matcher.includes(someString);
            if (matcherType === "function") return !!matcher(someString);
            if (someString !== null && someString !== void 0) {
                if (matcher instanceof RegExp) return matcher.test(someString);
                if (/^\/.*\/$/.test(matcher)) {
                    var pattern = matcher.substring(1, matcher.length - 1);
                    return new RegExp(pattern).test(someString);
                }
            }
            return matcher === someString;
        }
        var from_primative_default = fromPrimative;
        function hasAccessibleName2(vNode, matcher) {
            return from_primative_default(!!_accessibleTextVirtual(vNode), matcher);
        }
        var has_accessible_name_default = hasAccessibleName2;
        function fromFunction(getValue, matcher) {
            var matcherType = _typeof(matcher);
            if (matcherType !== "object" || Array.isArray(matcher) || matcher instanceof RegExp) throw new Error("Expect matcher to be an object");
            return Object.keys(matcher).every(function(propName) {
                return from_primative_default(getValue(propName), matcher[propName]);
            });
        }
        var from_function_default = fromFunction;
        function attributes(vNode, matcher) {
            vNode = _nodeLookup(vNode).vNode;
            return from_function_default(function(attrName) {
                return vNode.attr(attrName);
            }, matcher);
        }
        var attributes_default = attributes;
        function condition(arg, matcher) {
            return !!matcher(arg);
        }
        function explicitRole(vNode, matcher) {
            return from_primative_default(get_explicit_role_default(vNode), matcher);
        }
        var explicit_role_default = explicitRole;
        function implicitRole(vNode, matcher) {
            return from_primative_default(implicit_role_default(vNode), matcher);
        }
        var implicit_role_default2 = implicitRole;
        function nodeName(vNode, matcher) {
            vNode = _nodeLookup(vNode).vNode;
            return from_primative_default(vNode.props.nodeName, matcher);
        }
        var node_name_default = nodeName;
        function properties(vNode, matcher) {
            vNode = _nodeLookup(vNode).vNode;
            return from_function_default(function(propName) {
                return vNode.props[propName];
            }, matcher);
        }
        var properties_default = properties;
        function semanticRole(vNode, matcher) {
            return from_primative_default(get_role_default(vNode), matcher);
        }
        var semantic_role_default = semanticRole;
        var matchers = {
            hasAccessibleName: has_accessible_name_default,
            attributes: attributes_default,
            condition: condition,
            explicitRole: explicit_role_default,
            implicitRole: implicit_role_default2,
            nodeName: node_name_default,
            properties: properties_default,
            semanticRole: semantic_role_default
        };
        function fromDefinition(vNode, definition) {
            vNode = _nodeLookup(vNode).vNode;
            if (Array.isArray(definition)) return definition.some(function(definitionItem) {
                return fromDefinition(vNode, definitionItem);
            });
            if (typeof definition === "string") return _matches(vNode, definition);
            return Object.keys(definition).every(function(matcherName) {
                if (!matchers[matcherName]) throw new Error('Unknown matcher type "'.concat(matcherName, '"'));
                var matchMethod = matchers[matcherName];
                var matcher = definition[matcherName];
                return matchMethod(vNode, matcher);
            });
        }
        var from_definition_default = fromDefinition;
        function matches2(vNode, definition) {
            return from_definition_default(vNode, definition);
        }
        var matches_default = matches2;
        matches_default.hasAccessibleName = has_accessible_name_default;
        matches_default.attributes = attributes_default;
        matches_default.condition = condition;
        matches_default.explicitRole = explicit_role_default;
        matches_default.fromDefinition = from_definition_default;
        matches_default.fromFunction = from_function_default;
        matches_default.fromPrimative = from_primative_default;
        matches_default.implicitRole = implicit_role_default2;
        matches_default.nodeName = node_name_default;
        matches_default.properties = properties_default;
        matches_default.semanticRole = semantic_role_default;
        var matches_default2 = matches_default;
        function getElementSpec(vNode) {
            var _ref28 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref28$noMatchAccessi = _ref28.noMatchAccessibleName, noMatchAccessibleName = _ref28$noMatchAccessi === void 0 ? false : _ref28$noMatchAccessi;
            var standard = standards_default.htmlElms[vNode.props.nodeName];
            if (!standard) return {};
            if (!standard.variant) return standard;
            var variant = standard.variant, spec = _objectWithoutProperties(standard, _excluded4);
            for(var variantName in variant){
                if (!variant.hasOwnProperty(variantName) || variantName === "default") continue;
                var _variant$variantName = variant[variantName], matches4 = _variant$variantName.matches, props = _objectWithoutProperties(_variant$variantName, _excluded5);
                var matchProperties = Array.isArray(matches4) ? matches4 : [
                    matches4
                ];
                for(var _i9 = 0; _i9 < matchProperties.length && noMatchAccessibleName; _i9++){
                    if (matchProperties[_i9].hasOwnProperty("hasAccessibleName")) return standard;
                }
                if (matches_default2(vNode, matches4)) {
                    for(var propName in props)if (props.hasOwnProperty(propName)) spec[propName] = props[propName];
                }
            }
            for(var _propName in variant["default"])if (variant["default"].hasOwnProperty(_propName) && typeof spec[_propName] === "undefined") spec[_propName] = variant["default"][_propName];
            return spec;
        }
        var get_element_spec_default = getElementSpec;
        function implicitRole2(node) {
            var _ref29 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, chromium = _ref29.chromium;
            var vNode = node instanceof abstract_virtual_node_default ? node : get_node_from_tree_default(node);
            node = vNode.actualNode;
            if (!vNode) throw new ReferenceError("Cannot get implicit role of a node outside the current scope.");
            var nodeName2 = vNode.props.nodeName;
            var role = implicit_html_roles_default[nodeName2];
            if (!role && chromium) {
                var _get_element_spec_def = get_element_spec_default(vNode), chromiumRole = _get_element_spec_def.chromiumRole;
                return chromiumRole || null;
            }
            if (typeof role === "function") return role(vNode);
            return role || null;
        }
        var implicit_role_default = implicitRole2;
        var inheritsPresentationChain = {
            td: [
                "tr"
            ],
            th: [
                "tr"
            ],
            tr: [
                "thead",
                "tbody",
                "tfoot",
                "table"
            ],
            thead: [
                "table"
            ],
            tbody: [
                "table"
            ],
            tfoot: [
                "table"
            ],
            li: [
                "ol",
                "ul"
            ],
            dt: [
                "dl",
                "div"
            ],
            dd: [
                "dl",
                "div"
            ],
            div: [
                "dl"
            ]
        };
        function getInheritedRole(vNode, explicitRoleOptions) {
            var parentNodeNames = inheritsPresentationChain[vNode.props.nodeName];
            if (!parentNodeNames) return null;
            if (!vNode.parent) {
                if (!vNode.actualNode) return null;
                throw new ReferenceError("Cannot determine role presentational inheritance of a required parent outside the current scope.");
            }
            if (!parentNodeNames.includes(vNode.parent.props.nodeName)) return null;
            var parentRole = get_explicit_role_default(vNode.parent, explicitRoleOptions);
            if ([
                "none",
                "presentation"
            ].includes(parentRole) && !hasConflictResolution(vNode.parent)) return parentRole;
            if (parentRole) return null;
            return getInheritedRole(vNode.parent, explicitRoleOptions);
        }
        function resolveImplicitRole(vNode, _ref30) {
            var chromium = _ref30.chromium, explicitRoleOptions = _objectWithoutProperties(_ref30, _excluded6);
            var implicitRole3 = implicit_role_default(vNode, {
                chromium: chromium
            });
            if (!implicitRole3) return null;
            var presentationalRole = getInheritedRole(vNode, explicitRoleOptions);
            if (presentationalRole) return presentationalRole;
            return implicitRole3;
        }
        function hasConflictResolution(vNode) {
            var hasGlobalAria = get_global_aria_attrs_default().some(function(attr) {
                return vNode.hasAttr(attr);
            });
            return hasGlobalAria || _isFocusable(vNode);
        }
        function resolveRole(node) {
            var _ref31 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var noImplicit = _ref31.noImplicit, roleOptions = _objectWithoutProperties(_ref31, _excluded7);
            var _nodeLookup10 = _nodeLookup(node), vNode = _nodeLookup10.vNode;
            if (vNode.props.nodeType !== 1) return null;
            var explicitRole2 = get_explicit_role_default(vNode, roleOptions);
            if (!explicitRole2) return noImplicit ? null : resolveImplicitRole(vNode, roleOptions);
            if (![
                "presentation",
                "none"
            ].includes(explicitRole2)) return explicitRole2;
            if (hasConflictResolution(vNode)) return noImplicit ? null : resolveImplicitRole(vNode, roleOptions);
            return explicitRole2;
        }
        function getRole(node) {
            var _ref32 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var noPresentational = _ref32.noPresentational, options = _objectWithoutProperties(_ref32, _excluded8);
            var role = resolveRole(node, options);
            if (noPresentational && [
                "presentation",
                "none"
            ].includes(role)) return null;
            return role;
        }
        var get_role_default = getRole;
        var alwaysTitleElements = [
            "iframe"
        ];
        function titleText(node) {
            var _nodeLookup11 = _nodeLookup(node), vNode = _nodeLookup11.vNode;
            if (vNode.props.nodeType !== 1 || !node.hasAttr("title")) return "";
            if (!matches_default(vNode, alwaysTitleElements) && [
                "none",
                "presentation"
            ].includes(get_role_default(vNode))) return "";
            return vNode.attr("title");
        }
        var title_text_default = titleText;
        function namedFromContents(vNode) {
            var _ref33 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, strict = _ref33.strict;
            vNode = vNode instanceof abstract_virtual_node_default ? vNode : get_node_from_tree_default(vNode);
            if (vNode.props.nodeType !== 1) return false;
            var role = get_role_default(vNode);
            var roleDef = standards_default.ariaRoles[role];
            if (roleDef && roleDef.nameFromContent) return true;
            if (strict) return false;
            return !roleDef || [
                "presentation",
                "none"
            ].includes(role);
        }
        var named_from_contents_default = namedFromContents;
        function getOwnedVirtual(virtualNode) {
            var actualNode = virtualNode.actualNode, children = virtualNode.children;
            if (!children) throw new Error("getOwnedVirtual requires a virtual node");
            if (virtualNode.hasAttr("aria-owns")) {
                var owns = idrefs_default(actualNode, "aria-owns").filter(function(element) {
                    return !!element;
                }).map(function(element) {
                    return axe.utils.getNodeFromTree(element);
                });
                return [].concat(_toConsumableArray(children), _toConsumableArray(owns));
            }
            return _toConsumableArray(children);
        }
        var get_owned_virtual_default = getOwnedVirtual;
        var unsupported_default = {
            accessibleNameFromFieldValue: [
                "progressbar"
            ]
        };
        function _isVisibleToScreenReaders(vNode) {
            vNode = _nodeLookup(vNode).vNode;
            return isVisibleToScreenReadersVirtual(vNode);
        }
        var isVisibleToScreenReadersVirtual = memoize_default(function isVisibleToScreenReadersMemoized(vNode, isAncestor) {
            if (ariaHidden(vNode) || _isInert(vNode, {
                skipAncestors: true,
                isAncestor: isAncestor
            })) return false;
            if (vNode.actualNode && vNode.props.nodeName === "area") return !areaHidden(vNode, isVisibleToScreenReadersVirtual);
            if (_isHiddenForEveryone(vNode, {
                skipAncestors: true,
                isAncestor: isAncestor
            })) return false;
            if (!vNode.parent) return true;
            return isVisibleToScreenReadersVirtual(vNode.parent, true);
        });
        function visibleVirtual(element, screenReader, noRecursing) {
            var _nodeLookup12 = _nodeLookup(element), vNode = _nodeLookup12.vNode;
            var visibleMethod = screenReader ? _isVisibleToScreenReaders : _isVisibleOnScreen;
            var visible2 = !element.actualNode || element.actualNode && visibleMethod(element);
            var result = vNode.children.map(function(child) {
                var _child$props = child.props, nodeType = _child$props.nodeType, nodeValue = _child$props.nodeValue;
                if (nodeType === 3) {
                    if (nodeValue && visible2) return nodeValue;
                } else if (!noRecursing) return visibleVirtual(child, screenReader);
            }).join("");
            return sanitize_default(result);
        }
        var visible_virtual_default = visibleVirtual;
        var nonTextInputTypes = [
            "button",
            "checkbox",
            "color",
            "file",
            "hidden",
            "image",
            "password",
            "radio",
            "reset",
            "submit"
        ];
        function isNativeTextbox(node) {
            node = node instanceof abstract_virtual_node_default ? node : get_node_from_tree_default(node);
            var nodeName2 = node.props.nodeName;
            return nodeName2 === "textarea" || nodeName2 === "input" && !nonTextInputTypes.includes((node.attr("type") || "").toLowerCase());
        }
        var is_native_textbox_default = isNativeTextbox;
        function isNativeSelect(node) {
            node = node instanceof abstract_virtual_node_default ? node : get_node_from_tree_default(node);
            var nodeName2 = node.props.nodeName;
            return nodeName2 === "select";
        }
        var is_native_select_default = isNativeSelect;
        function isAriaTextbox(node) {
            var role = get_explicit_role_default(node);
            return role === "textbox";
        }
        var is_aria_textbox_default = isAriaTextbox;
        function isAriaListbox(node) {
            var role = get_explicit_role_default(node);
            return role === "listbox";
        }
        var is_aria_listbox_default = isAriaListbox;
        function isAriaCombobox(node) {
            var role = get_explicit_role_default(node);
            return role === "combobox";
        }
        var is_aria_combobox_default = isAriaCombobox;
        var rangeRoles = [
            "progressbar",
            "scrollbar",
            "slider",
            "spinbutton"
        ];
        function isAriaRange(node) {
            var role = get_explicit_role_default(node);
            return rangeRoles.includes(role);
        }
        var is_aria_range_default = isAriaRange;
        var controlValueRoles = [
            "textbox",
            "progressbar",
            "scrollbar",
            "slider",
            "spinbutton",
            "combobox",
            "listbox"
        ];
        var _formControlValueMethods = {
            nativeTextboxValue: nativeTextboxValue,
            nativeSelectValue: nativeSelectValue,
            ariaTextboxValue: ariaTextboxValue,
            ariaListboxValue: ariaListboxValue,
            ariaComboboxValue: ariaComboboxValue,
            ariaRangeValue: ariaRangeValue
        };
        function formControlValue(virtualNode) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var actualNode = virtualNode.actualNode;
            var unsupportedRoles = unsupported_default.accessibleNameFromFieldValue || [];
            var role = get_role_default(virtualNode);
            if (context.startNode === virtualNode || !controlValueRoles.includes(role) || unsupportedRoles.includes(role)) return "";
            var valueMethods = Object.keys(_formControlValueMethods).map(function(name) {
                return _formControlValueMethods[name];
            });
            var valueString = valueMethods.reduce(function(accName, step) {
                return accName || step(virtualNode, context);
            }, "");
            if (context.debug) log_default(valueString || "{empty-value}", actualNode, context);
            return valueString;
        }
        function nativeTextboxValue(node) {
            var _nodeLookup13 = _nodeLookup(node), vNode = _nodeLookup13.vNode;
            if (is_native_textbox_default(vNode)) return vNode.props.value || "";
            return "";
        }
        function nativeSelectValue(node) {
            var _nodeLookup14 = _nodeLookup(node), vNode = _nodeLookup14.vNode;
            if (!is_native_select_default(vNode)) return "";
            var options = query_selector_all_default(vNode, "option");
            var selectedOptions = options.filter(function(option) {
                return option.props.selected;
            });
            if (!selectedOptions.length) selectedOptions.push(options[0]);
            return selectedOptions.map(function(option) {
                return visible_virtual_default(option);
            }).join(" ") || "";
        }
        function ariaTextboxValue(node) {
            var _nodeLookup15 = _nodeLookup(node), vNode = _nodeLookup15.vNode, domNode = _nodeLookup15.domNode;
            if (!is_aria_textbox_default(vNode)) return "";
            if (!domNode || domNode && !_isHiddenForEveryone(domNode)) return visible_virtual_default(vNode, true);
            else return domNode.textContent;
        }
        function ariaListboxValue(node, context) {
            var _nodeLookup16 = _nodeLookup(node), vNode = _nodeLookup16.vNode;
            if (!is_aria_listbox_default(vNode)) return "";
            var selected = get_owned_virtual_default(vNode).filter(function(owned) {
                return get_role_default(owned) === "option" && owned.attr("aria-selected") === "true";
            });
            if (selected.length === 0) return "";
            return _accessibleTextVirtual(selected[0], context);
        }
        function ariaComboboxValue(node, context) {
            var _nodeLookup17 = _nodeLookup(node), vNode = _nodeLookup17.vNode;
            if (!is_aria_combobox_default(vNode)) return "";
            var listbox = get_owned_virtual_default(vNode).filter(function(elm) {
                return get_role_default(elm) === "listbox";
            })[0];
            return listbox ? ariaListboxValue(listbox, context) : "";
        }
        function ariaRangeValue(node) {
            var _nodeLookup18 = _nodeLookup(node), vNode = _nodeLookup18.vNode;
            if (!is_aria_range_default(vNode) || !vNode.hasAttr("aria-valuenow")) return "";
            var valueNow = +vNode.attr("aria-valuenow");
            return !isNaN(valueNow) ? String(valueNow) : "0";
        }
        var form_control_value_default = formControlValue;
        function subtreeText(virtualNode) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var alreadyProcessed2 = _accessibleTextVirtual.alreadyProcessed;
            context.startNode = context.startNode || virtualNode;
            var _context = context, strict = _context.strict, inControlContext = _context.inControlContext, inLabelledByContext = _context.inLabelledByContext;
            var role = get_role_default(virtualNode);
            var _get_element_spec_def2 = get_element_spec_default(virtualNode, {
                noMatchAccessibleName: true
            }), contentTypes = _get_element_spec_def2.contentTypes;
            if (alreadyProcessed2(virtualNode, context) || virtualNode.props.nodeType !== 1 || contentTypes !== null && contentTypes !== void 0 && contentTypes.includes("embedded") || controlValueRoles.includes(role)) return "";
            if (!context.subtreeDescendant && !context.inLabelledByContext && !named_from_contents_default(virtualNode, {
                strict: strict
            })) return "";
            if (!strict) {
                var subtreeDescendant = !inControlContext && !inLabelledByContext;
                context = _extends({
                    subtreeDescendant: subtreeDescendant
                }, context);
            }
            return get_owned_virtual_default(virtualNode).reduce(function(contentText, child) {
                return appendAccessibleText(contentText, child, context);
            }, "");
        }
        var phrasingElements = get_elements_by_content_type_default("phrasing").concat([
            "#text"
        ]);
        function appendAccessibleText(contentText, virtualNode, context) {
            var nodeName2 = virtualNode.props.nodeName;
            var contentTextAdd = _accessibleTextVirtual(virtualNode, context);
            if (!contentTextAdd) return contentText;
            if (!phrasingElements.includes(nodeName2)) {
                if (contentTextAdd[0] !== " ") contentTextAdd += " ";
                if (contentText && contentText[contentText.length - 1] !== " ") contentTextAdd = " " + contentTextAdd;
            }
            return contentText + contentTextAdd;
        }
        var subtree_text_default = subtreeText;
        function labelText(virtualNode) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var alreadyProcessed2 = _accessibleTextVirtual.alreadyProcessed;
            if (context.inControlContext || context.inLabelledByContext || alreadyProcessed2(virtualNode, context)) return "";
            if (!context.startNode) context.startNode = virtualNode;
            var labelContext = _extends({
                inControlContext: true
            }, context);
            var explicitLabels = getExplicitLabels(virtualNode);
            var implicitLabel = closest_default(virtualNode, "label");
            var labels;
            if (implicitLabel) {
                labels = [].concat(_toConsumableArray(explicitLabels), [
                    implicitLabel.actualNode
                ]);
                labels.sort(node_sorter_default);
            } else labels = explicitLabels;
            return labels.map(function(label3) {
                return accessible_text_default(label3, labelContext);
            }).filter(function(text) {
                return text !== "";
            }).join(" ");
        }
        function getExplicitLabels(virtualNode) {
            if (!virtualNode.attr("id")) return [];
            if (!virtualNode.actualNode) throw new TypeError("Cannot resolve explicit label reference for non-DOM nodes");
            return find_elms_in_context_default({
                elm: "label",
                attr: "for",
                value: virtualNode.attr("id"),
                context: virtualNode.actualNode
            });
        }
        var label_text_default = labelText;
        var defaultButtonValues = {
            submit: "Submit",
            image: "Submit",
            reset: "Reset",
            button: ""
        };
        var nativeTextMethods = {
            valueText: function valueText(_ref34) {
                var actualNode = _ref34.actualNode;
                return actualNode.value || "";
            },
            buttonDefaultText: function buttonDefaultText(_ref35) {
                var actualNode = _ref35.actualNode;
                return defaultButtonValues[actualNode.type] || "";
            },
            tableCaptionText: descendantText.bind(null, "caption"),
            figureText: descendantText.bind(null, "figcaption"),
            svgTitleText: descendantText.bind(null, "title"),
            fieldsetLegendText: descendantText.bind(null, "legend"),
            altText: attrText.bind(null, "alt"),
            tableSummaryText: attrText.bind(null, "summary"),
            titleText: title_text_default,
            subtreeText: subtree_text_default,
            labelText: label_text_default,
            singleSpace: function singleSpace() {
                return " ";
            },
            placeholderText: attrText.bind(null, "placeholder")
        };
        function attrText(attr, vNode) {
            return vNode.attr(attr) || "";
        }
        function descendantText(nodeName2, _ref36, context) {
            var actualNode = _ref36.actualNode;
            nodeName2 = nodeName2.toLowerCase();
            var nodeNames2 = [
                nodeName2,
                actualNode.nodeName.toLowerCase()
            ].join(",");
            var candidate = actualNode.querySelector(nodeNames2);
            if (!candidate || candidate.nodeName.toLowerCase() !== nodeName2) return "";
            return accessible_text_default(candidate, context);
        }
        var native_text_methods_default = nativeTextMethods;
        function _nativeTextAlternative(virtualNode) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var actualNode = virtualNode.actualNode;
            if (virtualNode.props.nodeType !== 1 || [
                "presentation",
                "none"
            ].includes(get_role_default(virtualNode))) return "";
            var textMethods = findTextMethods(virtualNode);
            var accessibleName = textMethods.reduce(function(accName, step) {
                return accName || step(virtualNode, context);
            }, "");
            if (context.debug) axe.log(accessibleName || "{empty-value}", actualNode, context);
            return accessibleName;
        }
        function findTextMethods(virtualNode) {
            var elmSpec = get_element_spec_default(virtualNode, {
                noMatchAccessibleName: true
            });
            var methods = elmSpec.namingMethods || [];
            return methods.map(function(methodName) {
                return native_text_methods_default[methodName];
            });
        }
        function getUnicodeNonBmpRegExp() {
            return /[\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\uE000-\uF8FF]/g;
        }
        function getPunctuationRegExp() {
            return /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&\xa3\xa2\xa5\xa7\u20ac()*+,\-.\/:;<=>?@\[\]^_`{|}~\xb1]/g;
        }
        function getSupplementaryPrivateUseRegExp() {
            return /[\uDB80-\uDBBF][\uDC00-\uDFFF]/g;
        }
        function getCategoryFormatRegExp() {
            return /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/g;
        }
        var emoji_regex_default = function emoji_regex_default() {
            return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC08\uDC26](?:\u200D\u2B1B)?|[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
        };
        function hasUnicode(str, options) {
            var emoji = options.emoji, nonBmp = options.nonBmp, punctuations = options.punctuations;
            var value = false;
            if (emoji) value || (value = emoji_regex_default().test(str));
            if (nonBmp) value || (value = getUnicodeNonBmpRegExp().test(str) || getSupplementaryPrivateUseRegExp().test(str) || getCategoryFormatRegExp().test(str));
            if (punctuations) value || (value = getPunctuationRegExp().test(str));
            return value;
        }
        var has_unicode_default = hasUnicode;
        function _isIconLigature(textVNode) {
            var differenceThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .15;
            var occurrenceThreshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
            var nodeValue = textVNode.actualNode.nodeValue.trim();
            if (!sanitize_default(nodeValue) || has_unicode_default(nodeValue, {
                emoji: true,
                nonBmp: true
            })) return false;
            var canvasContext = cache_default.get("canvasContext", function() {
                return document.createElement("canvas").getContext("2d", {
                    willReadFrequently: true
                });
            });
            var canvas = canvasContext.canvas;
            var fonts = cache_default.get("fonts", function() {
                return {};
            });
            var style = window1.getComputedStyle(textVNode.parent.actualNode);
            var fontFamily = style.getPropertyValue("font-family");
            if (!fonts[fontFamily]) fonts[fontFamily] = {
                occurrences: 0,
                numLigatures: 0
            };
            var font = fonts[fontFamily];
            if (font.occurrences >= occurrenceThreshold) {
                if (font.numLigatures / font.occurrences === 1) return true;
                else if (font.numLigatures === 0) return false;
            }
            font.occurrences++;
            var fontSize = 30;
            var fontStyle = "".concat(fontSize, "px ").concat(fontFamily);
            canvasContext.font = fontStyle;
            var firstChar = nodeValue.charAt(0);
            var width = canvasContext.measureText(firstChar).width;
            if (width === 0) {
                font.numLigatures++;
                return true;
            }
            if (width < 30) {
                var diff = 30 / width;
                width *= diff;
                fontSize *= diff;
                fontStyle = "".concat(fontSize, "px ").concat(fontFamily);
            }
            canvas.width = width;
            canvas.height = fontSize;
            canvasContext.font = fontStyle;
            canvasContext.textAlign = "left";
            canvasContext.textBaseline = "top";
            canvasContext.fillText(firstChar, 0, 0);
            var compareData = new Uint32Array(canvasContext.getImageData(0, 0, width, fontSize).data.buffer);
            if (!compareData.some(function(pixel) {
                return pixel;
            })) {
                font.numLigatures++;
                return true;
            }
            canvasContext.clearRect(0, 0, width, fontSize);
            canvasContext.fillText(nodeValue, 0, 0);
            var compareWith = new Uint32Array(canvasContext.getImageData(0, 0, width, fontSize).data.buffer);
            var differences = compareData.reduce(function(diff, pixel, i) {
                if (pixel === 0 && compareWith[i] === 0) return diff;
                if (pixel !== 0 && compareWith[i] !== 0) return diff;
                return ++diff;
            }, 0);
            var expectedWidth = nodeValue.split("").reduce(function(totalWidth, _char2) {
                return totalWidth + canvasContext.measureText(_char2).width;
            }, 0);
            var actualWidth = canvasContext.measureText(nodeValue).width;
            var pixelDifference = differences / compareData.length;
            var sizeDifference = 1 - actualWidth / expectedWidth;
            if (pixelDifference >= differenceThreshold && sizeDifference >= differenceThreshold) {
                font.numLigatures++;
                return true;
            }
            return false;
        }
        function _accessibleTextVirtual(virtualNode) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            context = prepareContext(virtualNode, context);
            if (shouldIgnoreHidden(virtualNode, context)) return "";
            if (shouldIgnoreIconLigature(virtualNode, context)) return "";
            var computationSteps = [
                arialabelledby_text_default,
                _arialabelText,
                _nativeTextAlternative,
                form_control_value_default,
                subtree_text_default,
                textNodeValue,
                title_text_default
            ];
            var accessibleName = computationSteps.reduce(function(accName, step) {
                if (context.startNode === virtualNode) accName = sanitize_default(accName);
                if (accName !== "") return accName;
                return step(virtualNode, context);
            }, "");
            if (context.debug) axe.log(accessibleName || "{empty-value}", virtualNode.actualNode, context);
            return accessibleName;
        }
        function textNodeValue(virtualNode) {
            if (virtualNode.props.nodeType !== 3) return "";
            return virtualNode.props.nodeValue;
        }
        function shouldIgnoreHidden(virtualNode, context) {
            if (!virtualNode) return false;
            if (virtualNode.props.nodeType !== 1 || context.includeHidden) return false;
            return !_isVisibleToScreenReaders(virtualNode);
        }
        function shouldIgnoreIconLigature(virtualNode, context) {
            var _context$occurrenceTh;
            var ignoreIconLigature = context.ignoreIconLigature, pixelThreshold = context.pixelThreshold;
            var occurrenceThreshold = (_context$occurrenceTh = context.occurrenceThreshold) !== null && _context$occurrenceTh !== void 0 ? _context$occurrenceTh : context.occuranceThreshold;
            if (virtualNode.props.nodeType !== 3 || !ignoreIconLigature) return false;
            return _isIconLigature(virtualNode, pixelThreshold, occurrenceThreshold);
        }
        function prepareContext(virtualNode, context) {
            if (!context.startNode) context = _extends({
                startNode: virtualNode
            }, context);
            if (virtualNode.props.nodeType === 1 && context.inLabelledByContext && context.includeHidden === void 0) context = _extends({
                includeHidden: !_isVisibleToScreenReaders(virtualNode)
            }, context);
            return context;
        }
        _accessibleTextVirtual.alreadyProcessed = function alreadyProcessed(virtualnode, context) {
            context.processed = context.processed || [];
            if (context.processed.includes(virtualnode)) return true;
            context.processed.push(virtualnode);
            return false;
        };
        function removeUnicode(str, options) {
            var emoji = options.emoji, nonBmp = options.nonBmp, punctuations = options.punctuations;
            if (emoji) str = str.replace(emoji_regex_default(), "");
            if (nonBmp) str = str.replace(getUnicodeNonBmpRegExp(), "").replace(getSupplementaryPrivateUseRegExp(), "").replace(getCategoryFormatRegExp(), "");
            if (punctuations) str = str.replace(getPunctuationRegExp(), "");
            return str;
        }
        var remove_unicode_default = removeUnicode;
        function isHumanInterpretable(str) {
            if (!str.length) return 0;
            var alphaNumericIconMap = [
                "x",
                "i"
            ];
            if (alphaNumericIconMap.includes(str)) return 0;
            var noUnicodeStr = remove_unicode_default(str, {
                emoji: true,
                nonBmp: true,
                punctuations: true
            });
            if (!sanitize_default(noUnicodeStr)) return 0;
            return 1;
        }
        var is_human_interpretable_default = isHumanInterpretable;
        var _autocomplete = {
            stateTerms: [
                "on",
                "off"
            ],
            standaloneTerms: [
                "name",
                "honorific-prefix",
                "given-name",
                "additional-name",
                "family-name",
                "honorific-suffix",
                "nickname",
                "username",
                "new-password",
                "current-password",
                "organization-title",
                "organization",
                "street-address",
                "address-line1",
                "address-line2",
                "address-line3",
                "address-level4",
                "address-level3",
                "address-level2",
                "address-level1",
                "country",
                "country-name",
                "postal-code",
                "cc-name",
                "cc-given-name",
                "cc-additional-name",
                "cc-family-name",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc",
                "cc-type",
                "transaction-currency",
                "transaction-amount",
                "language",
                "bday",
                "bday-day",
                "bday-month",
                "bday-year",
                "sex",
                "url",
                "photo",
                "one-time-code"
            ],
            qualifiers: [
                "home",
                "work",
                "mobile",
                "fax",
                "pager"
            ],
            qualifiedTerms: [
                "tel",
                "tel-country-code",
                "tel-national",
                "tel-area-code",
                "tel-local",
                "tel-local-prefix",
                "tel-local-suffix",
                "tel-extension",
                "email",
                "impp"
            ],
            locations: [
                "billing",
                "shipping"
            ]
        };
        function isValidAutocomplete(autocompleteValue) {
            var _ref37 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref37$looseTyped = _ref37.looseTyped, looseTyped = _ref37$looseTyped === void 0 ? false : _ref37$looseTyped, _ref37$stateTerms = _ref37.stateTerms, stateTerms = _ref37$stateTerms === void 0 ? [] : _ref37$stateTerms, _ref37$locations = _ref37.locations, locations = _ref37$locations === void 0 ? [] : _ref37$locations, _ref37$qualifiers = _ref37.qualifiers, qualifiers = _ref37$qualifiers === void 0 ? [] : _ref37$qualifiers, _ref37$standaloneTerm = _ref37.standaloneTerms, standaloneTerms = _ref37$standaloneTerm === void 0 ? [] : _ref37$standaloneTerm, _ref37$qualifiedTerms = _ref37.qualifiedTerms, qualifiedTerms = _ref37$qualifiedTerms === void 0 ? [] : _ref37$qualifiedTerms;
            autocompleteValue = autocompleteValue.toLowerCase().trim();
            stateTerms = stateTerms.concat(_autocomplete.stateTerms);
            if (stateTerms.includes(autocompleteValue) || autocompleteValue === "") return true;
            qualifiers = qualifiers.concat(_autocomplete.qualifiers);
            locations = locations.concat(_autocomplete.locations);
            standaloneTerms = standaloneTerms.concat(_autocomplete.standaloneTerms);
            qualifiedTerms = qualifiedTerms.concat(_autocomplete.qualifiedTerms);
            var autocompleteTerms = autocompleteValue.split(/\s+/g);
            if (autocompleteTerms[autocompleteTerms.length - 1] === "webauthn") {
                autocompleteTerms.pop();
                if (autocompleteTerms.length === 0) return false;
            }
            if (!looseTyped) {
                if (autocompleteTerms[0].length > 8 && autocompleteTerms[0].substr(0, 8) === "section-") autocompleteTerms.shift();
                if (locations.includes(autocompleteTerms[0])) autocompleteTerms.shift();
                if (qualifiers.includes(autocompleteTerms[0])) {
                    autocompleteTerms.shift();
                    standaloneTerms = [];
                }
                if (autocompleteTerms.length !== 1) return false;
            }
            var purposeTerm = autocompleteTerms[autocompleteTerms.length - 1];
            return standaloneTerms.includes(purposeTerm) || qualifiedTerms.includes(purposeTerm);
        }
        var is_valid_autocomplete_default = isValidAutocomplete;
        function labelVirtual(virtualNode) {
            var ref, candidate;
            if (virtualNode.attr("aria-labelledby")) {
                ref = idrefs_default(virtualNode.actualNode, "aria-labelledby");
                candidate = ref.map(function(thing) {
                    var vNode = get_node_from_tree_default(thing);
                    return vNode ? visible_virtual_default(vNode) : "";
                }).join(" ").trim();
                if (candidate) return candidate;
            }
            candidate = virtualNode.attr("aria-label");
            if (candidate) {
                candidate = sanitize_default(candidate);
                if (candidate) return candidate;
            }
            return null;
        }
        var label_virtual_default = labelVirtual;
        function visible(element, screenReader, noRecursing) {
            element = get_node_from_tree_default(element);
            return visible_virtual_default(element, screenReader, noRecursing);
        }
        var visible_default = visible;
        function labelVirtual2(virtualNode) {
            var ref, candidate, doc;
            candidate = label_virtual_default(virtualNode);
            if (candidate) return candidate;
            if (virtualNode.attr("id")) {
                if (!virtualNode.actualNode) throw new TypeError("Cannot resolve explicit label reference for non-DOM nodes");
                var id = escape_selector_default(virtualNode.attr("id"));
                doc = get_root_node_default2(virtualNode.actualNode);
                ref = doc.querySelector('label[for="' + id + '"]');
                candidate = ref && visible_default(ref, true);
                if (candidate) return candidate;
            }
            ref = closest_default(virtualNode, "label");
            candidate = ref && visible_virtual_default(ref, true);
            if (candidate) return candidate;
            return null;
        }
        var label_virtual_default2 = labelVirtual2;
        function label(node) {
            node = get_node_from_tree_default(node);
            return label_virtual_default2(node);
        }
        var label_default = label;
        var nativeElementType = [
            {
                matches: [
                    {
                        nodeName: "textarea"
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "text",
                                "password",
                                "search",
                                "tel",
                                "email",
                                "url"
                            ]
                        }
                    }
                ],
                namingMethods: "labelText"
            },
            {
                matches: {
                    nodeName: "input",
                    properties: {
                        type: [
                            "button",
                            "submit",
                            "reset"
                        ]
                    }
                },
                namingMethods: [
                    "valueText",
                    "titleText",
                    "buttonDefaultText"
                ]
            },
            {
                matches: {
                    nodeName: "input",
                    properties: {
                        type: "image"
                    }
                },
                namingMethods: [
                    "altText",
                    "valueText",
                    "labelText",
                    "titleText",
                    "buttonDefaultText"
                ]
            },
            {
                matches: "button",
                namingMethods: "subtreeText"
            },
            {
                matches: "fieldset",
                namingMethods: "fieldsetLegendText"
            },
            {
                matches: "OUTPUT",
                namingMethods: "subtreeText"
            },
            {
                matches: [
                    {
                        nodeName: "select"
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: /^(?!text|password|search|tel|email|url|button|submit|reset)/
                        }
                    }
                ],
                namingMethods: "labelText"
            },
            {
                matches: "summary",
                namingMethods: "subtreeText"
            },
            {
                matches: "figure",
                namingMethods: [
                    "figureText",
                    "titleText"
                ]
            },
            {
                matches: "img",
                namingMethods: "altText"
            },
            {
                matches: "table",
                namingMethods: [
                    "tableCaptionText",
                    "tableSummaryText"
                ]
            },
            {
                matches: [
                    "hr",
                    "br"
                ],
                namingMethods: [
                    "titleText",
                    "singleSpace"
                ]
            }
        ];
        var native_element_type_default = nativeElementType;
        function visibleTextNodes(vNode) {
            var parentVisible = _isVisibleOnScreen(vNode);
            var nodes = [];
            vNode.children.forEach(function(child) {
                if (child.actualNode.nodeType === 3) {
                    if (parentVisible) nodes.push(child);
                } else nodes = nodes.concat(visibleTextNodes(child));
            });
            return nodes;
        }
        var visible_text_nodes_default = visibleTextNodes;
        var getVisibleChildTextRects = memoize_default(function getVisibleChildTextRectsMemoized(node) {
            var vNode = get_node_from_tree_default(node);
            var nodeRect = vNode.boundingClientRect;
            var clientRects = [];
            var overflowHiddenNodes = get_overflow_hidden_ancestors_default(vNode);
            node.childNodes.forEach(function(textNode) {
                if (textNode.nodeType !== 3 || sanitize_default(textNode.nodeValue) === "") return;
                var contentRects = getContentRects(textNode);
                if (isOutsideNodeBounds(contentRects, nodeRect)) return;
                clientRects.push.apply(clientRects, _toConsumableArray(filterHiddenRects(contentRects, overflowHiddenNodes)));
            });
            return clientRects.length ? clientRects : [
                nodeRect
            ];
        });
        var get_visible_child_text_rects_default = getVisibleChildTextRects;
        function getContentRects(node) {
            var range2 = document.createRange();
            range2.selectNodeContents(node);
            return Array.from(range2.getClientRects());
        }
        function isOutsideNodeBounds(rects, nodeRect) {
            return rects.some(function(rect) {
                var centerPoint = _getRectCenter(rect);
                return !_isPointInRect(centerPoint, nodeRect);
            });
        }
        function filterHiddenRects(contentRects, overflowHiddenNodes) {
            var visibleRects = [];
            contentRects.forEach(function(contentRect) {
                if (contentRect.width < 1 || contentRect.height < 1) return;
                var visibleRect = overflowHiddenNodes.reduce(function(rect, overflowNode) {
                    return rect && _getIntersectionRect(rect, overflowNode.boundingClientRect);
                }, contentRect);
                if (visibleRect) visibleRects.push(visibleRect);
            });
            return visibleRects;
        }
        function getTextElementStack(node) {
            _createGrid();
            var vNode = get_node_from_tree_default(node);
            var grid = vNode._grid;
            if (!grid) return [];
            var clientRects = get_visible_child_text_rects_default(node);
            return clientRects.map(function(rect) {
                return getRectStack(grid, rect);
            });
        }
        var get_text_element_stack_default = getTextElementStack;
        var visualRoles = [
            "checkbox",
            "img",
            "meter",
            "progressbar",
            "scrollbar",
            "radio",
            "slider",
            "spinbutton",
            "textbox"
        ];
        function isVisualContent(el) {
            var _nodeLookup19 = _nodeLookup(el), vNode = _nodeLookup19.vNode;
            var role = axe.commons.aria.getExplicitRole(vNode);
            if (role) return visualRoles.indexOf(role) !== -1;
            switch(vNode.props.nodeName){
                case "img":
                case "iframe":
                case "object":
                case "video":
                case "audio":
                case "canvas":
                case "svg":
                case "math":
                case "button":
                case "select":
                case "textarea":
                case "keygen":
                case "progress":
                case "meter":
                    return true;
                case "input":
                    return vNode.props.type !== "hidden";
                default:
                    return false;
            }
        }
        var is_visual_content_default = isVisualContent;
        var hiddenTextElms = [
            "head",
            "title",
            "template",
            "script",
            "style",
            "iframe",
            "object",
            "video",
            "audio",
            "noscript"
        ];
        function hasChildTextNodes(elm) {
            if (hiddenTextElms.includes(elm.props.nodeName)) return false;
            return elm.children.some(function(_ref38) {
                var props = _ref38.props;
                return props.nodeType === 3 && props.nodeValue.trim();
            });
        }
        function hasContentVirtual(elm, noRecursion, ignoreAria) {
            return hasChildTextNodes(elm) || is_visual_content_default(elm.actualNode) || !ignoreAria && !!label_virtual_default(elm) || !noRecursion && elm.children.some(function(child) {
                return child.actualNode.nodeType === 1 && hasContentVirtual(child);
            });
        }
        var has_content_virtual_default = hasContentVirtual;
        function hasContent(elm, noRecursion, ignoreAria) {
            elm = get_node_from_tree_default(elm);
            return has_content_virtual_default(elm, noRecursion, ignoreAria);
        }
        var has_content_default = hasContent;
        function _hasLangText(virtualNode) {
            if (typeof virtualNode.children === "undefined" || hasChildTextNodes(virtualNode)) return true;
            if (virtualNode.props.nodeType === 1 && is_visual_content_default(virtualNode)) return !!axe.commons.text.accessibleTextVirtual(virtualNode);
            return virtualNode.children.some(function(child) {
                return !child.attr("lang") && _hasLangText(child) && !_isHiddenForEveryone(child);
            });
        }
        function insertedIntoFocusOrder(el) {
            var tabIndex = parseInt(el.getAttribute("tabindex"), 10);
            return tabIndex > -1 && _isFocusable(el) && !is_natively_focusable_default(el);
        }
        var inserted_into_focus_order_default = insertedIntoFocusOrder;
        function isHiddenWithCSS(el, descendentVisibilityValue) {
            var _nodeLookup20 = _nodeLookup(el), vNode = _nodeLookup20.vNode, domNode = _nodeLookup20.domNode;
            if (!vNode) return _isHiddenWithCSS(domNode, descendentVisibilityValue);
            if (vNode._isHiddenWithCSS === void 0) vNode._isHiddenWithCSS = _isHiddenWithCSS(domNode, descendentVisibilityValue);
            return vNode._isHiddenWithCSS;
        }
        function _isHiddenWithCSS(el, descendentVisibilityValue) {
            if (el.nodeType === 9) return false;
            if (el.nodeType === 11) el = el.host;
            if ([
                "STYLE",
                "SCRIPT"
            ].includes(el.nodeName.toUpperCase())) return false;
            var style = window1.getComputedStyle(el, null);
            if (!style) throw new Error("Style does not exist for the given element.");
            var displayValue = style.getPropertyValue("display");
            if (displayValue === "none") return true;
            var HIDDEN_VISIBILITY_VALUES = [
                "hidden",
                "collapse"
            ];
            var visibilityValue = style.getPropertyValue("visibility");
            if (HIDDEN_VISIBILITY_VALUES.includes(visibilityValue) && !descendentVisibilityValue) return true;
            if (HIDDEN_VISIBILITY_VALUES.includes(visibilityValue) && descendentVisibilityValue && HIDDEN_VISIBILITY_VALUES.includes(descendentVisibilityValue)) return true;
            var parent = get_composed_parent_default(el);
            if (parent && !HIDDEN_VISIBILITY_VALUES.includes(visibilityValue)) return isHiddenWithCSS(parent, visibilityValue);
            return false;
        }
        var is_hidden_with_css_default = isHiddenWithCSS;
        function isHTML5(doc) {
            var node = doc.doctype;
            if (node === null) return false;
            return node.name === "html" && !node.publicId && !node.systemId;
        }
        var is_html5_default = isHTML5;
        function getRoleType(role) {
            var _window3;
            if (role instanceof abstract_virtual_node_default || (_window3 = window1) !== null && _window3 !== void 0 && _window3.Node && role instanceof window1.Node) role = axe.commons.aria.getRole(role);
            var roleDef = standards_default.ariaRoles[role];
            return (roleDef === null || roleDef === void 0 ? void 0 : roleDef.type) || null;
        }
        var get_role_type_default = getRoleType;
        function walkDomNode(node, functor) {
            if (functor(node.actualNode) !== false) node.children.forEach(function(child) {
                return walkDomNode(child, functor);
            });
        }
        var blockLike = [
            "block",
            "list-item",
            "table",
            "flex",
            "grid",
            "inline-block"
        ];
        function isBlock(elm) {
            var display2 = window1.getComputedStyle(elm).getPropertyValue("display");
            return blockLike.includes(display2) || display2.substr(0, 6) === "table-";
        }
        function getBlockParent(node) {
            var parentBlock = get_composed_parent_default(node);
            while(parentBlock && !isBlock(parentBlock))parentBlock = get_composed_parent_default(parentBlock);
            return get_node_from_tree_default(parentBlock);
        }
        function isInTextBlock(node, options) {
            if (isBlock(node)) return false;
            var virtualParent = getBlockParent(node);
            var parentText = "";
            var widgetText = "";
            var inBrBlock = 0;
            walkDomNode(virtualParent, function(currNode) {
                if (inBrBlock === 2) return false;
                if (currNode.nodeType === 3) parentText += currNode.nodeValue;
                if (currNode.nodeType !== 1) return;
                var nodeName2 = (currNode.nodeName || "").toUpperCase();
                if (currNode === node) inBrBlock = 1;
                if ([
                    "BR",
                    "HR"
                ].includes(nodeName2)) {
                    if (inBrBlock === 0) {
                        parentText = "";
                        widgetText = "";
                    } else inBrBlock = 2;
                } else if (currNode.style.display === "none" || currNode.style.overflow === "hidden" || ![
                    "",
                    null,
                    "none"
                ].includes(currNode.style["float"]) || ![
                    "",
                    null,
                    "relative"
                ].includes(currNode.style.position)) return false;
                else if (get_role_type_default(currNode) === "widget") {
                    widgetText += currNode.textContent;
                    return false;
                }
            });
            parentText = sanitize_default(parentText);
            if (options !== null && options !== void 0 && options.noLengthCompare) return parentText.length !== 0;
            widgetText = sanitize_default(widgetText);
            return parentText.length > widgetText.length;
        }
        var is_in_text_block_default = isInTextBlock;
        function isModalOpen(options) {
            options = options || {};
            var modalPercent = options.modalPercent || .75;
            if (cache_default.get("isModalOpen")) return cache_default.get("isModalOpen");
            var definiteModals = query_selector_all_filter_default(axe._tree[0], "dialog, [role=dialog], [aria-modal=true]", _isVisibleOnScreen);
            if (definiteModals.length) {
                cache_default.set("isModalOpen", true);
                return true;
            }
            var viewport = get_viewport_size_default(window1);
            var percentWidth = viewport.width * modalPercent;
            var percentHeight = viewport.height * modalPercent;
            var x = (viewport.width - percentWidth) / 2;
            var y = (viewport.height - percentHeight) / 2;
            var points = [
                {
                    x: x,
                    y: y
                },
                {
                    x: viewport.width - x,
                    y: y
                },
                {
                    x: viewport.width / 2,
                    y: viewport.height / 2
                },
                {
                    x: x,
                    y: viewport.height - y
                },
                {
                    x: viewport.width - x,
                    y: viewport.height - y
                }
            ];
            var stacks = points.map(function(point) {
                return Array.from(document.elementsFromPoint(point.x, point.y));
            });
            var _loop4 = function _loop4(_i10) {
                var modalElement = stacks[_i10].find(function(elm) {
                    var style = window1.getComputedStyle(elm);
                    return parseInt(style.width, 10) >= percentWidth && parseInt(style.height, 10) >= percentHeight && style.getPropertyValue("pointer-events") !== "none" && (style.position === "absolute" || style.position === "fixed");
                });
                if (modalElement && stacks.every(function(stack) {
                    return stack.includes(modalElement);
                })) {
                    cache_default.set("isModalOpen", true);
                    return {
                        v: true
                    };
                }
            };
            for(var _i10 = 0; _i10 < stacks.length; _i10++){
                var _ret = _loop4(_i10);
                if (_typeof(_ret) === "object") return _ret.v;
            }
            cache_default.set("isModalOpen", void 0);
            return void 0;
        }
        var is_modal_open_default = isModalOpen;
        function _isMultiline(domNode) {
            var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
            var range2 = domNode.ownerDocument.createRange();
            range2.setStart(domNode, 0);
            range2.setEnd(domNode, domNode.childNodes.length);
            var lastLineEnd = 0;
            var lineCount = 0;
            var _iterator5 = _createForOfIteratorHelper(range2.getClientRects()), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var rect = _step5.value;
                    if (rect.height <= margin) continue;
                    if (lastLineEnd > rect.top + margin) lastLineEnd = Math.max(lastLineEnd, rect.bottom);
                    else if (lineCount === 0) {
                        lastLineEnd = rect.bottom;
                        lineCount++;
                    } else return true;
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
            return false;
        }
        function isNode(element) {
            return element instanceof window1.Node;
        }
        var is_node_default = isNode;
        var cacheKey = "color.incompleteData";
        var incompleteData = {
            set: function set(key, reason) {
                if (typeof key !== "string") throw new Error("Incomplete data: key must be a string");
                var data = cache_default.get(cacheKey, function() {
                    return {};
                });
                if (reason) data[key] = reason;
                return data[key];
            },
            get: function get(key) {
                var data = cache_default.get(cacheKey);
                return data === null || data === void 0 ? void 0 : data[key];
            },
            clear: function clear() {
                cache_default.set(cacheKey, {});
            }
        };
        var incomplete_data_default = incompleteData;
        function elementHasImage(elm, style) {
            var graphicNodes = [
                "IMG",
                "CANVAS",
                "OBJECT",
                "IFRAME",
                "VIDEO",
                "SVG"
            ];
            var nodeName2 = elm.nodeName.toUpperCase();
            if (graphicNodes.includes(nodeName2)) {
                incomplete_data_default.set("bgColor", "imgNode");
                return true;
            }
            style = style || window1.getComputedStyle(elm);
            var bgImageStyle = style.getPropertyValue("background-image");
            var hasBgImage = bgImageStyle !== "none";
            if (hasBgImage) {
                var hasGradient = /gradient/.test(bgImageStyle);
                incomplete_data_default.set("bgColor", hasGradient ? "bgGradient" : "bgImage");
            }
            return hasBgImage;
        }
        var element_has_image_default = elementHasImage;
        var imports_exports = {};
        __export(imports_exports, {
            Colorjs: function Colorjs() {
                return Color;
            },
            CssSelectorParser: function CssSelectorParser() {
                return import_css_selector_parser2.CssSelectorParser;
            },
            doT: function doT() {
                return import_dot["default"];
            },
            emojiRegexText: function emojiRegexText() {
                return emoji_regex_default;
            },
            memoize: function memoize() {
                return import_memoizee2["default"];
            }
        });
        var import_css_selector_parser2 = __toModule(require_lib());
        var import_dot = __toModule(require_doT());
        var import_memoizee2 = __toModule(require_memoizee());
        function multiplyMatrices(A, B) {
            var m3 = A.length;
            if (!Array.isArray(A[0])) A = [
                A
            ];
            if (!Array.isArray(B[0])) B = B.map(function(x) {
                return [
                    x
                ];
            });
            var p2 = B[0].length;
            var B_cols = B[0].map(function(_, i) {
                return B.map(function(x) {
                    return x[i];
                });
            });
            var product = A.map(function(row) {
                return B_cols.map(function(col) {
                    var ret = 0;
                    if (!Array.isArray(row)) {
                        var _iterator6 = _createForOfIteratorHelper(col), _step6;
                        try {
                            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                var c4 = _step6.value;
                                ret += row * c4;
                            }
                        } catch (err) {
                            _iterator6.e(err);
                        } finally{
                            _iterator6.f();
                        }
                        return ret;
                    }
                    for(var _i11 = 0; _i11 < row.length; _i11++)ret += row[_i11] * (col[_i11] || 0);
                    return ret;
                });
            });
            if (m3 === 1) product = product[0];
            if (p2 === 1) return product.map(function(x) {
                return x[0];
            });
            return product;
        }
        function isString(str) {
            return type(str) === "string";
        }
        function type(o) {
            var str = Object.prototype.toString.call(o);
            return (str.match(/^\[object\s+(.*?)\]$/)[1] || "").toLowerCase();
        }
        function toPrecision(n2, precision) {
            n2 = +n2;
            precision = +precision;
            var integerLength = (Math.floor(n2) + "").length;
            if (precision > integerLength) return +n2.toFixed(precision - integerLength);
            else {
                var p10 = Math.pow(10, integerLength - precision);
                return Math.round(n2 / p10) * p10;
            }
        }
        function parseFunction(str) {
            if (!str) return;
            str = str.trim();
            var isFunctionRegex = /^([a-z]+)\((.+?)\)$/i;
            var isNumberRegex = /^-?[\d.]+$/;
            var parts = str.match(isFunctionRegex);
            if (parts) {
                var args = [];
                parts[2].replace(/\/?\s*([-\w.]+(?:%|deg)?)/g, function($0, arg) {
                    if (/%$/.test(arg)) {
                        arg = new Number(arg.slice(0, -1) / 100);
                        arg.type = "<percentage>";
                    } else if (/deg$/.test(arg)) {
                        arg = new Number(+arg.slice(0, -3));
                        arg.type = "<angle>";
                        arg.unit = "deg";
                    } else if (isNumberRegex.test(arg)) {
                        arg = new Number(arg);
                        arg.type = "<number>";
                    }
                    if ($0.startsWith("/")) {
                        arg = arg instanceof Number ? arg : new Number(arg);
                        arg.alpha = true;
                    }
                    args.push(arg);
                });
                return {
                    name: parts[1].toLowerCase(),
                    rawName: parts[1],
                    rawArgs: parts[2],
                    args: args
                };
            }
        }
        function last(arr) {
            return arr[arr.length - 1];
        }
        function interpolate(start, end, p2) {
            if (isNaN(start)) return end;
            if (isNaN(end)) return start;
            return start + (end - start) * p2;
        }
        function interpolateInv(start, end, value) {
            return (value - start) / (end - start);
        }
        function mapRange(from, to2, value) {
            return interpolate(to2[0], to2[1], interpolateInv(from[0], from[1], value));
        }
        function parseCoordGrammar(coordGrammars) {
            return coordGrammars.map(function(coordGrammar2) {
                return coordGrammar2.split("|").map(function(type2) {
                    type2 = type2.trim();
                    var range2 = type2.match(/^(<[a-z]+>)\[(-?[.\d]+),\s*(-?[.\d]+)\]?$/);
                    if (range2) {
                        var ret = new String(range2[1]);
                        ret.range = [
                            +range2[2],
                            +range2[3]
                        ];
                        return ret;
                    }
                    return type2;
                });
            });
        }
        var util = Object.freeze({
            __proto__: null,
            isString: isString,
            type: type,
            toPrecision: toPrecision,
            parseFunction: parseFunction,
            last: last,
            interpolate: interpolate,
            interpolateInv: interpolateInv,
            mapRange: mapRange,
            parseCoordGrammar: parseCoordGrammar,
            multiplyMatrices: multiplyMatrices
        });
        var Hooks = function() {
            function Hooks() {
                _classCallCheck(this, Hooks);
            }
            _createClass(Hooks, [
                {
                    key: "add",
                    value: function add(name, callback, first) {
                        if (typeof arguments[0] != "string") {
                            for(var name in arguments[0])this.add(name, arguments[0][name], arguments[1]);
                            return;
                        }
                        (Array.isArray(name) ? name : [
                            name
                        ]).forEach(function(name2) {
                            this[name2] = this[name2] || [];
                            if (callback) this[name2][first ? "unshift" : "push"](callback);
                        }, this);
                    }
                },
                {
                    key: "run",
                    value: function run(name, env) {
                        this[name] = this[name] || [];
                        this[name].forEach(function(callback) {
                            callback.call(env && env.context ? env.context : env, env);
                        });
                    }
                }
            ]);
            return Hooks;
        }();
        var hooks = new Hooks();
        var defaults = {
            gamut_mapping: "lch.c",
            precision: 5,
            deltaE: "76"
        };
        var WHITES = {
            D50: [
                .3457 / .3585,
                1,
                0.8251046025104602
            ],
            D65: [
                .3127 / .329,
                1,
                1.0890577507598784
            ]
        };
        function getWhite(name) {
            if (Array.isArray(name)) return name;
            return WHITES[name];
        }
        function adapt$1(W1, W2, XYZ) {
            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            W1 = getWhite(W1);
            W2 = getWhite(W2);
            if (!W1 || !W2) throw new TypeError("Missing white point to convert ".concat(!W1 ? "from" : "").concat(!W1 && !W2 ? "/" : "").concat(!W2 ? "to" : ""));
            if (W1 === W2) return XYZ;
            var env = {
                W1: W1,
                W2: W2,
                XYZ: XYZ,
                options: options
            };
            hooks.run("chromatic-adaptation-start", env);
            if (!env.M) {
                if (env.W1 === WHITES.D65 && env.W2 === WHITES.D50) env.M = [
                    [
                        1.0479298208405488,
                        .022946793341019088,
                        -0.05019222954313557
                    ],
                    [
                        .029627815688159344,
                        .990434484573249,
                        -0.01707382502938514
                    ],
                    [
                        -0.009243058152591178,
                        .015055144896577895,
                        .7518742899580008
                    ]
                ];
                else if (env.W1 === WHITES.D50 && env.W2 === WHITES.D65) env.M = [
                    [
                        .9554734527042182,
                        -0.023098536874261423,
                        .0632593086610217
                    ],
                    [
                        -0.028369706963208136,
                        1.0099954580058226,
                        .021041398966943008
                    ],
                    [
                        .012314001688319899,
                        -0.020507696433477912,
                        1.3303659366080753
                    ]
                ];
            }
            hooks.run("chromatic-adaptation-end", env);
            if (env.M) return multiplyMatrices(env.M, env.XYZ);
            else throw new TypeError("Only Bradford CAT with white points D50 and D65 supported for now.");
        }
        var ε$4 = 75e-6;
        var _ColorSpace = (_processFormat = new WeakSet(), _path = new WeakMap(), _getPath = new WeakSet(), function() {
            function _ColorSpace(options) {
                var _options$coords, _ref39, _options$white, _options$formats, _this$formats$functio, _this$formats, _this$formats2;
                _classCallCheck(this, _ColorSpace);
                _classPrivateMethodInitSpec(this, _getPath);
                _classPrivateMethodInitSpec(this, _processFormat);
                _classPrivateFieldInitSpec(this, _path, {
                    writable: true,
                    value: void 0
                });
                this.id = options.id;
                this.name = options.name;
                this.base = options.base ? _ColorSpace.get(options.base) : null;
                this.aliases = options.aliases;
                if (this.base) {
                    this.fromBase = options.fromBase;
                    this.toBase = options.toBase;
                }
                var _coords = (_options$coords = options.coords) !== null && _options$coords !== void 0 ? _options$coords : this.base.coords;
                this.coords = _coords;
                var white2 = (_ref39 = (_options$white = options.white) !== null && _options$white !== void 0 ? _options$white : this.base.white) !== null && _ref39 !== void 0 ? _ref39 : "D65";
                this.white = getWhite(white2);
                this.formats = (_options$formats = options.formats) !== null && _options$formats !== void 0 ? _options$formats : {};
                for(var name in this.formats){
                    var format = this.formats[name];
                    format.type || (format.type = "function");
                    format.name || (format.name = name);
                }
                if (options.cssId && !((_this$formats$functio = this.formats.functions) !== null && _this$formats$functio !== void 0 && _this$formats$functio.color)) {
                    this.formats.color = {
                        id: options.cssId
                    };
                    Object.defineProperty(this, "cssId", {
                        value: options.cssId
                    });
                } else if ((_this$formats = this.formats) !== null && _this$formats !== void 0 && _this$formats.color && !((_this$formats2 = this.formats) !== null && _this$formats2 !== void 0 && _this$formats2.color.id)) this.formats.color.id = this.id;
                this.referred = options.referred;
                _classPrivateFieldSet(this, _path, _classPrivateMethodGet(this, _getPath, _getPath2).call(this).reverse());
                hooks.run("colorspace-init-end", this);
            }
            _createClass(_ColorSpace, [
                {
                    key: "inGamut",
                    value: function inGamut(coords) {
                        var _ref40 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref40$epsilon = _ref40.epsilon, epsilon = _ref40$epsilon === void 0 ? ε$4 : _ref40$epsilon;
                        if (this.isPolar) {
                            coords = this.toBase(coords);
                            return this.base.inGamut(coords, {
                                epsilon: epsilon
                            });
                        }
                        var coordMeta = Object.values(this.coords);
                        return coords.every(function(c4, i) {
                            var meta = coordMeta[i];
                            if (meta.type !== "angle" && meta.range) {
                                if (Number.isNaN(c4)) return true;
                                var _meta$range = _slicedToArray(meta.range, 2), min = _meta$range[0], max2 = _meta$range[1];
                                return (min === void 0 || c4 >= min - epsilon) && (max2 === void 0 || c4 <= max2 + epsilon);
                            }
                            return true;
                        });
                    }
                },
                {
                    key: "cssId",
                    get: function get() {
                        var _this$formats$functio2, _this$formats$functio3;
                        return ((_this$formats$functio2 = this.formats.functions) === null || _this$formats$functio2 === void 0 ? void 0 : (_this$formats$functio3 = _this$formats$functio2.color) === null || _this$formats$functio3 === void 0 ? void 0 : _this$formats$functio3.id) || this.id;
                    }
                },
                {
                    key: "isPolar",
                    get: function get() {
                        for(var id in this.coords){
                            if (this.coords[id].type === "angle") return true;
                        }
                        return false;
                    }
                },
                {
                    key: "getFormat",
                    value: function getFormat(format) {
                        if (_typeof(format) === "object") {
                            format = _classPrivateMethodGet(this, _processFormat, _processFormat2).call(this, format);
                            return format;
                        }
                        var ret;
                        if (format === "default") ret = Object.values(this.formats)[0];
                        else ret = this.formats[format];
                        if (ret) {
                            ret = _classPrivateMethodGet(this, _processFormat, _processFormat2).call(this, ret);
                            return ret;
                        }
                        return null;
                    }
                },
                {
                    key: "to",
                    value: function to(space, coords) {
                        if (arguments.length === 1) {
                            var _ref41 = [
                                space.space,
                                space.coords
                            ];
                            space = _ref41[0];
                            coords = _ref41[1];
                        }
                        space = _ColorSpace.get(space);
                        if (this === space) return coords;
                        coords = coords.map(function(c4) {
                            return Number.isNaN(c4) ? 0 : c4;
                        });
                        var myPath = _classPrivateFieldGet(this, _path);
                        var otherPath = _classPrivateFieldGet(space, _path);
                        var connectionSpace, connectionSpaceIndex;
                        for(var _i12 = 0; _i12 < myPath.length; _i12++){
                            if (myPath[_i12] === otherPath[_i12]) {
                                connectionSpace = myPath[_i12];
                                connectionSpaceIndex = _i12;
                            } else break;
                        }
                        if (!connectionSpace) throw new Error("Cannot convert between color spaces ".concat(this, " and ").concat(space, ": no connection space was found"));
                        for(var _i13 = myPath.length - 1; _i13 > connectionSpaceIndex; _i13--)coords = myPath[_i13].toBase(coords);
                        for(var _i14 = connectionSpaceIndex + 1; _i14 < otherPath.length; _i14++)coords = otherPath[_i14].fromBase(coords);
                        return coords;
                    }
                },
                {
                    key: "from",
                    value: function from(space, coords) {
                        if (arguments.length === 1) {
                            var _ref42 = [
                                space.space,
                                space.coords
                            ];
                            space = _ref42[0];
                            coords = _ref42[1];
                        }
                        space = _ColorSpace.get(space);
                        return space.to(this, coords);
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return "".concat(this.name, " (").concat(this.id, ")");
                    }
                },
                {
                    key: "getMinCoords",
                    value: function getMinCoords() {
                        var ret = [];
                        for(var id in this.coords){
                            var _range2$min;
                            var meta = this.coords[id];
                            var range2 = meta.range || meta.refRange;
                            ret.push((_range2$min = range2 === null || range2 === void 0 ? void 0 : range2.min) !== null && _range2$min !== void 0 ? _range2$min : 0);
                        }
                        return ret;
                    }
                }
            ], [
                {
                    key: "all",
                    get: function get() {
                        return _toConsumableArray(new Set(Object.values(_ColorSpace.registry)));
                    }
                },
                {
                    key: "register",
                    value: function register(id, space) {
                        if (arguments.length === 1) {
                            space = arguments[0];
                            id = space.id;
                        }
                        space = this.get(space);
                        if (this.registry[id] && this.registry[id] !== space) throw new Error("Duplicate color space registration: '".concat(id, "'"));
                        this.registry[id] = space;
                        if (arguments.length === 1 && space.aliases) {
                            var _iterator7 = _createForOfIteratorHelper(space.aliases), _step7;
                            try {
                                for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                    var alias = _step7.value;
                                    this.register(alias, space);
                                }
                            } catch (err) {
                                _iterator7.e(err);
                            } finally{
                                _iterator7.f();
                            }
                        }
                        return space;
                    }
                },
                {
                    key: "get",
                    value: function get(space) {
                        if (!space || space instanceof _ColorSpace) return space;
                        var argType = type(space);
                        if (argType === "string") {
                            var ret = _ColorSpace.registry[space.toLowerCase()];
                            if (!ret) throw new TypeError('No color space found with id = "'.concat(space, '"'));
                            return ret;
                        }
                        for(var _len2 = arguments.length, alternatives = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)alternatives[_key2 - 1] = arguments[_key2];
                        if (alternatives.length) return _ColorSpace.get.apply(_ColorSpace, alternatives);
                        throw new TypeError("".concat(space, " is not a valid color space"));
                    }
                },
                {
                    key: "resolveCoord",
                    value: function resolveCoord(ref, workingSpace) {
                        var coordType = type(ref);
                        var space, coord;
                        if (coordType === "string") {
                            if (ref.includes(".")) {
                                var _ref$split = ref.split(".");
                                var _ref$split2 = _slicedToArray(_ref$split, 2);
                                space = _ref$split2[0];
                                coord = _ref$split2[1];
                            } else {
                                space = void 0;
                                coord = ref;
                            }
                        } else if (Array.isArray(ref)) {
                            var _ref43 = _slicedToArray(ref, 2);
                            space = _ref43[0];
                            coord = _ref43[1];
                        } else {
                            space = ref.space;
                            coord = ref.coordId;
                        }
                        space = _ColorSpace.get(space);
                        if (!space) space = workingSpace;
                        if (!space) throw new TypeError("Cannot resolve coordinate reference ".concat(ref, ": No color space specified and relative references are not allowed here"));
                        coordType = type(coord);
                        if (coordType === "number" || coordType === "string" && coord >= 0) {
                            var meta = Object.entries(space.coords)[coord];
                            if (meta) return _extends({
                                space: space,
                                id: meta[0],
                                index: coord
                            }, meta[1]);
                        }
                        space = _ColorSpace.get(space);
                        var normalizedCoord = coord.toLowerCase();
                        var i = 0;
                        for(var id in space.coords){
                            var _meta$name;
                            var _meta = space.coords[id];
                            if (id.toLowerCase() === normalizedCoord || ((_meta$name = _meta.name) === null || _meta$name === void 0 ? void 0 : _meta$name.toLowerCase()) === normalizedCoord) return _extends({
                                space: space,
                                id: id,
                                index: i
                            }, _meta);
                            i++;
                        }
                        throw new TypeError('No "'.concat(coord, '" coordinate found in ').concat(space.name, ". Its coordinates are: ").concat(Object.keys(space.coords).join(", ")));
                    }
                }
            ]);
            return _ColorSpace;
        }());
        function _processFormat2(format) {
            if (format.coords && !format.coordGrammar) {
                format.type || (format.type = "function");
                format.name || (format.name = "color");
                format.coordGrammar = parseCoordGrammar(format.coords);
                var coordFormats = Object.entries(this.coords).map(function(_ref151, i) {
                    var _ref152 = _slicedToArray(_ref151, 2), id = _ref152[0], coordMeta = _ref152[1];
                    var outputType = format.coordGrammar[i][0];
                    var fromRange = coordMeta.range || coordMeta.refRange;
                    var toRange = outputType.range, suffix = "";
                    if (outputType == "<percentage>") {
                        toRange = [
                            0,
                            100
                        ];
                        suffix = "%";
                    } else if (outputType == "<angle>") suffix = "deg";
                    return {
                        fromRange: fromRange,
                        toRange: toRange,
                        suffix: suffix
                    };
                });
                format.serializeCoords = function(coords, precision) {
                    return coords.map(function(c4, i) {
                        var _coordFormats$i = coordFormats[i], fromRange = _coordFormats$i.fromRange, toRange = _coordFormats$i.toRange, suffix = _coordFormats$i.suffix;
                        if (fromRange && toRange) c4 = mapRange(fromRange, toRange, c4);
                        c4 = toPrecision(c4, precision);
                        if (suffix) c4 += suffix;
                        return c4;
                    });
                };
            }
            return format;
        }
        function _getPath2() {
            var ret = [
                this
            ];
            for(var _space2 = this; _space2 = _space2.base;)ret.push(_space2);
            return ret;
        }
        var ColorSpace = _ColorSpace;
        __publicField(ColorSpace, "registry", {});
        __publicField(ColorSpace, "DEFAULT_FORMAT", {
            type: "functions",
            name: "color"
        });
        var XYZ_D65 = new ColorSpace({
            id: "xyz-d65",
            name: "XYZ D65",
            coords: {
                x: {
                    name: "X"
                },
                y: {
                    name: "Y"
                },
                z: {
                    name: "Z"
                }
            },
            white: "D65",
            formats: {
                color: {
                    ids: [
                        "xyz-d65",
                        "xyz"
                    ]
                }
            },
            aliases: [
                "xyz"
            ]
        });
        var RGBColorSpace = function(_ColorSpace2) {
            _inherits(RGBColorSpace, _ColorSpace2);
            var _super = _createSuper(RGBColorSpace);
            function RGBColorSpace(options) {
                var _options$referred;
                var _this;
                _classCallCheck(this, RGBColorSpace);
                if (!options.coords) options.coords = {
                    r: {
                        range: [
                            0,
                            1
                        ],
                        name: "Red"
                    },
                    g: {
                        range: [
                            0,
                            1
                        ],
                        name: "Green"
                    },
                    b: {
                        range: [
                            0,
                            1
                        ],
                        name: "Blue"
                    }
                };
                if (!options.base) options.base = XYZ_D65;
                if (options.toXYZ_M && options.fromXYZ_M) {
                    var _options$toBase, _options$fromBase;
                    (_options$toBase = options.toBase) !== null && _options$toBase !== void 0 ? _options$toBase : options.toBase = function(rgb) {
                        var xyz = multiplyMatrices(options.toXYZ_M, rgb);
                        if (_this.white !== _this.base.white) xyz = adapt$1(_this.white, _this.base.white, xyz);
                        return xyz;
                    };
                    (_options$fromBase = options.fromBase) !== null && _options$fromBase !== void 0 ? _options$fromBase : options.fromBase = function(xyz) {
                        xyz = adapt$1(_this.base.white, _this.white, xyz);
                        return multiplyMatrices(options.fromXYZ_M, xyz);
                    };
                }
                (_options$referred = options.referred) !== null && _options$referred !== void 0 ? _options$referred : options.referred = "display";
                return _this = _super.call(this, options);
            }
            return _createClass(RGBColorSpace);
        }(ColorSpace);
        function parse2(str) {
            var _String;
            var env = {
                str: (_String = String(str)) === null || _String === void 0 ? void 0 : _String.trim()
            };
            hooks.run("parse-start", env);
            if (env.color) return env.color;
            env.parsed = parseFunction(env.str);
            if (env.parsed) {
                var _ret2 = function() {
                    var name = env.parsed.name;
                    if (name === "color") {
                        var id = env.parsed.args.shift();
                        var alpha = env.parsed.rawArgs.indexOf("/") > 0 ? env.parsed.args.pop() : 1;
                        var _iterator8 = _createForOfIteratorHelper(ColorSpace.all), _step8;
                        try {
                            for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                                var space = _step8.value;
                                var colorSpec = space.getFormat("color");
                                if (colorSpec) {
                                    var _colorSpec$ids;
                                    if (id === colorSpec.id || (_colorSpec$ids = colorSpec.ids) !== null && _colorSpec$ids !== void 0 && _colorSpec$ids.includes(id)) {
                                        var _ret3 = function() {
                                            var argCount = Object.keys(space.coords).length;
                                            var coords = Array(argCount).fill(0);
                                            coords.forEach(function(_, i) {
                                                return coords[i] = env.parsed.args[i] || 0;
                                            });
                                            return {
                                                v: {
                                                    v: {
                                                        spaceId: space.id,
                                                        coords: coords,
                                                        alpha: alpha
                                                    }
                                                }
                                            };
                                        }();
                                        if (_typeof(_ret3) === "object") return _ret3.v;
                                    }
                                }
                            }
                        } catch (err) {
                            _iterator8.e(err);
                        } finally{
                            _iterator8.f();
                        }
                        var didYouMean = "";
                        if (id in ColorSpace.registry) {
                            var _ColorSpace$registry$, _ColorSpace$registry$2, _ColorSpace$registry$3;
                            var cssId = (_ColorSpace$registry$ = ColorSpace.registry[id].formats) === null || _ColorSpace$registry$ === void 0 ? void 0 : (_ColorSpace$registry$2 = _ColorSpace$registry$.functions) === null || _ColorSpace$registry$2 === void 0 ? void 0 : (_ColorSpace$registry$3 = _ColorSpace$registry$2.color) === null || _ColorSpace$registry$3 === void 0 ? void 0 : _ColorSpace$registry$3.id;
                            if (cssId) didYouMean = "Did you mean color(".concat(cssId, ")?");
                        }
                        throw new TypeError("Cannot parse color(".concat(id, "). ") + (didYouMean || "Missing a plugin?"));
                    } else {
                        var _iterator9 = _createForOfIteratorHelper(ColorSpace.all), _step9;
                        try {
                            var _loop5 = function _loop5() {
                                var space = _step9.value;
                                var format = space.getFormat(name);
                                if (format && format.type === "function") {
                                    var _alpha = 1;
                                    if (format.lastAlpha || last(env.parsed.args).alpha) _alpha = env.parsed.args.pop();
                                    var coords = env.parsed.args;
                                    if (format.coordGrammar) Object.entries(space.coords).forEach(function(_ref44, i) {
                                        var _coords$i;
                                        var _ref45 = _slicedToArray(_ref44, 2), id = _ref45[0], coordMeta = _ref45[1];
                                        var coordGrammar2 = format.coordGrammar[i];
                                        var providedType = (_coords$i = coords[i]) === null || _coords$i === void 0 ? void 0 : _coords$i.type;
                                        coordGrammar2 = coordGrammar2.find(function(c4) {
                                            return c4 == providedType;
                                        });
                                        if (!coordGrammar2) {
                                            var coordName = coordMeta.name || id;
                                            throw new TypeError("".concat(providedType, " not allowed for ").concat(coordName, " in ").concat(name, "()"));
                                        }
                                        var fromRange = coordGrammar2.range;
                                        if (providedType === "<percentage>") fromRange || (fromRange = [
                                            0,
                                            1
                                        ]);
                                        var toRange = coordMeta.range || coordMeta.refRange;
                                        if (fromRange && toRange) coords[i] = mapRange(fromRange, toRange, coords[i]);
                                    });
                                    return {
                                        v: {
                                            v: {
                                                spaceId: space.id,
                                                coords: coords,
                                                alpha: _alpha
                                            }
                                        }
                                    };
                                }
                            };
                            for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                                var _ret4 = _loop5();
                                if (_typeof(_ret4) === "object") return _ret4.v;
                            }
                        } catch (err) {
                            _iterator9.e(err);
                        } finally{
                            _iterator9.f();
                        }
                    }
                }();
                if (_typeof(_ret2) === "object") return _ret2.v;
            } else {
                var _iterator10 = _createForOfIteratorHelper(ColorSpace.all), _step10;
                try {
                    for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
                        var space = _step10.value;
                        for(var formatId in space.formats){
                            var format = space.formats[formatId];
                            if (format.type !== "custom") continue;
                            if (format.test && !format.test(env.str)) continue;
                            var color = format.parse(env.str);
                            if (color) {
                                var _color$alpha;
                                (_color$alpha = color.alpha) !== null && _color$alpha !== void 0 ? _color$alpha : color.alpha = 1;
                                return color;
                            }
                        }
                    }
                } catch (err) {
                    _iterator10.e(err);
                } finally{
                    _iterator10.f();
                }
            }
            throw new TypeError("Could not parse ".concat(str, " as a color. Missing a plugin?"));
        }
        function getColor(color) {
            if (!color) throw new TypeError("Empty color reference");
            if (isString(color)) color = parse2(color);
            var space = color.space || color.spaceId;
            if (!(space instanceof ColorSpace)) color.space = ColorSpace.get(space);
            if (color.alpha === void 0) color.alpha = 1;
            return color;
        }
        function getAll(color, space) {
            space = ColorSpace.get(space);
            return space.from(color);
        }
        function get(color, prop) {
            var _ColorSpace$resolveCo = ColorSpace.resolveCoord(prop, color.space), space = _ColorSpace$resolveCo.space, index = _ColorSpace$resolveCo.index;
            var coords = getAll(color, space);
            return coords[index];
        }
        function setAll(color, space, coords) {
            space = ColorSpace.get(space);
            color.coords = space.to(color.space, coords);
            return color;
        }
        function set(color, prop, value) {
            color = getColor(color);
            if (arguments.length === 2 && type(arguments[1]) === "object") {
                var object = arguments[1];
                for(var p2 in object)set(color, p2, object[p2]);
            } else {
                if (typeof value === "function") value = value(get(color, prop));
                var _ColorSpace$resolveCo2 = ColorSpace.resolveCoord(prop, color.space), space = _ColorSpace$resolveCo2.space, index = _ColorSpace$resolveCo2.index;
                var coords = getAll(color, space);
                coords[index] = value;
                setAll(color, space, coords);
            }
            return color;
        }
        var XYZ_D50 = new ColorSpace({
            id: "xyz-d50",
            name: "XYZ D50",
            white: "D50",
            base: XYZ_D65,
            fromBase: function fromBase(coords) {
                return adapt$1(XYZ_D65.white, "D50", coords);
            },
            toBase: function toBase(coords) {
                return adapt$1("D50", XYZ_D65.white, coords);
            },
            formats: {
                color: {}
            }
        });
        var ε$3 = 216 / 24389;
        var ε3$1 = 24 / 116;
        var κ$1 = 24389 / 27;
        var white$1 = WHITES.D50;
        var lab = new ColorSpace({
            id: "lab",
            name: "Lab",
            coords: {
                l: {
                    refRange: [
                        0,
                        100
                    ],
                    name: "L"
                },
                a: {
                    refRange: [
                        -125,
                        125
                    ]
                },
                b: {
                    refRange: [
                        -125,
                        125
                    ]
                }
            },
            white: white$1,
            base: XYZ_D50,
            fromBase: function fromBase(XYZ) {
                var xyz = XYZ.map(function(value, i) {
                    return value / white$1[i];
                });
                var f = xyz.map(function(value) {
                    return value > ε$3 ? Math.cbrt(value) : (κ$1 * value + 16) / 116;
                });
                return [
                    116 * f[1] - 16,
                    500 * (f[0] - f[1]),
                    200 * (f[1] - f[2])
                ];
            },
            toBase: function toBase(Lab) {
                var f = [];
                f[1] = (Lab[0] + 16) / 116;
                f[0] = Lab[1] / 500 + f[1];
                f[2] = f[1] - Lab[2] / 200;
                var xyz = [
                    f[0] > ε3$1 ? Math.pow(f[0], 3) : (116 * f[0] - 16) / κ$1,
                    Lab[0] > 8 ? Math.pow((Lab[0] + 16) / 116, 3) : Lab[0] / κ$1,
                    f[2] > ε3$1 ? Math.pow(f[2], 3) : (116 * f[2] - 16) / κ$1
                ];
                return xyz.map(function(value, i) {
                    return value * white$1[i];
                });
            },
            formats: {
                lab: {
                    coords: [
                        "<number> | <percentage>",
                        "<number>",
                        "<number>"
                    ]
                }
            }
        });
        function constrain(angle) {
            return (angle % 360 + 360) % 360;
        }
        function adjust(arc, angles) {
            if (arc === "raw") return angles;
            var _angles$map = angles.map(constrain), _angles$map2 = _slicedToArray(_angles$map, 2), a1 = _angles$map2[0], a2 = _angles$map2[1];
            var angleDiff = a2 - a1;
            if (arc === "increasing") {
                if (angleDiff < 0) a2 += 360;
            } else if (arc === "decreasing") {
                if (angleDiff > 0) a1 += 360;
            } else if (arc === "longer") {
                if (-180 < angleDiff && angleDiff < 180) {
                    if (angleDiff > 0) a2 += 360;
                    else a1 += 360;
                }
            } else if (arc === "shorter") {
                if (angleDiff > 180) a1 += 360;
                else if (angleDiff < -180) a2 += 360;
            }
            return [
                a1,
                a2
            ];
        }
        var lch = new ColorSpace({
            id: "lch",
            name: "LCH",
            coords: {
                l: {
                    refRange: [
                        0,
                        100
                    ],
                    name: "Lightness"
                },
                c: {
                    refRange: [
                        0,
                        150
                    ],
                    name: "Chroma"
                },
                h: {
                    refRange: [
                        0,
                        360
                    ],
                    type: "angle",
                    name: "Hue"
                }
            },
            base: lab,
            fromBase: function fromBase(Lab) {
                var _Lab = _slicedToArray(Lab, 3), L = _Lab[0], a2 = _Lab[1], b2 = _Lab[2];
                var hue;
                var ε2 = .02;
                if (Math.abs(a2) < ε2 && Math.abs(b2) < ε2) hue = NaN;
                else hue = Math.atan2(b2, a2) * 180 / Math.PI;
                return [
                    L,
                    Math.sqrt(Math.pow(a2, 2) + Math.pow(b2, 2)),
                    constrain(hue)
                ];
            },
            toBase: function toBase(LCH) {
                var _LCH = _slicedToArray(LCH, 3), Lightness = _LCH[0], Chroma = _LCH[1], Hue = _LCH[2];
                if (Chroma < 0) Chroma = 0;
                if (isNaN(Hue)) Hue = 0;
                return [
                    Lightness,
                    Chroma * Math.cos(Hue * Math.PI / 180),
                    Chroma * Math.sin(Hue * Math.PI / 180)
                ];
            },
            formats: {
                lch: {
                    coords: [
                        "<number> | <percentage>",
                        "<number>",
                        "<number> | <angle>"
                    ]
                }
            }
        });
        var Gfactor = Math.pow(25, 7);
        var π$1 = Math.PI;
        var r2d = 180 / π$1;
        var d2r$1 = π$1 / 180;
        function deltaE2000(color, sample) {
            var _ref46 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref46$kL = _ref46.kL, kL = _ref46$kL === void 0 ? 1 : _ref46$kL, _ref46$kC = _ref46.kC, kC = _ref46$kC === void 0 ? 1 : _ref46$kC, _ref46$kH = _ref46.kH, kH = _ref46$kH === void 0 ? 1 : _ref46$kH;
            var _lab$from = lab.from(color), _lab$from2 = _slicedToArray(_lab$from, 3), L1 = _lab$from2[0], a1 = _lab$from2[1], b1 = _lab$from2[2];
            var C1 = lch.from(lab, [
                L1,
                a1,
                b1
            ])[1];
            var _lab$from3 = lab.from(sample), _lab$from4 = _slicedToArray(_lab$from3, 3), L2 = _lab$from4[0], a2 = _lab$from4[1], b2 = _lab$from4[2];
            var C2 = lch.from(lab, [
                L2,
                a2,
                b2
            ])[1];
            if (C1 < 0) C1 = 0;
            if (C2 < 0) C2 = 0;
            var Cbar = (C1 + C2) / 2;
            var C7 = Math.pow(Cbar, 7);
            var G = .5 * (1 - Math.sqrt(C7 / (C7 + Gfactor)));
            var adash1 = (1 + G) * a1;
            var adash2 = (1 + G) * a2;
            var Cdash1 = Math.sqrt(Math.pow(adash1, 2) + Math.pow(b1, 2));
            var Cdash2 = Math.sqrt(Math.pow(adash2, 2) + Math.pow(b2, 2));
            var h1 = adash1 === 0 && b1 === 0 ? 0 : Math.atan2(b1, adash1);
            var h2 = adash2 === 0 && b2 === 0 ? 0 : Math.atan2(b2, adash2);
            if (h1 < 0) h1 += 2 * π$1;
            if (h2 < 0) h2 += 2 * π$1;
            h1 *= r2d;
            h2 *= r2d;
            var ΔL = L2 - L1;
            var ΔC = Cdash2 - Cdash1;
            var hdiff = h2 - h1;
            var hsum = h1 + h2;
            var habs = Math.abs(hdiff);
            var Δh;
            if (Cdash1 * Cdash2 === 0) Δh = 0;
            else if (habs <= 180) Δh = hdiff;
            else if (hdiff > 180) Δh = hdiff - 360;
            else if (hdiff < -180) Δh = hdiff + 360;
            else console.log("the unthinkable has happened");
            var ΔH = 2 * Math.sqrt(Cdash2 * Cdash1) * Math.sin(Δh * d2r$1 / 2);
            var Ldash = (L1 + L2) / 2;
            var Cdash = (Cdash1 + Cdash2) / 2;
            var Cdash7 = Math.pow(Cdash, 7);
            var hdash;
            if (Cdash1 * Cdash2 === 0) hdash = hsum;
            else if (habs <= 180) hdash = hsum / 2;
            else if (hsum < 360) hdash = (hsum + 360) / 2;
            else hdash = (hsum - 360) / 2;
            var lsq = Math.pow(Ldash - 50, 2);
            var SL = 1 + .015 * lsq / Math.sqrt(20 + lsq);
            var SC = 1 + .045 * Cdash;
            var T = 1;
            T -= .17 * Math.cos((hdash - 30) * d2r$1);
            T += .24 * Math.cos(2 * hdash * d2r$1);
            T += .32 * Math.cos((3 * hdash + 6) * d2r$1);
            T -= .2 * Math.cos((4 * hdash - 63) * d2r$1);
            var SH = 1 + .015 * Cdash * T;
            var Δθ = 30 * Math.exp(-1 * Math.pow((hdash - 275) / 25, 2));
            var RC = 2 * Math.sqrt(Cdash7 / (Cdash7 + Gfactor));
            var RT = -1 * Math.sin(2 * Δθ * d2r$1) * RC;
            var dE = Math.pow(ΔL / (kL * SL), 2);
            dE += Math.pow(ΔC / (kC * SC), 2);
            dE += Math.pow(ΔH / (kH * SH), 2);
            dE += RT * (ΔC / (kC * SC)) * (ΔH / (kH * SH));
            return Math.sqrt(dE);
        }
        var ε$2 = 75e-6;
        function inGamut(color) {
            var space = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : color.space;
            var _ref47 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref47$epsilon = _ref47.epsilon, epsilon = _ref47$epsilon === void 0 ? ε$2 : _ref47$epsilon;
            color = getColor(color);
            space = ColorSpace.get(space);
            var coords = color.coords;
            if (space !== color.space) coords = space.from(color);
            return space.inGamut(coords, {
                epsilon: epsilon
            });
        }
        function clone2(color) {
            return {
                space: color.space,
                coords: color.coords.slice(),
                alpha: color.alpha
            };
        }
        function toGamut(color) {
            var _ref48 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref48$method = _ref48.method, method = _ref48$method === void 0 ? defaults.gamut_mapping : _ref48$method, _ref48$space = _ref48.space, space = _ref48$space === void 0 ? color.space : _ref48$space;
            if (isString(arguments[1])) space = arguments[1];
            space = ColorSpace.get(space);
            if (inGamut(color, space, {
                epsilon: 0
            })) return color;
            var spaceColor = to(color, space);
            if (method !== "clip" && !inGamut(color, space)) {
                var clipped = toGamut(clone2(spaceColor), {
                    method: "clip",
                    space: space
                });
                if (deltaE2000(color, clipped) > 2) {
                    var coordMeta = ColorSpace.resolveCoord(method);
                    var mapSpace = coordMeta.space;
                    var coordId = coordMeta.id;
                    var mappedColor = to(spaceColor, mapSpace);
                    var bounds = coordMeta.range || coordMeta.refRange;
                    var min = bounds[0];
                    var ε2 = .01;
                    var low = min;
                    var high = get(mappedColor, coordId);
                    while(high - low > ε2){
                        var clipped2 = clone2(mappedColor);
                        clipped2 = toGamut(clipped2, {
                            space: space,
                            method: "clip"
                        });
                        var deltaE2 = deltaE2000(mappedColor, clipped2);
                        if (deltaE2 - 2 < ε2) low = get(mappedColor, coordId);
                        else high = get(mappedColor, coordId);
                        set(mappedColor, coordId, (low + high) / 2);
                    }
                    spaceColor = to(mappedColor, space);
                } else spaceColor = clipped;
            }
            if (method === "clip" || !inGamut(spaceColor, space, {
                epsilon: 0
            })) {
                var _bounds = Object.values(space.coords).map(function(c4) {
                    return c4.range || [];
                });
                spaceColor.coords = spaceColor.coords.map(function(c4, i) {
                    var _bounds$i = _slicedToArray(_bounds[i], 2), min = _bounds$i[0], max2 = _bounds$i[1];
                    if (min !== void 0) c4 = Math.max(min, c4);
                    if (max2 !== void 0) c4 = Math.min(c4, max2);
                    return c4;
                });
            }
            if (space !== color.space) spaceColor = to(spaceColor, color.space);
            color.coords = spaceColor.coords;
            return color;
        }
        toGamut.returns = "color";
        function to(color, space) {
            var _ref49 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, inGamut2 = _ref49.inGamut;
            color = getColor(color);
            space = ColorSpace.get(space);
            var coords = space.from(color);
            var ret = {
                space: space,
                coords: coords,
                alpha: color.alpha
            };
            if (inGamut2) ret = toGamut(ret);
            return ret;
        }
        to.returns = "color";
        function serialize(color) {
            var _ref51, _color$space$getForma;
            var _ref50 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _ref50$precision = _ref50.precision, precision = _ref50$precision === void 0 ? defaults.precision : _ref50$precision, _ref50$format = _ref50.format, format = _ref50$format === void 0 ? "default" : _ref50$format, _ref50$inGamut = _ref50.inGamut, inGamut$1 = _ref50$inGamut === void 0 ? true : _ref50$inGamut, customOptions = _objectWithoutProperties(_ref50, _excluded9);
            var ret;
            color = getColor(color);
            var formatId = format;
            format = (_ref51 = (_color$space$getForma = color.space.getFormat(format)) !== null && _color$space$getForma !== void 0 ? _color$space$getForma : color.space.getFormat("default")) !== null && _ref51 !== void 0 ? _ref51 : ColorSpace.DEFAULT_FORMAT;
            inGamut$1 || (inGamut$1 = format.toGamut);
            var coords = color.coords;
            coords = coords.map(function(c4) {
                return c4 ? c4 : 0;
            });
            if (inGamut$1 && !inGamut(color)) coords = toGamut(clone2(color), inGamut$1 === true ? void 0 : inGamut$1).coords;
            if (format.type === "custom") {
                customOptions.precision = precision;
                if (format.serialize) ret = format.serialize(coords, color.alpha, customOptions);
                else throw new TypeError("format ".concat(formatId, " can only be used to parse colors, not for serialization"));
            } else {
                var name = format.name || "color";
                if (format.serializeCoords) coords = format.serializeCoords(coords, precision);
                else if (precision !== null) coords = coords.map(function(c4) {
                    return toPrecision(c4, precision);
                });
                var args = _toConsumableArray(coords);
                if (name === "color") {
                    var _format$ids;
                    var cssId = format.id || ((_format$ids = format.ids) === null || _format$ids === void 0 ? void 0 : _format$ids[0]) || color.space.id;
                    args.unshift(cssId);
                }
                var alpha = color.alpha;
                if (precision !== null) alpha = toPrecision(alpha, precision);
                var strAlpha = color.alpha < 1 && !format.noAlpha ? "".concat(format.commas ? "," : " /", " ").concat(alpha) : "";
                ret = "".concat(name, "(").concat(args.join(format.commas ? ", " : " ")).concat(strAlpha, ")");
            }
            return ret;
        }
        var toXYZ_M$5 = [
            [
                .6369580483012914,
                .14461690358620832,
                .1688809751641721
            ],
            [
                .2627002120112671,
                .6779980715188708,
                .05930171646986196
            ],
            [
                0,
                .028072693049087428,
                1.060985057710791
            ]
        ];
        var fromXYZ_M$5 = [
            [
                1.716651187971268,
                -0.355670783776392,
                -0.25336628137366
            ],
            [
                -0.666684351832489,
                1.616481236634939,
                .0157685458139111
            ],
            [
                .017639857445311,
                -0.042770613257809,
                .942103121235474
            ]
        ];
        var REC2020Linear = new RGBColorSpace({
            id: "rec2020-linear",
            name: "Linear REC.2020",
            white: "D65",
            toXYZ_M: toXYZ_M$5,
            fromXYZ_M: fromXYZ_M$5,
            formats: {
                color: {}
            }
        });
        var α = 1.09929682680944;
        var β = .018053968510807;
        var REC2020 = new RGBColorSpace({
            id: "rec2020",
            name: "REC.2020",
            base: REC2020Linear,
            toBase: function toBase(RGB) {
                return RGB.map(function(val) {
                    if (val < β * 4.5) return val / 4.5;
                    return Math.pow((val + α - 1) / α, 1 / .45);
                });
            },
            fromBase: function fromBase(RGB) {
                return RGB.map(function(val) {
                    if (val >= β) return α * Math.pow(val, .45) - (α - 1);
                    return 4.5 * val;
                });
            },
            formats: {
                color: {}
            }
        });
        var toXYZ_M$4 = [
            [
                .4865709486482162,
                .26566769316909306,
                .1982172852343625
            ],
            [
                .2289745640697488,
                .6917385218365064,
                .079286914093745
            ],
            [
                0,
                .04511338185890264,
                1.043944368900976
            ]
        ];
        var fromXYZ_M$4 = [
            [
                2.493496911941425,
                -0.9313836179191239,
                -0.40271078445071684
            ],
            [
                -0.8294889695615747,
                1.7626640603183463,
                .023624685841943577
            ],
            [
                .03584583024378447,
                -0.07617238926804182,
                .9568845240076872
            ]
        ];
        var P3Linear = new RGBColorSpace({
            id: "p3-linear",
            name: "Linear P3",
            white: "D65",
            toXYZ_M: toXYZ_M$4,
            fromXYZ_M: fromXYZ_M$4
        });
        var toXYZ_M$3 = [
            [
                .41239079926595934,
                .357584339383878,
                .1804807884018343
            ],
            [
                .21263900587151027,
                .715168678767756,
                .07219231536073371
            ],
            [
                .01933081871559182,
                .11919477979462598,
                .9505321522496607
            ]
        ];
        var fromXYZ_M$3 = [
            [
                3.2409699419045226,
                -1.537383177570094,
                -0.4986107602930034
            ],
            [
                -0.9692436362808796,
                1.8759675015077202,
                .04155505740717559
            ],
            [
                .05563007969699366,
                -0.20397695888897652,
                1.0569715142428786
            ]
        ];
        var sRGBLinear = new RGBColorSpace({
            id: "srgb-linear",
            name: "Linear sRGB",
            white: "D65",
            toXYZ_M: toXYZ_M$3,
            fromXYZ_M: fromXYZ_M$3,
            formats: {
                color: {}
            }
        });
        var KEYWORDS = {
            aliceblue: [
                240 / 255,
                248 / 255,
                1
            ],
            antiquewhite: [
                250 / 255,
                235 / 255,
                215 / 255
            ],
            aqua: [
                0,
                1,
                1
            ],
            aquamarine: [
                127 / 255,
                1,
                212 / 255
            ],
            azure: [
                240 / 255,
                1,
                1
            ],
            beige: [
                245 / 255,
                245 / 255,
                220 / 255
            ],
            bisque: [
                1,
                228 / 255,
                196 / 255
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                1,
                235 / 255,
                205 / 255
            ],
            blue: [
                0,
                0,
                1
            ],
            blueviolet: [
                138 / 255,
                43 / 255,
                226 / 255
            ],
            brown: [
                165 / 255,
                42 / 255,
                42 / 255
            ],
            burlywood: [
                222 / 255,
                184 / 255,
                135 / 255
            ],
            cadetblue: [
                95 / 255,
                158 / 255,
                160 / 255
            ],
            chartreuse: [
                127 / 255,
                1,
                0
            ],
            chocolate: [
                210 / 255,
                105 / 255,
                30 / 255
            ],
            coral: [
                1,
                127 / 255,
                80 / 255
            ],
            cornflowerblue: [
                100 / 255,
                149 / 255,
                237 / 255
            ],
            cornsilk: [
                1,
                248 / 255,
                220 / 255
            ],
            crimson: [
                220 / 255,
                20 / 255,
                60 / 255
            ],
            cyan: [
                0,
                1,
                1
            ],
            darkblue: [
                0,
                0,
                139 / 255
            ],
            darkcyan: [
                0,
                139 / 255,
                139 / 255
            ],
            darkgoldenrod: [
                184 / 255,
                134 / 255,
                11 / 255
            ],
            darkgray: [
                169 / 255,
                169 / 255,
                169 / 255
            ],
            darkgreen: [
                0,
                100 / 255,
                0
            ],
            darkgrey: [
                169 / 255,
                169 / 255,
                169 / 255
            ],
            darkkhaki: [
                189 / 255,
                183 / 255,
                107 / 255
            ],
            darkmagenta: [
                139 / 255,
                0,
                139 / 255
            ],
            darkolivegreen: [
                85 / 255,
                107 / 255,
                47 / 255
            ],
            darkorange: [
                1,
                140 / 255,
                0
            ],
            darkorchid: [
                0.6,
                50 / 255,
                0.8
            ],
            darkred: [
                139 / 255,
                0,
                0
            ],
            darksalmon: [
                233 / 255,
                150 / 255,
                122 / 255
            ],
            darkseagreen: [
                143 / 255,
                188 / 255,
                143 / 255
            ],
            darkslateblue: [
                72 / 255,
                61 / 255,
                139 / 255
            ],
            darkslategray: [
                47 / 255,
                79 / 255,
                79 / 255
            ],
            darkslategrey: [
                47 / 255,
                79 / 255,
                79 / 255
            ],
            darkturquoise: [
                0,
                206 / 255,
                209 / 255
            ],
            darkviolet: [
                148 / 255,
                0,
                211 / 255
            ],
            deeppink: [
                1,
                20 / 255,
                147 / 255
            ],
            deepskyblue: [
                0,
                191 / 255,
                1
            ],
            dimgray: [
                105 / 255,
                105 / 255,
                105 / 255
            ],
            dimgrey: [
                105 / 255,
                105 / 255,
                105 / 255
            ],
            dodgerblue: [
                30 / 255,
                144 / 255,
                1
            ],
            firebrick: [
                178 / 255,
                34 / 255,
                34 / 255
            ],
            floralwhite: [
                1,
                250 / 255,
                240 / 255
            ],
            forestgreen: [
                34 / 255,
                139 / 255,
                34 / 255
            ],
            fuchsia: [
                1,
                0,
                1
            ],
            gainsboro: [
                220 / 255,
                220 / 255,
                220 / 255
            ],
            ghostwhite: [
                248 / 255,
                248 / 255,
                1
            ],
            gold: [
                1,
                215 / 255,
                0
            ],
            goldenrod: [
                218 / 255,
                165 / 255,
                32 / 255
            ],
            gray: [
                128 / 255,
                128 / 255,
                128 / 255
            ],
            green: [
                0,
                128 / 255,
                0
            ],
            greenyellow: [
                173 / 255,
                1,
                47 / 255
            ],
            grey: [
                128 / 255,
                128 / 255,
                128 / 255
            ],
            honeydew: [
                240 / 255,
                1,
                240 / 255
            ],
            hotpink: [
                1,
                105 / 255,
                180 / 255
            ],
            indianred: [
                205 / 255,
                92 / 255,
                92 / 255
            ],
            indigo: [
                75 / 255,
                0,
                130 / 255
            ],
            ivory: [
                1,
                1,
                240 / 255
            ],
            khaki: [
                240 / 255,
                230 / 255,
                140 / 255
            ],
            lavender: [
                230 / 255,
                230 / 255,
                250 / 255
            ],
            lavenderblush: [
                1,
                240 / 255,
                245 / 255
            ],
            lawngreen: [
                124 / 255,
                252 / 255,
                0
            ],
            lemonchiffon: [
                1,
                250 / 255,
                205 / 255
            ],
            lightblue: [
                173 / 255,
                216 / 255,
                230 / 255
            ],
            lightcoral: [
                240 / 255,
                128 / 255,
                128 / 255
            ],
            lightcyan: [
                224 / 255,
                1,
                1
            ],
            lightgoldenrodyellow: [
                250 / 255,
                250 / 255,
                210 / 255
            ],
            lightgray: [
                211 / 255,
                211 / 255,
                211 / 255
            ],
            lightgreen: [
                144 / 255,
                238 / 255,
                144 / 255
            ],
            lightgrey: [
                211 / 255,
                211 / 255,
                211 / 255
            ],
            lightpink: [
                1,
                182 / 255,
                193 / 255
            ],
            lightsalmon: [
                1,
                160 / 255,
                122 / 255
            ],
            lightseagreen: [
                32 / 255,
                178 / 255,
                170 / 255
            ],
            lightskyblue: [
                135 / 255,
                206 / 255,
                250 / 255
            ],
            lightslategray: [
                119 / 255,
                136 / 255,
                0.6
            ],
            lightslategrey: [
                119 / 255,
                136 / 255,
                0.6
            ],
            lightsteelblue: [
                176 / 255,
                196 / 255,
                222 / 255
            ],
            lightyellow: [
                1,
                1,
                224 / 255
            ],
            lime: [
                0,
                1,
                0
            ],
            limegreen: [
                50 / 255,
                205 / 255,
                50 / 255
            ],
            linen: [
                250 / 255,
                240 / 255,
                230 / 255
            ],
            magenta: [
                1,
                0,
                1
            ],
            maroon: [
                128 / 255,
                0,
                0
            ],
            mediumaquamarine: [
                0.4,
                205 / 255,
                170 / 255
            ],
            mediumblue: [
                0,
                0,
                205 / 255
            ],
            mediumorchid: [
                186 / 255,
                85 / 255,
                211 / 255
            ],
            mediumpurple: [
                147 / 255,
                112 / 255,
                219 / 255
            ],
            mediumseagreen: [
                60 / 255,
                179 / 255,
                113 / 255
            ],
            mediumslateblue: [
                123 / 255,
                104 / 255,
                238 / 255
            ],
            mediumspringgreen: [
                0,
                250 / 255,
                154 / 255
            ],
            mediumturquoise: [
                72 / 255,
                209 / 255,
                0.8
            ],
            mediumvioletred: [
                199 / 255,
                21 / 255,
                133 / 255
            ],
            midnightblue: [
                25 / 255,
                25 / 255,
                112 / 255
            ],
            mintcream: [
                245 / 255,
                1,
                250 / 255
            ],
            mistyrose: [
                1,
                228 / 255,
                225 / 255
            ],
            moccasin: [
                1,
                228 / 255,
                181 / 255
            ],
            navajowhite: [
                1,
                222 / 255,
                173 / 255
            ],
            navy: [
                0,
                0,
                128 / 255
            ],
            oldlace: [
                253 / 255,
                245 / 255,
                230 / 255
            ],
            olive: [
                128 / 255,
                128 / 255,
                0
            ],
            olivedrab: [
                107 / 255,
                142 / 255,
                35 / 255
            ],
            orange: [
                1,
                165 / 255,
                0
            ],
            orangered: [
                1,
                69 / 255,
                0
            ],
            orchid: [
                218 / 255,
                112 / 255,
                214 / 255
            ],
            palegoldenrod: [
                238 / 255,
                232 / 255,
                170 / 255
            ],
            palegreen: [
                152 / 255,
                251 / 255,
                152 / 255
            ],
            paleturquoise: [
                175 / 255,
                238 / 255,
                238 / 255
            ],
            palevioletred: [
                219 / 255,
                112 / 255,
                147 / 255
            ],
            papayawhip: [
                1,
                239 / 255,
                213 / 255
            ],
            peachpuff: [
                1,
                218 / 255,
                185 / 255
            ],
            peru: [
                205 / 255,
                133 / 255,
                63 / 255
            ],
            pink: [
                1,
                192 / 255,
                203 / 255
            ],
            plum: [
                221 / 255,
                160 / 255,
                221 / 255
            ],
            powderblue: [
                176 / 255,
                224 / 255,
                230 / 255
            ],
            purple: [
                128 / 255,
                0,
                128 / 255
            ],
            rebeccapurple: [
                0.4,
                0.2,
                0.6
            ],
            red: [
                1,
                0,
                0
            ],
            rosybrown: [
                188 / 255,
                143 / 255,
                143 / 255
            ],
            royalblue: [
                65 / 255,
                105 / 255,
                225 / 255
            ],
            saddlebrown: [
                139 / 255,
                69 / 255,
                19 / 255
            ],
            salmon: [
                250 / 255,
                128 / 255,
                114 / 255
            ],
            sandybrown: [
                244 / 255,
                164 / 255,
                96 / 255
            ],
            seagreen: [
                46 / 255,
                139 / 255,
                87 / 255
            ],
            seashell: [
                1,
                245 / 255,
                238 / 255
            ],
            sienna: [
                160 / 255,
                82 / 255,
                45 / 255
            ],
            silver: [
                192 / 255,
                192 / 255,
                192 / 255
            ],
            skyblue: [
                135 / 255,
                206 / 255,
                235 / 255
            ],
            slateblue: [
                106 / 255,
                90 / 255,
                205 / 255
            ],
            slategray: [
                112 / 255,
                128 / 255,
                144 / 255
            ],
            slategrey: [
                112 / 255,
                128 / 255,
                144 / 255
            ],
            snow: [
                1,
                250 / 255,
                250 / 255
            ],
            springgreen: [
                0,
                1,
                127 / 255
            ],
            steelblue: [
                70 / 255,
                130 / 255,
                180 / 255
            ],
            tan: [
                210 / 255,
                180 / 255,
                140 / 255
            ],
            teal: [
                0,
                128 / 255,
                128 / 255
            ],
            thistle: [
                216 / 255,
                191 / 255,
                216 / 255
            ],
            tomato: [
                1,
                99 / 255,
                71 / 255
            ],
            turquoise: [
                64 / 255,
                224 / 255,
                208 / 255
            ],
            violet: [
                238 / 255,
                130 / 255,
                238 / 255
            ],
            wheat: [
                245 / 255,
                222 / 255,
                179 / 255
            ],
            white: [
                1,
                1,
                1
            ],
            whitesmoke: [
                245 / 255,
                245 / 255,
                245 / 255
            ],
            yellow: [
                1,
                1,
                0
            ],
            yellowgreen: [
                154 / 255,
                205 / 255,
                50 / 255
            ]
        };
        var coordGrammar = Array(3).fill("<percentage> | <number>[0, 255]");
        var coordGrammarNumber = Array(3).fill("<number>[0, 255]");
        var sRGB = new RGBColorSpace({
            id: "srgb",
            name: "sRGB",
            base: sRGBLinear,
            fromBase: function fromBase(rgb) {
                return rgb.map(function(val) {
                    var sign = val < 0 ? -1 : 1;
                    var abs = val * sign;
                    if (abs > .0031308) return sign * (1.055 * Math.pow(abs, 1 / 2.4) - .055);
                    return 12.92 * val;
                });
            },
            toBase: function toBase(rgb) {
                return rgb.map(function(val) {
                    var sign = val < 0 ? -1 : 1;
                    var abs = val * sign;
                    if (abs < .04045) return val / 12.92;
                    return sign * Math.pow((abs + .055) / 1.055, 2.4);
                });
            },
            formats: {
                rgb: {
                    coords: coordGrammar
                },
                rgb_number: {
                    name: "rgb",
                    commas: true,
                    coords: coordGrammarNumber,
                    noAlpha: true
                },
                color: {},
                rgba: {
                    coords: coordGrammar,
                    commas: true,
                    lastAlpha: true
                },
                rgba_number: {
                    name: "rgba",
                    commas: true,
                    coords: coordGrammarNumber
                },
                hex: {
                    type: "custom",
                    toGamut: true,
                    test: function test(str) {
                        return /^#([a-f0-9]{3,4}){1,2}$/i.test(str);
                    },
                    parse: function parse(str) {
                        if (str.length <= 5) str = str.replace(/[a-f0-9]/gi, "$&$&");
                        var rgba = [];
                        str.replace(/[a-f0-9]{2}/gi, function(component) {
                            rgba.push(parseInt(component, 16) / 255);
                        });
                        return {
                            spaceId: "srgb",
                            coords: rgba.slice(0, 3),
                            alpha: rgba.slice(3)[0]
                        };
                    },
                    serialize: function serialize(coords, alpha) {
                        var _ref52 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref52$collapse = _ref52.collapse, collapse = _ref52$collapse === void 0 ? true : _ref52$collapse;
                        if (alpha < 1) coords.push(alpha);
                        coords = coords.map(function(c4) {
                            return Math.round(c4 * 255);
                        });
                        var collapsible = collapse && coords.every(function(c4) {
                            return c4 % 17 === 0;
                        });
                        var hex = coords.map(function(c4) {
                            if (collapsible) return (c4 / 17).toString(16);
                            return c4.toString(16).padStart(2, "0");
                        }).join("");
                        return "#" + hex;
                    }
                },
                keyword: {
                    type: "custom",
                    test: function test(str) {
                        return /^[a-z]+$/i.test(str);
                    },
                    parse: function parse(str) {
                        str = str.toLowerCase();
                        var ret = {
                            spaceId: "srgb",
                            coords: null,
                            alpha: 1
                        };
                        if (str === "transparent") {
                            ret.coords = KEYWORDS.black;
                            ret.alpha = 0;
                        } else ret.coords = KEYWORDS[str];
                        if (ret.coords) return ret;
                    }
                }
            }
        });
        var P3 = new RGBColorSpace({
            id: "p3",
            name: "P3",
            base: P3Linear,
            fromBase: sRGB.fromBase,
            toBase: sRGB.toBase,
            formats: {
                color: {
                    id: "display-p3"
                }
            }
        });
        defaults.display_space = sRGB;
        if (typeof CSS !== "undefined" && CSS.supports) for(var _i15 = 0, _arr3 = [
            lab,
            REC2020,
            P3
        ]; _i15 < _arr3.length; _i15++){
            var space = _arr3[_i15];
            var coords = space.getMinCoords();
            var color = {
                space: space,
                coords: coords,
                alpha: 1
            };
            var str = serialize(color);
            if (CSS.supports("color", str)) {
                defaults.display_space = space;
                break;
            }
        }
        function _display(color) {
            var _ref53 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _ref53$space = _ref53.space, space = _ref53$space === void 0 ? defaults.display_space : _ref53$space, options = _objectWithoutProperties(_ref53, _excluded10);
            var ret = serialize(color, options);
            if (typeof CSS === "undefined" || CSS.supports("color", ret) || !defaults.display_space) {
                ret = new String(ret);
                ret.color = color;
            } else {
                var fallbackColor = to(color, space);
                ret = new String(serialize(fallbackColor, options));
                ret.color = fallbackColor;
            }
            return ret;
        }
        function distance(color1, color2) {
            var space = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "lab";
            space = ColorSpace.get(space);
            var coords1 = space.from(color1);
            var coords2 = space.from(color2);
            return Math.sqrt(coords1.reduce(function(acc, c12, i) {
                var c22 = coords2[i];
                if (isNaN(c12) || isNaN(c22)) return acc;
                return acc + Math.pow(c22 - c12, 2);
            }, 0));
        }
        function equals(color1, color2) {
            color1 = getColor(color1);
            color2 = getColor(color2);
            return color1.space === color2.space && color1.alpha === color2.alpha && color1.coords.every(function(c4, i) {
                return c4 === color2.coords[i];
            });
        }
        function getLuminance(color) {
            return get(color, [
                XYZ_D65,
                "y"
            ]);
        }
        function setLuminance(color, value) {
            set(color, [
                XYZ_D65,
                "y"
            ], value);
        }
        function register$2(Color3) {
            Object.defineProperty(Color3.prototype, "luminance", {
                get: function get() {
                    return getLuminance(this);
                },
                set: function set(value) {
                    setLuminance(this, value);
                }
            });
        }
        var luminance = Object.freeze({
            __proto__: null,
            getLuminance: getLuminance,
            setLuminance: setLuminance,
            register: register$2
        });
        function contrastWCAG21(color1, color2) {
            color1 = getColor(color1);
            color2 = getColor(color2);
            var Y1 = Math.max(getLuminance(color1), 0);
            var Y2 = Math.max(getLuminance(color2), 0);
            if (Y2 > Y1) {
                var _ref54 = [
                    Y2,
                    Y1
                ];
                Y1 = _ref54[0];
                Y2 = _ref54[1];
            }
            return (Y1 + .05) / (Y2 + .05);
        }
        var normBG = .56;
        var normTXT = .57;
        var revTXT = .62;
        var revBG = .65;
        var blkThrs = .022;
        var blkClmp = 1.414;
        var loClip = .1;
        var deltaYmin = 5e-4;
        var scaleBoW = 1.14;
        var loBoWoffset = .027;
        var scaleWoB = 1.14;
        function fclamp(Y) {
            if (Y >= blkThrs) return Y;
            return Y + Math.pow(blkThrs - Y, blkClmp);
        }
        function linearize(val) {
            var sign = val < 0 ? -1 : 1;
            var abs = Math.abs(val);
            return sign * Math.pow(abs, 2.4);
        }
        function contrastAPCA(background, foreground) {
            foreground = getColor(foreground);
            background = getColor(background);
            var S;
            var C;
            var Sapc;
            var R, G, B;
            foreground = to(foreground, "srgb");
            var _foreground$coords = _slicedToArray(foreground.coords, 3);
            R = _foreground$coords[0];
            G = _foreground$coords[1];
            B = _foreground$coords[2];
            var lumTxt = linearize(R) * .2126729 + linearize(G) * .7151522 + linearize(B) * .072175;
            background = to(background, "srgb");
            var _background$coords = _slicedToArray(background.coords, 3);
            R = _background$coords[0];
            G = _background$coords[1];
            B = _background$coords[2];
            var lumBg = linearize(R) * .2126729 + linearize(G) * .7151522 + linearize(B) * .072175;
            var Ytxt = fclamp(lumTxt);
            var Ybg = fclamp(lumBg);
            var BoW = Ybg > Ytxt;
            if (Math.abs(Ybg - Ytxt) < deltaYmin) C = 0;
            else if (BoW) {
                S = Math.pow(Ybg, normBG) - Math.pow(Ytxt, normTXT);
                C = S * scaleBoW;
            } else {
                S = Math.pow(Ybg, revBG) - Math.pow(Ytxt, revTXT);
                C = S * scaleWoB;
            }
            if (Math.abs(C) < loClip) Sapc = 0;
            else if (C > 0) Sapc = C - loBoWoffset;
            else Sapc = C + loBoWoffset;
            return Sapc * 100;
        }
        function contrastMichelson(color1, color2) {
            color1 = getColor(color1);
            color2 = getColor(color2);
            var Y1 = Math.max(getLuminance(color1), 0);
            var Y2 = Math.max(getLuminance(color2), 0);
            if (Y2 > Y1) {
                var _ref55 = [
                    Y2,
                    Y1
                ];
                Y1 = _ref55[0];
                Y2 = _ref55[1];
            }
            var denom = Y1 + Y2;
            return denom === 0 ? 0 : (Y1 - Y2) / denom;
        }
        var max = 5e4;
        function contrastWeber(color1, color2) {
            color1 = getColor(color1);
            color2 = getColor(color2);
            var Y1 = Math.max(getLuminance(color1), 0);
            var Y2 = Math.max(getLuminance(color2), 0);
            if (Y2 > Y1) {
                var _ref56 = [
                    Y2,
                    Y1
                ];
                Y1 = _ref56[0];
                Y2 = _ref56[1];
            }
            return Y2 === 0 ? max : (Y1 - Y2) / Y2;
        }
        function contrastLstar(color1, color2) {
            color1 = getColor(color1);
            color2 = getColor(color2);
            var L1 = get(color1, [
                lab,
                "l"
            ]);
            var L2 = get(color2, [
                lab,
                "l"
            ]);
            return Math.abs(L1 - L2);
        }
        var ε$1 = 216 / 24389;
        var ε3 = 24 / 116;
        var κ = 24389 / 27;
        var white = WHITES.D65;
        var lab_d65 = new ColorSpace({
            id: "lab-d65",
            name: "Lab D65",
            coords: {
                l: {
                    refRange: [
                        0,
                        100
                    ],
                    name: "L"
                },
                a: {
                    refRange: [
                        -125,
                        125
                    ]
                },
                b: {
                    refRange: [
                        -125,
                        125
                    ]
                }
            },
            white: white,
            base: XYZ_D65,
            fromBase: function fromBase(XYZ) {
                var xyz = XYZ.map(function(value, i) {
                    return value / white[i];
                });
                var f = xyz.map(function(value) {
                    return value > ε$1 ? Math.cbrt(value) : (κ * value + 16) / 116;
                });
                return [
                    116 * f[1] - 16,
                    500 * (f[0] - f[1]),
                    200 * (f[1] - f[2])
                ];
            },
            toBase: function toBase(Lab) {
                var f = [];
                f[1] = (Lab[0] + 16) / 116;
                f[0] = Lab[1] / 500 + f[1];
                f[2] = f[1] - Lab[2] / 200;
                var xyz = [
                    f[0] > ε3 ? Math.pow(f[0], 3) : (116 * f[0] - 16) / κ,
                    Lab[0] > 8 ? Math.pow((Lab[0] + 16) / 116, 3) : Lab[0] / κ,
                    f[2] > ε3 ? Math.pow(f[2], 3) : (116 * f[2] - 16) / κ
                ];
                return xyz.map(function(value, i) {
                    return value * white[i];
                });
            },
            formats: {
                "lab-d65": {
                    coords: [
                        "<number> | <percentage>",
                        "<number>",
                        "<number>"
                    ]
                }
            }
        });
        var phi = Math.pow(5, .5) * .5 + .5;
        function contrastDeltaPhi(color1, color2) {
            color1 = getColor(color1);
            color2 = getColor(color2);
            var Lstr1 = get(color1, [
                lab_d65,
                "l"
            ]);
            var Lstr2 = get(color2, [
                lab_d65,
                "l"
            ]);
            var deltaPhiStar = Math.abs(Math.pow(Lstr1, phi) - Math.pow(Lstr2, phi));
            var contrast2 = Math.pow(deltaPhiStar, 1 / phi) * Math.SQRT2 - 40;
            return contrast2 < 7.5 ? 0 : contrast2;
        }
        var contrastMethods = Object.freeze({
            __proto__: null,
            contrastWCAG21: contrastWCAG21,
            contrastAPCA: contrastAPCA,
            contrastMichelson: contrastMichelson,
            contrastWeber: contrastWeber,
            contrastLstar: contrastLstar,
            contrastDeltaPhi: contrastDeltaPhi
        });
        function contrast(background, foreground) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (isString(o)) o = {
                algorithm: o
            };
            var _o = o, algorithm = _o.algorithm, rest = _objectWithoutProperties(_o, _excluded11);
            if (!algorithm) {
                var algorithms = Object.keys(contrastMethods).map(function(a2) {
                    return a2.replace(/^contrast/, "");
                }).join(", ");
                throw new TypeError("contrast() function needs a contrast algorithm. Please specify one of: ".concat(algorithms));
            }
            background = getColor(background);
            foreground = getColor(foreground);
            for(var a2 in contrastMethods){
                if ("contrast" + algorithm.toLowerCase() === a2.toLowerCase()) return contrastMethods[a2](background, foreground, rest);
            }
            throw new TypeError("Unknown contrast algorithm: ".concat(algorithm));
        }
        function uv(color) {
            var _getAll = getAll(color, XYZ_D65), _getAll2 = _slicedToArray(_getAll, 3), X = _getAll2[0], Y = _getAll2[1], Z = _getAll2[2];
            var denom = X + 15 * Y + 3 * Z;
            return [
                4 * X / denom,
                9 * Y / denom
            ];
        }
        function xy(color) {
            var _getAll3 = getAll(color, XYZ_D65), _getAll4 = _slicedToArray(_getAll3, 3), X = _getAll4[0], Y = _getAll4[1], Z = _getAll4[2];
            var sum = X + Y + Z;
            return [
                X / sum,
                Y / sum
            ];
        }
        function register$1(Color3) {
            Object.defineProperty(Color3.prototype, "uv", {
                get: function get() {
                    return uv(this);
                }
            });
            Object.defineProperty(Color3.prototype, "xy", {
                get: function get() {
                    return xy(this);
                }
            });
        }
        var chromaticity = Object.freeze({
            __proto__: null,
            uv: uv,
            xy: xy,
            register: register$1
        });
        function deltaE76(color, sample) {
            return distance(color, sample, "lab");
        }
        var π = Math.PI;
        var d2r = π / 180;
        function deltaECMC(color, sample) {
            var _ref57 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref57$l = _ref57.l, l = _ref57$l === void 0 ? 2 : _ref57$l, _ref57$c = _ref57.c, c4 = _ref57$c === void 0 ? 1 : _ref57$c;
            var _lab$from5 = lab.from(color), _lab$from6 = _slicedToArray(_lab$from5, 3), L1 = _lab$from6[0], a1 = _lab$from6[1], b1 = _lab$from6[2];
            var _lch$from = lch.from(lab, [
                L1,
                a1,
                b1
            ]), _lch$from2 = _slicedToArray(_lch$from, 3), C1 = _lch$from2[1], H1 = _lch$from2[2];
            var _lab$from7 = lab.from(sample), _lab$from8 = _slicedToArray(_lab$from7, 3), L2 = _lab$from8[0], a2 = _lab$from8[1], b2 = _lab$from8[2];
            var C2 = lch.from(lab, [
                L2,
                a2,
                b2
            ])[1];
            if (C1 < 0) C1 = 0;
            if (C2 < 0) C2 = 0;
            var ΔL = L1 - L2;
            var ΔC = C1 - C2;
            var Δa = a1 - a2;
            var Δb = b1 - b2;
            var H2 = Math.pow(Δa, 2) + Math.pow(Δb, 2) - Math.pow(ΔC, 2);
            var SL = .511;
            if (L1 >= 16) SL = .040975 * L1 / (1 + .01765 * L1);
            var SC = .0638 * C1 / (1 + .0131 * C1) + .638;
            var T;
            if (Number.isNaN(H1)) H1 = 0;
            if (H1 >= 164 && H1 <= 345) T = .56 + Math.abs(.2 * Math.cos((H1 + 168) * d2r));
            else T = .36 + Math.abs(.4 * Math.cos((H1 + 35) * d2r));
            var C4 = Math.pow(C1, 4);
            var F = Math.sqrt(C4 / (C4 + 1900));
            var SH = SC * (F * T + 1 - F);
            var dE = Math.pow(ΔL / (l * SL), 2);
            dE += Math.pow(ΔC / (c4 * SC), 2);
            dE += H2 / Math.pow(SH, 2);
            return Math.sqrt(dE);
        }
        var Yw$1 = 203;
        var XYZ_Abs_D65 = new ColorSpace({
            id: "xyz-abs-d65",
            name: "Absolute XYZ D65",
            coords: {
                x: {
                    refRange: [
                        0,
                        9504.7
                    ],
                    name: "Xa"
                },
                y: {
                    refRange: [
                        0,
                        1e4
                    ],
                    name: "Ya"
                },
                z: {
                    refRange: [
                        0,
                        10888.3
                    ],
                    name: "Za"
                }
            },
            base: XYZ_D65,
            fromBase: function fromBase(XYZ) {
                return XYZ.map(function(v) {
                    return Math.max(v * Yw$1, 0);
                });
            },
            toBase: function toBase(AbsXYZ) {
                return AbsXYZ.map(function(v) {
                    return Math.max(v / Yw$1, 0);
                });
            }
        });
        var b$1 = 1.15;
        var g = .66;
        var n$1 = 2610 / Math.pow(2, 14);
        var ninv$1 = Math.pow(2, 14) / 2610;
        var c1$2 = 3424 / Math.pow(2, 12);
        var c2$2 = 2413 / Math.pow(2, 7);
        var c3$2 = 2392 / Math.pow(2, 7);
        var p = 1.7 * 2523 / Math.pow(2, 5);
        var pinv = Math.pow(2, 5) / (1.7 * 2523);
        var d = -0.56;
        var d0 = 16295499532821565e-27;
        var XYZtoCone_M = [
            [
                .41478972,
                .579999,
                .014648
            ],
            [
                -0.20151,
                1.120649,
                .0531008
            ],
            [
                -0.0166008,
                .2648,
                .6684799
            ]
        ];
        var ConetoXYZ_M = [
            [
                1.9242264357876067,
                -1.0047923125953657,
                .037651404030618
            ],
            [
                .35031676209499907,
                .7264811939316552,
                -0.06538442294808501
            ],
            [
                -0.09098281098284752,
                -0.3127282905230739,
                1.5227665613052603
            ]
        ];
        var ConetoIab_M = [
            [
                .5,
                .5,
                0
            ],
            [
                3.524,
                -4.066708,
                .542708
            ],
            [
                .199076,
                1.096799,
                -1.295875
            ]
        ];
        var IabtoCone_M = [
            [
                1,
                .1386050432715393,
                .05804731615611886
            ],
            [
                .9999999999999999,
                -0.1386050432715393,
                -0.05804731615611886
            ],
            [
                .9999999999999998,
                -0.09601924202631895,
                -0.8118918960560388
            ]
        ];
        var Jzazbz = new ColorSpace({
            id: "jzazbz",
            name: "Jzazbz",
            coords: {
                jz: {
                    refRange: [
                        0,
                        1
                    ],
                    name: "Jz"
                },
                az: {
                    refRange: [
                        -0.5,
                        .5
                    ]
                },
                bz: {
                    refRange: [
                        -0.5,
                        .5
                    ]
                }
            },
            base: XYZ_Abs_D65,
            fromBase: function fromBase(XYZ) {
                var _XYZ = _slicedToArray(XYZ, 3), Xa = _XYZ[0], Ya = _XYZ[1], Za = _XYZ[2];
                var Xm = b$1 * Xa - (b$1 - 1) * Za;
                var Ym = g * Ya - (g - 1) * Xa;
                var LMS = multiplyMatrices(XYZtoCone_M, [
                    Xm,
                    Ym,
                    Za
                ]);
                var PQLMS = LMS.map(function(val) {
                    var num = c1$2 + c2$2 * Math.pow(val / 1e4, n$1);
                    var denom = 1 + c3$2 * Math.pow(val / 1e4, n$1);
                    return Math.pow(num / denom, p);
                });
                var _multiplyMatrices = multiplyMatrices(ConetoIab_M, PQLMS), _multiplyMatrices2 = _slicedToArray(_multiplyMatrices, 3), Iz = _multiplyMatrices2[0], az = _multiplyMatrices2[1], bz = _multiplyMatrices2[2];
                var Jz = (1 + d) * Iz / (1 + d * Iz) - d0;
                return [
                    Jz,
                    az,
                    bz
                ];
            },
            toBase: function toBase(Jzazbz2) {
                var _Jzazbz = _slicedToArray(Jzazbz2, 3), Jz = _Jzazbz[0], az = _Jzazbz[1], bz = _Jzazbz[2];
                var Iz = (Jz + d0) / (1 + d - d * (Jz + d0));
                var PQLMS = multiplyMatrices(IabtoCone_M, [
                    Iz,
                    az,
                    bz
                ]);
                var LMS = PQLMS.map(function(val) {
                    var num = c1$2 - Math.pow(val, pinv);
                    var denom = c3$2 * Math.pow(val, pinv) - c2$2;
                    var x = 1e4 * Math.pow(num / denom, ninv$1);
                    return x;
                });
                var _multiplyMatrices3 = multiplyMatrices(ConetoXYZ_M, LMS), _multiplyMatrices4 = _slicedToArray(_multiplyMatrices3, 3), Xm = _multiplyMatrices4[0], Ym = _multiplyMatrices4[1], Za = _multiplyMatrices4[2];
                var Xa = (Xm + (b$1 - 1) * Za) / b$1;
                var Ya = (Ym + (g - 1) * Xa) / g;
                return [
                    Xa,
                    Ya,
                    Za
                ];
            },
            formats: {
                color: {}
            }
        });
        var jzczhz = new ColorSpace({
            id: "jzczhz",
            name: "JzCzHz",
            coords: {
                jz: {
                    refRange: [
                        0,
                        1
                    ],
                    name: "Jz"
                },
                cz: {
                    refRange: [
                        0,
                        1
                    ],
                    name: "Chroma"
                },
                hz: {
                    refRange: [
                        0,
                        360
                    ],
                    type: "angle",
                    name: "Hue"
                }
            },
            base: Jzazbz,
            fromBase: function fromBase(jzazbz) {
                var _jzazbz = _slicedToArray(jzazbz, 3), Jz = _jzazbz[0], az = _jzazbz[1], bz = _jzazbz[2];
                var hue;
                var ε2 = 2e-4;
                if (Math.abs(az) < ε2 && Math.abs(bz) < ε2) hue = NaN;
                else hue = Math.atan2(bz, az) * 180 / Math.PI;
                return [
                    Jz,
                    Math.sqrt(Math.pow(az, 2) + Math.pow(bz, 2)),
                    constrain(hue)
                ];
            },
            toBase: function toBase(jzczhz2) {
                return [
                    jzczhz2[0],
                    jzczhz2[1] * Math.cos(jzczhz2[2] * Math.PI / 180),
                    jzczhz2[1] * Math.sin(jzczhz2[2] * Math.PI / 180)
                ];
            },
            formats: {
                color: {}
            }
        });
        function deltaEJz(color, sample) {
            var _jzczhz$from = jzczhz.from(color), _jzczhz$from2 = _slicedToArray(_jzczhz$from, 3), Jz1 = _jzczhz$from2[0], Cz1 = _jzczhz$from2[1], Hz1 = _jzczhz$from2[2];
            var _jzczhz$from3 = jzczhz.from(sample), _jzczhz$from4 = _slicedToArray(_jzczhz$from3, 3), Jz2 = _jzczhz$from4[0], Cz2 = _jzczhz$from4[1], Hz2 = _jzczhz$from4[2];
            var ΔJ = Jz1 - Jz2;
            var ΔC = Cz1 - Cz2;
            if (Number.isNaN(Hz1) && Number.isNaN(Hz2)) {
                Hz1 = 0;
                Hz2 = 0;
            } else if (Number.isNaN(Hz1)) Hz1 = Hz2;
            else if (Number.isNaN(Hz2)) Hz2 = Hz1;
            var Δh = Hz1 - Hz2;
            var ΔH = 2 * Math.sqrt(Cz1 * Cz2) * Math.sin(Δh / 2 * (Math.PI / 180));
            return Math.sqrt(Math.pow(ΔJ, 2) + Math.pow(ΔC, 2) + Math.pow(ΔH, 2));
        }
        var c1$1 = 0.8359375;
        var c2$1 = 2413 / 128;
        var c3$1 = 18.6875;
        var m1 = 2610 / 16384;
        var m2 = 2523 / 32;
        var im1 = 16384 / 2610;
        var im2 = 32 / 2523;
        var XYZtoLMS_M$1 = [
            [
                .3592,
                .6976,
                -0.0358
            ],
            [
                -0.1922,
                1.1004,
                .0755
            ],
            [
                .007,
                .0749,
                .8434
            ]
        ];
        var LMStoIPT_M = [
            [
                0.5,
                0.5,
                0
            ],
            [
                6610 / 4096,
                -13613 / 4096,
                7003 / 4096
            ],
            [
                17933 / 4096,
                -17390 / 4096,
                -543 / 4096
            ]
        ];
        var IPTtoLMS_M = [
            [
                .9999888965628402,
                .008605050147287059,
                .11103437159861648
            ],
            [
                1.00001110343716,
                -0.008605050147287059,
                -0.11103437159861648
            ],
            [
                1.0000320633910054,
                .56004913547279,
                -0.3206339100541203
            ]
        ];
        var LMStoXYZ_M$1 = [
            [
                2.0701800566956137,
                -1.326456876103021,
                .20661600684785517
            ],
            [
                .3649882500326575,
                .6804673628522352,
                -0.04542175307585323
            ],
            [
                -0.04959554223893211,
                -0.04942116118675749,
                1.1879959417328034
            ]
        ];
        var ictcp = new ColorSpace({
            id: "ictcp",
            name: "ICTCP",
            coords: {
                i: {
                    refRange: [
                        0,
                        1
                    ],
                    name: "I"
                },
                ct: {
                    refRange: [
                        -0.5,
                        .5
                    ],
                    name: "CT"
                },
                cp: {
                    refRange: [
                        -0.5,
                        .5
                    ],
                    name: "CP"
                }
            },
            base: XYZ_Abs_D65,
            fromBase: function fromBase(XYZ) {
                var LMS = multiplyMatrices(XYZtoLMS_M$1, XYZ);
                return LMStoICtCp(LMS);
            },
            toBase: function toBase(ICtCp) {
                var LMS = ICtCptoLMS(ICtCp);
                return multiplyMatrices(LMStoXYZ_M$1, LMS);
            },
            formats: {
                color: {}
            }
        });
        function LMStoICtCp(LMS) {
            var PQLMS = LMS.map(function(val) {
                var num = c1$1 + c2$1 * Math.pow(val / 1e4, m1);
                var denom = 1 + c3$1 * Math.pow(val / 1e4, m1);
                return Math.pow(num / denom, m2);
            });
            return multiplyMatrices(LMStoIPT_M, PQLMS);
        }
        function ICtCptoLMS(ICtCp) {
            var PQLMS = multiplyMatrices(IPTtoLMS_M, ICtCp);
            var LMS = PQLMS.map(function(val) {
                var num = Math.max(Math.pow(val, im2) - c1$1, 0);
                var denom = c2$1 - c3$1 * Math.pow(val, im2);
                return 1e4 * Math.pow(num / denom, im1);
            });
            return LMS;
        }
        function deltaEITP(color, sample) {
            var _ictcp$from = ictcp.from(color), _ictcp$from2 = _slicedToArray(_ictcp$from, 3), I1 = _ictcp$from2[0], T1 = _ictcp$from2[1], P1 = _ictcp$from2[2];
            var _ictcp$from3 = ictcp.from(sample), _ictcp$from4 = _slicedToArray(_ictcp$from3, 3), I2 = _ictcp$from4[0], T2 = _ictcp$from4[1], P2 = _ictcp$from4[2];
            return 720 * Math.sqrt(Math.pow(I1 - I2, 2) + .25 * Math.pow(T1 - T2, 2) + Math.pow(P1 - P2, 2));
        }
        var XYZtoLMS_M = [
            [
                .8190224432164319,
                .3619062562801221,
                -0.12887378261216414
            ],
            [
                .0329836671980271,
                .9292868468965546,
                .03614466816999844
            ],
            [
                .048177199566046255,
                .26423952494422764,
                .6335478258136937
            ]
        ];
        var LMStoXYZ_M = [
            [
                1.2268798733741557,
                -0.5578149965554813,
                .28139105017721583
            ],
            [
                -0.04057576262431372,
                1.1122868293970594,
                -0.07171106666151701
            ],
            [
                -0.07637294974672142,
                -0.4214933239627914,
                1.5869240244272418
            ]
        ];
        var LMStoLab_M = [
            [
                .2104542553,
                .793617785,
                -0.0040720468
            ],
            [
                1.9779984951,
                -2.428592205,
                .4505937099
            ],
            [
                .0259040371,
                .7827717662,
                -0.808675766
            ]
        ];
        var LabtoLMS_M = [
            [
                .9999999984505198,
                .39633779217376786,
                .2158037580607588
            ],
            [
                1.0000000088817609,
                -0.10556134232365635,
                -0.06385417477170591
            ],
            [
                1.0000000546724108,
                -0.08948418209496575,
                -1.2914855378640917
            ]
        ];
        var OKLab = new ColorSpace({
            id: "oklab",
            name: "OKLab",
            coords: {
                l: {
                    refRange: [
                        0,
                        1
                    ],
                    name: "L"
                },
                a: {
                    refRange: [
                        -0.4,
                        .4
                    ]
                },
                b: {
                    refRange: [
                        -0.4,
                        .4
                    ]
                }
            },
            white: "D65",
            base: XYZ_D65,
            fromBase: function fromBase(XYZ) {
                var LMS = multiplyMatrices(XYZtoLMS_M, XYZ);
                var LMSg = LMS.map(function(val) {
                    return Math.cbrt(val);
                });
                return multiplyMatrices(LMStoLab_M, LMSg);
            },
            toBase: function toBase(OKLab2) {
                var LMSg = multiplyMatrices(LabtoLMS_M, OKLab2);
                var LMS = LMSg.map(function(val) {
                    return Math.pow(val, 3);
                });
                return multiplyMatrices(LMStoXYZ_M, LMS);
            },
            formats: {
                oklab: {
                    coords: [
                        "<number> | <percentage>",
                        "<number>",
                        "<number>"
                    ]
                }
            }
        });
        function deltaEOK(color, sample) {
            var _OKLab$from = OKLab.from(color), _OKLab$from2 = _slicedToArray(_OKLab$from, 3), L1 = _OKLab$from2[0], a1 = _OKLab$from2[1], b1 = _OKLab$from2[2];
            var _OKLab$from3 = OKLab.from(sample), _OKLab$from4 = _slicedToArray(_OKLab$from3, 3), L2 = _OKLab$from4[0], a2 = _OKLab$from4[1], b2 = _OKLab$from4[2];
            var ΔL = L1 - L2;
            var Δa = a1 - a2;
            var Δb = b1 - b2;
            return Math.sqrt(Math.pow(ΔL, 2) + Math.pow(Δa, 2) + Math.pow(Δb, 2));
        }
        var deltaEMethods = Object.freeze({
            __proto__: null,
            deltaE76: deltaE76,
            deltaECMC: deltaECMC,
            deltaE2000: deltaE2000,
            deltaEJz: deltaEJz,
            deltaEITP: deltaEITP,
            deltaEOK: deltaEOK
        });
        function deltaE(c12, c22) {
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (isString(o)) o = {
                method: o
            };
            var _o2 = o, _o2$method = _o2.method, method = _o2$method === void 0 ? defaults.deltaE : _o2$method, rest = _objectWithoutProperties(_o2, _excluded12);
            c12 = getColor(c12);
            c22 = getColor(c22);
            for(var m3 in deltaEMethods){
                if ("deltae" + method.toLowerCase() === m3.toLowerCase()) return deltaEMethods[m3](c12, c22, rest);
            }
            throw new TypeError("Unknown deltaE method: ".concat(method));
        }
        function lighten(color) {
            var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .25;
            var space = ColorSpace.get("oklch", "lch");
            var lightness = [
                space,
                "l"
            ];
            return set(color, lightness, function(l) {
                return l * (1 + amount);
            });
        }
        function darken(color) {
            var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .25;
            var space = ColorSpace.get("oklch", "lch");
            var lightness = [
                space,
                "l"
            ];
            return set(color, lightness, function(l) {
                return l * (1 - amount);
            });
        }
        var variations = Object.freeze({
            __proto__: null,
            lighten: lighten,
            darken: darken
        });
        function mix(c12, c22) {
            var p2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .5;
            var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var _ref58 = [
                getColor(c12),
                getColor(c22)
            ];
            c12 = _ref58[0];
            c22 = _ref58[1];
            if (type(p2) === "object") {
                var _ref59 = [
                    .5,
                    p2
                ];
                p2 = _ref59[0];
                o = _ref59[1];
            }
            var _o3 = o, space = _o3.space, outputSpace = _o3.outputSpace, premultiplied = _o3.premultiplied;
            var r = range(c12, c22, {
                space: space,
                outputSpace: outputSpace,
                premultiplied: premultiplied
            });
            return r(p2);
        }
        function steps(c12, c22) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var colorRange;
            if (isRange(c12)) {
                colorRange = c12;
                options = c22;
                var _colorRange$rangeArgs = _slicedToArray(colorRange.rangeArgs.colors, 2);
                c12 = _colorRange$rangeArgs[0];
                c22 = _colorRange$rangeArgs[1];
            }
            var _options = options, maxDeltaE = _options.maxDeltaE, deltaEMethod = _options.deltaEMethod, _options$steps = _options.steps, steps2 = _options$steps === void 0 ? 2 : _options$steps, _options$maxSteps = _options.maxSteps, maxSteps = _options$maxSteps === void 0 ? 1e3 : _options$maxSteps, rangeOptions = _objectWithoutProperties(_options, _excluded13);
            if (!colorRange) {
                var _ref60 = [
                    getColor(c12),
                    getColor(c22)
                ];
                c12 = _ref60[0];
                c22 = _ref60[1];
                colorRange = range(c12, c22, rangeOptions);
            }
            var totalDelta = deltaE(c12, c22);
            var actualSteps = maxDeltaE > 0 ? Math.max(steps2, Math.ceil(totalDelta / maxDeltaE) + 1) : steps2;
            var ret = [];
            if (maxSteps !== void 0) actualSteps = Math.min(actualSteps, maxSteps);
            if (actualSteps === 1) ret = [
                {
                    p: .5,
                    color: colorRange(.5)
                }
            ];
            else {
                var step = 1 / (actualSteps - 1);
                ret = Array.from({
                    length: actualSteps
                }, function(_, i) {
                    var p2 = i * step;
                    return {
                        p: p2,
                        color: colorRange(p2)
                    };
                });
            }
            if (maxDeltaE > 0) {
                var maxDelta = ret.reduce(function(acc, cur, i) {
                    if (i === 0) return 0;
                    var ΔΕ = deltaE(cur.color, ret[i - 1].color, deltaEMethod);
                    return Math.max(acc, ΔΕ);
                }, 0);
                while(maxDelta > maxDeltaE){
                    maxDelta = 0;
                    for(var _i16 = 1; _i16 < ret.length && ret.length < maxSteps; _i16++){
                        var prev = ret[_i16 - 1];
                        var cur = ret[_i16];
                        var p2 = (cur.p + prev.p) / 2;
                        var _color = colorRange(p2);
                        maxDelta = Math.max(maxDelta, deltaE(_color, prev.color), deltaE(_color, cur.color));
                        ret.splice(_i16, 0, {
                            p: p2,
                            color: colorRange(p2)
                        });
                        _i16++;
                    }
                }
            }
            ret = ret.map(function(a2) {
                return a2.color;
            });
            return ret;
        }
        function range(color1, color2) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (isRange(color1)) {
                var r = color1, options2 = color2;
                return range.apply(void 0, _toConsumableArray(r.rangeArgs.colors).concat([
                    _extends({}, r.rangeArgs.options, options2)
                ]));
            }
            var space = options.space, outputSpace = options.outputSpace, progression = options.progression, premultiplied = options.premultiplied;
            color1 = getColor(color1);
            color2 = getColor(color2);
            color1 = clone2(color1);
            color2 = clone2(color2);
            var rangeArgs = {
                colors: [
                    color1,
                    color2
                ],
                options: options
            };
            if (space) space = ColorSpace.get(space);
            else space = ColorSpace.registry[defaults.interpolationSpace] || color1.space;
            outputSpace = outputSpace ? ColorSpace.get(outputSpace) : space;
            color1 = to(color1, space);
            color2 = to(color2, space);
            color1 = toGamut(color1);
            color2 = toGamut(color2);
            if (space.coords.h && space.coords.h.type === "angle") {
                var arc = options.hue = options.hue || "shorter";
                var hue = [
                    space,
                    "h"
                ];
                var _ref61 = [
                    get(color1, hue),
                    get(color2, hue)
                ], θ1 = _ref61[0], θ2 = _ref61[1];
                var _adjust = adjust(arc, [
                    θ1,
                    θ2
                ]);
                var _adjust2 = _slicedToArray(_adjust, 2);
                θ1 = _adjust2[0];
                θ2 = _adjust2[1];
                set(color1, hue, θ1);
                set(color2, hue, θ2);
            }
            if (premultiplied) {
                color1.coords = color1.coords.map(function(c4) {
                    return c4 * color1.alpha;
                });
                color2.coords = color2.coords.map(function(c4) {
                    return c4 * color2.alpha;
                });
            }
            return Object.assign(function(p2) {
                p2 = progression ? progression(p2) : p2;
                var coords = color1.coords.map(function(start, i) {
                    var end = color2.coords[i];
                    return interpolate(start, end, p2);
                });
                var alpha = interpolate(color1.alpha, color2.alpha, p2);
                var ret = {
                    space: space,
                    coords: coords,
                    alpha: alpha
                };
                if (premultiplied) ret.coords = ret.coords.map(function(c4) {
                    return c4 / alpha;
                });
                if (outputSpace !== space) ret = to(ret, outputSpace);
                return ret;
            }, {
                rangeArgs: rangeArgs
            });
        }
        function isRange(val) {
            return type(val) === "function" && !!val.rangeArgs;
        }
        defaults.interpolationSpace = "lab";
        function register(Color3) {
            Color3.defineFunction("mix", mix, {
                returns: "color"
            });
            Color3.defineFunction("range", range, {
                returns: "function<color>"
            });
            Color3.defineFunction("steps", steps, {
                returns: "array<color>"
            });
        }
        var interpolation = Object.freeze({
            __proto__: null,
            mix: mix,
            steps: steps,
            range: range,
            isRange: isRange,
            register: register
        });
        var HSL = new ColorSpace({
            id: "hsl",
            name: "HSL",
            coords: {
                h: {
                    refRange: [
                        0,
                        360
                    ],
                    type: "angle",
                    name: "Hue"
                },
                s: {
                    range: [
                        0,
                        100
                    ],
                    name: "Saturation"
                },
                l: {
                    range: [
                        0,
                        100
                    ],
                    name: "Lightness"
                }
            },
            base: sRGB,
            fromBase: function fromBase(rgb) {
                var max2 = Math.max.apply(Math, _toConsumableArray(rgb));
                var min = Math.min.apply(Math, _toConsumableArray(rgb));
                var _rgb = _slicedToArray(rgb, 3), r = _rgb[0], g2 = _rgb[1], b2 = _rgb[2];
                var h = NaN, s = 0, l = (min + max2) / 2;
                var d2 = max2 - min;
                if (d2 !== 0) {
                    s = l === 0 || l === 1 ? 0 : (max2 - l) / Math.min(l, 1 - l);
                    switch(max2){
                        case r:
                            h = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
                            break;
                        case g2:
                            h = (b2 - r) / d2 + 2;
                            break;
                        case b2:
                            h = (r - g2) / d2 + 4;
                    }
                    h = h * 60;
                }
                return [
                    h,
                    s * 100,
                    l * 100
                ];
            },
            toBase: function toBase(hsl) {
                var _hsl = _slicedToArray(hsl, 3), h = _hsl[0], s = _hsl[1], l = _hsl[2];
                h = h % 360;
                if (h < 0) h += 360;
                s /= 100;
                l /= 100;
                function f(n2) {
                    var k = (n2 + h / 30) % 12;
                    var a2 = s * Math.min(l, 1 - l);
                    return l - a2 * Math.max(-1, Math.min(k - 3, 9 - k, 1));
                }
                return [
                    f(0),
                    f(8),
                    f(4)
                ];
            },
            formats: {
                hsl: {
                    toGamut: true,
                    coords: [
                        "<number> | <angle>",
                        "<percentage>",
                        "<percentage>"
                    ]
                },
                hsla: {
                    coords: [
                        "<number> | <angle>",
                        "<percentage>",
                        "<percentage>"
                    ],
                    commas: true,
                    lastAlpha: true
                }
            }
        });
        var HSV = new ColorSpace({
            id: "hsv",
            name: "HSV",
            coords: {
                h: {
                    refRange: [
                        0,
                        360
                    ],
                    type: "angle",
                    name: "Hue"
                },
                s: {
                    range: [
                        0,
                        100
                    ],
                    name: "Saturation"
                },
                v: {
                    range: [
                        0,
                        100
                    ],
                    name: "Value"
                }
            },
            base: HSL,
            fromBase: function fromBase(hsl) {
                var _hsl2 = _slicedToArray(hsl, 3), h = _hsl2[0], s = _hsl2[1], l = _hsl2[2];
                s /= 100;
                l /= 100;
                var v = l + s * Math.min(l, 1 - l);
                return [
                    h,
                    v === 0 ? 0 : 200 * (1 - l / v),
                    100 * v
                ];
            },
            toBase: function toBase(hsv) {
                var _hsv = _slicedToArray(hsv, 3), h = _hsv[0], s = _hsv[1], v = _hsv[2];
                s /= 100;
                v /= 100;
                var l = v * (1 - s / 2);
                return [
                    h,
                    l === 0 || l === 1 ? 0 : (v - l) / Math.min(l, 1 - l) * 100,
                    l * 100
                ];
            },
            formats: {
                color: {
                    toGamut: true
                }
            }
        });
        var hwb = new ColorSpace({
            id: "hwb",
            name: "HWB",
            coords: {
                h: {
                    refRange: [
                        0,
                        360
                    ],
                    type: "angle",
                    name: "Hue"
                },
                w: {
                    range: [
                        0,
                        100
                    ],
                    name: "Whiteness"
                },
                b: {
                    range: [
                        0,
                        100
                    ],
                    name: "Blackness"
                }
            },
            base: HSV,
            fromBase: function fromBase(hsv) {
                var _hsv2 = _slicedToArray(hsv, 3), h = _hsv2[0], s = _hsv2[1], v = _hsv2[2];
                return [
                    h,
                    v * (100 - s) / 100,
                    100 - v
                ];
            },
            toBase: function toBase(hwb2) {
                var _hwb = _slicedToArray(hwb2, 3), h = _hwb[0], w = _hwb[1], b2 = _hwb[2];
                w /= 100;
                b2 /= 100;
                var sum = w + b2;
                if (sum >= 1) {
                    var gray = w / sum;
                    return [
                        h,
                        0,
                        gray * 100
                    ];
                }
                var v = 1 - b2;
                var s = v === 0 ? 0 : 1 - w / v;
                return [
                    h,
                    s * 100,
                    v * 100
                ];
            },
            formats: {
                hwb: {
                    toGamut: true,
                    coords: [
                        "<number> | <angle>",
                        "<percentage>",
                        "<percentage>"
                    ]
                }
            }
        });
        var toXYZ_M$2 = [
            [
                .5766690429101305,
                .1855582379065463,
                .1882286462349947
            ],
            [
                .29734497525053605,
                .6273635662554661,
                .07529145849399788
            ],
            [
                .02703136138641234,
                .07068885253582723,
                .9913375368376388
            ]
        ];
        var fromXYZ_M$2 = [
            [
                2.0415879038107465,
                -0.5650069742788596,
                -0.34473135077832956
            ],
            [
                -0.9692436362808795,
                1.8759675015077202,
                .04155505740717557
            ],
            [
                .013444280632031142,
                -0.11836239223101838,
                1.0151749943912054
            ]
        ];
        var A98Linear = new RGBColorSpace({
            id: "a98rgb-linear",
            name: "Linear Adobe\xae 98 RGB compatible",
            white: "D65",
            toXYZ_M: toXYZ_M$2,
            fromXYZ_M: fromXYZ_M$2
        });
        var a98rgb = new RGBColorSpace({
            id: "a98rgb",
            name: "Adobe\xae 98 RGB compatible",
            base: A98Linear,
            toBase: function toBase(RGB) {
                return RGB.map(function(val) {
                    return Math.pow(Math.abs(val), 563 / 256) * Math.sign(val);
                });
            },
            fromBase: function fromBase(RGB) {
                return RGB.map(function(val) {
                    return Math.pow(Math.abs(val), 256 / 563) * Math.sign(val);
                });
            },
            formats: {
                color: {
                    id: "a98-rgb"
                }
            }
        });
        var toXYZ_M$1 = [
            [
                .7977604896723027,
                .13518583717574031,
                .0313493495815248
            ],
            [
                .2880711282292934,
                .7118432178101014,
                8565396060525902e-20
            ],
            [
                0,
                0,
                .8251046025104601
            ]
        ];
        var fromXYZ_M$1 = [
            [
                1.3457989731028281,
                -0.25558010007997534,
                -0.05110628506753401
            ],
            [
                -0.5446224939028347,
                1.5082327413132781,
                .02053603239147973
            ],
            [
                0,
                0,
                1.2119675456389454
            ]
        ];
        var ProPhotoLinear = new RGBColorSpace({
            id: "prophoto-linear",
            name: "Linear ProPhoto",
            white: "D50",
            base: XYZ_D50,
            toXYZ_M: toXYZ_M$1,
            fromXYZ_M: fromXYZ_M$1
        });
        var Et = 1 / 512;
        var Et2 = 16 / 512;
        var prophoto = new RGBColorSpace({
            id: "prophoto",
            name: "ProPhoto",
            base: ProPhotoLinear,
            toBase: function toBase(RGB) {
                return RGB.map(function(v) {
                    return v < Et2 ? v / 16 : Math.pow(v, 1.8);
                });
            },
            fromBase: function fromBase(RGB) {
                return RGB.map(function(v) {
                    return v >= Et ? Math.pow(v, 1 / 1.8) : 16 * v;
                });
            },
            formats: {
                color: {
                    id: "prophoto-rgb"
                }
            }
        });
        var oklch = new ColorSpace({
            id: "oklch",
            name: "OKLCh",
            coords: {
                l: {
                    refRange: [
                        0,
                        1
                    ],
                    name: "Lightness"
                },
                c: {
                    refRange: [
                        0,
                        .4
                    ],
                    name: "Chroma"
                },
                h: {
                    refRange: [
                        0,
                        360
                    ],
                    type: "angle",
                    name: "Hue"
                }
            },
            white: "D65",
            base: OKLab,
            fromBase: function fromBase(oklab) {
                var _oklab = _slicedToArray(oklab, 3), L = _oklab[0], a2 = _oklab[1], b2 = _oklab[2];
                var h;
                var ε2 = 2e-4;
                if (Math.abs(a2) < ε2 && Math.abs(b2) < ε2) h = NaN;
                else h = Math.atan2(b2, a2) * 180 / Math.PI;
                return [
                    L,
                    Math.sqrt(Math.pow(a2, 2) + Math.pow(b2, 2)),
                    constrain(h)
                ];
            },
            toBase: function toBase(oklch2) {
                var _oklch = _slicedToArray(oklch2, 3), L = _oklch[0], C = _oklch[1], h = _oklch[2];
                var a2, b2;
                if (isNaN(h)) {
                    a2 = 0;
                    b2 = 0;
                } else {
                    a2 = C * Math.cos(h * Math.PI / 180);
                    b2 = C * Math.sin(h * Math.PI / 180);
                }
                return [
                    L,
                    a2,
                    b2
                ];
            },
            formats: {
                oklch: {
                    coords: [
                        "<number> | <percentage>",
                        "<number>",
                        "<number> | <angle>"
                    ]
                }
            }
        });
        var Yw = 203;
        var n = 2610 / Math.pow(2, 14);
        var ninv = Math.pow(2, 14) / 2610;
        var m = 2523 / Math.pow(2, 5);
        var minv = Math.pow(2, 5) / 2523;
        var c1 = 3424 / Math.pow(2, 12);
        var c2 = 2413 / Math.pow(2, 7);
        var c3 = 2392 / Math.pow(2, 7);
        var rec2100Pq = new RGBColorSpace({
            id: "rec2100pq",
            name: "REC.2100-PQ",
            base: REC2020Linear,
            toBase: function toBase(RGB) {
                return RGB.map(function(val) {
                    var x = Math.pow(Math.max(Math.pow(val, minv) - c1, 0) / (c2 - c3 * Math.pow(val, minv)), ninv);
                    return x * 1e4 / Yw;
                });
            },
            fromBase: function fromBase(RGB) {
                return RGB.map(function(val) {
                    var x = Math.max(val * Yw / 1e4, 0);
                    var num = c1 + c2 * Math.pow(x, n);
                    var denom = 1 + c3 * Math.pow(x, n);
                    return Math.pow(num / denom, m);
                });
            },
            formats: {
                color: {
                    id: "rec2100-pq"
                }
            }
        });
        var a = .17883277;
        var b = .28466892;
        var c = .55991073;
        var scale = 3.7743;
        var rec2100Hlg = new RGBColorSpace({
            id: "rec2100hlg",
            cssid: "rec2100-hlg",
            name: "REC.2100-HLG",
            referred: "scene",
            base: REC2020Linear,
            toBase: function toBase(RGB) {
                return RGB.map(function(val) {
                    if (val <= .5) return Math.pow(val, 2) / 3 * scale;
                    return Math.exp((val - c) / a + b) / 12 * scale;
                });
            },
            fromBase: function fromBase(RGB) {
                return RGB.map(function(val) {
                    val /= scale;
                    if (val <= 1 / 12) return Math.sqrt(3 * val);
                    return a * Math.log(12 * val - b) + c;
                });
            },
            formats: {
                color: {
                    id: "rec2100-hlg"
                }
            }
        });
        var CATs = {};
        hooks.add("chromatic-adaptation-start", function(env) {
            if (env.options.method) env.M = adapt(env.W1, env.W2, env.options.method);
        });
        hooks.add("chromatic-adaptation-end", function(env) {
            if (!env.M) env.M = adapt(env.W1, env.W2, env.options.method);
        });
        function defineCAT(_ref62) {
            var id = _ref62.id, toCone_M = _ref62.toCone_M, fromCone_M = _ref62.fromCone_M;
            CATs[id] = arguments[0];
        }
        function adapt(W1, W2) {
            var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Bradford";
            var method = CATs[id];
            var _multiplyMatrices5 = multiplyMatrices(method.toCone_M, W1), _multiplyMatrices6 = _slicedToArray(_multiplyMatrices5, 3), ρs = _multiplyMatrices6[0], γs = _multiplyMatrices6[1], βs = _multiplyMatrices6[2];
            var _multiplyMatrices7 = multiplyMatrices(method.toCone_M, W2), _multiplyMatrices8 = _slicedToArray(_multiplyMatrices7, 3), ρd = _multiplyMatrices8[0], γd = _multiplyMatrices8[1], βd = _multiplyMatrices8[2];
            var scale2 = [
                [
                    ρd / ρs,
                    0,
                    0
                ],
                [
                    0,
                    γd / γs,
                    0
                ],
                [
                    0,
                    0,
                    βd / βs
                ]
            ];
            var scaled_cone_M = multiplyMatrices(scale2, method.toCone_M);
            var adapt_M = multiplyMatrices(method.fromCone_M, scaled_cone_M);
            return adapt_M;
        }
        defineCAT({
            id: "von Kries",
            toCone_M: [
                [
                    .40024,
                    .7076,
                    -0.08081
                ],
                [
                    -0.2263,
                    1.16532,
                    .0457
                ],
                [
                    0,
                    0,
                    .91822
                ]
            ],
            fromCone_M: [
                [
                    1.8599364,
                    -1.1293816,
                    .2198974
                ],
                [
                    .3611914,
                    .6388125,
                    -0.0000064
                ],
                [
                    0,
                    0,
                    1.0890636
                ]
            ]
        });
        defineCAT({
            id: "Bradford",
            toCone_M: [
                [
                    .8951,
                    .2664,
                    -0.1614
                ],
                [
                    -0.7502,
                    1.7135,
                    .0367
                ],
                [
                    .0389,
                    -0.0685,
                    1.0296
                ]
            ],
            fromCone_M: [
                [
                    .9869929,
                    -0.1470543,
                    .1599627
                ],
                [
                    .4323053,
                    .5183603,
                    .0492912
                ],
                [
                    -0.0085287,
                    .0400428,
                    .9684867
                ]
            ]
        });
        defineCAT({
            id: "CAT02",
            toCone_M: [
                [
                    .7328,
                    .4296,
                    -0.1624
                ],
                [
                    -0.7036,
                    1.6975,
                    .0061
                ],
                [
                    .003,
                    .0136,
                    .9834
                ]
            ],
            fromCone_M: [
                [
                    1.0961238,
                    -0.278869,
                    .1827452
                ],
                [
                    .454369,
                    .4735332,
                    .0720978
                ],
                [
                    -0.0096276,
                    -0.005698,
                    1.0153256
                ]
            ]
        });
        defineCAT({
            id: "CAT16",
            toCone_M: [
                [
                    .401288,
                    .650173,
                    -0.051461
                ],
                [
                    -0.250268,
                    1.204414,
                    .045854
                ],
                [
                    -0.002079,
                    .048952,
                    .953127
                ]
            ],
            fromCone_M: [
                [
                    1.862067855087233,
                    -1.011254630531685,
                    .1491867754444518
                ],
                [
                    .3875265432361372,
                    .6214474419314753,
                    -0.008973985167612518
                ],
                [
                    -0.01584149884933386,
                    -0.03412293802851557,
                    1.04996443687785
                ]
            ]
        });
        Object.assign(WHITES, {
            A: [
                1.0985,
                1,
                .35585
            ],
            C: [
                .98074,
                1,
                1.18232
            ],
            D55: [
                .95682,
                1,
                .92149
            ],
            D75: [
                .94972,
                1,
                1.22638
            ],
            E: [
                1,
                1,
                1
            ],
            F2: [
                .99186,
                1,
                .67393
            ],
            F7: [
                .95041,
                1,
                1.08747
            ],
            F11: [
                1.00962,
                1,
                .6435
            ]
        });
        WHITES.ACES = [
            .32168 / .33767,
            1,
            1.0088251843515859
        ];
        var toXYZ_M = [
            [
                .6624541811085053,
                .13400420645643313,
                .1561876870049078
            ],
            [
                .27222871678091454,
                .6740817658111484,
                .05368951740793705
            ],
            [
                -0.005574649490394108,
                .004060733528982826,
                1.0103391003129971
            ]
        ];
        var fromXYZ_M = [
            [
                1.6410233796943257,
                -0.32480329418479,
                -0.23642469523761225
            ],
            [
                -0.6636628587229829,
                1.6153315916573379,
                .016756347685530137
            ],
            [
                .011721894328375376,
                -0.008284441996237409,
                .9883948585390215
            ]
        ];
        var ACEScg = new RGBColorSpace({
            id: "acescg",
            name: "ACEScg",
            coords: {
                r: {
                    range: [
                        0,
                        65504
                    ],
                    name: "Red"
                },
                g: {
                    range: [
                        0,
                        65504
                    ],
                    name: "Green"
                },
                b: {
                    range: [
                        0,
                        65504
                    ],
                    name: "Blue"
                }
            },
            referred: "scene",
            white: WHITES.ACES,
            toXYZ_M: toXYZ_M,
            fromXYZ_M: fromXYZ_M,
            formats: {
                color: {}
            }
        });
        var ε = Math.pow(2, -16);
        var ACES_min_nonzero = -0.35828683;
        var ACES_cc_max = (Math.log2(65504) + 9.72) / 17.52;
        var acescc = new RGBColorSpace({
            id: "acescc",
            name: "ACEScc",
            coords: {
                r: {
                    range: [
                        ACES_min_nonzero,
                        ACES_cc_max
                    ],
                    name: "Red"
                },
                g: {
                    range: [
                        ACES_min_nonzero,
                        ACES_cc_max
                    ],
                    name: "Green"
                },
                b: {
                    range: [
                        ACES_min_nonzero,
                        ACES_cc_max
                    ],
                    name: "Blue"
                }
            },
            referred: "scene",
            base: ACEScg,
            toBase: function toBase(RGB) {
                var low = (9.72 - 15) / 17.52;
                return RGB.map(function(val) {
                    if (val <= low) return (Math.pow(2, val * 17.52 - 9.72) - ε) * 2;
                    else if (val < ACES_cc_max) return Math.pow(2, val * 17.52 - 9.72);
                    else return 65504;
                });
            },
            fromBase: function fromBase(RGB) {
                return RGB.map(function(val) {
                    if (val <= 0) return (Math.log2(ε) + 9.72) / 17.52;
                    else if (val < ε) return (Math.log2(ε + val * .5) + 9.72) / 17.52;
                    else return (Math.log2(val) + 9.72) / 17.52;
                });
            },
            formats: {
                color: {}
            }
        });
        var spaces = Object.freeze({
            __proto__: null,
            XYZ_D65: XYZ_D65,
            XYZ_D50: XYZ_D50,
            XYZ_ABS_D65: XYZ_Abs_D65,
            Lab_D65: lab_d65,
            Lab: lab,
            LCH: lch,
            sRGB_Linear: sRGBLinear,
            sRGB: sRGB,
            HSL: HSL,
            HWB: hwb,
            HSV: HSV,
            P3_Linear: P3Linear,
            P3: P3,
            A98RGB_Linear: A98Linear,
            A98RGB: a98rgb,
            ProPhoto_Linear: ProPhotoLinear,
            ProPhoto: prophoto,
            REC_2020_Linear: REC2020Linear,
            REC_2020: REC2020,
            OKLab: OKLab,
            OKLCH: oklch,
            Jzazbz: Jzazbz,
            JzCzHz: jzczhz,
            ICTCP: ictcp,
            REC_2100_PQ: rec2100Pq,
            REC_2100_HLG: rec2100Hlg,
            ACEScg: ACEScg,
            ACEScc: acescc
        });
        var Color = (_space = new WeakMap(), function() {
            function Color() {
                var _this2 = this;
                _classCallCheck(this, Color);
                _classPrivateFieldInitSpec(this, _space, {
                    writable: true,
                    value: void 0
                });
                var color;
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                if (args.length === 1) color = getColor(args[0]);
                var space, coords, alpha;
                if (color) {
                    space = color.space || color.spaceId;
                    coords = color.coords;
                    alpha = color.alpha;
                } else {
                    space = args[0];
                    coords = args[1];
                    alpha = args[2];
                }
                _classPrivateFieldSet(this, _space, ColorSpace.get(space));
                this.coords = coords ? coords.slice() : [
                    0,
                    0,
                    0
                ];
                this.alpha = alpha < 1 ? alpha : 1;
                for(var _i17 = 0; _i17 < this.coords.length; _i17++)if (this.coords[_i17] === "NaN") this.coords[_i17] = NaN;
                var _loop6 = function _loop6(id) {
                    Object.defineProperty(_this2, id, {
                        get: function get() {
                            return _this2.get(id);
                        },
                        set: function set(value) {
                            return _this2.set(id, value);
                        }
                    });
                };
                for(var id in _classPrivateFieldGet(this, _space).coords)_loop6(id);
            }
            _createClass(Color, [
                {
                    key: "space",
                    get: function get() {
                        return _classPrivateFieldGet(this, _space);
                    }
                },
                {
                    key: "spaceId",
                    get: function get() {
                        return _classPrivateFieldGet(this, _space).id;
                    }
                },
                {
                    key: "clone",
                    value: function clone() {
                        return new Color(this.space, this.coords, this.alpha);
                    }
                },
                {
                    key: "toJSON",
                    value: function toJSON() {
                        return {
                            spaceId: this.spaceId,
                            coords: this.coords,
                            alpha: this.alpha
                        };
                    }
                },
                {
                    key: "display",
                    value: function display() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = _display.apply(void 0, [
                            this
                        ].concat(args));
                        ret.color = new Color(ret.color);
                        return ret;
                    }
                }
            ], [
                {
                    key: "get",
                    value: function get(color) {
                        if (color instanceof Color) return color;
                        for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
                        return _construct(Color, [
                            color
                        ].concat(args));
                    }
                },
                {
                    key: "defineFunction",
                    value: function defineFunction(name, code) {
                        var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : code;
                        var _o$instance = o.instance, instance = _o$instance === void 0 ? true : _o$instance, returns = o.returns;
                        var func = function func() {
                            var ret = code.apply(void 0, arguments);
                            if (returns === "color") ret = Color.get(ret);
                            else if (returns === "function<color>") {
                                var f = ret;
                                ret = function ret() {
                                    var ret2 = f.apply(void 0, arguments);
                                    return Color.get(ret2);
                                };
                                Object.assign(ret, f);
                            } else if (returns === "array<color>") ret = ret.map(function(c4) {
                                return Color.get(c4);
                            });
                            return ret;
                        };
                        if (!(name in Color)) Color[name] = func;
                        if (instance) Color.prototype[name] = function() {
                            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
                            return func.apply(void 0, [
                                this
                            ].concat(args));
                        };
                    }
                },
                {
                    key: "defineFunctions",
                    value: function defineFunctions(o) {
                        for(var name in o)Color.defineFunction(name, o[name], o[name]);
                    }
                },
                {
                    key: "extend",
                    value: function extend(exports) {
                        if (exports.register) exports.register(Color);
                        else for(var name in exports)Color.defineFunction(name, exports[name]);
                    }
                }
            ]);
            return Color;
        }());
        Color.defineFunctions({
            get: get,
            getAll: getAll,
            set: set,
            setAll: setAll,
            to: to,
            equals: equals,
            inGamut: inGamut,
            toGamut: toGamut,
            distance: distance,
            toString: serialize
        });
        Object.assign(Color, {
            util: util,
            hooks: hooks,
            WHITES: WHITES,
            Space: ColorSpace,
            spaces: ColorSpace.registry,
            parse: parse2,
            defaults: defaults
        });
        for(var _i18 = 0, _Object$keys2 = Object.keys(spaces); _i18 < _Object$keys2.length; _i18++){
            var key = _Object$keys2[_i18];
            ColorSpace.register(spaces[key]);
        }
        for(var id in ColorSpace.registry)addSpaceAccessors(id, ColorSpace.registry[id]);
        hooks.add("colorspace-init-end", function(space) {
            var _space$aliases;
            addSpaceAccessors(space.id, space);
            (_space$aliases = space.aliases) === null || _space$aliases === void 0 || _space$aliases.forEach(function(alias) {
                addSpaceAccessors(alias, space);
            });
        });
        function addSpaceAccessors(id, space) {
            Object.keys(space.coords);
            Object.values(space.coords).map(function(c4) {
                return c4.name;
            });
            var propId = id.replace(/-/g, "_");
            Object.defineProperty(Color.prototype, propId, {
                get: function get() {
                    var _this3 = this;
                    var ret = this.getAll(id);
                    if (typeof Proxy === "undefined") return ret;
                    return new Proxy(ret, {
                        has: function has(obj, property) {
                            try {
                                ColorSpace.resolveCoord([
                                    space,
                                    property
                                ]);
                                return true;
                            } catch (e) {}
                            return Reflect.has(obj, property);
                        },
                        get: function get(obj, property, receiver) {
                            if (property && _typeof(property) !== "symbol" && !(property in obj)) {
                                var _ColorSpace$resolveCo3 = ColorSpace.resolveCoord([
                                    space,
                                    property
                                ]), index = _ColorSpace$resolveCo3.index;
                                if (index >= 0) return obj[index];
                            }
                            return Reflect.get(obj, property, receiver);
                        },
                        set: function set(obj, property, value, receiver) {
                            if (property && _typeof(property) !== "symbol" && !(property in obj) || property >= 0) {
                                var _ColorSpace$resolveCo4 = ColorSpace.resolveCoord([
                                    space,
                                    property
                                ]), index = _ColorSpace$resolveCo4.index;
                                if (index >= 0) {
                                    obj[index] = value;
                                    _this3.setAll(id, obj);
                                    return true;
                                }
                            }
                            return Reflect.set(obj, property, value, receiver);
                        }
                    });
                },
                set: function set(coords) {
                    this.setAll(id, coords);
                },
                configurable: true,
                enumerable: true
            });
        }
        Color.extend(deltaEMethods);
        Color.extend({
            deltaE: deltaE
        });
        Color.extend(variations);
        Color.extend({
            contrast: contrast
        });
        Color.extend(chromaticity);
        Color.extend(luminance);
        Color.extend(interpolation);
        Color.extend(contrastMethods);
        var import_es6_promise = __toModule(require_es6_promise());
        var import_typedarray = __toModule(require_typedarray());
        var import_weakmap_polyfill = __toModule(require_weakmap_polyfill());
        var import_has_own = __toModule(require_has_own3());
        if (!("hasOwn" in Object)) Object.hasOwn = import_has_own["default"];
        import_dot["default"].templateSettings.strip = false;
        if (!("Promise" in window1)) import_es6_promise["default"].polyfill();
        if (!("Uint32Array" in window1)) window1.Uint32Array = import_typedarray.Uint32Array;
        if (window1.Uint32Array) {
            if (!("some" in window1.Uint32Array.prototype)) Object.defineProperty(window1.Uint32Array.prototype, "some", {
                value: Array.prototype.some
            });
            if (!("reduce" in window1.Uint32Array.prototype)) Object.defineProperty(window1.Uint32Array.prototype, "reduce", {
                value: Array.prototype.reduce
            });
        }
        var hexRegex = /^#[0-9a-f]{3,8}$/i;
        var hslRegex = /hsl\(\s*([\d.]+)(rad|turn)/;
        var Color2 = function() {
            function Color2(red, green, blue) {
                var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                _classCallCheck(this, Color2);
                this.red = red;
                this.green = green;
                this.blue = blue;
                this.alpha = alpha;
            }
            _createClass(Color2, [
                {
                    key: "toHexString",
                    value: function toHexString() {
                        var redString = Math.round(this.red).toString(16);
                        var greenString = Math.round(this.green).toString(16);
                        var blueString = Math.round(this.blue).toString(16);
                        return "#" + (this.red > 15.5 ? redString : "0" + redString) + (this.green > 15.5 ? greenString : "0" + greenString) + (this.blue > 15.5 ? blueString : "0" + blueString);
                    }
                },
                {
                    key: "toJSON",
                    value: function toJSON() {
                        var red = this.red, green = this.green, blue = this.blue, alpha = this.alpha;
                        return {
                            red: red,
                            green: green,
                            blue: blue,
                            alpha: alpha
                        };
                    }
                },
                {
                    key: "parseString",
                    value: function parseString(colorString) {
                        colorString = colorString.replace(hslRegex, function(match, angle, unit) {
                            var value = angle + unit;
                            switch(unit){
                                case "rad":
                                    return match.replace(value, radToDeg(angle));
                                case "turn":
                                    return match.replace(value, turnToDeg(angle));
                            }
                        });
                        try {
                            var _color2 = new Color(colorString).to("srgb");
                            this.red = Math.round(clamp(_color2.r, 0, 1) * 255);
                            this.green = Math.round(clamp(_color2.g, 0, 1) * 255);
                            this.blue = Math.round(clamp(_color2.b, 0, 1) * 255);
                            this.alpha = +_color2.alpha;
                        } catch (err2) {
                            throw new Error('Unable to parse color "'.concat(colorString, '"'));
                        }
                        return this;
                    }
                },
                {
                    key: "parseRgbString",
                    value: function parseRgbString(colorString) {
                        this.parseString(colorString);
                    }
                },
                {
                    key: "parseHexString",
                    value: function parseHexString(colorString) {
                        if (!colorString.match(hexRegex) || [
                            6,
                            8
                        ].includes(colorString.length)) return;
                        this.parseString(colorString);
                    }
                },
                {
                    key: "parseColorFnString",
                    value: function parseColorFnString(colorString) {
                        this.parseString(colorString);
                    }
                },
                {
                    key: "getRelativeLuminance",
                    value: function getRelativeLuminance() {
                        var rSRGB = this.red / 255;
                        var gSRGB = this.green / 255;
                        var bSRGB = this.blue / 255;
                        var r = rSRGB <= .03928 ? rSRGB / 12.92 : Math.pow((rSRGB + .055) / 1.055, 2.4);
                        var g2 = gSRGB <= .03928 ? gSRGB / 12.92 : Math.pow((gSRGB + .055) / 1.055, 2.4);
                        var b2 = bSRGB <= .03928 ? bSRGB / 12.92 : Math.pow((bSRGB + .055) / 1.055, 2.4);
                        return .2126 * r + .7152 * g2 + .0722 * b2;
                    }
                }
            ]);
            return Color2;
        }();
        var color_default = Color2;
        function clamp(value, min, max2) {
            return Math.min(Math.max(min, value), max2);
        }
        function radToDeg(rad) {
            return rad * 180 / Math.PI;
        }
        function turnToDeg(turn) {
            return turn * 360;
        }
        function getOwnBackgroundColor(elmStyle) {
            var bgColor = new color_default();
            bgColor.parseString(elmStyle.getPropertyValue("background-color"));
            if (bgColor.alpha !== 0) {
                var opacity = elmStyle.getPropertyValue("opacity");
                bgColor.alpha = bgColor.alpha * opacity;
            }
            return bgColor;
        }
        var get_own_background_color_default = getOwnBackgroundColor;
        function isOpaque(node) {
            var style = window1.getComputedStyle(node);
            return element_has_image_default(node, style) || get_own_background_color_default(style).alpha === 1;
        }
        var is_opaque_default = isOpaque;
        function _isSkipLink(element) {
            if (!element.href) return false;
            var firstPageLink = cache_default.get("firstPageLink", generateFirstPageLink);
            if (!firstPageLink) return true;
            return element.compareDocumentPosition(firstPageLink.actualNode) === element.DOCUMENT_POSITION_FOLLOWING;
        }
        function generateFirstPageLink() {
            var firstPageLink;
            if (!window1.location.origin) firstPageLink = query_selector_all_default(axe._tree, 'a:not([href^="#"]):not([href^="/#"]):not([href^="javascript:"])')[0];
            else firstPageLink = query_selector_all_default(axe._tree, 'a[href]:not([href^="javascript:"])').find(function(link) {
                return !_isCurrentPageLink(link.actualNode);
            });
            return firstPageLink || null;
        }
        var clipRegex2 = /rect\s*\(([0-9]+)px,?\s*([0-9]+)px,?\s*([0-9]+)px,?\s*([0-9]+)px\s*\)/;
        var clipPathRegex2 = /(\w+)\((\d+)/;
        function isClipped(style) {
            var matchesClip = style.getPropertyValue("clip").match(clipRegex2);
            var matchesClipPath = style.getPropertyValue("clip-path").match(clipPathRegex2);
            if (matchesClip && matchesClip.length === 5) {
                var position = style.getPropertyValue("position");
                if ([
                    "fixed",
                    "absolute"
                ].includes(position)) return matchesClip[3] - matchesClip[1] <= 0 && matchesClip[2] - matchesClip[4] <= 0;
            }
            if (matchesClipPath) {
                var type2 = matchesClipPath[1];
                var value = parseInt(matchesClipPath[2], 10);
                switch(type2){
                    case "inset":
                        return value >= 50;
                    case "circle":
                        return value === 0;
                    default:
                }
            }
            return false;
        }
        function isAreaVisible(el, screenReader, recursed) {
            var mapEl = find_up_default(el, "map");
            if (!mapEl) return false;
            var mapElName = mapEl.getAttribute("name");
            if (!mapElName) return false;
            var mapElRootNode = get_root_node_default2(el);
            if (!mapElRootNode || mapElRootNode.nodeType !== 9) return false;
            var refs = query_selector_all_default(axe._tree, 'img[usemap="#'.concat(escape_selector_default(mapElName), '"]'));
            if (!refs || !refs.length) return false;
            return refs.some(function(_ref63) {
                var actualNode = _ref63.actualNode;
                return isVisible(actualNode, screenReader, recursed);
            });
        }
        function isVisible(el, screenReader, recursed) {
            var _window$Node2;
            if (!el) throw new TypeError("Cannot determine if element is visible for non-DOM nodes");
            var vNode = el instanceof abstract_virtual_node_default ? el : get_node_from_tree_default(el);
            el = vNode ? vNode.actualNode : el;
            var cacheName = "_isVisible" + (screenReader ? "ScreenReader" : "");
            var _ref64 = (_window$Node2 = window1.Node) !== null && _window$Node2 !== void 0 ? _window$Node2 : {}, DOCUMENT_NODE = _ref64.DOCUMENT_NODE, DOCUMENT_FRAGMENT_NODE = _ref64.DOCUMENT_FRAGMENT_NODE;
            var nodeType = vNode ? vNode.props.nodeType : el.nodeType;
            var nodeName2 = vNode ? vNode.props.nodeName : el.nodeName.toLowerCase();
            if (vNode && typeof vNode[cacheName] !== "undefined") return vNode[cacheName];
            if (nodeType === DOCUMENT_NODE) return true;
            if ([
                "style",
                "script",
                "noscript",
                "template"
            ].includes(nodeName2)) return false;
            if (el && nodeType === DOCUMENT_FRAGMENT_NODE) el = el.host;
            if (screenReader) {
                var ariaHiddenValue = vNode ? vNode.attr("aria-hidden") : el.getAttribute("aria-hidden");
                if (ariaHiddenValue === "true") return false;
            }
            if (!el) {
                var parent2 = vNode.parent;
                var visible3 = true;
                if (parent2) visible3 = isVisible(parent2, screenReader, true);
                if (vNode) vNode[cacheName] = visible3;
                return visible3;
            }
            var style = window1.getComputedStyle(el, null);
            if (style === null) return false;
            if (nodeName2 === "area") return isAreaVisible(el, screenReader, recursed);
            if (style.getPropertyValue("display") === "none") return false;
            var elHeight = parseInt(style.getPropertyValue("height"));
            var elWidth = parseInt(style.getPropertyValue("width"));
            var scroll = get_scroll_default(el);
            var scrollableWithZeroHeight = scroll && elHeight === 0;
            var scrollableWithZeroWidth = scroll && elWidth === 0;
            var posAbsoluteOverflowHiddenAndSmall = style.getPropertyValue("position") === "absolute" && (elHeight < 2 || elWidth < 2) && style.getPropertyValue("overflow") === "hidden";
            if (!screenReader && (isClipped(style) || style.getPropertyValue("opacity") === "0" || scrollableWithZeroHeight || scrollableWithZeroWidth || posAbsoluteOverflowHiddenAndSmall)) return false;
            if (!recursed && (style.getPropertyValue("visibility") === "hidden" || !screenReader && is_offscreen_default(el))) return false;
            var parent = el.assignedSlot ? el.assignedSlot : el.parentNode;
            var visible2 = false;
            if (parent) visible2 = isVisible(parent, screenReader, true);
            if (vNode) vNode[cacheName] = visible2;
            return visible2;
        }
        var is_visible_default = isVisible;
        function reduceToElementsBelowFloating(elements, targetNode) {
            var floatingPositions = [
                "fixed",
                "sticky"
            ];
            var finalElements = [];
            var targetFound = false;
            for(var index = 0; index < elements.length; ++index){
                var currentNode = elements[index];
                if (currentNode === targetNode) targetFound = true;
                var style = window1.getComputedStyle(currentNode);
                if (!targetFound && floatingPositions.indexOf(style.position) !== -1) {
                    finalElements = [];
                    continue;
                }
                finalElements.push(currentNode);
            }
            return finalElements;
        }
        var reduce_to_elements_below_floating_default = reduceToElementsBelowFloating;
        function _visuallyContains(node, parent) {
            var parentScrollAncestor = getScrollAncestor(parent);
            do {
                var nextScrollAncestor = getScrollAncestor(node);
                if (nextScrollAncestor === parentScrollAncestor || nextScrollAncestor === parent) return contains2(node, parent);
                node = nextScrollAncestor;
            }while (node);
            return false;
        }
        function getScrollAncestor(node) {
            var vNode = get_node_from_tree_default(node);
            var ancestor = vNode.parent;
            while(ancestor){
                if (get_scroll_default(ancestor.actualNode)) return ancestor.actualNode;
                ancestor = ancestor.parent;
            }
        }
        function contains2(node, parent) {
            var style = window1.getComputedStyle(parent);
            var overflow = style.getPropertyValue("overflow");
            if (style.getPropertyValue("display") === "inline") return true;
            var clientRects = Array.from(node.getClientRects());
            var boundingRect = parent.getBoundingClientRect();
            var rect = {
                left: boundingRect.left,
                top: boundingRect.top,
                width: boundingRect.width,
                height: boundingRect.height
            };
            if ([
                "scroll",
                "auto"
            ].includes(overflow) || parent instanceof window1.HTMLHtmlElement) {
                rect.width = parent.scrollWidth;
                rect.height = parent.scrollHeight;
            }
            if (clientRects.length === 1 && overflow === "hidden" && style.getPropertyValue("white-space") === "nowrap") clientRects[0] = rect;
            return clientRects.some(function(clientRect) {
                return !(Math.ceil(clientRect.left) < Math.floor(rect.left) || Math.ceil(clientRect.top) < Math.floor(rect.top) || Math.floor(clientRect.left + clientRect.width) > Math.ceil(rect.left + rect.width) || Math.floor(clientRect.top + clientRect.height) > Math.ceil(rect.top + rect.height));
            });
        }
        function shadowElementsFromPoint(nodeX, nodeY) {
            var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            if (i > 999) throw new Error("Infinite loop detected");
            return Array.from(root.elementsFromPoint(nodeX, nodeY) || []).filter(function(nodes) {
                return get_root_node_default2(nodes) === root;
            }).reduce(function(stack, elm) {
                if (is_shadow_root_default(elm)) {
                    var shadowStack = shadowElementsFromPoint(nodeX, nodeY, elm.shadowRoot, i + 1);
                    stack = stack.concat(shadowStack);
                    if (stack.length && _visuallyContains(stack[0], elm)) stack.push(elm);
                } else stack.push(elm);
                return stack;
            }, []);
        }
        var shadow_elements_from_point_default = shadowElementsFromPoint;
        function urlPropsFromAttribute(node, attribute) {
            if (!node.hasAttribute(attribute)) return void 0;
            var nodeName2 = node.nodeName.toUpperCase();
            var parser2 = node;
            if (![
                "A",
                "AREA"
            ].includes(nodeName2) || node.ownerSVGElement) {
                parser2 = document.createElement("a");
                parser2.href = node.getAttribute(attribute);
            }
            var protocol = [
                "https:",
                "ftps:"
            ].includes(parser2.protocol) ? parser2.protocol.replace(/s:$/, ":") : parser2.protocol;
            var parserPathname = /^\//.test(parser2.pathname) ? parser2.pathname : "/".concat(parser2.pathname);
            var _getPathnameOrFilenam = getPathnameOrFilename(parserPathname), pathname = _getPathnameOrFilenam.pathname, filename = _getPathnameOrFilenam.filename;
            return {
                protocol: protocol,
                hostname: parser2.hostname,
                port: getPort(parser2.port),
                pathname: /\/$/.test(pathname) ? pathname : "".concat(pathname, "/"),
                search: getSearchPairs(parser2.search),
                hash: getHashRoute(parser2.hash),
                filename: filename
            };
        }
        function getPort(port) {
            var excludePorts = [
                "443",
                "80"
            ];
            return !excludePorts.includes(port) ? port : "";
        }
        function getPathnameOrFilename(pathname) {
            var filename = pathname.split("/").pop();
            if (!filename || filename.indexOf(".") === -1) return {
                pathname: pathname,
                filename: ""
            };
            return {
                pathname: pathname.replace(filename, ""),
                filename: /index./.test(filename) ? "" : filename
            };
        }
        function getSearchPairs(searchStr) {
            var query = {};
            if (!searchStr || !searchStr.length) return query;
            var pairs = searchStr.substring(1).split("&");
            if (!pairs || !pairs.length) return query;
            for(var index = 0; index < pairs.length; index++){
                var pair = pairs[index];
                var _pair$split = pair.split("="), _pair$split2 = _slicedToArray(_pair$split, 2), _key7 = _pair$split2[0], _pair$split2$ = _pair$split2[1], value = _pair$split2$ === void 0 ? "" : _pair$split2$;
                query[decodeURIComponent(_key7)] = decodeURIComponent(value);
            }
            return query;
        }
        function getHashRoute(hash) {
            if (!hash) return "";
            var hashRegex = /#!?\/?/g;
            var hasMatch = hash.match(hashRegex);
            if (!hasMatch) return "";
            var _hasMatch = _slicedToArray(hasMatch, 1), matchedStr = _hasMatch[0];
            if (matchedStr === "#") return "";
            return hash;
        }
        var url_props_from_attribute_default = urlPropsFromAttribute;
        function visuallyOverlaps(rect, parent) {
            var parentRect = parent.getBoundingClientRect();
            var parentTop = parentRect.top;
            var parentLeft = parentRect.left;
            var parentScrollArea = {
                top: parentTop - parent.scrollTop,
                bottom: parentTop - parent.scrollTop + parent.scrollHeight,
                left: parentLeft - parent.scrollLeft,
                right: parentLeft - parent.scrollLeft + parent.scrollWidth
            };
            if (rect.left > parentScrollArea.right && rect.left > parentRect.right || rect.top > parentScrollArea.bottom && rect.top > parentRect.bottom || rect.right < parentScrollArea.left && rect.right < parentRect.left || rect.bottom < parentScrollArea.top && rect.bottom < parentRect.top) return false;
            var style = window1.getComputedStyle(parent);
            if (rect.left > parentRect.right || rect.top > parentRect.bottom) return style.overflow === "scroll" || style.overflow === "auto" || parent instanceof window1.HTMLBodyElement || parent instanceof window1.HTMLHtmlElement;
            return true;
        }
        var visually_overlaps_default = visuallyOverlaps;
        var nodeIndex2 = 0;
        var VirtualNode = function(_abstract_virtual_nod) {
            _inherits(VirtualNode, _abstract_virtual_nod);
            var _super2 = _createSuper(VirtualNode);
            function VirtualNode(node, parent, shadowId) {
                var _this4;
                _classCallCheck(this, VirtualNode);
                _this4 = _super2.call(this);
                _this4.shadowId = shadowId;
                _this4.children = [];
                _this4.actualNode = node;
                _this4.parent = parent;
                if (!parent) nodeIndex2 = 0;
                _this4.nodeIndex = nodeIndex2++;
                _this4._isHidden = null;
                _this4._cache = {};
                _this4._isXHTML = is_xhtml_default(node.ownerDocument);
                if (node.nodeName.toLowerCase() === "input") {
                    var type2 = node.getAttribute("type");
                    type2 = _this4._isXHTML ? type2 : (type2 || "").toLowerCase();
                    if (!valid_input_type_default().includes(type2)) type2 = "text";
                    _this4._type = type2;
                }
                if (cache_default.get("nodeMap")) cache_default.get("nodeMap").set(node, _assertThisInitialized(_this4));
                return _this4;
            }
            _createClass(VirtualNode, [
                {
                    key: "props",
                    get: function get() {
                        if (!this._cache.hasOwnProperty("props")) {
                            var _this$actualNode = this.actualNode, nodeType = _this$actualNode.nodeType, nodeName2 = _this$actualNode.nodeName, _id = _this$actualNode.id, multiple = _this$actualNode.multiple, nodeValue = _this$actualNode.nodeValue, value = _this$actualNode.value, selected = _this$actualNode.selected, checked = _this$actualNode.checked, indeterminate = _this$actualNode.indeterminate;
                            this._cache.props = {
                                nodeType: nodeType,
                                nodeName: this._isXHTML ? nodeName2 : nodeName2.toLowerCase(),
                                id: _id,
                                type: this._type,
                                multiple: multiple,
                                nodeValue: nodeValue,
                                value: value,
                                selected: selected,
                                checked: checked,
                                indeterminate: indeterminate
                            };
                        }
                        return this._cache.props;
                    }
                },
                {
                    key: "attr",
                    value: function attr(attrName) {
                        if (typeof this.actualNode.getAttribute !== "function") return null;
                        return this.actualNode.getAttribute(attrName);
                    }
                },
                {
                    key: "hasAttr",
                    value: function hasAttr(attrName) {
                        if (typeof this.actualNode.hasAttribute !== "function") return false;
                        return this.actualNode.hasAttribute(attrName);
                    }
                },
                {
                    key: "attrNames",
                    get: function get() {
                        if (!this._cache.hasOwnProperty("attrNames")) {
                            var attrs;
                            if (this.actualNode.attributes instanceof window1.NamedNodeMap) attrs = this.actualNode.attributes;
                            else attrs = this.actualNode.cloneNode(false).attributes;
                            this._cache.attrNames = Array.from(attrs).map(function(attr) {
                                return attr.name;
                            });
                        }
                        return this._cache.attrNames;
                    }
                },
                {
                    key: "getComputedStylePropertyValue",
                    value: function getComputedStylePropertyValue(property) {
                        var key = "computedStyle_" + property;
                        if (!this._cache.hasOwnProperty(key)) {
                            if (!this._cache.hasOwnProperty("computedStyle")) this._cache.computedStyle = window1.getComputedStyle(this.actualNode);
                            this._cache[key] = this._cache.computedStyle.getPropertyValue(property);
                        }
                        return this._cache[key];
                    }
                },
                {
                    key: "isFocusable",
                    get: function get() {
                        if (!this._cache.hasOwnProperty("isFocusable")) this._cache.isFocusable = _isFocusable(this.actualNode);
                        return this._cache.isFocusable;
                    }
                },
                {
                    key: "tabbableElements",
                    get: function get() {
                        if (!this._cache.hasOwnProperty("tabbableElements")) this._cache.tabbableElements = get_tabbable_elements_default(this);
                        return this._cache.tabbableElements;
                    }
                },
                {
                    key: "clientRects",
                    get: function get() {
                        if (!this._cache.hasOwnProperty("clientRects")) this._cache.clientRects = Array.from(this.actualNode.getClientRects()).filter(function(rect) {
                            return rect.width > 0;
                        });
                        return this._cache.clientRects;
                    }
                },
                {
                    key: "boundingClientRect",
                    get: function get() {
                        if (!this._cache.hasOwnProperty("boundingClientRect")) this._cache.boundingClientRect = this.actualNode.getBoundingClientRect();
                        return this._cache.boundingClientRect;
                    }
                }
            ]);
            return VirtualNode;
        }(abstract_virtual_node_default);
        var virtual_node_default = VirtualNode;
        function tokenList(str) {
            return (str || "").trim().replace(/\s{2,}/g, " ").split(" ");
        }
        var token_list_default = tokenList;
        var idsKey = " [idsMap]";
        function getNodesMatchingExpression(domTree, expressions, filter) {
            var selectorMap = domTree[0]._selectorMap;
            if (!selectorMap) return;
            var shadowId = domTree[0].shadowId;
            for(var _i19 = 0; _i19 < expressions.length; _i19++){
                if (expressions[_i19].length > 1 && expressions[_i19].some(function(expression) {
                    return isGlobalSelector(expression);
                })) return;
            }
            var nodeSet = new Set();
            expressions.forEach(function(expression) {
                var _matchingNodes$nodes;
                var matchingNodes = findMatchingNodes(expression, selectorMap, shadowId);
                matchingNodes === null || matchingNodes === void 0 || (_matchingNodes$nodes = matchingNodes.nodes) === null || _matchingNodes$nodes === void 0 || _matchingNodes$nodes.forEach(function(node) {
                    if (matchingNodes.isComplexSelector && !_matchesExpression(node, expression)) return;
                    nodeSet.add(node);
                });
            });
            var matchedNodes = [];
            nodeSet.forEach(function(node) {
                return matchedNodes.push(node);
            });
            if (filter) matchedNodes = matchedNodes.filter(filter);
            return matchedNodes.sort(function(a2, b2) {
                return a2.nodeIndex - b2.nodeIndex;
            });
        }
        function findMatchingNodes(expression, selectorMap, shadowId) {
            var exp = expression[expression.length - 1];
            var nodes = null;
            var isComplexSelector = expression.length > 1 || !!exp.pseudos || !!exp.classes;
            if (isGlobalSelector(exp)) nodes = selectorMap["*"];
            else {
                if (exp.id) {
                    var _selectorMap$idsKey$e;
                    if (!selectorMap[idsKey] || !Object.hasOwn(selectorMap[idsKey], exp.id) || !((_selectorMap$idsKey$e = selectorMap[idsKey][exp.id]) !== null && _selectorMap$idsKey$e !== void 0 && _selectorMap$idsKey$e.length)) return;
                    nodes = selectorMap[idsKey][exp.id].filter(function(node) {
                        return node.shadowId === shadowId;
                    });
                }
                if (exp.tag && exp.tag !== "*") {
                    var _selectorMap$exp$tag;
                    if (!((_selectorMap$exp$tag = selectorMap[exp.tag]) !== null && _selectorMap$exp$tag !== void 0 && _selectorMap$exp$tag.length)) return;
                    var cachedNodes = selectorMap[exp.tag];
                    nodes = nodes ? getSharedValues(cachedNodes, nodes) : cachedNodes;
                }
                if (exp.classes) {
                    var _selectorMap$Class;
                    if (!((_selectorMap$Class = selectorMap["[class]"]) !== null && _selectorMap$Class !== void 0 && _selectorMap$Class.length)) return;
                    var _cachedNodes = selectorMap["[class]"];
                    nodes = nodes ? getSharedValues(_cachedNodes, nodes) : _cachedNodes;
                }
                if (exp.attributes) for(var _i20 = 0; _i20 < exp.attributes.length; _i20++){
                    var _selectorMap;
                    var attr = exp.attributes[_i20];
                    if (attr.type === "attrValue") isComplexSelector = true;
                    if (!((_selectorMap = selectorMap["[".concat(attr.key, "]")]) !== null && _selectorMap !== void 0 && _selectorMap.length)) return;
                    var _cachedNodes2 = selectorMap["[".concat(attr.key, "]")];
                    nodes = nodes ? getSharedValues(_cachedNodes2, nodes) : _cachedNodes2;
                }
            }
            return {
                nodes: nodes,
                isComplexSelector: isComplexSelector
            };
        }
        function isGlobalSelector(expression) {
            return expression.tag === "*" && !expression.attributes && !expression.id && !expression.classes;
        }
        function getSharedValues(a2, b2) {
            return a2.filter(function(node) {
                return b2.includes(node);
            });
        }
        function cacheSelector(key, vNode, map) {
            if (!Object.hasOwn(map, key)) map[key] = [];
            map[key].push(vNode);
        }
        function cacheNodeSelectors(vNode, selectorMap) {
            if (vNode.props.nodeType !== 1) return;
            cacheSelector(vNode.props.nodeName, vNode, selectorMap);
            cacheSelector("*", vNode, selectorMap);
            vNode.attrNames.forEach(function(attrName) {
                if (attrName === "id") {
                    selectorMap[idsKey] = selectorMap[idsKey] || {};
                    token_list_default(vNode.attr(attrName)).forEach(function(value) {
                        cacheSelector(value, vNode, selectorMap[idsKey]);
                    });
                }
                cacheSelector("[".concat(attrName, "]"), vNode, selectorMap);
            });
        }
        var hasShadowRoot;
        function _getFlattenedTree() {
            var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
            var shadowId = arguments.length > 1 ? arguments[1] : undefined;
            hasShadowRoot = false;
            var selectorMap = {};
            cache_default.set("nodeMap", new WeakMap());
            cache_default.set("selectorMap", selectorMap);
            var tree = flattenTree(node, shadowId, null);
            tree[0]._selectorMap = selectorMap;
            tree[0]._hasShadowRoot = hasShadowRoot;
            return tree;
        }
        function getSlotChildren(node) {
            var retVal = [];
            node = node.firstChild;
            while(node){
                retVal.push(node);
                node = node.nextSibling;
            }
            return retVal;
        }
        function createNode(node, parent, shadowId) {
            var vNode = new virtual_node_default(node, parent, shadowId);
            cacheNodeSelectors(vNode, cache_default.get("selectorMap"));
            return vNode;
        }
        function flattenTree(node, shadowId, parent) {
            var retVal, realArray, nodeName2;
            function reduceShadowDOM(res, child, parentVNode) {
                var replacements = flattenTree(child, shadowId, parentVNode);
                if (replacements) res = res.concat(replacements);
                return res;
            }
            if (node.documentElement) node = node.documentElement;
            nodeName2 = node.nodeName.toLowerCase();
            if (is_shadow_root_default(node)) {
                hasShadowRoot = true;
                retVal = createNode(node, parent, shadowId);
                shadowId = "a" + Math.random().toString().substring(2);
                realArray = Array.from(node.shadowRoot.childNodes);
                retVal.children = realArray.reduce(function(res, child) {
                    return reduceShadowDOM(res, child, retVal);
                }, []);
                return [
                    retVal
                ];
            } else {
                if (nodeName2 === "content" && typeof node.getDistributedNodes === "function") {
                    realArray = Array.from(node.getDistributedNodes());
                    return realArray.reduce(function(res, child) {
                        return reduceShadowDOM(res, child, parent);
                    }, []);
                } else if (nodeName2 === "slot" && typeof node.assignedNodes === "function") {
                    realArray = Array.from(node.assignedNodes());
                    if (!realArray.length) realArray = getSlotChildren(node);
                    var styl = window1.getComputedStyle(node);
                    return realArray.reduce(function(res, child) {
                        return reduceShadowDOM(res, child, parent);
                    }, []);
                } else {
                    if (node.nodeType === 1) {
                        retVal = createNode(node, parent, shadowId);
                        realArray = Array.from(node.childNodes);
                        retVal.children = realArray.reduce(function(res, child) {
                            return reduceShadowDOM(res, child, retVal);
                        }, []);
                        return [
                            retVal
                        ];
                    } else if (node.nodeType === 3) return [
                        createNode(node, parent)
                    ];
                    return void 0;
                }
            }
        }
        function getBaseLang(lang) {
            if (!lang) return "";
            return lang.trim().split("-")[0].toLowerCase();
        }
        var get_base_lang_default = getBaseLang;
        function failureSummary(nodeData) {
            var failingChecks = {};
            failingChecks.none = nodeData.none.concat(nodeData.all);
            failingChecks.any = nodeData.any;
            return Object.keys(failingChecks).map(function(key) {
                if (!failingChecks[key].length) return;
                var sum = axe._audit.data.failureSummaries[key];
                if (sum && typeof sum.failureMessage === "function") return sum.failureMessage(failingChecks[key].map(function(check) {
                    return check.message || "";
                }));
            }).filter(function(i) {
                return i !== void 0;
            }).join("\n\n");
        }
        var failure_summary_default = failureSummary;
        function incompleteFallbackMessage() {
            var message = axe._audit.data.incompleteFallbackMessage;
            if (typeof message === "function") message = message();
            if (typeof message !== "string") return "";
            return message;
        }
        var resultKeys = constants_default.resultGroups;
        function processAggregate(results, options) {
            var resultObject = axe.utils.aggregateResult(results);
            resultKeys.forEach(function(key) {
                if (options.resultTypes && !options.resultTypes.includes(key)) (resultObject[key] || []).forEach(function(ruleResult) {
                    if (Array.isArray(ruleResult.nodes) && ruleResult.nodes.length > 0) ruleResult.nodes = [
                        ruleResult.nodes[0]
                    ];
                });
                resultObject[key] = (resultObject[key] || []).map(function(ruleResult) {
                    ruleResult = Object.assign({}, ruleResult);
                    if (Array.isArray(ruleResult.nodes) && ruleResult.nodes.length > 0) ruleResult.nodes = ruleResult.nodes.map(function(subResult) {
                        if (_typeof(subResult.node) === "object") {
                            var serialElm = trimElementSpec(subResult.node, options);
                            Object.assign(subResult, serialElm);
                        }
                        delete subResult.result;
                        delete subResult.node;
                        normalizeRelatedNodes(subResult, options);
                        return subResult;
                    });
                    resultKeys.forEach(function(resultKey) {
                        return delete ruleResult[resultKey];
                    });
                    delete ruleResult.pageLevel;
                    delete ruleResult.result;
                    return ruleResult;
                });
            });
            return resultObject;
        }
        function normalizeRelatedNodes(node, options) {
            [
                "any",
                "all",
                "none"
            ].forEach(function(type2) {
                if (!Array.isArray(node[type2])) return;
                node[type2].filter(function(checkRes) {
                    return Array.isArray(checkRes.relatedNodes);
                }).forEach(function(checkRes) {
                    checkRes.relatedNodes = checkRes.relatedNodes.map(function(relatedNode) {
                        return trimElementSpec(relatedNode, options);
                    });
                });
            });
        }
        function trimElementSpec() {
            var elmSpec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var runOptions = arguments.length > 1 ? arguments[1] : undefined;
            elmSpec = node_serializer_default.dqElmToSpec(elmSpec, runOptions);
            var serialElm = {};
            if (axe._audit.noHtml) serialElm.html = null;
            else {
                var _elmSpec$source;
                serialElm.html = (_elmSpec$source = elmSpec.source) !== null && _elmSpec$source !== void 0 ? _elmSpec$source : "Undefined";
            }
            if (runOptions.elementRef && !elmSpec.fromFrame) {
                var _elmSpec$element;
                serialElm.element = (_elmSpec$element = elmSpec.element) !== null && _elmSpec$element !== void 0 ? _elmSpec$element : null;
            }
            if (runOptions.selectors !== false || elmSpec.fromFrame) {
                var _elmSpec$selector;
                serialElm.target = (_elmSpec$selector = elmSpec.selector) !== null && _elmSpec$selector !== void 0 ? _elmSpec$selector : [
                    ":root"
                ];
            }
            if (runOptions.ancestry) {
                var _elmSpec$ancestry;
                serialElm.ancestry = (_elmSpec$ancestry = elmSpec.ancestry) !== null && _elmSpec$ancestry !== void 0 ? _elmSpec$ancestry : [
                    ":root"
                ];
            }
            if (runOptions.xpath) {
                var _elmSpec$xpath;
                serialElm.xpath = (_elmSpec$xpath = elmSpec.xpath) !== null && _elmSpec$xpath !== void 0 ? _elmSpec$xpath : [
                    "/"
                ];
            }
            return serialElm;
        }
        var dataRegex = /\$\{\s?data\s?\}/g;
        function substitute(str, data) {
            if (typeof data === "string") return str.replace(dataRegex, data);
            for(var prop in data)if (data.hasOwnProperty(prop)) {
                var regex = new RegExp("\\${\\s?data\\." + prop + "\\s?}", "g");
                var replace = typeof data[prop] === "undefined" ? "" : String(data[prop]);
                str = str.replace(regex, replace);
            }
            return str;
        }
        function processMessage(message, data) {
            if (!message) return;
            if (Array.isArray(data)) {
                data.values = data.join(", ");
                if (typeof message.singular === "string" && typeof message.plural === "string") {
                    var str2 = data.length === 1 ? message.singular : message.plural;
                    return substitute(str2, data);
                }
                return substitute(message, data);
            }
            if (typeof message === "string") return substitute(message, data);
            if (typeof data === "string") {
                var _str = message[data];
                return substitute(_str, data);
            }
            var str = message["default"] || incompleteFallbackMessage();
            if (data && data.messageKey && message[data.messageKey]) str = message[data.messageKey];
            return processMessage(str, data);
        }
        var process_message_default = processMessage;
        function getCheckMessage(checkId, type2, data) {
            var check = axe._audit.data.checks[checkId];
            if (!check) throw new Error("Cannot get message for unknown check: ".concat(checkId, "."));
            if (!check.messages[type2]) throw new Error('Check "'.concat(checkId, '"" does not have a "').concat(type2, '" message.'));
            return process_message_default(check.messages[type2], data);
        }
        var get_check_message_default = getCheckMessage;
        function getCheckOption(check, ruleID, options) {
            var ruleCheckOption = ((options.rules && options.rules[ruleID] || {}).checks || {})[check.id];
            var checkOption = (options.checks || {})[check.id];
            var enabled = check.enabled;
            var opts = check.options;
            if (checkOption) {
                if (checkOption.hasOwnProperty("enabled")) enabled = checkOption.enabled;
                if (checkOption.hasOwnProperty("options")) opts = checkOption.options;
            }
            if (ruleCheckOption) {
                if (ruleCheckOption.hasOwnProperty("enabled")) enabled = ruleCheckOption.enabled;
                if (ruleCheckOption.hasOwnProperty("options")) opts = ruleCheckOption.options;
            }
            return {
                enabled: enabled,
                options: opts,
                absolutePaths: options.absolutePaths
            };
        }
        var get_check_option_default = getCheckOption;
        function _getEnvironmentData() {
            var _win$location;
            var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window1;
            if (metadata && _typeof(metadata) === "object") return metadata;
            else if (_typeof(win) !== "object") return {};
            return {
                testEngine: {
                    name: "axe-core",
                    version: axe.version
                },
                testRunner: {
                    name: axe._audit.brand
                },
                testEnvironment: getTestEnvironment(win),
                timestamp: new Date().toISOString(),
                url: (_win$location = win.location) === null || _win$location === void 0 ? void 0 : _win$location.href
            };
        }
        function getTestEnvironment(win) {
            if (!win.navigator || _typeof(win.navigator) !== "object") return {};
            var navigator = win.navigator, innerHeight = win.innerHeight, innerWidth = win.innerWidth;
            var _ref65 = getOrientation(win) || {}, angle = _ref65.angle, type2 = _ref65.type;
            return {
                userAgent: navigator.userAgent,
                windowWidth: innerWidth,
                windowHeight: innerHeight,
                orientationAngle: angle,
                orientationType: type2
            };
        }
        function getOrientation(_ref66) {
            var screen = _ref66.screen;
            return screen.orientation || screen.msOrientation || screen.mozOrientation;
        }
        function createFrameContext(frame, _ref67) {
            var focusable = _ref67.focusable, page = _ref67.page;
            return {
                node: frame,
                include: [],
                exclude: [],
                initiator: false,
                focusable: focusable && frameFocusable(frame),
                size: getBoundingSize(frame),
                page: page
            };
        }
        function frameFocusable(frame) {
            var tabIndex = frame.getAttribute("tabindex");
            if (!tabIndex) return true;
            var _int = parseInt(tabIndex, 10);
            return isNaN(_int) || _int >= 0;
        }
        function getBoundingSize(domNode) {
            var width = parseInt(domNode.getAttribute("width"), 10);
            var height = parseInt(domNode.getAttribute("height"), 10);
            if (isNaN(width) || isNaN(height)) {
                var rect = domNode.getBoundingClientRect();
                width = isNaN(width) ? rect.width : width;
                height = isNaN(height) ? rect.height : height;
            }
            return {
                width: width,
                height: height
            };
        }
        function normalizeContext(contextSpec) {
            if (isContextObject(contextSpec)) {
                var msg = " must be used inside include or exclude. It should not be on the same object.";
                assert2(!objectHasOwn(contextSpec, "fromFrames"), "fromFrames" + msg);
                assert2(!objectHasOwn(contextSpec, "fromShadowDom"), "fromShadowDom" + msg);
            } else if (isContextProp(contextSpec)) contextSpec = {
                include: contextSpec,
                exclude: []
            };
            else return {
                include: [
                    document
                ],
                exclude: []
            };
            var include = normalizeContextList(contextSpec.include);
            if (include.length === 0) include.push(document);
            var exclude = normalizeContextList(contextSpec.exclude);
            return {
                include: include,
                exclude: exclude
            };
        }
        function isContextSpec(contextSpec) {
            return isContextObject(contextSpec) || isContextProp(contextSpec);
        }
        function normalizeContextList() {
            var selectorList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var normalizedList = [];
            if (!isArrayLike(selectorList)) selectorList = [
                selectorList
            ];
            for(var _i21 = 0; _i21 < selectorList.length; _i21++){
                var normalizedSelector = normalizeContextSelector(selectorList[_i21]);
                if (normalizedSelector) normalizedList.push(normalizedSelector);
            }
            return normalizedList;
        }
        function normalizeContextSelector(selector) {
            if (selector instanceof window1.Node) return selector;
            if (typeof selector === "string") return [
                selector
            ];
            if (isLabelledFramesSelector(selector)) {
                assertLabelledFrameSelector(selector);
                selector = selector.fromFrames;
            } else if (isLabelledShadowDomSelector(selector)) selector = [
                selector
            ];
            return normalizeFrameSelectors(selector);
        }
        function normalizeFrameSelectors(frameSelectors) {
            if (!Array.isArray(frameSelectors)) return;
            var normalizedSelectors = [];
            var _iterator11 = _createForOfIteratorHelper(frameSelectors), _step11;
            try {
                for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                    var selector = _step11.value;
                    if (isLabelledShadowDomSelector(selector)) {
                        assertLabelledShadowDomSelector(selector);
                        selector = selector.fromShadowDom;
                    }
                    if (typeof selector !== "string" && !isShadowSelector(selector)) return;
                    normalizedSelectors.push(selector);
                }
            } catch (err) {
                _iterator11.e(err);
            } finally{
                _iterator11.f();
            }
            return normalizedSelectors;
        }
        function isContextObject(contextSpec) {
            return [
                "include",
                "exclude"
            ].some(function(prop) {
                return objectHasOwn(contextSpec, prop) && isContextProp(contextSpec[prop]);
            });
        }
        function isContextProp(contextList) {
            return typeof contextList === "string" || contextList instanceof window1.Node || isLabelledFramesSelector(contextList) || isLabelledShadowDomSelector(contextList) || isArrayLike(contextList);
        }
        function isLabelledFramesSelector(selector) {
            return objectHasOwn(selector, "fromFrames");
        }
        function isLabelledShadowDomSelector(selector) {
            return objectHasOwn(selector, "fromShadowDom");
        }
        function assertLabelledFrameSelector(selector) {
            assert2(Array.isArray(selector.fromFrames), "fromFrames property must be an array");
            assert2(selector.fromFrames.every(function(fromFrameSelector) {
                return !objectHasOwn(fromFrameSelector, "fromFrames");
            }), "Invalid context; fromFrames selector must be appended, rather than nested");
            assert2(!objectHasOwn(selector, "fromShadowDom"), "fromFrames and fromShadowDom cannot be used on the same object");
        }
        function assertLabelledShadowDomSelector(selector) {
            assert2(Array.isArray(selector.fromShadowDom), "fromShadowDom property must be an array");
            assert2(selector.fromShadowDom.every(function(fromShadowDomSelector) {
                return !objectHasOwn(fromShadowDomSelector, "fromFrames");
            }), "shadow selector must be inside fromFrame instead");
            assert2(selector.fromShadowDom.every(function(fromShadowDomSelector) {
                return !objectHasOwn(fromShadowDomSelector, "fromShadowDom");
            }), "fromShadowDom selector must be appended, rather than nested");
        }
        function isShadowSelector(selector) {
            return Array.isArray(selector) && selector.every(function(str) {
                return typeof str === "string";
            });
        }
        function isArrayLike(arr) {
            return arr && _typeof(arr) === "object" && typeof arr.length === "number" && arr instanceof window1.Node === false;
        }
        function assert2(bool, str) {
            assert_default(bool, "Invalid context; ".concat(str, "\nSee: https://github.com/dequelabs/axe-core/blob/master/doc/context.md"));
        }
        function objectHasOwn(obj, prop) {
            if (!obj || _typeof(obj) !== "object") return false;
            return Object.prototype.hasOwnProperty.call(obj, prop);
        }
        function parseSelectorArray(context, type2) {
            var result = [];
            for(var _i22 = 0, l = context[type2].length; _i22 < l; _i22++){
                var item = context[type2][_i22];
                if (item instanceof window1.Node) {
                    if (item.documentElement instanceof window1.Node) result.push(context.flatTree[0]);
                    else result.push(get_node_from_tree_default(item));
                } else if (item && item.length) {
                    if (item.length > 1) pushUniqueFrameSelector(context, type2, item);
                    else {
                        var nodeList = _shadowSelectAll(item[0]);
                        result.push.apply(result, _toConsumableArray(nodeList.map(function(node) {
                            return get_node_from_tree_default(node);
                        })));
                    }
                }
            }
            return result.filter(function(r) {
                return r;
            });
        }
        function pushUniqueFrameSelector(context, type2, selectorArray) {
            context.frames = context.frames || [];
            var frameSelector = selectorArray.shift();
            var frames = _shadowSelectAll(frameSelector);
            frames.forEach(function(frame) {
                var frameContext = context.frames.find(function(result) {
                    return result.node === frame;
                });
                if (!frameContext) {
                    frameContext = createFrameContext(frame, context);
                    context.frames.push(frameContext);
                }
                frameContext[type2].push(selectorArray);
            });
        }
        function Context(spec, flatTree) {
            var _spec, _spec2, _spec3, _spec4, _this5 = this;
            spec = _clone(spec);
            this.frames = [];
            this.page = typeof ((_spec = spec) === null || _spec === void 0 ? void 0 : _spec.page) === "boolean" ? spec.page : void 0;
            this.initiator = typeof ((_spec2 = spec) === null || _spec2 === void 0 ? void 0 : _spec2.initiator) === "boolean" ? spec.initiator : true;
            this.focusable = typeof ((_spec3 = spec) === null || _spec3 === void 0 ? void 0 : _spec3.focusable) === "boolean" ? spec.focusable : true;
            this.size = _typeof((_spec4 = spec) === null || _spec4 === void 0 ? void 0 : _spec4.size) === "object" ? spec.size : {};
            spec = normalizeContext(spec);
            this.flatTree = flatTree !== null && flatTree !== void 0 ? flatTree : _getFlattenedTree(getRootNode2(spec));
            this.exclude = spec.exclude;
            this.include = spec.include;
            this.include = parseSelectorArray(this, "include");
            this.exclude = parseSelectorArray(this, "exclude");
            _select("frame, iframe", this).forEach(function(frame) {
                if (_isNodeInContext(frame, _this5)) pushUniqueFrame(_this5, frame.actualNode);
            });
            if (typeof this.page === "undefined") {
                this.page = isPageContext(this);
                this.frames.forEach(function(frame) {
                    frame.page = _this5.page;
                });
            }
            validateContext(this);
            if (!Array.isArray(this.include)) this.include = Array.from(this.include);
            this.include.sort(node_sorter_default);
        }
        function pushUniqueFrame(context, frame) {
            if (!_isVisibleToScreenReaders(frame) || find_by_default(context.frames, "node", frame)) return;
            context.frames.push(createFrameContext(frame, context));
        }
        function isPageContext(_ref68) {
            var include = _ref68.include;
            return include.length === 1 && include[0].actualNode === document.documentElement;
        }
        function validateContext(context) {
            if (context.include.length === 0 && context.frames.length === 0) {
                var env = _respondable.isInFrame() ? "frame" : "page";
                throw new Error("No elements found for include in " + env + " Context");
            }
        }
        function getRootNode2(_ref69) {
            var include = _ref69.include, exclude = _ref69.exclude;
            var selectors = Array.from(include).concat(Array.from(exclude));
            for(var _i23 = 0; _i23 < selectors.length; _i23++){
                var item = selectors[_i23];
                if (item instanceof window1.Element) return item.ownerDocument.documentElement;
                if (item instanceof window1.Document) return item.documentElement;
            }
            return document.documentElement;
        }
        function _getFrameContexts(context) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (options.iframes === false) return [];
            var _Context = new Context(context), frames = _Context.frames;
            return frames.map(function(_ref70) {
                var node = _ref70.node, frameContext = _objectWithoutProperties(_ref70, _excluded14);
                frameContext.initiator = false;
                var frameSelector = _getAncestry(node);
                return {
                    frameSelector: frameSelector,
                    frameContext: frameContext
                };
            });
        }
        function _getRule(ruleId) {
            var rule = axe._audit.rules.find(function(_ref71) {
                var id = _ref71.id;
                return id === ruleId;
            });
            if (!rule) throw new Error("Cannot find rule by id: ".concat(ruleId));
            return rule;
        }
        function getScroll(elm) {
            var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var overflowX = elm.scrollWidth > elm.clientWidth + buffer;
            var overflowY = elm.scrollHeight > elm.clientHeight + buffer;
            if (!(overflowX || overflowY)) return;
            var style = window1.getComputedStyle(elm);
            var scrollableX = isScrollable(style, "overflow-x");
            var scrollableY = isScrollable(style, "overflow-y");
            if (overflowX && scrollableX || overflowY && scrollableY) return {
                elm: elm,
                top: elm.scrollTop,
                left: elm.scrollLeft
            };
        }
        function isScrollable(style, prop) {
            var overflowProp = style.getPropertyValue(prop);
            return [
                "scroll",
                "auto"
            ].includes(overflowProp);
        }
        var get_scroll_default = memoize_default(getScroll);
        function getElmScrollRecursive(root) {
            return Array.from(root.children || root.childNodes || []).reduce(function(scrolls, elm) {
                var scroll = get_scroll_default(elm);
                if (scroll) scrolls.push(scroll);
                return scrolls.concat(getElmScrollRecursive(elm));
            }, []);
        }
        function getScrollState() {
            var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window1;
            var root = win.document.documentElement;
            var windowScroll = [
                win.pageXOffset !== void 0 ? {
                    elm: win,
                    top: win.pageYOffset,
                    left: win.pageXOffset
                } : {
                    elm: root,
                    top: root.scrollTop,
                    left: root.scrollLeft
                }
            ];
            return windowScroll.concat(getElmScrollRecursive(document.body));
        }
        var get_scroll_state_default = getScrollState;
        function _getStandards() {
            return _clone(standards_default);
        }
        function getStyleSheetFactory(dynamicDoc) {
            if (!dynamicDoc) throw new Error("axe.utils.getStyleSheetFactory should be invoked with an argument");
            return function(options) {
                var data = options.data, _options$isCrossOrigi = options.isCrossOrigin, isCrossOrigin = _options$isCrossOrigi === void 0 ? false : _options$isCrossOrigi, shadowId = options.shadowId, root = options.root, priority = options.priority, _options$isLink = options.isLink, isLink = _options$isLink === void 0 ? false : _options$isLink;
                var style = dynamicDoc.createElement("style");
                if (isLink) {
                    var text = dynamicDoc.createTextNode('@import "'.concat(data.href, '"'));
                    style.appendChild(text);
                } else style.appendChild(dynamicDoc.createTextNode(data));
                dynamicDoc.head.appendChild(style);
                return {
                    sheet: style.sheet,
                    isCrossOrigin: isCrossOrigin,
                    shadowId: shadowId,
                    root: root,
                    priority: priority
                };
            };
        }
        var get_stylesheet_factory_default = getStyleSheetFactory;
        var styleSheet;
        function injectStyle(style) {
            if (styleSheet && styleSheet.parentNode) {
                if (styleSheet.styleSheet === void 0) styleSheet.appendChild(document.createTextNode(style));
                else styleSheet.styleSheet.cssText += style;
                return styleSheet;
            }
            if (!style) return;
            var head = document.head || document.getElementsByTagName("head")[0];
            styleSheet = document.createElement("style");
            styleSheet.type = "text/css";
            if (styleSheet.styleSheet === void 0) styleSheet.appendChild(document.createTextNode(style));
            else styleSheet.styleSheet.cssText = style;
            head.appendChild(styleSheet);
            return styleSheet;
        }
        var inject_style_default = injectStyle;
        function isHidden(el, recursed) {
            var node = get_node_from_tree_default(el);
            if (el.nodeType === 9) return false;
            if (el.nodeType === 11) el = el.host;
            if (node && node._isHidden !== null) return node._isHidden;
            var style = window1.getComputedStyle(el, null);
            if (!style || !el.parentNode || style.getPropertyValue("display") === "none" || !recursed && style.getPropertyValue("visibility") === "hidden" || el.getAttribute("aria-hidden") === "true") return true;
            var parent = el.assignedSlot ? el.assignedSlot : el.parentNode;
            var hidden = isHidden(parent, true);
            if (node) node._isHidden = hidden;
            return hidden;
        }
        var is_hidden_default = isHidden;
        function isHtmlElement(node) {
            var _node$props$nodeName, _node$props;
            var nodeName2 = (_node$props$nodeName = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.nodeName) !== null && _node$props$nodeName !== void 0 ? _node$props$nodeName : node.nodeName.toLowerCase();
            if (node.namespaceURI === "http://www.w3.org/2000/svg") return false;
            return !!standards_default.htmlElms[nodeName2];
        }
        var is_html_element_default = isHtmlElement;
        function _isNodeInContext(node, _ref72) {
            var _ref72$include = _ref72.include, include = _ref72$include === void 0 ? [] : _ref72$include, _ref72$exclude = _ref72.exclude, exclude = _ref72$exclude === void 0 ? [] : _ref72$exclude;
            var filterInclude = include.filter(function(candidate) {
                return _contains(candidate, node);
            });
            if (filterInclude.length === 0) return false;
            var filterExcluded = exclude.filter(function(candidate) {
                return _contains(candidate, node);
            });
            if (filterExcluded.length === 0) return true;
            var deepestInclude = getDeepest(filterInclude);
            var deepestExclude = getDeepest(filterExcluded);
            return _contains(deepestExclude, deepestInclude);
        }
        function getDeepest(collection) {
            var deepest;
            var _iterator12 = _createForOfIteratorHelper(collection), _step12;
            try {
                for(_iterator12.s(); !(_step12 = _iterator12.n()).done;){
                    var node = _step12.value;
                    if (!deepest || !_contains(node, deepest)) deepest = node;
                }
            } catch (err) {
                _iterator12.e(err);
            } finally{
                _iterator12.f();
            }
            return deepest;
        }
        function _matchAncestry(ancestryA, ancestryB) {
            if (ancestryA.length !== ancestryB.length) return false;
            return ancestryA.every(function(selectorA, ancestorIndex) {
                var selectorB = ancestryB[ancestorIndex];
                if (!Array.isArray(selectorA)) return selectorA === selectorB;
                if (selectorA.length !== selectorB.length) return false;
                return selectorA.every(function(str, selectorIndex) {
                    return selectorB[selectorIndex] === str;
                });
            });
        }
        function nodeSorter(nodeA, nodeB) {
            nodeA = nodeA.actualNode || nodeA;
            nodeB = nodeB.actualNode || nodeB;
            if (nodeA === nodeB) return 0;
            if (nodeA.compareDocumentPosition(nodeB) & 4) return -1;
            else return 1;
        }
        var node_sorter_default = nodeSorter;
        function _nodeLookup(node) {
            if (node instanceof abstract_virtual_node_default) return {
                vNode: node,
                domNode: node.actualNode
            };
            return {
                vNode: get_node_from_tree_default(node),
                domNode: node
            };
        }
        function parseSameOriginStylesheet(sheet, options, priority, importedUrls) {
            var isCrossOrigin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            var rules = Array.from(sheet.cssRules);
            if (!rules) return Promise.resolve();
            var cssImportRules = rules.filter(function(r) {
                return r.type === 3;
            });
            if (!cssImportRules.length) return Promise.resolve({
                isCrossOrigin: isCrossOrigin,
                priority: priority,
                root: options.rootNode,
                shadowId: options.shadowId,
                sheet: sheet
            });
            var cssImportUrlsNotAlreadyImported = cssImportRules.filter(function(rule) {
                return rule.href;
            }).map(function(rule) {
                return rule.href;
            }).filter(function(url) {
                return !importedUrls.includes(url);
            });
            var promises = cssImportUrlsNotAlreadyImported.map(function(importUrl, cssRuleIndex) {
                var newPriority = [].concat(_toConsumableArray(priority), [
                    cssRuleIndex
                ]);
                var isCrossOriginRequest = /^https?:\/\/|^\/\//i.test(importUrl);
                return parse_crossorigin_stylesheet_default(importUrl, options, newPriority, importedUrls, isCrossOriginRequest);
            });
            var nonImportCSSRules = rules.filter(function(r) {
                return r.type !== 3;
            });
            if (!nonImportCSSRules.length) return Promise.all(promises);
            promises.push(Promise.resolve(options.convertDataToStylesheet({
                data: nonImportCSSRules.map(function(rule) {
                    return rule.cssText;
                }).join(),
                isCrossOrigin: isCrossOrigin,
                priority: priority,
                root: options.rootNode,
                shadowId: options.shadowId
            })));
            return Promise.all(promises);
        }
        var parse_sameorigin_stylesheet_default = parseSameOriginStylesheet;
        function parseStylesheet(sheet, options, priority, importedUrls) {
            var isCrossOrigin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
            var isSameOrigin = isSameOriginStylesheet(sheet);
            if (isSameOrigin) return parse_sameorigin_stylesheet_default(sheet, options, priority, importedUrls, isCrossOrigin);
            return parse_crossorigin_stylesheet_default(sheet.href, options, priority, importedUrls, true);
        }
        function isSameOriginStylesheet(sheet) {
            try {
                var rules = sheet.cssRules;
                if (!rules && sheet.href) return false;
                return true;
            } catch (e) {
                return false;
            }
        }
        var parse_stylesheet_default = parseStylesheet;
        function parseCrossOriginStylesheet(url, options, priority, importedUrls, isCrossOrigin) {
            importedUrls.push(url);
            return new Promise(function(resolve, reject) {
                var request = new window1.XMLHttpRequest();
                request.open("GET", url);
                request.timeout = constants_default.preload.timeout;
                request.addEventListener("error", reject);
                request.addEventListener("timeout", reject);
                request.addEventListener("loadend", function(event) {
                    if (event.loaded && request.responseText) return resolve(request.responseText);
                    reject(request.responseText);
                });
                request.send();
            }).then(function(data) {
                var result = options.convertDataToStylesheet({
                    data: data,
                    isCrossOrigin: isCrossOrigin,
                    priority: priority,
                    root: options.rootNode,
                    shadowId: options.shadowId
                });
                return parse_stylesheet_default(result.sheet, options, priority, importedUrls, result.isCrossOrigin);
            });
        }
        var parse_crossorigin_stylesheet_default = parseCrossOriginStylesheet;
        var performanceTimer = function() {
            function now() {
                if (window1.performance && window1.performance) return window1.performance.now();
            }
            var originalTime = null;
            var lastRecordedTime = now();
            return {
                start: function start() {
                    this.mark("mark_axe_start");
                },
                end: function end() {
                    this.mark("mark_axe_end");
                    this.measure("axe", "mark_axe_start", "mark_axe_end");
                    this.logMeasures("axe");
                },
                auditStart: function auditStart() {
                    this.mark("mark_audit_start");
                },
                auditEnd: function auditEnd() {
                    this.mark("mark_audit_end");
                    this.measure("audit_start_to_end", "mark_audit_start", "mark_audit_end");
                    this.logMeasures();
                },
                mark: function mark(markName) {
                    if (window1.performance && window1.performance.mark !== void 0) window1.performance.mark(markName);
                },
                measure: function measure(measureName, startMark, endMark) {
                    if (window1.performance && window1.performance.measure !== void 0) window1.performance.measure(measureName, startMark, endMark);
                },
                logMeasures: function logMeasures(measureName) {
                    function logMeasure(req2) {
                        log_default("Measure " + req2.name + " took " + req2.duration + "ms");
                    }
                    if (window1.performance && window1.performance.getEntriesByType !== void 0) {
                        var axeStart = window1.performance.getEntriesByName("mark_axe_start")[0];
                        var measures = window1.performance.getEntriesByType("measure").filter(function(measure) {
                            return measure.startTime >= axeStart.startTime;
                        });
                        for(var i = 0; i < measures.length; ++i){
                            var req = measures[i];
                            if (req.name === measureName) {
                                logMeasure(req);
                                return;
                            }
                            logMeasure(req);
                        }
                    }
                },
                timeElapsed: function timeElapsed() {
                    return now() - lastRecordedTime;
                },
                reset: function reset() {
                    if (!originalTime) originalTime = now();
                    lastRecordedTime = now();
                }
            };
        }();
        var performance_timer_default = performanceTimer;
        if (typeof Object.assign !== "function") (function() {
            Object.assign = function(target) {
                if (target === void 0 || target === null) throw new TypeError("Cannot convert undefined or null to object");
                var output = Object(target);
                for(var index = 1; index < arguments.length; index++){
                    var source = arguments[index];
                    if (source !== void 0 && source !== null) {
                        for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
                    }
                }
                return output;
            };
        })();
        if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
            value: function value(predicate) {
                if (this === null) throw new TypeError("Array.prototype.find called on null or undefined");
                if (typeof predicate !== "function") throw new TypeError("predicate must be a function");
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;
                for(var i = 0; i < length; i++){
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) return value;
                }
                return void 0;
            }
        });
        if (!Array.prototype.findIndex) Object.defineProperty(Array.prototype, "findIndex", {
            value: function value(predicate, thisArg) {
                if (this === null) throw new TypeError("Array.prototype.find called on null or undefined");
                if (typeof predicate !== "function") throw new TypeError("predicate must be a function");
                var list = Object(this);
                var length = list.length >>> 0;
                var value;
                for(var i = 0; i < length; i++){
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) return i;
                }
                return -1;
            }
        });
        function _pollyfillElementsFromPoint() {
            if (document.elementsFromPoint) return document.elementsFromPoint;
            if (document.msElementsFromPoint) return document.msElementsFromPoint;
            var usePointer = function() {
                var element = document.createElement("x");
                element.style.cssText = "pointer-events:auto";
                return element.style.pointerEvents === "auto";
            }();
            var cssProp = usePointer ? "pointer-events" : "visibility";
            var cssDisableVal = usePointer ? "none" : "hidden";
            var style = document.createElement("style");
            style.innerHTML = usePointer ? "* { pointer-events: all }" : "* { visibility: visible }";
            return function(x, y) {
                var current, i, d2;
                var elements = [];
                var previousPointerEvents = [];
                document.head.appendChild(style);
                while((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1){
                    elements.push(current);
                    previousPointerEvents.push({
                        value: current.style.getPropertyValue(cssProp),
                        priority: current.style.getPropertyPriority(cssProp)
                    });
                    current.style.setProperty(cssProp, cssDisableVal, "important");
                }
                if (elements.indexOf(document.documentElement) < elements.length - 1) {
                    elements.splice(elements.indexOf(document.documentElement), 1);
                    elements.push(document.documentElement);
                }
                for(i = previousPointerEvents.length; !!(d2 = previousPointerEvents[--i]);)elements[i].style.setProperty(cssProp, d2.value ? d2.value : "", d2.priority);
                document.head.removeChild(style);
                return elements;
            };
        }
        if (typeof window1.addEventListener === "function") document.elementsFromPoint = _pollyfillElementsFromPoint();
        if (!Array.prototype.includes) Object.defineProperty(Array.prototype, "includes", {
            value: function value(searchElement) {
                var O = Object(this);
                var len = parseInt(O.length, 10) || 0;
                if (len === 0) return false;
                var n2 = parseInt(arguments[1], 10) || 0;
                var k;
                if (n2 >= 0) k = n2;
                else {
                    k = len + n2;
                    if (k < 0) k = 0;
                }
                var currentElement;
                while(k < len){
                    currentElement = O[k];
                    if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) return true;
                    k++;
                }
                return false;
            }
        });
        if (!Array.prototype.some) Object.defineProperty(Array.prototype, "some", {
            value: function value(fun) {
                if (this == null) throw new TypeError("Array.prototype.some called on null or undefined");
                if (typeof fun !== "function") throw new TypeError();
                var t = Object(this);
                var len = t.length >>> 0;
                var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
                for(var i = 0; i < len; i++){
                    if (i in t && fun.call(thisArg, t[i], i, t)) return true;
                }
                return false;
            }
        });
        if (!Array.from) Object.defineProperty(Array, "from", {
            value: function() {
                var toStr = Object.prototype.toString;
                var isCallable = function isCallable(fn) {
                    return typeof fn === "function" || toStr.call(fn) === "[object Function]";
                };
                var toInteger = function toInteger(value) {
                    var number = Number(value);
                    if (isNaN(number)) return 0;
                    if (number === 0 || !isFinite(number)) return number;
                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                };
                var maxSafeInteger = Math.pow(2, 53) - 1;
                var toLength = function toLength(value) {
                    var len = toInteger(value);
                    return Math.min(Math.max(len, 0), maxSafeInteger);
                };
                return function from(arrayLike) {
                    var C = this;
                    var items = Object(arrayLike);
                    if (arrayLike == null) throw new TypeError("Array.from requires an array-like object - not null or undefined");
                    var mapFn = arguments.length > 1 ? arguments[1] : void 0;
                    var T;
                    if (typeof mapFn !== "undefined") {
                        if (!isCallable(mapFn)) throw new TypeError("Array.from: when provided, the second argument must be a function");
                        if (arguments.length > 2) T = arguments[2];
                    }
                    var len = toLength(items.length);
                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                    var k = 0;
                    var kValue;
                    while(k < len){
                        kValue = items[k];
                        if (mapFn) A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                        else A[k] = kValue;
                        k += 1;
                    }
                    A.length = len;
                    return A;
                };
            }()
        });
        if (!String.prototype.includes) String.prototype.includes = function(search, start) {
            if (typeof start !== "number") start = 0;
            if (start + search.length > this.length) return false;
            else return this.indexOf(search, start) !== -1;
        };
        if (!Array.prototype.flat) Object.defineProperty(Array.prototype, "flat", {
            configurable: true,
            value: function flat() {
                var depth = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
                return depth ? Array.prototype.reduce.call(this, function(acc, cur) {
                    if (Array.isArray(cur)) acc.push.apply(acc, flat.call(cur, depth - 1));
                    else acc.push(cur);
                    return acc;
                }, []) : Array.prototype.slice.call(this);
            },
            writable: true
        });
        if (window1.Node && !("isConnected" in window1.Node.prototype)) Object.defineProperty(window1.Node.prototype, "isConnected", {
            get: function get() {
                return !this.ownerDocument || !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
            }
        });
        function uniqueArray(arr1, arr2) {
            return arr1.concat(arr2).filter(function(elem, pos, arr) {
                return arr.indexOf(elem) === pos;
            });
        }
        var unique_array_default = uniqueArray;
        function createLocalVariables(vNodes, anyLevel, thisLevel, parentShadowId, recycledLocalVariable) {
            var retVal = recycledLocalVariable || {};
            retVal.vNodes = vNodes;
            retVal.vNodesIndex = 0;
            retVal.anyLevel = anyLevel;
            retVal.thisLevel = thisLevel;
            retVal.parentShadowId = parentShadowId;
            return retVal;
        }
        function matchExpressions(domTree, expressions, filter) {
            var recycledLocalVariables = cache_default.get("qsa.recycledLocalVariables", function() {
                return [];
            });
            var stack = [];
            var vNodes = Array.isArray(domTree) ? domTree : [
                domTree
            ];
            var currentLevel = createLocalVariables(vNodes, expressions, null, domTree[0].shadowId, recycledLocalVariables.pop());
            var result = [];
            while(currentLevel.vNodesIndex < currentLevel.vNodes.length){
                var _currentLevel$anyLeve, _currentLevel$thisLev;
                var vNode = currentLevel.vNodes[currentLevel.vNodesIndex++];
                var childOnly = null;
                var childAny = null;
                var combinedLength = (((_currentLevel$anyLeve = currentLevel.anyLevel) === null || _currentLevel$anyLeve === void 0 ? void 0 : _currentLevel$anyLeve.length) || 0) + (((_currentLevel$thisLev = currentLevel.thisLevel) === null || _currentLevel$thisLev === void 0 ? void 0 : _currentLevel$thisLev.length) || 0);
                var added = false;
                for(var _i24 = 0; _i24 < combinedLength; _i24++){
                    var _currentLevel$anyLeve2, _currentLevel$anyLeve3, _currentLevel$anyLeve4;
                    var exp = _i24 < (((_currentLevel$anyLeve2 = currentLevel.anyLevel) === null || _currentLevel$anyLeve2 === void 0 ? void 0 : _currentLevel$anyLeve2.length) || 0) ? currentLevel.anyLevel[_i24] : currentLevel.thisLevel[_i24 - (((_currentLevel$anyLeve3 = currentLevel.anyLevel) === null || _currentLevel$anyLeve3 === void 0 ? void 0 : _currentLevel$anyLeve3.length) || 0)];
                    if ((!exp[0].id || vNode.shadowId === currentLevel.parentShadowId) && _matchesExpression(vNode, exp[0])) {
                        if (exp.length === 1) {
                            if (!added && (!filter || filter(vNode))) {
                                result.push(vNode);
                                added = true;
                            }
                        } else {
                            var rest = exp.slice(1);
                            if ([
                                " ",
                                ">"
                            ].includes(rest[0].combinator) === false) throw new Error("axe.utils.querySelectorAll does not support the combinator: " + exp[1].combinator);
                            if (rest[0].combinator === ">") (childOnly = childOnly || []).push(rest);
                            else (childAny = childAny || []).push(rest);
                        }
                    }
                    if ((!exp[0].id || vNode.shadowId === currentLevel.parentShadowId) && (_currentLevel$anyLeve4 = currentLevel.anyLevel) !== null && _currentLevel$anyLeve4 !== void 0 && _currentLevel$anyLeve4.includes(exp)) (childAny = childAny || []).push(exp);
                }
                if (vNode.children && vNode.children.length) {
                    stack.push(currentLevel);
                    currentLevel = createLocalVariables(vNode.children, childAny, childOnly, vNode.shadowId, recycledLocalVariables.pop());
                }
                while(currentLevel.vNodesIndex === currentLevel.vNodes.length && stack.length){
                    recycledLocalVariables.push(currentLevel);
                    currentLevel = stack.pop();
                }
            }
            return result;
        }
        function querySelectorAllFilter(domTree, selector, filter) {
            domTree = Array.isArray(domTree) ? domTree : [
                domTree
            ];
            var expressions = _convertSelector(selector);
            var nodes = getNodesMatchingExpression(domTree, expressions, filter);
            if (nodes) return nodes;
            return matchExpressions(domTree, expressions, filter);
        }
        var query_selector_all_filter_default = querySelectorAllFilter;
        function preloadCssom(_ref73) {
            var _ref73$treeRoot = _ref73.treeRoot, treeRoot = _ref73$treeRoot === void 0 ? axe._tree[0] : _ref73$treeRoot;
            var rootNodes = getAllRootNodesInTree(treeRoot);
            if (!rootNodes.length) return Promise.resolve();
            var dynamicDoc = document.implementation.createHTMLDocument("Dynamic document for loading cssom");
            var convertDataToStylesheet = get_stylesheet_factory_default(dynamicDoc);
            return getCssomForAllRootNodes(rootNodes, convertDataToStylesheet).then(function(assets) {
                return flattenAssets(assets);
            });
        }
        var preload_cssom_default = preloadCssom;
        function getAllRootNodesInTree(tree) {
            var ids = [];
            var rootNodes = query_selector_all_filter_default(tree, "*", function(node) {
                if (ids.includes(node.shadowId)) return false;
                ids.push(node.shadowId);
                return true;
            }).map(function(node) {
                return {
                    shadowId: node.shadowId,
                    rootNode: get_root_node_default(node.actualNode)
                };
            });
            return unique_array_default(rootNodes, []);
        }
        function getCssomForAllRootNodes(rootNodes, convertDataToStylesheet) {
            var promises = [];
            rootNodes.forEach(function(_ref74, index) {
                var rootNode = _ref74.rootNode, shadowId = _ref74.shadowId;
                var sheets = getStylesheetsOfRootNode(rootNode, shadowId, convertDataToStylesheet);
                if (!sheets) return Promise.all(promises);
                var rootIndex = index + 1;
                var parseOptions = {
                    rootNode: rootNode,
                    shadowId: shadowId,
                    convertDataToStylesheet: convertDataToStylesheet,
                    rootIndex: rootIndex
                };
                var importedUrls = [];
                var p2 = Promise.all(sheets.map(function(sheet, sheetIndex) {
                    var priority = [
                        rootIndex,
                        sheetIndex
                    ];
                    return parse_stylesheet_default(sheet, parseOptions, priority, importedUrls);
                }));
                promises.push(p2);
            });
            return Promise.all(promises);
        }
        function flattenAssets(assets) {
            return assets.reduce(function(acc, val) {
                return Array.isArray(val) ? acc.concat(flattenAssets(val)) : acc.concat(val);
            }, []);
        }
        function getStylesheetsOfRootNode(rootNode, shadowId, convertDataToStylesheet) {
            var sheets;
            if (rootNode.nodeType === 11 && shadowId) sheets = getStylesheetsFromDocumentFragment(rootNode, convertDataToStylesheet);
            else sheets = getStylesheetsFromDocument(rootNode);
            return filterStylesheetsWithSameHref(sheets);
        }
        function getStylesheetsFromDocumentFragment(rootNode, convertDataToStylesheet) {
            return Array.from(rootNode.children).filter(filerStyleAndLinkAttributesInDocumentFragment).reduce(function(out, node) {
                var nodeName2 = node.nodeName.toUpperCase();
                var data = nodeName2 === "STYLE" ? node.textContent : node;
                var isLink = nodeName2 === "LINK";
                var stylesheet = convertDataToStylesheet({
                    data: data,
                    isLink: isLink,
                    root: rootNode
                });
                if (stylesheet.sheet) out.push(stylesheet.sheet);
                return out;
            }, []);
        }
        function getStylesheetsFromDocument(rootNode) {
            return Array.from(rootNode.styleSheets).filter(function(sheet) {
                if (!sheet.media) return false;
                return filterMediaIsPrint(sheet.media.mediaText);
            });
        }
        function filerStyleAndLinkAttributesInDocumentFragment(node) {
            var nodeName2 = node.nodeName.toUpperCase();
            var linkHref = node.getAttribute("href");
            var linkRel = node.getAttribute("rel");
            var isLink = nodeName2 === "LINK" && linkHref && linkRel && node.rel.toUpperCase().includes("STYLESHEET");
            var isStyle = nodeName2 === "STYLE";
            return isStyle || isLink && filterMediaIsPrint(node.media);
        }
        function filterMediaIsPrint(media) {
            if (!media) return true;
            return !media.toUpperCase().includes("PRINT");
        }
        function filterStylesheetsWithSameHref(sheets) {
            var hrefs = [];
            return sheets.filter(function(sheet) {
                if (!sheet.href) return true;
                if (hrefs.includes(sheet.href)) return false;
                hrefs.push(sheet.href);
                return true;
            });
        }
        function preloadMedia(_ref75) {
            var _ref75$treeRoot = _ref75.treeRoot, treeRoot = _ref75$treeRoot === void 0 ? axe._tree[0] : _ref75$treeRoot;
            var mediaVirtualNodes = query_selector_all_filter_default(treeRoot, "video, audio", function(_ref76) {
                var actualNode = _ref76.actualNode;
                if (actualNode.hasAttribute("src")) return !!actualNode.getAttribute("src");
                var sourceWithSrc = Array.from(actualNode.getElementsByTagName("source")).filter(function(source) {
                    return !!source.getAttribute("src");
                });
                if (sourceWithSrc.length <= 0) return false;
                return true;
            });
            return Promise.all(mediaVirtualNodes.map(function(_ref77) {
                var actualNode = _ref77.actualNode;
                return isMediaElementReady(actualNode);
            }));
        }
        var preload_media_default = preloadMedia;
        function isMediaElementReady(elm) {
            return new Promise(function(resolve) {
                if (elm.readyState > 0) resolve(elm);
                function onMediaReady() {
                    elm.removeEventListener("loadedmetadata", onMediaReady);
                    resolve(elm);
                }
                elm.addEventListener("loadedmetadata", onMediaReady);
            });
        }
        function _preload(options) {
            var preloadFunctionsMap = {
                cssom: preload_cssom_default,
                media: preload_media_default
            };
            if (!_shouldPreload(options)) return Promise.resolve();
            return new Promise(function(resolve, reject) {
                var _getPreloadConfig2 = _getPreloadConfig(options), assets = _getPreloadConfig2.assets, timeout = _getPreloadConfig2.timeout;
                var preloadTimeout = setTimeout(function() {
                    return reject(new Error("Preload assets timed out."));
                }, timeout);
                Promise.all(assets.map(function(asset) {
                    return preloadFunctionsMap[asset](options).then(function(results) {
                        return _defineProperty({}, asset, results);
                    });
                })).then(function(results) {
                    var preloadAssets = results.reduce(function(out, result) {
                        return _extends({}, out, result);
                    }, {});
                    clearTimeout(preloadTimeout);
                    resolve(preloadAssets);
                })["catch"](function(err2) {
                    clearTimeout(preloadTimeout);
                    reject(err2);
                });
            });
        }
        function isValidPreloadObject(preloadObj) {
            return _typeof(preloadObj) === "object" && Array.isArray(preloadObj.assets);
        }
        function _shouldPreload(options) {
            if (!options || options.preload === void 0 || options.preload === null) return true;
            if (typeof options.preload === "boolean") return options.preload;
            return isValidPreloadObject(options.preload);
        }
        function _getPreloadConfig(options) {
            var _constants_default$pr = constants_default.preload, assets = _constants_default$pr.assets, timeout = _constants_default$pr.timeout;
            var config = {
                assets: assets,
                timeout: timeout
            };
            if (!options.preload) return config;
            if (typeof options.preload === "boolean") return config;
            var areRequestedAssetsValid = options.preload.assets.every(function(a2) {
                return assets.includes(a2.toLowerCase());
            });
            if (!areRequestedAssetsValid) throw new Error("Requested assets, not supported. Supported assets are: ".concat(assets.join(", "), "."));
            config.assets = unique_array_default(options.preload.assets.map(function(a2) {
                return a2.toLowerCase();
            }), []);
            if (options.preload.timeout && typeof options.preload.timeout === "number" && !isNaN(options.preload.timeout)) config.timeout = options.preload.timeout;
            return config;
        }
        function _publishMetaData(ruleResult) {
            var checksData = axe._audit.data.checks || {};
            var rulesData = axe._audit.data.rules || {};
            var rule = find_by_default(axe._audit.rules, "id", ruleResult.id) || {};
            ruleResult.tags = _clone(rule.tags || []);
            var shouldBeTrue = extender(checksData, true, rule);
            var shouldBeFalse = extender(checksData, false, rule);
            ruleResult.nodes.forEach(function(detail) {
                detail.any.forEach(shouldBeTrue);
                detail.all.forEach(shouldBeTrue);
                detail.none.forEach(shouldBeFalse);
            });
            extend_meta_data_default(ruleResult, _clone(rulesData[ruleResult.id] || {}));
        }
        function getIncompleteReason(checkData, messages) {
            function getDefaultMsg(message) {
                if (message.incomplete && message.incomplete["default"]) return message.incomplete["default"];
                else return incompleteFallbackMessage();
            }
            if (checkData && checkData.missingData) try {
                var msg = messages.incomplete[checkData.missingData[0].reason];
                if (!msg) throw new Error();
                return msg;
            } catch (e) {
                if (typeof checkData.missingData === "string") return messages.incomplete[checkData.missingData];
                else return getDefaultMsg(messages);
            }
            else if (checkData && checkData.messageKey) return messages.incomplete[checkData.messageKey];
            else return getDefaultMsg(messages);
        }
        function extender(checksData, shouldBeTrue, rule) {
            return function(check) {
                var sourceData = checksData[check.id] || {};
                var messages = sourceData.messages || {};
                var data = Object.assign({}, sourceData);
                delete data.messages;
                if (!rule.reviewOnFail && check.result === void 0) {
                    if (_typeof(messages.incomplete) === "object" && !Array.isArray(check.data)) data.message = getIncompleteReason(check.data, messages);
                    if (!data.message) data.message = messages.incomplete;
                } else data.message = check.result === shouldBeTrue ? messages.pass : messages.fail;
                if (typeof data.message !== "function") data.message = process_message_default(data.message, check.data);
                extend_meta_data_default(check, data);
            };
        }
        function querySelectorAll(domTree, selector) {
            return query_selector_all_filter_default(domTree, selector);
        }
        var query_selector_all_default = querySelectorAll;
        function matchTags(rule, runOnly) {
            var include, exclude, matching;
            var defaultExclude = axe._audit && axe._audit.tagExclude ? axe._audit.tagExclude : [];
            if (runOnly.hasOwnProperty("include") || runOnly.hasOwnProperty("exclude")) {
                include = runOnly.include || [];
                include = Array.isArray(include) ? include : [
                    include
                ];
                exclude = runOnly.exclude || [];
                exclude = Array.isArray(exclude) ? exclude : [
                    exclude
                ];
                exclude = exclude.concat(defaultExclude.filter(function(tag) {
                    return include.indexOf(tag) === -1;
                }));
            } else {
                include = Array.isArray(runOnly) ? runOnly : [
                    runOnly
                ];
                exclude = defaultExclude.filter(function(tag) {
                    return include.indexOf(tag) === -1;
                });
            }
            matching = include.some(function(tag) {
                return rule.tags.indexOf(tag) !== -1;
            });
            if (matching || include.length === 0 && rule.enabled !== false) return exclude.every(function(tag) {
                return rule.tags.indexOf(tag) === -1;
            });
            else return false;
        }
        function ruleShouldRun(rule, context, options) {
            var runOnly = options.runOnly || {};
            var ruleOptions = (options.rules || {})[rule.id];
            if (rule.pageLevel && !context.page) return false;
            else if (runOnly.type === "rule") return runOnly.values.indexOf(rule.id) !== -1;
            else if (ruleOptions && typeof ruleOptions.enabled === "boolean") return ruleOptions.enabled;
            else if (runOnly.type === "tag" && runOnly.values) return matchTags(rule, runOnly.values);
            else return matchTags(rule, []);
        }
        var rule_should_run_default = ruleShouldRun;
        function _filterHtmlAttrs(element, filterAttrs) {
            if (!filterAttrs) return element;
            var node = element.cloneNode(false);
            var attributes2 = get_node_attributes_default(node);
            if (node.nodeType === 1) {
                var outerHTML = node.outerHTML;
                node = cache_default.get(outerHTML, function() {
                    return setNodeAttributes(node, attributes2, element, filterAttrs);
                });
            } else node = setNodeAttributes(node, attributes2, element, filterAttrs);
            Array.from(element.childNodes).forEach(function(child) {
                node.appendChild(_filterHtmlAttrs(child, filterAttrs));
            });
            return node;
        }
        function setNodeAttributes(node, attributes2, element, filterAttrs) {
            if (!attributes2) return node;
            node = document.createElement(node.nodeName);
            Array.from(attributes2).forEach(function(attr) {
                if (!attributeMatches(element, attr.name, filterAttrs)) node.setAttribute(attr.name, attr.value);
            });
            return node;
        }
        function attributeMatches(node, attrName, filterAttrs) {
            if (typeof filterAttrs[attrName] === "undefined") return false;
            if (filterAttrs[attrName] === true) return true;
            return element_matches_default(node, filterAttrs[attrName]);
        }
        function _select(selector, context) {
            var result = [];
            var candidate;
            if (axe._selectCache) for(var j = 0, l = axe._selectCache.length; j < l; j++){
                var item = axe._selectCache[j];
                if (item.selector === selector) return item.result;
            }
            var outerIncludes = getOuterIncludes(context.include);
            var isInContext = getContextFilter(context);
            for(var _i25 = 0; _i25 < outerIncludes.length; _i25++){
                candidate = outerIncludes[_i25];
                var nodes = query_selector_all_filter_default(candidate, selector, isInContext);
                result = mergeArrayUniques(result, nodes);
            }
            if (axe._selectCache) axe._selectCache.push({
                selector: selector,
                result: result
            });
            return result;
        }
        function getOuterIncludes(includes) {
            return includes.reduce(function(res, el) {
                if (!res.length || !_contains(res[res.length - 1], el)) res.push(el);
                return res;
            }, []);
        }
        function getContextFilter(context) {
            if (!context.exclude || context.exclude.length === 0) return null;
            return function(node) {
                return _isNodeInContext(node, context);
            };
        }
        function mergeArrayUniques(arr1, arr2) {
            if (arr1.length === 0) return arr2;
            if (arr1.length < arr2.length) {
                var temp = arr1;
                arr1 = arr2;
                arr2 = temp;
            }
            for(var _i26 = 0, l = arr2.length; _i26 < l; _i26++)if (!arr1.includes(arr2[_i26])) arr1.push(arr2[_i26]);
            return arr1;
        }
        function setScroll(elm, top, left) {
            if (elm === window1) return elm.scroll(left, top);
            else {
                elm.scrollTop = top;
                elm.scrollLeft = left;
            }
        }
        function setScrollState(scrollState) {
            scrollState.forEach(function(_ref79) {
                var elm = _ref79.elm, top = _ref79.top, left = _ref79.left;
                return setScroll(elm, top, left);
            });
        }
        var set_scroll_state_default = setScrollState;
        function _shadowSelect(selectors) {
            var selectorArr = Array.isArray(selectors) ? _toConsumableArray(selectors) : [
                selectors
            ];
            return selectRecursive(selectorArr, document);
        }
        function selectRecursive(selectors, doc) {
            var selectorStr = selectors.shift();
            var elm = selectorStr ? doc.querySelector(selectorStr) : null;
            if (selectors.length === 0) return elm;
            if (!(elm !== null && elm !== void 0 && elm.shadowRoot)) return null;
            return selectRecursive(selectors, elm.shadowRoot);
        }
        function _shadowSelectAll(selectors) {
            var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
            var selectorArr = Array.isArray(selectors) ? _toConsumableArray(selectors) : [
                selectors
            ];
            if (selectors.length === 0) return [];
            return selectAllRecursive(selectorArr, doc);
        }
        function selectAllRecursive(_ref80, doc) {
            var _ref81 = _toArray(_ref80), selectorStr = _ref81[0], restSelector = _ref81.slice(1);
            var elms = doc.querySelectorAll(selectorStr);
            if (restSelector.length === 0) return Array.from(elms);
            var selected = [];
            var _iterator13 = _createForOfIteratorHelper(elms), _step13;
            try {
                for(_iterator13.s(); !(_step13 = _iterator13.n()).done;){
                    var elm = _step13.value;
                    if (elm !== null && elm !== void 0 && elm.shadowRoot) selected.push.apply(selected, _toConsumableArray(selectAllRecursive(restSelector, elm.shadowRoot)));
                }
            } catch (err) {
                _iterator13.e(err);
            } finally{
                _iterator13.f();
            }
            return selected;
        }
        function validInputTypes() {
            return [
                "hidden",
                "text",
                "search",
                "tel",
                "url",
                "email",
                "password",
                "date",
                "month",
                "week",
                "time",
                "datetime-local",
                "number",
                "range",
                "color",
                "checkbox",
                "radio",
                "file",
                "submit",
                "image",
                "reset",
                "button"
            ];
        }
        var valid_input_type_default = validInputTypes;
        var langs = [
            ,
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                ,
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                ,
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1
                ],
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                ,
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1
                ],
                ,
                [
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                ,
                [
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                ,
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                ,
                [
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                ,
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                ,
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ]
            ],
            [
                ,
                [
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    1,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    1,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    1,
                    ,
                    1,
                    1,
                    ,
                    1,
                    1,
                    1,
                    ,
                    ,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                ,
                [
                    ,
                    1
                ],
                [
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ],
                [
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    1,
                    ,
                    ,
                    1,
                    ,
                    ,
                    ,
                    1,
                    ,
                    1
                ],
                [
                    ,
                    1,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    ,
                    1
                ]
            ]
        ];
        function isValidLang(lang) {
            var array = langs;
            while(lang.length < 3)lang += "`";
            for(var _i27 = 0; _i27 <= lang.length - 1; _i27++){
                var index = lang.charCodeAt(_i27) - 96;
                array = array[index];
                if (!array) return false;
            }
            return true;
        }
        function _validLangs(langArray) {
            langArray = Array.isArray(langArray) ? langArray : langs;
            var codes = [];
            langArray.forEach(function(lang, index) {
                var _char3 = String.fromCharCode(index + 96).replace("`", "");
                if (Array.isArray(lang)) codes = codes.concat(_validLangs(lang).map(function(newLang) {
                    return _char3 + newLang;
                }));
                else codes.push(_char3);
            });
            return codes;
        }
        var valid_langs_default = isValidLang;
        var SerialVirtualNode = function(_abstract_virtual_nod2) {
            _inherits(SerialVirtualNode, _abstract_virtual_nod2);
            var _super3 = _createSuper(SerialVirtualNode);
            function SerialVirtualNode(serialNode) {
                var _this6;
                _classCallCheck(this, SerialVirtualNode);
                _this6 = _super3.call(this);
                _this6._props = normaliseProps(serialNode);
                _this6._attrs = normaliseAttrs(serialNode);
                return _this6;
            }
            _createClass(SerialVirtualNode, [
                {
                    key: "props",
                    get: function get() {
                        return this._props;
                    }
                },
                {
                    key: "attr",
                    value: function attr(attrName) {
                        var _this$_attrs$attrName;
                        return (_this$_attrs$attrName = this._attrs[attrName]) !== null && _this$_attrs$attrName !== void 0 ? _this$_attrs$attrName : null;
                    }
                },
                {
                    key: "hasAttr",
                    value: function hasAttr(attrName) {
                        return this._attrs[attrName] !== void 0;
                    }
                },
                {
                    key: "attrNames",
                    get: function get() {
                        return Object.keys(this._attrs);
                    }
                }
            ]);
            return SerialVirtualNode;
        }(abstract_virtual_node_default);
        var nodeNamesToTypes = {
            "#cdata-section": 2,
            "#text": 3,
            "#comment": 8,
            "#document": 9,
            "#document-fragment": 11
        };
        var nodeTypeToName = {};
        var nodeNames = Object.keys(nodeNamesToTypes);
        nodeNames.forEach(function(nodeName2) {
            nodeTypeToName[nodeNamesToTypes[nodeName2]] = nodeName2;
        });
        function normaliseProps(serialNode) {
            var _serialNode$nodeName, _ref82, _serialNode$nodeType;
            var nodeName2 = (_serialNode$nodeName = serialNode.nodeName) !== null && _serialNode$nodeName !== void 0 ? _serialNode$nodeName : nodeTypeToName[serialNode.nodeType];
            var nodeType = (_ref82 = (_serialNode$nodeType = serialNode.nodeType) !== null && _serialNode$nodeType !== void 0 ? _serialNode$nodeType : nodeNamesToTypes[serialNode.nodeName]) !== null && _ref82 !== void 0 ? _ref82 : 1;
            assert_default(typeof nodeType === "number", "nodeType has to be a number, got '".concat(nodeType, "'"));
            assert_default(typeof nodeName2 === "string", "nodeName has to be a string, got '".concat(nodeName2, "'"));
            nodeName2 = nodeName2.toLowerCase();
            var type2 = null;
            if (nodeName2 === "input") {
                type2 = (serialNode.type || serialNode.attributes && serialNode.attributes.type || "").toLowerCase();
                if (!valid_input_type_default().includes(type2)) type2 = "text";
            }
            var props = _extends({}, serialNode, {
                nodeType: nodeType,
                nodeName: nodeName2
            });
            if (type2) props.type = type2;
            delete props.attributes;
            return Object.freeze(props);
        }
        function normaliseAttrs(_ref83) {
            var _ref83$attributes = _ref83.attributes, attributes2 = _ref83$attributes === void 0 ? {} : _ref83$attributes;
            var attrMap = {
                htmlFor: "for",
                className: "class"
            };
            return Object.keys(attributes2).reduce(function(attrs, attrName) {
                var value = attributes2[attrName];
                assert_default(_typeof(value) !== "object" || value === null, "expects attributes not to be an object, '".concat(attrName, "' was"));
                if (value !== void 0) {
                    var mappedName = attrMap[attrName] || attrName;
                    attrs[mappedName] = value !== null ? String(value) : null;
                }
                return attrs;
            }, {});
        }
        var serial_virtual_node_default = SerialVirtualNode;
        function cleanup(resolve, reject) {
            resolve = resolve || function res() {};
            reject = reject || axe.log;
            if (!axe._audit) throw new Error("No audit configured");
            var q = axe.utils.queue();
            var cleanupErrors = [];
            Object.keys(axe.plugins).forEach(function(key) {
                q.defer(function(res) {
                    var rej = function rej2(err2) {
                        cleanupErrors.push(err2);
                        res();
                    };
                    try {
                        axe.plugins[key].cleanup(res, rej);
                    } catch (err2) {
                        rej(err2);
                    }
                });
            });
            var flattenedTree = axe.utils.getFlattenedTree(document.body);
            axe.utils.querySelectorAll(flattenedTree, "iframe, frame").forEach(function(node) {
                q.defer(function(res, rej) {
                    return axe.utils.sendCommandToFrame(node.actualNode, {
                        command: "cleanup-plugin"
                    }, res, rej);
                });
            });
            q.then(function(results) {
                if (cleanupErrors.length === 0) resolve(results);
                else reject(cleanupErrors);
            })["catch"](reject);
        }
        var cleanup_default = cleanup;
        var reporters = {};
        var defaultReporter;
        function hasReporter(reporterName) {
            return reporters.hasOwnProperty(reporterName);
        }
        function getReporter(reporter) {
            if (typeof reporter === "string" && reporters[reporter]) return reporters[reporter];
            if (typeof reporter === "function") return reporter;
            return defaultReporter;
        }
        function addReporter(name, cb, isDefault) {
            reporters[name] = cb;
            if (isDefault) defaultReporter = cb;
        }
        function configure(spec) {
            var audit;
            audit = axe._audit;
            if (!audit) throw new Error("No audit configured");
            if (spec.axeVersion || spec.ver) {
                var specVersion = spec.axeVersion || spec.ver;
                if (!/^\d+\.\d+\.\d+(-canary)?/.test(specVersion)) throw new Error("Invalid configured version ".concat(specVersion));
                var _specVersion$split = specVersion.split("-"), _specVersion$split2 = _slicedToArray(_specVersion$split, 2), version = _specVersion$split2[0], canary = _specVersion$split2[1];
                var _version$split$map = version.split(".").map(Number), _version$split$map2 = _slicedToArray(_version$split$map, 3), major = _version$split$map2[0], minor = _version$split$map2[1], patch = _version$split$map2[2];
                var _axe$version$split = axe.version.split("-"), _axe$version$split2 = _slicedToArray(_axe$version$split, 2), axeVersion = _axe$version$split2[0], axeCanary = _axe$version$split2[1];
                var _axeVersion$split$map = axeVersion.split(".").map(Number), _axeVersion$split$map2 = _slicedToArray(_axeVersion$split$map, 3), axeMajor = _axeVersion$split$map2[0], axeMinor = _axeVersion$split$map2[1], axePatch = _axeVersion$split$map2[2];
                if (major !== axeMajor || axeMinor < minor || axeMinor === minor && axePatch < patch || major === axeMajor && minor === axeMinor && patch === axePatch && canary && canary !== axeCanary) throw new Error("Configured version ".concat(specVersion, " is not compatible with current axe version ").concat(axe.version));
            }
            if (spec.reporter && (typeof spec.reporter === "function" || hasReporter(spec.reporter))) audit.reporter = spec.reporter;
            if (spec.checks) {
                if (!Array.isArray(spec.checks)) throw new TypeError("Checks property must be an array");
                spec.checks.forEach(function(check) {
                    if (!check.id) throw new TypeError("Configured check ".concat(JSON.stringify(check), " is invalid. Checks must be an object with at least an id property"));
                    audit.addCheck(check);
                });
            }
            var modifiedRules = [];
            if (spec.rules) {
                if (!Array.isArray(spec.rules)) throw new TypeError("Rules property must be an array");
                spec.rules.forEach(function(rule) {
                    if (!rule.id) throw new TypeError("Configured rule ".concat(JSON.stringify(rule), " is invalid. Rules must be an object with at least an id property"));
                    modifiedRules.push(rule.id);
                    audit.addRule(rule);
                });
            }
            if (spec.disableOtherRules) audit.rules.forEach(function(rule) {
                if (modifiedRules.includes(rule.id) === false) rule.enabled = false;
            });
            if (typeof spec.branding !== "undefined") audit.setBranding(spec.branding);
            else audit._constructHelpUrls();
            if (spec.tagExclude) audit.tagExclude = spec.tagExclude;
            if (spec.locale) audit.applyLocale(spec.locale);
            if (spec.standards) configureStandards(spec.standards);
            if (spec.noHtml) audit.noHtml = true;
            if (spec.allowedOrigins) {
                if (!Array.isArray(spec.allowedOrigins)) throw new TypeError("Allowed origins property must be an array");
                if (spec.allowedOrigins.includes("*")) throw new Error('"*" is not allowed. Use "'.concat(constants_default.allOrigins, '" instead'));
                audit.setAllowedOrigins(spec.allowedOrigins);
            }
        }
        var configure_default = configure;
        function frameMessenger2(frameHandler) {
            _respondable.updateMessenger(frameHandler);
        }
        function getRules(tags) {
            tags = tags || [];
            var matchingRules = !tags.length ? axe._audit.rules : axe._audit.rules.filter(function(item) {
                return !!tags.filter(function(tag) {
                    return item.tags.indexOf(tag) !== -1;
                }).length;
            });
            var ruleData = axe._audit.data.rules || {};
            return matchingRules.map(function(matchingRule) {
                var rd = ruleData[matchingRule.id] || {};
                return {
                    ruleId: matchingRule.id,
                    description: rd.description,
                    help: rd.help,
                    helpUrl: rd.helpUrl,
                    tags: matchingRule.tags,
                    actIds: matchingRule.actIds
                };
            });
        }
        var get_rules_default = getRules;
        var aria_exports = {};
        __export(aria_exports, {
            allowedAttr: function allowedAttr() {
                return allowed_attr_default;
            },
            arialabelText: function arialabelText() {
                return _arialabelText;
            },
            arialabelledbyText: function arialabelledbyText() {
                return arialabelledby_text_default;
            },
            getAccessibleRefs: function getAccessibleRefs() {
                return get_accessible_refs_default;
            },
            getElementUnallowedRoles: function getElementUnallowedRoles() {
                return get_element_unallowed_roles_default;
            },
            getExplicitRole: function getExplicitRole() {
                return get_explicit_role_default;
            },
            getImplicitRole: function getImplicitRole() {
                return implicit_role_default;
            },
            getOwnedVirtual: function getOwnedVirtual() {
                return get_owned_virtual_default;
            },
            getRole: function getRole() {
                return get_role_default;
            },
            getRoleType: function getRoleType() {
                return get_role_type_default;
            },
            getRolesByType: function getRolesByType() {
                return get_roles_by_type_default;
            },
            getRolesWithNameFromContents: function getRolesWithNameFromContents() {
                return get_roles_with_name_from_contents_default;
            },
            implicitNodes: function implicitNodes() {
                return implicit_nodes_default;
            },
            implicitRole: function implicitRole() {
                return implicit_role_default;
            },
            isAccessibleRef: function isAccessibleRef() {
                return is_accessible_ref_default;
            },
            isAriaRoleAllowedOnElement: function isAriaRoleAllowedOnElement() {
                return is_aria_role_allowed_on_element_default;
            },
            isComboboxPopup: function isComboboxPopup() {
                return _isComboboxPopup;
            },
            isUnsupportedRole: function isUnsupportedRole() {
                return is_unsupported_role_default;
            },
            isValidRole: function isValidRole() {
                return is_valid_role_default;
            },
            label: function label() {
                return label_default2;
            },
            labelVirtual: function labelVirtual() {
                return label_virtual_default;
            },
            lookupTable: function lookupTable() {
                return lookup_table_default;
            },
            namedFromContents: function namedFromContents() {
                return named_from_contents_default;
            },
            requiredAttr: function requiredAttr() {
                return required_attr_default;
            },
            requiredContext: function requiredContext() {
                return required_context_default;
            },
            requiredOwned: function requiredOwned() {
                return required_owned_default;
            },
            validateAttr: function validateAttr() {
                return validate_attr_default;
            },
            validateAttrValue: function validateAttrValue() {
                return validate_attr_value_default;
            }
        });
        function allowedAttr(role) {
            var roleDef = standards_default.ariaRoles[role];
            var attrs = _toConsumableArray(get_global_aria_attrs_default());
            if (!roleDef) return attrs;
            if (roleDef.allowedAttrs) attrs.push.apply(attrs, _toConsumableArray(roleDef.allowedAttrs));
            if (roleDef.requiredAttrs) attrs.push.apply(attrs, _toConsumableArray(roleDef.requiredAttrs));
            return attrs;
        }
        var allowed_attr_default = allowedAttr;
        var idRefsRegex = /^idrefs?$/;
        function cacheIdRefs(node, idRefs, refAttrs) {
            if (node.hasAttribute) {
                if (node.nodeName.toUpperCase() === "LABEL" && node.hasAttribute("for")) {
                    var _id2 = node.getAttribute("for");
                    if (!idRefs.has(_id2)) idRefs.set(_id2, [
                        node
                    ]);
                    else idRefs.get(_id2).push(node);
                }
                for(var _i28 = 0; _i28 < refAttrs.length; ++_i28){
                    var attr = refAttrs[_i28];
                    var attrValue = sanitize_default(node.getAttribute(attr) || "");
                    if (!attrValue) continue;
                    var _iterator14 = _createForOfIteratorHelper(token_list_default(attrValue)), _step14;
                    try {
                        for(_iterator14.s(); !(_step14 = _iterator14.n()).done;){
                            var token = _step14.value;
                            if (!idRefs.has(token)) idRefs.set(token, [
                                node
                            ]);
                            else idRefs.get(token).push(node);
                        }
                    } catch (err) {
                        _iterator14.e(err);
                    } finally{
                        _iterator14.f();
                    }
                }
            }
            for(var _i29 = 0; _i29 < node.childNodes.length; _i29++)if (node.childNodes[_i29].nodeType === 1) cacheIdRefs(node.childNodes[_i29], idRefs, refAttrs);
        }
        function getAccessibleRefs(node) {
            var _idRefs$get;
            node = node.actualNode || node;
            var root = get_root_node_default2(node);
            root = root.documentElement || root;
            var idRefsByRoot = cache_default.get("idRefsByRoot", function() {
                return new Map();
            });
            var idRefs = idRefsByRoot.get(root);
            if (!idRefs) {
                idRefs = new Map();
                idRefsByRoot.set(root, idRefs);
                var refAttrs = Object.keys(standards_default.ariaAttrs).filter(function(attr) {
                    var type2 = standards_default.ariaAttrs[attr].type;
                    return idRefsRegex.test(type2);
                });
                cacheIdRefs(root, idRefs, refAttrs);
            }
            return (_idRefs$get = idRefs.get(node.id)) !== null && _idRefs$get !== void 0 ? _idRefs$get : [];
        }
        var get_accessible_refs_default = getAccessibleRefs;
        function isAriaRoleAllowedOnElement(node, role) {
            var vNode = node instanceof abstract_virtual_node_default ? node : get_node_from_tree_default(node);
            var implicitRole3 = implicit_role_default(vNode);
            var spec = get_element_spec_default(vNode);
            if (Array.isArray(spec.allowedRoles)) return spec.allowedRoles.includes(role);
            if (role === implicitRole3) return false;
            return !!spec.allowedRoles;
        }
        var is_aria_role_allowed_on_element_default = isAriaRoleAllowedOnElement;
        var dpubRoles2 = [
            "doc-backlink",
            "doc-biblioentry",
            "doc-biblioref",
            "doc-cover",
            "doc-endnote",
            "doc-glossref",
            "doc-noteref"
        ];
        var landmarkRoles = {
            header: "banner",
            footer: "contentinfo"
        };
        function getRoleSegments(vNode) {
            var roles = [];
            if (!vNode) return roles;
            if (vNode.hasAttr("role")) {
                var nodeRoles = token_list_default(vNode.attr("role").toLowerCase());
                roles = roles.concat(nodeRoles);
            }
            return roles.filter(function(role) {
                return is_valid_role_default(role);
            });
        }
        function getElementUnallowedRoles(node) {
            var allowImplicit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _nodeLookup21 = _nodeLookup(node), vNode = _nodeLookup21.vNode;
            if (!is_html_element_default(vNode)) return [];
            var nodeName2 = vNode.props.nodeName;
            var implicitRole3 = implicit_role_default(vNode) || landmarkRoles[nodeName2];
            var roleSegments = getRoleSegments(vNode);
            return roleSegments.filter(function(role) {
                return !roleIsAllowed(role, vNode, allowImplicit, implicitRole3);
            });
        }
        function roleIsAllowed(role, vNode, allowImplicit, implicitRole3) {
            if (allowImplicit && role === implicitRole3) return true;
            if (dpubRoles2.includes(role) && get_role_type_default(role) !== implicitRole3) return false;
            return is_aria_role_allowed_on_element_default(vNode, role);
        }
        var get_element_unallowed_roles_default = getElementUnallowedRoles;
        function getAriaRolesByType(type2) {
            return Object.keys(standards_default.ariaRoles).filter(function(roleName) {
                return standards_default.ariaRoles[roleName].type === type2;
            });
        }
        var get_aria_roles_by_type_default = getAriaRolesByType;
        function getRolesByType(roleType) {
            return get_aria_roles_by_type_default(roleType);
        }
        var get_roles_by_type_default = getRolesByType;
        function getAriaRolesSupportingNameFromContent() {
            return cache_default.get("ariaRolesNameFromContent", function() {
                return Object.keys(standards_default.ariaRoles).filter(function(roleName) {
                    return standards_default.ariaRoles[roleName].nameFromContent;
                });
            });
        }
        var get_aria_roles_supporting_name_from_content_default = getAriaRolesSupportingNameFromContent;
        function getRolesWithNameFromContents() {
            return get_aria_roles_supporting_name_from_content_default();
        }
        var get_roles_with_name_from_contents_default = getRolesWithNameFromContents;
        var isNull = function isNull(value) {
            return value === null;
        };
        var isNotNull = function isNotNull(value) {
            return value !== null;
        };
        var lookupTable = {};
        lookupTable.attributes = {
            "aria-activedescendant": {
                type: "idref",
                allowEmpty: true,
                unsupported: false
            },
            "aria-atomic": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-autocomplete": {
                type: "nmtoken",
                values: [
                    "inline",
                    "list",
                    "both",
                    "none"
                ],
                unsupported: false
            },
            "aria-busy": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-checked": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "mixed",
                    "undefined"
                ],
                unsupported: false
            },
            "aria-colcount": {
                type: "int",
                unsupported: false
            },
            "aria-colindex": {
                type: "int",
                unsupported: false
            },
            "aria-colspan": {
                type: "int",
                unsupported: false
            },
            "aria-controls": {
                type: "idrefs",
                allowEmpty: true,
                unsupported: false
            },
            "aria-current": {
                type: "nmtoken",
                allowEmpty: true,
                values: [
                    "page",
                    "step",
                    "location",
                    "date",
                    "time",
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-describedby": {
                type: "idrefs",
                allowEmpty: true,
                unsupported: false
            },
            "aria-describedat": {
                unsupported: true,
                unstandardized: true
            },
            "aria-details": {
                type: "idref",
                allowEmpty: true,
                unsupported: false
            },
            "aria-disabled": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-dropeffect": {
                type: "nmtokens",
                values: [
                    "copy",
                    "move",
                    "reference",
                    "execute",
                    "popup",
                    "none"
                ],
                unsupported: false
            },
            "aria-errormessage": {
                type: "idref",
                allowEmpty: true,
                unsupported: false
            },
            "aria-expanded": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "undefined"
                ],
                unsupported: false
            },
            "aria-flowto": {
                type: "idrefs",
                allowEmpty: true,
                unsupported: false
            },
            "aria-grabbed": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "undefined"
                ],
                unsupported: false
            },
            "aria-haspopup": {
                type: "nmtoken",
                allowEmpty: true,
                values: [
                    "true",
                    "false",
                    "menu",
                    "listbox",
                    "tree",
                    "grid",
                    "dialog"
                ],
                unsupported: false
            },
            "aria-hidden": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-invalid": {
                type: "nmtoken",
                allowEmpty: true,
                values: [
                    "true",
                    "false",
                    "spelling",
                    "grammar"
                ],
                unsupported: false
            },
            "aria-keyshortcuts": {
                type: "string",
                allowEmpty: true,
                unsupported: false
            },
            "aria-label": {
                type: "string",
                allowEmpty: true,
                unsupported: false
            },
            "aria-labelledby": {
                type: "idrefs",
                allowEmpty: true,
                unsupported: false
            },
            "aria-level": {
                type: "int",
                unsupported: false
            },
            "aria-live": {
                type: "nmtoken",
                values: [
                    "off",
                    "polite",
                    "assertive"
                ],
                unsupported: false
            },
            "aria-modal": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-multiline": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-multiselectable": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-orientation": {
                type: "nmtoken",
                values: [
                    "horizontal",
                    "vertical"
                ],
                unsupported: false
            },
            "aria-owns": {
                type: "idrefs",
                allowEmpty: true,
                unsupported: false
            },
            "aria-placeholder": {
                type: "string",
                allowEmpty: true,
                unsupported: false
            },
            "aria-posinset": {
                type: "int",
                unsupported: false
            },
            "aria-pressed": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "mixed",
                    "undefined"
                ],
                unsupported: false
            },
            "aria-readonly": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-relevant": {
                type: "nmtokens",
                values: [
                    "additions",
                    "removals",
                    "text",
                    "all"
                ],
                unsupported: false
            },
            "aria-required": {
                type: "boolean",
                values: [
                    "true",
                    "false"
                ],
                unsupported: false
            },
            "aria-roledescription": {
                type: "string",
                allowEmpty: true,
                unsupported: false
            },
            "aria-rowcount": {
                type: "int",
                unsupported: false
            },
            "aria-rowindex": {
                type: "int",
                unsupported: false
            },
            "aria-rowspan": {
                type: "int",
                unsupported: false
            },
            "aria-selected": {
                type: "nmtoken",
                values: [
                    "true",
                    "false",
                    "undefined"
                ],
                unsupported: false
            },
            "aria-setsize": {
                type: "int",
                unsupported: false
            },
            "aria-sort": {
                type: "nmtoken",
                values: [
                    "ascending",
                    "descending",
                    "other",
                    "none"
                ],
                unsupported: false
            },
            "aria-valuemax": {
                type: "decimal",
                unsupported: false
            },
            "aria-valuemin": {
                type: "decimal",
                unsupported: false
            },
            "aria-valuenow": {
                type: "decimal",
                unsupported: false
            },
            "aria-valuetext": {
                type: "string",
                unsupported: false
            }
        };
        lookupTable.globalAttributes = [
            "aria-atomic",
            "aria-busy",
            "aria-controls",
            "aria-current",
            "aria-describedby",
            "aria-details",
            "aria-disabled",
            "aria-dropeffect",
            "aria-flowto",
            "aria-grabbed",
            "aria-haspopup",
            "aria-hidden",
            "aria-invalid",
            "aria-keyshortcuts",
            "aria-label",
            "aria-labelledby",
            "aria-live",
            "aria-owns",
            "aria-relevant",
            "aria-roledescription"
        ];
        lookupTable.role = {
            alert: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            alertdialog: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-modal",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "dialog",
                    "section"
                ]
            },
            application: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage",
                        "aria-activedescendant"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "article",
                    "audio",
                    "embed",
                    "iframe",
                    "object",
                    "section",
                    "svg",
                    "video"
                ]
            },
            article: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "article"
                ],
                unsupported: false
            },
            banner: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "header"
                ],
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            button: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-pressed",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    "button",
                    'input[type="button"]',
                    'input[type="image"]',
                    'input[type="reset"]',
                    'input[type="submit"]',
                    "summary"
                ],
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            cell: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-colindex",
                        "aria-colspan",
                        "aria-rowindex",
                        "aria-rowspan",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "row"
                ],
                implicit: [
                    "td",
                    "th"
                ],
                unsupported: false
            },
            checkbox: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-checked",
                        "aria-required",
                        "aria-readonly",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    'input[type="checkbox"]'
                ],
                unsupported: false,
                allowedElements: [
                    "button"
                ]
            },
            columnheader: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-colindex",
                        "aria-colspan",
                        "aria-expanded",
                        "aria-rowindex",
                        "aria-rowspan",
                        "aria-required",
                        "aria-readonly",
                        "aria-selected",
                        "aria-sort",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "row"
                ],
                implicit: [
                    "th"
                ],
                unsupported: false
            },
            combobox: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-autocomplete",
                        "aria-required",
                        "aria-activedescendant",
                        "aria-orientation",
                        "aria-errormessage"
                    ],
                    required: [
                        "aria-expanded"
                    ]
                },
                owned: {
                    all: [
                        "listbox",
                        "tree",
                        "grid",
                        "dialog",
                        "textbox"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "text",
                                "search",
                                "tel",
                                "url",
                                "email"
                            ]
                        }
                    }
                ]
            },
            command: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            },
            complementary: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "aside"
                ],
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            composite: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            },
            contentinfo: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "footer"
                ],
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            definition: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "dd",
                    "dfn"
                ],
                unsupported: false
            },
            dialog: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-modal",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "dialog"
                ],
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            directory: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            document: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "body"
                ],
                unsupported: false,
                allowedElements: [
                    "article",
                    "embed",
                    "iframe",
                    "object",
                    "section",
                    "svg"
                ]
            },
            "doc-abstract": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-acknowledgments": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-afterword": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-appendix": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-backlink": {
                type: "link",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            "doc-biblioentry": {
                type: "listitem",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-level",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: [
                    "doc-bibliography"
                ],
                unsupported: false,
                allowedElements: [
                    "li"
                ]
            },
            "doc-bibliography": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "doc-biblioentry"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-biblioref": {
                type: "link",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            "doc-chapter": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-colophon": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-conclusion": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-cover": {
                type: "img",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false
            },
            "doc-credit": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-credits": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-dedication": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-endnote": {
                type: "listitem",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-level",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: [
                    "doc-endnotes"
                ],
                unsupported: false,
                allowedElements: [
                    "li"
                ]
            },
            "doc-endnotes": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "doc-endnote"
                    ]
                },
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-epigraph": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false
            },
            "doc-epilogue": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-errata": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-example": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "aside",
                    "section"
                ]
            },
            "doc-footnote": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "aside",
                    "footer",
                    "header"
                ]
            },
            "doc-foreword": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-glossary": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: [
                    "term",
                    "definition"
                ],
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "dl"
                ]
            },
            "doc-glossref": {
                type: "link",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            "doc-index": {
                type: "navigation",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "nav",
                    "section"
                ]
            },
            "doc-introduction": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-noteref": {
                type: "link",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            "doc-notice": {
                type: "note",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-pagebreak": {
                type: "separator",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "hr"
                ]
            },
            "doc-pagelist": {
                type: "navigation",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "nav",
                    "section"
                ]
            },
            "doc-part": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-preface": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-prologue": {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-pullquote": {
                type: "none",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "aside",
                    "section"
                ]
            },
            "doc-qna": {
                type: "section",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            "doc-subtitle": {
                type: "sectionhead",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: {
                    nodeName: [
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6"
                    ]
                }
            },
            "doc-tip": {
                type: "note",
                attributes: {
                    allowed: [
                        "aria-expanded"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "aside"
                ]
            },
            "doc-toc": {
                type: "navigation",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                namefrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "nav",
                    "section"
                ]
            },
            feed: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "article"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "article",
                    "aside",
                    "section"
                ]
            },
            figure: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    "figure"
                ],
                unsupported: false
            },
            form: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "form"
                ],
                unsupported: false
            },
            grid: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-colcount",
                        "aria-level",
                        "aria-multiselectable",
                        "aria-readonly",
                        "aria-rowcount",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "rowgroup",
                        "row"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "table"
                ],
                unsupported: false
            },
            gridcell: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-colindex",
                        "aria-colspan",
                        "aria-expanded",
                        "aria-rowindex",
                        "aria-rowspan",
                        "aria-selected",
                        "aria-readonly",
                        "aria-required",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "row"
                ],
                implicit: [
                    "td",
                    "th"
                ],
                unsupported: false
            },
            group: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "details",
                    "optgroup"
                ],
                unsupported: false,
                allowedElements: [
                    "dl",
                    "figcaption",
                    "fieldset",
                    "figure",
                    "footer",
                    "header",
                    "ol",
                    "ul"
                ]
            },
            heading: {
                type: "structure",
                attributes: {
                    required: [
                        "aria-level"
                    ],
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6"
                ],
                unsupported: false
            },
            img: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "img"
                ],
                unsupported: false,
                allowedElements: [
                    "embed",
                    "iframe",
                    "object",
                    "svg"
                ]
            },
            input: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            },
            landmark: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            },
            link: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    "a[href]",
                    "area[href]"
                ],
                unsupported: false,
                allowedElements: [
                    "button",
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "image",
                                "button"
                            ]
                        }
                    }
                ]
            },
            list: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    all: [
                        "listitem"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "ol",
                    "ul",
                    "dl"
                ],
                unsupported: false
            },
            listbox: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-multiselectable",
                        "aria-readonly",
                        "aria-required",
                        "aria-expanded",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    all: [
                        "option"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "select"
                ],
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            listitem: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-level",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "list"
                ],
                implicit: [
                    "li",
                    "dt"
                ],
                unsupported: false
            },
            log: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            main: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "main"
                ],
                unsupported: false,
                allowedElements: [
                    "article",
                    "section"
                ]
            },
            marquee: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            math: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "math"
                ],
                unsupported: false
            },
            menu: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "menuitem",
                        "menuitemradio",
                        "menuitemcheckbox"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    'menu[type="context"]'
                ],
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            menubar: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "menuitem",
                        "menuitemradio",
                        "menuitemcheckbox"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            menuitem: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-posinset",
                        "aria-setsize",
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "menu",
                    "menubar"
                ],
                implicit: [
                    'menuitem[type="command"]'
                ],
                unsupported: false,
                allowedElements: [
                    "button",
                    "li",
                    {
                        nodeName: "iput",
                        properties: {
                            type: [
                                "image",
                                "button"
                            ]
                        }
                    },
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            menuitemcheckbox: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-checked",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "menu",
                    "menubar"
                ],
                implicit: [
                    'menuitem[type="checkbox"]'
                ],
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "button",
                            "li"
                        ]
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "checkbox",
                                "image",
                                "button"
                            ]
                        }
                    },
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            menuitemradio: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-checked",
                        "aria-selected",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "menu",
                    "menubar"
                ],
                implicit: [
                    'menuitem[type="radio"]'
                ],
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "button",
                            "li"
                        ]
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "image",
                                "button",
                                "radio"
                            ]
                        }
                    },
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            navigation: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "nav"
                ],
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            none: {
                type: "structure",
                attributes: null,
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "article",
                            "aside",
                            "dl",
                            "embed",
                            "figcaption",
                            "fieldset",
                            "figure",
                            "footer",
                            "form",
                            "h1",
                            "h2",
                            "h3",
                            "h4",
                            "h5",
                            "h6",
                            "header",
                            "hr",
                            "iframe",
                            "li",
                            "ol",
                            "section",
                            "ul"
                        ]
                    },
                    {
                        nodeName: "img",
                        attributes: {
                            alt: isNotNull
                        }
                    }
                ]
            },
            note: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "aside"
                ]
            },
            option: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-selected",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-checked",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "listbox"
                ],
                implicit: [
                    "option"
                ],
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "button",
                            "li"
                        ]
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "checkbox",
                                "button"
                            ]
                        }
                    },
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            presentation: {
                type: "structure",
                attributes: null,
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "article",
                            "aside",
                            "dl",
                            "embed",
                            "figcaption",
                            "fieldset",
                            "figure",
                            "footer",
                            "form",
                            "h1",
                            "h2",
                            "h3",
                            "h4",
                            "h5",
                            "h6",
                            "header",
                            "hr",
                            "iframe",
                            "li",
                            "ol",
                            "section",
                            "ul"
                        ]
                    },
                    {
                        nodeName: "img",
                        attributes: {
                            alt: isNotNull
                        }
                    }
                ]
            },
            progressbar: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-valuetext",
                        "aria-valuenow",
                        "aria-valuemax",
                        "aria-valuemin",
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "progress"
                ],
                unsupported: false
            },
            radio: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-selected",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-required",
                        "aria-errormessage",
                        "aria-checked"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    'input[type="radio"]'
                ],
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "button",
                            "li"
                        ]
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "image",
                                "button"
                            ]
                        }
                    }
                ]
            },
            radiogroup: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-required",
                        "aria-expanded",
                        "aria-readonly",
                        "aria-errormessage",
                        "aria-orientation"
                    ]
                },
                owned: {
                    all: [
                        "radio"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: {
                    nodeName: [
                        "ol",
                        "ul",
                        "fieldset"
                    ]
                }
            },
            range: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            },
            region: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "section[aria-label]",
                    "section[aria-labelledby]",
                    "section[title]"
                ],
                unsupported: false,
                allowedElements: {
                    nodeName: [
                        "article",
                        "aside"
                    ]
                }
            },
            roletype: {
                type: "abstract",
                unsupported: false
            },
            row: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-colindex",
                        "aria-expanded",
                        "aria-level",
                        "aria-selected",
                        "aria-rowindex",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "cell",
                        "columnheader",
                        "rowheader",
                        "gridcell"
                    ]
                },
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "rowgroup",
                    "grid",
                    "treegrid",
                    "table"
                ],
                implicit: [
                    "tr"
                ],
                unsupported: false
            },
            rowgroup: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    all: [
                        "row"
                    ]
                },
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "grid",
                    "table",
                    "treegrid"
                ],
                implicit: [
                    "tbody",
                    "thead",
                    "tfoot"
                ],
                unsupported: false
            },
            rowheader: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-colindex",
                        "aria-colspan",
                        "aria-expanded",
                        "aria-rowindex",
                        "aria-rowspan",
                        "aria-required",
                        "aria-readonly",
                        "aria-selected",
                        "aria-sort",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "row"
                ],
                implicit: [
                    "th"
                ],
                unsupported: false
            },
            scrollbar: {
                type: "widget",
                attributes: {
                    required: [
                        "aria-controls",
                        "aria-valuenow"
                    ],
                    allowed: [
                        "aria-valuetext",
                        "aria-orientation",
                        "aria-errormessage",
                        "aria-valuemax",
                        "aria-valuemin"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false
            },
            search: {
                type: "landmark",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: {
                    nodeName: [
                        "aside",
                        "form",
                        "section"
                    ]
                }
            },
            searchbox: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-autocomplete",
                        "aria-multiline",
                        "aria-readonly",
                        "aria-required",
                        "aria-placeholder",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    'input[type="search"]'
                ],
                unsupported: false,
                allowedElements: {
                    nodeName: "input",
                    properties: {
                        type: "text"
                    }
                }
            },
            section: {
                nameFrom: [
                    "author",
                    "contents"
                ],
                type: "abstract",
                unsupported: false
            },
            sectionhead: {
                nameFrom: [
                    "author",
                    "contents"
                ],
                type: "abstract",
                unsupported: false
            },
            select: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            },
            separator: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-orientation",
                        "aria-valuenow",
                        "aria-valuemax",
                        "aria-valuemin",
                        "aria-valuetext",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "hr"
                ],
                unsupported: false,
                allowedElements: [
                    "li"
                ]
            },
            slider: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-valuetext",
                        "aria-orientation",
                        "aria-readonly",
                        "aria-errormessage",
                        "aria-valuemax",
                        "aria-valuemin"
                    ],
                    required: [
                        "aria-valuenow"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    'input[type="range"]'
                ],
                unsupported: false
            },
            spinbutton: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-valuetext",
                        "aria-required",
                        "aria-readonly",
                        "aria-errormessage",
                        "aria-valuemax",
                        "aria-valuemin"
                    ],
                    required: [
                        "aria-valuenow"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    'input[type="number"]'
                ],
                unsupported: false,
                allowedElements: {
                    nodeName: "input",
                    properties: {
                        type: [
                            "text",
                            "tel"
                        ]
                    }
                }
            },
            status: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    "output"
                ],
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            structure: {
                type: "abstract",
                unsupported: false
            },
            switch: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-errormessage"
                    ],
                    required: [
                        "aria-checked"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "button",
                    {
                        nodeName: "input",
                        properties: {
                            type: [
                                "checkbox",
                                "image",
                                "button"
                            ]
                        }
                    },
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            tab: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-selected",
                        "aria-expanded",
                        "aria-setsize",
                        "aria-posinset",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "tablist"
                ],
                unsupported: false,
                allowedElements: [
                    {
                        nodeName: [
                            "button",
                            "h1",
                            "h2",
                            "h3",
                            "h4",
                            "h5",
                            "h6",
                            "li"
                        ]
                    },
                    {
                        nodeName: "input",
                        properties: {
                            type: "button"
                        }
                    },
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            table: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-colcount",
                        "aria-rowcount",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "rowgroup",
                        "row"
                    ]
                },
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    "table"
                ],
                unsupported: false
            },
            tablist: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-level",
                        "aria-multiselectable",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    all: [
                        "tab"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            tabpanel: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "section"
                ]
            },
            term: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                implicit: [
                    "dt"
                ],
                unsupported: false
            },
            textbox: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-autocomplete",
                        "aria-multiline",
                        "aria-readonly",
                        "aria-required",
                        "aria-placeholder",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    'input[type="text"]',
                    'input[type="email"]',
                    'input[type="password"]',
                    'input[type="tel"]',
                    'input[type="url"]',
                    "input:not([type])",
                    "textarea"
                ],
                unsupported: false
            },
            timer: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false
            },
            toolbar: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-expanded",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author"
                ],
                context: null,
                implicit: [
                    'menu[type="toolbar"]'
                ],
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            tooltip: {
                type: "structure",
                attributes: {
                    allowed: [
                        "aria-expanded",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: null,
                unsupported: false
            },
            tree: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-multiselectable",
                        "aria-required",
                        "aria-expanded",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    all: [
                        "treeitem"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false,
                allowedElements: [
                    "ol",
                    "ul"
                ]
            },
            treegrid: {
                type: "composite",
                attributes: {
                    allowed: [
                        "aria-activedescendant",
                        "aria-colcount",
                        "aria-expanded",
                        "aria-level",
                        "aria-multiselectable",
                        "aria-readonly",
                        "aria-required",
                        "aria-rowcount",
                        "aria-orientation",
                        "aria-errormessage"
                    ]
                },
                owned: {
                    one: [
                        "rowgroup",
                        "row"
                    ]
                },
                nameFrom: [
                    "author"
                ],
                context: null,
                unsupported: false
            },
            treeitem: {
                type: "widget",
                attributes: {
                    allowed: [
                        "aria-checked",
                        "aria-selected",
                        "aria-expanded",
                        "aria-level",
                        "aria-posinset",
                        "aria-setsize",
                        "aria-errormessage"
                    ]
                },
                owned: null,
                nameFrom: [
                    "author",
                    "contents"
                ],
                context: [
                    "group",
                    "tree"
                ],
                unsupported: false,
                allowedElements: [
                    "li",
                    {
                        nodeName: "a",
                        attributes: {
                            href: isNotNull
                        }
                    }
                ]
            },
            widget: {
                type: "abstract",
                unsupported: false
            },
            window: {
                nameFrom: [
                    "author"
                ],
                type: "abstract",
                unsupported: false
            }
        };
        lookupTable.implicitHtmlRole = implicit_html_roles_default;
        lookupTable.elementsAllowedNoRole = [
            {
                nodeName: [
                    "base",
                    "body",
                    "caption",
                    "col",
                    "colgroup",
                    "datalist",
                    "dd",
                    "details",
                    "dt",
                    "head",
                    "html",
                    "keygen",
                    "label",
                    "legend",
                    "main",
                    "map",
                    "math",
                    "meta",
                    "meter",
                    "noscript",
                    "optgroup",
                    "param",
                    "picture",
                    "progress",
                    "script",
                    "source",
                    "style",
                    "template",
                    "textarea",
                    "title",
                    "track"
                ]
            },
            {
                nodeName: "area",
                attributes: {
                    href: isNotNull
                }
            },
            {
                nodeName: "input",
                properties: {
                    type: [
                        "color",
                        "data",
                        "datatime",
                        "file",
                        "hidden",
                        "month",
                        "number",
                        "password",
                        "range",
                        "reset",
                        "submit",
                        "time",
                        "week"
                    ]
                }
            },
            {
                nodeName: "link",
                attributes: {
                    href: isNotNull
                }
            },
            {
                nodeName: "menu",
                attributes: {
                    type: "context"
                }
            },
            {
                nodeName: "menuitem",
                attributes: {
                    type: [
                        "command",
                        "checkbox",
                        "radio"
                    ]
                }
            },
            {
                nodeName: "select",
                condition: function condition(vNode) {
                    if (!(vNode instanceof axe.AbstractVirtualNode)) vNode = axe.utils.getNodeFromTree(vNode);
                    return Number(vNode.attr("size")) > 1;
                },
                properties: {
                    multiple: true
                }
            },
            {
                nodeName: [
                    "clippath",
                    "cursor",
                    "defs",
                    "desc",
                    "feblend",
                    "fecolormatrix",
                    "fecomponenttransfer",
                    "fecomposite",
                    "feconvolvematrix",
                    "fediffuselighting",
                    "fedisplacementmap",
                    "fedistantlight",
                    "fedropshadow",
                    "feflood",
                    "fefunca",
                    "fefuncb",
                    "fefuncg",
                    "fefuncr",
                    "fegaussianblur",
                    "feimage",
                    "femerge",
                    "femergenode",
                    "femorphology",
                    "feoffset",
                    "fepointlight",
                    "fespecularlighting",
                    "fespotlight",
                    "fetile",
                    "feturbulence",
                    "filter",
                    "hatch",
                    "hatchpath",
                    "lineargradient",
                    "marker",
                    "mask",
                    "meshgradient",
                    "meshpatch",
                    "meshrow",
                    "metadata",
                    "mpath",
                    "pattern",
                    "radialgradient",
                    "solidcolor",
                    "stop",
                    "switch",
                    "view"
                ]
            }
        ];
        lookupTable.elementsAllowedAnyRole = [
            {
                nodeName: "a",
                attributes: {
                    href: isNull
                }
            },
            {
                nodeName: "img",
                attributes: {
                    alt: isNull
                }
            },
            {
                nodeName: [
                    "abbr",
                    "address",
                    "canvas",
                    "div",
                    "p",
                    "pre",
                    "blockquote",
                    "ins",
                    "del",
                    "output",
                    "span",
                    "table",
                    "tbody",
                    "thead",
                    "tfoot",
                    "td",
                    "em",
                    "strong",
                    "small",
                    "s",
                    "cite",
                    "q",
                    "dfn",
                    "abbr",
                    "time",
                    "code",
                    "var",
                    "samp",
                    "kbd",
                    "sub",
                    "sup",
                    "i",
                    "b",
                    "u",
                    "mark",
                    "ruby",
                    "rt",
                    "rp",
                    "bdi",
                    "bdo",
                    "br",
                    "wbr",
                    "th",
                    "tr"
                ]
            }
        ];
        lookupTable.evaluateRoleForElement = {
            A: function A(_ref84) {
                var node = _ref84.node, out = _ref84.out;
                if (node.namespaceURI === "http://www.w3.org/2000/svg") return true;
                if (node.href.length) return out;
                return true;
            },
            AREA: function AREA(_ref85) {
                var node = _ref85.node;
                return !node.href;
            },
            BUTTON: function BUTTON(_ref86) {
                var node = _ref86.node, role = _ref86.role, out = _ref86.out;
                if (node.getAttribute("type") === "menu") return role === "menuitem";
                return out;
            },
            IMG: function IMG(_ref87) {
                var node = _ref87.node, role = _ref87.role, out = _ref87.out;
                switch(node.alt){
                    case null:
                        return out;
                    case "":
                        return role === "presentation" || role === "none";
                    default:
                        return role !== "presentation" && role !== "none";
                }
            },
            INPUT: function INPUT(_ref88) {
                var node = _ref88.node, role = _ref88.role, out = _ref88.out;
                switch(node.type){
                    case "button":
                    case "image":
                        return out;
                    case "checkbox":
                        if (role === "button" && node.hasAttribute("aria-pressed")) return true;
                        return out;
                    case "radio":
                        return role === "menuitemradio";
                    case "text":
                        return role === "combobox" || role === "searchbox" || role === "spinbutton";
                    case "tel":
                        return role === "combobox" || role === "spinbutton";
                    case "url":
                    case "search":
                    case "email":
                        return role === "combobox";
                    default:
                        return false;
                }
            },
            LI: function LI(_ref89) {
                var node = _ref89.node, out = _ref89.out;
                var hasImplicitListitemRole = axe.utils.matchesSelector(node, "ol li, ul li");
                if (hasImplicitListitemRole) return out;
                return true;
            },
            MENU: function MENU(_ref90) {
                var node = _ref90.node;
                if (node.getAttribute("type") === "context") return false;
                return true;
            },
            OPTION: function OPTION(_ref91) {
                var node = _ref91.node;
                var withinOptionList = axe.utils.matchesSelector(node, "select > option, datalist > option, optgroup > option");
                return !withinOptionList;
            },
            SELECT: function SELECT(_ref92) {
                var node = _ref92.node, role = _ref92.role;
                return !node.multiple && node.size <= 1 && role === "menu";
            },
            SVG: function SVG(_ref93) {
                var node = _ref93.node, out = _ref93.out;
                if (node.parentNode && node.parentNode.namespaceURI === "http://www.w3.org/2000/svg") return true;
                return out;
            }
        };
        lookupTable.rolesOfType = {
            widget: [
                "button",
                "checkbox",
                "dialog",
                "gridcell",
                "link",
                "log",
                "marquee",
                "menuitem",
                "menuitemcheckbox",
                "menuitemradio",
                "option",
                "progressbar",
                "radio",
                "scrollbar",
                "searchbox",
                "slider",
                "spinbutton",
                "status",
                "switch",
                "tab",
                "tabpanel",
                "textbox",
                "timer",
                "tooltip",
                "tree",
                "treeitem"
            ]
        };
        var lookup_table_default = lookupTable;
        function implicitNodes(role) {
            var implicit = null;
            var roles = lookup_table_default.role[role];
            if (roles && roles.implicit) implicit = _clone(roles.implicit);
            return implicit;
        }
        var implicit_nodes_default = implicitNodes;
        function isAccessibleRef(node) {
            return !!get_accessible_refs_default(node).length;
        }
        var is_accessible_ref_default = isAccessibleRef;
        function _isComboboxPopup(virtualNode) {
            var _popupRoles;
            var _ref94 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, popupRoles = _ref94.popupRoles;
            var role = get_role_default(virtualNode);
            (_popupRoles = popupRoles) !== null && _popupRoles !== void 0 ? _popupRoles : popupRoles = aria_attrs_default["aria-haspopup"].values;
            if (!popupRoles.includes(role)) return false;
            var vParent = nearestParentWithRole(virtualNode);
            if (isCombobox(vParent)) return true;
            var id = virtualNode.props.id;
            if (!id) return false;
            if (!virtualNode.actualNode) throw new Error("Unable to determine combobox popup without an actualNode");
            var root = get_root_node_default(virtualNode.actualNode);
            var ownedCombobox = root.querySelectorAll('[aria-owns~="'.concat(id, '"][role~="combobox"]:not(select),\n     [aria-controls~="').concat(id, '"][role~="combobox"]:not(select)'));
            return Array.from(ownedCombobox).some(isCombobox);
        }
        var isCombobox = function isCombobox(node) {
            return node && get_role_default(node) === "combobox";
        };
        function nearestParentWithRole(vNode) {
            while(vNode = vNode.parent){
                if (get_role_default(vNode, {
                    noPresentational: true
                }) !== null) return vNode;
            }
            return null;
        }
        function label2(node) {
            node = get_node_from_tree_default(node);
            return label_virtual_default(node);
        }
        var label_default2 = label2;
        function requiredAttr(role) {
            var roleDef = standards_default.ariaRoles[role];
            if (!roleDef || !Array.isArray(roleDef.requiredAttrs)) return [];
            return _toConsumableArray(roleDef.requiredAttrs);
        }
        var required_attr_default = requiredAttr;
        function requiredContext(role) {
            var roleDef = standards_default.ariaRoles[role];
            if (!roleDef || !Array.isArray(roleDef.requiredContext)) return null;
            return _toConsumableArray(roleDef.requiredContext);
        }
        var required_context_default = requiredContext;
        function requiredOwned(role) {
            var roleDef = standards_default.ariaRoles[role];
            if (!roleDef || !Array.isArray(roleDef.requiredOwned)) return null;
            return _toConsumableArray(roleDef.requiredOwned);
        }
        var required_owned_default = requiredOwned;
        function validateAttrValue(vNode, attr) {
            vNode = vNode instanceof abstract_virtual_node_default ? vNode : get_node_from_tree_default(vNode);
            var matches4;
            var list;
            var value = vNode.attr(attr);
            var attrInfo = standards_default.ariaAttrs[attr];
            if (!attrInfo) return true;
            if (attrInfo.allowEmpty && (!value || value.trim() === "")) return true;
            switch(attrInfo.type){
                case "boolean":
                    return [
                        "true",
                        "false"
                    ].includes(value.toLowerCase());
                case "nmtoken":
                    return typeof value === "string" && attrInfo.values.includes(value.toLowerCase());
                case "nmtokens":
                    list = token_list_default(value);
                    return list.reduce(function(result, token) {
                        return result && attrInfo.values.includes(token);
                    }, list.length !== 0);
                case "idref":
                    try {
                        var doc = get_root_node_default2(vNode.actualNode);
                        return !!(value && doc.getElementById(value));
                    } catch (e) {
                        throw new TypeError("Cannot resolve id references for partial DOM");
                    }
                case "idrefs":
                    return idrefs_default(vNode, attr).some(function(node) {
                        return !!node;
                    });
                case "string":
                    return value.trim() !== "";
                case "decimal":
                    matches4 = value.match(/^[-+]?([0-9]*)\.?([0-9]*)$/);
                    return !!(matches4 && (matches4[1] || matches4[2]));
                case "int":
                    var minValue = typeof attrInfo.minValue !== "undefined" ? attrInfo.minValue : -Infinity;
                    return /^[-+]?[0-9]+$/.test(value) && parseInt(value) >= minValue;
            }
        }
        var validate_attr_value_default = validateAttrValue;
        function validateAttr(att) {
            var attrDefinition = standards_default.ariaAttrs[att];
            return !!attrDefinition;
        }
        var validate_attr_default = validateAttr;
        function abstractroleEvaluate(node, options, virtualNode) {
            var abstractRoles = token_list_default(virtualNode.attr("role")).filter(function(role) {
                return get_role_type_default(role) === "abstract";
            });
            if (abstractRoles.length > 0) {
                this.data(abstractRoles);
                return true;
            }
            return false;
        }
        var abstractrole_evaluate_default = abstractroleEvaluate;
        function ariaAllowedAttrEvaluate(node, options, virtualNode) {
            var invalid = [];
            var role = get_role_default(virtualNode);
            var allowed = allowed_attr_default(role);
            if (Array.isArray(options[role])) allowed = unique_array_default(options[role].concat(allowed));
            var _iterator15 = _createForOfIteratorHelper(virtualNode.attrNames), _step15;
            try {
                for(_iterator15.s(); !(_step15 = _iterator15.n()).done;){
                    var attrName = _step15.value;
                    if (validate_attr_default(attrName) && !allowed.includes(attrName)) invalid.push(attrName);
                }
            } catch (err) {
                _iterator15.e(err);
            } finally{
                _iterator15.f();
            }
            if (!invalid.length) return true;
            this.data(invalid.map(function(attrName) {
                return attrName + '="' + virtualNode.attr(attrName) + '"';
            }));
            if (!role && !is_html_element_default(virtualNode) && !_isFocusable(virtualNode)) return void 0;
            return false;
        }
        function ariaAllowedRoleEvaluate(node) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var virtualNode = arguments.length > 2 ? arguments[2] : undefined;
            var _options$allowImplici = options.allowImplicit, allowImplicit = _options$allowImplici === void 0 ? true : _options$allowImplici, _options$ignoredTags = options.ignoredTags, ignoredTags = _options$ignoredTags === void 0 ? [] : _options$ignoredTags;
            var nodeName2 = virtualNode.props.nodeName;
            if (ignoredTags.map(function(tag) {
                return tag.toLowerCase();
            }).includes(nodeName2)) return true;
            var unallowedRoles = get_element_unallowed_roles_default(virtualNode, allowImplicit);
            if (unallowedRoles.length) {
                this.data(unallowedRoles);
                if (!_isVisibleToScreenReaders(virtualNode)) return void 0;
                return false;
            }
            return true;
        }
        var aria_allowed_role_evaluate_default = ariaAllowedRoleEvaluate;
        function ariaBusyEvaluate(node, options, virtualNode) {
            return virtualNode.attr("aria-busy") === "true";
        }
        function ariaConditionalCheckboxAttr(node, options, virtualNode) {
            var _virtualNode$props = virtualNode.props, nodeName2 = _virtualNode$props.nodeName, type2 = _virtualNode$props.type;
            var ariaChecked = normalizeAriaChecked(virtualNode.attr("aria-checked"));
            if (nodeName2 !== "input" || type2 !== "checkbox" || !ariaChecked) return true;
            var checkState = getCheckState(virtualNode);
            if (ariaChecked === checkState) return true;
            this.data({
                messageKey: "checkbox",
                checkState: checkState
            });
            return false;
        }
        function getCheckState(vNode) {
            if (vNode.props.indeterminate) return "mixed";
            return vNode.props.checked ? "true" : "false";
        }
        function normalizeAriaChecked(ariaCheckedVal) {
            if (!ariaCheckedVal) return "";
            ariaCheckedVal = ariaCheckedVal.toLowerCase();
            if ([
                "mixed",
                "true"
            ].includes(ariaCheckedVal)) return ariaCheckedVal;
            return "false";
        }
        function ariaConditionalRowAttr(node) {
            var _invalidTableRowAttrs, _invalidTableRowAttrs2;
            var _ref95 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, invalidTableRowAttrs = _ref95.invalidTableRowAttrs;
            var virtualNode = arguments.length > 2 ? arguments[2] : undefined;
            var invalidAttrs = (_invalidTableRowAttrs = invalidTableRowAttrs === null || invalidTableRowAttrs === void 0 ? void 0 : (_invalidTableRowAttrs2 = invalidTableRowAttrs.filter) === null || _invalidTableRowAttrs2 === void 0 ? void 0 : _invalidTableRowAttrs2.call(invalidTableRowAttrs, function(invalidAttr) {
                return virtualNode.hasAttr(invalidAttr);
            })) !== null && _invalidTableRowAttrs !== void 0 ? _invalidTableRowAttrs : [];
            if (invalidAttrs.length === 0) return true;
            var owner = getRowOwner(virtualNode);
            var ownerRole = owner && get_role_default(owner);
            if (!ownerRole || ownerRole === "treegrid") return true;
            var messageKey = "row".concat(invalidAttrs.length > 1 ? "Plural" : "Singular");
            this.data({
                messageKey: messageKey,
                invalidAttrs: invalidAttrs,
                ownerRole: ownerRole
            });
            return false;
        }
        function getRowOwner(virtualNode) {
            if (!virtualNode.parent) return;
            var rowOwnerQuery = 'table:not([role]), [role~="treegrid"], [role~="table"], [role~="grid"]';
            return closest_default(virtualNode, rowOwnerQuery);
        }
        var conditionalRoleMap = {
            row: ariaConditionalRowAttr,
            checkbox: ariaConditionalCheckboxAttr
        };
        function ariaConditionalAttrEvaluate(node, options, virtualNode) {
            var role = get_role_default(virtualNode);
            if (!conditionalRoleMap[role]) return true;
            return conditionalRoleMap[role].call(this, node, options, virtualNode);
        }
        function ariaErrormessageEvaluate(node, options, virtualNode) {
            options = Array.isArray(options) ? options : [];
            var errorMessageAttr = virtualNode.attr("aria-errormessage");
            var hasAttr = virtualNode.hasAttr("aria-errormessage");
            var invaid = virtualNode.attr("aria-invalid");
            var hasInvallid = virtualNode.hasAttr("aria-invalid");
            if (!hasInvallid || invaid === "false") return true;
            function validateAttrValue2(attr) {
                if (attr.trim() === "") return standards_default.ariaAttrs["aria-errormessage"].allowEmpty;
                var idref;
                try {
                    idref = attr && idrefs_default(virtualNode, "aria-errormessage")[0];
                } catch (e) {
                    this.data({
                        messageKey: "idrefs",
                        values: token_list_default(attr)
                    });
                    return void 0;
                }
                if (idref) {
                    if (!_isVisibleToScreenReaders(idref)) {
                        this.data({
                            messageKey: "hidden",
                            values: token_list_default(attr)
                        });
                        return false;
                    }
                    return idref.getAttribute("role") === "alert" || idref.getAttribute("aria-live") === "assertive" || idref.getAttribute("aria-live") === "polite" || token_list_default(virtualNode.attr("aria-describedby")).indexOf(attr) > -1;
                }
                return;
            }
            if (options.indexOf(errorMessageAttr) === -1 && hasAttr) {
                this.data(token_list_default(errorMessageAttr));
                return validateAttrValue2.call(this, errorMessageAttr);
            }
            return true;
        }
        function ariaHiddenBodyEvaluate(node, options, virtualNode) {
            return virtualNode.attr("aria-hidden") !== "true";
        }
        var aria_hidden_body_evaluate_default = ariaHiddenBodyEvaluate;
        function ariaLevelEvaluate(node, options, virtualNode) {
            var ariaHeadingLevel = virtualNode.attr("aria-level");
            var ariaLevel = parseInt(ariaHeadingLevel, 10);
            if (ariaLevel > 6) return void 0;
            return true;
        }
        var aria_level_evaluate_default = ariaLevelEvaluate;
        function ariaProhibitedAttrEvaluate(node) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var virtualNode = arguments.length > 2 ? arguments[2] : undefined;
            var elementsAllowedAriaLabel = (options === null || options === void 0 ? void 0 : options.elementsAllowedAriaLabel) || [];
            var nodeName2 = virtualNode.props.nodeName;
            var role = get_role_default(virtualNode, {
                chromium: true
            });
            var prohibitedList = listProhibitedAttrs(role, nodeName2, elementsAllowedAriaLabel);
            var prohibited = prohibitedList.filter(function(attrName) {
                if (!virtualNode.attrNames.includes(attrName)) return false;
                return sanitize_default(virtualNode.attr(attrName)) !== "";
            });
            if (prohibited.length === 0) return false;
            var messageKey = virtualNode.hasAttr("role") ? "hasRole" : "noRole";
            messageKey += prohibited.length > 1 ? "Plural" : "Singular";
            this.data({
                role: role,
                nodeName: nodeName2,
                messageKey: messageKey,
                prohibited: prohibited
            });
            var textContent = subtree_text_default(virtualNode, {
                subtreeDescendant: true
            });
            if (sanitize_default(textContent) !== "") return void 0;
            return true;
        }
        function listProhibitedAttrs(role, nodeName2, elementsAllowedAriaLabel) {
            var roleSpec = standards_default.ariaRoles[role];
            if (roleSpec) return roleSpec.prohibitedAttrs || [];
            if (!!role || elementsAllowedAriaLabel.includes(nodeName2)) return [];
            return [
                "aria-label",
                "aria-labelledby"
            ];
        }
        var standards_exports = {};
        __export(standards_exports, {
            getAriaRolesByType: function getAriaRolesByType() {
                return get_aria_roles_by_type_default;
            },
            getAriaRolesSupportingNameFromContent: function getAriaRolesSupportingNameFromContent() {
                return get_aria_roles_supporting_name_from_content_default;
            },
            getElementSpec: function getElementSpec() {
                return get_element_spec_default;
            },
            getElementsByContentType: function getElementsByContentType() {
                return get_elements_by_content_type_default;
            },
            getGlobalAriaAttrs: function getGlobalAriaAttrs() {
                return get_global_aria_attrs_default;
            },
            implicitHtmlRoles: function implicitHtmlRoles() {
                return implicit_html_roles_default;
            }
        });
        function ariaRequiredAttrEvaluate(node) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var virtualNode = arguments.length > 2 ? arguments[2] : undefined;
            var role = get_explicit_role_default(virtualNode);
            var attrs = virtualNode.attrNames;
            var requiredAttrs = required_attr_default(role);
            if (Array.isArray(options[role])) requiredAttrs = unique_array_default(options[role], requiredAttrs);
            if (!role || !attrs.length || !requiredAttrs.length) return true;
            if (isStaticSeparator(virtualNode, role) || isClosedCombobox(virtualNode, role)) return true;
            var elmSpec = get_element_spec_default(virtualNode);
            var missingAttrs = requiredAttrs.filter(function(requiredAttr2) {
                return !virtualNode.attr(requiredAttr2) && !hasImplicitAttr(elmSpec, requiredAttr2);
            });
            if (missingAttrs.length) {
                this.data(missingAttrs);
                return false;
            }
            return true;
        }
        function isStaticSeparator(vNode, role) {
            return role === "separator" && !_isFocusable(vNode);
        }
        function hasImplicitAttr(elmSpec, attr) {
            var _elmSpec$implicitAttr;
            return ((_elmSpec$implicitAttr = elmSpec.implicitAttrs) === null || _elmSpec$implicitAttr === void 0 ? void 0 : _elmSpec$implicitAttr[attr]) !== void 0;
        }
        function isClosedCombobox(vNode, role) {
            return role === "combobox" && vNode.attr("aria-expanded") === "false";
        }
        function ariaRequiredChildrenEvaluate(node, options, virtualNode) {
            var reviewEmpty = options && Array.isArray(options.reviewEmpty) ? options.reviewEmpty : [];
            var explicitRole2 = get_explicit_role_default(virtualNode, {
                dpub: true
            });
            var required = required_owned_default(explicitRole2);
            if (required === null) return true;
            var ownedRoles = getOwnedRoles(virtualNode, required);
            var unallowed = ownedRoles.filter(function(_ref96) {
                var role = _ref96.role, vNode = _ref96.vNode;
                return vNode.props.nodeType === 1 && !required.includes(role);
            });
            if (unallowed.length) {
                this.relatedNodes(unallowed.map(function(_ref97) {
                    var vNode = _ref97.vNode;
                    return vNode;
                }));
                this.data({
                    messageKey: "unallowed",
                    values: unallowed.map(function(_ref98) {
                        var vNode = _ref98.vNode, attr = _ref98.attr;
                        return getUnallowedSelector(vNode, attr);
                    }).filter(function(selector, index, array) {
                        return array.indexOf(selector) === index;
                    }).join(", ")
                });
                return false;
            }
            if (hasRequiredChildren(required, ownedRoles)) return true;
            this.data(required);
            if (reviewEmpty.includes(explicitRole2) && !ownedRoles.some(isContent)) return void 0;
            return false;
        }
        function getOwnedRoles(virtualNode, required) {
            var vNode;
            var ownedRoles = [];
            var ownedVirtual = get_owned_virtual_default(virtualNode);
            var _loop7 = function _loop7() {
                if (vNode.props.nodeType === 3) ownedRoles.push({
                    vNode: vNode,
                    role: null
                });
                if (vNode.props.nodeType !== 1 || !_isVisibleToScreenReaders(vNode)) return "continue";
                var role = get_role_default(vNode, {
                    noPresentational: true
                });
                var globalAriaAttr = getGlobalAriaAttr(vNode);
                var hasGlobalAriaOrFocusable = !!globalAriaAttr || _isFocusable(vNode);
                if (!role && !hasGlobalAriaOrFocusable || [
                    "group",
                    "rowgroup"
                ].includes(role) && required.some(function(requiredRole) {
                    return requiredRole === role;
                })) ownedVirtual.push.apply(ownedVirtual, _toConsumableArray(vNode.children));
                else if (role || hasGlobalAriaOrFocusable) {
                    var attr = globalAriaAttr || "tabindex";
                    ownedRoles.push({
                        role: role,
                        attr: attr,
                        vNode: vNode
                    });
                }
            };
            while(vNode = ownedVirtual.shift()){
                var _ret5 = _loop7();
                if (_ret5 === "continue") continue;
            }
            return ownedRoles;
        }
        function hasRequiredChildren(required, ownedRoles) {
            return ownedRoles.some(function(_ref99) {
                var role = _ref99.role;
                return role && required.includes(role);
            });
        }
        function getGlobalAriaAttr(vNode) {
            return get_global_aria_attrs_default().find(function(attr) {
                return vNode.hasAttr(attr);
            });
        }
        function getUnallowedSelector(vNode, attr) {
            var _vNode$props = vNode.props, nodeName2 = _vNode$props.nodeName, nodeType = _vNode$props.nodeType;
            if (nodeType === 3) return "#text";
            var role = get_explicit_role_default(vNode, {
                dpub: true
            });
            if (role) return "[role=".concat(role, "]");
            if (attr) return nodeName2 + "[".concat(attr, "]");
            return nodeName2;
        }
        function isContent(_ref100) {
            var vNode = _ref100.vNode;
            if (vNode.props.nodeType === 3) return vNode.props.nodeValue.trim().length > 0;
            return has_content_virtual_default(vNode, false, true);
        }
        function getMissingContext(virtualNode, ownGroupRoles, reqContext, includeElement) {
            var explicitRole2 = get_explicit_role_default(virtualNode);
            if (!reqContext) reqContext = required_context_default(explicitRole2);
            if (!reqContext) return null;
            var allowsGroup = reqContext.includes("group");
            var vNode = includeElement ? virtualNode : virtualNode.parent;
            while(vNode){
                var role = get_role_default(vNode, {
                    noPresentational: true
                });
                if (!role) vNode = vNode.parent;
                else if (role === "group" && allowsGroup) {
                    if (ownGroupRoles.includes(explicitRole2)) reqContext.push(explicitRole2);
                    reqContext = reqContext.filter(function(r) {
                        return r !== "group";
                    });
                    vNode = vNode.parent;
                } else if (reqContext.includes(role)) return null;
                else return reqContext;
            }
            return reqContext;
        }
        function getAriaOwners(element) {
            var owners = [], o = null;
            while(element){
                if (element.getAttribute("id")) {
                    var _id3 = escape_selector_default(element.getAttribute("id"));
                    var doc = get_root_node_default2(element);
                    o = doc.querySelector("[aria-owns~=".concat(_id3, "]"));
                    if (o) owners.push(o);
                }
                element = element.parentElement;
            }
            return owners.length ? owners : null;
        }
        function ariaRequiredParentEvaluate(node, options, virtualNode) {
            var ownGroupRoles = options && Array.isArray(options.ownGroupRoles) ? options.ownGroupRoles : [];
            var missingParents = getMissingContext(virtualNode, ownGroupRoles);
            if (!missingParents) return true;
            var owners = getAriaOwners(node);
            if (owners) for(var _i30 = 0, l = owners.length; _i30 < l; _i30++){
                missingParents = getMissingContext(get_node_from_tree_default(owners[_i30]), ownGroupRoles, missingParents, true);
                if (!missingParents) return true;
            }
            this.data(missingParents);
            return false;
        }
        var aria_required_parent_evaluate_default = ariaRequiredParentEvaluate;
        function ariaRoledescriptionEvaluate(node) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var virtualNode = arguments.length > 2 ? arguments[2] : undefined;
            var role = get_role_default(virtualNode);
            var supportedRoles = options.supportedRoles || [];
            if (supportedRoles.includes(role)) return true;
            if (role && role !== "presentation" && role !== "none") return void 0;
            return false;
        }
        var aria_roledescription_evaluate_default = ariaRoledescriptionEvaluate;
        function ariaUnsupportedAttrEvaluate(node, options, virtualNode) {
            var unsupportedAttrs = virtualNode.attrNames.filter(function(name) {
                var attribute = standards_default.ariaAttrs[name];
                if (!validate_attr_default(name)) return false;
                var unsupported = attribute.unsupported;
                if (_typeof(unsupported) !== "object") return !!unsupported;
                return !matches_default2(node, unsupported.exceptions);
            });
            if (unsupportedAttrs.length) {
                this.data(unsupportedAttrs);
                return true;
            }
            return false;
        }
        var aria_unsupported_attr_evaluate_default = ariaUnsupportedAttrEvaluate;
        function ariaValidAttrEvaluate(node, options, virtualNode) {
            options = Array.isArray(options.value) ? options.value : [];
            var invalid = [];
            var aria = /^aria-/;
            virtualNode.attrNames.forEach(function(attr) {
                if (options.indexOf(attr) === -1 && aria.test(attr) && !validate_attr_default(attr)) invalid.push(attr);
            });
            if (invalid.length) {
                this.data(invalid);
                return false;
            }
            return true;
        }
        var aria_valid_attr_evaluate_default = ariaValidAttrEvaluate;
        function ariaValidAttrValueEvaluate(node, options, virtualNode) {
            options = Array.isArray(options.value) ? options.value : [];
            var needsReview = "";
            var messageKey = "";
            var invalid = [];
            var aria = /^aria-/;
            var skipAttrs = [
                "aria-errormessage"
            ];
            var preChecks = {
                "aria-controls": function ariaControls() {
                    return virtualNode.attr("aria-expanded") !== "false" && virtualNode.attr("aria-selected") !== "false";
                },
                "aria-current": function ariaCurrent(validValue) {
                    if (!validValue) {
                        needsReview = 'aria-current="'.concat(virtualNode.attr("aria-current"), '"');
                        messageKey = "ariaCurrent";
                    }
                    return;
                },
                "aria-owns": function ariaOwns() {
                    return virtualNode.attr("aria-expanded") !== "false";
                },
                "aria-describedby": function ariaDescribedby(validValue) {
                    if (!validValue) {
                        needsReview = 'aria-describedby="'.concat(virtualNode.attr("aria-describedby"), '"');
                        messageKey = axe._tree && axe._tree[0]._hasShadowRoot ? "noIdShadow" : "noId";
                    }
                    return;
                },
                "aria-labelledby": function ariaLabelledby(validValue) {
                    if (!validValue) {
                        needsReview = 'aria-labelledby="'.concat(virtualNode.attr("aria-labelledby"), '"');
                        messageKey = axe._tree && axe._tree[0]._hasShadowRoot ? "noIdShadow" : "noId";
                    }
                }
            };
            virtualNode.attrNames.forEach(function(attrName) {
                if (skipAttrs.includes(attrName) || options.includes(attrName) || !aria.test(attrName)) return;
                var validValue;
                var attrValue = virtualNode.attr(attrName);
                try {
                    validValue = validate_attr_value_default(virtualNode, attrName);
                } catch (e) {
                    needsReview = "".concat(attrName, '="').concat(attrValue, '"');
                    messageKey = "idrefs";
                    return;
                }
                if ((preChecks[attrName] ? preChecks[attrName](validValue) : true) && !validValue) {
                    if (attrValue === "" && !isStringType(attrName)) {
                        needsReview = attrName;
                        messageKey = "empty";
                    } else invalid.push("".concat(attrName, '="').concat(attrValue, '"'));
                }
            });
            if (invalid.length) {
                this.data(invalid);
                return false;
            }
            if (needsReview) {
                this.data({
                    messageKey: messageKey,
                    needsReview: needsReview
                });
                return void 0;
            }
            return true;
        }
        function isStringType(attrName) {
            var _standards_default$ar;
            return ((_standards_default$ar = standards_default.ariaAttrs[attrName]) === null || _standards_default$ar === void 0 ? void 0 : _standards_default$ar.type) === "string";
        }
        function brailleLabelEquivalentEvaluate(node, options, virtualNode) {
            var _virtualNode$attr;
            var brailleLabel = (_virtualNode$attr = virtualNode.attr("aria-braillelabel")) !== null && _virtualNode$attr !== void 0 ? _virtualNode$attr : "";
            if (!brailleLabel.trim()) return true;
            try {
                return sanitize_default(_accessibleTextVirtual(virtualNode)) !== "";
            } catch (_unused) {
                return void 0;
            }
        }
        function brailleRoleDescriptionEquivalentEvaluate(node, options, virtualNode) {
            var _virtualNode$attr2;
            var brailleRoleDesc = (_virtualNode$attr2 = virtualNode.attr("aria-brailleroledescription")) !== null && _virtualNode$attr2 !== void 0 ? _virtualNode$attr2 : "";
            if (sanitize_default(brailleRoleDesc) === "") return true;
            var roleDesc = virtualNode.attr("aria-roledescription");
            if (typeof roleDesc !== "string") {
                this.data({
                    messageKey: "noRoleDescription"
                });
                return false;
            }
            if (sanitize_default(roleDesc) === "") {
                this.data({
                    messageKey: "emptyRoleDescription"
                });
                return false;
            }
            return true;
        }
        function deprecatedroleEvaluate(node, options, virtualNode) {
            var role = get_role_default(virtualNode, {
                dpub: true,
                fallback: true
            });
            var roleDefinition = standards_default.ariaRoles[role];
            if (!(roleDefinition !== null && roleDefinition !== void 0 && roleDefinition.deprecated)) return false;
            this.data(role);
            return true;
        }
        function nonePresentationOnElementWithNoImplicitRole(virtualNode, explicitRoles) {
            var hasImplicitRole = implicit_role_default(virtualNode);
            return !hasImplicitRole && explicitRoles.length === 2 && explicitRoles.includes("none") && explicitRoles.includes("presentation");
        }
        function fallbackroleEvaluate(node, options, virtualNode) {
            var explicitRoles = token_list_default(virtualNode.attr("role"));
            if (explicitRoles.length <= 1) return false;
            return nonePresentationOnElementWithNoImplicitRole(virtualNode, explicitRoles) ? void 0 : true;
        }
        var fallbackrole_evaluate_default = fallbackroleEvaluate;
        function hasGlobalAriaAttributeEvaluate(node, options, virtualNode) {
            var globalAttrs = get_global_aria_attrs_default().filter(function(attr) {
                return virtualNode.hasAttr(attr);
            });
            this.data(globalAttrs);
            return globalAttrs.length > 0;
        }
        var has_global_aria_attribute_evaluate_default = hasGlobalAriaAttributeEvaluate;
        function hasWidgetRoleEvaluate(node) {
            var role = node.getAttribute("role");
            if (role === null) return false;
            var roleType = get_role_type_default(role);
            return roleType === "widget" || roleType === "composite";
        }
        var has_widget_role_evaluate_default = hasWidgetRoleEvaluate;
        function invalidroleEvaluate(node, options, virtualNode) {
            var allRoles = token_list_default(virtualNode.attr("role"));
            var allInvalid = allRoles.every(function(role) {
                return !is_valid_role_default(role, {
                    allowAbstract: true
                });
            });
            if (allInvalid) {
                this.data(allRoles);
                return true;
            }
            return false;
        }
        var invalidrole_evaluate_default = invalidroleEvaluate;
        function isElementFocusableEvaluate(node, options, virtualNode) {
            return _isFocusable(virtualNode);
        }
        var is_element_focusable_evaluate_default = isElementFocusableEvaluate;
        function noImplicitExplicitLabelEvaluate(node, options, virtualNode) {
            var role = get_role_default(virtualNode, {
                noImplicit: true
            });
            this.data(role);
            var label3;
            var accText;
            try {
                label3 = sanitize_default(label_text_default(virtualNode)).toLowerCase();
                accText = sanitize_default(_accessibleTextVirtual(virtualNode)).toLowerCase();
            } catch (e) {
                return void 0;
            }
            if (!accText && !label3) return false;
            if (!accText && label3) return void 0;
            if (!accText.includes(label3)) return void 0;
            return false;
        }
        var no_implicit_explicit_label_evaluate_default = noImplicitExplicitLabelEvaluate;
        function unsupportedroleEvaluate(node, options, virtualNode) {
            var role = get_role_default(virtualNode, {
                dpub: true,
                fallback: true
            });
            var isUnsupported = is_unsupported_role_default(role);
            if (isUnsupported) this.data(role);
            return isUnsupported;
        }
        var unsupportedrole_evaluate_default = unsupportedroleEvaluate;
        var VALID_TAG_NAMES_FOR_SCROLLABLE_REGIONS = {
            ARTICLE: true,
            ASIDE: true,
            NAV: true,
            SECTION: true
        };
        var VALID_ROLES_FOR_SCROLLABLE_REGIONS = {
            application: true,
            article: true,
            banner: false,
            complementary: true,
            contentinfo: true,
            form: true,
            main: true,
            navigation: true,
            region: true,
            search: false
        };
        function validScrollableTagName(node) {
            var nodeName2 = node.nodeName.toUpperCase();
            return VALID_TAG_NAMES_FOR_SCROLLABLE_REGIONS[nodeName2] || false;
        }
        function validScrollableRole(node, options) {
            var role = get_explicit_role_default(node);
            if (!role) return false;
            return VALID_ROLES_FOR_SCROLLABLE_REGIONS[role] || options.roles.includes(role) || false;
        }
        function validScrollableSemanticsEvaluate(node, options) {
            return validScrollableRole(node, options) || validScrollableTagName(node);
        }
        var valid_scrollable_semantics_evaluate_default = validScrollableSemanticsEvaluate;
        var color_exports = {};
        __export(color_exports, {
            Color: function Color() {
                return color_default;
            },
            centerPointOfRect: function centerPointOfRect() {
                return center_point_of_rect_default;
            },
            elementHasImage: function elementHasImage() {
                return element_has_image_default;
            },
            elementIsDistinct: function elementIsDistinct() {
                return element_is_distinct_default;
            },
            filteredRectStack: function filteredRectStack() {
                return filtered_rect_stack_default;
            },
            flattenColors: function flattenColors() {
                return flatten_colors_default;
            },
            flattenShadowColors: function flattenShadowColors() {
                return _flattenShadowColors;
            },
            getBackgroundColor: function getBackgroundColor() {
                return _getBackgroundColor2;
            },
            getBackgroundStack: function getBackgroundStack() {
                return _getBackgroundStack;
            },
            getContrast: function getContrast() {
                return get_contrast_default;
            },
            getForegroundColor: function getForegroundColor() {
                return _getForegroundColor;
            },
            getOwnBackgroundColor: function getOwnBackgroundColor() {
                return get_own_background_color_default;
            },
            getRectStack: function getRectStack() {
                return get_rect_stack_default;
            },
            getStackingContext: function getStackingContext() {
                return _getStackingContext;
            },
            getStrokeColorsFromShadows: function getStrokeColorsFromShadows() {
                return _getStrokeColorsFromShadows;
            },
            getTextShadowColors: function getTextShadowColors() {
                return _getTextShadowColors;
            },
            hasValidContrastRatio: function hasValidContrastRatio() {
                return has_valid_contrast_ratio_default;
            },
            incompleteData: function incompleteData() {
                return incomplete_data_default;
            },
            parseTextShadows: function parseTextShadows() {
                return _parseTextShadows;
            },
            stackingContextToColor: function stackingContextToColor() {
                return _stackingContextToColor;
            }
        });
        function centerPointOfRect(rect) {
            if (rect.left > window1.innerWidth) return void 0;
            if (rect.top > window1.innerHeight) return void 0;
            var x = Math.min(Math.ceil(rect.left + rect.width / 2), window1.innerWidth - 1);
            var y = Math.min(Math.ceil(rect.top + rect.height / 2), window1.innerHeight - 1);
            return {
                x: x,
                y: y
            };
        }
        var center_point_of_rect_default = centerPointOfRect;
        function _getFonts(style) {
            return style.getPropertyValue("font-family").split(/[,;]/g).map(function(font) {
                return font.trim().toLowerCase();
            });
        }
        function elementIsDistinct(node, ancestorNode) {
            var nodeStyle = window1.getComputedStyle(node);
            if (nodeStyle.getPropertyValue("background-image") !== "none") return true;
            var hasBorder = [
                "border-bottom",
                "border-top",
                "outline"
            ].reduce(function(result, edge) {
                var borderClr = new color_default();
                borderClr.parseString(nodeStyle.getPropertyValue(edge + "-color"));
                return result || nodeStyle.getPropertyValue(edge + "-style") !== "none" && parseFloat(nodeStyle.getPropertyValue(edge + "-width")) > 0 && borderClr.alpha !== 0;
            }, false);
            if (hasBorder) return true;
            var parentStyle = window1.getComputedStyle(ancestorNode);
            if (_getFonts(nodeStyle)[0] !== _getFonts(parentStyle)[0]) return true;
            var hasStyle = [
                "text-decoration-line",
                "text-decoration-style",
                "font-weight",
                "font-style",
                "font-size"
            ].reduce(function(result, cssProp) {
                return result || nodeStyle.getPropertyValue(cssProp) !== parentStyle.getPropertyValue(cssProp);
            }, false);
            var tDec = nodeStyle.getPropertyValue("text-decoration");
            if (tDec.split(" ").length < 3) hasStyle = hasStyle || tDec !== parentStyle.getPropertyValue("text-decoration");
            return hasStyle;
        }
        var element_is_distinct_default = elementIsDistinct;
        function getRectStack2(elm) {
            var boundingStack = get_element_stack_default(elm);
            var filteredArr = get_text_element_stack_default(elm);
            if (!filteredArr || filteredArr.length <= 1) return [
                boundingStack
            ];
            if (filteredArr.some(function(stack) {
                return stack === void 0;
            })) return null;
            filteredArr.splice(0, 0, boundingStack);
            return filteredArr;
        }
        var get_rect_stack_default = getRectStack2;
        function filteredRectStack(elm) {
            var rectStack = get_rect_stack_default(elm);
            if (rectStack && rectStack.length === 1) return rectStack[0];
            if (rectStack && rectStack.length > 1) {
                var boundingStack = rectStack.shift();
                var isSame;
                rectStack.forEach(function(rectList, index) {
                    if (index === 0) return;
                    var rectA = rectStack[index - 1], rectB = rectStack[index];
                    isSame = rectA.every(function(element, elementIndex) {
                        return element === rectB[elementIndex];
                    }) || boundingStack.includes(elm);
                });
                if (!isSame) {
                    incomplete_data_default.set("bgColor", "elmPartiallyObscuring");
                    return null;
                }
                return rectStack[0];
            }
            incomplete_data_default.set("bgColor", "outsideViewport");
            return null;
        }
        var filtered_rect_stack_default = filteredRectStack;
        function clamp2(value, min, max2) {
            return Math.min(Math.max(min, value), max2);
        }
        var blendFunctions = {
            normal: function normal(Cb, Cs) {
                return Cs;
            },
            multiply: function multiply(Cb, Cs) {
                return Cs * Cb;
            },
            screen: function screen(Cb, Cs) {
                return Cb + Cs - Cb * Cs;
            },
            overlay: function overlay(Cb, Cs) {
                return this["hard-light"](Cs, Cb);
            },
            darken: function darken(Cb, Cs) {
                return Math.min(Cb, Cs);
            },
            lighten: function lighten(Cb, Cs) {
                return Math.max(Cb, Cs);
            },
            "color-dodge": function colorDodge(Cb, Cs) {
                return Cb === 0 ? 0 : Cs === 1 ? 1 : Math.min(1, Cb / (1 - Cs));
            },
            "color-burn": function colorBurn(Cb, Cs) {
                return Cb === 1 ? 1 : Cs === 0 ? 0 : 1 - Math.min(1, (1 - Cb) / Cs);
            },
            "hard-light": function hardLight(Cb, Cs) {
                return Cs <= .5 ? this.multiply(Cb, 2 * Cs) : this.screen(Cb, 2 * Cs - 1);
            },
            "soft-light": function softLight(Cb, Cs) {
                if (Cs <= .5) return Cb - (1 - 2 * Cs) * Cb * (1 - Cb);
                else {
                    var D = Cb <= .25 ? ((16 * Cb - 12) * Cb + 4) * Cb : Math.sqrt(Cb);
                    return Cb + (2 * Cs - 1) * (D - Cb);
                }
            },
            difference: function difference(Cb, Cs) {
                return Math.abs(Cb - Cs);
            },
            exclusion: function exclusion(Cb, Cs) {
                return Cb + Cs - 2 * Cb * Cs;
            }
        };
        function simpleAlphaCompositing(Cs, αs, Cb, αb, blendMode) {
            return αs * (1 - αb) * Cs + αs * αb * blendFunctions[blendMode](Cb / 255, Cs / 255) * 255 + (1 - αs) * αb * Cb;
        }
        function flattenColors(sourceColor, backdrop) {
            var blendMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "normal";
            var r = simpleAlphaCompositing(sourceColor.red, sourceColor.alpha, backdrop.red, backdrop.alpha, blendMode);
            var g2 = simpleAlphaCompositing(sourceColor.green, sourceColor.alpha, backdrop.green, backdrop.alpha, blendMode);
            var b2 = simpleAlphaCompositing(sourceColor.blue, sourceColor.alpha, backdrop.blue, backdrop.alpha, blendMode);
            var αo = clamp2(sourceColor.alpha + backdrop.alpha * (1 - sourceColor.alpha), 0, 1);
            if (αo === 0) return new color_default(r, g2, b2, αo);
            var Cr = Math.round(r / αo);
            var Cg = Math.round(g2 / αo);
            var Cb = Math.round(b2 / αo);
            return new color_default(Cr, Cg, Cb, αo);
        }
        var flatten_colors_default = flattenColors;
        function _flattenShadowColors(fgColor, bgColor) {
            var alpha = fgColor.alpha;
            var r = (1 - alpha) * bgColor.red + alpha * fgColor.red;
            var g2 = (1 - alpha) * bgColor.green + alpha * fgColor.green;
            var b2 = (1 - alpha) * bgColor.blue + alpha * fgColor.blue;
            var a2 = fgColor.alpha + bgColor.alpha * (1 - fgColor.alpha);
            return new color_default(r, g2, b2, a2);
        }
        function _getBackgroundStack(node) {
            var stacks = get_text_element_stack_default(node).map(function(stack) {
                stack = reduce_to_elements_below_floating_default(stack, node);
                stack = sortPageBackground(stack);
                return stack;
            });
            for(var index = 0; index < stacks.length; index++){
                var stack = stacks[index];
                if (stack[0] !== node) {
                    incomplete_data_default.set("bgColor", "bgOverlap");
                    return null;
                }
                if (index !== 0 && !shallowArraysEqual(stack, stacks[0])) {
                    incomplete_data_default.set("bgColor", "elmPartiallyObscuring");
                    return null;
                }
            }
            return stacks[0] || null;
        }
        function sortPageBackground(elmStack) {
            var bodyIndex = elmStack.indexOf(document.body);
            var bgNodes = elmStack;
            var htmlBgColor = get_own_background_color_default(window1.getComputedStyle(document.documentElement));
            if (bodyIndex > 1 && htmlBgColor.alpha === 0 && !element_has_image_default(document.documentElement)) {
                if (bodyIndex > 1) {
                    bgNodes.splice(bodyIndex, 1);
                    bgNodes.push(document.body);
                }
                var htmlIndex = bgNodes.indexOf(document.documentElement);
                if (htmlIndex > 0) {
                    bgNodes.splice(htmlIndex, 1);
                    bgNodes.push(document.documentElement);
                }
            }
            return bgNodes;
        }
        function shallowArraysEqual(a2, b2) {
            if (a2 === b2) return true;
            if (a2 === null || b2 === null) return false;
            if (a2.length !== b2.length) return false;
            for(var i = 0; i < a2.length; ++i){
                if (a2[i] !== b2[i]) return false;
            }
            return true;
        }
        var SHADOW_STROKE_ALPHA = .54;
        var VISIBLE_SHADOW_MIN_PX = .5;
        var OPAQUE_STROKE_OFFSET_MIN_PX = 1.5;
        var edges = [
            "top",
            "right",
            "bottom",
            "left"
        ];
        function _getStrokeColorsFromShadows(parsedShadows) {
            var _ref101 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref101$ignoreEdgeCou = _ref101.ignoreEdgeCount, ignoreEdgeCount = _ref101$ignoreEdgeCou === void 0 ? false : _ref101$ignoreEdgeCou;
            var shadowMap = getShadowColorsMap(parsedShadows);
            var shadowsByColor = Object.entries(shadowMap).map(function(_ref102) {
                var _ref103 = _slicedToArray(_ref102, 2), colorStr = _ref103[0], sides = _ref103[1];
                var edgeCount = edges.filter(function(side) {
                    return sides[side].length !== 0;
                }).length;
                return {
                    colorStr: colorStr,
                    sides: sides,
                    edgeCount: edgeCount
                };
            });
            if (!ignoreEdgeCount && shadowsByColor.some(function(_ref104) {
                var edgeCount = _ref104.edgeCount;
                return edgeCount > 1 && edgeCount < 4;
            })) return null;
            return shadowsByColor.map(shadowGroupToColor).filter(function(shadow) {
                return shadow !== null;
            });
        }
        function getShadowColorsMap(parsedShadows) {
            var colorMap = {};
            var _iterator16 = _createForOfIteratorHelper(parsedShadows), _step16;
            try {
                for(_iterator16.s(); !(_step16 = _iterator16.n()).done;){
                    var _colorMap$colorStr;
                    var _step16$value = _step16.value, colorStr = _step16$value.colorStr, pixels = _step16$value.pixels;
                    (_colorMap$colorStr = colorMap[colorStr]) !== null && _colorMap$colorStr !== void 0 ? _colorMap$colorStr : colorMap[colorStr] = {
                        top: [],
                        right: [],
                        bottom: [],
                        left: []
                    };
                    var borders = colorMap[colorStr];
                    var _pixels = _slicedToArray(pixels, 2), offsetX = _pixels[0], offsetY = _pixels[1];
                    if (offsetX > VISIBLE_SHADOW_MIN_PX) borders.right.push(offsetX);
                    else if (-offsetX > VISIBLE_SHADOW_MIN_PX) borders.left.push(-offsetX);
                    if (offsetY > VISIBLE_SHADOW_MIN_PX) borders.bottom.push(offsetY);
                    else if (-offsetY > VISIBLE_SHADOW_MIN_PX) borders.top.push(-offsetY);
                }
            } catch (err) {
                _iterator16.e(err);
            } finally{
                _iterator16.f();
            }
            return colorMap;
        }
        function shadowGroupToColor(_ref105) {
            var colorStr = _ref105.colorStr, sides = _ref105.sides, edgeCount = _ref105.edgeCount;
            if (edgeCount !== 4) return null;
            var strokeColor = new color_default();
            strokeColor.parseString(colorStr);
            var density = 0;
            var isSolid = true;
            edges.forEach(function(edge) {
                density += sides[edge].length / 4;
                isSolid && (isSolid = sides[edge].every(function(offset) {
                    return offset > OPAQUE_STROKE_OFFSET_MIN_PX;
                }));
            });
            if (!isSolid) strokeColor.alpha = 1 - Math.pow(SHADOW_STROKE_ALPHA, density);
            return strokeColor;
        }
        function _parseTextShadows(textShadow) {
            var current = {
                pixels: []
            };
            var str = textShadow.trim();
            var shadows = [
                current
            ];
            if (!str) return [];
            while(str){
                var colorMatch = str.match(/^[a-z]+(\([^)]+\))?/i) || str.match(/^#[0-9a-f]+/i);
                var pixelMatch = str.match(/^([0-9.-]+)px/i) || str.match(/^(0)/);
                if (colorMatch) {
                    assert_default(!current.colorStr, "Multiple colors identified in text-shadow: ".concat(textShadow));
                    str = str.replace(colorMatch[0], "").trim();
                    current.colorStr = colorMatch[0];
                } else if (pixelMatch) {
                    assert_default(current.pixels.length < 3, "Too many pixel units in text-shadow: ".concat(textShadow));
                    str = str.replace(pixelMatch[0], "").trim();
                    var pixelUnit = parseFloat((pixelMatch[1][0] === "." ? "0" : "") + pixelMatch[1]);
                    current.pixels.push(pixelUnit);
                } else if (str[0] === ",") {
                    assert_default(current.pixels.length >= 2, "Missing pixel value in text-shadow: ".concat(textShadow));
                    current = {
                        pixels: []
                    };
                    shadows.push(current);
                    str = str.substr(1).trim();
                } else throw new Error("Unable to process text-shadows: ".concat(str));
            }
            shadows.forEach(function(_ref106) {
                var pixels = _ref106.pixels;
                if (pixels.length === 2) pixels.push(0);
            });
            return shadows;
        }
        function _getTextShadowColors(node) {
            var _ref107 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, minRatio = _ref107.minRatio, maxRatio = _ref107.maxRatio, ignoreEdgeCount = _ref107.ignoreEdgeCount;
            var shadowColors = [];
            var style = window1.getComputedStyle(node);
            var textShadow = style.getPropertyValue("text-shadow");
            if (textShadow === "none") return shadowColors;
            var fontSizeStr = style.getPropertyValue("font-size");
            var fontSize = parseInt(fontSizeStr);
            assert_default(isNaN(fontSize) === false, "Unable to determine font-size value ".concat(fontSizeStr));
            var thinShadows = [];
            var shadows = _parseTextShadows(textShadow);
            var _iterator17 = _createForOfIteratorHelper(shadows), _step17;
            try {
                for(_iterator17.s(); !(_step17 = _iterator17.n()).done;){
                    var shadow = _step17.value;
                    var colorStr = shadow.colorStr || style.getPropertyValue("color");
                    var _shadow$pixels = _slicedToArray(shadow.pixels, 3), offsetX = _shadow$pixels[0], offsetY = _shadow$pixels[1], _shadow$pixels$ = _shadow$pixels[2], blurRadius = _shadow$pixels$ === void 0 ? 0 : _shadow$pixels$;
                    if (maxRatio && blurRadius >= fontSize * maxRatio) continue;
                    if (minRatio && blurRadius < fontSize * minRatio) {
                        thinShadows.push({
                            colorStr: colorStr,
                            pixels: shadow.pixels
                        });
                        continue;
                    }
                    if (thinShadows.length > 0) {
                        var _strokeColors = _getStrokeColorsFromShadows(thinShadows, {
                            ignoreEdgeCount: ignoreEdgeCount
                        });
                        if (_strokeColors === null) return null;
                        shadowColors.push.apply(shadowColors, _toConsumableArray(_strokeColors));
                        thinShadows.splice(0, thinShadows.length);
                    }
                    var _color3 = textShadowColor({
                        colorStr: colorStr,
                        offsetX: offsetX,
                        offsetY: offsetY,
                        blurRadius: blurRadius,
                        fontSize: fontSize
                    });
                    shadowColors.push(_color3);
                }
            } catch (err) {
                _iterator17.e(err);
            } finally{
                _iterator17.f();
            }
            if (thinShadows.length > 0) {
                var strokeColors = _getStrokeColorsFromShadows(thinShadows, {
                    ignoreEdgeCount: ignoreEdgeCount
                });
                if (strokeColors === null) return null;
                shadowColors.push.apply(shadowColors, _toConsumableArray(strokeColors));
            }
            return shadowColors;
        }
        function textShadowColor(_ref108) {
            var colorStr = _ref108.colorStr, offsetX = _ref108.offsetX, offsetY = _ref108.offsetY, blurRadius = _ref108.blurRadius, fontSize = _ref108.fontSize;
            if (offsetX > blurRadius || offsetY > blurRadius) return new color_default(0, 0, 0, 0);
            var shadowColor = new color_default();
            shadowColor.parseString(colorStr);
            shadowColor.alpha *= blurRadiusToAlpha(blurRadius, fontSize);
            return shadowColor;
        }
        function blurRadiusToAlpha(blurRadius, fontSize) {
            if (blurRadius === 0) return 1;
            var relativeBlur = blurRadius / fontSize;
            return .185 / (relativeBlur + .4);
        }
        function _getStackingContext(elm, elmStack) {
            var _elmStack;
            var virtualNode = get_node_from_tree_default(elm);
            if (virtualNode._stackingContext) return virtualNode._stackingContext;
            var stackingContext = [];
            var contextMap = new Map();
            elmStack = (_elmStack = elmStack) !== null && _elmStack !== void 0 ? _elmStack : _getBackgroundStack(elm);
            elmStack.forEach(function(bgElm) {
                var _stackingOrder2;
                var bgVNode = get_node_from_tree_default(bgElm);
                var bgColor = getOwnBackgroundColor2(bgVNode);
                var stackingOrder = bgVNode._stackingOrder.filter(function(_ref109) {
                    var vNode = _ref109.vNode;
                    return !!vNode;
                });
                stackingOrder.forEach(function(_ref110, index) {
                    var _stackingOrder;
                    var vNode = _ref110.vNode;
                    var ancestorVNode2 = (_stackingOrder = stackingOrder[index - 1]) === null || _stackingOrder === void 0 ? void 0 : _stackingOrder.vNode;
                    var context2 = addToStackingContext(contextMap, vNode, ancestorVNode2);
                    if (index === 0 && !contextMap.get(vNode)) stackingContext.unshift(context2);
                    contextMap.set(vNode, context2);
                });
                var ancestorVNode = (_stackingOrder2 = stackingOrder[stackingOrder.length - 1]) === null || _stackingOrder2 === void 0 ? void 0 : _stackingOrder2.vNode;
                var context = addToStackingContext(contextMap, bgVNode, ancestorVNode);
                if (!stackingOrder.length) stackingContext.unshift(context);
                context.bgColor = bgColor;
            });
            virtualNode._stackingContext = stackingContext;
            return stackingContext;
        }
        function _stackingContextToColor(context) {
            var _context$descendants;
            if (!((_context$descendants = context.descendants) !== null && _context$descendants !== void 0 && _context$descendants.length)) {
                var color2 = context.bgColor;
                color2.alpha *= context.opacity;
                return {
                    color: color2,
                    blendMode: context.blendMode
                };
            }
            var sourceColor = context.descendants.reduce(reduceToColor, createStackingContext2());
            var color = flatten_colors_default(sourceColor, context.bgColor, context.descendants[0].blendMode);
            color.alpha *= context.opacity;
            return {
                color: color,
                blendMode: context.blendMode
            };
        }
        function reduceToColor(backdropContext, sourceContext) {
            var backdrop;
            if (backdropContext instanceof color_default) backdrop = backdropContext;
            else backdrop = _stackingContextToColor(backdropContext).color;
            var sourceColor = _stackingContextToColor(sourceContext).color;
            return flatten_colors_default(sourceColor, backdrop, sourceContext.blendMode);
        }
        function createStackingContext2(vNode, ancestorContext) {
            var _vNode$getComputedSty;
            return {
                vNode: vNode,
                ancestor: ancestorContext,
                opacity: parseFloat((_vNode$getComputedSty = vNode === null || vNode === void 0 ? void 0 : vNode.getComputedStylePropertyValue("opacity")) !== null && _vNode$getComputedSty !== void 0 ? _vNode$getComputedSty : 1),
                bgColor: new color_default(0, 0, 0, 0),
                blendMode: normalizeBlendMode(vNode === null || vNode === void 0 ? void 0 : vNode.getComputedStylePropertyValue("mix-blend-mode")),
                descendants: []
            };
        }
        function normalizeBlendMode(blendmode) {
            return !!blendmode ? blendmode : void 0;
        }
        function addToStackingContext(contextMap, vNode, ancestorVNode) {
            var _contextMap$get;
            var ancestorContext = contextMap.get(ancestorVNode);
            var context = (_contextMap$get = contextMap.get(vNode)) !== null && _contextMap$get !== void 0 ? _contextMap$get : createStackingContext2(vNode, ancestorContext);
            if (ancestorContext && ancestorVNode !== vNode && !ancestorContext.descendants.includes(context)) ancestorContext.descendants.unshift(context);
            return context;
        }
        function getOwnBackgroundColor2(vNode) {
            var bgColor = new color_default();
            bgColor.parseString(vNode.getComputedStylePropertyValue("background-color"));
            return bgColor;
        }
        function _getBackgroundColor2(elm) {
            var bgElms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var shadowOutlineEmMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .1;
            var vNode = get_node_from_tree_default(elm);
            var bgColorCache = vNode._cache.getBackgroundColor;
            if (bgColorCache) {
                bgElms.push.apply(bgElms, _toConsumableArray(bgColorCache.bgElms));
                incomplete_data_default.set("bgColor", bgColorCache.incompleteData);
                return bgColorCache.bgColor;
            }
            var bgColor = _getBackgroundColor(elm, bgElms, shadowOutlineEmMax);
            vNode._cache.getBackgroundColor = {
                bgColor: bgColor,
                bgElms: bgElms,
                incompleteData: incomplete_data_default.get("bgColor")
            };
            return bgColor;
        }
        function _getBackgroundColor(elm, bgElms, shadowOutlineEmMax) {
            var _getTextShadowColors2, _bgColors;
            var elmStack = _getBackgroundStack(elm);
            if (!elmStack) return null;
            var textRects = get_visible_child_text_rects_default(elm);
            var bgColors = (_getTextShadowColors2 = _getTextShadowColors(elm, {
                minRatio: shadowOutlineEmMax,
                ignoreEdgeCount: true
            })) !== null && _getTextShadowColors2 !== void 0 ? _getTextShadowColors2 : [];
            if (bgColors.length) bgColors = [
                {
                    color: bgColors.reduce(_flattenShadowColors)
                }
            ];
            for(var _i31 = 0; _i31 < elmStack.length; _i31++){
                var bgElm = elmStack[_i31];
                var bgElmStyle = window1.getComputedStyle(bgElm);
                if (element_has_image_default(bgElm, bgElmStyle)) {
                    bgElms.push(bgElm);
                    return null;
                }
                var bgColor = get_own_background_color_default(bgElmStyle);
                if (bgColor.alpha === 0) continue;
                if (bgElmStyle.getPropertyValue("display") !== "inline" && !fullyEncompasses(bgElm, textRects)) {
                    bgElms.push(bgElm);
                    incomplete_data_default.set("bgColor", "elmPartiallyObscured");
                    return null;
                }
                bgElms.push(bgElm);
                if (bgColor.alpha === 1) break;
            }
            var stackingContext = _getStackingContext(elm, elmStack);
            bgColors = stackingContext.map(_stackingContextToColor).concat(bgColors);
            var pageBgs = getPageBackgroundColors(elm, elmStack.includes(document.body));
            (_bgColors = bgColors).unshift.apply(_bgColors, _toConsumableArray(pageBgs));
            if (bgColors.length === 0) return new color_default(255, 255, 255, 1);
            var blendedColor = bgColors.reduce(function(bgColor, fgColor) {
                return flatten_colors_default(fgColor.color, bgColor.color instanceof color_default ? bgColor.color : bgColor, fgColor.blendMode);
            });
            return flatten_colors_default(blendedColor.color instanceof color_default ? blendedColor.color : blendedColor, new color_default(255, 255, 255, 1));
        }
        function fullyEncompasses(node, rects) {
            rects = Array.isArray(rects) ? rects : [
                rects
            ];
            var nodeRect = node.getBoundingClientRect();
            var right = nodeRect.right, bottom = nodeRect.bottom;
            var style = window1.getComputedStyle(node);
            var overflow = style.getPropertyValue("overflow");
            if ([
                "scroll",
                "auto"
            ].includes(overflow) || node instanceof window1.HTMLHtmlElement) {
                right = nodeRect.left + node.scrollWidth;
                bottom = nodeRect.top + node.scrollHeight;
            }
            return rects.every(function(rect) {
                return rect.top >= nodeRect.top && rect.bottom <= bottom && rect.left >= nodeRect.left && rect.right <= right;
            });
        }
        function normalizeBlendMode2(blendmode) {
            return !!blendmode ? blendmode : void 0;
        }
        function getPageBackgroundColors(elm, stackContainsBody) {
            var pageColors = [];
            if (!stackContainsBody) {
                var html = document.documentElement;
                var body = document.body;
                var htmlStyle = window1.getComputedStyle(html);
                var bodyStyle = window1.getComputedStyle(body);
                var htmlBgColor = get_own_background_color_default(htmlStyle);
                var bodyBgColor = get_own_background_color_default(bodyStyle);
                var bodyBgColorApplies = bodyBgColor.alpha !== 0 && fullyEncompasses(body, elm.getBoundingClientRect());
                if (bodyBgColor.alpha !== 0 && htmlBgColor.alpha === 0 || bodyBgColorApplies && bodyBgColor.alpha !== 1) pageColors.unshift({
                    color: bodyBgColor,
                    blendMode: normalizeBlendMode2(bodyStyle.getPropertyValue("mix-blend-mode"))
                });
                if (htmlBgColor.alpha !== 0 && (!bodyBgColorApplies || bodyBgColorApplies && bodyBgColor.alpha !== 1)) pageColors.unshift({
                    color: htmlBgColor,
                    blendMode: normalizeBlendMode2(htmlStyle.getPropertyValue("mix-blend-mode"))
                });
            }
            return pageColors;
        }
        function getContrast(bgColor, fgColor) {
            if (!fgColor || !bgColor) return null;
            if (fgColor.alpha < 1) fgColor = flatten_colors_default(fgColor, bgColor);
            var bL = bgColor.getRelativeLuminance();
            var fL = fgColor.getRelativeLuminance();
            return (Math.max(fL, bL) + .05) / (Math.min(fL, bL) + .05);
        }
        var get_contrast_default = getContrast;
        function _getForegroundColor(node, _, bgColor) {
            var _bgColor;
            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var nodeStyle = window1.getComputedStyle(node);
            var colorStack = [
                function() {
                    return getStrokeColor(nodeStyle, options);
                },
                function() {
                    return getTextColor(nodeStyle);
                },
                function() {
                    return _getTextShadowColors(node, {
                        minRatio: 0
                    });
                }
            ];
            var fgColors = [];
            for(var _i32 = 0, _colorStack = colorStack; _i32 < _colorStack.length; _i32++){
                var colorFn = _colorStack[_i32];
                var _color4 = colorFn();
                if (!_color4) continue;
                fgColors = fgColors.concat(_color4);
                if (_color4.alpha === 1) break;
            }
            var fgColor = fgColors.reduce(function(source, backdrop) {
                return flatten_colors_default(source, backdrop);
            });
            (_bgColor = bgColor) !== null && _bgColor !== void 0 ? _bgColor : bgColor = _getBackgroundColor2(node, []);
            if (bgColor === null) {
                var reason = incomplete_data_default.get("bgColor");
                incomplete_data_default.set("fgColor", reason);
                return null;
            }
            var stackingContexts = _getStackingContext(node);
            var context = findNodeInContexts(stackingContexts, node);
            return flatten_colors_default(calculateBlendedForegroundColor(fgColor, context, stackingContexts), new color_default(255, 255, 255, 1));
        }
        function getTextColor(nodeStyle) {
            return new color_default().parseString(nodeStyle.getPropertyValue("-webkit-text-fill-color") || nodeStyle.getPropertyValue("color"));
        }
        function getStrokeColor(nodeStyle, _ref111) {
            var _ref111$textStrokeEmM = _ref111.textStrokeEmMin, textStrokeEmMin = _ref111$textStrokeEmM === void 0 ? 0 : _ref111$textStrokeEmM;
            var strokeWidth = parseFloat(nodeStyle.getPropertyValue("-webkit-text-stroke-width"));
            if (strokeWidth === 0) return null;
            var fontSize = nodeStyle.getPropertyValue("font-size");
            var relativeStrokeWidth = strokeWidth / parseFloat(fontSize);
            if (isNaN(relativeStrokeWidth) || relativeStrokeWidth < textStrokeEmMin) return null;
            var strokeColor = nodeStyle.getPropertyValue("-webkit-text-stroke-color");
            return new color_default().parseString(strokeColor);
        }
        function calculateBlendedForegroundColor(fgColor, context, stackingContexts) {
            while(context){
                var _context$ancestor;
                if (context.opacity === 1 && context.ancestor) {
                    context = context.ancestor;
                    continue;
                }
                fgColor.alpha *= context.opacity;
                var stack = ((_context$ancestor = context.ancestor) === null || _context$ancestor === void 0 ? void 0 : _context$ancestor.descendants) || stackingContexts;
                if (context.opacity !== 1) stack = stack.slice(0, stack.indexOf(context));
                var bgColors = stack.map(_stackingContextToColor);
                if (!bgColors.length) {
                    context = context.ancestor;
                    continue;
                }
                var bgColor = bgColors.reduce(function(backdrop, source) {
                    return flatten_colors_default(source.color, backdrop.color instanceof color_default ? backdrop.color : backdrop);
                }, {
                    color: new color_default(0, 0, 0, 0),
                    blendMode: "normal"
                });
                fgColor = flatten_colors_default(fgColor, bgColor);
                context = context.ancestor;
            }
            return fgColor;
        }
        function findNodeInContexts(contexts, node) {
            var _iterator18 = _createForOfIteratorHelper(contexts), _step18;
            try {
                for(_iterator18.s(); !(_step18 = _iterator18.n()).done;){
                    var _context$vNode;
                    var context = _step18.value;
                    if (((_context$vNode = context.vNode) === null || _context$vNode === void 0 ? void 0 : _context$vNode.actualNode) === node) return context;
                    var found = findNodeInContexts(context.descendants, node);
                    if (found) return found;
                }
            } catch (err) {
                _iterator18.e(err);
            } finally{
                _iterator18.f();
            }
        }
        function hasValidContrastRatio(bg, fg, fontSize, isBold) {
            var contrast2 = get_contrast_default(bg, fg);
            var isSmallFont = isBold && Math.ceil(fontSize * 72) / 96 < 14 || !isBold && Math.ceil(fontSize * 72) / 96 < 18;
            var expectedContrastRatio = isSmallFont ? 4.5 : 3;
            return {
                isValid: contrast2 > expectedContrastRatio,
                contrastRatio: contrast2,
                expectedContrastRatio: expectedContrastRatio
            };
        }
        var has_valid_contrast_ratio_default = hasValidContrastRatio;
        function colorContrastEvaluate(node, options, virtualNode) {
            var ignoreUnicode = options.ignoreUnicode, ignoreLength = options.ignoreLength, ignorePseudo = options.ignorePseudo, boldValue = options.boldValue, boldTextPt = options.boldTextPt, largeTextPt = options.largeTextPt, contrastRatio = options.contrastRatio, shadowOutlineEmMax = options.shadowOutlineEmMax, pseudoSizeThreshold = options.pseudoSizeThreshold;
            if (!_isVisibleOnScreen(node)) {
                this.data({
                    messageKey: "hidden"
                });
                return true;
            }
            var visibleText = visible_virtual_default(virtualNode, false, true);
            if (ignoreUnicode && textIsEmojis(visibleText)) {
                this.data({
                    messageKey: "nonBmp"
                });
                return void 0;
            }
            var nodeStyle = window1.getComputedStyle(node);
            var fontSize = parseFloat(nodeStyle.getPropertyValue("font-size"));
            var fontWeight = nodeStyle.getPropertyValue("font-weight");
            var bold = parseFloat(fontWeight) >= boldValue || fontWeight === "bold";
            var ptSize = Math.ceil(fontSize * 72) / 96;
            var isSmallFont = bold && ptSize < boldTextPt || !bold && ptSize < largeTextPt;
            var _ref112 = isSmallFont ? contrastRatio.normal : contrastRatio.large, expected = _ref112.expected, minThreshold = _ref112.minThreshold, maxThreshold = _ref112.maxThreshold;
            var pseudoElm = findPseudoElement(virtualNode, {
                ignorePseudo: ignorePseudo,
                pseudoSizeThreshold: pseudoSizeThreshold
            });
            if (pseudoElm) {
                this.data({
                    fontSize: "".concat((fontSize * 72 / 96).toFixed(1), "pt (").concat(fontSize, "px)"),
                    fontWeight: bold ? "bold" : "normal",
                    messageKey: "pseudoContent",
                    expectedContrastRatio: expected + ":1"
                });
                this.relatedNodes(pseudoElm.actualNode);
                return void 0;
            }
            var shadowColors = _getTextShadowColors(node, {
                minRatio: .001,
                maxRatio: shadowOutlineEmMax
            });
            if (shadowColors === null) {
                this.data({
                    messageKey: "complexTextShadows"
                });
                return void 0;
            }
            var bgNodes = [];
            var bgColor = _getBackgroundColor2(node, bgNodes, shadowOutlineEmMax);
            var fgColor = _getForegroundColor(node, false, bgColor, options);
            var contrast2 = null;
            var contrastContributor = null;
            var shadowColor = null;
            if (shadowColors.length === 0) contrast2 = get_contrast_default(bgColor, fgColor);
            else if (fgColor && bgColor) {
                shadowColor = [].concat(_toConsumableArray(shadowColors), [
                    bgColor
                ]).reduce(_flattenShadowColors);
                var fgBgContrast = get_contrast_default(bgColor, fgColor);
                var bgShContrast = get_contrast_default(bgColor, shadowColor);
                var fgShContrast = get_contrast_default(shadowColor, fgColor);
                contrast2 = Math.max(fgBgContrast, bgShContrast, fgShContrast);
                if (contrast2 !== fgBgContrast) contrastContributor = bgShContrast > fgShContrast ? "shadowOnBgColor" : "fgOnShadowColor";
            }
            var isValid = contrast2 > expected;
            if (typeof minThreshold === "number" && (typeof contrast2 !== "number" || contrast2 < minThreshold) || typeof maxThreshold === "number" && (typeof contrast2 !== "number" || contrast2 > maxThreshold)) {
                this.data({
                    contrastRatio: contrast2
                });
                return true;
            }
            var truncatedResult = Math.floor(contrast2 * 100) / 100;
            var missing;
            if (bgColor === null) missing = incomplete_data_default.get("bgColor");
            else if (!isValid) missing = contrastContributor;
            var equalRatio = truncatedResult === 1;
            var shortTextContent = visibleText.length === 1;
            if (equalRatio) missing = incomplete_data_default.set("bgColor", "equalRatio");
            else if (!isValid && shortTextContent && !ignoreLength) missing = "shortTextContent";
            this.data({
                fgColor: fgColor ? fgColor.toHexString() : void 0,
                bgColor: bgColor ? bgColor.toHexString() : void 0,
                contrastRatio: truncatedResult,
                fontSize: "".concat((fontSize * 72 / 96).toFixed(1), "pt (").concat(fontSize, "px)"),
                fontWeight: bold ? "bold" : "normal",
                messageKey: missing,
                expectedContrastRatio: expected + ":1",
                shadowColor: shadowColor ? shadowColor.toHexString() : void 0
            });
            if (fgColor === null || bgColor === null || equalRatio || shortTextContent && !ignoreLength && !isValid) {
                missing = null;
                incomplete_data_default.clear();
                this.relatedNodes(bgNodes);
                return void 0;
            }
            if (!isValid) this.relatedNodes(bgNodes);
            return isValid;
        }
        function findPseudoElement(vNode, _ref113) {
            var _ref113$pseudoSizeThr = _ref113.pseudoSizeThreshold, pseudoSizeThreshold = _ref113$pseudoSizeThr === void 0 ? .25 : _ref113$pseudoSizeThr, _ref113$ignorePseudo = _ref113.ignorePseudo, ignorePseudo = _ref113$ignorePseudo === void 0 ? false : _ref113$ignorePseudo;
            if (ignorePseudo) return;
            var rect = vNode.boundingClientRect;
            var minimumSize = rect.width * rect.height * pseudoSizeThreshold;
            do {
                var beforeSize = getPseudoElementArea(vNode.actualNode, ":before");
                var afterSize = getPseudoElementArea(vNode.actualNode, ":after");
                if (beforeSize + afterSize > minimumSize) return vNode;
            }while (vNode = vNode.parent);
        }
        var getPseudoElementArea = memoize_default(function getPseudoElementArea2(node, pseudo) {
            var style = window1.getComputedStyle(node, pseudo);
            var matchPseudoStyle = function matchPseudoStyle(prop, value) {
                return style.getPropertyValue(prop) === value;
            };
            if (matchPseudoStyle("content", "none") || matchPseudoStyle("display", "none") || matchPseudoStyle("visibility", "hidden") || matchPseudoStyle("position", "absolute") === false) return 0;
            if (get_own_background_color_default(style).alpha === 0 && matchPseudoStyle("background-image", "none")) return 0;
            var pseudoWidth = parseUnit(style.getPropertyValue("width"));
            var pseudoHeight = parseUnit(style.getPropertyValue("height"));
            if (pseudoWidth.unit !== "px" || pseudoHeight.unit !== "px") return pseudoWidth.value === 0 || pseudoHeight.value === 0 ? 0 : Infinity;
            return pseudoWidth.value * pseudoHeight.value;
        });
        function textIsEmojis(visibleText) {
            var options = {
                nonBmp: true
            };
            var hasUnicodeChars = has_unicode_default(visibleText, options);
            var hasNonUnicodeChars = sanitize_default(remove_unicode_default(visibleText, options)) === "";
            return hasUnicodeChars && hasNonUnicodeChars;
        }
        function parseUnit(str) {
            var unitRegex = /^([0-9.]+)([a-z]+)$/i;
            var _ref114 = str.match(unitRegex) || [], _ref115 = _slicedToArray(_ref114, 3), _ref115$ = _ref115[1], value = _ref115$ === void 0 ? "" : _ref115$, _ref115$2 = _ref115[2], unit = _ref115$2 === void 0 ? "" : _ref115$2;
            return {
                value: parseFloat(value),
                unit: unit.toLowerCase()
            };
        }
        function getContrast2(color1, color2) {
            var c1lum = color1.getRelativeLuminance();
            var c2lum = color2.getRelativeLuminance();
            return (Math.max(c1lum, c2lum) + .05) / (Math.min(c1lum, c2lum) + .05);
        }
        var blockLike2 = [
            "block",
            "list-item",
            "table",
            "flex",
            "grid",
            "inline-block"
        ];
        function isBlock2(elm) {
            var display2 = window1.getComputedStyle(elm).getPropertyValue("display");
            return blockLike2.indexOf(display2) !== -1 || display2.substr(0, 6) === "table-";
        }
        function linkInTextBlockEvaluate(node, options) {
            var requiredContrastRatio = options.requiredContrastRatio, allowSameColor = options.allowSameColor;
            if (isBlock2(node)) return false;
            var parentBlock = get_composed_parent_default(node);
            while(parentBlock && parentBlock.nodeType === 1 && !isBlock2(parentBlock))parentBlock = get_composed_parent_default(parentBlock);
            if (!parentBlock) return void 0;
            this.relatedNodes([
                parentBlock
            ]);
            var nodeColor = _getForegroundColor(node);
            var parentColor = _getForegroundColor(parentBlock);
            var nodeBackgroundColor = _getBackgroundColor2(node);
            var parentBackgroundColor = _getBackgroundColor2(parentBlock);
            var textContrast = nodeColor && parentColor ? getContrast2(nodeColor, parentColor) : void 0;
            if (textContrast) textContrast = Math.floor(textContrast * 100) / 100;
            if (textContrast && textContrast >= requiredContrastRatio) return true;
            var backgroundContrast = nodeBackgroundColor && parentBackgroundColor ? getContrast2(nodeBackgroundColor, parentBackgroundColor) : void 0;
            if (backgroundContrast) backgroundContrast = Math.floor(backgroundContrast * 100) / 100;
            if (backgroundContrast && backgroundContrast >= requiredContrastRatio) return true;
            if (!backgroundContrast) {
                var _incomplete_data_defa;
                var reason = (_incomplete_data_defa = incomplete_data_default.get("bgColor")) !== null && _incomplete_data_defa !== void 0 ? _incomplete_data_defa : "bgContrast";
                this.data({
                    messageKey: reason
                });
                incomplete_data_default.clear();
                return void 0;
            }
            if (!textContrast) return void 0;
            if (allowSameColor && textContrast === 1 && backgroundContrast === 1) return true;
            if (textContrast === 1 && backgroundContrast > 1) {
                this.data({
                    messageKey: "bgContrast",
                    contrastRatio: backgroundContrast,
                    requiredContrastRatio: requiredContrastRatio,
                    nodeBackgroundColor: nodeBackgroundColor ? nodeBackgroundColor.toHexString() : void 0,
                    parentBackgroundColor: parentBackgroundColor ? parentBackgroundColor.toHexString() : void 0
                });
                return false;
            }
            this.data({
                messageKey: "fgContrast",
                contrastRatio: textContrast,
                requiredContrastRatio: requiredContrastRatio,
                nodeColor: nodeColor ? nodeColor.toHexString() : void 0,
                parentColor: parentColor ? parentColor.toHexString() : void 0
            });
            return false;
        }
        var link_in_text_block_evaluate_default = linkInTextBlockEvaluate;
        var blockLike3 = [
            "block",
            "list-item",
            "table",
            "flex",
            "grid",
            "inline-block"
        ];
        function linkInTextBlockStyleEvaluate(node) {
            if (isBlock3(node)) return false;
            var parentBlock = get_composed_parent_default(node);
            while(parentBlock && parentBlock.nodeType === 1 && !isBlock3(parentBlock))parentBlock = get_composed_parent_default(parentBlock);
            if (!parentBlock) return void 0;
            this.relatedNodes([
                parentBlock
            ]);
            if (element_is_distinct_default(node, parentBlock)) return true;
            if (hasPseudoContent(node)) {
                this.data({
                    messageKey: "pseudoContent"
                });
                return void 0;
            }
            return false;
        }
        function isBlock3(elm) {
            var display2 = window1.getComputedStyle(elm).getPropertyValue("display");
            return blockLike3.indexOf(display2) !== -1 || display2.substr(0, 6) === "table-";
        }
        function hasPseudoContent(node) {
            for(var _i33 = 0, _arr4 = [
                "before",
                "after"
            ]; _i33 < _arr4.length; _i33++){
                var pseudo = _arr4[_i33];
                var style = window1.getComputedStyle(node, ":".concat(pseudo));
                var content = style.getPropertyValue("content");
                if (content !== "none") return true;
            }
            return false;
        }
        function autocompleteAppropriateEvaluate(node, options, virtualNode) {
            if (virtualNode.props.nodeName !== "input") return true;
            var number = [
                "text",
                "search",
                "number",
                "tel"
            ];
            var url = [
                "text",
                "search",
                "url"
            ];
            var allowedTypesMap = {
                bday: [
                    "text",
                    "search",
                    "date"
                ],
                email: [
                    "text",
                    "search",
                    "email"
                ],
                username: [
                    "text",
                    "search",
                    "email"
                ],
                "street-address": [
                    "text"
                ],
                tel: [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-country-code": [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-national": [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-area-code": [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-local": [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-local-prefix": [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-local-suffix": [
                    "text",
                    "search",
                    "tel"
                ],
                "tel-extension": [
                    "text",
                    "search",
                    "tel"
                ],
                "cc-number": number,
                "cc-exp": [
                    "text",
                    "search",
                    "month",
                    "tel"
                ],
                "cc-exp-month": number,
                "cc-exp-year": number,
                "cc-csc": number,
                "transaction-amount": number,
                "bday-day": number,
                "bday-month": number,
                "bday-year": number,
                "new-password": [
                    "text",
                    "search",
                    "password"
                ],
                "current-password": [
                    "text",
                    "search",
                    "password"
                ],
                url: url,
                photo: url,
                impp: url
            };
            if (_typeof(options) === "object") Object.keys(options).forEach(function(key) {
                if (!allowedTypesMap[key]) allowedTypesMap[key] = [];
                allowedTypesMap[key] = allowedTypesMap[key].concat(options[key]);
            });
            var autocompleteAttr = virtualNode.attr("autocomplete");
            var autocompleteTerms = autocompleteAttr.split(/\s+/g).map(function(term) {
                return term.toLowerCase();
            });
            var purposeTerm = autocompleteTerms[autocompleteTerms.length - 1];
            if (_autocomplete.stateTerms.includes(purposeTerm)) return true;
            var allowedTypes = allowedTypesMap[purposeTerm];
            var type2 = virtualNode.hasAttr("type") ? sanitize_default(virtualNode.attr("type")).toLowerCase() : "text";
            type2 = valid_input_type_default().includes(type2) ? type2 : "text";
            if (typeof allowedTypes === "undefined") return type2 === "text";
            return allowedTypes.includes(type2);
        }
        var autocomplete_appropriate_evaluate_default = autocompleteAppropriateEvaluate;
        function autocompleteValidEvaluate(node, options, virtualNode) {
            var autocomplete2 = virtualNode.attr("autocomplete") || "";
            return is_valid_autocomplete_default(autocomplete2, options);
        }
        var autocomplete_valid_evaluate_default = autocompleteValidEvaluate;
        function attrNonSpaceContentEvaluate(node) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var vNode = arguments.length > 2 ? arguments[2] : undefined;
            if (!options.attribute || typeof options.attribute !== "string") throw new TypeError("attr-non-space-content requires options.attribute to be a string");
            if (!vNode.hasAttr(options.attribute)) {
                this.data({
                    messageKey: "noAttr"
                });
                return false;
            }
            var attribute = vNode.attr(options.attribute);
            var attributeIsEmpty = !sanitize_default(attribute);
            if (attributeIsEmpty) {
                this.data({
                    messageKey: "emptyAttr"
                });
                return false;
            }
            return true;
        }
        var attr_non_space_content_evaluate_default = attrNonSpaceContentEvaluate;
        function pageHasElmAfter(results) {
            var elmUsedAnywhere = results.some(function(frameResult) {
                return frameResult.result === true;
            });
            if (elmUsedAnywhere) results.forEach(function(result) {
                result.result = true;
            });
            return results;
        }
        var has_descendant_after_default = pageHasElmAfter;
        function hasDescendant(node, options, virtualNode) {
            if (!options || !options.selector || typeof options.selector !== "string") throw new TypeError("has-descendant requires options.selector to be a string");
            if (options.passForModal && is_modal_open_default()) return true;
            var matchingElms = query_selector_all_filter_default(virtualNode, options.selector, function(vNode) {
                return _isVisibleToScreenReaders(vNode);
            });
            this.relatedNodes(matchingElms.map(function(vNode) {
                return vNode.actualNode;
            }));
            return matchingElms.length > 0;
        }
        var has_descendant_evaluate_default = hasDescendant;
        function hasTextContentEvaluate(node, options, virtualNode) {
            try {
                return sanitize_default(subtree_text_default(virtualNode)) !== "";
            } catch (e) {
                return void 0;
            }
        }
        function matchesDefinitionEvaluate(_, options, virtualNode) {
            return matches_default2(virtualNode, options.matcher);
        }
        var matches_definition_evaluate_default = matchesDefinitionEvaluate;
        function pageNoDuplicateAfter(results) {
            return results.filter(function(checkResult) {
                return checkResult.data !== "ignored";
            });
        }
        var page_no_duplicate_after_default = pageNoDuplicateAfter;
        function pageNoDuplicateEvaluate(node, options, virtualNode) {
            if (!options || !options.selector || typeof options.selector !== "string") throw new TypeError("page-no-duplicate requires options.selector to be a string");
            var key = "page-no-duplicate;" + options.selector;
            if (cache_default.get(key)) {
                this.data("ignored");
                return;
            }
            cache_default.set(key, true);
            var elms = query_selector_all_filter_default(axe._tree[0], options.selector, function(elm) {
                return _isVisibleToScreenReaders(elm);
            });
            if (typeof options.nativeScopeFilter === "string") elms = elms.filter(function(elm) {
                return elm.actualNode.hasAttribute("role") || !find_up_virtual_default(elm, options.nativeScopeFilter);
            });
            if (typeof options.role === "string") elms = elms.filter(function(elm) {
                return get_role_default(elm) === options.role;
            });
            this.relatedNodes(elms.filter(function(elm) {
                return elm !== virtualNode;
            }).map(function(elm) {
                return elm.actualNode;
            }));
            return elms.length <= 1;
        }
        var page_no_duplicate_evaluate_default = pageNoDuplicateEvaluate;
        function accesskeysAfter(results) {
            var seen = {};
            return results.filter(function(r) {
                if (!r.data) return false;
                var key = r.data.toUpperCase();
                if (!seen[key]) {
                    seen[key] = r;
                    r.relatedNodes = [];
                    return true;
                }
                seen[key].relatedNodes.push(r.relatedNodes[0]);
                return false;
            }).map(function(r) {
                r.result = !!r.relatedNodes.length;
                return r;
            });
        }
        var accesskeys_after_default = accesskeysAfter;
        function accesskeysEvaluate(node, options, vNode) {
            if (!_isHiddenForEveryone(vNode)) {
                this.data(vNode.attr("accesskey"));
                this.relatedNodes([
                    node
                ]);
            }
            return true;
        }
        var accesskeys_evaluate_default = accesskeysEvaluate;
        function focusableContentEvaluate(node, options, virtualNode) {
            var tabbableElements = virtualNode.tabbableElements;
            if (!tabbableElements) return false;
            var tabbableContentElements = tabbableElements.filter(function(el) {
                return el !== virtualNode;
            });
            return tabbableContentElements.length > 0;
        }
        var focusable_content_evaluate_default = focusableContentEvaluate;
        function focusableDisabledEvaluate(node, options, virtualNode) {
            var elementsThatCanBeDisabled = [
                "button",
                "fieldset",
                "input",
                "select",
                "textarea"
            ];
            var tabbableElements = virtualNode.tabbableElements;
            if (!tabbableElements || !tabbableElements.length) return true;
            var relatedNodes = tabbableElements.filter(function(vNode) {
                return elementsThatCanBeDisabled.includes(vNode.props.nodeName);
            });
            this.relatedNodes(relatedNodes.map(function(vNode) {
                return vNode.actualNode;
            }));
            if (relatedNodes.length === 0 || is_modal_open_default()) return true;
            return relatedNodes.every(function(vNode) {
                var pointerEvents = vNode.getComputedStylePropertyValue("pointer-events");
                var width = parseInt(vNode.getComputedStylePropertyValue("width"));
                var height = parseInt(vNode.getComputedStylePropertyValue("height"));
                return vNode.actualNode.onfocus || (width === 0 || height === 0) && pointerEvents === "none";
            }) ? void 0 : false;
        }
        var focusable_disabled_evaluate_default = focusableDisabledEvaluate;
        function focusableElementEvaluate(node, options, virtualNode) {
            if (virtualNode.hasAttr("contenteditable") && isContenteditable(virtualNode)) return true;
            return _isInTabOrder(virtualNode);
            function isContenteditable(vNode) {
                var contenteditable = vNode.attr("contenteditable");
                if (contenteditable === "true" || contenteditable === "") return true;
                if (contenteditable === "false") return false;
                var ancestor = closest_default(virtualNode.parent, "[contenteditable]");
                if (!ancestor) return false;
                return isContenteditable(ancestor);
            }
        }
        var focusable_element_evaluate_default = focusableElementEvaluate;
        function focusableModalOpenEvaluate(node, options, virtualNode) {
            var tabbableElements = virtualNode.tabbableElements.map(function(_ref116) {
                var actualNode = _ref116.actualNode;
                return actualNode;
            });
            if (!tabbableElements || !tabbableElements.length) return true;
            if (is_modal_open_default()) {
                this.relatedNodes(tabbableElements);
                return void 0;
            }
            return true;
        }
        var focusable_modal_open_evaluate_default = focusableModalOpenEvaluate;
        function focusableNoNameEvaluate(node, options, virtualNode) {
            var tabIndex = virtualNode.attr("tabindex");
            var inFocusOrder = _isFocusable(virtualNode) && tabIndex > -1;
            if (!inFocusOrder) return false;
            try {
                return !_accessibleTextVirtual(virtualNode);
            } catch (e) {
                return void 0;
            }
        }
        var focusable_no_name_evaluate_default = focusableNoNameEvaluate;
        function focusableNotTabbableEvaluate(node, options, virtualNode) {
            var elementsThatCanBeDisabled = [
                "button",
                "fieldset",
                "input",
                "select",
                "textarea"
            ];
            var tabbableElements = virtualNode.tabbableElements;
            if (!tabbableElements || !tabbableElements.length) return true;
            var relatedNodes = tabbableElements.filter(function(vNode) {
                return !elementsThatCanBeDisabled.includes(vNode.props.nodeName);
            });
            this.relatedNodes(relatedNodes.map(function(vNode) {
                return vNode.actualNode;
            }));
            if (relatedNodes.length === 0 || is_modal_open_default()) return true;
            return relatedNodes.every(function(vNode) {
                var pointerEvents = vNode.getComputedStylePropertyValue("pointer-events");
                var width = parseInt(vNode.getComputedStylePropertyValue("width"));
                var height = parseInt(vNode.getComputedStylePropertyValue("height"));
                return vNode.actualNode.onfocus || (width === 0 || height === 0) && pointerEvents === "none";
            }) ? void 0 : false;
        }
        var focusable_not_tabbable_evaluate_default = focusableNotTabbableEvaluate;
        function frameFocusableContentEvaluate(node, options, virtualNode) {
            if (!virtualNode.children) return void 0;
            try {
                return !virtualNode.children.some(function(child) {
                    return focusableDescendants(child);
                });
            } catch (e) {
                return void 0;
            }
        }
        function focusableDescendants(vNode) {
            if (_isInTabOrder(vNode)) return true;
            if (!vNode.children) {
                if (vNode.props.nodeType === 1) throw new Error("Cannot determine children");
                return false;
            }
            return vNode.children.some(function(child) {
                return focusableDescendants(child);
            });
        }
        function landmarkIsTopLevelEvaluate(node) {
            var landmarks = get_aria_roles_by_type_default("landmark");
            var parent = get_composed_parent_default(node);
            var nodeRole = get_role_default(node);
            this.data({
                role: nodeRole
            });
            while(parent){
                var role = parent.getAttribute("role");
                if (!role && parent.nodeName.toUpperCase() !== "FORM") role = implicit_role_default(parent);
                if (role && landmarks.includes(role) && !(role === "main" && nodeRole === "complementary")) return false;
                parent = get_composed_parent_default(parent);
            }
            return true;
        }
        var landmark_is_top_level_evaluate_default = landmarkIsTopLevelEvaluate;
        function noFocusableContentEvaluate(node, options, virtualNode) {
            if (!virtualNode.children) return void 0;
            try {
                var focusableDescendants2 = getFocusableDescendants(virtualNode);
                if (!focusableDescendants2.length) return true;
                var notHiddenElements = focusableDescendants2.filter(usesUnreliableHidingStrategy);
                if (notHiddenElements.length > 0) {
                    this.data({
                        messageKey: "notHidden"
                    });
                    this.relatedNodes(notHiddenElements);
                } else this.relatedNodes(focusableDescendants2);
                return false;
            } catch (e) {
                return void 0;
            }
        }
        function getFocusableDescendants(vNode) {
            if (!vNode.children) {
                if (vNode.props.nodeType === 1) throw new Error("Cannot determine children");
                return [];
            }
            var retVal = [];
            vNode.children.forEach(function(child) {
                if (get_role_type_default(child) === "widget" && _isFocusable(child)) retVal.push(child);
                else retVal.push.apply(retVal, _toConsumableArray(getFocusableDescendants(child)));
            });
            return retVal;
        }
        function usesUnreliableHidingStrategy(vNode) {
            var tabIndex = parseInt(vNode.attr("tabindex"), 10);
            return !isNaN(tabIndex) && tabIndex < 0;
        }
        function tabindexEvaluate(node, options, virtualNode) {
            var tabIndex = parseInt(virtualNode.attr("tabindex"), 10);
            return isNaN(tabIndex) ? true : tabIndex <= 0;
        }
        var tabindex_evaluate_default = tabindexEvaluate;
        function altSpaceValueEvaluate(node, options, virtualNode) {
            var alt = virtualNode.attr("alt");
            var isOnlySpace = /^\s+$/;
            return typeof alt === "string" && isOnlySpace.test(alt);
        }
        var alt_space_value_evaluate_default = altSpaceValueEvaluate;
        function duplicateImgLabelEvaluate(node, options, virtualNode) {
            if ([
                "none",
                "presentation"
            ].includes(get_role_default(virtualNode))) return false;
            var parentVNode = closest_default(virtualNode, options.parentSelector);
            if (!parentVNode) return false;
            var visibleText = visible_virtual_default(parentVNode, true).toLowerCase();
            if (visibleText === "") return false;
            return visibleText === _accessibleTextVirtual(virtualNode).toLowerCase();
        }
        var duplicate_img_label_evaluate_default = duplicateImgLabelEvaluate;
        function explicitEvaluate(node, options, virtualNode) {
            var _this7 = this;
            if (!virtualNode.attr("id")) return false;
            if (!virtualNode.actualNode) return void 0;
            var root = get_root_node_default2(virtualNode.actualNode);
            var id = escape_selector_default(virtualNode.attr("id"));
            var labels = Array.from(root.querySelectorAll('label[for="'.concat(id, '"]')));
            this.relatedNodes(labels);
            if (!labels.length) return false;
            try {
                return labels.some(function(label3) {
                    if (!_isVisibleOnScreen(label3)) return true;
                    else {
                        var explicitLabel = sanitize_default(accessible_text_default(label3, {
                            inControlContext: true,
                            startNode: virtualNode
                        }));
                        _this7.data({
                            explicitLabel: explicitLabel
                        });
                        return !!explicitLabel;
                    }
                });
            } catch (e) {
                return void 0;
            }
        }
        var explicit_evaluate_default = explicitEvaluate;
        function helpSameAsLabelEvaluate(node, options, virtualNode) {
            var labelText2 = label_virtual_default2(virtualNode), check = node.getAttribute("title");
            if (!labelText2) return false;
            if (!check) {
                check = "";
                if (node.getAttribute("aria-describedby")) {
                    var ref = idrefs_default(node, "aria-describedby");
                    check = ref.map(function(thing) {
                        return thing ? accessible_text_default(thing) : "";
                    }).join("");
                }
            }
            return sanitize_default(check) === sanitize_default(labelText2);
        }
        var help_same_as_label_evaluate_default = helpSameAsLabelEvaluate;
        function hiddenExplicitLabelEvaluate(node, options, virtualNode) {
            if (virtualNode.hasAttr("id")) {
                if (!virtualNode.actualNode) return void 0;
                var root = get_root_node_default2(node);
                var _id4 = escape_selector_default(node.getAttribute("id"));
                var label3 = root.querySelector('label[for="'.concat(_id4, '"]'));
                if (label3 && !_isVisibleToScreenReaders(label3)) {
                    var name;
                    try {
                        name = _accessibleTextVirtual(virtualNode).trim();
                    } catch (e) {
                        return void 0;
                    }
                    var isNameEmpty = name === "";
                    return isNameEmpty;
                }
            }
            return false;
        }
        var hidden_explicit_label_evaluate_default = hiddenExplicitLabelEvaluate;
        function implicitEvaluate(node, options, virtualNode) {
            try {
                var label3 = closest_default(virtualNode, "label");
                if (label3) {
                    var implicitLabel = sanitize_default(_accessibleTextVirtual(label3, {
                        inControlContext: true,
                        startNode: virtualNode
                    }));
                    if (label3.actualNode) this.relatedNodes([
                        label3.actualNode
                    ]);
                    this.data({
                        implicitLabel: implicitLabel
                    });
                    return !!implicitLabel;
                }
                return false;
            } catch (e) {
                return void 0;
            }
        }
        var implicit_evaluate_default = implicitEvaluate;
        function isStringContained(compare, compareWith) {
            var curatedCompareWith = curateString(compareWith);
            var curatedCompare = curateString(compare);
            if (!curatedCompareWith || !curatedCompare) return false;
            return curatedCompareWith.includes(curatedCompare);
        }
        function curateString(str) {
            var noUnicodeStr = remove_unicode_default(str, {
                emoji: true,
                nonBmp: true,
                punctuations: true
            });
            return sanitize_default(noUnicodeStr);
        }
        function labelContentNameMismatchEvaluate(node, options, virtualNode) {
            var _options$occurrenceTh;
            var pixelThreshold = options === null || options === void 0 ? void 0 : options.pixelThreshold;
            var occurrenceThreshold = (_options$occurrenceTh = options === null || options === void 0 ? void 0 : options.occurrenceThreshold) !== null && _options$occurrenceTh !== void 0 ? _options$occurrenceTh : options === null || options === void 0 ? void 0 : options.occuranceThreshold;
            var accText = accessible_text_default(node).toLowerCase();
            if (is_human_interpretable_default(accText) < 1) return void 0;
            var visibleText = sanitize_default(subtree_text_default(virtualNode, {
                subtreeDescendant: true,
                ignoreIconLigature: true,
                pixelThreshold: pixelThreshold,
                occurrenceThreshold: occurrenceThreshold
            })).toLowerCase();
            if (!visibleText) return true;
            if (is_human_interpretable_default(visibleText) < 1) {
                if (isStringContained(visibleText, accText)) return true;
                return void 0;
            }
            return isStringContained(visibleText, accText);
        }
        var label_content_name_mismatch_evaluate_default = labelContentNameMismatchEvaluate;
        function multipleLabelEvaluate(node) {
            var id = escape_selector_default(node.getAttribute("id"));
            var parent = node.parentNode;
            var root = get_root_node_default2(node);
            root = root.documentElement || root;
            var labels = Array.from(root.querySelectorAll('label[for="'.concat(id, '"]')));
            if (labels.length) labels = labels.filter(function(label3) {
                return !_isHiddenForEveryone(label3);
            });
            while(parent){
                if (parent.nodeName.toUpperCase() === "LABEL" && labels.indexOf(parent) === -1) labels.push(parent);
                parent = parent.parentNode;
            }
            this.relatedNodes(labels);
            if (labels.length > 1) {
                var ATVisibleLabels = labels.filter(function(label3) {
                    return _isVisibleToScreenReaders(label3);
                });
                if (ATVisibleLabels.length > 1) return void 0;
                var labelledby = idrefs_default(node, "aria-labelledby");
                return !labelledby.includes(ATVisibleLabels[0]) ? void 0 : false;
            }
            return false;
        }
        var multiple_label_evaluate_default = multipleLabelEvaluate;
        function titleOnlyEvaluate(node, options, virtualNode) {
            var labelText2 = label_virtual_default2(virtualNode);
            var title = title_text_default(virtualNode);
            var ariaDescribedBy = virtualNode.attr("aria-describedby");
            return !labelText2 && !!(title || ariaDescribedBy);
        }
        var title_only_evaluate_default = titleOnlyEvaluate;
        function landmarkIsUniqueAfter(results) {
            var uniqueLandmarks = [];
            return results.filter(function(currentResult) {
                var findMatch = function findMatch(someResult) {
                    return currentResult.data.role === someResult.data.role && currentResult.data.accessibleText === someResult.data.accessibleText;
                };
                var matchedResult = uniqueLandmarks.find(findMatch);
                if (matchedResult) {
                    matchedResult.result = false;
                    matchedResult.relatedNodes.push(currentResult.relatedNodes[0]);
                    return false;
                }
                uniqueLandmarks.push(currentResult);
                currentResult.relatedNodes = [];
                return true;
            });
        }
        var landmark_is_unique_after_default = landmarkIsUniqueAfter;
        function landmarkIsUniqueEvaluate(node, options, virtualNode) {
            var role = get_role_default(node);
            var accessibleText2 = _accessibleTextVirtual(virtualNode);
            accessibleText2 = accessibleText2 ? accessibleText2.toLowerCase() : null;
            this.data({
                role: role,
                accessibleText: accessibleText2
            });
            this.relatedNodes([
                node
            ]);
            return true;
        }
        var landmark_is_unique_evaluate_default = landmarkIsUniqueEvaluate;
        function hasValue(value) {
            return (value || "").trim() !== "";
        }
        function hasLangEvaluate(node, options, virtualNode) {
            var xhtml = typeof document !== "undefined" ? is_xhtml_default(document) : false;
            if (options.attributes.includes("xml:lang") && options.attributes.includes("lang") && hasValue(virtualNode.attr("xml:lang")) && !hasValue(virtualNode.attr("lang")) && !xhtml) {
                this.data({
                    messageKey: "noXHTML"
                });
                return false;
            }
            var hasLang = options.attributes.some(function(name) {
                return hasValue(virtualNode.attr(name));
            });
            if (!hasLang) {
                this.data({
                    messageKey: "noLang"
                });
                return false;
            }
            return true;
        }
        var has_lang_evaluate_default = hasLangEvaluate;
        function validLangEvaluate(node, options, virtualNode) {
            var invalid = [];
            options.attributes.forEach(function(langAttr) {
                var langVal = virtualNode.attr(langAttr);
                if (typeof langVal !== "string") return;
                var baselangVal = get_base_lang_default(langVal);
                var invalidLang = options.value ? !options.value.map(get_base_lang_default).includes(baselangVal) : !valid_langs_default(baselangVal);
                if (baselangVal !== "" && invalidLang || langVal !== "" && !sanitize_default(langVal)) invalid.push(langAttr + '="' + virtualNode.attr(langAttr) + '"');
            });
            if (!invalid.length) return false;
            if (virtualNode.props.nodeName !== "html" && !_hasLangText(virtualNode)) return false;
            this.data(invalid);
            return true;
        }
        var valid_lang_evaluate_default = validLangEvaluate;
        function xmlLangMismatchEvaluate(node, options, vNode) {
            var primaryLangValue = get_base_lang_default(vNode.attr("lang"));
            var primaryXmlLangValue = get_base_lang_default(vNode.attr("xml:lang"));
            return primaryLangValue === primaryXmlLangValue;
        }
        var xml_lang_mismatch_evaluate_default = xmlLangMismatchEvaluate;
        function dlitemEvaluate(node) {
            var parent = get_composed_parent_default(node);
            var parentTagName = parent.nodeName.toUpperCase();
            var parentRole = get_explicit_role_default(parent);
            if (parentTagName === "DIV" && [
                "presentation",
                "none",
                null
            ].includes(parentRole)) {
                parent = get_composed_parent_default(parent);
                parentTagName = parent.nodeName.toUpperCase();
                parentRole = get_explicit_role_default(parent);
            }
            if (parentTagName !== "DL") return false;
            if (!parentRole || [
                "presentation",
                "none",
                "list"
            ].includes(parentRole)) return true;
            return false;
        }
        var dlitem_evaluate_default = dlitemEvaluate;
        function invalidChildrenEvaluate(node) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var virtualNode = arguments.length > 2 ? arguments[2] : undefined;
            var relatedNodes = [];
            var issues = [];
            if (!virtualNode.children) return void 0;
            var vChildren = mapWithNested(virtualNode.children);
            while(vChildren.length){
                var _vChild$actualNode;
                var _vChildren$shift = vChildren.shift(), vChild = _vChildren$shift.vChild, nested = _vChildren$shift.nested;
                if (options.divGroups && !nested && isDivGroup(vChild)) {
                    if (!vChild.children) return void 0;
                    var vGrandChildren = mapWithNested(vChild.children, true);
                    vChildren.push.apply(vChildren, _toConsumableArray(vGrandChildren));
                    continue;
                }
                var issue = getInvalidSelector(vChild, nested, options);
                if (!issue) continue;
                if (!issues.includes(issue)) issues.push(issue);
                if ((vChild === null || vChild === void 0 ? void 0 : (_vChild$actualNode = vChild.actualNode) === null || _vChild$actualNode === void 0 ? void 0 : _vChild$actualNode.nodeType) === 1) relatedNodes.push(vChild.actualNode);
            }
            if (issues.length === 0) return false;
            this.data({
                values: issues.join(", ")
            });
            this.relatedNodes(relatedNodes);
            return true;
        }
        function getInvalidSelector(vChild, nested, _ref117) {
            var _ref117$validRoles = _ref117.validRoles, validRoles = _ref117$validRoles === void 0 ? [] : _ref117$validRoles, _ref117$validNodeName = _ref117.validNodeNames, validNodeNames = _ref117$validNodeName === void 0 ? [] : _ref117$validNodeName;
            var _vChild$props = vChild.props, nodeName2 = _vChild$props.nodeName, nodeType = _vChild$props.nodeType, nodeValue = _vChild$props.nodeValue;
            var selector = nested ? "div > " : "";
            if (nodeType === 3 && nodeValue.trim() !== "") return selector + "#text";
            if (nodeType !== 1 || !_isVisibleToScreenReaders(vChild)) return false;
            var role = get_explicit_role_default(vChild);
            if (role) return validRoles.includes(role) ? false : selector + "[role=".concat(role, "]");
            else return validNodeNames.includes(nodeName2) ? false : selector + nodeName2;
        }
        function isDivGroup(vNode) {
            return vNode.props.nodeName === "div" && get_explicit_role_default(vNode) === null;
        }
        function mapWithNested(vNodes) {
            var nested = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return vNodes.map(function(vChild) {
                return {
                    vChild: vChild,
                    nested: nested
                };
            });
        }
        function listitemEvaluate(node, options, virtualNode) {
            var parent = virtualNode.parent;
            if (!parent) return void 0;
            var parentNodeName = parent.props.nodeName;
            var parentRole = get_explicit_role_default(parent);
            if ([
                "presentation",
                "none",
                "list"
            ].includes(parentRole)) return true;
            if (parentRole && is_valid_role_default(parentRole)) {
                this.data({
                    messageKey: "roleNotValid"
                });
                return false;
            }
            return [
                "ul",
                "ol",
                "menu"
            ].includes(parentNodeName);
        }
        function onlyDlitemsEvaluate(node, options, virtualNode) {
            var ALLOWED_ROLES = [
                "definition",
                "term",
                "list"
            ];
            var base = {
                badNodes: [],
                hasNonEmptyTextNode: false
            };
            var content = virtualNode.children.reduce(function(vNodes, child) {
                var actualNode = child.actualNode;
                if (actualNode.nodeName.toUpperCase() === "DIV" && get_role_default(actualNode) === null) return vNodes.concat(child.children);
                return vNodes.concat(child);
            }, []);
            var result = content.reduce(function(out, childNode) {
                var actualNode = childNode.actualNode;
                var tagName = actualNode.nodeName.toUpperCase();
                if (actualNode.nodeType === 1 && _isVisibleToScreenReaders(actualNode)) {
                    var explicitRole2 = get_explicit_role_default(actualNode);
                    if (tagName !== "DT" && tagName !== "DD" || explicitRole2) {
                        if (!ALLOWED_ROLES.includes(explicitRole2)) out.badNodes.push(actualNode);
                    }
                } else if (actualNode.nodeType === 3 && actualNode.nodeValue.trim() !== "") out.hasNonEmptyTextNode = true;
                return out;
            }, base);
            if (result.badNodes.length) this.relatedNodes(result.badNodes);
            return !!result.badNodes.length || result.hasNonEmptyTextNode;
        }
        function onlyListitemsEvaluate(node, options, virtualNode) {
            var hasNonEmptyTextNode = false;
            var atLeastOneListitem = false;
            var isEmpty = true;
            var badNodes = [];
            var badRoleNodes = [];
            var badRoles = [];
            virtualNode.children.forEach(function(vNode) {
                var actualNode = vNode.actualNode;
                if (actualNode.nodeType === 3 && actualNode.nodeValue.trim() !== "") {
                    hasNonEmptyTextNode = true;
                    return;
                }
                if (actualNode.nodeType !== 1 || !_isVisibleToScreenReaders(actualNode)) return;
                isEmpty = false;
                var isLi = actualNode.nodeName.toUpperCase() === "LI";
                var role = get_role_default(vNode);
                var isListItemRole = role === "listitem";
                if (!isLi && !isListItemRole) badNodes.push(actualNode);
                if (isLi && !isListItemRole) {
                    badRoleNodes.push(actualNode);
                    if (!badRoles.includes(role)) badRoles.push(role);
                }
                if (isListItemRole) atLeastOneListitem = true;
            });
            if (hasNonEmptyTextNode || badNodes.length) {
                this.relatedNodes(badNodes);
                return true;
            }
            if (isEmpty || atLeastOneListitem) return false;
            this.relatedNodes(badRoleNodes);
            this.data({
                messageKey: "roleNotValid",
                roles: badRoles.join(", ")
            });
            return true;
        }
        var only_listitems_evaluate_default = onlyListitemsEvaluate;
        function structuredDlitemsEvaluate(node, options, virtualNode) {
            var children = virtualNode.children;
            if (!children || !children.length) return false;
            var hasDt = false, hasDd = false, nodeName2;
            for(var i = 0; i < children.length; i++){
                nodeName2 = children[i].props.nodeName.toUpperCase();
                if (nodeName2 === "DT") hasDt = true;
                if (hasDt && nodeName2 === "DD") return false;
                if (nodeName2 === "DD") hasDd = true;
            }
            return hasDt || hasDd;
        }
        var structured_dlitems_evaluate_default = structuredDlitemsEvaluate;
        function captionEvaluate(node, options, virtualNode) {
            var tracks = query_selector_all_default(virtualNode, "track");
            var hasCaptions = tracks.some(function(vNode) {
                return (vNode.attr("kind") || "").toLowerCase() === "captions";
            });
            return hasCaptions ? false : void 0;
        }
        var caption_evaluate_default = captionEvaluate;
        var joinStr = " > ";
        function frameTestedAfter(results) {
            var iframes = {};
            return results.filter(function(result) {
                var frameResult = result.node.ancestry[result.node.ancestry.length - 1] !== "html";
                if (frameResult) {
                    var ancestry2 = result.node.ancestry.flat(Infinity).join(joinStr);
                    iframes[ancestry2] = result;
                    return true;
                }
                var ancestry = result.node.ancestry.slice(0, result.node.ancestry.length - 1).flat(Infinity).join(joinStr);
                if (iframes[ancestry]) iframes[ancestry].result = true;
                return false;
            });
        }
        var frame_tested_after_default = frameTestedAfter;
        function frameTestedEvaluate(node, options) {
            return options.isViolation ? false : void 0;
        }
        var frame_tested_evaluate_default = frameTestedEvaluate;
        function noAutoplayAudioEvaluate(node, options) {
            if (!node.duration) {
                console.warn("axe.utils.preloadMedia did not load metadata");
                return void 0;
            }
            var _options$allowedDurat = options.allowedDuration, allowedDuration = _options$allowedDurat === void 0 ? 3 : _options$allowedDurat;
            var playableDuration = getPlayableDuration(node);
            if (playableDuration <= allowedDuration && !node.hasAttribute("loop")) return true;
            if (!node.hasAttribute("controls")) return false;
            return true;
            function getPlayableDuration(elm) {
                if (!elm.currentSrc) return 0;
                var playbackRange = getPlaybackRange(elm.currentSrc);
                if (!playbackRange) return Math.abs(elm.duration - (elm.currentTime || 0));
                if (playbackRange.length === 1) return Math.abs(elm.duration - playbackRange[0]);
                return Math.abs(playbackRange[1] - playbackRange[0]);
            }
            function getPlaybackRange(src) {
                var match = src.match(/#t=(.*)/);
                if (!match) return;
                var _match = _slicedToArray(match, 2), value = _match[1];
                var ranges = value.split(",");
                return ranges.map(function(range2) {
                    if (/:/.test(range2)) return convertHourMinSecToSeconds(range2);
                    return parseFloat(range2);
                });
            }
            function convertHourMinSecToSeconds(hhMmSs) {
                var parts = hhMmSs.split(":");
                var secs = 0;
                var mins = 1;
                while(parts.length > 0){
                    secs += mins * parseInt(parts.pop(), 10);
                    mins *= 60;
                }
                return parseFloat(secs);
            }
        }
        var no_autoplay_audio_evaluate_default = noAutoplayAudioEvaluate;
        function cssOrientationLockEvaluate(node, options, virtualNode, context) {
            var _ref118 = context || {}, _ref118$cssom = _ref118.cssom, cssom = _ref118$cssom === void 0 ? void 0 : _ref118$cssom;
            var _ref119 = options || {}, _ref119$degreeThresho = _ref119.degreeThreshold, degreeThreshold = _ref119$degreeThresho === void 0 ? 0 : _ref119$degreeThresho;
            if (!cssom || !cssom.length) return void 0;
            var isLocked = false;
            var relatedElements = [];
            var rulesGroupByDocumentFragment = groupCssomByDocument(cssom);
            var _loop8 = function _loop8() {
                var key = _Object$keys3[_i34];
                var _rulesGroupByDocument = rulesGroupByDocumentFragment[key], root = _rulesGroupByDocument.root, rules = _rulesGroupByDocument.rules;
                var orientationRules = rules.filter(isMediaRuleWithOrientation);
                if (!orientationRules.length) return "continue";
                orientationRules.forEach(function(_ref120) {
                    var cssRules = _ref120.cssRules;
                    Array.from(cssRules).forEach(function(cssRule) {
                        var locked = getIsOrientationLocked(cssRule);
                        if (locked && cssRule.selectorText.toUpperCase() !== "HTML") {
                            var elms = Array.from(root.querySelectorAll(cssRule.selectorText)) || [];
                            relatedElements = relatedElements.concat(elms);
                        }
                        isLocked = isLocked || locked;
                    });
                });
            };
            for(var _i34 = 0, _Object$keys3 = Object.keys(rulesGroupByDocumentFragment); _i34 < _Object$keys3.length; _i34++){
                var _ret6 = _loop8();
                if (_ret6 === "continue") continue;
            }
            if (!isLocked) return true;
            if (relatedElements.length) this.relatedNodes(relatedElements);
            return false;
            function groupCssomByDocument(cssObjectModel) {
                return cssObjectModel.reduce(function(out, _ref121) {
                    var sheet = _ref121.sheet, root = _ref121.root, shadowId = _ref121.shadowId;
                    var key = shadowId ? shadowId : "topDocument";
                    if (!out[key]) out[key] = {
                        root: root,
                        rules: []
                    };
                    if (!sheet || !sheet.cssRules) return out;
                    var rules = Array.from(sheet.cssRules);
                    out[key].rules = out[key].rules.concat(rules);
                    return out;
                }, {});
            }
            function isMediaRuleWithOrientation(_ref122) {
                var type2 = _ref122.type, cssText = _ref122.cssText;
                if (type2 !== 4) return false;
                return /orientation:\s*landscape/i.test(cssText) || /orientation:\s*portrait/i.test(cssText);
            }
            function getIsOrientationLocked(_ref123) {
                var selectorText = _ref123.selectorText, style = _ref123.style;
                if (!selectorText || style.length <= 0) return false;
                var transformStyle = style.transform || style.webkitTransform || style.msTransform || false;
                if (!transformStyle && !style.rotate) return false;
                var transformDegrees = getTransformDegrees(transformStyle);
                var rotateDegrees = getRotationInDegrees("rotate", style.rotate);
                var degrees = transformDegrees + rotateDegrees;
                if (!degrees) return false;
                degrees = Math.abs(degrees);
                if (Math.abs(degrees - 180) % 180 <= degreeThreshold) return false;
                return Math.abs(degrees - 90) % 90 <= degreeThreshold;
            }
            function getTransformDegrees(transformStyle) {
                if (!transformStyle) return 0;
                var matches4 = transformStyle.match(/(rotate|rotateZ|rotate3d|matrix|matrix3d)\(([^)]+)\)(?!.*(rotate|rotateZ|rotate3d|matrix|matrix3d))/);
                if (!matches4) return 0;
                var _matches2 = _slicedToArray(matches4, 3), transformFn = _matches2[1], transformFnValue = _matches2[2];
                return getRotationInDegrees(transformFn, transformFnValue);
            }
            function getRotationInDegrees(transformFunction, transformFnValue) {
                switch(transformFunction){
                    case "rotate":
                    case "rotateZ":
                        return getAngleInDegrees(transformFnValue);
                    case "rotate3d":
                        var _transformFnValue$spl = transformFnValue.split(",").map(function(value) {
                            return value.trim();
                        }), _transformFnValue$spl2 = _slicedToArray(_transformFnValue$spl, 4), z = _transformFnValue$spl2[2], angleWithUnit = _transformFnValue$spl2[3];
                        if (parseInt(z) === 0) return;
                        return getAngleInDegrees(angleWithUnit);
                    case "matrix":
                    case "matrix3d":
                        return getAngleInDegreesFromMatrixTransform(transformFnValue);
                    default:
                        return 0;
                }
            }
            function getAngleInDegrees(angleWithUnit) {
                var _ref124 = angleWithUnit.match(/(deg|grad|rad|turn)/) || [], _ref125 = _slicedToArray(_ref124, 1), unit = _ref125[0];
                if (!unit) return 0;
                var angle = parseFloat(angleWithUnit.replace(unit, ""));
                switch(unit){
                    case "rad":
                        return convertRadToDeg(angle);
                    case "grad":
                        return convertGradToDeg(angle);
                    case "turn":
                        return convertTurnToDeg(angle);
                    case "deg":
                    default:
                        return parseInt(angle);
                }
            }
            function getAngleInDegreesFromMatrixTransform(transformFnValue) {
                var values = transformFnValue.split(",");
                if (values.length <= 6) {
                    var _values = _slicedToArray(values, 2), a2 = _values[0], b3 = _values[1];
                    var radians = Math.atan2(parseFloat(b3), parseFloat(a2));
                    return convertRadToDeg(radians);
                }
                var sinB = parseFloat(values[8]);
                var b2 = Math.asin(sinB);
                var cosB = Math.cos(b2);
                var rotateZRadians = Math.acos(parseFloat(values[0]) / cosB);
                return convertRadToDeg(rotateZRadians);
            }
            function convertRadToDeg(radians) {
                return Math.round(radians * (180 / Math.PI));
            }
            function convertGradToDeg(grad) {
                grad = grad % 400;
                if (grad < 0) grad += 400;
                return Math.round(grad / 400 * 360);
            }
            function convertTurnToDeg(turn) {
                return Math.round(360 / (1 / turn));
            }
        }
        var css_orientation_lock_evaluate_default = cssOrientationLockEvaluate;
        function metaViewportScaleEvaluate(node, options, virtualNode) {
            var _ref126 = options || {}, _ref126$scaleMinimum = _ref126.scaleMinimum, scaleMinimum = _ref126$scaleMinimum === void 0 ? 2 : _ref126$scaleMinimum, _ref126$lowerBound = _ref126.lowerBound, lowerBound = _ref126$lowerBound === void 0 ? false : _ref126$lowerBound;
            var content = virtualNode.attr("content") || "";
            if (!content) return true;
            var result = content.split(/[;,]/).reduce(function(out, item) {
                var contentValue = item.trim();
                if (!contentValue) return out;
                var _contentValue$split = contentValue.split("="), _contentValue$split2 = _slicedToArray(_contentValue$split, 2), key = _contentValue$split2[0], value = _contentValue$split2[1];
                if (!key || !value) return out;
                var curatedKey = key.toLowerCase().trim();
                var curatedValue = value.toLowerCase().trim();
                if (curatedKey === "maximum-scale" && curatedValue === "yes") curatedValue = 1;
                if (curatedKey === "maximum-scale" && parseFloat(curatedValue) < 0) return out;
                out[curatedKey] = curatedValue;
                return out;
            }, {});
            if (lowerBound && result["maximum-scale"] && parseFloat(result["maximum-scale"]) < lowerBound) return true;
            if (!lowerBound && result["user-scalable"] === "no") {
                this.data("user-scalable=no");
                return false;
            }
            var userScalableAsFloat = parseFloat(result["user-scalable"]);
            if (!lowerBound && result["user-scalable"] && (userScalableAsFloat || userScalableAsFloat === 0) && userScalableAsFloat > -1 && userScalableAsFloat < 1) {
                this.data("user-scalable");
                return false;
            }
            if (result["maximum-scale"] && parseFloat(result["maximum-scale"]) < scaleMinimum) {
                this.data("maximum-scale");
                return false;
            }
            return true;
        }
        var meta_viewport_scale_evaluate_default = metaViewportScaleEvaluate;
        var roundingMargin2 = .05;
        function targetOffsetEvaluate(node, options, vNode) {
            var minOffset = (options === null || options === void 0 ? void 0 : options.minOffset) || 24;
            var closeNeighbors = [];
            var closestOffset = minOffset;
            var _iterator19 = _createForOfIteratorHelper(_findNearbyElms(vNode, minOffset)), _step19;
            try {
                for(_iterator19.s(); !(_step19 = _iterator19.n()).done;){
                    var vNeighbor = _step19.value;
                    if (get_role_type_default(vNeighbor) !== "widget" || !_isFocusable(vNeighbor)) continue;
                    var offset = roundToSingleDecimal(_getOffset(vNode, vNeighbor, minOffset / 2)) * 2;
                    if (offset + roundingMargin2 >= minOffset) continue;
                    closestOffset = Math.min(closestOffset, offset);
                    closeNeighbors.push(vNeighbor);
                }
            } catch (err) {
                _iterator19.e(err);
            } finally{
                _iterator19.f();
            }
            if (closeNeighbors.length === 0) {
                this.data({
                    closestOffset: closestOffset,
                    minOffset: minOffset
                });
                return true;
            }
            this.relatedNodes(closeNeighbors.map(function(_ref127) {
                var actualNode = _ref127.actualNode;
                return actualNode;
            }));
            if (!closeNeighbors.some(_isInTabOrder)) {
                this.data({
                    messageKey: "nonTabbableNeighbor",
                    closestOffset: closestOffset,
                    minOffset: minOffset
                });
                return void 0;
            }
            this.data({
                closestOffset: closestOffset,
                minOffset: minOffset
            });
            return _isInTabOrder(vNode) ? false : void 0;
        }
        function roundToSingleDecimal(num) {
            return Math.round(num * 10) / 10;
        }
        function targetSize(node, options, vNode) {
            var minSize = (options === null || options === void 0 ? void 0 : options.minSize) || 24;
            var nodeRect = vNode.boundingClientRect;
            var hasMinimumSize = _rectHasMinimumSize.bind(null, minSize);
            var nearbyElms = _findNearbyElms(vNode);
            var overflowingContent = filterOverflowingContent(vNode, nearbyElms);
            var _filterByElmsOverlap = filterByElmsOverlap(vNode, nearbyElms), fullyObscuringElms = _filterByElmsOverlap.fullyObscuringElms, partialObscuringElms = _filterByElmsOverlap.partialObscuringElms;
            if (fullyObscuringElms.length && !overflowingContent.length) {
                this.relatedNodes(mapActualNodes(fullyObscuringElms));
                this.data({
                    messageKey: "obscured"
                });
                return true;
            }
            var negativeOutcome = _isInTabOrder(vNode) ? false : void 0;
            if (!hasMinimumSize(nodeRect) && !overflowingContent.length) {
                this.data(_extends({
                    minSize: minSize
                }, toDecimalSize(nodeRect)));
                return negativeOutcome;
            }
            var obscuredWidgets = filterFocusableWidgets(partialObscuringElms);
            var largestInnerRect = getLargestUnobscuredArea(vNode, obscuredWidgets);
            if (overflowingContent.length) {
                if (fullyObscuringElms.length || !hasMinimumSize(largestInnerRect || nodeRect)) {
                    this.data({
                        minSize: minSize,
                        messageKey: "contentOverflow"
                    });
                    this.relatedNodes(mapActualNodes(overflowingContent));
                    return void 0;
                }
            }
            if (obscuredWidgets.length !== 0 && !hasMinimumSize(largestInnerRect)) {
                var allTabbable = obscuredWidgets.every(_isInTabOrder);
                var messageKey = "partiallyObscured".concat(allTabbable ? "" : "NonTabbable");
                this.data(_extends({
                    messageKey: messageKey,
                    minSize: minSize
                }, toDecimalSize(largestInnerRect)));
                this.relatedNodes(mapActualNodes(obscuredWidgets));
                return allTabbable ? negativeOutcome : void 0;
            }
            this.data(_extends({
                minSize: minSize
            }, toDecimalSize(largestInnerRect || nodeRect)));
            this.relatedNodes(mapActualNodes(obscuredWidgets));
            return true;
        }
        function filterOverflowingContent(vNode, nearbyElms) {
            return nearbyElms.filter(function(nearbyElm) {
                return !isEnclosedRect2(nearbyElm, vNode) && isDescendantNotInTabOrder2(vNode, nearbyElm);
            });
        }
        function filterByElmsOverlap(vNode, nearbyElms) {
            var fullyObscuringElms = [];
            var partialObscuringElms = [];
            var _iterator20 = _createForOfIteratorHelper(nearbyElms), _step20;
            try {
                for(_iterator20.s(); !(_step20 = _iterator20.n()).done;){
                    var vNeighbor = _step20.value;
                    if (!isDescendantNotInTabOrder2(vNode, vNeighbor) && _hasVisualOverlap(vNode, vNeighbor) && getCssPointerEvents(vNeighbor) !== "none") {
                        if (isEnclosedRect2(vNode, vNeighbor)) fullyObscuringElms.push(vNeighbor);
                        else partialObscuringElms.push(vNeighbor);
                    }
                }
            } catch (err) {
                _iterator20.e(err);
            } finally{
                _iterator20.f();
            }
            return {
                fullyObscuringElms: fullyObscuringElms,
                partialObscuringElms: partialObscuringElms
            };
        }
        function getLargestUnobscuredArea(vNode, obscuredNodes) {
            var nodeRect = vNode.boundingClientRect;
            if (obscuredNodes.length === 0) return null;
            var obscuringRects = obscuredNodes.map(function(_ref128) {
                var rect = _ref128.boundingClientRect;
                return rect;
            });
            var unobscuredRects = _splitRects(nodeRect, obscuringRects);
            return getLargestRect2(unobscuredRects);
        }
        function getLargestRect2(rects, minSize) {
            return rects.reduce(function(rectA, rectB) {
                var rectAisMinimum = _rectHasMinimumSize(minSize, rectA);
                var rectBisMinimum = _rectHasMinimumSize(minSize, rectB);
                if (rectAisMinimum !== rectBisMinimum) return rectAisMinimum ? rectA : rectB;
                var areaA = rectA.width * rectA.height;
                var areaB = rectB.width * rectB.height;
                return areaA > areaB ? rectA : rectB;
            });
        }
        function filterFocusableWidgets(vNodes) {
            return vNodes.filter(function(vNode) {
                return get_role_type_default(vNode) === "widget" && _isFocusable(vNode);
            });
        }
        function isEnclosedRect2(vNodeA, vNodeB) {
            var rectA = vNodeA.boundingClientRect;
            var rectB = vNodeB.boundingClientRect;
            return rectA.top >= rectB.top && rectA.left >= rectB.left && rectA.bottom <= rectB.bottom && rectA.right <= rectB.right;
        }
        function getCssPointerEvents(vNode) {
            return vNode.getComputedStylePropertyValue("pointer-events");
        }
        function toDecimalSize(rect) {
            return {
                width: Math.round(rect.width * 10) / 10,
                height: Math.round(rect.height * 10) / 10
            };
        }
        function isDescendantNotInTabOrder2(vAncestor, vNode) {
            return vAncestor.actualNode.contains(vNode.actualNode) && !_isInTabOrder(vNode);
        }
        function mapActualNodes(vNodes) {
            return vNodes.map(function(_ref129) {
                var actualNode = _ref129.actualNode;
                return actualNode;
            });
        }
        function headingOrderAfter(results) {
            var headingOrder = getHeadingOrder(results);
            results.forEach(function(result) {
                result.result = getHeadingOrderOutcome(result, headingOrder);
            });
            return results;
        }
        function getHeadingOrderOutcome(result, headingOrder) {
            var _headingOrder$index$l, _headingOrder$index, _headingOrder$level, _headingOrder;
            var index = findHeadingOrderIndex(headingOrder, result.node.ancestry);
            var currLevel = (_headingOrder$index$l = (_headingOrder$index = headingOrder[index]) === null || _headingOrder$index === void 0 ? void 0 : _headingOrder$index.level) !== null && _headingOrder$index$l !== void 0 ? _headingOrder$index$l : -1;
            var prevLevel = (_headingOrder$level = (_headingOrder = headingOrder[index - 1]) === null || _headingOrder === void 0 ? void 0 : _headingOrder.level) !== null && _headingOrder$level !== void 0 ? _headingOrder$level : -1;
            if (index === 0) return true;
            if (currLevel === -1) return void 0;
            return currLevel - prevLevel <= 1;
        }
        function getHeadingOrder(results) {
            results = _toConsumableArray(results);
            results.sort(function(_ref130, _ref131) {
                var nodeA = _ref130.node;
                var nodeB = _ref131.node;
                return nodeA.ancestry.length - nodeB.ancestry.length;
            });
            var headingOrder = results.reduce(mergeHeadingOrder, []);
            return headingOrder.filter(function(_ref132) {
                var level = _ref132.level;
                return level !== -1;
            });
        }
        function mergeHeadingOrder(mergedHeadingOrder, result) {
            var _result$data;
            var frameHeadingOrder = (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.headingOrder;
            var frameAncestry = shortenArray(result.node.ancestry, 1);
            if (!frameHeadingOrder) return mergedHeadingOrder;
            var normalizedHeadingOrder = frameHeadingOrder.map(function(heading) {
                return addFrameToHeadingAncestry(heading, frameAncestry);
            });
            var index = getFrameIndex(mergedHeadingOrder, frameAncestry);
            if (index === -1) mergedHeadingOrder.push.apply(mergedHeadingOrder, _toConsumableArray(normalizedHeadingOrder));
            else mergedHeadingOrder.splice.apply(mergedHeadingOrder, [
                index,
                0
            ].concat(_toConsumableArray(normalizedHeadingOrder)));
            return mergedHeadingOrder;
        }
        function getFrameIndex(headingOrder, frameAncestry) {
            while(frameAncestry.length){
                var index = findHeadingOrderIndex(headingOrder, frameAncestry);
                if (index !== -1) return index;
                frameAncestry = shortenArray(frameAncestry, 1);
            }
            return -1;
        }
        function findHeadingOrderIndex(headingOrder, ancestry) {
            return headingOrder.findIndex(function(heading) {
                return _matchAncestry(heading.ancestry, ancestry);
            });
        }
        function addFrameToHeadingAncestry(heading, frameAncestry) {
            var ancestry = frameAncestry.concat(heading.ancestry);
            return _extends({}, heading, {
                ancestry: ancestry
            });
        }
        function shortenArray(arr, spliceLength) {
            return arr.slice(0, arr.length - spliceLength);
        }
        function getLevel(vNode) {
            var role = get_role_default(vNode);
            var headingRole = role && role.includes("heading");
            var ariaHeadingLevel = vNode.attr("aria-level");
            var ariaLevel = parseInt(ariaHeadingLevel, 10);
            var _ref133 = vNode.props.nodeName.match(/h(\d)/) || [], _ref134 = _slicedToArray(_ref133, 2), headingLevel = _ref134[1];
            if (!headingRole) return -1;
            if (headingLevel && !ariaHeadingLevel) return parseInt(headingLevel, 10);
            if (isNaN(ariaLevel) || ariaLevel < 1) {
                if (headingLevel) return parseInt(headingLevel, 10);
                return 2;
            }
            if (ariaLevel) return ariaLevel;
            return -1;
        }
        function headingOrderEvaluate() {
            var headingOrder = cache_default.get("headingOrder");
            if (headingOrder) return true;
            var selector = "h1, h2, h3, h4, h5, h6, [role=heading], iframe, frame";
            var vNodes = query_selector_all_filter_default(axe._tree[0], selector, _isVisibleToScreenReaders);
            headingOrder = vNodes.map(function(vNode) {
                return {
                    ancestry: [
                        _getAncestry(vNode.actualNode)
                    ],
                    level: getLevel(vNode)
                };
            });
            this.data({
                headingOrder: headingOrder
            });
            cache_default.set("headingOrder", vNodes);
            return true;
        }
        var heading_order_evaluate_default = headingOrderEvaluate;
        function isIdenticalObject(a2, b2) {
            if (!a2 || !b2) return false;
            var aProps = Object.getOwnPropertyNames(a2);
            var bProps = Object.getOwnPropertyNames(b2);
            if (aProps.length !== bProps.length) return false;
            var result = aProps.every(function(propName) {
                var aValue = a2[propName];
                var bValue = b2[propName];
                if (_typeof(aValue) !== _typeof(bValue)) return false;
                if (_typeof(aValue) === "object" || _typeof(bValue) === "object") return isIdenticalObject(aValue, bValue);
                return aValue === bValue;
            });
            return result;
        }
        function identicalLinksSamePurposeAfter(results) {
            if (results.length < 2) return results;
            var incompleteResults = results.filter(function(_ref135) {
                var result = _ref135.result;
                return result !== void 0;
            });
            var uniqueResults = [];
            var nameMap = {};
            var _loop9 = function _loop9(index) {
                var _currentResult$relate;
                var currentResult = incompleteResults[index];
                var _currentResult$data = currentResult.data, name = _currentResult$data.name, urlProps = _currentResult$data.urlProps;
                if (nameMap[name]) return "continue";
                var sameNameResults = incompleteResults.filter(function(_ref136, resultNum) {
                    var data = _ref136.data;
                    return data.name === name && resultNum !== index;
                });
                var isSameUrl = sameNameResults.every(function(_ref137) {
                    var data = _ref137.data;
                    return isIdenticalObject(data.urlProps, urlProps);
                });
                if (sameNameResults.length && !isSameUrl) currentResult.result = void 0;
                currentResult.relatedNodes = [];
                (_currentResult$relate = currentResult.relatedNodes).push.apply(_currentResult$relate, _toConsumableArray(sameNameResults.map(function(node) {
                    return node.relatedNodes[0];
                })));
                nameMap[name] = sameNameResults;
                uniqueResults.push(currentResult);
            };
            for(var index = 0; index < incompleteResults.length; index++){
                var _ret7 = _loop9(index);
                if (_ret7 === "continue") continue;
            }
            return uniqueResults;
        }
        var identical_links_same_purpose_after_default = identicalLinksSamePurposeAfter;
        var commons_exports = {};
        __export(commons_exports, {
            aria: function aria() {
                return aria_exports;
            },
            color: function color() {
                return color_exports;
            },
            dom: function dom() {
                return dom_exports;
            },
            forms: function forms() {
                return forms_exports;
            },
            matches: function matches() {
                return matches_default2;
            },
            math: function math() {
                return math_exports;
            },
            standards: function standards() {
                return standards_exports;
            },
            table: function table() {
                return table_exports;
            },
            text: function text() {
                return text_exports;
            },
            utils: function utils() {
                return utils_exports;
            }
        });
        var forms_exports = {};
        __export(forms_exports, {
            isAriaCombobox: function isAriaCombobox() {
                return is_aria_combobox_default;
            },
            isAriaListbox: function isAriaListbox() {
                return is_aria_listbox_default;
            },
            isAriaRange: function isAriaRange() {
                return is_aria_range_default;
            },
            isAriaTextbox: function isAriaTextbox() {
                return is_aria_textbox_default;
            },
            isDisabled: function isDisabled() {
                return is_disabled_default;
            },
            isNativeSelect: function isNativeSelect() {
                return is_native_select_default;
            },
            isNativeTextbox: function isNativeTextbox() {
                return is_native_textbox_default;
            }
        });
        var disabledNodeNames = [
            "fieldset",
            "button",
            "select",
            "input",
            "textarea"
        ];
        function isDisabled(virtualNode) {
            var disabledState = virtualNode._isDisabled;
            if (typeof disabledState === "boolean") return disabledState;
            var nodeName2 = virtualNode.props.nodeName;
            var ariaDisabled = virtualNode.attr("aria-disabled");
            if (disabledNodeNames.includes(nodeName2) && virtualNode.hasAttr("disabled")) disabledState = true;
            else if (ariaDisabled) disabledState = ariaDisabled.toLowerCase() === "true";
            else if (virtualNode.parent) disabledState = isDisabled(virtualNode.parent);
            else disabledState = false;
            virtualNode._isDisabled = disabledState;
            return disabledState;
        }
        var is_disabled_default = isDisabled;
        var table_exports = {};
        __export(table_exports, {
            getAllCells: function getAllCells() {
                return get_all_cells_default;
            },
            getCellPosition: function getCellPosition() {
                return get_cell_position_default;
            },
            getHeaders: function getHeaders() {
                return get_headers_default;
            },
            getScope: function getScope() {
                return _getScope;
            },
            isColumnHeader: function isColumnHeader() {
                return is_column_header_default;
            },
            isDataCell: function isDataCell() {
                return is_data_cell_default;
            },
            isDataTable: function isDataTable() {
                return is_data_table_default;
            },
            isHeader: function isHeader() {
                return is_header_default;
            },
            isRowHeader: function isRowHeader() {
                return is_row_header_default;
            },
            toArray: function toArray() {
                return to_grid_default;
            },
            toGrid: function toGrid() {
                return to_grid_default;
            },
            traverse: function traverse() {
                return traverse_default;
            }
        });
        function getAllCells(tableElm) {
            var rowIndex, cellIndex, rowLength, cellLength;
            var cells = [];
            for(rowIndex = 0, rowLength = tableElm.rows.length; rowIndex < rowLength; rowIndex++)for(cellIndex = 0, cellLength = tableElm.rows[rowIndex].cells.length; cellIndex < cellLength; cellIndex++)cells.push(tableElm.rows[rowIndex].cells[cellIndex]);
            return cells;
        }
        var get_all_cells_default = getAllCells;
        function traverseForHeaders(headerType, position, tableGrid) {
            var property = headerType === "row" ? "_rowHeaders" : "_colHeaders";
            var predicate = headerType === "row" ? is_row_header_default : is_column_header_default;
            var startCell = tableGrid[position.y][position.x];
            var colspan = startCell.colSpan - 1;
            var rowspanAttr = startCell.getAttribute("rowspan");
            var rowspanValue = parseInt(rowspanAttr) === 0 || startCell.rowspan === 0 ? tableGrid.length : startCell.rowSpan;
            var rowspan = rowspanValue - 1;
            var rowStart = position.y + rowspan;
            var colStart = position.x + colspan;
            var rowEnd = headerType === "row" ? position.y : 0;
            var colEnd = headerType === "row" ? 0 : position.x;
            var headers;
            var cells = [];
            for(var row = rowStart; row >= rowEnd && !headers; row--)for(var col = colStart; col >= colEnd; col--){
                var cell = tableGrid[row] ? tableGrid[row][col] : void 0;
                if (!cell) continue;
                var vNode = axe.utils.getNodeFromTree(cell);
                if (vNode[property]) {
                    headers = vNode[property];
                    break;
                }
                cells.push(cell);
            }
            headers = (headers || []).concat(cells.filter(predicate));
            cells.forEach(function(tableCell) {
                var vNode = axe.utils.getNodeFromTree(tableCell);
                vNode[property] = headers;
            });
            return headers;
        }
        function getHeaders(cell, tableGrid) {
            if (cell.getAttribute("headers")) {
                var headers = idrefs_default(cell, "headers");
                if (headers.filter(function(header) {
                    return header;
                }).length) return headers;
            }
            if (!tableGrid) tableGrid = to_grid_default(find_up_default(cell, "table"));
            var position = get_cell_position_default(cell, tableGrid);
            var rowHeaders = traverseForHeaders("row", position, tableGrid);
            var colHeaders = traverseForHeaders("col", position, tableGrid);
            return [].concat(rowHeaders, colHeaders).reverse();
        }
        var get_headers_default = getHeaders;
        function isDataCell(cell) {
            if (!cell.children.length && !cell.textContent.trim()) return false;
            var role = cell.getAttribute("role");
            if (is_valid_role_default(role)) return [
                "cell",
                "gridcell"
            ].includes(role);
            else return cell.nodeName.toUpperCase() === "TD";
        }
        var is_data_cell_default = isDataCell;
        function isDataTable(node) {
            var role = (node.getAttribute("role") || "").toLowerCase();
            if ((role === "presentation" || role === "none") && !_isFocusable(node)) return false;
            if (node.getAttribute("contenteditable") === "true" || find_up_default(node, '[contenteditable="true"]')) return true;
            if (role === "grid" || role === "treegrid" || role === "table") return true;
            if (get_role_type_default(role) === "landmark") return true;
            if (node.getAttribute("datatable") === "0") return false;
            if (node.getAttribute("summary")) return true;
            if (node.tHead || node.tFoot || node.caption) return true;
            for(var childIndex = 0, childLength = node.children.length; childIndex < childLength; childIndex++){
                if (node.children[childIndex].nodeName.toUpperCase() === "COLGROUP") return true;
            }
            var cells = 0;
            var rowLength = node.rows.length;
            var row, cell;
            var hasBorder = false;
            for(var rowIndex = 0; rowIndex < rowLength; rowIndex++){
                row = node.rows[rowIndex];
                for(var cellIndex = 0, cellLength = row.cells.length; cellIndex < cellLength; cellIndex++){
                    cell = row.cells[cellIndex];
                    if (cell.nodeName.toUpperCase() === "TH") return true;
                    if (!hasBorder && (cell.offsetWidth !== cell.clientWidth || cell.offsetHeight !== cell.clientHeight)) hasBorder = true;
                    if (cell.getAttribute("scope") || cell.getAttribute("headers") || cell.getAttribute("abbr")) return true;
                    if ([
                        "columnheader",
                        "rowheader"
                    ].includes((cell.getAttribute("role") || "").toLowerCase())) return true;
                    if (cell.children.length === 1 && cell.children[0].nodeName.toUpperCase() === "ABBR") return true;
                    cells++;
                }
            }
            if (node.getElementsByTagName("table").length) return false;
            if (rowLength < 2) return false;
            var sampleRow = node.rows[Math.ceil(rowLength / 2)];
            if (sampleRow.cells.length === 1 && sampleRow.cells[0].colSpan === 1) return false;
            if (sampleRow.cells.length >= 5) return true;
            if (hasBorder) return true;
            var bgColor, bgImage;
            for(rowIndex = 0; rowIndex < rowLength; rowIndex++){
                row = node.rows[rowIndex];
                if (bgColor && bgColor !== window1.getComputedStyle(row).getPropertyValue("background-color")) return true;
                else bgColor = window1.getComputedStyle(row).getPropertyValue("background-color");
                if (bgImage && bgImage !== window1.getComputedStyle(row).getPropertyValue("background-image")) return true;
                else bgImage = window1.getComputedStyle(row).getPropertyValue("background-image");
            }
            if (rowLength >= 20) return true;
            if (get_element_coordinates_default(node).width > get_viewport_size_default(window1).width * .95) return false;
            if (cells < 10) return false;
            if (node.querySelector("object, embed, iframe, applet")) return false;
            return true;
        }
        var is_data_table_default = isDataTable;
        function isHeader(cell) {
            if (is_column_header_default(cell) || is_row_header_default(cell)) return true;
            if (cell.getAttribute("id")) {
                var _id5 = escape_selector_default(cell.getAttribute("id"));
                return !!document.querySelector('[headers~="'.concat(_id5, '"]'));
            }
            return false;
        }
        var is_header_default = isHeader;
        function traverseTable(dir, position, tableGrid, callback) {
            var result;
            var cell = tableGrid[position.y] ? tableGrid[position.y][position.x] : void 0;
            if (!cell) return [];
            if (typeof callback === "function") {
                result = callback(cell, position, tableGrid);
                if (result === true) return [
                    cell
                ];
            }
            result = traverseTable(dir, {
                x: position.x + dir.x,
                y: position.y + dir.y
            }, tableGrid, callback);
            result.unshift(cell);
            return result;
        }
        function traverse(dir, startPos, tableGrid, callback) {
            if (Array.isArray(startPos)) {
                callback = tableGrid;
                tableGrid = startPos;
                startPos = {
                    x: 0,
                    y: 0
                };
            }
            if (typeof dir === "string") switch(dir){
                case "left":
                    dir = {
                        x: -1,
                        y: 0
                    };
                    break;
                case "up":
                    dir = {
                        x: 0,
                        y: -1
                    };
                    break;
                case "right":
                    dir = {
                        x: 1,
                        y: 0
                    };
                    break;
                case "down":
                    dir = {
                        x: 0,
                        y: 1
                    };
                    break;
            }
            return traverseTable(dir, {
                x: startPos.x + dir.x,
                y: startPos.y + dir.y
            }, tableGrid, callback);
        }
        var traverse_default = traverse;
        function identicalLinksSamePurposeEvaluate(node, options, virtualNode) {
            var accText = text_exports.accessibleTextVirtual(virtualNode);
            var name = text_exports.sanitize(text_exports.removeUnicode(accText, {
                emoji: true,
                nonBmp: true,
                punctuations: true
            })).toLowerCase();
            if (!name) return void 0;
            var afterData = {
                name: name,
                urlProps: dom_exports.urlPropsFromAttribute(node, "href")
            };
            this.data(afterData);
            this.relatedNodes([
                node
            ]);
            return true;
        }
        var identical_links_same_purpose_evaluate_default = identicalLinksSamePurposeEvaluate;
        function internalLinkPresentEvaluate(node, options, virtualNode) {
            var links = query_selector_all_default(virtualNode, "a[href]");
            return links.some(function(vLink) {
                return /^#[^/!]/.test(vLink.attr("href"));
            });
        }
        var internal_link_present_evaluate_default = internalLinkPresentEvaluate;
        var separatorRegex = /[;,\s]/;
        var validRedirectNumRegex = /^[0-9.]+$/;
        function metaRefreshEvaluate(node, options, virtualNode) {
            var _ref138 = options || {}, minDelay = _ref138.minDelay, maxDelay = _ref138.maxDelay;
            var content = (virtualNode.attr("content") || "").trim();
            var _content$split = content.split(separatorRegex), _content$split2 = _slicedToArray(_content$split, 1), redirectStr = _content$split2[0];
            if (!redirectStr.match(validRedirectNumRegex)) return true;
            var redirectDelay = parseFloat(redirectStr);
            this.data({
                redirectDelay: redirectDelay
            });
            if (typeof minDelay === "number" && redirectDelay <= options.minDelay) return true;
            if (typeof maxDelay === "number" && redirectDelay > options.maxDelay) return true;
            return false;
        }
        function normalizeFontWeight(weight) {
            switch(weight){
                case "lighter":
                    return 100;
                case "normal":
                    return 400;
                case "bold":
                    return 700;
                case "bolder":
                    return 900;
            }
            weight = parseInt(weight);
            return !isNaN(weight) ? weight : 400;
        }
        function getTextContainer(elm) {
            var nextNode = elm;
            var outerText = elm.textContent.trim();
            var innerText = outerText;
            while(innerText === outerText && nextNode !== void 0){
                var _i35 = -1;
                elm = nextNode;
                if (elm.children.length === 0) return elm;
                do {
                    _i35++;
                    innerText = elm.children[_i35].textContent.trim();
                }while (innerText === "" && _i35 + 1 < elm.children.length);
                nextNode = elm.children[_i35];
            }
            return elm;
        }
        function getStyleValues(node) {
            var style = window1.getComputedStyle(getTextContainer(node));
            return {
                fontWeight: normalizeFontWeight(style.getPropertyValue("font-weight")),
                fontSize: parseInt(style.getPropertyValue("font-size")),
                isItalic: style.getPropertyValue("font-style") === "italic"
            };
        }
        function isHeaderStyle(styleA, styleB, margins) {
            return margins.reduce(function(out, margin) {
                return out || (!margin.size || styleA.fontSize / margin.size > styleB.fontSize) && (!margin.weight || styleA.fontWeight - margin.weight > styleB.fontWeight) && (!margin.italic || styleA.isItalic && !styleB.isItalic);
            }, false);
        }
        function pAsHeadingEvaluate(node, options, virtualNode) {
            var siblings = Array.from(node.parentNode.children);
            var currentIndex = siblings.indexOf(node);
            options = options || {};
            var margins = options.margins || [];
            var nextSibling = siblings.slice(currentIndex + 1).find(function(elm) {
                return elm.nodeName.toUpperCase() === "P";
            });
            var prevSibling = siblings.slice(0, currentIndex).reverse().find(function(elm) {
                return elm.nodeName.toUpperCase() === "P";
            });
            var currStyle = getStyleValues(node);
            var nextStyle = nextSibling ? getStyleValues(nextSibling) : null;
            var prevStyle = prevSibling ? getStyleValues(prevSibling) : null;
            var optionsPassLength = options.passLength;
            var optionsFailLength = options.failLength;
            var headingLength = node.textContent.trim().length;
            var paragraphLength = nextSibling === null || nextSibling === void 0 ? void 0 : nextSibling.textContent.trim().length;
            if (headingLength > paragraphLength * optionsPassLength) return true;
            if (!nextStyle || !isHeaderStyle(currStyle, nextStyle, margins)) return true;
            var blockquote = find_up_virtual_default(virtualNode, "blockquote");
            if (blockquote && blockquote.nodeName.toUpperCase() === "BLOCKQUOTE") return void 0;
            if (prevStyle && !isHeaderStyle(currStyle, prevStyle, margins)) return void 0;
            if (headingLength > paragraphLength * optionsFailLength) return void 0;
            return false;
        }
        var p_as_heading_evaluate_default = pAsHeadingEvaluate;
        function regionAfter(results) {
            var iframeResults = results.filter(function(r) {
                return r.data.isIframe;
            });
            results.forEach(function(r) {
                if (r.result || r.node.ancestry.length === 1) return;
                var frameAncestry = r.node.ancestry.slice(0, -1);
                var _iterator21 = _createForOfIteratorHelper(iframeResults), _step21;
                try {
                    for(_iterator21.s(); !(_step21 = _iterator21.n()).done;){
                        var iframeResult = _step21.value;
                        if (_matchAncestry(frameAncestry, iframeResult.node.ancestry)) {
                            r.result = iframeResult.result;
                            break;
                        }
                    }
                } catch (err) {
                    _iterator21.e(err);
                } finally{
                    _iterator21.f();
                }
            });
            iframeResults.forEach(function(r) {
                if (!r.result) r.result = true;
            });
            return results;
        }
        var region_after_default = regionAfter;
        var implicitAriaLiveRoles = [
            "alert",
            "log",
            "status"
        ];
        function regionEvaluate(node, options, virtualNode) {
            this.data({
                isIframe: [
                    "iframe",
                    "frame"
                ].includes(virtualNode.props.nodeName)
            });
            var regionlessNodes = cache_default.get("regionlessNodes", function() {
                return getRegionlessNodes(options);
            });
            return !regionlessNodes.includes(virtualNode);
        }
        function getRegionlessNodes(options) {
            var regionlessNodes = findRegionlessElms(axe._tree[0], options).map(function(vNode) {
                while(vNode.parent && !vNode.parent._hasRegionDescendant && vNode.parent.actualNode !== document.body)vNode = vNode.parent;
                return vNode;
            }).filter(function(vNode, index, array) {
                return array.indexOf(vNode) === index;
            });
            return regionlessNodes;
        }
        function findRegionlessElms(virtualNode, options) {
            var node = virtualNode.actualNode;
            if (get_role_default(virtualNode) === "button" || isRegion(virtualNode, options) || [
                "iframe",
                "frame"
            ].includes(virtualNode.props.nodeName) || _isSkipLink(virtualNode.actualNode) && get_element_by_reference_default(virtualNode.actualNode, "href") || !_isVisibleToScreenReaders(node)) {
                var vNode = virtualNode;
                while(vNode){
                    vNode._hasRegionDescendant = true;
                    vNode = vNode.parent;
                }
                if ([
                    "iframe",
                    "frame"
                ].includes(virtualNode.props.nodeName)) return [
                    virtualNode
                ];
                return [];
            } else if (node !== document.body && has_content_default(node, true)) return [
                virtualNode
            ];
            else return virtualNode.children.filter(function(_ref139) {
                var actualNode = _ref139.actualNode;
                return actualNode.nodeType === 1;
            }).map(function(vNode) {
                return findRegionlessElms(vNode, options);
            }).reduce(function(a2, b2) {
                return a2.concat(b2);
            }, []);
        }
        function isRegion(virtualNode, options) {
            var node = virtualNode.actualNode;
            var role = get_role_default(virtualNode);
            var ariaLive = (node.getAttribute("aria-live") || "").toLowerCase().trim();
            var landmarkRoles2 = get_aria_roles_by_type_default("landmark");
            if ([
                "assertive",
                "polite"
            ].includes(ariaLive) || implicitAriaLiveRoles.includes(role)) return true;
            if (landmarkRoles2.includes(role)) return true;
            if (options.regionMatcher && matches_default2(virtualNode, options.regionMatcher)) return true;
            return false;
        }
        function skipLinkEvaluate(node) {
            var target = get_element_by_reference_default(node, "href");
            if (target) return _isVisibleToScreenReaders(target) || void 0;
            return false;
        }
        var skip_link_evaluate_default = skipLinkEvaluate;
        function uniqueFrameTitleAfter(results) {
            var titles = {};
            results.forEach(function(r) {
                titles[r.data] = titles[r.data] !== void 0 ? ++titles[r.data] : 0;
            });
            results.forEach(function(r) {
                r.result = !!titles[r.data];
            });
            return results;
        }
        var unique_frame_title_after_default = uniqueFrameTitleAfter;
        function uniqueFrameTitleEvaluate(node, options, vNode) {
            var title = sanitize_default(vNode.attr("title")).toLowerCase();
            this.data(title);
            return true;
        }
        var unique_frame_title_evaluate_default = uniqueFrameTitleEvaluate;
        function duplicateIdAfter(results) {
            var uniqueIds = [];
            return results.filter(function(r) {
                if (uniqueIds.indexOf(r.data) === -1) {
                    uniqueIds.push(r.data);
                    return true;
                }
                return false;
            });
        }
        var duplicate_id_after_default = duplicateIdAfter;
        function duplicateIdEvaluate(node) {
            var id = node.getAttribute("id").trim();
            if (!id) return true;
            var root = get_root_node_default2(node);
            var matchingNodes = Array.from(root.querySelectorAll('[id="'.concat(escape_selector_default(id), '"]'))).filter(function(foundNode) {
                return foundNode !== node;
            });
            if (matchingNodes.length) this.relatedNodes(matchingNodes);
            this.data(id);
            return matchingNodes.length === 0;
        }
        var duplicate_id_evaluate_default = duplicateIdEvaluate;
        function ariaLabelEvaluate(node, options, virtualNode) {
            return !!sanitize_default(_arialabelText(virtualNode));
        }
        var aria_label_evaluate_default = ariaLabelEvaluate;
        function ariaLabelledbyEvaluate(node, options, virtualNode) {
            try {
                return !!sanitize_default(arialabelledby_text_default(virtualNode));
            } catch (e) {
                return void 0;
            }
        }
        var aria_labelledby_evaluate_default = ariaLabelledbyEvaluate;
        function avoidInlineSpacingEvaluate(node, options) {
            var overriddenProperties = options.cssProperties.filter(function(property) {
                if (node.style.getPropertyPriority(property) === "important") return property;
            });
            if (overriddenProperties.length > 0) {
                this.data(overriddenProperties);
                return false;
            }
            return true;
        }
        var avoid_inline_spacing_evaluate_default = avoidInlineSpacingEvaluate;
        function docHasTitleEvaluate() {
            var title = document.title;
            return !!sanitize_default(title);
        }
        var doc_has_title_evaluate_default = docHasTitleEvaluate;
        function existsEvaluate() {
            return void 0;
        }
        var exists_evaluate_default = existsEvaluate;
        function hasAltEvaluate(node, options, virtualNode) {
            var nodeName2 = virtualNode.props.nodeName;
            if (![
                "img",
                "input",
                "area"
            ].includes(nodeName2)) return false;
            return virtualNode.hasAttr("alt");
        }
        var has_alt_evaluate_default = hasAltEvaluate;
        function inlineStyleProperty(node, options) {
            var cssProperty = options.cssProperty, absoluteValues = options.absoluteValues, minValue = options.minValue, maxValue = options.maxValue, _options$normalValue = options.normalValue, normalValue = _options$normalValue === void 0 ? 0 : _options$normalValue, noImportant = options.noImportant, multiLineOnly = options.multiLineOnly;
            if (!noImportant && node.style.getPropertyPriority(cssProperty) !== "important" || multiLineOnly && !_isMultiline(node)) return true;
            var data = {};
            if (typeof minValue === "number") data.minValue = minValue;
            if (typeof maxValue === "number") data.maxValue = maxValue;
            var declaredPropValue = node.style.getPropertyValue(cssProperty);
            if ([
                "inherit",
                "unset",
                "revert",
                "revert-layer"
            ].includes(declaredPropValue)) {
                this.data(_extends({
                    value: declaredPropValue
                }, data));
                return true;
            }
            var value = getNumberValue(node, {
                absoluteValues: absoluteValues,
                cssProperty: cssProperty,
                normalValue: normalValue
            });
            this.data(_extends({
                value: value
            }, data));
            if (typeof value !== "number") return void 0;
            if ((typeof minValue !== "number" || value >= minValue) && (typeof maxValue !== "number" || value <= maxValue)) return true;
            return false;
        }
        function getNumberValue(domNode, _ref140) {
            var cssProperty = _ref140.cssProperty, absoluteValues = _ref140.absoluteValues, normalValue = _ref140.normalValue;
            var computedStyle = window1.getComputedStyle(domNode);
            var cssPropValue = computedStyle.getPropertyValue(cssProperty);
            if (cssPropValue === "normal") return normalValue;
            var parsedValue = parseFloat(cssPropValue);
            if (absoluteValues) return parsedValue;
            var fontSize = parseFloat(computedStyle.getPropertyValue("font-size"));
            var value = Math.round(parsedValue / fontSize * 100) / 100;
            if (isNaN(value)) return cssPropValue;
            return value;
        }
        function isOnScreenEvaluate(node) {
            return _isVisibleOnScreen(node);
        }
        var is_on_screen_evaluate_default = isOnScreenEvaluate;
        function nonEmptyIfPresentEvaluate(node, options, virtualNode) {
            var nodeName2 = virtualNode.props.nodeName;
            var type2 = (virtualNode.attr("type") || "").toLowerCase();
            var label3 = virtualNode.attr("value");
            if (label3) this.data({
                messageKey: "has-label"
            });
            if (nodeName2 === "input" && [
                "submit",
                "reset"
            ].includes(type2)) return label3 === null;
            return false;
        }
        var non_empty_if_present_evaluate_default = nonEmptyIfPresentEvaluate;
        function presentationalRoleEvaluate(node, options, virtualNode) {
            var explicitRole2 = get_explicit_role_default(virtualNode);
            if ([
                "presentation",
                "none"
            ].includes(explicitRole2) && [
                "iframe",
                "frame"
            ].includes(virtualNode.props.nodeName) && virtualNode.hasAttr("title")) {
                this.data({
                    messageKey: "iframe",
                    nodeName: virtualNode.props.nodeName
                });
                return false;
            }
            var role = get_role_default(virtualNode);
            if ([
                "presentation",
                "none"
            ].includes(role)) {
                this.data({
                    role: role
                });
                return true;
            }
            if (![
                "presentation",
                "none"
            ].includes(explicitRole2)) return false;
            var hasGlobalAria = get_global_aria_attrs_default().some(function(attr) {
                return virtualNode.hasAttr(attr);
            });
            var focusable = _isFocusable(virtualNode);
            var messageKey;
            if (hasGlobalAria && !focusable) messageKey = "globalAria";
            else if (!hasGlobalAria && focusable) messageKey = "focusable";
            else messageKey = "both";
            this.data({
                messageKey: messageKey,
                role: role
            });
            return false;
        }
        function svgNonEmptyTitleEvaluate(node, options, virtualNode) {
            if (!virtualNode.children) return void 0;
            var titleNode = virtualNode.children.find(function(_ref141) {
                var props = _ref141.props;
                return props.nodeName === "title";
            });
            if (!titleNode) {
                this.data({
                    messageKey: "noTitle"
                });
                return false;
            }
            try {
                var titleText2 = subtree_text_default(titleNode, {
                    includeHidden: true
                }).trim();
                if (titleText2 === "") {
                    this.data({
                        messageKey: "emptyTitle"
                    });
                    return false;
                }
            } catch (e) {
                return void 0;
            }
            return true;
        }
        var svg_non_empty_title_evaluate_default = svgNonEmptyTitleEvaluate;
        function captionFakedEvaluate(node) {
            var table = to_grid_default(node);
            var firstRow = table[0];
            if (table.length <= 1 || firstRow.length <= 1 || node.rows.length <= 1) return true;
            return firstRow.reduce(function(out, curr, i) {
                return out || curr !== firstRow[i + 1] && firstRow[i + 1] !== void 0;
            }, false);
        }
        var caption_faked_evaluate_default = captionFakedEvaluate;
        function html5ScopeEvaluate(node) {
            if (!is_html5_default(document)) return true;
            return node.nodeName.toUpperCase() === "TH";
        }
        var html5_scope_evaluate_default = html5ScopeEvaluate;
        var same_caption_summary_evaluate_default = sameCaptionSummaryEvaluate;
        function sameCaptionSummaryEvaluate(node, options, virtualNode) {
            if (virtualNode.children === void 0) return void 0;
            var summary = virtualNode.attr("summary");
            var captionNode = virtualNode.children.find(isCaptionNode);
            var caption = captionNode ? sanitize_default(subtree_text_default(captionNode)) : false;
            if (!caption || !summary) return false;
            return sanitize_default(summary).toLowerCase() === sanitize_default(caption).toLowerCase();
        }
        function isCaptionNode(virtualNode) {
            return virtualNode.props.nodeName === "caption";
        }
        function scopeValueEvaluate(node, options) {
            var value = node.getAttribute("scope").toLowerCase();
            return options.values.indexOf(value) !== -1;
        }
        var scope_value_evaluate_default = scopeValueEvaluate;
        function tdHasHeaderEvaluate(node) {
            var badCells = [];
            var cells = get_all_cells_default(node);
            var tableGrid = to_grid_default(node);
            cells.forEach(function(cell) {
                if (has_content_default(cell) && is_data_cell_default(cell) && !label_default2(cell)) {
                    var hasHeaders = get_headers_default(cell, tableGrid).some(function(header) {
                        return header !== null && !!has_content_default(header);
                    });
                    if (!hasHeaders) badCells.push(cell);
                }
            });
            if (badCells.length) {
                this.relatedNodes(badCells);
                return false;
            }
            return true;
        }
        var td_has_header_evaluate_default = tdHasHeaderEvaluate;
        function tdHeadersAttrEvaluate(node) {
            var cells = [];
            var reviewCells = [];
            var badCells = [];
            for(var rowIndex = 0; rowIndex < node.rows.length; rowIndex++){
                var row = node.rows[rowIndex];
                for(var cellIndex = 0; cellIndex < row.cells.length; cellIndex++)cells.push(row.cells[cellIndex]);
            }
            var ids = cells.filter(function(cell) {
                return cell.getAttribute("id");
            }).map(function(cell) {
                return cell.getAttribute("id");
            });
            cells.forEach(function(cell) {
                var isSelf = false;
                var notOfTable = false;
                if (!cell.hasAttribute("headers") || !_isVisibleToScreenReaders(cell)) return;
                var headersAttr = cell.getAttribute("headers").trim();
                if (!headersAttr) return reviewCells.push(cell);
                var headers = token_list_default(headersAttr);
                if (headers.length !== 0) {
                    if (cell.getAttribute("id")) isSelf = headers.indexOf(cell.getAttribute("id").trim()) !== -1;
                    notOfTable = headers.some(function(header) {
                        return !ids.includes(header);
                    });
                    if (isSelf || notOfTable) badCells.push(cell);
                }
            });
            if (badCells.length > 0) {
                this.relatedNodes(badCells);
                return false;
            }
            if (reviewCells.length) {
                this.relatedNodes(reviewCells);
                return void 0;
            }
            return true;
        }
        function thHasDataCellsEvaluate(node) {
            var cells = get_all_cells_default(node);
            var checkResult = this;
            var reffedHeaders = [];
            cells.forEach(function(cell) {
                var headers2 = cell.getAttribute("headers");
                if (headers2) reffedHeaders = reffedHeaders.concat(headers2.split(/\s+/));
                var ariaLabel = cell.getAttribute("aria-labelledby");
                if (ariaLabel) reffedHeaders = reffedHeaders.concat(ariaLabel.split(/\s+/));
            });
            var headers = cells.filter(function(cell) {
                if (sanitize_default(cell.textContent) === "") return false;
                return cell.nodeName.toUpperCase() === "TH" || [
                    "rowheader",
                    "columnheader"
                ].indexOf(cell.getAttribute("role")) !== -1;
            });
            var tableGrid = to_grid_default(node);
            var out = true;
            headers.forEach(function(header) {
                if (header.getAttribute("id") && reffedHeaders.includes(header.getAttribute("id"))) return;
                var pos = get_cell_position_default(header, tableGrid);
                var hasCell = false;
                if (is_column_header_default(header)) hasCell = traverse_default("down", pos, tableGrid).find(function(cell) {
                    return !is_column_header_default(cell) && get_headers_default(cell, tableGrid).includes(header);
                });
                if (!hasCell && is_row_header_default(header)) hasCell = traverse_default("right", pos, tableGrid).find(function(cell) {
                    return !is_row_header_default(cell) && get_headers_default(cell, tableGrid).includes(header);
                });
                if (!hasCell) checkResult.relatedNodes(header);
                out = out && hasCell;
            });
            return out ? true : void 0;
        }
        var th_has_data_cells_evaluate_default = thHasDataCellsEvaluate;
        function hiddenContentEvaluate(node, options, virtualNode) {
            var allowlist = [
                "SCRIPT",
                "HEAD",
                "TITLE",
                "NOSCRIPT",
                "STYLE",
                "TEMPLATE"
            ];
            if (!allowlist.includes(node.nodeName.toUpperCase()) && has_content_virtual_default(virtualNode)) {
                var styles = window1.getComputedStyle(node);
                if (styles.getPropertyValue("display") === "none") return void 0;
                else if (styles.getPropertyValue("visibility") === "hidden") {
                    var parent = get_composed_parent_default(node);
                    var parentStyle = parent && window1.getComputedStyle(parent);
                    if (!parentStyle || parentStyle.getPropertyValue("visibility") !== "hidden") return void 0;
                }
            }
            return true;
        }
        var hidden_content_evaluate_default = hiddenContentEvaluate;
        function ariaAllowedAttrMatches(node, virtualNode) {
            var aria = /^aria-/;
            var attrs = virtualNode.attrNames;
            if (attrs.length) for(var _i36 = 0, l = attrs.length; _i36 < l; _i36++){
                if (aria.test(attrs[_i36])) return true;
            }
            return false;
        }
        var aria_allowed_attr_matches_default = ariaAllowedAttrMatches;
        function ariaAllowedRoleMatches(node, virtualNode) {
            return get_explicit_role_default(virtualNode, {
                dpub: true,
                fallback: true
            }) !== null;
        }
        var aria_allowed_role_matches_default = ariaAllowedRoleMatches;
        function ariaHasAttrMatches(node, virtualNode) {
            var aria = /^aria-/;
            return virtualNode.attrNames.some(function(attr) {
                return aria.test(attr);
            });
        }
        var aria_has_attr_matches_default = ariaHasAttrMatches;
        function shouldMatchElement(el) {
            if (!el) return true;
            if (el.getAttribute("aria-hidden") === "true") return false;
            return shouldMatchElement(get_composed_parent_default(el));
        }
        function ariaHiddenFocusMatches(node) {
            return shouldMatchElement(get_composed_parent_default(node));
        }
        var aria_hidden_focus_matches_default = ariaHiddenFocusMatches;
        function ariaRequiredChildrenMatches(node, virtualNode) {
            var role = get_explicit_role_default(virtualNode, {
                dpub: true
            });
            return !!required_owned_default(role);
        }
        var aria_required_children_matches_default = ariaRequiredChildrenMatches;
        function ariaRequiredParentMatches(node, virtualNode) {
            var role = get_explicit_role_default(virtualNode);
            return !!required_context_default(role);
        }
        var aria_required_parent_matches_default = ariaRequiredParentMatches;
        function autocompleteMatches(node, virtualNode) {
            var autocomplete2 = virtualNode.attr("autocomplete");
            if (!autocomplete2 || sanitize_default(autocomplete2) === "") return false;
            var nodeName2 = virtualNode.props.nodeName;
            if ([
                "textarea",
                "input",
                "select"
            ].includes(nodeName2) === false) return false;
            var excludedInputTypes = [
                "submit",
                "reset",
                "button",
                "hidden"
            ];
            if (nodeName2 === "input" && excludedInputTypes.includes(virtualNode.props.type)) return false;
            var ariaDisabled = virtualNode.attr("aria-disabled") || "false";
            if (virtualNode.hasAttr("disabled") || ariaDisabled.toLowerCase() === "true") return false;
            var role = virtualNode.attr("role");
            var tabIndex = virtualNode.attr("tabindex");
            if (tabIndex === "-1" && role) {
                var roleDef = standards_default.ariaRoles[role];
                if (roleDef === void 0 || roleDef.type !== "widget") return false;
            }
            if (tabIndex === "-1" && virtualNode.actualNode && !_isVisibleOnScreen(virtualNode) && !_isVisibleToScreenReaders(virtualNode)) return false;
            return true;
        }
        var autocomplete_matches_default = autocompleteMatches;
        function isInitiatorMatches(node, virtualNode, context) {
            return context.initiator;
        }
        var is_initiator_matches_default = isInitiatorMatches;
        function bypassMatches(node, virtualNode, context) {
            if (is_initiator_matches_default(node, virtualNode, context)) return !!node.querySelector("a[href]");
            return true;
        }
        var bypass_matches_default = bypassMatches;
        function colorContrastMatches(node, virtualNode) {
            var _virtualNode$props2 = virtualNode.props, nodeName2 = _virtualNode$props2.nodeName, inputType = _virtualNode$props2.type;
            if (nodeName2 === "option") return false;
            if (nodeName2 === "select" && !node.options.length) return false;
            var nonTextInput = [
                "hidden",
                "range",
                "color",
                "checkbox",
                "radio",
                "image"
            ];
            if (nodeName2 === "input" && nonTextInput.includes(inputType)) return false;
            if (is_disabled_default(virtualNode) || _isInert(virtualNode)) return false;
            var formElements = [
                "input",
                "select",
                "textarea"
            ];
            if (formElements.includes(nodeName2)) {
                var style = window1.getComputedStyle(node);
                var textIndent = parseInt(style.getPropertyValue("text-indent"), 10);
                if (textIndent) {
                    var rect = node.getBoundingClientRect();
                    rect = {
                        top: rect.top,
                        bottom: rect.bottom,
                        left: rect.left + textIndent,
                        right: rect.right + textIndent
                    };
                    if (!visually_overlaps_default(rect, node)) return false;
                }
                return true;
            }
            var nodeParentLabel = find_up_virtual_default(virtualNode, "label");
            if (nodeName2 === "label" || nodeParentLabel) {
                var labelNode = nodeParentLabel || node;
                var labelVirtual3 = nodeParentLabel ? get_node_from_tree_default(nodeParentLabel) : virtualNode;
                if (labelNode.htmlFor) {
                    var doc = get_root_node_default2(labelNode);
                    var explicitControl = doc.getElementById(labelNode.htmlFor);
                    var explicitControlVirtual = explicitControl && get_node_from_tree_default(explicitControl);
                    if (explicitControlVirtual && is_disabled_default(explicitControlVirtual)) return false;
                }
                var query = 'input:not([type="hidden"],[type="image"],[type="button"],[type="submit"],[type="reset"]), select, textarea';
                var implicitControl = query_selector_all_default(labelVirtual3, query)[0];
                if (implicitControl && is_disabled_default(implicitControl)) return false;
            }
            var ariaLabelledbyControls = [];
            var ancestorNode = virtualNode;
            while(ancestorNode){
                if (ancestorNode.props.id) {
                    var virtualControls = get_accessible_refs_default(ancestorNode).filter(function(control) {
                        return token_list_default(control.getAttribute("aria-labelledby") || "").includes(ancestorNode.props.id);
                    }).map(function(control) {
                        return get_node_from_tree_default(control);
                    });
                    ariaLabelledbyControls.push.apply(ariaLabelledbyControls, _toConsumableArray(virtualControls));
                }
                ancestorNode = ancestorNode.parent;
            }
            if (ariaLabelledbyControls.length > 0 && ariaLabelledbyControls.every(is_disabled_default)) return false;
            if (!hasRealTextChildren(virtualNode)) return false;
            var range2 = document.createRange();
            var childNodes = virtualNode.children;
            for(var index = 0; index < childNodes.length; index++){
                var child = childNodes[index];
                if (child.actualNode.nodeType === 3 && sanitize_default(child.actualNode.nodeValue) !== "") range2.selectNodeContents(child.actualNode);
            }
            var rects = range2.getClientRects();
            for(var _index2 = 0; _index2 < rects.length; _index2++){
                if (visually_overlaps_default(rects[_index2], node)) return true;
            }
            return false;
        }
        var color_contrast_matches_default = colorContrastMatches;
        var removeUnicodeOptions = {
            emoji: true,
            nonBmp: false,
            punctuations: true
        };
        function hasRealTextChildren(virtualNode) {
            var visibleText = visible_virtual_default(virtualNode, false, true);
            if (visibleText === "" || remove_unicode_default(visibleText, removeUnicodeOptions) === "") return false;
            return virtualNode.children.some(function(vChild) {
                return vChild.props.nodeName === "#text" && !_isIconLigature(vChild);
            });
        }
        function dataTableLargeMatches(node) {
            if (is_data_table_default(node)) {
                var tableArray = to_grid_default(node);
                return tableArray.length >= 3 && tableArray[0].length >= 3 && tableArray[1].length >= 3 && tableArray[2].length >= 3;
            }
            return false;
        }
        var data_table_large_matches_default = dataTableLargeMatches;
        function dataTableMatches(node) {
            return is_data_table_default(node);
        }
        var data_table_matches_default = dataTableMatches;
        function duplicateIdActiveMatches(node) {
            var id = node.getAttribute("id").trim();
            var idSelector = '*[id="'.concat(escape_selector_default(id), '"]');
            var idMatchingElms = Array.from(get_root_node_default2(node).querySelectorAll(idSelector));
            return !is_accessible_ref_default(node) && idMatchingElms.some(_isFocusable);
        }
        var duplicate_id_active_matches_default = duplicateIdActiveMatches;
        function duplicateIdAriaMatches(node) {
            return is_accessible_ref_default(node);
        }
        var duplicate_id_aria_matches_default = duplicateIdAriaMatches;
        function duplicateIdMiscMatches(node) {
            var id = node.getAttribute("id").trim();
            var idSelector = '*[id="'.concat(escape_selector_default(id), '"]');
            var idMatchingElms = Array.from(get_root_node_default2(node).querySelectorAll(idSelector));
            return !is_accessible_ref_default(node) && idMatchingElms.every(function(elm) {
                return !_isFocusable(elm);
            });
        }
        var duplicate_id_misc_matches_default = duplicateIdMiscMatches;
        function frameFocusableContentMatches(node, virtualNode, context) {
            var _context$size, _context$size2;
            return !context.initiator && !context.focusable && ((_context$size = context.size) === null || _context$size === void 0 ? void 0 : _context$size.width) * ((_context$size2 = context.size) === null || _context$size2 === void 0 ? void 0 : _context$size2.height) > 1;
        }
        var frame_focusable_content_matches_default = frameFocusableContentMatches;
        function frameTitleHasTextMatches(node) {
            var title = node.getAttribute("title");
            return !!sanitize_default(title);
        }
        var frame_title_has_text_matches_default = frameTitleHasTextMatches;
        function hasImplicitChromiumRoleMatches(node, virtualNode) {
            return implicit_role_default(virtualNode, {
                chromium: true
            }) !== null;
        }
        var has_implicit_chromium_role_matches_default = hasImplicitChromiumRoleMatches;
        function headingMatches(node, virtualNode) {
            return get_role_default(virtualNode) === "heading";
        }
        function svgNamespaceMatches(node, virtualNode) {
            try {
                var nodeName2 = virtualNode.props.nodeName;
                if (nodeName2 === "svg") return true;
                return !!closest_default(virtualNode, "svg");
            } catch (e) {
                return false;
            }
        }
        var svg_namespace_matches_default = svgNamespaceMatches;
        function htmlNamespaceMatches(node, virtualNode) {
            return !svg_namespace_matches_default(node, virtualNode);
        }
        var html_namespace_matches_default = htmlNamespaceMatches;
        function identicalLinksSamePurposeMatches(node, virtualNode) {
            var hasAccName = !!_accessibleTextVirtual(virtualNode);
            if (!hasAccName) return false;
            var role = get_role_default(node);
            if (role && role !== "link") return false;
            return true;
        }
        var identical_links_same_purpose_matches_default = identicalLinksSamePurposeMatches;
        function insertedIntoFocusOrderMatches(node) {
            return inserted_into_focus_order_default(node);
        }
        var inserted_into_focus_order_matches_default = insertedIntoFocusOrderMatches;
        function hasVisibleTextMatches(node) {
            return _isVisibleOnScreen(node);
        }
        function isVisibleOnScreenMatches(node, virtualNode) {
            return _isVisibleOnScreen(virtualNode);
        }
        function labelContentNameMismatchMatches(node, virtualNode) {
            var role = get_role_default(node);
            if (!role) return false;
            var widgetRoles = get_aria_roles_by_type_default("widget");
            var isWidgetType2 = widgetRoles.includes(role);
            if (!isWidgetType2) return false;
            var rolesWithNameFromContents = get_aria_roles_supporting_name_from_content_default();
            if (!rolesWithNameFromContents.includes(role)) return false;
            if (!sanitize_default(_arialabelText(virtualNode)) && !sanitize_default(arialabelledby_text_default(node))) return false;
            if (!sanitize_default(visible_virtual_default(virtualNode))) return false;
            return true;
        }
        var label_content_name_mismatch_matches_default = labelContentNameMismatchMatches;
        function labelMatches(node, virtualNode) {
            if (virtualNode.props.nodeName !== "input" || virtualNode.hasAttr("type") === false) return true;
            var type2 = virtualNode.attr("type").toLowerCase();
            return [
                "hidden",
                "image",
                "button",
                "submit",
                "reset"
            ].includes(type2) === false;
        }
        var label_matches_default = labelMatches;
        function landmarkHasBodyContextMatches(node, virtualNode) {
            var nativeScopeFilter = "article, aside, main, nav, section";
            return node.hasAttribute("role") || !find_up_virtual_default(virtualNode, nativeScopeFilter);
        }
        var landmark_has_body_context_matches_default = landmarkHasBodyContextMatches;
        var excludedParentsForHeaderFooterLandmarks = [
            "article",
            "aside",
            "main",
            "nav",
            "section"
        ].join(",");
        function landmarkUniqueMatches(node, virtualNode) {
            return isLandmarkVirtual(virtualNode) && _isVisibleToScreenReaders(virtualNode);
        }
        function isLandmarkVirtual(vNode) {
            var landmarkRoles2 = get_aria_roles_by_type_default("landmark");
            var role = get_role_default(vNode);
            if (!role) return false;
            var nodeName2 = vNode.props.nodeName;
            if (nodeName2 === "header" || nodeName2 === "footer") return isHeaderFooterLandmark(vNode);
            if (nodeName2 === "section" || nodeName2 === "form") {
                var accessibleText2 = _accessibleTextVirtual(vNode);
                return !!accessibleText2;
            }
            return landmarkRoles2.indexOf(role) >= 0 || role === "region";
        }
        function isHeaderFooterLandmark(headerFooterElement) {
            return !closest_default(headerFooterElement, excludedParentsForHeaderFooterLandmarks);
        }
        function dataTableMatches2(node) {
            return !is_data_table_default(node) && !_isFocusable(node);
        }
        var layout_table_matches_default = dataTableMatches2;
        function linkInTextBlockMatches(node) {
            var text = sanitize_default(node.innerText);
            var role = node.getAttribute("role");
            if (role && role !== "link") return false;
            if (!text) return false;
            if (!_isVisibleOnScreen(node)) return false;
            return is_in_text_block_default(node);
        }
        var link_in_text_block_matches_default = linkInTextBlockMatches;
        function nestedInteractiveMatches(node, virtualNode) {
            var role = get_role_default(virtualNode);
            if (!role) return false;
            return !!standards_default.ariaRoles[role].childrenPresentational;
        }
        var nested_interactive_matches_default = nestedInteractiveMatches;
        function noAutoplayAudioMatches(node) {
            if (!node.currentSrc) return false;
            if (node.hasAttribute("paused") || node.hasAttribute("muted")) return false;
            return true;
        }
        var no_autoplay_audio_matches_default = noAutoplayAudioMatches;
        function noEmptyRoleMatches(node, virtualNode) {
            if (!virtualNode.hasAttr("role")) return false;
            if (!virtualNode.attr("role").trim()) return false;
            return true;
        }
        var no_empty_role_matches_default = noEmptyRoleMatches;
        function noExplicitNameRequired(node, virtualNode) {
            var role = get_explicit_role_default(virtualNode);
            if (!role || [
                "none",
                "presentation"
            ].includes(role)) return true;
            var _ref142 = aria_roles_default[role] || {}, accessibleNameRequired = _ref142.accessibleNameRequired;
            if (accessibleNameRequired || _isFocusable(virtualNode)) return true;
            return false;
        }
        var no_explicit_name_required_matches_default = noExplicitNameRequired;
        function noNamingMethodMatches(node, virtualNode) {
            var _get_element_spec_def3 = get_element_spec_default(virtualNode), namingMethods = _get_element_spec_def3.namingMethods;
            if (namingMethods && namingMethods.length !== 0) return false;
            if (get_explicit_role_default(virtualNode) === "combobox" && query_selector_all_default(virtualNode, 'input:not([type="hidden"])').length) return false;
            if (_isComboboxPopup(virtualNode, {
                popupRoles: [
                    "listbox"
                ]
            })) return false;
            return true;
        }
        var no_naming_method_matches_default = noNamingMethodMatches;
        function noNegativeTabindexMatches(node, virtualNode) {
            var tabindex = parseInt(virtualNode.attr("tabindex"), 10);
            return isNaN(tabindex) || tabindex >= 0;
        }
        var no_negative_tabindex_matches_default = noNegativeTabindexMatches;
        function noRoleMatches(node, vNode) {
            return !vNode.attr("role");
        }
        var no_role_matches_default = noRoleMatches;
        function notHtmlMatches(node, virtualNode) {
            return virtualNode.props.nodeName !== "html";
        }
        var not_html_matches_default = notHtmlMatches;
        var object_is_loaded_matches_default = function object_is_loaded_matches_default(node, vNode) {
            return [
                no_explicit_name_required_matches_default,
                objectHasLoaded
            ].every(function(fn) {
                return fn(node, vNode);
            });
        };
        function objectHasLoaded(node) {
            var _node$ownerDocument;
            if (!(node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.createRange)) return true;
            var range2 = node.ownerDocument.createRange();
            range2.setStart(node, 0);
            range2.setEnd(node, node.childNodes.length);
            return range2.getClientRects().length === 0;
        }
        function pAsHeadingMatches(node) {
            var children = Array.from(node.parentNode.childNodes);
            var nodeText = node.textContent.trim();
            var isSentence = /[.!?:;](?![.!?:;])/g;
            if (nodeText.length === 0 || (nodeText.match(isSentence) || []).length >= 2) return false;
            var siblingsAfter = children.slice(children.indexOf(node) + 1).filter(function(elm) {
                return elm.nodeName.toUpperCase() === "P" && elm.textContent.trim() !== "";
            });
            return siblingsAfter.length !== 0;
        }
        var p_as_heading_matches_default = pAsHeadingMatches;
        function presentationRoleConflictMatches(node, virtualNode) {
            return implicit_role_default(virtualNode, {
                chromiumRoles: true
            }) !== null;
        }
        var presentation_role_conflict_matches_default = presentationRoleConflictMatches;
        function scrollableRegionFocusableMatches(node, virtualNode) {
            return get_scroll_default(node, 13) !== void 0 && _isComboboxPopup(virtualNode) === false && isNoneEmptyElement(virtualNode);
        }
        function isNoneEmptyElement(vNode) {
            return query_selector_all_default(vNode, "*").some(function(elm) {
                return has_content_virtual_default(elm, true, true);
            });
        }
        function skipLinkMatches(node) {
            return _isSkipLink(node) && is_offscreen_default(node);
        }
        var skip_link_matches_default = skipLinkMatches;
        function tableOrGridRoleMatches(_, vNode) {
            var role = get_role_default(vNode);
            return [
                "treegrid",
                "grid",
                "table"
            ].includes(role);
        }
        function widgetNotInline(node, vNode) {
            return matchesFns.every(function(fn) {
                return fn(node, vNode);
            });
        }
        var matchesFns = [
            function(node, vNode) {
                return isWidgetType(vNode);
            },
            function(node, vNode) {
                return isNotAreaElement(vNode);
            },
            function(node, vNode) {
                return !svg_namespace_matches_default(node, vNode);
            },
            function(node, vNode) {
                return _isFocusable(vNode);
            },
            function(node, vNode) {
                return _isInTabOrder(vNode) || !hasWidgetAncestorInTabOrder(vNode);
            },
            function(node) {
                return !is_in_text_block_default(node, {
                    noLengthCompare: true
                });
            }
        ];
        function isWidgetType(vNode) {
            return get_role_type_default(vNode) === "widget";
        }
        function isNotAreaElement(vNode) {
            return vNode.props.nodeName !== "area";
        }
        var hasWidgetAncestorInTabOrder = memoize_default(function hasWidgetAncestorInTabOrderMemoized(vNode) {
            if (!(vNode !== null && vNode !== void 0 && vNode.parent)) return false;
            if (isWidgetType(vNode.parent) && _isInTabOrder(vNode.parent)) return true;
            return hasWidgetAncestorInTabOrderMemoized(vNode.parent);
        });
        function windowIsTopMatches(node) {
            return node.ownerDocument.defaultView.self === node.ownerDocument.defaultView.top;
        }
        var window_is_top_matches_default = windowIsTopMatches;
        function xmlLangMismatchMatches(node) {
            var primaryLangValue = get_base_lang_default(node.getAttribute("lang"));
            var primaryXmlLangValue = get_base_lang_default(node.getAttribute("xml:lang"));
            return valid_langs_default(primaryLangValue) && valid_langs_default(primaryXmlLangValue);
        }
        var xml_lang_mismatch_matches_default = xmlLangMismatchMatches;
        var metadataFunctionMap = {
            "abstractrole-evaluate": abstractrole_evaluate_default,
            "accesskeys-after": accesskeys_after_default,
            "accesskeys-evaluate": accesskeys_evaluate_default,
            "alt-space-value-evaluate": alt_space_value_evaluate_default,
            "aria-allowed-attr-evaluate": ariaAllowedAttrEvaluate,
            "aria-allowed-attr-matches": aria_allowed_attr_matches_default,
            "aria-allowed-role-evaluate": aria_allowed_role_evaluate_default,
            "aria-allowed-role-matches": aria_allowed_role_matches_default,
            "aria-busy-evaluate": ariaBusyEvaluate,
            "aria-conditional-attr-evaluate": ariaConditionalAttrEvaluate,
            "aria-conditional-checkbox-attr-evaluate": ariaConditionalCheckboxAttr,
            "aria-conditional-row-attr-evaluate": ariaConditionalRowAttr,
            "aria-errormessage-evaluate": ariaErrormessageEvaluate,
            "aria-has-attr-matches": aria_has_attr_matches_default,
            "aria-hidden-body-evaluate": aria_hidden_body_evaluate_default,
            "aria-hidden-focus-matches": aria_hidden_focus_matches_default,
            "aria-label-evaluate": aria_label_evaluate_default,
            "aria-labelledby-evaluate": aria_labelledby_evaluate_default,
            "aria-level-evaluate": aria_level_evaluate_default,
            "aria-prohibited-attr-evaluate": ariaProhibitedAttrEvaluate,
            "aria-required-attr-evaluate": ariaRequiredAttrEvaluate,
            "aria-required-children-evaluate": ariaRequiredChildrenEvaluate,
            "aria-required-children-matches": aria_required_children_matches_default,
            "aria-required-parent-evaluate": aria_required_parent_evaluate_default,
            "aria-required-parent-matches": aria_required_parent_matches_default,
            "aria-roledescription-evaluate": aria_roledescription_evaluate_default,
            "aria-unsupported-attr-evaluate": aria_unsupported_attr_evaluate_default,
            "aria-valid-attr-evaluate": aria_valid_attr_evaluate_default,
            "aria-valid-attr-value-evaluate": ariaValidAttrValueEvaluate,
            "attr-non-space-content-evaluate": attr_non_space_content_evaluate_default,
            "autocomplete-appropriate-evaluate": autocomplete_appropriate_evaluate_default,
            "autocomplete-matches": autocomplete_matches_default,
            "autocomplete-valid-evaluate": autocomplete_valid_evaluate_default,
            "avoid-inline-spacing-evaluate": avoid_inline_spacing_evaluate_default,
            "braille-label-equivalent-evaluate": brailleLabelEquivalentEvaluate,
            "braille-roledescription-equivalent-evaluate": brailleRoleDescriptionEquivalentEvaluate,
            "bypass-matches": bypass_matches_default,
            "caption-evaluate": caption_evaluate_default,
            "caption-faked-evaluate": caption_faked_evaluate_default,
            "color-contrast-evaluate": colorContrastEvaluate,
            "color-contrast-matches": color_contrast_matches_default,
            "css-orientation-lock-evaluate": css_orientation_lock_evaluate_default,
            "data-table-large-matches": data_table_large_matches_default,
            "data-table-matches": data_table_matches_default,
            "deprecatedrole-evaluate": deprecatedroleEvaluate,
            "dlitem-evaluate": dlitem_evaluate_default,
            "doc-has-title-evaluate": doc_has_title_evaluate_default,
            "duplicate-id-active-matches": duplicate_id_active_matches_default,
            "duplicate-id-after": duplicate_id_after_default,
            "duplicate-id-aria-matches": duplicate_id_aria_matches_default,
            "duplicate-id-evaluate": duplicate_id_evaluate_default,
            "duplicate-id-misc-matches": duplicate_id_misc_matches_default,
            "duplicate-img-label-evaluate": duplicate_img_label_evaluate_default,
            "exists-evaluate": exists_evaluate_default,
            "explicit-evaluate": explicit_evaluate_default,
            "fallbackrole-evaluate": fallbackrole_evaluate_default,
            "focusable-content-evaluate": focusable_content_evaluate_default,
            "focusable-disabled-evaluate": focusable_disabled_evaluate_default,
            "focusable-element-evaluate": focusable_element_evaluate_default,
            "focusable-modal-open-evaluate": focusable_modal_open_evaluate_default,
            "focusable-no-name-evaluate": focusable_no_name_evaluate_default,
            "focusable-not-tabbable-evaluate": focusable_not_tabbable_evaluate_default,
            "frame-focusable-content-evaluate": frameFocusableContentEvaluate,
            "frame-focusable-content-matches": frame_focusable_content_matches_default,
            "frame-tested-after": frame_tested_after_default,
            "frame-tested-evaluate": frame_tested_evaluate_default,
            "frame-title-has-text-matches": frame_title_has_text_matches_default,
            "has-alt-evaluate": has_alt_evaluate_default,
            "has-descendant-after": has_descendant_after_default,
            "has-descendant-evaluate": has_descendant_evaluate_default,
            "has-global-aria-attribute-evaluate": has_global_aria_attribute_evaluate_default,
            "has-implicit-chromium-role-matches": has_implicit_chromium_role_matches_default,
            "has-lang-evaluate": has_lang_evaluate_default,
            "has-text-content-evaluate": hasTextContentEvaluate,
            "has-widget-role-evaluate": has_widget_role_evaluate_default,
            "heading-matches": headingMatches,
            "heading-order-after": headingOrderAfter,
            "heading-order-evaluate": heading_order_evaluate_default,
            "help-same-as-label-evaluate": help_same_as_label_evaluate_default,
            "hidden-content-evaluate": hidden_content_evaluate_default,
            "hidden-explicit-label-evaluate": hidden_explicit_label_evaluate_default,
            "html-namespace-matches": html_namespace_matches_default,
            "html5-scope-evaluate": html5_scope_evaluate_default,
            "identical-links-same-purpose-after": identical_links_same_purpose_after_default,
            "identical-links-same-purpose-evaluate": identical_links_same_purpose_evaluate_default,
            "identical-links-same-purpose-matches": identical_links_same_purpose_matches_default,
            "implicit-evaluate": implicit_evaluate_default,
            "inline-style-property-evaluate": inlineStyleProperty,
            "inserted-into-focus-order-matches": inserted_into_focus_order_matches_default,
            "internal-link-present-evaluate": internal_link_present_evaluate_default,
            "invalid-children-evaluate": invalidChildrenEvaluate,
            "invalidrole-evaluate": invalidrole_evaluate_default,
            "is-element-focusable-evaluate": is_element_focusable_evaluate_default,
            "is-initiator-matches": is_initiator_matches_default,
            "is-on-screen-evaluate": is_on_screen_evaluate_default,
            "is-visible-matches": hasVisibleTextMatches,
            "is-visible-on-screen-matches": isVisibleOnScreenMatches,
            "label-content-name-mismatch-evaluate": label_content_name_mismatch_evaluate_default,
            "label-content-name-mismatch-matches": label_content_name_mismatch_matches_default,
            "label-matches": label_matches_default,
            "landmark-has-body-context-matches": landmark_has_body_context_matches_default,
            "landmark-is-top-level-evaluate": landmark_is_top_level_evaluate_default,
            "landmark-is-unique-after": landmark_is_unique_after_default,
            "landmark-is-unique-evaluate": landmark_is_unique_evaluate_default,
            "landmark-unique-matches": landmarkUniqueMatches,
            "layout-table-matches": layout_table_matches_default,
            "link-in-text-block-evaluate": link_in_text_block_evaluate_default,
            "link-in-text-block-matches": link_in_text_block_matches_default,
            "link-in-text-block-style-evaluate": linkInTextBlockStyleEvaluate,
            "listitem-evaluate": listitemEvaluate,
            "matches-definition-evaluate": matches_definition_evaluate_default,
            "meta-refresh-evaluate": metaRefreshEvaluate,
            "meta-viewport-scale-evaluate": meta_viewport_scale_evaluate_default,
            "multiple-label-evaluate": multiple_label_evaluate_default,
            "nested-interactive-matches": nested_interactive_matches_default,
            "no-autoplay-audio-evaluate": no_autoplay_audio_evaluate_default,
            "no-autoplay-audio-matches": no_autoplay_audio_matches_default,
            "no-empty-role-matches": no_empty_role_matches_default,
            "no-explicit-name-required-matches": no_explicit_name_required_matches_default,
            "no-focusable-content-evaluate": noFocusableContentEvaluate,
            "no-implicit-explicit-label-evaluate": no_implicit_explicit_label_evaluate_default,
            "no-naming-method-matches": no_naming_method_matches_default,
            "no-negative-tabindex-matches": no_negative_tabindex_matches_default,
            "no-role-matches": no_role_matches_default,
            "non-empty-if-present-evaluate": non_empty_if_present_evaluate_default,
            "not-html-matches": not_html_matches_default,
            "object-is-loaded-matches": object_is_loaded_matches_default,
            "only-dlitems-evaluate": onlyDlitemsEvaluate,
            "only-listitems-evaluate": only_listitems_evaluate_default,
            "p-as-heading-evaluate": p_as_heading_evaluate_default,
            "p-as-heading-matches": p_as_heading_matches_default,
            "page-no-duplicate-after": page_no_duplicate_after_default,
            "page-no-duplicate-evaluate": page_no_duplicate_evaluate_default,
            "presentation-role-conflict-matches": presentation_role_conflict_matches_default,
            "presentational-role-evaluate": presentationalRoleEvaluate,
            "region-after": region_after_default,
            "region-evaluate": regionEvaluate,
            "same-caption-summary-evaluate": same_caption_summary_evaluate_default,
            "scope-value-evaluate": scope_value_evaluate_default,
            "scrollable-region-focusable-matches": scrollableRegionFocusableMatches,
            "skip-link-evaluate": skip_link_evaluate_default,
            "skip-link-matches": skip_link_matches_default,
            "structured-dlitems-evaluate": structured_dlitems_evaluate_default,
            "svg-namespace-matches": svg_namespace_matches_default,
            "svg-non-empty-title-evaluate": svg_non_empty_title_evaluate_default,
            "tabindex-evaluate": tabindex_evaluate_default,
            "table-or-grid-role-matches": tableOrGridRoleMatches,
            "target-offset-evaluate": targetOffsetEvaluate,
            "target-size-evaluate": targetSize,
            "td-has-header-evaluate": td_has_header_evaluate_default,
            "td-headers-attr-evaluate": tdHeadersAttrEvaluate,
            "th-has-data-cells-evaluate": th_has_data_cells_evaluate_default,
            "title-only-evaluate": title_only_evaluate_default,
            "unique-frame-title-after": unique_frame_title_after_default,
            "unique-frame-title-evaluate": unique_frame_title_evaluate_default,
            "unsupportedrole-evaluate": unsupportedrole_evaluate_default,
            "valid-lang-evaluate": valid_lang_evaluate_default,
            "valid-scrollable-semantics-evaluate": valid_scrollable_semantics_evaluate_default,
            "widget-not-inline-matches": widgetNotInline,
            "window-is-top-matches": window_is_top_matches_default,
            "xml-lang-mismatch-evaluate": xml_lang_mismatch_evaluate_default,
            "xml-lang-mismatch-matches": xml_lang_mismatch_matches_default
        };
        var metadata_function_map_default = metadataFunctionMap;
        function CheckResult(check) {
            this.id = check.id;
            this.data = null;
            this.relatedNodes = [];
            this.result = null;
        }
        var check_result_default = CheckResult;
        function createExecutionContext(spec) {
            if (typeof spec === "string") {
                if (metadata_function_map_default[spec]) return metadata_function_map_default[spec];
                if (/^\s*function[\s\w]*\(/.test(spec)) return new Function("return " + spec + ";")();
                throw new ReferenceError("Function ID does not exist in the metadata-function-map: ".concat(spec));
            }
            return spec;
        }
        function normalizeOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (Array.isArray(options) || _typeof(options) !== "object") options = {
                value: options
            };
            return options;
        }
        function Check(spec) {
            if (spec) {
                this.id = spec.id;
                this.configure(spec);
            }
        }
        Check.prototype.enabled = true;
        Check.prototype.run = function run(node, options, context, resolve, reject) {
            options = options || {};
            var enabled = options.hasOwnProperty("enabled") ? options.enabled : this.enabled;
            var checkOptions = this.getOptions(options.options);
            if (enabled) {
                var checkResult = new check_result_default(this);
                var helper = check_helper_default(checkResult, options, resolve, reject);
                var result;
                try {
                    result = this.evaluate.call(helper, node.actualNode, checkOptions, node, context);
                } catch (e) {
                    if (node && node.actualNode) e.errorNode = node_serializer_default.toSpec(node);
                    reject(e);
                    return;
                }
                if (!helper.isAsync) {
                    checkResult.result = result;
                    resolve(checkResult);
                }
            } else resolve(null);
        };
        Check.prototype.runSync = function runSync(node, options, context) {
            options = options || {};
            var _options2 = options, _options2$enabled = _options2.enabled, enabled = _options2$enabled === void 0 ? this.enabled : _options2$enabled;
            if (!enabled) return null;
            var checkOptions = this.getOptions(options.options);
            var checkResult = new check_result_default(this);
            var helper = check_helper_default(checkResult, options);
            helper.async = function async() {
                throw new Error("Cannot run async check while in a synchronous run");
            };
            var result;
            try {
                result = this.evaluate.call(helper, node.actualNode, checkOptions, node, context);
            } catch (e) {
                if (node && node.actualNode) e.errorNode = node_serializer_default.toSpec(node);
                throw e;
            }
            checkResult.result = result;
            return checkResult;
        };
        Check.prototype.configure = function configure2(spec) {
            var _this8 = this;
            if (!spec.evaluate || metadata_function_map_default[spec.evaluate]) this._internalCheck = true;
            if (spec.hasOwnProperty("enabled")) this.enabled = spec.enabled;
            if (spec.hasOwnProperty("options")) {
                if (this._internalCheck) this.options = normalizeOptions(spec.options);
                else this.options = spec.options;
            }
            [
                "evaluate",
                "after"
            ].filter(function(prop) {
                return spec.hasOwnProperty(prop);
            }).forEach(function(prop) {
                return _this8[prop] = createExecutionContext(spec[prop]);
            });
        };
        Check.prototype.getOptions = function getOptions(options) {
            if (this._internalCheck) return deep_merge_default(this.options, normalizeOptions(options || {}));
            else return options || this.options;
        };
        var check_default = Check;
        function RuleResult(rule) {
            this.id = rule.id;
            this.result = constants_default.NA;
            this.pageLevel = rule.pageLevel;
            this.impact = null;
            this.nodes = [];
        }
        var rule_result_default = RuleResult;
        function Rule(spec, parentAudit) {
            this._audit = parentAudit;
            this.id = spec.id;
            this.selector = spec.selector || "*";
            if (spec.impact) {
                assert_default(constants_default.impact.includes(spec.impact), "Impact ".concat(spec.impact, " is not a valid impact"));
                this.impact = spec.impact;
            }
            this.excludeHidden = typeof spec.excludeHidden === "boolean" ? spec.excludeHidden : true;
            this.enabled = typeof spec.enabled === "boolean" ? spec.enabled : true;
            this.pageLevel = typeof spec.pageLevel === "boolean" ? spec.pageLevel : false;
            this.reviewOnFail = typeof spec.reviewOnFail === "boolean" ? spec.reviewOnFail : false;
            this.any = spec.any || [];
            this.all = spec.all || [];
            this.none = spec.none || [];
            this.tags = spec.tags || [];
            this.preload = spec.preload ? true : false;
            this.actIds = spec.actIds;
            if (spec.matches) this.matches = createExecutionContext(spec.matches);
        }
        Rule.prototype.matches = function matches3() {
            return true;
        };
        Rule.prototype.gather = function gather(context) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var markStart = "mark_gather_start_" + this.id;
            var markEnd = "mark_gather_end_" + this.id;
            var markHiddenStart = "mark_isVisibleToScreenReaders_start_" + this.id;
            var markHiddenEnd = "mark_isVisibleToScreenReaders_end_" + this.id;
            if (options.performanceTimer) performance_timer_default.mark(markStart);
            var elements = _select(this.selector, context);
            if (this.excludeHidden) {
                if (options.performanceTimer) performance_timer_default.mark(markHiddenStart);
                elements = elements.filter(function(element) {
                    return _isVisibleToScreenReaders(element);
                });
                if (options.performanceTimer) {
                    performance_timer_default.mark(markHiddenEnd);
                    performance_timer_default.measure("rule_" + this.id + "#gather_axe.utils.isVisibleToScreenReaders", markHiddenStart, markHiddenEnd);
                }
            }
            if (options.performanceTimer) {
                performance_timer_default.mark(markEnd);
                performance_timer_default.measure("rule_" + this.id + "#gather", markStart, markEnd);
            }
            return elements;
        };
        Rule.prototype.runChecks = function runChecks(type2, node, options, context, resolve, reject) {
            var self2 = this;
            var checkQueue = queue_default();
            this[type2].forEach(function(c4) {
                var check = self2._audit.checks[c4.id || c4];
                var option = get_check_option_default(check, self2.id, options);
                checkQueue.defer(function(res, rej) {
                    check.run(node, option, context, res, rej);
                });
            });
            checkQueue.then(function(results) {
                results = results.filter(function(check) {
                    return check;
                });
                resolve({
                    type: type2,
                    results: results
                });
            })["catch"](reject);
        };
        Rule.prototype.runChecksSync = function runChecksSync(type2, node, options, context) {
            var self2 = this;
            var results = [];
            this[type2].forEach(function(c4) {
                var check = self2._audit.checks[c4.id || c4];
                var option = get_check_option_default(check, self2.id, options);
                results.push(check.runSync(node, option, context));
            });
            results = results.filter(function(check) {
                return check;
            });
            return {
                type: type2,
                results: results
            };
        };
        Rule.prototype.run = function run2(context) {
            var _this9 = this;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var resolve = arguments.length > 2 ? arguments[2] : undefined;
            var reject = arguments.length > 3 ? arguments[3] : undefined;
            if (options.performanceTimer) this._trackPerformance();
            var q = queue_default();
            var ruleResult = new rule_result_default(this);
            var nodes;
            try {
                nodes = this.gatherAndMatchNodes(context, options);
            } catch (error) {
                reject(new SupportError({
                    cause: error,
                    ruleId: this.id
                }));
                return;
            }
            if (options.performanceTimer) this._logGatherPerformance(nodes);
            nodes.forEach(function(node) {
                q.defer(function(resolveNode, rejectNode) {
                    var checkQueue = queue_default();
                    [
                        "any",
                        "all",
                        "none"
                    ].forEach(function(type2) {
                        checkQueue.defer(function(res, rej) {
                            _this9.runChecks(type2, node, options, context, res, rej);
                        });
                    });
                    checkQueue.then(function(results) {
                        var result = getResult(results);
                        if (result) {
                            result.node = new dq_element_default(node);
                            ruleResult.nodes.push(result);
                            if (_this9.reviewOnFail) {
                                [
                                    "any",
                                    "all"
                                ].forEach(function(type2) {
                                    result[type2].forEach(function(checkResult) {
                                        if (checkResult.result === false) checkResult.result = void 0;
                                    });
                                });
                                result.none.forEach(function(checkResult) {
                                    if (checkResult.result === true) checkResult.result = void 0;
                                });
                            }
                        }
                        resolveNode();
                    })["catch"](function(err2) {
                        return rejectNode(err2);
                    });
                });
            });
            q.defer(function(res) {
                return setTimeout(res, 0);
            });
            if (options.performanceTimer) this._logRulePerformance();
            q.then(function() {
                return resolve(ruleResult);
            })["catch"](function(error) {
                return reject(error);
            });
        };
        Rule.prototype.runSync = function runSync2(context) {
            var _this10 = this;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (options.performanceTimer) this._trackPerformance();
            var ruleResult = new rule_result_default(this);
            var nodes;
            try {
                nodes = this.gatherAndMatchNodes(context, options);
            } catch (error) {
                throw new SupportError({
                    cause: error,
                    ruleId: this.id
                });
            }
            if (options.performanceTimer) this._logGatherPerformance(nodes);
            nodes.forEach(function(node) {
                var results = [];
                [
                    "any",
                    "all",
                    "none"
                ].forEach(function(type2) {
                    results.push(_this10.runChecksSync(type2, node, options, context));
                });
                var result = getResult(results);
                if (result) {
                    result.node = node.actualNode ? new dq_element_default(node) : null;
                    ruleResult.nodes.push(result);
                    if (_this10.reviewOnFail) {
                        [
                            "any",
                            "all"
                        ].forEach(function(type2) {
                            result[type2].forEach(function(checkResult) {
                                if (checkResult.result === false) checkResult.result = void 0;
                            });
                        });
                        result.none.forEach(function(checkResult) {
                            if (checkResult.result === true) checkResult.result = void 0;
                        });
                    }
                }
            });
            if (options.performanceTimer) this._logRulePerformance();
            return ruleResult;
        };
        Rule.prototype._trackPerformance = function _trackPerformance() {
            this._markStart = "mark_rule_start_" + this.id;
            this._markEnd = "mark_rule_end_" + this.id;
            this._markChecksStart = "mark_runchecks_start_" + this.id;
            this._markChecksEnd = "mark_runchecks_end_" + this.id;
        };
        Rule.prototype._logGatherPerformance = function _logGatherPerformance(nodes) {
            log_default("gather (", nodes.length, "):", performance_timer_default.timeElapsed() + "ms");
            performance_timer_default.mark(this._markChecksStart);
        };
        Rule.prototype._logRulePerformance = function _logRulePerformance() {
            performance_timer_default.mark(this._markChecksEnd);
            performance_timer_default.mark(this._markEnd);
            performance_timer_default.measure("runchecks_" + this.id, this._markChecksStart, this._markChecksEnd);
            performance_timer_default.measure("rule_" + this.id, this._markStart, this._markEnd);
        };
        function getResult(results) {
            if (results.length) {
                var hasResults = false;
                var result = {};
                results.forEach(function(r) {
                    var res = r.results.filter(function(_result) {
                        return _result;
                    });
                    result[r.type] = res;
                    if (res.length) hasResults = true;
                });
                if (hasResults) return result;
                return null;
            }
        }
        Rule.prototype.gatherAndMatchNodes = function gatherAndMatchNodes(context, options) {
            var _this11 = this;
            var markMatchesStart = "mark_matches_start_" + this.id;
            var markMatchesEnd = "mark_matches_end_" + this.id;
            var nodes = this.gather(context, options);
            if (options.performanceTimer) performance_timer_default.mark(markMatchesStart);
            nodes = nodes.filter(function(node) {
                return _this11.matches(node.actualNode, node, context);
            });
            if (options.performanceTimer) {
                performance_timer_default.mark(markMatchesEnd);
                performance_timer_default.measure("rule_" + this.id + "#matches", markMatchesStart, markMatchesEnd);
            }
            return nodes;
        };
        function findAfterChecks(rule) {
            return get_all_checks_default(rule).map(function(c4) {
                var check = rule._audit.checks[c4.id || c4];
                return check && typeof check.after === "function" ? check : null;
            }).filter(Boolean);
        }
        function findCheckResults(nodes, checkID) {
            var checkResults = [];
            nodes.forEach(function(nodeResult) {
                var checks = get_all_checks_default(nodeResult);
                checks.forEach(function(checkResult) {
                    if (checkResult.id === checkID) {
                        checkResult.node = nodeResult.node;
                        checkResults.push(checkResult);
                    }
                });
            });
            return checkResults;
        }
        function filterChecks(checks) {
            return checks.filter(function(check) {
                return check.filtered !== true;
            });
        }
        function sanitizeNodes(result) {
            var checkTypes2 = [
                "any",
                "all",
                "none"
            ];
            var nodes = result.nodes.filter(function(detail) {
                var length = 0;
                checkTypes2.forEach(function(type2) {
                    detail[type2] = filterChecks(detail[type2]);
                    length += detail[type2].length;
                });
                return length > 0;
            });
            if (result.pageLevel && nodes.length) nodes = [
                nodes.reduce(function(a2, b2) {
                    if (a2) {
                        checkTypes2.forEach(function(type2) {
                            a2[type2].push.apply(a2[type2], b2[type2]);
                        });
                        return a2;
                    }
                })
            ];
            return nodes;
        }
        Rule.prototype.after = function after(result, options) {
            var _this12 = this;
            var afterChecks = findAfterChecks(this);
            var ruleID = this.id;
            afterChecks.forEach(function(check) {
                var beforeResults = findCheckResults(result.nodes, check.id);
                var checkOption = get_check_option_default(check, ruleID, options);
                var afterResults = check.after(beforeResults, checkOption.options);
                if (_this12.reviewOnFail) afterResults.forEach(function(checkResult) {
                    var changeAnyAllResults = (_this12.any.includes(checkResult.id) || _this12.all.includes(checkResult.id)) && checkResult.result === false;
                    var changeNoneResult = _this12.none.includes(checkResult.id) && checkResult.result === true;
                    if (changeAnyAllResults || changeNoneResult) checkResult.result = void 0;
                });
                beforeResults.forEach(function(item) {
                    delete item.node;
                    if (afterResults.indexOf(item) === -1) item.filtered = true;
                });
            });
            result.nodes = sanitizeNodes(result);
            return result;
        };
        Rule.prototype.configure = function configure3(spec) {
            if (spec.hasOwnProperty("selector")) this.selector = spec.selector;
            if (spec.hasOwnProperty("excludeHidden")) this.excludeHidden = typeof spec.excludeHidden === "boolean" ? spec.excludeHidden : true;
            if (spec.hasOwnProperty("enabled")) this.enabled = typeof spec.enabled === "boolean" ? spec.enabled : true;
            if (spec.hasOwnProperty("pageLevel")) this.pageLevel = typeof spec.pageLevel === "boolean" ? spec.pageLevel : false;
            if (spec.hasOwnProperty("reviewOnFail")) this.reviewOnFail = typeof spec.reviewOnFail === "boolean" ? spec.reviewOnFail : false;
            if (spec.hasOwnProperty("any")) this.any = spec.any;
            if (spec.hasOwnProperty("all")) this.all = spec.all;
            if (spec.hasOwnProperty("none")) this.none = spec.none;
            if (spec.hasOwnProperty("tags")) this.tags = spec.tags;
            if (spec.hasOwnProperty("actIds")) this.actIds = spec.actIds;
            if (spec.hasOwnProperty("matches")) this.matches = createExecutionContext(spec.matches);
            if (spec.impact) {
                assert_default(constants_default.impact.includes(spec.impact), "Impact ".concat(spec.impact, " is not a valid impact"));
                this.impact = spec.impact;
            }
        };
        var import_dot2 = __toModule(require_doT());
        var dotRegex = /\{\{.+?\}\}/g;
        var Audit = function() {
            function Audit(audit) {
                _classCallCheck(this, Audit);
                this.lang = "en";
                this.defaultConfig = audit;
                this.standards = standards_default;
                this._init();
                this._defaultLocale = null;
            }
            _createClass(Audit, [
                {
                    key: "_setDefaultLocale",
                    value: function _setDefaultLocale() {
                        if (this._defaultLocale) return;
                        var locale = {
                            checks: {},
                            rules: {},
                            failureSummaries: {},
                            incompleteFallbackMessage: "",
                            lang: this.lang
                        };
                        var checkIDs = Object.keys(this.data.checks);
                        for(var _i37 = 0; _i37 < checkIDs.length; _i37++){
                            var _id6 = checkIDs[_i37];
                            var check = this.data.checks[_id6];
                            var _check$messages = check.messages, pass = _check$messages.pass, fail = _check$messages.fail, incomplete = _check$messages.incomplete;
                            locale.checks[_id6] = {
                                pass: pass,
                                fail: fail,
                                incomplete: incomplete
                            };
                        }
                        var ruleIDs = Object.keys(this.data.rules);
                        for(var _i38 = 0; _i38 < ruleIDs.length; _i38++){
                            var _id7 = ruleIDs[_i38];
                            var rule = this.data.rules[_id7];
                            var description = rule.description, help = rule.help;
                            locale.rules[_id7] = {
                                description: description,
                                help: help
                            };
                        }
                        var failureSummaries = Object.keys(this.data.failureSummaries);
                        for(var _i39 = 0; _i39 < failureSummaries.length; _i39++){
                            var type2 = failureSummaries[_i39];
                            var failureSummary2 = this.data.failureSummaries[type2];
                            var failureMessage = failureSummary2.failureMessage;
                            locale.failureSummaries[type2] = {
                                failureMessage: failureMessage
                            };
                        }
                        locale.incompleteFallbackMessage = this.data.incompleteFallbackMessage;
                        this._defaultLocale = locale;
                    }
                },
                {
                    key: "_resetLocale",
                    value: function _resetLocale() {
                        var defaultLocale = this._defaultLocale;
                        if (!defaultLocale) return;
                        this.applyLocale(defaultLocale);
                    }
                },
                {
                    key: "_applyCheckLocale",
                    value: function _applyCheckLocale(checks) {
                        var keys = Object.keys(checks);
                        for(var _i40 = 0; _i40 < keys.length; _i40++){
                            var _id8 = keys[_i40];
                            if (!this.data.checks[_id8]) throw new Error('Locale provided for unknown check: "'.concat(_id8, '"'));
                            this.data.checks[_id8] = mergeCheckLocale(this.data.checks[_id8], checks[_id8]);
                        }
                    }
                },
                {
                    key: "_applyRuleLocale",
                    value: function _applyRuleLocale(rules) {
                        var keys = Object.keys(rules);
                        for(var _i41 = 0; _i41 < keys.length; _i41++){
                            var _id9 = keys[_i41];
                            if (!this.data.rules[_id9]) throw new Error('Locale provided for unknown rule: "'.concat(_id9, '"'));
                            this.data.rules[_id9] = mergeRuleLocale(this.data.rules[_id9], rules[_id9]);
                        }
                    }
                },
                {
                    key: "_applyFailureSummaries",
                    value: function _applyFailureSummaries(messages) {
                        var keys = Object.keys(messages);
                        for(var _i42 = 0; _i42 < keys.length; _i42++){
                            var _key8 = keys[_i42];
                            if (!this.data.failureSummaries[_key8]) throw new Error('Locale provided for unknown failureMessage: "'.concat(_key8, '"'));
                            this.data.failureSummaries[_key8] = mergeFailureMessage(this.data.failureSummaries[_key8], messages[_key8]);
                        }
                    }
                },
                {
                    key: "applyLocale",
                    value: function applyLocale(locale) {
                        this._setDefaultLocale();
                        if (locale.checks) this._applyCheckLocale(locale.checks);
                        if (locale.rules) this._applyRuleLocale(locale.rules);
                        if (locale.failureSummaries) this._applyFailureSummaries(locale.failureSummaries, "failureSummaries");
                        if (locale.incompleteFallbackMessage) this.data.incompleteFallbackMessage = mergeFallbackMessage(this.data.incompleteFallbackMessage, locale.incompleteFallbackMessage);
                        if (locale.lang) this.lang = locale.lang;
                    }
                },
                {
                    key: "setAllowedOrigins",
                    value: function setAllowedOrigins(allowedOrigins) {
                        var defaultOrigin = getDefaultOrigin();
                        this.allowedOrigins = [];
                        var _iterator22 = _createForOfIteratorHelper(allowedOrigins), _step22;
                        try {
                            for(_iterator22.s(); !(_step22 = _iterator22.n()).done;){
                                var origin = _step22.value;
                                if (origin === constants_default.allOrigins) {
                                    this.allowedOrigins = [
                                        "*"
                                    ];
                                    return;
                                } else if (origin !== constants_default.sameOrigin) this.allowedOrigins.push(origin);
                                else if (defaultOrigin) this.allowedOrigins.push(defaultOrigin);
                            }
                        } catch (err) {
                            _iterator22.e(err);
                        } finally{
                            _iterator22.f();
                        }
                    }
                },
                {
                    key: "_init",
                    value: function _init() {
                        var audit = getDefaultConfiguration(this.defaultConfig);
                        this.lang = audit.lang || "en";
                        this.reporter = audit.reporter;
                        this.commands = {};
                        this.rules = [];
                        this.checks = {};
                        this.brand = "axe";
                        this.application = "axeAPI";
                        this.tagExclude = [
                            "experimental"
                        ];
                        this.noHtml = audit.noHtml;
                        this.allowedOrigins = audit.allowedOrigins;
                        unpackToObject(audit.rules, this, "addRule");
                        unpackToObject(audit.checks, this, "addCheck");
                        this.data = {};
                        this.data.checks = audit.data && audit.data.checks || {};
                        this.data.rules = audit.data && audit.data.rules || {};
                        this.data.failureSummaries = audit.data && audit.data.failureSummaries || {};
                        this.data.incompleteFallbackMessage = audit.data && audit.data.incompleteFallbackMessage || "";
                        this._constructHelpUrls();
                    }
                },
                {
                    key: "registerCommand",
                    value: function registerCommand(command) {
                        this.commands[command.id] = command.callback;
                    }
                },
                {
                    key: "addRule",
                    value: function addRule(spec) {
                        if (spec.metadata) this.data.rules[spec.id] = spec.metadata;
                        var rule = this.getRule(spec.id);
                        if (rule) rule.configure(spec);
                        else this.rules.push(new Rule(spec, this));
                    }
                },
                {
                    key: "addCheck",
                    value: function addCheck(spec) {
                        var metadata = spec.metadata;
                        if (_typeof(metadata) === "object") {
                            this.data.checks[spec.id] = metadata;
                            if (_typeof(metadata.messages) === "object") Object.keys(metadata.messages).filter(function(prop) {
                                return metadata.messages.hasOwnProperty(prop) && typeof metadata.messages[prop] === "string";
                            }).forEach(function(prop) {
                                if (metadata.messages[prop].indexOf("function") === 0) metadata.messages[prop] = new Function("return " + metadata.messages[prop] + ";")();
                            });
                        }
                        if (this.checks[spec.id]) this.checks[spec.id].configure(spec);
                        else this.checks[spec.id] = new check_default(spec);
                    }
                },
                {
                    key: "run",
                    value: function run(context, options, resolve, reject) {
                        this.normalizeOptions(options);
                        dq_element_default.setRunOptions(options);
                        axe._selectCache = [];
                        var allRulesToRun = getRulesToRun(this.rules, context, options);
                        var runNowRules = allRulesToRun.now;
                        var runLaterRules = allRulesToRun.later;
                        var nowRulesQueue = queue_default();
                        runNowRules.forEach(function(rule) {
                            nowRulesQueue.defer(getDefferedRule(rule, context, options));
                        });
                        var preloaderQueue = queue_default();
                        if (runLaterRules.length) preloaderQueue.defer(function(res) {
                            _preload(options).then(function(assets) {
                                return res(assets);
                            })["catch"](function(err2) {
                                console.warn("Couldn't load preload assets: ", err2);
                                res(void 0);
                            });
                        });
                        var queueForNowRulesAndPreloader = queue_default();
                        queueForNowRulesAndPreloader.defer(nowRulesQueue);
                        queueForNowRulesAndPreloader.defer(preloaderQueue);
                        queueForNowRulesAndPreloader.then(function(nowRulesAndPreloaderResults) {
                            var assetsFromQueue = nowRulesAndPreloaderResults.pop();
                            if (assetsFromQueue && assetsFromQueue.length) {
                                var assets = assetsFromQueue[0];
                                if (assets) context = _extends({}, context, assets);
                            }
                            var nowRulesResults = nowRulesAndPreloaderResults[0];
                            if (!runLaterRules.length) {
                                axe._selectCache = void 0;
                                resolve(nowRulesResults.filter(function(result) {
                                    return !!result;
                                }));
                                return;
                            }
                            var laterRulesQueue = queue_default();
                            runLaterRules.forEach(function(rule) {
                                var deferredRule = getDefferedRule(rule, context, options);
                                laterRulesQueue.defer(deferredRule);
                            });
                            laterRulesQueue.then(function(laterRuleResults) {
                                axe._selectCache = void 0;
                                resolve(nowRulesResults.concat(laterRuleResults).filter(function(result) {
                                    return !!result;
                                }));
                            })["catch"](reject);
                        })["catch"](reject);
                    }
                },
                {
                    key: "after",
                    value: function after(results, options) {
                        var rules = this.rules;
                        return results.map(function(ruleResult) {
                            var rule = find_by_default(rules, "id", ruleResult.id);
                            if (!rule) throw new Error("Result for unknown rule. You may be running mismatch axe-core versions");
                            return rule.after(ruleResult, options);
                        });
                    }
                },
                {
                    key: "getRule",
                    value: function getRule(ruleId) {
                        return this.rules.find(function(rule) {
                            return rule.id === ruleId;
                        });
                    }
                },
                {
                    key: "normalizeOptions",
                    value: function normalizeOptions(options) {
                        var audit = this;
                        var tags = [];
                        var ruleIds = [];
                        audit.rules.forEach(function(rule) {
                            ruleIds.push(rule.id);
                            rule.tags.forEach(function(tag) {
                                if (!tags.includes(tag)) tags.push(tag);
                            });
                        });
                        if ([
                            "object",
                            "string"
                        ].includes(_typeof(options.runOnly))) {
                            if (typeof options.runOnly === "string") options.runOnly = [
                                options.runOnly
                            ];
                            if (Array.isArray(options.runOnly)) {
                                var hasTag = options.runOnly.find(function(value) {
                                    return tags.includes(value);
                                });
                                var hasRule = options.runOnly.find(function(value) {
                                    return ruleIds.includes(value);
                                });
                                if (hasTag && hasRule) throw new Error("runOnly cannot be both rules and tags");
                                if (hasRule) options.runOnly = {
                                    type: "rule",
                                    values: options.runOnly
                                };
                                else options.runOnly = {
                                    type: "tag",
                                    values: options.runOnly
                                };
                            }
                            var only = options.runOnly;
                            if (only.value && !only.values) {
                                only.values = only.value;
                                delete only.value;
                            }
                            if (!Array.isArray(only.values) || only.values.length === 0) throw new Error("runOnly.values must be a non-empty array");
                            if ([
                                "rule",
                                "rules"
                            ].includes(only.type)) {
                                only.type = "rule";
                                only.values.forEach(function(ruleId) {
                                    if (!ruleIds.includes(ruleId)) throw new Error("unknown rule `" + ruleId + "` in options.runOnly");
                                });
                            } else if ([
                                "tag",
                                "tags",
                                void 0
                            ].includes(only.type)) {
                                only.type = "tag";
                                var unmatchedTags = only.values.filter(function(tag) {
                                    return !tags.includes(tag) && !/wcag2[1-3]a{1,3}/.test(tag);
                                });
                                if (unmatchedTags.length !== 0) axe.log("Could not find tags `" + unmatchedTags.join("`, `") + "`");
                            } else throw new Error("Unknown runOnly type '".concat(only.type, "'"));
                        }
                        if (_typeof(options.rules) === "object") Object.keys(options.rules).forEach(function(ruleId) {
                            if (!ruleIds.includes(ruleId)) throw new Error("unknown rule `" + ruleId + "` in options.rules");
                        });
                        return options;
                    }
                },
                {
                    key: "setBranding",
                    value: function setBranding(branding) {
                        var previous = {
                            brand: this.brand,
                            application: this.application
                        };
                        if (typeof branding === "string") this.application = branding;
                        if (branding && branding.hasOwnProperty("brand") && branding.brand && typeof branding.brand === "string") this.brand = branding.brand;
                        if (branding && branding.hasOwnProperty("application") && branding.application && typeof branding.application === "string") this.application = branding.application;
                        this._constructHelpUrls(previous);
                    }
                },
                {
                    key: "_constructHelpUrls",
                    value: function _constructHelpUrls() {
                        var _this13 = this;
                        var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                        var version = (axe.version.match(/^[1-9][0-9]*\.[0-9]+/) || [
                            "x.y"
                        ])[0];
                        this.rules.forEach(function(rule) {
                            if (!_this13.data.rules[rule.id]) _this13.data.rules[rule.id] = {};
                            var metaData = _this13.data.rules[rule.id];
                            if (typeof metaData.helpUrl !== "string" || previous && metaData.helpUrl === getHelpUrl(previous, rule.id, version)) metaData.helpUrl = getHelpUrl(_this13, rule.id, version);
                        });
                    }
                },
                {
                    key: "resetRulesAndChecks",
                    value: function resetRulesAndChecks() {
                        this._init();
                        this._resetLocale();
                    }
                }
            ]);
            return Audit;
        }();
        var audit_default = Audit;
        function getDefaultOrigin() {
            if (window1.origin && window1.origin !== "null") return window1.origin;
            if (window1.location && window1.location.origin && window1.location.origin !== "null") return window1.location.origin;
        }
        function getDefaultConfiguration(audit) {
            var config;
            if (audit) {
                config = _clone(audit);
                config.commons = audit.commons;
            } else config = {};
            config.reporter = config.reporter || null;
            config.noHtml = config.noHtml || false;
            if (!config.allowedOrigins) {
                var defaultOrigin = getDefaultOrigin();
                config.allowedOrigins = defaultOrigin ? [
                    defaultOrigin
                ] : [];
            }
            config.rules = config.rules || [];
            config.checks = config.checks || [];
            config.data = _extends({
                checks: {},
                rules: {}
            }, config.data);
            return config;
        }
        function unpackToObject(collection, audit, method) {
            var i, l;
            for(i = 0, l = collection.length; i < l; i++)audit[method](collection[i]);
        }
        var mergeCheckLocale = function mergeCheckLocale(a2, b2) {
            var pass = b2.pass, fail = b2.fail;
            if (typeof pass === "string" && dotRegex.test(pass)) pass = import_dot2["default"].compile(pass);
            if (typeof fail === "string" && dotRegex.test(fail)) fail = import_dot2["default"].compile(fail);
            return _extends({}, a2, {
                messages: {
                    pass: pass || a2.messages.pass,
                    fail: fail || a2.messages.fail,
                    incomplete: _typeof(a2.messages.incomplete) === "object" ? _extends({}, a2.messages.incomplete, b2.incomplete) : b2.incomplete
                }
            });
        };
        var mergeRuleLocale = function mergeRuleLocale(a2, b2) {
            var help = b2.help, description = b2.description;
            if (typeof help === "string" && dotRegex.test(help)) help = import_dot2["default"].compile(help);
            if (typeof description === "string" && dotRegex.test(description)) description = import_dot2["default"].compile(description);
            return _extends({}, a2, {
                help: help || a2.help,
                description: description || a2.description
            });
        };
        var mergeFailureMessage = function mergeFailureMessage(a2, b2) {
            var failureMessage = b2.failureMessage;
            if (typeof failureMessage === "string" && dotRegex.test(failureMessage)) failureMessage = import_dot2["default"].compile(failureMessage);
            return _extends({}, a2, {
                failureMessage: failureMessage || a2.failureMessage
            });
        };
        var mergeFallbackMessage = function mergeFallbackMessage(a2, b2) {
            if (typeof b2 === "string" && dotRegex.test(b2)) b2 = import_dot2["default"].compile(b2);
            return b2 || a2;
        };
        function getRulesToRun(rules, context, options) {
            var base = {
                now: [],
                later: []
            };
            var splitRules = rules.reduce(function(out, rule) {
                if (!rule_should_run_default(rule, context, options)) return out;
                if (rule.preload) {
                    out.later.push(rule);
                    return out;
                }
                out.now.push(rule);
                return out;
            }, base);
            return splitRules;
        }
        function getDefferedRule(rule, context, options) {
            if (options.performanceTimer) performance_timer_default.mark("mark_rule_start_" + rule.id);
            return function(resolve, reject) {
                rule.run(context, options, function(ruleResult) {
                    resolve(ruleResult);
                }, function(err2) {
                    if (!options.debug) {
                        var errResult = Object.assign(new rule_result_default(rule), {
                            result: constants_default.CANTTELL,
                            description: "An error occured while running this rule",
                            message: err2.message,
                            stack: err2.stack,
                            error: err2,
                            errorNode: err2.errorNode
                        });
                        resolve(errResult);
                    } else reject(err2);
                });
            };
        }
        function getHelpUrl(_ref143, ruleId, version) {
            var brand = _ref143.brand, application = _ref143.application, lang = _ref143.lang;
            return constants_default.helpUrlBase + brand + "/" + (version || axe.version.substring(0, axe.version.lastIndexOf("."))) + "/" + ruleId + "?application=" + encodeURIComponent(application) + (lang && lang !== "en" ? "&lang=" + encodeURIComponent(lang) : "");
        }
        function setupGlobals(context) {
            var hasWindow = window1 && "Node" in window1 && "NodeList" in window1;
            var hasDoc = !!document;
            if (hasWindow && hasDoc) return;
            if (!context || !context.ownerDocument) throw new Error('Required "window" or "document" globals not defined and cannot be deduced from the context. Either set the globals before running or pass in a valid Element.');
            if (!hasDoc) {
                cache_default.set("globalDocumentSet", true);
                document = context.ownerDocument;
            }
            if (!hasWindow) {
                cache_default.set("globalWindowSet", true);
                window1 = document.defaultView;
            }
        }
        function resetGlobals() {
            if (cache_default.get("globalDocumentSet")) {
                cache_default.set("globalDocumentSet", false);
                document = null;
            }
            if (cache_default.get("globalWindowSet")) {
                cache_default.set("globalWindowSet", false);
                window1 = null;
            }
        }
        function teardown() {
            resetGlobals();
            axe._memoizedFns.forEach(function(fn) {
                return fn.clear();
            });
            cache_default.clear();
            axe._tree = void 0;
            axe._selectorData = void 0;
            axe._selectCache = void 0;
        }
        var teardown_default = teardown;
        function runRules(context, options, resolve, reject) {
            try {
                context = new Context(context);
                axe._tree = context.flatTree;
                axe._selectorData = _getSelectorData(context.flatTree);
            } catch (e) {
                teardown_default();
                return reject(e);
            }
            var q = queue_default();
            var audit = axe._audit;
            if (options.performanceTimer) performance_timer_default.auditStart();
            if (context.frames.length && options.iframes !== false) q.defer(function(res, rej) {
                _collectResultsFromFrames(context, options, "rules", null, res, rej);
            });
            q.defer(function(res, rej) {
                audit.run(context, options, res, rej);
            });
            q.then(function(data) {
                try {
                    if (options.performanceTimer) performance_timer_default.auditEnd();
                    var results = merge_results_default(data.map(function(res) {
                        return {
                            results: res
                        };
                    }));
                    if (context.initiator) {
                        results = audit.after(results, options);
                        results.forEach(_publishMetaData);
                        results = results.map(_finalizeRuleResult);
                    }
                    try {
                        resolve(results, teardown_default);
                    } catch (e) {
                        teardown_default();
                        log_default(e);
                    }
                } catch (e) {
                    teardown_default();
                    reject(e);
                }
            })["catch"](function(e) {
                teardown_default();
                reject(e);
            });
        }
        function load(audit) {
            axe._audit = new audit_default(audit);
        }
        function runCommand(data, keepalive, callback) {
            var resolve = callback;
            var reject = function reject2(err2) {
                if (err2 instanceof Error === false) err2 = new Error(err2);
                callback(err2);
            };
            var context = data && data.context || {};
            if (context.hasOwnProperty("include") && !context.include.length) context.include = [
                document
            ];
            var options = data && data.options || {};
            switch(data.command){
                case "rules":
                    return runRules(context, options, function(results, cleanupFn) {
                        results = node_serializer_default.mapRawResults(results);
                        resolve(results);
                        cleanupFn();
                    }, reject);
                case "cleanup-plugin":
                    return cleanup_default(resolve, reject);
                default:
                    if (axe._audit && axe._audit.commands && axe._audit.commands[data.command]) return axe._audit.commands[data.command](data, callback);
            }
        }
        if (window1.top !== window1) {
            _respondable.subscribe("axe.start", runCommand);
            _respondable.subscribe("axe.ping", function(data, keepalive, respond) {
                respond({
                    axe: true
                });
            });
        }
        function Plugin(spec) {
            this._run = spec.run;
            this._collect = spec.collect;
            this._registry = {};
            spec.commands.forEach(function(command) {
                axe._audit.registerCommand(command);
            });
        }
        Plugin.prototype.run = function run3() {
            return this._run.apply(this, arguments);
        };
        Plugin.prototype.collect = function collect() {
            return this._collect.apply(this, arguments);
        };
        Plugin.prototype.cleanup = function cleanup2(done) {
            var q = axe.utils.queue();
            var that = this;
            Object.keys(this._registry).forEach(function(key) {
                q.defer(function(_done) {
                    that._registry[key].cleanup(_done);
                });
            });
            q.then(done);
        };
        Plugin.prototype.add = function add(impl) {
            this._registry[impl.id] = impl;
        };
        function registerPlugin(plugin) {
            axe.plugins[plugin.id] = new Plugin(plugin);
        }
        var plugins_default = registerPlugin;
        function reset() {
            var audit = axe._audit;
            if (!audit) throw new Error("No audit configured");
            audit.resetRulesAndChecks();
            resetStandards();
        }
        var reset_default = reset;
        function runVirtualRule(ruleId, vNode) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            options.reporter = options.reporter || axe._audit.reporter || "v1";
            axe._selectorData = {};
            if (!(vNode instanceof abstract_virtual_node_default)) vNode = new serial_virtual_node_default(vNode);
            var rule = _getRule(ruleId);
            if (!rule) throw new Error("unknown rule `" + ruleId + "`");
            rule = Object.create(rule, {
                excludeHidden: {
                    value: false
                }
            });
            var context = {
                initiator: true,
                include: [
                    vNode
                ],
                exclude: [],
                frames: [],
                page: false,
                focusable: true,
                size: {},
                flatTree: []
            };
            var rawResults = rule.runSync(context, options);
            _publishMetaData(rawResults);
            _finalizeRuleResult(rawResults);
            var results = aggregate_result_default([
                rawResults
            ]);
            results.violations.forEach(function(result) {
                return result.nodes.forEach(function(nodeResult) {
                    nodeResult.failureSummary = failure_summary_default(nodeResult);
                });
            });
            return _extends({}, _getEnvironmentData(), results, {
                toolOptions: options
            });
        }
        function normalizeRunParams(_ref144) {
            var _ref146, _options$reporter, _axe$_audit;
            var _ref145 = _slicedToArray(_ref144, 3), context = _ref145[0], options = _ref145[1], callback = _ref145[2];
            var typeErr = new TypeError("axe.run arguments are invalid");
            if (!isContextSpec(context)) {
                if (callback !== void 0) throw typeErr;
                callback = options;
                options = context;
                context = document;
            }
            if (_typeof(options) !== "object") {
                if (callback !== void 0) throw typeErr;
                callback = options;
                options = {};
            }
            if (typeof callback !== "function" && callback !== void 0) throw typeErr;
            options = _clone(options);
            options.reporter = (_ref146 = (_options$reporter = options.reporter) !== null && _options$reporter !== void 0 ? _options$reporter : (_axe$_audit = axe._audit) === null || _axe$_audit === void 0 ? void 0 : _axe$_audit.reporter) !== null && _ref146 !== void 0 ? _ref146 : "v1";
            return {
                context: context,
                options: options,
                callback: callback
            };
        }
        var noop2 = function noop2() {};
        function run4() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key9 = 0; _key9 < _len7; _key9++)args[_key9] = arguments[_key9];
            setupGlobals(args[0]);
            var _normalizeRunParams = normalizeRunParams(args), context = _normalizeRunParams.context, options = _normalizeRunParams.options, _normalizeRunParams$c = _normalizeRunParams.callback, callback = _normalizeRunParams$c === void 0 ? noop2 : _normalizeRunParams$c;
            var _getPromiseHandlers = getPromiseHandlers(callback), thenable = _getPromiseHandlers.thenable, resolve = _getPromiseHandlers.resolve, reject = _getPromiseHandlers.reject;
            try {
                assert_default(axe._audit, "No audit configured");
                assert_default(!axe._running, "Axe is already running. Use `await axe.run()` to wait for the previous run to finish before starting a new run.");
            } catch (e) {
                return handleError(e, callback);
            }
            axe._running = true;
            if (options.performanceTimer) axe.utils.performanceTimer.start();
            function handleRunRules(rawResults, teardown2) {
                var respond = function respond(results) {
                    axe._running = false;
                    teardown2();
                    try {
                        resolve(results);
                    } catch (e) {
                        axe.log(e);
                    }
                };
                var wrappedReject = function wrappedReject(err2) {
                    axe._running = false;
                    teardown2();
                    try {
                        reject(err2);
                    } catch (e) {
                        axe.log(e);
                    }
                };
                if (options.performanceTimer) axe.utils.performanceTimer.end();
                try {
                    createReport(rawResults, options, respond, wrappedReject);
                } catch (err2) {
                    wrappedReject(err2);
                }
            }
            function errorRunRules(err2) {
                if (options.performanceTimer) axe.utils.performanceTimer.end();
                axe._running = false;
                callback(err2);
                reject(err2);
            }
            axe._runRules(context, options, handleRunRules, errorRunRules);
            return thenable;
        }
        function getPromiseHandlers(callback) {
            var thenable, reject, resolve;
            if (typeof Promise === "function" && callback === noop2) thenable = new Promise(function(_resolve, _reject) {
                reject = _reject;
                resolve = _resolve;
            });
            else {
                resolve = function resolve(result) {
                    return callback(null, result);
                };
                reject = function reject(err2) {
                    return callback(err2);
                };
            }
            return {
                thenable: thenable,
                reject: reject,
                resolve: resolve
            };
        }
        function createReport(rawResults, options, respond, reject) {
            var reporter = getReporter(options.reporter);
            var results = reporter(rawResults, options, respond, reject);
            if (results !== void 0) respond(results);
        }
        function handleError(err2, callback) {
            if (typeof callback === "function" && callback !== noop2) {
                callback(err2.message);
                return;
            }
            throw err2;
        }
        function runPartial() {
            for(var _len8 = arguments.length, args = new Array(_len8), _key10 = 0; _key10 < _len8; _key10++)args[_key10] = arguments[_key10];
            var _normalizeRunParams2 = normalizeRunParams(args), options = _normalizeRunParams2.options, context = _normalizeRunParams2.context;
            assert_default(axe._audit, "Axe is not configured. Audit is missing.");
            assert_default(!axe._running, "Axe is already running. Use `await axe.run()` to wait for the previous run to finish before starting a new run.");
            var contextObj = new Context(context, axe._tree);
            axe._tree = contextObj.flatTree;
            axe._selectorData = _getSelectorData(contextObj.flatTree);
            axe._running = true;
            options.elementRef = false;
            return new Promise(function(res, rej) {
                axe._audit.run(contextObj, options, res, rej);
            }).then(function(results) {
                results = node_serializer_default.mapRawResults(results);
                var frames = contextObj.frames.map(function(_ref147) {
                    var node = _ref147.node;
                    return node_serializer_default.toSpec(node);
                });
                var environmentData;
                if (contextObj.initiator) environmentData = _getEnvironmentData();
                axe._running = false;
                teardown_default();
                return {
                    results: results,
                    frames: frames,
                    environmentData: environmentData
                };
            })["catch"](function(err2) {
                axe._running = false;
                teardown_default();
                return Promise.reject(err2);
            });
        }
        function finishRun(partialResults) {
            var _ref149, _options$reporter2, _axe$_audit2;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            options = _clone(options);
            var _ref148 = partialResults.find(function(r) {
                return r.environmentData;
            }) || {}, environmentData = _ref148.environmentData;
            axe._audit.normalizeOptions(options);
            options.reporter = (_ref149 = (_options$reporter2 = options.reporter) !== null && _options$reporter2 !== void 0 ? _options$reporter2 : (_axe$_audit2 = axe._audit) === null || _axe$_audit2 === void 0 ? void 0 : _axe$_audit2.reporter) !== null && _ref149 !== void 0 ? _ref149 : "v1";
            setFrameSpec(partialResults);
            var results = merge_results_default(partialResults);
            results = axe._audit.after(results, options);
            results.forEach(_publishMetaData);
            results = results.map(_finalizeRuleResult);
            return createReport2(results, _extends({
                environmentData: environmentData
            }, options));
        }
        function setFrameSpec(partialResults) {
            var frameStack = [];
            var _iterator23 = _createForOfIteratorHelper(partialResults), _step23;
            try {
                for(_iterator23.s(); !(_step23 = _iterator23.n()).done;){
                    var partialResult = _step23.value;
                    var frameSpec = frameStack.shift();
                    if (!partialResult) continue;
                    partialResult.frameSpec = frameSpec !== null && frameSpec !== void 0 ? frameSpec : null;
                    var frameSpecs = getMergedFrameSpecs(partialResult);
                    frameStack.unshift.apply(frameStack, _toConsumableArray(frameSpecs));
                }
            } catch (err) {
                _iterator23.e(err);
            } finally{
                _iterator23.f();
            }
        }
        function getMergedFrameSpecs(_ref150) {
            var childFrameSpecs = _ref150.frames, parentFrameSpec = _ref150.frameSpec;
            if (!parentFrameSpec) return childFrameSpecs;
            return childFrameSpecs.map(function(childFrameSpec) {
                return node_serializer_default.mergeSpecs(childFrameSpec, parentFrameSpec);
            });
        }
        function createReport2(results, options) {
            return new Promise(function(resolve, reject) {
                var reporter = getReporter(options.reporter);
                reporter(results, options, resolve, reject);
            });
        }
        function setup(node) {
            if (axe._tree) throw new Error("Axe is already setup. Call `axe.teardown()` before calling `axe.setup` again.");
            if (node && _typeof(node.documentElement) === "object" && _typeof(node.defaultView) === "object") node = node.documentElement;
            setupGlobals(node);
            axe._tree = _getFlattenedTree(node);
            axe._selectorData = _getSelectorData(axe._tree);
            return axe._tree[0];
        }
        var setup_default = setup;
        var naReporter = function naReporter(results, options, callback) {
            console.warn('"na" reporter will be deprecated in axe v4.0. Use the "v2" reporter instead.');
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            var _options3 = options, environmentData = _options3.environmentData, toolOptions = _objectWithoutProperties(_options3, _excluded15);
            callback(_extends({}, _getEnvironmentData(environmentData), {
                toolOptions: toolOptions
            }, processAggregate(results, options)));
        };
        var na_default = naReporter;
        var noPassesReporter = function noPassesReporter(results, options, callback) {
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            var _options4 = options, environmentData = _options4.environmentData, toolOptions = _objectWithoutProperties(_options4, _excluded16);
            options.resultTypes = [
                "violations"
            ];
            var _processAggregate = processAggregate(results, options), violations = _processAggregate.violations;
            callback(_extends({}, _getEnvironmentData(environmentData), {
                toolOptions: toolOptions,
                violations: violations
            }));
        };
        var no_passes_default = noPassesReporter;
        var rawReporter = function rawReporter(results, options, callback) {
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            if (!results || !Array.isArray(results)) return callback(results);
            var transformedResults = results.map(function(result) {
                var transformedResult = _extends({}, result);
                var types = [
                    "passes",
                    "violations",
                    "incomplete",
                    "inapplicable"
                ];
                for(var _i43 = 0, _types = types; _i43 < _types.length; _i43++){
                    var type2 = _types[_i43];
                    transformedResult[type2] = node_serializer_default.mapRawNodeResults(transformedResult[type2]);
                }
                return transformedResult;
            });
            callback(transformedResults);
        };
        var raw_default = rawReporter;
        var rawEnvReporter = function rawEnvReporter(results, options, callback) {
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            var _options5 = options, environmentData = _options5.environmentData, toolOptions = _objectWithoutProperties(_options5, _excluded17);
            raw_default(results, toolOptions, function(raw) {
                var env = _getEnvironmentData(environmentData);
                callback({
                    raw: raw,
                    env: env
                });
            });
        };
        var raw_env_default = rawEnvReporter;
        var v1Reporter = function v1Reporter(results, options, callback) {
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            var _options6 = options, environmentData = _options6.environmentData, toolOptions = _objectWithoutProperties(_options6, _excluded18);
            var out = processAggregate(results, options);
            var addFailureSummaries = function addFailureSummaries(result) {
                result.nodes.forEach(function(nodeResult) {
                    nodeResult.failureSummary = failure_summary_default(nodeResult);
                });
            };
            out.incomplete.forEach(addFailureSummaries);
            out.violations.forEach(addFailureSummaries);
            callback(_extends({}, _getEnvironmentData(environmentData), {
                toolOptions: toolOptions
            }, out));
        };
        var v1_default = v1Reporter;
        var v2Reporter = function v2Reporter(results, options, callback) {
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            var _options7 = options, environmentData = _options7.environmentData, toolOptions = _objectWithoutProperties(_options7, _excluded19);
            var out = processAggregate(results, options);
            callback(_extends({}, _getEnvironmentData(environmentData), {
                toolOptions: toolOptions
            }, out));
        };
        var v2_default = v2Reporter;
        var _thisWillBeDeletedDoNotUse = {
            base: {
                Audit: audit_default,
                CheckResult: check_result_default,
                Check: check_default,
                Context: Context,
                RuleResult: rule_result_default,
                Rule: Rule,
                metadataFunctionMap: metadata_function_map_default
            },
            public: {
                reporters: reporters
            },
            helpers: {
                failureSummary: failure_summary_default,
                incompleteFallbackMessage: incompleteFallbackMessage,
                processAggregate: processAggregate
            },
            utils: {
                setDefaultFrameMessenger: setDefaultFrameMessenger,
                cacheNodeSelectors: cacheNodeSelectors,
                getNodesMatchingExpression: getNodesMatchingExpression,
                convertSelector: _convertSelector
            },
            commons: {
                dom: {
                    nativelyHidden: nativelyHidden,
                    displayHidden: displayHidden,
                    visibilityHidden: visibilityHidden,
                    contentVisibiltyHidden: contentVisibiltyHidden,
                    ariaHidden: ariaHidden,
                    opacityHidden: opacityHidden,
                    scrollHidden: scrollHidden,
                    overflowHidden: overflowHidden,
                    clipHidden: clipHidden,
                    areaHidden: areaHidden,
                    detailsHidden: detailsHidden
                }
            }
        };
        var exposed_for_testing_default = _thisWillBeDeletedDoNotUse;
        axe._thisWillBeDeletedDoNotUse = exposed_for_testing_default;
        axe.constants = constants_default;
        axe.log = log_default;
        axe.AbstractVirtualNode = abstract_virtual_node_default;
        axe.SerialVirtualNode = serial_virtual_node_default;
        axe.VirtualNode = virtual_node_default;
        axe._cache = cache_default;
        axe.imports = imports_exports;
        axe.cleanup = cleanup_default;
        axe.configure = configure_default;
        axe.frameMessenger = frameMessenger2;
        axe.getRules = get_rules_default;
        axe._load = load;
        axe.plugins = {};
        axe.registerPlugin = plugins_default;
        axe.hasReporter = hasReporter;
        axe.getReporter = getReporter;
        axe.addReporter = addReporter;
        axe.reset = reset_default;
        axe._runRules = runRules;
        axe.runVirtualRule = runVirtualRule;
        axe.run = run4;
        axe.setup = setup_default;
        axe.teardown = teardown_default;
        axe.runPartial = runPartial;
        axe.finishRun = finishRun;
        axe.commons = commons_exports;
        axe.utils = utils_exports;
        axe.addReporter("na", na_default);
        axe.addReporter("no-passes", no_passes_default);
        axe.addReporter("rawEnv", raw_env_default);
        axe.addReporter("raw", raw_default);
        axe.addReporter("v1", v1_default);
        axe.addReporter("v2", v2_default, true);
    })();
    "use strict";
    axe._load({
        lang: "en",
        data: {
            rules: {
                accesskeys: {
                    description: "Ensures every accesskey attribute value is unique",
                    help: "accesskey attribute value should be unique"
                },
                "area-alt": {
                    description: "Ensures <area> elements of image maps have alternate text",
                    help: "Active <area> elements must have alternate text"
                },
                "aria-allowed-attr": {
                    description: "Ensures an element's role supports its ARIA attributes",
                    help: "Elements must only use supported ARIA attributes"
                },
                "aria-allowed-role": {
                    description: "Ensures role attribute has an appropriate value for the element",
                    help: "ARIA role should be appropriate for the element"
                },
                "aria-braille-equivalent": {
                    description: "Ensure aria-braillelabel and aria-brailleroledescription have a non-braille equivalent",
                    help: "aria-braille attributes must have a non-braille equivalent"
                },
                "aria-command-name": {
                    description: "Ensures every ARIA button, link and menuitem has an accessible name",
                    help: "ARIA commands must have an accessible name"
                },
                "aria-conditional-attr": {
                    description: "Ensures ARIA attributes are used as described in the specification of the element's role",
                    help: "ARIA attributes must be used as specified for the element's role"
                },
                "aria-deprecated-role": {
                    description: "Ensures elements do not use deprecated roles",
                    help: "Deprecated ARIA roles must not be used"
                },
                "aria-dialog-name": {
                    description: "Ensures every ARIA dialog and alertdialog node has an accessible name",
                    help: "ARIA dialog and alertdialog nodes should have an accessible name"
                },
                "aria-hidden-body": {
                    description: 'Ensures aria-hidden="true" is not present on the document body.',
                    help: 'aria-hidden="true" must not be present on the document body'
                },
                "aria-hidden-focus": {
                    description: "Ensures aria-hidden elements are not focusable nor contain focusable elements",
                    help: "ARIA hidden element must not be focusable or contain focusable elements"
                },
                "aria-input-field-name": {
                    description: "Ensures every ARIA input field has an accessible name",
                    help: "ARIA input fields must have an accessible name"
                },
                "aria-meter-name": {
                    description: "Ensures every ARIA meter node has an accessible name",
                    help: "ARIA meter nodes must have an accessible name"
                },
                "aria-progressbar-name": {
                    description: "Ensures every ARIA progressbar node has an accessible name",
                    help: "ARIA progressbar nodes must have an accessible name"
                },
                "aria-prohibited-attr": {
                    description: "Ensures ARIA attributes are not prohibited for an element's role",
                    help: "Elements must only use permitted ARIA attributes"
                },
                "aria-required-attr": {
                    description: "Ensures elements with ARIA roles have all required ARIA attributes",
                    help: "Required ARIA attributes must be provided"
                },
                "aria-required-children": {
                    description: "Ensures elements with an ARIA role that require child roles contain them",
                    help: "Certain ARIA roles must contain particular children"
                },
                "aria-required-parent": {
                    description: "Ensures elements with an ARIA role that require parent roles are contained by them",
                    help: "Certain ARIA roles must be contained by particular parents"
                },
                "aria-roledescription": {
                    description: "Ensure aria-roledescription is only used on elements with an implicit or explicit role",
                    help: "aria-roledescription must be on elements with a semantic role"
                },
                "aria-roles": {
                    description: "Ensures all elements with a role attribute use a valid value",
                    help: "ARIA roles used must conform to valid values"
                },
                "aria-text": {
                    description: 'Ensures role="text" is used on elements with no focusable descendants',
                    help: '"role=text" should have no focusable descendants'
                },
                "aria-toggle-field-name": {
                    description: "Ensures every ARIA toggle field has an accessible name",
                    help: "ARIA toggle fields must have an accessible name"
                },
                "aria-tooltip-name": {
                    description: "Ensures every ARIA tooltip node has an accessible name",
                    help: "ARIA tooltip nodes must have an accessible name"
                },
                "aria-treeitem-name": {
                    description: "Ensures every ARIA treeitem node has an accessible name",
                    help: "ARIA treeitem nodes should have an accessible name"
                },
                "aria-valid-attr-value": {
                    description: "Ensures all ARIA attributes have valid values",
                    help: "ARIA attributes must conform to valid values"
                },
                "aria-valid-attr": {
                    description: "Ensures attributes that begin with aria- are valid ARIA attributes",
                    help: "ARIA attributes must conform to valid names"
                },
                "audio-caption": {
                    description: "Ensures <audio> elements have captions",
                    help: "<audio> elements must have a captions track"
                },
                "autocomplete-valid": {
                    description: "Ensure the autocomplete attribute is correct and suitable for the form field",
                    help: "autocomplete attribute must be used correctly"
                },
                "avoid-inline-spacing": {
                    description: "Ensure that text spacing set through style attributes can be adjusted with custom stylesheets",
                    help: "Inline text spacing must be adjustable with custom stylesheets"
                },
                blink: {
                    description: "Ensures <blink> elements are not used",
                    help: "<blink> elements are deprecated and must not be used"
                },
                "button-name": {
                    description: "Ensures buttons have discernible text",
                    help: "Buttons must have discernible text"
                },
                bypass: {
                    description: "Ensures each page has at least one mechanism for a user to bypass navigation and jump straight to the content",
                    help: "Page must have means to bypass repeated blocks"
                },
                "color-contrast-enhanced": {
                    description: "Ensures the contrast between foreground and background colors meets WCAG 2 AAA enhanced contrast ratio thresholds",
                    help: "Elements must meet enhanced color contrast ratio thresholds"
                },
                "color-contrast": {
                    description: "Ensures the contrast between foreground and background colors meets WCAG 2 AA minimum contrast ratio thresholds",
                    help: "Elements must meet minimum color contrast ratio thresholds"
                },
                "css-orientation-lock": {
                    description: "Ensures content is not locked to any specific display orientation, and the content is operable in all display orientations",
                    help: "CSS Media queries must not lock display orientation"
                },
                "definition-list": {
                    description: "Ensures <dl> elements are structured correctly",
                    help: "<dl> elements must only directly contain properly-ordered <dt> and <dd> groups, <script>, <template> or <div> elements"
                },
                dlitem: {
                    description: "Ensures <dt> and <dd> elements are contained by a <dl>",
                    help: "<dt> and <dd> elements must be contained by a <dl>"
                },
                "document-title": {
                    description: "Ensures each HTML document contains a non-empty <title> element",
                    help: "Documents must have <title> element to aid in navigation"
                },
                "duplicate-id-active": {
                    description: "Ensures every id attribute value of active elements is unique",
                    help: "IDs of active elements must be unique"
                },
                "duplicate-id-aria": {
                    description: "Ensures every id attribute value used in ARIA and in labels is unique",
                    help: "IDs used in ARIA and labels must be unique"
                },
                "duplicate-id": {
                    description: "Ensures every id attribute value is unique",
                    help: "id attribute value must be unique"
                },
                "empty-heading": {
                    description: "Ensures headings have discernible text",
                    help: "Headings should not be empty"
                },
                "empty-table-header": {
                    description: "Ensures table headers have discernible text",
                    help: "Table header text should not be empty"
                },
                "focus-order-semantics": {
                    description: "Ensures elements in the focus order have a role appropriate for interactive content",
                    help: "Elements in the focus order should have an appropriate role"
                },
                "form-field-multiple-labels": {
                    description: "Ensures form field does not have multiple label elements",
                    help: "Form field must not have multiple label elements"
                },
                "frame-focusable-content": {
                    description: "Ensures <frame> and <iframe> elements with focusable content do not have tabindex=-1",
                    help: "Frames with focusable content must not have tabindex=-1"
                },
                "frame-tested": {
                    description: "Ensures <iframe> and <frame> elements contain the axe-core script",
                    help: "Frames should be tested with axe-core"
                },
                "frame-title-unique": {
                    description: "Ensures <iframe> and <frame> elements contain a unique title attribute",
                    help: "Frames must have a unique title attribute"
                },
                "frame-title": {
                    description: "Ensures <iframe> and <frame> elements have an accessible name",
                    help: "Frames must have an accessible name"
                },
                "heading-order": {
                    description: "Ensures the order of headings is semantically correct",
                    help: "Heading levels should only increase by one"
                },
                "hidden-content": {
                    description: "Informs users about hidden content.",
                    help: "Hidden content on the page should be analyzed"
                },
                "html-has-lang": {
                    description: "Ensures every HTML document has a lang attribute",
                    help: "<html> element must have a lang attribute"
                },
                "html-lang-valid": {
                    description: "Ensures the lang attribute of the <html> element has a valid value",
                    help: "<html> element must have a valid value for the lang attribute"
                },
                "html-xml-lang-mismatch": {
                    description: "Ensure that HTML elements with both valid lang and xml:lang attributes agree on the base language of the page",
                    help: "HTML elements with lang and xml:lang must have the same base language"
                },
                "identical-links-same-purpose": {
                    description: "Ensure that links with the same accessible name serve a similar purpose",
                    help: "Links with the same name must have a similar purpose"
                },
                "image-alt": {
                    description: "Ensures <img> elements have alternate text or a role of none or presentation",
                    help: "Images must have alternate text"
                },
                "image-redundant-alt": {
                    description: "Ensure image alternative is not repeated as text",
                    help: "Alternative text of images should not be repeated as text"
                },
                "input-button-name": {
                    description: "Ensures input buttons have discernible text",
                    help: "Input buttons must have discernible text"
                },
                "input-image-alt": {
                    description: 'Ensures <input type="image"> elements have alternate text',
                    help: "Image buttons must have alternate text"
                },
                "label-content-name-mismatch": {
                    description: "Ensures that elements labelled through their content must have their visible text as part of their accessible name",
                    help: "Elements must have their visible text as part of their accessible name"
                },
                "label-title-only": {
                    description: "Ensures that every form element has a visible label and is not solely labeled using hidden labels, or the title or aria-describedby attributes",
                    help: "Form elements should have a visible label"
                },
                label: {
                    description: "Ensures every form element has a label",
                    help: "Form elements must have labels"
                },
                "landmark-banner-is-top-level": {
                    description: "Ensures the banner landmark is at top level",
                    help: "Banner landmark should not be contained in another landmark"
                },
                "landmark-complementary-is-top-level": {
                    description: "Ensures the complementary landmark or aside is at top level",
                    help: "Aside should not be contained in another landmark"
                },
                "landmark-contentinfo-is-top-level": {
                    description: "Ensures the contentinfo landmark is at top level",
                    help: "Contentinfo landmark should not be contained in another landmark"
                },
                "landmark-main-is-top-level": {
                    description: "Ensures the main landmark is at top level",
                    help: "Main landmark should not be contained in another landmark"
                },
                "landmark-no-duplicate-banner": {
                    description: "Ensures the document has at most one banner landmark",
                    help: "Document should not have more than one banner landmark"
                },
                "landmark-no-duplicate-contentinfo": {
                    description: "Ensures the document has at most one contentinfo landmark",
                    help: "Document should not have more than one contentinfo landmark"
                },
                "landmark-no-duplicate-main": {
                    description: "Ensures the document has at most one main landmark",
                    help: "Document should not have more than one main landmark"
                },
                "landmark-one-main": {
                    description: "Ensures the document has a main landmark",
                    help: "Document should have one main landmark"
                },
                "landmark-unique": {
                    help: "Ensures landmarks are unique",
                    description: "Landmarks should have a unique role or role/label/title (i.e. accessible name) combination"
                },
                "link-in-text-block": {
                    description: "Ensure links are distinguished from surrounding text in a way that does not rely on color",
                    help: "Links must be distinguishable without relying on color"
                },
                "link-name": {
                    description: "Ensures links have discernible text",
                    help: "Links must have discernible text"
                },
                list: {
                    description: "Ensures that lists are structured correctly",
                    help: "<ul> and <ol> must only directly contain <li>, <script> or <template> elements"
                },
                listitem: {
                    description: "Ensures <li> elements are used semantically",
                    help: "<li> elements must be contained in a <ul> or <ol>"
                },
                marquee: {
                    description: "Ensures <marquee> elements are not used",
                    help: "<marquee> elements are deprecated and must not be used"
                },
                "meta-refresh-no-exceptions": {
                    description: 'Ensures <meta http-equiv="refresh"> is not used for delayed refresh',
                    help: "Delayed refresh must not be used"
                },
                "meta-refresh": {
                    description: 'Ensures <meta http-equiv="refresh"> is not used for delayed refresh',
                    help: "Delayed refresh under 20 hours must not be used"
                },
                "meta-viewport-large": {
                    description: 'Ensures <meta name="viewport"> can scale a significant amount',
                    help: "Users should be able to zoom and scale the text up to 500%"
                },
                "meta-viewport": {
                    description: 'Ensures <meta name="viewport"> does not disable text scaling and zooming',
                    help: "Zooming and scaling must not be disabled"
                },
                "nested-interactive": {
                    description: "Ensures interactive controls are not nested as they are not always announced by screen readers or can cause focus problems for assistive technologies",
                    help: "Interactive controls must not be nested"
                },
                "no-autoplay-audio": {
                    description: "Ensures <video> or <audio> elements do not autoplay audio for more than 3 seconds without a control mechanism to stop or mute the audio",
                    help: "<video> or <audio> elements must not play automatically"
                },
                "object-alt": {
                    description: "Ensures <object> elements have alternate text",
                    help: "<object> elements must have alternate text"
                },
                "p-as-heading": {
                    description: "Ensure bold, italic text and font-size is not used to style <p> elements as a heading",
                    help: "Styled <p> elements must not be used as headings"
                },
                "page-has-heading-one": {
                    description: "Ensure that the page, or at least one of its frames contains a level-one heading",
                    help: "Page should contain a level-one heading"
                },
                "presentation-role-conflict": {
                    description: "Elements marked as presentational should not have global ARIA or tabindex to ensure all screen readers ignore them",
                    help: "Ensure elements marked as presentational are consistently ignored"
                },
                region: {
                    description: "Ensures all page content is contained by landmarks",
                    help: "All page content should be contained by landmarks"
                },
                "role-img-alt": {
                    description: 'Ensures [role="img"] elements have alternate text',
                    help: '[role="img"] elements must have an alternative text'
                },
                "scope-attr-valid": {
                    description: "Ensures the scope attribute is used correctly on tables",
                    help: "scope attribute should be used correctly"
                },
                "scrollable-region-focusable": {
                    description: "Ensure elements that have scrollable content are accessible by keyboard",
                    help: "Scrollable region must have keyboard access"
                },
                "select-name": {
                    description: "Ensures select element has an accessible name",
                    help: "Select element must have an accessible name"
                },
                "server-side-image-map": {
                    description: "Ensures that server-side image maps are not used",
                    help: "Server-side image maps must not be used"
                },
                "skip-link": {
                    description: "Ensure all skip links have a focusable target",
                    help: "The skip-link target should exist and be focusable"
                },
                "svg-img-alt": {
                    description: "Ensures <svg> elements with an img, graphics-document or graphics-symbol role have an accessible text",
                    help: "<svg> elements with an img role must have an alternative text"
                },
                tabindex: {
                    description: "Ensures tabindex attribute values are not greater than 0",
                    help: "Elements should not have tabindex greater than zero"
                },
                "table-duplicate-name": {
                    description: "Ensure the <caption> element does not contain the same text as the summary attribute",
                    help: "tables should not have the same summary and caption"
                },
                "table-fake-caption": {
                    description: "Ensure that tables with a caption use the <caption> element.",
                    help: "Data or header cells must not be used to give caption to a data table."
                },
                "target-size": {
                    description: "Ensure touch target have sufficient size and space",
                    help: "All touch targets must be 24px large, or leave sufficient space"
                },
                "td-has-header": {
                    description: "Ensure that each non-empty data cell in a <table> larger than 3 by 3  has one or more table headers",
                    help: "Non-empty <td> elements in larger <table> must have an associated table header"
                },
                "td-headers-attr": {
                    description: "Ensure that each cell in a table that uses the headers attribute refers only to other cells in that table",
                    help: "Table cells that use the headers attribute must only refer to cells in the same table"
                },
                "th-has-data-cells": {
                    description: "Ensure that <th> elements and elements with role=columnheader/rowheader have data cells they describe",
                    help: "Table headers in a data table must refer to data cells"
                },
                "valid-lang": {
                    description: "Ensures lang attributes have valid values",
                    help: "lang attribute must have a valid value"
                },
                "video-caption": {
                    description: "Ensures <video> elements have captions",
                    help: "<video> elements must have captions"
                }
            },
            checks: {
                abstractrole: {
                    impact: "serious",
                    messages: {
                        pass: "Abstract roles are not used",
                        fail: {
                            singular: "Abstract role cannot be directly used: ${data.values}",
                            plural: "Abstract roles cannot be directly used: ${data.values}"
                        }
                    }
                },
                "aria-allowed-attr": {
                    impact: "critical",
                    messages: {
                        pass: "ARIA attributes are used correctly for the defined role",
                        fail: {
                            singular: "ARIA attribute is not allowed: ${data.values}",
                            plural: "ARIA attributes are not allowed: ${data.values}"
                        },
                        incomplete: "Check that there is no problem if the ARIA attribute is ignored on this element: ${data.values}"
                    }
                },
                "aria-allowed-role": {
                    impact: "minor",
                    messages: {
                        pass: "ARIA role is allowed for given element",
                        fail: {
                            singular: "ARIA role ${data.values} is not allowed for given element",
                            plural: "ARIA roles ${data.values} are not allowed for given element"
                        },
                        incomplete: {
                            singular: "ARIA role ${data.values} must be removed when the element is made visible, as it is not allowed for the element",
                            plural: "ARIA roles ${data.values} must be removed when the element is made visible, as they are not allowed for the element"
                        }
                    }
                },
                "aria-busy": {
                    impact: "serious",
                    messages: {
                        pass: "Element has an aria-busy attribute",
                        fail: 'Element uses aria-busy="true" while showing a loader'
                    }
                },
                "aria-conditional-attr": {
                    impact: "serious",
                    messages: {
                        pass: "ARIA attribute is allowed",
                        fail: {
                            checkbox: 'Remove aria-checked, or set it to "${data.checkState}" to match the real checkbox state',
                            rowSingular: "This attribute is supported with treegrid rows, but not ${data.ownerRole}: ${data.invalidAttrs}",
                            rowPlural: "These attributes are supported with treegrid rows, but not ${data.ownerRole}: ${data.invalidAttrs}"
                        }
                    }
                },
                "aria-errormessage": {
                    impact: "critical",
                    messages: {
                        pass: "aria-errormessage exists and references elements visible to screen readers that use a supported aria-errormessage technique",
                        fail: {
                            singular: "aria-errormessage value `${data.values}` must use a technique to announce the message (e.g., aria-live, aria-describedby, role=alert, etc.)",
                            plural: "aria-errormessage values `${data.values}` must use a technique to announce the message (e.g., aria-live, aria-describedby, role=alert, etc.)",
                            hidden: "aria-errormessage value `${data.values}` cannot reference a hidden element"
                        },
                        incomplete: {
                            singular: "ensure aria-errormessage value `${data.values}` references an existing element",
                            plural: "ensure aria-errormessage values `${data.values}` reference existing elements",
                            idrefs: "unable to determine if aria-errormessage element exists on the page: ${data.values}"
                        }
                    }
                },
                "aria-hidden-body": {
                    impact: "critical",
                    messages: {
                        pass: "No aria-hidden attribute is present on document body",
                        fail: "aria-hidden=true should not be present on the document body"
                    }
                },
                "aria-level": {
                    impact: "serious",
                    messages: {
                        pass: "aria-level values are valid",
                        incomplete: "aria-level values greater than 6 are not supported in all screenreader and browser combinations"
                    }
                },
                "aria-prohibited-attr": {
                    impact: "serious",
                    messages: {
                        pass: "ARIA attribute is allowed",
                        fail: {
                            hasRolePlural: '${data.prohibited} attributes cannot be used with role "${data.role}".',
                            hasRoleSingular: '${data.prohibited} attribute cannot be used with role "${data.role}".',
                            noRolePlural: "${data.prohibited} attributes cannot be used on a ${data.nodeName} with no valid role attribute.",
                            noRoleSingular: "${data.prohibited} attribute cannot be used on a ${data.nodeName} with no valid role attribute."
                        },
                        incomplete: {
                            hasRoleSingular: '${data.prohibited} attribute is not well supported with role "${data.role}".',
                            hasRolePlural: '${data.prohibited} attributes are not well supported with role "${data.role}".',
                            noRoleSingular: "${data.prohibited} attribute is not well supported on a ${data.nodeName} with no valid role attribute.",
                            noRolePlural: "${data.prohibited} attributes are not well supported on a ${data.nodeName} with no valid role attribute."
                        }
                    }
                },
                "aria-required-attr": {
                    impact: "critical",
                    messages: {
                        pass: "All required ARIA attributes are present",
                        fail: {
                            singular: "Required ARIA attribute not present: ${data.values}",
                            plural: "Required ARIA attributes not present: ${data.values}"
                        }
                    }
                },
                "aria-required-children": {
                    impact: "critical",
                    messages: {
                        pass: "Required ARIA children are present",
                        fail: {
                            singular: "Required ARIA child role not present: ${data.values}",
                            plural: "Required ARIA children role not present: ${data.values}",
                            unallowed: "Element has children which are not allowed: ${data.values}"
                        },
                        incomplete: {
                            singular: "Expecting ARIA child role to be added: ${data.values}",
                            plural: "Expecting ARIA children role to be added: ${data.values}"
                        }
                    }
                },
                "aria-required-parent": {
                    impact: "critical",
                    messages: {
                        pass: "Required ARIA parent role present",
                        fail: {
                            singular: "Required ARIA parent role not present: ${data.values}",
                            plural: "Required ARIA parents role not present: ${data.values}"
                        }
                    }
                },
                "aria-roledescription": {
                    impact: "serious",
                    messages: {
                        pass: "aria-roledescription used on a supported semantic role",
                        incomplete: "Check that the aria-roledescription is announced by supported screen readers",
                        fail: "Give the element a role that supports aria-roledescription"
                    }
                },
                "aria-unsupported-attr": {
                    impact: "critical",
                    messages: {
                        pass: "ARIA attribute is supported",
                        fail: "ARIA attribute is not widely supported in screen readers and assistive technologies: ${data.values}"
                    }
                },
                "aria-valid-attr-value": {
                    impact: "critical",
                    messages: {
                        pass: "ARIA attribute values are valid",
                        fail: {
                            singular: "Invalid ARIA attribute value: ${data.values}",
                            plural: "Invalid ARIA attribute values: ${data.values}"
                        },
                        incomplete: {
                            noId: "ARIA attribute element ID does not exist on the page: ${data.needsReview}",
                            noIdShadow: "ARIA attribute element ID does not exist on the page or is a descendant of a different shadow DOM tree: ${data.needsReview}",
                            ariaCurrent: 'ARIA attribute value is invalid and will be treated as "aria-current=true": ${data.needsReview}',
                            idrefs: "Unable to determine if ARIA attribute element ID exists on the page: ${data.needsReview}",
                            empty: "ARIA attribute value is ignored while empty: ${data.needsReview}"
                        }
                    }
                },
                "aria-valid-attr": {
                    impact: "critical",
                    messages: {
                        pass: "ARIA attribute name is valid",
                        fail: {
                            singular: "Invalid ARIA attribute name: ${data.values}",
                            plural: "Invalid ARIA attribute names: ${data.values}"
                        }
                    }
                },
                "braille-label-equivalent": {
                    impact: "serious",
                    messages: {
                        pass: "aria-braillelabel is used on an element with accessible text",
                        fail: "aria-braillelabel is used on an element with no accessible text",
                        incomplete: "Unable to compute accessible text"
                    }
                },
                "braille-roledescription-equivalent": {
                    impact: "serious",
                    messages: {
                        pass: "aria-brailleroledescription is used on an element with aria-roledescription",
                        fail: {
                            noRoleDescription: "aria-brailleroledescription is used on an element with no aria-roledescription",
                            emptyRoleDescription: "aria-brailleroledescription is used on an element with an empty aria-roledescription"
                        }
                    }
                },
                deprecatedrole: {
                    impact: "minor",
                    messages: {
                        pass: "ARIA role is not deprecated",
                        fail: "The role used is deprecated: ${data}"
                    }
                },
                fallbackrole: {
                    impact: "serious",
                    messages: {
                        pass: "Only one role value used",
                        fail: "Use only one role value, since fallback roles are not supported in older browsers",
                        incomplete: "Use only role 'presentation' or 'none' since they are synonymous."
                    }
                },
                "has-global-aria-attribute": {
                    impact: "minor",
                    messages: {
                        pass: {
                            singular: "Element has global ARIA attribute: ${data.values}",
                            plural: "Element has global ARIA attributes: ${data.values}"
                        },
                        fail: "Element does not have global ARIA attribute"
                    }
                },
                "has-widget-role": {
                    impact: "minor",
                    messages: {
                        pass: "Element has a widget role.",
                        fail: "Element does not have a widget role."
                    }
                },
                invalidrole: {
                    impact: "critical",
                    messages: {
                        pass: "ARIA role is valid",
                        fail: {
                            singular: "Role must be one of the valid ARIA roles: ${data.values}",
                            plural: "Roles must be one of the valid ARIA roles: ${data.values}"
                        }
                    }
                },
                "is-element-focusable": {
                    impact: "minor",
                    messages: {
                        pass: "Element is focusable.",
                        fail: "Element is not focusable."
                    }
                },
                "no-implicit-explicit-label": {
                    impact: "serious",
                    messages: {
                        pass: "There is no mismatch between a <label> and accessible name",
                        incomplete: "Check that the <label> does not need be part of the ARIA ${data} field's name"
                    }
                },
                unsupportedrole: {
                    impact: "critical",
                    messages: {
                        pass: "ARIA role is supported",
                        fail: "The role used is not widely supported in screen readers and assistive technologies: ${data}"
                    }
                },
                "valid-scrollable-semantics": {
                    impact: "minor",
                    messages: {
                        pass: "Element has valid semantics for an element in the focus order.",
                        fail: "Element has invalid semantics for an element in the focus order."
                    }
                },
                "color-contrast-enhanced": {
                    impact: "serious",
                    messages: {
                        pass: "Element has sufficient color contrast of ${data.contrastRatio}",
                        fail: {
                            default: "Element has insufficient color contrast of ${data.contrastRatio} (foreground color: ${data.fgColor}, background color: ${data.bgColor}, font size: ${data.fontSize}, font weight: ${data.fontWeight}). Expected contrast ratio of ${data.expectedContrastRatio}",
                            fgOnShadowColor: "Element has insufficient color contrast of ${data.contrastRatio} between the foreground and shadow color (foreground color: ${data.fgColor}, text-shadow color: ${data.shadowColor}, font size: ${data.fontSize}, font weight: ${data.fontWeight}). Expected contrast ratio of ${data.expectedContrastRatio}",
                            shadowOnBgColor: "Element has insufficient color contrast of ${data.contrastRatio} between the shadow color and background color (text-shadow color: ${data.shadowColor}, background color: ${data.bgColor}, font size: ${data.fontSize}, font weight: ${data.fontWeight}). Expected contrast ratio of ${data.expectedContrastRatio}"
                        },
                        incomplete: {
                            default: "Unable to determine contrast ratio",
                            bgImage: "Element's background color could not be determined due to a background image",
                            bgGradient: "Element's background color could not be determined due to a background gradient",
                            imgNode: "Element's background color could not be determined because element contains an image node",
                            bgOverlap: "Element's background color could not be determined because it is overlapped by another element",
                            fgAlpha: "Element's foreground color could not be determined because of alpha transparency",
                            elmPartiallyObscured: "Element's background color could not be determined because it's partially obscured by another element",
                            elmPartiallyObscuring: "Element's background color could not be determined because it partially overlaps other elements",
                            outsideViewport: "Element's background color could not be determined because it's outside the viewport",
                            equalRatio: "Element has a 1:1 contrast ratio with the background",
                            shortTextContent: "Element content is too short to determine if it is actual text content",
                            nonBmp: "Element content contains only non-text characters",
                            pseudoContent: "Element's background color could not be determined due to a pseudo element"
                        }
                    }
                },
                "color-contrast": {
                    impact: "serious",
                    messages: {
                        pass: {
                            default: "Element has sufficient color contrast of ${data.contrastRatio}",
                            hidden: "Element is hidden"
                        },
                        fail: {
                            default: "Element has insufficient color contrast of ${data.contrastRatio} (foreground color: ${data.fgColor}, background color: ${data.bgColor}, font size: ${data.fontSize}, font weight: ${data.fontWeight}). Expected contrast ratio of ${data.expectedContrastRatio}",
                            fgOnShadowColor: "Element has insufficient color contrast of ${data.contrastRatio} between the foreground and shadow color (foreground color: ${data.fgColor}, text-shadow color: ${data.shadowColor}, font size: ${data.fontSize}, font weight: ${data.fontWeight}). Expected contrast ratio of ${data.expectedContrastRatio}",
                            shadowOnBgColor: "Element has insufficient color contrast of ${data.contrastRatio} between the shadow color and background color (text-shadow color: ${data.shadowColor}, background color: ${data.bgColor}, font size: ${data.fontSize}, font weight: ${data.fontWeight}). Expected contrast ratio of ${data.expectedContrastRatio}"
                        },
                        incomplete: {
                            default: "Unable to determine contrast ratio",
                            bgImage: "Element's background color could not be determined due to a background image",
                            bgGradient: "Element's background color could not be determined due to a background gradient",
                            imgNode: "Element's background color could not be determined because element contains an image node",
                            bgOverlap: "Element's background color could not be determined because it is overlapped by another element",
                            complexTextShadows: "Element's contrast could not be determined because it uses complex text shadows",
                            fgAlpha: "Element's foreground color could not be determined because of alpha transparency",
                            elmPartiallyObscured: "Element's background color could not be determined because it's partially obscured by another element",
                            elmPartiallyObscuring: "Element's background color could not be determined because it partially overlaps other elements",
                            outsideViewport: "Element's background color could not be determined because it's outside the viewport",
                            equalRatio: "Element has a 1:1 contrast ratio with the background",
                            shortTextContent: "Element content is too short to determine if it is actual text content",
                            nonBmp: "Element content contains only non-text characters",
                            pseudoContent: "Element's background color could not be determined due to a pseudo element"
                        }
                    }
                },
                "link-in-text-block-style": {
                    impact: "serious",
                    messages: {
                        pass: "Links can be distinguished from surrounding text by visual styling",
                        incomplete: {
                            default: "Check if the link needs styling to distinguish it from nearby text",
                            pseudoContent: "Check if the link's pseudo style is sufficient to distinguish it from the surrounding text"
                        },
                        fail: "The link has no styling (such as underline) to distinguish it from the surrounding text"
                    }
                },
                "link-in-text-block": {
                    impact: "serious",
                    messages: {
                        pass: "Links can be distinguished from surrounding text in some way other than by color",
                        fail: {
                            fgContrast: "The link has insufficient color contrast of ${data.contrastRatio}:1 with the surrounding text. (Minimum contrast is ${data.requiredContrastRatio}:1, link text: ${data.nodeColor}, surrounding text: ${data.parentColor})",
                            bgContrast: "The link background has insufficient color contrast of ${data.contrastRatio} (Minimum contrast is ${data.requiredContrastRatio}:1, link background color: ${data.nodeBackgroundColor}, surrounding background color: ${data.parentBackgroundColor})"
                        },
                        incomplete: {
                            default: "Element's foreground contrast ratio could not be determined",
                            bgContrast: "Element's background contrast ratio could not be determined",
                            bgImage: "Element's contrast ratio could not be determined due to a background image",
                            bgGradient: "Element's contrast ratio could not be determined due to a background gradient",
                            imgNode: "Element's contrast ratio could not be determined because element contains an image node",
                            bgOverlap: "Element's contrast ratio could not be determined because of element overlap"
                        }
                    }
                },
                "autocomplete-appropriate": {
                    impact: "serious",
                    messages: {
                        pass: "the autocomplete value is on an appropriate element",
                        fail: "the autocomplete value is inappropriate for this type of input"
                    }
                },
                "autocomplete-valid": {
                    impact: "serious",
                    messages: {
                        pass: "the autocomplete attribute is correctly formatted",
                        fail: "the autocomplete attribute is incorrectly formatted"
                    }
                },
                accesskeys: {
                    impact: "serious",
                    messages: {
                        pass: "Accesskey attribute value is unique",
                        fail: "Document has multiple elements with the same accesskey"
                    }
                },
                "focusable-content": {
                    impact: "serious",
                    messages: {
                        pass: "Element contains focusable elements",
                        fail: "Element should have focusable content"
                    }
                },
                "focusable-disabled": {
                    impact: "serious",
                    messages: {
                        pass: "No focusable elements contained within element",
                        incomplete: "Check if the focusable elements immediately move the focus indicator",
                        fail: "Focusable content should be disabled or be removed from the DOM"
                    }
                },
                "focusable-element": {
                    impact: "serious",
                    messages: {
                        pass: "Element is focusable",
                        fail: "Element should be focusable"
                    }
                },
                "focusable-modal-open": {
                    impact: "serious",
                    messages: {
                        pass: "No focusable elements while a modal is open",
                        incomplete: "Check that focusable elements are not tabbable in the current state"
                    }
                },
                "focusable-no-name": {
                    impact: "serious",
                    messages: {
                        pass: "Element is not in tab order or has accessible text",
                        fail: "Element is in tab order and does not have accessible text",
                        incomplete: "Unable to determine if element has an accessible name"
                    }
                },
                "focusable-not-tabbable": {
                    impact: "serious",
                    messages: {
                        pass: "No focusable elements contained within element",
                        incomplete: "Check if the focusable elements immediately move the focus indicator",
                        fail: 'Focusable content should have tabindex="-1" or be removed from the DOM'
                    }
                },
                "frame-focusable-content": {
                    impact: "serious",
                    messages: {
                        pass: "Element does not have focusable descendants",
                        fail: "Element has focusable descendants",
                        incomplete: "Could not determine if element has descendants"
                    }
                },
                "landmark-is-top-level": {
                    impact: "moderate",
                    messages: {
                        pass: "The ${data.role} landmark is at the top level.",
                        fail: "The ${data.role} landmark is contained in another landmark."
                    }
                },
                "no-focusable-content": {
                    impact: "serious",
                    messages: {
                        pass: "Element does not have focusable descendants",
                        fail: {
                            default: "Element has focusable descendants",
                            notHidden: 'Using a negative tabindex on an element inside an interactive control does not prevent assistive technologies from focusing the element (even with aria-hidden="true")'
                        },
                        incomplete: "Could not determine if element has descendants"
                    }
                },
                "page-has-heading-one": {
                    impact: "moderate",
                    messages: {
                        pass: "Page has at least one level-one heading",
                        fail: "Page must have a level-one heading"
                    }
                },
                "page-has-main": {
                    impact: "moderate",
                    messages: {
                        pass: "Document has at least one main landmark",
                        fail: "Document does not have a main landmark"
                    }
                },
                "page-no-duplicate-banner": {
                    impact: "moderate",
                    messages: {
                        pass: "Document does not have more than one banner landmark",
                        fail: "Document has more than one banner landmark"
                    }
                },
                "page-no-duplicate-contentinfo": {
                    impact: "moderate",
                    messages: {
                        pass: "Document does not have more than one contentinfo landmark",
                        fail: "Document has more than one contentinfo landmark"
                    }
                },
                "page-no-duplicate-main": {
                    impact: "moderate",
                    messages: {
                        pass: "Document does not have more than one main landmark",
                        fail: "Document has more than one main landmark"
                    }
                },
                tabindex: {
                    impact: "serious",
                    messages: {
                        pass: "Element does not have a tabindex greater than 0",
                        fail: "Element has a tabindex greater than 0"
                    }
                },
                "alt-space-value": {
                    impact: "critical",
                    messages: {
                        pass: "Element has a valid alt attribute value",
                        fail: "Element has an alt attribute containing only a space character, which is not ignored by all screen readers"
                    }
                },
                "duplicate-img-label": {
                    impact: "minor",
                    messages: {
                        pass: "Element does not duplicate existing text in <img> alt text",
                        fail: "Element contains <img> element with alt text that duplicates existing text"
                    }
                },
                "explicit-label": {
                    impact: "critical",
                    messages: {
                        pass: "Form element has an explicit <label>",
                        fail: "Form element does not have an explicit <label>",
                        incomplete: "Unable to determine if form element has an explicit <label>"
                    }
                },
                "help-same-as-label": {
                    impact: "minor",
                    messages: {
                        pass: "Help text (title or aria-describedby) does not duplicate label text",
                        fail: "Help text (title or aria-describedby) text is the same as the label text"
                    }
                },
                "hidden-explicit-label": {
                    impact: "critical",
                    messages: {
                        pass: "Form element has a visible explicit <label>",
                        fail: "Form element has explicit <label> that is hidden",
                        incomplete: "Unable to determine if form element has explicit <label> that is hidden"
                    }
                },
                "implicit-label": {
                    impact: "critical",
                    messages: {
                        pass: "Form element has an implicit (wrapped) <label>",
                        fail: "Form element does not have an implicit (wrapped) <label>",
                        incomplete: "Unable to determine if form element has an implicit (wrapped} <label>"
                    }
                },
                "label-content-name-mismatch": {
                    impact: "serious",
                    messages: {
                        pass: "Element contains visible text as part of it's accessible name",
                        fail: "Text inside the element is not included in the accessible name"
                    }
                },
                "multiple-label": {
                    impact: "moderate",
                    messages: {
                        pass: "Form field does not have multiple label elements",
                        incomplete: "Multiple label elements is not widely supported in assistive technologies. Ensure the first label contains all necessary information."
                    }
                },
                "title-only": {
                    impact: "serious",
                    messages: {
                        pass: "Form element does not solely use title attribute for its label",
                        fail: "Only title used to generate label for form element"
                    }
                },
                "landmark-is-unique": {
                    impact: "moderate",
                    messages: {
                        pass: "Landmarks must have a unique role or role/label/title (i.e. accessible name) combination",
                        fail: "The landmark must have a unique aria-label, aria-labelledby, or title to make landmarks distinguishable"
                    }
                },
                "has-lang": {
                    impact: "serious",
                    messages: {
                        pass: "The <html> element has a lang attribute",
                        fail: {
                            noXHTML: "The xml:lang attribute is not valid on HTML pages, use the lang attribute.",
                            noLang: "The <html> element does not have a lang attribute"
                        }
                    }
                },
                "valid-lang": {
                    impact: "serious",
                    messages: {
                        pass: "Value of lang attribute is included in the list of valid languages",
                        fail: "Value of lang attribute not included in the list of valid languages"
                    }
                },
                "xml-lang-mismatch": {
                    impact: "moderate",
                    messages: {
                        pass: "Lang and xml:lang attributes have the same base language",
                        fail: "Lang and xml:lang attributes do not have the same base language"
                    }
                },
                dlitem: {
                    impact: "serious",
                    messages: {
                        pass: "Description list item has a <dl> parent element",
                        fail: "Description list item does not have a <dl> parent element"
                    }
                },
                listitem: {
                    impact: "serious",
                    messages: {
                        pass: 'List item has a <ul>, <ol> or role="list" parent element',
                        fail: {
                            default: "List item does not have a <ul>, <ol> parent element",
                            roleNotValid: 'List item does not have a <ul>, <ol> parent element without a role, or a role="list"'
                        }
                    }
                },
                "only-dlitems": {
                    impact: "serious",
                    messages: {
                        pass: "dl element only has direct children that are allowed inside; <dt>, <dd>, or <div> elements",
                        fail: "dl element has direct children that are not allowed: ${data.values}"
                    }
                },
                "only-listitems": {
                    impact: "serious",
                    messages: {
                        pass: "List element only has direct children that are allowed inside <li> elements",
                        fail: "List element has direct children that are not allowed: ${data.values}"
                    }
                },
                "structured-dlitems": {
                    impact: "serious",
                    messages: {
                        pass: "When not empty, element has both <dt> and <dd> elements",
                        fail: "When not empty, element does not have at least one <dt> element followed by at least one <dd> element"
                    }
                },
                caption: {
                    impact: "critical",
                    messages: {
                        pass: "The multimedia element has a captions track",
                        incomplete: "Check that captions is available for the element"
                    }
                },
                "frame-tested": {
                    impact: "critical",
                    messages: {
                        pass: "The iframe was tested with axe-core",
                        fail: "The iframe could not be tested with axe-core",
                        incomplete: "The iframe still has to be tested with axe-core"
                    }
                },
                "no-autoplay-audio": {
                    impact: "moderate",
                    messages: {
                        pass: "<video> or <audio> does not output audio for more than allowed duration or has controls mechanism",
                        fail: "<video> or <audio> outputs audio for more than allowed duration and does not have a controls mechanism",
                        incomplete: "Check that the <video> or <audio> does not output audio for more than allowed duration or provides a controls mechanism"
                    }
                },
                "css-orientation-lock": {
                    impact: "serious",
                    messages: {
                        pass: "Display is operable, and orientation lock does not exist",
                        fail: "CSS Orientation lock is applied, and makes display inoperable",
                        incomplete: "CSS Orientation lock cannot be determined"
                    }
                },
                "meta-viewport-large": {
                    impact: "minor",
                    messages: {
                        pass: "<meta> tag does not prevent significant zooming on mobile devices",
                        fail: "<meta> tag limits zooming on mobile devices"
                    }
                },
                "meta-viewport": {
                    impact: "critical",
                    messages: {
                        pass: "<meta> tag does not disable zooming on mobile devices",
                        fail: "${data} on <meta> tag disables zooming on mobile devices"
                    }
                },
                "target-offset": {
                    impact: "serious",
                    messages: {
                        pass: "Target has sufficient space from its closest neighbors. Safe clickable space has a diameter of ${data.closestOffset}px which is at least ${data.minOffset}px.",
                        fail: "Target has insufficient space to its closest neighbors. Safe clickable space has a diameter of ${data.closestOffset}px instead of at least ${data.minOffset}px.",
                        incomplete: {
                            default: "Element with negative tabindex has insufficient space to its closest neighbors. Safe clickable space has a diameter of ${data.closestOffset}px instead of at least ${data.minOffset}px. Is this a target?",
                            nonTabbableNeighbor: "Target has insufficient space to its closest neighbors. Safe clickable space has a diameter of ${data.closestOffset}px instead of at least ${data.minOffset}px. Is the neighbor a target?"
                        }
                    }
                },
                "target-size": {
                    impact: "serious",
                    messages: {
                        pass: {
                            default: "Control has sufficient size (${data.width}px by ${data.height}px, should be at least ${data.minSize}px by ${data.minSize}px)",
                            obscured: "Control is ignored because it is fully obscured and thus not clickable"
                        },
                        fail: {
                            default: "Target has insufficient size (${data.width}px by ${data.height}px, should be at least ${data.minSize}px by ${data.minSize}px)",
                            partiallyObscured: "Target has insufficient size because it is partially obscured (smallest space is ${data.width}px by ${data.height}px, should be at least ${data.minSize}px by ${data.minSize}px)"
                        },
                        incomplete: {
                            default: "Element with negative tabindex has insufficient size (${data.width}px by ${data.height}px, should be at least ${data.minSize}px by ${data.minSize}px). Is this a target?",
                            contentOverflow: "Element size could not be accurately determined due to overflow content",
                            partiallyObscured: "Element with negative tabindex has insufficient size because it is partially obscured (smallest space is ${data.width}px by ${data.height}px, should be at least ${data.minSize}px by ${data.minSize}px). Is this a target?",
                            partiallyObscuredNonTabbable: "Target has insufficient size because it is partially obscured by a neighbor with negative tabindex (smallest space is ${data.width}px by ${data.height}px, should be at least ${data.minSize}px by ${data.minSize}px). Is the neighbor a target?"
                        }
                    }
                },
                "header-present": {
                    impact: "serious",
                    messages: {
                        pass: "Page has a heading",
                        fail: "Page does not have a heading"
                    }
                },
                "heading-order": {
                    impact: "moderate",
                    messages: {
                        pass: "Heading order valid",
                        fail: "Heading order invalid",
                        incomplete: "Unable to determine previous heading"
                    }
                },
                "identical-links-same-purpose": {
                    impact: "minor",
                    messages: {
                        pass: "There are no other links with the same name, that go to a different URL",
                        incomplete: "Check that links have the same purpose, or are intentionally ambiguous."
                    }
                },
                "internal-link-present": {
                    impact: "serious",
                    messages: {
                        pass: "Valid skip link found",
                        fail: "No valid skip link found"
                    }
                },
                landmark: {
                    impact: "serious",
                    messages: {
                        pass: "Page has a landmark region",
                        fail: "Page does not have a landmark region"
                    }
                },
                "meta-refresh-no-exceptions": {
                    impact: "minor",
                    messages: {
                        pass: "<meta> tag does not immediately refresh the page",
                        fail: "<meta> tag forces timed refresh of page"
                    }
                },
                "meta-refresh": {
                    impact: "critical",
                    messages: {
                        pass: "<meta> tag does not immediately refresh the page",
                        fail: "<meta> tag forces timed refresh of page (less than 20 hours)"
                    }
                },
                "p-as-heading": {
                    impact: "serious",
                    messages: {
                        pass: "<p> elements are not styled as headings",
                        fail: "Heading elements should be used instead of styled <p> elements",
                        incomplete: "Unable to determine if <p> elements are styled as headings"
                    }
                },
                region: {
                    impact: "moderate",
                    messages: {
                        pass: "All page content is contained by landmarks",
                        fail: "Some page content is not contained by landmarks"
                    }
                },
                "skip-link": {
                    impact: "moderate",
                    messages: {
                        pass: "Skip link target exists",
                        incomplete: "Skip link target should become visible on activation",
                        fail: "No skip link target"
                    }
                },
                "unique-frame-title": {
                    impact: "serious",
                    messages: {
                        pass: "Element's title attribute is unique",
                        fail: "Element's title attribute is not unique"
                    }
                },
                "duplicate-id-active": {
                    impact: "serious",
                    messages: {
                        pass: "Document has no active elements that share the same id attribute",
                        fail: "Document has active elements with the same id attribute: ${data}"
                    }
                },
                "duplicate-id-aria": {
                    impact: "critical",
                    messages: {
                        pass: "Document has no elements referenced with ARIA or labels that share the same id attribute",
                        fail: "Document has multiple elements referenced with ARIA with the same id attribute: ${data}"
                    }
                },
                "duplicate-id": {
                    impact: "minor",
                    messages: {
                        pass: "Document has no static elements that share the same id attribute",
                        fail: "Document has multiple static elements with the same id attribute: ${data}"
                    }
                },
                "aria-label": {
                    impact: "serious",
                    messages: {
                        pass: "aria-label attribute exists and is not empty",
                        fail: "aria-label attribute does not exist or is empty"
                    }
                },
                "aria-labelledby": {
                    impact: "serious",
                    messages: {
                        pass: "aria-labelledby attribute exists and references elements that are visible to screen readers",
                        fail: "aria-labelledby attribute does not exist, references elements that do not exist or references elements that are empty",
                        incomplete: "ensure aria-labelledby references an existing element"
                    }
                },
                "avoid-inline-spacing": {
                    impact: "serious",
                    messages: {
                        pass: "No inline styles with '!important' that affect text spacing has been specified",
                        fail: {
                            singular: "Remove '!important' from inline style ${data.values}, as overriding this is not supported by most browsers",
                            plural: "Remove '!important' from inline styles ${data.values}, as overriding this is not supported by most browsers"
                        }
                    }
                },
                "button-has-visible-text": {
                    impact: "critical",
                    messages: {
                        pass: "Element has inner text that is visible to screen readers",
                        fail: "Element does not have inner text that is visible to screen readers",
                        incomplete: "Unable to determine if element has children"
                    }
                },
                "doc-has-title": {
                    impact: "serious",
                    messages: {
                        pass: "Document has a non-empty <title> element",
                        fail: "Document does not have a non-empty <title> element"
                    }
                },
                exists: {
                    impact: "minor",
                    messages: {
                        pass: "Element does not exist",
                        incomplete: "Element exists"
                    }
                },
                "has-alt": {
                    impact: "critical",
                    messages: {
                        pass: "Element has an alt attribute",
                        fail: "Element does not have an alt attribute"
                    }
                },
                "has-visible-text": {
                    impact: "minor",
                    messages: {
                        pass: "Element has text that is visible to screen readers",
                        fail: "Element does not have text that is visible to screen readers",
                        incomplete: "Unable to determine if element has children"
                    }
                },
                "important-letter-spacing": {
                    impact: "serious",
                    messages: {
                        pass: "Letter-spacing in the style attribute is not set to !important, or meets the minimum",
                        fail: "letter-spacing in the style attribute must not use !important, or be at ${data.minValue}em (current ${data.value}em)"
                    }
                },
                "important-line-height": {
                    impact: "serious",
                    messages: {
                        pass: "line-height in the style attribute is not set to !important, or meets the minimum",
                        fail: "line-height in the style attribute must not use !important, or be at ${data.minValue}em (current ${data.value}em)"
                    }
                },
                "important-word-spacing": {
                    impact: "serious",
                    messages: {
                        pass: "word-spacing in the style attribute is not set to !important, or meets the minimum",
                        fail: "word-spacing in the style attribute must not use !important, or be at ${data.minValue}em (current ${data.value}em)"
                    }
                },
                "is-on-screen": {
                    impact: "serious",
                    messages: {
                        pass: "Element is not visible",
                        fail: "Element is visible"
                    }
                },
                "non-empty-alt": {
                    impact: "critical",
                    messages: {
                        pass: "Element has a non-empty alt attribute",
                        fail: {
                            noAttr: "Element has no alt attribute",
                            emptyAttr: "Element has an empty alt attribute"
                        }
                    }
                },
                "non-empty-if-present": {
                    impact: "critical",
                    messages: {
                        pass: {
                            default: "Element does not have a value attribute",
                            "has-label": "Element has a non-empty value attribute"
                        },
                        fail: "Element has a value attribute and the value attribute is empty"
                    }
                },
                "non-empty-placeholder": {
                    impact: "serious",
                    messages: {
                        pass: "Element has a placeholder attribute",
                        fail: {
                            noAttr: "Element has no placeholder attribute",
                            emptyAttr: "Element has an empty placeholder attribute"
                        }
                    }
                },
                "non-empty-title": {
                    impact: "serious",
                    messages: {
                        pass: "Element has a title attribute",
                        fail: {
                            noAttr: "Element has no title attribute",
                            emptyAttr: "Element has an empty title attribute"
                        }
                    }
                },
                "non-empty-value": {
                    impact: "critical",
                    messages: {
                        pass: "Element has a non-empty value attribute",
                        fail: {
                            noAttr: "Element has no value attribute",
                            emptyAttr: "Element has an empty value attribute"
                        }
                    }
                },
                "presentational-role": {
                    impact: "minor",
                    messages: {
                        pass: 'Element\'s default semantics were overriden with role="${data.role}"',
                        fail: {
                            default: 'Element\'s default semantics were not overridden with role="none" or role="presentation"',
                            globalAria: "Element's role is not presentational because it has a global ARIA attribute",
                            focusable: "Element's role is not presentational because it is focusable",
                            both: "Element's role is not presentational because it has a global ARIA attribute and is focusable",
                            iframe: 'Using the "title" attribute on an ${data.nodeName} element with a presentational role behaves inconsistently between screen readers'
                        }
                    }
                },
                "role-none": {
                    impact: "minor",
                    messages: {
                        pass: 'Element\'s default semantics were overriden with role="none"',
                        fail: 'Element\'s default semantics were not overridden with role="none"'
                    }
                },
                "role-presentation": {
                    impact: "minor",
                    messages: {
                        pass: 'Element\'s default semantics were overriden with role="presentation"',
                        fail: 'Element\'s default semantics were not overridden with role="presentation"'
                    }
                },
                "svg-non-empty-title": {
                    impact: "serious",
                    messages: {
                        pass: "Element has a child that is a title",
                        fail: {
                            noTitle: "Element has no child that is a title",
                            emptyTitle: "Element child title is empty"
                        },
                        incomplete: "Unable to determine element has a child that is a title"
                    }
                },
                "caption-faked": {
                    impact: "serious",
                    messages: {
                        pass: "The first row of a table is not used as a caption",
                        fail: "The first child of the table should be a caption instead of a table cell"
                    }
                },
                "html5-scope": {
                    impact: "moderate",
                    messages: {
                        pass: "Scope attribute is only used on table header elements (<th>)",
                        fail: "In HTML 5, scope attributes may only be used on table header elements (<th>)"
                    }
                },
                "same-caption-summary": {
                    impact: "minor",
                    messages: {
                        pass: "Content of summary attribute and <caption> are not duplicated",
                        fail: "Content of summary attribute and <caption> element are identical",
                        incomplete: "Unable to determine if <table> element has a caption"
                    }
                },
                "scope-value": {
                    impact: "critical",
                    messages: {
                        pass: "Scope attribute is used correctly",
                        fail: "The value of the scope attribute may only be 'row' or 'col'"
                    }
                },
                "td-has-header": {
                    impact: "critical",
                    messages: {
                        pass: "All non-empty data cells have table headers",
                        fail: "Some non-empty data cells do not have table headers"
                    }
                },
                "td-headers-attr": {
                    impact: "serious",
                    messages: {
                        pass: "The headers attribute is exclusively used to refer to other cells in the table",
                        incomplete: "The headers attribute is empty",
                        fail: "The headers attribute is not exclusively used to refer to other cells in the table"
                    }
                },
                "th-has-data-cells": {
                    impact: "serious",
                    messages: {
                        pass: "All table header cells refer to data cells",
                        fail: "Not all table header cells refer to data cells",
                        incomplete: "Table data cells are missing or empty"
                    }
                },
                "hidden-content": {
                    impact: "minor",
                    messages: {
                        pass: "All content on the page has been analyzed.",
                        fail: "There were problems analyzing the content on this page.",
                        incomplete: "There is hidden content on the page that was not analyzed. You will need to trigger the display of this content in order to analyze it."
                    }
                }
            },
            failureSummaries: {
                any: {
                    failureMessage: function anonymous(it) {
                        var out = "Fix any of the following:";
                        var arr1 = it;
                        if (arr1) {
                            var value, i1 = -1, l1 = arr1.length - 1;
                            while(i1 < l1){
                                value = arr1[i1 += 1];
                                out += "\n  " + value.split("\n").join("\n  ");
                            }
                        }
                        return out;
                    }
                },
                none: {
                    failureMessage: function anonymous(it) {
                        var out = "Fix all of the following:";
                        var arr1 = it;
                        if (arr1) {
                            var value, i1 = -1, l1 = arr1.length - 1;
                            while(i1 < l1){
                                value = arr1[i1 += 1];
                                out += "\n  " + value.split("\n").join("\n  ");
                            }
                        }
                        return out;
                    }
                }
            },
            incompleteFallbackMessage: "axe couldn't tell the reason. Time to break out the element inspector!"
        },
        rules: [
            {
                id: "accesskeys",
                impact: "serious",
                selector: "[accesskey]",
                excludeHidden: false,
                tags: [
                    "cat.keyboard",
                    "best-practice"
                ],
                all: [],
                any: [],
                none: [
                    "accesskeys"
                ]
            },
            {
                id: "area-alt",
                impact: "critical",
                selector: "map area[href]",
                excludeHidden: false,
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag244",
                    "wcag412",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT6.a",
                    "EN-301-549",
                    "EN-9.2.4.4",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "c487ae"
                ],
                all: [],
                any: [
                    {
                        options: {
                            attribute: "alt"
                        },
                        id: "non-empty-alt"
                    },
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-allowed-attr",
                impact: "critical",
                matches: "aria-allowed-attr-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "5c01ea"
                ],
                all: [
                    {
                        options: {
                            validTreeRowAttrs: [
                                "aria-posinset",
                                "aria-setsize",
                                "aria-expanded",
                                "aria-level"
                            ]
                        },
                        id: "aria-allowed-attr"
                    }
                ],
                any: [],
                none: [
                    "aria-unsupported-attr"
                ]
            },
            {
                id: "aria-allowed-role",
                impact: "minor",
                excludeHidden: false,
                selector: "[role]",
                matches: "aria-allowed-role-matches",
                tags: [
                    "cat.aria",
                    "best-practice"
                ],
                all: [],
                any: [
                    {
                        options: {
                            allowImplicit: true,
                            ignoredTags: []
                        },
                        id: "aria-allowed-role"
                    }
                ],
                none: []
            },
            {
                id: "aria-braille-equivalent",
                reviewOnFail: true,
                impact: "serious",
                selector: "[aria-brailleroledescription], [aria-braillelabel]",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                all: [
                    "braille-roledescription-equivalent",
                    "braille-label-equivalent"
                ],
                any: [],
                none: []
            },
            {
                id: "aria-command-name",
                impact: "serious",
                selector: '[role="link"], [role="button"], [role="menuitem"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "TTv5",
                    "TT6.a",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "97a4e1"
                ],
                all: [],
                any: [
                    "has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-conditional-attr",
                impact: "serious",
                matches: "aria-allowed-attr-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "5c01ea"
                ],
                all: [
                    {
                        options: {
                            invalidTableRowAttrs: [
                                "aria-posinset",
                                "aria-setsize",
                                "aria-expanded",
                                "aria-level"
                            ]
                        },
                        id: "aria-conditional-attr"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "aria-deprecated-role",
                impact: "minor",
                selector: "[role]",
                matches: "no-empty-role-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "674b10"
                ],
                all: [],
                any: [],
                none: [
                    "deprecatedrole"
                ]
            },
            {
                id: "aria-dialog-name",
                impact: "serious",
                selector: '[role="dialog"], [role="alertdialog"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "best-practice"
                ],
                all: [],
                any: [
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-hidden-body",
                impact: "critical",
                selector: "body",
                excludeHidden: false,
                matches: "is-initiator-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                all: [],
                any: [
                    "aria-hidden-body"
                ],
                none: []
            },
            {
                id: "aria-hidden-focus",
                impact: "serious",
                selector: '[aria-hidden="true"]',
                matches: "aria-hidden-focus-matches",
                excludeHidden: false,
                tags: [
                    "cat.name-role-value",
                    "wcag2a",
                    "wcag412",
                    "TTv5",
                    "TT6.a",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "6cfa84"
                ],
                all: [
                    "focusable-modal-open",
                    "focusable-disabled",
                    "focusable-not-tabbable"
                ],
                any: [],
                none: []
            },
            {
                id: "aria-input-field-name",
                impact: "serious",
                selector: '[role="combobox"], [role="listbox"], [role="searchbox"], [role="slider"], [role="spinbutton"], [role="textbox"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "TTv5",
                    "TT5.c",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "e086e5"
                ],
                all: [],
                any: [
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: [
                    "no-implicit-explicit-label"
                ]
            },
            {
                id: "aria-meter-name",
                impact: "serious",
                selector: '[role="meter"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag111",
                    "EN-301-549",
                    "EN-9.1.1.1"
                ],
                all: [],
                any: [
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-progressbar-name",
                impact: "serious",
                selector: '[role="progressbar"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag111",
                    "EN-301-549",
                    "EN-9.1.1.1"
                ],
                all: [],
                any: [
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-prohibited-attr",
                impact: "serious",
                matches: "aria-allowed-attr-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "5c01ea"
                ],
                all: [],
                any: [],
                none: [
                    {
                        options: {
                            elementsAllowedAriaLabel: [
                                "applet",
                                "input"
                            ]
                        },
                        id: "aria-prohibited-attr"
                    }
                ]
            },
            {
                id: "aria-required-attr",
                impact: "critical",
                selector: "[role]",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "4e8ab6"
                ],
                all: [],
                any: [
                    "aria-required-attr"
                ],
                none: []
            },
            {
                id: "aria-required-children",
                impact: "critical",
                selector: "[role]",
                matches: "aria-required-children-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                actIds: [
                    "bc4a75",
                    "ff89c9"
                ],
                all: [],
                any: [
                    {
                        options: {
                            reviewEmpty: [
                                "doc-bibliography",
                                "doc-endnotes",
                                "grid",
                                "list",
                                "listbox",
                                "menu",
                                "menubar",
                                "table",
                                "tablist",
                                "tree",
                                "treegrid",
                                "rowgroup"
                            ]
                        },
                        id: "aria-required-children"
                    },
                    "aria-busy"
                ],
                none: []
            },
            {
                id: "aria-required-parent",
                impact: "critical",
                selector: "[role]",
                matches: "aria-required-parent-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                actIds: [
                    "ff89c9"
                ],
                all: [],
                any: [
                    {
                        options: {
                            ownGroupRoles: [
                                "listitem",
                                "treeitem"
                            ]
                        },
                        id: "aria-required-parent"
                    }
                ],
                none: []
            },
            {
                id: "aria-roledescription",
                impact: "serious",
                selector: "[aria-roledescription]",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "deprecated"
                ],
                enabled: false,
                all: [],
                any: [
                    {
                        options: {
                            supportedRoles: [
                                "button",
                                "img",
                                "checkbox",
                                "radio",
                                "combobox",
                                "menuitemcheckbox",
                                "menuitemradio"
                            ]
                        },
                        id: "aria-roledescription"
                    }
                ],
                none: []
            },
            {
                id: "aria-roles",
                impact: "critical",
                selector: "[role]",
                matches: "no-empty-role-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "674b10"
                ],
                all: [],
                any: [],
                none: [
                    "invalidrole",
                    "abstractrole",
                    "unsupportedrole"
                ]
            },
            {
                id: "aria-text",
                impact: "serious",
                selector: "[role=text]",
                tags: [
                    "cat.aria",
                    "best-practice"
                ],
                all: [],
                any: [
                    "no-focusable-content"
                ],
                none: []
            },
            {
                id: "aria-toggle-field-name",
                impact: "serious",
                selector: '[role="checkbox"], [role="menuitemcheckbox"], [role="menuitemradio"], [role="radio"], [role="switch"], [role="option"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "TTv5",
                    "TT5.c",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "e086e5"
                ],
                all: [],
                any: [
                    "has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: [
                    "no-implicit-explicit-label"
                ]
            },
            {
                id: "aria-tooltip-name",
                impact: "serious",
                selector: '[role="tooltip"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                all: [],
                any: [
                    "has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-treeitem-name",
                impact: "serious",
                selector: '[role="treeitem"]',
                matches: "no-naming-method-matches",
                tags: [
                    "cat.aria",
                    "best-practice"
                ],
                all: [],
                any: [
                    "has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "aria-valid-attr-value",
                impact: "critical",
                matches: "aria-has-attr-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "6a7281"
                ],
                all: [
                    {
                        options: [],
                        id: "aria-valid-attr-value"
                    },
                    "aria-errormessage",
                    "aria-level"
                ],
                any: [],
                none: []
            },
            {
                id: "aria-valid-attr",
                impact: "critical",
                matches: "aria-has-attr-matches",
                tags: [
                    "cat.aria",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "5f99a7"
                ],
                all: [],
                any: [
                    {
                        options: [],
                        id: "aria-valid-attr"
                    }
                ],
                none: []
            },
            {
                id: "audio-caption",
                impact: "critical",
                selector: "audio",
                enabled: false,
                excludeHidden: false,
                tags: [
                    "cat.time-and-media",
                    "wcag2a",
                    "wcag121",
                    "EN-301-549",
                    "EN-9.1.2.1",
                    "section508",
                    "section508.22.a",
                    "deprecated"
                ],
                actIds: [
                    "2eb176",
                    "afb423"
                ],
                all: [],
                any: [],
                none: [
                    "caption"
                ]
            },
            {
                id: "autocomplete-valid",
                impact: "serious",
                matches: "autocomplete-matches",
                tags: [
                    "cat.forms",
                    "wcag21aa",
                    "wcag135",
                    "EN-301-549",
                    "EN-9.1.3.5",
                    "ACT"
                ],
                actIds: [
                    "73f2c2"
                ],
                all: [
                    {
                        options: {
                            stateTerms: [
                                "none",
                                "false",
                                "true",
                                "disabled",
                                "enabled",
                                "undefined",
                                "null"
                            ]
                        },
                        id: "autocomplete-valid"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "avoid-inline-spacing",
                impact: "serious",
                selector: "[style]",
                matches: "is-visible-on-screen-matches",
                tags: [
                    "cat.structure",
                    "wcag21aa",
                    "wcag1412",
                    "EN-301-549",
                    "EN-9.1.4.12",
                    "ACT"
                ],
                actIds: [
                    "24afc2",
                    "9e45ec",
                    "78fd32"
                ],
                all: [
                    {
                        options: {
                            cssProperty: "letter-spacing",
                            minValue: .12
                        },
                        id: "important-letter-spacing"
                    },
                    {
                        options: {
                            cssProperty: "word-spacing",
                            minValue: .16
                        },
                        id: "important-word-spacing"
                    },
                    {
                        options: {
                            multiLineOnly: true,
                            cssProperty: "line-height",
                            minValue: 1.5,
                            normalValue: 1
                        },
                        id: "important-line-height"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "blink",
                impact: "serious",
                selector: "blink",
                excludeHidden: false,
                tags: [
                    "cat.time-and-media",
                    "wcag2a",
                    "wcag222",
                    "section508",
                    "section508.22.j",
                    "TTv5",
                    "TT2.b",
                    "EN-301-549",
                    "EN-9.2.2.2"
                ],
                all: [],
                any: [],
                none: [
                    "is-on-screen"
                ]
            },
            {
                id: "button-name",
                impact: "critical",
                selector: "button",
                matches: "no-explicit-name-required-matches",
                tags: [
                    "cat.name-role-value",
                    "wcag2a",
                    "wcag412",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT6.a",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "97a4e1",
                    "m6b1q3"
                ],
                all: [],
                any: [
                    "button-has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    "presentational-role"
                ],
                none: []
            },
            {
                id: "bypass",
                impact: "serious",
                selector: "html",
                pageLevel: true,
                matches: "bypass-matches",
                reviewOnFail: true,
                tags: [
                    "cat.keyboard",
                    "wcag2a",
                    "wcag241",
                    "section508",
                    "section508.22.o",
                    "TTv5",
                    "TT9.a",
                    "EN-301-549",
                    "EN-9.2.4.1"
                ],
                actIds: [
                    "cf77f2",
                    "047fe0",
                    "b40fd1",
                    "3e12e1",
                    "ye5d6e"
                ],
                all: [],
                any: [
                    "internal-link-present",
                    {
                        options: {
                            selector: ":is(h1, h2, h3, h4, h5, h6):not([role]), [role=heading]"
                        },
                        id: "header-present"
                    },
                    {
                        options: {
                            selector: "main, [role=main]"
                        },
                        id: "landmark"
                    }
                ],
                none: []
            },
            {
                id: "color-contrast-enhanced",
                impact: "serious",
                matches: "color-contrast-matches",
                excludeHidden: false,
                enabled: false,
                tags: [
                    "cat.color",
                    "wcag2aaa",
                    "wcag146",
                    "ACT"
                ],
                actIds: [
                    "09o5cg"
                ],
                all: [],
                any: [
                    {
                        options: {
                            ignoreUnicode: true,
                            ignoreLength: false,
                            ignorePseudo: false,
                            boldValue: 700,
                            boldTextPt: 14,
                            largeTextPt: 18,
                            contrastRatio: {
                                normal: {
                                    expected: 7,
                                    minThreshold: 4.5
                                },
                                large: {
                                    expected: 4.5,
                                    minThreshold: 3
                                }
                            },
                            pseudoSizeThreshold: .25,
                            shadowOutlineEmMax: .1,
                            textStrokeEmMin: .03
                        },
                        id: "color-contrast-enhanced"
                    }
                ],
                none: []
            },
            {
                id: "color-contrast",
                impact: "serious",
                matches: "color-contrast-matches",
                excludeHidden: false,
                tags: [
                    "cat.color",
                    "wcag2aa",
                    "wcag143",
                    "TTv5",
                    "TT13.c",
                    "EN-301-549",
                    "EN-9.1.4.3",
                    "ACT"
                ],
                actIds: [
                    "afw4f7",
                    "09o5cg"
                ],
                all: [],
                any: [
                    {
                        options: {
                            ignoreUnicode: true,
                            ignoreLength: false,
                            ignorePseudo: false,
                            boldValue: 700,
                            boldTextPt: 14,
                            largeTextPt: 18,
                            contrastRatio: {
                                normal: {
                                    expected: 4.5
                                },
                                large: {
                                    expected: 3
                                }
                            },
                            pseudoSizeThreshold: .25,
                            shadowOutlineEmMax: .2,
                            textStrokeEmMin: .03
                        },
                        id: "color-contrast"
                    }
                ],
                none: []
            },
            {
                id: "css-orientation-lock",
                impact: "serious",
                selector: "html",
                tags: [
                    "cat.structure",
                    "wcag134",
                    "wcag21aa",
                    "EN-301-549",
                    "EN-9.1.3.4",
                    "experimental"
                ],
                actIds: [
                    "b33eff"
                ],
                all: [
                    {
                        options: {
                            degreeThreshold: 2
                        },
                        id: "css-orientation-lock"
                    }
                ],
                any: [],
                none: [],
                preload: true
            },
            {
                id: "definition-list",
                impact: "serious",
                selector: "dl",
                matches: "no-role-matches",
                tags: [
                    "cat.structure",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                all: [],
                any: [],
                none: [
                    "structured-dlitems",
                    {
                        options: {
                            validRoles: [
                                "definition",
                                "term",
                                "listitem"
                            ],
                            validNodeNames: [
                                "dt",
                                "dd"
                            ],
                            divGroups: true
                        },
                        id: "only-dlitems"
                    }
                ]
            },
            {
                id: "dlitem",
                impact: "serious",
                selector: "dd, dt",
                matches: "no-role-matches",
                tags: [
                    "cat.structure",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                all: [],
                any: [
                    "dlitem"
                ],
                none: []
            },
            {
                id: "document-title",
                impact: "serious",
                selector: "html",
                matches: "is-initiator-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag242",
                    "TTv5",
                    "TT12.a",
                    "EN-301-549",
                    "EN-9.2.4.2",
                    "ACT"
                ],
                actIds: [
                    "2779a5"
                ],
                all: [],
                any: [
                    "doc-has-title"
                ],
                none: []
            },
            {
                id: "duplicate-id-active",
                impact: "serious",
                selector: "[id]",
                matches: "duplicate-id-active-matches",
                excludeHidden: false,
                tags: [
                    "cat.parsing",
                    "wcag2a-obsolete",
                    "wcag411",
                    "deprecated"
                ],
                enabled: false,
                actIds: [
                    "3ea0c8"
                ],
                all: [],
                any: [
                    "duplicate-id-active"
                ],
                none: []
            },
            {
                id: "duplicate-id-aria",
                impact: "critical",
                selector: "[id]",
                matches: "duplicate-id-aria-matches",
                excludeHidden: false,
                tags: [
                    "cat.parsing",
                    "wcag2a",
                    "wcag412",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                reviewOnFail: true,
                actIds: [
                    "3ea0c8"
                ],
                all: [],
                any: [
                    "duplicate-id-aria"
                ],
                none: []
            },
            {
                id: "duplicate-id",
                impact: "minor",
                selector: "[id]",
                matches: "duplicate-id-misc-matches",
                excludeHidden: false,
                tags: [
                    "cat.parsing",
                    "wcag2a-obsolete",
                    "wcag411",
                    "deprecated"
                ],
                enabled: false,
                actIds: [
                    "3ea0c8"
                ],
                all: [],
                any: [
                    "duplicate-id"
                ],
                none: []
            },
            {
                id: "empty-heading",
                impact: "minor",
                selector: 'h1, h2, h3, h4, h5, h6, [role="heading"]',
                matches: "heading-matches",
                tags: [
                    "cat.name-role-value",
                    "best-practice"
                ],
                actIds: [
                    "ffd0e9"
                ],
                all: [],
                any: [
                    "has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "empty-table-header",
                impact: "minor",
                selector: 'th:not([role]), [role="rowheader"], [role="columnheader"]',
                tags: [
                    "cat.name-role-value",
                    "best-practice"
                ],
                all: [],
                any: [
                    "has-visible-text"
                ],
                none: []
            },
            {
                id: "focus-order-semantics",
                impact: "minor",
                selector: "div, h1, h2, h3, h4, h5, h6, [role=heading], p, span",
                matches: "inserted-into-focus-order-matches",
                tags: [
                    "cat.keyboard",
                    "best-practice",
                    "experimental"
                ],
                all: [],
                any: [
                    {
                        options: [],
                        id: "has-widget-role"
                    },
                    {
                        options: {
                            roles: [
                                "tooltip"
                            ]
                        },
                        id: "valid-scrollable-semantics"
                    }
                ],
                none: []
            },
            {
                id: "form-field-multiple-labels",
                impact: "moderate",
                selector: "input, select, textarea",
                matches: "label-matches",
                tags: [
                    "cat.forms",
                    "wcag2a",
                    "wcag332",
                    "TTv5",
                    "TT5.c",
                    "EN-301-549",
                    "EN-9.3.3.2"
                ],
                all: [],
                any: [],
                none: [
                    "multiple-label"
                ]
            },
            {
                id: "frame-focusable-content",
                impact: "serious",
                selector: "html",
                matches: "frame-focusable-content-matches",
                tags: [
                    "cat.keyboard",
                    "wcag2a",
                    "wcag211",
                    "TTv5",
                    "TT4.a",
                    "EN-301-549",
                    "EN-9.2.1.1"
                ],
                actIds: [
                    "akn7bn"
                ],
                all: [],
                any: [
                    "frame-focusable-content"
                ],
                none: []
            },
            {
                id: "frame-tested",
                impact: "critical",
                selector: "html, frame, iframe",
                tags: [
                    "cat.structure",
                    "best-practice",
                    "review-item"
                ],
                all: [
                    {
                        options: {
                            isViolation: false
                        },
                        id: "frame-tested"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "frame-title-unique",
                impact: "serious",
                selector: "frame[title], iframe[title]",
                matches: "frame-title-has-text-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag412",
                    "TTv5",
                    "TT12.d",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "4b1c6c"
                ],
                all: [],
                any: [],
                none: [
                    "unique-frame-title"
                ],
                reviewOnFail: true
            },
            {
                id: "frame-title",
                impact: "serious",
                selector: "frame, iframe",
                matches: "no-negative-tabindex-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag412",
                    "section508",
                    "section508.22.i",
                    "TTv5",
                    "TT12.d",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "cae760"
                ],
                all: [],
                any: [
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    "aria-label",
                    "aria-labelledby",
                    "presentational-role"
                ],
                none: []
            },
            {
                id: "heading-order",
                impact: "moderate",
                selector: "h1, h2, h3, h4, h5, h6, [role=heading]",
                matches: "heading-matches",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    "heading-order"
                ],
                none: []
            },
            {
                id: "hidden-content",
                impact: "minor",
                selector: "*",
                excludeHidden: false,
                tags: [
                    "cat.structure",
                    "best-practice",
                    "experimental",
                    "review-item"
                ],
                all: [],
                any: [
                    "hidden-content"
                ],
                none: []
            },
            {
                id: "html-has-lang",
                impact: "serious",
                selector: "html",
                matches: "is-initiator-matches",
                tags: [
                    "cat.language",
                    "wcag2a",
                    "wcag311",
                    "TTv5",
                    "TT11.a",
                    "EN-301-549",
                    "EN-9.3.1.1",
                    "ACT"
                ],
                actIds: [
                    "b5c3f8"
                ],
                all: [],
                any: [
                    {
                        options: {
                            attributes: [
                                "lang",
                                "xml:lang"
                            ]
                        },
                        id: "has-lang"
                    }
                ],
                none: []
            },
            {
                id: "html-lang-valid",
                impact: "serious",
                selector: 'html[lang]:not([lang=""]), html[xml\\:lang]:not([xml\\:lang=""])',
                tags: [
                    "cat.language",
                    "wcag2a",
                    "wcag311",
                    "TTv5",
                    "TT11.a",
                    "EN-301-549",
                    "EN-9.3.1.1",
                    "ACT"
                ],
                actIds: [
                    "bf051a"
                ],
                all: [],
                any: [],
                none: [
                    {
                        options: {
                            attributes: [
                                "lang",
                                "xml:lang"
                            ]
                        },
                        id: "valid-lang"
                    }
                ]
            },
            {
                id: "html-xml-lang-mismatch",
                impact: "moderate",
                selector: "html[lang][xml\\:lang]",
                matches: "xml-lang-mismatch-matches",
                tags: [
                    "cat.language",
                    "wcag2a",
                    "wcag311",
                    "EN-301-549",
                    "EN-9.3.1.1",
                    "ACT"
                ],
                actIds: [
                    "5b7ae0"
                ],
                all: [
                    "xml-lang-mismatch"
                ],
                any: [],
                none: []
            },
            {
                id: "identical-links-same-purpose",
                impact: "minor",
                selector: 'a[href], area[href], [role="link"]',
                excludeHidden: false,
                enabled: false,
                matches: "identical-links-same-purpose-matches",
                tags: [
                    "cat.semantics",
                    "wcag2aaa",
                    "wcag249"
                ],
                actIds: [
                    "b20e66"
                ],
                all: [
                    "identical-links-same-purpose"
                ],
                any: [],
                none: []
            },
            {
                id: "image-alt",
                impact: "critical",
                selector: "img",
                matches: "no-explicit-name-required-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag111",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT7.a",
                    "TT7.b",
                    "EN-301-549",
                    "EN-9.1.1.1",
                    "ACT"
                ],
                actIds: [
                    "23a2a8"
                ],
                all: [],
                any: [
                    "has-alt",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    "presentational-role"
                ],
                none: [
                    "alt-space-value"
                ]
            },
            {
                id: "image-redundant-alt",
                impact: "minor",
                selector: "img",
                tags: [
                    "cat.text-alternatives",
                    "best-practice"
                ],
                all: [],
                any: [],
                none: [
                    {
                        options: {
                            parentSelector: "button, [role=button], a[href], p, li, td, th"
                        },
                        id: "duplicate-img-label"
                    }
                ]
            },
            {
                id: "input-button-name",
                impact: "critical",
                selector: 'input[type="button"], input[type="submit"], input[type="reset"]',
                matches: "no-explicit-name-required-matches",
                tags: [
                    "cat.name-role-value",
                    "wcag2a",
                    "wcag412",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT5.c",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "97a4e1"
                ],
                all: [],
                any: [
                    "non-empty-if-present",
                    {
                        options: {
                            attribute: "value"
                        },
                        id: "non-empty-value"
                    },
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    "presentational-role"
                ],
                none: []
            },
            {
                id: "input-image-alt",
                impact: "critical",
                selector: 'input[type="image"]',
                matches: "no-explicit-name-required-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag111",
                    "wcag412",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT7.a",
                    "EN-301-549",
                    "EN-9.1.1.1",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "59796f"
                ],
                all: [],
                any: [
                    {
                        options: {
                            attribute: "alt"
                        },
                        id: "non-empty-alt"
                    },
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "label-content-name-mismatch",
                impact: "serious",
                matches: "label-content-name-mismatch-matches",
                tags: [
                    "cat.semantics",
                    "wcag21a",
                    "wcag253",
                    "EN-301-549",
                    "EN-9.2.5.3",
                    "experimental"
                ],
                actIds: [
                    "2ee8b8"
                ],
                all: [],
                any: [
                    {
                        options: {
                            pixelThreshold: .1,
                            occurrenceThreshold: 3
                        },
                        id: "label-content-name-mismatch"
                    }
                ],
                none: []
            },
            {
                id: "label-title-only",
                impact: "serious",
                selector: "input, select, textarea",
                matches: "label-matches",
                tags: [
                    "cat.forms",
                    "best-practice"
                ],
                all: [],
                any: [],
                none: [
                    "title-only"
                ]
            },
            {
                id: "label",
                impact: "critical",
                selector: "input, textarea",
                matches: "label-matches",
                tags: [
                    "cat.forms",
                    "wcag2a",
                    "wcag412",
                    "section508",
                    "section508.22.n",
                    "TTv5",
                    "TT5.c",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "e086e5"
                ],
                all: [],
                any: [
                    "implicit-label",
                    "explicit-label",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    {
                        options: {
                            attribute: "placeholder"
                        },
                        id: "non-empty-placeholder"
                    },
                    "presentational-role"
                ],
                none: [
                    "hidden-explicit-label"
                ]
            },
            {
                id: "landmark-banner-is-top-level",
                impact: "moderate",
                selector: "header:not([role]), [role=banner]",
                matches: "landmark-has-body-context-matches",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    "landmark-is-top-level"
                ],
                none: []
            },
            {
                id: "landmark-complementary-is-top-level",
                impact: "moderate",
                selector: "aside:not([role]), [role=complementary]",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    "landmark-is-top-level"
                ],
                none: []
            },
            {
                id: "landmark-contentinfo-is-top-level",
                impact: "moderate",
                selector: "footer:not([role]), [role=contentinfo]",
                matches: "landmark-has-body-context-matches",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    "landmark-is-top-level"
                ],
                none: []
            },
            {
                id: "landmark-main-is-top-level",
                impact: "moderate",
                selector: "main:not([role]), [role=main]",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    "landmark-is-top-level"
                ],
                none: []
            },
            {
                id: "landmark-no-duplicate-banner",
                impact: "moderate",
                selector: "header:not([role]), [role=banner]",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    {
                        options: {
                            selector: "header:not([role]), [role=banner]",
                            role: "banner"
                        },
                        id: "page-no-duplicate-banner"
                    }
                ],
                none: []
            },
            {
                id: "landmark-no-duplicate-contentinfo",
                impact: "moderate",
                selector: "footer:not([role]), [role=contentinfo]",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    {
                        options: {
                            selector: "footer:not([role]), [role=contentinfo]",
                            role: "contentinfo"
                        },
                        id: "page-no-duplicate-contentinfo"
                    }
                ],
                none: []
            },
            {
                id: "landmark-no-duplicate-main",
                impact: "moderate",
                selector: "main:not([role]), [role=main]",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [],
                any: [
                    {
                        options: {
                            selector: "main:not([role]), [role='main']"
                        },
                        id: "page-no-duplicate-main"
                    }
                ],
                none: []
            },
            {
                id: "landmark-one-main",
                impact: "moderate",
                selector: "html",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [
                    {
                        options: {
                            selector: "main:not([role]), [role='main']",
                            passForModal: true
                        },
                        id: "page-has-main"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "landmark-unique",
                impact: "moderate",
                selector: "[role=banner], [role=complementary], [role=contentinfo], [role=main], [role=navigation], [role=region], [role=search], [role=form], form, footer, header, aside, main, nav, section",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                matches: "landmark-unique-matches",
                all: [],
                any: [
                    "landmark-is-unique"
                ],
                none: []
            },
            {
                id: "link-in-text-block",
                impact: "serious",
                selector: "a[href], [role=link]",
                matches: "link-in-text-block-matches",
                excludeHidden: false,
                tags: [
                    "cat.color",
                    "wcag2a",
                    "wcag141",
                    "TTv5",
                    "TT13.a",
                    "EN-301-549",
                    "EN-9.1.4.1"
                ],
                all: [],
                any: [
                    {
                        options: {
                            requiredContrastRatio: 3,
                            allowSameColor: true
                        },
                        id: "link-in-text-block"
                    },
                    "link-in-text-block-style"
                ],
                none: []
            },
            {
                id: "link-name",
                impact: "serious",
                selector: "a[href]",
                tags: [
                    "cat.name-role-value",
                    "wcag2a",
                    "wcag244",
                    "wcag412",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT6.a",
                    "EN-301-549",
                    "EN-9.2.4.4",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "c487ae"
                ],
                all: [],
                any: [
                    "has-visible-text",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: [
                    "focusable-no-name"
                ]
            },
            {
                id: "list",
                impact: "serious",
                selector: "ul, ol",
                matches: "no-role-matches",
                tags: [
                    "cat.structure",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                all: [],
                any: [],
                none: [
                    {
                        options: {
                            validRoles: [
                                "listitem"
                            ],
                            validNodeNames: [
                                "li"
                            ]
                        },
                        id: "only-listitems"
                    }
                ]
            },
            {
                id: "listitem",
                impact: "serious",
                selector: "li",
                matches: "no-role-matches",
                tags: [
                    "cat.structure",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                all: [],
                any: [
                    "listitem"
                ],
                none: []
            },
            {
                id: "marquee",
                impact: "serious",
                selector: "marquee",
                excludeHidden: false,
                tags: [
                    "cat.parsing",
                    "wcag2a",
                    "wcag222",
                    "TTv5",
                    "TT2.b",
                    "EN-301-549",
                    "EN-9.2.2.2"
                ],
                all: [],
                any: [],
                none: [
                    "is-on-screen"
                ]
            },
            {
                id: "meta-refresh-no-exceptions",
                impact: "minor",
                selector: 'meta[http-equiv="refresh"][content]',
                excludeHidden: false,
                enabled: false,
                tags: [
                    "cat.time-and-media",
                    "wcag2aaa",
                    "wcag224",
                    "wcag325"
                ],
                actIds: [
                    "bisz58"
                ],
                all: [],
                any: [
                    {
                        options: {
                            minDelay: 72e3,
                            maxDelay: false
                        },
                        id: "meta-refresh-no-exceptions"
                    }
                ],
                none: []
            },
            {
                id: "meta-refresh",
                impact: "critical",
                selector: 'meta[http-equiv="refresh"][content]',
                excludeHidden: false,
                tags: [
                    "cat.time-and-media",
                    "wcag2a",
                    "wcag221",
                    "TTv5",
                    "TT8.a",
                    "EN-301-549",
                    "EN-9.2.2.1"
                ],
                actIds: [
                    "bc659a",
                    "bisz58"
                ],
                all: [],
                any: [
                    {
                        options: {
                            minDelay: 0,
                            maxDelay: 72e3
                        },
                        id: "meta-refresh"
                    }
                ],
                none: []
            },
            {
                id: "meta-viewport-large",
                impact: "minor",
                selector: 'meta[name="viewport"]',
                matches: "is-initiator-matches",
                excludeHidden: false,
                tags: [
                    "cat.sensory-and-visual-cues",
                    "best-practice"
                ],
                all: [],
                any: [
                    {
                        options: {
                            scaleMinimum: 5,
                            lowerBound: 2
                        },
                        id: "meta-viewport-large"
                    }
                ],
                none: []
            },
            {
                id: "meta-viewport",
                impact: "critical",
                selector: 'meta[name="viewport"]',
                matches: "is-initiator-matches",
                excludeHidden: false,
                tags: [
                    "cat.sensory-and-visual-cues",
                    "wcag2aa",
                    "wcag144",
                    "EN-301-549",
                    "EN-9.1.4.4",
                    "ACT"
                ],
                actIds: [
                    "b4f0c3"
                ],
                all: [],
                any: [
                    {
                        options: {
                            scaleMinimum: 2
                        },
                        id: "meta-viewport"
                    }
                ],
                none: []
            },
            {
                id: "nested-interactive",
                impact: "serious",
                matches: "nested-interactive-matches",
                tags: [
                    "cat.keyboard",
                    "wcag2a",
                    "wcag412",
                    "TTv5",
                    "TT6.a",
                    "EN-301-549",
                    "EN-9.4.1.2"
                ],
                actIds: [
                    "307n5z"
                ],
                all: [],
                any: [
                    "no-focusable-content"
                ],
                none: []
            },
            {
                id: "no-autoplay-audio",
                impact: "moderate",
                excludeHidden: false,
                selector: "audio[autoplay], video[autoplay]",
                matches: "no-autoplay-audio-matches",
                reviewOnFail: true,
                tags: [
                    "cat.time-and-media",
                    "wcag2a",
                    "wcag142",
                    "TTv5",
                    "TT2.a",
                    "EN-301-549",
                    "EN-9.1.4.2",
                    "ACT"
                ],
                actIds: [
                    "80f0bf"
                ],
                preload: true,
                all: [
                    {
                        options: {
                            allowedDuration: 3
                        },
                        id: "no-autoplay-audio"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "object-alt",
                impact: "serious",
                selector: "object[data]",
                matches: "object-is-loaded-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag111",
                    "section508",
                    "section508.22.a",
                    "EN-301-549",
                    "EN-9.1.1.1"
                ],
                actIds: [
                    "8fc3b6"
                ],
                all: [],
                any: [
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    "presentational-role"
                ],
                none: []
            },
            {
                id: "p-as-heading",
                impact: "serious",
                selector: "p",
                matches: "p-as-heading-matches",
                tags: [
                    "cat.semantics",
                    "wcag2a",
                    "wcag131",
                    "EN-301-549",
                    "EN-9.1.3.1",
                    "experimental"
                ],
                all: [
                    {
                        options: {
                            margins: [
                                {
                                    weight: 150,
                                    italic: true
                                },
                                {
                                    weight: 150,
                                    size: 1.15
                                },
                                {
                                    italic: true,
                                    size: 1.15
                                },
                                {
                                    size: 1.4
                                }
                            ],
                            passLength: 1,
                            failLength: .5
                        },
                        id: "p-as-heading"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "page-has-heading-one",
                impact: "moderate",
                selector: "html",
                tags: [
                    "cat.semantics",
                    "best-practice"
                ],
                all: [
                    {
                        options: {
                            selector: "h1:not([role], [aria-level]), :is(h1, h2, h3, h4, h5, h6):not([role])[aria-level=1], [role=heading][aria-level=1]",
                            passForModal: true
                        },
                        id: "page-has-heading-one"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "presentation-role-conflict",
                impact: "minor",
                selector: 'img[alt=\'\'], [role="none"], [role="presentation"]',
                matches: "has-implicit-chromium-role-matches",
                tags: [
                    "cat.aria",
                    "best-practice",
                    "ACT"
                ],
                actIds: [
                    "46ca7f"
                ],
                all: [],
                any: [],
                none: [
                    "is-element-focusable",
                    "has-global-aria-attribute"
                ]
            },
            {
                id: "region",
                impact: "moderate",
                selector: "body *",
                tags: [
                    "cat.keyboard",
                    "best-practice"
                ],
                all: [],
                any: [
                    {
                        options: {
                            regionMatcher: "dialog, [role=dialog], [role=alertdialog], svg"
                        },
                        id: "region"
                    }
                ],
                none: []
            },
            {
                id: "role-img-alt",
                impact: "serious",
                selector: "[role='img']:not(img, area, input, object)",
                matches: "html-namespace-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag111",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT7.a",
                    "EN-301-549",
                    "EN-9.1.1.1",
                    "ACT"
                ],
                actIds: [
                    "23a2a8"
                ],
                all: [],
                any: [
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "scope-attr-valid",
                impact: "moderate",
                selector: "td[scope], th[scope]",
                tags: [
                    "cat.tables",
                    "best-practice"
                ],
                all: [
                    "html5-scope",
                    {
                        options: {
                            values: [
                                "row",
                                "col",
                                "rowgroup",
                                "colgroup"
                            ]
                        },
                        id: "scope-value"
                    }
                ],
                any: [],
                none: []
            },
            {
                id: "scrollable-region-focusable",
                impact: "serious",
                selector: "*:not(select,textarea)",
                matches: "scrollable-region-focusable-matches",
                tags: [
                    "cat.keyboard",
                    "wcag2a",
                    "wcag211",
                    "TTv5",
                    "TT4.a",
                    "EN-301-549",
                    "EN-9.2.1.1"
                ],
                actIds: [
                    "0ssw9k"
                ],
                all: [],
                any: [
                    "focusable-content",
                    "focusable-element"
                ],
                none: []
            },
            {
                id: "select-name",
                impact: "critical",
                selector: "select",
                tags: [
                    "cat.forms",
                    "wcag2a",
                    "wcag412",
                    "section508",
                    "section508.22.n",
                    "TTv5",
                    "TT5.c",
                    "EN-301-549",
                    "EN-9.4.1.2",
                    "ACT"
                ],
                actIds: [
                    "e086e5"
                ],
                all: [],
                any: [
                    "implicit-label",
                    "explicit-label",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    },
                    "presentational-role"
                ],
                none: [
                    "hidden-explicit-label"
                ]
            },
            {
                id: "server-side-image-map",
                impact: "minor",
                selector: "img[ismap]",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag211",
                    "section508",
                    "section508.22.f",
                    "TTv5",
                    "TT4.a",
                    "EN-301-549",
                    "EN-9.2.1.1"
                ],
                all: [],
                any: [],
                none: [
                    "exists"
                ]
            },
            {
                id: "skip-link",
                impact: "moderate",
                selector: 'a[href^="#"], a[href^="/#"]',
                matches: "skip-link-matches",
                tags: [
                    "cat.keyboard",
                    "best-practice"
                ],
                all: [],
                any: [
                    "skip-link"
                ],
                none: []
            },
            {
                id: "svg-img-alt",
                impact: "serious",
                selector: '[role="img"], [role="graphics-symbol"], svg[role="graphics-document"]',
                matches: "svg-namespace-matches",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag111",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT7.a",
                    "EN-301-549",
                    "EN-9.1.1.1",
                    "ACT"
                ],
                actIds: [
                    "7d6734"
                ],
                all: [],
                any: [
                    "svg-non-empty-title",
                    "aria-label",
                    "aria-labelledby",
                    {
                        options: {
                            attribute: "title"
                        },
                        id: "non-empty-title"
                    }
                ],
                none: []
            },
            {
                id: "tabindex",
                impact: "serious",
                selector: "[tabindex]",
                tags: [
                    "cat.keyboard",
                    "best-practice"
                ],
                all: [],
                any: [
                    "tabindex"
                ],
                none: []
            },
            {
                id: "table-duplicate-name",
                impact: "minor",
                selector: "table",
                tags: [
                    "cat.tables",
                    "best-practice"
                ],
                all: [],
                any: [],
                none: [
                    "same-caption-summary"
                ]
            },
            {
                id: "table-fake-caption",
                impact: "serious",
                selector: "table",
                matches: "data-table-matches",
                tags: [
                    "cat.tables",
                    "experimental",
                    "wcag2a",
                    "wcag131",
                    "section508",
                    "section508.22.g",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                all: [
                    "caption-faked"
                ],
                any: [],
                none: []
            },
            {
                id: "target-size",
                impact: "serious",
                selector: "*",
                enabled: false,
                matches: "widget-not-inline-matches",
                tags: [
                    "cat.sensory-and-visual-cues",
                    "wcag22aa",
                    "wcag258"
                ],
                all: [],
                any: [
                    {
                        options: {
                            minSize: 24
                        },
                        id: "target-size"
                    },
                    {
                        options: {
                            minOffset: 24
                        },
                        id: "target-offset"
                    }
                ],
                none: []
            },
            {
                id: "td-has-header",
                impact: "critical",
                selector: "table",
                matches: "data-table-large-matches",
                tags: [
                    "cat.tables",
                    "experimental",
                    "wcag2a",
                    "wcag131",
                    "section508",
                    "section508.22.g",
                    "TTv5",
                    "TT14.b",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                all: [
                    "td-has-header"
                ],
                any: [],
                none: []
            },
            {
                id: "td-headers-attr",
                impact: "serious",
                selector: "table",
                matches: "table-or-grid-role-matches",
                tags: [
                    "cat.tables",
                    "wcag2a",
                    "wcag131",
                    "section508",
                    "section508.22.g",
                    "TTv5",
                    "TT14.b",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                actIds: [
                    "a25f45"
                ],
                all: [
                    "td-headers-attr"
                ],
                any: [],
                none: []
            },
            {
                id: "th-has-data-cells",
                impact: "serious",
                selector: "table",
                matches: "data-table-matches",
                tags: [
                    "cat.tables",
                    "wcag2a",
                    "wcag131",
                    "section508",
                    "section508.22.g",
                    "TTv5",
                    "TT14.b",
                    "EN-301-549",
                    "EN-9.1.3.1"
                ],
                actIds: [
                    "d0f69e"
                ],
                all: [
                    "th-has-data-cells"
                ],
                any: [],
                none: []
            },
            {
                id: "valid-lang",
                impact: "serious",
                selector: "[lang]:not(html), [xml\\:lang]:not(html)",
                tags: [
                    "cat.language",
                    "wcag2aa",
                    "wcag312",
                    "TTv5",
                    "TT11.b",
                    "EN-301-549",
                    "EN-9.3.1.2",
                    "ACT"
                ],
                actIds: [
                    "de46e4"
                ],
                all: [],
                any: [],
                none: [
                    {
                        options: {
                            attributes: [
                                "lang",
                                "xml:lang"
                            ]
                        },
                        id: "valid-lang"
                    }
                ]
            },
            {
                id: "video-caption",
                impact: "critical",
                selector: "video",
                tags: [
                    "cat.text-alternatives",
                    "wcag2a",
                    "wcag122",
                    "section508",
                    "section508.22.a",
                    "TTv5",
                    "TT17.a",
                    "EN-301-549",
                    "EN-9.1.2.2"
                ],
                actIds: [
                    "eac66b"
                ],
                all: [],
                any: [],
                none: [
                    "caption"
                ]
            }
        ],
        checks: [
            {
                id: "abstractrole",
                evaluate: "abstractrole-evaluate"
            },
            {
                id: "aria-allowed-attr",
                evaluate: "aria-allowed-attr-evaluate",
                options: {
                    validTreeRowAttrs: [
                        "aria-posinset",
                        "aria-setsize",
                        "aria-expanded",
                        "aria-level"
                    ]
                }
            },
            {
                id: "aria-allowed-role",
                evaluate: "aria-allowed-role-evaluate",
                options: {
                    allowImplicit: true,
                    ignoredTags: []
                }
            },
            {
                id: "aria-busy",
                evaluate: "aria-busy-evaluate"
            },
            {
                id: "aria-conditional-attr",
                evaluate: "aria-conditional-attr-evaluate",
                options: {
                    invalidTableRowAttrs: [
                        "aria-posinset",
                        "aria-setsize",
                        "aria-expanded",
                        "aria-level"
                    ]
                }
            },
            {
                id: "aria-errormessage",
                evaluate: "aria-errormessage-evaluate"
            },
            {
                id: "aria-hidden-body",
                evaluate: "aria-hidden-body-evaluate"
            },
            {
                id: "aria-level",
                evaluate: "aria-level-evaluate"
            },
            {
                id: "aria-prohibited-attr",
                evaluate: "aria-prohibited-attr-evaluate",
                options: {
                    elementsAllowedAriaLabel: [
                        "applet",
                        "input"
                    ]
                }
            },
            {
                id: "aria-required-attr",
                evaluate: "aria-required-attr-evaluate"
            },
            {
                id: "aria-required-children",
                evaluate: "aria-required-children-evaluate",
                options: {
                    reviewEmpty: [
                        "doc-bibliography",
                        "doc-endnotes",
                        "grid",
                        "list",
                        "listbox",
                        "menu",
                        "menubar",
                        "table",
                        "tablist",
                        "tree",
                        "treegrid",
                        "rowgroup"
                    ]
                }
            },
            {
                id: "aria-required-parent",
                evaluate: "aria-required-parent-evaluate",
                options: {
                    ownGroupRoles: [
                        "listitem",
                        "treeitem"
                    ]
                }
            },
            {
                id: "aria-roledescription",
                evaluate: "aria-roledescription-evaluate",
                options: {
                    supportedRoles: [
                        "button",
                        "img",
                        "checkbox",
                        "radio",
                        "combobox",
                        "menuitemcheckbox",
                        "menuitemradio"
                    ]
                }
            },
            {
                id: "aria-unsupported-attr",
                evaluate: "aria-unsupported-attr-evaluate"
            },
            {
                id: "aria-valid-attr-value",
                evaluate: "aria-valid-attr-value-evaluate",
                options: []
            },
            {
                id: "aria-valid-attr",
                evaluate: "aria-valid-attr-evaluate",
                options: []
            },
            {
                id: "braille-label-equivalent",
                evaluate: "braille-label-equivalent-evaluate"
            },
            {
                id: "braille-roledescription-equivalent",
                evaluate: "braille-roledescription-equivalent-evaluate"
            },
            {
                id: "deprecatedrole",
                evaluate: "deprecatedrole-evaluate"
            },
            {
                id: "fallbackrole",
                evaluate: "fallbackrole-evaluate"
            },
            {
                id: "has-global-aria-attribute",
                evaluate: "has-global-aria-attribute-evaluate"
            },
            {
                id: "has-widget-role",
                evaluate: "has-widget-role-evaluate",
                options: []
            },
            {
                id: "invalidrole",
                evaluate: "invalidrole-evaluate"
            },
            {
                id: "is-element-focusable",
                evaluate: "is-element-focusable-evaluate"
            },
            {
                id: "no-implicit-explicit-label",
                evaluate: "no-implicit-explicit-label-evaluate"
            },
            {
                id: "unsupportedrole",
                evaluate: "unsupportedrole-evaluate"
            },
            {
                id: "valid-scrollable-semantics",
                evaluate: "valid-scrollable-semantics-evaluate",
                options: {
                    roles: [
                        "tooltip"
                    ]
                }
            },
            {
                id: "color-contrast-enhanced",
                evaluate: "color-contrast-evaluate",
                options: {
                    ignoreUnicode: true,
                    ignoreLength: false,
                    ignorePseudo: false,
                    boldValue: 700,
                    boldTextPt: 14,
                    largeTextPt: 18,
                    contrastRatio: {
                        normal: {
                            expected: 7,
                            minThreshold: 4.5
                        },
                        large: {
                            expected: 4.5,
                            minThreshold: 3
                        }
                    },
                    pseudoSizeThreshold: .25,
                    shadowOutlineEmMax: .1,
                    textStrokeEmMin: .03
                }
            },
            {
                id: "color-contrast",
                evaluate: "color-contrast-evaluate",
                options: {
                    ignoreUnicode: true,
                    ignoreLength: false,
                    ignorePseudo: false,
                    boldValue: 700,
                    boldTextPt: 14,
                    largeTextPt: 18,
                    contrastRatio: {
                        normal: {
                            expected: 4.5
                        },
                        large: {
                            expected: 3
                        }
                    },
                    pseudoSizeThreshold: .25,
                    shadowOutlineEmMax: .2,
                    textStrokeEmMin: .03
                }
            },
            {
                id: "link-in-text-block-style",
                evaluate: "link-in-text-block-style-evaluate"
            },
            {
                id: "link-in-text-block",
                evaluate: "link-in-text-block-evaluate",
                options: {
                    requiredContrastRatio: 3,
                    allowSameColor: true
                }
            },
            {
                id: "autocomplete-appropriate",
                evaluate: "autocomplete-appropriate-evaluate",
                deprecated: true
            },
            {
                id: "autocomplete-valid",
                evaluate: "autocomplete-valid-evaluate",
                options: {
                    stateTerms: [
                        "none",
                        "false",
                        "true",
                        "disabled",
                        "enabled",
                        "undefined",
                        "null"
                    ]
                }
            },
            {
                id: "accesskeys",
                evaluate: "accesskeys-evaluate",
                after: "accesskeys-after"
            },
            {
                id: "focusable-content",
                evaluate: "focusable-content-evaluate"
            },
            {
                id: "focusable-disabled",
                evaluate: "focusable-disabled-evaluate"
            },
            {
                id: "focusable-element",
                evaluate: "focusable-element-evaluate"
            },
            {
                id: "focusable-modal-open",
                evaluate: "focusable-modal-open-evaluate"
            },
            {
                id: "focusable-no-name",
                evaluate: "focusable-no-name-evaluate"
            },
            {
                id: "focusable-not-tabbable",
                evaluate: "focusable-not-tabbable-evaluate"
            },
            {
                id: "frame-focusable-content",
                evaluate: "frame-focusable-content-evaluate"
            },
            {
                id: "landmark-is-top-level",
                evaluate: "landmark-is-top-level-evaluate"
            },
            {
                id: "no-focusable-content",
                evaluate: "no-focusable-content-evaluate"
            },
            {
                id: "page-has-heading-one",
                evaluate: "has-descendant-evaluate",
                after: "has-descendant-after",
                options: {
                    selector: "h1:not([role], [aria-level]), :is(h1, h2, h3, h4, h5, h6):not([role])[aria-level=1], [role=heading][aria-level=1]",
                    passForModal: true
                }
            },
            {
                id: "page-has-main",
                evaluate: "has-descendant-evaluate",
                after: "has-descendant-after",
                options: {
                    selector: "main:not([role]), [role='main']",
                    passForModal: true
                }
            },
            {
                id: "page-no-duplicate-banner",
                evaluate: "page-no-duplicate-evaluate",
                after: "page-no-duplicate-after",
                options: {
                    selector: "header:not([role]), [role=banner]",
                    role: "banner"
                }
            },
            {
                id: "page-no-duplicate-contentinfo",
                evaluate: "page-no-duplicate-evaluate",
                after: "page-no-duplicate-after",
                options: {
                    selector: "footer:not([role]), [role=contentinfo]",
                    role: "contentinfo"
                }
            },
            {
                id: "page-no-duplicate-main",
                evaluate: "page-no-duplicate-evaluate",
                after: "page-no-duplicate-after",
                options: {
                    selector: "main:not([role]), [role='main']"
                }
            },
            {
                id: "tabindex",
                evaluate: "tabindex-evaluate"
            },
            {
                id: "alt-space-value",
                evaluate: "alt-space-value-evaluate"
            },
            {
                id: "duplicate-img-label",
                evaluate: "duplicate-img-label-evaluate",
                options: {
                    parentSelector: "button, [role=button], a[href], p, li, td, th"
                }
            },
            {
                id: "explicit-label",
                evaluate: "explicit-evaluate"
            },
            {
                id: "help-same-as-label",
                evaluate: "help-same-as-label-evaluate"
            },
            {
                id: "hidden-explicit-label",
                evaluate: "hidden-explicit-label-evaluate"
            },
            {
                id: "implicit-label",
                evaluate: "implicit-evaluate"
            },
            {
                id: "label-content-name-mismatch",
                evaluate: "label-content-name-mismatch-evaluate",
                options: {
                    pixelThreshold: .1,
                    occurrenceThreshold: 3
                }
            },
            {
                id: "multiple-label",
                evaluate: "multiple-label-evaluate"
            },
            {
                id: "title-only",
                evaluate: "title-only-evaluate"
            },
            {
                id: "landmark-is-unique",
                evaluate: "landmark-is-unique-evaluate",
                after: "landmark-is-unique-after"
            },
            {
                id: "has-lang",
                evaluate: "has-lang-evaluate",
                options: {
                    attributes: [
                        "lang",
                        "xml:lang"
                    ]
                }
            },
            {
                id: "valid-lang",
                evaluate: "valid-lang-evaluate",
                options: {
                    attributes: [
                        "lang",
                        "xml:lang"
                    ]
                }
            },
            {
                id: "xml-lang-mismatch",
                evaluate: "xml-lang-mismatch-evaluate"
            },
            {
                id: "dlitem",
                evaluate: "dlitem-evaluate"
            },
            {
                id: "listitem",
                evaluate: "listitem-evaluate"
            },
            {
                id: "only-dlitems",
                evaluate: "invalid-children-evaluate",
                options: {
                    validRoles: [
                        "definition",
                        "term",
                        "listitem"
                    ],
                    validNodeNames: [
                        "dt",
                        "dd"
                    ],
                    divGroups: true
                }
            },
            {
                id: "only-listitems",
                evaluate: "invalid-children-evaluate",
                options: {
                    validRoles: [
                        "listitem"
                    ],
                    validNodeNames: [
                        "li"
                    ]
                }
            },
            {
                id: "structured-dlitems",
                evaluate: "structured-dlitems-evaluate"
            },
            {
                id: "caption",
                evaluate: "caption-evaluate"
            },
            {
                id: "frame-tested",
                evaluate: "frame-tested-evaluate",
                after: "frame-tested-after",
                options: {
                    isViolation: false
                }
            },
            {
                id: "no-autoplay-audio",
                evaluate: "no-autoplay-audio-evaluate",
                options: {
                    allowedDuration: 3
                }
            },
            {
                id: "css-orientation-lock",
                evaluate: "css-orientation-lock-evaluate",
                options: {
                    degreeThreshold: 2
                }
            },
            {
                id: "meta-viewport-large",
                evaluate: "meta-viewport-scale-evaluate",
                options: {
                    scaleMinimum: 5,
                    lowerBound: 2
                }
            },
            {
                id: "meta-viewport",
                evaluate: "meta-viewport-scale-evaluate",
                options: {
                    scaleMinimum: 2
                }
            },
            {
                id: "target-offset",
                evaluate: "target-offset-evaluate",
                options: {
                    minOffset: 24
                }
            },
            {
                id: "target-size",
                evaluate: "target-size-evaluate",
                options: {
                    minSize: 24
                }
            },
            {
                id: "header-present",
                evaluate: "has-descendant-evaluate",
                after: "has-descendant-after",
                options: {
                    selector: ":is(h1, h2, h3, h4, h5, h6):not([role]), [role=heading]"
                }
            },
            {
                id: "heading-order",
                evaluate: "heading-order-evaluate",
                after: "heading-order-after"
            },
            {
                id: "identical-links-same-purpose",
                evaluate: "identical-links-same-purpose-evaluate",
                after: "identical-links-same-purpose-after"
            },
            {
                id: "internal-link-present",
                evaluate: "internal-link-present-evaluate"
            },
            {
                id: "landmark",
                evaluate: "has-descendant-evaluate",
                options: {
                    selector: "main, [role=main]"
                }
            },
            {
                id: "meta-refresh-no-exceptions",
                evaluate: "meta-refresh-evaluate",
                options: {
                    minDelay: 72e3,
                    maxDelay: false
                }
            },
            {
                id: "meta-refresh",
                evaluate: "meta-refresh-evaluate",
                options: {
                    minDelay: 0,
                    maxDelay: 72e3
                }
            },
            {
                id: "p-as-heading",
                evaluate: "p-as-heading-evaluate",
                options: {
                    margins: [
                        {
                            weight: 150,
                            italic: true
                        },
                        {
                            weight: 150,
                            size: 1.15
                        },
                        {
                            italic: true,
                            size: 1.15
                        },
                        {
                            size: 1.4
                        }
                    ],
                    passLength: 1,
                    failLength: .5
                }
            },
            {
                id: "region",
                evaluate: "region-evaluate",
                after: "region-after",
                options: {
                    regionMatcher: "dialog, [role=dialog], [role=alertdialog], svg"
                }
            },
            {
                id: "skip-link",
                evaluate: "skip-link-evaluate"
            },
            {
                id: "unique-frame-title",
                evaluate: "unique-frame-title-evaluate",
                after: "unique-frame-title-after"
            },
            {
                id: "duplicate-id-active",
                evaluate: "duplicate-id-evaluate",
                after: "duplicate-id-after"
            },
            {
                id: "duplicate-id-aria",
                evaluate: "duplicate-id-evaluate",
                after: "duplicate-id-after"
            },
            {
                id: "duplicate-id",
                evaluate: "duplicate-id-evaluate",
                after: "duplicate-id-after"
            },
            {
                id: "aria-label",
                evaluate: "aria-label-evaluate"
            },
            {
                id: "aria-labelledby",
                evaluate: "aria-labelledby-evaluate"
            },
            {
                id: "avoid-inline-spacing",
                evaluate: "avoid-inline-spacing-evaluate",
                options: {
                    cssProperties: [
                        "line-height",
                        "letter-spacing",
                        "word-spacing"
                    ]
                }
            },
            {
                id: "button-has-visible-text",
                evaluate: "has-text-content-evaluate"
            },
            {
                id: "doc-has-title",
                evaluate: "doc-has-title-evaluate"
            },
            {
                id: "exists",
                evaluate: "exists-evaluate"
            },
            {
                id: "has-alt",
                evaluate: "has-alt-evaluate"
            },
            {
                id: "has-visible-text",
                evaluate: "has-text-content-evaluate"
            },
            {
                id: "important-letter-spacing",
                evaluate: "inline-style-property-evaluate",
                options: {
                    cssProperty: "letter-spacing",
                    minValue: .12
                }
            },
            {
                id: "important-line-height",
                evaluate: "inline-style-property-evaluate",
                options: {
                    multiLineOnly: true,
                    cssProperty: "line-height",
                    minValue: 1.5,
                    normalValue: 1
                }
            },
            {
                id: "important-word-spacing",
                evaluate: "inline-style-property-evaluate",
                options: {
                    cssProperty: "word-spacing",
                    minValue: .16
                }
            },
            {
                id: "is-on-screen",
                evaluate: "is-on-screen-evaluate"
            },
            {
                id: "non-empty-alt",
                evaluate: "attr-non-space-content-evaluate",
                options: {
                    attribute: "alt"
                }
            },
            {
                id: "non-empty-if-present",
                evaluate: "non-empty-if-present-evaluate"
            },
            {
                id: "non-empty-placeholder",
                evaluate: "attr-non-space-content-evaluate",
                options: {
                    attribute: "placeholder"
                }
            },
            {
                id: "non-empty-title",
                evaluate: "attr-non-space-content-evaluate",
                options: {
                    attribute: "title"
                }
            },
            {
                id: "non-empty-value",
                evaluate: "attr-non-space-content-evaluate",
                options: {
                    attribute: "value"
                }
            },
            {
                id: "presentational-role",
                evaluate: "presentational-role-evaluate"
            },
            {
                id: "role-none",
                evaluate: "matches-definition-evaluate",
                deprecated: true,
                options: {
                    matcher: {
                        attributes: {
                            role: "none"
                        }
                    }
                }
            },
            {
                id: "role-presentation",
                evaluate: "matches-definition-evaluate",
                deprecated: true,
                options: {
                    matcher: {
                        attributes: {
                            role: "presentation"
                        }
                    }
                }
            },
            {
                id: "svg-non-empty-title",
                evaluate: "svg-non-empty-title-evaluate"
            },
            {
                id: "caption-faked",
                evaluate: "caption-faked-evaluate"
            },
            {
                id: "html5-scope",
                evaluate: "html5-scope-evaluate"
            },
            {
                id: "same-caption-summary",
                evaluate: "same-caption-summary-evaluate"
            },
            {
                id: "scope-value",
                evaluate: "scope-value-evaluate",
                options: {
                    values: [
                        "row",
                        "col",
                        "rowgroup",
                        "colgroup"
                    ]
                }
            },
            {
                id: "td-has-header",
                evaluate: "td-has-header-evaluate"
            },
            {
                id: "td-headers-attr",
                evaluate: "td-headers-attr-evaluate"
            },
            {
                id: "th-has-data-cells",
                evaluate: "th-has-data-cells-evaluate"
            },
            {
                id: "hidden-content",
                evaluate: "hidden-content-evaluate"
            }
        ]
    });
})(typeof window === "object" ? window : this);

});

parcelRequire.register("h8uFI", function(module, exports) {
(function(factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, module.exports) module.exports = factory();
    else window.idleCallbackShim = factory();
})(function() {
    "use strict";
    var scheduleStart, throttleDelay, lazytimer, lazyraf;
    var root = typeof window != "undefined" ? window : ($parcel$global, $parcel$global);
    var requestAnimationFrame = root.cancelRequestAnimationFrame && root.requestAnimationFrame || setTimeout;
    var cancelRequestAnimationFrame = root.cancelRequestAnimationFrame || clearTimeout;
    var tasks = [];
    var runAttempts = 0;
    var isRunning = false;
    var remainingTime = 7;
    var minThrottle = 35;
    var throttle = 125;
    var index = 0;
    var taskStart = 0;
    var tasklength = 0;
    var IdleDeadline = {
        get didTimeout () {
            return false;
        },
        timeRemaining: function() {
            var timeRemaining = remainingTime - (Date.now() - taskStart);
            return timeRemaining < 0 ? 0 : timeRemaining;
        }
    };
    var setInactive = debounce(function() {
        remainingTime = 22;
        throttle = 66;
        minThrottle = 0;
    });
    function debounce(fn) {
        var id, timestamp;
        var wait = 99;
        var check = function() {
            var last = Date.now() - timestamp;
            if (last < wait) id = setTimeout(check, wait - last);
            else {
                id = null;
                fn();
            }
        };
        return function() {
            timestamp = Date.now();
            if (!id) id = setTimeout(check, wait);
        };
    }
    function abortRunning() {
        if (isRunning) {
            if (lazyraf) cancelRequestAnimationFrame(lazyraf);
            if (lazytimer) clearTimeout(lazytimer);
            isRunning = false;
        }
    }
    function onInputorMutation() {
        if (throttle != 125) {
            remainingTime = 7;
            throttle = 125;
            minThrottle = 35;
            if (isRunning) {
                abortRunning();
                scheduleLazy();
            }
        }
        setInactive();
    }
    function scheduleAfterRaf() {
        lazyraf = null;
        lazytimer = setTimeout(runTasks, 0);
    }
    function scheduleRaf() {
        lazytimer = null;
        requestAnimationFrame(scheduleAfterRaf);
    }
    function scheduleLazy() {
        if (isRunning) return;
        throttleDelay = throttle - (Date.now() - taskStart);
        scheduleStart = Date.now();
        isRunning = true;
        if (minThrottle && throttleDelay < minThrottle) throttleDelay = minThrottle;
        if (throttleDelay > 9) lazytimer = setTimeout(scheduleRaf, throttleDelay);
        else {
            throttleDelay = 0;
            scheduleRaf();
        }
    }
    function runTasks() {
        var task, i, len;
        var timeThreshold = remainingTime > 9 ? 9 : 1;
        taskStart = Date.now();
        isRunning = false;
        lazytimer = null;
        if (runAttempts > 2 || taskStart - throttleDelay - 50 < scheduleStart) for(i = 0, len = tasks.length; i < len && IdleDeadline.timeRemaining() > timeThreshold; i++){
            task = tasks.shift();
            tasklength++;
            if (task) task(IdleDeadline);
        }
        if (tasks.length) scheduleLazy();
        else runAttempts = 0;
    }
    function requestIdleCallbackShim(task) {
        index++;
        tasks.push(task);
        scheduleLazy();
        return index;
    }
    function cancelIdleCallbackShim(id) {
        var index = id - 1 - tasklength;
        if (tasks[index]) tasks[index] = null;
    }
    if (!root.requestIdleCallback || !root.cancelIdleCallback) {
        root.requestIdleCallback = requestIdleCallbackShim;
        root.cancelIdleCallback = cancelIdleCallbackShim;
        if (root.document && document.addEventListener) {
            root.addEventListener("scroll", onInputorMutation, true);
            root.addEventListener("resize", onInputorMutation);
            document.addEventListener("focus", onInputorMutation, true);
            document.addEventListener("mouseover", onInputorMutation, true);
            [
                "click",
                "keypress",
                "touchstart",
                "mousedown"
            ].forEach(function(name) {
                document.addEventListener(name, onInputorMutation, {
                    capture: true,
                    passive: true
                });
            });
            if (root.MutationObserver) new MutationObserver(onInputorMutation).observe(document.documentElement, {
                childList: true,
                subtree: true,
                attributes: true
            });
        }
    } else try {
        root.requestIdleCallback(function() {}, {
            timeout: 0
        });
    } catch (e) {
        (function(rIC) {
            var timeRemainingProto, timeRemaining;
            root.requestIdleCallback = function(fn, timeout) {
                if (timeout && typeof timeout.timeout == "number") return rIC(fn, timeout.timeout);
                return rIC(fn);
            };
            if (root.IdleCallbackDeadline && (timeRemainingProto = IdleCallbackDeadline.prototype)) {
                timeRemaining = Object.getOwnPropertyDescriptor(timeRemainingProto, "timeRemaining");
                if (!timeRemaining || !timeRemaining.configurable || !timeRemaining.get) return;
                Object.defineProperty(timeRemainingProto, "timeRemaining", {
                    value: function() {
                        return timeRemaining.get.call(this);
                    },
                    enumerable: true,
                    configurable: true
                });
            }
        })(root.requestIdleCallback);
    }
    return {
        request: requestIdleCallbackShim,
        cancel: cancelIdleCallbackShim
    };
});

});



var $ayMG0 = parcelRequire("ayMG0");

Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", {
    configurable: !0,
    value: function r() {
        var t = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
        return t ? Array.prototype.reduce.call(this, function(a, e) {
            return Array.isArray(e) ? a.push.apply(a, r.call(e, t - 1)) : a.push(e), a;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: !0
}), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", {
    configurable: !0,
    value: function(r) {
        return Array.prototype.map.apply(this, arguments).flat();
    },
    writable: !0
});



var $acw62 = parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $b2387a3a0aaf3520$export$2e2bcd8739ae039() {
    $b2387a3a0aaf3520$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b2387a3a0aaf3520$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");



var $fHPaR = parcelRequire("fHPaR");

var $lT1cX = parcelRequire("lT1cX");
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $b2387a3a0aaf3520$export$2e2bcd8739ae039)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $lT1cX.default)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $20a8501e6e2f4912$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHPaR.default).Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;



parcelRequire("8zogs");
var $1my5K = parcelRequire("1my5K");

var $7HKeb = parcelRequire("7HKeb");

var $ayMG0 = parcelRequire("ayMG0");
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$InnerThemeProvider(props) {
    const theme = (0, $7HKeb.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1my5K.T).Provider, {
        value: typeof theme === "object" ? theme : $50ef44b883b4d7f9$var$EMPTY_THEME,
        children: props.children
    });
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff44a152eb20ab0$export$2e2bcd8739ae039), {
        theme: localTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($50ef44b883b4d7f9$var$InnerThemeProvider, {
            children: children
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;



var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
var $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
var $f9089991fdc24c9c$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $f9089991fdc24c9c$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $f9089991fdc24c9c$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    var batch = (0, $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $de1db2bafb2c3b5a$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $de1db2bafb2c3b5a$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $acw62 = parcelRequire("acw62");
var $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $31f4d8f6ffbbb628$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $acw62.useMemo)(function() {
        var subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $acw62.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $55099852ccad0564$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));





var $1a53bfd8072ab080$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $1a53bfd8072ab080$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $1a53bfd8072ab080$var$EMPTY_ARRAY = [];
var $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1a53bfd8072ab080$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1a53bfd8072ab080$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $1a53bfd8072ab080$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1a53bfd8072ab080$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $1a53bfd8072ab080$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $1a53bfd8072ab080$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $55099852ccad0564$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref2, $1a53bfd8072ab080$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $acw62.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $acw62.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $1a53bfd8072ab080$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $acw62.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $3251146683c5d714$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $acw62.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $acw62.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $acw62.useMemo)(function() {
                if (!shouldHandleStateChanges) return $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $acw62.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $acw62.useReducer)($1a53bfd8072ab080$var$storeStateUpdatesReducer, $1a53bfd8072ab080$var$EMPTY_ARRAY, $1a53bfd8072ab080$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $acw62.useRef)();
            var lastWrapperProps = (0, $acw62.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $acw62.useRef)();
            var renderIsScheduled = (0, $acw62.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $acw62.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $acw62.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connect, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
}






function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $859ec94da7aa38c4$export$2e2bcd8739ae039)(value)) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $2d566511964cb2c4$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $d4dd493c66c4df43$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $d4dd493c66c4df43$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d4dd493c66c4df43$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $6a22b9cec285f673$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d4dd493c66c4df43$export$2e2bcd8739ae039 = [
    $d4dd493c66c4df43$export$a9f27b4b187c1166,
    $d4dd493c66c4df43$export$ba20d1a7aa0c4a90,
    $d4dd493c66c4df43$export$94a6e55709d4d961
];



function $f337fd5395077a96$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $f337fd5395077a96$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $f337fd5395077a96$export$2e2bcd8739ae039 = [
    $f337fd5395077a96$export$23fc470827b14aa,
    $f337fd5395077a96$export$514bc8c1a53c1d66
];




function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : undefined;
}
function $59349e43bbd01749$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $59349e43bbd01749$export$691c327fc30bc857;
    } : undefined;
}
var $59349e43bbd01749$export$2e2bcd8739ae039 = [
    $59349e43bbd01749$export$d61b680184bc3f00,
    $59349e43bbd01749$export$a13ba70ef50dda6d
];




function $98b92028b84cbd13$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $98b92028b84cbd13$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $98b92028b84cbd13$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $98b92028b84cbd13$var$verify(mergeProps, "mergeProps", displayName);
}


var $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref2, $2eb761e6a8ffbe36$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f : $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $cb2d32d6c07199e9$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $cb2d32d6c07199e9$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $cb2d32d6c07199e9$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $cb2d32d6c07199e9$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $1a53bfd8072ab080$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $f337fd5395077a96$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $d4dd493c66c4df43$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $59349e43bbd01749$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $2eb761e6a8ffbe36$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $cb2d32d6c07199e9$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $66f27f2048ec2805$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $66f27f2048ec2805$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $66f27f2048ec2805$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref3, $cb2d32d6c07199e9$var$_excluded);
        var initMapStateToProps = $cb2d32d6c07199e9$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $cb2d32d6c07199e9$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $cb2d32d6c07199e9$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $cb2d32d6c07199e9$export$2e2bcd8739ae039 = /*#__PURE__*/ $cb2d32d6c07199e9$export$9f9feb656dec1fc4();




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $11518dc3bb05d381$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $acw62.useContext)((0, $55099852ccad0564$export$cc80c08dc91f1c00));
    return contextValue;
}


function $391671225302c365$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $55099852ccad0564$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();


function $20d80f3cecee513e$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $55099852ccad0564$export$cc80c08dc91f1c00);
    var useStore = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $391671225302c365$export$6ccbb43953eebf8) : (0, $391671225302c365$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();



var $acw62 = parcelRequire("acw62");




var $d8fc8d639f906efc$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $acw62.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $acw62.useMemo)(function() {
        return (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $acw62.useRef)();
    var latestSelector = (0, $acw62.useRef)();
    var latestStoreState = (0, $acw62.useRef)();
    var latestSelectedState = (0, $acw62.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $55099852ccad0564$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $d8fc8d639f906efc$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $f9089991fdc24c9c$export$4b9874722d0da7bc)((0, $11492dca620dcaa5$exports.unstable_batchedUpdates));



var $acw62 = parcelRequire("acw62");
function $6e12196636af0b10$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e12196636af0b10$var$_typeof(obj);
}
function $6e12196636af0b10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e12196636af0b10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e12196636af0b10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e12196636af0b10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e12196636af0b10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e12196636af0b10$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e12196636af0b10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e12196636af0b10$var$_assertThisInitialized(self);
}
function $6e12196636af0b10$var$_getPrototypeOf(o) {
    $6e12196636af0b10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e12196636af0b10$var$_getPrototypeOf(o);
}
function $6e12196636af0b10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e12196636af0b10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e12196636af0b10$var$_setPrototypeOf(subClass, superClass);
}
function $6e12196636af0b10$var$_setPrototypeOf(o, p) {
    $6e12196636af0b10$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e12196636af0b10$var$_setPrototypeOf(o, p);
}
function $6e12196636af0b10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6e12196636af0b10$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $6e12196636af0b10$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $6e12196636af0b10$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6e12196636af0b10$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6e12196636af0b10$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $6e12196636af0b10$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $acw62.PureComponent));
$6e12196636af0b10$var$_defineProperty($6e12196636af0b10$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
/**
 * React Router DOM v6.2.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $6d23e34a443a4a03$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6d23e34a443a4a03$export$e19cd5f9376f8cee || ($6d23e34a443a4a03$export$e19cd5f9376f8cee = {}));
var $6d23e34a443a4a03$var$readOnly = function(obj) {
    return obj;
};
function $6d23e34a443a4a03$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $6d23e34a443a4a03$var$BeforeUnloadEventType = "beforeunload";
var $6d23e34a443a4a03$var$HashChangeEventType = "hashchange";
var $6d23e34a443a4a03$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6d23e34a443a4a03$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6d23e34a443a4a03$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $6d23e34a443a4a03$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $6d23e34a443a4a03$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($6d23e34a443a4a03$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($6d23e34a443a4a03$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($6d23e34a443a4a03$export$fe53371bee54353d(nextLocation) !== $6d23e34a443a4a03$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($6d23e34a443a4a03$var$BeforeUnloadEventType, $6d23e34a443a4a03$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $6d23e34a443a4a03$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $6d23e34a443a4a03$var$createKey()
        }, typeof entry === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $6d23e34a443a4a03$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $6d23e34a443a4a03$var$createEvents();
    var blockers = $6d23e34a443a4a03$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $6d23e34a443a4a03$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $6d23e34a443a4a03$var$readOnly((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $6d23e34a443a4a03$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $6d23e34a443a4a03$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $6d23e34a443a4a03$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $6d23e34a443a4a03$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $6d23e34a443a4a03$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $6d23e34a443a4a03$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $6d23e34a443a4a03$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $6d23e34a443a4a03$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $6d23e34a443a4a03$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $6d23e34a443a4a03$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


/**
 * React Router v6.2.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $926608a7a86d7371$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $926608a7a86d7371$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $926608a7a86d7371$var$alreadyWarned = {};
function $926608a7a86d7371$var$warningOnce(key, cond, message) {
    if (!cond && !$926608a7a86d7371$var$alreadyWarned[key]) $926608a7a86d7371$var$alreadyWarned[key] = true;
} ///////////////////////////////////////////////////////////////////////////////
// CONTEXT
///////////////////////////////////////////////////////////////////////////////
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $926608a7a86d7371$export$26749e8557646306 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $926608a7a86d7371$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $926608a7a86d7371$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $acw62.createContext)({
    outlet: null,
    matches: []
});
// COMPONENTS
///////////////////////////////////////////////////////////////////////////////
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $926608a7a86d7371$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $926608a7a86d7371$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let navigate = $926608a7a86d7371$export$9770f232ac06a008();
    (0, $acw62.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $926608a7a86d7371$export$910ae8079b2c2852(props) {
    return $926608a7a86d7371$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $926608a7a86d7371$export$e7b0ac011bb776c6(_props) {
    $926608a7a86d7371$var$invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $926608a7a86d7371$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6d23e34a443a4a03$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let basename = $926608a7a86d7371$var$normalizePathname(basenameProp);
    let navigationContext = (0, $acw62.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $acw62.useMemo)(()=>{
        let trailingPathname = $926608a7a86d7371$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $926608a7a86d7371$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $926608a7a86d7371$export$5d3fca4a98652595($926608a7a86d7371$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// HOOKS
///////////////////////////////////////////////////////////////////////////////
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $926608a7a86d7371$export$b66bb29c5006f12f(to) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $acw62.useContext)($926608a7a86d7371$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $926608a7a86d7371$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $926608a7a86d7371$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $926608a7a86d7371$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $926608a7a86d7371$export$9c954a9d03d32f4a() {
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $926608a7a86d7371$export$45d76561a5302f2b() {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $926608a7a86d7371$export$1b3f31771c5d07c() {
    return (0, $acw62.useContext)($926608a7a86d7371$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $926608a7a86d7371$export$6c330e8992e8a295(pattern) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { pathname: pathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    return (0, $acw62.useMemo)(()=>$926608a7a86d7371$export$81336c211d5ff295(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $926608a7a86d7371$export$9770f232ac06a008() {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $acw62.useContext)($926608a7a86d7371$export$26749e8557646306);
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $acw62.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $926608a7a86d7371$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $926608a7a86d7371$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $926608a7a86d7371$var$OutletContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */ function $926608a7a86d7371$export$4138103a3ae699cc() {
    return (0, $acw62.useContext)($926608a7a86d7371$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $926608a7a86d7371$export$a3be3530d8e40d0b(context) {
    let outlet = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $926608a7a86d7371$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $926608a7a86d7371$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $926608a7a86d7371$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $acw62.useMemo)(()=>$926608a7a86d7371$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $926608a7a86d7371$export$5d3fca4a98652595(routes, locationArg) {
    !$926608a7a86d7371$export$9c954a9d03d32f4a() && $926608a7a86d7371$var$invariant(false);
    let { matches: parentMatches } = (0, $acw62.useContext)($926608a7a86d7371$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $926608a7a86d7371$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $926608a7a86d7371$var$invariant(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $926608a7a86d7371$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    return $926608a7a86d7371$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $926608a7a86d7371$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $926608a7a86d7371$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $926608a7a86d7371$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $acw62.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $acw62.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $acw62.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $926608a7a86d7371$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $926608a7a86d7371$export$e7b0ac011bb776c6) && $926608a7a86d7371$var$invariant(false);
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $926608a7a86d7371$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * The parameters that were parsed from the URL path.
 */ /**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $926608a7a86d7371$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $926608a7a86d7371$var$invariant(false);
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $926608a7a86d7371$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(locationArg) : locationArg;
    let pathname = $926608a7a86d7371$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $926608a7a86d7371$var$flattenRoutes(routes);
    $926608a7a86d7371$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $926608a7a86d7371$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $926608a7a86d7371$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $926608a7a86d7371$var$invariant(false);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $926608a7a86d7371$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $926608a7a86d7371$var$invariant(false);
            $926608a7a86d7371$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $926608a7a86d7371$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $926608a7a86d7371$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $926608a7a86d7371$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $926608a7a86d7371$var$paramRe = /^:\w+$/;
const $926608a7a86d7371$var$dynamicSegmentValue = 3;
const $926608a7a86d7371$var$indexRouteValue = 2;
const $926608a7a86d7371$var$emptySegmentValue = 1;
const $926608a7a86d7371$var$staticSegmentValue = 10;
const $926608a7a86d7371$var$splatPenalty = -2;
const $926608a7a86d7371$var$isSplat = (s)=>s === "*";
function $926608a7a86d7371$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($926608a7a86d7371$var$isSplat)) initialScore += $926608a7a86d7371$var$splatPenalty;
    if (index) initialScore += $926608a7a86d7371$var$indexRouteValue;
    return segments.filter((s)=>!$926608a7a86d7371$var$isSplat(s)).reduce((score, segment)=>score + ($926608a7a86d7371$var$paramRe.test(segment) ? $926608a7a86d7371$var$dynamicSegmentValue : segment === "" ? $926608a7a86d7371$var$emptySegmentValue : $926608a7a86d7371$var$staticSegmentValue), initialScore);
}
function $926608a7a86d7371$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $926608a7a86d7371$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $926608a7a86d7371$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            params: matchedParams,
            pathname: $926608a7a86d7371$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $926608a7a86d7371$var$normalizePathname($926608a7a86d7371$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $926608a7a86d7371$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $926608a7a86d7371$export$daf73786167a7f72(matches) {
    return $926608a7a86d7371$var$_renderMatches(matches);
}
function $926608a7a86d7371$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $acw62.createElement)($926608a7a86d7371$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : outlet,
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $926608a7a86d7371$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $926608a7a86d7371$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $926608a7a86d7371$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $926608a7a86d7371$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $926608a7a86d7371$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $926608a7a86d7371$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $926608a7a86d7371$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $926608a7a86d7371$var$normalizeSearch(search),
        hash: $926608a7a86d7371$var$normalizeHash(hash)
    };
}
function $926608a7a86d7371$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $926608a7a86d7371$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $926608a7a86d7371$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $926608a7a86d7371$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $6d23e34a443a4a03$export$8ccf933b0513f8d0)(to).pathname : to.pathname;
}
function $926608a7a86d7371$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $926608a7a86d7371$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $926608a7a86d7371$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $926608a7a86d7371$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $926608a7a86d7371$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash; ///////////////////////////////////////////////////////////////////////////////


function $0c90f43fc3673aef$var$_extends() {
    $0c90f43fc3673aef$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c90f43fc3673aef$var$_extends.apply(this, arguments);
}
function $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0c90f43fc3673aef$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $0c90f43fc3673aef$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
];
function $0c90f43fc3673aef$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0c90f43fc3673aef$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$719fc203c4e16dee)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0c90f43fc3673aef$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $acw62.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $6d23e34a443a4a03$export$b71fdd3798280242)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0c90f43fc3673aef$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = (0, $acw62.useState)({
        action: history.action,
        location: history.location
    });
    (0, $acw62.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $926608a7a86d7371$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $0c90f43fc3673aef$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $0c90f43fc3673aef$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $acw62.forwardRef)(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref4, rest = $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(_ref4, $0c90f43fc3673aef$var$_excluded);
    let href = (0, $926608a7a86d7371$export$b66bb29c5006f12f)(to);
    let internalOnClick = $0c90f43fc3673aef$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $acw62.createElement)("a", $0c90f43fc3673aef$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $0c90f43fc3673aef$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $acw62.forwardRef)(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $0c90f43fc3673aef$var$_objectWithoutPropertiesLoose(_ref5, $0c90f43fc3673aef$var$_excluded2);
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let path = (0, $926608a7a86d7371$export$e75d2a2d1b3c245b)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $acw62.createElement)($0c90f43fc3673aef$export$a6c7ac8248d6e38a, $0c90f43fc3673aef$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive
    }) : children);
});
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0c90f43fc3673aef$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let path = (0, $926608a7a86d7371$export$e75d2a2d1b3c245b)(to);
    return (0, $acw62.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$0c90f43fc3673aef$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $6d23e34a443a4a03$export$fe53371bee54353d)(location) === (0, $6d23e34a443a4a03$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0c90f43fc3673aef$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = (0, $acw62.useRef)($0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    let searchParams = (0, $acw62.useMemo)(()=>{
        let searchParams = $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    let setSearchParams = (0, $acw62.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0c90f43fc3673aef$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}



var $ayMG0 = parcelRequire("ayMG0");
function $0cc00d6355b1f45f$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $5195cccf2493af96$export$2e2bcd8739ae039() {
    $5195cccf2493af96$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5195cccf2493af96$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");

var $df322d3da36c941f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $df322d3da36c941f$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(document)) === "object" && document.nodeType === 9;
var $df322d3da36c941f$export$2e2bcd8739ae039 = $df322d3da36c941f$export$4e09c449d6c407f7;


var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;


function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $b03e06a37d110f0d$var$plainObjectConstrurctor = {}.constructor;
function $b03e06a37d110f0d$var$cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map($b03e06a37d110f0d$var$cloneStyle);
    if (style.constructor !== $b03e06a37d110f0d$var$plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = $b03e06a37d110f0d$var$cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function $b03e06a37d110f0d$export$56e87122f905fac0(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = $b03e06a37d110f0d$var$cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var $b03e06a37d110f0d$var$join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var $b03e06a37d110f0d$export$5ac341d5e3cf9273 = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += $b03e06a37d110f0d$var$join(value[i], " ");
    }
    else cssValue = $b03e06a37d110f0d$var$join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function $b03e06a37d110f0d$var$getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function $b03e06a37d110f0d$var$indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function $b03e06a37d110f0d$var$toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += $b03e06a37d110f0d$var$indentStr(prop + ":" + space + $b03e06a37d110f0d$export$5ac341d5e3cf9273(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += $b03e06a37d110f0d$var$indentStr(_prop + ":" + space + $b03e06a37d110f0d$export$5ac341d5e3cf9273(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += $b03e06a37d110f0d$var$indentStr(_prop2 + ":" + space + $b03e06a37d110f0d$export$5ac341d5e3cf9273(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return $b03e06a37d110f0d$var$indentStr("" + selector + space + "{" + result, indent) + $b03e06a37d110f0d$var$indentStr("}", indent);
}
var $b03e06a37d110f0d$var$escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var $b03e06a37d110f0d$var$nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var $b03e06a37d110f0d$var$escape = function(str) {
    return $b03e06a37d110f0d$var$nativeEscape ? $b03e06a37d110f0d$var$nativeEscape(str) : str.replace($b03e06a37d110f0d$var$escapeRegex, "\\$1");
};
var $b03e06a37d110f0d$var$BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var $b03e06a37d110f0d$var$StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)), sheet);
            _this.selectorText = "." + $b03e06a37d110f0d$var$escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = $b03e06a37d110f0d$export$5ac341d5e3cf9273(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            allowEmpty: true
        }) : options;
        return $b03e06a37d110f0d$var$toCss(this.selectorText, this.style, opts);
    };
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}($b03e06a37d110f0d$var$BaseStyleRule);
var $b03e06a37d110f0d$var$pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new $b03e06a37d110f0d$var$StyleRule(key, style, options);
    }
};
var $b03e06a37d110f0d$var$defaultToStringOptions = {
    indent: 1,
    children: true
};
var $b03e06a37d110f0d$var$atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var $b03e06a37d110f0d$var$ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match($b03e06a37d110f0d$var$atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new $b03e06a37d110f0d$export$d9da2a13178d3d68((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $b03e06a37d110f0d$var$defaultToStringOptions;
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $b03e06a37d110f0d$var$defaultToStringOptions.indent;
        if (options.children == null) options.children = $b03e06a37d110f0d$var$defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var $b03e06a37d110f0d$var$keyRegExp = /@media|@supports\s+/;
var $b03e06a37d110f0d$var$pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return $b03e06a37d110f0d$var$keyRegExp.test(key) ? new $b03e06a37d110f0d$var$ConditionalRule(key, styles, options) : null;
    }
};
var $b03e06a37d110f0d$var$defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var $b03e06a37d110f0d$var$nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var $b03e06a37d110f0d$var$KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match($b03e06a37d110f0d$var$nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : $b03e06a37d110f0d$var$escape(generateId(this, sheet));
        this.rules = new $b03e06a37d110f0d$export$d9da2a13178d3d68((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $b03e06a37d110f0d$var$defaultToStringOptions$1;
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $b03e06a37d110f0d$var$defaultToStringOptions$1.indent;
        if (options.children == null) options.children = $b03e06a37d110f0d$var$defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var $b03e06a37d110f0d$var$keyRegExp$1 = /@keyframes\s+/;
var $b03e06a37d110f0d$var$refRegExp = /\$([\w-]+)/g;
var $b03e06a37d110f0d$var$findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace($b03e06a37d110f0d$var$refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var $b03e06a37d110f0d$var$replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = $b03e06a37d110f0d$var$findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var $b03e06a37d110f0d$var$pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && $b03e06a37d110f0d$var$keyRegExp$1.test(key) ? new $b03e06a37d110f0d$var$KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) $b03e06a37d110f0d$var$replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) $b03e06a37d110f0d$var$replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return $b03e06a37d110f0d$var$findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return $b03e06a37d110f0d$var$findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var $b03e06a37d110f0d$var$KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            allowEmpty: true
        }) : options;
        return $b03e06a37d110f0d$var$toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}($b03e06a37d110f0d$var$BaseStyleRule);
var $b03e06a37d110f0d$var$pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new $b03e06a37d110f0d$var$KeyframeRule(key, style, options);
        return null;
    }
};
var $b03e06a37d110f0d$var$FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += $b03e06a37d110f0d$var$toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return $b03e06a37d110f0d$var$toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var $b03e06a37d110f0d$var$keyRegExp$2 = /@font-face/;
var $b03e06a37d110f0d$var$pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return $b03e06a37d110f0d$var$keyRegExp$2.test(key) ? new $b03e06a37d110f0d$var$FontFaceRule(key, style, options) : null;
    }
};
var $b03e06a37d110f0d$var$ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return $b03e06a37d110f0d$var$toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var $b03e06a37d110f0d$var$pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new $b03e06a37d110f0d$var$ViewportRule(key, style, options) : null;
    }
};
var $b03e06a37d110f0d$var$SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var $b03e06a37d110f0d$var$keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var $b03e06a37d110f0d$var$pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in $b03e06a37d110f0d$var$keysMap ? new $b03e06a37d110f0d$var$SimpleRule(key, value, options) : null;
    }
};
var $b03e06a37d110f0d$var$plugins = [
    $b03e06a37d110f0d$var$pluginStyleRule,
    $b03e06a37d110f0d$var$pluginConditionalRule,
    $b03e06a37d110f0d$var$pluginKeyframesRule,
    $b03e06a37d110f0d$var$pluginKeyframeRule,
    $b03e06a37d110f0d$var$pluginFontFaceRule,
    $b03e06a37d110f0d$var$pluginViewportRule,
    $b03e06a37d110f0d$var$pluginSimpleRule
];
var $b03e06a37d110f0d$var$defaultUpdateOptions = {
    process: true
};
var $b03e06a37d110f0d$var$forceUpdateOptions = {
    force: true,
    process: true
};
var $b03e06a37d110f0d$export$d9da2a13178d3d68 = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + $b03e06a37d110f0d$var$escape(this.classes[key]);
        var rule = $b03e06a37d110f0d$export$56e87122f905fac0(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof $b03e06a37d110f0d$var$StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof $b03e06a37d110f0d$var$KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof $b03e06a37d110f0d$var$StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof $b03e06a37d110f0d$var$KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = $b03e06a37d110f0d$var$defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, $b03e06a37d110f0d$var$forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, $b03e06a37d110f0d$var$forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var $b03e06a37d110f0d$var$StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new $b03e06a37d110f0d$export$d9da2a13178d3d68(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var $b03e06a37d110f0d$var$PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var $b03e06a37d110f0d$export$bcb2f1d96ff51db3 = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var $b03e06a37d110f0d$export$d1f2fc3a3d47c5af = new $b03e06a37d110f0d$export$bcb2f1d96ff51db3();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var $b03e06a37d110f0d$var$globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var $b03e06a37d110f0d$var$ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if ($b03e06a37d110f0d$var$globalThis$1[$b03e06a37d110f0d$var$ns] == null) $b03e06a37d110f0d$var$globalThis$1[$b03e06a37d110f0d$var$ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var $b03e06a37d110f0d$var$moduleId = $b03e06a37d110f0d$var$globalThis$1[$b03e06a37d110f0d$var$ns]++;
var $b03e06a37d110f0d$var$maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var $b03e06a37d110f0d$export$ddff9cce7c732c82 = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + $b03e06a37d110f0d$var$moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + $b03e06a37d110f0d$var$moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var $b03e06a37d110f0d$var$memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var $b03e06a37d110f0d$var$getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var $b03e06a37d110f0d$var$setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = $b03e06a37d110f0d$export$5ac341d5e3cf9273(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var $b03e06a37d110f0d$var$removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var $b03e06a37d110f0d$var$setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var $b03e06a37d110f0d$var$getHead = $b03e06a37d110f0d$var$memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function $b03e06a37d110f0d$var$findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function $b03e06a37d110f0d$var$findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function $b03e06a37d110f0d$var$findCommentNode(text) {
    var head = $b03e06a37d110f0d$var$getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function $b03e06a37d110f0d$var$findPrevNode(options) {
    var registry = $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = $b03e06a37d110f0d$var$findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = $b03e06a37d110f0d$var$findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = $b03e06a37d110f0d$var$findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function $b03e06a37d110f0d$var$insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = $b03e06a37d110f0d$var$findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    $b03e06a37d110f0d$var$getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var $b03e06a37d110f0d$var$getNonce = $b03e06a37d110f0d$var$memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var $b03e06a37d110f0d$var$_insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var $b03e06a37d110f0d$var$getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var $b03e06a37d110f0d$var$createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var $b03e06a37d110f0d$var$DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = $b03e06a37d110f0d$var$getPropertyValue;
        this.setProperty = $b03e06a37d110f0d$var$setProperty;
        this.removeProperty = $b03e06a37d110f0d$var$removeProperty;
        this.setSelector = $b03e06a37d110f0d$var$setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || $b03e06a37d110f0d$var$createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = $b03e06a37d110f0d$var$getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        $b03e06a37d110f0d$var$insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = $b03e06a37d110f0d$var$getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = $b03e06a37d110f0d$var$_insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = $b03e06a37d110f0d$var$getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = $b03e06a37d110f0d$var$_insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof $b03e06a37d110f0d$var$StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var $b03e06a37d110f0d$var$instanceCounter = 0;
var $b03e06a37d110f0d$var$Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = $b03e06a37d110f0d$var$instanceCounter++;
        this.version = "10.9.2";
        this.plugins = new $b03e06a37d110f0d$var$PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: $b03e06a37d110f0d$export$ddff9cce7c732c82,
            Renderer: (0, $df322d3da36c941f$export$2e2bcd8739ae039) ? $b03e06a37d110f0d$var$DomRenderer : null,
            plugins: []
        };
        this.generateId = $b03e06a37d110f0d$export$ddff9cce7c732c82({
            minify: false
        });
        for(var i = 0; i < $b03e06a37d110f0d$var$plugins.length; i++)this.plugins.use($b03e06a37d110f0d$var$plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.index === 0 ? 0 : $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.index + 1;
        var sheet = new $b03e06a37d110f0d$var$StyleSheet(styles, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = $b03e06a37d110f0d$export$56e87122f905fac0(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var $b03e06a37d110f0d$export$185802fd694ee1f5 = function createJss(options) {
    return new $b03e06a37d110f0d$var$Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var $b03e06a37d110f0d$export$c72bb5031d779271 = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var $b03e06a37d110f0d$export$2305122a7d881dec = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function $b03e06a37d110f0d$export$8558f2aefa046992(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = $b03e06a37d110f0d$export$8558f2aefa046992(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var $b03e06a37d110f0d$var$index = $b03e06a37d110f0d$export$185802fd694ee1f5();
var $b03e06a37d110f0d$export$2e2bcd8739ae039 = $b03e06a37d110f0d$var$index;




function $2e8f358add423b98$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, $5195cccf2493af96$export$2e2bcd8739ae039)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $8971db9eb9bb20fc$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $8971db9eb9bb20fc$export$2e2bcd8739ae039 = $8971db9eb9bb20fc$var$multiKeyStore;



var $lT1cX = parcelRequire("lT1cX");



var $acw62 = parcelRequire("acw62");




/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $cad142f86b77d6d8$var$stateClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
];
function $cad142f86b77d6d8$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = "jss", seed: seed = "" } = options;
    const seedPrefix = seed === "" ? "" : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($cad142f86b77d6d8$var$stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $20a8501e6e2f4912$export$2e2bcd8739ae039] || seed !== "") return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}




var $afea4036e4b96092$var$now = Date.now();
var $afea4036e4b96092$var$fnValuesNs = "fnValues" + $afea4036e4b96092$var$now;
var $afea4036e4b96092$var$fnRuleNs = "fnStyle" + ++$afea4036e4b96092$var$now;
var $afea4036e4b96092$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $b03e06a37d110f0d$export$56e87122f905fac0)(name, {}, options);
            rule[$afea4036e4b96092$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($afea4036e4b96092$var$fnValuesNs in rule || $afea4036e4b96092$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$afea4036e4b96092$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$afea4036e4b96092$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$afea4036e4b96092$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $afea4036e4b96092$export$2e2bcd8739ae039 = $afea4036e4b96092$var$functionPlugin;




var $1917e24186a6046e$var$at = "@global";
var $1917e24186a6046e$var$atPrefix = "@global ";
var $1917e24186a6046e$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $b03e06a37d110f0d$export$d9da2a13178d3d68)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1917e24186a6046e$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1917e24186a6046e$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $1917e24186a6046e$var$separatorRegExp = /\s*,\s*/g;
function $1917e24186a6046e$var$addScope(selector, scope) {
    var parts = selector.split($1917e24186a6046e$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1917e24186a6046e$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
        selector: $1917e24186a6046e$var$addScope(name, rule.selector)
    }));
    delete style[$1917e24186a6046e$var$at];
}
function $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $1917e24186a6046e$var$at.length) !== $1917e24186a6046e$var$at) continue;
        var selector = $1917e24186a6046e$var$addScope(prop.substr($1917e24186a6046e$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1917e24186a6046e$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1917e24186a6046e$var$at) return new $1917e24186a6046e$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $1917e24186a6046e$var$atPrefix.length) === $1917e24186a6046e$var$atPrefix) return new $1917e24186a6046e$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet);
        $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1917e24186a6046e$export$2e2bcd8739ae039 = $1917e24186a6046e$var$jssGlobal;




var $9afd3d12d6cbc635$var$separatorRegExp = /\s*,\s*/g;
var $9afd3d12d6cbc635$var$parentRegExp = /&/g;
var $9afd3d12d6cbc635$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9afd3d12d6cbc635$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($9afd3d12d6cbc635$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($9afd3d12d6cbc635$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $9afd3d12d6cbc635$export$2e2bcd8739ae039 = $9afd3d12d6cbc635$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $cb370b3f4a9491f5$var$uppercasePattern = /[A-Z]/g;
var $cb370b3f4a9491f5$var$msPattern = /^ms-/;
var $cb370b3f4a9491f5$var$cache = {};
function $cb370b3f4a9491f5$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $cb370b3f4a9491f5$var$hyphenateStyleName(name) {
    if ($cb370b3f4a9491f5$var$cache.hasOwnProperty(name)) return $cb370b3f4a9491f5$var$cache[name];
    var hName = name.replace($cb370b3f4a9491f5$var$uppercasePattern, $cb370b3f4a9491f5$var$toHyphenLower);
    return $cb370b3f4a9491f5$var$cache[name] = $cb370b3f4a9491f5$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $cb370b3f4a9491f5$export$2e2bcd8739ae039 = $cb370b3f4a9491f5$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $5e89d92f45e570c6$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $cb370b3f4a9491f5$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($5e89d92f45e570c6$var$convertCase);
        else converted.fallbacks = $5e89d92f45e570c6$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $5e89d92f45e570c6$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $5e89d92f45e570c6$var$convertCase(style[index]);
            return style;
        }
        return $5e89d92f45e570c6$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $cb370b3f4a9491f5$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5e89d92f45e570c6$export$2e2bcd8739ae039 = $5e89d92f45e570c6$var$camelCase;



var $5280ebef38a3c5c6$var$px = (0, $b03e06a37d110f0d$export$2305122a7d881dec) && CSS ? CSS.px : "px";
var $5280ebef38a3c5c6$var$ms = (0, $b03e06a37d110f0d$export$2305122a7d881dec) && CSS ? CSS.ms : "ms";
var $5280ebef38a3c5c6$var$percent = (0, $b03e06a37d110f0d$export$2305122a7d881dec) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $5280ebef38a3c5c6$var$defaultUnits = {
    // Animation properties
    "animation-delay": $5280ebef38a3c5c6$var$ms,
    "animation-duration": $5280ebef38a3c5c6$var$ms,
    // Background properties
    "background-position": $5280ebef38a3c5c6$var$px,
    "background-position-x": $5280ebef38a3c5c6$var$px,
    "background-position-y": $5280ebef38a3c5c6$var$px,
    "background-size": $5280ebef38a3c5c6$var$px,
    // Border Properties
    border: $5280ebef38a3c5c6$var$px,
    "border-bottom": $5280ebef38a3c5c6$var$px,
    "border-bottom-left-radius": $5280ebef38a3c5c6$var$px,
    "border-bottom-right-radius": $5280ebef38a3c5c6$var$px,
    "border-bottom-width": $5280ebef38a3c5c6$var$px,
    "border-left": $5280ebef38a3c5c6$var$px,
    "border-left-width": $5280ebef38a3c5c6$var$px,
    "border-radius": $5280ebef38a3c5c6$var$px,
    "border-right": $5280ebef38a3c5c6$var$px,
    "border-right-width": $5280ebef38a3c5c6$var$px,
    "border-top": $5280ebef38a3c5c6$var$px,
    "border-top-left-radius": $5280ebef38a3c5c6$var$px,
    "border-top-right-radius": $5280ebef38a3c5c6$var$px,
    "border-top-width": $5280ebef38a3c5c6$var$px,
    "border-width": $5280ebef38a3c5c6$var$px,
    "border-block": $5280ebef38a3c5c6$var$px,
    "border-block-end": $5280ebef38a3c5c6$var$px,
    "border-block-end-width": $5280ebef38a3c5c6$var$px,
    "border-block-start": $5280ebef38a3c5c6$var$px,
    "border-block-start-width": $5280ebef38a3c5c6$var$px,
    "border-block-width": $5280ebef38a3c5c6$var$px,
    "border-inline": $5280ebef38a3c5c6$var$px,
    "border-inline-end": $5280ebef38a3c5c6$var$px,
    "border-inline-end-width": $5280ebef38a3c5c6$var$px,
    "border-inline-start": $5280ebef38a3c5c6$var$px,
    "border-inline-start-width": $5280ebef38a3c5c6$var$px,
    "border-inline-width": $5280ebef38a3c5c6$var$px,
    "border-start-start-radius": $5280ebef38a3c5c6$var$px,
    "border-start-end-radius": $5280ebef38a3c5c6$var$px,
    "border-end-start-radius": $5280ebef38a3c5c6$var$px,
    "border-end-end-radius": $5280ebef38a3c5c6$var$px,
    // Margin properties
    margin: $5280ebef38a3c5c6$var$px,
    "margin-bottom": $5280ebef38a3c5c6$var$px,
    "margin-left": $5280ebef38a3c5c6$var$px,
    "margin-right": $5280ebef38a3c5c6$var$px,
    "margin-top": $5280ebef38a3c5c6$var$px,
    "margin-block": $5280ebef38a3c5c6$var$px,
    "margin-block-end": $5280ebef38a3c5c6$var$px,
    "margin-block-start": $5280ebef38a3c5c6$var$px,
    "margin-inline": $5280ebef38a3c5c6$var$px,
    "margin-inline-end": $5280ebef38a3c5c6$var$px,
    "margin-inline-start": $5280ebef38a3c5c6$var$px,
    // Padding properties
    padding: $5280ebef38a3c5c6$var$px,
    "padding-bottom": $5280ebef38a3c5c6$var$px,
    "padding-left": $5280ebef38a3c5c6$var$px,
    "padding-right": $5280ebef38a3c5c6$var$px,
    "padding-top": $5280ebef38a3c5c6$var$px,
    "padding-block": $5280ebef38a3c5c6$var$px,
    "padding-block-end": $5280ebef38a3c5c6$var$px,
    "padding-block-start": $5280ebef38a3c5c6$var$px,
    "padding-inline": $5280ebef38a3c5c6$var$px,
    "padding-inline-end": $5280ebef38a3c5c6$var$px,
    "padding-inline-start": $5280ebef38a3c5c6$var$px,
    // Mask properties
    "mask-position-x": $5280ebef38a3c5c6$var$px,
    "mask-position-y": $5280ebef38a3c5c6$var$px,
    "mask-size": $5280ebef38a3c5c6$var$px,
    // Width and height properties
    height: $5280ebef38a3c5c6$var$px,
    width: $5280ebef38a3c5c6$var$px,
    "min-height": $5280ebef38a3c5c6$var$px,
    "max-height": $5280ebef38a3c5c6$var$px,
    "min-width": $5280ebef38a3c5c6$var$px,
    "max-width": $5280ebef38a3c5c6$var$px,
    // Position properties
    bottom: $5280ebef38a3c5c6$var$px,
    left: $5280ebef38a3c5c6$var$px,
    top: $5280ebef38a3c5c6$var$px,
    right: $5280ebef38a3c5c6$var$px,
    inset: $5280ebef38a3c5c6$var$px,
    "inset-block": $5280ebef38a3c5c6$var$px,
    "inset-block-end": $5280ebef38a3c5c6$var$px,
    "inset-block-start": $5280ebef38a3c5c6$var$px,
    "inset-inline": $5280ebef38a3c5c6$var$px,
    "inset-inline-end": $5280ebef38a3c5c6$var$px,
    "inset-inline-start": $5280ebef38a3c5c6$var$px,
    // Shadow properties
    "box-shadow": $5280ebef38a3c5c6$var$px,
    "text-shadow": $5280ebef38a3c5c6$var$px,
    // Column properties
    "column-gap": $5280ebef38a3c5c6$var$px,
    "column-rule": $5280ebef38a3c5c6$var$px,
    "column-rule-width": $5280ebef38a3c5c6$var$px,
    "column-width": $5280ebef38a3c5c6$var$px,
    // Font and text properties
    "font-size": $5280ebef38a3c5c6$var$px,
    "font-size-delta": $5280ebef38a3c5c6$var$px,
    "letter-spacing": $5280ebef38a3c5c6$var$px,
    "text-decoration-thickness": $5280ebef38a3c5c6$var$px,
    "text-indent": $5280ebef38a3c5c6$var$px,
    "text-stroke": $5280ebef38a3c5c6$var$px,
    "text-stroke-width": $5280ebef38a3c5c6$var$px,
    "word-spacing": $5280ebef38a3c5c6$var$px,
    // Motion properties
    motion: $5280ebef38a3c5c6$var$px,
    "motion-offset": $5280ebef38a3c5c6$var$px,
    // Outline properties
    outline: $5280ebef38a3c5c6$var$px,
    "outline-offset": $5280ebef38a3c5c6$var$px,
    "outline-width": $5280ebef38a3c5c6$var$px,
    // Perspective properties
    perspective: $5280ebef38a3c5c6$var$px,
    "perspective-origin-x": $5280ebef38a3c5c6$var$percent,
    "perspective-origin-y": $5280ebef38a3c5c6$var$percent,
    // Transform properties
    "transform-origin": $5280ebef38a3c5c6$var$percent,
    "transform-origin-x": $5280ebef38a3c5c6$var$percent,
    "transform-origin-y": $5280ebef38a3c5c6$var$percent,
    "transform-origin-z": $5280ebef38a3c5c6$var$percent,
    // Transition properties
    "transition-delay": $5280ebef38a3c5c6$var$ms,
    "transition-duration": $5280ebef38a3c5c6$var$ms,
    // Alignment properties
    "vertical-align": $5280ebef38a3c5c6$var$px,
    "flex-basis": $5280ebef38a3c5c6$var$px,
    // Some random properties
    "shape-margin": $5280ebef38a3c5c6$var$px,
    size: $5280ebef38a3c5c6$var$px,
    gap: $5280ebef38a3c5c6$var$px,
    // Grid properties
    grid: $5280ebef38a3c5c6$var$px,
    "grid-gap": $5280ebef38a3c5c6$var$px,
    "row-gap": $5280ebef38a3c5c6$var$px,
    "grid-row-gap": $5280ebef38a3c5c6$var$px,
    "grid-column-gap": $5280ebef38a3c5c6$var$px,
    "grid-template-rows": $5280ebef38a3c5c6$var$px,
    "grid-template-columns": $5280ebef38a3c5c6$var$px,
    "grid-auto-rows": $5280ebef38a3c5c6$var$px,
    "grid-auto-columns": $5280ebef38a3c5c6$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $5280ebef38a3c5c6$var$px,
    "box-shadow-y": $5280ebef38a3c5c6$var$px,
    "box-shadow-blur": $5280ebef38a3c5c6$var$px,
    "box-shadow-spread": $5280ebef38a3c5c6$var$px,
    "font-line-height": $5280ebef38a3c5c6$var$px,
    "text-shadow-x": $5280ebef38a3c5c6$var$px,
    "text-shadow-y": $5280ebef38a3c5c6$var$px,
    "text-shadow-blur": $5280ebef38a3c5c6$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $5280ebef38a3c5c6$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $5280ebef38a3c5c6$var$units = $5280ebef38a3c5c6$var$addCamelCasedVersion($5280ebef38a3c5c6$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $5280ebef38a3c5c6$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $5280ebef38a3c5c6$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $5280ebef38a3c5c6$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $5280ebef38a3c5c6$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $5280ebef38a3c5c6$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $5280ebef38a3c5c6$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $5280ebef38a3c5c6$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $5280ebef38a3c5c6$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $5280ebef38a3c5c6$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $5280ebef38a3c5c6$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5280ebef38a3c5c6$export$2e2bcd8739ae039 = $5280ebef38a3c5c6$var$defaultUnit;



function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $0b14cdf9ea25e36f$var$js = "";
var $0b14cdf9ea25e36f$var$css = "";
var $0b14cdf9ea25e36f$var$vendor = "";
var $0b14cdf9ea25e36f$var$browser = "";
var $0b14cdf9ea25e36f$var$isTouch = (0, $df322d3da36c941f$export$2e2bcd8739ae039) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $df322d3da36c941f$export$2e2bcd8739ae039) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $0b14cdf9ea25e36f$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $0b14cdf9ea25e36f$var$_document$createEleme = document.createElement("p"), $0b14cdf9ea25e36f$var$style = $0b14cdf9ea25e36f$var$_document$createEleme.style;
    var $0b14cdf9ea25e36f$var$testProp = "Transform";
    for(var $0b14cdf9ea25e36f$var$key in $0b14cdf9ea25e36f$var$jsCssMap)if ($0b14cdf9ea25e36f$var$key + $0b14cdf9ea25e36f$var$testProp in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = $0b14cdf9ea25e36f$var$key;
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap[$0b14cdf9ea25e36f$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($0b14cdf9ea25e36f$var$js === "Webkit" && "msHyphens" in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = "ms";
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap.ms;
        $0b14cdf9ea25e36f$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($0b14cdf9ea25e36f$var$js === "Webkit" && "-apple-trailing-word" in $0b14cdf9ea25e36f$var$style) $0b14cdf9ea25e36f$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $0b14cdf9ea25e36f$export$82e9f45cca5ba907 = {
    js: $0b14cdf9ea25e36f$var$js,
    css: $0b14cdf9ea25e36f$var$css,
    vendor: $0b14cdf9ea25e36f$var$vendor,
    browser: $0b14cdf9ea25e36f$var$browser,
    isTouch: $0b14cdf9ea25e36f$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $0b14cdf9ea25e36f$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $0b14cdf9ea25e36f$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $0b14cdf9ea25e36f$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$camelize(str) {
    return str.replace($0b14cdf9ea25e36f$var$regExp, $0b14cdf9ea25e36f$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$pascalize(str) {
    return $0b14cdf9ea25e36f$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $0b14cdf9ea25e36f$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($0b14cdf9ea25e36f$var$camelize(longhand) in style) return prop;
            if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(longhand) in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $0b14cdf9ea25e36f$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === "apple" && !$0b14cdf9ea25e36f$export$82e9f45cca5ba907.isTouch) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $0b14cdf9ea25e36f$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $0b14cdf9ea25e36f$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $0b14cdf9ea25e36f$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms" && $0b14cdf9ea25e36f$export$82e9f45cca5ba907.browser !== "edge") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $0b14cdf9ea25e36f$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === "apple") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $0b14cdf9ea25e36f$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return jsProp in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $0b14cdf9ea25e36f$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $0b14cdf9ea25e36f$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $0b14cdf9ea25e36f$var$camelize(prop) in style ? prop : false;
    }
};
var $0b14cdf9ea25e36f$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $0b14cdf9ea25e36f$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + pascalized in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $0b14cdf9ea25e36f$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return "" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $0b14cdf9ea25e36f$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $0b14cdf9ea25e36f$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $0b14cdf9ea25e36f$var$propMap[prop];
        if (!newProp) return false;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $0b14cdf9ea25e36f$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $0b14cdf9ea25e36f$var$propKeys = Object.keys($0b14cdf9ea25e36f$var$propMap$1);
var $0b14cdf9ea25e36f$var$prefixCss = function prefixCss(p) {
    return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $0b14cdf9ea25e36f$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($0b14cdf9ea25e36f$var$propKeys.indexOf(prop) > -1) {
            var newProp = $0b14cdf9ea25e36f$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($0b14cdf9ea25e36f$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $0b14cdf9ea25e36f$var$plugins = [
    $0b14cdf9ea25e36f$var$appearence,
    $0b14cdf9ea25e36f$var$colorAdjust,
    $0b14cdf9ea25e36f$var$mask,
    $0b14cdf9ea25e36f$var$textOrientation,
    $0b14cdf9ea25e36f$var$transform,
    $0b14cdf9ea25e36f$var$transition,
    $0b14cdf9ea25e36f$var$writingMode,
    $0b14cdf9ea25e36f$var$userSelect,
    $0b14cdf9ea25e36f$var$breakPropsOld,
    $0b14cdf9ea25e36f$var$inlineLogicalOld,
    $0b14cdf9ea25e36f$var$unprefixed,
    $0b14cdf9ea25e36f$var$prefixed,
    $0b14cdf9ea25e36f$var$scrollSnap,
    $0b14cdf9ea25e36f$var$overscrollBehavior,
    $0b14cdf9ea25e36f$var$flex2012,
    $0b14cdf9ea25e36f$var$flex2009
];
var $0b14cdf9ea25e36f$var$propertyDetectors = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $0b14cdf9ea25e36f$var$noPrefill = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $0b14cdf9ea25e36f$var$el;
var $0b14cdf9ea25e36f$var$cache = {};
if (0, $df322d3da36c941f$export$2e2bcd8739ae039) {
    $0b14cdf9ea25e36f$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $0b14cdf9ea25e36f$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $0b14cdf9ea25e36f$var$key$1 in $0b14cdf9ea25e36f$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($0b14cdf9ea25e36f$var$key$1)) $0b14cdf9ea25e36f$var$cache[$0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1]] = $0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $0b14cdf9ea25e36f$var$noPrefill.forEach(function(x) {
        return delete $0b14cdf9ea25e36f$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$0b14cdf9ea25e36f$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($0b14cdf9ea25e36f$var$cache[prop] != null) return $0b14cdf9ea25e36f$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $0b14cdf9ea25e36f$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $0b14cdf9ea25e36f$var$propertyDetectors.length; i++){
        $0b14cdf9ea25e36f$var$cache[prop] = $0b14cdf9ea25e36f$var$propertyDetectors[i](prop, $0b14cdf9ea25e36f$var$el.style, options); // Break loop, if value found.
        if ($0b14cdf9ea25e36f$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $0b14cdf9ea25e36f$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $0b14cdf9ea25e36f$var$cache[prop];
}
var $0b14cdf9ea25e36f$var$cache$1 = {};
var $0b14cdf9ea25e36f$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $0b14cdf9ea25e36f$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $0b14cdf9ea25e36f$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p1) : ", " + $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $df322d3da36c941f$export$2e2bcd8739ae039) $0b14cdf9ea25e36f$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$0b14cdf9ea25e36f$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($0b14cdf9ea25e36f$var$cache$1[cacheKey] != null) return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($0b14cdf9ea25e36f$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($0b14cdf9ea25e36f$var$transPropsRegExp, $0b14cdf9ea25e36f$var$prefixTransitionCallback);
    else if ($0b14cdf9ea25e36f$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $0b14cdf9ea25e36f$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($0b14cdf9ea25e36f$var$el$1.style[property] === "") {
            $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $0b14cdf9ea25e36f$var$el$1.style[property] = ""; // Write current value to cache.
    $0b14cdf9ea25e36f$var$cache$1[cacheKey] = prefixedValue;
    return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
}



/**
 * Add vendor prefix to a property name when needed.
 */ function $5d87dec9ac2db100$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $0b14cdf9ea25e36f$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $0b14cdf9ea25e36f$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $0b14cdf9ea25e36f$export$511766124059c277)(supportedProp, (0, $b03e06a37d110f0d$export$5ac341d5e3cf9273)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $0b14cdf9ea25e36f$export$511766124059c277)(prop, (0, $b03e06a37d110f0d$export$5ac341d5e3cf9273)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5d87dec9ac2db100$export$2e2bcd8739ae039 = $5d87dec9ac2db100$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $2d5851d4b913d01d$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $2d5851d4b913d01d$export$2e2bcd8739ae039 = $2d5851d4b913d01d$var$jssPropsSort;


function $089369f56021741c$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $afea4036e4b96092$export$2e2bcd8739ae039)(),
            (0, $1917e24186a6046e$export$2e2bcd8739ae039)(),
            (0, $9afd3d12d6cbc635$export$2e2bcd8739ae039)(),
            (0, $5e89d92f45e570c6$export$2e2bcd8739ae039)(),
            (0, $5280ebef38a3c5c6$export$2e2bcd8739ae039)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $5d87dec9ac2db100$export$2e2bcd8739ae039)(),
            (0, $2d5851d4b913d01d$export$2e2bcd8739ae039)()
        ]
    };
}



var $ayMG0 = parcelRequire("ayMG0");
const $66c47682defefc53$var$_excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const $66c47682defefc53$var$defaultJSS = (0, $b03e06a37d110f0d$export$185802fd694ee1f5)((0, $089369f56021741c$export$2e2bcd8739ae039)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $66c47682defefc53$var$defaultGenerateClassName = (0, $cad142f86b77d6d8$export$2e2bcd8739ae039)();
const $66c47682defefc53$export$70a8aea9ff58d1cd = new Map();
const $66c47682defefc53$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $66c47682defefc53$var$defaultGenerateClassName,
    jss: $66c47682defefc53$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $66c47682defefc53$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $66c47682defefc53$export$f4de434b269fe487 = /*#__PURE__*/ $acw62.createContext($66c47682defefc53$var$defaultOptions);
let $66c47682defefc53$var$injectFirstNode;
function $66c47682defefc53$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false } = props, localOptions = (0, $0cc00d6355b1f45f$export$2e2bcd8739ae039)(props, $66c47682defefc53$var$_excluded);
    const outerOptions = $acw62.useContext($66c47682defefc53$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = (0, $5195cccf2493af96$export$2e2bcd8739ae039)({}, outerOptions, localOptions);
    const value = $acw62.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
            if (!$66c47682defefc53$var$injectFirstNode) {
                const head = document.head;
                $66c47682defefc53$var$injectFirstNode = document.createComment("mui-inject-first");
                head.insertBefore($66c47682defefc53$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $b03e06a37d110f0d$export$185802fd694ee1f5)({
                plugins: (0, $089369f56021741c$export$2e2bcd8739ae039)().plugins,
                insertionPoint: $66c47682defefc53$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($66c47682defefc53$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}


/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $6d8d47425bc40907$var$indexCounter = -1000000000;
function $6d8d47425bc40907$export$a2647aa13413c947() {
    $6d8d47425bc40907$var$indexCounter += 1;
    return $6d8d47425bc40907$var$indexCounter;
}




var $17r9Q = parcelRequire("17r9Q");


var $6IaFk = parcelRequire("6IaFk");
const $f5489d1d50f78a43$var$_excluded = [
    "variant"
];
function $f5489d1d50f78a43$var$isEmpty(string) {
    return string.length === 0;
}
function $f5489d1d50f78a43$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $0cc00d6355b1f45f$export$2e2bcd8739ae039)(props, $f5489d1d50f78a43$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $f5489d1d50f78a43$var$isEmpty(classKey) ? props[key] : (0, $6IaFk.default)(props[key]);
        else classKey += `${$f5489d1d50f78a43$var$isEmpty(classKey) ? key : (0, $6IaFk.default)(key)}${(0, $6IaFk.default)(props[key].toString())}`;
    });
    return classKey;
}



function $afb35a18e8b17e0a$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, $5195cccf2493af96$export$2e2bcd8739ae039)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $17r9Q.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $f5489d1d50f78a43$export$2e2bcd8739ae039)(definition.props);
                stylesWithOverrides[classKey] = (0, $17r9Q.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
const $41ce589cb6180c8f$var$noopTheme = {};
var $41ce589cb6180c8f$export$2e2bcd8739ae039 = $41ce589cb6180c8f$var$noopTheme;


const $13a9e1ccd58618d1$var$_excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function $13a9e1ccd58618d1$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $2e8f358add423b98$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $13a9e1ccd58618d1$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $8971db9eb9bb20fc$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $8971db9eb9bb20fc$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, $5195cccf2493af96$export$2e2bcd8739ae039)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $8971db9eb9bb20fc$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $5195cccf2493af96$export$2e2bcd8739ae039)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $8971db9eb9bb20fc$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $b03e06a37d110f0d$export$8558f2aefa046992)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $5195cccf2493af96$export$2e2bcd8739ae039)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $2e8f358add423b98$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $13a9e1ccd58618d1$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $13a9e1ccd58618d1$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $8971db9eb9bb20fc$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $8971db9eb9bb20fc$export$2e2bcd8739ae039).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $13a9e1ccd58618d1$var$useSynchronousEffect(func, values) {
    const key = $acw62.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = $acw62.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $acw62.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $13a9e1ccd58618d1$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $41ce589cb6180c8f$export$2e2bcd8739ae039) } = options, stylesOptions2 = (0, $0cc00d6355b1f45f$export$2e2bcd8739ae039)(options, $13a9e1ccd58618d1$var$_excluded);
    const stylesCreator = (0, $afb35a18e8b17e0a$export$2e2bcd8739ae039)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $6d8d47425bc40907$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $lT1cX.default)() || defaultTheme;
        const stylesOptions = (0, $5195cccf2493af96$export$2e2bcd8739ae039)({}, $acw62.useContext((0, $66c47682defefc53$export$f4de434b269fe487)), stylesOptions2);
        const instance = $acw62.useRef();
        const shouldUpdate = $acw62.useRef();
        $13a9e1ccd58618d1$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $13a9e1ccd58618d1$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $13a9e1ccd58618d1$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $acw62.useEffect(()=>{
            if (shouldUpdate.current) $13a9e1ccd58618d1$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $13a9e1ccd58618d1$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}


parcelRequire("acw62");
var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $bf2dbd940d8d1ee7$exports(arr) || $efa3fde0b6100532$exports(arr, i) || $51f08ebed50a2438$exports(arr, i) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $bb7ca61ce45563c4$exports = {};
function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



var $acw62 = parcelRequire("acw62");
var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};
function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;




var $acw62 = parcelRequire("acw62");
var $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $d7f2d92b0368699f$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $d7f2d92b0368699f$var$htmlEntities[m];
};
var $d7f2d92b0368699f$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);
};


function $0636c84fe4549f1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0636c84fe4549f1f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0636c84fe4549f1f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0636c84fe4549f1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0636c84fe4549f1f$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $d7f2d92b0368699f$export$e8bacd2802a88316)
};
var $0636c84fe4549f1f$var$i18nInstance;
var $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
function $0636c84fe4549f1f$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $0636c84fe4549f1f$var$defaultOptions = $0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, $0636c84fe4549f1f$var$defaultOptions), options);
}
function $0636c84fe4549f1f$export$212bb2fc580a90a8() {
    return $0636c84fe4549f1f$var$defaultOptions;
}
var $0636c84fe4549f1f$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $0636c84fe4549f1f$export$a039134f2fc7e0(instance) {
    $0636c84fe4549f1f$var$i18nInstance = instance;
}
function $0636c84fe4549f1f$export$64af334f494c2f47() {
    return $0636c84fe4549f1f$var$i18nInstance;
}
var $0636c84fe4549f1f$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $0636c84fe4549f1f$export$2e2366488d12e20d(instance.options.react);
        $0636c84fe4549f1f$export$a039134f2fc7e0(instance);
    }
};
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    var i18n = $0636c84fe4549f1f$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $3765cebd031b52c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3765cebd031b52c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3765cebd031b52c0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3765cebd031b52c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3765cebd031b52c0$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $0636c84fe4549f1f$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread({}, (0, $0636c84fe4549f1f$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $acw62.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    var isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $gUrmH = parcelRequire("gUrmH");

var $kEIch = parcelRequire("kEIch");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $bOOlK = parcelRequire("bOOlK");

var $9dZwz = parcelRequire("9dZwz");
var $gUrmH = parcelRequire("gUrmH");

var $kEIch = parcelRequire("kEIch");

var $17r9Q = parcelRequire("17r9Q");

var $7XUPs = parcelRequire("7XUPs");
const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ((0, $7XUPs.propToStyleFunction)[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $kEIch.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $17r9Q.isPlainObject)(result)) return systemProps;
        return (0, $gUrmH.default)({}, systemProps, result);
    };
    else finalSx = (0, $gUrmH.default)({}, systemProps, inSx);
    return (0, $gUrmH.default)({}, otherProps, {
        sx: finalSx
    });
}



var $7HKeb = parcelRequire("7HKeb");

var $ayMG0 = parcelRequire("ayMG0");
const $b85125360b778ad2$var$_excluded = [
    "className",
    "component"
];
function $b85125360b778ad2$export$2e2bcd8739ae039(options = {}) {
    const { defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName, styleFunctionSx: styleFunctionSx = (0, $9dZwz.default) } = options;
    const BoxRoot = (0, $bOOlK.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })(styleFunctionSx);
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $7HKeb.default)(defaultTheme);
        const _extendSxProp = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $kEIch.default)(_extendSxProp, $b85125360b778ad2$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $gUrmH.default)({
            as: component,
            ref: ref,
            className: (0, $1SA7b.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: theme
        }, other));
    });
    return Box;
}




var $bnost = parcelRequire("bnost");

var $2rLZY = parcelRequire("2rLZY");
const $ed0dc78f73685bb9$var$defaultTheme = (0, $2rLZY.default)();
const $ed0dc78f73685bb9$var$Box = (0, $b85125360b778ad2$export$2e2bcd8739ae039)({
    defaultTheme: $ed0dc78f73685bb9$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $bnost.default).generate
});
var $ed0dc78f73685bb9$export$2e2bcd8739ae039 = $ed0dc78f73685bb9$var$Box;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $3OJTQ = parcelRequire("3OJTQ");

var $8Indx = parcelRequire("8Indx");


var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");
parcelRequire("acw62");

var $7HKeb = parcelRequire("7HKeb");

var $e7sAA = parcelRequire("e7sAA");
function $81976569638fc3b7$export$2e2bcd8739ae039() {
    const theme = (0, $7HKeb.default)((0, $e7sAA.default));
    return theme;
}



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $d3fa2a4e6f2666df$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $d3fa2a4e6f2666df$export$2e2bcd8739ae039 = $d3fa2a4e6f2666df$var$GridContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bce8e74876a44ba8$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)("MuiGrid", slot);
}
const $bce8e74876a44ba8$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $bce8e74876a44ba8$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $bce8e74876a44ba8$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $bce8e74876a44ba8$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $bce8e74876a44ba8$var$gridClasses = (0, $beCSm.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$bce8e74876a44ba8$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$bce8e74876a44ba8$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$bce8e74876a44ba8$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$bce8e74876a44ba8$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$bce8e74876a44ba8$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$bce8e74876a44ba8$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$bce8e74876a44ba8$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$bce8e74876a44ba8$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $bce8e74876a44ba8$export$2e2bcd8739ae039 = $bce8e74876a44ba8$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $a2c903eb2263b589$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $a2c903eb2263b589$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $a2c903eb2263b589$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $3OJTQ.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$a2c903eb2263b589$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $e8gS1.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $a2c903eb2263b589$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3OJTQ.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3OJTQ.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $bce8e74876a44ba8$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $a2c903eb2263b589$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $a2c903eb2263b589$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $a2c903eb2263b589$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$a2c903eb2263b589$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $bce8e74876a44ba8$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $a2c903eb2263b589$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $bce8e74876a44ba8$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $a2c903eb2263b589$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3OJTQ.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $a2c903eb2263b589$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3OJTQ.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$a2c903eb2263b589$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$a2c903eb2263b589$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $bce8e74876a44ba8$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $a2c903eb2263b589$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $bce8e74876a44ba8$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $a2c903eb2263b589$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $a2c903eb2263b589$var$GridRoot = (0, $1Ikg4.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $a2c903eb2263b589$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $a2c903eb2263b589$export$71d4225eeb1bc13e, $a2c903eb2263b589$export$380604d7c79f9e8f, $a2c903eb2263b589$export$4315fba5128fb4a1, $a2c903eb2263b589$export$ca2a698f6020fda);
function $a2c903eb2263b589$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $a2c903eb2263b589$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $a2c903eb2263b589$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bce8e74876a44ba8$export$9973ac5fd0181f33), classes);
};
const $a2c903eb2263b589$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const props = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1sz44.default)(props, $a2c903eb2263b589$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $d3fa2a4e6f2666df$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $e8gS1.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $a2c903eb2263b589$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3fa2a4e6f2666df$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a2c903eb2263b589$var$GridRoot, (0, $e8gS1.default)({
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $a2c903eb2263b589$export$2e2bcd8739ae039 = $a2c903eb2263b589$var$Grid;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $acw62 = parcelRequire("acw62");
let $04d6f011ad19b2fc$var$hadKeyboardEvent = true;
let $04d6f011ad19b2fc$var$hadFocusVisibleRecently = false;
let $04d6f011ad19b2fc$var$hadFocusVisibleRecentlyTimeout;
const $04d6f011ad19b2fc$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $04d6f011ad19b2fc$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $04d6f011ad19b2fc$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $04d6f011ad19b2fc$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $04d6f011ad19b2fc$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $04d6f011ad19b2fc$var$handlePointerDown() {
    $04d6f011ad19b2fc$var$hadKeyboardEvent = false;
}
function $04d6f011ad19b2fc$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($04d6f011ad19b2fc$var$hadFocusVisibleRecently) $04d6f011ad19b2fc$var$hadKeyboardEvent = true;
    }
}
function $04d6f011ad19b2fc$var$prepare(doc) {
    doc.addEventListener("keydown", $04d6f011ad19b2fc$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $04d6f011ad19b2fc$var$handleVisibilityChange, true);
}
function $04d6f011ad19b2fc$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $04d6f011ad19b2fc$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $04d6f011ad19b2fc$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $04d6f011ad19b2fc$var$handleVisibilityChange, true);
}
function $04d6f011ad19b2fc$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $04d6f011ad19b2fc$var$hadKeyboardEvent || $04d6f011ad19b2fc$var$focusTriggersKeyboardModality(target);
}
function $04d6f011ad19b2fc$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $04d6f011ad19b2fc$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $04d6f011ad19b2fc$var$hadFocusVisibleRecently = true;
            window.clearTimeout($04d6f011ad19b2fc$var$hadFocusVisibleRecentlyTimeout);
            $04d6f011ad19b2fc$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $04d6f011ad19b2fc$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($04d6f011ad19b2fc$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $e40fc9424df4cf9c$export$2e2bcd8739ae039 = (0, $04d6f011ad19b2fc$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $a5536215dd353a4e$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $6fd6e1f605afb988$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $0a9974d6176bfa01$export$2e2bcd8739ae039 = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039);



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e9163c6dd169139$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)("MuiTypography", slot);
}
const $6e9163c6dd169139$var$typographyClasses = (0, $beCSm.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $6e9163c6dd169139$export$2e2bcd8739ae039 = $6e9163c6dd169139$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $5ca16cb6e72a53f1$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $5ca16cb6e72a53f1$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $3AM7p.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e9163c6dd169139$export$24c1f8f60cbac79e), classes);
};
const $5ca16cb6e72a53f1$export$140e2f5526d3cad8 = (0, $1Ikg4.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $3AM7p.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $5ca16cb6e72a53f1$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $5ca16cb6e72a53f1$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $5ca16cb6e72a53f1$var$transformDeprecatedColors = (color)=>{
    return $5ca16cb6e72a53f1$var$colorTransformations[color] || color;
};
const $5ca16cb6e72a53f1$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $5ca16cb6e72a53f1$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)((0, $e8gS1.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $5ca16cb6e72a53f1$var$defaultVariantMapping } = props, other = (0, $1sz44.default)(props, $5ca16cb6e72a53f1$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $5ca16cb6e72a53f1$var$defaultVariantMapping[variant]) || "span";
    const classes = $5ca16cb6e72a53f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5ca16cb6e72a53f1$export$140e2f5526d3cad8, (0, $e8gS1.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other));
});
var $5ca16cb6e72a53f1$export$2e2bcd8739ae039 = $5ca16cb6e72a53f1$var$Typography;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $884f3676036e9695$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)("MuiLink", slot);
}
const $884f3676036e9695$var$linkClasses = (0, $beCSm.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $884f3676036e9695$export$2e2bcd8739ae039 = $884f3676036e9695$var$linkClasses;



var $jgarO = parcelRequire("jgarO");
var $k0igC = parcelRequire("k0igC");
const $ad0717f3ca2b2499$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $ad0717f3ca2b2499$var$transformDeprecatedColors = (color)=>{
    return $ad0717f3ca2b2499$export$c4e140d5d351182b[color] || color;
};
const $ad0717f3ca2b2499$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $ad0717f3ca2b2499$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $k0igC.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $k0igC.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $jgarO.alpha)(color, 0.4);
};
var $ad0717f3ca2b2499$export$2e2bcd8739ae039 = $ad0717f3ca2b2499$var$getTextDecoration;



var $ayMG0 = parcelRequire("ayMG0");
const $b7fbb59cc24be7e9$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $b7fbb59cc24be7e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $3AM7p.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $884f3676036e9695$export$d6efab9620b78fec), classes);
};
const $b7fbb59cc24be7e9$var$LinkRoot = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $3AM7p.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $e8gS1.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $e8gS1.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $ad0717f3ca2b2499$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $884f3676036e9695$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $b7fbb59cc24be7e9$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $1sz44.default)(props, $b7fbb59cc24be7e9$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $e40fc9424df4cf9c$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handlerRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $b7fbb59cc24be7e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b7fbb59cc24be7e9$var$LinkRoot, (0, $e8gS1.default)({
        color: color,
        className: (0, $1SA7b.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $ad0717f3ca2b2499$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $b7fbb59cc24be7e9$export$2e2bcd8739ae039 = $b7fbb59cc24be7e9$var$Link;



parcelRequire("acw62");
var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(obj);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;




var $acw62 = parcelRequire("acw62");
var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;




var $e04d9533328ca578$var$_excluded = [
    "format"
], $e04d9533328ca578$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $e04d9533328ca578$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e04d9533328ca578$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e04d9533328ca578$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e04d9533328ca578$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e04d9533328ca578$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $e04d9533328ca578$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $e04d9533328ca578$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $acw62.isValidElement)(child);
    });
}
function $e04d9533328ca578$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $e04d9533328ca578$var$mergeProps(source, target) {
    var newTarget = $e04d9533328ca578$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $e04d9533328ca578$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $e04d9533328ca578$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $acw62.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $e04d9533328ca578$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(child, $e04d9533328ca578$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $e04d9533328ca578$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $e04d9533328ca578$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($e04d9533328ca578$var$hasChildren(child)) getData($e04d9533328ca578$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object" && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $e04d9533328ca578$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $e04d9533328ca578$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $e04d9533328ca578$var$getAsArray(reactNode);
        var astNodes = $e04d9533328ca578$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $e04d9533328ca578$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $acw62.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $e04d9533328ca578$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($e04d9533328ca578$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $e04d9533328ca578$var$getAsArray(children || []));
    return $e04d9533328ca578$var$getChildren(result[0]);
}
function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $e04d9533328ca578$var$_excluded2);
    var _ref2 = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $0636c84fe4549f1f$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, (0, $0636c84fe4549f1f$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $e04d9533328ca578$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $e04d9533328ca578$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



const $4155b23599949a13$var$useBreakpoints = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        appTitle: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        desktopHeader: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        appBar: {
            [theme.breakpoints.up("md")]: {
                display: "none !important"
            },
            flex: 0
        },
        formActions: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        layout: {
            height: "100%",
            [theme.breakpoints.up("md")]: {
                flex: 1,
                height: "auto"
            }
        },
        routes: {
            height: "100%",
            [theme.breakpoints.up("md")]: {
                paddingLeft: theme.spacing(12),
                paddingRight: theme.spacing(12)
            }
        },
        stepper: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        footer: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        mobilePrintButton: {
            [theme.breakpoints.up("md")]: {
                display: "none"
            }
        }
    }));
var $4155b23599949a13$export$2e2bcd8739ae039 = $4155b23599949a13$var$useBreakpoints;


function $d47ca00e0d20c7c7$export$2e2bcd8739ae039({ sticky: sticky }) {
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: breakpoints.footer,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d47ca00e0d20c7c7$export$5ec89def58de9ac8, {
            sticky: sticky,
            firstColumnLinks: [
                {
                    text: "footer.saavutettavuus",
                    href: "/saavutettavuus"
                },
                {
                    text: "footer.tietosuoja",
                    href: "https://www.luke.fi/fi/tietosuoja"
                }
            ],
            secondColumnLinks: [
                {
                    text: "footer.sato"
                },
                {
                    text: "footer.peruna"
                }
            ]
        })
    });
}
const $d47ca00e0d20c7c7$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        box: {
            position: "relative",
            right: 0,
            left: 0,
            bottom: 0,
            backgroundColor: "#F1F4F9",
            [theme.breakpoints.down("sm")]: {
                position: "relative"
            }
        },
        sticky: {
            position: "absolute",
            [theme.breakpoints.down("sm")]: {
                position: "absolute"
            },
            [theme.breakpoints.down("xs")]: {
                position: "relative"
            }
        },
        link: {
            color: "black",
            textDecoration: "underline"
        },
        links: {
            [theme.breakpoints.down("xs")]: {
                textAlign: "center"
            }
        },
        linksRight: {
            [theme.breakpoints.down("sm")]: {
                textAlign: "right"
            },
            [theme.breakpoints.down("xs")]: {
                textAlign: "center"
            }
        },
        copyright: {
            textAlign: "right",
            [theme.breakpoints.down("sm")]: {
                textAlign: "center",
                paddingTop: theme.spacing(2)
            }
        }
    }));
function $d47ca00e0d20c7c7$export$5ec89def58de9ac8({ sticky: sticky, firstColumnLinks: firstColumnLinks, secondColumnLinks: secondColumnLinks }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $d47ca00e0d20c7c7$var$useStyles({
        sticky: sticky
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        pt: 4,
        pb: 4,
        pl: 8,
        pr: 8,
        className: `${classes.box} ${sticky ? classes.sticky : "-"}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    className: `${classes.links}`,
                    item: true,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    children: (firstColumnLinks || []).map((row, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                            className: classes.link,
                            href: row.href,
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t(row.text)
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    className: `${classes.links} ${classes.linksRight}`,
                    item: true,
                    md: 3,
                    sm: 6,
                    xs: 12,
                    children: (secondColumnLinks || []).map((row, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: classes.link,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                sx: {
                                    "& a": {
                                        color: "black"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    i18nKey: row.text,
                                    components: {
                                        a: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {})
                                    }
                                })
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    item: true,
                    md: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        className: classes.copyright,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: [
                                "\xa9 ",
                                t("common.copyright")
                            ]
                        })
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $3AM7p = parcelRequire("3AM7p");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5ce2784ff2666cf4$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)("MuiPaper", slot);
}
const $5ce2784ff2666cf4$var$paperClasses = (0, $beCSm.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $5ce2784ff2666cf4$export$2e2bcd8739ae039 = $5ce2784ff2666cf4$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $bca3355350079f94$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $bca3355350079f94$export$7852ee65d7f1c129 = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
const $bca3355350079f94$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5ce2784ff2666cf4$export$29cdb466b9b6f20b), classes);
};
const $bca3355350079f94$var$PaperRoot = (0, $1Ikg4.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $e8gS1.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $e8gS1.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $jgarO.alpha)("#fff", $bca3355350079f94$export$7852ee65d7f1c129(ownerState.elevation))}, ${(0, $jgarO.alpha)("#fff", $bca3355350079f94$export$7852ee65d7f1c129(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $bca3355350079f94$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $1sz44.default)(props, $bca3355350079f94$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $bca3355350079f94$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bca3355350079f94$var$PaperRoot, (0, $e8gS1.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other));
});
var $bca3355350079f94$export$2e2bcd8739ae039 = $bca3355350079f94$var$Paper;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ecc4a2c716d1152c$export$47a2da616e55e8e9(slot) {
    return (0, $4Cod0.default)("MuiAppBar", slot);
}
const $ecc4a2c716d1152c$var$appBarClasses = (0, $beCSm.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $ecc4a2c716d1152c$export$2e2bcd8739ae039 = $ecc4a2c716d1152c$var$appBarClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $75f50dd5200dc7fd$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $75f50dd5200dc7fd$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $3AM7p.default)(color)}`,
            `position${(0, $3AM7p.default)(position)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ecc4a2c716d1152c$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $75f50dd5200dc7fd$var$joinVars = (var1, var2)=>`${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})`;
const $75f50dd5200dc7fd$var$AppBarRoot = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $3AM7p.default)(ownerState.position)}`],
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $e8gS1.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $e8gS1.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $e8gS1.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $e8gS1.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $75f50dd5200dc7fd$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $1sz44.default)(props, $75f50dd5200dc7fd$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $75f50dd5200dc7fd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($75f50dd5200dc7fd$var$AppBarRoot, (0, $e8gS1.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $1SA7b.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $75f50dd5200dc7fd$export$2e2bcd8739ae039 = $75f50dd5200dc7fd$var$AppBar;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $f8b7b39c1ae7354b$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $f8b7b39c1ae7354b$export$2e2bcd8739ae039 = $f8b7b39c1ae7354b$var$useEnhancedEffect;


function $7132531a8fc4c99c$export$2e2bcd8739ae039(fn) {
    const ref = $acw62.useRef(fn);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}


var $52726edc538865d0$export$2e2bcd8739ae039 = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039);




var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, "appear", props),
            enter: $04540450bf60efa1$var$getProp(child, "enter", props),
            exit: $04540450bf60efa1$var$getProp(child, "exit", props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $1SA7b = parcelRequire("1SA7b");

var $8zogs = parcelRequire("8zogs");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $ayMG0 = parcelRequire("ayMG0");
function $171a3e689242bc25$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $1SA7b.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $1SA7b.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $171a3e689242bc25$export$2e2bcd8739ae039 = $171a3e689242bc25$var$Ripple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $71da1f2c906d4bee$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)("MuiTouchRipple", slot);
}
const $71da1f2c906d4bee$var$touchRippleClasses = (0, $beCSm.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $71da1f2c906d4bee$export$2e2bcd8739ae039 = $71da1f2c906d4bee$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $ed95ec2260a9d464$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $ed95ec2260a9d464$var$_ = (t)=>t, $ed95ec2260a9d464$var$_t, $ed95ec2260a9d464$var$_t2, $ed95ec2260a9d464$var$_t3, $ed95ec2260a9d464$var$_t4;
const $ed95ec2260a9d464$var$DURATION = 550;
const $ed95ec2260a9d464$export$95d0c9356b2231a3 = 80;
const $ed95ec2260a9d464$var$enterKeyframe = (0, $8zogs.keyframes)($ed95ec2260a9d464$var$_t || ($ed95ec2260a9d464$var$_t = $ed95ec2260a9d464$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $ed95ec2260a9d464$var$exitKeyframe = (0, $8zogs.keyframes)($ed95ec2260a9d464$var$_t2 || ($ed95ec2260a9d464$var$_t2 = $ed95ec2260a9d464$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $ed95ec2260a9d464$var$pulsateKeyframe = (0, $8zogs.keyframes)($ed95ec2260a9d464$var$_t3 || ($ed95ec2260a9d464$var$_t3 = $ed95ec2260a9d464$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $ed95ec2260a9d464$export$f6b7418508c72c25 = (0, $1Ikg4.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $ed95ec2260a9d464$export$676cfe7b12693c4b = (0, $1Ikg4.default)((0, $171a3e689242bc25$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($ed95ec2260a9d464$var$_t4 || ($ed95ec2260a9d464$var$_t4 = $ed95ec2260a9d464$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).rippleVisible, $ed95ec2260a9d464$var$enterKeyframe, $ed95ec2260a9d464$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).child, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childLeaving, $ed95ec2260a9d464$var$exitKeyframe, $ed95ec2260a9d464$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childPulsate, $ed95ec2260a9d464$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $ed95ec2260a9d464$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1sz44.default)(props, $ed95ec2260a9d464$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $acw62.useRef(null);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($ed95ec2260a9d464$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $1SA7b.default)(classes.ripple, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $1SA7b.default)(classes.rippleVisible, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $1SA7b.default)(classes.ripplePulsate, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $1SA7b.default)(classes.child, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $1SA7b.default)(classes.childLeaving, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $1SA7b.default)(classes.childPulsate, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $ed95ec2260a9d464$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $ed95ec2260a9d464$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed95ec2260a9d464$export$f6b7418508c72c25, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)((0, $71da1f2c906d4bee$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $ed95ec2260a9d464$export$2e2bcd8739ae039 = $ed95ec2260a9d464$var$TouchRipple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fcd0c39d812092df$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)("MuiButtonBase", slot);
}
const $fcd0c39d812092df$var$buttonBaseClasses = (0, $beCSm.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $fcd0c39d812092df$export$2e2bcd8739ae039 = $fcd0c39d812092df$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $21d0be68de155ec6$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $21d0be68de155ec6$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $fcd0c39d812092df$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $21d0be68de155ec6$export$7ec0dcc5e3cdcd36 = (0, $1Ikg4.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $fcd0c39d812092df$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $21d0be68de155ec6$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1sz44.default)(props, $21d0be68de155ec6$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $e40fc9424df4cf9c$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $e8gS1.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $21d0be68de155ec6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($21d0be68de155ec6$export$7ec0dcc5e3cdcd36, (0, $e8gS1.default)({
        as: ComponentProp,
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $ed95ec2260a9d464$export$2e2bcd8739ae039), (0, $e8gS1.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $21d0be68de155ec6$export$2e2bcd8739ae039 = $21d0be68de155ec6$var$ButtonBase;



var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $51a63158336e7c66$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)("MuiIconButton", slot);
}
const $51a63158336e7c66$var$iconButtonClasses = (0, $beCSm.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $51a63158336e7c66$export$2e2bcd8739ae039 = $51a63158336e7c66$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $05a469b554e6dcda$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $05a469b554e6dcda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $3AM7p.default)(color)}`,
            edge && `edge${(0, $3AM7p.default)(edge)}`,
            `size${(0, $3AM7p.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $51a63158336e7c66$export$5e8702d71474f093), classes);
};
const $05a469b554e6dcda$var$IconButtonRoot = (0, $1Ikg4.default)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $3AM7p.default)(ownerState.edge)}`],
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $e8gS1.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $e8gS1.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $e8gS1.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $51a63158336e7c66$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $05a469b554e6dcda$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $1sz44.default)(props, $05a469b554e6dcda$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $05a469b554e6dcda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($05a469b554e6dcda$var$IconButtonRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $05a469b554e6dcda$export$2e2bcd8739ae039 = $05a469b554e6dcda$var$IconButton;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11a5c049f91ec9c6$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)("MuiToolbar", slot);
}
const $11a5c049f91ec9c6$var$toolbarClasses = (0, $beCSm.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $11a5c049f91ec9c6$export$2e2bcd8739ae039 = $11a5c049f91ec9c6$var$toolbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $e223a49097a073d9$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $e223a49097a073d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $11a5c049f91ec9c6$export$b12cb262231eef32), classes);
};
const $e223a49097a073d9$var$ToolbarRoot = (0, $1Ikg4.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $e223a49097a073d9$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $1sz44.default)(props, $e223a49097a073d9$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $e223a49097a073d9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e223a49097a073d9$var$ToolbarRoot, (0, $e8gS1.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $e223a49097a073d9$export$2e2bcd8739ae039 = $e223a49097a073d9$var$Toolbar;



function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}





function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}




function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7d110e739ae14cc6$export$2e2bcd8739ae039(arr) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $673ff3dfc4a496de$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $673ff3dfc4a496de$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
var $673ff3dfc4a496de$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $673ff3dfc4a496de$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    var _getLastOfPath = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    var _getLastOfPath3 = $673ff3dfc4a496de$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    var value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $673ff3dfc4a496de$var$_entityMap[s];
    });
    return data;
}
var $673ff3dfc4a496de$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $673ff3dfc4a496de$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $673ff3dfc4a496de$var$ResourceStore = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $673ff3dfc4a496de$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $673ff3dfc4a496de$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
                if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
                else pack = $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, pack), resources);
                $673ff3dfc4a496de$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($673ff3dfc4a496de$var$EventEmitter);
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $673ff3dfc4a496de$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $673ff3dfc4a496de$var$checkedLoadedFor = {};
var $673ff3dfc4a496de$var$Translator = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {
                        interpolation: $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $673ff3dfc4a496de$var$_objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $673ff3dfc4a496de$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $673ff3dfc4a496de$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    var rules = {};
    $673ff3dfc4a496de$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $673ff3dfc4a496de$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$673ff3dfc4a496de$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $673ff3dfc4a496de$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, k), f, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && options.hasOwnProperty(matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $673ff3dfc4a496de$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $673ff3dfc4a496de$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || "day");
                };
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $673ff3dfc4a496de$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $673ff3dfc4a496de$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$5(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $673ff3dfc4a496de$var$Connector = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $673ff3dfc4a496de$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $673ff3dfc4a496de$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, $673ff3dfc4a496de$var$_objectSpread$5($673ff3dfc4a496de$var$_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$6(Object(source), true).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $673ff3dfc4a496de$var$I18n = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.options = $673ff3dfc4a496de$var$transformOptions(options);
        _this.services = {};
        _this.logger = $673ff3dfc4a496de$var$baseLogger;
        _this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(_this, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $673ff3dfc4a496de$var$get();
                this.options = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, defOpts), this.options), $673ff3dfc4a496de$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
                    var lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
                    this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $673ff3dfc4a496de$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $673ff3dfc4a496de$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $673ff3dfc4a496de$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $673ff3dfc4a496de$var$_objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var mergedOptions = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $673ff3dfc4a496de$var$_objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($673ff3dfc4a496de$var$EventEmitter);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($673ff3dfc4a496de$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $673ff3dfc4a496de$var$I18n(options, callback);
});
var $673ff3dfc4a496de$var$instance = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$var$instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
var $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$var$instance.createInstance;
var $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$var$instance.init;
var $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$var$instance.loadResources;
var $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$var$instance.reloadResources;
var $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$var$instance.use;
var $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$var$instance.changeLanguage;
var $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$var$instance.getFixedT;
var $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$var$instance.t;
var $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$var$instance.exists;
var $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$var$instance.setDefaultNamespace;
var $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$var$instance.hasLoadedNamespace;
var $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$var$instance.loadNamespaces;
var $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$var$instance.loadLanguages;
var $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$instance;


parcelRequire("acw62");

var $ab8749cbc737a51d$exports = {};

$ab8749cbc737a51d$exports = new URL((parcelRequire("27Lyk")).resolve("2bLFX"), import.meta.url).toString();


var $3754d21c80fdfa85$exports = {};

$3754d21c80fdfa85$exports = new URL((parcelRequire("27Lyk")).resolve("dOR6b"), import.meta.url).toString();


var $5d2635ab09e018a6$exports = {};

$5d2635ab09e018a6$exports = new URL((parcelRequire("27Lyk")).resolve("574Cp"), import.meta.url).toString();


var $de59dbffe2aac879$exports = {};

$de59dbffe2aac879$exports = new URL((parcelRequire("27Lyk")).resolve("6g38S"), import.meta.url).toString();




function $b84db5159a18b987$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $3dbdd088cf671ff4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3dbdd088cf671ff4$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $3dbdd088cf671ff4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3dbdd088cf671ff4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] // cookieMinutes: 10,
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $b84db5159a18b987$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $3dbdd088cf671ff4$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = "languageDetector";


var $00aa8ec466738ae8$var$arr = [];
var $00aa8ec466738ae8$var$each = $00aa8ec466738ae8$var$arr.forEach;
var $00aa8ec466738ae8$var$slice = $00aa8ec466738ae8$var$arr.slice;
function $00aa8ec466738ae8$export$ebe90cb607ad99e(obj) {
    $00aa8ec466738ae8$var$each.call($00aa8ec466738ae8$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $00aa8ec466738ae8$export$61fc7d43ac8f84b0(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this;
        var args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
function $00aa8ec466738ae8$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (!object) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        object = object[key];
    }
    if (!object) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $00aa8ec466738ae8$export$1518ffc4a8ff94f2(object, path, newValue) {
    var _getLastOfPath = $00aa8ec466738ae8$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $00aa8ec466738ae8$export$abf558874911f4d9(object, path, newValue, concat) {
    var _getLastOfPath2 = $00aa8ec466738ae8$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $00aa8ec466738ae8$export$2aa3fd96c49a84a8(object, path) {
    var _getLastOfPath3 = $00aa8ec466738ae8$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
var $00aa8ec466738ae8$var$regexp = new RegExp("{{(.+?)}}", "g");
function $00aa8ec466738ae8$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $00aa8ec466738ae8$export$89e29e4ab65e70a9(str, data, lng) {
    var match, value;
    function regexSafe(val) {
        return val.replace(/\$/g, "$$$$");
    }
    while(match = $00aa8ec466738ae8$var$regexp.exec(str)){
        value = match[1].trim();
        if (typeof value !== "string") value = $00aa8ec466738ae8$var$makeString(value);
        if (!value) value = "";
        value = regexSafe(value);
        str = str.replace(match[0], data[value] || value);
        $00aa8ec466738ae8$var$regexp.lastIndex = 0;
    }
    return str;
}
function $00aa8ec466738ae8$export$d467d8460b2e6a82(obj, props) {
    return props.reduce(function(mem, p) {
        if (mem) return mem;
        if (!obj || !obj[p] || typeof obj[p] !== "string" || !obj[p].toLowerCase() === p.toLowerCase()) {
            var err = 'i18next-locize-backend :: got "'.concat(obj[p], '" in options for ').concat(p, " which is invalid.");
            console.warn(err);
            return err;
        }
        return false;
    }, false);
}
function $00aa8ec466738ae8$export$f6ea5db7bf5147cd(obj, props) {
    return !$00aa8ec466738ae8$export$d467d8460b2e6a82(obj, props);
}
function $00aa8ec466738ae8$export$260e5c0943f31606() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}


var $def132d668a7904d$exports = {};
var $def132d668a7904d$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $def132d668a7904d$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $def132d668a7904d$var$fetchApi = window.fetch;
    else $def132d668a7904d$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $def132d668a7904d$var$f = $def132d668a7904d$var$fetchApi || (parcelRequire("R5nvG"));
    if ($def132d668a7904d$var$f.default) $def132d668a7904d$var$f = $def132d668a7904d$var$f.default;
    $def132d668a7904d$exports.default = $def132d668a7904d$var$f;
    $def132d668a7904d$exports = $def132d668a7904d$exports.default;
}


function $9b3ce6276e1f4b29$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9b3ce6276e1f4b29$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9b3ce6276e1f4b29$var$_typeof(obj);
}
var $9b3ce6276e1f4b29$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $9b3ce6276e1f4b29$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $9b3ce6276e1f4b29$var$fetchApi = window.fetch;
    else $9b3ce6276e1f4b29$var$fetchApi = fetch;
}
var $9b3ce6276e1f4b29$var$XmlHttpRequestApi;
if (typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $9b3ce6276e1f4b29$var$_typeof(XMLHttpRequest)) === "object") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $9b3ce6276e1f4b29$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $9b3ce6276e1f4b29$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $9b3ce6276e1f4b29$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $9b3ce6276e1f4b29$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $9b3ce6276e1f4b29$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$9b3ce6276e1f4b29$var$fetchApi && $def132d668a7904d$exports && !$9b3ce6276e1f4b29$var$XmlHttpRequestApi && !$9b3ce6276e1f4b29$var$ActiveXObjectApi) $9b3ce6276e1f4b29$var$fetchApi = $def132d668a7904d$exports.default || $def132d668a7904d$exports;
if (typeof $9b3ce6276e1f4b29$var$fetchApi !== "function") $9b3ce6276e1f4b29$var$fetchApi = undefined;
var $9b3ce6276e1f4b29$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    var headers = {};
    if (options.authorize && options.apiKey) headers.Authorization = options.apiKey;
    if (payload || options.setContentTypeJSON) headers["Content-Type"] = "application/json";
    $9b3ce6276e1f4b29$var$fetchApi(url, {
        method: payload ? "POST" : "GET",
        body: payload ? JSON.stringify(payload) : undefined,
        headers: headers
    }).then(function(response) {
        var resourceNotExisting = response.headers && response.headers.get("x-cache") === "Error from cloudfront";
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status,
            resourceNotExisting: resourceNotExisting
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data,
                resourceNotExisting: resourceNotExisting
            });
        }).catch(callback);
    }).catch(callback);
};
var $9b3ce6276e1f4b29$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    try {
        var x;
        if ($9b3ce6276e1f4b29$var$XmlHttpRequestApi) x = new $9b3ce6276e1f4b29$var$XmlHttpRequestApi();
        else x = new $9b3ce6276e1f4b29$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        if (options.authorize && options.apiKey) x.setRequestHeader("Authorization", options.apiKey);
        if (payload || options.setContentTypeJSON) x.setRequestHeader("Content-Type", "application/json");
        x.onreadystatechange = function() {
            var resourceNotExisting = x.getResponseHeader("x-cache") === "Error from cloudfront";
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText,
                resourceNotExisting: resourceNotExisting
            });
        };
        x.send(JSON.stringify(payload));
    } catch (e) {
        console && console.log(e);
    }
};
var $9b3ce6276e1f4b29$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($9b3ce6276e1f4b29$var$fetchApi) return $9b3ce6276e1f4b29$var$requestWithFetch(options, url, payload, callback);
    if (typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $9b3ce6276e1f4b29$var$_typeof(XMLHttpRequest)) === "object" || typeof ActiveXObject === "function") return $9b3ce6276e1f4b29$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $9b3ce6276e1f4b29$export$2e2bcd8739ae039 = $9b3ce6276e1f4b29$var$request;


function $6995d8b46a5319c0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6995d8b46a5319c0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6995d8b46a5319c0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6995d8b46a5319c0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6995d8b46a5319c0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $6995d8b46a5319c0$var$getDefaults = function getDefaults() {
    return {
        loadPath: "https://api.locize.app/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
        privatePath: "https://api.locize.app/private/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
        getLanguagesPath: "https://api.locize.app/languages/{{projectId}}",
        addPath: "https://api.locize.app/missing/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
        updatePath: "https://api.locize.app/update/{{projectId}}/{{version}}/{{lng}}/{{ns}}",
        referenceLng: "en",
        crossDomain: true,
        setContentTypeJSON: false,
        version: "latest",
        private: false,
        translatedPercentageThreshold: 0.9,
        failLoadingOnEmptyJSON: false,
        allowedAddOrUpdateHosts: [
            "localhost"
        ],
        onSaved: false,
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        checkForProjectTimeout: 3000,
        storageExpiration: 3600000,
        writeDebounce: 5000
    };
};
var $6995d8b46a5319c0$var$hasLocalStorageSupport;
try {
    $6995d8b46a5319c0$var$hasLocalStorageSupport = typeof window !== "undefined" && window.localStorage !== null;
    var $6995d8b46a5319c0$var$testKey = "notExistingLocizeProject";
    window.localStorage.setItem($6995d8b46a5319c0$var$testKey, "foo");
    window.localStorage.removeItem($6995d8b46a5319c0$var$testKey);
} catch (e) {
    $6995d8b46a5319c0$var$hasLocalStorageSupport = false;
}
function $6995d8b46a5319c0$var$getStorage(storageExpiration) {
    var setProjectNotExisting = function setProjectNotExisting() {};
    var isProjectNotExisting = function isProjectNotExisting() {};
    if ($6995d8b46a5319c0$var$hasLocalStorageSupport) {
        setProjectNotExisting = function setProjectNotExisting(projectId) {
            window.localStorage.setItem("notExistingLocizeProject_".concat(projectId), Date.now());
        };
        isProjectNotExisting = function isProjectNotExisting(projectId) {
            var ret = window.localStorage.getItem("notExistingLocizeProject_".concat(projectId));
            if (!ret) return false;
            if (Date.now() - ret > storageExpiration) {
                window.localStorage.removeItem("notExistingLocizeProject_".concat(projectId));
                return false;
            }
            return true;
        };
    } else if (typeof document !== "undefined") {
        setProjectNotExisting = function setProjectNotExisting(projectId) {
            var date = new Date();
            date.setTime(date.getTime() + storageExpiration);
            var expires = "; expires=".concat(date.toGMTString());
            var name = "notExistingLocizeProject_".concat(projectId);
            try {
                document.cookie = "".concat(name, "=").concat(Date.now()).concat(expires, ";path=/");
            } catch (err) {}
        };
        isProjectNotExisting = function isProjectNotExisting(projectId) {
            var name = "notExistingLocizeProject_".concat(projectId);
            var nameEQ = "".concat(name, "=");
            try {
                var ca = document.cookie.split(";");
                for(var i = 0; i < ca.length; i++){
                    var c = ca[i];
                    while(c.charAt(0) === " ")c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) === 0) return true;
                }
            } catch (err) {}
            return false;
        };
    }
    return {
        setProjectNotExisting: setProjectNotExisting,
        isProjectNotExisting: isProjectNotExisting
    };
}
var $6995d8b46a5319c0$var$I18NextLocizeBackend = function() {
    function I18NextLocizeBackend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var callback = arguments.length > 3 ? arguments[3] : undefined;
        $6995d8b46a5319c0$var$_classCallCheck(this, I18NextLocizeBackend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        if (services && services.projectId) this.init(null, services, allOptions, options);
        else this.init(services, options, allOptions, callback);
    }
    $6995d8b46a5319c0$var$_createClass(I18NextLocizeBackend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!options.referenceLng && allOptions.fallbackLng && Array.isArray(allOptions.fallbackLng) && allOptions.fallbackLng[0] !== "dev") options.referenceLng = allOptions.fallbackLng[0];
                this.services = services;
                var defOpt = $6995d8b46a5319c0$var$getDefaults();
                var passedOpt = (0, $00aa8ec466738ae8$export$ebe90cb607ad99e)(options, this.options || {});
                if (passedOpt.reloadInterval && passedOpt.reloadInterval < 300000) {
                    console.warn("Your configured reloadInterval option is to low.");
                    passedOpt.reloadInterval = defOpt.reloadInterval;
                }
                this.options = (0, $00aa8ec466738ae8$export$ebe90cb607ad99e)(options, this.options || {}, defOpt);
                this.allOptions = allOptions;
                this.somethingLoaded = false;
                this.isProjectNotExisting = false;
                this.storage = $6995d8b46a5319c0$var$getStorage(this.options.storageExpiration);
                if (this.options.pull) console.warn('The pull API was removed use "private: true" option instead: https://docs.locize.com/integration/api#fetch-private-namespace-resources');
                var hostname = typeof window !== "undefined" && window.location && window.location.hostname;
                if (hostname) {
                    this.isAddOrUpdateAllowed = typeof this.options.allowedAddOrUpdateHosts === "function" ? this.options.allowedAddOrUpdateHosts(hostname) : this.options.allowedAddOrUpdateHosts.indexOf(hostname) > -1;
                    if (services && services.logger && (allOptions.saveMissing || allOptions.updateMissing)) {
                        if (!this.isAddOrUpdateAllowed) services.logger.warn(typeof this.options.allowedAddOrUpdateHosts === "function" ? 'locize-backend: will not save or update missings because allowedAddOrUpdateHosts returned false for the host "'.concat(hostname, '".') : 'locize-backend: will not save or update missings because the host "'.concat(hostname, '" was not in the list of allowedAddOrUpdateHosts: ').concat(this.options.allowedAddOrUpdateHosts.join(", "), " (matches need to be exact)."));
                        else if (hostname !== "localhost") services.logger.warn('locize-backend: you are using the save or update missings feature from this host "'.concat(hostname, '".\nMake sure you will not use it in production!\nhttps://docs.locize.com/guides-tips-and-tricks/going-production'));
                    }
                } else this.isAddOrUpdateAllowed = true;
                if (typeof callback === "function") this.getOptions(function(err, opts, languages) {
                    if (err) return callback(err);
                    _this.options.referenceLng = options.referenceLng || opts.referenceLng || _this.options.referenceLng;
                    callback(null, opts, languages);
                });
                this.queuedWrites = {
                    pending: {}
                };
                this.debouncedProcess = (0, $00aa8ec466738ae8$export$61fc7d43ac8f84b0)(this.process, this.options.writeDebounce);
                if (this.interval) clearInterval(this.interval);
                if (this.options.reloadInterval && this.options.projectId) this.interval = setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this2 = this;
                var _ref = this.services || {
                    logger: console
                }, backendConnector = _ref.backendConnector, languageUtils = _ref.languageUtils, logger = _ref.logger;
                if (!backendConnector) return;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this2.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        },
        {
            key: "getLanguages",
            value: function getLanguages(callback) {
                var _this3 = this;
                var deferred;
                if (!callback) {
                    deferred = (0, $00aa8ec466738ae8$export$260e5c0943f31606)();
                    callback = function callback(err, ret) {
                        if (err) return deferred.reject(err);
                        deferred.resolve(ret);
                    };
                }
                var isMissing = (0, $00aa8ec466738ae8$export$d467d8460b2e6a82)(this.options, [
                    "projectId"
                ]);
                if (isMissing) return callback(new Error(isMissing));
                var url = (0, $00aa8ec466738ae8$export$89e29e4ab65e70a9)(this.options.getLanguagesPath, {
                    projectId: this.options.projectId
                });
                if (!this.isProjectNotExisting && this.storage.isProjectNotExisting(this.options.projectId)) this.isProjectNotExisting = true;
                if (this.isProjectNotExisting) return callback(new Error("locize project ".concat(this.options.projectId, " does not exist!")));
                this.getLanguagesCalls = this.getLanguagesCalls || [];
                this.getLanguagesCalls.push(callback);
                if (this.getLanguagesCalls.length > 1) return;
                this.loadUrl({}, url, function(err, ret, info) {
                    if (!_this3.somethingLoaded && info && info.resourceNotExisting) {
                        _this3.isProjectNotExisting = true;
                        _this3.storage.setProjectNotExisting(_this3.options.projectId);
                        var e = new Error("locize project ".concat(_this3.options.projectId, " does not exist!"));
                        var _clbs = _this3.getLanguagesCalls;
                        _this3.getLanguagesCalls = [];
                        return _clbs.forEach(function(clb) {
                            return clb(e);
                        });
                    }
                    if (ret) {
                        var referenceLng = Object.keys(ret).reduce(function(mem, k) {
                            var item = ret[k];
                            if (item.isReferenceLanguage) mem = k;
                            return mem;
                        }, "");
                        if (referenceLng && _this3.options.referenceLng !== referenceLng) _this3.options.referenceLng = referenceLng;
                    }
                    _this3.somethingLoaded = true;
                    var clbs = _this3.getLanguagesCalls;
                    _this3.getLanguagesCalls = [];
                    clbs.forEach(function(clb) {
                        return clb(err, ret);
                    });
                });
                return deferred;
            }
        },
        {
            key: "getOptions",
            value: function getOptions(callback) {
                var _this4 = this;
                var deferred;
                if (!callback) {
                    deferred = (0, $00aa8ec466738ae8$export$260e5c0943f31606)();
                    callback = function callback(err, ret) {
                        if (err) return deferred.reject(err);
                        deferred.resolve(ret);
                    };
                }
                this.getLanguages(function(err, data) {
                    if (err) return callback(err);
                    var keys = Object.keys(data);
                    if (!keys.length) return callback(new Error("was unable to load languages via API"));
                    var lngs = keys.reduce(function(mem, k) {
                        var item = data[k];
                        if (item.translated[_this4.options.version] && item.translated[_this4.options.version] >= _this4.options.translatedPercentageThreshold) mem.push(k);
                        return mem;
                    }, []);
                    var hasRegion = keys.reduce(function(mem, k) {
                        if (k.indexOf("-") > -1) return true;
                        return mem;
                    }, false);
                    callback(null, {
                        fallbackLng: _this4.options.referenceLng,
                        referenceLng: _this4.options.referenceLng,
                        supportedLngs: lngs,
                        load: hasRegion ? "all" : "languageOnly"
                    }, data);
                });
                return deferred;
            }
        },
        {
            key: "checkIfProjectExists",
            value: function checkIfProjectExists(callback) {
                var _this5 = this;
                var _ref2 = this.services || {
                    logger: console
                }, logger = _ref2.logger;
                if (this.somethingLoaded) {
                    if (callback) callback(null);
                    return;
                }
                if (this.alreadyRequestedCheckIfProjectExists) {
                    setTimeout(function() {
                        return _this5.checkIfProjectExists(callback);
                    }, this.options.checkForProjectTimeout);
                    return;
                }
                this.alreadyRequestedCheckIfProjectExists = true;
                this.getLanguages(function(err) {
                    if (err && err.message && err.message.indexOf("does not exist") > 0) {
                        if (logger) logger.error(err.message);
                    }
                    if (callback) callback(err);
                });
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                var _this6 = this;
                var _ref3 = this.services || {
                    logger: console
                }, logger = _ref3.logger;
                var url;
                var options = {};
                if (this.options.private) {
                    var isMissing = (0, $00aa8ec466738ae8$export$d467d8460b2e6a82)(this.options, [
                        "projectId",
                        "version",
                        "apiKey"
                    ]);
                    if (isMissing) return callback(new Error(isMissing), false);
                    url = (0, $00aa8ec466738ae8$export$89e29e4ab65e70a9)(this.options.privatePath, {
                        lng: language,
                        ns: namespace,
                        projectId: this.options.projectId,
                        version: this.options.version
                    });
                    options = {
                        authorize: true
                    };
                } else {
                    var _isMissing = (0, $00aa8ec466738ae8$export$d467d8460b2e6a82)(this.options, [
                        "projectId",
                        "version"
                    ]);
                    if (_isMissing) return callback(new Error(_isMissing), false);
                    url = (0, $00aa8ec466738ae8$export$89e29e4ab65e70a9)(this.options.loadPath, {
                        lng: language,
                        ns: namespace,
                        projectId: this.options.projectId,
                        version: this.options.version
                    });
                }
                if (!this.isProjectNotExisting && this.storage.isProjectNotExisting(this.options.projectId)) this.isProjectNotExisting = true;
                if (this.isProjectNotExisting) {
                    var err = new Error("locize project ".concat(this.options.projectId, " does not exist!"));
                    if (logger) logger.error(err.message);
                    if (callback) callback(err);
                    return;
                }
                this.loadUrl(options, url, function(err, ret, info) {
                    if (!_this6.somethingLoaded) {
                        if (info && info.resourceNotExisting) setTimeout(function() {
                            return _this6.checkIfProjectExists();
                        }, _this6.options.checkForProjectTimeout);
                        else _this6.somethingLoaded = true;
                    }
                    callback(err, ret);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(options, url, payload, callback) {
                var _this7 = this;
                options = (0, $00aa8ec466738ae8$export$ebe90cb607ad99e)(options, this.options);
                if (typeof payload === "function") {
                    callback = payload;
                    payload = undefined;
                }
                callback = callback || function() {};
                (0, $9b3ce6276e1f4b29$export$2e2bcd8739ae039)(options, url, payload, function(err, res) {
                    var resourceNotExisting = res && res.resourceNotExisting;
                    if (res && (res.status === 408 || res.status === 400)) return callback("failed loading " + url, true, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url, true, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url, false, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url, true, {
                        resourceNotExisting: resourceNotExisting
                    });
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        ret = JSON.parse(res.data);
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    if (_this7.options.failLoadingOnEmptyJSON && !Object.keys(ret).length) return callback("loaded result empty for " + url, false, {
                        resourceNotExisting: resourceNotExisting
                    });
                    callback(null, ret, {
                        resourceNotExisting: resourceNotExisting
                    });
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback, options) {
                var _this8 = this;
                if (!callback) callback = function callback() {};
                this.checkIfProjectExists(function(err) {
                    if (err) return callback(err);
                    var isMissing = (0, $00aa8ec466738ae8$export$d467d8460b2e6a82)(_this8.options, [
                        "projectId",
                        "version",
                        "apiKey",
                        "referenceLng"
                    ]);
                    if (isMissing) return callback(new Error(isMissing));
                    if (!_this8.isAddOrUpdateAllowed) return callback("host is not allowed to create key.");
                    if (typeof languages === "string") languages = [
                        languages
                    ];
                    if (languages.filter(function(l) {
                        return l === _this8.options.referenceLng;
                    }).length < 1) _this8.services && _this8.services.logger && _this8.services.logger.warn('locize-backend: will not save missings because the reference language "'.concat(_this8.options.referenceLng, '" was not in the list of to save languages: ').concat(languages.join(", "), " (open your site in the reference language to save missings)."));
                    languages.forEach(function(lng) {
                        if (lng === _this8.options.referenceLng) _this8.queue.call(_this8, _this8.options.referenceLng, namespace, key, fallbackValue, callback, options);
                    });
                });
            }
        },
        {
            key: "update",
            value: function update(languages, namespace, key, fallbackValue, callback, options) {
                var _this9 = this;
                if (!callback) callback = function callback() {};
                this.checkIfProjectExists(function(err) {
                    if (err) return callback(err);
                    var isMissing = (0, $00aa8ec466738ae8$export$d467d8460b2e6a82)(_this9.options, [
                        "projectId",
                        "version",
                        "apiKey",
                        "referenceLng"
                    ]);
                    if (isMissing) return callback(new Error(isMissing));
                    if (!_this9.isAddOrUpdateAllowed) return callback("host is not allowed to update key.");
                    if (!options) options = {};
                    if (typeof languages === "string") languages = [
                        languages
                    ];
                    options.isUpdate = true;
                    languages.forEach(function(lng) {
                        if (lng === _this9.options.referenceLng) _this9.queue.call(_this9, _this9.options.referenceLng, namespace, key, fallbackValue, callback, options);
                    });
                });
            }
        },
        {
            key: "writePage",
            value: function writePage(lng, namespace, missings, callback) {
                var missingUrl = (0, $00aa8ec466738ae8$export$89e29e4ab65e70a9)(this.options.addPath, {
                    lng: lng,
                    ns: namespace,
                    projectId: this.options.projectId,
                    version: this.options.version
                });
                var updatesUrl = (0, $00aa8ec466738ae8$export$89e29e4ab65e70a9)(this.options.updatePath, {
                    lng: lng,
                    ns: namespace,
                    projectId: this.options.projectId,
                    version: this.options.version
                });
                var hasMissing = false;
                var hasUpdates = false;
                var payloadMissing = {};
                var payloadUpdate = {};
                missings.forEach(function(item) {
                    var value = item.options && item.options.tDescription ? {
                        value: item.fallbackValue || "",
                        context: {
                            text: item.options.tDescription
                        }
                    } : item.fallbackValue || "";
                    if (item.options && item.options.isUpdate) {
                        if (!hasUpdates) hasUpdates = true;
                        payloadUpdate[item.key] = value;
                    } else {
                        if (!hasMissing) hasMissing = true;
                        payloadMissing[item.key] = value;
                    }
                });
                var todo = 0;
                if (hasMissing) todo++;
                if (hasUpdates) todo++;
                var doneOne = function doneOne(err) {
                    todo--;
                    if (!todo) callback(err);
                };
                if (!todo) doneOne();
                if (hasMissing) (0, $9b3ce6276e1f4b29$export$2e2bcd8739ae039)((0, $00aa8ec466738ae8$export$ebe90cb607ad99e)({
                    authorize: true
                }, this.options), missingUrl, payloadMissing, doneOne);
                if (hasUpdates) (0, $9b3ce6276e1f4b29$export$2e2bcd8739ae039)((0, $00aa8ec466738ae8$export$ebe90cb607ad99e)({
                    authorize: true
                }, this.options), updatesUrl, payloadUpdate, doneOne);
            }
        },
        {
            key: "write",
            value: function write(lng, namespace) {
                var _this10 = this;
                var lock = (0, $00aa8ec466738ae8$export$2aa3fd96c49a84a8)(this.queuedWrites, [
                    "locks",
                    lng,
                    namespace
                ]);
                if (lock) return;
                var missings = (0, $00aa8ec466738ae8$export$2aa3fd96c49a84a8)(this.queuedWrites, [
                    lng,
                    namespace
                ]);
                (0, $00aa8ec466738ae8$export$1518ffc4a8ff94f2)(this.queuedWrites, [
                    lng,
                    namespace
                ], []);
                var pageSize = 1000;
                var clbs = missings.filter(function(m) {
                    return m.callback;
                }).map(function(missing) {
                    return missing.callback;
                });
                if (missings.length) (function() {
                    (0, $00aa8ec466738ae8$export$1518ffc4a8ff94f2)(_this10.queuedWrites, [
                        "locks",
                        lng,
                        namespace
                    ], true);
                    var namespaceSaved = function namespaceSaved() {
                        (0, $00aa8ec466738ae8$export$1518ffc4a8ff94f2)(_this10.queuedWrites, [
                            "locks",
                            lng,
                            namespace
                        ], false);
                        clbs.forEach(function(clb) {
                            return clb();
                        });
                        if (_this10.options.onSaved) _this10.options.onSaved(lng, namespace);
                        _this10.debouncedProcess(lng, namespace);
                    };
                    var amountOfPages = missings.length / pageSize;
                    var pagesDone = 0;
                    var page = missings.splice(0, pageSize);
                    _this10.writePage(lng, namespace, page, function() {
                        pagesDone++;
                        if (pagesDone >= amountOfPages) namespaceSaved();
                    });
                    while(page.length === pageSize){
                        page = missings.splice(0, pageSize);
                        if (page.length) _this10.writePage(lng, namespace, page, function() {
                            pagesDone++;
                            if (pagesDone >= amountOfPages) namespaceSaved();
                        });
                    }
                })();
            }
        },
        {
            key: "process",
            value: function process() {
                var _this11 = this;
                Object.keys(this.queuedWrites).forEach(function(lng) {
                    if (lng === "locks") return;
                    Object.keys(_this11.queuedWrites[lng]).forEach(function(ns) {
                        var todo = _this11.queuedWrites[lng][ns];
                        if (todo.length) _this11.write(lng, ns);
                    });
                });
            }
        },
        {
            key: "queue",
            value: function queue(lng, namespace, key, fallbackValue, callback, options) {
                (0, $00aa8ec466738ae8$export$abf558874911f4d9)(this.queuedWrites, [
                    lng,
                    namespace
                ], {
                    key: key,
                    fallbackValue: fallbackValue || "",
                    callback: callback,
                    options: options
                });
                this.debouncedProcess();
            }
        }
    ]);
    return I18NextLocizeBackend;
}();
$6995d8b46a5319c0$var$I18NextLocizeBackend.type = "backend";
var $6995d8b46a5319c0$export$2e2bcd8739ae039 = $6995d8b46a5319c0$var$I18NextLocizeBackend;



var $2a0d42a1ea4cbd47$exports = {};
$2a0d42a1ea4cbd47$exports = JSON.parse('{"kirjaudu.title":"Tervetuloa Luonnonvarakeskuksen tilastokyselyyn","kirjaudu.ohjeteksti1.1":"T\xe4m\xe4n s\xe4hk\xf6isen tiedonkeruunpalvelun kautta vastataan Luonnonvarakeskuksen satotilastokyselyyn ja perunan h\xe4vikki- ja varastokyselyyn.","kirjaudu.ohjeteksti1.2":"Satotilastokysely on avoinna 30.9.-30.10. v\xe4lisen\xe4 aikana. Perunan h\xe4vikki- ja varastokysely on avoinna 30.9.-30.10. klo 23.59 v\xe4lisen\xe4 aikana.","kirjaudu.ohjeteksti2.1":"Vastaajiksi kutsuttujen viljelij\xf6iden tulee vastata tiedonkeruuseen yll\xe4 olevien aikataulujen puitteissa.","kirjaudu.ohjeteksti2.2":"Olemme haastattelijoiden toimesta yhteydess\xe4 niihin viljelij\xf6ihin, joilta ei ole saatu vastausta s\xe4hk\xf6isen tiedonkeruun p\xe4\xe4ttymiseen menness\xe4.","kirjaudu.ohjeteksti3.1":"Luonnonvarakeskuksen tilastokyselyt ovat lakis\xe4\xe4teist\xe4 viranomaistoimintaa. Antamasi tiedot k\xe4sitell\xe4\xe4n luottamuksellisina ja niit\xe4 k\xe4ytet\xe4\xe4n vain tilastotarkoituksiin.","kirjaudu.ohjeteksti3.2":"Tunnistaudu viljelij\xe4n\xe4 valitsemalla <b>Tunnistaudu</b>. Jos olet viljelij\xe4n valtuuttama henkil\xf6, valitse <b>Tunnistaudu valtuutettuna.</b>","kirjaudu.linkkiteksti1":"Ohjeita tunnistautumiseen ja valtuuttamiseen l\xf6yd\xe4t Luken verkkosivuilta kohdasta","kirjaudu.linkkiteksti2":"Suomi.fi-tunnistus ja -valtuudet viljelij\xe4tiedonkeruissa","kirjaudu.linkki":"https://www.luke.fi/fi/tilastot/tietoa-tilastoista/suomifitunnistus-ja-valtuudet-viljelijatiedonkeruissa","kirjaudu.suomifi":"Tunnistaudu","kirjaudu.suomifi.valtuutettu":"Tunnistaudu valtuutettuna","kirjaudu.tunnistautuminenEpaonnistui.title":"Tunnistautuminen sovellukseen keskeytyi.","kirjaudu.tunnistautuminenEpaonnistui.return":"Palaa etusivulle","Accessibility.title":"Saavutettavuusseloste","Accessibility.tervetuloa":"Tervetuloa, t\xe4m\xe4 on organisaation Luonnonvarakeskus saavutettavuusseloste","Accessibility.lakiperuste":"T\xe4m\xe4 saavutettavuusseloste koskee palvelua <a>https://sato.luke.fi</a> ja on laadittu / p\xe4ivitetty 21.09.2022. Palvelua koskee laki digitaalisten palvelujen tarjoamisesta, jossa edellytet\xe4\xe4n, ett\xe4 julkisten verkkopalvelujen on oltava saavutettavia.","Accessibility.arviointi":"Olemme arvioineet palvelun saavutettavuuden itse","Accessibility.saavutettavuustila":"Digipalvelun saavutettavuuden tila","Accessibility.tayttaaVaatimukset":"T\xe4ytt\xe4\xe4 saavutettavuusvaatimukset osittain.","Accessibility.saavuttamatonsisalto":"Ei-saavutettava sis\xe4lt\xf6","Accessibility.eiVaatimustenMukainen":"Verkkosivusto ei ole viel\xe4 kaikilta osin vaatimusten mukainen","Accessibility.mobiilikaytto":"Komponenttien toiminta mobiilik\xe4yt\xf6ss\xe4","Accessibility.mobiilikaytto.teksti":"Mobiilik\xe4yt\xf6ss\xe4 osa verkkosivun komponenteista toimivat eri tavalla, kuin tietokoneella. Saavutettavuustestausta ei ole tehty mobiilisivustolle. (WCAG 1.4.13)","Accessibility.pdfLuettavuus":"Sivustolta ladattavan PDF-tiedoston luettavuus","Accessibility.pdfLuettavuus.teksti":"Sivusto tarjoaa kyselyyn vastanneelle mahdollisuutta ladata omista vastauksistaan PDF-tiedoston. T\xe4m\xe4n tiedosto koostetaan sivulla n\xe4kyv\xe4st\xe4 yhteenvedosta ja on tarjottu lis\xe4toiminto k\xe4ytt\xe4j\xe4lle. K\xe4ytt\xe4j\xe4 saa samat tiedot sivuston k\xe4ytt\xf6liittym\xe4n kautta saavutettavasti. <br />Ladattavan PDF-tiedoston saavutettavuus ei toteudu kaikilta osin t\xe4ydellisesti. Tietokoneelle ladatun tiedoston saavutettavuudessa on joitakin haasteita. (WCAG 1.3.1).","Accessibility.saavutettavuuspuute":"Huomasitko saavutettavuuspuutteen digipalvelussamme? Kerro se meille ja teemme parhaamme puutteen korjaamiseksi","Accessibility.sahkopostilla":"S\xe4hk\xf6postilla","Accessibility.kirjaamo":"kirjaamo@luke.fi","Accessibility.muillatavoin":"Muilla tavoin","Accessibility.muillatavoin.teksti":"Jos huomaat sivustollamme saavutettavuusongelmia, niin kerrothan niist\xe4 meille. L\xe4het\xe4 saavutettavuutta koskeva palautteesi osoitteeseen kirjaamo@luke.fi. Vastaamme palautteeseesi 14 p\xe4iv\xe4n sis\xe4ll\xe4. <br /> <br /> Huomaathan, ett\xe4 voit my\xf6s pyyt\xe4\xe4 lis\xe4tietoja osoitteesta kirjaamo@luke.fi, mik\xe4li tarvitsemasi tieto ei ole saavutettavassa muodossa verkkosivuillamme. Vastaamme pyynt\xf6\xf6si 14 p\xe4iv\xe4n sis\xe4ll\xe4. Jos pyynt\xf6 koskee laajaa sis\xe4lt\xf6\xe4, voimme jatkaa vastausaikaa enint\xe4\xe4n kahdella viikolla. <br /> <br /> Tiedonkeruusovellusten k\xe4ytt\xf6ongelmiin liittyviss\xe4 kysymyksiss\xe4 voit ottaa yhteytt\xe4 osoitteeseen tilastokyselyt@luke.fi. Tilastollisten tiedonkeruiden aikana Luonnonvarakeskus auttaa tiedonluovuttajia antamaan tiedot tarvittaessa vaihtoehtoisella tavalla.","Accessibility.valvontaviranomainen":"Valvontaviranomainen","Accessibility.valvontaviranomainen.teksti":"Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta meille eli sivuston yll\xe4pit\xe4j\xe4lle. Vastauksessa voi menn\xe4 14 p\xe4iv\xe4\xe4. Jos et ole tyytyv\xe4inen saamaasi vastaukseen tai et saa vastausta lainkaan kahden viikon aikana, <a href=\\"https://www.saavutettavuusvaatimukset.fi/oikeutesi/\\" target=\\"_blank\\"> voit tehd\xe4 ilmoituksen Etel\xe4-Suomen aluehallintovirastoon <span>Avautuu uuteen ikkunaan</span></a> . Etel\xe4-Suomen aluehallintoviraston sivulla kerrotaan tarkasti, miten ilmoituksen voi tehd\xe4 ja miten asia k\xe4sitell\xe4\xe4n.","Accessibility.valvontaYhteystiedot":"Valvontaviranomaisen yhteystiedot","Accessibility.valvontaYhteystiedot.teksti":"Etel\xe4-Suomen aluehallintovirasto <br /> Saavutettavuuden valvonnan yksikk\xf6 <br /> www.saavutettavuusvaatimukset.fi <br /> saavutettavuus(at)avi.fi <br /> puhelinnumero vaihde 0295 016 000","Accessibility.saavutettavuudenParantaminen":"Teemme jatkuvasti ty\xf6t\xe4 saavutettavuuden parantamiseksi","Accessibility.tarjoammeTukea":"Tarjoamme tukea k\xe4ytt\xe4jille joille digipalvelut eiv\xe4t ole saavutettavissa","Accessibility.tarjoammetukea.teksti":"Mik\xe4li k\xe4ytt\xe4j\xe4 ei pysty vastaamaan lakis\xe4\xe4teiseen tiedonkeruuseen tiedonkeruulomaketta k\xe4ytt\xe4en, Luonnonvarakeskus on puhelimitse yhteydess\xe4 n\xe4ihin henkil\xf6ihin tietojen saamiseksi.","Accessibility.julkaisu":"T\xe4m\xe4 verkkosivusto/sovellus on julkaistu","Accessibility.julkaisu.pvm":"29.09.2022","common.app":"Satosovellus","common.logout":"Kirjaudu ulos","common.edellinen":"Edellinen","common.seuraava":"Seuraava","common.kirjautumisvirhe":"Vastaajatunnus on virheellinen.","common.syota_vastaajatunnus":"Vastaajatunnus","common.l\xe4het\xe4":"L\xe4het\xe4","common.hello":"Hei","common.fi":"Suomeksi","common.se":"P\xe5 svenska","common.satotilastokysely":"Satotilastokysely","common.satotilastokysely.luomu":"Satotilastokysely luomu","common.peruna":"Perunan sato ja varastot","common.loggedOut":"Olet kirjautunut ulos. Tilastokyselyihin annetut vastaukset tallentuvat automaattisesti.","common.timedOut":"Istuntosi on vanhentunut ja tiedot tallennettu automaattisesti. Kirjaudu uudelleen sis\xe4\xe4n jatkaaksesi.","common.toFrontpage":"Palaa etusivulle","common.uusilomake":"Palaa alkuun","common.kiitos":"Kiitos vastauksistasi!","common.tilatunnus":"Tilatunnus","common.status":"Vastauksen tila","common.download_pdf":"Lataa PDF","common.kiitosTekstiSato1.1":"Kiitos vastauksesta satotilastokyselyyn.","common.kiitosTekstiSato1.2":"Voit muuttaa vastauksiasi 30.10. saakka. Jos teet vastauksiin muutoksia, l\xe4het\xe4 kysely uudelleen.","common.kiitosTekstiPeruna1.1":"Kiitos vastauksesta perunan h\xe4vikki- ja varastokyselyyn.","common.kiitosTekstiPeruna1.2":"Voit muuttaa vastauksiasi 30.10. klo 23.59 saakka. Jos teet vastauksiin muutoksia, l\xe4het\xe4 kysely uudelleen.","common.kiitosTilastoteksti":"Antamiasi tietoja k\xe4ytet\xe4\xe4n Luonnonvarakeskuksen tilastojulkistuksissa. Voit tilata Luken tilastojulkistukset s\xe4hk\xf6postiisi sivulta","common.kiitosTilastolinkki":"https://www.luke.fi/fi/form/subscribe-to-releases","common.kiitos.linkiteksti":"Tilaa tilastojulkistuksia","common.eiEsit\xe4ytt\xf6tietoja":" Tietojemme mukaan et viljele t\xe4h\xe4n osioon liittyvi\xe4 kasvilajeja. Voit jatkaa seuraavaan osioon painamalla <b>Seuraava</b> -painiketta.","common.tuntematonVirheOtsikko":"Tapahtui virhe.","common.tuntematonVirheViesti":"P\xe4ivit\xe4 sivu yritt\xe4\xe4ksesi uudelleen.","virhe.404.sivuaEiLoytynyt.virhe":"Hakemaasi sivua ei l\xf6ytynyt.","virhe.404.sivuaEiLoytynyt.ohje.alku":"P\xe4\xe4set sivun alkuun","virhe.404.sivuaEiLoytynyt.ohje.linkki":"t\xe4st\xe4","virhe.404.kysymyssarjaaEiLoytynyt.virhe":"Hakemaasi kysymyssarjaa ei l\xf6ytynyt.","virhe.404.kysymyssarjaaEiLoytynyt.ohje":"Valitse haluamasi kysymyssarja valikosta.","virhe.errorboundary.kysymyssarja.virhe":"Tapahtui virhe.","virhe.errorboundary.kysymyssarja.ohje":"Yrit\xe4 valita haluamasi kysymyssarja uudelleen valikosta.","virhe.errorboundary.router.virhe":"Tapahtui virhe.","virhe.errorboundary.router.ohje":"P\xe4ivit\xe4 sivu yritt\xe4\xe4ksesi uudelleen.","virhe.palvelin.tallennus":"Tallennus palvelimelle ep\xe4onnistui. Yrit\xe4 kohta uudelleen.","virhe.palvelin.luku":"Luku palvelimelta ep\xe4onnistui. Yrit\xe4 kohta uudelleen p\xe4ivitt\xe4m\xe4ll\xe4 sivu.","muutViljelyKasvit.title":"Muut viljelykasvit","muutViljelyKasvit.oljykasvit.title":"\xd6ljykasvit","muutViljelyKasvit.oljykasvit.kev\xe4trypsi":"Kev\xe4trypsi","muutViljelyKasvit.oljykasvit.kev\xe4trapsi":"Kev\xe4trapsi","muutViljelyKasvit.oljykasvit.syysrypsi":"Syysrypsi","muutViljelyKasvit.oljykasvit.syysrapsi":"Syysrapsi","muutViljelyKasvit.kumina":"Kumina","muutViljelyKasvit.kumina.ohjeteksti.Viljelyala":"Viljelyala sis\xe4lt\xe4\xe4 sen tukihakemukseen ilmoitetun kumina-alan, jota on viljelty samalla peltolohkolla vuosina {{ed_vuosi}} ja {{vuosi}}. Anna tiedot korjatulta kumina-alalta. Viljely- ja korjuualat eiv\xe4t saa sis\xe4lt\xe4\xe4 alaa, jolta satoa korjataan tulevina vuosina.","muutViljelyKasvit.tattari":"Tattari","muutViljelyKasvit.sokerijuurikas":"Sokerijuurikas","muutViljelyKasvit.timoteinsiemen":"Timoteinsiemen","muutViljelyKasvit.oljykasvit.\xf6ljypellava":"\xd6ljypellava","muutViljelyKasvit.oljykasvit.\xf6ljyhamppu":"\xd6ljyhamppu","muutViljelyKasvit.viljelyala":"Viljelyala","muutViljelyKasvit.korjuuala":"Korjuuala","muutViljelyKasvit.ohjeteksti.KiljelyalaOhje":"Viljelyala on esit\xe4ytetty tukihakemuksen tiedoilla vuosilta 2021 ja 2022.","muutViljelyKasvit.ohjeteksti.KorjuualaOhje":"Ilmoita korjuualaan vain korjattu viljelyala. Korjuuala ei saa sis\xe4lt\xe4\xe4 alaa, jolta satoa korjataan tulevina vuosina.","muutViljelyKasvit.ohjeteksti.tayttoohje":"Viljelyala on esit\xe4ytetty tukihakemuksen tiedoilla. Lis\xe4\xe4 siihen tarvittaessa pystyyn ostettu ala ja v\xe4henn\xe4 pystyyn myyty ala.","common.ha":"ha","common.kg":"kg","common.kg-ha":"kg/ha","common.ei":"Ei","common.kyll\xe4":"Kyll\xe4","sato.title":"Satotilastokysely","sato.description1.1":"Tervetuloa vastaamaan tilastokyselyyn, jossa selvitet\xe4\xe4n vuoden 2022 peltokasvituotantoa Suomessa.","sato.description1.1.2":"Kyselyss\xe4 on mukana noin 6 200 erikokoista ja erilaista tuotantoa harjoittavaa maatilaa eri puolilta Suomea. N\xe4ist\xe4 tiloista luomutuotannossa on noin 700 tilaa.","sato.description1.2":"Maatilanne osalta kysely sis\xe4lt\xe4\xe4 peltokasvien kylv\xf6- ja korjuualat sek\xe4 kokonaissadot, syyskylv\xf6alat sek\xe4 viljan varastom\xe4\xe4r\xe4t.","sato.description1.2.1":"Luomutuotantoa harjoittavilta tiloilta kysyt\xe4\xe4n vain luomutuotannossa olevan peltoalan tiedot. Tiedoista koostetaan Suomen virallisia tilastoja, joista t\xe4rkein on satotilasto.","sato.luovutus":"Yksikk\xf6tason tietoja ei luovuteta miss\xe4\xe4n olosuhteissa hallinnollista p\xe4\xe4t\xf6ksentekoa, tutkintaa, valvontaa tai muuta vastaavaa k\xe4ytt\xf6\xe4 varten.","peruna.title":"Perunan sato ja varastot","peruna.description1.1":"Tervetuloa vastaamaan tilastokyselyyn, jossa selvitet\xe4\xe4n maatilojen varastoissa olevan ruoka- ja ruokateollisuusperunan m\xe4\xe4r\xe4\xe4 sek\xe4 t\xe4m\xe4n vuoden peltokasvituotantoa Suomessa.","peruna.description1.2":"Kyselyss\xe4 on mukana noin 200 maatilaa eri puolilta Suomea. Tiedoista koostetaan ruokaperuna varastotilasto ja satotilasto.","peruna.ohjeteksti.SatotiedotOhje":"Korjuuala ei sis\xe4ll\xe4 katoalaa","footer.saavutettavuus":"Saavutettavuusseloste","footer.tietosuoja":"Tietosuojaseloste","ViljanSatotiedot.title":"Viljakasvit","kasvilajit.label":"Kasvilajit","ViljanSatotiedot.ohjeteksti.tayttoohje":"Viljelyala on esit\xe4ytetty tukihakemuksen tiedoilla. Lis\xe4\xe4 siihen tarvittaessa pystyyn ostettu ala ja v\xe4henn\xe4 pystyyn myyty ala.","ViljanSatotiedot.ohjeteksti.ValitseKorjuutapa":"<b>Kuivattava vilja</b> on tuleentunut vilja, joka on kuivattu varastokosteuteen. <b>Tuores\xe4il\xf6vilja</b> on puimalla korjattu, tuoreena s\xe4il\xf6tty jyv\xe4vilja. <b>Kokoviljas\xe4il\xf6rehu</b> on t\xe4hkimisen j\xe4lkeen niitt\xe4m\xe4ll\xe4 korjattu kokonainen viljakasvusto.","ViljanSatotiedot.ohjeteksti.ViljelyalaOhje":"Lis\xe4\xe4 pystyyn ostettu ala ja v\xe4henn\xe4 pystyyn myyty ala.","ViljanSatotiedot.ohjeteksti.KuivattavaViljaKorjuualaOhje":"Korjuuala ei sis\xe4ll\xe4 katoalaa, eik\xe4 pystyyn myyty\xe4 alaa","ViljanSatotiedot.ohjeteksti.KokoviljaS\xe4il\xf6rehuKorjuualaOhje":"Korjuuala ei sis\xe4ll\xe4 katoalaa, eik\xe4 pystyyn myyty\xe4 alaa","ViljanSatotiedot.ohjeteksti.TuoreenaKorjattavaViljaOhje":"Korjuuala ei sis\xe4ll\xe4 katoalaa, eik\xe4 pystyyn myyty\xe4 alaa","ViljanSatotiedot.KuivattavaVilja":"Kuivattava vilja","ViljanSatotiedot.TuoreenaKorjattavaVilja":"Tuores\xe4il\xf6vilja","ViljanSatotiedot.Kokoviljas\xe4il\xf6rehu":"Kokoviljas\xe4il\xf6rehu","ViljanSatotiedot.Vihantavilja":"Vihantavilja","ViljanSatotiedot.ohjeteksti.VihantaviljaKorjuualaOhje":"Alasta v\xe4hennet\xe4\xe4n laidun-ja niittorehuala.","ViljanSatotiedot.lajiohjeet":"Valitse viljellyt kasvilajit ja sy\xf6t\xe4 satotiedot kullekin lajille. Tukihakemuksessa ilmoittamasi kasvilajit on valittu sinulle automaattisesti.","Varastotiedot.title":"Varastovilja","Varastotiedot.ohje":"Ilmoita viljan varastom\xe4\xe4r\xe4 {{heinakuussa}} ja arvio viljan varastom\xe4\xe4r\xe4st\xe4 {{tammikuussa}}. Mukaan lasketaan tilan omistama viljam\xe4\xe4r\xe4, tilan ulkopuoliset varastot sek\xe4 kauppaan ja/tai teollisuuteen myyty vilja, joka on tilan varastossa edell\xe4 mainittuina p\xe4iv\xe4m\xe4\xe4rin\xe4. <b>Ilmoita vain kuivana korjatun viljan varastom\xe4\xe4r\xe4.</b>","Varastotiedot.ohje.luomu":"Ilmoita luomuna tuotetun viljan varastom\xe4\xe4r\xe4 1.7.2022 ja arvio viljan varastom\xe4\xe4r\xe4st\xe4 1.1.2023. Mukaan lasketaan tilan omistama viljam\xe4\xe4r\xe4, tilan ulkopuoliset varastot sek\xe4 kauppaan ja/tai teollisuuteen myyty vilja, joka on tilan varastossa edell\xe4 mainittuina p\xe4iv\xe4m\xe4\xe4rin\xe4. <b>Ilmoita vain kuivana korjatun viljan varastom\xe4\xe4r\xe4.</b>","Varastotiedot.vehn\xe4":"Vehn\xe4","Varastotiedot.ruis":"Ruis","Varastotiedot.kaura":"Kaura","Varastotiedot.ohra":"Ohra","fields.Kuivakorjuuala":"Kuivan sadon korjuuala","fields.Viljelyala":"Viljelyala","fields.KuivattuKokonaism\xe4\xe4r\xe4":"Kuivatun sadon kokonaism\xe4\xe4r\xe4","fields.VarastoarvoHein\xe4kuu":"Viljaa varastossa {{hein\xe4kuu}}","fields.VarastoarvoHein\xe4kuuYhteenveto":"Viljaa varastossa 1.7.2022","fields.VarastoarvoTammikuuArvio":"Viljaa varastosta {{tammikuu}}, arvio","fields.VarastoarvoTammikuuArvioYhteenveto":"Viljaa varastossa 1.1.2023, arvio","fields.onkoVarastossaViljaa":"Varastossa on viljaa","fields.TuoreviljanKorjuuala":"Tuoreviljan korjuuala","fields.TuoresadonKokonaism\xe4\xe4r\xe4":"Tuoresadon kokonaism\xe4\xe4r\xe4","fields.Kokoviljas\xe4il\xf6rehuKorjuuala":"Kokoviljas\xe4il\xf6rehun korjuuala","fields.Kokoviljas\xe4il\xf6rehuKokonaism\xe4\xe4r\xe4":"Kokoviljas\xe4il\xf6rehusadon kokonaism\xe4\xe4r\xe4","fields.KuivaaineProsentti":"Kuiva-aineprosentti","fields.Kosteusprosentti":"Kosteusprosentti","fields.Vihantavilja":"Korjattiinko tilallanne vihantaviljaa?","fields.VihantaviljaKorjuuala":"Korjuuala","fields.VihantaviljaKokonaism\xe4\xe4r\xe4":"Sadon kokonaism\xe4\xe4r\xe4","fields.SadonKokonaism\xe4\xe4r\xe4":"Sadon kokonaism\xe4\xe4r\xe4","fields.Kylvoala":"Kylv\xf6ala","fields.Suorakylvoala":"Suorakylv\xf6ala","fields.KuivasadonSatotaso":"Kuivasadon satotaso kg/ha","fields.TuoresadonSatotaso":"Tuoresadon satotaso kg/ha","fields.Korjuuala":"Korjuuala","fields.Korjuukerta":"Korjuukerta","fields.SatoYhteens\xe4":"Satom\xe4\xe4r\xe4","fields.Niittorehu":"Niittorehu","fields.S\xe4il\xf6rehu":"S\xe4il\xf6rehu, tuore","fields.S\xe4il\xf6rehuEsikuivattu":"S\xe4il\xf6rehu, esikuivattu","fields.Satotaso":"Satotaso","RehunurmenSatotiedot.otsikko.KorjattuRehunurmiala":"Rehunurmiala kasvukaudella","RehunurmenSatotiedot.otsikko.Kokonaissato":"Kokonaissato","RehunurmenSatotiedot.otsikko.Korjuukerrat":"Korjuukerrat kasvukaudella","RehunurmenSatotiedot.tooltip.Korjattuala":"Korjattu rehunurmiala = tukihakemuksessa ilmoitettu rehunurmiala - pystyyn myyty ala - ei korjuuta tai niitetty maahan + pystyyn ostettu","fields.Pystyynmyynti":"Pystyyn myyty","fields.RehunurmialaYhteens\xe4":"Tukihakemuksessa ilmoitettu ala","fields.Pystyynosto":"Pystyyn ostettu","fields.Katoala":"Ei korjuuta tai niitetty maahan","fields.Korjattuala":"Ala, jolta korjattu satoa","fields.ohjeteksti.Esitaytto":"Esit\xe4ytetty tukihakemuksen tiedoilla.","fields.Kuivahein\xe4":"Kuivahein\xe4","fields.S\xe4il\xf6rehunKorjuuala":"S\xe4il\xf6rehun korjuuala","fields.S\xe4il\xf6rehuEsikuivattuKuivaaineProsentti":"Esikuivatun s\xe4il\xf6rehun kuiva-aineprosentti","fields.S\xe4il\xf6rehuKuivaaineProsentti":"Tuoreen s\xe4il\xf6rehun kuiva-aineprosentti","fields.NiittorehuKuivaaineProsentti":"Niittorehun kuiva-aineprosentti","fields.Istutusala":"Istutusala","fields.TuotettuSato":"Tilalla korjattu satoa vuonna {{vuosi}}","fields.Korjaamaton":"Korjaamaton peltoon j\xe4\xe4nyt sato","fields.TuotettuSatoYhteenveto":"Tilalla tuotettu satoa vuonna 2021","fields.Elintarvikek\xe4ytt\xf6\xf6n":"Elintarvikek\xe4ytt\xf6\xf6n p\xe4\xe4tynyt sato","fields.Rehuksi":"Rehuksi p\xe4\xe4tynyt sato","fields.Kompostointiin":"Kompostointiin/bioj\xe4teker\xe4ykseen p\xe4\xe4tynyt sato","fields.Muu":"Muuhun k\xe4ytt\xf6\xf6n p\xe4\xe4tynyt sato","fields.MuuSelite":"Muun k\xe4yt\xf6n selite","fields.KayttoYhteensa":"K\xe4ytt\xf6 yhteens\xe4","fields.muutsyyt":"Syyt, joiden vuoksi satoa k\xe4ytettiin muuhun kuin elintarvikek\xe4ytt\xf6\xf6n","fields.Lis\xe4tiedot":"Lis\xe4tiedot","fields.H\xe4vikkikokolaatu":"Koko, paino, muoto tai muu ulkon\xe4k\xf6\xf6n liittyv\xe4 syy / ostajan kriteerit eiv\xe4t t\xe4yty","fields.H\xe4vikkiSuurisato":"Ennakoitua suurempi sato /sadon valmistuminen ennakoitua aiemmin","fields.H\xe4vikkiMenekkivaikeudet":"Menekkivaikeudet","fields.H\xe4vikkiVarastointitappio":"Varastointitappio","fields.S\xe4\xe4":"S\xe4\xe4","fields.Kokopaino":"Ulkon\xe4k\xf6- ja muut laatuvaatimukset","fields.Nostoh\xe4vikki":"Nostoh\xe4vikki","fields.errors.Min":"Arvo ei voi olla negatiivinen","fields.satotaso":"Satotaso","fields.errors.MaxHundreds":"Arvo saa olla maksimissaan 999,99 ha.","fields.errors.MaxThousands":"Arvo saa olla maksimissaan 9999,99 ha.","fields.errors.MaxMillion":"Arvo saa olla maksimissaan 999 999 kg.","fields.errors.MaxMillions":"Arvo saa olla maksimissaan 9 999 999 kg.","fields.errors.Tuores\xe4il\xf6viljanKosteusprosenttiMin":"Tuores\xe4il\xf6viljan kosteusprosentin on oltava v\xe4hint\xe4\xe4n 11%.","fields.errors.Tuores\xe4il\xf6viljanKosteusprosenttiMax":"Tuores\xe4il\xf6viljan kosteusprosentti voi olla enint\xe4\xe4n 80%.","fields.errors.ViljanKuivaaineProsenttiMin":"Kuiva-aineprosentin on oltava v\xe4hint\xe4\xe4n 12%.","fields.errors.ViljanKuivaaineProsenttiMax":"Kuiva-aineprosentti saa olla enint\xe4\xe4n 80%.","fields.errors.ValkuaiskasvienKosteusprosenttiMin":"Valkuaiskasvisadon kosteusprosentin on oltava v\xe4hint\xe4\xe4n 5%.","fields.errors.ValkuaiskasvienKosteusprosenttiMax":"Valkuaiskasvisadon kosteusprosentti voi olla enint\xe4\xe4n 50%.","fields.errors.ValkuaiskasvienKuivaaineProsenttiMin":"Valkuaiskasvisadon kuiva-aineprosentin on oltava v\xe4hint\xe4\xe4n 12%.","fields.errors.ValkuaiskasvienKuivaaineProsenttiMax":"Valkuaiskasvisadon kuiva-aineprosentti voi olla enint\xe4\xe4n 80%.","fields.errors.\xd6ljykasvienKosteusprosenttiMin":"\xd6ljykasvisadon kosteusprosentin on oltava v\xe4hint\xe4\xe4n 5%.","fields.errors.\xd6ljykasvienKosteusprosenttiMax":"\xd6ljykasvisadon kosteusprosentti voi olla enint\xe4\xe4n 50%.","fields.errors.S\xe4il\xf6rehuMax":"S\xe4il\xf6rehun satom\xe4\xe4r\xe4 saa olla enint\xe4\xe4n 99 999 999 kg.","fields.errors.NurmirehuKuivaaineProsenttiMin":"Rehunurmen kuiva-aineprosentin on oltava v\xe4hint\xe4\xe4n 10%.","fields.errors.NurmirehuKuivaaineProsenttiMax":"Rehunurmen kuiva-aineprosentti voi olla enint\xe4\xe4n 60%","fields.errors.S\xe4il\xf6rehuEsikuivattuKuivaaineprosenttiMin":"Esikuivatun s\xe4ili\xf6rehun kuiva-aineprosentin on oltava v\xe4hint\xe4\xe4n 15%.","fields.errors.S\xe4il\xf6rehuEsikuivattuKuivaaineprosenttiMax":"Esikuivatun s\xe4ili\xf6rehun kuiva-aineprosentti voi olla enint\xe4\xe4n 70%.","fields.errors.S\xe4il\xf6rehuSatoYhteens\xe4":"S\xe4il\xf6rehusadon on oltava enemm\xe4n kuin 0 kg.","fields.errors.S\xe4il\xf6rehuSatoYhteens\xe4Max":"S\xe4il\xf6rehusato voi olla enint\xe4\xe4n 99 999 999 kg.","fields.errors.PercentageMaxSadonk\xe4ytt\xf6":"K\xe4yt\xf6n yhteenlaskettu prosenttim\xe4\xe4r\xe4 voi olla enint\xe4\xe4n 100%.","fields.errors.yliKylv\xf6alan":"Suorakylv\xf6ala ei saa olla suurempi kuin kylv\xf6ala.","fields.errors.yliViljelyalan":"Korjuuala ei saa ylitt\xe4\xe4 viljelyalaa.","fields.errors.yliIstutusalan":"Korjuuala ei saa ylitt\xe4\xe4 istutusalaa.","fields.errors.kuivattuSatoRequired":"Ilmoita kuivatun sadon kokonaism\xe4\xe4r\xe4.","fields.errors.korjuualaRequired":"Ilmoita korjuuala. Jos et ole korjannut satoa, ilmoita korjuualaksi 0.","fields.errors.korjuualaValkuaiskasvitRequired":"Ilmoita korjuuala v\xe4hint\xe4\xe4n yhdelle korjuutavalle. Jos et ole korjannut satoa, ilmoita korjuualaksi 0.","fields.errors.kuivakorjuualaRequired":"Ilmoita kuivan sadon korjuuala.","fields.errors.tuoresatoRequired":"Ilmoita tuoresadon kokonaism\xe4\xe4r\xe4.","fields.errors.kosteusprosenttiRequired":"Ilmoita kosteusprosentti.","fields.errors.kuivaaineprosenttiRequired":"Ilmoita kuiva-aineprosentti.","fields.errors.sadonKokonaism\xe4\xe4r\xe4Required":"Ilmoita sadon kokonaism\xe4\xe4r\xe4.","fields.errors.kokoviljas\xe4il\xf6rehukorjuualaRequired":"Ilmoita sadon kokonaism\xe4\xe4r\xe4.","fields.errors.kokoviljas\xe4il\xf6rehusatoRequired":"Ilmoita sadon kokonaism\xe4\xe4r\xe4.","fields.errors.tuorekorjuualaRequired":"Ilmoita tuoreviljan korjuuala.","fields.errors.myym\xe4tt\xe4J\xe4\xe4nytRequired":"Ilmoita myym\xe4tt\xe4 j\xe4\xe4neen sadon m\xe4\xe4r\xe4 kiloissa. Jos satoa ei ole j\xe4\xe4nyt myym\xe4tt\xe4, anna kentt\xe4\xe4n luku 0.","fields.errors.korjaamattaJ\xe4\xe4nytRequired":"Ilmoita korjaamattoman, peltoon j\xe4\xe4neen sadon m\xe4\xe4r\xe4 kiloissa. Jos satoa ei ole j\xe4\xe4nyt korjaamatta, anna kentt\xe4\xe4n luku 0.","fields.errors.muuviljarequired":"Anna satotiedot. Jos sinulla ei ole viljelyalaa esimerkiksi pystyyn myynnin takia, ilmoita viljelyalaksi 0.","fields.errors.korjuutaparequired":"Valitse ainakin yksi korjuutapa. Jos et ole korjannut satoa, sy\xf6t\xe4 viljelyalaksi 0.","fields.validation.numberRequired":"Sy\xf6t\xe4 numeroarvo.","fields.validation.positiveNumberRequired":"Sy\xf6t\xe4 numeroarvo joka on suurempi kuin nolla.","fields.errors.viljelyalaRequired":"Viljelyala on pakollinen tieto. Jos viljelyala poikkeaa EU-tukihakemukseen ilmoitetusta tiedosta, ilmoita uusi ala tai merkitse kentt\xe4\xe4n luku 0, jos olet esimerkiksi myynyt pystyyn koko alan.","syyskylvot.title":"Syyskylv\xf6t","fields.errors.korjuu1eroaakokonaiskorjuusta":"Antamasi tiedot eiv\xe4t t\xe4sm\xe4\xe4. Ensimm\xe4isen korjuun hehtaarialojen summa tulee olla yht\xe4 suuri, kuin Korjattu rehunurmiala -kent\xe4ss\xe4 oleva luku. Erotus on {{erotus}}.","fields.errors.korjuu2eroaakokonaiskorjuusta":"Antamasi tiedot eiv\xe4t t\xe4sm\xe4\xe4. Toisen korjuun hehtaarialojen summan tulee olla yht\xe4 suuri tai v\xe4hemm\xe4n kuin korjattu rehunurmiala. Erotus on {{erotus}}.","fields.errors.korjuu3eroaakokonaiskorjuusta":"Antamasi tiedot eiv\xe4t t\xe4sm\xe4\xe4. Kolmannen korjuun hehtaarialojen summan tulee olla yht\xe4 suuri tai v\xe4hemm\xe4n kuin korjattu rehunurmiala. Erotus on {{erotus}}.","fields.errors.rehunurmensatotiedot.kokonaissatovastaakorjuuta":"Kokonaissato ei voi olla tyhj\xe4 tai nolla, sill\xe4 kasvukaudella on ilmoitettu korjuualaa. Anna satom\xe4\xe4r\xe4 kiloissa.","fields.errors.rehunurmensatotiedot.kokonaissadonkuivaaineprosenttiannettu":"Kuiva-aineprosentti ei voi olla tyhj\xe4, sill\xe4 kokonaissadon m\xe4\xe4r\xe4 on annettu. Ilmoita sadon kuiva-aineprosentti.","fields.errors.satotaso.hehtaarisatoylitt\xe4\xe4sallitunarvon":"Hehtaarisato ylitt\xe4\xe4 sallitun arvon. Tarkista sadon korjuuala ja kokonaism\xe4\xe4r\xe4.","fields.errors.peruna.k\xe4ytt\xf6yhteens\xe4":"K\xe4ytt\xf6kohteiden yhteenlaskettu prosenttiluku on {{prosenttiYhteensa}}%. Luvun tulee olla tasan 100%.","syyskylvot.ohjeteksti.ohje":"Ilmoita hehtaarit, jotka tilan peltoalasta on kylvetty syksyll\xe4 {{vuosi}}.","syyskylvot.ohjeteksti.selitys":"Suorakylv\xf6alalla tarkoitetaan, ett\xe4 kylv\xf6 tehty edelt\xe4v\xe4n kasvin s\xe4nkeen.","syyskylvot.ohjeteksti.SuorakylvoalaOhje":"Kylv\xf6 tehty edelt\xe4v\xe4n kasvin s\xe4nkeen.","syyskylvot.syysvehna":"Syysvehn\xe4","syyskylvot.syysohra":"Syysohra","syyskylvot.syysrypsi":"Syysrypsi","syyskylvot.syysruis":"Syysruis","syyskylvot.syysrapsi":"Syysrapsi","syyskylvot.syysvehna.spelttivehna":"(sis. spelttivehn\xe4n)","ValkuaiskasvienSatotiedot.title":"Valkuais- ja \xf6ljykasvit","ValkuaiskasvienSatotiedot.KuivattavaKasvi":"Puitu siemen","ValkuaiskasvienSatotiedot.Korjuutiedot":"Korjuutiedot","ValkuaiskasvienSatotiedot.S\xe4il\xf6rehu":"S\xe4il\xf6rehu","ValkuaiskasvienSatotiedot.ohjeteksti.tayttoohje":"Viljelyala on esit\xe4ytetty tukihakemuksen tiedoilla. Lis\xe4\xe4 siihen tarvittaessa pystyyn ostettu ala ja v\xe4henn\xe4 pystyyn myyty ala. ","RehunurmenSatotiedot.ohjeteksti":"Esit\xe4ytetty","RehunurmenSatotiedot.ohjeteksti1":"sis\xe4lt\xe4\xe4 kuivahein\xe4-, s\xe4il\xf6rehu- ja tuorerehunurmena ilmoitetun alan. Anna ensin erikseen rehunurmialat, jotka on","RehunurmenSatotiedot.ohjeteksti_a":"myyty pystyyn,","RehunurmenSatotiedot.ohjeteksti_b":"ei korjattu kertaakaan kasvukaudella (niitetty maahan tai ei korjattu kertaakaan) tai","RehunurmenSatotiedot.ohjeteksti_c":"ostettu pystyyn.","RehunurmenSatotiedot.tukihakemus":"tukihakemuksessa ilmoitettu ala","RehunurmenSatotiedot.ohjeteksti2":"Anna jokaiselta korjuukerralta korjatun rehun alat (ha).","RehunurmenSatotiedot.ohjeteksti3":"Anna jokaisesta rehusta kokonaissato (kg) s\xe4il\xf6nt\xe4kosteudessa. Anna my\xf6s ilmoittamasi kokonaissadon kuiva-aine-%.","RehunurmenSatotiedot.Kuivahein\xe4":"Kuivahein\xe4","RehunurmenSatotiedot.Kuivahein\xe4n":"Kuivahein\xe4n","RehunurmenSatotiedot.S\xe4il\xf6rehu":"S\xe4il\xf6rehu, tuores\xe4il\xf6tty","RehunurmenSatotiedot.Tuores\xe4il\xf6ttyS\xe4il\xf6rehun":"Tuores\xe4il\xf6tyn s\xe4il\xf6rehun","RehunurmenSatotiedot.S\xe4il\xf6rehuEsikuivattu":"S\xe4il\xf6rehu, esikuivattu","RehunurmenSatotiedot.EsikuivattuS\xe4il\xf6rehun":"Esikuivatun s\xe4il\xf6rehun","RehunurmenSatotiedot.Niittorehu":"Niittorehu","RehunurmenSatotiedot.title":"Rehunurmi","PerunanSatotiedot.title":"Peruna","PerunanSatotiedot.Ruokaperuna":"Ruokaperuna","PerunanSatotiedot.Ruokateollisuusperuna":"Ruokateollisuusperuna","PerunanSatotiedot.Varhaisperuna":"Varhaisperuna","PerunanSatotiedot.T\xe4rkkelysperuna":"T\xe4rkkelysperuna","PerunanSatotiedot.Siemenperuna":"Siemenperuna","PerunanSatotiedot.ohjeteksti.tayttoohje":"Vain omaan k\xe4ytt\xf6\xf6n viljelty\xe4 perunaa ei tarvitse ilmoittaa.","PerunanSatotiedot.ohjeteksti.VarastossaOhje":"Omalla tilalla viljellyn kauppakelpoisen perunan varastom\xe4\xe4r\xe4 15.10.2022. Mukaan lasketaan sek\xe4 tilan omassa varastossa ett\xe4 tilan ulkopuolella vuokravarastossa oleva perunam\xe4\xe4r\xe4.Mukaan ei lasketa omassa varastossa olevaa muilta viljelij\xf6ilt\xe4 ostettua tai muiden tuottamaa vuokravarastoitua perunam\xe4\xe4r\xe4\xe4","PerunanSatotiedot.ohjeteksti.KorjuualaOhje":"Korjuuala ei sis\xe4ll\xe4 katoalaa","PerunanSatotiedotYhteensa.ohjeteksti.yhteenveto":"Alla yhteenveto antamistasi tiedoista. Muokkaa yll\xe4 olevia tietoja tarvittaessa.","PerunanSatotiedotYhteensa.otsikko":"Yhteens\xe4","fields.Sadostamyyty1510":"Sadosta myyty 15.10. menness\xe4","fields.Varastossa1510":"Varastossa 15.10.","fields.KorjaamatonSatoVaadittu":"Jos peltoon j\xe4\xe4nytt\xe4 korjaamatonta satoa ei ole, ilmoita nolla.","fields.KorjaamatonSato":"Korjaamaton sato","fields.MuuSyy":"Muu syy, esimerkiksi ty\xf6voiman saatavuus tai konerikko","fields.MuuSyyKasvistenSadonk\xe4ytt\xf6Tilalla":"Muu syy, esimerkiksi t\xe4rkkelysperunatehdas","fields.satoakorjaamatta":"Syyt, jonka vuoksi satoa j\xe4i korjaamatta:","fields.IstutusalaYhteens\xe4":"Istutusala yhteens\xe4","fields.KorjattuAlaYhteens\xe4":"Korjattu ala yhteens\xe4","fields.KorjaamatonAlaYhteens\xe4":"Korjaamaton ala yhteens\xe4","Lis\xe4tiedot.title":"Lis\xe4tiedot","PerunanSatojaVarastot.title":"Perunan sato ja varastot","PerunanLis\xe4tiedot.title":"Lis\xe4tiedot","KasvistenSadonk\xe4ytt\xf6.title":"Vuoden {{ed_vuosi}} sadonk\xe4ytt\xf6 tilalla","KasvistenSadonk\xe4ytt\xf6.K\xe4yt\xf6nOhje":"Ilmoita, mihin korjattu sato on k\xe4ytetty. Jos m\xe4\xe4rist\xe4 ei ole tarkkaa tietoa, arvion voi tehd\xe4 aikaisempien vuosien keskiarvon mukaan. T\xe4h\xe4n sis\xe4ltyy kaikki omalla tilalla tapahtuva toiminta (varastointi, kauppakunnostus, pakkaaminen) ennen mahdollista jatkojalostusta.","KasvistenSadonk\xe4ytt\xf6.H\xe4vikkisyytOtsikko":"Mist\xe4 syist\xe4 osa korjatusta sadosta p\xe4\xe4tyi muuhun kuin elintarvike- tai rehuk\xe4ytt\xf6\xf6n?","KasvistenSadonk\xe4ytt\xf6.K\xe4ytt\xf6kohteetOtsikko":"Mihin k\xe4ytt\xf6kohteisiin korjattu sato p\xe4\xe4tyi?","KasvistenSadonk\xe4ytt\xf6.K\xe4ytt\xf6kohteetOhje":"Arvioi, kuinka suuri osa viime syksyn\xe4 korjatusta kuorip\xe4\xe4llisest\xe4 perunasta p\xe4\xe4tyi alla oleviin eri  k\xe4ytt\xf6kohteisiin.","KorjaamatonSato.title":"Peltoon j\xe4\xe4nyt korjaamaton sato","KorjaamatonSato.K\xe4yt\xf6nOhje":"Jos peltoon j\xe4\xe4nytt\xe4 korjaamatonta satoa ei ole, ilmoita kohtaan nolla.","KorjaamatonSato.KorjaamatonSyytOhje":"Arvioi mist\xe4 syist\xe4 satoa j\xe4i korjaamatta. Valitse 1-2 t\xe4rkeint\xe4 syyt\xe4.","perunanSato.title":"Perunan satotiedot","confirmdialog.title":"Sivulla on tallentamattomia tietoja","confirmdialog.content":"Sivulla on tallentamattomia tietoja. Jos siirryt toiseen osioon, n\xe4m\xe4 tiedot menetet\xe4\xe4n. Jos haluat tallentaa tiedot, valitse Palaa ja paina Seuraava-painiketta sivun oikeassa alalaidassa.","confirmdialog.back":"Palaa","confirmdialog.continue":"Jatka tallentamatta tietoja","lis\xe4tiedot.ohjeteksti":"Tarkenna antamiasi tietoja tarvittaessa. Voit esimerkiksi kertoa, miksi satotiedot poikkeavat normaalista.","yhteenveto.title":"Yhteenveto","yhteenveto.ohjeteksti":"<p>Alla n\xe4et yhteenvedon antamistasi vastauksista. Tarkista antamasi tiedot. Saat tallennettua vastaukset painamalla painiketta <b>Lataa PDF</b>. Vastausten tallentaminen on mahdollista my\xf6s niiden l\xe4hett\xe4misen j\xe4lkeen.</p><p>Kun kaikki vaaditut tiedot on annettu, paina <b>L\xe4het\xe4</b>. Voit palata muokkaamaan vastauksia tietojen l\xe4hett\xe4misen j\xe4lkeen. Muutokset p\xe4ivittyv\xe4t, kun l\xe4het\xe4t tiedot uudelleen.</p>","status.aloittamaton":"Aloittamaton","status.kesken":"Kesken","status.l\xe4hetetty":"L\xe4hetetty"}');


var $aeffdc676e79244a$exports = {};
$aeffdc676e79244a$exports = JSON.parse('{"kirjaudu.title":"V\xe4llkommen till Naturresursinstitutets applikation!","kirjaudu.ohjeteksti1.1":"kirjaudu.ohjeteksti1.1","kirjaudu.ohjeteksti1.2":"kirjaudu.ohjeteksti1.2","kirjaudu.ohjeteksti1":"V\xe4lkommen att svara till Naturresursinstitutets elektroniska datainsamling. Uppgifterna du l\xe4mnar behandlas konfidentiellt och de anv\xe4nds endast f\xf6r statistiska \xe4ndam\xe5l.","kirjaudu.suomifi":"Identifiera dig","kirjaudu.tunnistautuminenEpaonnistui.title":"","kirjaudu.tunnistautuminenEpaonnistui.return":"G\xe5 till startsidan","common.app":"","common.logout":"Logga ut","common.edellinen":"F\xf6reg\xe5ende sida","common.seuraava":"Forts\xe4tt till n\xe4sta","common.kirjautumisvirhe":"","common.syota_vastaajatunnus":"Svararkoden","common.l\xe4het\xe4":"Skicka","common.hello":"Hej","common.fi":"Suomeksi","common.se":"P\xe5 svenska","common.satotilastokysely":"Statistikf\xf6rfr\xe5gan om sk\xf6rden","common.peruna":"Sk\xf6rd av potatis samt lagerm\xe4ngd","common.loggedOut":"","common.timedOut":"","common.toFrontpage":"G\xe5 till startsidan","virhe.404.sivuaEiLoytynyt.virhe":"Sidan kunde inte hittas","virhe.404.sivuaEiLoytynyt.ohje.alku":"","virhe.404.sivuaEiLoytynyt.ohje.linkki":"","virhe.404.kysymyssarjaaEiLoytynyt.virhe":"","virhe.404.kysymyssarjaaEiLoytynyt.ohje":"","virhe.errorboundary.kysymyssarja.virhe":"","virhe.errorboundary.kysymyssarja.ohje":"","virhe.errorboundary.router.virhe":"","virhe.errorboundary.router.ohje":"","muutViljelyKasvit.title":"Sk\xf6rdar av \xf6vriga odlingsv\xe4xter","muutViljelyKasvit.oljykasvit.title":"","muutViljelyKasvit.oljykasvit.kev\xe4trypsi":"V\xe5rrybs","muutViljelyKasvit.oljykasvit.kev\xe4trapsi":"V\xe5rraps","muutViljelyKasvit.oljykasvit.syysrypsi":"H\xf6strybs","muutViljelyKasvit.oljykasvit.syysrapsi":"H\xf6straps","muutViljelyKasvit.kumina":"Kummin","muutViljelyKasvit.tattari":"Bovete","muutViljelyKasvit.sokerijuurikas":"Sockerbeta","muutViljelyKasvit.timoteinsiemen":"Timotejfr\xf6","muutViljelyKasvit.oljykasvit.\xf6ljypellava":"Oljelin","muutViljelyKasvit.oljykasvit.\xf6ljyhamppu":"Oljehampa","muutViljelyKasvit.viljelyala":"Odlingsareal","muutViljelyKasvit.korjuuala":"Sk\xf6rdeareal","common.ha":"ha","common.kg":"kg","common.kg-ha":"kg/ha","common.ei":"","common.kyll\xe4":"","sato.title":"Statistikf\xf6rfr\xe5gan om sk\xf6rden","sato.description1.1":"V\xe4lkommen att svara p\xe5 en statistikf\xf6rfr\xe5gan om produktionen av \xe5kergr\xf6dor i Finland 2022.","sato.description1.1.2":"I f\xf6rfr\xe5gan deltar cirka 6 200 g\xe5rdar av olika storlekar och med olika produktionsformer runt om i Finland. Av dessa \xe4r cirka 700 g\xe5rdar i ekologisk produktion.","sato.description1.2":"F\xf6rfr\xe5gan till er g\xe5rd inkluderar s\xe5dda och sk\xf6rdade arealer samt totala sk\xf6rdar av \xe5kergr\xf6dor, h\xf6sts\xe5dda arealer samt lagervolymer av spannm\xe5l.","sato.description1.2.1":"G\xe5rdar med ekologisk produktion ombes enbart l\xe4mna uppgifter om den \xe5kerareal som anv\xe4nds f\xf6r ekologisk produktion. Av uppgifterna sammanst\xe4lls Finlands officiella statistik, varav den viktigaste \xe4r sk\xf6rdestatistiken.","sato.luovutus":"Uppgifter p\xe5 objektsniv\xe5 l\xe4mnas underinga omst\xe4ndigheter ut f\xf6r administrativa beslut, unders\xf6kningar, tillsyn ellerannan motsvarande","peruna.title":"Sk\xf6rd av potatis samt lagerm\xe4ngd","peruna.description1.1":"V\xe4lkommen att svara p\xe5 en statistikf\xf6rfr\xe5gan om g\xe5rdarnas lagervolymer av mat- och livsmedelsindustripotatis samt om \xe5rets produktion av \xe5kergr\xf6dor i Finland.","peruna.description1.2":"I f\xf6rfr\xe5gan deltar cirka 200 g\xe5rdar runt om i Finland. Av uppgifterna sammanst\xe4lls statistik \xf6ver lagren av matpotatis och sk\xf6rdestatistik.","peruna.ohjeteksti.SatotiedotOhje":"Korjuuala ei sis\xe4ll\xe4 katoalaa","footer.saavutettavuus":"Tillg\xe4nglighetsutl\xe5tande","footer.tietosuoja":"Dataskyddsbeskrivning","ViljanSatotiedot.title":"Spannm\xe5lssk\xf6rd","kasvilajit.label":"","ViljanSatotiedot.KuivattavaVilja":"Torr s\xe4d","ViljanSatotiedot.TuoreenaKorjattavaVilja":"Ensilerat spannm\xe5l","ViljanSatotiedot.Kokoviljas\xe4il\xf6rehu":"Hels\xe4desensilage","ViljanSatotiedot.Vihantavilja":"Gr\xf6nfoders\xe4d","ViljanSatotiedot.lajiohjeet":"","Varastotiedot.title":"","Varastotiedot.ohje":"","Varastotiedot.vehn\xe4":"Vete","Varastotiedot.ruis":"R\xe5g","Varastotiedot.kaura":"Havre","Varastotiedot.ohra":"Korn","fields.Kuivakorjuuala":"","fields.Viljelyala":"Odlingsareal","fields.KuivattuKokonaism\xe4\xe4r\xe4":"Totalm\xe4ngden av torkad sk\xf6rd","fields.VarastoarvoHein\xe4kuu":"","fields.VarastoarvoTammikuuArvio":"","fields.onkoVarastossaViljaa":"","fields.TuoreviljanKorjuuala":"Sk\xf6rdeareal f\xf6r f\xe4rsk spannm\xe5l","fields.TuoresadonKokonaism\xe4\xe4r\xe4":"Total m\xe4ngd f\xe4rsk sk\xf6rd","fields.Kokoviljas\xe4il\xf6rehuKorjuuala":"Sk\xf6rdeareal f\xf6r hels\xe4desensilage","fields.Kokoviljas\xe4il\xf6rehuKokonaism\xe4\xe4r\xe4":"Total m\xe4ngd f\xf6r sk\xf6rd av hels\xe4desensilage","fields.KuivaaineProsentti":"Torrsubstanshalt i procent","fields.Kosteusprosentti":"Fukthalt i procent","fields.Vihantavilja":"Sk\xf6rdades gr\xf6nfoderspannm\xe5l p\xe5 g\xe5rden?","fields.VihantaviljaKorjuuala":"Sk\xf6rdeareal","fields.VihantaviljaKokonaism\xe4\xe4r\xe4":"Sk\xf6rden totalt","fields.VihantaviljaKuivaaineProsentti":"Torrsubstanshalt i procent","fields.SadonKokonaism\xe4\xe4r\xe4":"Sk\xf6rden totalt","fields.Kylvoala":"S\xe5dd areal","fields.Suorakylvoala":"Direkts\xe5dd areal","fields.KuivasadonSatotaso":"Sk\xf6rdeniv\xe5n f\xf6r torr sk\xf6rd kg/ha","fields.TuoresadonSatotaso":"Sk\xf6rdeniv\xe5n f\xf6r f\xe4rsk sk\xf6rd kg/ha","fields.Korjuuala":"Sk\xf6rdeareal","fields.SatoYhteens\xe4":"Sk\xf6rden totalt","fields.Niittorehu":"Saftfoder","fields.S\xe4il\xf6rehu":"Ensilage, f\xe4rskensilering","fields.S\xe4il\xf6rehuEsikuivattu":"Ensilage, f\xf6rtorkning","fields.Pystyynmyynti":"Areal som s\xe5lts p\xe5 rot","fields.RehunurmialaYhteens\xe4":"Fodervallareal totalt","fields.Kuivahein\xe4":"Torrh\xf6","fields.S\xe4il\xf6rehunKorjuuala":"","fields.S\xe4il\xf6rehuEsikuivattuKuivaaineProsentti":"Torrsubstanshalt f\xf6r f\xf6rtorkat ensilage","fields.S\xe4il\xf6rehuKuivaaineProsentti":"Torrsubstanshalt f\xf6r f\xe4rsk ensilage","fields.NiittorehuKuivaaineProsentti":"Torrsubstanshalt f\xf6r sl\xe5tterfoder","fields.Istutusala":"S\xe5ningsareal","fields.TuotettuSato":"Sk\xf6rd som producerats p\xe5 g\xe5rden \xe5r {{vuosi}}","fields.Elintarvikek\xe4ytt\xf6\xf6n":"Sk\xf6rd som blivit till livsmedel och vidaref\xf6r\xe4dlats","fields.Rehuksi":"Sk\xf6rd som blivit till djurfoder","fields.Kompostointiin":"Sk\xf6rd som komposterats/blivit bioavfall","fields.Energiaksi":"Sk\xf6rd som blivit till energi","fields.Muu":"Sk\xf6rd som anv\xe4nts f\xf6r annat \xe4ndam\xe5l","fields.MuuSelite":"F\xf6rklaring av annan anv\xe4ndning","fields.KayttoYhteensa":"Anv\xe4ndning totalt","fields.Lis\xe4tiedot":"Till\xe4ggs information","fields.H\xe4vikkiKokolaatu":"Storlek, vikt, form eller annan faktor som g\xe4ller utseende och/eller k\xf6parens kriterier uppfylls inte","fields.H\xe4vikkiSuurisato":"St\xf6rre sk\xf6rd \xe4n f\xf6rutsett/sk\xf6rden klar tidigare \xe4n f\xf6rutsett","fields.H\xe4vikkiMenekkivaikeudet":"Avs\xe4ttningsproblem","fields.H\xe4vikkiVarastointitappio":"Lagerf\xf6rlust","fields.Ylituotanto":"\xd6verproduktion, ol\xf6nsamhet och/eller ingen l\xe4mplig k\xf6pare","fields.Kokopaino":"Storlek, vikt, form eller annan faktor som g\xe4ller utseende och/eller k\xf6parens kriterier uppfylls inte","fields.Ty\xf6voimanSaatavuus":"Tillg\xe5ng till arbetskraft","fields.TekninenOngelma":"Tekniskt problem (t.ex. g\xe5r lyftanordningen s\xf6nder)","fields.Korjuutappio":"Sk\xf6rdef\xf6rlust","fields.Kasvitaudit":"V\xe4xtsjukdomar, skadedjur","fields.errors.Min":"Det angivna v\xe4rdet ska vara st\xf6rre \xe4n 0.","fields.satotaso":"Sk\xf6rdeniv\xe5","fields.errors.MaxHundreds":"V\xe4rdet f\xe5r h\xf6gst vara 999,99 ha.","fields.errors.MaxThousands":"V\xe4rdet f\xe5r h\xf6gst vara 9999,99 ha.","fields.errors.MaxMillion":"V\xe4rdet f\xe5r h\xf6gst vara 999 999 kg.","fields.errors.MaxMillions":"V\xe4rdet f\xe5r h\xf6gst vara 9 999 999 kg.","fields.errors.Tuores\xe4il\xf6viljanKosteusprosenttiMin":"Fukthalten f\xf6r f\xe4rsk ensilerad spannm\xe5l ska uppg\xe5 till minst 11\xa0%.","fields.errors.Tuores\xe4il\xf6viljanKosteusprosenttiMax":"Fukthalten f\xf6r f\xe4rsk ensilerad spannm\xe5l f\xe5r vara h\xf6gst 80\xa0%.","fields.errors.ViljanKuivaaineProsenttiMin":"Torrsubstanshalten ska uppg\xe5 till minst 12\xa0%.","fields.errors.ViljanKuivaaineProsenttiMax":"Torrsubstanshalten f\xe5r vara h\xf6gst 80%.","fields.errors.ValkuaiskasvienKosteusprosenttiMin":"Fukthalten f\xf6r proteinv\xe4xtsk\xf6rden ska uppg\xe5 till minst 5\xa0%.","fields.errors.ValkuaiskasvienKosteusprosenttiMax":"Fukthalten f\xf6r proteinv\xe4xtsk\xf6rden f\xe5r vara h\xf6gst 50\xa0%.","fields.errors.ValkuaiskasvienKuivaaineprosenttiMin":"Torrsubstanshalten f\xf6r proteinv\xe4xtsk\xf6rden ska uppg\xe5 till minst 12\xa0%.","fields.errors.ValkuaiskasvienKuivaaineProsenttiMax":"Torrsubstanshalten f\xf6r proteinv\xe4xtsk\xf6rden f\xe5r vara h\xf6gst 80\xa0%.","fields.errors.\xd6ljykasvienKosteusprosenttiMin":"Fukthalten f\xf6r oljev\xe4xtsk\xf6rden ska uppg\xe5 till minst 5\xa0%.","fields.errors.\xd6ljykasvienKosteusprosenttiMax":"Fukthalten f\xf6r oljev\xe4xtsk\xf6rden f\xe5r vara h\xf6gst 50\xa0%.","fields.errors.S\xe4il\xf6rehuMax":"Ensilagesk\xf6rden kan h\xf6gst vara 99 999 999 kg.","fields.errors.NurmirehuKuivaaineProsenttiMin":"Torrsubstanshalten f\xf6r vall ska uppg\xe5 till minst 10\xa0%.","fields.errors.NurmirehuKuivaaineProsenttiMax":"Torrsubstanshalten f\xf6r vall f\xe5r vara h\xf6gst 60%","fields.errors.S\xe4il\xf6rehuEsikuivattuKuivaaineprosenttiMin":"Torrsubstanshalten f\xf6r f\xf6rtorkat ensilage ska uppg\xe5 till minst 15\xa0%.","fields.errors.S\xe4il\xf6rehuEsikuivattuKuivaaineprosenttiMax":"Torrsubstanshalten f\xf6r f\xf6rtorkat ensilage f\xe5r vara h\xf6gst 70\xa0%.","fields.errors.S\xe4il\xf6rehuSatoYhteens\xe4":"Ensilagesk\xf6rden ska uppg\xe5 till mer \xe4n 0 kg.","fields.errors.S\xe4il\xf6rehuSatoYhteens\xe4Max":"Ensilagesk\xf6rden kan h\xf6gst vara 99 999 999 kg.","fields.errors.PercentageMaxSadonk\xe4ytt\xf6":"Den sammanlagda anv\xe4ndningen i procent kan uppg\xe5 till h\xf6gst 100\xa0%.","fields.errors.yliKylv\xf6alan":"Den direkts\xe5dda arealen f\xe5r inte vara st\xf6rre \xe4n s\xe5ddarealen.","fields.errors.yliViljelyalan":"Sk\xf6rdearealen f\xe5r inte \xf6verskrida odlingsarealen.","fields.errors.yliIstutusalan":"Sk\xf6rdearealen f\xe5r inte \xf6verskrida planteringsarealen.","fields.errors.kuivattuSatoRequired":"Ange den totala m\xe4ngden torkad sk\xf6rd.","fields.errors.kuivakorjuualaRequired":"Ange sk\xf6rdearealen f\xf6r torr sk\xf6rd.","fields.errors.tuoresatoRequired":"Ange den totala m\xe4ngden f\xe4rsk sk\xf6rd.","fields.errors.kosteusprosenttiRequired":"Ange fukthalt i procent.","fields.errors.kuivaaineprosenttiRequired":"Ange torrsubstanshalt i procent.","fields.errors.sadonKokonaism\xe4\xe4r\xe4Required":"Ange den totala m\xe4ngden sk\xf6rd.","fields.errors.kokoviljas\xe4il\xf6rehukorjuualaRequired":"Ange den totala m\xe4ngden sk\xf6rd.","fields.errors.kokoviljas\xe4il\xf6rehusatoRequired":"Ange den totala m\xe4ngden sk\xf6rd.","syyskylvot.title":"H\xf6sts\xe5dda arealer och direkts\xe5dda arealer h\xf6sten","syyskylvot.ohjeteksti":"Ange de hektar som s\xe5ddes av g\xe5rdens \xe5kerareal p\xe5 h\xf6sten.","syyskylvot.ohjeteksti1":"Med direkts\xe5dd areal avses att uts\xe4det s\xe5s i sk\xf6rderesterna f\xf6r f\xf6reg\xe5ende v\xe4xt.","ValkuaiskasvienSatotiedot.title":"Sk\xf6rdar av proteingr\xf6dor","ValkuaiskasvienSatotiedot.KuivattavaKasvi":"Torr","ValkuaiskasvienSatotiedot.S\xe4il\xf6rehu":"Ensilage","RehunurmenSatotiedot.Kuivahein\xe4":"Torrh\xf6","RehunurmenSatotiedot.S\xe4il\xf6rehu":"Ensilage, f\xe4rskensilering","RehunurmenSatotiedot.S\xe4il\xf6rehuEsikuivattu":"Ensilage, f\xf6rtorkning","RehunurmenSatotiedot.Niittorehu":"Saftfoder","RehunurmenSatotiedot.title":"Sk\xf6rden av vallfoder","PerunanSatotiedot.title":"Sk\xf6rd av potatis","PerunanSatotiedot.Ruokaperuna":"Matpotatis","PerunanSatotiedot.Ruokateollisuusperuna":"Potatis f\xf6r matindustri","PerunanSatotiedot.Varhaisperuna":"Tidig potatis","PerunanSatotiedot.T\xe4rkkelysperuna":"St\xe4rkelsepotatis","PerunanSatotiedot.Siemenperuna":"S\xe4ttpotatis","fields.Sadostamyyty1510":"Sk\xf6rdem\xe4ngd som s\xe5lts f\xf6re 15.10","fields.Varastossa1510":"M\xe4ngdi lager 15.10","fields.KorjaamatonSatoVaadittu":"Om inga gr\xf6dor p\xe5 rot blivit kvar i \xe5kern, ska du skriva noll i punkten.","fields.KorjaamatonSato":"Gr\xf6dor p\xe5 rot","fields.MuuSyy":"Annan orsak, vilken?","Lis\xe4tiedot.title":"Till\xe4ggs information","PerunanSatojaVarastot.title":"Sk\xf6rd av potatis samt lagerm\xe4ngd","PerunanLis\xe4tiedot.title":"Till\xe4ggs information","KasvistenSadonk\xe4ytt\xf6.title":"Anv\xe4ndningen av vegetabilier p\xe5 g\xe5rden","KasvistenSadonk\xe4ytt\xf6.K\xe4yt\xf6nOhje":"Ange vad sk\xf6rden anv\xe4nts till. Om du inte har de exakta m\xe4ngderna kan du g\xf6ra en uppskattning utifr\xe5n medeltalet f\xf6r tidigare \xe5r. I detta ing\xe5r all verksamhet p\xe5 g\xe5rden (lagring, beredning f\xf6r saluf\xf6ring, f\xf6rpackning) f\xf6re eventuell f\xf6r\xe4dling.","KasvistenSadonk\xe4ytt\xf6.H\xe4vikkisyytOhje":"Bed\xf6m varf\xf6r en del av sk\xf6rden anv\xe4nds f\xf6r n\xe5got annat \xe4n livsmedelsbruk. V\xe4lj 1–2 av de viktigaste orsakerna.","KorjaamatonSato.title":"Gr\xf6dor p\xe5 rot som blivit kvar i \xe5kern","KorjaamatonSato.K\xe4yt\xf6nOhje":"Om inga gr\xf6dor p\xe5 rot blivit kvar i \xe5kern, ska du skriva noll i punkten.","KorjaamatonSato.KorjaamatonSyytOhje":"Bed\xf6m varf\xf6r gr\xf6dorna inte sk\xf6rdades. V\xe4lj 1–2 av de viktigaste orsakerna."}');


const $6c154842fccf6556$var$locizeOptions = {
    projectId: "531c17ff-c224-46d8-969b-f9f47f36c48b",
    apiKey: "1ed18e97-c1d9-4ea5-8273-df7eb204b591",
    referenceLng: "fi"
};
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $6995d8b46a5319c0$export$2e2bcd8739ae039))// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use((0, $60196a4650e96cb1$export$2e2bcd8739ae039))// pass the i18n instance to react-i18next.
.use((0, $0636c84fe4549f1f$export$ae7e14d40d89f296))// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    fallbackLng: "fi",
    debug: false,
    interpolation: {
        escapeValue: false
    },
    backend: $6c154842fccf6556$var$locizeOptions
});
var $6c154842fccf6556$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");

// ==== action type types ====
var $4eb73ced7ff4ee76$export$182858e9e5f292cd;
(function(ErrorActionType) {
    ErrorActionType["SET_ERROR"] = "SET_ERROR";
    ErrorActionType["DELETE_ERROR"] = "DELETE_ERROR";
})($4eb73ced7ff4ee76$export$182858e9e5f292cd || ($4eb73ced7ff4ee76$export$182858e9e5f292cd = {}));


let $c7a54fa30ebf964c$var$idCounter = 0;
const $c7a54fa30ebf964c$var$getId = ()=>{
    return $c7a54fa30ebf964c$var$idCounter++;
};
function $c7a54fa30ebf964c$export$b8d0bb2aa0adefe5(message, additionalInformation) {
    return {
        type: (0, $4eb73ced7ff4ee76$export$182858e9e5f292cd).SET_ERROR,
        payload: {
            message: message,
            additionalInformation: additionalInformation,
            id: $c7a54fa30ebf964c$var$getId()
        }
    };
}
function $c7a54fa30ebf964c$export$1c45f616ab56feb9(id) {
    return {
        type: (0, $4eb73ced7ff4ee76$export$182858e9e5f292cd).DELETE_ERROR,
        payload: id
    };
}



function $2c9b978d9b80f4fb$export$44b6c4ccb6ebc82e() {
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.error.errors);
}



var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $3AM7p = parcelRequire("3AM7p");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2cd2c63af2aa1e89$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)("MuiAlert", slot);
}
const $2cd2c63af2aa1e89$var$alertClasses = (0, $beCSm.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $2cd2c63af2aa1e89$export$2e2bcd8739ae039 = $2cd2c63af2aa1e89$var$alertClasses;



parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $4fe9ab3ffea456b8$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $caf1eafd8571d91c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $72c6d34894446252$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $7dcb7ddf91c6cf94$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $7880a6389ac08655$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $ayMG0 = parcelRequire("ayMG0");
const $11072e450c597f96$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $11072e450c597f96$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $3AM7p.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2cd2c63af2aa1e89$export$69aecd24bc2cf7e3), classes);
};
const $11072e450c597f96$var$AlertRoot = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $3AM7p.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $jgarO.darken) : (0, $jgarO.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $jgarO.lighten) : (0, $jgarO.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $e8gS1.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $2cd2c63af2aa1e89$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette.mode === "dark" ? theme.palette[color].main : theme.palette[color].light
        }
    }, color && ownerState.variant === "outlined" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $2cd2c63af2aa1e89$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette.mode === "dark" ? theme.palette[color].main : theme.palette[color].light
        }
    }, color && ownerState.variant === "filled" && (0, $e8gS1.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main)
    }));
});
const $11072e450c597f96$var$AlertIcon = (0, $1Ikg4.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $11072e450c597f96$var$AlertMessage = (0, $1Ikg4.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $11072e450c597f96$var$AlertAction = (0, $1Ikg4.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $11072e450c597f96$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fe9ab3ffea456b8$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $caf1eafd8571d91c$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72c6d34894446252$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dcb7ddf91c6cf94$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $11072e450c597f96$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $11072e450c597f96$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $1sz44.default)(props, $11072e450c597f96$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $11072e450c597f96$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $7880a6389ac08655$export$2e2bcd8739ae039);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($11072e450c597f96$var$AlertRoot, (0, $e8gS1.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)($11072e450c597f96$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $11072e450c597f96$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($11072e450c597f96$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)($11072e450c597f96$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)($11072e450c597f96$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(AlertCloseButton, (0, $e8gS1.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(AlertCloseIcon, (0, $e8gS1.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $11072e450c597f96$export$2e2bcd8739ae039 = $11072e450c597f96$var$Alert;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");

function $4cf4482b502c4310$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $ayMG0 = parcelRequire("ayMG0");
function $7aabd1280e8804e7$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $7aabd1280e8804e7$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base/api/click-away-listener/)
 */ function $7aabd1280e8804e7$var$ClickAwayListener(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $7aabd1280e8804e7$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $7aabd1280e8804e7$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $7aabd1280e8804e7$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, childrenProps)
    });
}
var $7aabd1280e8804e7$export$2e2bcd8739ae039 = $7aabd1280e8804e7$var$ClickAwayListener;



var $1Ikg4 = parcelRequire("1Ikg4");


var $cpBQU = parcelRequire("cpBQU");


var $3AM7p = parcelRequire("3AM7p");

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



const $09228c405c75d141$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $09228c405c75d141$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $ayMG0 = parcelRequire("ayMG0");
const $5a8449c70e836e71$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $5a8449c70e836e71$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $5a8449c70e836e71$var$styles = {
    entering: {
        opacity: 1,
        transform: $5a8449c70e836e71$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $5a8449c70e836e71$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5a8449c70e836e71$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1sz44.default)(props, $5a8449c70e836e71$var$_excluded);
    const timer = $acw62.useRef();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: $5a8449c70e836e71$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $5a8449c70e836e71$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $e8gS1.default)({
                style: (0, $e8gS1.default)({
                    opacity: 0,
                    transform: $5a8449c70e836e71$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $5a8449c70e836e71$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$5a8449c70e836e71$var$Grow.muiSupportAuto = true;
var $5a8449c70e836e71$export$2e2bcd8739ae039 = $5a8449c70e836e71$var$Grow;



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $96f7b4ca6350aea0$export$def81488db1a3216(slot) {
    return (0, $4Cod0.default)("MuiSnackbarContent", slot);
}
const $96f7b4ca6350aea0$var$snackbarContentClasses = (0, $beCSm.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $96f7b4ca6350aea0$export$2e2bcd8739ae039 = $96f7b4ca6350aea0$var$snackbarContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $c10f30b5937de473$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $c10f30b5937de473$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $96f7b4ca6350aea0$export$def81488db1a3216), classes);
};
const $c10f30b5937de473$var$SnackbarContentRoot = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $jgarO.emphasize)(theme.palette.background.default, emphasis);
    return (0, $e8gS1.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $c10f30b5937de473$var$SnackbarContentMessage = (0, $1Ikg4.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $c10f30b5937de473$var$SnackbarContentAction = (0, $1Ikg4.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $c10f30b5937de473$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $1sz44.default)(props, $c10f30b5937de473$var$_excluded);
    const ownerState = props;
    const classes = $c10f30b5937de473$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c10f30b5937de473$var$SnackbarContentRoot, (0, $e8gS1.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($c10f30b5937de473$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $ayMG0.jsx)($c10f30b5937de473$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $c10f30b5937de473$export$2e2bcd8739ae039 = $c10f30b5937de473$var$SnackbarContent;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8da2e7a3a807d031$export$6cb096457f5926f4(slot) {
    return (0, $4Cod0.default)("MuiSnackbar", slot);
}
const $8da2e7a3a807d031$var$snackbarClasses = (0, $beCSm.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $8da2e7a3a807d031$export$2e2bcd8739ae039 = $8da2e7a3a807d031$var$snackbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $7323af1cd599e3bc$var$_excluded = [
    "onEnter",
    "onExited"
], $7323af1cd599e3bc$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7323af1cd599e3bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $3AM7p.default)(anchorOrigin.vertical)}${(0, $3AM7p.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8da2e7a3a807d031$export$6cb096457f5926f4), classes);
};
const $7323af1cd599e3bc$var$SnackbarRoot = (0, $1Ikg4.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $3AM7p.default)(ownerState.anchorOrigin.vertical)}${(0, $3AM7p.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $e8gS1.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $e8gS1.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $7323af1cd599e3bc$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, TransitionComponent: TransitionComponent = (0, $5a8449c70e836e71$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $1sz44.default)(props.TransitionProps, $7323af1cd599e3bc$var$_excluded), other = (0, $1sz44.default)(props, $7323af1cd599e3bc$var$_excluded2);
    const ownerState = (0, $e8gS1.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        }
    });
    const classes = $7323af1cd599e3bc$var$useUtilityClasses(ownerState);
    const timerAutoHide = $acw62.useRef();
    const [exited, setExited] = $acw62.useState(true);
    const handleClose = (0, $52726edc538865d0$export$2e2bcd8739ae039)((...args)=>{
        if (onClose) onClose(...args);
    });
    const setAutoHideTimer = (0, $52726edc538865d0$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    };
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        handlePause();
    };
    const handleMouseEnter = (event)=>{
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        handleResume();
    };
    const handleMouseLeave = (event)=>{
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    const handleClickAway = (event)=>{
        if (onClose) onClose(event, "clickaway");
    };
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                // IE11, Edge (prior to using Bink?) use 'Esc'
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                {
                    if (onClose) onClose(nativeEvent, "escapeKeyDown");
                }
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        exited,
        open,
        onClose
    ]);
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7aabd1280e8804e7$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($7323af1cd599e3bc$var$SnackbarRoot, (0, $e8gS1.default)({
            className: (0, $1SA7b.default)(classes.root, className),
            onBlur: handleBlur,
            onFocus: handleFocus,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            ownerState: ownerState,
            ref: ref,
            role: "presentation"
        }, other, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c10f30b5937de473$export$2e2bcd8739ae039), (0, $e8gS1.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $7323af1cd599e3bc$export$2e2bcd8739ae039 = $7323af1cd599e3bc$var$Snackbar;


parcelRequire("acw62");


const $df5bef30413a053b$export$385fc1c9ea2be551 = (path)=>{
    const match = (0, $926608a7a86d7371$export$81336c211d5ff295)("/:inquiry/*", window.location.pathname);
    const inquiry = match?.params.inquiry;
    return `/${inquiry}/${path}`;
};
const $df5bef30413a053b$export$df77466336fe5355 = false;


const $d60b1406772a8f57$var$tenSecondsInMS = 10000;
const $d60b1406772a8f57$export$712d180eb75a0693 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d60b1406772a8f57$export$3b4e64e77073e307, {
        severity: "error",
        ...props
    });
const $d60b1406772a8f57$export$3b4e64e77073e307 = ({ message: message, additionalInformation: additionalInformation, severity: severity, onClose: onClose })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7323af1cd599e3bc$export$2e2bcd8739ae039, {
        open: true,
        autoHideDuration: $d60b1406772a8f57$var$tenSecondsInMS,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($11072e450c597f96$export$2e2bcd8739ae039, {
            severity: severity,
            children: [
                t(message),
                (0, $df5bef30413a053b$export$df77466336fe5355) && additionalInformation && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        " (",
                        additionalInformation,
                        ")"
                    ]
                })
            ]
        })
    });
};


const $b37bbb1b94b75ea9$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        box: {
            position: "absolute",
            top: 0,
            display: "flex",
            justifyContent: "center",
            width: "100%"
        }
    }));
const $b37bbb1b94b75ea9$var$BannerShower = ({})=>{
    const errors = (0, $2c9b978d9b80f4fb$export$44b6c4ccb6ebc82e)();
    const classes = $b37bbb1b94b75ea9$var$useStyles();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handleClose = (id)=>()=>{
            dispatch((0, $c7a54fa30ebf964c$export$1c45f616ab56feb9)(id));
        };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed0dc78f73685bb9$export$2e2bcd8739ae039, {
        className: classes.box,
        children: errors.map(({ id: id, message: message, additionalInformation: additionalInformation })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d60b1406772a8f57$export$712d180eb75a0693), {
                onClose: handleClose(id),
                message: message,
                additionalInformation: additionalInformation
            }, id))
    });
};
var $b37bbb1b94b75ea9$export$2e2bcd8739ae039 = $b37bbb1b94b75ea9$var$BannerShower;



var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$exports = {};
"use strict";
var $edd7271c3062ef00$exports = {};
function $edd7271c3062ef00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$edd7271c3062ef00$exports = $edd7271c3062ef00$var$_interopRequireDefault, $edd7271c3062ef00$exports.__esModule = true, $edd7271c3062ef00$exports["default"] = $edd7271c3062ef00$exports;


Object.defineProperty($c842ddb70f8ccad0$exports, "__esModule", {
    value: true
});
$c842ddb70f8ccad0$exports.default = void 0;

var $c842ddb70f8ccad0$var$_createSvgIcon = $edd7271c3062ef00$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$var$_default = (0, $c842ddb70f8ccad0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
$c842ddb70f8ccad0$exports.default = $c842ddb70f8ccad0$var$_default;


var $35f16394a96a7f2a$exports = {};
"use strict";

Object.defineProperty($35f16394a96a7f2a$exports, "__esModule", {
    value: true
});
$35f16394a96a7f2a$exports.default = void 0;

var $35f16394a96a7f2a$var$_createSvgIcon = $edd7271c3062ef00$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $35f16394a96a7f2a$var$_default = (0, $35f16394a96a7f2a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert");
$35f16394a96a7f2a$exports.default = $35f16394a96a7f2a$var$_default;



var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");
var $936e1576c7caee60$exports = {};
"use strict";

$936e1576c7caee60$exports = (parcelRequire("cSJDD"));




var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");



var $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039 = (0, $4cf4482b502c4310$export$2e2bcd8739ae039);



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $ccdf08267bdb07b4$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $ccdf08267bdb07b4$export$2e2bcd8739ae039 = $ccdf08267bdb07b4$var$ListContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2036eb6d4835ac15$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)("MuiList", slot);
}
const $2036eb6d4835ac15$var$listClasses = (0, $beCSm.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $2036eb6d4835ac15$export$2e2bcd8739ae039 = $2036eb6d4835ac15$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $d987fddc25cef197$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $d987fddc25cef197$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2036eb6d4835ac15$export$c6bd6795ed6e3203), classes);
};
const $d987fddc25cef197$var$ListRoot = (0, $1Ikg4.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $d987fddc25cef197$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1sz44.default)(props, $d987fddc25cef197$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $d987fddc25cef197$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($d987fddc25cef197$var$ListRoot, (0, $e8gS1.default)({
            as: component,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $d987fddc25cef197$export$2e2bcd8739ae039 = $d987fddc25cef197$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7a9415d492047f70$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $6e949a478f594883$export$2e2bcd8739ae039 = (0, $7a9415d492047f70$export$2e2bcd8739ae039);




var $6d0031115bbee1bb$export$2e2bcd8739ae039 = (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
const $7c6e657321c9c45b$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $7c6e657321c9c45b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $7c6e657321c9c45b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menubutton/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $7c6e657321c9c45b$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $1sz44.default)(props, $7c6e657321c9c45b$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $6e949a478f594883$export$2e2bcd8739ae039)((0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $7c6e657321c9c45b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $7c6e657321c9c45b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $7c6e657321c9c45b$export$2e2bcd8739ae039 = $7c6e657321c9c45b$var$MenuList;




var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");


var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $41c4238d7b0ec499$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $83167607eb9ed060$export$2e2bcd8739ae039 = (0, $41c4238d7b0ec499$export$2e2bcd8739ae039);




function $230cae465a5568fd$export$2e2bcd8739ae039(node) {
    const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $85795f3c4e07aecf$export$2e2bcd8739ae039 = (0, $230cae465a5568fd$export$2e2bcd8739ae039);





var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");

function $4171c580f9e5aff6$export$2e2bcd8739ae039() {
    $4171c580f9e5aff6$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4171c580f9e5aff6$export$2e2bcd8739ae039.apply(this, arguments);
}


function $5877039b6aa04c0b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $acw62 = parcelRequire("acw62");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c91b8f922607ad66$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
function $b2ad7edda02764f6$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ const $b2ad7edda02764f6$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, ref) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? children.ref : null, ref);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($b2ad7edda02764f6$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(ref, mountNode);
            return ()=>{
                (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) return /*#__PURE__*/ $acw62.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode
    });
});
var $b2ad7edda02764f6$export$2e2bcd8739ae039 = $b2ad7edda02764f6$var$Portal;



// Is a vertical scrollbar displayed?
function $10594cfe2cdcfbe1$var$isOverflowing(container) {
    const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $230cae465a5568fd$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $10594cfe2cdcfbe1$var$getPaddingRight(element) {
    return parseInt((0, $230cae465a5568fd$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $10594cfe2cdcfbe1$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $10594cfe2cdcfbe1$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$10594cfe2cdcfbe1$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(element, show);
    });
}
function $10594cfe2cdcfbe1$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $10594cfe2cdcfbe1$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($10594cfe2cdcfbe1$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7a9415d492047f70$export$2e2bcd8739ae039)((0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$10594cfe2cdcfbe1$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$10594cfe2cdcfbe1$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $10594cfe2cdcfbe1$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $10594cfe2cdcfbe1$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $10594cfe2cdcfbe1$var$getHiddenSiblings(container);
        $10594cfe2cdcfbe1$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $10594cfe2cdcfbe1$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $10594cfe2cdcfbe1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $10594cfe2cdcfbe1$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $10594cfe2cdcfbe1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $10594cfe2cdcfbe1$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $10594cfe2cdcfbe1$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
const $9feea497446f1db4$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $9feea497446f1db4$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $9feea497446f1db4$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $9feea497446f1db4$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $9feea497446f1db4$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $9feea497446f1db4$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($9feea497446f1db4$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $9feea497446f1db4$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$9feea497446f1db4$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $9feea497446f1db4$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 */ function $9feea497446f1db4$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $9feea497446f1db4$var$defaultGetTabbable, isEnabled: isEnabled = $9feea497446f1db4$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef();
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement referes to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $9feea497446f1db4$export$2e2bcd8739ae039 = $9feea497446f1db4$var$FocusTrap;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d4c7e29c21143dc7$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)("MuiModal", slot);
}
const $d4c7e29c21143dc7$var$modalUnstyledClasses = (0, $beCSm.default)("MuiModal", [
    "root",
    "hidden"
]);
var $d4c7e29c21143dc7$export$2e2bcd8739ae039 = $d4c7e29c21143dc7$var$modalUnstyledClasses;






/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $93dbc7362e67d1d8$var$isHostComponent(element) {
    return typeof element === "string";
}
var $93dbc7362e67d1d8$export$2e2bcd8739ae039 = $93dbc7362e67d1d8$var$isHostComponent;


function $bca986a09b53b6aa$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if ((0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, otherProps, {
        ownerState: (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, otherProps.ownerState, ownerState)
    });
}




var $1SA7b = parcelRequire("1SA7b");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $929bdf9ff30fa5c5$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $f743bb8bda831b4a$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $aedfd69e1cc9b30d$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $1SA7b.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $929bdf9ff30fa5c5$export$2e2bcd8739ae039)((0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $f743bb8bda831b4a$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $f743bb8bda831b4a$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming MUI Base) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $1SA7b.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $3e85a6fbe0c646f1$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === "function") return componentProps(ownerState);
    return componentProps;
}


const $fce864403201fe7f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $fce864403201fe7f$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState } = parameters, rest = (0, $5877039b6aa04c0b$export$2e2bcd8739ae039)(parameters, $fce864403201fe7f$var$_excluded);
    const resolvedComponentsProps = (0, $3e85a6fbe0c646f1$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $aedfd69e1cc9b30d$export$2e2bcd8739ae039)((0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(elementType, (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $ayMG0 = parcelRequire("ayMG0");
const $a8647b5a9242652e$var$_excluded = [
    "children",
    "classes",
    "closeAfterTransition",
    "component",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $a8647b5a9242652e$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d4c7e29c21143dc7$export$67960e22b12a638d), classes);
};
function $a8647b5a9242652e$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $a8647b5a9242652e$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $a8647b5a9242652e$var$defaultManager = new (0, $10594cfe2cdcfbe1$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a8647b5a9242652e$var$ModalUnstyled = /*#__PURE__*/ $acw62.forwardRef(function ModalUnstyled(props, ref) {
    var _props$ariaHidden, _ref;
    const { children: children, classes: classesProp, closeAfterTransition: closeAfterTransition = false, component: component, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, manager: // private
    // eslint-disable-next-line react/prop-types
    manager = $a8647b5a9242652e$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, onTransitionEnter: /* eslint-disable react/prop-types */ onTransitionEnter, onTransitionExited: onTransitionExited, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $5877039b6aa04c0b$export$2e2bcd8739ae039)(props, $a8647b5a9242652e$var$_excluded);
    const [exited, setExited] = $acw62.useState(true);
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(modalRef, ref);
    const hasTransition = $a8647b5a9242652e$var$getHasTransition(props);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $4cf4482b502c4310$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $a8647b5a9242652e$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else (0, $10594cfe2cdcfbe1$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, props, {
        classes: classesProp,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $a8647b5a9242652e$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $c91b8f922607ad66$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $c91b8f922607ad66$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = (_ref = component != null ? component : slots.root) != null ? _ref : "div";
    const rootProps = (0, $fce864403201fe7f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $fce864403201fe7f$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2ad7edda02764f6$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropComponent, (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9feea497446f1db4$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a8647b5a9242652e$export$2e2bcd8739ae039 = $a8647b5a9242652e$var$ModalUnstyled;





var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");
const $b0a9dc0bcc2977a8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $b0a9dc0bcc2977a8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b0a9dc0bcc2977a8$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1sz44.default)(props, $b0a9dc0bcc2977a8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $e8gS1.default)({
                style: (0, $e8gS1.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $b0a9dc0bcc2977a8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $b0a9dc0bcc2977a8$export$2e2bcd8739ae039 = $b0a9dc0bcc2977a8$var$Fade;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8aee358ee862b8d1$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)("MuiBackdrop", slot);
}
const $8aee358ee862b8d1$var$backdropClasses = (0, $beCSm.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $8aee358ee862b8d1$export$2e2bcd8739ae039 = $8aee358ee862b8d1$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $89da4f4236459888$var$_excluded = [
    "children",
    "component",
    "components",
    "componentsProps",
    "className",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "transitionDuration",
    "TransitionComponent"
];
const $89da4f4236459888$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8aee358ee862b8d1$export$9927a91fd93152bd), classes);
};
const $89da4f4236459888$var$BackdropRoot = (0, $1Ikg4.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $89da4f4236459888$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, className: className, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, transitionDuration: transitionDuration, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039) } = props, other = (0, $1sz44.default)(props, $89da4f4236459888$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $89da4f4236459888$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($89da4f4236459888$var$BackdropRoot, (0, $e8gS1.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $1SA7b.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $e8gS1.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $89da4f4236459888$export$2e2bcd8739ae039 = $89da4f4236459888$var$Backdrop;



var $ayMG0 = parcelRequire("ayMG0");
const $4e95d56438178f01$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "closeAfterTransition",
    "children",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "slotProps",
    "slots",
    "theme"
];
const $4e95d56438178f01$export$eb211a494147b724 = (0, $d4c7e29c21143dc7$export$2e2bcd8739ae039);
const $4e95d56438178f01$var$extendUtilityClasses = (ownerState)=>{
    return ownerState.classes;
};
const $4e95d56438178f01$var$ModalRoot = (0, $1Ikg4.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $4e95d56438178f01$var$ModalBackdrop = (0, $1Ikg4.default)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4e95d56438178f01$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $cpBQU.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4e95d56438178f01$var$ModalBackdrop, BackdropProps: BackdropProps, closeAfterTransition: closeAfterTransition = false, children: children, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, slotProps: slotProps, slots: slots, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $1sz44.default)(props, $4e95d56438178f01$var$_excluded);
    const [exited, setExited] = $acw62.useState(true);
    const commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const ownerState = (0, $e8gS1.default)({}, props, commonProps, {
        exited: exited
    });
    const classes = $4e95d56438178f01$var$extendUtilityClasses(ownerState);
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $4e95d56438178f01$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8647b5a9242652e$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $e8gS1.default)({}, (0, $3e85a6fbe0c646f1$export$2e2bcd8739ae039)(rootSlotProps, ownerState), !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(RootSlot) && {
                    as: component,
                    theme: theme
                }),
            backdrop: ()=>(0, $e8gS1.default)({}, BackdropProps, (0, $3e85a6fbe0c646f1$export$2e2bcd8739ae039)(backdropSlotProps, ownerState))
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, {
        classes: classes
    }, commonProps, {
        children: children
    }));
});
var $4e95d56438178f01$export$2e2bcd8739ae039 = $4e95d56438178f01$var$Modal;




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d57438dc3523b8a0$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)("MuiPopover", slot);
}
const $d57438dc3523b8a0$var$popoverClasses = (0, $beCSm.default)("MuiPopover", [
    "root",
    "paper"
]);
var $d57438dc3523b8a0$export$2e2bcd8739ae039 = $d57438dc3523b8a0$var$popoverClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $0420c70951dd1796$var$_excluded = [
    "onEntering"
], $0420c70951dd1796$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
function $0420c70951dd1796$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $0420c70951dd1796$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $0420c70951dd1796$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $0420c70951dd1796$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $0420c70951dd1796$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d57438dc3523b8a0$export$88f455dd56c95edb), classes);
};
const $0420c70951dd1796$var$PopoverRoot = (0, $1Ikg4.default)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $0420c70951dd1796$var$PopoverPaper = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0420c70951dd1796$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperProps = {}, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $5a8449c70e836e71$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {} } = props, TransitionProps = (0, $1sz44.default)(props.TransitionProps, $0420c70951dd1796$var$_excluded), other = (0, $1sz44.default)(props, $0420c70951dd1796$var$_excluded2);
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(paperRef, PaperProps.ref);
    const ownerState = (0, $e8gS1.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        PaperProps: PaperProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $0420c70951dd1796$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $0420c70951dd1796$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $0420c70951dd1796$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $0420c70951dd1796$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $0420c70951dd1796$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $0420c70951dd1796$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0420c70951dd1796$var$PopoverRoot, (0, $e8gS1.default)({
        BackdropProps: {
            invisible: true
        },
        className: (0, $1SA7b.default)(classes.root, className),
        container: container,
        open: open,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($0420c70951dd1796$var$PopoverPaper, (0, $e8gS1.default)({
                elevation: elevation
            }, PaperProps, {
                ref: handlePaperRef,
                className: (0, $1SA7b.default)(classes.paper, PaperProps.className)
            }, isPositioned ? undefined : {
                style: (0, $e8gS1.default)({}, PaperProps.style, {
                    opacity: 0
                })
            }, {
                ownerState: ownerState,
                children: children
            }))
        }))
    }));
});
var $0420c70951dd1796$export$2e2bcd8739ae039 = $0420c70951dd1796$var$Popover;



var $1Ikg4 = parcelRequire("1Ikg4");


var $cpBQU = parcelRequire("cpBQU");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ef00757e7f408a3f$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)("MuiMenu", slot);
}
const $ef00757e7f408a3f$var$menuClasses = (0, $beCSm.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $ef00757e7f408a3f$export$2e2bcd8739ae039 = $ef00757e7f408a3f$var$menuClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $81db31f1007c14e1$var$_excluded = [
    "onEntering"
], $81db31f1007c14e1$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $81db31f1007c14e1$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $81db31f1007c14e1$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $81db31f1007c14e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ef00757e7f408a3f$export$2cf86a63a84fe23d), classes);
};
const $81db31f1007c14e1$var$MenuRoot = (0, $1Ikg4.default)((0, $0420c70951dd1796$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $81db31f1007c14e1$var$MenuPaper = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $81db31f1007c14e1$var$MenuMenuList = (0, $1Ikg4.default)((0, $7c6e657321c9c45b$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $81db31f1007c14e1$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu" } = props, TransitionProps = (0, $1sz44.default)(props.TransitionProps, $81db31f1007c14e1$var$_excluded), other = (0, $1sz44.default)(props, $81db31f1007c14e1$var$_excluded2);
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $e8gS1.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $81db31f1007c14e1$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81db31f1007c14e1$var$MenuRoot, (0, $e8gS1.default)({
        classes: PopoverClasses,
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $81db31f1007c14e1$var$RTL_ORIGIN : $81db31f1007c14e1$var$LTR_ORIGIN,
        PaperProps: (0, $e8gS1.default)({
            component: $81db31f1007c14e1$var$MenuPaper
        }, PaperProps, {
            classes: (0, $e8gS1.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $e8gS1.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($81db31f1007c14e1$var$MenuMenuList, (0, $e8gS1.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $1SA7b.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $81db31f1007c14e1$export$2e2bcd8739ae039 = $81db31f1007c14e1$var$Menu;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");





var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0fc9796113f6362d$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)("MuiDivider", slot);
}
const $0fc9796113f6362d$var$dividerClasses = (0, $beCSm.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $0fc9796113f6362d$export$2e2bcd8739ae039 = $0fc9796113f6362d$var$dividerClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $863c8b42c24a5d20$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)("MuiListItemIcon", slot);
}
const $863c8b42c24a5d20$var$listItemIconClasses = (0, $beCSm.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $863c8b42c24a5d20$export$2e2bcd8739ae039 = $863c8b42c24a5d20$var$listItemIconClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8ffc2f5b8ea69aff$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)("MuiListItemText", slot);
}
const $8ffc2f5b8ea69aff$var$listItemTextClasses = (0, $beCSm.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $8ffc2f5b8ea69aff$export$2e2bcd8739ae039 = $8ffc2f5b8ea69aff$var$listItemTextClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $52ee1ef7b0f3c27a$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)("MuiMenuItem", slot);
}
const $52ee1ef7b0f3c27a$var$menuItemClasses = (0, $beCSm.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $52ee1ef7b0f3c27a$export$2e2bcd8739ae039 = $52ee1ef7b0f3c27a$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $45389177b9c2b08c$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $45389177b9c2b08c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $45389177b9c2b08c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $52ee1ef7b0f3c27a$export$515f8c67b5305377), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $45389177b9c2b08c$var$MenuItemRoot = (0, $1Ikg4.default)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $45389177b9c2b08c$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $jgarO.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $0fc9796113f6362d$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $0fc9796113f6362d$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $863c8b42c24a5d20$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $e8gS1.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $863c8b42c24a5d20$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $45389177b9c2b08c$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $1sz44.default)(props, $45389177b9c2b08c$var$_excluded);
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $e8gS1.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $45389177b9c2b08c$var$useUtilityClasses(props);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($45389177b9c2b08c$var$MenuItemRoot, (0, $e8gS1.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $1SA7b.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $1SA7b.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $45389177b9c2b08c$export$2e2bcd8739ae039 = $45389177b9c2b08c$var$MenuItem;




var $acw62 = parcelRequire("acw62");




const $d18a0a91bd86f32d$export$eb728d1e04946462 = "SET_TOKEN";
const $d18a0a91bd86f32d$export$53f522aeda635e8b = "DELETE_TOKEN";


const $4cad8f036e74fc6a$export$18138ec54e25ae31 = "SET_VALUES";
const $4cad8f036e74fc6a$export$7f2d035eeabb2a2b = "INIT_VALUES";
const $4cad8f036e74fc6a$export$918c630449e022d1 = "RESET_VALUES";



var $acw62 = parcelRequire("acw62");



function $d57e8ba77789de33$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const token = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.auth.token);
    (0, $acw62.useEffect)(()=>{
        if (token) {
            const payload = JSON.parse(atob(token.split(".")[1]));
            const now = Date.now();
            /**
       * Token is expired => clear token and logout
       */ if (now >= payload.exp * 1000) {
                dispatch({
                    type: (0, $d18a0a91bd86f32d$export$53f522aeda635e8b)
                });
                navigate("/uloskirjauduttu?reason=timeout");
            }
        }
    }, []);
    return token;
}


var $54c991629ee0a8ce$exports = {};






$54c991629ee0a8ce$exports = {
    decode: (parcelRequire("7SR5F")),
    verify: (parcelRequire("1PSJS")),
    sign: (parcelRequire("8fWg9")),
    JsonWebTokenError: (parcelRequire("4r9pO")),
    NotBeforeError: (parcelRequire("fUN9R")),
    TokenExpiredError: (parcelRequire("agX5Y"))
};



function $557966054e36245a$export$2e2bcd8739ae039() {
    const token = (0, $d57e8ba77789de33$export$2e2bcd8739ae039)();
    if (token) try {
        const { u: u } = (0, (/*@__PURE__*/$parcel$interopDefault($54c991629ee0a8ce$exports))).decode(token);
        return u;
    } catch (e) {
        console.error(e);
    }
    return null;
}


function $e4f5da8c80007dda$export$2e2bcd8739ae039() {
    const token = (0, $d57e8ba77789de33$export$2e2bcd8739ae039)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const user = (0, $557966054e36245a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return async ()=>{
        dispatch({
            type: (0, $d18a0a91bd86f32d$export$53f522aeda635e8b)
        });
        dispatch({
            type: (0, $4cad8f036e74fc6a$export$918c630449e022d1)
        });
        localStorage.clear();
        // Redirect to SAML logout if not in development or using non-Suomifi token.
        if (user && user.upn) navigate("/uloskirjauduttu");
        else window.location.href = "https://tunnistus-test-tikal.luke.fi/SAML2SLO" + `?t=${token}&app_id=sato`;
    };
}



const $822642a182bc99e4$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        desktopIcon: {
            [theme.breakpoints.down("md")]: {
                display: "none !important"
            }
        },
        mobileIcon: {
            [theme.breakpoints.down("md")]: {
                display: "flex !important"
            },
            [theme.breakpoints.up("md")]: {
                display: "none !important"
            }
        }
    }));
/**
 * Compare two language codes, and see if they are the same.
 *
 * We set language to be either 'fi' and 'sv', but it can be something else as well.
 * This is because the language comes from react-i18n's languageDetector,
 * and the detector might find 'fi-FI' or something else from user's browser.
 *
 * In addition, react-i18n expects all languages to be given in the format
 * defined by BCP 47 (eg. "fi-FI").
 *
 * Because of this, we will consider languages to be same if their
 * language part is same - the region part of the code can be different.
 *
 * @param expectedLanguage - language code of the button - either "fi" or "sv".
 * @param currentLanguage - language code from `i18n.language`.
 */ const $822642a182bc99e4$var$isSameLanguage = (expectedLanguage, currentLanguage)=>{
    return currentLanguage === expectedLanguage || new RegExp(`^${expectedLanguage}-`).test(currentLanguage);
};
/**
 * Language picker button. Allows changing language.
 *
 * Button is not shown, if its language is already in use.
 */ const $822642a182bc99e4$var$LanguagePickerButton = ({ language: language, onClick: onClick, label: label })=>{
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if ($822642a182bc99e4$var$isSameLanguage(language, i18n.language)) return null;
    const handleLanguageChange = (language)=>{
        onClick();
        setTimeout(()=>{
            i18n.changeLanguage(language);
        }, 100);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
        onClick: ()=>handleLanguageChange(language),
        children: label
    });
};
function $822642a182bc99e4$export$2e2bcd8739ae039() {
    const user = (0, $557966054e36245a$export$2e2bcd8739ae039)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const classes = $822642a182bc99e4$var$useStyles();
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const open = Boolean(anchorEl);
    const handleLogout = (0, $e4f5da8c80007dda$export$2e2bcd8739ae039)();
    const handleMenuClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = ()=>setAnchorEl(null);
    const handleLanguageChange = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                className: classes.desktopIcon,
                "aria-label": "Avaa k\xe4ytt\xe4j\xe4valikko",
                onClick: handleMenuClick,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                size: "large",
                edge: "start",
                color: "inherit",
                className: classes.mobileIcon,
                "aria-label": "Avaa k\xe4ytt\xe4j\xe4valikko",
                onClick: handleMenuClick,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35f16394a96a7f2a$exports))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $81db31f1007c14e1$export$2e2bcd8739ae039), {
                open: open,
                onClose: handleMenuClose,
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($822642a182bc99e4$var$LanguagePickerButton, {
                        language: "fi",
                        label: t("common.fi"),
                        onClick: handleLanguageChange
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($822642a182bc99e4$var$LanguagePickerButton, {
                        language: "sv",
                        label: t("common.se"),
                        onClick: handleLanguageChange
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                        onClick: handleLogout,
                        children: t("common.logout")
                    })
                ]
            })
        ]
    });
}




function $76cdbbeb537534c7$export$2e2bcd8739ae039() {
    const token = (0, $d57e8ba77789de33$export$2e2bcd8739ae039)();
    if (!token) return [];
    try {
        const { m: m } = (0, (/*@__PURE__*/$parcel$interopDefault($54c991629ee0a8ce$exports))).decode(token);
        return m;
    } catch (e) {
        console.error(e);
        return [];
    }
}



const $1247e84894e86471$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        appBarCenter: {
            flexGrow: 1,
            display: "flex",
            justifyContent: "center"
        },
        appBar: {
            ["@media print"]: {
                display: "none !important"
            }
        },
        logout: {
            textAlign: "right"
        },
        logoMobile: {
            height: "48px"
        },
        svtLogo: {
            marginLeft: "32px",
            maxWidth: "250px",
            height: "60px",
            marginTop: "20px"
        },
        link: {
            color: "#0033a0",
            textDecoration: "underline",
            cursor: "pointer"
        },
        items: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end"
        }
    }));
const $1247e84894e86471$var$Brand = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        to: "/",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: (0, $6c154842fccf6556$export$2e2bcd8739ae039).language == "fi" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3754d21c80fdfa85$exports))),
                height: 90,
                alt: "Logo"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5d2635ab09e018a6$exports))),
                height: 90,
                alt: "Logo"
            })
        })
    });
function $1247e84894e86471$export$2e2bcd8739ae039({ isLoggedIn: isLoggedIn }) {
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    const user = (0, $557966054e36245a$export$2e2bcd8739ae039)();
    const classes = $1247e84894e86471$var$useStyles();
    const meta = (0, $76cdbbeb537534c7$export$2e2bcd8739ae039)();
    const tiltu = meta.find((row)=>row.key === "TILTU");
    const handleLanguageChange = (lng)=>{
        setTimeout(()=>{
            (0, $6c154842fccf6556$export$2e2bcd8739ae039).changeLanguage(lng);
        }, 100);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                pl: 8,
                pr: 8,
                pt: 4,
                pb: 4,
                className: breakpoints.desktopHeader,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            item: true,
                            sm: 6,
                            xs: 12,
                            sx: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1247e84894e86471$var$Brand, {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    tabIndex: 0,
                                    alt: (0, $673ff3dfc4a496de$export$625550452a3fa3ec)("common.svt_logo"),
                                    className: classes.svtLogo,
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($de59dbffe2aac879$exports)))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            className: classes.logout,
                            item: true,
                            sm: 6,
                            xs: 12,
                            children: [
                                isLoggedIn && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: classes.items,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "subtitle2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: user?.n
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        (0, $673ff3dfc4a496de$export$625550452a3fa3ec)("common.tila"),
                                                        " ",
                                                        tiltu?.value
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $822642a182bc99e4$export$2e2bcd8739ae039), {})
                                    ]
                                }),
                                !isLoggedIn && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: classes.items,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: ()=>handleLanguageChange("fi"),
                                            children: (0, $673ff3dfc4a496de$export$625550452a3fa3ec)("common.fi")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: ()=>handleLanguageChange("sv"),
                                            children: (0, $673ff3dfc4a496de$export$625550452a3fa3ec)("common.se")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75f50dd5200dc7fd$export$2e2bcd8739ae039), {
                position: "static",
                className: `${breakpoints.appBar} ${classes.appBar}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: classes.appBarCenter,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: classes.logoMobile,
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ab8749cbc737a51d$exports))),
                                        alt: "Luonnonvarakeskuksen logo"
                                    })
                                ]
                            })
                        }),
                        isLoggedIn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $822642a182bc99e4$export$2e2bcd8739ae039), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b37bbb1b94b75ea9$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");




var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $frp52 = parcelRequire("frp52");




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d763330bc495c775$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)("MuiCollapse", slot);
}
const $d763330bc495c775$var$collapseClasses = (0, $beCSm.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $d763330bc495c775$export$2e2bcd8739ae039 = $d763330bc495c775$var$collapseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $691c7db844a32c8c$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $691c7db844a32c8c$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d763330bc495c775$export$5162da8f798e0959), classes);
};
const $691c7db844a32c8c$var$CollapseRoot = (0, $1Ikg4.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $e8gS1.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $691c7db844a32c8c$var$CollapseWrapper = (0, $1Ikg4.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $691c7db844a32c8c$var$CollapseWrapperInner = (0, $1Ikg4.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $691c7db844a32c8c$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $frp52.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1sz44.default)(props, $691c7db844a32c8c$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $691c7db844a32c8c$var$useUtilityClasses(ownerState);
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const timer = $acw62.useRef();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($691c7db844a32c8c$var$CollapseRoot, (0, $e8gS1.default)({
                as: component,
                className: (0, $1SA7b.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $e8gS1.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $e8gS1.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($691c7db844a32c8c$var$CollapseWrapper, {
                    ownerState: (0, $e8gS1.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($691c7db844a32c8c$var$CollapseWrapperInner, {
                        ownerState: (0, $e8gS1.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$691c7db844a32c8c$var$Collapse.muiSupportAuto = true;
var $691c7db844a32c8c$export$2e2bcd8739ae039 = $691c7db844a32c8c$var$Collapse;




var $acw62 = parcelRequire("acw62");
const $a35747d000bef14a$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        title: {
            fontSize: "1.5rem"
        },
        box: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            height: "209px",
            boxSizing: "border-box",
            textShadow: "0.01em 0 rgba(0, 0, 0, 0.2),0 0.01em rgba(0, 0, 0, 0.2),-0.01em 0 rgba(0, 0, 0, 0.2),0 -0.01em rgba(0, 0, 0, 0.2)"
        },
        shrinkBox: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            height: "100px",
            display: "flex",
            alignItems: "center"
        }
    }));
function $a35747d000bef14a$export$2e2bcd8739ae039({ title: title, variant: variant }) {
    const [fade, setFade] = (0, $acw62.useState)(false);
    const [animate, setAnimate] = (0, $acw62.useState)(true);
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    const classes = $a35747d000bef14a$var$useStyles();
    (0, $acw62.useEffect)(()=>{
        setAnimate(false);
    }, []);
    const onCollapsed = ()=>{
        setCollapsed(true);
        setFade(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            !collapsed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $691c7db844a32c8c$export$2e2bcd8739ae039), {
                in: animate,
                collapsedSize: 60,
                onExited: onCollapsed,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    className: classes.box,
                    pr: 8,
                    pl: 8,
                    pt: 8,
                    pb: 8
                })
            }),
            collapsed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                className: classes.shrinkBox,
                pr: 8,
                pl: 8,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), {
                    in: fade,
                    timeout: 200,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        className: classes.title,
                        variant: "h1",
                        children: title
                    })
                })
            })
        ]
    });
}


const $a3f66fbfc482f10f$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        title: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        }
    }));
function $a3f66fbfc482f10f$export$2e2bcd8739ae039({ title: title }) {
    const classes = $a3f66fbfc482f10f$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.title,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a35747d000bef14a$export$2e2bcd8739ae039), {
            variant: "h5",
            title: title
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $2f66afa0319941ff$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        sisalto: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: theme.typography.body1.fontFamily
        },
        virhe: {
            fontWeight: "700",
            marginBottom: "1rem"
        },
        ohje: {}
    }));
function $2f66afa0319941ff$export$2e2bcd8739ae039(props) {
    const classes = $2f66afa0319941ff$var$useStyles();
    const { virhe: virhe, ohje: ohje, Virhe: VirheRP, Ohje: OhjeRP } = props;
    if (!VirheRP && !virhe) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: classes.sisalto,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classes.virhe,
                children: VirheRP ? /*#__PURE__*/ (0, $ayMG0.jsx)(VirheRP, {}) : virhe
            }),
            (OhjeRP || ohje) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classes.ohje,
                children: OhjeRP ? /*#__PURE__*/ (0, $ayMG0.jsx)(OhjeRP, {}) : ohje
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
class $ddbfc09852d0c2dc$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            virheTapahtunut: false
        };
    }
    static getDerivedStateFromError() {
        return {
            virheTapahtunut: true
        };
    }
    componentDidCatch(error, errorInfo) {
    // TODO: logita virhe
    }
    render() {
        const { Virhenakyma: Virhenakyma } = this.props;
        if (this.state.virheTapahtunut) return /*#__PURE__*/ (0, $ayMG0.jsx)(Virhenakyma, {});
        return this.props.children;
    }
}
var $ddbfc09852d0c2dc$export$2e2bcd8739ae039 = $ddbfc09852d0c2dc$var$ErrorBoundary;


const $c8c2567824fae8d2$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        sivu: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: "100vh"
        },
        sisalto: {
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        },
        virhe: {
            fontWeight: "700",
            marginBottom: "1rem"
        },
        ohje: {}
    }));
const $c8c2567824fae8d2$export$50747c9e2b7cc3ec = ()=>{
    const classes = $c8c2567824fae8d2$var$useStyles();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3f66fbfc482f10f$export$2e2bcd8739ae039), {
                title: t("common.app")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classes.sisalto,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f66afa0319941ff$export$2e2bcd8739ae039), {
                    virhe: t("virhe.errorboundary.router.virhe"),
                    ohje: t("virhe.errorboundary.router.ohje")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
};
const $c8c2567824fae8d2$var$RouterErrorBoundary = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddbfc09852d0c2dc$export$2e2bcd8739ae039), {
        Virhenakyma: $c8c2567824fae8d2$export$50747c9e2b7cc3ec,
        children: children
    });
};
var $c8c2567824fae8d2$export$2e2bcd8739ae039 = $c8c2567824fae8d2$var$RouterErrorBoundary;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");





const $96338aceb27663ef$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        sivu: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: "100vh"
        },
        sisalto: {
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        }
    }));
function $96338aceb27663ef$export$2e2bcd8739ae039() {
    const classes = $96338aceb27663ef$var$useStyles();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3f66fbfc482f10f$export$2e2bcd8739ae039), {
                title: t("common.app")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classes.sisalto,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f66afa0319941ff$export$2e2bcd8739ae039), {
                    virhe: t("virhe.404.sivuaEiLoytynyt.virhe"),
                    Ohje: ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                t("virhe.404.sivuaEiLoytynyt.ohje.alku"),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "/",
                                    children: t("virhe.404.sivuaEiLoytynyt.ohje.linkki")
                                }),
                                "."
                            ]
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $be63994ddb0aacc4$var$GuardedRoute = ({ children: children })=>{
    const auth = (0, $d57e8ba77789de33$export$2e2bcd8739ae039)();
    // Bypass guard in development env.
    if (!auth && true) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
};
var $be63994ddb0aacc4$export$2e2bcd8739ae039 = $be63994ddb0aacc4$var$GuardedRoute;



var $acw62 = parcelRequire("acw62");

const $6d99d1420325c74f$var$ScrollReset = ({ children: children })=>{
    const location = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        location
    ]);
    return children;
};
var $6d99d1420325c74f$export$2e2bcd8739ae039 = $6d99d1420325c74f$var$ScrollReset;



var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $1vDzc = parcelRequire("1vDzc");

var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");


var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1c400751848b9b57$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)("MuiButton", slot);
}
const $1c400751848b9b57$var$buttonClasses = (0, $beCSm.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $1c400751848b9b57$export$2e2bcd8739ae039 = $1c400751848b9b57$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $17e2bbdd939aa1be$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $17e2bbdd939aa1be$export$2e2bcd8739ae039 = $17e2bbdd939aa1be$var$ButtonGroupContext;



var $ayMG0 = parcelRequire("ayMG0");
const $00a06c270f3ebd57$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $00a06c270f3ebd57$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $3AM7p.default)(color)}`,
            `size${(0, $3AM7p.default)(size)}`,
            `${variant}Size${(0, $3AM7p.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $3AM7p.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $3AM7p.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $1c400751848b9b57$export$5a6f9035944c8119), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $00a06c270f3ebd57$var$commonIconStyles = (ownerState)=>(0, $e8gS1.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $00a06c270f3ebd57$var$ButtonRoot = (0, $1Ikg4.default)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $3AM7p.default)(ownerState.color)}`],
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $e8gS1.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $e8gS1.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $e8gS1.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).focusVisible}`]: (0, $e8gS1.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: (0, $e8gS1.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "outlined" && ownerState.color === "secondary" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabled}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $jgarO.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $00a06c270f3ebd57$var$ButtonStartIcon = (0, $1Ikg4.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $00a06c270f3ebd57$var$commonIconStyles(ownerState)));
const $00a06c270f3ebd57$var$ButtonEndIcon = (0, $1Ikg4.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $00a06c270f3ebd57$var$commonIconStyles(ownerState)));
const $00a06c270f3ebd57$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $17e2bbdd939aa1be$export$2e2bcd8739ae039));
    const resolvedProps = (0, $1vDzc.default)(contextProps, inProps);
    const props = (0, $cpBQU.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $1sz44.default)(props, $00a06c270f3ebd57$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $00a06c270f3ebd57$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($00a06c270f3ebd57$var$ButtonRoot, (0, $e8gS1.default)({
        ownerState: ownerState,
        className: (0, $1SA7b.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $1SA7b.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $00a06c270f3ebd57$export$2e2bcd8739ae039 = $00a06c270f3ebd57$var$Button;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
let $f649782d844a38be$var$globalId = 0;
function $f649782d844a38be$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $f649782d844a38be$var$globalId += 1;
            setDefaultId(`mui-${$f649782d844a38be$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $f649782d844a38be$var$maybeReactUseId = $acw62.useId;
function $f649782d844a38be$export$2e2bcd8739ae039(idOverride) {
    if ($f649782d844a38be$var$maybeReactUseId !== undefined) {
        const reactId = $f649782d844a38be$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $f649782d844a38be$var$useGlobalId(idOverride);
}



var $3AM7p = parcelRequire("3AM7p");




var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $849b663ea7e799fa$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)("MuiDialog", slot);
}
const $849b663ea7e799fa$var$dialogClasses = (0, $beCSm.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $849b663ea7e799fa$export$2e2bcd8739ae039 = $849b663ea7e799fa$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
const $fde71ca8ed33ed16$var$DialogContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $fde71ca8ed33ed16$export$2e2bcd8739ae039 = $fde71ca8ed33ed16$var$DialogContext;





var $ayMG0 = parcelRequire("ayMG0");
const $37762b86c13fe370$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $37762b86c13fe370$var$DialogBackdrop = (0, $1Ikg4.default)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $37762b86c13fe370$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $3AM7p.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $3AM7p.default)(scroll)}`,
            `paperWidth${(0, $3AM7p.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $849b663ea7e799fa$export$2177af0aa15c34c2), classes);
};
const $37762b86c13fe370$var$DialogRoot = (0, $1Ikg4.default)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $37762b86c13fe370$var$DialogContainer = (0, $1Ikg4.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $3AM7p.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $37762b86c13fe370$var$DialogPaper = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $3AM7p.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $3AM7p.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
        [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $37762b86c13fe370$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $bca3355350079f94$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1sz44.default)(props, $37762b86c13fe370$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $37762b86c13fe370$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $f649782d844a38be$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($37762b86c13fe370$var$DialogRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $37762b86c13fe370$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $e8gS1.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($37762b86c13fe370$var$DialogContainer, {
                className: (0, $1SA7b.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($37762b86c13fe370$var$DialogPaper, (0, $e8gS1.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $1SA7b.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fde71ca8ed33ed16$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $37762b86c13fe370$export$2e2bcd8739ae039 = $37762b86c13fe370$var$Dialog;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $26cda4b569d13e19$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)("MuiDialogActions", slot);
}
const $26cda4b569d13e19$var$dialogActionsClasses = (0, $beCSm.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $26cda4b569d13e19$export$2e2bcd8739ae039 = $26cda4b569d13e19$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $ce32ef3e14a19991$var$_excluded = [
    "className",
    "disableSpacing"
];
const $ce32ef3e14a19991$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $26cda4b569d13e19$export$5e57a444791c63be), classes);
};
const $ce32ef3e14a19991$var$DialogActionsRoot = (0, $1Ikg4.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $ce32ef3e14a19991$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1sz44.default)(props, $ce32ef3e14a19991$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $ce32ef3e14a19991$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ce32ef3e14a19991$var$DialogActionsRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $ce32ef3e14a19991$export$2e2bcd8739ae039 = $ce32ef3e14a19991$var$DialogActions;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ad2dd284aafca16e$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)("MuiDialogContent", slot);
}
const $ad2dd284aafca16e$var$dialogContentClasses = (0, $beCSm.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $ad2dd284aafca16e$export$2e2bcd8739ae039 = $ad2dd284aafca16e$var$dialogContentClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)("MuiDialogTitle", slot);
}
const $d28a3cfcf0fa99af$var$dialogTitleClasses = (0, $beCSm.default)("MuiDialogTitle", [
    "root"
]);
var $d28a3cfcf0fa99af$export$2e2bcd8739ae039 = $d28a3cfcf0fa99af$var$dialogTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $17fd443c9302d537$var$_excluded = [
    "className",
    "dividers"
];
const $17fd443c9302d537$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ad2dd284aafca16e$export$61b0ee1f05fb344e), classes);
};
const $17fd443c9302d537$var$DialogContentRoot = (0, $1Ikg4.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $d28a3cfcf0fa99af$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $17fd443c9302d537$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1sz44.default)(props, $17fd443c9302d537$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        dividers: dividers
    });
    const classes = $17fd443c9302d537$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($17fd443c9302d537$var$DialogContentRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $17fd443c9302d537$export$2e2bcd8739ae039 = $17fd443c9302d537$var$DialogContent;


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");


var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");



var $ayMG0 = parcelRequire("ayMG0");
const $493ef287866e3611$var$_excluded = [
    "className",
    "id"
];
const $493ef287866e3611$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088), classes);
};
const $493ef287866e3611$var$DialogTitleRoot = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $493ef287866e3611$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $1sz44.default)(props, $493ef287866e3611$var$_excluded);
    const ownerState = props;
    const classes = $493ef287866e3611$var$useUtilityClasses(ownerState);
    const { titleId: id = idProp } = $acw62.useContext((0, $fde71ca8ed33ed16$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($493ef287866e3611$var$DialogTitleRoot, (0, $e8gS1.default)({
        component: "h2",
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: id
    }, other));
});
var $493ef287866e3611$export$2e2bcd8739ae039 = $493ef287866e3611$var$DialogTitle;




var $acw62 = parcelRequire("acw62");


function $4486ed8a46e21cd4$export$2e2bcd8739ae039() {
    const { i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return ()=>window.location.href = `${"https://tunnistus-test-tikal.luke.fi/SAML2SP?app_id=sato"}&lang=${i18n.language}`;
}




function $fda54edbcd7c0473$export$2e2bcd8739ae039() {
    const token = (0, $d57e8ba77789de33$export$2e2bcd8739ae039)();
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const login = (0, $4486ed8a46e21cd4$export$2e2bcd8739ae039)();
    const logout = (0, $e4f5da8c80007dda$export$2e2bcd8739ae039)();
    const onExit = ()=>{
        setOpen(false);
        logout();
    };
    const onContinue = ()=>{
        setOpen(false);
        login();
    };
    (0, $acw62.useEffect)(()=>{
        const logoutTimer = setInterval(()=>{
            if (token) {
                const payload = (0, $54c991629ee0a8ce$exports.decode)(token);
                const remainingTokenLifetime = (payload?.exp * 1000 - Date.now()) / 60000; // minutes
                if (remainingTokenLifetime < 10 && remainingTokenLifetime > 5) setOpen(true);
                else if (remainingTokenLifetime < 5) onExit();
            }
        }, 180000);
        return ()=>clearInterval(logoutTimer);
    }, [
        token
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        open: open,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                children: t("istuntodialog.title")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                dividers: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        i18nKey: "istuntodialog.content",
                        components: {
                            b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {}),
                            p: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {})
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        autoFocus: true,
                        onClick: onExit,
                        children: t("istuntodialog.back")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        onClick: onContinue,
                        children: t("istuntodialog.continue")
                    })
                ]
            })
        ]
    });
}


var $666bc8f27f76152a$exports = {};
(function(global, factory) {
    $666bc8f27f76152a$exports = factory();
})($666bc8f27f76152a$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});




function $e0bb8374e8619b72$export$57e714f81a2c3d86(token) {
    return {
        type: (0, $d18a0a91bd86f32d$export$eb728d1e04946462),
        payload: token
    };
}
function $e0bb8374e8619b72$export$95d23a5f596fdc8e() {
    return {
        type: (0, $d18a0a91bd86f32d$export$53f522aeda635e8b)
    };
}


function $78830b532ad30aed$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const token = (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get("TikalToken");
    if (token) {
        dispatch((0, $e0bb8374e8619b72$export$57e714f81a2c3d86)(token));
        (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).remove("TikalToken", {
            domain: ".luke.fi"
        });
    }
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");

var $dbf501d16b9c17ad$exports = {};

$dbf501d16b9c17ad$exports = new URL((parcelRequire("27Lyk")).resolve("lyIMi"), import.meta.url).toString();


var $8deca4a369a5f7fa$exports = {};

$8deca4a369a5f7fa$exports = new URL((parcelRequire("27Lyk")).resolve("6JWf1"), import.meta.url).toString();



function $0eab64f4fb796a14$export$5f2bdd6b3206051e() {
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ meta: meta })=>meta.ttyyppi) || 1;
}
function $0eab64f4fb796a14$export$6dae7db33dd9c904() {
    const viljakasvit = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.meta.valkuaiskasvit.sort((a, b)=>a.order - b.order));
    const korjuutavat = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.ValkuaiskasvienSatotiedot);
    const opts = {};
    viljakasvit.forEach((row)=>{
        opts[row.id] = {
            ...row,
            ...korjuutavat.find((k)=>k.Kasvilaji === row.id)
        };
    });
    return opts;
}




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $3b74e724e26e2cba$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        actions: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            },
            ["@media print"]: {
                display: "none !important"
            },
            display: "flex",
            marginTop: theme.spacing(2),
            justifyContent: "space-between"
        }
    }));
function $3b74e724e26e2cba$export$2e2bcd8739ae039({ children: children }) {
    const classes = $3b74e724e26e2cba$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.actions,
        children: children
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
/**
 * Provides information about the current step in Stepper.
 */ const $9eb879b6e31989e0$var$StepperContext = /*#__PURE__*/ $acw62.createContext({});
function $9eb879b6e31989e0$export$1ff9b16b13b0447() {
    return $acw62.useContext($9eb879b6e31989e0$var$StepperContext);
}
var $9eb879b6e31989e0$export$2e2bcd8739ae039 = $9eb879b6e31989e0$var$StepperContext;



var $acw62 = parcelRequire("acw62");
/**
 * Provides information about the current step in Stepper.
 */ const $a82caf2e329a5865$var$StepContext = /*#__PURE__*/ $acw62.createContext({});
function $a82caf2e329a5865$export$90d5f24cfecec416() {
    return $acw62.useContext($a82caf2e329a5865$var$StepContext);
}
var $a82caf2e329a5865$export$2e2bcd8739ae039 = $a82caf2e329a5865$var$StepContext;



var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $55b60af22f619573$export$8977e0f3c012cfac(slot) {
    return (0, $4Cod0.default)("MuiStep", slot);
}
const $55b60af22f619573$var$stepClasses = (0, $beCSm.default)("MuiStep", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "completed"
]);
var $55b60af22f619573$export$2e2bcd8739ae039 = $55b60af22f619573$var$stepClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $75af78c9da0fe470$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $75af78c9da0fe470$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            completed && "completed"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $55b60af22f619573$export$8977e0f3c012cfac), classes);
};
const $75af78c9da0fe470$var$StepRoot = (0, $1Ikg4.default)("div", {
    name: "MuiStep",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({}, ownerState.orientation === "horizontal" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: "relative"
    }));
const $75af78c9da0fe470$var$Step = /*#__PURE__*/ $acw62.forwardRef(function Step(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiStep"
    });
    const { active: activeProp, children: children, className: className, component: component = "div", completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $1sz44.default)(props, $75af78c9da0fe470$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $acw62.useContext((0, $9eb879b6e31989e0$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $acw62.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $e8gS1.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $75af78c9da0fe470$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $ayMG0.jsxs)($75af78c9da0fe470$var$StepRoot, (0, $e8gS1.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a82caf2e329a5865$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $75af78c9da0fe470$export$2e2bcd8739ae039 = $75af78c9da0fe470$var$Step;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $b7b6f614b7ddde24$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $f1978192be49e14c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");



var $2VxZV = parcelRequire("2VxZV");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3276960dd870b84b$export$62a6e0748bec9297(slot) {
    return (0, $4Cod0.default)("MuiStepIcon", slot);
}
const $3276960dd870b84b$var$stepIconClasses = (0, $beCSm.default)("MuiStepIcon", [
    "root",
    "active",
    "completed",
    "error",
    "text"
]);
var $3276960dd870b84b$export$2e2bcd8739ae039 = $3276960dd870b84b$var$stepIconClasses;



var $ayMG0 = parcelRequire("ayMG0");
var $125e5fbc28a24425$var$_circle;
const $125e5fbc28a24425$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $125e5fbc28a24425$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active",
            completed && "completed",
            error && "error"
        ],
        text: [
            "text"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3276960dd870b84b$export$62a6e0748bec9297), classes);
};
const $125e5fbc28a24425$var$StepIconRoot = (0, $1Ikg4.default)((0, $2VxZV.default), {
    name: "MuiStepIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $3276960dd870b84b$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $3276960dd870b84b$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $3276960dd870b84b$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $125e5fbc28a24425$var$StepIconText = (0, $1Ikg4.default)("text", {
    name: "MuiStepIcon",
    slot: "Text",
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $125e5fbc28a24425$var$StepIcon = /*#__PURE__*/ $acw62.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiStepIcon"
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $1sz44.default)(props, $125e5fbc28a24425$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $125e5fbc28a24425$var$useUtilityClasses(ownerState);
    if (typeof icon === "number" || typeof icon === "string") {
        const className = (0, $1SA7b.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($125e5fbc28a24425$var$StepIconRoot, (0, $e8gS1.default)({
            as: (0, $f1978192be49e14c$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $ayMG0.jsx)($125e5fbc28a24425$var$StepIconRoot, (0, $e8gS1.default)({
            as: (0, $b7b6f614b7ddde24$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($125e5fbc28a24425$var$StepIconRoot, (0, $e8gS1.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $125e5fbc28a24425$var$_circle || ($125e5fbc28a24425$var$_circle = /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($125e5fbc28a24425$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $125e5fbc28a24425$export$2e2bcd8739ae039 = $125e5fbc28a24425$var$StepIcon;





var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3fede488ce196f71$export$9625a725551d158a(slot) {
    return (0, $4Cod0.default)("MuiStepLabel", slot);
}
const $3fede488ce196f71$var$stepLabelClasses = (0, $beCSm.default)("MuiStepLabel", [
    "root",
    "horizontal",
    "vertical",
    "label",
    "active",
    "completed",
    "error",
    "disabled",
    "iconContainer",
    "alternativeLabel",
    "labelContainer"
]);
var $3fede488ce196f71$export$2e2bcd8739ae039 = $3fede488ce196f71$var$stepLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $b7a6aa590340583d$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $b7a6aa590340583d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        label: [
            "label",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        iconContainer: [
            "iconContainer",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        labelContainer: [
            "labelContainer",
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3fede488ce196f71$export$9625a725551d158a), classes);
};
const $b7a6aa590340583d$var$StepLabelRoot = (0, $1Ikg4.default)("span", {
    name: "MuiStepLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "flex",
        alignItems: "center",
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: "column"
        },
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.orientation === "vertical" && {
        textAlign: "left",
        padding: "8px 0"
    }));
const $b7a6aa590340583d$var$StepLabelLabel = (0, $1Ikg4.default)("span", {
    name: "MuiStepLabel",
    slot: "Label",
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $e8gS1.default)({}, theme.typography.body2, {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $b7a6aa590340583d$var$StepLabelIconContainer = (0, $1Ikg4.default)("span", {
    name: "MuiStepLabel",
    slot: "IconContainer",
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: "flex",
        paddingRight: 8,
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $b7a6aa590340583d$var$StepLabelLabelContainer = (0, $1Ikg4.default)("span", {
    name: "MuiStepLabel",
    slot: "LabelContainer",
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: "100%",
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $3fede488ce196f71$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: "center"
        }
    }));
const $b7a6aa590340583d$var$StepLabel = /*#__PURE__*/ $acw62.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiStepLabel"
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $1sz44.default)(props, $b7a6aa590340583d$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $acw62.useContext((0, $9eb879b6e31989e0$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $acw62.useContext((0, $a82caf2e329a5865$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $125e5fbc28a24425$export$2e2bcd8739ae039);
    const ownerState = (0, $e8gS1.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $b7a6aa590340583d$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b7a6aa590340583d$var$StepLabelRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)($b7a6aa590340583d$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(StepIconComponent, (0, $e8gS1.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($b7a6aa590340583d$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $ayMG0.jsx)($b7a6aa590340583d$var$StepLabelLabel, (0, $e8gS1.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $1SA7b.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$b7a6aa590340583d$var$StepLabel.muiName = "StepLabel";
var $b7a6aa590340583d$export$2e2bcd8739ae039 = $b7a6aa590340583d$var$StepLabel;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $00ca7923feb07e5e$export$797947b6292e28e1(slot) {
    return (0, $4Cod0.default)("MuiStepper", slot);
}
const $00ca7923feb07e5e$var$stepperClasses = (0, $beCSm.default)("MuiStepper", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel"
]);
var $00ca7923feb07e5e$export$2e2bcd8739ae039 = $00ca7923feb07e5e$var$stepperClasses;



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e8b79390bab8a4d4$export$6fbaff484b0d9308(slot) {
    return (0, $4Cod0.default)("MuiStepConnector", slot);
}
const $e8b79390bab8a4d4$var$stepConnectorClasses = (0, $beCSm.default)("MuiStepConnector", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "active",
    "completed",
    "disabled",
    "line",
    "lineHorizontal",
    "lineVertical"
]);
var $e8b79390bab8a4d4$export$2e2bcd8739ae039 = $e8b79390bab8a4d4$var$stepConnectorClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $88188b1334fa69af$var$_excluded = [
    "className"
];
const $88188b1334fa69af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            active && "active",
            completed && "completed",
            disabled && "disabled"
        ],
        line: [
            "line",
            `line${(0, $3AM7p.default)(orientation)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e8b79390bab8a4d4$export$6fbaff484b0d9308), classes);
};
const $88188b1334fa69af$var$StepConnectorRoot = (0, $1Ikg4.default)("div", {
    name: "MuiStepConnector",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        flex: "1 1 auto"
    }, ownerState.orientation === "vertical" && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: "absolute",
        top: 12,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)"
    }));
const $88188b1334fa69af$var$StepConnectorLine = (0, $1Ikg4.default)("span", {
    name: "MuiStepConnector",
    slot: "Line",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $3AM7p.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $e8gS1.default)({
        display: "block",
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === "horizontal" && {
        borderTopStyle: "solid",
        borderTopWidth: 1
    }, ownerState.orientation === "vertical" && {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $88188b1334fa69af$var$StepConnector = /*#__PURE__*/ $acw62.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiStepConnector"
    });
    const { className: className } = props, other = (0, $1sz44.default)(props, $88188b1334fa69af$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = "horizontal" } = $acw62.useContext((0, $9eb879b6e31989e0$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $acw62.useContext((0, $a82caf2e329a5865$export$2e2bcd8739ae039));
    const ownerState = (0, $e8gS1.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $88188b1334fa69af$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($88188b1334fa69af$var$StepConnectorRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($88188b1334fa69af$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $88188b1334fa69af$export$2e2bcd8739ae039 = $88188b1334fa69af$var$StepConnector;




var $ayMG0 = parcelRequire("ayMG0");
const $df88535386b73ee4$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $df88535386b73ee4$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $00ca7923feb07e5e$export$797947b6292e28e1), classes);
};
const $df88535386b73ee4$var$StepperRoot = (0, $1Ikg4.default)("div", {
    name: "MuiStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "flex"
    }, ownerState.orientation === "horizontal" && {
        flexDirection: "row",
        alignItems: "center"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.alternativeLabel && {
        alignItems: "flex-start"
    }));
const $df88535386b73ee4$var$defaultConnector = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88188b1334fa69af$export$2e2bcd8739ae039), {});
const $df88535386b73ee4$var$Stepper = /*#__PURE__*/ $acw62.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiStepper"
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = "div", connector: connector = $df88535386b73ee4$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = "horizontal" } = props, other = (0, $1sz44.default)(props, $df88535386b73ee4$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $df88535386b73ee4$var$useUtilityClasses(ownerState);
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $acw62.cloneElement(step, (0, $e8gS1.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $acw62.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9eb879b6e31989e0$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($df88535386b73ee4$var$StepperRoot, (0, $e8gS1.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $df88535386b73ee4$export$2e2bcd8739ae039 = $df88535386b73ee4$var$Stepper;



parcelRequire("acw62");




/**
 * Application's pathnames without inquiry prefix
 */ const $155cd4757147cec6$var$paths = {
    aloitus: "aloitus",
    kiitos: "kiitos",
    lisatiedot: "lisatiedot",
    muidenviljelykasviensatotiedot: "muiden-viljelykasvien-satotiedot",
    perunansatotiedot: "perunan-satotiedot",
    rehunurmensatotiedot: "rehunurmen-satotiedot",
    satojavarastot: "sato-ja-varastot",
    syyskylvot: "syyskylvot",
    valkuaiskasviensatotiedot: "valkuaiskasvien-satotiedot",
    vastauskoodit: "vastauskoodit",
    viljansatotiedot: "viljan-satotiedot",
    viljanvarastot: "viljan-varastot",
    yhteenveto: "yhteenveto"
};
var $155cd4757147cec6$export$2e2bcd8739ae039 = $155cd4757147cec6$var$paths;



var $920660c8aca77688$exports = {};

$parcel$export($920660c8aca77688$exports, "addMethod", () => $920660c8aca77688$export$20be359f745f973c);
$parcel$export($920660c8aca77688$exports, "mixed", () => $9baedbe56e25b51a$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "bool", () => $0237b22d97657ad7$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "boolean", () => $0237b22d97657ad7$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "string", () => $bcc252d93ab3046c$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "number", () => $425f4614c2bd74f2$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "date", () => $647598aeb0c659d9$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "object", () => $cd7706ce94a8dfd1$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "array", () => $e218604b96487b25$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "ref", () => $f5cdfa956e941194$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "lazy", () => $5a78aa552a6b7bb3$export$185802fd694ee1f5);
$parcel$export($920660c8aca77688$exports, "reach", () => $5b552ca0a6c1ed5f$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "isSchema", () => $1d4517ced724be00$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "setLocale", () => $eabff3e78de076bd$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "ValidationError", () => $d2e70d35996a7daf$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "BaseSchema", () => $bcee4fc8dbde13e1$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "MixedSchema", () => $9baedbe56e25b51a$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "BooleanSchema", () => $0237b22d97657ad7$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "StringSchema", () => $bcc252d93ab3046c$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "NumberSchema", () => $425f4614c2bd74f2$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "DateSchema", () => $647598aeb0c659d9$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "ObjectSchema", () => $cd7706ce94a8dfd1$export$2e2bcd8739ae039);
$parcel$export($920660c8aca77688$exports, "ArraySchema", () => $e218604b96487b25$export$2e2bcd8739ae039);
// ES6 Map
var $c20a5baa3b2b3be7$var$map;
try {
    $c20a5baa3b2b3be7$var$map = Map;
} catch (_) {}
var $c20a5baa3b2b3be7$var$set;
// ES6 Set
try {
    $c20a5baa3b2b3be7$var$set = Set;
} catch (_) {}
function $c20a5baa3b2b3be7$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($c20a5baa3b2b3be7$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($c20a5baa3b2b3be7$var$map && src instanceof $c20a5baa3b2b3be7$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($c20a5baa3b2b3be7$var$set && src instanceof $c20a5baa3b2b3be7$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $c20a5baa3b2b3be7$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $c20a5baa3b2b3be7$export$2e2bcd8739ae039(src) {
    return $c20a5baa3b2b3be7$var$baseClone(src, [], []);
}


const $3bcbbcae986c2431$var$toString = Object.prototype.toString;
const $3bcbbcae986c2431$var$errorToString = Error.prototype.toString;
const $3bcbbcae986c2431$var$regExpToString = RegExp.prototype.toString;
const $3bcbbcae986c2431$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $3bcbbcae986c2431$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $3bcbbcae986c2431$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $3bcbbcae986c2431$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $3bcbbcae986c2431$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $3bcbbcae986c2431$var$symbolToString.call(val).replace($3bcbbcae986c2431$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $3bcbbcae986c2431$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $3bcbbcae986c2431$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $3bcbbcae986c2431$var$regExpToString.call(val);
    return null;
}
function $3bcbbcae986c2431$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $3bcbbcae986c2431$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $3bcbbcae986c2431$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $3ea8894c2d1a8ff8$export$9b30b6294c1449a8 = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let $3ea8894c2d1a8ff8$export$22b082955e083ec3 = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $3ea8894c2d1a8ff8$export$98e628dec113755e = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $3ea8894c2d1a8ff8$export$324d90190a8b822a = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $3ea8894c2d1a8ff8$export$4a21f16c33752377 = {
    isValue: "${path} field must be ${value}"
};
let $3ea8894c2d1a8ff8$export$be5493f9613cbbe = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $3ea8894c2d1a8ff8$export$2f23118c22fb2630 = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
var $3ea8894c2d1a8ff8$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $3ea8894c2d1a8ff8$export$9b30b6294c1449a8,
    string: $3ea8894c2d1a8ff8$export$22b082955e083ec3,
    number: $3ea8894c2d1a8ff8$export$98e628dec113755e,
    date: $3ea8894c2d1a8ff8$export$324d90190a8b822a,
    object: $3ea8894c2d1a8ff8$export$be5493f9613cbbe,
    array: $3ea8894c2d1a8ff8$export$2f23118c22fb2630,
    boolean: $3ea8894c2d1a8ff8$export$4a21f16c33752377
});


var $e21135b6db383fe3$exports = {};
var $3c47f0745c8ad323$exports = {};
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
$3c47f0745c8ad323$exports = $3c47f0745c8ad323$var$baseHas;


var $85aaea8f77d790ae$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, "create");
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, "Map");
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8d50e526a9e9b7fa$exports,
        "map": new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        "string": new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype["delete"] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + "";
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;



var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $6b5a5095e0934938$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $3c47f0745c8ad323$exports);
}
$e21135b6db383fe3$exports = $e21135b6db383fe3$var$has;


const $1d4517ced724be00$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $1d4517ced724be00$export$2e2bcd8739ae039 = $1d4517ced724be00$var$isSchema;


class $7e653e8008789a27$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
var $7e653e8008789a27$export$2e2bcd8739ae039 = $7e653e8008789a27$var$Condition;



function $245da59127fdc582$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $d2e70d35996a7daf$var$_extends() {
    $d2e70d35996a7daf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2e70d35996a7daf$var$_extends.apply(this, arguments);
}
let $d2e70d35996a7daf$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $d2e70d35996a7daf$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = $d2e70d35996a7daf$var$_extends({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($d2e70d35996a7daf$var$strReg, (_, key)=>(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $245da59127fdc582$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($d2e70d35996a7daf$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d2e70d35996a7daf$export$2e2bcd8739ae039);
    }
}


const $d2d0e6ad55c8832e$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $d2d0e6ad55c8832e$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $d2d0e6ad55c8832e$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $17211428bc2045c4$exports = {};
var $96b401257ea00d24$exports = {};
var $31e24313ace94404$exports = {};

var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;


var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;





var $f504n = parcelRequire("f504n");

var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, "DataView");
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, "Promise");
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, "Set");
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, "WeakMap");
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};

var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == "object") return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17211428bc2045c4$exports = $17211428bc2045c4$var$mapValues;



var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


const $f5cdfa956e941194$var$prefixes = {
    context: "$",
    value: "."
};
function $f5cdfa956e941194$export$185802fd694ee1f5(key, options) {
    return new $f5cdfa956e941194$export$2e2bcd8739ae039(key, options);
}
class $f5cdfa956e941194$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $f5cdfa956e941194$var$prefixes.context;
        this.isValue = this.key[0] === $f5cdfa956e941194$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $f5cdfa956e941194$var$prefixes.context : this.isValue ? $f5cdfa956e941194$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$f5cdfa956e941194$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $7c576e9ad8044c54$var$_extends() {
    $7c576e9ad8044c54$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c576e9ad8044c54$var$_extends.apply(this, arguments);
}
function $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7c576e9ad8044c54$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = "", label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))($7c576e9ad8044c54$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $7c576e9ad8044c54$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $5b552ca0a6c1ed5f$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $5b552ca0a6c1ed5f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $5b552ca0a6c1ed5f$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $5b552ca0a6c1ed5f$var$reach = (obj, path, value, context)=>$5b552ca0a6c1ed5f$export$c52e5867d5879e24(obj, path, value, context).schema;
var $5b552ca0a6c1ed5f$export$2e2bcd8739ae039 = $5b552ca0a6c1ed5f$var$reach;




class $3f307508f67966f1$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $3f307508f67966f1$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $bcee4fc8dbde13e1$var$_extends() {
    $bcee4fc8dbde13e1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bcee4fc8dbde13e1$var$_extends.apply(this, arguments);
}
class $bcee4fc8dbde13e1$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $3f307508f67966f1$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $3f307508f67966f1$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = $bcee4fc8dbde13e1$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $bcee4fc8dbde13e1$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $c20a5baa3b2b3be7$export$2e2bcd8739ae039)($bcee4fc8dbde13e1$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $bcee4fc8dbde13e1$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($bcee4fc8dbde13e1$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $bcee4fc8dbde13e1$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $bcee4fc8dbde13e1$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, $c20a5baa3b2b3be7$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message: message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, $245da59127fdc582$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $f5cdfa956e941194$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $7e653e8008789a27$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $5b552ca0a6c1ed5f$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $bcee4fc8dbde13e1$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notOneOf;
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.optional = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notRequired;


const $9baedbe56e25b51a$var$Mixed = (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039);
var $9baedbe56e25b51a$export$2e2bcd8739ae039 = $9baedbe56e25b51a$var$Mixed;
function $9baedbe56e25b51a$export$185802fd694ee1f5() {
    return new $9baedbe56e25b51a$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$9baedbe56e25b51a$export$185802fd694ee1f5.prototype = $9baedbe56e25b51a$var$Mixed.prototype;




const $55daa1cd95624d91$var$isAbsent = (value)=>value == null;
var $55daa1cd95624d91$export$2e2bcd8739ae039 = $55daa1cd95624d91$var$isAbsent;


function $0237b22d97657ad7$export$185802fd694ee1f5() {
    return new $0237b22d97657ad7$export$2e2bcd8739ae039();
}
class $0237b22d97657ad7$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, $3ea8894c2d1a8ff8$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $3ea8894c2d1a8ff8$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$0237b22d97657ad7$export$185802fd694ee1f5.prototype = $0237b22d97657ad7$export$2e2bcd8739ae039.prototype;





let $bcc252d93ab3046c$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $bcc252d93ab3046c$var$isTrimmed = (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.trim();
let $bcc252d93ab3046c$var$objStringTag = ({}).toString();
function $bcc252d93ab3046c$export$185802fd694ee1f5() {
    return new $bcc252d93ab3046c$export$2e2bcd8739ae039();
}
class $bcc252d93ab3046c$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $bcc252d93ab3046c$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).email) {
        return this.matches($bcc252d93ab3046c$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).url) {
        return this.matches($bcc252d93ab3046c$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).uuid) {
        return this.matches($bcc252d93ab3046c$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $bcc252d93ab3046c$var$isTrimmed
        });
    }
    lowercase(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$bcc252d93ab3046c$export$185802fd694ee1f5.prototype = $bcc252d93ab3046c$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $425f4614c2bd74f2$var$isNaN = (value)=>value != +value;
function $425f4614c2bd74f2$export$185802fd694ee1f5() {
    return new $425f4614c2bd74f2$export$2e2bcd8739ae039();
}
class $425f4614c2bd74f2$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !$425f4614c2bd74f2$var$isNaN(value);
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).integer) {
        return this.test({
            name: "integer",
            message: message,
            test: (val)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$425f4614c2bd74f2$export$185802fd694ee1f5.prototype = $425f4614c2bd74f2$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7b96554ad88dbbc3$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7b96554ad88dbbc3$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7b96554ad88dbbc3$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $647598aeb0c659d9$var$invalidDate = new Date("");
let $647598aeb0c659d9$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $647598aeb0c659d9$export$185802fd694ee1f5() {
    return new $647598aeb0c659d9$export$2e2bcd8739ae039();
}
class $647598aeb0c659d9$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $7b96554ad88dbbc3$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $647598aeb0c659d9$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $647598aeb0c659d9$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$647598aeb0c659d9$export$2e2bcd8739ae039.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;
$647598aeb0c659d9$export$185802fd694ee1f5.prototype = $647598aeb0c659d9$export$2e2bcd8739ae039.prototype;
$647598aeb0c659d9$export$185802fd694ee1f5.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;



var $4f0248df72a92950$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = "\\u0300-\\u036f", $ed80fa8833e2b532$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ed80fa8833e2b532$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = "[" + $ed80fa8833e2b532$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, "");
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = "\ud800-\udfff", $325a565efdffbc96$var$rsComboMarksRange = "\\u0300-\\u036f", $325a565efdffbc96$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $325a565efdffbc96$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = "\\u2700-\\u27bf", $325a565efdffbc96$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $325a565efdffbc96$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $325a565efdffbc96$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $325a565efdffbc96$var$rsPunctuationRange = "\\u2000-\\u206f", $325a565efdffbc96$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $325a565efdffbc96$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $325a565efdffbc96$var$rsVarRange = "\\ufe0e\\ufe0f", $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['’]", $325a565efdffbc96$var$rsBreak = "[" + $325a565efdffbc96$var$rsBreakRange + "]", $325a565efdffbc96$var$rsCombo = "[" + $325a565efdffbc96$var$rsComboRange + "]", $325a565efdffbc96$var$rsDigits = "\\d+", $325a565efdffbc96$var$rsDingbat = "[" + $325a565efdffbc96$var$rsDingbatRange + "]", $325a565efdffbc96$var$rsLower = "[" + $325a565efdffbc96$var$rsLowerRange + "]", $325a565efdffbc96$var$rsMisc = "[^" + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsFitz = "\ud83c[\udffb-\udfff]", $325a565efdffbc96$var$rsModifier = "(?:" + $325a565efdffbc96$var$rsCombo + "|" + $325a565efdffbc96$var$rsFitz + ")", $325a565efdffbc96$var$rsNonAstral = "[^" + $325a565efdffbc96$var$rsAstralRange + "]", $325a565efdffbc96$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $325a565efdffbc96$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $325a565efdffbc96$var$rsUpper = "[" + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = "(?:" + $325a565efdffbc96$var$rsLower + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsMiscUpper = "(?:" + $325a565efdffbc96$var$rsUpper + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsOptContrLower = "(?:" + $325a565efdffbc96$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $325a565efdffbc96$var$rsOptContrUpper = "(?:" + $325a565efdffbc96$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + "?", $325a565efdffbc96$var$rsOptVar = "[" + $325a565efdffbc96$var$rsVarRange + "]?", $325a565efdffbc96$var$rsOptJoin = "(?:" + $325a565efdffbc96$var$rsZWJ + "(?:" + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ")*", $325a565efdffbc96$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $325a565efdffbc96$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = "(?:" + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsLower + "+" + $325a565efdffbc96$var$rsOptContrLower + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsMiscUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsMiscLower + "+" + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $f5d9385a9cc7e413$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['’]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, "")), callback, "");
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $4f0248df72a92950$var$snakeCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
$4f0248df72a92950$exports = $4f0248df72a92950$var$snakeCase;


var $d57e6f3349076887$exports = {};
var $49f1f8db3e260fbf$exports = {};

var $da6130e1e4702e32$exports = {};
var $0d9811a54a2f955a$exports = {};
var $cfe77c1a7b7c7d6e$exports = {};
var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $109fb88fe59de104$exports(array, start, end);
}
$cfe77c1a7b7c7d6e$exports = $cfe77c1a7b7c7d6e$var$castSlice;


var $00fdf7eab00be2e7$exports = {};
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = "\ud800-\udfff", $00fdf7eab00be2e7$var$rsComboMarksRange = "\\u0300-\\u036f", $00fdf7eab00be2e7$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $00fdf7eab00be2e7$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp("[" + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
$00fdf7eab00be2e7$exports = $00fdf7eab00be2e7$var$hasUnicode;


var $9a986c87d425808c$exports = {};
var $43b96a6d93895c83$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split("");
}
$43b96a6d93895c83$exports = $43b96a6d93895c83$var$asciiToArray;



var $c3bf9ebcb1b53b1d$exports = {};
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = "\ud800-\udfff", $c3bf9ebcb1b53b1d$var$rsComboMarksRange = "\\u0300-\\u036f", $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = "[" + $c3bf9ebcb1b53b1d$var$rsAstralRange + "]", $c3bf9ebcb1b53b1d$var$rsCombo = "[" + $c3bf9ebcb1b53b1d$var$rsComboRange + "]", $c3bf9ebcb1b53b1d$var$rsFitz = "\ud83c[\udffb-\udfff]", $c3bf9ebcb1b53b1d$var$rsModifier = "(?:" + $c3bf9ebcb1b53b1d$var$rsCombo + "|" + $c3bf9ebcb1b53b1d$var$rsFitz + ")", $c3bf9ebcb1b53b1d$var$rsNonAstral = "[^" + $c3bf9ebcb1b53b1d$var$rsAstralRange + "]", $c3bf9ebcb1b53b1d$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $c3bf9ebcb1b53b1d$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $c3bf9ebcb1b53b1d$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + "?", $c3bf9ebcb1b53b1d$var$rsOptVar = "[" + $c3bf9ebcb1b53b1d$var$rsVarRange + "]?", $c3bf9ebcb1b53b1d$var$rsOptJoin = "(?:" + $c3bf9ebcb1b53b1d$var$rsZWJ + "(?:" + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join("|") + ")" + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ")*", $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = "(?:" + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + "?",
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + "(?=" + $c3bf9ebcb1b53b1d$var$rsFitz + ")|" + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
$c3bf9ebcb1b53b1d$exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $00fdf7eab00be2e7$exports(string) ? $c3bf9ebcb1b53b1d$exports(string) : $43b96a6d93895c83$exports(string);
}
$9a986c87d425808c$exports = $9a986c87d425808c$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f5d9385a9cc7e413$exports(string);
        var strSymbols = $00fdf7eab00be2e7$exports(string) ? $9a986c87d425808c$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cfe77c1a7b7c7d6e$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$0d9811a54a2f955a$exports = $0d9811a54a2f955a$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $0d9811a54a2f955a$exports("toUpperCase");
$da6130e1e4702e32$exports = $da6130e1e4702e32$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $49f1f8db3e260fbf$var$capitalize(string) {
    return $da6130e1e4702e32$exports($f5d9385a9cc7e413$exports(string).toLowerCase());
}
$49f1f8db3e260fbf$exports = $49f1f8db3e260fbf$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $d57e6f3349076887$var$camelCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $49f1f8db3e260fbf$exports(word) : word);
});
$d57e6f3349076887$exports = $d57e6f3349076887$var$camelCase;


var $3415b394b567e74a$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $3415b394b567e74a$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$3415b394b567e74a$exports = $3415b394b567e74a$var$mapKeys;






var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $ade87c847c1ee6bb$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $1d4517ced724be00$export$2e2bcd8739ae039)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}


function $b59a7ce2e5e0a1e4$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $b59a7ce2e5e0a1e4$var$findIndex(keys, a) - $b59a7ce2e5e0a1e4$var$findIndex(keys, b);
    };
}





function $cd7706ce94a8dfd1$var$_extends() {
    $cd7706ce94a8dfd1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd7706ce94a8dfd1$var$_extends.apply(this, arguments);
}
let $cd7706ce94a8dfd1$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cd7706ce94a8dfd1$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cd7706ce94a8dfd1$var$defaultSort = (0, $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039)([]);
class $cd7706ce94a8dfd1$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = $cd7706ce94a8dfd1$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $cd7706ce94a8dfd1$var$isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $cd7706ce94a8dfd1$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$cd7706ce94a8dfd1$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], $cd7706ce94a8dfd1$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $cd7706ce94a8dfd1$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $ade87c847c1ee6bb$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(obj, from)) {
                newObj = $cd7706ce94a8dfd1$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $3ea8894c2d1a8ff8$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cd7706ce94a8dfd1$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $3ea8894c2d1a8ff8$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($3415b394b567e74a$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($d57e6f3349076887$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($4f0248df72a92950$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($4f0248df72a92950$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $cd7706ce94a8dfd1$export$185802fd694ee1f5(spec) {
    return new $cd7706ce94a8dfd1$export$2e2bcd8739ae039(spec);
}
$cd7706ce94a8dfd1$export$185802fd694ee1f5.prototype = $cd7706ce94a8dfd1$export$2e2bcd8739ae039.prototype;









function $e218604b96487b25$var$_extends() {
    $e218604b96487b25$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e218604b96487b25$var$_extends.apply(this, arguments);
}
function $e218604b96487b25$export$185802fd694ee1f5(type) {
    return new $e218604b96487b25$export$2e2bcd8739ae039(type);
}
class $e218604b96487b25$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $e218604b96487b25$var$_extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $e218604b96487b25$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$e218604b96487b25$export$185802fd694ee1f5.prototype = $e218604b96487b25$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $5a78aa552a6b7bb3$export$185802fd694ee1f5(builder) {
    return new $5a78aa552a6b7bb3$var$Lazy(builder);
}
class $5a78aa552a6b7bb3$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $5a78aa552a6b7bb3$export$2e2bcd8739ae039 = $5a78aa552a6b7bb3$var$Lazy;






function $eabff3e78de076bd$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $3ea8894c2d1a8ff8$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $920660c8aca77688$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}


var $16ddfb9208d7186e$export$ea8a71b4c90cb36;
(function(FieldsVastauskoodiKommentti) {
    FieldsVastauskoodiKommentti["VastauskoodiKommentti"] = "60376442716299";
})($16ddfb9208d7186e$export$ea8a71b4c90cb36 || ($16ddfb9208d7186e$export$ea8a71b4c90cb36 = {}));
var $16ddfb9208d7186e$export$4efffd68e8e9fa4c;
(function(FieldsVastauskoodi) {
    FieldsVastauskoodi["NO_PRODUCTION"] = "215176442721507";
    FieldsVastauskoodi["NO_INFORMATION"] = "215176442714599";
    FieldsVastauskoodi["NO_CONTACT"] = "2151764427391379";
    FieldsVastauskoodi["INFORMATION_AVAILABLE"] = "215176442714597";
})($16ddfb9208d7186e$export$4efffd68e8e9fa4c || ($16ddfb9208d7186e$export$4efffd68e8e9fa4c = {}));
const $16ddfb9208d7186e$export$60e5bc4d71c60812 = {
    NO_PRODUCTION: $16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_PRODUCTION,
    NO_INFORMATION: $16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_INFORMATION,
    NO_CONTACT: $16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_CONTACT,
    INFORMATION_AVAILABLE: $16ddfb9208d7186e$export$4efffd68e8e9fa4c.INFORMATION_AVAILABLE
};
const $16ddfb9208d7186e$export$7a75760034b90e9 = {
    [$16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_PRODUCTION]: 1,
    [$16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_INFORMATION]: 2,
    [$16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_CONTACT]: 3,
    [$16ddfb9208d7186e$export$4efffd68e8e9fa4c.INFORMATION_AVAILABLE]: 4
};
// regex joka löytää ei sallitut merkit
const $16ddfb9208d7186e$var$invalidCharactersRegex = /[`#$^&*_[\]{};\\|<>~]/;
const $16ddfb9208d7186e$export$bcefcf174d0c821 = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    vastauskoodi: $bcc252d93ab3046c$export$185802fd694ee1f5().oneOf([
        $16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_PRODUCTION,
        $16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_INFORMATION,
        $16ddfb9208d7186e$export$4efffd68e8e9fa4c.NO_CONTACT,
        $16ddfb9208d7186e$export$4efffd68e8e9fa4c.INFORMATION_AVAILABLE
    ]),
    vastauskoodiKommentti: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        [$16ddfb9208d7186e$export$ea8a71b4c90cb36.VastauskoodiKommentti]: $bcc252d93ab3046c$export$185802fd694ee1f5().test("invalidCharacters", "fields.errors.invalidCharacters", (item)=>item ? !item.match($16ddfb9208d7186e$var$invalidCharactersRegex) : true).trim()
    })
});


function $1c48e19d77c40bbb$export$2a81128bb716296c() {
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.ViljanSatotiedot);
}
function $1c48e19d77c40bbb$export$629a55e219471ce0() {
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.Varastotiedot);
}
function $1c48e19d77c40bbb$export$d4b2503a359650ed() {
    const perunansatotiedot = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.PerunanSatotiedot).sort((a, b)=>{
        const varhaisperunaId = "_21575";
        if (a.Kasvilaji === varhaisperunaId) return -1;
        else if (a.Kasvilaji === b.Kasvilaji) return 0;
        else return 1;
    });
    return perunansatotiedot;
}
function $1c48e19d77c40bbb$export$6dc76d0fc8fd54c5() {
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.ValkuaiskasvienSatotiedot);
}
function $1c48e19d77c40bbb$export$c935199da4e1ad1e() {
    return (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.vastauskoodi);
}
function $1c48e19d77c40bbb$export$29aee41b3e0c698f() {
    const vastauskoodi = $1c48e19d77c40bbb$export$c935199da4e1ad1e();
    return vastauskoodi === undefined || vastauskoodi && !!vastauskoodi[(0, $16ddfb9208d7186e$export$4efffd68e8e9fa4c).INFORMATION_AVAILABLE];
}



const $5358ea1077bf4480$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        nav: {
            color: "black"
        },
        title: {
            [theme.breakpoints.down("md")]: {
                display: "none"
            }
        },
        navLink: {
            color: "inherit",
            textDecoration: "none",
            cursor: "pointer"
        },
        disabled: {
            pointerEvents: "none"
        },
        divider: {
            marginTop: "24px",
            marginRight: "-1px",
            marginBottom: "24px",
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        },
        nested: {
            paddingLeft: theme.spacing(2)
        }
    }));
function $5358ea1077bf4480$var$isStepAllowed(stepHref, isInquiryDataAvailable) {
    return isInquiryDataAvailable || [
        (0, $155cd4757147cec6$export$2e2bcd8739ae039).vastauskoodit,
        (0, $155cd4757147cec6$export$2e2bcd8739ae039).yhteenveto
    ].includes(stepHref);
}
function $5358ea1077bf4480$export$2e2bcd8739ae039({ routes: routes, formId: formId }) {
    const user = (0, $557966054e36245a$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    const classes = $5358ea1077bf4480$var$useStyles();
    const isInquiryDataAvailable = (0, $1c48e19d77c40bbb$export$29aee41b3e0c698f)();
    let activeStep = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.step) || 0;
    if (user?.upn) activeStep += 1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        pt: 4,
        pb: 4,
        className: breakpoints.stepper,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $df88535386b73ee4$export$2e2bcd8739ae039), {
            activeStep: activeStep,
            alternativeLabel: true,
            children: [
                user?.upn && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $75af78c9da0fe470$export$2e2bcd8739ae039), {
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                            className: classes.navLink,
                            to: `vastauskoodit?id=${formId}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7a6aa590340583d$export$2e2bcd8739ae039), {
                                    children: t("common.vastauskoodit")
                                }),
                                " "
                            ]
                        }, "vastauskoodit")
                    ]
                }, "vastauskoodit"),
                routes.map((route, index)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75af78c9da0fe470$export$2e2bcd8739ae039), {
                        "data-testid": "stepper-step",
                        completed: $5358ea1077bf4480$var$isStepAllowed(route.href, isInquiryDataAvailable) && index + (user?.upn ? 1 : 0) < activeStep,
                        disabled: !$5358ea1077bf4480$var$isStepAllowed(route.href, isInquiryDataAvailable),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5358ea1077bf4480$var$RouteLabel, {
                            route: route,
                            formId: formId,
                            isCompletedOrActive: index <= activeStep,
                            disabled: !$5358ea1077bf4480$var$isStepAllowed(route.href, isInquiryDataAvailable)
                        })
                    }, route.text);
                })
            ]
        })
    });
}
function $5358ea1077bf4480$var$RouteLabel({ route: route, disabled: disabled, formId: formId, isCompletedOrActive: isCompletedOrActive }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $5358ea1077bf4480$var$useStyles();
    const Label = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7a6aa590340583d$export$2e2bcd8739ae039), {
            children: t(route.text)
        });
    if (!disabled && isCompletedOrActive) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
        className: classes.navLink,
        to: `${route.href}?id=${formId}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(Label, {}),
            " "
        ]
    }, route.text);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Label, {});
}



function $c49f7d6593097bdf$export$2e2bcd8739ae039() {
    return new URLSearchParams((0, $926608a7a86d7371$export$45d76561a5302f2b)().search);
}





var $ayMG0 = parcelRequire("ayMG0");

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a4737a8a027d021$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)("MuiCard", slot);
}
const $9a4737a8a027d021$var$cardClasses = (0, $beCSm.default)("MuiCard", [
    "root"
]);
var $9a4737a8a027d021$export$2e2bcd8739ae039 = $9a4737a8a027d021$var$cardClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $99712a90aa90aa89$var$_excluded = [
    "className",
    "raised"
];
const $99712a90aa90aa89$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9a4737a8a027d021$export$f3b76d2cce458caa), classes);
};
const $99712a90aa90aa89$var$CardRoot = (0, $1Ikg4.default)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $99712a90aa90aa89$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $1sz44.default)(props, $99712a90aa90aa89$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        raised: raised
    });
    const classes = $99712a90aa90aa89$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($99712a90aa90aa89$var$CardRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $99712a90aa90aa89$export$2e2bcd8739ae039 = $99712a90aa90aa89$var$Card;


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $935ef2657527bd0d$export$ee5828fb8c43a48e(slot) {
    return (0, $4Cod0.default)("MuiCardActionArea", slot);
}
const $935ef2657527bd0d$var$cardActionAreaClasses = (0, $beCSm.default)("MuiCardActionArea", [
    "root",
    "focusVisible",
    "focusHighlight"
]);
var $935ef2657527bd0d$export$2e2bcd8739ae039 = $935ef2657527bd0d$var$cardActionAreaClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $ad801f62d38bb2d2$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $ad801f62d38bb2d2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        focusHighlight: [
            "focusHighlight"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $935ef2657527bd0d$export$ee5828fb8c43a48e), classes);
};
const $ad801f62d38bb2d2$var$CardActionAreaRoot = (0, $1Ikg4.default)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: "MuiCardActionArea",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        textAlign: "inherit",
        width: "100%",
        [`&:hover .${(0, $935ef2657527bd0d$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            "@media (hover: none)": {
                opacity: 0
            }
        },
        [`&.${(0, $935ef2657527bd0d$export$2e2bcd8739ae039).focusVisible} .${(0, $935ef2657527bd0d$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $ad801f62d38bb2d2$var$CardActionAreaFocusHighlight = (0, $1Ikg4.default)("span", {
    name: "MuiCardActionArea",
    slot: "FocusHighlight",
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: "inherit",
        opacity: 0,
        backgroundColor: "currentcolor",
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.short
        })
    }));
const $ad801f62d38bb2d2$var$CardActionArea = /*#__PURE__*/ $acw62.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCardActionArea"
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $1sz44.default)(props, $ad801f62d38bb2d2$var$_excluded);
    const ownerState = props;
    const classes = $ad801f62d38bb2d2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ad801f62d38bb2d2$var$CardActionAreaRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        focusVisibleClassName: (0, $1SA7b.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)($ad801f62d38bb2d2$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $ad801f62d38bb2d2$export$2e2bcd8739ae039 = $ad801f62d38bb2d2$var$CardActionArea;


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $118171a03565b94b$export$964336739a8c7119(slot) {
    return (0, $4Cod0.default)("MuiCardContent", slot);
}
const $118171a03565b94b$var$cardContentClasses = (0, $beCSm.default)("MuiCardContent", [
    "root"
]);
var $118171a03565b94b$export$2e2bcd8739ae039 = $118171a03565b94b$var$cardContentClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $e721a73094186d5d$var$_excluded = [
    "className",
    "component"
];
const $e721a73094186d5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $118171a03565b94b$export$964336739a8c7119), classes);
};
const $e721a73094186d5d$var$CardContentRoot = (0, $1Ikg4.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $e721a73094186d5d$var$CardContent = /*#__PURE__*/ $acw62.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $1sz44.default)(props, $e721a73094186d5d$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component
    });
    const classes = $e721a73094186d5d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e721a73094186d5d$var$CardContentRoot, (0, $e8gS1.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $e721a73094186d5d$export$2e2bcd8739ae039 = $e721a73094186d5d$var$CardContent;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2abc9ba3407d6d9d$export$5f5333fe417019a7(slot) {
    return (0, $4Cod0.default)("MuiCardMedia", slot);
}
const $2abc9ba3407d6d9d$var$cardMediaClasses = (0, $beCSm.default)("MuiCardMedia", [
    "root",
    "media",
    "img"
]);
var $2abc9ba3407d6d9d$export$2e2bcd8739ae039 = $2abc9ba3407d6d9d$var$cardMediaClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $eec1235702964728$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $eec1235702964728$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            "root",
            isMediaComponent && "media",
            isImageComponent && "img"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2abc9ba3407d6d9d$export$5f5333fe417019a7), classes);
};
const $eec1235702964728$var$CardMediaRoot = (0, $1Ikg4.default)("div", {
    name: "MuiCardMedia",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }, ownerState.isMediaComponent && {
        width: "100%"
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover"
    }));
const $eec1235702964728$var$MEDIA_COMPONENTS = [
    "video",
    "audio",
    "picture",
    "iframe",
    "img"
];
const $eec1235702964728$var$IMAGE_COMPONENTS = [
    "picture",
    "img"
];
const $eec1235702964728$var$CardMedia = /*#__PURE__*/ $acw62.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCardMedia"
    });
    const { children: children, className: className, component: component = "div", image: image, src: src, style: style } = props, other = (0, $1sz44.default)(props, $eec1235702964728$var$_excluded);
    const isMediaComponent = $eec1235702964728$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $e8gS1.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $eec1235702964728$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $eec1235702964728$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eec1235702964728$var$CardMediaRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? "img" : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $eec1235702964728$export$2e2bcd8739ae039 = $eec1235702964728$var$CardMedia;



parcelRequire("acw62");

const $94b3a8ce74314e9b$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        action: {
            textDecoration: "none"
        },
        media: {
            height: "140px"
        },
        title: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        },
        card: {
            height: "100%"
        }
    }));
function $94b3a8ce74314e9b$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, image: image, href: href }) {
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    const classes = $94b3a8ce74314e9b$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
        className: classes.card,
        onClick: ()=>navigate(href),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ad801f62d38bb2d2$export$2e2bcd8739ae039), {
            children: [
                image && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eec1235702964728$export$2e2bcd8739ae039), {
                    className: classes.media,
                    title: title,
                    image: image
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e721a73094186d5d$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            className: classes.title,
                            gutterBottom: true,
                            variant: "h3",
                            children: title
                        }),
                        subtitle
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $8zogs = parcelRequire("8zogs");

var $3AM7p = parcelRequire("3AM7p");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd7829380e349eb6$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)("MuiCircularProgress", slot);
}
const $fd7829380e349eb6$var$circularProgressClasses = (0, $beCSm.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $fd7829380e349eb6$export$2e2bcd8739ae039 = $fd7829380e349eb6$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $32db5964c492ae2d$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $32db5964c492ae2d$var$_ = (t)=>t, $32db5964c492ae2d$var$_t, $32db5964c492ae2d$var$_t2, $32db5964c492ae2d$var$_t3, $32db5964c492ae2d$var$_t4;
const $32db5964c492ae2d$var$SIZE = 44;
const $32db5964c492ae2d$var$circularRotateKeyframe = (0, $8zogs.keyframes)($32db5964c492ae2d$var$_t || ($32db5964c492ae2d$var$_t = $32db5964c492ae2d$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $32db5964c492ae2d$var$circularDashKeyframe = (0, $8zogs.keyframes)($32db5964c492ae2d$var$_t2 || ($32db5964c492ae2d$var$_t2 = $32db5964c492ae2d$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $32db5964c492ae2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $3AM7p.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $3AM7p.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd7829380e349eb6$export$29cad1383b3f235d), classes);
};
const $32db5964c492ae2d$var$CircularProgressRoot = (0, $1Ikg4.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $e8gS1.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $8zogs.css)($32db5964c492ae2d$var$_t3 || ($32db5964c492ae2d$var$_t3 = $32db5964c492ae2d$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $32db5964c492ae2d$var$circularRotateKeyframe));
const $32db5964c492ae2d$var$CircularProgressSVG = (0, $1Ikg4.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $32db5964c492ae2d$var$CircularProgressCircle = (0, $1Ikg4.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $3AM7p.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $e8gS1.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $8zogs.css)($32db5964c492ae2d$var$_t4 || ($32db5964c492ae2d$var$_t4 = $32db5964c492ae2d$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $32db5964c492ae2d$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $32db5964c492ae2d$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $1sz44.default)(props, $32db5964c492ae2d$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $32db5964c492ae2d$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($32db5964c492ae2d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        style: (0, $e8gS1.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE} ${$32db5964c492ae2d$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $32db5964c492ae2d$var$SIZE,
                cy: $32db5964c492ae2d$var$SIZE,
                r: ($32db5964c492ae2d$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $32db5964c492ae2d$export$2e2bcd8739ae039 = $32db5964c492ae2d$var$CircularProgress;


parcelRequire("acw62");
const $4a2a6b1040c5d176$var$CenteredCircularProgress = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            height: "100%",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
    });
var $4a2a6b1040c5d176$export$2e2bcd8739ae039 = $4a2a6b1040c5d176$var$CenteredCircularProgress;




var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");
const $7e3454bd6982de9c$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        box: {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            textShadow: "0.01em 0 rgba(0, 0, 0, 0.2),0 0.01em rgba(0, 0, 0, 0.2),-0.01em 0 rgba(0, 0, 0, 0.2),0 -0.01em rgba(0, 0, 0, 0.2)"
        }
    }));
function $7e3454bd6982de9c$export$2e2bcd8739ae039({ children: children, props: props }) {
    const classes = $7e3454bd6982de9c$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        ...props,
        className: classes.box,
        pr: 8,
        pl: 8,
        pt: 8,
        pb: 8,
        children: children
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $36464e4be8053fb8$var$_extends() {
    $36464e4be8053fb8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36464e4be8053fb8$var$_extends.apply(this, arguments);
}
// A type of promise-like that resolves synchronously and supports only one observer
const $36464e4be8053fb8$var$_iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
const $36464e4be8053fb8$var$_asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";
// Asynchronously await a promise and pass the result to a finally continuation
function $36464e4be8053fb8$var$_finallyRethrows(body, finalizer) {
    try {
        var result = body();
    } catch (e) {
        return finalizer(true, e);
    }
    if (result && result.then) return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
    return finalizer(false, value);
}
var $36464e4be8053fb8$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect); // Assign current value to a ref and returns a stable getter to get the latest value.
// This way we are sure to always get latest value provided to hook and
// avoid weird issues due to closures capturing stale values...
// See https://github.com/facebook/react/issues/16956
// See https://overreacted.io/making-setinterval-declarative-with-react-hooks/
var $36464e4be8053fb8$var$useGetter = function useGetter(t) {
    var ref = (0, $acw62.useRef)(t);
    $36464e4be8053fb8$var$useIsomorphicLayoutEffect(function() {
        ref.current = t;
    });
    return (0, $acw62.useCallback)(function() {
        return ref.current;
    }, [
        ref
    ]);
};
var $36464e4be8053fb8$var$InitialAsyncState = {
    status: "not-requested",
    loading: false,
    result: undefined,
    error: undefined
};
var $36464e4be8053fb8$var$InitialAsyncLoadingState = {
    status: "loading",
    loading: true,
    result: undefined,
    error: undefined
};
var $36464e4be8053fb8$var$defaultSetLoading = function defaultSetLoading(_asyncState) {
    return $36464e4be8053fb8$var$InitialAsyncLoadingState;
};
var $36464e4be8053fb8$var$defaultSetResult = function defaultSetResult(result, _asyncState) {
    return {
        status: "success",
        loading: false,
        result: result,
        error: undefined
    };
};
var $36464e4be8053fb8$var$defaultSetError = function defaultSetError(error, _asyncState) {
    return {
        status: "error",
        loading: false,
        result: undefined,
        error: error
    };
};
var $36464e4be8053fb8$var$noop = function noop() {};
var $36464e4be8053fb8$var$DefaultOptions = {
    initialState: function initialState(options) {
        return options && options.executeOnMount ? $36464e4be8053fb8$var$InitialAsyncLoadingState : $36464e4be8053fb8$var$InitialAsyncState;
    },
    executeOnMount: true,
    executeOnUpdate: true,
    setLoading: $36464e4be8053fb8$var$defaultSetLoading,
    setResult: $36464e4be8053fb8$var$defaultSetResult,
    setError: $36464e4be8053fb8$var$defaultSetError,
    onSuccess: $36464e4be8053fb8$var$noop,
    onError: $36464e4be8053fb8$var$noop
};
var $36464e4be8053fb8$var$normalizeOptions = function normalizeOptions(options) {
    return $36464e4be8053fb8$var$_extends({}, $36464e4be8053fb8$var$DefaultOptions, {}, options);
};
var $36464e4be8053fb8$var$useAsyncState = function useAsyncState(options) {
    var _useState = (0, $acw62.useState)(function() {
        return options.initialState(options);
    }), value1 = _useState[0], setValue = _useState[1];
    var reset = (0, $acw62.useCallback)(function() {
        return setValue(options.initialState(options));
    }, [
        setValue,
        options
    ]);
    var setLoading = (0, $acw62.useCallback)(function() {
        return setValue(options.setLoading(value1));
    }, [
        value1,
        setValue
    ]);
    var setResult = (0, $acw62.useCallback)(function(result) {
        return setValue(options.setResult(result, value1));
    }, [
        value1,
        setValue
    ]);
    var setError = (0, $acw62.useCallback)(function(error) {
        return setValue(options.setError(error, value1));
    }, [
        value1,
        setValue
    ]);
    var merge = (0, $acw62.useCallback)(function(state) {
        return setValue($36464e4be8053fb8$var$_extends({}, value1, {}, state));
    }, [
        value1,
        setValue
    ]);
    return {
        value: value1,
        set: setValue,
        merge: merge,
        reset: reset,
        setLoading: setLoading,
        setResult: setResult,
        setError: setError
    };
};
var $36464e4be8053fb8$var$useIsMounted = function useIsMounted() {
    var ref = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        ref.current = true;
        return function() {
            ref.current = false;
        };
    }, []);
    return function() {
        return ref.current;
    };
};
var $36464e4be8053fb8$var$useCurrentPromise = function useCurrentPromise() {
    var ref = (0, $acw62.useRef)(null);
    return {
        set: function set(promise) {
            return ref.current = promise;
        },
        get: function get() {
            return ref.current;
        },
        is: function is(promise) {
            return ref.current === promise;
        }
    };
}; // Relaxed interface which accept both async and sync functions
// Accepting sync function is convenient for useAsyncCallback
var $36464e4be8053fb8$var$useAsyncInternal = function useAsyncInternal(asyncFunction, params, options) {
    // Fallback missing params, only for JS users forgetting the deps array, to prevent infinite loops
    // https://github.com/slorber/react-async-hook/issues/27
    // @ts-ignore
    !params && (params = []);
    var normalizedOptions = $36464e4be8053fb8$var$normalizeOptions(options);
    var _useState2 = (0, $acw62.useState)(null), currentParams = _useState2[0], setCurrentParams = _useState2[1];
    var AsyncState = $36464e4be8053fb8$var$useAsyncState(normalizedOptions);
    var isMounted = $36464e4be8053fb8$var$useIsMounted();
    var CurrentPromise = $36464e4be8053fb8$var$useCurrentPromise(); // We only want to handle the promise result/error
    // if it is the last operation and the comp is still mounted
    var shouldHandlePromise = function shouldHandlePromise(p) {
        return isMounted() && CurrentPromise.is(p);
    };
    var executeAsyncOperation = function executeAsyncOperation() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // async ensures errors thrown synchronously are caught (ie, bug when formatting api payloads)
        // async ensures promise-like and synchronous functions are handled correctly too
        // see https://github.com/slorber/react-async-hook/issues/24
        var promise = function() {
            try {
                return Promise.resolve(asyncFunction.apply(void 0, args));
            } catch (e) {
                return Promise.reject(e);
            }
        }();
        setCurrentParams(args);
        CurrentPromise.set(promise);
        AsyncState.setLoading();
        promise.then(function(result) {
            if (shouldHandlePromise(promise)) AsyncState.setResult(result);
            normalizedOptions.onSuccess(result, {
                isCurrent: function isCurrent() {
                    return CurrentPromise.is(promise);
                }
            });
        }, function(error) {
            if (shouldHandlePromise(promise)) AsyncState.setError(error);
            normalizedOptions.onError(error, {
                isCurrent: function isCurrent() {
                    return CurrentPromise.is(promise);
                }
            });
        });
        return promise;
    };
    var getLatestExecuteAsyncOperation = $36464e4be8053fb8$var$useGetter(executeAsyncOperation);
    var executeAsyncOperationMemo = (0, $acw62.useCallback)(function() {
        return getLatestExecuteAsyncOperation().apply(void 0, arguments);
    }, [
        getLatestExecuteAsyncOperation
    ]); // Keep this outside useEffect, because inside isMounted()
    // will be true as the component is already mounted when it's run
    var isMounting = !isMounted();
    (0, $acw62.useEffect)(function() {
        var execute = function execute() {
            return getLatestExecuteAsyncOperation().apply(void 0, params);
        };
        isMounting && normalizedOptions.executeOnMount && execute();
        !isMounting && normalizedOptions.executeOnUpdate && execute();
    }, params);
    return $36464e4be8053fb8$var$_extends({}, AsyncState.value, {
        set: AsyncState.set,
        merge: AsyncState.merge,
        reset: AsyncState.reset,
        execute: executeAsyncOperationMemo,
        currentPromise: CurrentPromise.get(),
        currentParams: currentParams
    });
};
function $36464e4be8053fb8$export$cdf1dc76b55502e3(asyncFunction, params, options) {
    return $36464e4be8053fb8$var$useAsyncInternal(asyncFunction, params, options);
}
var $36464e4be8053fb8$export$a4c3459d1b3dd407 = function useAsyncAbortable(asyncFunction, params, options) {
    var abortControllerRef = (0, $acw62.useRef)(); // Wrap the original async function and enhance it with abortion login
    var asyncFunctionWrapper = function asyncFunctionWrapper() {
        for(var _len2 = arguments.length, p = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)p[_key2] = arguments[_key2];
        try {
            // Cancel previous async call
            if (abortControllerRef.current) abortControllerRef.current.abort();
             // Create/store new abort controller for next async call
            var abortController = new AbortController();
            abortControllerRef.current = abortController;
            return Promise.resolve($36464e4be8053fb8$var$_finallyRethrows(function() {
                // @ts-ignore // TODO how to type this?
                return Promise.resolve(asyncFunction.apply(void 0, [
                    abortController.signal
                ].concat(p)));
            }, function(_wasThrown, _result) {
                // Unset abortController ref if response is already there,
                // as it's not needed anymore to try to abort it (would it be no-op?)
                if (abortControllerRef.current === abortController) abortControllerRef.current = undefined;
                if (_wasThrown) throw _result;
                return _result;
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
    return $36464e4be8053fb8$export$cdf1dc76b55502e3(asyncFunctionWrapper, params, options);
};
var $36464e4be8053fb8$export$fbeb804c371ac8d = function useAsyncCallback(asyncFunction, options) {
    return $36464e4be8053fb8$var$useAsyncInternal(asyncFunction, // because async function is only executed manually
    [], $36464e4be8053fb8$var$_extends({}, options, {
        executeOnMount: false,
        executeOnUpdate: false
    }));
};


function $be9872526568fda4$export$2e2bcd8739ae039() {
    const [inquiries, setInquiries] = (0, $acw62.useState)({
        inquiries: [],
        ttyyppi: 0
    });
    const endpoint = "https://sato-backend-test.azurewebsites.net/api/GetInquiries";
    const { loading: loading } = (0, $36464e4be8053fb8$export$cdf1dc76b55502e3)(async ()=>{
        const res = await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(endpoint);
        setInquiries(res.data);
    }, []);
    return {
        inquiries: inquiries,
        loading: loading
    };
}



const $f52b806a43de9e88$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        box: {
            height: "100%"
        }
    }));
var $f52b806a43de9e88$export$f66f92b8741acd5b;
(function(StatusCode) {
    StatusCode[StatusCode["Aloittamaton"] = 0] = "Aloittamaton";
    StatusCode[StatusCode["Kesken"] = 1] = "Kesken";
    StatusCode[StatusCode["L\xe4hetetty"] = 2] = "L\xe4hetetty";
})($f52b806a43de9e88$export$f66f92b8741acd5b || ($f52b806a43de9e88$export$f66f92b8741acd5b = {}));
function $f52b806a43de9e88$export$dde867dc2e19cdfb({ status: status }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    let formStatus;
    let subtitleColor;
    switch(status){
        case $f52b806a43de9e88$export$f66f92b8741acd5b.Aloittamaton:
            formStatus = t("status.aloittamaton");
            subtitleColor = "textSecondary";
            break;
        case $f52b806a43de9e88$export$f66f92b8741acd5b.Kesken:
            formStatus = t("status.kesken");
            subtitleColor = "#c7bd06";
            break;
        case $f52b806a43de9e88$export$f66f92b8741acd5b.Lähetetty:
            formStatus = t("status.l\xe4hetetty");
            subtitleColor = "#0f800b";
            break;
        default:
            formStatus = t("status.aloittamaton");
            subtitleColor = "#c70c22";
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        variant: "body1",
        color: subtitleColor,
        component: "p",
        children: formStatus
    });
}
function $f52b806a43de9e88$export$2e2bcd8739ae039() {
    const classes = $f52b806a43de9e88$var$useStyles();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { inquiries: inquiries, loading: loading } = (0, $be9872526568fda4$export$2e2bcd8739ae039)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const user = (0, $557966054e36245a$export$2e2bcd8739ae039)();
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e3454bd6982de9c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                className: classes.box,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a2a6b1040c5d176$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7e3454bd6982de9c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: [
                            t("common.hello"),
                            ", ",
                            user?.gn,
                            "!"
                        ]
                    }),
                    inquiries && inquiries.ttyyppi === 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("peruna.description1.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("peruna.description1.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: "bold"
                                },
                                variant: "body1",
                                children: t("sato.luovutus")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("sato.description1.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("sato.description1.1.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("sato.description1.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("sato.description1.2.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: "bold"
                                },
                                variant: "body1",
                                children: t("sato.luovutus")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                className: classes.box,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f52b806a43de9e88$var$Actions, {
                    children: [
                        loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a2a6b1040c5d176$export$2e2bcd8739ae039), {}),
                        !loading && inquiries.inquiries.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 3,
                                children: [
                                    row.key === "sato" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94b3a8ce74314e9b$export$2e2bcd8739ae039), {
                                        title: `${ttyyppi === 2 ? t("common.satotilastokysely.luomu") : t("common.satotilastokysely")} ${new Date().getFullYear()}`,
                                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)($f52b806a43de9e88$export$dde867dc2e19cdfb, {
                                            status: row.status
                                        }),
                                        href: `/sato/viljan-satotiedot?id=${row.period_id}`,
                                        image: (0, (/*@__PURE__*/$parcel$interopDefault($8deca4a369a5f7fa$exports)))
                                    }),
                                    row.key === "perunan-sato-ja-varastot" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94b3a8ce74314e9b$export$2e2bcd8739ae039), {
                                        title: t("common.peruna"),
                                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)($f52b806a43de9e88$export$dde867dc2e19cdfb, {
                                            status: row.status
                                        }),
                                        href: `/peruna/sato-ja-varastot?id=${row.period_id}`,
                                        image: (0, (/*@__PURE__*/$parcel$interopDefault($dbf501d16b9c17ad$exports)))
                                    })
                                ]
                            }, row.key))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}
function $f52b806a43de9e88$var$Actions({ children: children, p: p, spacing: spacing }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        p: p || 8,
        sx: {
            position: "relative",
            right: 0,
            left: 0,
            marginTop: "-95px"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            spacing: spacing || 4,
            children: children
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



const $887ea0d447fd8b9f$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        teksti: {
            width: "100%",
            maxHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        virhe: {
            fontWeight: "700",
            marginBottom: "1rem"
        },
        ohje: {}
    }));
const $887ea0d447fd8b9f$export$f6d6133f5618ae37 = ()=>{
    const classes = $887ea0d447fd8b9f$var$useStyles();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.teksti,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f66afa0319941ff$export$2e2bcd8739ae039), {
            virhe: t("virhe.errorboundary.kysymyssarja.virhe"),
            ohje: t("virhe.errorboundary.kysymyssarja.ohje")
        })
    });
};
const $887ea0d447fd8b9f$var$KysymyssivuErrorBoundary = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddbfc09852d0c2dc$export$2e2bcd8739ae039), {
        Virhenakyma: $887ea0d447fd8b9f$export$f6d6133f5618ae37,
        children: children
    });
};
var $887ea0d447fd8b9f$export$2e2bcd8739ae039 = $887ea0d447fd8b9f$var$KysymyssivuErrorBoundary;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


const $e64fcd986b51089d$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        teksti: {
            width: "100%",
            maxHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    }));
function $e64fcd986b51089d$export$2e2bcd8739ae039() {
    const classes = $e64fcd986b51089d$var$useStyles();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.teksti,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f66afa0319941ff$export$2e2bcd8739ae039), {
            virhe: t("virhe.404.kysymyssarjaaEiLoytynyt.virhe"),
            ohje: t("virhe.404.kysymyssarjaaEiLoytynyt.ohje")
        })
    });
}








function $ec8af8064cfe02fe$export$9718fc758ee2ba3a(values) {
    return {
        type: (0, $4cad8f036e74fc6a$export$7f2d035eeabb2a2b),
        payload: values
    };
}
function $ec8af8064cfe02fe$export$6927fcb03f934e4(values) {
    return {
        type: (0, $4cad8f036e74fc6a$export$18138ec54e25ae31),
        payload: values
    };
}


const $e139c8a6e6e59fea$export$8f578363830fb4cc = "SET_META";


function $d4bf9507974107f7$export$88a8803dc14be868(payload) {
    return {
        type: (0, $e139c8a6e6e59fea$export$8f578363830fb4cc),
        payload: payload
    };
}



function $0e220426a973ad75$export$2e2bcd8739ae039(periodId) {
    const query = (0, $c49f7d6593097bdf$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const endpoint = `${"https://sato-backend-test.azurewebsites.net/api"}/GetData?id=${query.get("id")}`;
    const metaendpoint = `${"https://sato-backend-test.azurewebsites.net/api"}/GetMetadata`;
    const fetch = (0, $36464e4be8053fb8$export$cdf1dc76b55502e3)(async ()=>{
        try {
            const [form, meta] = await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).all([
                (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(endpoint),
                (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(metaendpoint)
            ]);
            dispatch((0, $ec8af8064cfe02fe$export$9718fc758ee2ba3a)({
                ...form.data,
                periodId: periodId
            }));
            dispatch((0, $d4bf9507974107f7$export$88a8803dc14be868)(meta.data));
        } catch (e) {
            console.warn(e);
        }
    }, []);
    return {
        loading: fetch.loading,
        error: fetch.error
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === "object";
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(obj)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $0d70f179cf56e662$var$isUndefined(result) || result === obj ? $0d70f179cf56e662$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, props.children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, _proxyFormState, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (_proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) _proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, isRoot)=>{
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>exact && signalName ? name === signalName : !name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const tearDown = (subscription)=>{
            if (subscription) subscription.unsubscribe();
        };
        const subscription = !props.disabled && _props.current.subject.subscribe({
            next: _props.current.callback
        });
        return ()=>tearDown(subscription);
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    _name.current = name;
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current) && updateFormState({
            ...control._formState,
            ...value1
        }), [
        control,
        exact
    ]);
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        callback: callback,
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        return ()=>{
            _mounted.current = false;
        };
    }, []);
    return $0d70f179cf56e662$var$getProxyFormState(formState, control._proxyFormState, _localProxyFormState.current, false);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === "string";
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal)=>{
    const isArray = Array.isArray(names);
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names);
    }
    if (isArray) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === "function";
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((formState)=>{
        if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) {
            const fieldValues = $0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues);
            updateValue($0d70f179cf56e662$var$isUndefined(_name.current) || $0d70f179cf56e662$var$isObject(fieldValues) && !$0d70f179cf56e662$var$objectHasFunction(fieldValues) ? {
                ...fieldValues
            } : Array.isArray(fieldValues) ? [
                ...fieldValues
            ] : $0d70f179cf56e662$var$isUndefined(fieldValues) ? defaultValue : fieldValues);
        }
    }, [
        control,
        exact,
        defaultValue
    ]);
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.watch,
        callback: callback
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($0d70f179cf56e662$var$isUndefined(defaultValue) ? control._getWatch(name) : defaultValue);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._removeUnmounted();
    });
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        return ()=>{
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField ? _shouldUnregisterField && !control._stateFlags.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>{
                _registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                });
            }, [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
                _registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                });
            }, [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (elm && field && elm.focus) field._f.ref = {
                    focus: ()=>elm.focus(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                name,
                control._fields
            ])
        },
        formState: formState,
        fieldState: control.getFieldState(name, formState)
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $0d70f179cf56e662$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
const $0d70f179cf56e662$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus && $0d70f179cf56e662$var$isUndefined(_f.ref.focus())) break;
                else if (_f.refs) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) $0d70f179cf56e662$var$focusFieldBy(currentField, callback);
        }
    }
};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
function $0d70f179cf56e662$var$append(data, value1) {
    return [
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
}
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (isArray || $0d70f179cf56e662$var$isObject(data)) {
        copy = isArray ? [] : {};
        for(const key in data){
            if ($0d70f179cf56e662$var$isFunction(data[key])) {
                copy = data;
                break;
            }
            copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $0d70f179cf56e662$var$prepend(data, value1) {
    return [
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
}
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ values: values, name: fieldArrayName })=>{
        if (fieldArrayName === _name.current || !fieldArrayName) {
            const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current, []);
            setFields(fieldValues);
            ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
        }
    }, []);
    $0d70f179cf56e662$var$useSubscribe({
        callback: callback,
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$append(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$append, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prepend(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prepend, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._stateFlags.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current) control._executeSchema([
            name
        ]).then((result)=>{
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
            if (error && error.type && !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name)) {
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error);
                control._subjects.state.next({
                    errors: control._formState.errors
                });
            }
        });
        control._subjects.watch.next({
            name: name,
            values: control._formValues
        });
        control._names.focus && $0d70f179cf56e662$var$focusFieldBy(control._fields, (key)=>key.startsWith(control._names.focus));
        control._names.focus = "";
        control._proxyFormState.isValid && control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $0d70f179cf56e662$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === "file";
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>value1 instanceof HTMLElement;
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === "radio";
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const updatePath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = updatePath.length == 1 ? object : $0d70f179cf56e662$var$baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) delete childObject[key];
    for(let k = 0; k < updatePath.slice(0, -1).length; k++){
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) previousObjRef = object;
        while(++index < currentPaths.length){
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index && ($0d70f179cf56e662$var$isObject(objectRef) && $0d70f179cf56e662$var$isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter((data)=>!$0d70f179cf56e662$var$isUndefined(data)).length)) previousObjRef ? delete previousObjRef[item] : delete object[item];
            previousObjRef = objectRef;
        }
    }
    return object;
}
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === "" ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : +value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? undefined : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(value1);
function $0d70f179cf56e662$var$getValidateError(result, ref, type = "validate") {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $0d70f179cf56e662$var$validateField = async (field, inputValue, validateAllFieldCriteria, shouldUseNativeValidation)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? "" : message || " ");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && !ref.value || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || +inputValue;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            if ($0d70f179cf56e662$var$isString(maxOutput.value)) exceedMax = valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value)) exceedMin = valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$cloneObject(_options.defaultValues) || {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    let validateFields = {};
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        watch: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback, wait)=>(...args)=>{
            clearTimeout(timer);
            timer = window.setTimeout(()=>callback(...args), wait);
        };
    const _updateValid = async (shouldSkipRender)=>{
        let isValid = false;
        if (_proxyFormState.isValid) {
            isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuildInValidation(_fields, true);
            if (!shouldSkipRender && isValid !== _formState.isValid) {
                _formState.isValid = isValid;
                _subjects.state.next({
                    isValid: isValid
                });
            }
        }
        return isValid;
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (_proxyFormState.errors && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>($0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error), _subjects.state.next({
            errors: _formState.errors
        }));
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let isFieldDirty = false;
        const output = {
            name: name
        };
        const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
        if (_proxyFormState.isDirty) {
            const isPreviousFormDirty = _formState.isDirty;
            _formState.isDirty = output.isDirty = _getDirty();
            isFieldDirty = isPreviousFormDirty !== output.isDirty;
        }
        if (_proxyFormState.dirtyFields && (!isBlurEvent || shouldDirty)) {
            const isPreviousFieldDirty = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            const isCurrentFieldPristine = $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isCurrentFieldPristine ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            isFieldDirty = isFieldDirty || isPreviousFieldDirty !== $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
        }
        if (isBlurEvent && !isPreviousFieldTouched) {
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
            output.touchedFields = _formState.touchedFields;
            isFieldDirty = isFieldDirty || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
        }
        isFieldDirty && shouldRender && _subjects.state.next(output);
        return isFieldDirty ? output : {};
    };
    const shouldRenderByError = async (shouldSkipRender, name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = delayErrorCallback || debounce(updateErrors, props.delayError);
            delayErrorCallback(name, error);
        } else {
            clearTimeout(timer);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if (((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) && !shouldSkipRender) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        validateFields[name]--;
        if (_proxyFormState.isValidating && !Object.values(validateFields).some((v)=>v)) {
            _subjects.state.next({
                isValidating: false
            });
            validateFields = {};
        }
    };
    const _executeSchema = async (name)=>_options.resolver ? await _options.resolver({
            ..._formValues
        }, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation)) : {};
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema();
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuildInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: fieldReference, ...fieldValue } = field;
                if (fieldReference) {
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldReference.name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);
                    if (fieldError[fieldReference.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    if (!shouldOnlyCheckValid) fieldError[fieldReference.name] ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, fieldReference.name, fieldError[fieldReference.name]) : $0d70f179cf56e662$var$unset(_formState.errors, fieldReference.name);
                }
                fieldValue && await executeBuildInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>{
        const fieldValues = {
            ..._stateFlags.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        };
        return $0d70f179cf56e662$var$generateWatchOutput(names, _names, fieldValues, isGlobal);
    };
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? "" : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((selectRef)=>selectRef.selected = fieldValue.includes(selectRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>!checkboxRef.disabled && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.watch.next({
                        name: name
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$0d70f179cf56e662$var$isPrimitive(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: _formValues
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) {
                _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
                _subjects.state.next({
                    name: name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name: name
        });
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) field._f.onBlur && field._f.onBlur(event);
            else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.watch.next({
                name: name,
                type: event.type
            });
            if (shouldSkipValidation) return shouldRender && _subjects.state.next({
                name: name,
                ...watched ? {} : fieldState
            });
            !isBlurEvent && watched && _subjects.state.next({});
            validateFields[name] = validateFields[name] ? 1 : 1;
            _subjects.state.next({
                isValidating: true
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            } else {
                error = (await $0d70f179cf56e662$var$validateField(field, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name), shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isValid = await _updateValid(true);
            }
            field._f.deps && trigger(field._f.deps);
            shouldRenderByError(false, name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        _subjects.state.next({
            isValidating: true
        });
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuildInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuildInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$focusFieldBy(_fields, (key)=>$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._stateFlags.mount ? _formValues : {}
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name ? $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName)) : _formState.errors = {};
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.watch.subscribe({
            next: (info)=>name(_getWatch(undefined, defaultValue), info)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName)) {
                if (!options.keepValue) {
                    $0d70f179cf56e662$var$unset(_fields, fieldName);
                    $0d70f179cf56e662$var$unset(_formValues, fieldName);
                }
                !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
                !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.shouldUseNativeValidation ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...!!Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _stateFlags.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let hasNoPromiseError = true;
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            try {
                if (_options.resolver) {
                    const { errors: errors, values: values } = await _executeSchema();
                    _formState.errors = errors;
                    fieldValues = values;
                } else await executeBuildInValidation(_fields);
                if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors) && Object.keys(_formState.errors).every((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(fieldValues, name))) {
                    _subjects.state.next({
                        errors: {},
                        isSubmitting: true
                    });
                    await onValid(fieldValues, e);
                } else {
                    if (onInvalid) await onInvalid({
                        ..._formState.errors
                    }, e);
                    _options.shouldFocusError && $0d70f179cf56e662$var$focusFieldBy(_fields, (key)=>$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
                }
            } catch (err) {
                hasNoPromiseError = false;
                throw err;
            } finally{
                _formState.isSubmitted = true;
                _subjects.state.next({
                    isSubmitted: true,
                    isSubmitting: false,
                    isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && hasNoPromiseError,
                    submitCount: _formState.submitCount + 1,
                    errors: _formState.errors
                });
            }
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const values = formValues && !$0d70f179cf56e662$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (field && field._f) {
                    const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                    try {
                        $0d70f179cf56e662$var$isHTMLElement(fieldReference) && fieldReference.closest("form").reset();
                        break;
                    } catch (_a) {}
                }
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _fields = {};
            _subjects.array.next({
                values: values
            });
            _subjects.watch.next({
                values: values
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _stateFlags.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : keepStateOptions.keepDefaultValues ? !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues) : false,
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirty ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? Object.entries(formValues).reduce((previous, [key, value1])=>({
                    ...previous,
                    [key]: value1 !== $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, key)
                }), {}) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f;
        const fieldRef = field.refs ? field.refs[0] : field.ref;
        options.shouldSelect ? fieldRef.select() : fieldRef.focus();
    };
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _stateFlags () {
                return _stateFlags;
            },
            set _stateFlags (value){
                _stateFlags = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to mange the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touchedFields: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        errors: {}
    });
    if (_formControl.current) _formControl.current.control._options = props;
    else _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    const callback = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value1)=>{
        if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, true)) {
            control._formState = {
                ...control._formState,
                ...value1
            };
            updateFormState({
                ...control._formState
            });
        }
    }, [
        control
    ]);
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        callback: callback
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._stateFlags.mount) {
            control._proxyFormState.isValid && control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control._proxyFormState);
    return _formControl.current;
}


var $302743bfdc67c75e$var$e = function(i, e, t) {
    if (i && "reportValidity" in i) {
        var f = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(t, e);
        i.setCustomValidity(f && f.message || ""), i.reportValidity();
    }
}, $302743bfdc67c75e$export$6bd436d70894afff = function(r, i) {
    var t = function(t) {
        var f = i.fields[t];
        f && f.ref && "reportValidity" in f.ref ? $302743bfdc67c75e$var$e(f.ref, t, r) : f.refs && f.refs.forEach(function(i) {
            return $302743bfdc67c75e$var$e(i, t, r);
        });
    };
    for(var f in i.fields)t(f);
}, $302743bfdc67c75e$export$3cfb7e8a4d7a0630 = function(e, f) {
    f.shouldUseNativeValidation && $302743bfdc67c75e$export$6bd436d70894afff(e, f);
    var o = {};
    for(var a in e){
        var n = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(f.fields, a);
        (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(o, a, Object.assign(e[a], {
            ref: n && n.ref
        }));
    }
    return o;
};



var $0df32c3dd3ad0e0c$export$d55832dfcd4989a = function(o, n, a) {
    return void 0 === n && (n = {}), void 0 === a && (a = {}), function(s, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (n.context, Promise.resolve(o["sync" === a.mode ? "validateSync" : "validate"](s, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $302743bfdc67c75e$export$6bd436d70894afff)({}, c), {
                            values: a.rawValues ? s : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $302743bfdc67c75e$export$3cfb7e8a4d7a0630)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, a = o && o[t.type];
                            e[t.path] = (0, $0d70f179cf56e662$export$b196c2a4f765bd30)(t.path, n, e, t.type, a ? [].concat(a, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
};



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $beb6670688e6a4c6$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $beb6670688e6a4c6$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($beb6670688e6a4c6$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $beb6670688e6a4c6$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $beb6670688e6a4c6$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $3AM7p = parcelRequire("3AM7p");

var $acw62 = parcelRequire("acw62");
function $d637ac0d813ae381$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


var $a313fb4a2074834f$export$2e2bcd8739ae039 = (0, $d637ac0d813ae381$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $c51e307705f35677$var$FormControlContext = /*#__PURE__*/ $acw62.createContext();
var $c51e307705f35677$export$2e2bcd8739ae039 = $c51e307705f35677$var$FormControlContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9e00b477c7793448$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)("MuiFormControl", slot);
}
const $9e00b477c7793448$var$formControlClasses = (0, $beCSm.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $9e00b477c7793448$export$2e2bcd8739ae039 = $9e00b477c7793448$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $88a0f3656f701f08$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $88a0f3656f701f08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $3AM7p.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9e00b477c7793448$export$149c8b8bab2289d1), classes);
};
const $88a0f3656f701f08$var$FormControlRoot = (0, $1Ikg4.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $e8gS1.default)({}, styles.root, styles[`margin${(0, $3AM7p.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $88a0f3656f701f08$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $1sz44.default)(props, $88a0f3656f701f08$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $88a0f3656f701f08$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $beb6670688e6a4c6$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($88a0f3656f701f08$var$FormControlRoot, (0, $e8gS1.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $88a0f3656f701f08$export$2e2bcd8739ae039 = $88a0f3656f701f08$var$FormControl;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");

function $343072e2ec7ced8d$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $c51e307705f35677$export$2e2bcd8739ae039));
}




var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ae0c5c6bd551796$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)("MuiFormControlLabel", slot);
}
const $4ae0c5c6bd551796$var$formControlLabelClasses = (0, $beCSm.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error"
]);
var $4ae0c5c6bd551796$export$2e2bcd8739ae039 = $4ae0c5c6bd551796$var$formControlLabelClasses;


function $23f47324c549140d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $ayMG0 = parcelRequire("ayMG0");
const $e29860be68ec3320$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "slotProps",
    "value"
];
const $e29860be68ec3320$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $3AM7p.default)(labelPlacement)}`,
            error && "error"
        ],
        label: [
            "label",
            disabled && "disabled"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ae0c5c6bd551796$export$717666c39ec07e12), classes);
};
const $e29860be68ec3320$export$1b479270917a5676 = (0, $1Ikg4.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $3AM7p.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $e29860be68ec3320$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _slotProps$typography;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", slotProps: slotProps = {} } = props, other = (0, $1sz44.default)(props, $e29860be68ec3320$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    const controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        error: fcs.error
    });
    const classes = $e29860be68ec3320$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $1SA7b.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e29860be68ec3320$export$1b479270917a5676, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            label
        ]
    }));
});
var $e29860be68ec3320$export$2e2bcd8739ae039 = $e29860be68ec3320$var$FormControlLabel;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");



var $1Ikg4 = parcelRequire("1Ikg4");

var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bdd2baf6568f6f86$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)("MuiFormHelperText", slot);
}
const $bdd2baf6568f6f86$var$formHelperTextClasses = (0, $beCSm.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $bdd2baf6568f6f86$export$2e2bcd8739ae039 = $bdd2baf6568f6f86$var$formHelperTextClasses;



var $cpBQU = parcelRequire("cpBQU");

var $ayMG0 = parcelRequire("ayMG0");
var $937760e70ffc7914$var$_span;
const $937760e70ffc7914$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $937760e70ffc7914$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $3AM7p.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bdd2baf6568f6f86$export$a394fa61b1d583a9), classes);
};
const $937760e70ffc7914$var$FormHelperTextRoot = (0, $1Ikg4.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $bdd2baf6568f6f86$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $bdd2baf6568f6f86$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $937760e70ffc7914$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $1sz44.default)(props, $937760e70ffc7914$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $937760e70ffc7914$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($937760e70ffc7914$var$FormHelperTextRoot, (0, $e8gS1.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $937760e70ffc7914$var$_span || ($937760e70ffc7914$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "​"
        })) : children
    }));
});
var $937760e70ffc7914$export$2e2bcd8739ae039 = $937760e70ffc7914$var$FormHelperText;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");



var $3AM7p = parcelRequire("3AM7p");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f349e4b76c0b885d$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)("MuiFormLabel", slot);
}
const $f349e4b76c0b885d$var$formLabelClasses = (0, $beCSm.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $f349e4b76c0b885d$export$2e2bcd8739ae039 = $f349e4b76c0b885d$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $db3da65b5688c8f8$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $db3da65b5688c8f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $3AM7p.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f349e4b76c0b885d$export$f7d501e40371cd17), classes);
};
const $db3da65b5688c8f8$export$aa5bc7f8a4705b27 = (0, $1Ikg4.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $e8gS1.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $db3da65b5688c8f8$var$AsteriskComponent = (0, $1Ikg4.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $db3da65b5688c8f8$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $1sz44.default)(props, $db3da65b5688c8f8$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $db3da65b5688c8f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($db3da65b5688c8f8$export$aa5bc7f8a4705b27, (0, $e8gS1.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($db3da65b5688c8f8$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $db3da65b5688c8f8$export$2e2bcd8739ae039 = $db3da65b5688c8f8$var$FormLabel;


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $acw62 = parcelRequire("acw62");
function $3b481a8630784b69$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $3c946fbcfb716a43$export$2e2bcd8739ae039 = (0, $3b481a8630784b69$export$2e2bcd8739ae039);





var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $082f01778759dbca$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)("PrivateSwitchBase", slot);
}
const $082f01778759dbca$var$switchBaseClasses = (0, $beCSm.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $082f01778759dbca$export$2e2bcd8739ae039 = $082f01778759dbca$var$switchBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $dadefa050dca578a$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $dadefa050dca578a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $3AM7p.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $082f01778759dbca$export$baa0faa0c7ad8085), classes);
};
const $dadefa050dca578a$var$SwitchBaseRoot = (0, $1Ikg4.default)((0, $21d0be68de155ec6$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $dadefa050dca578a$var$SwitchBaseInput = (0, $1Ikg4.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $dadefa050dca578a$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1sz44.default)(props, $dadefa050dca578a$var$_excluded);
    const [checked, setCheckedState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $e8gS1.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $dadefa050dca578a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dadefa050dca578a$var$SwitchBaseRoot, (0, $e8gS1.default)({
        component: "span",
        className: (0, $1SA7b.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($dadefa050dca578a$var$SwitchBaseInput, (0, $e8gS1.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor && id,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $dadefa050dca578a$export$2e2bcd8739ae039 = $dadefa050dca578a$var$SwitchBase;



var $cpBQU = parcelRequire("cpBQU");

var $e8gS1 = parcelRequire("e8gS1");
parcelRequire("acw62");

parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $1cb10b5ba3096930$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $59248c5edcc630d3$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $1Ikg4 = parcelRequire("1Ikg4");

var $ayMG0 = parcelRequire("ayMG0");
const $30a65a873f527c35$var$RadioButtonIconRoot = (0, $1Ikg4.default)("span")({
    position: "relative",
    display: "flex"
});
const $30a65a873f527c35$var$RadioButtonIconBackground = (0, $1Ikg4.default)((0, $1cb10b5ba3096930$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $30a65a873f527c35$var$RadioButtonIconDot = (0, $1Ikg4.default)((0, $59248c5edcc630d3$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $30a65a873f527c35$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $e8gS1.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($30a65a873f527c35$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($30a65a873f527c35$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($30a65a873f527c35$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $30a65a873f527c35$export$2e2bcd8739ae039 = $30a65a873f527c35$var$RadioButtonIcon;



var $3AM7p = parcelRequire("3AM7p");

var $71dd6ce5929449ce$export$2e2bcd8739ae039 = (0, $c91b8f922607ad66$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $3049db72b7690206$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $3049db72b7690206$export$2e2bcd8739ae039 = $3049db72b7690206$var$RadioGroupContext;


function $ee6a752b51430a78$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $3049db72b7690206$export$2e2bcd8739ae039));
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $17730288e1c01674$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)("MuiRadio", slot);
}
const $17730288e1c01674$var$radioClasses = (0, $beCSm.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary"
]);
var $17730288e1c01674$export$2e2bcd8739ae039 = $17730288e1c01674$var$radioClasses;



var $1Ikg4 = parcelRequire("1Ikg4");

var $ayMG0 = parcelRequire("ayMG0");
const $a588c4a0dc9c5bcb$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $a588c4a0dc9c5bcb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $3AM7p.default)(color)}`
        ]
    };
    return (0, $e8gS1.default)({}, classes, (0, $8Indx.default)(slots, (0, $17730288e1c01674$export$192f7b2363c77155), classes));
};
const $a588c4a0dc9c5bcb$var$RadioRoot = (0, $1Ikg4.default)((0, $dadefa050dca578a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $17730288e1c01674$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $17730288e1c01674$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $a588c4a0dc9c5bcb$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $a588c4a0dc9c5bcb$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30a65a873f527c35$export$2e2bcd8739ae039), {
    checked: true
});
const $a588c4a0dc9c5bcb$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30a65a873f527c35$export$2e2bcd8739ae039), {});
const $a588c4a0dc9c5bcb$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $a588c4a0dc9c5bcb$var$defaultCheckedIcon, color: color = "primary", icon: icon = $a588c4a0dc9c5bcb$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $1sz44.default)(props, $a588c4a0dc9c5bcb$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $a588c4a0dc9c5bcb$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $ee6a752b51430a78$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $71dd6ce5929449ce$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $a588c4a0dc9c5bcb$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a588c4a0dc9c5bcb$var$RadioRoot, (0, $e8gS1.default)({
        type: "radio",
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $a588c4a0dc9c5bcb$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $a588c4a0dc9c5bcb$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other));
});
var $a588c4a0dc9c5bcb$export$2e2bcd8739ae039 = $a588c4a0dc9c5bcb$var$Radio;


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $54112a2ab124f669$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)("MuiFormGroup", slot);
}
const $54112a2ab124f669$var$formGroupClasses = (0, $beCSm.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $54112a2ab124f669$export$2e2bcd8739ae039 = $54112a2ab124f669$var$formGroupClasses;





var $ayMG0 = parcelRequire("ayMG0");
const $a3c16f3270115bea$var$_excluded = [
    "className",
    "row"
];
const $a3c16f3270115bea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $54112a2ab124f669$export$d72d4cbdc30b331f), classes);
};
const $a3c16f3270115bea$var$FormGroupRoot = (0, $1Ikg4.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $a3c16f3270115bea$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $1sz44.default)(props, $a3c16f3270115bea$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $a3c16f3270115bea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a3c16f3270115bea$var$FormGroupRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $a3c16f3270115bea$export$2e2bcd8739ae039 = $a3c16f3270115bea$var$FormGroup;






var $51b2e046136200b6$export$2e2bcd8739ae039 = (0, $f649782d844a38be$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
const $851ed26fd4271995$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $851ed26fd4271995$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $1sz44.default)(props, $851ed26fd4271995$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const [value, setValueState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3049db72b7690206$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), (0, $e8gS1.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $851ed26fd4271995$export$2e2bcd8739ae039 = $851ed26fd4271995$var$RadioGroup;


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");


var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $17r9Q = parcelRequire("17r9Q");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $bUPtf = parcelRequire("bUPtf");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
const $0311c85f7d96727c$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $0311c85f7d96727c$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
const $0311c85f7d96727c$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $0311c85f7d96727c$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
const $0311c85f7d96727c$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, ref) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $5877039b6aa04c0b$export$2e2bcd8739ae039)(props, $0311c85f7d96727c$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(ref, inputRef);
    const shadowRef = $acw62.useRef(null);
    const renders = $acw62.useRef(0);
    const [state, setState] = $acw62.useState({});
    const getUpdatedState = $acw62.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {};
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle["box-sizing"];
        const padding = $0311c85f7d96727c$var$getStyleValue(computedStyle, "padding-bottom") + $0311c85f7d96727c$var$getStyleValue(computedStyle, "padding-top");
        const border = $0311c85f7d96727c$var$getStyleValue(computedStyle, "border-bottom-width") + $0311c85f7d96727c$var$getStyleValue(computedStyle, "border-top-width");
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $acw62.useCallback(()=>{
        const newState = getUpdatedState();
        if ($0311c85f7d96727c$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSycn = ()=>{
        const newState = getUpdatedState();
        if ($0311c85f7d96727c$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        (0, $11492dca620dcaa5$exports.flushSync)(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $acw62.useEffect(()=>{
        const handleResize = (0, $41c4238d7b0ec499$export$2e2bcd8739ae039)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSycn();
        });
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(inputRef.current);
        containerWindow.addEventListener("resize", handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(inputRef.current);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $acw62.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : null
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, $0311c85f7d96727c$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $0311c85f7d96727c$export$2e2bcd8739ae039 = $0311c85f7d96727c$var$TextareaAutosize;


var $8Indx = parcelRequire("8Indx");




var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $3AM7p = parcelRequire("3AM7p");



var $e8gS1 = parcelRequire("e8gS1");
parcelRequire("acw62");


var $bBbjn = parcelRequire("bBbjn");

var $e7sAA = parcelRequire("e7sAA");

var $ayMG0 = parcelRequire("ayMG0");
function $7daa246831c829f7$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), (0, $e8gS1.default)({}, props, {
        defaultTheme: (0, $e7sAA.default)
    }));
}
var $7daa246831c829f7$export$2e2bcd8739ae039 = $7daa246831c829f7$var$GlobalStyles;




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $587a42eced554844$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)("MuiInputBase", slot);
}
const $587a42eced554844$var$inputBaseClasses = (0, $beCSm.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $587a42eced554844$export$2e2bcd8739ae039 = $587a42eced554844$var$inputBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $810f5d6293d4467f$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $810f5d6293d4467f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $810f5d6293d4467f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $810f5d6293d4467f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $3AM7p.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $587a42eced554844$export$ef57d5c8ca2278f6), classes);
};
const $810f5d6293d4467f$export$298a043133d72a38 = (0, $1Ikg4.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $810f5d6293d4467f$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $587a42eced554844$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $e8gS1.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $810f5d6293d4467f$export$a1ad29c901026019 = (0, $1Ikg4.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $810f5d6293d4467f$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $e8gS1.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $e8gS1.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $587a42eced554844$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $587a42eced554844$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $810f5d6293d4467f$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7daa246831c829f7$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $810f5d6293d4467f$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $1sz44.default)(props, $810f5d6293d4467f$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $bUPtf.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $e8gS1.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $e8gS1.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $0311c85f7d96727c$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $810f5d6293d4467f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $810f5d6293d4467f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $810f5d6293d4467f$export$a1ad29c901026019;
    inputProps = (0, $e8gS1.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $810f5d6293d4467f$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $e8gS1.default)({}, rootProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $e8gS1.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $1SA7b.default)(classes.root, rootProps.className, className),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $e8gS1.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $e8gS1.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $1SA7b.default)(classes.input, inputProps.className),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $e8gS1.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $810f5d6293d4467f$export$2e2bcd8739ae039 = $810f5d6293d4467f$var$InputBase;



var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $e8gS1 = parcelRequire("e8gS1");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $4e32f80fb9096d1f$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)("MuiInput", slot);
}
const $4e32f80fb9096d1f$var$inputClasses = (0, $e8gS1.default)({}, (0, $587a42eced554844$export$2e2bcd8739ae039), (0, $beCSm.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $4e32f80fb9096d1f$export$2e2bcd8739ae039 = $4e32f80fb9096d1f$var$inputClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $3745a2c6ea1264ac$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $3745a2c6ea1264ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $4e32f80fb9096d1f$export$cdb270390122322b), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $3745a2c6ea1264ac$var$InputRoot = (0, $1Ikg4.default)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $810f5d6293d4467f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $e8gS1.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).error}:after`]: {
            borderBottomColor: (theme.vars || theme).palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).disabled}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $3745a2c6ea1264ac$var$InputInput = (0, $1Ikg4.default)((0, $810f5d6293d4467f$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})({});
const $3745a2c6ea1264ac$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $1sz44.default)(props, $3745a2c6ea1264ac$var$_excluded);
    const classes = $3745a2c6ea1264ac$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $17r9Q.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $3745a2c6ea1264ac$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $3745a2c6ea1264ac$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$3745a2c6ea1264ac$var$Input.muiName = "Input";
var $3745a2c6ea1264ac$export$2e2bcd8739ae039 = $3745a2c6ea1264ac$var$Input;



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");

var $17r9Q = parcelRequire("17r9Q");


var $8Indx = parcelRequire("8Indx");


var $1Ikg4 = parcelRequire("1Ikg4");

var $cpBQU = parcelRequire("cpBQU");

var $e8gS1 = parcelRequire("e8gS1");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $5ba40350513245a8$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)("MuiFilledInput", slot);
}
const $5ba40350513245a8$var$filledInputClasses = (0, $e8gS1.default)({}, (0, $587a42eced554844$export$2e2bcd8739ae039), (0, $beCSm.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $5ba40350513245a8$export$2e2bcd8739ae039 = $5ba40350513245a8$var$filledInputClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $215c05c02ba2f8f4$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $215c05c02ba2f8f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5ba40350513245a8$export$3331e419f1a48437), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $215c05c02ba2f8f4$var$FilledInputRoot = (0, $1Ikg4.default)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $810f5d6293d4467f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $e8gS1.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).error}:after`]: {
            borderBottomColor: (theme.vars || theme).palette.error.main,
            transform: "scaleX(1)" // error is always underlined in red
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $e8gS1.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $215c05c02ba2f8f4$var$FilledInputInput = (0, $1Ikg4.default)((0, $810f5d6293d4467f$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $215c05c02ba2f8f4$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $1sz44.default)(props, $215c05c02ba2f8f4$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $215c05c02ba2f8f4$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $17r9Q.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $215c05c02ba2f8f4$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $215c05c02ba2f8f4$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$215c05c02ba2f8f4$var$FilledInput.muiName = "Input";
var $215c05c02ba2f8f4$export$2e2bcd8739ae039 = $215c05c02ba2f8f4$var$FilledInput;



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");
parcelRequire("acw62");


var $1Ikg4 = parcelRequire("1Ikg4");

var $ayMG0 = parcelRequire("ayMG0");
var $908e29d7221628c4$var$_span;
const $908e29d7221628c4$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $908e29d7221628c4$var$NotchedOutlineRoot = (0, $1Ikg4.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $908e29d7221628c4$var$NotchedOutlineLegend = (0, $1Ikg4.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $e8gS1.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $e8gS1.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $908e29d7221628c4$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1sz44.default)(props, $908e29d7221628c4$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $e8gS1.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($908e29d7221628c4$var$NotchedOutlineRoot, (0, $e8gS1.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($908e29d7221628c4$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $908e29d7221628c4$var$_span || ($908e29d7221628c4$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}





var $1Ikg4 = parcelRequire("1Ikg4");

var $e8gS1 = parcelRequire("e8gS1");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $64077992b1d8b572$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)("MuiOutlinedInput", slot);
}
const $64077992b1d8b572$var$outlinedInputClasses = (0, $e8gS1.default)({}, (0, $587a42eced554844$export$2e2bcd8739ae039), (0, $beCSm.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $64077992b1d8b572$export$2e2bcd8739ae039 = $64077992b1d8b572$var$outlinedInputClasses;




var $cpBQU = parcelRequire("cpBQU");

var $ayMG0 = parcelRequire("ayMG0");
const $fe946640f9150f45$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $fe946640f9150f45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $64077992b1d8b572$export$89922944c7227687), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $fe946640f9150f45$var$OutlinedInputRoot = (0, $1Ikg4.default)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $810f5d6293d4467f$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $e8gS1.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).focused} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).error} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).disabled} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $e8gS1.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $fe946640f9150f45$var$NotchedOutlineRoot = (0, $1Ikg4.default)((0, $908e29d7221628c4$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $fe946640f9150f45$var$OutlinedInputInput = (0, $1Ikg4.default)((0, $810f5d6293d4467f$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $fe946640f9150f45$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $1sz44.default)(props, $fe946640f9150f45$var$_excluded);
    const classes = $fe946640f9150f45$var$useUtilityClasses(props);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $fe946640f9150f45$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $fe946640f9150f45$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), (0, $e8gS1.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($fe946640f9150f45$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\xa0",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $e8gS1.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$fe946640f9150f45$var$OutlinedInput.muiName = "Input";
var $fe946640f9150f45$export$2e2bcd8739ae039 = $fe946640f9150f45$var$OutlinedInput;



var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $1SA7b = parcelRequire("1SA7b");




var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $73574a1c301dedd6$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)("MuiInputLabel", slot);
}
const $73574a1c301dedd6$var$inputLabelClasses = (0, $beCSm.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $73574a1c301dedd6$export$2e2bcd8739ae039 = $73574a1c301dedd6$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $499ac2a9f7a67cb8$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $499ac2a9f7a67cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size === "small" && "sizeSmall",
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $73574a1c301dedd6$export$c1c4b4545ad2ea5f), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $499ac2a9f7a67cb8$var$InputLabelRoot = (0, $1Ikg4.default)((0, $db3da65b5688c8f8$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $e8gS1.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $e8gS1.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $e8gS1.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        maxWidth: "calc(133% - 24px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $499ac2a9f7a67cb8$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $cpBQU.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1sz44.default)(props, $499ac2a9f7a67cb8$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $e8gS1.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $499ac2a9f7a67cb8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($499ac2a9f7a67cb8$var$InputLabelRoot, (0, $e8gS1.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $499ac2a9f7a67cb8$export$2e2bcd8739ae039 = $499ac2a9f7a67cb8$var$InputLabel;





var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $17r9Q = parcelRequire("17r9Q");

var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");

var $bUPtf = parcelRequire("bUPtf");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");


var $3AM7p = parcelRequire("3AM7p");


var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d0b029d306802dc1$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)("MuiNativeSelect", slot);
}
const $d0b029d306802dc1$var$nativeSelectClasses = (0, $beCSm.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $d0b029d306802dc1$export$2e2bcd8739ae039 = $d0b029d306802dc1$var$nativeSelectClasses;



var $1Ikg4 = parcelRequire("1Ikg4");

var $ayMG0 = parcelRequire("ayMG0");
const $5218b8cdffce5874$var$_excluded = [
    "className",
    "disabled",
    "IconComponent",
    "inputRef",
    "variant"
];
const $5218b8cdffce5874$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $3AM7p.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d0b029d306802dc1$export$1ee13051fd9e2ab5), classes);
};
const $5218b8cdffce5874$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $e8gS1.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $e8gS1.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $5218b8cdffce5874$var$NativeSelectSelect = (0, $1Ikg4.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $1Ikg4.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            {
                [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($5218b8cdffce5874$export$c1eccd1617458c87);
const $5218b8cdffce5874$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $e8gS1.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $5218b8cdffce5874$var$NativeSelectIcon = (0, $1Ikg4.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $3AM7p.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($5218b8cdffce5874$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $5218b8cdffce5874$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $1sz44.default)(props, $5218b8cdffce5874$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        disabled: disabled,
        variant: variant
    });
    const classes = $5218b8cdffce5874$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5218b8cdffce5874$var$NativeSelectSelect, (0, $e8gS1.default)({
                ownerState: ownerState,
                className: (0, $1SA7b.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5218b8cdffce5874$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $5218b8cdffce5874$export$2e2bcd8739ae039 = $5218b8cdffce5874$var$NativeSelectInput;




var $1Ikg4 = parcelRequire("1Ikg4");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $384af05952ac69db$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)("MuiSelect", slot);
}
const $384af05952ac69db$var$selectClasses = (0, $beCSm.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput"
]);
var $384af05952ac69db$export$2e2bcd8739ae039 = $384af05952ac69db$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
var $0dd118e425182cac$var$_span;
const $0dd118e425182cac$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $0dd118e425182cac$var$SelectSelect = (0, $1Ikg4.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $5218b8cdffce5874$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $0dd118e425182cac$var$SelectIcon = (0, $1Ikg4.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $3AM7p.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $5218b8cdffce5874$export$e7a817afd12a40d0));
const $0dd118e425182cac$var$SelectNativeInput = (0, $1Ikg4.default)("input", {
    shouldForwardProp: (prop)=>(0, $1Ikg4.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $0dd118e425182cac$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $0dd118e425182cac$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $0dd118e425182cac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple"
        ],
        icon: [
            "icon",
            `icon${(0, $3AM7p.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $384af05952ac69db$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $0dd118e425182cac$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $1sz44.default)(props, $0dd118e425182cac$var$_excluded);
    const [value, setValueState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const index = childrenArray.map((child)=>child.props.value).indexOf(event.target.value);
        if (index === -1) return;
        const child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/example-index/combobox/combobox-select-only.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child, index, arr)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $bUPtf.default)(2));
            selected = value.some((v)=>$0dd118e425182cac$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0dd118e425182cac$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        if (child.props.value === undefined) return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-readonly": true,
            role: "option"
        });
        const isFirstSelectableElement = ()=>{
            if (value) return selected;
            const firstSelectableElement = arr.find((item)=>item.props.value !== undefined && item.props.disabled !== true);
            if (child === firstSelectableElement) return true;
            return selected;
        };
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: arr[0].props.value === undefined || arr[0].props.disabled === true ? isFirstSelectableElement() : selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $e8gS1.default)({}, props, {
        variant: variant,
        value: value,
        open: open
    });
    const classes = $0dd118e425182cac$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectSelect, (0, $e8gS1.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $1SA7b.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $0dd118e425182cac$var$isEmpty(display) ? $0dd118e425182cac$var$_span || ($0dd118e425182cac$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectNativeInput, (0, $e8gS1.default)({
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81db31f1007c14e1$export$2e2bcd8739ae039), (0, $e8gS1.default)({
                id: `menu-${name || ""}`,
                anchorEl: displayNode,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $e8gS1.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $e8gS1.default)({}, MenuProps.PaperProps, {
                    style: (0, $e8gS1.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $0dd118e425182cac$export$2e2bcd8739ae039 = $0dd118e425182cac$var$SelectInput;




parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $ade182381ccbdcec$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");







var $cpBQU = parcelRequire("cpBQU");


var $1Ikg4 = parcelRequire("1Ikg4");

var $ayMG0 = parcelRequire("ayMG0");
var $13a94221f14f71e8$var$_StyledInput, $13a94221f14f71e8$var$_StyledFilledInput;
const $13a94221f14f71e8$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $13a94221f14f71e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $13a94221f14f71e8$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $13a94221f14f71e8$var$StyledInput = (0, $1Ikg4.default)((0, $3745a2c6ea1264ac$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)("");
const $13a94221f14f71e8$var$StyledOutlinedInput = (0, $1Ikg4.default)((0, $fe946640f9150f45$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)("");
const $13a94221f14f71e8$var$StyledFilledInput = (0, $1Ikg4.default)((0, $215c05c02ba2f8f4$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)("");
const $13a94221f14f71e8$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $cpBQU.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $ade182381ccbdcec$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $1sz44.default)(props, $13a94221f14f71e8$var$_excluded);
    const inputComponent = native ? (0, $5218b8cdffce5874$export$2e2bcd8739ae039) : (0, $0dd118e425182cac$export$2e2bcd8739ae039);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    const variant = fcs.variant || variantProp;
    const InputComponent = input || ({
        standard: $13a94221f14f71e8$var$_StyledInput || ($13a94221f14f71e8$var$_StyledInput = /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledInput, {})),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledOutlinedInput, {
            label: label
        }),
        filled: $13a94221f14f71e8$var$_StyledFilledInput || ($13a94221f14f71e8$var$_StyledFilledInput = /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledFilledInput, {}))
    })[variant];
    const ownerState = (0, $e8gS1.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $13a94221f14f71e8$var$useUtilityClasses(ownerState);
    const inputComponentRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $e8gS1.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $e8gS1.default)({
                children: children,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $e8gS1.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $17r9Q.default)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $1SA7b.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$13a94221f14f71e8$var$Select.muiName = "Select";
var $13a94221f14f71e8$export$2e2bcd8739ae039 = $13a94221f14f71e8$var$Select;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e71b8b43f7b2f425$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)("MuiTextField", slot);
}
const $e71b8b43f7b2f425$var$textFieldClasses = (0, $beCSm.default)("MuiTextField", [
    "root"
]);
var $e71b8b43f7b2f425$export$2e2bcd8739ae039 = $e71b8b43f7b2f425$var$textFieldClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $f480fb6201951027$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $f480fb6201951027$var$variantComponent = {
    standard: (0, $3745a2c6ea1264ac$export$2e2bcd8739ae039),
    filled: (0, $215c05c02ba2f8f4$export$2e2bcd8739ae039),
    outlined: (0, $fe946640f9150f45$export$2e2bcd8739ae039)
};
const $f480fb6201951027$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e71b8b43f7b2f425$export$c1bdcbaf0596aeda), classes);
};
const $f480fb6201951027$var$TextFieldRoot = (0, $1Ikg4.default)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $f480fb6201951027$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $1sz44.default)(props, $f480fb6201951027$var$_excluded);
    const ownerState = (0, $e8gS1.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $f480fb6201951027$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $f649782d844a38be$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $f480fb6201951027$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $e8gS1.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f480fb6201951027$var$TextFieldRoot, (0, $e8gS1.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), (0, $e8gS1.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), (0, $e8gS1.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), (0, $e8gS1.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $f480fb6201951027$export$2e2bcd8739ae039 = $f480fb6201951027$var$TextField;


parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $9423f4a2da402de0$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m14 7-5 5 5 5V7z"
}), "ArrowLeft");


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $68613eb14e9ec7e3$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m10 17 5-5-5-5v10z"
}), "ArrowRight");



function $b9c362fbce901abe$export$2e2bcd8739ae039(styles) {
    return styles;
}


parcelRequire("acw62");

const $7e0f3d43455a411d$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>(0, $b9c362fbce901abe$export$2e2bcd8739ae039)({
        button: {}
    }));
function $7e0f3d43455a411d$export$353f5b6fc5456de1(props) {
    const { size: size, variant: variant, color: color, className: className = "", children: children, ...rest } = props;
    const classes = $7e0f3d43455a411d$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$export$2e2bcd8739ae039, {
        ...rest,
        size: size || "medium",
        variant: variant || "contained",
        color: color || "primary",
        className: `${classes.button} ${className}`,
        children: children
    });
}
function $7e0f3d43455a411d$export$b03061e17dddb512({ text: text, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7e0f3d43455a411d$export$353f5b6fc5456de1, {
        endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68613eb14e9ec7e3$export$2e2bcd8739ae039), {}),
        ...rest,
        children: text || t("common.seuraava")
    });
}
function $7e0f3d43455a411d$export$e70d566b96318985({ text: text, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7e0f3d43455a411d$export$353f5b6fc5456de1, {
        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9423f4a2da402de0$export$2e2bcd8739ae039), {}),
        ...rest,
        children: text || t("common.edellinen")
    });
}
function $7e0f3d43455a411d$export$676e60fda78d8a0b({ text: text, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7e0f3d43455a411d$export$353f5b6fc5456de1, {
        ...rest,
        children: text || t("common.l\xe4het\xe4")
    });
}


function $8909cb8dfdebad01$export$2e2bcd8739ae039({ onNext: onNext, onPrevious: onPrevious }) {
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            onPrevious !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$e70d566b96318985), {
                onClick: onPrevious
            }),
            onNext !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$b03061e17dddb512), {
                onClick: methods.handleSubmit(onNext)
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");
function $6e280d639cc57177$export$2e2bcd8739ae039({ children: children }) {
    const [fade, setFade] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>setFade(true), 200);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), {
        in: fade,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            children: children
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");
const $09fc9d5e43e7d6b8$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        box: {
            [theme.breakpoints.up("md")]: {
                overflow: "initial",
                paddingRight: theme.spacing(8)
            },
            paddingTop: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            height: "100%",
            overflow: "scroll",
            position: "relative",
            boxSizing: "border-box",
            backgroundColor: "#fff"
        }
    }));
function $09fc9d5e43e7d6b8$export$2e2bcd8739ae039({ children: children }) {
    const classes = $09fc9d5e43e7d6b8$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        className: classes.box,
        children: children
    });
}


const $31c6cd2586786371$var$FormPage = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fc9d5e43e7d6b8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e280d639cc57177$export$2e2bcd8739ae039), {
            children: children
        })
    });
var $31c6cd2586786371$export$2e2bcd8739ae039 = $31c6cd2586786371$var$FormPage;



function $bed835bb43ab604a$export$2e2bcd8739ae039() {
    const { search: search } = (0, $926608a7a86d7371$export$45d76561a5302f2b)();
    const navigate = (0, $926608a7a86d7371$export$9770f232ac06a008)();
    return (to)=>navigate(to + search);
}



const $ddea074113ade8ae$var$useVastauskoodiValues = ()=>{
    const { vastauskoodi: vastauskoodi, vastauskoodiKommentti: vastauskoodiKommentti } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>({
            vastauskoodi: form.vastauskoodi || "",
            vastauskoodiKommentti: form.vastauskoodiKommentti || ""
        }));
    return {
        vastauskoodiKommentti: {
            [(0, $16ddfb9208d7186e$export$ea8a71b4c90cb36).VastauskoodiKommentti]: vastauskoodiKommentti[(0, $16ddfb9208d7186e$export$ea8a71b4c90cb36).VastauskoodiKommentti]
        },
        vastauskoodi: vastauskoodi
    };
};
function $ddea074113ade8ae$export$2e2bcd8739ae039({ nextPath: nextPath }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { vastauskoodi: vastauskoodi, vastauskoodiKommentti: vastauskoodiKommentti } = $ddea074113ade8ae$var$useVastauskoodiValues();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        reValidateMode: "onBlur",
        defaultValues: {
            vastauskoodi: Object.keys(vastauskoodi)[0],
            vastauskoodiKommentti: vastauskoodiKommentti
        },
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $16ddfb9208d7186e$export$bcefcf174d0c821))
    });
    const mapVastauskoodi = (vk)=>{
        if (!vk) return;
        return {
            vastauskoodi: {
                [vk]: (0, $16ddfb9208d7186e$export$7a75760034b90e9)[vk]
            }
        };
    };
    const handleNextClick = (values)=>{
        const isInformationAvailable = values.vastauskoodi === (0, $16ddfb9208d7186e$export$4efffd68e8e9fa4c).INFORMATION_AVAILABLE;
        const step = isInformationAvailable ? 0 : 8;
        const vastauskooditOut = mapVastauskoodi(values.vastauskoodi);
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            ...vastauskooditOut,
            step: step
        }));
        navigate(isInformationAvailable ? nextPath : (0, $df5bef30413a053b$export$385fc1c9ea2be551)((0, $155cd4757147cec6$export$2e2bcd8739ae039).yhteenveto));
    };
    const lisatietoError = methods.formState.errors.Lisatiedot && methods.formState.errors.Lisatiedot[(0, $16ddfb9208d7186e$export$ea8a71b4c90cb36).VastauskoodiKommentti]?.message;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                    component: "fieldset",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db3da65b5688c8f8$export$2e2bcd8739ae039), {
                            component: "legend",
                            children: t("common.vastauskoodit")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            control: methods.control,
                            name: "vastauskoodi",
                            defaultValue: 4,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $851ed26fd4271995$export$2e2bcd8739ae039), {
                                    ...field,
                                    children: Object.values((0, $16ddfb9208d7186e$export$60e5bc4d71c60812)).map((koodi, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                                            value: koodi,
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a588c4a0dc9c5bcb$export$2e2bcd8739ae039), {}),
                                            label: t(`vastauskoodit.${i + 1}`)
                                        }, koodi))
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `vastauskoodiKommentti.${(0, $16ddfb9208d7186e$export$ea8a71b4c90cb36).VastauskoodiKommentti}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    variant: "standard",
                                    inputRef: ref,
                                    ...field,
                                    error: !!lisatietoError,
                                    multiline: true,
                                    fullWidth: true,
                                    label: t("fields.Lis\xe4tiedot")
                                }),
                                !!lisatietoError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), {
                                    error: true,
                                    children: t(lisatietoError)
                                })
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onNext: handleNextClick
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");
const $629bf9a0e02907e2$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        instructions: {
            backgroundColor: "#E5F7CE",
            ["@media print"]: {
                border: "solid !important",
                display: "none"
            }
        }
    }));
function $629bf9a0e02907e2$export$2e2bcd8739ae039({ children: children }) {
    const classes = $629bf9a0e02907e2$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        p: 3,
        className: classes.instructions,
        mt: 2,
        mb: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
            component: "div",
            children: children
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $842761f20b136f2c$var$FormPageTitle = ({ children: children, sx: sx })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: sx || {},
        mb: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
            variant: "h2",
            children: children
        })
    });
var $842761f20b136f2c$export$2e2bcd8739ae039 = $842761f20b136f2c$var$FormPageTitle;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $503d053ab0e7a95d$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        footer: {
            [theme.breakpoints.up("md")]: {
                display: "none"
            },
            ["@media print"]: {
                display: "none !important"
            },
            height: "48px",
            position: "fixed",
            backgroundColor: "#B35C00",
            right: 0,
            left: 0,
            width: "100%",
            bottom: 0,
            display: "flex",
            justifyContent: "space-between",
            "& .MuiButton-root": {
                flex: 1
            }
        }
    }));
function $503d053ab0e7a95d$export$2e2bcd8739ae039({ children: children }) {
    const classes = $503d053ab0e7a95d$var$useStyles();
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes.footer,
        children: children
    });
}





var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");













var $ayMG0 = parcelRequire("ayMG0");

var $1Ikg4 = parcelRequire("1Ikg4");
parcelRequire("acw62");


const $cd7cda0be37bf83a$var$Stretcher = (0, $1Ikg4.default)("span")`
  flex: 1;
`;
const $cd7cda0be37bf83a$var$Step = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039))`
  background-color: #b35c00;
  color: white;
  display: flex;
  align-items: center;
`;
function $cd7cda0be37bf83a$export$2e2bcd8739ae039({ onNext: onNext, onPrevious: onPrevious, step: step }) {
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            onPrevious === undefined ? /*#__PURE__*/ (0, $ayMG0.jsx)($cd7cda0be37bf83a$var$Stretcher, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$e70d566b96318985), {
                sx: {
                    border: 0
                },
                disableElevation: true,
                onClick: onPrevious
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($cd7cda0be37bf83a$var$Step, {
                children: step
            }),
            onNext !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$b03061e17dddb512), {
                sx: {
                    border: 0
                },
                disableElevation: true,
                onClick: methods.handleSubmit(onNext)
            })
        ]
    });
}





function $b0a6fe3369babf11$export$2e2bcd8739ae039(id) {
    const endpoint = "https://sato-backend-test.azurewebsites.net/api/MarkFinished";
    const finish = (0, $36464e4be8053fb8$export$cdf1dc76b55502e3)(async ()=>{
        try {
            await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post(endpoint, {
                id: id
            });
            return true;
        } catch (e) {
            return true;
        }
    }, [], {
        executeOnMount: false
    });
    return {
        finish: finish,
        loading: finish.loading || finish.loading
    };
}



var $acw62 = parcelRequire("acw62");
function $323874ab8248d257$export$2e2bcd8739ae039() {
    (0, $acw62.useLayoutEffect)(()=>{
        setTimeout(()=>{
            try {
                const inputs = document.getElementsByTagName("input");
                if (inputs.length) inputs[0].focus();
            } catch (e) {
                console.warn(e);
            }
        }, 500);
    }, []);
}




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



var $91cfdcf11b4ccb63$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Lisatiedot"] = "_6037162990";
})($91cfdcf11b4ccb63$export$833b3e5a19fb8939 || ($91cfdcf11b4ccb63$export$833b3e5a19fb8939 = {}));
// regex joka löytää ei sallitut merkit
const $91cfdcf11b4ccb63$var$invalidCharactersRegex = /[`#$^&*_[\]{};\\|<>~]/;
const $91cfdcf11b4ccb63$export$e404dc3ff33af774 = ()=>{
    return $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        Lisatiedot: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
            [$91cfdcf11b4ccb63$export$833b3e5a19fb8939.Lisatiedot]: $bcc252d93ab3046c$export$185802fd694ee1f5().test("invalidCharacters", "fields.errors.invalidCharacters", (item)=>item ? !item.match($91cfdcf11b4ccb63$var$invalidCharactersRegex) : true).trim()
        })
    });
};


function $f7418071e6d65408$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.Lisatiedot);
    if (!values) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        p: 2,
        mt: 2,
        mb: 2,
        sx: {
            boxShadow: "0 0 4px rgba(0,0,0, 0.3)"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "h3",
                children: t("Lis\xe4tiedot.title")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                p: 2,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    children: values[(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $1Ikg4 = parcelRequire("1Ikg4");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");




var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $df1adf37dbd0f6dd$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)("MuiInputAdornment", slot);
}
const $df1adf37dbd0f6dd$var$inputAdornmentClasses = (0, $beCSm.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $df1adf37dbd0f6dd$export$2e2bcd8739ae039 = $df1adf37dbd0f6dd$var$inputAdornmentClasses;



var $cpBQU = parcelRequire("cpBQU");

var $ayMG0 = parcelRequire("ayMG0");
var $0ffab78552448ba6$var$_span;
const $0ffab78552448ba6$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $0ffab78552448ba6$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $3AM7p.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $0ffab78552448ba6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $3AM7p.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $3AM7p.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $df1adf37dbd0f6dd$export$4b135a4b3a6c4550), classes);
};
const $0ffab78552448ba6$var$InputAdornmentRoot = (0, $1Ikg4.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $0ffab78552448ba6$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $0ffab78552448ba6$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1sz44.default)(props, $0ffab78552448ba6$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $e8gS1.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $0ffab78552448ba6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0ffab78552448ba6$var$InputAdornmentRoot, (0, $e8gS1.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $0ffab78552448ba6$var$_span || ($0ffab78552448ba6$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "​"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $0ffab78552448ba6$export$2e2bcd8739ae039 = $0ffab78552448ba6$var$InputAdornment;


parcelRequire("acw62");


const $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab = 5;
const $a8fcb92d8c5bc3d8$export$19979b30ce8b3bab = 1 / Math.pow(10, $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab); // 0.00001
/**
 * Equality comparison between two decimal numbers, with specific precision.
 *
 * Mimics calling `===` on two decimal numbers, with specific precision.
 *
 * Default precision is defined in `DEFAULT_DECIMAL_PRECISION_DIGITS`.
 *
 * ```
 * eq(0.09, 0.11, { precion: 0.1 })  // true
 * eq(0.009, 0.09, { precion: 0.1 }) // false
 * ```
 */ const $a8fcb92d8c5bc3d8$export$9663ddc1cf085b32 = (a, b, { digits: digits = $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab, precision: precision = 1 / Math.pow(10, digits) } = {})=>{
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    return Math.abs(a - b) < precision;
};
/**
 * Greater than comparison between two decimal numbers, with specific precision.
 *
 * Mimics calling `>` on two decimal numbers, with specific precision.
 *
 * Default precision is defined in `DEFAULT_DECIMAL_PRECISION_DIGITS`.
 *
 * ```
 * gt(0.09, 0.01, { precion: 0.1 })  // true
 * gt(0.009, 0.09, { precion: 0.1 }) // false
 * ```
 */ const $a8fcb92d8c5bc3d8$export$dafeacbfe3530cd9 = (a, b, { digits: digits = $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab, precision: precision = 1 / Math.pow(10, digits) } = {})=>{
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    return a - b - precision > 0;
};
/**
 * Greater than or equal comparison between two decimal numbers, with specific precision.
 *
 * Mimics calling >=` on two decimal numbers, with specific precision.
 *
 * Default precision is defined in `DEFAULT_DECIMAL_PRECISION_DIGITS`.
 *
 * ```
 * gte(0.09, 0.11, { precion: 0.1 })  // true
 * gte(0.009, 0.09, { precion: 0.1 }) // false
 * ```
 */ const $a8fcb92d8c5bc3d8$export$aac79e834d1b4aed = (a, b, { digits: digits = $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab, precision: precision = 1 / Math.pow(10, digits) } = {})=>{
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    if ($a8fcb92d8c5bc3d8$export$9663ddc1cf085b32(a, b, {
        digits: digits
    })) return true;
    return $a8fcb92d8c5bc3d8$export$dafeacbfe3530cd9(a, b, {
        digits: digits
    });
};
/**
 * Lesser than comparison between two decimal numbers, with specific precision.
 *
 * Mimics calling `<` on two decimal numbers, with specific precision.
 *
 * Default precision is defined in `DEFAULT_DECIMAL_PRECISION_DIGITS`.
 *
 * ```
 * lt(0.009, 0.09, { precion: 0.1 }) // true
 * lt(0.09, 0.11, { precion: 0.1 })  // false
 * ```
 */ const $a8fcb92d8c5bc3d8$export$b961576059b7aeb6 = (a, b, { digits: digits = $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab, precision: precision = 1 / Math.pow(10, digits) } = {})=>{
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    return a - b + precision < 0;
};
/**
 * Lesser than or equal comparison between two decimal numbers, with specific precision.
 *
 * Mimics calling `<=` on two decimal numbers, with specific precision.
 *
 * Default precision is defined in `DEFAULT_DECIMAL_PRECISION_DIGITS`.
 *
 * ```
 * lte(0.09, 0.11, { precion: 0.1 })  // true
 * lte(0.11, 0.09, { precion: 0.1 })  // true
 * lte(0.09, 0.009, { precion: 0.1 }) // false
 * ```
 */ const $a8fcb92d8c5bc3d8$export$489c007ed603c05d = (a, b, { digits: digits = $a8fcb92d8c5bc3d8$export$33ff8c572dedfdab, precision: precision = 1 / Math.pow(10, digits) } = {})=>{
    if (Number.isNaN(a) || Number.isNaN(b)) return false;
    if ($a8fcb92d8c5bc3d8$export$9663ddc1cf085b32(a, b, {
        digits: digits
    })) return true;
    return $a8fcb92d8c5bc3d8$export$b961576059b7aeb6(a, b, {
        digits: digits
    });
};
/**
 * Calculate difference between two values as absolute value, rounded to two decimals.
 *
 * Returns difference as a string. Return `undefined` if value is `NaN`.
 */ const $a8fcb92d8c5bc3d8$export$acaf96a27438246b = (a, b, precision = $a8fcb92d8c5bc3d8$export$19979b30ce8b3bab)=>{
    if (Number.isNaN(a) || Number.isNaN(b)) return undefined;
    return Math.abs(a - b) < precision ? "0" : Math.abs(a - b).toFixed(2);
};






var $f1q41 = parcelRequire("f1q41");

// -------------------------------- HELPER FUNCTIONS -----------------------------------------
const $ab5958319bb12700$var$transformValueToNullableNumber = (_, value)=>{
    if (typeof value === "string") {
        // Yup interprets value as string and it needs to be handled
        if (value === "") return null;
        else {
            // Replace dot with comma, trim out whitespaces
            value = value.replace(/,/, ".");
            value = value.replaceAll(/\s/gi, "");
            return +value;
        }
    } else return value; // Value is number or null
};
const $ab5958319bb12700$export$d65ba4b80d352978 = $425f4614c2bd74f2$export$185802fd694ee1f5().typeError((0, $673ff3dfc4a496de$export$625550452a3fa3ec)("fields.validation.numberRequired"));
const $ab5958319bb12700$export$1fdbc7003da7c7a5 = $425f4614c2bd74f2$export$185802fd694ee1f5().min(0).transform($ab5958319bb12700$var$transformValueToNullableNumber).nullable(true);
const $ab5958319bb12700$export$22a0d6ac9d3db3b9 = (value)=>{
    let input = value?.toString();
    if (!input) return 0;
    input = input?.toString().replace(/ /g, "");
    input = input?.replace(/,/, ".");
    return Number(input);
};
function $ab5958319bb12700$var$requiredWith(field, message) {
    return this.when(field, {
        is: (value)=>{
            return !!value;
        },
        then: (schema)=>schema.required(message)
    });
}
$920660c8aca77688$export$20be359f745f973c($425f4614c2bd74f2$export$185802fd694ee1f5, "requiredWith", $ab5958319bb12700$var$requiredWith);
/* 
  Non-zero non-nullable number with the following rules
  != null & MIN >= 0
  min can be set to zero in order to let other yup validation functions
  pass their error messages when a minimum is reached
 */ function $ab5958319bb12700$var$notNull(minimum, message) {
    message = (0, $673ff3dfc4a496de$export$625550452a3fa3ec)(message || "fields.validation.numberRequired");
    if (minimum === undefined) return this.required(message);
    else return this.required(message).min(minimum, message);
}
$920660c8aca77688$export$20be359f745f973c($425f4614c2bd74f2$export$185802fd694ee1f5, "notNull", $ab5958319bb12700$var$notNull);
function $ab5958319bb12700$export$9c02e8b561622598(maximumValues, fields) {
    return [
        "satotasoMax",
        "fields.errors.satotaso.hehtaarisatoylitt\xe4\xe4sallitunarvon",
        function(satotaso) {
            if (!satotaso) return true;
            const kasvilaji = this.parent[fields.kasvilaji];
            const max = maximumValues[kasvilaji];
            if (!max) return true;
            return satotaso <= max;
        }
    ];
}
const $ab5958319bb12700$export$6f98703d2f5d4276 = {
    boolean: $0237b22d97657ad7$export$185802fd694ee1f5().nullable(),
    defaultNumber: $ab5958319bb12700$export$d65ba4b80d352978.min(0, "field.errors.Min"),
    istutusalaNotZero: $ab5958319bb12700$export$1fdbc7003da7c7a5.required("fields.errors.istutusalaNotZero"),
    percentage: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(0).max(100, "fields.errors.percentageMax"),
    million: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(0, "fields.errors.Min").max(1000000, "fields.errors.MaxMillion"),
    millions: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(0, "fields.errors.Min").max(10000000, "fields.errors.MaxMillions"),
    hundreds: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(0, "fields.errors.Min").max(999.99, "fields.errors.MaxHundreds"),
    thousands: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(0, "fields.errors.Min").max(9999.99, "fields.errors.MaxThousands"),
    tuoreSäilöviljanKosteusprosentti: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(11, "fields.errors.Tuores\xe4il\xf6viljanKosteusprosenttiMin").max(80, "fields.errors.Tuores\xe4il\xf6viljanKosteusprosenttiMax"),
    viljanKuivaaineProsentti: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(12, "fields.errors.ViljanKuivaaineProsenttiMin").max(80, "fields.errors.ViljanKuivaaineProsenttiMax"),
    valkuaiskasvienKosteusprosentti: $ab5958319bb12700$export$d65ba4b80d352978.notNull().min(5, "fields.errors.ValkuaiskasvienKosteusprosenttiMin").max(50, "fields.errors.ValkuaiskasvienKosteusprosenttiMax"),
    valkuaiskasvienKuivaaineProsentti: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(9, "fields.errors.ValkuaiskasvienKuivaaineProsenttiMin").max(80, "fields.errors.ValkuaiskasvienKuivaaineProsenttiMax"),
    öljykasvienKosteusprosentti: $ab5958319bb12700$export$d65ba4b80d352978.notNull().min(4, "fields.errors.\xd6ljykasvienKosteusprosenttiMin").max(40, "fields.errors.\xd6ljykasvienKosteusprosenttiMax"),
    säilörehu: $ab5958319bb12700$export$1fdbc7003da7c7a5.max(99999999, "fields.errors.S\xe4il\xf6rehuMax"),
    nurmirehuKuivaaineProsentti: $ab5958319bb12700$export$d65ba4b80d352978.notNull().min(10, "fields.errors.NurmirehuKuivaaineProsenttiMin").max(60, "fields.errors.NurmirehuKuivaaineProsenttiMax"),
    säilörehuEsikuivattuKuivaaineProsentti: $ab5958319bb12700$export$d65ba4b80d352978.notNull().min(15, "fields.errors.S\xe4il\xf6rehuEsikuivattuKuivaaineprosenttiMin").max(70, "fields.errors.S\xe4il\xf6rehuEsikuivattuKuivaaineprosenttiMax"),
    perunaSadonkäyttöProsentti: $ab5958319bb12700$export$1fdbc7003da7c7a5.min(0).max(100, "fields.errors.PercentageMaxSadonk\xe4ytt\xf6"),
    viljakasvienKorjuuala: $ab5958319bb12700$export$1fdbc7003da7c7a5.test("harvestedAreaMax", "fields.errors.yliViljelyalan", function(item) {
        if (!item) return true;
        if (!this.parent._610920941) return true;
        return $a8fcb92d8c5bc3d8$export$aac79e834d1b4aed(this.parent._610920941, (0, $f1q41.sum)([
            this.parent._610920919,
            this.parent._610920919ts,
            this.parent._610920919kvs
        ]));
    }),
    valkuaiskasvienKorjuuala: $ab5958319bb12700$export$1fdbc7003da7c7a5.test("harvestedAreaMax", "fields.errors.yliViljelyalan", function(item) {
        if (!item) return true;
        if (!this.parent._610920941) return true;
        return $a8fcb92d8c5bc3d8$export$aac79e834d1b4aed(this.parent._610920941, (0, $f1q41.sum)([
            this.parent._610920919,
            this.parent._610920919sr,
            this.parent._610920919_öljy
        ]));
    })
};
const $ab5958319bb12700$export$b3dfacad8d35487 = (state)=>{
    return !!Object.keys(state.dirtyFields).length;
};


var $87f876476293d35b$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["Istutusala"] = "_610920917";
    Fields["Korjuuala"] = "_610920919";
    Fields["Satom\xe4\xe4r\xe4"] = "_566014545";
    Fields["Sadostamyyty1510"] = "_5660386979";
    Fields["Varastossa1510"] = "_5660386963";
    Fields["Satotaso"] = "_Satotaso";
    Fields["IstutusalaYhteens\xe4"] = "_610920917386899";
    Fields["KorjattuAlaYhteens\xe4"] = "_610920919386899";
    Fields["KorjaamatonAlaYhteens\xe4"] = "_610914549386899";
})($87f876476293d35b$export$833b3e5a19fb8939 || ($87f876476293d35b$export$833b3e5a19fb8939 = {}));
let $87f876476293d35b$var$prop, $87f876476293d35b$var$prop1, $87f876476293d35b$var$prop2, $87f876476293d35b$var$prop3, $87f876476293d35b$var$prop4, $87f876476293d35b$var$prop5, $87f876476293d35b$var$prop6;
class $87f876476293d35b$export$589212d15f250602 {
    static #_ = (()=>{
        $87f876476293d35b$var$prop = $87f876476293d35b$export$833b3e5a19fb8939.Kasvilaji;
        $87f876476293d35b$var$prop1 = $87f876476293d35b$export$833b3e5a19fb8939.Istutusala;
        $87f876476293d35b$var$prop2 = $87f876476293d35b$export$833b3e5a19fb8939.Korjuuala;
        $87f876476293d35b$var$prop3 = $87f876476293d35b$export$833b3e5a19fb8939.Satomäärä;
        $87f876476293d35b$var$prop4 = $87f876476293d35b$export$833b3e5a19fb8939.Sadostamyyty1510;
        $87f876476293d35b$var$prop5 = $87f876476293d35b$export$833b3e5a19fb8939.Varastossa1510;
        $87f876476293d35b$var$prop6 = $87f876476293d35b$export$833b3e5a19fb8939.Satotaso;
    })();
    constructor(Kasvilaji, IstutusAla){
        this[$87f876476293d35b$var$prop1] = null;
        this[$87f876476293d35b$var$prop2] = null;
        this[$87f876476293d35b$var$prop3] = null;
        this[$87f876476293d35b$var$prop4] = null;
        this[$87f876476293d35b$var$prop5] = null;
        this[$87f876476293d35b$var$prop6] = null;
        this[$87f876476293d35b$export$833b3e5a19fb8939.Kasvilaji] = Kasvilaji;
        if (IstutusAla) this[$87f876476293d35b$export$833b3e5a19fb8939.Istutusala] = IstutusAla;
    }
}
var $87f876476293d35b$export$2e2bcd8739ae039 = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    PerunanSatotiedotYhteensa: $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        [$87f876476293d35b$export$833b3e5a19fb8939.IstutusalaYhteensä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5),
        [$87f876476293d35b$export$833b3e5a19fb8939.KorjattuAlaYhteensä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test("korjattualaMax", "fields.errors.korjattualaYlitt\xe4\xe4Istutusalan", function(item) {
            if (!item) return true;
            if (item > this.parent[$87f876476293d35b$export$833b3e5a19fb8939.IstutusalaYhteensä]) return false;
            return true;
        })
    }),
    PerunanSatotiedot: $e218604b96487b25$export$185802fd694ee1f5().of($cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        [$87f876476293d35b$export$833b3e5a19fb8939.Kasvilaji]: $bcc252d93ab3046c$export$185802fd694ee1f5().required(),
        [$87f876476293d35b$export$833b3e5a19fb8939.Istutusala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).istutusalaNotZero.notNull(0),
        [$87f876476293d35b$export$833b3e5a19fb8939.Korjuuala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands.requiredWith($87f876476293d35b$export$833b3e5a19fb8939.Istutusala, "fields.validation.numberRequired"),
        [$87f876476293d35b$export$833b3e5a19fb8939.Satomäärä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).requiredWith($87f876476293d35b$export$833b3e5a19fb8939.Korjuuala, "fields.validation.numberRequired"),
        [$87f876476293d35b$export$833b3e5a19fb8939.Sadostamyyty1510]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when($87f876476293d35b$export$833b3e5a19fb8939.Kasvilaji, {
            is: (value)=>value === "_14555" || value === "_20921",
            then: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when($87f876476293d35b$export$833b3e5a19fb8939.Korjuuala, {
                is: (value)=>value !== null && value !== 0,
                then: (schema)=>schema.test("varastoarvotDifferFromHarvested", "errors.varastoarvotEiv\xe4tT\xe4sm\xe4\xe4", $87f876476293d35b$var$testVarastoarvotEqualsFarmedArea)
            })
        }),
        [$87f876476293d35b$export$833b3e5a19fb8939.Varastossa1510]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when($87f876476293d35b$export$833b3e5a19fb8939.Kasvilaji, {
            is: (value)=>value === "_14555" || value === "_20921",
            then: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when($87f876476293d35b$export$833b3e5a19fb8939.Korjuuala, {
                is: (value)=>value !== null && value !== 0,
                then: (schema)=>schema.test("varastoarvotDifferFromHarvested", "errors.varastoarvotEiv\xe4tT\xe4sm\xe4\xe4", $87f876476293d35b$var$testVarastoarvotEqualsFarmedArea)
            })
        }),
        [$87f876476293d35b$export$833b3e5a19fb8939.Satotaso]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _14555: 80000,
            _20921: 80000,
            _21575: 50000,
            _386987: 80000,
            _386983: 80000
        }, {
            kasvilaji: $87f876476293d35b$export$833b3e5a19fb8939.Kasvilaji
        }))
    }))
});
function $87f876476293d35b$var$testVarastoarvotEqualsFarmedArea(item) {
    if (this.parent[$87f876476293d35b$export$833b3e5a19fb8939.Sadostamyyty1510] + this.parent[$87f876476293d35b$export$833b3e5a19fb8939.Varastossa1510] === this.parent[$87f876476293d35b$export$833b3e5a19fb8939.Satomäärä] || this.parent[$87f876476293d35b$export$833b3e5a19fb8939.Sadostamyyty1510] === 0 && this.parent[$87f876476293d35b$export$833b3e5a19fb8939.Varastossa1510] === 0 && this.parent[$87f876476293d35b$export$833b3e5a19fb8939.Satomäärä] === null) return true;
    else return false;
}




var $987975668562e0eb$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Korjuu"] = "Korjuu";
    Fields["Korjuuala"] = "_610920941387287";
    Fields["Pystyynmyynti"] = "_6109387239387287";
    Fields["Pystyynosto"] = "_6109390195387287";
    Fields["Katoala"] = "_610914549387287";
    Fields["Korjattuala"] = "_6109386967387287";
    Fields["Kuivahein\xe4"] = "_6109_korjuu_387291";
    Fields["S\xe4il\xf6rehu"] = "_6109_korjuu_387275";
    Fields["S\xe4il\xf6rehuEsikuivattu"] = "_6109_korjuu_387279";
    Fields["Niittorehu"] = "_6109_korjuu_387295";
    Fields["Kuivahein\xe4Yhteens\xe4Kg"] = "_566014545387291";
    Fields["S\xe4il\xf6rehuYhteens\xe4Kg"] = "_566014545387275";
    Fields["S\xe4il\xf6rehuEsikuivattuYhteens\xe4Kg"] = "_566014545387279";
    Fields["NiittorehuYhteens\xe4Kg"] = "_566014545387295";
    Fields["S\xe4il\xf6rehuKuivaaineProsentti"] = "_6115386931387275";
    Fields["S\xe4il\xf6rehuEsikuivattuKuivaaineProsentti"] = "_6115386931387279";
    Fields["NiittorehuKuivaaineProsentti"] = "_6115386931387295";
    Fields["SatotasoKuivaheinaYhteensa"] = "Satotaso_KuivaheinaYhteensa";
    Fields["SatotasoSailorehuYhteensa"] = "Satotaso_SailorehuYhteensa";
    Fields["SatotasoSailorehuEsikuivattuYhteensa"] = "Satotaso_SailorehuEsikuivattuYhteensa";
    Fields["SatotasoNiittorehuYhteensa"] = "Satotaso_NiittorehuYhteensa";
    Fields["KuivaheinaKorjuuAlaKaikkiKorjuukerratYhteensa"] = "KuivaheinaHaKaikkiKorjuuKerratYhteensa";
    Fields["SailorehuKorjuuAlaKaikkiKorjuukerratYhteensa"] = "SailorehuaHaKaikkiKorjuuKerratYhteensa";
    Fields["SailorehuEsikuivattuKorjuuAlaKaikkiKorjuukerratYhteensa"] = "SailorehuEsikuivattuHaKaikkiKorjuuKerratYhteensa";
    Fields["NiittorehuKorjuuAlaKaikkiKorjuukerratYhteensa"] = "NiittorehuHaKaikkiKorjuuKerratYhteensa";
})($987975668562e0eb$export$833b3e5a19fb8939 || ($987975668562e0eb$export$833b3e5a19fb8939 = {}));
let $987975668562e0eb$var$prop, $987975668562e0eb$var$prop1, $987975668562e0eb$var$prop2, $987975668562e0eb$var$prop3, $987975668562e0eb$var$prop4;
class $987975668562e0eb$export$1c6c761d15cd8b14 {
    static #_ = (()=>{
        $987975668562e0eb$var$prop = $987975668562e0eb$export$833b3e5a19fb8939.Korjuu;
        $987975668562e0eb$var$prop1 = $987975668562e0eb$export$833b3e5a19fb8939.Kuivaheinä;
        $987975668562e0eb$var$prop2 = $987975668562e0eb$export$833b3e5a19fb8939.Säilörehu;
        $987975668562e0eb$var$prop3 = $987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattu;
        $987975668562e0eb$var$prop4 = $987975668562e0eb$export$833b3e5a19fb8939.Niittorehu;
    })();
    constructor(Korjuu){
        this[$987975668562e0eb$var$prop] = null;
        this[$987975668562e0eb$var$prop1] = null;
        this[$987975668562e0eb$var$prop2] = null;
        this[$987975668562e0eb$var$prop3] = null;
        this[$987975668562e0eb$var$prop4] = null;
        this[$987975668562e0eb$export$833b3e5a19fb8939.Korjuu] = Korjuu;
    }
}
/* ****************** yup ******************* */ /**
 * Jos jossain korjuussa on korjattu tiettyä heinän tyyppiä,
 * kokonaissadon vastaava kenttä ei voi olla tyhjä tai nolla.
 *
 * HOF (higher-order function), joka saa vertailtavien kenttien nimet
 * ja palauttaa varsinaisen testin.
 */ const $987975668562e0eb$var$testKokonaissatoVastaaKorjuuta = (kokonaissadonKenttä, korjuunKenttä, t)=>(rehunurmenSatotiedot)=>{
        const { Korjuu: Korjuu = [], [kokonaissadonKenttä]: kokonaissadonKentänArvo, [$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala]: korjattuala } = rehunurmenSatotiedot;
        /**
       * Tehdään tarkistukset, vain jos korjattua alaa on määritetty,
       * ja nämä kentät ovat näkyvissä.
       */ if (!korjattuala) return true;
        const onkoKorjattuKorjuussa = Korjuu.find((k)=>!!k[korjuunKenttä]);
        if (onkoKorjattuKorjuussa && !kokonaissadonKentänArvo) /**
         * Palauttamalla `ValidationError`, virhe voidaan kohdistaa tiettyyn kenttään.
         * Tällöin virheilmoitus näkyy kohdistetun kentän yhteydessä.
         */ return new (0, $920660c8aca77688$exports).ValidationError(t("fields.errors.rehunurmensatotiedot.kokonaissatovastaakorjuuta"), kokonaissadonKentänArvo, `RehunurmenSatotiedot.${kokonaissadonKenttä}`);
        return true;
    };
const $987975668562e0eb$var$testKokonaissatoKuivaheinäDefinition = (t)=>({
        name: "Kokonaissadon kuivahein\xe4 on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissatoVastaaKorjuuta($987975668562e0eb$export$833b3e5a19fb8939.KuivaheinäYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.Kuivaheinä, t)
    });
const $987975668562e0eb$var$testKokonaissatoSäilörehuEsikuivattuDefinition = (t)=>({
        name: "Kokonaissadon s\xe4il\xf6rehu (esikuivattu) on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissatoVastaaKorjuuta($987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattu, t)
    });
const $987975668562e0eb$var$testKokonaissatoSäilörehuTuoreDefinition = (t)=>({
        name: "Kokonaissadon s\xe4il\xf6rehu (tuore) on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissatoVastaaKorjuuta($987975668562e0eb$export$833b3e5a19fb8939.SäilörehuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.Säilörehu, t)
    });
const $987975668562e0eb$var$testKokonaissatoNiittorehuDefinition = (t)=>({
        name: "Kokonaissadon niittorehu on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissatoVastaaKorjuuta($987975668562e0eb$export$833b3e5a19fb8939.NiittorehuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.Niittorehu, t)
    });
/**
 * Jos kokonaissadon kuiva-ainetta käyttävä satokenttä on annettu,
 * myös käytetty kuiva-aineprosentti tulee ilmoittaa.
 *
 * HOF (higher-order function), joka saa vertailtavien kenttien nimet
 * ja palauttaa varsinaisen testin.
 */ const $987975668562e0eb$var$testKokonaissadonKuivaaineProsenttiAnnettu = (satoKenttä, kuivaaineKenttä, t)=>(rehunurmenSatotiedot)=>{
        const { [satoKenttä]: satoKentänArvo, [kuivaaineKenttä]: kuivaaineKentänArvo, [$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala]: korjattualaKentänArvo } = rehunurmenSatotiedot;
        /**
       * Tehdään tarkistukset, vain jos korjattua alaa on määritetty,
       * ja nämä kentät ovat näkyvissä.
       */ if (!korjattualaKentänArvo) return true;
        if (!!satoKentänArvo && !kuivaaineKentänArvo) return new (0, $920660c8aca77688$exports).ValidationError(t("fields.errors.rehunurmensatotiedot.kokonaissadonkuivaaineprosenttiannettu"), kuivaaineKentänArvo, `RehunurmenSatotiedot.${kuivaaineKenttä}`);
        return true;
    };
const $987975668562e0eb$var$testKokonaissatoSäilörehuEsikuivattuProsenttiDefinition = (t)=>({
        name: "Kokonaissadon s\xe4il\xf6rehu (esikuivattu) on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissadonKuivaaineProsenttiAnnettu($987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattuKuivaaineProsentti, t)
    });
const $987975668562e0eb$var$testKokonaissatoSäilörehuTuoreProsenttiDefinition = (t)=>({
        name: "Kokonaissadon s\xe4il\xf6rehu (tuore) on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissadonKuivaaineProsenttiAnnettu($987975668562e0eb$export$833b3e5a19fb8939.SäilörehuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.SäilörehuKuivaaineProsentti, t)
    });
const $987975668562e0eb$var$testKokonaissatoNiittorehuProsenttiDefinition = (t)=>({
        name: "Kokonaissadon niittorehu on m\xe4\xe4ritetty tarvittaessa",
        test: $987975668562e0eb$var$testKokonaissadonKuivaaineProsenttiAnnettu($987975668562e0eb$export$833b3e5a19fb8939.NiittorehuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.NiittorehuKuivaaineProsentti, t)
    });
//TODO: REMOVE 'ANY' TYPING
const $987975668562e0eb$var$testKorjuualaAgainstOtherFields = (t)=>(rehunurmenSatotiedot, context)=>{
        if (!rehunurmenSatotiedot || rehunurmenSatotiedot.length < 3) return true;
        const korjattuala = rehunurmenSatotiedot[$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala] ?? 0;
        const laskeKorjuukerranSumma = (rivi = {})=>(rivi[$987975668562e0eb$export$833b3e5a19fb8939.Säilörehu] || 0) + (rivi[$987975668562e0eb$export$833b3e5a19fb8939.Kuivaheinä] || 0) + (rivi[$987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattu] || 0) + (rivi[$987975668562e0eb$export$833b3e5a19fb8939.Niittorehu] || 0);
        const kenttasumma = korjattuala - laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[0]);
        if (korjattuala === null || korjattuala === undefined || korjattuala === 0) return true;
        if (korjattuala < 0) return context.createError({
            message: t("fields.errors.korjattualaeivoiollanegatiivinen")
        });
        if (!$a8fcb92d8c5bc3d8$export$9663ddc1cf085b32(laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[0]), korjattuala)) return context.createError({
            message: t("fields.errors.korjuu1eroaakokonaiskorjuusta", {
                erotus: $a8fcb92d8c5bc3d8$export$acaf96a27438246b(laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[0]), korjattuala) || "-"
            })
        });
        if (laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[1]) > korjattuala) return context.createError({
            message: t("fields.errors.korjuu2eroaakokonaiskorjuusta", {
                erotus: $a8fcb92d8c5bc3d8$export$acaf96a27438246b(laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[1]), korjattuala) || "-"
            })
        });
        if (laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[2]) > korjattuala) return context.createError({
            message: t("fields.errors.korjuu3eroaakokonaiskorjuusta", {
                erotus: $a8fcb92d8c5bc3d8$export$acaf96a27438246b(laskeKorjuukerranSumma(rehunurmenSatotiedot.Korjuu[2]), korjattuala) || "-"
            })
        });
        return true;
    };
const $987975668562e0eb$var$testKorjuualaAgainstOtherFieldsDefinition = (t)=>({
        /*
    This test is used to determine whether or not the first member of the fields
      array has a value in the field 'korjuuala'
    Than checking whether or not the other fields in the same array have a value.
      Lastly, checking whether or not the sum of these other fields, is the same or less than korjuuala field's value
  */ name: "sumOfFields",
        exclusive: false,
        test: $987975668562e0eb$var$testKorjuualaAgainstOtherFields(t)
    });
const $987975668562e0eb$var$testlimitfields = (satoKenttä, korjattualaKenttä, numberLimit, plantname, t)=>(rehunurmenSatotiedot)=>{
        const { [satoKenttä]: satoKentanArvo, Korjuu: Korjuu } = rehunurmenSatotiedot;
        // Sum values for target field for each Korjuu
        const korjattualaKentänArvo = Korjuu.map((row)=>row[korjattualaKenttä]).filter((n)=>n !== undefined).reduce((a, b)=>Number(a) + Number(b), 0);
        /**
       * Tehdään tarkistukset, vain jos korjattua alaa on määritetty,
       * ja nämä kentät ovat näkyvissä.
       */ if (!korjattualaKentänArvo) return true;
        if (satoKentanArvo / korjattualaKentänArvo > numberLimit) return new (0, $920660c8aca77688$exports).ValidationError(t("fields.errors.satotaso.hehtaarisatoylitt\xe4\xe4sallitunarvon", {
            plantname: plantname,
            numberLimit: numberLimit
        }), satoKentanArvo, `RehunurmenSatotiedot.${satoKenttä}`);
        else return true;
    };
const $987975668562e0eb$var$testKuivaheinaLimitDefinition = (t)=>({
        name: "Kokonaissato ei saa ylitt\xe4\xe4 9 000kg/ha kuivahein\xe4ss\xe4.",
        test: $987975668562e0eb$var$testlimitfields($987975668562e0eb$export$833b3e5a19fb8939.KuivaheinäYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.Kuivaheinä, 9000, t("RehunurmenSatotiedot.Kuivahein\xe4n"), t)
    });
const $987975668562e0eb$var$testTuoresailorehuLimitDefinition = (t)=>({
        name: "Kokonaissato ei saa ylitt\xe4\xe4 40 000kg/ha tuores\xe4il\xf6rehussa.",
        test: $987975668562e0eb$var$testlimitfields($987975668562e0eb$export$833b3e5a19fb8939.SäilörehuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.Säilörehu, 40000, t("RehunurmenSatotiedot.Tuores\xe4il\xf6ttyS\xe4il\xf6rehun"), t)
    });
const $987975668562e0eb$var$testEsikuivattuSailorehuLimitDefinition = (t)=>({
        name: "Kokonaissato ei saa ylitt\xe4\xe4 40 000kg/ha esikuivatussa s\xe4il\xf6rehussa.",
        test: $987975668562e0eb$var$testlimitfields($987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattu, 40000, t("RehunurmenSatotiedot.EsikuivattuS\xe4il\xf6rehun"), t)
    });
const $987975668562e0eb$var$testNiittorehuLimitDefinition = (t)=>({
        name: "Kokonaissato ei saa ylitt\xe4\xe4 40 000kg/ha niittorehussa",
        test: $987975668562e0eb$var$testlimitfields($987975668562e0eb$export$833b3e5a19fb8939.NiittorehuYhteensäKg, $987975668562e0eb$export$833b3e5a19fb8939.Niittorehu, 40000, t("RehunurmenSatotiedot.Niittorehun"), t)
    });
var $987975668562e0eb$export$2e2bcd8739ae039 = (t)=>(0, $920660c8aca77688$exports).object().shape({
        RehunurmenSatotiedot: (0, $920660c8aca77688$exports).object().test($987975668562e0eb$var$testKuivaheinaLimitDefinition(t)).test($987975668562e0eb$var$testTuoresailorehuLimitDefinition(t)).test($987975668562e0eb$var$testEsikuivattuSailorehuLimitDefinition(t)).test($987975668562e0eb$var$testNiittorehuLimitDefinition(t)).test($987975668562e0eb$var$testKorjuualaAgainstOtherFieldsDefinition(t)).test($987975668562e0eb$var$testKokonaissatoKuivaheinäDefinition(t)).test($987975668562e0eb$var$testKokonaissatoSäilörehuEsikuivattuDefinition(t)).test($987975668562e0eb$var$testKokonaissatoSäilörehuTuoreDefinition(t)).test($987975668562e0eb$var$testKokonaissatoNiittorehuDefinition(t)).test($987975668562e0eb$var$testKokonaissatoSäilörehuEsikuivattuProsenttiDefinition(t)).test($987975668562e0eb$var$testKokonaissatoSäilörehuTuoreProsenttiDefinition(t)).test($987975668562e0eb$var$testKokonaissatoNiittorehuProsenttiDefinition(t)).shape({
            [$987975668562e0eb$export$833b3e5a19fb8939.Korjuuala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).defaultNumber,
            [$987975668562e0eb$export$833b3e5a19fb8939.Pystyynmyynti]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands,
            [$987975668562e0eb$export$833b3e5a19fb8939.Pystyynosto]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands,
            [$987975668562e0eb$export$833b3e5a19fb8939.Katoala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands,
            [$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands,
            [$987975668562e0eb$export$833b3e5a19fb8939.KuivaheinäYhteensäKg]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions,
            [$987975668562e0eb$export$833b3e5a19fb8939.SäilörehuYhteensäKg]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when(`RehunurmenSatotiedot.${$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala}`, {
                is: (value)=>value > 0,
                then: (0, $ab5958319bb12700$export$d65ba4b80d352978).notNull(1).max(99999999, "fields.errors.s\xe4il\xf6rehuSatoYhteens\xe4Max")
            }),
            [$987975668562e0eb$export$833b3e5a19fb8939.SäilörehuKuivaaineProsentti]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when(`RehunurmenSatotiedot.${$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala}`, {
                is: (value)=>value > 0,
                then: (0, $ab5958319bb12700$export$6f98703d2f5d4276).nurmirehuKuivaaineProsentti
            }).min(10, "fields.errors.s\xe4il\xf6rehuKuivaaineProsenttiMin").max(60, "fields.errors.s\xe4il\xf6rehuKuivaaineProsenttiMax"),
            [$987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattuYhteensäKg]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when(`RehunurmenSatotiedot.${$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala}`, {
                is: (value)=>value > 0,
                then: (0, $ab5958319bb12700$export$d65ba4b80d352978).notNull(1)
            }),
            [$987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattuKuivaaineProsentti]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when(`RehunurmenSatotiedot.${$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala}`, {
                is: (value)=>value > 0,
                then: (0, $ab5958319bb12700$export$6f98703d2f5d4276).säilörehuEsikuivattuKuivaaineProsentti
            }).min(15, "fields.errors.s\xe4il\xf6rehuEsikuivattuKuivaaineProsenttiMin").max(70, "fields.errors.s\xe4il\xf6rehuEsikuivattuKuivaaineProsenttiMax"),
            [$987975668562e0eb$export$833b3e5a19fb8939.NiittorehuYhteensäKg]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions,
            [$987975668562e0eb$export$833b3e5a19fb8939.NiittorehuKuivaaineProsentti]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).when(`RehunurmenSatotiedot.${$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala}`, {
                is: (value)=>value > 0,
                then: (0, $ab5958319bb12700$export$6f98703d2f5d4276).nurmirehuKuivaaineProsentti
            }).min(10, "fields.errors.niittorehuKuivaaineProsenttiMin").max(60, "fields.errors.niittorehuKuivaaineProsenttiMax"),
            Korjuu: (0, $920660c8aca77688$exports).array().of((0, $920660c8aca77688$exports).object().shape({
                [$987975668562e0eb$export$833b3e5a19fb8939.Korjuu]: (0, $920660c8aca77688$exports).string().when(`RehunurmenSatotiedot.${$987975668562e0eb$export$833b3e5a19fb8939.Korjattuala}`, {
                    is: (value)=>value > 0,
                    then: (0, $920660c8aca77688$exports).string().required()
                }),
                [$987975668562e0eb$export$833b3e5a19fb8939.Kuivaheinä]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands,
                [$987975668562e0eb$export$833b3e5a19fb8939.Säilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).säilörehu,
                [$987975668562e0eb$export$833b3e5a19fb8939.SäilörehuEsikuivattu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).säilörehu,
                [$987975668562e0eb$export$833b3e5a19fb8939.Niittorehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands
            }))
        })
    });



var $f1q41 = parcelRequire("f1q41");



var $af1189b7d638610c$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["Kylv\xf6ala"] = "_6109386939";
    Fields["Suorakylv\xf6ala"] = "_6109386943";
})($af1189b7d638610c$export$833b3e5a19fb8939 || ($af1189b7d638610c$export$833b3e5a19fb8939 = {}));
let $af1189b7d638610c$var$prop, $af1189b7d638610c$var$prop1, $af1189b7d638610c$var$prop2;
class $af1189b7d638610c$export$1bc931c35d6ecc19 {
    static #_ = (()=>{
        $af1189b7d638610c$var$prop = $af1189b7d638610c$export$833b3e5a19fb8939.Kasvilaji;
        $af1189b7d638610c$var$prop1 = $af1189b7d638610c$export$833b3e5a19fb8939.Kylvöala;
        $af1189b7d638610c$var$prop2 = $af1189b7d638610c$export$833b3e5a19fb8939.Suorakylvöala;
    })();
    constructor(Kasvilaji, kylvöala, suorakylvöala){
        this[$af1189b7d638610c$var$prop1] = null;
        this[$af1189b7d638610c$var$prop2] = null;
        this[$af1189b7d638610c$export$833b3e5a19fb8939.Kasvilaji] = Kasvilaji;
        if (kylvöala) this[$af1189b7d638610c$export$833b3e5a19fb8939.Kylvöala] = kylvöala;
        if (suorakylvöala) this[$af1189b7d638610c$export$833b3e5a19fb8939.Suorakylvöala] = suorakylvöala;
    }
}
var $af1189b7d638610c$export$2e2bcd8739ae039 = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    Syyskylvot: $e218604b96487b25$export$185802fd694ee1f5().of($cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        [$af1189b7d638610c$export$833b3e5a19fb8939.Kasvilaji]: $bcc252d93ab3046c$export$185802fd694ee1f5().required(),
        [$af1189b7d638610c$export$833b3e5a19fb8939.Kylvöala]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5),
        [$af1189b7d638610c$export$833b3e5a19fb8939.Suorakylvöala]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test("harvestedAreaMax", "fields.errors.yliKylv\xf6alan", function(item) {
            if (!item) return true;
            return this.parent[$af1189b7d638610c$export$833b3e5a19fb8939.Kylvöala] >= (0, $f1q41.sum)([
                item
            ]);
        })
    }))
});
function $af1189b7d638610c$export$9aa81cac6926090e() {
    const vals = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.Syyskylvot);
    const syyskylvoViljat = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.meta.viljakasvit).filter((value)=>value.syyskylvo);
    const syyskylvoValkuaiskasvit = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.meta.valkuaiskasvit).filter((value)=>value.syyskylvo);
    return syyskylvoViljat.concat(syyskylvoValkuaiskasvit).map((row)=>{
        const match = (vals || []).find((v)=>v.Kasvilaji === row.id);
        if (match) return new $af1189b7d638610c$export$1bc931c35d6ecc19(row.id, match[$af1189b7d638610c$export$833b3e5a19fb8939.Kylvöala], match[$af1189b7d638610c$export$833b3e5a19fb8939.Suorakylvöala]);
        return new $af1189b7d638610c$export$1bc931c35d6ecc19(row.id);
    });
}



var $d6577b6792f647a6$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["Viljelyala"] = "_610920941";
    Fields["Korjuuala"] = "_610920919";
    Fields["KorjuualaS\xe4il\xf6rehu"] = "_610920919sr";
    Fields["Sato"] = "_566014545";
    Fields["SatoS\xe4il\xf6rehu"] = "_566014545sr";
    Fields["KuivaaineS\xe4il\xf6rehu"] = "_6115386931";
    Fields["SatotasoKuiva"] = "Satotaso_Kuiva";
    Fields["SatotasoTuore"] = "Satotaso_Tuore";
    Fields["Korjuuala\xd6ljykasvi"] = "_610920919_\xf6ljy";
    Fields["Satom\xe4\xe4r\xe4\xd6ljykasvi"] = "_566014545_\xf6ljy";
    Fields["Satotaso\xd6ljykasvi"] = "_Satotaso_\xf6ljy";
})($d6577b6792f647a6$export$833b3e5a19fb8939 || ($d6577b6792f647a6$export$833b3e5a19fb8939 = {}));
let $d6577b6792f647a6$var$prop, $d6577b6792f647a6$var$prop1, $d6577b6792f647a6$var$prop2, $d6577b6792f647a6$var$prop3, $d6577b6792f647a6$var$prop4, $d6577b6792f647a6$var$prop5, $d6577b6792f647a6$var$prop6, $d6577b6792f647a6$var$prop7, $d6577b6792f647a6$var$prop8, $d6577b6792f647a6$var$prop9, $d6577b6792f647a6$var$prop10, $d6577b6792f647a6$var$prop11, $d6577b6792f647a6$var$prop12;
class $d6577b6792f647a6$export$ddc696011e42056a {
    static #_ = (()=>{
        $d6577b6792f647a6$var$prop = $d6577b6792f647a6$export$833b3e5a19fb8939.Kasvilaji;
        $d6577b6792f647a6$var$prop1 = $d6577b6792f647a6$export$833b3e5a19fb8939.Viljelyala;
        $d6577b6792f647a6$var$prop2 = $d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala;
        $d6577b6792f647a6$var$prop3 = $d6577b6792f647a6$export$833b3e5a19fb8939.Sato;
        $d6577b6792f647a6$var$prop4 = $d6577b6792f647a6$export$833b3e5a19fb8939.SatotasoKuiva;
        $d6577b6792f647a6$var$prop5 = $d6577b6792f647a6$export$833b3e5a19fb8939.SatotasoTuore;
        $d6577b6792f647a6$var$prop6 = $d6577b6792f647a6$export$833b3e5a19fb8939.KuivaaineSäilörehu;
        $d6577b6792f647a6$var$prop7 = $d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu;
        $d6577b6792f647a6$var$prop8 = $d6577b6792f647a6$export$833b3e5a19fb8939.SatoSäilörehu;
        $d6577b6792f647a6$var$prop9 = $d6577b6792f647a6$export$833b3e5a19fb8939.KuivaaineSäilörehu;
        $d6577b6792f647a6$var$prop10 = $d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi;
        $d6577b6792f647a6$var$prop11 = $d6577b6792f647a6$export$833b3e5a19fb8939.SatomääräÖljykasvi;
        $d6577b6792f647a6$var$prop12 = $d6577b6792f647a6$export$833b3e5a19fb8939.SatotasoÖljykasvi;
    })();
    constructor(Kasvilaji, Viljelyala){
        this[$d6577b6792f647a6$var$prop1] = null;
        this[$d6577b6792f647a6$var$prop2] = null;
        this[$d6577b6792f647a6$var$prop3] = null;
        this[$d6577b6792f647a6$var$prop4] = null;
        this[$d6577b6792f647a6$var$prop5] = null;
        this[$d6577b6792f647a6$var$prop6] = null;
        this[$d6577b6792f647a6$var$prop7] = null;
        this[$d6577b6792f647a6$var$prop8] = null;
        this[$d6577b6792f647a6$var$prop9] = null;
        this[$d6577b6792f647a6$var$prop10] = null;
        this[$d6577b6792f647a6$var$prop11] = null;
        this[$d6577b6792f647a6$var$prop12] = null;
        this[$d6577b6792f647a6$export$833b3e5a19fb8939.Kasvilaji] = Kasvilaji;
        if (Viljelyala) this[$d6577b6792f647a6$export$833b3e5a19fb8939.Viljelyala] = Viljelyala;
    }
}
var $d6577b6792f647a6$export$2e2bcd8739ae039 = (0, $920660c8aca77688$exports).object().shape({
    ValkuaiskasvienSatotiedot: (0, $920660c8aca77688$exports).array().of((0, $920660c8aca77688$exports).object().shape({
        [$d6577b6792f647a6$export$833b3e5a19fb8939.Kasvilaji]: (0, $920660c8aca77688$exports).string().required(),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.Viljelyala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).hundreds.notNull(0, "fields.errors.viljelyalaRequired"),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).valkuaiskasvienKorjuuala.max(1000000, "fields.errors.MaxMillion").test("korjuualaRequired", "fields.errors.korjuualaValkuaiskasvitRequired", function(item) {
            // If KorjuualaSäilörehu or KorjuualaÖljykasvi is not given, field is required to have a value.
            if (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Viljelyala] && (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu] === undefined || this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu] === null) && (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi] === undefined || this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi] === null) && (item === undefined || item === null)) return false;
            return true;
        }),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.Sato]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala, "fields.errors.kuivattuSatoRequired"),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).valkuaiskasvienKorjuuala.test("korjuualaRequired", "fields.errors.korjuualaValkuaiskasvitRequired", function(item) {
            // If Korjuuala or KorjuualaÖljykasvi is not given, field is required to have a value.
            if (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Viljelyala] && (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala] === undefined || this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala] === null) && (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi] === undefined || this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi] === null) && (item === undefined || item === null)) return false;
            return true;
        }),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.SatoSäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu, "fields.errors.tuoresatoRequired"),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.KuivaaineSäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).valkuaiskasvienKuivaaineProsentti.requiredWith($d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu, "fields.errors.kuivaaineprosenttiRequired"),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.SatotasoTuore]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _387139: null,
            _386579: 35000,
            _61223: 35000
        }, {
            kasvilaji: $d6577b6792f647a6$export$833b3e5a19fb8939.Kasvilaji
        })),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.SatotasoKuiva]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _387139: 10000,
            _386579: 10000,
            _61223: 6000
        }, {
            kasvilaji: $d6577b6792f647a6$export$833b3e5a19fb8939.Kasvilaji
        })),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).valkuaiskasvienKorjuuala.test("harvestedAreaMax", "fields.errors.korjuualaValkuaiskasvitRequired", function(item) {
            // If KorjuualaSäilörehu or Korjuuala is not given, field is required to have a value.
            if (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Viljelyala] && (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu] === undefined || this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaSäilörehu] === null) && (this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala] === undefined || this.parent[$d6577b6792f647a6$export$833b3e5a19fb8939.Korjuuala] === null) && (item === undefined || item === null)) return false;
            else return true;
        }),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.SatomääräÖljykasvi]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).million.requiredWith($d6577b6792f647a6$export$833b3e5a19fb8939.KorjuualaÖljykasvi, "fields.errors.sadonKokonaism\xe4\xe4r\xe4Required"),
        [$d6577b6792f647a6$export$833b3e5a19fb8939.SatotasoÖljykasvi]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _387023: 6000,
            _387019: 5000,
            _387027: 5000,
            _387243: 6000,
            _386999: 4000,
            _387003: 4000
        }, {
            kasvilaji: $d6577b6792f647a6$export$833b3e5a19fb8939.Kasvilaji
        }))
    }))
});




var $8600e8026484e4e0$export$bf26e3698826ecc9;
(function(VarastoViljat) {
    VarastoViljat["vehn\xe4"] = "_61189";
    VarastoViljat["ruis"] = "_61197";
    VarastoViljat["ohra"] = "_61199";
    VarastoViljat["kaura"] = "_61209";
})($8600e8026484e4e0$export$bf26e3698826ecc9 || ($8600e8026484e4e0$export$bf26e3698826ecc9 = {}));
var $8600e8026484e4e0$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["VarastoarvoHein\xe4kuu"] = "_5660386923";
    Fields["VarastoarvioTammikuu"] = "_5660386927";
})($8600e8026484e4e0$export$833b3e5a19fb8939 || ($8600e8026484e4e0$export$833b3e5a19fb8939 = {}));
class $8600e8026484e4e0$export$b6fa684646d12923 {
    constructor(varastossaOnViljaa){
        this.varastossaOnViljaa = false;
        this.viljat = [];
        this.varastossaOnViljaa = varastossaOnViljaa;
        Object.values($8600e8026484e4e0$export$bf26e3698826ecc9).forEach((label)=>{
            this.viljat.push({
                Kasvilaji: label
            });
        });
    }
}
const $8600e8026484e4e0$var$schema = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    Varastotiedot: $e218604b96487b25$export$185802fd694ee1f5().of($cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        [$8600e8026484e4e0$export$833b3e5a19fb8939.Kasvilaji]: $bcc252d93ab3046c$export$185802fd694ee1f5(),
        [$8600e8026484e4e0$export$833b3e5a19fb8939.VarastoarvoHeinäkuu]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5),
        [$8600e8026484e4e0$export$833b3e5a19fb8939.VarastoarvioTammikuu]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5)
    }))
});
var $8600e8026484e4e0$export$2e2bcd8739ae039 = $8600e8026484e4e0$var$schema;



var $f1q41 = parcelRequire("f1q41");


var $91f1e45fd4a11301$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["KorjattuKuivana"] = "Korjattu_KuivattavaVilja";
    Fields["KorjattuTuores\xe4il\xf6rehu"] = "Korjattu_Tuoresailovilja";
    Fields["KorjattuKokoviljas\xe4il\xf6rehu"] = "Korjattu_Kokoviljasailo";
    Fields["Viljelyala"] = "_610920941";
    Fields["KorjuualaKuivattavaVilja"] = "_610920919";
    Fields["Satom\xe4\xe4r\xe4KuivattavaVilja"] = "_566014545kv";
    Fields["VarastoHein\xe4kuu"] = "_5660386923";
    Fields["VarastoTammikuu"] = "_5660386927";
    Fields["KorjuualaTuores\xe4il\xf6vilja"] = "_610920919ts";
    Fields["Satom\xe4\xe4r\xe4Tuores\xe4il\xf6vilja"] = "_566014545ts";
    Fields["KosteusTuores\xe4il\xf6vilja"] = "_6115386935";
    Fields["KuivaaineKokoviljas\xe4il\xf6rehu"] = "_6115386931";
    Fields["KorjuualaVihantavilja"] = "_610920919vv";
    Fields["Satom\xe4\xe4r\xe4Vihantavilja"] = "_566014545vv";
    Fields["KorjuualaKokoviljas\xe4il\xf6rehu"] = "_610920919kvs";
    Fields["Satom\xe4\xe4r\xe4Kokoviljas\xe4il\xf6rehu"] = "_566014545kvs";
    Fields["SatotasoKuivattavaVilja"] = "_Satotaso_KuivattavaVilja";
    Fields["SatotasoTuores\xe4il\xf6vilja"] = "_Satotaso_Tuoresailovilja";
    Fields["SatotasoKokoviljas\xe4il\xf6rehu"] = "_Satotaso_Kokoviljasailorehu";
    Fields["SatotasoVihantavilja"] = "_Satotaso_Vihantavilja";
    Fields["KuivaaineVihantavilja"] = "_6115386931vv";
    Fields["KorjuualaMallasohra"] = "610920919mo";
    Fields["Satom\xe4\xe4r\xe4Mallasohra"] = "566014545mo";
})($91f1e45fd4a11301$export$833b3e5a19fb8939 || ($91f1e45fd4a11301$export$833b3e5a19fb8939 = {}));
let $91f1e45fd4a11301$var$prop, $91f1e45fd4a11301$var$prop1, $91f1e45fd4a11301$var$prop2, $91f1e45fd4a11301$var$prop3, $91f1e45fd4a11301$var$prop4, $91f1e45fd4a11301$var$prop5, $91f1e45fd4a11301$var$prop6, $91f1e45fd4a11301$var$prop7, $91f1e45fd4a11301$var$prop8, $91f1e45fd4a11301$var$prop9, $91f1e45fd4a11301$var$prop10, $91f1e45fd4a11301$var$prop11, $91f1e45fd4a11301$var$prop12, $91f1e45fd4a11301$var$prop13, $91f1e45fd4a11301$var$prop14, $91f1e45fd4a11301$var$prop15, $91f1e45fd4a11301$var$prop16, $91f1e45fd4a11301$var$prop17, $91f1e45fd4a11301$var$prop18, $91f1e45fd4a11301$var$prop19, $91f1e45fd4a11301$var$prop20, $91f1e45fd4a11301$var$prop21, $91f1e45fd4a11301$var$prop22;
class $91f1e45fd4a11301$export$bfbeee6f7bc43c8d {
    static #_ = (()=>{
        $91f1e45fd4a11301$var$prop = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKuivana;
        $91f1e45fd4a11301$var$prop1 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuTuoresäilörehu;
        $91f1e45fd4a11301$var$prop2 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKokoviljasäilörehu;
        $91f1e45fd4a11301$var$prop3 = $91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala;
        $91f1e45fd4a11301$var$prop4 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaKuivattavaVilja;
        $91f1e45fd4a11301$var$prop5 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräKuivattavaVilja;
        $91f1e45fd4a11301$var$prop6 = $91f1e45fd4a11301$export$833b3e5a19fb8939.VarastoHeinäkuu;
        $91f1e45fd4a11301$var$prop7 = $91f1e45fd4a11301$export$833b3e5a19fb8939.VarastoTammikuu;
        $91f1e45fd4a11301$var$prop8 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaTuoresäilövilja;
        $91f1e45fd4a11301$var$prop9 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräTuoresäilövilja;
        $91f1e45fd4a11301$var$prop10 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KosteusTuoresäilövilja;
        $91f1e45fd4a11301$var$prop11 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KuivaaineKokoviljasäilörehu;
        $91f1e45fd4a11301$var$prop12 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaKokoviljasäilörehu;
        $91f1e45fd4a11301$var$prop13 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräKokoviljasäilörehu;
        $91f1e45fd4a11301$var$prop14 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräVihantavilja;
        $91f1e45fd4a11301$var$prop15 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaVihantavilja;
        $91f1e45fd4a11301$var$prop16 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoKuivattavaVilja;
        $91f1e45fd4a11301$var$prop17 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoKokoviljasäilörehu;
        $91f1e45fd4a11301$var$prop18 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoTuoresäilövilja;
        $91f1e45fd4a11301$var$prop19 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoVihantavilja;
        $91f1e45fd4a11301$var$prop20 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KuivaaineVihantavilja;
        $91f1e45fd4a11301$var$prop21 = $91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaMallasohra;
        $91f1e45fd4a11301$var$prop22 = $91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräMallasohra;
    })();
    constructor(Kasvilaji, Viljelyala){
        this[$91f1e45fd4a11301$var$prop] = false;
        this[$91f1e45fd4a11301$var$prop1] = false;
        this[$91f1e45fd4a11301$var$prop2] = false;
        this[$91f1e45fd4a11301$var$prop3] = null;
        this[$91f1e45fd4a11301$var$prop4] = null;
        this[$91f1e45fd4a11301$var$prop5] = null;
        this[$91f1e45fd4a11301$var$prop6] = null;
        this[$91f1e45fd4a11301$var$prop7] = null;
        this[$91f1e45fd4a11301$var$prop8] = null;
        this[$91f1e45fd4a11301$var$prop9] = null;
        this[$91f1e45fd4a11301$var$prop10] = null;
        this[$91f1e45fd4a11301$var$prop11] = null;
        this[$91f1e45fd4a11301$var$prop12] = null;
        this[$91f1e45fd4a11301$var$prop13] = null;
        this[$91f1e45fd4a11301$var$prop14] = null;
        this[$91f1e45fd4a11301$var$prop15] = null;
        this[$91f1e45fd4a11301$var$prop16] = null;
        this[$91f1e45fd4a11301$var$prop17] = null;
        this[$91f1e45fd4a11301$var$prop18] = null;
        this[$91f1e45fd4a11301$var$prop19] = null;
        this[$91f1e45fd4a11301$var$prop20] = null;
        this[$91f1e45fd4a11301$var$prop21] = null;
        this[$91f1e45fd4a11301$var$prop22] = null;
        this.Kasvilaji = Kasvilaji;
        if (Viljelyala) this[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala] = Viljelyala;
    }
}
var $91f1e45fd4a11301$export$2e2bcd8739ae039 = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    ViljanSatotiedot: $e218604b96487b25$export$185802fd694ee1f5().of($cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji]: $bcc252d93ab3046c$export$185802fd694ee1f5().required(),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKuivana]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).boolean.test("korjuutapaRequired", function(item) {
            // Checkboxes are not required for vihantavilja or mallasohra
            if (this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji] === "_386583" || this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji] === "_61201") return true;
            // Return false if none of the checkboxes are checked
            if (this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala] && !item && !this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKokoviljasäilörehu] && !this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuTuoresäilörehu]) return false;
            return true;
        }),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuTuoresäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).boolean,
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKokoviljasäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).boolean,
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).thousands.notNull(0, "fields.errors.viljelyalaRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaKuivattavaVilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).viljakasvienKorjuuala.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKuivana, "fields.errors.kuivakorjuualaRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräKuivattavaVilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaKuivattavaVilja, "fields.errors.kuivattuSatoRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaTuoresäilövilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).viljakasvienKorjuuala.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuTuoresäilörehu, "fields.errors.tuorekorjuualaRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräTuoresäilövilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaTuoresäilövilja, "fields.errors.tuoresatoRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KosteusTuoresäilövilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).tuoreSäilöviljanKosteusprosentti.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräTuoresäilövilja, "fields.errors.kosteusprosenttiRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaKokoviljasäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).viljakasvienKorjuuala.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjattuKokoviljasäilörehu, "fields.errors.kokoviljas\xe4il\xf6rehukorjuualaRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräKokoviljasäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaKokoviljasäilörehu, "fields.errors.kokoviljas\xe4il\xf6rehusatoRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KuivaaineKokoviljasäilörehu]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).viljanKuivaaineProsentti.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräKokoviljasäilörehu, "fields.errors.kuivaaineprosenttiRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräVihantavilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaVihantavilja, "fields.errors.sadonKokonaism\xe4\xe4r\xe4Required"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaVihantavilja]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test("korjuualaRequired", "fields.errors.korjuualaRequired", function(item) {
            if (this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji] === "_386583" && (item === undefined || item === null) && this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala] !== 0) return false;
            return true;
        }).test("harvestedAreaMax", "fields.errors.yliViljelyalan", function(item) {
            if (!item || this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji] !== "_386583") return true;
            if (!this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala]) return true;
            return this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala] >= (0, $f1q41.sum)([
                this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaVihantavilja]
            ]);
        }),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KuivaaineVihantavilja]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).viljanKuivaaineProsentti.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaVihantavilja, "fields.errors.kuivaaineprosenttiRequired"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaMallasohra]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test("korjuualaRequired", "fields.errors.korjuualaRequired", function(item) {
            if (this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji] === "_61201" && this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala] && (item === undefined || item === null)) return false;
            return true;
        }).test("harvestedAreaMax", "fields.errors.yliViljelyalan", function(item) {
            if (!item || this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji] !== "_61201") return true;
            if (!this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.Viljelyala]) return true;
            return this.parent._610920941 >= (0, $f1q41.sum)([
                this.parent[$91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaMallasohra]
            ]);
        }),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatomääräMallasohra]: (0, $ab5958319bb12700$export$6f98703d2f5d4276).millions.requiredWith($91f1e45fd4a11301$export$833b3e5a19fb8939.KorjuualaMallasohra, "fields.errors.sadonKokonaism\xe4\xe4r\xe4Required"),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoKokoviljasäilörehu]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _386591: 30000,
            _386903: 30000,
            _386587: 30000,
            _387267: 30000,
            _386583: null,
            _61201: null,
            _61209: 30000,
            _61203: 30000,
            _386907: 30000,
            _61197: 30000,
            _386911: 30000,
            _386915: 30000
        }, {
            kasvilaji: $91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji
        })),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoKuivattavaVilja]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _386591: 10000,
            _386903: 10000,
            _386587: 10000,
            _387267: 10000,
            _386583: null,
            _61201: 10000,
            _61209: 10000,
            _61203: 10000,
            _386907: 10000,
            _61197: 10000,
            _386911: 10000,
            _386915: 10000
        }, {
            kasvilaji: $91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji
        })),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoTuoresäilövilja]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _386591: 25000,
            _386903: 25000,
            _386587: 25000,
            _387267: 25000,
            _386583: null,
            _61201: null,
            _61209: 25000,
            _61203: 25000,
            _386907: 25000,
            _61197: 25000,
            _386911: 25000,
            _386915: 25000
        }, {
            kasvilaji: $91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji
        })),
        [$91f1e45fd4a11301$export$833b3e5a19fb8939.SatotasoVihantavilja]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _386591: null,
            _386903: null,
            _386587: null,
            _387267: null,
            _386583: 35000,
            _61201: null,
            _61209: null,
            _61203: null,
            _386907: null,
            _61197: null,
            _386911: null,
            _386915: null
        }, {
            kasvilaji: $91f1e45fd4a11301$export$833b3e5a19fb8939.Kasvilaji
        }))
    }))
});



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

var $1Ikg4 = parcelRequire("1Ikg4");


var $cpBQU = parcelRequire("cpBQU");

var $3AM7p = parcelRequire("3AM7p");


var $e8gS1 = parcelRequire("e8gS1");

var $1sz44 = parcelRequire("1sz44");



var $acw62 = parcelRequire("acw62");

function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}



var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $60bdf67e43f5dfcb$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $60bdf67e43f5dfcb$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $8Indx = parcelRequire("8Indx");


var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $d1b0a83afb76c574$export$b4312079ad514ba0(slot) {
    return (0, $4Cod0.default)("MuiPopperUnstyled", slot);
}
const $d1b0a83afb76c574$var$popperUnstyledClasses = (0, $beCSm.default)("MuiPopperUnstyled", [
    "root"
]);
var $d1b0a83afb76c574$export$2e2bcd8739ae039 = $d1b0a83afb76c574$var$popperUnstyledClasses;




var $ayMG0 = parcelRequire("ayMG0");
const $d9a06bdf697677bb$var$_excluded = [
    "anchorEl",
    "children",
    "component",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "ownerState",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps"
], $d9a06bdf697677bb$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition"
];
function $d9a06bdf697677bb$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $d9a06bdf697677bb$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $d9a06bdf697677bb$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d1b0a83afb76c574$export$b4312079ad514ba0), {});
};
const $d9a06bdf697677bb$var$defaultPopperOptions = {};
/* eslint-disable react/prop-types */ const $d9a06bdf697677bb$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, ref) {
    var _ref;
    const { anchorEl: anchorEl, children: children, component: component, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, ownerState: ownerState, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $5877039b6aa04c0b$export$2e2bcd8739ae039)(props, $d9a06bdf697677bb$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(tooltipRef, ref);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $d9a06bdf697677bb$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (!anchorEl || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        const resolvedAnchorEl = $d9a06bdf697677bb$var$resolveAnchorEl(anchorEl);
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)($d9a06bdf697677bb$var$resolveAnchorEl(anchorEl), tooltipRef.current, (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $d9a06bdf697677bb$var$useUtilityClasses();
    const Root = (_ref = component != null ? component : slots.root) != null ? _ref : "div";
    const rootProps = (0, $fce864403201fe7f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, props, ownerState),
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/* eslint-enable react/prop-types */ /**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */ const $d9a06bdf697677bb$var$PopperUnstyled = /*#__PURE__*/ $acw62.forwardRef(function PopperUnstyled(props, ref) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $d9a06bdf697677bb$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false } = props, other = (0, $5877039b6aa04c0b$export$2e2bcd8739ae039)(props, $d9a06bdf697677bb$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $4cf4482b502c4310$export$2e2bcd8739ae039)($d9a06bdf697677bb$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2ad7edda02764f6$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d9a06bdf697677bb$var$PopperTooltip, (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: ref,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef
        }, other, {
            style: (0, $4171c580f9e5aff6$export$2e2bcd8739ae039)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: !open && keepMounted && (!transition || exited) ? "none" : null
            }, style),
            TransitionProps: transition ? {
                in: open,
                onEnter: handleEnter,
                onExited: handleExited
            } : null,
            children: children
        }))
    });
});
var $d9a06bdf697677bb$export$2e2bcd8739ae039 = $d9a06bdf697677bb$var$PopperUnstyled;



var $2HliV = parcelRequire("2HliV");



var $acw62 = parcelRequire("acw62");

var $1Ikg4 = parcelRequire("1Ikg4");
var $cpBQU = parcelRequire("cpBQU");

var $ayMG0 = parcelRequire("ayMG0");
const $d825775ecf14115c$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps"
];
const $d825775ecf14115c$var$PopperRoot = (0, $1Ikg4.default)((0, $d9a06bdf697677bb$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $d825775ecf14115c$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $2HliV.default)();
    const _useThemeProps = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiPopper"
    }), { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps } = _useThemeProps, other = (0, $1sz44.default)(_useThemeProps, $d825775ecf14115c$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d825775ecf14115c$var$PopperRoot, (0, $e8gS1.default)({
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, other, {
        ref: ref
    }));
});
var $d825775ecf14115c$export$2e2bcd8739ae039 = $d825775ecf14115c$var$Popper;








var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6bdb694b99441ccf$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)("MuiTooltip", slot);
}
const $6bdb694b99441ccf$var$tooltipClasses = (0, $beCSm.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $6bdb694b99441ccf$export$2e2bcd8739ae039 = $6bdb694b99441ccf$var$tooltipClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $0c12c30993373593$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $0c12c30993373593$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $0c12c30993373593$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $3AM7p.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6bdb694b99441ccf$export$837848f5f6cee923), classes);
};
const $0c12c30993373593$var$TooltipPopper = (0, $1Ikg4.default)((0, $d825775ecf14115c$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $e8gS1.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: (0, $e8gS1.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: (0, $e8gS1.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $0c12c30993373593$var$TooltipTooltip = (0, $1Ikg4.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $3AM7p.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $jgarO.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$0c12c30993373593$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $e8gS1.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $e8gS1.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $e8gS1.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $e8gS1.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $e8gS1.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $e8gS1.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $e8gS1.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $e8gS1.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $0c12c30993373593$var$TooltipArrow = (0, $1Ikg4.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $jgarO.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $0c12c30993373593$var$hystersisOpen = false;
let $0c12c30993373593$var$hystersisTimer = null;
function $0c12c30993373593$export$b9ee5a7ace0541f8() {
    $0c12c30993373593$var$hystersisOpen = false;
    clearTimeout($0c12c30993373593$var$hystersisTimer);
}
function $0c12c30993373593$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $0c12c30993373593$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: children, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $5a8449c70e836e71$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1sz44.default)(props, $0c12c30993373593$var$_excluded);
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $acw62.useRef();
    const enterTimer = $acw62.useRef();
    const leaveTimer = $acw62.useRef();
    const touchTimer = $acw62.useRef();
    const [openState, setOpenState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = $acw62.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($0c12c30993373593$var$hystersisTimer);
        $0c12c30993373593$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $52726edc538865d0$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($0c12c30993373593$var$hystersisTimer);
        $0c12c30993373593$var$hystersisTimer = setTimeout(()=>{
            $0c12c30993373593$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $0c12c30993373593$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $0c12c30993373593$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $e40fc9424df4cf9c$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const positionRef = $acw62.useRef({
        x: 0,
        y: 0
    });
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        positionRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $e8gS1.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $1SA7b.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $0c12c30993373593$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $0c12c30993373593$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $0c12c30993373593$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $0c12c30993373593$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $e8gS1.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $e8gS1.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $0c12c30993373593$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $0c12c30993373593$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $5a8449c70e836e71$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $0c12c30993373593$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $0c12c30993373593$var$TooltipArrow;
    const popperProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(PopperComponent, (0, $e8gS1.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $1SA7b.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(TransitionComponent, (0, $e8gS1.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(TooltipComponent, (0, $e8gS1.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $1SA7b.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(ArrowComponent, (0, $e8gS1.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $1SA7b.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $e8gS1.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $d825775ecf14115c$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: positionRef.current.y,
                            left: positionRef.current.x,
                            right: positionRef.current.x,
                            bottom: positionRef.current.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $e8gS1.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        "data-foo": "bar",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $e8gS1.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $e8gS1.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $0c12c30993373593$export$2e2bcd8739ae039 = $0c12c30993373593$var$Tooltip;



parcelRequire("acw62");
const $b32b693c08b8f30b$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        popper: {
            margin: "-30px 0 !important"
        }
    }));
const $b32b693c08b8f30b$var$FieldTooltip = ({ title: title, children: children, open: open })=>{
    const classes = $b32b693c08b8f30b$var$useStyles();
    if (!title) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
        PopperProps: {
            className: classes.popper
        },
        title: title,
        placement: "top",
        arrow: true,
        open: open,
        describeChild: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: children
        })
    });
};
var $b32b693c08b8f30b$export$2e2bcd8739ae039 = $b32b693c08b8f30b$var$FieldTooltip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * react-number-format - 4.9.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ 
var $acw62 = parcelRequire("acw62");
//     
// basic noop function
function $f9d8d8bd3b422c11$var$noop() {}
function $f9d8d8bd3b422c11$var$returnTrue() {
    return true;
}
function $f9d8d8bd3b422c11$var$charIsNumber(char) {
    return !!(char || "").match(/\d/);
}
function $f9d8d8bd3b422c11$var$isNil(val) {
    return val === null || val === undefined;
}
function $f9d8d8bd3b422c11$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function $f9d8d8bd3b422c11$var$getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case "lakh":
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case "wan":
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case "thousand":
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $f9d8d8bd3b422c11$var$applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = $f9d8d8bd3b422c11$var$getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, "$1" + thousandSeparator);
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function $f9d8d8bd3b422c11$var$splitDecimal(numStr, allowNegative) {
    if (allowNegative === void 0) allowNegative = true;
    var hasNagation = numStr[0] === "-";
    var addNegation = hasNagation && allowNegative;
    numStr = numStr.replace("-", "");
    var parts = numStr.split(".");
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || "";
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNagation: hasNagation,
        addNegation: addNegation
    };
}
function $f9d8d8bd3b422c11$var$fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === "-";
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split(".");
    var beforeDecimal = parts[0].replace(/^0+/, "") || "0";
    var afterDecimal = parts[1] || "";
    return "" + (isNegative ? "-" : "") + beforeDecimal + (afterDecimal ? "." + afterDecimal : "");
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function $f9d8d8bd3b422c11$var$limitToScale(numStr, scale, fixedDecimalScale) {
    var str = "";
    var filler = fixedDecimalScale ? "0" : "";
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
function $f9d8d8bd3b422c11$var$repeat(str, count) {
    return Array(count + 1).join(str);
}
function $f9d8d8bd3b422c11$var$toNumericString(num) {
    num += ""; // typecast number to string
    // store the sign and remove it from the number.
    var sign = num[0] === "-" ? "-" : "";
    if (sign) num = num.substring(1);
    // split the number into cofficient and exponent
    var ref = num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) return sign + coefficient;
    coefficient = coefficient.replace(".", "");
    /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */ var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = "0." + $f9d8d8bd3b422c11$var$repeat("0", Math.abs(decimalIndex)) + coefficient;
    else if (decimalIndex >= coffiecientLn) // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + $f9d8d8bd3b422c11$var$repeat("0", decimalIndex - coffiecientLn);
    else // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || "0") + "." + coefficient.substring(decimalIndex);
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function $f9d8d8bd3b422c11$var$roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        "",
        "-"
    ].indexOf(numStr) !== -1) return numStr;
    var shoudHaveDecimalSeparator = numStr.indexOf(".") !== -1 && scale;
    var ref = $f9d8d8bd3b422c11$var$splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNagation = ref.hasNagation;
    var floatValue = parseFloat("0." + (afterDecimal || "0"));
    var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split(".");
    var intPart = beforeDecimal.split("").reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = $f9d8d8bd3b422c11$var$limitToScale(roundedDecimalParts[1] || "", Math.min(scale, afterDecimal.length), fixedDecimalScale);
    var negation = hasNagation ? "-" : "";
    var decimalSeparator = shoudHaveDecimalSeparator ? "." : "";
    return "" + negation + intPart + decimalSeparator + decimalPart;
}
/** set the caret positon in an input field **/ function $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        if (el.createTextRange) {
            var range = el.createTextRange();
            range.move("character", caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/ function $f9d8d8bd3b422c11$var$findChangedIndex(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
    //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        start: i,
        end: prevLength - j
    };
}
/*
  Returns a number whose value is limited to the given range
*/ function $f9d8d8bd3b422c11$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $f9d8d8bd3b422c11$var$getCurrentCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
function $f9d8d8bd3b422c11$var$addInputMode(format) {
    return format || typeof navigator !== "undefined" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
//     
function $f9d8d8bd3b422c11$var$objectWithoutProperties(obj, exclude) {
    var target = {};
    for(var k in obj)if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
    return target;
}
var $f9d8d8bd3b422c11$var$defaultProps = {
    displayType: "input",
    decimalSeparator: ".",
    thousandsGroupStyle: "thousand",
    fixedDecimalScale: false,
    prefix: "",
    suffix: "",
    allowNegative: true,
    allowEmptyFormatting: false,
    allowLeadingZeros: false,
    isNumericString: false,
    type: "text",
    onValueChange: $f9d8d8bd3b422c11$var$noop,
    onChange: $f9d8d8bd3b422c11$var$noop,
    onKeyDown: $f9d8d8bd3b422c11$var$noop,
    onMouseUp: $f9d8d8bd3b422c11$var$noop,
    onFocus: $f9d8d8bd3b422c11$var$noop,
    onBlur: $f9d8d8bd3b422c11$var$noop,
    isAllowed: $f9d8d8bd3b422c11$var$returnTrue
};
var $f9d8d8bd3b422c11$var$NumberFormat = /*@__PURE__*/ function(superclass) {
    function NumberFormat(props) {
        superclass.call(this, props);
        var defaultValue = props.defaultValue;
        //validate props
        this.validateProps();
        var formattedValue = this.formatValueProp(defaultValue);
        this.state = {
            value: formattedValue,
            numAsString: this.removeFormatting(formattedValue),
            mounted: false
        };
        this.selectionBeforeInput = {
            selectionStart: 0,
            selectionEnd: 0
        };
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }
    if (superclass) NumberFormat.__proto__ = superclass;
    NumberFormat.prototype = Object.create(superclass && superclass.prototype);
    NumberFormat.prototype.constructor = NumberFormat;
    NumberFormat.prototype.componentDidMount = function componentDidMount() {
        // set mounted state
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
            mounted: true
        });
    };
    NumberFormat.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        this.updateValueIfRequired(prevProps);
    };
    NumberFormat.prototype.componentWillUnmount = function componentWillUnmount() {
        clearTimeout(this.focusTimeout);
        clearTimeout(this.caretPositionTimeout);
    };
    NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired(prevProps) {
        var ref = this;
        var props = ref.props;
        var state = ref.state;
        var focusedElm = ref.focusedElm;
        var stateValue = state.value;
        var lastNumStr = state.numAsString;
        if (lastNumStr === void 0) lastNumStr = "";
        // If only state changed no need to do any thing
        if (prevProps !== props) {
            //validate props
            this.validateProps();
            var lastValueWithNewFormat = this.formatNumString(lastNumStr);
            var formattedValue = $f9d8d8bd3b422c11$var$isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
            var numAsString = this.removeFormatting(formattedValue);
            var floatValue = parseFloat(numAsString);
            var lastFloatValue = parseFloat(lastNumStr);
            if ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || //can also set state when float value is same and the format props changes
            lastValueWithNewFormat !== stateValue || //set state always when not in focus and formatted value is changed
            focusedElm === null && formattedValue !== stateValue) this.updateValue({
                formattedValue: formattedValue,
                numAsString: numAsString,
                input: focusedElm,
                source: "prop",
                event: null
            });
        }
    };
    /** Misc methods **/ NumberFormat.prototype.getFloatString = function getFloatString(num) {
        if (num === void 0) num = "";
        var ref = this.props;
        var decimalScale = ref.decimalScale;
        var ref$1 = this.getSeparators();
        var decimalSeparator = ref$1.decimalSeparator;
        var numRegex = this.getNumberRegex(true);
        //remove negation for regex check
        var hasNegation = num[0] === "-";
        if (hasNegation) num = num.replace("-", "");
        //if decimal scale is zero remove decimal and number after decimalSeparator
        if (decimalSeparator && decimalScale === 0) num = num.split(decimalSeparator)[0];
        num = (num.match(numRegex) || []).join("").replace(decimalSeparator, ".");
        //remove extra decimals
        var firstDecimalIndex = num.indexOf(".");
        if (firstDecimalIndex !== -1) num = num.substring(0, firstDecimalIndex) + "." + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp($f9d8d8bd3b422c11$var$escapeRegExp(decimalSeparator), "g"), "");
        //add negation back
        if (hasNegation) num = "-" + num;
        return num;
    };
    //returned regex assumes decimalSeparator is as per prop
    NumberFormat.prototype.getNumberRegex = function getNumberRegex(g, ignoreDecimalSeparator) {
        var ref = this.props;
        var format = ref.format;
        var decimalScale = ref.decimalScale;
        var customNumerals = ref.customNumerals;
        var ref$1 = this.getSeparators();
        var decimalSeparator = ref$1.decimalSeparator;
        return new RegExp("[0-9" + (customNumerals ? customNumerals.join("") : "") + "]" + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? "|" + $f9d8d8bd3b422c11$var$escapeRegExp(decimalSeparator) : ""), g ? "g" : undefined);
    };
    NumberFormat.prototype.getSeparators = function getSeparators() {
        var ref = this.props;
        var decimalSeparator = ref.decimalSeparator;
        var ref$1 = this.props;
        var thousandSeparator = ref$1.thousandSeparator;
        var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
        if (thousandSeparator === true) thousandSeparator = ",";
        if (!allowedDecimalSeparators) allowedDecimalSeparators = [
            decimalSeparator,
            "."
        ];
        return {
            decimalSeparator: decimalSeparator,
            thousandSeparator: thousandSeparator,
            allowedDecimalSeparators: allowedDecimalSeparators
        };
    };
    NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex(index) {
        var ref = this.props;
        var mask = ref.mask;
        if (mask === void 0) mask = " ";
        if (typeof mask === "string") return mask;
        return mask[index] || " ";
    };
    NumberFormat.prototype.getValueObject = function getValueObject(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue
        };
    };
    NumberFormat.prototype.validateProps = function validateProps() {
        var ref = this.props;
        var mask = ref.mask;
        //validate decimalSeparator and thousandSeparator
        var ref$1 = this.getSeparators();
        var decimalSeparator = ref$1.decimalSeparator;
        var thousandSeparator = ref$1.thousandSeparator;
        if (decimalSeparator === thousandSeparator) throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + " (default value for decimalSeparator is .)\n       ");
        //validate mask
        if (mask) {
            var maskAsStr = mask === "string" ? mask : mask.toString();
            if (maskAsStr.match(/\d/g)) throw new Error("\n          Mask " + mask + " should not contain numeric character;\n        ");
        }
    };
    /** Misc methods end **/ /** caret specific methods **/ NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition(el, caretPos, currentValue) {
        /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */ $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        this.caretPositionTimeout = setTimeout(function() {
            if (el.value === currentValue) $f9d8d8bd3b422c11$var$setCaretPosition(el, caretPos);
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */ NumberFormat.prototype.correctCaretPosition = function correctCaretPosition(value, caretPos, direction) {
        var ref = this.props;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        var format = ref.format;
        //if value is empty return 0
        if (value === "") return 0;
        //caret position should be between 0 and value length
        caretPos = $f9d8d8bd3b422c11$var$clamp(caretPos, 0, value.length);
        //in case of format as number limit between prefix and suffix
        if (!format) {
            var hasNegation = value[0] === "-";
            return $f9d8d8bd3b422c11$var$clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
        }
        //in case if custom format method don't do anything
        if (typeof format === "function") return caretPos;
        /* in case format is string find the closest # position from the caret position */ //in case the caretPos have input value on it don't do anything
        if (format[caretPos] === "#" && $f9d8d8bd3b422c11$var$charIsNumber(value[caretPos])) return caretPos;
        //if caretPos is just after input value don't do anything
        if (format[caretPos - 1] === "#" && $f9d8d8bd3b422c11$var$charIsNumber(value[caretPos - 1])) return caretPos;
        //find the nearest caret position
        var firstHashPosition = format.indexOf("#");
        var lastHashPosition = format.lastIndexOf("#");
        //limit the cursor between the first # position and the last # position
        caretPos = $f9d8d8bd3b422c11$var$clamp(caretPos, firstHashPosition, lastHashPosition + 1);
        var nextPos = format.substring(caretPos, format.length).indexOf("#");
        var caretLeftBound = caretPos;
        var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);
        //get the position where the last number is present
        while(caretLeftBound > firstHashPosition && (format[caretLeftBound] !== "#" || !$f9d8d8bd3b422c11$var$charIsNumber(value[caretLeftBound])))caretLeftBound -= 1;
        var goToLeft = !$f9d8d8bd3b422c11$var$charIsNumber(value[caretRightBound]) || direction === "left" && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;
        if (goToLeft) //check if number should be taken after the bound or after it
        //if number preceding a valid number keep it after
        return $f9d8d8bd3b422c11$var$charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
        return caretRightBound;
    };
    NumberFormat.prototype.getCaretPosition = function getCaretPosition(inputValue, formattedValue, caretPos) {
        var ref = this.props;
        var format = ref.format;
        var stateValue = this.state.value;
        var numRegex = this.getNumberRegex(true);
        var inputNumber = (inputValue.match(numRegex) || []).join("");
        var formattedNumber = (formattedValue.match(numRegex) || []).join("");
        var j, i;
        j = 0;
        for(i = 0; i < caretPos; i++){
            var currentInputChar = inputValue[i] || "";
            var currentFormatChar = formattedValue[j] || "";
            //no need to increase new cursor position if formatted value does not have those characters
            //case inputValue = 1a23 and formattedValue =  123
            if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue;
            //When we are striping out leading zeros maintain the new cursor position
            //Case inputValue = 00023 and formattedValue = 23;
            if (currentInputChar === "0" && currentFormatChar.match(numRegex) && currentFormatChar !== "0" && inputNumber.length !== formattedNumber.length) continue;
            //we are not using currentFormatChar because j can change here
            while(currentInputChar !== formattedValue[j] && j < formattedValue.length)j++;
            j++;
        }
        if (typeof format === "string" && !stateValue) //set it to the maximum value so it goes after the last number
        j = formattedValue.length;
        //correct caret position if its outside of editable area
        j = this.correctCaretPosition(formattedValue, j);
        return j;
    };
    /** caret specific methods ends **/ /** methods to remove formattting **/ NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix(val) {
        var ref = this.props;
        var format = ref.format;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        //remove prefix and suffix
        if (!format && val) {
            var isNegative = val[0] === "-";
            //remove negation sign
            if (isNegative) val = val.substring(1, val.length);
            //remove prefix
            val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;
            //remove suffix
            var suffixLastIndex = val.lastIndexOf(suffix);
            val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;
            //add negation sign back
            if (isNegative) val = "-" + val;
        }
        return val;
    };
    NumberFormat.prototype.removePatternFormatting = function removePatternFormatting(val) {
        var ref = this.props;
        var format = ref.format;
        var formatArray = format.split("#").filter(function(str) {
            return str !== "";
        });
        var start = 0;
        var numStr = "";
        for(var i = 0, ln = formatArray.length; i <= ln; i++){
            var part = formatArray[i] || "";
            //if i is the last fragment take the index of end of the value
            //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
            var index = i === ln ? val.length : val.indexOf(part, start);
            /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */ if (index === -1) {
                numStr = val;
                break;
            } else {
                numStr += val.substring(start, index);
                start = index + part.length;
            }
        }
        return (numStr.match(this.getNumberRegex(true)) || []).join("");
    };
    NumberFormat.prototype.removeFormatting = function removeFormatting(val) {
        var ref = this.props;
        var format = ref.format;
        var removeFormatting = ref.removeFormatting;
        if (!val) return val;
        if (!format) {
            val = this.removePrefixAndSuffix(val);
            val = this.getFloatString(val);
        } else if (typeof format === "string") val = this.removePatternFormatting(val);
        else if (typeof removeFormatting === "function") //condition need to be handled if format method is provide,
        val = removeFormatting(val);
        else val = (val.match(this.getNumberRegex(true)) || []).join("");
        return val;
    };
    /** methods to remove formattting end **/ /*** format specific methods start ***/ /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */ NumberFormat.prototype.formatWithPattern = function formatWithPattern(numStr) {
        var ref = this.props;
        var format = ref.format;
        var hashCount = 0;
        var formattedNumberAry = format.split("");
        for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === "#") {
            formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
            hashCount += 1;
        }
        return formattedNumberAry.join("");
    };
    /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */ NumberFormat.prototype.formatAsNumber = function formatAsNumber(numStr) {
        var ref = this.props;
        var decimalScale = ref.decimalScale;
        var fixedDecimalScale = ref.fixedDecimalScale;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        var allowNegative = ref.allowNegative;
        var thousandsGroupStyle = ref.thousandsGroupStyle;
        var ref$1 = this.getSeparators();
        var thousandSeparator = ref$1.thousandSeparator;
        var decimalSeparator = ref$1.decimalSeparator;
        var hasDecimalSeparator = numStr.indexOf(".") !== -1 || decimalScale && fixedDecimalScale;
        var ref$2 = $f9d8d8bd3b422c11$var$splitDecimal(numStr, allowNegative);
        var beforeDecimal = ref$2.beforeDecimal;
        var afterDecimal = ref$2.afterDecimal;
        var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
        //apply decimal precision if its defined
        if (decimalScale !== undefined) afterDecimal = $f9d8d8bd3b422c11$var$limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
        if (thousandSeparator) beforeDecimal = $f9d8d8bd3b422c11$var$applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
        //add prefix and suffix
        if (prefix) beforeDecimal = prefix + beforeDecimal;
        if (suffix) afterDecimal = afterDecimal + suffix;
        //restore negation sign
        if (addNegation) beforeDecimal = "-" + beforeDecimal;
        numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || "") + afterDecimal;
        return numStr;
    };
    NumberFormat.prototype.formatNumString = function formatNumString(numStr) {
        if (numStr === void 0) numStr = "";
        var ref = this.props;
        var format = ref.format;
        var allowEmptyFormatting = ref.allowEmptyFormatting;
        var customNumerals = ref.customNumerals;
        var formattedValue = numStr;
        if (customNumerals && customNumerals.length === 10) {
            var customNumeralRegex = new RegExp("[" + customNumerals.join("") + "]", "g");
            formattedValue = numStr.replace(customNumeralRegex, function(digit) {
                return customNumerals.indexOf(digit).toString();
            });
        }
        if (numStr === "" && !allowEmptyFormatting) formattedValue = "";
        else if (numStr === "-" && !format) formattedValue = "-";
        else if (typeof format === "string") formattedValue = this.formatWithPattern(formattedValue);
        else if (typeof format === "function") formattedValue = format(formattedValue);
        else formattedValue = this.formatAsNumber(formattedValue);
        return formattedValue;
    };
    NumberFormat.prototype.formatValueProp = function formatValueProp(defaultValue) {
        var ref = this.props;
        var format = ref.format;
        var decimalScale = ref.decimalScale;
        var fixedDecimalScale = ref.fixedDecimalScale;
        var allowEmptyFormatting = ref.allowEmptyFormatting;
        var ref$1 = this.props;
        var value = ref$1.value;
        var isNumericString = ref$1.isNumericString;
        // if value is undefined or null, use defaultValue instead
        value = $f9d8d8bd3b422c11$var$isNil(value) ? defaultValue : value;
        var isNonNumericFalsy = !value && value !== 0;
        if (isNonNumericFalsy && allowEmptyFormatting) value = "";
        // if value is not defined return empty string
        if (isNonNumericFalsy && !allowEmptyFormatting) return "";
        if (typeof value === "number") {
            value = $f9d8d8bd3b422c11$var$toNumericString(value);
            isNumericString = true;
        }
        //change infinity value to empty string
        if (value === "Infinity" && isNumericString) value = "";
        //round the number based on decimalScale
        //format only if non formatted value is provided
        if (isNumericString && !format && typeof decimalScale === "number") value = $f9d8d8bd3b422c11$var$roundToPrecision(value, decimalScale, fixedDecimalScale);
        var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
        return formattedValue;
    };
    NumberFormat.prototype.formatNegation = function formatNegation(value) {
        if (value === void 0) value = "";
        var ref = this.props;
        var allowNegative = ref.allowNegative;
        var negationRegex = new RegExp("(-)");
        var doubleNegationRegex = new RegExp("(-)(.)*(-)");
        // Check number has '-' value
        var hasNegation = negationRegex.test(value);
        // Check number has 2 or more '-' values
        var removeNegation = doubleNegationRegex.test(value);
        //remove negation
        value = value.replace(/-/g, "");
        if (hasNegation && !removeNegation && allowNegative) value = "-" + value;
        return value;
    };
    NumberFormat.prototype.formatInput = function formatInput(value) {
        if (value === void 0) value = "";
        var ref = this.props;
        var format = ref.format;
        //format negation only if we are formatting as number
        if (!format) {
            value = this.removePrefixAndSuffix(value);
            value = this.formatNegation(value);
        }
        //remove formatting from number
        value = this.removeFormatting(value);
        return this.formatNumString(value);
    };
    /*** format specific methods end ***/ NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat(caretPos, value) {
        var ref = this.props;
        var format = ref.format;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        var decimalScale = ref.decimalScale;
        var fixedDecimalScale = ref.fixedDecimalScale;
        var ref$1 = this.getSeparators();
        var decimalSeparator = ref$1.decimalSeparator;
        //check within format pattern
        if (typeof format === "string" && format[caretPos] !== "#") return true;
        //check in number format
        if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) return true;
        return false;
    };
    /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/ NumberFormat.prototype.correctInputValue = function correctInputValue(caretPos, lastValue, value) {
        var this$1 = this;
        var ref = this.props;
        var format = ref.format;
        var allowNegative = ref.allowNegative;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        var decimalScale = ref.decimalScale;
        var ref$1 = this.getSeparators();
        var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
        var decimalSeparator = ref$1.decimalSeparator;
        var lastNumStr = this.state.numAsString || "";
        var ref$2 = this.selectionBeforeInput;
        var selectionStart = ref$2.selectionStart;
        var selectionEnd = ref$2.selectionEnd;
        var ref$3 = $f9d8d8bd3b422c11$var$findChangedIndex(lastValue, value);
        var start = ref$3.start;
        var end = ref$3.end;
        /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (!format && start === end && allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1) {
            var separator = decimalScale === 0 ? "" : decimalSeparator;
            return value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length);
        }
        var leftBound = !!format ? 0 : prefix.length;
        var rightBound = lastValue.length - (!!format ? 0 : suffix.length);
        if (// don't do anything if something got added
        value.length > lastValue.length || // or if the new value is an empty string
        !value.length || // or if nothing has changed, in which case start will be same as end
        start === end || // or in case if whole input is selected and new value is typed
        selectionStart === 0 && selectionEnd === lastValue.length || // or in case if the whole content is replaced by browser, example (autocomplete)
        start === 0 && end === lastValue.length || // or if charcters between prefix and suffix is selected.
        // For numeric inputs we apply the format so, prefix and suffix can be ignored
        selectionStart === leftBound && selectionEnd === rightBound) return value;
        // check whether the deleted portion has a character that is part of a format
        var deletedValues = lastValue.substr(start, end - start);
        var formatGotDeleted = !![].concat(deletedValues).find(function(deletedVal, idx) {
            return this$1.isCharacterAFormat(idx + start, lastValue);
        });
        // if it has, only remove characters that are not part of the format
        if (formatGotDeleted) {
            var deletedValuePortion = lastValue.substr(start);
            var recordIndexOfFormatCharacters = {};
            var resolvedPortion = [];
            [].concat(deletedValuePortion).forEach(function(currentPortion, idx) {
                if (this$1.isCharacterAFormat(idx + start, lastValue)) recordIndexOfFormatCharacters[idx] = currentPortion;
                else if (idx > deletedValues.length - 1) resolvedPortion.push(currentPortion);
            });
            Object.keys(recordIndexOfFormatCharacters).forEach(function(idx) {
                if (resolvedPortion.length > idx) resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
                else resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
            });
            value = lastValue.substr(0, start) + resolvedPortion.join("");
        }
        //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
        //clear all numbers in such case while keeping the - sign
        if (!format) {
            var numericString = this.removeFormatting(value);
            var ref$4 = $f9d8d8bd3b422c11$var$splitDecimal(numericString, allowNegative);
            var beforeDecimal = ref$4.beforeDecimal;
            var afterDecimal = ref$4.afterDecimal;
            var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const
            //clear only if something got deleted
            var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
            if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === "" && !parseFloat(afterDecimal)) return addNegation ? "-" : "";
        }
        return value;
    };
    /** Update value and caret position */ NumberFormat.prototype.updateValue = function updateValue(params) {
        var formattedValue = params.formattedValue;
        var input = params.input;
        var setCaretPosition = params.setCaretPosition;
        if (setCaretPosition === void 0) setCaretPosition = true;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos = params.caretPos;
        var ref = this.props;
        var onValueChange = ref.onValueChange;
        var ref$1 = this.state;
        var lastValue = ref$1.value;
        if (input) {
            //calculate caret position if not defined
            if (caretPos === undefined && setCaretPosition) {
                var inputValue = params.inputValue || input.value;
                var currentCaretPosition = $f9d8d8bd3b422c11$var$getCurrentCaretPosition(input);
                /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */ input.value = formattedValue;
                //get the caret position
                caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
            }
            /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */ input.value = formattedValue;
            //set caret position, and value imperatively when element is provided
            if (setCaretPosition) //set caret position
            this.setPatchedCaretPosition(input, caretPos, formattedValue);
        }
        //calculate numeric string if not passed
        if (numAsString === undefined) numAsString = this.removeFormatting(formattedValue);
        //update state if value is changed
        if (formattedValue !== lastValue) {
            this.setState({
                value: formattedValue,
                numAsString: numAsString
            });
            // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
            onValueChange(this.getValueObject(formattedValue, numAsString), {
                event: event,
                source: source
            });
        }
    };
    NumberFormat.prototype.onChange = function onChange(e) {
        var el = e.target;
        var inputValue = el.value;
        var ref = this;
        var state = ref.state;
        var props = ref.props;
        var isAllowed = props.isAllowed;
        var lastValue = state.value || "";
        var currentCaretPosition = $f9d8d8bd3b422c11$var$getCurrentCaretPosition(el);
        inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
        var formattedValue = this.formatInput(inputValue) || "";
        var numAsString = this.removeFormatting(formattedValue);
        var valueObj = this.getValueObject(formattedValue, numAsString);
        var isChangeAllowed = isAllowed(valueObj);
        if (!isChangeAllowed) formattedValue = lastValue;
        this.updateValue({
            formattedValue: formattedValue,
            numAsString: numAsString,
            inputValue: inputValue,
            input: el,
            event: e,
            source: "event"
        });
        if (isChangeAllowed) props.onChange(e);
    };
    NumberFormat.prototype.onBlur = function onBlur(e) {
        var ref = this;
        var props = ref.props;
        var state = ref.state;
        var format = props.format;
        var onBlur = props.onBlur;
        var allowLeadingZeros = props.allowLeadingZeros;
        var numAsString = state.numAsString;
        var lastValue = state.value;
        this.focusedElm = null;
        clearTimeout(this.focusTimeout);
        clearTimeout(this.caretPositionTimeout);
        if (!format) {
            // if the numAsString is not a valid number reset it to empty
            if (isNaN(parseFloat(numAsString))) numAsString = "";
            if (!allowLeadingZeros) numAsString = $f9d8d8bd3b422c11$var$fixLeadingZero(numAsString);
            var formattedValue = this.formatNumString(numAsString);
            //change the state
            if (formattedValue !== lastValue) {
                // the event needs to be persisted because its properties can be accessed in an asynchronous way
                this.updateValue({
                    formattedValue: formattedValue,
                    numAsString: numAsString,
                    input: e.target,
                    setCaretPosition: false,
                    event: e,
                    source: "event"
                });
                onBlur(e);
                return;
            }
        }
        onBlur(e);
    };
    NumberFormat.prototype.onKeyDown = function onKeyDown(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = "";
        var expectedCaretPosition;
        var ref = this.props;
        var decimalScale = ref.decimalScale;
        var fixedDecimalScale = ref.fixedDecimalScale;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        var format = ref.format;
        var onKeyDown = ref.onKeyDown;
        var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
        var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
        var negativeRegex = new RegExp("-");
        var isPatternFormat = typeof format === "string";
        this.selectionBeforeInput = {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        };
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === "ArrowLeft" || key === "Backspace") expectedCaretPosition = selectionStart - 1;
        else if (key === "ArrowRight") expectedCaretPosition = selectionStart + 1;
        else if (key === "Delete") expectedCaretPosition = selectionStart;
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        //also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        var leftBound = isPatternFormat ? format.indexOf("#") : prefix.length;
        var rightBound = isPatternFormat ? format.lastIndexOf("#") + 1 : value.length - suffix.length;
        if (key === "ArrowLeft" || key === "ArrowRight") {
            var direction = key === "ArrowLeft" ? "left" : "right";
            newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
        } else if (key === "Delete" && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) while(!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound)newCaretPosition++;
        else if (key === "Backspace" && !numRegex.test(value[expectedCaretPosition])) {
            /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */ if (selectionStart <= leftBound + 1 && value[0] === "-" && typeof format === "undefined") {
                var newValue = value.substring(1);
                this.updateValue({
                    formattedValue: newValue,
                    caretPos: newCaretPosition,
                    input: el,
                    event: e,
                    source: "event"
                });
            } else if (!negativeRegex.test(value[expectedCaretPosition])) {
                while(!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound)newCaretPosition--;
                newCaretPosition = this.correctCaretPosition(value, newCaretPosition, "left");
            }
        }
        if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
            e.preventDefault();
            this.setPatchedCaretPosition(el, newCaretPosition, value);
        }
        /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */ if (e.isUnitTestRun) this.setPatchedCaretPosition(el, newCaretPosition, value);
        onKeyDown(e);
    };
    /** required to handle the caret position when click anywhere within the input **/ NumberFormat.prototype.onMouseUp = function onMouseUp(e) {
        var el = e.target;
        /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */ var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = "";
        if (selectionStart === selectionEnd) {
            var caretPosition = this.correctCaretPosition(value, selectionStart);
            if (caretPosition !== selectionStart) this.setPatchedCaretPosition(el, caretPosition, value);
        }
        this.props.onMouseUp(e);
    };
    NumberFormat.prototype.onFocus = function onFocus(e) {
        var this$1 = this;
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        e.persist();
        this.focusedElm = e.target;
        this.focusTimeout = setTimeout(function() {
            var el = e.target;
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = "";
            var caretPosition = this$1.correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) this$1.setPatchedCaretPosition(el, caretPosition, value);
            this$1.props.onFocus(e);
        }, 0);
    };
    NumberFormat.prototype.render = function render() {
        var ref = this.props;
        var type = ref.type;
        var displayType = ref.displayType;
        var customInput = ref.customInput;
        var renderText = ref.renderText;
        var getInputRef = ref.getInputRef;
        var format = ref.format;
        var thousandSeparator = ref.thousandSeparator;
        var decimalSeparator = ref.decimalSeparator;
        var allowedDecimalSeparators = ref.allowedDecimalSeparators;
        var thousandsGroupStyle = ref.thousandsGroupStyle;
        var decimalScale = ref.decimalScale;
        var fixedDecimalScale = ref.fixedDecimalScale;
        var prefix = ref.prefix;
        var suffix = ref.suffix;
        var removeFormatting = ref.removeFormatting;
        var mask = ref.mask;
        var defaultValue = ref.defaultValue;
        var isNumericString = ref.isNumericString;
        var allowNegative = ref.allowNegative;
        var allowEmptyFormatting = ref.allowEmptyFormatting;
        var allowLeadingZeros = ref.allowLeadingZeros;
        var onValueChange = ref.onValueChange;
        var isAllowed = ref.isAllowed;
        var customNumerals = ref.customNumerals;
        var onChange = ref.onChange;
        var onKeyDown = ref.onKeyDown;
        var onMouseUp = ref.onMouseUp;
        var onFocus = ref.onFocus;
        var onBlur = ref.onBlur;
        var propValue = ref.value;
        var rest = $f9d8d8bd3b422c11$var$objectWithoutProperties(ref, [
            "type",
            "displayType",
            "customInput",
            "renderText",
            "getInputRef",
            "format",
            "thousandSeparator",
            "decimalSeparator",
            "allowedDecimalSeparators",
            "thousandsGroupStyle",
            "decimalScale",
            "fixedDecimalScale",
            "prefix",
            "suffix",
            "removeFormatting",
            "mask",
            "defaultValue",
            "isNumericString",
            "allowNegative",
            "allowEmptyFormatting",
            "allowLeadingZeros",
            "onValueChange",
            "isAllowed",
            "customNumerals",
            "onChange",
            "onKeyDown",
            "onMouseUp",
            "onFocus",
            "onBlur",
            "value"
        ]);
        var otherProps = rest;
        var ref$1 = this.state;
        var value = ref$1.value;
        var mounted = ref$1.mounted;
        // add input mode on element based on format prop and device once the component is mounted
        var inputMode = mounted && $f9d8d8bd3b422c11$var$addInputMode(format) ? "numeric" : undefined;
        var inputProps = Object.assign({
            inputMode: inputMode
        }, otherProps, {
            type: type,
            value: value,
            onChange: this.onChange,
            onKeyDown: this.onKeyDown,
            onMouseUp: this.onMouseUp,
            onFocus: this.onFocus,
            onBlur: this.onBlur
        });
        if (displayType === "text") return renderText ? renderText(value, otherProps) || null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, otherProps, {
            ref: getInputRef
        }), value);
        else if (customInput) {
            var CustomInput = customInput;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomInput, Object.assign({}, inputProps, {
                ref: getInputRef
            }));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({}, inputProps, {
            ref: getInputRef
        }));
    };
    return NumberFormat;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$f9d8d8bd3b422c11$var$NumberFormat.defaultProps = $f9d8d8bd3b422c11$var$defaultProps;
var $f9d8d8bd3b422c11$export$2e2bcd8739ae039 = $f9d8d8bd3b422c11$var$NumberFormat;


/**
 * Pick correct value, from incoming values.
 *
 * If value is a number, we can use `values.floatValue`.
 *
 * But if the `floatValue` is `undefined`, because it was e.g. cleared,
 * we need to pass empty string from `values.formattedValue`,
 * so that field stays controlled, and `react-hook-form` doesn't pass it default value.
 *
 * @see https://github.com/s-yadav/react-number-format/issues/528#issuecomment-825787850
 * @param values
 */ const $aac2891bf2338b54$var$pickCorrectValue = (values)=>values.floatValue !== undefined ? values.floatValue : values.formattedValue;
var // eslint-disable-next-line react/display-name
$aac2891bf2338b54$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { onChange: onChange, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9d8d8bd3b422c11$export$2e2bcd8739ae039), {
        getInputRef: ref,
        onValueChange: (values)=>{
            onChange({
                target: {
                    name: props.name,
                    value: $aac2891bf2338b54$var$pickCorrectValue(values)
                }
            });
        },
        maxLength: props.maxLength || 8,
        decimalScale: props.decimalScale || 0,
        decimalSeparator: ",",
        thousandSeparator: " ",
        ...rest
    });
});


const $5a65944773ef4e18$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>(0, $b9c362fbce901abe$export$2e2bcd8739ae039)({
        input: {
            ["@media print"]: {
                borderBottom: "solid !important"
            }
        }
    }));
/**
 * Pick a correct value based on props, to be given to `react-number-format`.
 *
 * @see resetting value in react-number-format happens by passing empty string (`""`) - https://github.com/s-yadav/react-number-format/issues/528#issuecomment-825787850
 * @param props.value - value
 * @param props.allowZeroForInputValue - is 0 allowed value, or should it clear field
 * @returns `values.floatValue` or `""` for missing values
 */ const $5a65944773ef4e18$var$pickValueForInputComponent = ({ value: value, allowZeroForInputValue: allowZeroForInputValue = true })=>{
    if (value === 0 && allowZeroForInputValue) return 0;
    // Resetting a value happens by giving `NumberFormatter` an empty string (`""`).
    // See link to issue #528 in jsdoc.
    if (!value) return "";
    return value;
};
function $5a65944773ef4e18$export$2e2bcd8739ae039({ allowZeroForInputValue: allowZeroForInputValue, ...props }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $5a65944773ef4e18$var$useStyles();
    const { formState: formState } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b32b693c08b8f30b$export$2e2bcd8739ae039), {
        title: props.tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
            fullWidth: props.fullWidth,
            error: !!(0, $0d70f179cf56e662$export$3988ae62b71be9a3)(formState.errors, props.name),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                ...props,
                color: props.color || "primary",
                variant: props.variant || "standard",
                className: classes.input,
                InputProps: {
                    ...props.InputProps,
                    value: $5a65944773ef4e18$var$pickValueForInputComponent({
                        ...props,
                        allowZeroForInputValue: allowZeroForInputValue
                    }),
                    inputComponent: (0, $aac2891bf2338b54$export$2e2bcd8739ae039)
                },
                error: !!(0, $0d70f179cf56e662$export$3988ae62b71be9a3)(formState.errors, props.name),
                helperText: t((0, $0d70f179cf56e662$export$3988ae62b71be9a3)(formState.errors, props.name)?.message)
            })
        })
    });
}


function $4f6c83beccc29d67$export$c143f692a8a0ec42({ name: name, label: label, tProps: tProps = {}, allowNegative: allowNegative = false, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a65944773ef4e18$export$2e2bcd8739ae039), {
        name: name,
        variant: "standard",
        label: t(`fields.${label}`, tProps),
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                position: "end",
                children: t("common.ha")
            }),
            inputProps: {
                maxLength: 8,
                allowNegative: allowNegative,
                decimalScale: 2,
                decimalSeparator: ","
            }
        },
        ...rest
    });
}
function $4f6c83beccc29d67$export$a984fed0d3d78c4f({ name: name, label: label, tProps: tProps = {}, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a65944773ef4e18$export$2e2bcd8739ae039), {
        variant: "standard",
        name: name,
        label: t(`fields.${label}`, tProps),
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                position: "end",
                children: t("common.kg")
            }),
            inputProps: {
                maxLength: 9,
                allowNegative: false,
                decimalSeparator: ","
            }
        },
        ...rest
    });
}
function $4f6c83beccc29d67$export$feca3be394453c29({ name: name, label: label, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a65944773ef4e18$export$2e2bcd8739ae039), {
        InputLabelProps: {
            shrink: true
        },
        variant: "standard",
        name: name,
        label: t(`fields.${label}`),
        InputProps: {
            readOnly: true,
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                position: "end",
                children: t("common.kg-ha")
            }),
            inputProps: {
                maxLength: 10,
                allowNegative: false,
                decimalScale: 2,
                decimalSeparator: ","
            }
        },
        ...rest
    });
}
function $4f6c83beccc29d67$export$12084818538df79c({ name: name, label: label, InputProps: InputProps, tProps: tProps = {}, ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a65944773ef4e18$export$2e2bcd8739ae039), {
        variant: "standard",
        name: name,
        label: t(`fields.${label}`, tProps),
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                position: "end",
                children: "%"
            }),
            inputProps: {
                maxLength: 5,
                decimalScale: rest.decimalScale || 2,
                allowNegative: false,
                decimalSeparator: ",",
                isAllowed: ({ floatValue: floatValue })=>{
                    if (floatValue === undefined || isNaN(floatValue)) return true;
                    return floatValue >= 0 && floatValue <= 100;
                }
            },
            ...InputProps
        },
        ...rest
    });
}
function $4f6c83beccc29d67$export$8603e28d2ac53e0e({ ...rest }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f6c83beccc29d67$export$feca3be394453c29, {
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                position: "end",
                children: t("common.kg-ha")
            }),
            inputProps: {
                readOnly: true,
                maxLength: 10,
                allowNegative: false,
                decimalScale: 0,
                decimalSeparator: ","
            }
        },
        ...rest
    });
}
const $4f6c83beccc29d67$export$de268ca9ecbe6435 = {
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Viljelyala]: {
        label: "fields.Viljelyala",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKuivattavaVilja]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräVihantavilja]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoVihantavilja]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineVihantavilja]: {
        label: "fields.KuivaaineProsentti",
        unit: "%"
    },
    [(0, $8600e8026484e4e0$export$833b3e5a19fb8939).VarastoarvioTammikuu]: {
        label: "fields.VarastoarvoTammikuuArvioYhteenveto",
        unit: "common.kg"
    },
    [(0, $8600e8026484e4e0$export$833b3e5a19fb8939).VarastoarvoHeinäkuu]: {
        label: "fields.VarastoarvoHein\xe4kuuYhteenveto",
        unit: "common.kg"
    },
    [(0, $87f876476293d35b$export$833b3e5a19fb8939).Satotaso]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $87f876476293d35b$export$833b3e5a19fb8939).Istutusala]: {
        label: "fields.Istutusala",
        unit: "common.ha"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoTuore]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoÖljykasvi]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $af1189b7d638610c$export$833b3e5a19fb8939).Kylvöala]: {
        label: "fields.Kylvoala",
        unit: "common.ha"
    },
    [(0, $af1189b7d638610c$export$833b3e5a19fb8939).Suorakylvöala]: {
        label: "fields.Suorakylvoala",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Kuivaheinä]: {
        label: "fields.Kuivahein\xe4",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Niittorehu]: {
        label: "fields.Niittorehu",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Säilörehu]: {
        label: "fields.S\xe4il\xf6rehu",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattu]: {
        label: "fields.S\xe4il\xf6rehuEsikuivattu",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKuivaaineProsentti]: {
        label: "fields.KuivaaineProsentti",
        unit: "%"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg]: {
        label: "fields.Kuivahein\xe4",
        unit: "common.kg"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg]: {
        label: "fields.S\xe4il\xf6rehu",
        unit: "common.kg"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg]: {
        label: "fields.S\xe4il\xf6rehuEsikuivattu",
        unit: "common.kg"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg]: {
        label: "fields.Niittorehu",
        unit: "common.kg"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuKuivaaineProsentti]: {
        label: "fields.KuivaaineProsentti",
        unit: "%"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuKuivaaineProsentti]: {
        label: "fields.KuivaaineProsentti",
        unit: "%"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuuala]: {
        label: "fields.RehunurmialaYhteens\xe4",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjattuala]: {
        label: "fields.Korjattuala",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynosto]: {
        label: "fields.Pystyynosto",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynmyynti]: {
        label: "fields.Pystyynmyynti",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).Katoala]: {
        label: "fields.Katoala",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoKuivaheinaYhteensa]: {
        label: "fields.satotaso",
        unit: "common.kg-ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuYhteensa]: {
        label: "fields.satotaso",
        unit: "common.kg-ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuEsikuivattuYhteensa]: {
        label: "fields.satotaso",
        unit: "common.kg-ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoNiittorehuYhteensa]: {
        label: "fields.satotaso",
        unit: "common.kg-ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinaKorjuuAlaKaikkiKorjuukerratYhteensa]: {
        label: "fields.KorjattuAlaYhteens\xe4",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuKorjuuAlaKaikkiKorjuukerratYhteensa]: {
        label: "fields.KorjattuAlaYhteens\xe4",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuEsikuivattuKorjuuAlaKaikkiKorjuukerratYhteensa]: {
        label: "fields.KorjattuAlaYhteens\xe4",
        unit: "common.ha"
    },
    [(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKorjuuAlaKaikkiKorjuukerratYhteensa]: {
        label: "fields.KorjattuAlaYhteens\xe4",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoTuoresäilövilja]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKokoviljasäilörehu]: {
        label: "fields.Satotaso",
        unit: "common.kg-ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KosteusTuoresäilövilja]: {
        label: "fields.Kosteusprosentti",
        unit: "%"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaTuoresäilövilja]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräTuoresäilövilja]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineKokoviljasäilörehu]: {
        label: "fields.KuivaaineProsentti",
        unit: "%"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKokoviljasäilörehu]: {
        label: "fields.SatoYhteens\xe4",
        unit: "common.kg"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKokoviljasäilörehu]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaMallasohra]: {
        label: "fields.Korjuuala",
        unit: "common.ha"
    },
    [(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräMallasohra]: {
        label: "fields.SadonKokonaism\xe4\xe4r\xe4",
        unit: "common.kg"
    },
    [(0, $87f876476293d35b$export$833b3e5a19fb8939).Sadostamyyty1510]: {
        label: "fields.Sadostamyyty1510",
        unit: "common.kg"
    },
    [(0, $87f876476293d35b$export$833b3e5a19fb8939).Varastossa1510]: {
        label: "fields.Varastossa1510",
        unit: "common.kg"
    }
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


function $33585bb92b9b52d5$export$2e2bcd8739ae039({ id: id }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const laji = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ meta: meta })=>[
            ...meta.viljakasvit,
            ...meta.muutkasvit,
            ...meta.perunakasvit,
            ...meta.valkuaiskasvit
        ].find((row)=>row.id === id));
    if (!laji) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "-"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: t(laji.name)
    });
}


const $5accf32bce1117cd$export$2e1a5bb9d2fd5c1e = (0, $1Ikg4.default)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039))`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
`;
const $5accf32bce1117cd$export$d670ff80c26bb1a5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        variant: "h3",
        children: children
    });
};
const $5accf32bce1117cd$export$c1daab4f241f73da = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        mb: 1,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
            sx: {
                textTransform: "capitalize",
                textDecoration: "underline"
            },
            children: children
        })
    });
};
const $5accf32bce1117cd$export$d205032b03c9a51a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        sx: {
            fontWeight: "bold"
        },
        children: children
    });
};
const $5accf32bce1117cd$export$b27146e4b5c31b11 = (0, $1Ikg4.default)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039))`
  display: flex;
  justify-content: space-between;
  max-width: 332px;
`;
const $5accf32bce1117cd$export$41b44b1640b4fd40 = (0, $1Ikg4.default)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039))`
  display: flex;
  justify-content: space-between;
  max-width: 308px;
`;
const $5accf32bce1117cd$export$46453a0401d6cd1a = ({ title: title, idAttribute: idAttribute = "Kasvilaji", data: data, CustomSummaryRowHeader: CustomSummaryRowHeader })=>{
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5accf32bce1117cd$export$2e1a5bb9d2fd5c1e, {
        p: 2,
        mt: 2,
        mb: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5accf32bce1117cd$export$d670ff80c26bb1a5, {
                children: title
            }),
            data.map((row, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5accf32bce1117cd$export$2e58c2d5c54ab58d, {
                    Header: CustomSummaryRowHeader,
                    data: row,
                    idAttribute: idAttribute
                }, index))
        ]
    });
};
function $5accf32bce1117cd$export$2e58c2d5c54ab58d({ data: data, idAttribute: idAttribute, Header: Header }) {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [summaryValueRows, setSummaryValueRows] = (0, $acw62.useState)([]);
    /**
   * This useEffect hook appears, based on very superficial reading, to do memoization of the
   * rendered jsx based on changes to `data`.
   *
   * As it is, it seems to work just fine for now. No need to change it at the moment.
   *
   * If it would ever need changing, consider either:
   *
   * 1. converting it to a new subcomponent that is memoized with `React.memo`. This would reduce its
   *    complexity drastically.
   * 2. Possibly dropping the memoization, and just rendering it plain inside a map.
   *
   * There is a slight change that it might be doing something more than what `React.memo` would do.
   * Because of this, if you think of changing it, read through it first, and make sure it isn't actually
   * doing anything else.
   */ (0, $acw62.useEffect)(()=>{
        let els = [];
        Object.keys(data).forEach((value)=>{
            if (value === idAttribute) return;
            if (data[value] === null) return;
            if (typeof data[value] === "object") els.push(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                pl: 4,
                mb: 1,
                mt: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5accf32bce1117cd$export$d205032b03c9a51a, {
                        children: t(value)
                    }),
                    Object.keys(data[value]).map((nestedKey)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($5accf32bce1117cd$export$41b44b1640b4fd40, {
                                pl: 3,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[nestedKey] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[nestedKey].label) : nestedKey
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            data[value][nestedKey],
                                            "  ",
                                            (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[nestedKey] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[nestedKey].unit) : ""
                                        ]
                                    })
                                ]
                            })
                        }, nestedKey))
                ]
            }, value));
            else els.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($5accf32bce1117cd$export$b27146e4b5c31b11, {
                    pl: 4,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[value] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[value].label) : value,
                                "  "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                data[value],
                                " ",
                                (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[value] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[value].unit) : ""
                            ]
                        })
                    ]
                })
            }, value));
        });
        setSummaryValueRows(els);
    }, [
        data,
        i18n.language
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                pl: 2,
                pt: 1,
                pb: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5accf32bce1117cd$export$c1daab4f241f73da, {
                    children: Header ? /*#__PURE__*/ (0, $ayMG0.jsx)(Header, {
                        id: data[idAttribute]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
                        id: data[idAttribute]
                    })
                })
            }),
            summaryValueRows
        ]
    });
}


function $1b90bcff73642abc$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.MuutViljelykasvitSatotiedot);
    if (!values || !values.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$46453a0401d6cd1a), {
        title: t("muutViljelyKasvit.title"),
        data: values
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $c64da8ead8518076$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.PerunanSatotiedot);
    if (!values || !values.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$46453a0401d6cd1a), {
        title: t("PerunanSatotiedot.title"),
        data: values
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");





const $b1759aae1b0aa1db$var$YhteenvetoNimike = ({ fieldId: fieldId, paddingLeft: paddingLeft })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        pl: paddingLeft,
        children: (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[fieldId] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[fieldId].label) : fieldId
    });
};
const $b1759aae1b0aa1db$var$YhteenvetoArvoJaYksikko = ({ fieldId: fieldId, korjuukerta: korjuukerta })=>{
    return korjuukerta ? /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$RehunurmenSatotiedotKorjuuValue, {
        fieldId: fieldId,
        korjuukerta: korjuukerta
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$RehunurmenSatotiedotValue, {
        fieldId: fieldId
    });
};
const $b1759aae1b0aa1db$var$RehunurmenSatotiedotKorjuuValue = ({ fieldId: fieldId, korjuukerta: korjuukerta })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const korjuu = korjuukerta;
    const value = korjuu[fieldId] ? korjuu[fieldId] : 0;
    const unit = (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[fieldId] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[fieldId].unit) : "";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5accf32bce1117cd$export$b27146e4b5c31b11), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: value
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: unit
            })
        ]
    });
};
const $b1759aae1b0aa1db$var$RehunurmenSatotiedotValue = ({ fieldId: fieldId })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const rehunurmenSatotiedot = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.RehunurmenSatotiedot);
    const value = rehunurmenSatotiedot[fieldId] ? rehunurmenSatotiedot[fieldId] : 0;
    const unit = (0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[fieldId] ? t((0, $4f6c83beccc29d67$export$de268ca9ecbe6435)[fieldId].unit) : "";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5accf32bce1117cd$export$b27146e4b5c31b11), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: value
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: unit
            })
        ]
    });
};
const $b1759aae1b0aa1db$var$YhteenvetoRivi = ({ fieldId: fieldId, paddingLeft: paddingLeft, korjuukerta: korjuukerta })=>{
    const pl = 4;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5accf32bce1117cd$export$b27146e4b5c31b11), {
        pl: pl,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoNimike, {
                fieldId: fieldId,
                paddingLeft: paddingLeft
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoArvoJaYksikko, {
                fieldId: fieldId,
                korjuukerta: korjuukerta
            })
        ]
    });
};
const $b1759aae1b0aa1db$var$KuivaheinaYhteensaJaSatotaso = ()=>{
    const KuivaheinaHaKaikkiKorjuukerratYhteensa = (0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinaKorjuuAlaKaikkiKorjuukerratYhteensa;
    const kuivaheinaYhteensaKG = (0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg;
    const satotasoKuivaheina = (0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoKuivaheinaYhteensa;
    const KuivaheinaYhteensaJaSatotasoTaulukko = [
        KuivaheinaHaKaikkiKorjuukerratYhteensa,
        kuivaheinaYhteensaKG,
        satotasoKuivaheina
    ];
    const KuivaheinaYhteensaJaSatotasoRivit = KuivaheinaYhteensaJaSatotasoTaulukko.map((fieldId, index)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
            fieldId: fieldId,
            paddingLeft: 0
        }, index);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: KuivaheinaYhteensaJaSatotasoRivit
    });
};
const $b1759aae1b0aa1db$var$SailorehuYhteensaJaSatotaso = ()=>{
    const SailorehuHaKaikkiKorjuukerratYhteensa = (0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuKorjuuAlaKaikkiKorjuukerratYhteensa;
    const SailorehuYhteensaKG = (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg;
    const satotasoSailorehu = (0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuYhteensa;
    const sailorehuKuivaaineProsentti = (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuKuivaaineProsentti;
    const SailorehuYhteensaJaSatotasoTaulukko = [
        SailorehuHaKaikkiKorjuukerratYhteensa,
        SailorehuYhteensaKG,
        satotasoSailorehu,
        sailorehuKuivaaineProsentti
    ];
    const SailorehuYhteensaSatotasoRivit = SailorehuYhteensaJaSatotasoTaulukko.map((fieldId, index)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
            fieldId: fieldId,
            paddingLeft: 0
        }, index);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: SailorehuYhteensaSatotasoRivit
    });
};
const $b1759aae1b0aa1db$var$SailorehuEsikuivattuYhteensaJaSatotaso = ()=>{
    const SailorehuEsikuivattuHaKaikkiKorjuukerratYhteensa = (0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuEsikuivattuKorjuuAlaKaikkiKorjuukerratYhteensa;
    const sailorehuEsikuivattuYhteensaKg = (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg;
    const satotasoSailorehuEsikuivattu = (0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuEsikuivattuYhteensa;
    const sailorehuEsikuivattuKuivaaineProsentti = (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuKuivaaineProsentti;
    const SailorehuEsikuivattuYhteensaJaSatotasoTaulukko = [
        SailorehuEsikuivattuHaKaikkiKorjuukerratYhteensa,
        sailorehuEsikuivattuYhteensaKg,
        satotasoSailorehuEsikuivattu,
        sailorehuEsikuivattuKuivaaineProsentti
    ];
    const SailorehuEsikuivattuYhteensaSatotasoRivit = SailorehuEsikuivattuYhteensaJaSatotasoTaulukko.map((fieldId, index)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
            fieldId: fieldId,
            paddingLeft: 0
        }, index);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: SailorehuEsikuivattuYhteensaSatotasoRivit
    });
};
const $b1759aae1b0aa1db$var$NiittorehuYhteensaJaSatotaso = ()=>{
    const NiittorehuHaKaikkiKorjuukerratYhteensa = (0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKorjuuAlaKaikkiKorjuukerratYhteensa;
    const niittorehuYhteensaKg = (0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg;
    const satotasoNiittorehu = (0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoNiittorehuYhteensa;
    const niittorehuKuivaaineProsentti = (0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKuivaaineProsentti;
    const NiittorehuYhteensaJaSatotasoTaulukko = [
        NiittorehuHaKaikkiKorjuukerratYhteensa,
        niittorehuYhteensaKg,
        satotasoNiittorehu,
        niittorehuKuivaaineProsentti
    ];
    const NiittorehuYhteensaSatotasoRivit = NiittorehuYhteensaJaSatotasoTaulukko.map((fieldId, index)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
            fieldId: fieldId,
            paddingLeft: 0
        }, index);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: NiittorehuYhteensaSatotasoRivit
    });
};
const $b1759aae1b0aa1db$var$YleisetArvotOsio = ()=>{
    const tukihakemuksessaImoitettuAlaKey = (0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuuala;
    const alaJoltaKorjattuSatoaKey = (0, $987975668562e0eb$export$833b3e5a19fb8939).Korjattuala;
    const pystyynOstettuKey = (0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynosto;
    const pystyynMyytyKey = (0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynmyynti;
    const katoAlaKey = (0, $987975668562e0eb$export$833b3e5a19fb8939).Katoala;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
                fieldId: tukihakemuksessaImoitettuAlaKey
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
                fieldId: alaJoltaKorjattuSatoaKey
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
                fieldId: pystyynOstettuKey
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
                fieldId: pystyynMyytyKey
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
                fieldId: katoAlaKey
            })
        ]
    });
};
const $b1759aae1b0aa1db$var$SadonKokonaisMaaraOsio = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                pt: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: "bold"
                    },
                    children: t("fields.SadonKokonaism\xe4\xe4r\xe4")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.Kuivahein\xe4n")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$KuivaheinaYhteensaJaSatotaso, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.Tuores\xe4il\xf6ttyS\xe4il\xf6rehun")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$SailorehuYhteensaJaSatotaso, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.EsikuivattuS\xe4il\xf6rehun")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$SailorehuEsikuivattuYhteensaJaSatotaso, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.Niittorehun")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$NiittorehuYhteensaJaSatotaso, {})
        ]
    });
};
const $b1759aae1b0aa1db$var$Korjuukerta = ({ number: number, korjuukerta: korjuukerta })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        pt: 1,
        pb: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5accf32bce1117cd$export$c1daab4f241f73da), {
                children: [
                    number,
                    ". ",
                    t("fields.Korjuukerta")
                ]
            }),
            Object.keys(korjuukerta).filter((fieldId)=>fieldId !== (0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuu).map((fieldId, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YhteenvetoRivi, {
                    fieldId: fieldId,
                    korjuukerta: korjuukerta
                }, index);
            })
        ]
    });
};
const $b1759aae1b0aa1db$var$KorjuukerratOsio = ()=>{
    const korjuukerrat = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.RehunurmenSatotiedot.Korjuu);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                pt: 1,
                pb: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: "bold"
                    },
                    children: t("RehunurmenSatotiedot.otsikko.Korjuukerrat")
                })
            }),
            korjuukerrat.map((korjuukerta, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$Korjuukerta, {
                    number: index + 1,
                    korjuukerta: korjuukerta
                }, index + 1))
        ]
    });
};
function $b1759aae1b0aa1db$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const rehunurmenSatotiedot = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.RehunurmenSatotiedot);
    if (!rehunurmenSatotiedot) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5accf32bce1117cd$export$2e1a5bb9d2fd5c1e), {
        p: 2,
        mt: 2,
        mb: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                pl: 1,
                pb: 1,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$d670ff80c26bb1a5), {
                    children: t("RehunurmenSatotiedot.title")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$YleisetArvotOsio, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$KorjuukerratOsio, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($b1759aae1b0aa1db$var$SadonKokonaisMaaraOsio, {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $e206fe07cddc58a3$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.Syyskylvot);
    if (!values || !values.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$46453a0401d6cd1a), {
        title: t("syyskylvot.title"),
        data: values
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




function $8e49d1731d7f8ec7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.ValkuaiskasvienSatotiedot.map((row)=>{
            let summary = (0, $f1q41.pick)(row, [
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).Kasvilaji,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).Viljelyala
            ]);
            if (row[(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala]) summary["ValkuaiskasvienSatotiedot.KuivattavaKasvi"] = (0, $f1q41.pick)(row, [
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva
            ]);
            if (row[(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu]) summary["ValkuaiskasvienSatotiedot.S\xe4il\xf6rehu"] = (0, $f1q41.pick)(row, [
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoTuore,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).KuivaaineSäilörehu
            ]);
            if (row[(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi]) summary["ValkuaiskasvienSatotiedot.Korjuutiedot"] = (0, $f1q41.pick)(row, [
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi,
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoÖljykasvi
            ]);
            return summary;
        }));
    if (!values || !values.length) return null;
    // cast to `any`, as `SummaryData` type is horribly broken.
    const data = values;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$46453a0401d6cd1a), {
        title: t("ValkuaiskasvienSatotiedot.title"),
        data: data
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");




var $59bd8eb267700007$export$2e2bcd8739ae039 = {
    tammikuu: "1.1.2023",
    heinäkuu: "1.7.2022"
};


const $5c7428704f927050$export$dc8c85f99b4d9106 = {
    [(0, $8600e8026484e4e0$export$bf26e3698826ecc9).vehnä]: "Varastotiedot.vehn\xe4",
    [(0, $8600e8026484e4e0$export$bf26e3698826ecc9).ruis]: "Varastotiedot.ruis",
    [(0, $8600e8026484e4e0$export$bf26e3698826ecc9).ohra]: "Varastotiedot.ohra",
    [(0, $8600e8026484e4e0$export$bf26e3698826ecc9).kaura]: "Varastotiedot.kaura"
};
const $5c7428704f927050$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        sectionHeader: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        }
    }));
/**
 * Get the kasvilaji value from either `kasvilaji` or `Kasvilaji` key.
 */ const $5c7428704f927050$var$getKasvilaji = (field)=>{
    const { kasvilaji: kasvilaji, Kasvilaji: Kasvilaji } = field;
    if (kasvilaji) return kasvilaji;
    if (Kasvilaji) return Kasvilaji;
    return undefined;
};
const $5c7428704f927050$var$LajinNimiOtsake = ({ field: field })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $5c7428704f927050$var$useStyles();
    const laji = $5c7428704f927050$var$getKasvilaji(field);
    let otsake = "-";
    if (laji) {
        const tunnisteI18N = $5c7428704f927050$export$dc8c85f99b4d9106[laji];
        otsake = t(tunnisteI18N);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5ca16cb6e72a53f1$export$2e2bcd8739ae039, {
        className: classes.sectionHeader,
        variant: "h5",
        children: otsake
    });
};
const $5c7428704f927050$var$ViljakohtaisetKentät = ()=>{
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "Varastotiedot"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: fields.map((f, index)=>{
            const field = f;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($ed0dc78f73685bb9$export$2e2bcd8739ae039, {
                component: $bca3355350079f94$export$2e2bcd8739ae039,
                p: 2,
                mt: 2,
                mb: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($a2c903eb2263b589$export$2e2bcd8739ae039, {
                        spacing: 4,
                        container: true,
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a2c903eb2263b589$export$2e2bcd8739ae039, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($5c7428704f927050$var$LajinNimiOtsake, {
                                field: field
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($a2c903eb2263b589$export$2e2bcd8739ae039, {
                        container: true,
                        item: true,
                        spacing: 4,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a2c903eb2263b589$export$2e2bcd8739ae039, {
                                item: true,
                                md: 6,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    name: `Varastotiedot.${index}.${(0, $8600e8026484e4e0$export$833b3e5a19fb8939).VarastoarvoHeinäkuu}`,
                                    control: methods.control,
                                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                                            inputRef: ref,
                                            ...field,
                                            label: "VarastoarvoHein\xe4kuu",
                                            tProps: {
                                                heinäkuu: (0, $59bd8eb267700007$export$2e2bcd8739ae039).heinäkuu
                                            },
                                            fullWidth: true
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a2c903eb2263b589$export$2e2bcd8739ae039, {
                                item: true,
                                md: 6,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    name: `Varastotiedot.${index}.${(0, $8600e8026484e4e0$export$833b3e5a19fb8939).VarastoarvioTammikuu}`,
                                    control: methods.control,
                                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                                            inputRef: ref,
                                            ...field,
                                            label: "VarastoarvoTammikuuArvio",
                                            tProps: {
                                                tammikuu: (0, $59bd8eb267700007$export$2e2bcd8739ae039).tammikuu
                                            },
                                            fullWidth: true
                                        })
                                })
                            })
                        ]
                    })
                ]
            }, `Varastotiedot.${index}.${(0, $8600e8026484e4e0$export$833b3e5a19fb8939).Kasvilaji}`);
        })
    });
};
var $5c7428704f927050$export$2e2bcd8739ae039 = $5c7428704f927050$var$ViljakohtaisetKentät;


const $ca9c5a281fca9649$var$CustomSummaryRowHeader = ({ id: id })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if (!Object.keys((0, $5c7428704f927050$export$dc8c85f99b4d9106)).includes(id)) return null;
    const title = (0, $5c7428704f927050$export$dc8c85f99b4d9106)[id];
    if (!title) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: t(title)
    });
};
const $ca9c5a281fca9649$var$YhteenvetoVarastotiedot = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.Varastotiedot);
    if (!values || !values.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$46453a0401d6cd1a), {
        CustomSummaryRowHeader: $ca9c5a281fca9649$var$CustomSummaryRowHeader,
        idAttribute: "kasvilaji",
        title: t("Varastotiedot.title"),
        data: values
    });
};
var $ca9c5a281fca9649$export$2e2bcd8739ae039 = $ca9c5a281fca9649$var$YhteenvetoVarastotiedot;



var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");




function $5b82636de689bcf3$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.ViljanSatotiedot.map((row)=>{
            let summary = (0, $f1q41.pick)(row, [
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Kasvilaji,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Viljelyala
            ]);
            if (row[(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana]) summary["ViljanSatotiedot.KuivattavaVilja"] = (0, $f1q41.pick)(row, [
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKuivattavaVilja,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja
            ]);
            if (row[(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuTuoresäilörehu]) summary["ViljanSatotiedot.TuoreenaKorjattavaVilja"] = (0, $f1q41.pick)(row, [
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaTuoresäilövilja,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräTuoresäilövilja,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoTuoresäilövilja,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KosteusTuoresäilövilja
            ]);
            if (row[(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKokoviljasäilörehu]) summary["ViljanSatotiedot.Kokoviljas\xe4il\xf6rehu"] = (0, $f1q41.pick)(row, [
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKokoviljasäilörehu,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKokoviljasäilörehu,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKokoviljasäilörehu,
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineKokoviljasäilörehu
            ]);
            if (row.Kasvilaji === "_386583") summary = {
                ...summary,
                ...(0, $f1q41.pick)(row, [
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja,
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräVihantavilja,
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoVihantavilja,
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineVihantavilja
                ])
            };
            if (row.Kasvilaji === "_61201") summary = {
                ...summary,
                ...(0, $f1q41.pick)(row, [
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaMallasohra,
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräMallasohra,
                    (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja
                ])
            };
            return summary;
        }));
    if (!values || !values.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5accf32bce1117cd$export$46453a0401d6cd1a), {
        title: t("ViljanSatotiedot.title"),
        data: values
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $1Ikg4 = parcelRequire("1Ikg4");
function $d80b5c5b4def8f69$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $d80b5c5b4def8f69$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d80b5c5b4def8f69$export$2e2bcd8739ae039(obj);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $d80b5c5b4def8f69$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $d80b5c5b4def8f69$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}





function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(date).getTime() - (0, $4e98b4d5a2488885$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}







var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}


function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5b38b39a484f4993$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}



function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;


var $d91e238bf521c720$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dbfee7256f9ba04c$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;


var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $b99de2b03d4f39be$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;


var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $9567ced935a3b497$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: "en-US",
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $b99de2b03d4f39be$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;


var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $d91e238bf521c720$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a5375092e28b891e$export$c6cc36aa33304772)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}


parcelRequire("acw62");









const $3e9bcaf8713dac03$var$muodostaAikaleima = (aika)=>{
    const nyt = aika ? new Date(aika) : new Date();
    const pvm = (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(nyt, "d.M.y");
    const klo = (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(nyt, "HH:mm");
    return {
        pvm: pvm,
        klo: klo
    };
};
const $3e9bcaf8713dac03$var$GenerointiAikaleima = ()=>{
    const Aikaleima = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039))``;
    const aikaleima = $3e9bcaf8713dac03$var$muodostaAikaleima();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Aikaleima, {
        children: [
            aikaleima.pvm,
            " ",
            aikaleima.klo
        ]
    });
};
const $3e9bcaf8713dac03$var$LähetysAikaleima = ()=>{
    const lähetettyAikaleima = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.finished_at);
    if (!lähetettyAikaleima) return null;
    const aikaleima = $3e9bcaf8713dac03$var$muodostaAikaleima(lähetettyAikaleima);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        variant: "body1",
        component: "span",
        children: [
            "(",
            aikaleima.pvm,
            " ",
            aikaleima.klo,
            ")"
        ]
    });
};
/**
 * Näytetään onko lomake aloitettu, kesken vai lähetetty.
 */ const $3e9bcaf8713dac03$var$LomakkeenTila = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { inquiries: inquiries } = (0, $be9872526568fda4$export$2e2bcd8739ae039)();
    const query = (0, $c49f7d6593097bdf$export$2e2bcd8739ae039)();
    const SRunko = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039))``;
    const STila = (0, $1Ikg4.default)("span")`
    & > * {
      display: inline;
    }
  `;
    const tila = inquiries.inquiries.find((i)=>i.period_id === query.get("id"))?.status || 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(SRunko, {
        children: [
            t("common.status"),
            ":",
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsxs)(STila, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f52b806a43de9e88$export$dde867dc2e19cdfb), {
                        status: tila
                    }),
                    tila === (0, $f52b806a43de9e88$export$f66f92b8741acd5b).Lähetetty && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3e9bcaf8713dac03$var$LähetysAikaleima, {})
                        ]
                    })
                ]
            })
        ]
    });
};
const $3e9bcaf8713dac03$var$Tilatunnus = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039))``;
const $3e9bcaf8713dac03$var$Kysely = (0, $1Ikg4.default)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039))``;
function $3e9bcaf8713dac03$export$2e2bcd8739ae039({ title: title }) {
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const meta = (0, $76cdbbeb537534c7$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: "none",
            justifyContent: "space-between",
            ["@media print"]: {
                display: "flex"
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    i18n.language === "fi" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        style: {
                            height: "100px"
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3754d21c80fdfa85$exports))),
                        alt: "Luonnonvarakeskuksen logo"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        style: {
                            height: "100px"
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5d2635ab09e018a6$exports))),
                        alt: "Luonnonvarakeskuksen logo"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3e9bcaf8713dac03$var$Kysely, {
                        children: t(title)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3e9bcaf8713dac03$var$GenerointiAikaleima, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($3e9bcaf8713dac03$var$Tilatunnus, {
                        children: [
                            t("common.tilatunnus"),
                            ":",
                            " ",
                            meta.find((row)=>row.key === "TILTU")?.value
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3e9bcaf8713dac03$var$LomakkeenTila, {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: {
                        maxWidth: "250px"
                    },
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($de59dbffe2aac879$exports)))
                })
            })
        ]
    });
}


const $f172a1bdf4b6cb8f$export$8ae807fc5204eb26 = ({ fullWidth: fullWidth, onClick: onClick })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
        fullWidth: !!fullWidth,
        variant: "contained",
        sx: {
            marginRight: "16px"
        },
        onClick: onClick,
        children: t("common.download_pdf")
    });
};
function $f172a1bdf4b6cb8f$export$c4fed20b2e4a2401() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e9bcaf8713dac03$export$2e2bcd8739ae039), {
                title: "common.satoPdfTitle"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5b82636de689bcf3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca9c5a281fca9649$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e49d1731d7f8ec7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b90bcff73642abc$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c64da8ead8518076$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e206fe07cddc58a3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b1759aae1b0aa1db$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7418071e6d65408$export$2e2bcd8739ae039), {})
        ]
    });
}
function $f172a1bdf4b6cb8f$export$2e2bcd8739ae039() {
    const id = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.periodId);
    const canFillInForms = (0, $1c48e19d77c40bbb$export$29aee41b3e0c698f)();
    const { finish: finish } = (0, $b0a6fe3369babf11$export$2e2bcd8739ae039)(id);
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handlePreviousClick = ()=>{
        navigate((0, $df5bef30413a053b$export$385fc1c9ea2be551)(canFillInForms ? (0, $155cd4757147cec6$export$2e2bcd8739ae039).lisatiedot : (0, $155cd4757147cec6$export$2e2bcd8739ae039).vastauskoodit));
    };
    const handleFinishClick = async ()=>{
        await finish.execute();
        navigate((0, $df5bef30413a053b$export$385fc1c9ea2be551)((0, $155cd4757147cec6$export$2e2bcd8739ae039).kiitos));
    };
    const handleDownloadClick = ()=>{
        window.print();
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        sx: {
                            ["@media print"]: {
                                display: "none"
                            }
                        },
                        children: [
                            "9. ",
                            t("yhteenveto.title")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "yhteenveto.ohjeteksti",
                            components: {
                                b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {}),
                                p: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: breakpoints.mobilePrintButton,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f172a1bdf4b6cb8f$export$8ae807fc5204eb26, {
                            fullWidth: true,
                            onClick: handleDownloadClick
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($f172a1bdf4b6cb8f$export$c4fed20b2e4a2401, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                                onPrevious: handlePreviousClick
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f172a1bdf4b6cb8f$export$8ae807fc5204eb26, {
                                        onClick: handleDownloadClick
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                                        disabled: finish.loading || !canFillInForms,
                                        onClick: handleFinishClick,
                                        children: t("common.finish")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                        onPrevious: handlePreviousClick,
                        step: "9/9"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                        disableElevation: true,
                        sx: {
                            border: 0
                        },
                        onClick: handleFinishClick,
                        disabled: finish.loading
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





















function $9637e8f2a6152bad$export$5e41d377d29167d2() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e9bcaf8713dac03$export$2e2bcd8739ae039), {
                title: "common.perunaPdfTitle"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c64da8ead8518076$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7418071e6d65408$export$2e2bcd8739ae039), {})
        ]
    });
}
function $9637e8f2a6152bad$export$2e2bcd8739ae039() {
    const id = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.periodId);
    const isInquiryDataAvailable = (0, $1c48e19d77c40bbb$export$29aee41b3e0c698f)();
    const { finish: finish } = (0, $b0a6fe3369babf11$export$2e2bcd8739ae039)(id);
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handlePreviousClick = ()=>{
        navigate((0, $df5bef30413a053b$export$385fc1c9ea2be551)(isInquiryDataAvailable ? (0, $155cd4757147cec6$export$2e2bcd8739ae039).lisatiedot : (0, $155cd4757147cec6$export$2e2bcd8739ae039).vastauskoodit));
    };
    const handleFinishClick = async ()=>{
        await finish.execute();
        navigate((0, $df5bef30413a053b$export$385fc1c9ea2be551)((0, $155cd4757147cec6$export$2e2bcd8739ae039).kiitos));
    };
    const handleDownloadClick = ()=>{
        window.print();
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        sx: {
                            ["@media print"]: {
                                display: "none"
                            }
                        },
                        children: [
                            "3. ",
                            t("yhteenveto.title")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: "yhteenveto.ohjeteksti",
                            components: {
                                b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {}),
                                p: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: breakpoints.mobilePrintButton,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f172a1bdf4b6cb8f$export$8ae807fc5204eb26), {
                            fullWidth: true,
                            onClick: handleDownloadClick
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9637e8f2a6152bad$export$5e41d377d29167d2, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                                onPrevious: handlePreviousClick
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f172a1bdf4b6cb8f$export$8ae807fc5204eb26), {
                                        onClick: handleDownloadClick
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                                        disabled: finish.loading || !isInquiryDataAvailable,
                                        onClick: handleFinishClick,
                                        children: t("common.finish")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                        onPrevious: handlePreviousClick,
                        step: "3/3"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                        disableElevation: true,
                        sx: {
                            border: 0
                        },
                        onClick: handleFinishClick,
                        disabled: finish.loading
                    })
                ]
            })
        ]
    });
}


const $fa94ada6e399577f$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        lukeLink: {}
    }));
function $fa94ada6e399577f$export$2e2bcd8739ae039() {
    const classes = $fa94ada6e399577f$var$useStyles();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const logout = (0, $e4f5da8c80007dda$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleDownloadClick = ()=>{
        window.print();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        sx: {
                            ["@media print"]: {
                                display: "none"
                            }
                        },
                        children: t("common.kiitos")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: t("common.kiitosTekstiPeruna1.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: t("common.kiitosTekstiPeruna1.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    t("common.kiitosTilastoteksti"),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: classes.lukeLink,
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        href: t("common.kiitosTilastolinkki"),
                                        children: t("common.kiitos.linkiteksti")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: "none",
                            ["@media print"]: {
                                display: "block"
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9637e8f2a6152bad$export$5e41d377d29167d2), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$e70d566b96318985), {
                                text: t("common.uusilomake"),
                                onClick: ()=>navigate("/aloitus")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f172a1bdf4b6cb8f$export$8ae807fc5204eb26), {
                                        onClick: handleDownloadClick
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                                        text: t("common.logout"),
                                        onClick: ()=>logout()
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$e70d566b96318985), {
                        text: t("common.uusilomake"),
                        onClick: ()=>navigate("/aloitus")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                        text: t("common.logout"),
                        onClick: ()=>logout()
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");














var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $7b20996aacb4a85b$var$useBlocker(blocker, when = true) {
    const { navigator: navigator } = (0, $acw62.useContext)((0, $926608a7a86d7371$export$26749e8557646306));
    (0, $acw62.useEffect)(()=>{
        if (!when) return;
        const unblock = navigator.block((tx)=>{
            const autoUnblockingTx = {
                ...tx,
                retry () {
                    // Automatically unblock the transition so it can play all the way
                    // through before retrying it. TODO: Figure out how to re-enable
                    // this block if the transition is cancelled for some reason.
                    unblock();
                    tx.retry();
                }
            };
            blocker(autoUnblockingTx);
        });
        return unblock;
    }, [
        navigator,
        blocker,
        when
    ]);
}
var $7b20996aacb4a85b$export$2e2bcd8739ae039 = $7b20996aacb4a85b$var$useBlocker;



var $acw62 = parcelRequire("acw62");
const $b82e963860ab5295$var$noop = ()=>{
/*No Operation*/ };
const $b82e963860ab5295$var$initialConfirmState = {
    isActive: false,
    hasConfirmed: false,
    proceed: $b82e963860ab5295$var$noop,
    cancel: $b82e963860ab5295$var$noop
};
const $b82e963860ab5295$var$useConfirm = ()=>{
    const [confirm, setConfirm] = (0, $acw62.useState)($b82e963860ab5295$var$initialConfirmState);
    (0, $acw62.useEffect)(()=>{
        if (confirm.isActive) window.onbeforeunload = ()=>{
            return false;
        };
        return ()=>{
            if (confirm.isActive) window.onbeforeunload = null;
        };
    }, [
        confirm
    ]);
    const onConfirm = (0, $acw62.useCallback)(()=>{
        const promise = new Promise((resolve, reject)=>{
            setConfirm((prevState)=>({
                    ...prevState,
                    isActive: true,
                    proceed: resolve,
                    cancel: reject
                }));
        });
        return promise.then(()=>{
            setConfirm({
                ...confirm,
                isActive: false,
                hasConfirmed: true
            });
            return true;
        }, ()=>{
            setConfirm({
                ...confirm,
                isActive: false
            });
            return false;
        });
    }, []);
    const resetConfirmation = (0, $acw62.useCallback)(()=>{
        ()=>setConfirm($b82e963860ab5295$var$initialConfirmState);
    }, []);
    return {
        ...confirm,
        onConfirm: onConfirm,
        resetConfirmation: resetConfirmation
    };
};
var $b82e963860ab5295$export$2e2bcd8739ae039 = $b82e963860ab5295$var$useConfirm;


const $cbae818e89f45e96$var$Prompt = ({ when: when, children: children })=>{
    const { isActive: isActive, proceed: proceed, cancel: cancel, onConfirm: onConfirm, hasConfirmed: hasConfirmed, resetConfirmation: resetConfirmation } = (0, $b82e963860ab5295$export$2e2bcd8739ae039)();
    const blocker = (0, $acw62.useCallback)(async (tx)=>{
        if (await onConfirm()) {
            resetConfirmation();
            tx.retry();
        }
    }, [
        resetConfirmation,
        onConfirm
    ]);
    (0, $7b20996aacb4a85b$export$2e2bcd8739ae039)(blocker, when && !hasConfirmed);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: children({
            isActive: isActive,
            onConfirm: proceed,
            onCancel: cancel
        })
    });
};
var $cbae818e89f45e96$export$2e2bcd8739ae039 = $cbae818e89f45e96$var$Prompt;


function $346c0e6f4dd6aea5$export$2e2bcd8739ae039({ open: open }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbae818e89f45e96$export$2e2bcd8739ae039), {
        when: open,
        children: ({ isActive: isActive, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
                open: isActive,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                        children: t("confirmdialog.title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: t("confirmdialog.content")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                autoFocus: true,
                                onClick: onCancel,
                                children: t("confirmdialog.back")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                onClick: onConfirm,
                                children: t("confirmdialog.continue")
                            })
                        ]
                    })
                ]
            })
    });
}





const $3cb876d77e75d0d9$export$4bddc3220ee593d8 = ()=>{
    const { lisatiedotWithID: lisatiedotWithID, lisatiedotWithNoID: lisatiedotWithNoID } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>({
            lisatiedotWithID: form.Lisatiedot,
            lisatiedotWithNoID: form["Lis\xe4tiedot"]
        }));
    // if the lisatiedot field with kenttaID has values
    if (lisatiedotWithID && lisatiedotWithID[(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]) return lisatiedotWithID;
    // fixme: Backwards compatilibity workaround, to be removed after SATO tiedonkeruu is over and data is cleaned
    if (lisatiedotWithNoID) return {
        [(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]: lisatiedotWithNoID
    };
    return {
        [(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]: ""
    };
};




function $4cb0e2542d1bcd2d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const user = (0, $557966054e36245a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const lisatiedot = (0, $3cb876d77e75d0d9$export$4bddc3220ee593d8)();
    const schema = (0, $91cfdcf11b4ccb63$export$e404dc3ff33af774)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            Lisatiedot: lisatiedot
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)(schema)
    });
    const handlePreviousClick = ()=>{
        navigate("/peruna/sato-ja-varastot");
    };
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 4
        }));
        navigate("/peruna/yhteenveto");
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    const lisatietoError = methods.formState.errors.Lisatiedot && methods.formState.errors.Lisatiedot[(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]?.message;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "2. ",
                            t("PerunanLis\xe4tiedot.title")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: t("lis\xe4tiedot.ohjeteksti")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            item: true,
                            md: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `Lisatiedot.${(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                                inputRef: ref,
                                                ...field,
                                                multiline: true,
                                                variant: "standard",
                                                fullWidth: true,
                                                label: t("fields.Lis\xe4tiedot")
                                            }),
                                            !!lisatietoError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), {
                                                error: true,
                                                children: t(lisatietoError)
                                            })
                                        ]
                                    })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onPrevious: handlePreviousClick,
                            onNext: handleNextClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "2/3",
                    onPrevious: handlePreviousClick,
                    onNext: handleNextClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");















var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");

function $2b61f53edf67636e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        p: 8,
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "4px solid rgba(179, 92, 0, 0.3)"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: "common.eiEsit\xe4ytt\xf6tietoja",
                components: {
                    b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                }
            })
        })
    });
}
function $2b61f53edf67636e$export$e7d27b2fe391e8d5() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        p: 8,
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "4px solid rgba(179, 92, 0, 0.3)"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: "common.eiEdellisvuodenPerunasatoa",
                components: {
                    b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                }
            })
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
function $43badd48fe3b2ca1$export$2e2bcd8739ae039({ children: children, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {},
        component: (0, $bca3355350079f94$export$2e2bcd8739ae039),
        p: 2,
        pb: 4,
        mb: 2,
        ...rest,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            children: children
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $60c611e2ff3de0fd$var$FormSectionTitle = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        sx: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        },
        mb: 1,
        variant: "h3",
        children: children
    });
var $60c611e2ff3de0fd$export$2e2bcd8739ae039 = $60c611e2ff3de0fd$var$FormSectionTitle;




var $acw62 = parcelRequire("acw62");


const $1ec6fc95823d038d$var$round = (value)=>Math.round((value + Number.EPSILON) * 100) / 100;
const $1ec6fc95823d038d$export$fbc96ef4f18d6d75 = ({ kilograms: kilograms, acres: acres })=>{
    const acresHasValue = acres !== undefined && acres !== null;
    const kilogramsHasValue = kilograms !== undefined && kilograms !== null;
    if (!acresHasValue || !kilogramsHasValue) return null;
    const kg = (0, $ab5958319bb12700$export$22a0d6ac9d3db3b9)(kilograms);
    const ha = (0, $ab5958319bb12700$export$22a0d6ac9d3db3b9)(acres);
    // No strings or other non-numeric values (for its hard to do division with them).
    if (isNaN(kg) || isNaN(ha)) return null;
    // No division by 0.
    if (ha === 0) return null;
    return $1ec6fc95823d038d$var$round(kg / ha);
};
/**
 * Calculate total crops based on acres and satotaso.
 *
 * Formula:
 *
 * ```
 * Acres ha * satotaso kg/ha = total kg
 * ````
 *
 * @returns total - if either acres or satotaso are missing, returns undefined
 */ const $1ec6fc95823d038d$var$calculateTotalKg = ({ acres: acres, satotaso: satotaso })=>{
    const acresHasValue = acres !== undefined && acres !== null;
    const satotasoHasValue = satotaso !== undefined && satotaso !== null;
    if (!acresHasValue || !satotasoHasValue) return null;
    const ha = (0, $ab5958319bb12700$export$22a0d6ac9d3db3b9)(acres);
    const kgha = (0, $ab5958319bb12700$export$22a0d6ac9d3db3b9)(satotaso);
    if (isNaN(ha) || isNaN(kgha)) return null;
    return $1ec6fc95823d038d$var$round(ha * kgha);
};
function $1ec6fc95823d038d$export$1628ba309baaebb(kilogramFieldName, acreFieldName, satotasoFieldName) {
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const [kilograms, acres] = methods.watch([
        kilogramFieldName,
        acreFieldName
    ]);
    (0, $acw62.useEffect)(()=>{
        const satotaso = $1ec6fc95823d038d$export$fbc96ef4f18d6d75({
            kilograms: kilograms,
            acres: acres
        });
        methods.setValue(satotasoFieldName, satotaso);
    }, [
        kilograms,
        acres
    ]);
}
function $1ec6fc95823d038d$export$c17e948433f5d3d8(kilogramFieldName, acreFieldName, satotasoFieldName) {
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const handleChange = ({ acres: ha, kilograms: kg, acreFieldName: acreFieldName, kilogramFieldName: kilogramFieldName })=>{
        const acres = acreFieldName ? methods.getValues(acreFieldName) : ha;
        const kilograms = kilogramFieldName ? methods.getValues(kilogramFieldName) : kg;
        const satotasoNykyinen = methods.getValues(satotasoFieldName);
        const satotaso = $1ec6fc95823d038d$export$fbc96ef4f18d6d75({
            acres: acres,
            kilograms: kilograms
        });
        if (satotaso !== satotasoNykyinen) methods.setValue(satotasoFieldName, satotaso);
    };
    const handleChangeKilograms = (e)=>handleChange({
            acreFieldName: acreFieldName,
            kilograms: e.target.value
        });
    const handleChangeAcres = (e)=>handleChange({
            kilogramFieldName: kilogramFieldName,
            acres: e.target.value
        });
    return {
        handleChangeAcres: handleChangeAcres,
        handleChangeKilograms: handleChangeKilograms
    };
}
function $1ec6fc95823d038d$export$2e2bcd8739ae039() {
    return $1ec6fc95823d038d$export$fbc96ef4f18d6d75;
}



const $0ebef38dfd2d2321$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        acreField: {
            minWidth: "275px"
        },
        sectionHeader: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        }
    }));
function $0ebef38dfd2d2321$export$2e2bcd8739ae039({ field: field, index: index }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $0ebef38dfd2d2321$var$useStyles();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const istutusala = methods.watch(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Istutusala}`);
    const korjuuala = methods.watch(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Korjuuala}`);
    const sold = methods.watch(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Sadostamyyty1510}`);
    const stored = methods.watch(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Varastossa1510}`);
    const harvested = methods.watch(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satomäärä}`);
    (0, $acw62.useEffect)(()=>{
        methods.trigger(`PerunanSatotiedot.${index}.${[
            (0, $87f876476293d35b$export$833b3e5a19fb8939).Varastossa1510
        ]}`);
    }, [
        stored,
        sold,
        harvested,
        korjuuala,
        istutusala
    ]);
    (0, $acw62.useEffect)(()=>{
        methods.trigger(`PerunanSatotiedot.${index}.${[
            (0, $87f876476293d35b$export$833b3e5a19fb8939).Sadostamyyty1510
        ]}`);
    }, [
        sold,
        stored,
        harvested,
        korjuuala,
        istutusala
    ]);
    (0, $acw62.useEffect)(()=>{
        if (istutusala === 0) {
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Korjuuala}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satomäärä}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satotaso}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Sadostamyyty1510}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Varastossa1510}`, null);
        }
    }, [
        istutusala
    ]);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satomäärä}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satotaso}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Sadostamyyty1510}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Varastossa1510}`, null);
        }
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satomäärä}`, `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Korjuuala}`, `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satotaso}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
                    id: field.Kasvilaji
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                spacing: 2,
                container: true,
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            lg: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Istutusala}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                        tooltip: t("fields.ohjeteksti.Esitaytto"),
                                        inputRef: ref,
                                        ...field,
                                        className: classes.acreField,
                                        label: "Istutusala"
                                    })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Korjuuala}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                        disabled: istutusala === 0,
                                        tooltip: t("PerunanSatotiedot.ohjeteksti.KorjuualaOhje"),
                                        inputRef: ref,
                                        ...field,
                                        label: "Korjuuala",
                                        fullWidth: true,
                                        onChange: (e)=>{
                                            field.onChange(e);
                                            handleChangeAcres(e);
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satomäärä}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                                        disabled: istutusala === 0 || korjuuala === 0,
                                        inputRef: ref,
                                        ...field,
                                        label: "SadonKokonaism\xe4\xe4r\xe4",
                                        fullWidth: true,
                                        onChange: (e)=>{
                                            field.onChange(e);
                                            handleChangeKilograms(e);
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Satotaso}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                                        disabled: istutusala === 0 || korjuuala === 0,
                                        inputRef: ref,
                                        ...field,
                                        label: "satotaso",
                                        fullWidth: true
                                    })
                            })
                        ]
                    }),
                    field[(0, $87f876476293d35b$export$833b3e5a19fb8939).Kasvilaji] !== "_21575" && field[(0, $87f876476293d35b$export$833b3e5a19fb8939).Kasvilaji] !== "_386987" && field[(0, $87f876476293d35b$export$833b3e5a19fb8939).Kasvilaji] !== "_386983" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Sadostamyyty1510}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                                        disabled: istutusala === 0 || korjuuala === 0,
                                        inputRef: ref,
                                        ...field,
                                        label: "Sadostamyyty1510",
                                        fullWidth: true
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $87f876476293d35b$export$833b3e5a19fb8939).Varastossa1510}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                                        disabled: istutusala === 0 || korjuuala === 0,
                                        tooltip: t("PerunanSatotiedot.ohjeteksti.VarastossaOhje"),
                                        inputRef: ref,
                                        ...field,
                                        label: "Varastossa1510",
                                        fullWidth: true
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    }, field.Kasvilaji);
}




var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");







const $4dd1df45664713d5$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        field: {}
    }));
const $4dd1df45664713d5$var$useSummaryValues = (fields)=>{
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const istutusalaFieldNames = fields.map((_, index)=>`PerunanSatotiedot.${index}.${[
            (0, $87f876476293d35b$export$833b3e5a19fb8939).Istutusala
        ]}`);
    const korjuualaFieldNames = fields.map((_, index)=>`PerunanSatotiedot.${index}.${[
            (0, $87f876476293d35b$export$833b3e5a19fb8939).Korjuuala
        ]}`);
    const istutusalaFieldValues = methods.watch(istutusalaFieldNames);
    const korjuualaFieldValues = methods.watch(korjuualaFieldNames);
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`PerunanSatotiedotYhteensa.${(0, $87f876476293d35b$export$833b3e5a19fb8939).IstutusalaYhteensä}`, istutusalaFieldValues.reduce((acc, v)=>acc + v));
    }, [
        istutusalaFieldValues
    ]);
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`PerunanSatotiedotYhteensa.${(0, $87f876476293d35b$export$833b3e5a19fb8939).KorjattuAlaYhteensä}`, korjuualaFieldValues.reduce((acc, v)=>acc + v));
    }, [
        korjuualaFieldValues
    ]);
    (0, $acw62.useEffect)(()=>{
        const korjaamatonAla = istutusalaFieldValues.reduce((acc, v)=>acc + v) - korjuualaFieldValues.reduce((acc, v)=>acc + v);
        methods.setValue(`PerunanSatotiedotYhteensa.${(0, $87f876476293d35b$export$833b3e5a19fb8939).KorjaamatonAlaYhteensä}`, korjaamatonAla > 0 ? korjaamatonAla : 0);
    }, [
        istutusalaFieldValues,
        korjuualaFieldValues
    ]);
};
function $4dd1df45664713d5$export$2e2bcd8739ae039({ fields: fields }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $4dd1df45664713d5$var$useStyles();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    $4dd1df45664713d5$var$useSummaryValues(fields);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                children: t("PerunanSatotiedotYhteensa.ohjeteksti.yhteenveto")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                        children: t("PerunanSatotiedotYhteensa.otsikko")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        spacing: 2,
                        container: true,
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            md: 6,
                            item: true,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    name: `PerunanSatotiedotYhteensa.${(0, $87f876476293d35b$export$833b3e5a19fb8939).IstutusalaYhteensä}`,
                                    control: methods.control,
                                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                            inputRef: ref,
                                            ...field,
                                            disabled: true,
                                            fullWidth: true,
                                            className: classes.field,
                                            label: "IstutusalaYhteens\xe4"
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    name: `PerunanSatotiedotYhteensa.${(0, $87f876476293d35b$export$833b3e5a19fb8939).KorjattuAlaYhteensä}`,
                                    control: methods.control,
                                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                            inputRef: ref,
                                            ...field,
                                            disabled: true,
                                            fullWidth: true,
                                            className: classes.field,
                                            label: "KorjattuAlaYhteens\xe4"
                                        })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    name: `PerunanSatotiedotYhteensa.${(0, $87f876476293d35b$export$833b3e5a19fb8939).KorjaamatonAlaYhteensä}`,
                                    control: methods.control,
                                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                            inputRef: ref,
                                            ...field,
                                            disabled: true,
                                            fullWidth: true,
                                            className: classes.field,
                                            label: "KorjaamatonAlaYhteens\xe4"
                                        })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


function $67bc916cd0e3377c$export$2e2bcd8739ae039() {
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const PerunanSatotiedot = (0, $1c48e19d77c40bbb$export$d4b2503a359650ed)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            PerunanSatotiedot: PerunanSatotiedot
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $87f876476293d35b$export$2e2bcd8739ae039))
    });
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "PerunanSatotiedot"
    });
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 1
        }));
        navigate("/peruna/lisatiedot");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "1. ",
                            t("PerunanSatojaVarastot.title")
                        ]
                    }),
                    PerunanSatotiedot?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b61f53edf67636e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: ttyyppi === 2 ? t("PerunanSatotiedot.ohjeteksti.tayttoohje.luomu") : t("PerunanSatotiedot.ohjeteksti.tayttoohje")
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ebef38dfd2d2321$export$2e2bcd8739ae039), {
                                    field: field,
                                    index: index
                                }, field.Kasvilaji)),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dd1df45664713d5$export$2e2bcd8739ae039), {
                                fields: fields
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                                onNext: handleNextClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "1/3",
                    onNext: handleNextClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



function $9d66bd0b11e548a5$var$usePerunaRoutes() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return [
        {
            href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).satojavarastot,
            text: "PerunanSatojaVarastot.title"
        },
        {
            href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).lisatiedot,
            text: "PerunanLis\xe4tiedot.title"
        },
        {
            href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).yhteenveto,
            text: "yhteenveto.title"
        }
    ];
}
function $9d66bd0b11e548a5$export$2e2bcd8739ae039() {
    const nav = $9d66bd0b11e548a5$var$usePerunaRoutes();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    const query = (0, $c49f7d6593097bdf$export$2e2bcd8739ae039)();
    const id = query.get("id");
    /**
   * Load form values from backend and populate store before continuing to form pages
   */ const { loading: loading } = (0, $0e220426a973ad75$export$2e2bcd8739ae039)(id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3f66fbfc482f10f$export$2e2bcd8739ae039), {
                title: `${t("common.peruna")} ${new Date().getFullYear()}`
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a2a6b1040c5d176$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: breakpoints.layout,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5358ea1077bf4480$export$2e2bcd8739ae039), {
                        routes: nav,
                        formId: id
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $887ea0d447fd8b9f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            className: breakpoints.routes,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926608a7a86d7371$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e64fcd986b51089d$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).vastauskoodit,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddea074113ade8ae$export$2e2bcd8739ae039), {
                                            nextPath: (0, $df5bef30413a053b$export$385fc1c9ea2be551)((0, $155cd4757147cec6$export$2e2bcd8739ae039).satojavarastot)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).satojavarastot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67bc916cd0e3377c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).kiitos,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa94ada6e399577f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).yhteenveto,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9637e8f2a6152bad$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).lisatiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cb0e2542d1bcd2d$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        })
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");















var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");










const $4f87ac2afbd62aae$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        lukeLink: {}
    }));
function $4f87ac2afbd62aae$export$2e2bcd8739ae039() {
    const classes = $4f87ac2afbd62aae$var$useStyles();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const logout = (0, $e4f5da8c80007dda$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const handleDownloadClick = ()=>{
        window.print();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        sx: {
                            ["@media print"]: {
                                display: "none"
                            }
                        },
                        children: t("common.kiitos")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: t("common.kiitosTekstiSato1.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: t("common.kiitosTekstiSato1.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    t("common.kiitosTilastoteksti"),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: classes.lukeLink,
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        href: t("common.kiitosTilastolinkki"),
                                        children: t("common.kiitos.linkiteksti")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: "none",
                            ["@media print"]: {
                                display: "block"
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f172a1bdf4b6cb8f$export$c4fed20b2e4a2401), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$e70d566b96318985), {
                                text: t("common.uusilomake"),
                                onClick: ()=>navigate("/aloitus")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f172a1bdf4b6cb8f$export$8ae807fc5204eb26), {
                                        onClick: handleDownloadClick
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                                        text: t("common.logout"),
                                        onClick: ()=>logout()
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$e70d566b96318985), {
                        text: t("common.uusilomake"),
                        onClick: ()=>navigate("/aloitus")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$676e60fda78d8a0b), {
                        text: t("common.logout"),
                        onClick: ()=>logout()
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");

















function $dd0fbecfde8a8ccd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const lisatiedot = (0, $3cb876d77e75d0d9$export$4bddc3220ee593d8)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            Lisatiedot: lisatiedot
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $91cfdcf11b4ccb63$export$e404dc3ff33af774)())
    });
    const handlePreviousClick = ()=>{
        navigate("/sato/rehunurmen-satotiedot");
    };
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 8
        }));
        navigate("/sato/yhteenveto");
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    const lisatietoError = methods.formState.errors.Lisatiedot && methods.formState.errors.Lisatiedot[(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]?.message;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "8. ",
                            t("Lis\xe4tiedot.title")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: t("lis\xe4tiedot.ohjeteksti")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            item: true,
                            md: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `Lisatiedot.${(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                                variant: "standard",
                                                inputRef: ref,
                                                ...field,
                                                error: !!lisatietoError,
                                                multiline: true,
                                                fullWidth: true,
                                                label: t("fields.Lis\xe4tiedot")
                                            }),
                                            !!lisatietoError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), {
                                                error: true,
                                                children: t(lisatietoError)
                                            })
                                        ]
                                    })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onPrevious: handlePreviousClick,
                            onNext: handleNextClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "8/9",
                    onPrevious: handlePreviousClick,
                    onNext: handleNextClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");



















var $ayMG0 = parcelRequire("ayMG0");
var $a949128807fcb708$exports = {};
"use strict";

Object.defineProperty($a949128807fcb708$exports, "__esModule", {
    value: true
});
$a949128807fcb708$exports.default = void 0;

var $a949128807fcb708$var$_createSvgIcon = $edd7271c3062ef00$exports((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a949128807fcb708$var$_default = (0, $a949128807fcb708$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), "Info");
$a949128807fcb708$exports.default = $a949128807fcb708$var$_default;





var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
const $5153345ca3bcedbd$var$SectionSubtitle = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        sx: {
            fontWeight: "bold"
        },
        children: children
    });
var $5153345ca3bcedbd$export$2e2bcd8739ae039 = $5153345ca3bcedbd$var$SectionSubtitle;




var $f1q41 = parcelRequire("f1q41");

var $4c9b00ba8367062d$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["Viljelyala"] = "_610920941";
    Fields["Korjuuala"] = "_610920919";
    Fields["Satom\xe4\xe4r\xe4"] = "_566014545";
    Fields["Satotaso"] = "_Satotaso";
})($4c9b00ba8367062d$export$833b3e5a19fb8939 || ($4c9b00ba8367062d$export$833b3e5a19fb8939 = {}));
let $4c9b00ba8367062d$var$prop, $4c9b00ba8367062d$var$prop1, $4c9b00ba8367062d$var$prop2, $4c9b00ba8367062d$var$prop3, $4c9b00ba8367062d$var$prop4;
class $4c9b00ba8367062d$export$dfb283d0337e707f {
    static #_ = (()=>{
        $4c9b00ba8367062d$var$prop = $4c9b00ba8367062d$export$833b3e5a19fb8939.Kasvilaji;
        $4c9b00ba8367062d$var$prop1 = $4c9b00ba8367062d$export$833b3e5a19fb8939.Viljelyala;
        $4c9b00ba8367062d$var$prop2 = $4c9b00ba8367062d$export$833b3e5a19fb8939.Korjuuala;
        $4c9b00ba8367062d$var$prop3 = $4c9b00ba8367062d$export$833b3e5a19fb8939.Satomäärä;
        $4c9b00ba8367062d$var$prop4 = $4c9b00ba8367062d$export$833b3e5a19fb8939.Satotaso;
    })();
    constructor(kasvilaji, viljelyala){
        this[$4c9b00ba8367062d$var$prop1] = null;
        this[$4c9b00ba8367062d$var$prop2] = null;
        this[$4c9b00ba8367062d$var$prop3] = null;
        this[$4c9b00ba8367062d$var$prop4] = null;
        this[$4c9b00ba8367062d$export$833b3e5a19fb8939.Kasvilaji] = kasvilaji;
        if (viljelyala) this[$4c9b00ba8367062d$export$833b3e5a19fb8939.Viljelyala] = viljelyala;
    }
}
var $4c9b00ba8367062d$export$2e2bcd8739ae039 = (0, $920660c8aca77688$exports).object().shape({
    MuutViljelykasvitSatotiedot: (0, $920660c8aca77688$exports).array().of((0, $920660c8aca77688$exports).object().shape({
        [$4c9b00ba8367062d$export$833b3e5a19fb8939.Kasvilaji]: (0, $920660c8aca77688$exports).string().required(),
        [$4c9b00ba8367062d$export$833b3e5a19fb8939.Viljelyala]: (0, $ab5958319bb12700$export$d65ba4b80d352978).notNull(0, "fields.errors.viljelyalaRequired"),
        [$4c9b00ba8367062d$export$833b3e5a19fb8939.Korjuuala]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).requiredWith($4c9b00ba8367062d$export$833b3e5a19fb8939.Viljelyala, "fields.errors.korjuualaRequired").test("harvestedAreaMax", "fields.errors.yliViljelyalan", function(item) {
            if (!item) return true;
            return this.parent[$4c9b00ba8367062d$export$833b3e5a19fb8939.Viljelyala] >= (0, $f1q41.sum)([
                item
            ]);
        }),
        [$4c9b00ba8367062d$export$833b3e5a19fb8939.Satomäärä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).requiredWith($4c9b00ba8367062d$export$833b3e5a19fb8939.Korjuuala, "fields.errors.sadonKokonaism\xe4\xe4r\xe4Required"),
        [$4c9b00ba8367062d$export$833b3e5a19fb8939.Satotaso]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _387247: 4000,
            _387251: 4000,
            _387255: 70000,
            _387259: 3000
        }, {
            kasvilaji: $4c9b00ba8367062d$export$833b3e5a19fb8939.Kasvilaji
        }))
    }))
});


const $5dd4f00a23007cb8$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        sectionHeader: {
            display: "flex",
            alignItems: "flex-end"
        },
        title: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        },
        transText: {
            fontSize: "1.2em"
        },
        acreField: {
            minWidth: "275px"
        }
    }));
function $5dd4f00a23007cb8$export$2e2bcd8739ae039({ field: field, index: index }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const classes = $5dd4f00a23007cb8$var$useStyles();
    const viljelyAla = methods.watch(`MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Viljelyala}`);
    const korjuuala = methods.watch(`MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Korjuuala}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`MuutViljelykasvitSatotiedot.${index}.${[
                (0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satomäärä
            ]}`, null);
            methods.setValue(`MuutViljelykasvitSatotiedot.${index}.${[
                (0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satotaso
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    (0, $acw62.useEffect)(()=>{
        if (viljelyAla === 0) {
            methods.setValue(`MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Korjuuala}`, null);
            methods.setValue(`MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satomäärä}`, null);
            methods.setValue(`MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satotaso}`, null);
        }
    }, [
        viljelyAla
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satomäärä}`, `MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Korjuuala}`, `MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satotaso}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        item: true,
        md: 6,
        xs: 12,
        mb: 2,
        columnSpacing: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                className: classes.sectionHeader,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
                            id: field.Kasvilaji
                        })
                    }),
                    field[(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Kasvilaji] === "_387247" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                        tabIndex: 0,
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            className: classes.transText,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                i18nKey: "muutViljelyKasvit.kumina.ohjeteksti.Viljelyala",
                                components: {
                                    b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                                },
                                values: {
                                    ed_vuosi: new Date().getFullYear() - 1,
                                    vuosi: new Date().getFullYear()
                                },
                                children: t("muutViljelyKasvit.kumina.ohjeteksti.Viljelyala")
                            })
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a949128807fcb708$exports))), {
                            sx: {
                                color: "#0079C9",
                                top: "-10px",
                                left: "10px",
                                position: "relative"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                md: 12,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Viljelyala}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            inputRef: ref,
                            ...field,
                            className: classes.acreField,
                            label: "Viljelyala"
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                mt: 3,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5153345ca3bcedbd$export$2e2bcd8739ae039), {
                    children: t("ValkuaiskasvienSatotiedot.Korjuutiedot")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Korjuuala}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            inputRef: ref,
                            ...field,
                            fullWidth: true,
                            label: "Korjuuala",
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            },
                            disabled: viljelyAla === 0
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satomäärä}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            fullWidth: true,
                            label: "SadonKokonaism\xe4\xe4r\xe4",
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: viljelyAla === 0 || korjuuala === 0
                        })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `MuutViljelykasvitSatotiedot.${index}.${(0, $4c9b00ba8367062d$export$833b3e5a19fb8939).Satotaso}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            fullWidth: true,
                            label: "satotaso",
                            disabled: viljelyAla === 0 || korjuuala === 0
                        })
                })
            })
        ]
    }, index);
}



const $02d84a493b1910fa$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        sectionHeader: {
            display: "flex",
            alignItems: "flex-end"
        },
        title: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        }
    }));
function $02d84a493b1910fa$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const classes = $02d84a493b1910fa$var$useStyles();
    const muutkasvit = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ meta: meta })=>meta.muutkasvit);
    const MuutViljelykasvitSatotiedot = (0, $d8fc8d639f906efc$export$2105062e25df4afe)(({ form: form })=>form.MuutViljelykasvitSatotiedot);
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            MuutViljelykasvitSatotiedot: MuutViljelykasvitSatotiedot.sort((a, b)=>{
                const cropA = muutkasvit.find((row)=>row.id === a.Kasvilaji);
                const cropB = muutkasvit.find((row)=>row.id === b.Kasvilaji);
                if (!cropA || !cropB) return -1;
                return cropA.order - cropB.order;
            })
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $4c9b00ba8367062d$export$2e2bcd8739ae039))
    });
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "MuutViljelykasvitSatotiedot"
    });
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 4
        }));
        navigate("/sato/perunan-satotiedot");
    };
    const handlePreviousClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)(values));
        navigate("/sato/valkuaiskasvien-satotiedot");
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "4. ",
                            t("muutViljelyKasvit.title")
                        ]
                    }),
                    MuutViljelykasvitSatotiedot?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b61f53edf67636e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: ttyyppi === 2 ? t("muutViljelyKasvit.ohjeteksti.tayttoohje.luomu") : t("muutViljelyKasvit.ohjeteksti.tayttoohje")
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5dd4f00a23007cb8$export$2e2bcd8739ae039), {
                                        field: field,
                                        index: index
                                    }, index)
                                }, field.Kasvilaji))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onNext: handleNextClick,
                            onPrevious: handlePreviousClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "4/9",
                    onNext: handleNextClick,
                    onPrevious: handlePreviousClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



















var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");








var $9113ca47095180cd$export$833b3e5a19fb8939;
(function(Fields) {
    Fields["Kasvilaji"] = "Kasvilaji";
    Fields["Istutusala"] = "_610920917";
    Fields["Korjuuala"] = "_610920919";
    Fields["Satom\xe4\xe4r\xe4"] = "_566014545";
    Fields["Sadostamyyty1510"] = "_5660386979";
    Fields["Varastossa1510"] = "_5660386963";
    Fields["Satotaso"] = "_Satotaso";
    Fields["IstutusalaYhteens\xe4"] = "_610920917386899";
    Fields["KorjattuAlaYhteens\xe4"] = "_610920919386899";
})($9113ca47095180cd$export$833b3e5a19fb8939 || ($9113ca47095180cd$export$833b3e5a19fb8939 = {}));
let $9113ca47095180cd$var$prop, $9113ca47095180cd$var$prop1, $9113ca47095180cd$var$prop2, $9113ca47095180cd$var$prop3, $9113ca47095180cd$var$prop4, $9113ca47095180cd$var$prop5, $9113ca47095180cd$var$prop6;
class $9113ca47095180cd$export$589212d15f250602 {
    static #_ = (()=>{
        $9113ca47095180cd$var$prop = $9113ca47095180cd$export$833b3e5a19fb8939.Kasvilaji;
        $9113ca47095180cd$var$prop1 = $9113ca47095180cd$export$833b3e5a19fb8939.Istutusala;
        $9113ca47095180cd$var$prop2 = $9113ca47095180cd$export$833b3e5a19fb8939.Korjuuala;
        $9113ca47095180cd$var$prop3 = $9113ca47095180cd$export$833b3e5a19fb8939.Satomäärä;
        $9113ca47095180cd$var$prop4 = $9113ca47095180cd$export$833b3e5a19fb8939.Sadostamyyty1510;
        $9113ca47095180cd$var$prop5 = $9113ca47095180cd$export$833b3e5a19fb8939.Varastossa1510;
        $9113ca47095180cd$var$prop6 = $9113ca47095180cd$export$833b3e5a19fb8939.Satotaso;
    })();
    constructor(Kasvilaji, IstutusAla){
        this[$9113ca47095180cd$var$prop1] = null;
        this[$9113ca47095180cd$var$prop2] = null;
        this[$9113ca47095180cd$var$prop3] = null;
        this[$9113ca47095180cd$var$prop4] = null;
        this[$9113ca47095180cd$var$prop5] = null;
        this[$9113ca47095180cd$var$prop6] = null;
        this[$9113ca47095180cd$export$833b3e5a19fb8939.Kasvilaji] = Kasvilaji;
        if (IstutusAla) this[$9113ca47095180cd$export$833b3e5a19fb8939.Istutusala] = IstutusAla;
    }
}
var $9113ca47095180cd$export$2e2bcd8739ae039 = (0, $920660c8aca77688$exports).object().shape({
    PerunanSatotiedotYhteensa: (0, $920660c8aca77688$exports).object().shape({
        [$9113ca47095180cd$export$833b3e5a19fb8939.IstutusalaYhteensä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5),
        [$9113ca47095180cd$export$833b3e5a19fb8939.KorjattuAlaYhteensä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test("korjattualaMax", "fields.errors.korjattualaYlitt\xe4\xe4Istutusalan", function(item) {
            if (!item) return true;
            if (item > this.parent[$9113ca47095180cd$export$833b3e5a19fb8939.IstutusalaYhteensä]) return false;
            return true;
        })
    }),
    PerunanSatotiedot: (0, $920660c8aca77688$exports).array().of((0, $920660c8aca77688$exports).object().shape({
        [$9113ca47095180cd$export$833b3e5a19fb8939.Kasvilaji]: (0, $920660c8aca77688$exports).string().required(),
        [$9113ca47095180cd$export$833b3e5a19fb8939.Istutusala]: (0, $ab5958319bb12700$export$d65ba4b80d352978).notNull(0),
        [$9113ca47095180cd$export$833b3e5a19fb8939.Korjuuala]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).max(9999.99, "fields.errors.MaxThousands").requiredWith($9113ca47095180cd$export$833b3e5a19fb8939.Istutusala, "fields.errors.korjuualaRequired"),
        [$9113ca47095180cd$export$833b3e5a19fb8939.Satomäärä]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).requiredWith($9113ca47095180cd$export$833b3e5a19fb8939.Korjuuala, "fields.validation.numberRequired"),
        [$9113ca47095180cd$export$833b3e5a19fb8939.Satotaso]: (0, $ab5958319bb12700$export$1fdbc7003da7c7a5).test(...(0, $ab5958319bb12700$export$9c02e8b561622598)({
            _14555: 80000,
            _20921: 80000,
            _21575: 50000,
            _386987: 80000,
            _386983: 80000
        }, {
            kasvilaji: $9113ca47095180cd$export$833b3e5a19fb8939.Kasvilaji
        }))
    }))
});


const $6659c15db757f684$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        acreField: {
            minWidth: "275px"
        },
        sectionHeader: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        }
    }));
function $6659c15db757f684$export$2e2bcd8739ae039({ field: field, index: index }) {
    const classes = $6659c15db757f684$var$useStyles();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const istutusala = methods.watch(`PerunanSatotiedot.${index}.${[
        (0, $9113ca47095180cd$export$833b3e5a19fb8939).Istutusala
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (istutusala === 0) {
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Korjuuala}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satomäärä}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satotaso}`, null);
        }
    }, [
        istutusala
    ]);
    const korjuuala = methods.watch(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Korjuuala}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satomäärä}`, null);
            methods.setValue(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satotaso}`, null);
        }
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satomäärä}`, `PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Korjuuala}`, `PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satotaso}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
                    id: field.Kasvilaji
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                spacing: 2,
                container: true,
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: `PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Istutusala}`,
                            control: methods.control,
                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                    tooltip: t("fields.ohjeteksti.Esitaytto"),
                                    inputRef: ref,
                                    ...field,
                                    className: classes.acreField,
                                    label: "Istutusala"
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Korjuuala}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                        disabled: istutusala === 0,
                                        inputRef: ref,
                                        ...field,
                                        label: "Korjuuala",
                                        fullWidth: true,
                                        onChange: (e)=>{
                                            field.onChange(e);
                                            handleChangeAcres(e);
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satomäärä}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                                        disabled: istutusala === 0 || korjuuala === 0,
                                        inputRef: ref,
                                        ...field,
                                        label: "SadonKokonaism\xe4\xe4r\xe4",
                                        fullWidth: true,
                                        onChange: (e)=>{
                                            field.onChange(e);
                                            handleChangeKilograms(e);
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: `PerunanSatotiedot.${index}.${(0, $9113ca47095180cd$export$833b3e5a19fb8939).Satotaso}`,
                                control: methods.control,
                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                                        disabled: istutusala === 0 || korjuuala === 0,
                                        inputRef: ref,
                                        ...field,
                                        label: "satotaso",
                                        fullWidth: true
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    }, field.Kasvilaji);
}



function $b1414bed8eed83e0$export$2e2bcd8739ae039() {
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const PerunanSatotiedot = (0, $1c48e19d77c40bbb$export$d4b2503a359650ed)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            PerunanSatotiedot: PerunanSatotiedot
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $9113ca47095180cd$export$2e2bcd8739ae039))
    });
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "PerunanSatotiedot"
    });
    const handlePreviousClick = (values)=>{
        navigate("/sato/muiden-viljelykasvien-satotiedot");
    };
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 5
        }));
        navigate("/sato/syyskylvot");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "5. ",
                            t("perunanSato.title")
                        ]
                    }),
                    PerunanSatotiedot?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b61f53edf67636e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: ttyyppi === 2 ? t("PerunanSatotiedot.ohjeteksti.tayttoohje.luomu") : t("PerunanSatotiedot.ohjeteksti.tayttoohje")
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6659c15db757f684$export$2e2bcd8739ae039), {
                                    field: field,
                                    index: index
                                }, field.Kasvilaji)),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dd1df45664713d5$export$2e2bcd8739ae039), {
                                fields: fields
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onNext: handleNextClick,
                            onPrevious: handlePreviousClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "5/9",
                    onNext: handleNextClick,
                    onPrevious: handlePreviousClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");
















var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");
const $f892c52e52297b86$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        error: {
            color: "#d32f2f",
            margin: "10px 0"
        }
    }));
const $f892c52e52297b86$var$YUPVirheilmoitus = ({ errors: errors, id: id, type: type })=>{
    const classes = $f892c52e52297b86$var$useStyles();
    const virhe = errors[id];
    if (!virhe) return null;
    if (type && virhe.type !== type) return null;
    const { message: viesti } = virhe;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sato-yup-error-message",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
            severity: "error",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: viesti
            })
        })
    });
};
var $f892c52e52297b86$export$2e2bcd8739ae039 = $f892c52e52297b86$var$YUPVirheilmoitus;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







var $f1q41 = parcelRequire("f1q41");
const $f7c6c8b999b2f10b$export$927f83b1f9e4a918 = (value)=>{
    if (!value) return 0;
    if (typeof value !== "number") return 0;
    return value;
};
const $f7c6c8b999b2f10b$export$4b95d3471d2d2655 = (fields)=>{
    return !!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).sum((0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).compact(fields));
};
const $f7c6c8b999b2f10b$export$3c3108e6839a4adb = (fields)=>{
    const suurempiTaiPienempiKuinNolla = fields.find((korjuuKerta)=>(korjuuKerta < 0 || korjuuKerta > 0) && korjuuKerta !== null && isNaN(korjuuKerta) === false && korjuuKerta !== undefined);
    return !suurempiTaiPienempiKuinNolla;
};
const $f7c6c8b999b2f10b$export$4b8cdea6e411406d = (fields)=>{
    const notEmpty = fields.find((korjuuKerta)=>korjuuKerta !== null && korjuuKerta !== undefined && isNaN(korjuuKerta) === false);
    return !notEmpty;
};


const $a2f5aed6265e4ed4$export$2ca428a49dcf5e73 = (korjuualaRaaka, pystyynmyyntiRaaka, katoalaRaaka, pystyynostoRaaka)=>{
    const korjuuala = (0, $f7c6c8b999b2f10b$export$927f83b1f9e4a918)(korjuualaRaaka);
    const pystyynmyynti = (0, $f7c6c8b999b2f10b$export$927f83b1f9e4a918)(pystyynmyyntiRaaka);
    const katoala = (0, $f7c6c8b999b2f10b$export$927f83b1f9e4a918)(katoalaRaaka);
    const pystyynosto = (0, $f7c6c8b999b2f10b$export$927f83b1f9e4a918)(pystyynostoRaaka);
    /**
   * Kaava:
   *
   * ```
   * korjattu ala =
   *    tukihakemuksessa ilmoitettu rehunurmiala
   *  - pystyyn myyty ala
   *  - ei korjuuta tai niitetty maahan
   *  + pystyyn ostettu
   * ```
   */ const value = korjuuala - pystyynmyynti - katoala + pystyynosto;
    /**
   * If a value is a very small number close to zero, its due to decimal math processing in
   * javascript, and the correct value is actually 0.
   *
   * (Values can only be given with 2 decimals in the form, and there's only sum and difference
   * operations used in the calculator.)
   */ if (-(0, $a8fcb92d8c5bc3d8$export$19979b30ce8b3bab) < value && value < (0, $a8fcb92d8c5bc3d8$export$19979b30ce8b3bab)) return 0;
    return value;
};



const $150f5528e349880f$var$useKorjattualaValue = ({ methods: methods })=>{
    const otherFieldValues = methods.watch([
        `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuuala}`,
        `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynmyynti}`,
        `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Katoala}`,
        `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynosto}`
    ]);
    const value = (0, $a2f5aed6265e4ed4$export$2ca428a49dcf5e73)(...otherFieldValues);
    // Form validation needs to be triggered separately,
    // as it is not based on touching this field itself.
    // I.e. there is no `onBlur` event on this field (`Fields.Korjattuala`).
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjattuala}`, value);
    }, [
        value
    ]);
};
const $150f5528e349880f$var$KorjattuAla = ({ methods: methods })=>{
    $150f5528e349880f$var$useKorjattualaValue({
        methods: methods
    });
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
            name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjattuala}`,
            control: methods.control,
            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                    tooltip: t("RehunurmenSatotiedot.tooltip.Korjattuala"),
                    disabled: true,
                    inputRef: ref,
                    ...field,
                    fullWidth: true,
                    label: "Korjattuala",
                    allowNegative: true,
                    allowZeroForInputValue: true,
                    InputLabelProps: {
                        shrink: true
                    }
                })
        })
    });
};
const $150f5528e349880f$var$AlkutietoOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                children: t("RehunurmenSatotiedot.otsikko.KorjattuRehunurmiala")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuuala}`,
                            control: methods.control,
                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                    disabled: true,
                                    inputRef: ref,
                                    ...field,
                                    value: field.value || 0,
                                    fullWidth: true,
                                    label: "RehunurmialaYhteens\xe4",
                                    allowZeroForInputValue: true,
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynosto}`,
                            control: methods.control,
                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                    inputRef: ref,
                                    ...field,
                                    fullWidth: true,
                                    label: "Pystyynosto"
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Pystyynmyynti}`,
                            control: methods.control,
                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                    inputRef: ref,
                                    ...field,
                                    label: "Pystyynmyynti",
                                    fullWidth: true
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Katoala}`,
                            control: methods.control,
                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                    inputRef: ref,
                                    ...field,
                                    fullWidth: true,
                                    label: "Katoala"
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 3,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($150f5528e349880f$var$KorjattuAla, {
                            methods: methods
                        })
                    })
                ]
            })
        ]
    });
};
var $150f5528e349880f$export$2e2bcd8739ae039 = $150f5528e349880f$var$AlkutietoOsio;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







const $04dfda21834131cb$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        field: {}
    }));
const $04dfda21834131cb$var$kuivaheinaHaYhteensa = ({ methods: methods, fields: fields })=>{
    const kuivaheinaFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Kuivaheinä}`);
    const kuivaheinaFieldValues = methods.watch(kuivaheinaFieldNames);
    const summa = kuivaheinaFieldValues.reduce((acc, val)=>{
        return acc + (val || 0);
    }, 0);
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinaKorjuuAlaKaikkiKorjuukerratYhteensa}`, summa);
    }, [
        summa
    ]);
    return summa;
};
const $04dfda21834131cb$var$useSummaryValues = (fields, methods)=>{
    const kuivaheinaFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Kuivaheinä}`);
    const kuivaheinaFieldValues = methods.watch(kuivaheinaFieldNames);
    const kuivaheinaaKorjattu = (0, $f7c6c8b999b2f10b$export$4b95d3471d2d2655)(kuivaheinaFieldValues);
    const kuivaheinaKaikkiKorjuukerratNollia = (0, $f7c6c8b999b2f10b$export$3c3108e6839a4adb)(kuivaheinaFieldValues);
    const kuivaheinaKaikkiKorjuukerratTyhjia = (0, $f7c6c8b999b2f10b$export$4b8cdea6e411406d)(kuivaheinaFieldValues);
    const kuivaheinaKorjuukerratHaYhteensa = $04dfda21834131cb$var$kuivaheinaHaYhteensa({
        methods: methods,
        fields: fields
    });
    return {
        kuivaheinaaKorjattu: kuivaheinaaKorjattu,
        kuivaheinaKaikkiKorjuukerratNollia: kuivaheinaKaikkiKorjuukerratNollia,
        kuivaheinaKaikkiKorjuukerratTyhjia: kuivaheinaKaikkiKorjuukerratTyhjia,
        kuivaheinaKorjuukerratHaYhteensa: kuivaheinaKorjuukerratHaYhteensa
    };
};
const $04dfda21834131cb$var$KuivaheinaOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $04dfda21834131cb$var$useStyles();
    const rehunurmensatotiedot = methods.getValues("RehunurmenSatotiedot.Korjuu");
    const { kuivaheinaaKorjattu: kuivaheinaaKorjattu, kuivaheinaKaikkiKorjuukerratNollia: kuivaheinaKaikkiKorjuukerratNollia, kuivaheinaKaikkiKorjuukerratTyhjia: kuivaheinaKaikkiKorjuukerratTyhjia, kuivaheinaKorjuukerratHaYhteensa: kuivaheinaKorjuukerratHaYhteensa } = $04dfda21834131cb$var$useSummaryValues(rehunurmensatotiedot, methods);
    (0, $acw62.useEffect)(()=>{
        if (kuivaheinaKaikkiKorjuukerratNollia || kuivaheinaKaikkiKorjuukerratTyhjia) methods.clearErrors(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg}`);
        if (kuivaheinaaKorjattu === false) methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg}`, null);
    }, [
        kuivaheinaaKorjattu
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinaKorjuuAlaKaikkiKorjuukerratYhteensa}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoKuivaheinaYhteensa}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.Kuivahein\xe4n")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinaKorjuuAlaKaikkiKorjuukerratYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                        inputRef: ref,
                        ...field,
                        disabled: true,
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeAcres(e);
                        },
                        className: classes.field,
                        label: "KorjattuAlaYhteens\xe4"
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                        inputRef: ref,
                        ...field,
                        label: "Kuivahein\xe4",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeKilograms(e);
                        },
                        disabled: !kuivaheinaaKorjattu
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoKuivaheinaYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                        inputRef: ref,
                        ...field,
                        label: "satotaso",
                        fullWidth: true,
                        disabled: true
                    })
            })
        ]
    });
};
var $04dfda21834131cb$export$2e2bcd8739ae039 = $04dfda21834131cb$var$KuivaheinaOsio;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







const $1e2fc36c64871511$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        field: {}
    }));
const $1e2fc36c64871511$var$sailorehuTuoreHaYhteensa = ({ methods: methods, fields: fields })=>{
    const tuoresailorehuFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Säilörehu}`);
    const tuoresailorehuFieldValues = methods.watch(tuoresailorehuFieldNames);
    const summa = tuoresailorehuFieldValues.reduce((acc, val)=>{
        return acc + (val || 0);
    }, 0);
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuKorjuuAlaKaikkiKorjuukerratYhteensa}`, summa);
    }, [
        summa
    ]);
    return summa;
};
const $1e2fc36c64871511$var$useSummaryValues = (fields, methods)=>{
    const tuoresailorehuFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Säilörehu}`);
    const tuoresailorehuFieldValues = methods.watch(tuoresailorehuFieldNames);
    const tuoresailorehuaKorjattu = (0, $f7c6c8b999b2f10b$export$4b95d3471d2d2655)(tuoresailorehuFieldValues);
    const tuoresailorehuKaikkiKorjuukerratNollia = (0, $f7c6c8b999b2f10b$export$3c3108e6839a4adb)(tuoresailorehuFieldValues);
    const tuoresailorehuKaikkiKorjuukerratTyhjia = (0, $f7c6c8b999b2f10b$export$4b8cdea6e411406d)(tuoresailorehuFieldValues);
    const tuoreSailorehuHaKaikkiKorjuuKerratyhteensa = $1e2fc36c64871511$var$sailorehuTuoreHaYhteensa({
        methods: methods,
        fields: fields
    });
    return {
        tuoresailorehuaKorjattu: tuoresailorehuaKorjattu,
        tuoresailorehuKaikkiKorjuukerratNollia: tuoresailorehuKaikkiKorjuukerratNollia,
        tuoresailorehuKaikkiKorjuukerratTyhjia: tuoresailorehuKaikkiKorjuukerratTyhjia,
        tuoreSailorehuHaKaikkiKorjuuKerratyhteensa: tuoreSailorehuHaKaikkiKorjuuKerratyhteensa
    };
};
const $1e2fc36c64871511$var$SailorehuOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $1e2fc36c64871511$var$useStyles();
    const { tuoresailorehuaKorjattu: tuoresailorehuaKorjattu, tuoresailorehuKaikkiKorjuukerratNollia: tuoresailorehuKaikkiKorjuukerratNollia, tuoresailorehuKaikkiKorjuukerratTyhjia: tuoresailorehuKaikkiKorjuukerratTyhjia, tuoreSailorehuHaKaikkiKorjuuKerratyhteensa: tuoreSailorehuHaKaikkiKorjuuKerratyhteensa } = $1e2fc36c64871511$var$useSummaryValues(methods.getValues("RehunurmenSatotiedot.Korjuu"), methods);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuKorjuuAlaKaikkiKorjuukerratYhteensa}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuYhteensa}`);
    (0, $acw62.useEffect)(()=>{
        if (tuoresailorehuKaikkiKorjuukerratNollia || tuoresailorehuKaikkiKorjuukerratTyhjia) methods.clearErrors(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg}`);
        if (tuoresailorehuaKorjattu === false) {
            methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg}`, null);
            methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuKuivaaineProsentti}`, null);
        }
    }, [
        tuoresailorehuaKorjattu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.Tuores\xe4il\xf6ttyS\xe4il\xf6rehun")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuKorjuuAlaKaikkiKorjuukerratYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                        inputRef: ref,
                        ...field,
                        disabled: true,
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeAcres(e);
                        },
                        className: classes.field,
                        label: "KorjattuAlaYhteens\xe4"
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                        inputRef: ref,
                        ...field,
                        label: "S\xe4il\xf6rehu",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeKilograms(e);
                        },
                        disabled: !tuoresailorehuaKorjattu
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                        inputRef: ref,
                        ...field,
                        label: "satotaso",
                        fullWidth: true,
                        disabled: true
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuKuivaaineProsentti}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                        inputRef: ref,
                        ...field,
                        label: "S\xe4il\xf6rehuKuivaaineProsentti",
                        fullWidth: true,
                        disabled: !tuoresailorehuaKorjattu
                    })
            })
        ]
    });
};
var $1e2fc36c64871511$export$2e2bcd8739ae039 = $1e2fc36c64871511$var$SailorehuOsio;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







const $5673dfa98bc87a07$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        field: {}
    }));
const $5673dfa98bc87a07$var$sailorehuEsikuivattuHaYhteensa = ({ methods: methods, fields: fields })=>{
    const esikuivattusailorehuFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattu}`);
    const esikuivattusailorehuFieldValues = methods.watch(esikuivattusailorehuFieldNames);
    const summa = esikuivattusailorehuFieldValues.reduce((acc, val)=>{
        return acc + (val || 0);
    }, 0);
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuEsikuivattuKorjuuAlaKaikkiKorjuukerratYhteensa}`, summa);
    }, [
        summa
    ]);
    return summa;
};
const $5673dfa98bc87a07$var$useSummaryValues = (fields, methods)=>{
    const esikuivattusailorehuFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattu}`);
    const esikuivattusailorehuFieldValues = methods.watch(esikuivattusailorehuFieldNames);
    const esikuivattuaSailorehuaKorjattu = (0, $f7c6c8b999b2f10b$export$4b95d3471d2d2655)(esikuivattusailorehuFieldValues);
    const sailorehuEsikuivattuKaikkiKorjuukerratNollia = (0, $f7c6c8b999b2f10b$export$3c3108e6839a4adb)(esikuivattusailorehuFieldValues);
    const sailorehuEsikuivattuKaikkiKorjuukerratTyhjia = (0, $f7c6c8b999b2f10b$export$4b8cdea6e411406d)(esikuivattusailorehuFieldValues);
    const sailorehuEsikuivattuKorjuukerratHaYhteensa = $5673dfa98bc87a07$var$sailorehuEsikuivattuHaYhteensa({
        methods: methods,
        fields: fields
    });
    return {
        esikuivattuaSailorehuaKorjattu: esikuivattuaSailorehuaKorjattu,
        sailorehuEsikuivattuKaikkiKorjuukerratNollia: sailorehuEsikuivattuKaikkiKorjuukerratNollia,
        sailorehuEsikuivattuKaikkiKorjuukerratTyhjia: sailorehuEsikuivattuKaikkiKorjuukerratTyhjia,
        sailorehuEsikuivattuKorjuukerratHaYhteensa: sailorehuEsikuivattuKorjuukerratHaYhteensa
    };
};
const $5673dfa98bc87a07$var$EsikuivattuSailorehuOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $5673dfa98bc87a07$var$useStyles();
    const { esikuivattuaSailorehuaKorjattu: esikuivattuaSailorehuaKorjattu, sailorehuEsikuivattuKaikkiKorjuukerratNollia: sailorehuEsikuivattuKaikkiKorjuukerratNollia, sailorehuEsikuivattuKaikkiKorjuukerratTyhjia: sailorehuEsikuivattuKaikkiKorjuukerratTyhjia, sailorehuEsikuivattuKorjuukerratHaYhteensa: sailorehuEsikuivattuKorjuukerratHaYhteensa } = $5673dfa98bc87a07$var$useSummaryValues(methods.getValues("RehunurmenSatotiedot.Korjuu"), methods);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuEsikuivattuKorjuuAlaKaikkiKorjuukerratYhteensa}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuEsikuivattuYhteensa}`);
    (0, $acw62.useEffect)(()=>{
        if (sailorehuEsikuivattuKaikkiKorjuukerratNollia || sailorehuEsikuivattuKaikkiKorjuukerratTyhjia) methods.clearErrors(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg}`);
        if (esikuivattuaSailorehuaKorjattu === false) {
            methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg}`, null);
            methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuKuivaaineProsentti}`, null);
        }
    }, [
        esikuivattuaSailorehuaKorjattu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.EsikuivattuS\xe4il\xf6rehun")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SailorehuEsikuivattuKorjuuAlaKaikkiKorjuukerratYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                        inputRef: ref,
                        ...field,
                        disabled: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeAcres(e);
                        },
                        fullWidth: true,
                        className: classes.field,
                        label: "KorjattuAlaYhteens\xe4"
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                        inputRef: ref,
                        ...field,
                        label: "S\xe4il\xf6rehuEsikuivattu",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeKilograms(e);
                        },
                        disabled: !esikuivattuaSailorehuaKorjattu
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoSailorehuEsikuivattuYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                        inputRef: ref,
                        ...field,
                        label: "satotaso",
                        fullWidth: true,
                        disabled: true
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuKuivaaineProsentti}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                        inputRef: ref,
                        ...field,
                        label: "S\xe4il\xf6rehuEsikuivattuKuivaaineProsentti",
                        fullWidth: true,
                        disabled: !esikuivattuaSailorehuaKorjattu
                    })
            })
        ]
    });
};
var $5673dfa98bc87a07$export$2e2bcd8739ae039 = $5673dfa98bc87a07$var$EsikuivattuSailorehuOsio;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");







const $6f6898da23b6215b$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        field: {}
    }));
const $6f6898da23b6215b$var$niittorehuHaYhteensa = ({ methods: methods, fields: fields })=>{
    const niittorehuFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Niittorehu}`);
    const niittorehuFieldValues = methods.watch(niittorehuFieldNames);
    const summa = niittorehuFieldValues.reduce((acc, val)=>{
        return acc + (val || 0);
    }, 0);
    (0, $acw62.useEffect)(()=>{
        methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKorjuuAlaKaikkiKorjuukerratYhteensa}`, summa);
    }, [
        summa
    ]);
    return summa;
};
const $6f6898da23b6215b$var$useSummaryValues = (fields, methods)=>{
    const niittorehuFieldNames = fields.map((_, index)=>`RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Niittorehu}`);
    const niittorehuFieldValues = methods.watch(niittorehuFieldNames);
    const niittorehuaKorjattu = (0, $f7c6c8b999b2f10b$export$4b95d3471d2d2655)(niittorehuFieldValues);
    const niittorehuKaikkiKorjuukerratNollia = (0, $f7c6c8b999b2f10b$export$3c3108e6839a4adb)(niittorehuFieldValues);
    const niittorehuKaikkiKorjuukerratTyhjia = (0, $f7c6c8b999b2f10b$export$4b8cdea6e411406d)(niittorehuFieldValues);
    const niittorehuKorjuukerratHaYhteensa = $6f6898da23b6215b$var$niittorehuHaYhteensa({
        methods: methods,
        fields: fields
    });
    return {
        niittorehuaKorjattu: niittorehuaKorjattu,
        niittorehuKaikkiKorjuukerratNollia: niittorehuKaikkiKorjuukerratNollia,
        niittorehuKaikkiKorjuukerratTyhjia: niittorehuKaikkiKorjuukerratTyhjia,
        niittorehuKorjuukerratHaYhteensa: niittorehuKorjuukerratHaYhteensa
    };
};
const $6f6898da23b6215b$var$NiittorehuOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $6f6898da23b6215b$var$useStyles();
    const { niittorehuaKorjattu: niittorehuaKorjattu, niittorehuKaikkiKorjuukerratNollia: niittorehuKaikkiKorjuukerratNollia, niittorehuKaikkiKorjuukerratTyhjia: niittorehuKaikkiKorjuukerratTyhjia, niittorehuKorjuukerratHaYhteensa: niittorehuKorjuukerratHaYhteensa } = $6f6898da23b6215b$var$useSummaryValues(methods.getValues("RehunurmenSatotiedot.Korjuu"), methods);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKorjuuAlaKaikkiKorjuukerratYhteensa}`, `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoNiittorehuYhteensa}`);
    (0, $acw62.useEffect)(()=>{
        if (niittorehuKaikkiKorjuukerratNollia || niittorehuKaikkiKorjuukerratTyhjia) {
            methods.clearErrors(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg}`);
            methods.clearErrors(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKuivaaineProsentti}`);
        }
        if (niittorehuaKorjattu === false) {
            methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg}`, null);
            methods.setValue(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKuivaaineProsentti}`, null);
        }
    }, [
        niittorehuaKorjattu
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    fontWeight: "bold"
                },
                pt: 4,
                children: t("RehunurmenSatotiedot.Niittorehun")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKorjuuAlaKaikkiKorjuukerratYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                        inputRef: ref,
                        ...field,
                        disabled: true,
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeAcres(e);
                        },
                        className: classes.field,
                        label: "KorjattuAlaYhteens\xe4"
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                        inputRef: ref,
                        ...field,
                        label: "Niittorehu",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeKilograms(e);
                        },
                        disabled: !niittorehuaKorjattu
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SatotasoNiittorehuYhteensa}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                        inputRef: ref,
                        ...field,
                        label: "satotaso",
                        fullWidth: true,
                        disabled: true
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKuivaaineProsentti}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                        inputRef: ref,
                        ...field,
                        label: "NiittorehuKuivaaineProsentti",
                        fullWidth: true,
                        disabled: !niittorehuaKorjattu
                    })
            })
        ]
    });
};
var $6f6898da23b6215b$export$2e2bcd8739ae039 = $6f6898da23b6215b$var$NiittorehuOsio;


const $8e14f5275ac146c3$var$KokonaissatoOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                children: t("RehunurmenSatotiedot.otsikko.Kokonaissato")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 0,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    item: true,
                    md: 6,
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04dfda21834131cb$export$2e2bcd8739ae039), {
                            methods: methods
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e2fc36c64871511$export$2e2bcd8739ae039), {
                            methods: methods
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5673dfa98bc87a07$export$2e2bcd8739ae039), {
                            methods: methods
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f6898da23b6215b$export$2e2bcd8739ae039), {
                            methods: methods
                        })
                    ]
                })
            })
        ]
    });
};
var $8e14f5275ac146c3$export$2e2bcd8739ae039 = $8e14f5275ac146c3$var$KokonaissatoOsio;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");






const $0e143b97cb9c368c$var$KorjuualaOsio = ({ methods: methods })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "RehunurmenSatotiedot.Korjuu"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                children: t("RehunurmenSatotiedot.otsikko.Korjuukerrat")
            }),
            fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                            children: [
                                index + 1,
                                ". ",
                                t("fields.Korjuukerta")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    xs: 12,
                                    children: [
                                        field[(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuu] === "_386967" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                            name: `RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Kuivaheinä}`,
                                            control: methods.control,
                                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                    inputRef: ref,
                                                    ...field,
                                                    label: "Kuivahein\xe4",
                                                    fullWidth: true
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                            name: `RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Säilörehu}`,
                                            control: methods.control,
                                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                    inputRef: ref,
                                                    ...field,
                                                    label: "S\xe4il\xf6rehu",
                                                    fullWidth: true
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                            name: `RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattu}`,
                                            control: methods.control,
                                            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                    inputRef: ref,
                                                    ...field,
                                                    label: "S\xe4il\xf6rehuEsikuivattu",
                                                    fullWidth: true
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                        name: `RehunurmenSatotiedot.Korjuu.${index}.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Niittorehu}`,
                                        control: methods.control,
                                        render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                inputRef: ref,
                                                ...field,
                                                label: "Niittorehu",
                                                fullWidth: true
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }, field[(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjuu]))
        ]
    });
};
var $0e143b97cb9c368c$export$2e2bcd8739ae039 = $0e143b97cb9c368c$var$KorjuualaOsio;



const $35e91d7ce7495b20$var$useNavigation = ()=>{
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 7
        }));
        navigate("/sato/lisatiedot");
    };
    const handlePreviousClick = (values)=>{
        navigate("/sato/syyskylvot");
    };
    return {
        handleNextClick: handleNextClick,
        handlePreviousClick: handlePreviousClick
    };
};
const $35e91d7ce7495b20$var$EiKorjuitaNäkyvissäNäkymä = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: t("RehunurmenSatotiedot.ohjeteksti4")
            })
        })
    });
};
function $35e91d7ce7495b20$export$2e2bcd8739ae039() {
    const errRef = (0, $acw62.useRef)(null);
    const values = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.form.RehunurmenSatotiedot);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            RehunurmenSatotiedot: values
        },
        mode: "onBlur",
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $987975668562e0eb$export$2e2bcd8739ae039)(t))
    });
    const { handleNextClick: handleNextClick, handlePreviousClick: handlePreviousClick } = $35e91d7ce7495b20$var$useNavigation();
    (0, $acw62.useLayoutEffect)(()=>{
        if (methods.formState.errors["RehunurmenSatotiedot"] && methods.formState.errors["RehunurmenSatotiedot"].type === "sumOfFields" && errRef.current) window.scrollTo({
            behavior: "smooth",
            top: errRef.current.offsetTop
        });
    }, [
        errRef.current,
        methods.formState.errors
    ]);
    const korjattuala = methods.watch(`RehunurmenSatotiedot.${(0, $987975668562e0eb$export$833b3e5a19fb8939).Korjattuala}`);
    const ovatkoKorjuutNäkyvissä = !!korjattuala && korjattuala > 0;
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    (0, $acw62.useEffect)(()=>{
        if (!ovatkoKorjuutNäkyvissä) {
            [
                0,
                1,
                2
            ].forEach((korjuu)=>{
                [
                    (0, $987975668562e0eb$export$833b3e5a19fb8939).Kuivaheinä,
                    (0, $987975668562e0eb$export$833b3e5a19fb8939).Säilörehu,
                    (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattu,
                    (0, $987975668562e0eb$export$833b3e5a19fb8939).Niittorehu
                ].forEach((field)=>{
                    methods.resetField(`RehunurmenSatotiedot.Korjuu.${korjuu}.${field}`, {
                        defaultValue: null
                    });
                });
            });
            [
                (0, $987975668562e0eb$export$833b3e5a19fb8939).KuivaheinäYhteensäKg,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuYhteensäKg,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuKuivaaineProsentti,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuYhteensäKg,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattu,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).SäilörehuEsikuivattuKuivaaineProsentti,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuKuivaaineProsentti,
                (0, $987975668562e0eb$export$833b3e5a19fb8939).NiittorehuYhteensäKg
            ].forEach((field)=>{
                methods.resetField(`RehunurmenSatotiedot.${field}`, {
                    defaultValue: null
                });
            });
        }
    }, [
        korjattuala
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "7. ",
                            t("RehunurmenSatotiedot.title")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            i18nKey: ttyyppi === 2 ? "RehunurmenSatotiedot.tukihakemus_luomu" : "RehunurmenSatotiedot.tukihakemus",
                            components: {
                                b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $150f5528e349880f$export$2e2bcd8739ae039), {
                        methods: methods
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: errRef,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f892c52e52297b86$export$2e2bcd8739ae039), {
                            errors: methods.formState.errors,
                            id: "RehunurmenSatotiedot",
                            type: "sumOfFields"
                        })
                    }),
                    ovatkoKorjuutNäkyvissä ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: t("RehunurmenSatotiedot.ohjeteksti2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0e143b97cb9c368c$export$2e2bcd8739ae039), {
                                methods: methods
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "RehunurmenSatotiedot.ohjeteksti3",
                                    components: {
                                        p: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {}),
                                        a: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {})
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e14f5275ac146c3$export$2e2bcd8739ae039), {
                                methods: methods
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($35e91d7ce7495b20$var$EiKorjuitaNäkyvissäNäkymä, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onNext: handleNextClick,
                            onPrevious: handlePreviousClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "7/9",
                    onNext: handleNextClick,
                    onPrevious: handlePreviousClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



parcelRequire("acw62");




















const $41eeefaa6f60cc17$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        acreField: {
            minWidth: "275px"
        },
        sectionHeader: {
            display: "flex",
            alignItems: "flex-end"
        }
    }));
function $41eeefaa6f60cc17$export$2e2bcd8739ae039() {
    const classes = $41eeefaa6f60cc17$var$useStyles();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const values = (0, $af1189b7d638610c$export$9aa81cac6926090e)();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            Syyskylvot: values
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $af1189b7d638610c$export$2e2bcd8739ae039))
    });
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "Syyskylvot"
    });
    const handlePreviousClick = (values)=>{
        navigate("/sato/perunan-satotiedot");
    };
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 6
        }));
        navigate("/sato/rehunurmen-satotiedot");
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "6. ",
                            t("syyskylvot.title")
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "body1",
                            children: ttyyppi === 2 ? t("Syyskylvot.ohjeteksti.tayttoohje.luomu") : t("Syyskylvot.ohjeteksti.tayttoohje")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            children: fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    xs: 12,
                                    columnSpacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 12,
                                            md: 4,
                                            className: classes.sectionHeader,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                sx: {
                                                    "&:first-letter": {
                                                        textTransform: "capitalize"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
                                                        id: field.Kasvilaji
                                                    }),
                                                    index === 0 && " " + t("syyskylvot.syysvehna.spelttivehna")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            item: true,
                                            md: 4,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                name: `Syyskylvot.${index}.${(0, $af1189b7d638610c$export$833b3e5a19fb8939).Kylvöala}`,
                                                control: methods.control,
                                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                        autoFocus: true,
                                                        inputRef: ref,
                                                        ...field,
                                                        label: "Kylvoala",
                                                        fullWidth: true
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            item: true,
                                            md: 4,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                name: `Syyskylvot.${index}.${(0, $af1189b7d638610c$export$833b3e5a19fb8939).Suorakylvöala}`,
                                                control: methods.control,
                                                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                        inputRef: ref,
                                                        tooltip: t("syyskylvot.ohjeteksti.SuorakylvoalaOhje"),
                                                        ...field,
                                                        fullWidth: true,
                                                        label: "Suorakylvoala"
                                                    })
                                            })
                                        })
                                    ]
                                }, field.Kasvilaji))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onNext: handleNextClick,
                            onPrevious: handlePreviousClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "6/9",
                    onNext: handleNextClick,
                    onPrevious: handlePreviousClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



parcelRequire("acw62");
























var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



function $8f5fb0dc99c6388e$export$2e2bcd8739ae039({ index: index }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const viljelyAla = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Viljelyala}`);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: viljelyAla === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: t("ValkuaiskasvienSatotiedot.eiKorjattuaAlaa")
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $f3842039beddd7c4$export$2e2bcd8739ae039({ field: field, index: index }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const viljelyAla = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Viljelyala}`);
    const korjuuala = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi
            ]}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoÖljykasvi
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    (0, $acw62.useEffect)(()=>{
        if (viljelyAla === 0) {
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva}`, null);
            methods.trigger([
                `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi}`,
                `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi}`,
                `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva}`
            ]);
        }
    }, [
        viljelyAla
    ]);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala) methods.clearErrors(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi}`);
        else methods.clearErrors(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi}`);
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi}`, `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi}`, `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoÖljykasvi}`);
    if (viljelyAla === 0) return null;
    switch(field.Kasvilaji){
        case "_387023":
            break;
        case "_387019":
            break;
        case "_387027":
            break;
        case "_387243":
            break;
        case "_386999":
            break;
        case "_387003":
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        item: true,
        md: 6,
        xs: 12,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5153345ca3bcedbd$export$2e2bcd8739ae039), {
                children: t("ValkuaiskasvienSatotiedot.Korjuutiedot")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaÖljykasvi}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                        disabled: viljelyAla === 0,
                        inputRef: ref,
                        ...field,
                        label: "Korjuuala",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeAcres(e);
                        }
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatomääräÖljykasvi}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                        inputRef: ref,
                        ...field,
                        label: "SadonKokonaism\xe4\xe4r\xe4",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeKilograms(e);
                        },
                        disabled: !korjuuala
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoÖljykasvi}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                        inputRef: ref,
                        ...field,
                        label: "satotaso",
                        fullWidth: true,
                        disabled: !korjuuala
                    })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $7f9bd897c974936f$export$2e2bcd8739ae039({ field: field, index: index }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const viljelyAla = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Viljelyala}`);
    const korjuuala = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato
            ]}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    (0, $acw62.useEffect)(()=>{
        if (viljelyAla === 0) {
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu}`, null);
        }
    }, [
        viljelyAla
    ]);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala) methods.clearErrors(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu}`);
        else methods.clearErrors(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato}`);
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato}`, `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala}`, `ValkuaiskasvienSatotiedot.${index}.Satotaso_Kuiva`);
    if (viljelyAla === 0) return null;
    switch(field.Kasvilaji){
        case "_387139":
            break;
        case "_386579":
            break;
        case "_61223":
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        item: true,
        md: 6,
        xs: 12,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5153345ca3bcedbd$export$2e2bcd8739ae039), {
                children: t("ValkuaiskasvienSatotiedot.KuivattavaKasvi")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                        inputRef: ref,
                        disabled: viljelyAla === 0,
                        ...field,
                        label: "Kuivakorjuuala",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeAcres(e);
                        }
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Sato}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                        inputRef: ref,
                        ...field,
                        label: "KuivattuKokonaism\xe4\xe4r\xe4",
                        fullWidth: true,
                        onChange: (e)=>{
                            field.onChange(e);
                            handleChangeKilograms(e);
                        },
                        disabled: korjuuala === 0 || viljelyAla === 0
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoKuiva}`,
                control: methods.control,
                render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                        inputRef: ref,
                        ...field,
                        label: "KuivasadonSatotaso",
                        fullWidth: true,
                        disabled: korjuuala === 0 || viljelyAla === 0
                    })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $35348714b7d522e6$export$2e2bcd8739ae039({ field: field, index: index }) {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const viljelyAla = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Viljelyala}`);
    const korjuuala = methods.watch(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu
            ]}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoTuore
            ]}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${[
                (0, $d6577b6792f647a6$export$833b3e5a19fb8939).KuivaaineSäilörehu
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    (0, $acw62.useEffect)(()=>{
        if (viljelyAla === 0) {
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoTuore}`, null);
            methods.setValue(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KuivaaineSäilörehu}`, null);
        }
    }, [
        viljelyAla
    ]);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) methods.clearErrors([
            `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Korjuuala}`
        ]);
        else methods.clearErrors([
            `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu}`,
            `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KuivaaineSäilörehu}`
        ]);
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu}`, `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu}`, `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoTuore}`);
    if (viljelyAla === 0) return null;
    if (field.Kasvilaji !== "_386579" && field.Kasvilaji !== "_61223") return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            item: true,
            md: 6,
            xs: 12,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5153345ca3bcedbd$export$2e2bcd8739ae039), {
                    children: t("ValkuaiskasvienSatotiedot.S\xe4il\xf6rehu")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KorjuualaSäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            disabled: viljelyAla === 0,
                            inputRef: ref,
                            ...field,
                            label: "S\xe4il\xf6rehunKorjuuala",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            }
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatoSäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            label: "TuoresadonKokonaism\xe4\xe4r\xe4",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: korjuuala === 0 || viljelyAla === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).SatotasoTuore}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            label: "TuoresadonSatotaso",
                            fullWidth: true,
                            disabled: korjuuala === 0 || viljelyAla === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).KuivaaineSäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                            inputRef: ref,
                            ...field,
                            label: "KuivaaineProsentti",
                            fullWidth: true,
                            disabled: korjuuala === 0
                        })
                })
            ]
        })
    });
}



const $9714e0dcba67134c$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        acreField: {
            minWidth: "275px"
        },
        sectionHeader: {
            "&:first-letter": {
                textTransform: "capitalize"
            }
        }
    }));
function $9714e0dcba67134c$export$2e2bcd8739ae039() {
    const classes = $9714e0dcba67134c$var$useStyles();
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const cropVals = (0, $1c48e19d77c40bbb$export$6dc76d0fc8fd54c5)();
    const cropOpts = (0, $0eab64f4fb796a14$export$6dae7db33dd9c904)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            ValkuaiskasvienSatotiedot: cropVals
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $d6577b6792f647a6$export$2e2bcd8739ae039))
    });
    const getSatotaso = (0, $1ec6fc95823d038d$export$2e2bcd8739ae039)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "ValkuaiskasvienSatotiedot"
    });
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 3
        }));
        navigate("/sato/muiden-viljelykasvien-satotiedot");
    };
    const handlePreviousClick = (values)=>{
        navigate("/sato/viljan-varastot");
    };
    (0, $323874ab8248d257$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "3. ",
                            t("ValkuaiskasvienSatotiedot.title")
                        ]
                    }),
                    cropVals?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b61f53edf67636e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: ttyyppi === 2 ? t("ValkuaiskasvienSatotiedot.ohjeteksti.tayttoohje.luomu") : t("ValkuaiskasvienSatotiedot.ohjeteksti.tayttoohje")
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
                                                id: field.Kasvilaji
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            spacing: 4,
                                            container: true,
                                            item: true,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                                    item: true,
                                                    md: 12,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                                        name: `ValkuaiskasvienSatotiedot.${index}.${(0, $d6577b6792f647a6$export$833b3e5a19fb8939).Viljelyala}`,
                                                        control: methods.control,
                                                        render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                                                                inputRef: ref,
                                                                ...field,
                                                                className: classes.acreField,
                                                                label: "Viljelyala"
                                                            })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f5fb0dc99c6388e$export$2e2bcd8739ae039), {
                                                    index: index
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f9bd897c974936f$export$2e2bcd8739ae039), {
                                                    field: field,
                                                    index: index
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35348714b7d522e6$export$2e2bcd8739ae039), {
                                                    field: field,
                                                    index: index
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3842039beddd7c4$export$2e2bcd8739ae039), {
                                                    field: field,
                                                    index: index
                                                })
                                            ]
                                        })
                                    ]
                                }, field.Kasvilaji))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                            onNext: handleNextClick,
                            onPrevious: handlePreviousClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "3/9",
                    onNext: handleNextClick,
                    onPrevious: handlePreviousClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");















var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $1sz44 = parcelRequire("1sz44");

var $e8gS1 = parcelRequire("e8gS1");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8Indx = parcelRequire("8Indx");

var $jgarO = parcelRequire("jgarO");

parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $915769b4d8e5eccb$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $13bd0137e91b5d2a$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
var $41df310c6674b6f6$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $3AM7p = parcelRequire("3AM7p");

var $cpBQU = parcelRequire("cpBQU");

var $1Ikg4 = parcelRequire("1Ikg4");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6538b097db044083$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)("MuiCheckbox", slot);
}
const $6538b097db044083$var$checkboxClasses = (0, $beCSm.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary"
]);
var $6538b097db044083$export$2e2bcd8739ae039 = $6538b097db044083$var$checkboxClasses;



var $ayMG0 = parcelRequire("ayMG0");
const $e3ef6305be93c7af$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $e3ef6305be93c7af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $3AM7p.default)(color)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6538b097db044083$export$6c57c6e16b4063b), classes);
    return (0, $e8gS1.default)({}, classes, composedClasses);
};
const $e3ef6305be93c7af$var$CheckboxRoot = (0, $1Ikg4.default)((0, $dadefa050dca578a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1Ikg4.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $e8gS1.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $jgarO.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $6538b097db044083$export$2e2bcd8739ae039).checked}, &.${(0, $6538b097db044083$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $6538b097db044083$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $e3ef6305be93c7af$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13bd0137e91b5d2a$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $915769b4d8e5eccb$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41df310c6674b6f6$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $cpBQU.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $e3ef6305be93c7af$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $e3ef6305be93c7af$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $e3ef6305be93c7af$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $1sz44.default)(props, $e3ef6305be93c7af$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $e8gS1.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $e3ef6305be93c7af$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e3ef6305be93c7af$var$CheckboxRoot, (0, $e8gS1.default)({
        type: "checkbox",
        inputProps: (0, $e8gS1.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $e3ef6305be93c7af$export$2e2bcd8739ae039 = $e3ef6305be93c7af$var$Checkbox;


parcelRequire("acw62");

function $2e447a44b2a606d0$export$2e2bcd8739ae039(props) {
    const { control: control } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
        sx: {
            color: props.disabled ? "rgba(0, 0, 0, 0.3)" : "inherit"
        },
        label: props.label ?? "",
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
            name: props.name,
            control: control,
            render: ({ field: field })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
                    sx: {
                        "&.Mui-disabled": {
                            color: "rgba(0, 0, 0, 0.3);"
                        }
                    },
                    disabled: props.disabled,
                    color: "primary",
                    ...field,
                    checked: !!field.value,
                    onChange: (event)=>{
                        field.onChange({
                            target: {
                                name: name,
                                value: event.target.checked ? 1 : 0
                            }
                        });
                    }
                })
        })
    });
}




const $cb9572b8e3ff4f0c$var$Ohje = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5ca16cb6e72a53f1$export$2e2bcd8739ae039, {
            variant: "body1",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                i18nKey: ttyyppi === 2 ? "Varastotiedot.ohje.luomu" : "Varastotiedot.ohje",
                components: {
                    b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                },
                values: {
                    heinakuussa: (0, $59bd8eb267700007$export$2e2bcd8739ae039).heinäkuu,
                    tammikuussa: (0, $59bd8eb267700007$export$2e2bcd8739ae039).tammikuu
                }
            })
        })
    });
};
/**
 * Komponentin nimestä huolimatta kenttiä on nyt vain yksi.
 *
 * Niitä kuitenkin voisi olla useampikin tässä loogisessa kokonaisuudessa.
 */ const $cb9572b8e3ff4f0c$var$Kentät = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const otsake = t("fields.onkoVarastossaViljaa");
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed0dc78f73685bb9$export$2e2bcd8739ae039, {
        pt: 2,
        pb: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a2c903eb2263b589$export$2e2bcd8739ae039, {
            container: true,
            item: true,
            xs: 12,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e447a44b2a606d0$export$2e2bcd8739ae039), {
                label: otsake,
                name: "Varastotiedot.varastossaOnViljaa"
            })
        })
    });
};
const $cb9572b8e3ff4f0c$var$OnkoVarastoaKentät = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed0dc78f73685bb9$export$2e2bcd8739ae039, {
        pt: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cb9572b8e3ff4f0c$var$Ohje, {})
    });
};
var $cb9572b8e3ff4f0c$export$2e2bcd8739ae039 = $cb9572b8e3ff4f0c$var$OnkoVarastoaKentät;




const $37ec5121ecdc889c$var$useFormMovement = ({ nextUrl: nextUrl, previousUrl: previousUrl })=>{
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handlePreviousClick = ()=>{
        navigate(previousUrl);
    };
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 2
        }));
        navigate(nextUrl);
    };
    return {
        handleNextClick: handleNextClick,
        handlePreviousClick: handlePreviousClick
    };
};
const $37ec5121ecdc889c$var$FormWrapper = ({ children: children })=>{
    const varastoarvot = (0, $1c48e19d77c40bbb$export$629a55e219471ce0)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        mode: "onSubmit",
        defaultValues: {
            Varastotiedot: varastoarvot
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $8600e8026484e4e0$export$2e2bcd8739ae039))
    });
    const nextUrl = "/sato/valkuaiskasvien-satotiedot";
    const previousUrl = "/sato/viljan-satotiedot";
    const { handleNextClick: handleNextClick, handlePreviousClick: handlePreviousClick } = $37ec5121ecdc889c$var$useFormMovement({
        nextUrl: nextUrl,
        previousUrl: previousUrl
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fc9d5e43e7d6b8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e280d639cc57177$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($ed0dc78f73685bb9$export$2e2bcd8739ae039, {
                        children: [
                            children,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                                    onNext: handleNextClick,
                                    onPrevious: handlePreviousClick
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "2/9",
                    onNext: handleNextClick,
                    onPrevious: handlePreviousClick
                })
            })
        ]
    });
};
const $37ec5121ecdc889c$var$Otsikko = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const teksti = t("Varastotiedot.title");
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed0dc78f73685bb9$export$2e2bcd8739ae039, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($5ca16cb6e72a53f1$export$2e2bcd8739ae039, {
            variant: "h3",
            children: [
                "2. ",
                teksti
            ]
        })
    });
};
const $37ec5121ecdc889c$var$Varastotiedot = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)($37ec5121ecdc889c$var$FormWrapper, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($37ec5121ecdc889c$var$Otsikko, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb9572b8e3ff4f0c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c7428704f927050$export$2e2bcd8739ae039), {})
        ]
    });
var $37ec5121ecdc889c$export$2e2bcd8739ae039 = $37ec5121ecdc889c$var$Varastotiedot;



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



















var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $611386f78e19adae$export$114a0703763ccec5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    field: {},
    index: 0
});
function $611386f78e19adae$export$2e2bcd8739ae039({ field: field, index: index, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($611386f78e19adae$export$114a0703763ccec5.Provider, {
        value: {
            field: field,
            index: index
        },
        children: children
    });
}



const $bba8369b6b8e9dbc$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)(()=>({
        field: {
            minWidth: "275px"
        }
    }));
function $bba8369b6b8e9dbc$export$2e2bcd8739ae039() {
    const classes = $bba8369b6b8e9dbc$var$useStyles();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        mb: 2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
            name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Viljelyala}`,
            control: methods.control,
            render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                    inputRef: ref,
                    ...field,
                    label: "Viljelyala"
                })
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");




var $acw62 = parcelRequire("acw62");





const $e73a01a5c414ff8f$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)({
    transText: {
        fontSize: "1.2em"
    }
});
function $e73a01a5c414ff8f$export$2e2bcd8739ae039() {
    const errRef = (0, $acw62.useRef)(null);
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const classes = $e73a01a5c414ff8f$var$useStyles();
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const viljelyAla = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Viljelyala
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (viljelyAla === 0) {
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana}`, false);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuTuoresäilörehu}`, false);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKokoviljasäilörehu}`, false);
            methods.clearErrors(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana}`);
        }
    }, [
        viljelyAla
    ]);
    /**
   * Vihantavilja and mallasohra have no harvest method selection.
   */ if (field.Kasvilaji === "_386583" || field.Kasvilaji === "_61201") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const noMethodsSelected = methods.formState.errors.ViljanSatotiedot && methods.formState.errors.ViljanSatotiedot[index] && methods.formState.errors.ViljanSatotiedot[index][(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana];
    (0, $acw62.useEffect)(()=>{
        const errors = methods.formState.errors.ViljanSatotiedot && methods.formState.errors.ViljanSatotiedot[index] ? Object.keys(methods.formState.errors.ViljanSatotiedot[index]) : [];
        if (errors.length) window.scrollTo({
            top: errRef.current?.offsetTop
        });
    }, [
        errRef.current,
        methods.formState.errors
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        item: true,
        xs: 12,
        mb: 2,
        ref: errRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
            error: !!noMethodsSelected,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $db3da65b5688c8f8$export$2e2bcd8739ae039), {
                    component: "legend",
                    sx: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                marginRight: "8px"
                            },
                            children: t("ViljanSatotiedot.valitseKorjuutapa")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                            tabIndex: 0,
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                className: classes.transText,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "ViljanSatotiedot.ohjeteksti.ValitseKorjuutapa",
                                    components: {
                                        b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                                    },
                                    children: t("ViljanSatotiedot.ohjeteksti.ValitseKorjuutapa")
                                })
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a949128807fcb708$exports))), {
                                sx: {
                                    color: "#0079C9"
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
                    row: true,
                    sx: {
                        width: "100%",
                        alignItems: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e447a44b2a606d0$export$2e2bcd8739ae039), {
                            name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana}`,
                            label: t(`ViljanSatotiedot.KuivattavaVilja`),
                            disabled: viljelyAla === 0,
                            id: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e447a44b2a606d0$export$2e2bcd8739ae039), {
                            disabled: viljelyAla === 0,
                            label: t(`ViljanSatotiedot.TuoreenaKorjattavaVilja`),
                            name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuTuoresäilörehu}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e447a44b2a606d0$export$2e2bcd8739ae039), {
                            disabled: viljelyAla === 0,
                            label: t(`ViljanSatotiedot.Kokoviljasäilörehu`),
                            name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKokoviljasäilörehu}`
                        })
                    ]
                }),
                !!noMethodsSelected && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), {
                    children: t("fields.errors.korjuutaparequired")
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



function $1f9144c7920d67ed$export$2e2bcd8739ae039() {
    const { field: field } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60c611e2ff3de0fd$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33585bb92b9b52d5$export$2e2bcd8739ae039), {
            id: field.Kasvilaji
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $c8d1e2ff70d0472d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const selected = methods.watch(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKokoviljasäilörehu}`);
    const korjuuala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKokoviljasäilörehu
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKokoviljasäilörehu
            ]}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineKokoviljasäilörehu
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKokoviljasäilörehu}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKokoviljasäilörehu}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKokoviljasäilörehu}`);
    (0, $acw62.useEffect)(()=>{
        if (!selected) {
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKokoviljasäilörehu}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKokoviljasäilörehu}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKokoviljasäilörehu}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineKokoviljasäilörehu}`, null);
        }
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !!selected && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            item: true,
            md: 6,
            xs: 12,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: "bold"
                    },
                    children: t("ViljanSatotiedot.Kokoviljas\xe4il\xf6rehu")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKokoviljasäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            tooltip: t("ViljanSatotiedot.ohjeteksti.KokoviljaS\xe4il\xf6rehuKorjuualaOhje"),
                            inputRef: ref,
                            ...field,
                            label: "Kokoviljas\xe4il\xf6rehuKorjuuala",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            }
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKokoviljasäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            label: "Kokoviljas\xe4il\xf6rehuKokonaism\xe4\xe4r\xe4",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: korjuuala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKokoviljasäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            label: "satotaso",
                            fullWidth: true,
                            disabled: korjuuala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineKokoviljasäilörehu}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                            inputRef: ref,
                            ...field,
                            label: "KuivaaineProsentti",
                            fullWidth: true,
                            disabled: korjuuala === 0
                        })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $f9dbbf3054a14fc6$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const selected = methods.watch(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana}`);
    const korjuuala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKuivattavaVilja
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) methods.setValue(`ViljanSatotiedot.${index}.${[
            (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja
        ]}`, null);
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKuivattavaVilja}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja}`);
    (0, $acw62.useEffect)(()=>{
        if (!selected) {
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKuivattavaVilja}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja}`, null);
        }
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !!selected && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            item: true,
            md: 6,
            xs: 12,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: "bold"
                    },
                    children: t("ViljanSatotiedot.KuivattavaVilja")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaKuivattavaVilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            tooltip: t("ViljanSatotiedot.ohjeteksti.KuivattavaViljaKorjuualaOhje"),
                            inputRef: ref,
                            ...field,
                            label: "Kuivakorjuuala",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            }
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräKuivattavaVilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            label: "KuivattuKokonaism\xe4\xe4r\xe4",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: korjuuala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            label: "satotaso",
                            fullWidth: true,
                            disabled: korjuuala === 0
                        })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $f3708a583ee009d0$export$2e2bcd8739ae039() {
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const viljelyala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Viljelyala
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (viljelyala === 0) {
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaMallasohra
            ]}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräMallasohra
            ]}`, null);
        }
    }, [
        viljelyala
    ]);
    const korjuuala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaMallasohra
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) methods.setValue(`ViljanSatotiedot.${index}.${[
            (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräMallasohra
        ]}`, null);
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräMallasohra}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaMallasohra}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja}`);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: field.Kasvilaji === "_61201" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            item: true,
            md: 6,
            xs: 12,
            mt: 2,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: "bold"
                    },
                    children: t("ViljanSatotiedot.KuivattavaVilja")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaMallasohra}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            inputRef: ref,
                            ...field,
                            label: "Kuivakorjuuala",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            },
                            disabled: viljelyala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräMallasohra}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            label: "KuivattuKokonaism\xe4\xe4r\xe4",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: korjuuala === 0 || viljelyala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoKuivattavaVilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            label: "satotaso",
                            fullWidth: true,
                            disabled: korjuuala === 0 || viljelyala === 0
                        })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");




function $3e980c936fa672ee$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const values = methods.watch("ViljanSatotiedot");
    /**
   * Vihantavilja and mallasohra have no harvest method selection.
   */ if (field.Kasvilaji === "_386583" || field.Kasvilaji === "_61201") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !values[index][(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKuivana] && !values[index][(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuKokoviljasäilörehu] && !values[index][(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuTuoresäilörehu] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                width: "100%",
                minHeight: "200px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: t("ViljanSatotiedot.eiKorjuutapaaValittu")
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");
function $0319ad7b86f6ff4f$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        item: true,
        xs: 12,
        spacing: 2,
        children: children
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $16be9d0827a0aec3$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const selected = methods.watch(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjattuTuoresäilörehu}`);
    const korjuuala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaTuoresäilövilja
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräTuoresäilövilja
            ]}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KosteusTuoresäilövilja
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräTuoresäilövilja}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaTuoresäilövilja}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoTuoresäilövilja}`);
    (0, $acw62.useEffect)(()=>{
        if (!selected) {
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräTuoresäilövilja}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaTuoresäilövilja}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoTuoresäilövilja}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KosteusTuoresäilövilja}`, null);
        }
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !!selected && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            item: true,
            md: 6,
            xs: 12,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: "bold"
                    },
                    children: t("ViljanSatotiedot.TuoreenaKorjattavaVilja")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaTuoresäilövilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            tooltip: t("ViljanSatotiedot.ohjeteksti.TuoreenaKorjattavaViljaOhje"),
                            inputRef: ref,
                            ...field,
                            fullWidth: true,
                            label: "TuoreviljanKorjuuala",
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            }
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräTuoresäilövilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            label: "TuoresadonKokonaism\xe4\xe4r\xe4",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: korjuuala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoTuoresäilövilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            label: "satotaso",
                            fullWidth: true,
                            disabled: korjuuala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KosteusTuoresäilövilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                            inputRef: ref,
                            ...field,
                            label: "Kosteusprosentti",
                            fullWidth: true,
                            disabled: korjuuala === 0
                        })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






function $97584645d7f1d5d9$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { field: field, index: index } = (0, $acw62.useContext)((0, $611386f78e19adae$export$114a0703763ccec5));
    const methods = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const [showRequiredError, setRequiredError] = (0, $acw62.useState)(false);
    const viljelyala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).Viljelyala
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (viljelyala === 0) {
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja
            ]}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräVihantavilja
            ]}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineVihantavilja
            ]}`, null);
        }
    }, [
        viljelyala
    ]);
    const korjuuala = methods.watch(`ViljanSatotiedot.${index}.${[
        (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja
    ]}`);
    (0, $acw62.useEffect)(()=>{
        if (korjuuala === 0) {
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräVihantavilja
            ]}`, null);
            methods.setValue(`ViljanSatotiedot.${index}.${[
                (0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineVihantavilja
            ]}`, null);
        }
    }, [
        korjuuala
    ]);
    const { handleChangeAcres: handleChangeAcres, handleChangeKilograms: handleChangeKilograms } = (0, $1ec6fc95823d038d$export$c17e948433f5d3d8)(`ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräVihantavilja}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja}`, `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoVihantavilja}`);
    (0, $acw62.useEffect)(()=>{
        setRequiredError(methods.formState.errors.ViljanSatotiedot && methods.formState.errors.ViljanSatotiedot[index] && methods.formState.errors.ViljanSatotiedot[index][(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja]);
    }, [
        methods.formState
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: field.Kasvilaji === "_386583" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            item: true,
            md: 6,
            xs: 12,
            children: [
                showRequiredError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                    error: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), {
                        children: t("fields.errors.muuviljarequired")
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KorjuualaVihantavilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$c143f692a8a0ec42), {
                            tooltip: t("ViljanSatotiedot.ohjeteksti.TuoreenaKorjattavaViljaOhje"),
                            inputRef: ref,
                            ...field,
                            label: "VihantaviljaKorjuuala",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeAcres(e);
                            },
                            disabled: viljelyala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatomääräVihantavilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$a984fed0d3d78c4f), {
                            inputRef: ref,
                            ...field,
                            label: "VihantaviljaKokonaism\xe4\xe4r\xe4",
                            fullWidth: true,
                            onChange: (e)=>{
                                field.onChange(e);
                                handleChangeKilograms(e);
                            },
                            disabled: korjuuala === 0 || viljelyala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).SatotasoVihantavilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$8603e28d2ac53e0e), {
                            inputRef: ref,
                            ...field,
                            label: "satotaso",
                            fullWidth: true,
                            disabled: korjuuala === 0 || viljelyala === 0
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: `ViljanSatotiedot.${index}.${(0, $91f1e45fd4a11301$export$833b3e5a19fb8939).KuivaaineVihantavilja}`,
                    control: methods.control,
                    render: ({ field: { ref: ref, ...field } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f6c83beccc29d67$export$12084818538df79c), {
                            inputRef: ref,
                            ...field,
                            label: "KuivaaineProsentti",
                            fullWidth: true,
                            disabled: korjuuala === 0 || viljelyala === 0
                        })
                })
            ]
        })
    });
}



function $b178989897d9ccc9$export$2e2bcd8739ae039() {
    const navigate = (0, $bed835bb43ab604a$export$2e2bcd8739ae039)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const viljakasvit = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.meta.viljakasvit);
    const selectedValues = (0, $1c48e19d77c40bbb$export$2a81128bb716296c)();
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        shouldFocusError: true,
        defaultValues: {
            ViljanSatotiedot: selectedValues.sort((a, b)=>{
                const cropA = viljakasvit.find((row)=>row.id === a.Kasvilaji);
                const cropB = viljakasvit.find((row)=>row.id === b.Kasvilaji);
                if (!cropA || !cropB) return -1;
                return cropA.order - cropB.order;
            })
        },
        reValidateMode: "onBlur",
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)((0, $91f1e45fd4a11301$export$2e2bcd8739ae039))
    });
    const { fields: fields } = (0, $0d70f179cf56e662$export$310131896651d559)({
        control: methods.control,
        name: "ViljanSatotiedot"
    });
    const handleNextClick = (values)=>{
        dispatch((0, $ec8af8064cfe02fe$export$6927fcb03f934e4)({
            ...values,
            step: 1
        }));
        navigate("/sato/viljan-varastot");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $31c6cd2586786371$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $842761f20b136f2c$export$2e2bcd8739ae039), {
                        children: [
                            "1. ",
                            t("ViljanSatotiedot.title")
                        ]
                    }),
                    selectedValues?.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b61f53edf67636e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $629bf9a0e02907e2$export$2e2bcd8739ae039), {
                                children: ttyyppi === 2 ? t("ViljanSatotiedot.ohjeteksti.tayttoohje.luomu") : t("ViljanSatotiedot.ohjeteksti.tayttoohje")
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $43badd48fe3b2ca1$export$2e2bcd8739ae039), {
                                    sx: {
                                        minHeight: "400px"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $611386f78e19adae$export$2e2bcd8739ae039), {
                                        field: field,
                                        index: index,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f9144c7920d67ed$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bba8369b6b8e9dbc$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e73a01a5c414ff8f$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0319ad7b86f6ff4f$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e980c936fa672ee$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9dbbf3054a14fc6$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16be9d0827a0aec3$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8d1e2ff70d0472d$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97584645d7f1d5d9$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3708a583ee009d0$export$2e2bcd8739ae039), {})
                                                ]
                                            })
                                        ]
                                    })
                                }, field.Kasvilaji))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3b74e724e26e2cba$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8909cb8dfdebad01$export$2e2bcd8739ae039), {
                                onNext: handleNextClick
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $503d053ab0e7a95d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd7cda0be37bf83a$export$2e2bcd8739ae039), {
                    step: "1/9",
                    onNext: handleNextClick
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $346c0e6f4dd6aea5$export$2e2bcd8739ae039), {
                open: (0, $ab5958319bb12700$export$b3dfacad8d35487)(methods.formState) && !methods.formState.isSubmitting
            })
        ]
    });
}



const $05f59d505ed5f038$export$80e4b313e5e6b30d = [
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).viljansatotiedot,
        text: "ViljanSatotiedot.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).viljanvarastot,
        text: "Varastotiedot.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).valkuaiskasviensatotiedot,
        text: "ValkuaiskasvienSatotiedot.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).muidenviljelykasviensatotiedot,
        text: "muutViljelyKasvit.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).perunansatotiedot,
        text: "perunanSato.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).syyskylvot,
        text: "syyskylvot.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).rehunurmensatotiedot,
        text: "RehunurmenSatotiedot.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).lisatiedot,
        text: "Lis\xe4tiedot.title"
    },
    {
        href: (0, $155cd4757147cec6$export$2e2bcd8739ae039).yhteenveto,
        text: "yhteenveto.title"
    }
];
function $05f59d505ed5f038$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const breakpoints = (0, $4155b23599949a13$export$2e2bcd8739ae039)();
    const query = (0, $c49f7d6593097bdf$export$2e2bcd8739ae039)();
    const id = query.get("id");
    const ttyyppi = (0, $0eab64f4fb796a14$export$5f2bdd6b3206051e)();
    /**
   * Load form values from backend and populate store before continuing to form pages
   */ const { loading: loading } = (0, $0e220426a973ad75$export$2e2bcd8739ae039)(id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3f66fbfc482f10f$export$2e2bcd8739ae039), {
                title: `${ttyyppi === 2 ? t("common.satotilastokysely.luomu") : t("common.satotilastokysely")} ${new Date().getFullYear()}`
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a2a6b1040c5d176$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: breakpoints.layout,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5358ea1077bf4480$export$2e2bcd8739ae039), {
                        routes: $05f59d505ed5f038$export$80e4b313e5e6b30d,
                        formId: id
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $887ea0d447fd8b9f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            className: breakpoints.routes,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926608a7a86d7371$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e64fcd986b51089d$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).vastauskoodit,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddea074113ade8ae$export$2e2bcd8739ae039), {
                                            nextPath: (0, $df5bef30413a053b$export$385fc1c9ea2be551)((0, $155cd4757147cec6$export$2e2bcd8739ae039).viljansatotiedot)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).viljansatotiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b178989897d9ccc9$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).viljanvarastot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37ec5121ecdc889c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).rehunurmensatotiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35e91d7ce7495b20$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).perunansatotiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b1414bed8eed83e0$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).aloitus,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f52b806a43de9e88$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).kiitos,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f87ac2afbd62aae$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).yhteenveto,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f172a1bdf4b6cb8f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).muidenviljelykasviensatotiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02d84a493b1910fa$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).lisatiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd0fbecfde8a8ccd$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).syyskylvot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41eeefaa6f60cc17$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                        path: (0, $155cd4757147cec6$export$2e2bcd8739ae039).valkuaiskasviensatotiedot,
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9714e0dcba67134c$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");



function $d8530738f0251568$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e3454bd6982de9c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: t("Accessibility.title")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                p: 8,
                pt: 4,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    children: t("Accessibility.tervetuloa")
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            i18nKey: "Accessibility.lakiperuste",
                                            components: {
                                                a: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: "https://sato.luke.fi"
                                                })
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: t("Accessibility.arviointi")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: t("Accessibility.saavutettavuustila")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: t("Accessibility.tayttaaVaatimukset")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: t("Accessibility.saavuttamatonsisalto")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            children: [
                                                "3. ",
                                                t("Accessibility.eiVaatimustenMukainen"),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                            children: t("Accessibility.mobiilikaytto")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: t("Accessibility.mobiilikaytto.teksti")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                            children: t("Accessibility.pdfLuettavuus")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                                                i18nKey: "Accessibility.pdfLuettavuus.teksti",
                                                                components: {
                                                                    br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: t("Accessibility.saavutettavuuspuute")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                        children: [
                                            t("Accessibility.sahkopostilla"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: t("Accessibility.kirjaamo")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t("Accessibility.muillatavoin")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            i18nKey: "Accessibility.muillatavoin.teksti",
                                            components: {
                                                br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: t("Accessibility.valvontaviranomainen")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            i18nKey: "Accessibility.valvontaviranomainen.teksti",
                                            components: {
                                                br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                a: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {}),
                                                span: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: t("Accessibility.valvontaYhteystiedot")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            i18nKey: "Accessibility.valvontaYhteystiedot.teksti",
                                            components: {
                                                br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                        children: [
                                            t("Accessibility.saavutettavuudenParantaminen"),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t("Accessibility.tarjoammeTukea")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: t("Accessibility.tarjoammetukea.teksti")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: t("Accessibility.julkaisu")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            t("Accessibility.julkaisu.pvm"),
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");







const $bdaa3ed3d86ac1d1$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        title: {
            [theme.breakpoints.down("md")]: {
                padding: theme.spacing(4),
                minHeight: "100%"
            },
            padding: theme.spacing(8),
            backgroundColor: theme.palette.primary.main,
            color: "white",
            textShadow: // eslint-disable-next-line max-len
            "0.01em 0 rgba(0, 0, 0, 0.2),0 0.01em rgba(0, 0, 0, 0.2),-0.01em 0 rgba(0, 0, 0, 0.2),0 -0.01em rgba(0, 0, 0, 0.2)"
        },
        lukeLink: {
            color: "#fff"
        },
        authenticate: {
            display: "flex",
            alignItems: "flex-end"
        },
        flexContainer: {
            display: "flex",
            flexDirection: "column"
        },
        flexContent: {
            flex: "auto"
        },
        instructionsBox: {
            paddingTop: "10px",
            [theme.breakpoints.down("md")]: {
                fontSize: "1.75rem !important"
            }
        },
        error: {
            "&.Mui-error": {
                color: "white !important"
            }
        },
        button: {
            marginTop: "12px",
            [theme.breakpoints.down("md")]: {
                width: "100%"
            }
        }
    }));
function $bdaa3ed3d86ac1d1$export$2e2bcd8739ae039() {
    const login = (0, $4486ed8a46e21cd4$export$2e2bcd8739ae039)();
    const auth = (0, $d57e8ba77789de33$export$2e2bcd8739ae039)();
    const { t: t, i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $bdaa3ed3d86ac1d1$var$useStyles();
    const handleLoginClick = ()=>{
        localStorage.clear();
        login();
    };
    const handleValtuutettuLoginClick = ()=>{
        localStorage.clear();
        window.location.href = "https://tunnistus-test-tikal.luke.fi/SAML2SP?app_id=sato&valtuudetMode=hpa" + `&lang=` + i18n.language;
    };
    if (auth) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: "/aloitus"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                className: classes.title,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h1",
                        className: classes.instructionsBox,
                        children: t("kirjaudu.title")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("kirjaudu.ohjeteksti1.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("kirjaudu.ohjeteksti1.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("kirjaudu.ohjeteksti2.1")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: t("kirjaudu.ohjeteksti2.2")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body1",
                                children: [
                                    t("kirjaudu.ohjeteksti3.1"),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        i18nKey: "kirjaudu.ohjeteksti3.2",
                                        components: {
                                            b: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    t("kirjaudu.linkkiteksti1") + " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: classes.lukeLink,
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        href: t("kirjaudu.linkki"),
                                        children: t("kirjaudu.linkkiteksti2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        mt: 3,
                        className: classes.authenticate,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                md: 2,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e0f3d43455a411d$export$b03061e17dddb512), {
                                    fullWidth: true,
                                    className: classes.button,
                                    color: "secondary",
                                    sx: {
                                        fontWeight: "bold"
                                    },
                                    text: t("kirjaudu.suomifi"),
                                    onClick: handleLoginClick
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

parcelRequire("acw62");


function $2479817a5d288f59$export$2e2bcd8739ae039() {
    const query = (0, $c49f7d6593097bdf$export$2e2bcd8739ae039)();
    const id = query.get("id");
    const path = query.get("path");
    if (id && path) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$444b3ab0cb9aec40), {
        to: `${path}?id=${id}`
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        p: 4,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
            children: "Lomakkeelle ohjaus ep\xe4onnistui - ohjaustiedot puuttuvat."
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");



const $1ba292f75dc5b6e2$var$useStyles = (0, $13a9e1ccd58618d1$export$2e2bcd8739ae039)((theme)=>({
        middleBox: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        errorCodeAndTitle: {
            display: "flex",
            alignItems: "baseline"
        },
        errorTitleBox: {
            display: "flex"
        },
        errorBox: {
            display: "flex",
            alignItems: "center",
            marginTop: ""
        },
        errorNumber: {
            fontSize: "70px"
        },
        link: {
            color: "white"
        }
    }));
function $1ba292f75dc5b6e2$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $1ba292f75dc5b6e2$var$useStyles();
    //artifact
    var URLstatuscode;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {
                isLoggedIn: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                className: classes.middleBox,
                pr: 8,
                pl: 8,
                pt: 8,
                pb: 8,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        className: classes.errorCodeAndTitle,
                        children: [
                            !!URLstatuscode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                mr: 3,
                                className: classes.errorBox,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    className: classes.errorNumber,
                                    children: URLstatuscode
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                className: classes.errorTitleBox,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: t("kirjaudu.tunnistautuminenEpaonnistui.title")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        mt: 1,
                        className: classes.errorBox,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a), {
                                className: classes.link,
                                to: "/",
                                children: t("kirjaudu.tunnistautuminenEpaonnistui.return")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {
                sticky: true
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");





function $af9f459738716a8c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const query = (0, $c49f7d6593097bdf$export$2e2bcd8739ae039)();
    const [reason, setReason] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setReason(query.get("reason"));
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1247e84894e86471$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3f66fbfc482f10f$export$2e2bcd8739ae039), {
                title: t("common.app")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fc9d5e43e7d6b8$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    pl: 6,
                    pt: 2,
                    children: [
                        !reason && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            mb: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: t("common.loggedOut")
                            })
                        }),
                        reason === "timeout" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            mb: 2,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: t("common.timedOut")
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                            component: (0, $0c90f43fc3673aef$export$a6c7ac8248d6e38a),
                            to: "/",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    " ",
                                    t("common.toFrontpage")
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47ca00e0d20c7c7$export$2e2bcd8739ae039), {})
        ]
    });
}


function $8c10dd8884cb7442$export$2e2bcd8739ae039() {
    (0, $78830b532ad30aed$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0c90f43fc3673aef$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d99d1420325c74f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8c2567824fae8d2$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $926608a7a86d7371$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96338aceb27663ef$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bdaa3ed3d86ac1d1$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "/aloitus",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f52b806a43de9e88$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "/tunnistautuminen-epaonnistui",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ba292f75dc5b6e2$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "sato/*",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be63994ddb0aacc4$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05f59d505ed5f038$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "peruna/*",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $be63994ddb0aacc4$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d66bd0b11e548a5$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "uloskirjauduttu",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af9f459738716a8c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "saavutettavuus",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8530738f0251568$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $926608a7a86d7371$export$e7b0ac011bb776c6), {
                                path: "editor",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2479817a5d288f59$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fda54edbcd7c0473$export$2e2bcd8739ae039), {})
        ]
    });
}



function $983350b7b3960a26$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $983350b7b3960a26$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $983350b7b3960a26$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ad4393542232627c$var$isDate(val)) return "date";
    if ($ad4393542232627c$var$isError(val)) return "error";
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $ad4393542232627c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $dc4a47ea750d5f98$export$711117ad6ad27992 = "persist:";
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = "persist/FLUSH";
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = "persist/PERSIST";
var $dc4a47ea750d5f98$export$5514fc3b4067675f = "persist/PURGE";
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === "object";
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $ad4393542232627c$export$66e4520cdb265d18)(reducers));
}




function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $ad4393542232627c$export$f51a9068ac82ea43)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)("local");
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;


var $44241fd6c875387f$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $44241fd6c875387f$export$2b10f4b30fb65583 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("CANCEL_PROMISE");
var $44241fd6c875387f$export$3281fbb3edc9dee3 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("CHANNEL_END");
var $44241fd6c875387f$export$8f8422ac5947a789 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("IO");
var $44241fd6c875387f$export$5a1a83be8f503735 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("MATCH");
var $44241fd6c875387f$export$9074c4e62c4e51bb = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("MULTICAST");
var $44241fd6c875387f$export$7d963e45ecdffba1 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("SAGA_ACTION");
var $44241fd6c875387f$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("SELF_CANCELLATION");
var $44241fd6c875387f$export$9355e489ad16f98e = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("TASK");
var $44241fd6c875387f$export$a47f788ef0b36709 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("TASK_CANCEL");
var $44241fd6c875387f$export$d966e43d90bf4c05 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("TERMINATE");
var $44241fd6c875387f$export$bdae2c4f4f03305d = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("LOCATION");





var $15093a965cf6fe1c$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $15093a965cf6fe1c$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $15093a965cf6fe1c$export$86951950244e2001 = function func(f) {
    return typeof f === "function";
};
var $15093a965cf6fe1c$export$98e628dec113755e = function number(n) {
    return typeof n === "number";
};
var $15093a965cf6fe1c$export$22b082955e083ec3 = function string(s) {
    return typeof s === "string";
};
var $15093a965cf6fe1c$export$2f23118c22fb2630 = Array.isArray;
var $15093a965cf6fe1c$export$be5493f9613cbbe = function object(obj) {
    return obj && !$15093a965cf6fe1c$export$2f23118c22fb2630(obj) && typeof obj === "object";
};
var $15093a965cf6fe1c$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $15093a965cf6fe1c$export$86951950244e2001(p.then);
};
var $15093a965cf6fe1c$export$6f58e2338da23f4d = function iterator(it) {
    return it && $15093a965cf6fe1c$export$86951950244e2001(it.next) && $15093a965cf6fe1c$export$86951950244e2001(it.throw);
};
var $15093a965cf6fe1c$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $15093a965cf6fe1c$export$86951950244e2001(Symbol) ? $15093a965cf6fe1c$export$86951950244e2001(it[Symbol.iterator]) : $15093a965cf6fe1c$export$2f23118c22fb2630(it);
};
var $15093a965cf6fe1c$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $44241fd6c875387f$export$9355e489ad16f98e];
};
var $15093a965cf6fe1c$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $44241fd6c875387f$export$7d963e45ecdffba1]);
};
var $15093a965cf6fe1c$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $15093a965cf6fe1c$export$86951950244e2001(ob.subscribe);
};
var $15093a965cf6fe1c$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $15093a965cf6fe1c$export$86951950244e2001(buf.isEmpty) && $15093a965cf6fe1c$export$86951950244e2001(buf.take) && $15093a965cf6fe1c$export$86951950244e2001(buf.put);
};
var $15093a965cf6fe1c$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($15093a965cf6fe1c$export$22b082955e083ec3(pat) || $15093a965cf6fe1c$export$8f701197936bc2a6(pat) || $15093a965cf6fe1c$export$86951950244e2001(pat) || $15093a965cf6fe1c$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $15093a965cf6fe1c$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $15093a965cf6fe1c$export$86951950244e2001(ch.take) && $15093a965cf6fe1c$export$86951950244e2001(ch.close);
};
var $15093a965cf6fe1c$export$32b5e46230afa379 = function stringableFunc(f) {
    return $15093a965cf6fe1c$export$86951950244e2001(f) && f.hasOwnProperty("toString");
};
var $15093a965cf6fe1c$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === "function" && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $15093a965cf6fe1c$export$1364843af8d5a963 = function multicast(ch) {
    return $15093a965cf6fe1c$export$1f95fbd68d964d36(ch) && ch[0, $44241fd6c875387f$export$9074c4e62c4e51bb];
};
var $15093a965cf6fe1c$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $44241fd6c875387f$export$8f8422ac5947a789];
};






var $45b326adf3eff15d$var$MAX_SIGNED_INT = 2147483647;
function $45b326adf3eff15d$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($45b326adf3eff15d$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $44241fd6c875387f$export$2b10f4b30fb65583] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $45b326adf3eff15d$export$2e2bcd8739ae039 = $45b326adf3eff15d$var$delayP;


var $4b7c041aec498d87$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $4b7c041aec498d87$export$342063e11d6c3cad = /*#__PURE__*/ $4b7c041aec498d87$var$konst(true);
var $4b7c041aec498d87$export$625550452a3fa3ec = function noop() {};
var $4b7c041aec498d87$export$a9c23c6ac3fc3eca = function identity(v) {
    return v;
};
var $4b7c041aec498d87$var$hasSymbol = typeof Symbol === "function";
var $4b7c041aec498d87$export$d141bba7fdc215a3 = $4b7c041aec498d87$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function $4b7c041aec498d87$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $4b7c041aec498d87$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $4b7c041aec498d87$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $4b7c041aec498d87$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $4b7c041aec498d87$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $4b7c041aec498d87$var$kThrow = function kThrow(err) {
    throw err;
};
var $4b7c041aec498d87$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $4b7c041aec498d87$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $4b7c041aec498d87$var$kThrow;
    if (name === void 0) name = "iterator";
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $4b7c041aec498d87$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== "undefined") iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $4b7c041aec498d87$export$ef35774e6d314e91(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $4b7c041aec498d87$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $4b7c041aec498d87$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + "." : "") + "setContext(props): argument " + props + " is not a plain object";
};
var $4b7c041aec498d87$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $4b7c041aec498d87$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $4b7c041aec498d87$export$96f57966bedc81b4 = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $44241fd6c875387f$export$7d963e45ecdffba1), {
            value: true
        }));
    };
};
var $4b7c041aec498d87$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $44241fd6c875387f$export$d966e43d90bf4c05);
};
var $4b7c041aec498d87$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $44241fd6c875387f$export$a47f788ef0b36709);
};
var $4b7c041aec498d87$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $4b7c041aec498d87$export$df995fae86a55f06(res) || $4b7c041aec498d87$export$4a5767248b18ef41(res);
};
function $4b7c041aec498d87$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $15093a965cf6fe1c$export$2f23118c22fb2630)(shape) ? $4b7c041aec498d87$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $4b7c041aec498d87$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $4b7c041aec498d87$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $4b7c041aec498d87$export$35e795649ee09318(fn) {
    return {
        name: fn.name || "anonymous",
        location: $4b7c041aec498d87$export$90a7f3efeed30595(fn)
    };
}
function $4b7c041aec498d87$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $44241fd6c875387f$export$bdae2c4f4f03305d];
}
var $4b7c041aec498d87$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $4b7c041aec498d87$var$ON_OVERFLOW_THROW = 1;
var $4b7c041aec498d87$var$ON_OVERFLOW_DROP = 2;
var $4b7c041aec498d87$var$ON_OVERFLOW_SLIDE = 3;
var $4b7c041aec498d87$var$ON_OVERFLOW_EXPAND = 4;
var $4b7c041aec498d87$var$zeroBuffer = {
    isEmpty: $4b7c041aec498d87$export$342063e11d6c3cad,
    put: $4b7c041aec498d87$export$625550452a3fa3ec,
    take: $4b7c041aec498d87$export$625550452a3fa3ec
};
function $4b7c041aec498d87$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $4b7c041aec498d87$var$ON_OVERFLOW_THROW:
                        throw new Error($4b7c041aec498d87$var$BUFFER_OVERFLOW);
                    case $4b7c041aec498d87$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $4b7c041aec498d87$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $4b7c041aec498d87$export$7ccc53e8f1e7dfc5 = function none() {
    return $4b7c041aec498d87$var$zeroBuffer;
};
var $4b7c041aec498d87$var$fixed = function fixed(limit) {
    return $4b7c041aec498d87$var$ringBuffer(limit, $4b7c041aec498d87$var$ON_OVERFLOW_THROW);
};
var $4b7c041aec498d87$var$dropping = function dropping(limit) {
    return $4b7c041aec498d87$var$ringBuffer(limit, $4b7c041aec498d87$var$ON_OVERFLOW_DROP);
};
var $4b7c041aec498d87$export$3a6d5c9ae78a2c08 = function sliding(limit) {
    return $4b7c041aec498d87$var$ringBuffer(limit, $4b7c041aec498d87$var$ON_OVERFLOW_SLIDE);
};
var $4b7c041aec498d87$export$f1e1789686576879 = function expanding(initialSize) {
    return $4b7c041aec498d87$var$ringBuffer(initialSize, $4b7c041aec498d87$var$ON_OVERFLOW_EXPAND);
};
var $4b7c041aec498d87$export$7f8ddf7c7c20b3cd = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $4b7c041aec498d87$export$7ccc53e8f1e7dfc5,
    fixed: $4b7c041aec498d87$var$fixed,
    dropping: $4b7c041aec498d87$var$dropping,
    sliding: $4b7c041aec498d87$export$3a6d5c9ae78a2c08,
    expanding: $4b7c041aec498d87$export$f1e1789686576879
});
var $4b7c041aec498d87$export$971d5caa766a69d7 = "TAKE";
var $4b7c041aec498d87$export$56c0d5a1e737357d = "PUT";
var $4b7c041aec498d87$export$ebd11618f299a286 = "ALL";
var $4b7c041aec498d87$export$db202ddc8be9136 = "RACE";
var $4b7c041aec498d87$export$e7094788287c5e9b = "CALL";
var $4b7c041aec498d87$export$407448d2b89b1813 = "CPS";
var $4b7c041aec498d87$export$d66501df72047452 = "FORK";
var $4b7c041aec498d87$export$b4171a6734a65d42 = "JOIN";
var $4b7c041aec498d87$export$8b22cf2602fb60ce = "CANCEL";
var $4b7c041aec498d87$export$25ce5a424b770e84 = "SELECT";
var $4b7c041aec498d87$export$4368d992c4eafac0 = "ACTION_CHANNEL";
var $4b7c041aec498d87$export$2d1720544b23b823 = "CANCELLED";
var $4b7c041aec498d87$export$39b482c5e57630a8 = "FLUSH";
var $4b7c041aec498d87$export$2329c99376c9d0a4 = "GET_CONTEXT";
var $4b7c041aec498d87$export$dda1d9f60106f0e9 = "SET_CONTEXT";
var $4b7c041aec498d87$export$71cec2538cb2c617 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $4b7c041aec498d87$export$971d5caa766a69d7,
    PUT: $4b7c041aec498d87$export$56c0d5a1e737357d,
    ALL: $4b7c041aec498d87$export$ebd11618f299a286,
    RACE: $4b7c041aec498d87$export$db202ddc8be9136,
    CALL: $4b7c041aec498d87$export$e7094788287c5e9b,
    CPS: $4b7c041aec498d87$export$407448d2b89b1813,
    FORK: $4b7c041aec498d87$export$d66501df72047452,
    JOIN: $4b7c041aec498d87$export$b4171a6734a65d42,
    CANCEL: $4b7c041aec498d87$export$8b22cf2602fb60ce,
    SELECT: $4b7c041aec498d87$export$25ce5a424b770e84,
    ACTION_CHANNEL: $4b7c041aec498d87$export$4368d992c4eafac0,
    CANCELLED: $4b7c041aec498d87$export$2d1720544b23b823,
    FLUSH: $4b7c041aec498d87$export$39b482c5e57630a8,
    GET_CONTEXT: $4b7c041aec498d87$export$2329c99376c9d0a4,
    SET_CONTEXT: $4b7c041aec498d87$export$dda1d9f60106f0e9
});
var $4b7c041aec498d87$var$TEST_HINT = "\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)";
var $4b7c041aec498d87$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $44241fd6c875387f$export$8f8422ac5947a789] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $4b7c041aec498d87$var$isForkEffect = function isForkEffect(eff) {
    return (0, $15093a965cf6fe1c$export$dc573d8a6576cdb3)(eff) && eff.type === $4b7c041aec498d87$export$d66501df72047452;
};
var $4b7c041aec498d87$export$9bb611d729802a56 = function detach(eff) {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$d66501df72047452, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, eff.payload, {
        detached: true
    }));
};
function $4b7c041aec498d87$export$3466f893ebf79586(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = "*";
    if ((0, $15093a965cf6fe1c$export$24f82734ea047e6f)(patternOrChannel)) {
        if ((0, $15093a965cf6fe1c$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $15093a965cf6fe1c$export$1364843af8d5a963)(patternOrChannel) && (0, $15093a965cf6fe1c$export$1352885233577768)(multicastPattern) && (0, $15093a965cf6fe1c$export$24f82734ea047e6f)(multicastPattern)) return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $15093a965cf6fe1c$export$1f95fbd68d964d36)(patternOrChannel)) {
        if ((0, $15093a965cf6fe1c$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $4b7c041aec498d87$export$78acf4525d8a74c4 = function takeMaybe() {
    var eff = $4b7c041aec498d87$export$3466f893ebf79586.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $4b7c041aec498d87$export$8743009a87fcb00f(channel$1, action) {
    if ((0, $15093a965cf6fe1c$export$c7b6444af1f098df)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $4b7c041aec498d87$export$dc98b0b04f4c7758 = function putResolve() {
    var eff = $4b7c041aec498d87$export$8743009a87fcb00f.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $4b7c041aec498d87$export$71511d61b312f219(effects) {
    var eff = $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $4b7c041aec498d87$export$e7c866399fa523f5(effects) {
    var eff = $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $4b7c041aec498d87$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $4b7c041aec498d87$export$db3b6bfb95261072(fnDescriptor, (0, $15093a965cf6fe1c$export$1352885233577768), effectName + ": argument fn is undefined or null");
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $4b7c041aec498d87$export$db3b6bfb95261072(fn, (0, $15093a965cf6fe1c$export$1352885233577768), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $15093a965cf6fe1c$export$be5493f9613cbbe)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $4b7c041aec498d87$export$db3b6bfb95261072(fn, (0, $15093a965cf6fe1c$export$1352885233577768), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $4b7c041aec498d87$export$db3b6bfb95261072(fnDescriptor, (0, $15093a965cf6fe1c$export$86951950244e2001), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $15093a965cf6fe1c$export$22b082955e083ec3)(fn)) {
        $4b7c041aec498d87$export$db3b6bfb95261072(context[fn], (0, $15093a965cf6fe1c$export$86951950244e2001), effectName + ': context arguments has no such method - "' + fn + '"');
        return;
    }
    $4b7c041aec498d87$export$db3b6bfb95261072(fn, (0, $15093a965cf6fe1c$export$86951950244e2001), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $4b7c041aec498d87$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $15093a965cf6fe1c$export$22b082955e083ec3)(fn) && (0, $15093a965cf6fe1c$export$86951950244e2001)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $4b7c041aec498d87$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $4b7c041aec498d87$export$c4ce752e73470fba;
};
function $4b7c041aec498d87$export$a07804094c3ecf2d(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$e7094788287c5e9b, $4b7c041aec498d87$var$getFnCallDescriptor(fnDescriptor, args));
}
function $4b7c041aec498d87$export$3d8c2f653ac9d0b9(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$e7094788287c5e9b, $4b7c041aec498d87$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $4b7c041aec498d87$export$34aec0b863436764(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$407448d2b89b1813, $4b7c041aec498d87$var$getFnCallDescriptor(fnDescriptor, args));
}
function $4b7c041aec498d87$export$61196ced6d74a310(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$d66501df72047452, $4b7c041aec498d87$var$getFnCallDescriptor(fnDescriptor, args));
}
function $4b7c041aec498d87$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $4b7c041aec498d87$export$9bb611d729802a56($4b7c041aec498d87$export$61196ced6d74a310.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $4b7c041aec498d87$export$ce26c07117d59d6a(taskOrTasks) {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$b4171a6734a65d42, taskOrTasks);
}
function $4b7c041aec498d87$export$3a1a48c8f6ef640e(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $44241fd6c875387f$export$3f4d38f8b89bfda7);
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$8b22cf2602fb60ce, taskOrTasks);
}
function $4b7c041aec498d87$export$6559d589eb85fbb6(selector) {
    if (selector === void 0) selector = $4b7c041aec498d87$export$a9c23c6ac3fc3eca;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $4b7c041aec498d87$export$3722cfe417b6ed86(pattern$1, buffer$1) {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $4b7c041aec498d87$export$efca4cbe5dd06740() {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$2d1720544b23b823, {});
}
function $4b7c041aec498d87$export$a8550f7dbe79f93a(channel$1) {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$39b482c5e57630a8, channel$1);
}
function $4b7c041aec498d87$export$2e2af4578d910ddf(prop) {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$2329c99376c9d0a4, prop);
}
function $4b7c041aec498d87$export$a93c5207d687da10(props) {
    return $4b7c041aec498d87$var$makeEffect($4b7c041aec498d87$export$dda1d9f60106f0e9, props);
}
var $4b7c041aec498d87$export$c4ce752e73470fba = /*#__PURE__*/ $4b7c041aec498d87$export$a07804094c3ecf2d.bind(null, (0, $45b326adf3eff15d$export$2e2bcd8739ae039));



/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $a92d759a54265567$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $a92d759a54265567$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $a92d759a54265567$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $a92d759a54265567$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $a92d759a54265567$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $a92d759a54265567$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $a92d759a54265567$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $a92d759a54265567$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $a92d759a54265567$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($a92d759a54265567$var$isDate(val)) return "date";
    if ($a92d759a54265567$var$isError(val)) return "error";
    var constructorName = $a92d759a54265567$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $a92d759a54265567$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $a92d759a54265567$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $a92d759a54265567$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $a92d759a54265567$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $a92d759a54265567$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($a92d759a54265567$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($a92d759a54265567$var$formatProdErrorMessage(1));
        return enhancer($a92d759a54265567$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($a92d759a54265567$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($a92d759a54265567$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($a92d759a54265567$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($a92d759a54265567$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($a92d759a54265567$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$a92d759a54265567$var$isPlainObject(action)) throw new Error($a92d759a54265567$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($a92d759a54265567$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($a92d759a54265567$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($a92d759a54265567$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $a92d759a54265567$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($a92d759a54265567$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$a92d759a54265567$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $a92d759a54265567$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$a92d759a54265567$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $a92d759a54265567$export$8928921ea2d3b126 = $a92d759a54265567$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a92d759a54265567$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $a92d759a54265567$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $a92d759a54265567$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$a92d759a54265567$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $a92d759a54265567$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $a92d759a54265567$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $a92d759a54265567$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $a92d759a54265567$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($a92d759a54265567$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $a92d759a54265567$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($a92d759a54265567$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $a92d759a54265567$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $a92d759a54265567$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($a92d759a54265567$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $a92d759a54265567$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $a92d759a54265567$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $a92d759a54265567$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($a92d759a54265567$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $a92d759a54265567$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $a92d759a54265567$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $a92d759a54265567$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($a92d759a54265567$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $a92d759a54265567$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $a92d759a54265567$var$isCrushed() {}


function $da7a7b2afd0c6e2b$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $da7a7b2afd0c6e2b$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($da7a7b2afd0c6e2b$var$deferred());
    return arr;
}
var $da7a7b2afd0c6e2b$export$2e2bcd8739ae039 = $da7a7b2afd0c6e2b$var$deferred;



var $7c4c83baead83c48$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $7c4c83baead83c48$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $7c4c83baead83c48$var$exec(task) {
    try {
        $7c4c83baead83c48$var$suspend();
        task();
    } finally{
        $7c4c83baead83c48$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $7c4c83baead83c48$var$asap(task) {
    $7c4c83baead83c48$var$queue.push(task);
    if (!$7c4c83baead83c48$var$semaphore) {
        $7c4c83baead83c48$var$suspend();
        $7c4c83baead83c48$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $7c4c83baead83c48$var$immediately(task) {
    try {
        $7c4c83baead83c48$var$suspend();
        return task();
    } finally{
        $7c4c83baead83c48$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $7c4c83baead83c48$var$suspend() {
    $7c4c83baead83c48$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $7c4c83baead83c48$var$release() {
    $7c4c83baead83c48$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $7c4c83baead83c48$var$flush() {
    $7c4c83baead83c48$var$release();
    var task;
    while(!$7c4c83baead83c48$var$semaphore && (task = $7c4c83baead83c48$var$queue.shift()) !== undefined)$7c4c83baead83c48$var$exec(task);
}
var $7c4c83baead83c48$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $7c4c83baead83c48$var$matcher(p)(input);
        });
    };
};
var $7c4c83baead83c48$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $7c4c83baead83c48$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $7c4c83baead83c48$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $7c4c83baead83c48$var$wildcard = function wildcard() {
    return 0, $4b7c041aec498d87$export$342063e11d6c3cad;
};
function $7c4c83baead83c48$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === "*" ? $7c4c83baead83c48$var$wildcard : (0, $15093a965cf6fe1c$export$22b082955e083ec3)(pattern) ? $7c4c83baead83c48$var$string : (0, $15093a965cf6fe1c$export$2f23118c22fb2630)(pattern) ? $7c4c83baead83c48$var$array : (0, $15093a965cf6fe1c$export$32b5e46230afa379)(pattern) ? $7c4c83baead83c48$var$string : (0, $15093a965cf6fe1c$export$86951950244e2001)(pattern) ? $7c4c83baead83c48$var$predicate : (0, $15093a965cf6fe1c$export$8f701197936bc2a6)(pattern) ? $7c4c83baead83c48$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $7c4c83baead83c48$export$32239d68d9c6cb49 = {
    type: (0, $44241fd6c875387f$export$3281fbb3edc9dee3)
};
var $7c4c83baead83c48$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $44241fd6c875387f$export$3281fbb3edc9dee3);
};
var $7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS = "Cannot have a closed channel with pending takers";
var $7c4c83baead83c48$var$INVALID_BUFFER = "invalid buffer passed to channel factory function";
var $7c4c83baead83c48$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $7c4c83baead83c48$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $4b7c041aec498d87$export$f1e1789686576879)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $4b7c041aec498d87$export$23f2a1d2818174ef)($7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $4b7c041aec498d87$export$23f2a1d2818174ef)("Cannot have pending takers with non empty buffer");
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($7c4c83baead83c48$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $4b7c041aec498d87$export$43caf9889c228507)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($7c4c83baead83c48$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($7c4c83baead83c48$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $7c4c83baead83c48$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $4b7c041aec498d87$export$7ccc53e8f1e7dfc5)();
    var closed = false;
    var unsubscribe;
    var chan = $7c4c83baead83c48$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $15093a965cf6fe1c$export$86951950244e2001)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $4b7c041aec498d87$export$ae1af26003f05816)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $7c4c83baead83c48$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $4b7c041aec498d87$export$23f2a1d2818174ef)($7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($7c4c83baead83c48$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $44241fd6c875387f$export$9074c4e62c4e51bb] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $44241fd6c875387f$export$5a1a83be8f503735](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $7c4c83baead83c48$var$wildcard;
        if (closed) {
            cb($7c4c83baead83c48$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $44241fd6c875387f$export$5a1a83be8f503735] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $4b7c041aec498d87$export$ae1af26003f05816)(function() {
            ensureCanMutateNextTakers();
            (0, $4b7c041aec498d87$export$43caf9889c228507)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $7c4c83baead83c48$export$e987d166a3a4f3ec() {
    var chan = $7c4c83baead83c48$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $44241fd6c875387f$export$7d963e45ecdffba1]) {
            put(input);
            return;
        }
        $7c4c83baead83c48$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $7c4c83baead83c48$var$RUNNING = 0;
var $7c4c83baead83c48$var$CANCELLED = 1;
var $7c4c83baead83c48$var$ABORTED = 2;
var $7c4c83baead83c48$var$DONE = 3;
function $7c4c83baead83c48$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $44241fd6c875387f$export$2b10f4b30fb65583];
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $7c4c83baead83c48$var$current = 0;
var $7c4c83baead83c48$var$nextSagaId = function() {
    return ++$7c4c83baead83c48$var$current;
};
var $7c4c83baead83c48$var$_effectRunnerMap;
function $7c4c83baead83c48$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $4b7c041aec498d87$export$35e795649ee09318)(fn);
}
function $7c4c83baead83c48$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $15093a965cf6fe1c$export$6f58e2338da23f4d)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $4b7c041aec498d87$export$9e5f44173e64f162)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $4b7c041aec498d87$export$9e5f44173e64f162)(function() {
            throw err;
        });
    }
}
function $7c4c83baead83c48$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $7c4c83baead83c48$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(result)) $7c4c83baead83c48$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $7c4c83baead83c48$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $44241fd6c875387f$export$d966e43d90bf4c05));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $15093a965cf6fe1c$export$1352885233577768)(pattern) ? $7c4c83baead83c48$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $7c4c83baead83c48$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(result)) {
            $7c4c83baead83c48$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $15093a965cf6fe1c$export$6f58e2338da23f4d)(result)) {
            // resolve iterator
            $7c4c83baead83c48$var$proc(env, result, task.context, $7c4c83baead83c48$var$current, (0, $4b7c041aec498d87$export$35e795649ee09318)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $15093a965cf6fe1c$export$c7b6444af1f098df)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $7c4c83baead83c48$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $7c4c83baead83c48$var$getIteratorMetaInfo(taskIterator, fn);
    $7c4c83baead83c48$var$immediately(function() {
        var child = $7c4c83baead83c48$var$proc(env, taskIterator, parent.context, $7c4c83baead83c48$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $7c4c83baead83c48$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $4b7c041aec498d87$export$43caf9889c228507)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $4b7c041aec498d87$export$882b5998b3b9117c)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $7c4c83baead83c48$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $7c4c83baead83c48$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $44241fd6c875387f$export$3f4d38f8b89bfda7)) $7c4c83baead83c48$var$cancelSingleTask(task);
    else if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(taskOrTasks)) taskOrTasks.forEach($7c4c83baead83c48$var$cancelSingleTask);
    else $7c4c83baead83c48$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $7c4c83baead83c48$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $7c4c83baead83c48$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $4b7c041aec498d87$export$882b5998b3b9117c)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $7c4c83baead83c48$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $7c4c83baead83c48$var$current;
    var keys = Object.keys(effects);
    var response = (0, $15093a965cf6fe1c$export$2f23118c22fb2630)(effects) ? (0, $4b7c041aec498d87$export$953cecd6e717a553)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $4b7c041aec498d87$export$2408f22a0fab9ae5)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $7c4c83baead83c48$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $7c4c83baead83c48$export$1f95fbd68d964d36(buffer);
    var match = $7c4c83baead83c48$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$7c4c83baead83c48$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $7c4c83baead83c48$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $7c4c83baead83c48$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $7c4c83baead83c48$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $7c4c83baead83c48$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $4b7c041aec498d87$export$ffb5f4729a158638)(task.context, props);
    cb();
}
var $7c4c83baead83c48$var$effectRunnerMap = ($7c4c83baead83c48$var$_effectRunnerMap = {}, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$971d5caa766a69d7] = $7c4c83baead83c48$var$runTakeEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$56c0d5a1e737357d] = $7c4c83baead83c48$var$runPutEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$ebd11618f299a286] = $7c4c83baead83c48$var$runAllEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$db202ddc8be9136] = $7c4c83baead83c48$var$runRaceEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$e7094788287c5e9b] = $7c4c83baead83c48$var$runCallEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$407448d2b89b1813] = $7c4c83baead83c48$var$runCPSEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$d66501df72047452] = $7c4c83baead83c48$var$runForkEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$b4171a6734a65d42] = $7c4c83baead83c48$var$runJoinEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$8b22cf2602fb60ce] = $7c4c83baead83c48$var$runCancelEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$25ce5a424b770e84] = $7c4c83baead83c48$var$runSelectEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$4368d992c4eafac0] = $7c4c83baead83c48$var$runChannelEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$2d1720544b23b823] = $7c4c83baead83c48$var$runCancelledEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$39b482c5e57630a8] = $7c4c83baead83c48$var$runFlushEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$2329c99376c9d0a4] = $7c4c83baead83c48$var$runGetContextEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $4b7c041aec498d87$export$dda1d9f60106f0e9] = $7c4c83baead83c48$var$runSetContextEffect, $7c4c83baead83c48$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $7c4c83baead83c48$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $4b7c041aec498d87$export$43caf9889c228507)(tasks, task);
            task.cont = (0, $4b7c041aec498d87$export$625550452a3fa3ec);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $4b7c041aec498d87$export$625550452a3fa3ec);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $7c4c83baead83c48$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $7c4c83baead83c48$var$effectLocationAsString(effect) {
    var location = (0, $4b7c041aec498d87$export$90a7f3efeed30595)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $7c4c83baead83c48$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return "";
}
function $7c4c83baead83c48$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $7c4c83baead83c48$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $7c4c83baead83c48$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $4b7c041aec498d87$export$3b14a55fb2447963)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return "";
    return [
        "Tasks cancelled due to error:"
    ].concat(cancelledTasks).join("\n");
}
var $7c4c83baead83c48$var$crashedEffect = null;
var $7c4c83baead83c48$var$sagaStack = [];
var $7c4c83baead83c48$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $7c4c83baead83c48$var$crashedEffect;
    $7c4c83baead83c48$var$sagaStack.push(frame);
};
var $7c4c83baead83c48$var$clear = function clear() {
    $7c4c83baead83c48$var$crashedEffect = null;
    $7c4c83baead83c48$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $7c4c83baead83c48$var$setCrashedEffect = function setCrashedEffect(effect) {
    $7c4c83baead83c48$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $7c4c83baead83c48$var$toString = function toString() {
    var firstSaga = $7c4c83baead83c48$var$sagaStack[0], otherSagas = $7c4c83baead83c48$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $7c4c83baead83c48$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $7c4c83baead83c48$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : "");
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $7c4c83baead83c48$var$sagaLocationAsString(s.meta);
    }), [
        $7c4c83baead83c48$var$cancelledTasksAsString($7c4c83baead83c48$var$sagaStack)
    ]).join("\n");
};
function $7c4c83baead83c48$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $4b7c041aec498d87$export$625550452a3fa3ec);
    var status = $7c4c83baead83c48$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $7c4c83baead83c48$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $7c4c83baead83c48$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $7c4c83baead83c48$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $44241fd6c875387f$export$a47f788ef0b36709), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $44241fd6c875387f$export$a47f788ef0b36709)) status = $7c4c83baead83c48$var$CANCELLED;
            else if (status !== $7c4c83baead83c48$var$CANCELLED) status = $7c4c83baead83c48$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $7c4c83baead83c48$var$ABORTED;
            $7c4c83baead83c48$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $7c4c83baead83c48$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $7c4c83baead83c48$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $4b7c041aec498d87$export$ffb5f4729a158638)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $da7a7b2afd0c6e2b$export$2e2bcd8739ae039)();
        if (status === $7c4c83baead83c48$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $7c4c83baead83c48$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $44241fd6c875387f$export$9355e489ad16f98e] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $7c4c83baead83c48$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $7c4c83baead83c48$var$CANCELLED || status === $7c4c83baead83c48$var$RUNNING && mainTask.status === $7c4c83baead83c48$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $7c4c83baead83c48$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $7c4c83baead83c48$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $4b7c041aec498d87$export$625550452a3fa3ec);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $7c4c83baead83c48$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $7c4c83baead83c48$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $7c4c83baead83c48$var$RUNNING) {
            mainTask.status = $7c4c83baead83c48$var$CANCELLED;
            next((0, $44241fd6c875387f$export$a47f788ef0b36709));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $7c4c83baead83c48$var$clear();
            } else if ((0, $4b7c041aec498d87$export$4a5767248b18ef41)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $7c4c83baead83c48$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $15093a965cf6fe1c$export$86951950244e2001)(iterator$1.return) ? iterator$1.return((0, $44241fd6c875387f$export$a47f788ef0b36709)) : {
                    done: true,
                    value: (0, $44241fd6c875387f$export$a47f788ef0b36709)
                };
            } else if ((0, $4b7c041aec498d87$export$df995fae86a55f06)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $15093a965cf6fe1c$export$86951950244e2001)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $7c4c83baead83c48$var$CANCELLED) mainTask.status = $7c4c83baead83c48$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $7c4c83baead83c48$var$CANCELLED) throw error;
            mainTask.status = $7c4c83baead83c48$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(effect)) $7c4c83baead83c48$var$resolvePromise(effect, currCb);
        else if ((0, $15093a965cf6fe1c$export$6f58e2338da23f4d)(effect)) // resolve iterator
        $7c4c83baead83c48$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $44241fd6c875387f$export$8f8422ac5947a789]) {
            var effectRunner = $7c4c83baead83c48$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = "";
        var effectId = $7c4c83baead83c48$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $4b7c041aec498d87$export$625550452a3fa3ec); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $7c4c83baead83c48$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $4b7c041aec498d87$export$625550452a3fa3ec); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $4b7c041aec498d87$export$625550452a3fa3ec); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $7c4c83baead83c48$var$RUN_SAGA_SIGNATURE = "runSaga(options, saga, ...args)";
var $7c4c83baead83c48$var$NON_GENERATOR_ERR = $7c4c83baead83c48$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $7c4c83baead83c48$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $7c4c83baead83c48$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $4b7c041aec498d87$export$ef35774e6d314e91) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $7c4c83baead83c48$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $4b7c041aec498d87$export$625550452a3fa3ec);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $a92d759a54265567$export$f672e0b6f7222cd7).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $4b7c041aec498d87$export$a9c23c6ac3fc3eca);
    var env = {
        channel: channel,
        dispatch: (0, $4b7c041aec498d87$export$96f57966bedc81b4)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $7c4c83baead83c48$var$immediately(function() {
        var task = $7c4c83baead83c48$var$proc(env, iterator$1, context, effectId, (0, $4b7c041aec498d87$export$35e795649ee09318)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $7c4c83baead83c48$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $7c4c83baead83c48$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $7c4c83baead83c48$export$3d8d44bf0c43bb61.bind(null, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $4b7c041aec498d87$export$ffb5f4729a158638)(context, props);
    };
    return sagaMiddleware;
}
var $7c4c83baead83c48$export$2e2bcd8739ae039 = $7c4c83baead83c48$var$sagaMiddlewareFactory;


var $bea0a19dd4c5e28d$export$2e2bcd8739ae039 = (0, $7c4c83baead83c48$export$2e2bcd8739ae039);









var $1e1837559b2734c8$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $1e1837559b2734c8$var$qEnd = {};
function $1e1837559b2734c8$var$safeName(patternOrChannel) {
    if ((0, $15093a965cf6fe1c$export$1f95fbd68d964d36)(patternOrChannel)) return "channel";
    if ((0, $15093a965cf6fe1c$export$32b5e46230afa379)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $1e1837559b2734c8$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $1e1837559b2734c8$var$qEnd) return $1e1837559b2734c8$var$done(arg);
        if (error && !errorState) {
            nextState = $1e1837559b2734c8$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $1e1837559b2734c8$var$qEnd ? $1e1837559b2734c8$var$done(arg) : effect;
        }
    }
    return (0, $4b7c041aec498d87$export$9e5f44173e64f162)(next, function(error) {
        return next(null, error);
    }, name);
}
function $1e1837559b2734c8$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $4b7c041aec498d87$export$3466f893ebf79586)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yFork(action)
            };
        }
    }, "q1", "takeEvery(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $4b7c041aec498d87$export$3466f893ebf79586)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$3a1a48c8f6ef640e)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: "q3",
                effect: yCancel(task)
            } : {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, "q1", "takeLatest(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $4b7c041aec498d87$export$3466f893ebf79586)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$a07804094c3ecf2d).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yCall(action)
            };
        }
    }, "q1", "takeLeading(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$3466f893ebf79586)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $4b7c041aec498d87$export$c4ce752e73470fba)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $15093a965cf6fe1c$export$1f95fbd68d964d36)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $4b7c041aec498d87$export$3722cfe417b6ed86)(patternOrChannel, (0, $4b7c041aec498d87$export$3a6d5c9ae78a2c08)(1))
            };
            return {
                nextState: "q2",
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: "q4",
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: "q2",
                effect: yDelay
            };
        }
    }, needsChannel ? "q1" : "q2", "throttle(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $4b7c041aec498d87$export$a07804094c3ecf2d).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $4b7c041aec498d87$export$c4ce752e73470fba)(delayLength)
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yCall,
                errorState: "q10"
            };
        },
        q2: function q2() {
            return {
                nextState: $1e1837559b2734c8$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: "q1",
                effect: yDelay
            };
        }
    }, "q1", "retry(" + fn.name + ")");
}
function $1e1837559b2734c8$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $4b7c041aec498d87$export$3466f893ebf79586)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $4b7c041aec498d87$export$e7c866399fa523f5)({
            action: (0, $4b7c041aec498d87$export$3466f893ebf79586)(patternOrChannel),
            debounce: (0, $4b7c041aec498d87$export$c4ce752e73470fba)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: "q1",
                effect: yFork(action)
            } : {
                nextState: "q2",
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, "q1", "debounce(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $1e1837559b2734c8$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $4b7c041aec498d87$export$db3b6bfb95261072)(patternOrChannel, (0, $15093a965cf6fe1c$export$1352885233577768), fn.name + " requires a pattern or channel");
    (0, $4b7c041aec498d87$export$db3b6bfb95261072)(worker, (0, $15093a965cf6fe1c$export$1352885233577768), fn.name + " requires a saga parameter");
};
function $1e1837559b2734c8$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
        $1e1837559b2734c8$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
        $1e1837559b2734c8$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
        $1e1837559b2734c8$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
        $1e1837559b2734c8$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $4b7c041aec498d87$export$a07804094c3ecf2d).apply(void 0, [
        $1e1837559b2734c8$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $4b7c041aec498d87$export$61196ced6d74a310).apply(void 0, [
        $1e1837559b2734c8$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}






const $092650e24b689170$var$backend = {
    UpdateData: `${"https://sato-backend-test.azurewebsites.net/api"}/UpdateData`,
    GetData: `${"https://sato-backend-test.azurewebsites.net/api"}/GetData`
};
const $092650e24b689170$var$getPeriod = (state)=>state.form.periodId;
const $092650e24b689170$var$updateData = async (values)=>await (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($092650e24b689170$var$backend.UpdateData, values);
function* $092650e24b689170$var$updateApi(action) {
    try {
        let periodId = yield (0, $4b7c041aec498d87$export$6559d589eb85fbb6)($092650e24b689170$var$getPeriod);
        yield (0, $4b7c041aec498d87$export$a07804094c3ecf2d)($092650e24b689170$var$updateData, {
            ...action.payload,
            periodId: periodId
        });
    } catch (e) {
        console.warn(e);
        const additionalInformation = (0, $df5bef30413a053b$export$df77466336fe5355) ? e.toString() : undefined;
        yield (0, $4b7c041aec498d87$export$8743009a87fcb00f)((0, $c7a54fa30ebf964c$export$b8d0bb2aa0adefe5)("virhe.palvelin.tallennus", additionalInformation));
    }
}
function* $092650e24b689170$var$apiSaga() {
    yield (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)("SET_VALUES", $092650e24b689170$var$updateApi);
}
var $092650e24b689170$export$2e2bcd8739ae039 = $092650e24b689170$var$apiSaga;



const $11c8f0865ca3d403$var$initialState = {
    token: undefined
};
function $11c8f0865ca3d403$export$2e2bcd8739ae039(state = $11c8f0865ca3d403$var$initialState, action) {
    switch(action.type){
        case 0, $d18a0a91bd86f32d$export$eb728d1e04946462:
            return {
                ...state,
                token: action.payload
            };
        case 0, $d18a0a91bd86f32d$export$53f522aeda635e8b:
            return {
                token: undefined
            };
        default:
            return state;
    }
}



const $69094c7ace7ba371$var$initialState = {
    errors: []
};
const $69094c7ace7ba371$var$setErrorReducer = (state = $69094c7ace7ba371$var$initialState, action)=>{
    const errors = [
        ...state.errors
    ];
    const newError = action.payload;
    errors.push(newError);
    return {
        ...state,
        errors: errors
    };
};
const $69094c7ace7ba371$var$deleteErrorReducer = (state = $69094c7ace7ba371$var$initialState, action)=>{
    const id = action.payload;
    const errors = [
        ...state.errors
    ].filter((e)=>e.id !== id);
    return {
        ...state,
        errors: errors
    };
};
function $69094c7ace7ba371$export$2e2bcd8739ae039(state = $69094c7ace7ba371$var$initialState, action) {
    switch(action.type){
        case (0, $4eb73ced7ff4ee76$export$182858e9e5f292cd).SET_ERROR:
            return $69094c7ace7ba371$var$setErrorReducer(state, action);
        case (0, $4eb73ced7ff4ee76$export$182858e9e5f292cd).DELETE_ERROR:
            return $69094c7ace7ba371$var$deleteErrorReducer(state, action);
        default:
            return state;
    }
}





// fixme: remove ts-ignores
const $52de96ad681527f0$var$initialState = {
    periodId: null,
    ViljanSatotiedot: [],
    Syyskylvot: [],
    ValkuaiskasvienSatotiedot: [],
    // @ts-ignore
    RehunurmenSatotiedot: {
        Korjuu: [
            "_386967",
            "_386971",
            "_386975"
        ].map((n)=>new (0, $987975668562e0eb$export$1c6c761d15cd8b14)(n))
    },
    MuutViljelykasvitSatotiedot: [],
    PerunanSatotiedot: [],
    Lisatiedot: {
        [(0, $91cfdcf11b4ccb63$export$833b3e5a19fb8939).Lisatiedot]: ""
    }
};
function $52de96ad681527f0$export$2e2bcd8739ae039(state = $52de96ad681527f0$var$initialState, action) {
    switch(action.type){
        case 0, $4cad8f036e74fc6a$export$18138ec54e25ae31:
            {
                let step = state.step || 0;
                if (action?.payload?.step && action.payload.step > step) step = action.payload.step;
                return {
                    ...state,
                    ...action.payload,
                    step: step
                };
            }
        case 0, $4cad8f036e74fc6a$export$7f2d035eeabb2a2b:
            return {
                ...state,
                ...action.payload
            };
        case 0, $4cad8f036e74fc6a$export$918c630449e022d1:
            return $52de96ad681527f0$var$initialState;
        default:
            return state;
    }
}



const $ca17ccf89744ad98$var$initialState = {
    valkuaiskasvit: [],
    viljakasvit: [],
    öljykasvit: [],
    perunakasvit: [],
    muutkasvit: []
};
function $ca17ccf89744ad98$export$2e2bcd8739ae039(state = $ca17ccf89744ad98$var$initialState, action) {
    switch(action.type){
        case 0, $e139c8a6e6e59fea$export$8f578363830fb4cc:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}


var $861efbaea47407e3$export$2e2bcd8739ae039 = {
    auth: $11c8f0865ca3d403$export$2e2bcd8739ae039,
    meta: $ca17ccf89744ad98$export$2e2bcd8739ae039,
    form: $52de96ad681527f0$export$2e2bcd8739ae039,
    error: $69094c7ace7ba371$export$2e2bcd8739ae039
};


const $505741c010a7fc0c$var$sagaMiddleware = (0, $bea0a19dd4c5e28d$export$2e2bcd8739ae039)();
const $505741c010a7fc0c$var$persistConfig = {
    key: "root",
    storage: $b36a05dffe55b995$export$2e2bcd8739ae039,
    debug: true,
    whitelist: [
        "auth",
        "meta",
        "form"
    ]
};
const $505741c010a7fc0c$var$persistedReducer = (0, $04cffa891861b45f$export$2e2bcd8739ae039)($505741c010a7fc0c$var$persistConfig, (0, $861efbaea47407e3$export$2e2bcd8739ae039));
const $505741c010a7fc0c$var$composeEnhancers = (0, $df5bef30413a053b$export$df77466336fe5355) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $ad4393542232627c$export$f672e0b6f7222cd7);
let $505741c010a7fc0c$export$6f57813fe9f31bf9 = (0, $ad4393542232627c$export$f51a9068ac82ea43)($505741c010a7fc0c$var$persistedReducer, $505741c010a7fc0c$var$composeEnhancers((0, $ad4393542232627c$export$9ff26e0402cc7b7)($505741c010a7fc0c$var$sagaMiddleware)));
let $505741c010a7fc0c$export$7b682ac9934ca3e4 = (0, $46c0b3c6eec1f9fa$export$2e2bcd8739ae039)($505741c010a7fc0c$export$6f57813fe9f31bf9);
$505741c010a7fc0c$var$sagaMiddleware.run((0, $092650e24b689170$export$2e2bcd8739ae039));



var $2rLZY = parcelRequire("2rLZY");
const $227f11a6809b1d6b$var$theme = (0, $2rLZY.default)({
    palette: {
        primary: {
            main: "#B35C00",
            contrastText: "#fff"
        },
        secondary: {
            main: "#fff",
            contrastText: "#E07400"
        },
        action: {
            disabledBackground: "#B35C00",
            disabled: "#fff"
        }
    },
    typography: {
        fontFamily: "Titillium Web",
        h1: {
            fontSize: "2.25rem",
            lineHeight: 1.334,
            fontWeight: 400
        },
        h2: {
            fontSize: "1.8rem",
            lineHeight: 1.6,
            fontWeight: 400
        },
        h3: {
            fontSize: "1.5rem",
            lineHeight: 1.334,
            fontWeight: 400
        },
        subtitle2: {
            display: "block"
        },
        body1: {
            fontSize: "1.02rem"
        }
    }
});
const $227f11a6809b1d6b$var$extendedTheme = (0, $2rLZY.default)($227f11a6809b1d6b$var$theme, {
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: "black",
                    textDecoration: "underline"
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "rgba(0, 0, 0, 0.87)"
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    color: "rgba(0, 0, 0, 0.87)"
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: 0,
                    color: "#0033a0"
                }
            }
        },
        MuiCardActionArea: {
            styleOverrides: {
                root: {
                    height: "100%"
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    height: "100%"
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: "bold"
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    marginTop: $227f11a6809b1d6b$var$theme.spacing(1)
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {}
            }
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: "0"
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    color: "rgba(0, 0, 0, 0.87)",
                    "& .MuiTypography-root": {
                        color: "rgba(0, 0, 0, 0.87)"
                    }
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "rgba(0, 0, 0, 0.87)"
                },
                colorSecondary: {
                    color: "#fff"
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                colorSecondary: {
                    color: "#fff"
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fff"
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    marginTop: "24px",
                    marginRight: "-1px",
                    marginBottom: "24px"
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "0",
                    textTransform: "none"
                },
                containedSecondary: {
                    borderRadius: "3px"
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {},
                tooltipPlacementTop: {
                    marging: "-1rem"
                }
            }
        }
    }
});
var $227f11a6809b1d6b$export$2e2bcd8739ae039 = $227f11a6809b1d6b$var$extendedTheme;


(0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).interceptors.request.use((config)=>{
    if (config.headers) config.headers.Authorization = (0, $505741c010a7fc0c$export$6f57813fe9f31bf9).getState().auth.token || "no token";
    return config;
});
function $cd93687958c8007e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), {
            theme: (0, $227f11a6809b1d6b$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fff44a152eb20ab0$export$2e2bcd8739ae039), {
                theme: (0, $227f11a6809b1d6b$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f4d8f6ffbbb628$export$2e2bcd8739ae039), {
                    store: (0, $505741c010a7fc0c$export$6f57813fe9f31bf9),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e12196636af0b10$export$311ca220e7478cda), {
                        loading: null,
                        persistor: (0, $505741c010a7fc0c$export$7b682ac9934ca3e4),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8c10dd8884cb7442$export$2e2bcd8739ae039), {})
                    })
                })
            })
        })
    });
}






if (0, $df5bef30413a053b$export$df77466336fe5355) {
    const axe = (parcelRequire("36yar"));
    if (typeof axe == "function") axe((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))), 3000);
}
(0, $11492dca620dcaa5$exports.render)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {}), document.getElementById("root"));


//# sourceMappingURL=index.fc932c41.js.map
